export const DEMO_SITI = {
	"alessandria": {
		name: "Alessandria",
		region: "Piemonte",
		top: 24.95,
		left: 52.40,
		detailTitle: "Progetto di riqualificazione ambientale",
		detailText: "L'impianto è composto da due unità turbogas a ciclo semplice con potenza di circa 90 MW ciascuna. Alle unità si aggiunge un gruppo elettrogeno di emergenza come alimentazione di riserva. Nella centrale sono presenti vari impianti tecnologici ausiliari, necessari al processo di produzione come la stazione di decompressione gas metano, motori diesel “di lancio”, gruppi elettrogeni diesel di emergenza, rete idraulica e impianto di trattamento acque reflue.",
		hasDetail: false
	},
	"augusta": {
		name: "Augusta",
		region: "Sicilia",
		top: 90.8,
		left: 70.78,
		detailTitle: "Progetto di riqualificazione ambientale",
		detailText: "La centrale termoelettrica in provincia di Siracusa, estesa su un’area di 150mila metri quadrati, è caratterizzata da un particolare disegno architettonico, attento all'integrazione con l'ambiente e con grandi aree interne destinate al verde. Ha ricevuto per questo il premio “ARCHINSI 61” quale migliore opera architettonica realizzata in Sicilia. La centrale si compone di 3 sezioni termoelettriche a ciclo semplice, di potenza elettrica efficiente lorda pari a 70 MW ciascuna, alimentate a olio combustibile a bassissimo tenore di zolfo.",
		hasDetail: false
	},
	"bari": {
		name: "Bari",
		region: "Puglia",
		top: 58.75,
		left: 75.46,
		detailTitle: "Progetto di riqualificazione ambientale",
		detailText: "La centrale, fuori servizio dal 2013, si compone di 3 sezioni da 68,5 MW ciascuna e comprende 3 serbatoi per deposito oli combustibili: due da 7500 mmc e uno da 20000 mmc, con relativi bacini di contenimento. Si trova a Ovest della città, all’interno dell’area industriale.",
		hasDetail: false
	},
	"Genova": {
		name: "Genova",
		region: "Liguria",
		top: 30.35,
		left: 53.2,
		detailTitle: "Progetto di riqualificazione ambientale",
		detailText: "L’area della centrale a carbone di Genova, ubicata sotto la Lanterna, monumento simbolo della città, si estende per 48mila metri quadrati. Nel marzo del 2017 il Ministero dello Sviluppo Economico ha dato il via libera alla richiesta di Enel per la definitiva uscita dall’esercizio dell’impianto. L’impianto comprende una unità da 155 MW e due da 70 MW. Ospita un'area di 20.000 mq destinata allo stoccaggio del carbone dotata di sistemi e mezzi per limitare al massimo la dispersione delle polveri.",
		hasDetail: false
	},
	"la-spezia": {
		name: "La Spezia",
		region: "Liguria",
		top: 32.5,
		left: 55.95,
		detailTitle: "Progetto di riqualificazione ambientale",
		detailText: "La centrale “Eugenio Montale” è costituita da tre sezioni termoelettriche: SP1, ciclo combinato da 345 MW alimentato con gas naturale; SP2, ciclo combinato da 337 MW alimentato con gas naturale; SP3, impianto a vapore da 600 MW alimentato prevalentemente a carbone.",
		hasDetail: false
	},
	"livorno": {
		name: "Livorno",
		region: "Toscana",
		top: 37.1,
		left: 57.27,
		detailTitle: "Progetto di riqualificazione ambientale",
		detailText: "La “Marzocco” è una centrale termoelettrica tradizionale a ciclo Rankine. Ha 2 sezioni ognuna di potenza pari a 155 MW. L’impianto, oltre alle strutture e alle apparecchiature propriamente connesse alla produzione (caldaie, ciminiera, turbine, depolverizzatori elettrostatici, eccetera), è dotato di un deposito oli minerali costituito da 2 serbatoi di complessivi 36.000 mc. La centrale è adiacente all’ex Centro di Ricerca Enel, che ricopre un’area di complessivi 4 ettari.",
		hasDetail: false
	},
	"montalto-di-castro": {
		name: "Montalto di Castro",
		region: "Lazio",
		top: 47.8,
		left: 60.59,
		detailTitle: "Progetto di riqualificazione ambientale",
		detailText: "La centrale intitolata ad Alessandro Volta sorge in un’area inizialmente destinata ad ospitare uno dei primi impianti nucleari italiani, la cui costruzione fu poi interrotta. È una delle centrali per cui è stata scelta la procedura del Concorso di Progetti, volto a individuare soluzioni sostenibili per dare nuova vita al sito. La centrale è costituta da 8 turbogas (120 MW di potenza ciascuna) associati a coppie alle 4 unità a vapore da (660 MW di potenza unitaria). Le unità possono essere esercite in “ciclo semplice” oppure in “ciclo ripotenziato”. L’impianto è dotato di sistemi di abbattimento delle emissioni e di rilevamento della Qualità dell’Aria; ha inoltre ricevuto certificazione della sicurezza OHSAS 18001 e della qualità ISO 9001, ISO 14001 ed EMAS.",
		hasDetail: false
	},
	"piombino": {
		name: "Piombino",
		region: "Toscana",
		top: 42.4,
		left: 58,
		detailTitle: "Progetto di riqualificazione ambientale",
		detailText: "La centrale termoelettrica tradizionale a ciclo Rankine era alimentata a olio combustibile ed è costituita da 4 sezioni, ciascuna da 320 MW di potenza. Oltre alle strutture e alle apparecchiature connesse alla produzione, è dotata di un deposito oli minerali costituito da 4 serbatoi da 50.000 mc ciascuno e un serbatoio da 100.000 mc. I fumi di combustione delle 4 caldaie sono convogliati verso l’esterno attraverso due camini di 200 m di altezza; gli scarichi idrici sono trattati in un impianto centralizzato di trattamento dei reflui.",
		hasDetail: false
	},
	"porto-tolle": {
		name: "Porto Tolle",
		region: "Veneto",
		top: 25,
		left: 63.23,
		detailTitle: "Progetto di riqualificazione ambientale",
		detailText: "L’impianto, in provincia di Rovigo, ha cessato l’attività di produzione nel gennaio 2015. A conclusione del Concorso di Progetti, nel maggio 2019 è stato firmato il preliminare di vendita del sito con la società Human Company che ha presentato una proposta di riqualificazione per trasformarlo in un innovativo villaggio turistico open air. L’impianto è composto da 4 sezioni di 660 MW di potenza efficiente lorda ciascuna. Ogni sezione comprende un generatore di vapore alimentato con olio combustibile, una turbina a vapore e un alternatore con tensione 20 kV. L’alimentazione delle caldaie utilizza 2 serbatoi da 50.000 mq e 5 serbatoi da 100.000 mq.",
		hasDetail: false
	},
	"santa-barbara": {
		name: "Santa Barbara",
		region: "Toscana",
		top: 37.16,
		left: 60.46,
		detailTitle: "Progetto di riqualificazione ambientale",
		detailText: "L’area mineraria di Santa Barbara ha un’estensione di circa 1.600 ettari. La coltivazione, iniziata nel 1955 nel territorio del Comune di Cavriglia, è stata successivamente estesa interessando anche il territorio comunale di Figline Valdarno, recentemente diventato Comune di Figline e Incisa Valdarno.",
		hasDetail: true
	},
	"termini-imerese": {
		name: "Termini Imerese",
		region: "Sicilia",
		top: 84.4,
		left: 66.89,
		detailTitle: "Progetto di riqualificazione ambientale",
		detailText: "La centrale termoelettrica alimentata a gas in provincia di Palermo ha vissuto negli anni diversi ampliamenti e trasformazioni. Solo una parte del sito, oggi non più funzionale alla produzione di energia, è inclusa in Futur-e. L’impianto è composto dal nuovo ciclo combinato (TI6), da due turbogas a ciclo semplice (TI52 e TI53), e dal gruppo TI41 per un totale di 1340 MW di potenza installata. Tutti i gruppi di produzione utilizzano esclusivamente gas naturale.Il gruppo TI41 è autorizzato a funzionare non oltre 1000 ore/anno solo su esplicita richiesta del gestore della rete al fine di garantire la continuità del servizio elettrico.",
		hasDetail: false
	}

};

export const DEMO_SITO = {
	name: "Santa Barbara",
	location: "Cavriglia, Arezzo",
	description: "L’area mineraria di Santa Barbara ha un’estensione di circa 1.600 ettari. La coltivazione, iniziata nel 1955 nel territorio del Comune di Cavriglia, è stata successivamente estesa interessando anche il territorio comunale di Figline Valdarno, recentemente diventato Comune di Figline e Incisa Valdarno.",
	mapTitle: "Progetto di riqualificazione ambientale",
	mapText: "<p>Il comprensorio minerario di Santa Barbara si trova al confine tra i comuni di Cavriglia in provincia di Arezzo e Figline Incisa Valdarno in provincia di Firenze. Si tratta di un’area prevalentemente collinare/montuosa, di circa 20 km2, compresa tra i Monti del Chianti a sud-ovest, il fiume Arno a nord-est e delimitata a nord-ovest ed a sud-est, rispettivamente, dal corso dei borri Cesto e Vacchereccia.</p><p>L'attività estrattiva del bacino lignitifero di Santa Barbara ebbe di fatto inizio nella seconda metà dell’800, quando si avviò l'utilizzazione della lignite estratta da piccole miniere a cielo aperto, in corrispondenza e nelle immediate vicinanze degli affioramenti ai margini del banco lignitifero. Lo sfruttamento della lignite per la produzione termoelettrica ebbe inizio nei primi anni del 1900 con l'entrata in esercizio della Centrale di Castelnuovo dei Sabbioni.</p><p>La coltivazione della lignite in queste miniere è proseguita fino al 1994. A seguito della coltivazione si è proceduto con il riassetto morfologico dell’area mineraria.</p>",
	gallery: [
		{
			"filename": "1.jpg"
		},
		{
			"filename": "2.jpg"
		},
		{
			"filename": "3.jpg"
		},
		{
			"filename": "4.jpg"
		},
		{
			"filename": "5.jpg"
		},
		{
			"filename": "6.jpg"
		},
		{
			"filename": "7.jpg"
		},
		{
			"filename": "8.jpg"
		},
		{
			"filename": "9.jpg"
		},
		{
			"filename": "10.jpg"
		},
		{
			"filename": "11.jpg"
		},
		{
			"filename": "12.jpg"
		},
		{
			"filename": "13.jpg"
		},
		{
			"filename": "14.jpg"
		},
		{
			"filename": "15.jpg"
		}
	]

};

export const DEMO_MACROLOTTI = {
	"1": {
		"name": "Macrolotto B1",
		"center": {
			"lng": 11.4372015,
			"lat": 43.575952
		},
		"coords": [{
			"lng": 11.444378,
			"lat": 43.573476
		}, {
			"lng": 11.444306,
			"lat": 43.573873
		}, {
			"lng": 11.444481,
			"lat": 43.574165
		}, {
			"lng": 11.444517,
			"lat": 43.574286
		}, {
			"lng": 11.444525,
			"lat": 43.574379
		}, {
			"lng": 11.444506,
			"lat": 43.574566
		}, {
			"lng": 11.444113,
			"lat": 43.575824
		}, {
			"lng": 11.44403,
			"lat": 43.576241
		}, {
			"lng": 11.443931,
			"lat": 43.576898
		}, {
			"lng": 11.443874,
			"lat": 43.577588
		}, {
			"lng": 11.443885,
			"lat": 43.578098
		}, {
			"lng": 11.443716,
			"lat": 43.578933
		}, {
			"lng": 11.443718,
			"lat": 43.579395
		}, {
			"lng": 11.443619,
			"lat": 43.579974
		}, {
			"lng": 11.443714,
			"lat": 43.579972
		}, {
			"lng": 11.444026,
			"lat": 43.579943
		}, {
			"lng": 11.444213,
			"lat": 43.579914
		}, {
			"lng": 11.444422,
			"lat": 43.579873
		}, {
			"lng": 11.44473,
			"lat": 43.579792
		}, {
			"lng": 11.445071,
			"lat": 43.579679
		}, {
			"lng": 11.44519,
			"lat": 43.579617
		}, {
			"lng": 11.445322,
			"lat": 43.579558
		}, {
			"lng": 11.445474,
			"lat": 43.579474
		}, {
			"lng": 11.445598,
			"lat": 43.579409
		}, {
			"lng": 11.445743,
			"lat": 43.579315
		}, {
			"lng": 11.445906,
			"lat": 43.579201
		}, {
			"lng": 11.446164,
			"lat": 43.579054
		}, {
			"lng": 11.446333,
			"lat": 43.578977
		}, {
			"lng": 11.446564,
			"lat": 43.578894
		}, {
			"lng": 11.44682,
			"lat": 43.578825
		}, {
			"lng": 11.447095,
			"lat": 43.578776
		}, {
			"lng": 11.447385,
			"lat": 43.57875
		}, {
			"lng": 11.447681,
			"lat": 43.57875
		}, {
			"lng": 11.447968,
			"lat": 43.578775
		}, {
			"lng": 11.449125,
			"lat": 43.579038
		}, {
			"lng": 11.448558,
			"lat": 43.579343
		}, {
			"lng": 11.448039,
			"lat": 43.579519
		}, {
			"lng": 11.447828,
			"lat": 43.579578
		}, {
			"lng": 11.447334,
			"lat": 43.579715
		}, {
			"lng": 11.446912,
			"lat": 43.579872
		}, {
			"lng": 11.4465,
			"lat": 43.580005
		}, {
			"lng": 11.446017,
			"lat": 43.580074
		}, {
			"lng": 11.44594,
			"lat": 43.580104
		}, {
			"lng": 11.445632,
			"lat": 43.580205
		}, {
			"lng": 11.445377,
			"lat": 43.580356
		}, {
			"lng": 11.444915,
			"lat": 43.580654
		}, {
			"lng": 11.444634,
			"lat": 43.58084
		}, {
			"lng": 11.444255,
			"lat": 43.581064
		}, {
			"lng": 11.444099,
			"lat": 43.58113
		}, {
			"lng": 11.443994,
			"lat": 43.58121
		}, {
			"lng": 11.441298,
			"lat": 43.583276
		}, {
			"lng": 11.439461,
			"lat": 43.583368
		}, {
			"lng": 11.439188,
			"lat": 43.583218
		}, {
			"lng": 11.438791,
			"lat": 43.583395
		}, {
			"lng": 11.438582,
			"lat": 43.583283
		}, {
			"lng": 11.438382,
			"lat": 43.583442
		}, {
			"lng": 11.438287,
			"lat": 43.583329
		}, {
			"lng": 11.438223,
			"lat": 43.583114
		}, {
			"lng": 11.435852,
			"lat": 43.582666
		}, {
			"lng": 11.435822,
			"lat": 43.582618
		}, {
			"lng": 11.435699,
			"lat": 43.582706
		}, {
			"lng": 11.435445,
			"lat": 43.582864
		}, {
			"lng": 11.434792,
			"lat": 43.582944
		}, {
			"lng": 11.434644,
			"lat": 43.5829
		}, {
			"lng": 11.434439,
			"lat": 43.583062
		}, {
			"lng": 11.434273,
			"lat": 43.582988
		}, {
			"lng": 11.434158,
			"lat": 43.582984
		}, {
			"lng": 11.434045,
			"lat": 43.583053
		}, {
			"lng": 11.434032,
			"lat": 43.58309
		}, {
			"lng": 11.433277,
			"lat": 43.583085
		}, {
			"lng": 11.433011,
			"lat": 43.583057
		}, {
			"lng": 11.432595,
			"lat": 43.582852
		}, {
			"lng": 11.432518,
			"lat": 43.582742
		}, {
			"lng": 11.432224,
			"lat": 43.582653
		}, {
			"lng": 11.432126,
			"lat": 43.582681
		}, {
			"lng": 11.431809,
			"lat": 43.582772
		}, {
			"lng": 11.431725,
			"lat": 43.582704
		}, {
			"lng": 11.431516,
			"lat": 43.582392
		}, {
			"lng": 11.431846,
			"lat": 43.582471
		}, {
			"lng": 11.432037,
			"lat": 43.582379
		}, {
			"lng": 11.432189,
			"lat": 43.582111
		}, {
			"lng": 11.432166,
			"lat": 43.581883
		}, {
			"lng": 11.432295,
			"lat": 43.581802
		}, {
			"lng": 11.432552,
			"lat": 43.581701
		}, {
			"lng": 11.432771,
			"lat": 43.581662
		}, {
			"lng": 11.432617,
			"lat": 43.581567
		}, {
			"lng": 11.432986,
			"lat": 43.581267
		}, {
			"lng": 11.433177,
			"lat": 43.580921
		}, {
			"lng": 11.432993,
			"lat": 43.58086
		}, {
			"lng": 11.433496,
			"lat": 43.580489
		}, {
			"lng": 11.433794,
			"lat": 43.580155
		}, {
			"lng": 11.433721,
			"lat": 43.580066
		}, {
			"lng": 11.433561,
			"lat": 43.58009
		}, {
			"lng": 11.433382,
			"lat": 43.580093
		}, {
			"lng": 11.433251,
			"lat": 43.580042
		}, {
			"lng": 11.433143,
			"lat": 43.579957
		}, {
			"lng": 11.43279,
			"lat": 43.579854
		}, {
			"lng": 11.432693,
			"lat": 43.579954
		}, {
			"lng": 11.43273,
			"lat": 43.58001
		}, {
			"lng": 11.432611,
			"lat": 43.580123
		}, {
			"lng": 11.432537,
			"lat": 43.580147
		}, {
			"lng": 11.432419,
			"lat": 43.580131
		}, {
			"lng": 11.432236,
			"lat": 43.580263
		}, {
			"lng": 11.431976,
			"lat": 43.580221
		}, {
			"lng": 11.431872,
			"lat": 43.580194
		}, {
			"lng": 11.431813,
			"lat": 43.580098
		}, {
			"lng": 11.431313,
			"lat": 43.579961
		}, {
			"lng": 11.431218,
			"lat": 43.580049
		}, {
			"lng": 11.431377,
			"lat": 43.580369
		}, {
			"lng": 11.431106,
			"lat": 43.580265
		}, {
			"lng": 11.43105,
			"lat": 43.580443
		}, {
			"lng": 11.430741,
			"lat": 43.580403
		}, {
			"lng": 11.430586,
			"lat": 43.580426
		}, {
			"lng": 11.430256,
			"lat": 43.580396
		}, {
			"lng": 11.430248,
			"lat": 43.580062
		}, {
			"lng": 11.4301,
			"lat": 43.580128
		}, {
			"lng": 11.429857,
			"lat": 43.5802
		}, {
			"lng": 11.429507,
			"lat": 43.580401
		}, {
			"lng": 11.429263,
			"lat": 43.58072
		}, {
			"lng": 11.429254,
			"lat": 43.580714
		}, {
			"lng": 11.429321,
			"lat": 43.579754
		}, {
			"lng": 11.429325,
			"lat": 43.579714
		}, {
			"lng": 11.429113,
			"lat": 43.579671
		}, {
			"lng": 11.4289,
			"lat": 43.579663
		}, {
			"lng": 11.4286,
			"lat": 43.579696
		}, {
			"lng": 11.428419,
			"lat": 43.579613
		}, {
			"lng": 11.428299,
			"lat": 43.57959
		}, {
			"lng": 11.42838,
			"lat": 43.579439
		}, {
			"lng": 11.428202,
			"lat": 43.579395
		}, {
			"lng": 11.427665,
			"lat": 43.579428
		}, {
			"lng": 11.427337,
			"lat": 43.579423
		}, {
			"lng": 11.427104,
			"lat": 43.579338
		}, {
			"lng": 11.426924,
			"lat": 43.579342
		}, {
			"lng": 11.426673,
			"lat": 43.579376
		}, {
			"lng": 11.426578,
			"lat": 43.579384
		}, {
			"lng": 11.426515,
			"lat": 43.579318
		}, {
			"lng": 11.426393,
			"lat": 43.579244
		}, {
			"lng": 11.4258,
			"lat": 43.579199
		}, {
			"lng": 11.42555,
			"lat": 43.578628
		}, {
			"lng": 11.425807,
			"lat": 43.578451
		}, {
			"lng": 11.425879,
			"lat": 43.578342
		}, {
			"lng": 11.426091,
			"lat": 43.578284
		}, {
			"lng": 11.426316,
			"lat": 43.578223
		}, {
			"lng": 11.426455,
			"lat": 43.57821
		}, {
			"lng": 11.426852,
			"lat": 43.578339
		}, {
			"lng": 11.427445,
			"lat": 43.578386
		}, {
			"lng": 11.427625,
			"lat": 43.578104
		}, {
			"lng": 11.427667,
			"lat": 43.578092
		}, {
			"lng": 11.427764,
			"lat": 43.578211
		}, {
			"lng": 11.427915,
			"lat": 43.578301
		}, {
			"lng": 11.428205,
			"lat": 43.578286
		}, {
			"lng": 11.430507,
			"lat": 43.578201
		}, {
			"lng": 11.430581,
			"lat": 43.577819
		}, {
			"lng": 11.43115,
			"lat": 43.577859
		}, {
			"lng": 11.431205,
			"lat": 43.577644
		}, {
			"lng": 11.431111,
			"lat": 43.577582
		}, {
			"lng": 11.430969,
			"lat": 43.577636
		}, {
			"lng": 11.430794,
			"lat": 43.577626
		}, {
			"lng": 11.430448,
			"lat": 43.577545
		}, {
			"lng": 11.430478,
			"lat": 43.577501
		}, {
			"lng": 11.430411,
			"lat": 43.57748
		}, {
			"lng": 11.430453,
			"lat": 43.577326
		}, {
			"lng": 11.430474,
			"lat": 43.577299
		}, {
			"lng": 11.430828,
			"lat": 43.577143
		}, {
			"lng": 11.430853,
			"lat": 43.577152
		}, {
			"lng": 11.430895,
			"lat": 43.577069
		}, {
			"lng": 11.430921,
			"lat": 43.57681
		}, {
			"lng": 11.43089,
			"lat": 43.576676
		}, {
			"lng": 11.430915,
			"lat": 43.576545
		}, {
			"lng": 11.431013,
			"lat": 43.57654
		}, {
			"lng": 11.431181,
			"lat": 43.576552
		}, {
			"lng": 11.431325,
			"lat": 43.576594
		}, {
			"lng": 11.431398,
			"lat": 43.576601
		}, {
			"lng": 11.431443,
			"lat": 43.57661
		}, {
			"lng": 11.431442,
			"lat": 43.57658
		}, {
			"lng": 11.431407,
			"lat": 43.576512
		}, {
			"lng": 11.431166,
			"lat": 43.575187
		}, {
			"lng": 11.431162,
			"lat": 43.575152
		}, {
			"lng": 11.431048,
			"lat": 43.575154
		}, {
			"lng": 11.43072,
			"lat": 43.575185
		}, {
			"lng": 11.430089,
			"lat": 43.575194
		}, {
			"lng": 11.430113,
			"lat": 43.574524
		}, {
			"lng": 11.427193,
			"lat": 43.574528
		}, {
			"lng": 11.427144,
			"lat": 43.574592
		}, {
			"lng": 11.426966,
			"lat": 43.574432
		}, {
			"lng": 11.42691,
			"lat": 43.574408
		}, {
			"lng": 11.426802,
			"lat": 43.574386
		}, {
			"lng": 11.426602,
			"lat": 43.574432
		}, {
			"lng": 11.426462,
			"lat": 43.574481
		}, {
			"lng": 11.426361,
			"lat": 43.574533
		}, {
			"lng": 11.426211,
			"lat": 43.57459
		}, {
			"lng": 11.426123,
			"lat": 43.574601
		}, {
			"lng": 11.425915,
			"lat": 43.574595
		}, {
			"lng": 11.425848,
			"lat": 43.574565
		}, {
			"lng": 11.425833,
			"lat": 43.574528
		}, {
			"lng": 11.425784,
			"lat": 43.57433
		}, {
			"lng": 11.425776,
			"lat": 43.574283
		}, {
			"lng": 11.425624,
			"lat": 43.574136
		}, {
			"lng": 11.425519,
			"lat": 43.574071
		}, {
			"lng": 11.425348,
			"lat": 43.574021
		}, {
			"lng": 11.425278,
			"lat": 43.573848
		}, {
			"lng": 11.425348,
			"lat": 43.573822
		}, {
			"lng": 11.425577,
			"lat": 43.57369
		}, {
			"lng": 11.425604,
			"lat": 43.573676
		}, {
			"lng": 11.426093,
			"lat": 43.573506
		}, {
			"lng": 11.42618,
			"lat": 43.573457
		}, {
			"lng": 11.426392,
			"lat": 43.573393
		}, {
			"lng": 11.426744,
			"lat": 43.57316
		}, {
			"lng": 11.42711,
			"lat": 43.572966
		}, {
			"lng": 11.427254,
			"lat": 43.57311
		}, {
			"lng": 11.427453,
			"lat": 43.573198
		}, {
			"lng": 11.428041,
			"lat": 43.573053
		}, {
			"lng": 11.428218,
			"lat": 43.572965
		}, {
			"lng": 11.428259,
			"lat": 43.572964
		}, {
			"lng": 11.428339,
			"lat": 43.572889
		}, {
			"lng": 11.428359,
			"lat": 43.572834
		}, {
			"lng": 11.428336,
			"lat": 43.572702
		}, {
			"lng": 11.428579,
			"lat": 43.572684
		}, {
			"lng": 11.429291,
			"lat": 43.572761
		}, {
			"lng": 11.42985,
			"lat": 43.572675
		}, {
			"lng": 11.430137,
			"lat": 43.572731
		}, {
			"lng": 11.430345,
			"lat": 43.572774
		}, {
			"lng": 11.430374,
			"lat": 43.572777
		}, {
			"lng": 11.430473,
			"lat": 43.572799
		}, {
			"lng": 11.43088,
			"lat": 43.572979
		}, {
			"lng": 11.431413,
			"lat": 43.573458
		}, {
			"lng": 11.431484,
			"lat": 43.572834
		}, {
			"lng": 11.431767,
			"lat": 43.572807
		}, {
			"lng": 11.432195,
			"lat": 43.572869
		}, {
			"lng": 11.432313,
			"lat": 43.572447
		}, {
			"lng": 11.432696,
			"lat": 43.572184
		}, {
			"lng": 11.433354,
			"lat": 43.572023
		}, {
			"lng": 11.433441,
			"lat": 43.571808
		}, {
			"lng": 11.433461,
			"lat": 43.571777
		}, {
			"lng": 11.433535,
			"lat": 43.571776
		}, {
			"lng": 11.433686,
			"lat": 43.571677
		}, {
			"lng": 11.433742,
			"lat": 43.571601
		}, {
			"lng": 11.433866,
			"lat": 43.571293
		}, {
			"lng": 11.43337,
			"lat": 43.5713
		}, {
			"lng": 11.433049,
			"lat": 43.571422
		}, {
			"lng": 11.433012,
			"lat": 43.571418
		}, {
			"lng": 11.432784,
			"lat": 43.571295
		}, {
			"lng": 11.43285,
			"lat": 43.571218
		}, {
			"lng": 11.43298,
			"lat": 43.571266
		}, {
			"lng": 11.433893,
			"lat": 43.57099
		}, {
			"lng": 11.434281,
			"lat": 43.570711
		}, {
			"lng": 11.434147,
			"lat": 43.570331
		}, {
			"lng": 11.433908,
			"lat": 43.570234
		}, {
			"lng": 11.435508,
			"lat": 43.569523
		}, {
			"lng": 11.435378,
			"lat": 43.569006
		}, {
			"lng": 11.435417,
			"lat": 43.568845
		}, {
			"lng": 11.436746,
			"lat": 43.568836
		}, {
			"lng": 11.438879,
			"lat": 43.568872
		}, {
			"lng": 11.439252,
			"lat": 43.568917
		}, {
			"lng": 11.440236,
			"lat": 43.568462
		}, {
			"lng": 11.44117,
			"lat": 43.568788
		}, {
			"lng": 11.442362,
			"lat": 43.569426
		}, {
			"lng": 11.443334,
			"lat": 43.570021
		}, {
			"lng": 11.444423,
			"lat": 43.570965
		}, {
			"lng": 11.44475,
			"lat": 43.571189
		}, {
			"lng": 11.445035,
			"lat": 43.571467
		}, {
			"lng": 11.444825,
			"lat": 43.57184
		}, {
			"lng": 11.444378,
			"lat": 43.573476
		}]
	},
	"2": {
		"name": "Macrolotto B2",
		"center": {
			"lng": 11.4450,
			"lat": 43.5650
		},
		"coords": [{
			"lng": 11.460293,
			"lat": 43.570338
		}, {
			"lng": 11.460447,
			"lat": 43.570441
		}, {
			"lng": 11.460715,
			"lat": 43.570576
		}, {
			"lng": 11.461536,
			"lat": 43.570892
		}, {
			"lng": 11.462493,
			"lat": 43.571154
		}, {
			"lng": 11.463404,
			"lat": 43.57135
		}, {
			"lng": 11.464346,
			"lat": 43.57147
		}, {
			"lng": 11.46514,
			"lat": 43.571537
		}, {
			"lng": 11.465729,
			"lat": 43.57168
		}, {
			"lng": 11.466176,
			"lat": 43.571807
		}, {
			"lng": 11.466939,
			"lat": 43.572023
		}, {
			"lng": 11.467499,
			"lat": 43.572322
		}, {
			"lng": 11.468129,
			"lat": 43.573038
		}, {
			"lng": 11.468336,
			"lat": 43.573107
		}, {
			"lng": 11.468891,
			"lat": 43.573025
		}, {
			"lng": 11.469436,
			"lat": 43.572416
		}, {
			"lng": 11.469696,
			"lat": 43.572414
		}, {
			"lng": 11.470599,
			"lat": 43.572359
		}, {
			"lng": 11.469997,
			"lat": 43.572841
		}, {
			"lng": 11.469948,
			"lat": 43.572819
		}, {
			"lng": 11.469706,
			"lat": 43.573094
		}, {
			"lng": 11.46963,
			"lat": 43.57318
		}, {
			"lng": 11.469552,
			"lat": 43.573422
		}, {
			"lng": 11.470094,
			"lat": 43.573763
		}, {
			"lng": 11.47011,
			"lat": 43.573838
		}, {
			"lng": 11.469645,
			"lat": 43.574108
		}, {
			"lng": 11.468952,
			"lat": 43.573934
		}, {
			"lng": 11.46916,
			"lat": 43.574013
		}, {
			"lng": 11.469487,
			"lat": 43.574204
		}, {
			"lng": 11.46931,
			"lat": 43.5745
		}, {
			"lng": 11.46915,
			"lat": 43.574702
		}, {
			"lng": 11.469016,
			"lat": 43.574782
		}, {
			"lng": 11.468864,
			"lat": 43.574737
		}, {
			"lng": 11.468664,
			"lat": 43.574985
		}, {
			"lng": 11.46855,
			"lat": 43.57522
		}, {
			"lng": 11.468435,
			"lat": 43.575454
		}, {
			"lng": 11.468083,
			"lat": 43.575469
		}, {
			"lng": 11.467791,
			"lat": 43.57564
		}, {
			"lng": 11.467592,
			"lat": 43.575813
		}, {
			"lng": 11.467214,
			"lat": 43.576192
		}, {
			"lng": 11.467019,
			"lat": 43.57634
		}, {
			"lng": 11.466821,
			"lat": 43.576449
		}, {
			"lng": 11.466358,
			"lat": 43.576652
		}, {
			"lng": 11.465924,
			"lat": 43.576737
		}, {
			"lng": 11.465611,
			"lat": 43.576901
		}, {
			"lng": 11.465142,
			"lat": 43.576897
		}, {
			"lng": 11.463974,
			"lat": 43.57603
		}, {
			"lng": 11.463103,
			"lat": 43.575026
		}, {
			"lng": 11.462634,
			"lat": 43.574917
		}, {
			"lng": 11.462517,
			"lat": 43.574851
		}, {
			"lng": 11.462157,
			"lat": 43.575043
		}, {
			"lng": 11.46169,
			"lat": 43.575385
		}, {
			"lng": 11.460704,
			"lat": 43.575621
		}, {
			"lng": 11.460337,
			"lat": 43.575697
		}, {
			"lng": 11.460147,
			"lat": 43.57572
		}, {
			"lng": 11.459926,
			"lat": 43.575828
		}, {
			"lng": 11.459863,
			"lat": 43.575844
		}, {
			"lng": 11.458998,
			"lat": 43.5758
		}, {
			"lng": 11.458824,
			"lat": 43.575776
		}, {
			"lng": 11.458777,
			"lat": 43.57578
		}, {
			"lng": 11.458722,
			"lat": 43.575774
		}, {
			"lng": 11.458451,
			"lat": 43.57563
		}, {
			"lng": 11.458278,
			"lat": 43.575474
		}, {
			"lng": 11.458241,
			"lat": 43.575463
		}, {
			"lng": 11.458111,
			"lat": 43.575439
		}, {
			"lng": 11.457992,
			"lat": 43.575397
		}, {
			"lng": 11.457624,
			"lat": 43.575359
		}, {
			"lng": 11.457137,
			"lat": 43.575373
		}, {
			"lng": 11.457076,
			"lat": 43.575371
		}, {
			"lng": 11.457038,
			"lat": 43.575369
		}, {
			"lng": 11.456871,
			"lat": 43.575365
		}, {
			"lng": 11.456763,
			"lat": 43.575355
		}, {
			"lng": 11.45654,
			"lat": 43.575302
		}, {
			"lng": 11.456362,
			"lat": 43.575278
		}, {
			"lng": 11.456194,
			"lat": 43.575228
		}, {
			"lng": 11.455979,
			"lat": 43.575188
		}, {
			"lng": 11.455837,
			"lat": 43.575159
		}, {
			"lng": 11.455614,
			"lat": 43.57508
		}, {
			"lng": 11.455447,
			"lat": 43.575029
		}, {
			"lng": 11.455325,
			"lat": 43.575015
		}, {
			"lng": 11.45521,
			"lat": 43.575024
		}, {
			"lng": 11.455083,
			"lat": 43.575034
		}, {
			"lng": 11.454864,
			"lat": 43.575017
		}, {
			"lng": 11.454839,
			"lat": 43.575016
		}, {
			"lng": 11.454821,
			"lat": 43.575013
		}, {
			"lng": 11.454153,
			"lat": 43.575299
		}, {
			"lng": 11.453985,
			"lat": 43.575368
		}, {
			"lng": 11.453719,
			"lat": 43.575457
		}, {
			"lng": 11.453557,
			"lat": 43.575537
		}, {
			"lng": 11.453428,
			"lat": 43.575634
		}, {
			"lng": 11.453271,
			"lat": 43.57571
		}, {
			"lng": 11.453106,
			"lat": 43.575779
		}, {
			"lng": 11.452845,
			"lat": 43.575787
		}, {
			"lng": 11.452614,
			"lat": 43.575795
		}, {
			"lng": 11.452342,
			"lat": 43.575765
		}, {
			"lng": 11.452086,
			"lat": 43.57578
		}, {
			"lng": 11.45158,
			"lat": 43.576867
		}, {
			"lng": 11.45134,
			"lat": 43.577283
		}, {
			"lng": 11.451365,
			"lat": 43.577491
		}, {
			"lng": 11.451364,
			"lat": 43.57763
		}, {
			"lng": 11.451072,
			"lat": 43.577714
		}, {
			"lng": 11.450445,
			"lat": 43.577842
		}, {
			"lng": 11.450202,
			"lat": 43.57791
		}, {
			"lng": 11.450046,
			"lat": 43.578032
		}, {
			"lng": 11.449833,
			"lat": 43.578368
		}, {
			"lng": 11.449755,
			"lat": 43.57849
		}, {
			"lng": 11.449598,
			"lat": 43.578653
		}, {
			"lng": 11.449373,
			"lat": 43.578885
		}, {
			"lng": 11.449125,
			"lat": 43.579038
		}, {
			"lng": 11.447968,
			"lat": 43.578775
		}, {
			"lng": 11.447681,
			"lat": 43.57875
		}, {
			"lng": 11.447385,
			"lat": 43.57875
		}, {
			"lng": 11.447095,
			"lat": 43.578776
		}, {
			"lng": 11.44682,
			"lat": 43.578825
		}, {
			"lng": 11.446564,
			"lat": 43.578894
		}, {
			"lng": 11.446333,
			"lat": 43.578977
		}, {
			"lng": 11.446164,
			"lat": 43.579054
		}, {
			"lng": 11.445906,
			"lat": 43.579201
		}, {
			"lng": 11.445743,
			"lat": 43.579315
		}, {
			"lng": 11.445598,
			"lat": 43.579409
		}, {
			"lng": 11.445474,
			"lat": 43.579474
		}, {
			"lng": 11.445322,
			"lat": 43.579558
		}, {
			"lng": 11.44519,
			"lat": 43.579617
		}, {
			"lng": 11.445071,
			"lat": 43.579679
		}, {
			"lng": 11.44473,
			"lat": 43.579792
		}, {
			"lng": 11.444422,
			"lat": 43.579873
		}, {
			"lng": 11.444213,
			"lat": 43.579914
		}, {
			"lng": 11.444026,
			"lat": 43.579943
		}, {
			"lng": 11.443714,
			"lat": 43.579972
		}, {
			"lng": 11.443619,
			"lat": 43.579974
		}, {
			"lng": 11.443718,
			"lat": 43.579395
		}, {
			"lng": 11.443716,
			"lat": 43.578933
		}, {
			"lng": 11.443885,
			"lat": 43.578098
		}, {
			"lng": 11.443874,
			"lat": 43.577588
		}, {
			"lng": 11.443931,
			"lat": 43.576898
		}, {
			"lng": 11.44403,
			"lat": 43.576241
		}, {
			"lng": 11.444113,
			"lat": 43.575824
		}, {
			"lng": 11.444506,
			"lat": 43.574566
		}, {
			"lng": 11.444525,
			"lat": 43.574379
		}, {
			"lng": 11.444517,
			"lat": 43.574286
		}, {
			"lng": 11.444481,
			"lat": 43.574165
		}, {
			"lng": 11.444306,
			"lat": 43.573873
		}, {
			"lng": 11.444378,
			"lat": 43.573476
		}, {
			"lng": 11.444825,
			"lat": 43.57184
		}, {
			"lng": 11.445035,
			"lat": 43.571467
		}, {
			"lng": 11.44475,
			"lat": 43.571189
		}, {
			"lng": 11.444423,
			"lat": 43.570965
		}, {
			"lng": 11.443334,
			"lat": 43.570021
		}, {
			"lng": 11.442362,
			"lat": 43.569426
		}, {
			"lng": 11.44117,
			"lat": 43.568788
		}, {
			"lng": 11.440236,
			"lat": 43.568462
		}, {
			"lng": 11.439252,
			"lat": 43.568917
		}, {
			"lng": 11.438879,
			"lat": 43.568872
		}, {
			"lng": 11.436746,
			"lat": 43.568836
		}, {
			"lng": 11.435471,
			"lat": 43.568799
		}, {
			"lng": 11.435451,
			"lat": 43.568799
		}, {
			"lng": 11.434732,
			"lat": 43.568505
		}, {
			"lng": 11.434324,
			"lat": 43.568339
		}, {
			"lng": 11.434106,
			"lat": 43.568333
		}, {
			"lng": 11.43367,
			"lat": 43.568334
		}, {
			"lng": 11.433572,
			"lat": 43.568291
		}, {
			"lng": 11.433551,
			"lat": 43.568217
		}, {
			"lng": 11.433388,
			"lat": 43.567922
		}, {
			"lng": 11.432646,
			"lat": 43.567806
		}, {
			"lng": 11.432332,
			"lat": 43.567888
		}, {
			"lng": 11.432149,
			"lat": 43.568011
		}, {
			"lng": 11.432143,
			"lat": 43.568189
		}, {
			"lng": 11.432236,
			"lat": 43.568269
		}, {
			"lng": 11.43216,
			"lat": 43.568507
		}, {
			"lng": 11.431936,
			"lat": 43.56868
		}, {
			"lng": 11.432002,
			"lat": 43.5688
		}, {
			"lng": 11.431185,
			"lat": 43.568556
		}, {
			"lng": 11.430389,
			"lat": 43.568331
		}, {
			"lng": 11.430201,
			"lat": 43.568227
		}, {
			"lng": 11.429996,
			"lat": 43.568208
		}, {
			"lng": 11.429782,
			"lat": 43.568164
		}, {
			"lng": 11.429721,
			"lat": 43.568098
		}, {
			"lng": 11.429738,
			"lat": 43.567931
		}, {
			"lng": 11.429793,
			"lat": 43.567757
		}, {
			"lng": 11.429869,
			"lat": 43.567578
		}, {
			"lng": 11.430262,
			"lat": 43.567389
		}, {
			"lng": 11.430707,
			"lat": 43.567189
		}, {
			"lng": 11.430889,
			"lat": 43.567094
		}, {
			"lng": 11.431132,
			"lat": 43.566943
		}, {
			"lng": 11.431233,
			"lat": 43.566668
		}, {
			"lng": 11.431237,
			"lat": 43.566467
		}, {
			"lng": 11.431334,
			"lat": 43.566442
		}, {
			"lng": 11.431628,
			"lat": 43.566404
		}, {
			"lng": 11.431868,
			"lat": 43.566389
		}, {
			"lng": 11.432003,
			"lat": 43.566381
		}, {
			"lng": 11.432484,
			"lat": 43.566306
		}, {
			"lng": 11.432631,
			"lat": 43.566326
		}, {
			"lng": 11.432912,
			"lat": 43.566204
		}, {
			"lng": 11.433153,
			"lat": 43.566087
		}, {
			"lng": 11.433328,
			"lat": 43.565983
		}, {
			"lng": 11.433368,
			"lat": 43.56578
		}, {
			"lng": 11.433247,
			"lat": 43.565483
		}, {
			"lng": 11.433402,
			"lat": 43.565074
		}, {
			"lng": 11.433487,
			"lat": 43.565021
		}, {
			"lng": 11.433723,
			"lat": 43.564875
		}, {
			"lng": 11.434195,
			"lat": 43.564581
		}, {
			"lng": 11.434429,
			"lat": 43.564433
		}, {
			"lng": 11.434878,
			"lat": 43.564214
		}, {
			"lng": 11.434559,
			"lat": 43.564046
		}, {
			"lng": 11.434642,
			"lat": 43.563876
		}, {
			"lng": 11.433726,
			"lat": 43.563622
		}, {
			"lng": 11.433362,
			"lat": 43.563756
		}, {
			"lng": 11.433341,
			"lat": 43.563742
		}, {
			"lng": 11.433254,
			"lat": 43.563403
		}, {
			"lng": 11.433049,
			"lat": 43.563449
		}, {
			"lng": 11.43206,
			"lat": 43.563147
		}, {
			"lng": 11.432275,
			"lat": 43.562868
		}, {
			"lng": 11.432857,
			"lat": 43.562336
		}, {
			"lng": 11.432906,
			"lat": 43.562289
		}, {
			"lng": 11.43293,
			"lat": 43.562251
		}, {
			"lng": 11.432873,
			"lat": 43.562176
		}, {
			"lng": 11.432784,
			"lat": 43.562089
		}, {
			"lng": 11.432347,
			"lat": 43.562017
		}, {
			"lng": 11.432082,
			"lat": 43.562027
		}, {
			"lng": 11.431965,
			"lat": 43.561973
		}, {
			"lng": 11.431878,
			"lat": 43.561964
		}, {
			"lng": 11.431606,
			"lat": 43.561985
		}, {
			"lng": 11.431535,
			"lat": 43.561972
		}, {
			"lng": 11.431525,
			"lat": 43.560986
		}, {
			"lng": 11.431333,
			"lat": 43.560908
		}, {
			"lng": 11.430422,
			"lat": 43.560436
		}, {
			"lng": 11.430503,
			"lat": 43.560379
		}, {
			"lng": 11.431122,
			"lat": 43.560519
		}, {
			"lng": 11.431255,
			"lat": 43.560491
		}, {
			"lng": 11.431273,
			"lat": 43.560532
		}, {
			"lng": 11.431907,
			"lat": 43.560725
		}, {
			"lng": 11.431979,
			"lat": 43.560807
		}, {
			"lng": 11.43219,
			"lat": 43.560807
		}, {
			"lng": 11.432209,
			"lat": 43.560646
		}, {
			"lng": 11.432655,
			"lat": 43.560309
		}, {
			"lng": 11.432363,
			"lat": 43.55975
		}, {
			"lng": 11.432556,
			"lat": 43.559749
		}, {
			"lng": 11.433444,
			"lat": 43.559784
		}, {
			"lng": 11.43312,
			"lat": 43.559619
		}, {
			"lng": 11.433218,
			"lat": 43.559553
		}, {
			"lng": 11.433647,
			"lat": 43.559396
		}, {
			"lng": 11.434136,
			"lat": 43.559282
		}, {
			"lng": 11.434491,
			"lat": 43.559216
		}, {
			"lng": 11.434453,
			"lat": 43.55886
		}, {
			"lng": 11.434436,
			"lat": 43.558411
		}, {
			"lng": 11.434966,
			"lat": 43.558039
		}, {
			"lng": 11.435687,
			"lat": 43.558117
		}, {
			"lng": 11.435735,
			"lat": 43.557907
		}, {
			"lng": 11.435578,
			"lat": 43.557809
		}, {
			"lng": 11.435273,
			"lat": 43.55776
		}, {
			"lng": 11.435028,
			"lat": 43.557193
		}, {
			"lng": 11.434901,
			"lat": 43.556993
		}, {
			"lng": 11.434833,
			"lat": 43.556723
		}, {
			"lng": 11.43494,
			"lat": 43.556508
		}, {
			"lng": 11.43471,
			"lat": 43.556179
		}, {
			"lng": 11.434973,
			"lat": 43.556047
		}, {
			"lng": 11.435014,
			"lat": 43.556015
		}, {
			"lng": 11.434988,
			"lat": 43.555933
		}, {
			"lng": 11.434885,
			"lat": 43.555703
		}, {
			"lng": 11.435086,
			"lat": 43.555508
		}, {
			"lng": 11.435124,
			"lat": 43.555484
		}, {
			"lng": 11.435131,
			"lat": 43.555503
		}, {
			"lng": 11.435174,
			"lat": 43.55551
		}, {
			"lng": 11.435224,
			"lat": 43.555501
		}, {
			"lng": 11.435347,
			"lat": 43.555465
		}, {
			"lng": 11.435484,
			"lat": 43.55534
		}, {
			"lng": 11.435636,
			"lat": 43.555196
		}, {
			"lng": 11.435688,
			"lat": 43.55517
		}, {
			"lng": 11.435926,
			"lat": 43.55506
		}, {
			"lng": 11.436079,
			"lat": 43.554634
		}, {
			"lng": 11.436024,
			"lat": 43.554532
		}, {
			"lng": 11.435901,
			"lat": 43.554407
		}, {
			"lng": 11.435654,
			"lat": 43.554313
		}, {
			"lng": 11.435365,
			"lat": 43.554539
		}, {
			"lng": 11.435264,
			"lat": 43.554543
		}, {
			"lng": 11.435,
			"lat": 43.554449
		}, {
			"lng": 11.434635,
			"lat": 43.554421
		}, {
			"lng": 11.43466,
			"lat": 43.554335
		}, {
			"lng": 11.434603,
			"lat": 43.554052
		}, {
			"lng": 11.434271,
			"lat": 43.554035
		}, {
			"lng": 11.434791,
			"lat": 43.553668
		}, {
			"lng": 11.434856,
			"lat": 43.55363
		}, {
			"lng": 11.434879,
			"lat": 43.5536
		}, {
			"lng": 11.434855,
			"lat": 43.553562
		}, {
			"lng": 11.434849,
			"lat": 43.553472
		}, {
			"lng": 11.434836,
			"lat": 43.553387
		}, {
			"lng": 11.434825,
			"lat": 43.553278
		}, {
			"lng": 11.434774,
			"lat": 43.553185
		}, {
			"lng": 11.434495,
			"lat": 43.553021
		}, {
			"lng": 11.434253,
			"lat": 43.552893
		}, {
			"lng": 11.434062,
			"lat": 43.552788
		}, {
			"lng": 11.433811,
			"lat": 43.552648
		}, {
			"lng": 11.433809,
			"lat": 43.552543
		}, {
			"lng": 11.435123,
			"lat": 43.552644
		}, {
			"lng": 11.436854,
			"lat": 43.553089
		}, {
			"lng": 11.437616,
			"lat": 43.553225
		}, {
			"lng": 11.440033,
			"lat": 43.553853
		}, {
			"lng": 11.441641,
			"lat": 43.553608
		}, {
			"lng": 11.442823,
			"lat": 43.553372
		}, {
			"lng": 11.442984,
			"lat": 43.553123
		}, {
			"lng": 11.443378,
			"lat": 43.553103
		}, {
			"lng": 11.443981,
			"lat": 43.553267
		}, {
			"lng": 11.444129,
			"lat": 43.553279
		}, {
			"lng": 11.444361,
			"lat": 43.55294
		}, {
			"lng": 11.444653,
			"lat": 43.55221
		}, {
			"lng": 11.445092,
			"lat": 43.552483
		}, {
			"lng": 11.445419,
			"lat": 43.552687
		}, {
			"lng": 11.44579,
			"lat": 43.552655
		}, {
			"lng": 11.446181,
			"lat": 43.552621
		}, {
			"lng": 11.446909,
			"lat": 43.552515
		}, {
			"lng": 11.447796,
			"lat": 43.552438
		}, {
			"lng": 11.447884,
			"lat": 43.552257
		}, {
			"lng": 11.448196,
			"lat": 43.552051
		}, {
			"lng": 11.44854,
			"lat": 43.551868
		}, {
			"lng": 11.449182,
			"lat": 43.551749
		}, {
			"lng": 11.449753,
			"lat": 43.551585
		}, {
			"lng": 11.449828,
			"lat": 43.55135
		}, {
			"lng": 11.449749,
			"lat": 43.551121
		}, {
			"lng": 11.449906,
			"lat": 43.551122
		}, {
			"lng": 11.450416,
			"lat": 43.550731
		}, {
			"lng": 11.450747,
			"lat": 43.550536
		}, {
			"lng": 11.450864,
			"lat": 43.550399
		}, {
			"lng": 11.45098,
			"lat": 43.550357
		}, {
			"lng": 11.451099,
			"lat": 43.550352
		}, {
			"lng": 11.451661,
			"lat": 43.550159
		}, {
			"lng": 11.451891,
			"lat": 43.550772
		}, {
			"lng": 11.451997,
			"lat": 43.551167
		}, {
			"lng": 11.451992,
			"lat": 43.551367
		}, {
			"lng": 11.451945,
			"lat": 43.551602
		}, {
			"lng": 11.451809,
			"lat": 43.551865
		}, {
			"lng": 11.451573,
			"lat": 43.552135
		}, {
			"lng": 11.451438,
			"lat": 43.552263
		}, {
			"lng": 11.451188,
			"lat": 43.552504
		}, {
			"lng": 11.450803,
			"lat": 43.552857
		}, {
			"lng": 11.450709,
			"lat": 43.552936
		}, {
			"lng": 11.450506,
			"lat": 43.553343
		}, {
			"lng": 11.450459,
			"lat": 43.553618
		}, {
			"lng": 11.4505,
			"lat": 43.554006
		}, {
			"lng": 11.450527,
			"lat": 43.554167
		}, {
			"lng": 11.450614,
			"lat": 43.554329
		}, {
			"lng": 11.450831,
			"lat": 43.554655
		}, {
			"lng": 11.451023,
			"lat": 43.555071
		}, {
			"lng": 11.451226,
			"lat": 43.555289
		}, {
			"lng": 11.451343,
			"lat": 43.555512
		}, {
			"lng": 11.451469,
			"lat": 43.555684
		}, {
			"lng": 11.451604,
			"lat": 43.555959
		}, {
			"lng": 11.451776,
			"lat": 43.556264
		}, {
			"lng": 11.451798,
			"lat": 43.556603
		}, {
			"lng": 11.451777,
			"lat": 43.556886
		}, {
			"lng": 11.451643,
			"lat": 43.557243
		}, {
			"lng": 11.451641,
			"lat": 43.55746
		}, {
			"lng": 11.451651,
			"lat": 43.557573
		}, {
			"lng": 11.451662,
			"lat": 43.557744
		}, {
			"lng": 11.451719,
			"lat": 43.557901
		}, {
			"lng": 11.451824,
			"lat": 43.558149
		}, {
			"lng": 11.451935,
			"lat": 43.558307
		}, {
			"lng": 11.452088,
			"lat": 43.558468
		}, {
			"lng": 11.452318,
			"lat": 43.558704
		}, {
			"lng": 11.451005,
			"lat": 43.560286
		}, {
			"lng": 11.451135,
			"lat": 43.560408
		}, {
			"lng": 11.450851,
			"lat": 43.560738
		}, {
			"lng": 11.449826,
			"lat": 43.561951
		}, {
			"lng": 11.447395,
			"lat": 43.564858
		}, {
			"lng": 11.447212,
			"lat": 43.565136
		}, {
			"lng": 11.447216,
			"lat": 43.565883
		}, {
			"lng": 11.447508,
			"lat": 43.565988
		}, {
			"lng": 11.452716,
			"lat": 43.567486
		}, {
			"lng": 11.460293,
			"lat": 43.570338
		}]
	},
	"3": {
		"name": "Macrolotto A",
		"center": {
			"lng": 11.4681565,
			"lat": 43.5490095
		},
		"coords": [{
			"lng": 11.469495,
			"lat": 43.559542
		}, {
			"lng": 11.469418,
			"lat": 43.55957
		}, {
			"lng": 11.469259,
			"lat": 43.559617
		}, {
			"lng": 11.46911,
			"lat": 43.559646
		}, {
			"lng": 11.468908,
			"lat": 43.559671
		}, {
			"lng": 11.468521,
			"lat": 43.559778
		}, {
			"lng": 11.468253,
			"lat": 43.559864
		}, {
			"lng": 11.467832,
			"lat": 43.560007
		}, {
			"lng": 11.467797,
			"lat": 43.560083
		}, {
			"lng": 11.467608,
			"lat": 43.560695
		}, {
			"lng": 11.467567,
			"lat": 43.560828
		}, {
			"lng": 11.467411,
			"lat": 43.561322
		}, {
			"lng": 11.46771,
			"lat": 43.561384
		}, {
			"lng": 11.468014,
			"lat": 43.561425
		}, {
			"lng": 11.468252,
			"lat": 43.561493
		}, {
			"lng": 11.468565,
			"lat": 43.561602
		}, {
			"lng": 11.468694,
			"lat": 43.561666
		}, {
			"lng": 11.469037,
			"lat": 43.561799
		}, {
			"lng": 11.469351,
			"lat": 43.561894
		}, {
			"lng": 11.469584,
			"lat": 43.561986
		}, {
			"lng": 11.469827,
			"lat": 43.562082
		}, {
			"lng": 11.470313,
			"lat": 43.562257
		}, {
			"lng": 11.470346,
			"lat": 43.562219
		}, {
			"lng": 11.470572,
			"lat": 43.562277
		}, {
			"lng": 11.470954,
			"lat": 43.562379
		}, {
			"lng": 11.47106,
			"lat": 43.562406
		}, {
			"lng": 11.471483,
			"lat": 43.562508
		}, {
			"lng": 11.471527,
			"lat": 43.562572
		}, {
			"lng": 11.471711,
			"lat": 43.562634
		}, {
			"lng": 11.471802,
			"lat": 43.562655
		}, {
			"lng": 11.472181,
			"lat": 43.562744
		}, {
			"lng": 11.472249,
			"lat": 43.562759
		}, {
			"lng": 11.472376,
			"lat": 43.562796
		}, {
			"lng": 11.472589,
			"lat": 43.562875
		}, {
			"lng": 11.472702,
			"lat": 43.56291
		}, {
			"lng": 11.472837,
			"lat": 43.56293
		}, {
			"lng": 11.473219,
			"lat": 43.563037
		}, {
			"lng": 11.473767,
			"lat": 43.562994
		}, {
			"lng": 11.473969,
			"lat": 43.562957
		}, {
			"lng": 11.47421,
			"lat": 43.562924
		}, {
			"lng": 11.474521,
			"lat": 43.562884
		}, {
			"lng": 11.475115,
			"lat": 43.562805
		}, {
			"lng": 11.475559,
			"lat": 43.562754
		}, {
			"lng": 11.476171,
			"lat": 43.562744
		}, {
			"lng": 11.476193,
			"lat": 43.562881
		}, {
			"lng": 11.476194,
			"lat": 43.562948
		}, {
			"lng": 11.474631,
			"lat": 43.563125
		}, {
			"lng": 11.473414,
			"lat": 43.563216
		}, {
			"lng": 11.473025,
			"lat": 43.563205
		}, {
			"lng": 11.47243,
			"lat": 43.56308
		}, {
			"lng": 11.471482,
			"lat": 43.562804
		}, {
			"lng": 11.470479,
			"lat": 43.562538
		}, {
			"lng": 11.469543,
			"lat": 43.562253
		}, {
			"lng": 11.468303,
			"lat": 43.561782
		}, {
			"lng": 11.467477,
			"lat": 43.5616
		}, {
			"lng": 11.467015,
			"lat": 43.561472
		}, {
			"lng": 11.466274,
			"lat": 43.561275
		}, {
			"lng": 11.465322,
			"lat": 43.560937
		}, {
			"lng": 11.464133,
			"lat": 43.560551
		}, {
			"lng": 11.463038,
			"lat": 43.560177
		}, {
			"lng": 11.462763,
			"lat": 43.560443
		}, {
			"lng": 11.46234,
			"lat": 43.561283
		}, {
			"lng": 11.462218,
			"lat": 43.561286
		}, {
			"lng": 11.462604,
			"lat": 43.561561
		}, {
			"lng": 11.46318,
			"lat": 43.561579
		}, {
			"lng": 11.462755,
			"lat": 43.56164
		}, {
			"lng": 11.462359,
			"lat": 43.561952
		}, {
			"lng": 11.462283,
			"lat": 43.562019
		}, {
			"lng": 11.462146,
			"lat": 43.562166
		}, {
			"lng": 11.462118,
			"lat": 43.562176
		}, {
			"lng": 11.462107,
			"lat": 43.562248
		}, {
			"lng": 11.461504,
			"lat": 43.562395
		}, {
			"lng": 11.461433,
			"lat": 43.56241
		}, {
			"lng": 11.461112,
			"lat": 43.562434
		}, {
			"lng": 11.461095,
			"lat": 43.562461
		}, {
			"lng": 11.460667,
			"lat": 43.562672
		}, {
			"lng": 11.460086,
			"lat": 43.5629
		}, {
			"lng": 11.459864,
			"lat": 43.562987
		}, {
			"lng": 11.459805,
			"lat": 43.563016
		}, {
			"lng": 11.459387,
			"lat": 43.563188
		}, {
			"lng": 11.458971,
			"lat": 43.563287
		}, {
			"lng": 11.458921,
			"lat": 43.563097
		}, {
			"lng": 11.45887,
			"lat": 43.563009
		}, {
			"lng": 11.458623,
			"lat": 43.563058
		}, {
			"lng": 11.458633,
			"lat": 43.563098
		}, {
			"lng": 11.458581,
			"lat": 43.56338
		}, {
			"lng": 11.458566,
			"lat": 43.563507
		}, {
			"lng": 11.458565,
			"lat": 43.563507
		}, {
			"lng": 11.458676,
			"lat": 43.56449
		}, {
			"lng": 11.458679,
			"lat": 43.564673
		}, {
			"lng": 11.459094,
			"lat": 43.564566
		}, {
			"lng": 11.458637,
			"lat": 43.565539
		}, {
			"lng": 11.458617,
			"lat": 43.565685
		}, {
			"lng": 11.458613,
			"lat": 43.565701
		}, {
			"lng": 11.458755,
			"lat": 43.566048
		}, {
			"lng": 11.459136,
			"lat": 43.566178
		}, {
			"lng": 11.45939,
			"lat": 43.566016
		}, {
			"lng": 11.459521,
			"lat": 43.566106
		}, {
			"lng": 11.459866,
			"lat": 43.565903
		}, {
			"lng": 11.459913,
			"lat": 43.565875
		}, {
			"lng": 11.460609,
			"lat": 43.565724
		}, {
			"lng": 11.461174,
			"lat": 43.565897
		}, {
			"lng": 11.46082,
			"lat": 43.566127
		}, {
			"lng": 11.460782,
			"lat": 43.566151
		}, {
			"lng": 11.460736,
			"lat": 43.56618
		}, {
			"lng": 11.460212,
			"lat": 43.56615
		}, {
			"lng": 11.460011,
			"lat": 43.566299
		}, {
			"lng": 11.459714,
			"lat": 43.566519
		}, {
			"lng": 11.459759,
			"lat": 43.566819
		}, {
			"lng": 11.459795,
			"lat": 43.567032
		}, {
			"lng": 11.459816,
			"lat": 43.567126
		}, {
			"lng": 11.459773,
			"lat": 43.567144
		}, {
			"lng": 11.459827,
			"lat": 43.567212
		}, {
			"lng": 11.460019,
			"lat": 43.567449
		}, {
			"lng": 11.459725,
			"lat": 43.567923
		}, {
			"lng": 11.459557,
			"lat": 43.568209
		}, {
			"lng": 11.459596,
			"lat": 43.568239
		}, {
			"lng": 11.459484,
			"lat": 43.568871
		}, {
			"lng": 11.459471,
			"lat": 43.568918
		}, {
			"lng": 11.459477,
			"lat": 43.568982
		}, {
			"lng": 11.459502,
			"lat": 43.569153
		}, {
			"lng": 11.459694,
			"lat": 43.569667
		}, {
			"lng": 11.459755,
			"lat": 43.569821
		}, {
			"lng": 11.460211,
			"lat": 43.570307
		}, {
			"lng": 11.452716,
			"lat": 43.567486
		}, {
			"lng": 11.452695,
			"lat": 43.566492
		}, {
			"lng": 11.452624,
			"lat": 43.566402
		}, {
			"lng": 11.451708,
			"lat": 43.565114
		}, {
			"lng": 11.451865,
			"lat": 43.564553
		}, {
			"lng": 11.452511,
			"lat": 43.563952
		}, {
			"lng": 11.453267,
			"lat": 43.5635
		}, {
			"lng": 11.453613,
			"lat": 43.563257
		}, {
			"lng": 11.453836,
			"lat": 43.563077
		}, {
			"lng": 11.453984,
			"lat": 43.562987
		}, {
			"lng": 11.454145,
			"lat": 43.562915
		}, {
			"lng": 11.454459,
			"lat": 43.562743
		}, {
			"lng": 11.454591,
			"lat": 43.562645
		}, {
			"lng": 11.454826,
			"lat": 43.562546
		}, {
			"lng": 11.455446,
			"lat": 43.562847
		}, {
			"lng": 11.455454,
			"lat": 43.562837
		}, {
			"lng": 11.455943,
			"lat": 43.562765
		}, {
			"lng": 11.456037,
			"lat": 43.562739
		}, {
			"lng": 11.457553,
			"lat": 43.562543
		}, {
			"lng": 11.457751,
			"lat": 43.561984
		}, {
			"lng": 11.457829,
			"lat": 43.561765
		}, {
			"lng": 11.457977,
			"lat": 43.561381
		}, {
			"lng": 11.457285,
			"lat": 43.560687
		}, {
			"lng": 11.456967,
			"lat": 43.560337
		}, {
			"lng": 11.45665,
			"lat": 43.560278
		}, {
			"lng": 11.456045,
			"lat": 43.560163
		}, {
			"lng": 11.455618,
			"lat": 43.560074
		}, {
			"lng": 11.455277,
			"lat": 43.560025
		}, {
			"lng": 11.454587,
			"lat": 43.559302
		}, {
			"lng": 11.454214,
			"lat": 43.558846
		}, {
			"lng": 11.453917,
			"lat": 43.558398
		}, {
			"lng": 11.453823,
			"lat": 43.55829
		}, {
			"lng": 11.453756,
			"lat": 43.558274
		}, {
			"lng": 11.453669,
			"lat": 43.558218
		}, {
			"lng": 11.453497,
			"lat": 43.558172
		}, {
			"lng": 11.453504,
			"lat": 43.558103
		}, {
			"lng": 11.453509,
			"lat": 43.558031
		}, {
			"lng": 11.453508,
			"lat": 43.557942
		}, {
			"lng": 11.453273,
			"lat": 43.557667
		}, {
			"lng": 11.452939,
			"lat": 43.557649
		}, {
			"lng": 11.452803,
			"lat": 43.557559
		}, {
			"lng": 11.452642,
			"lat": 43.557397
		}, {
			"lng": 11.452431,
			"lat": 43.557406
		}, {
			"lng": 11.452126,
			"lat": 43.557407
		}, {
			"lng": 11.451953,
			"lat": 43.557391
		}, {
			"lng": 11.451969,
			"lat": 43.557351
		}, {
			"lng": 11.452084,
			"lat": 43.557059
		}, {
			"lng": 11.452161,
			"lat": 43.556806
		}, {
			"lng": 11.452147,
			"lat": 43.556578
		}, {
			"lng": 11.452133,
			"lat": 43.556406
		}, {
			"lng": 11.452069,
			"lat": 43.556105
		}, {
			"lng": 11.452055,
			"lat": 43.555852
		}, {
			"lng": 11.45193,
			"lat": 43.555796
		}, {
			"lng": 11.451665,
			"lat": 43.555351
		}, {
			"lng": 11.451059,
			"lat": 43.554266
		}, {
			"lng": 11.450954,
			"lat": 43.554084
		}, {
			"lng": 11.450878,
			"lat": 43.553881
		}, {
			"lng": 11.450884,
			"lat": 43.553684
		}, {
			"lng": 11.450926,
			"lat": 43.553446
		}, {
			"lng": 11.451018,
			"lat": 43.553296
		}, {
			"lng": 11.451199,
			"lat": 43.552987
		}, {
			"lng": 11.451463,
			"lat": 43.552669
		}, {
			"lng": 11.451561,
			"lat": 43.552572
		}, {
			"lng": 11.451783,
			"lat": 43.55236
		}, {
			"lng": 11.451978,
			"lat": 43.552178
		}, {
			"lng": 11.452118,
			"lat": 43.551955
		}, {
			"lng": 11.452321,
			"lat": 43.551563
		}, {
			"lng": 11.452328,
			"lat": 43.55126
		}, {
			"lng": 11.452445,
			"lat": 43.551093
		}, {
			"lng": 11.452549,
			"lat": 43.550952
		}, {
			"lng": 11.452664,
			"lat": 43.55085
		}, {
			"lng": 11.453056,
			"lat": 43.550543
		}, {
			"lng": 11.453382,
			"lat": 43.550323
		}, {
			"lng": 11.453684,
			"lat": 43.550209
		}, {
			"lng": 11.454054,
			"lat": 43.549951
		}, {
			"lng": 11.454269,
			"lat": 43.549563
		}, {
			"lng": 11.454379,
			"lat": 43.549116
		}, {
			"lng": 11.454422,
			"lat": 43.548723
		}, {
			"lng": 11.454146,
			"lat": 43.548423
		}, {
			"lng": 11.454102,
			"lat": 43.547924
		}, {
			"lng": 11.453666,
			"lat": 43.54776
		}, {
			"lng": 11.453724,
			"lat": 43.547569
		}, {
			"lng": 11.453656,
			"lat": 43.547344
		}, {
			"lng": 11.453635,
			"lat": 43.547271
		}, {
			"lng": 11.453771,
			"lat": 43.54701
		}, {
			"lng": 11.453778,
			"lat": 43.546997
		}, {
			"lng": 11.453836,
			"lat": 43.546862
		}, {
			"lng": 11.453779,
			"lat": 43.546755
		}, {
			"lng": 11.453725,
			"lat": 43.54665
		}, {
			"lng": 11.453945,
			"lat": 43.546602
		}, {
			"lng": 11.454133,
			"lat": 43.546713
		}, {
			"lng": 11.454221,
			"lat": 43.546667
		}, {
			"lng": 11.454306,
			"lat": 43.546596
		}, {
			"lng": 11.454394,
			"lat": 43.546485
		}, {
			"lng": 11.454567,
			"lat": 43.546492
		}, {
			"lng": 11.454687,
			"lat": 43.546462
		}, {
			"lng": 11.454812,
			"lat": 43.546468
		}, {
			"lng": 11.454894,
			"lat": 43.546391
		}, {
			"lng": 11.454991,
			"lat": 43.546257
		}, {
			"lng": 11.45506,
			"lat": 43.546106
		}, {
			"lng": 11.455076,
			"lat": 43.546002
		}, {
			"lng": 11.455231,
			"lat": 43.545974
		}, {
			"lng": 11.455236,
			"lat": 43.545885
		}, {
			"lng": 11.455149,
			"lat": 43.545755
		}, {
			"lng": 11.455017,
			"lat": 43.54566
		}, {
			"lng": 11.454865,
			"lat": 43.545608
		}, {
			"lng": 11.454737,
			"lat": 43.54558
		}, {
			"lng": 11.454592,
			"lat": 43.545573
		}, {
			"lng": 11.454406,
			"lat": 43.545581
		}, {
			"lng": 11.454153,
			"lat": 43.545601
		}, {
			"lng": 11.454002,
			"lat": 43.545608
		}, {
			"lng": 11.453958,
			"lat": 43.54548
		}, {
			"lng": 11.454091,
			"lat": 43.545381
		}, {
			"lng": 11.454131,
			"lat": 43.545331
		}, {
			"lng": 11.454286,
			"lat": 43.545278
		}, {
			"lng": 11.454455,
			"lat": 43.545284
		}, {
			"lng": 11.454639,
			"lat": 43.545048
		}, {
			"lng": 11.454742,
			"lat": 43.544626
		}, {
			"lng": 11.454702,
			"lat": 43.544347
		}, {
			"lng": 11.454585,
			"lat": 43.544212
		}, {
			"lng": 11.454401,
			"lat": 43.544157
		}, {
			"lng": 11.454385,
			"lat": 43.543955
		}, {
			"lng": 11.454531,
			"lat": 43.543816
		}, {
			"lng": 11.454705,
			"lat": 43.543605
		}, {
			"lng": 11.454903,
			"lat": 43.543599
		}, {
			"lng": 11.455106,
			"lat": 43.543671
		}, {
			"lng": 11.455316,
			"lat": 43.543746
		}, {
			"lng": 11.455432,
			"lat": 43.543885
		}, {
			"lng": 11.455697,
			"lat": 43.544026
		}, {
			"lng": 11.455816,
			"lat": 43.543966
		}, {
			"lng": 11.455984,
			"lat": 43.543573
		}, {
			"lng": 11.456206,
			"lat": 43.54342
		}, {
			"lng": 11.456479,
			"lat": 43.543285
		}, {
			"lng": 11.457115,
			"lat": 43.54306
		}, {
			"lng": 11.4573,
			"lat": 43.542937
		}, {
			"lng": 11.457475,
			"lat": 43.54277
		}, {
			"lng": 11.457228,
			"lat": 43.542647
		}, {
			"lng": 11.456906,
			"lat": 43.542538
		}, {
			"lng": 11.456865,
			"lat": 43.542408
		}, {
			"lng": 11.457009,
			"lat": 43.542238
		}, {
			"lng": 11.456877,
			"lat": 43.542177
		}, {
			"lng": 11.456846,
			"lat": 43.54199
		}, {
			"lng": 11.456819,
			"lat": 43.541648
		}, {
			"lng": 11.45684,
			"lat": 43.541277
		}, {
			"lng": 11.456447,
			"lat": 43.540998
		}, {
			"lng": 11.45635,
			"lat": 43.540308
		}, {
			"lng": 11.456373,
			"lat": 43.540212
		}, {
			"lng": 11.456439,
			"lat": 43.540113
		}, {
			"lng": 11.456625,
			"lat": 43.54018
		}, {
			"lng": 11.456884,
			"lat": 43.540391
		}, {
			"lng": 11.456979,
			"lat": 43.540518
		}, {
			"lng": 11.457092,
			"lat": 43.540641
		}, {
			"lng": 11.457421,
			"lat": 43.540818
		}, {
			"lng": 11.457526,
			"lat": 43.540832
		}, {
			"lng": 11.457627,
			"lat": 43.54082
		}, {
			"lng": 11.457786,
			"lat": 43.540747
		}, {
			"lng": 11.457867,
			"lat": 43.540661
		}, {
			"lng": 11.458015,
			"lat": 43.540255
		}, {
			"lng": 11.458166,
			"lat": 43.539934
		}, {
			"lng": 11.458157,
			"lat": 43.539835
		}, {
			"lng": 11.457999,
			"lat": 43.539517
		}, {
			"lng": 11.457681,
			"lat": 43.539082
		}, {
			"lng": 11.457466,
			"lat": 43.538694
		}, {
			"lng": 11.457482,
			"lat": 43.538545
		}, {
			"lng": 11.457914,
			"lat": 43.538648
		}, {
			"lng": 11.458153,
			"lat": 43.53868
		}, {
			"lng": 11.458465,
			"lat": 43.538581
		}, {
			"lng": 11.458403,
			"lat": 43.538144
		}, {
			"lng": 11.458421,
			"lat": 43.537826
		}, {
			"lng": 11.458161,
			"lat": 43.537453
		}, {
			"lng": 11.458331,
			"lat": 43.53726
		}, {
			"lng": 11.458486,
			"lat": 43.537213
		}, {
			"lng": 11.458318,
			"lat": 43.536976
		}, {
			"lng": 11.458089,
			"lat": 43.536651
		}, {
			"lng": 11.458101,
			"lat": 43.536377
		}, {
			"lng": 11.458003,
			"lat": 43.536131
		}, {
			"lng": 11.458063,
			"lat": 43.535997
		}, {
			"lng": 11.458425,
			"lat": 43.535942
		}, {
			"lng": 11.459388,
			"lat": 43.535932
		}, {
			"lng": 11.459875,
			"lat": 43.535995
		}, {
			"lng": 11.460339,
			"lat": 43.536236
		}, {
			"lng": 11.4604,
			"lat": 43.536206
		}, {
			"lng": 11.460937,
			"lat": 43.535939
		}, {
			"lng": 11.461052,
			"lat": 43.53589
		}, {
			"lng": 11.461072,
			"lat": 43.535541
		}, {
			"lng": 11.461209,
			"lat": 43.535528
		}, {
			"lng": 11.461378,
			"lat": 43.53539
		}, {
			"lng": 11.46168,
			"lat": 43.535382
		}, {
			"lng": 11.461779,
			"lat": 43.535482
		}, {
			"lng": 11.461692,
			"lat": 43.535581
		}, {
			"lng": 11.461572,
			"lat": 43.535621
		}, {
			"lng": 11.461351,
			"lat": 43.535668
		}, {
			"lng": 11.46144,
			"lat": 43.535767
		}, {
			"lng": 11.461197,
			"lat": 43.536066
		}, {
			"lng": 11.461418,
			"lat": 43.536244
		}, {
			"lng": 11.46169,
			"lat": 43.536017
		}, {
			"lng": 11.461791,
			"lat": 43.536107
		}, {
			"lng": 11.461911,
			"lat": 43.536052
		}, {
			"lng": 11.462042,
			"lat": 43.536069
		}, {
			"lng": 11.462202,
			"lat": 43.536212
		}, {
			"lng": 11.462333,
			"lat": 43.536366
		}, {
			"lng": 11.462562,
			"lat": 43.536358
		}, {
			"lng": 11.462726,
			"lat": 43.53642
		}, {
			"lng": 11.463031,
			"lat": 43.536593
		}, {
			"lng": 11.463024,
			"lat": 43.5367
		}, {
			"lng": 11.463524,
			"lat": 43.536912
		}, {
			"lng": 11.463657,
			"lat": 43.536968
		}, {
			"lng": 11.463643,
			"lat": 43.537047
		}, {
			"lng": 11.463674,
			"lat": 43.537089
		}, {
			"lng": 11.46386,
			"lat": 43.537121
		}, {
			"lng": 11.463929,
			"lat": 43.536918
		}, {
			"lng": 11.463845,
			"lat": 43.536742
		}, {
			"lng": 11.463906,
			"lat": 43.536629
		}, {
			"lng": 11.46409,
			"lat": 43.536565
		}, {
			"lng": 11.464217,
			"lat": 43.536539
		}, {
			"lng": 11.465464,
			"lat": 43.535855
		}, {
			"lng": 11.464841,
			"lat": 43.535365
		}, {
			"lng": 11.464879,
			"lat": 43.535241
		}, {
			"lng": 11.464884,
			"lat": 43.535078
		}, {
			"lng": 11.464994,
			"lat": 43.534864
		}, {
			"lng": 11.464961,
			"lat": 43.534616
		}, {
			"lng": 11.464989,
			"lat": 43.534399
		}, {
			"lng": 11.465294,
			"lat": 43.534368
		}, {
			"lng": 11.46562,
			"lat": 43.53431
		}, {
			"lng": 11.466,
			"lat": 43.534277
		}, {
			"lng": 11.466171,
			"lat": 43.533965
		}, {
			"lng": 11.466086,
			"lat": 43.533869
		}, {
			"lng": 11.465939,
			"lat": 43.533686
		}, {
			"lng": 11.465902,
			"lat": 43.533545
		}, {
			"lng": 11.465965,
			"lat": 43.53339
		}, {
			"lng": 11.465961,
			"lat": 43.533221
		}, {
			"lng": 11.465721,
			"lat": 43.533003
		}, {
			"lng": 11.465595,
			"lat": 43.532968
		}, {
			"lng": 11.465573,
			"lat": 43.533059
		}, {
			"lng": 11.465514,
			"lat": 43.533246
		}, {
			"lng": 11.464892,
			"lat": 43.533193
		}, {
			"lng": 11.464685,
			"lat": 43.532887
		}, {
			"lng": 11.464583,
			"lat": 43.53259
		}, {
			"lng": 11.464389,
			"lat": 43.532439
		}, {
			"lng": 11.464543,
			"lat": 43.532352
		}, {
			"lng": 11.465012,
			"lat": 43.532185
		}, {
			"lng": 11.465819,
			"lat": 43.531979
		}, {
			"lng": 11.465497,
			"lat": 43.531143
		}, {
			"lng": 11.465697,
			"lat": 43.531194
		}, {
			"lng": 11.46622,
			"lat": 43.531497
		}, {
			"lng": 11.466781,
			"lat": 43.531727
		}, {
			"lng": 11.466416,
			"lat": 43.53106
		}, {
			"lng": 11.466172,
			"lat": 43.530828
		}, {
			"lng": 11.465964,
			"lat": 43.530324
		}, {
			"lng": 11.465954,
			"lat": 43.529934
		}, {
			"lng": 11.46591,
			"lat": 43.529566
		}, {
			"lng": 11.466438,
			"lat": 43.529276
		}, {
			"lng": 11.467231,
			"lat": 43.528874
		}, {
			"lng": 11.467563,
			"lat": 43.528863
		}, {
			"lng": 11.467728,
			"lat": 43.528538
		}, {
			"lng": 11.468832,
			"lat": 43.527712
		}, {
			"lng": 11.470153,
			"lat": 43.527766
		}, {
			"lng": 11.470154,
			"lat": 43.528087
		}, {
			"lng": 11.470481,
			"lat": 43.528795
		}, {
			"lng": 11.471081,
			"lat": 43.529969
		}, {
			"lng": 11.472044,
			"lat": 43.530468
		}, {
			"lng": 11.47284,
			"lat": 43.531738
		}, {
			"lng": 11.473044,
			"lat": 43.531739
		}, {
			"lng": 11.473734,
			"lat": 43.532408
		}, {
			"lng": 11.474205,
			"lat": 43.53328
		}, {
			"lng": 11.475496,
			"lat": 43.533837
		}, {
			"lng": 11.474501,
			"lat": 43.534846
		}, {
			"lng": 11.474589,
			"lat": 43.535082
		}, {
			"lng": 11.474083,
			"lat": 43.53553
		}, {
			"lng": 11.474104,
			"lat": 43.535731
		}, {
			"lng": 11.474261,
			"lat": 43.535708
		}, {
			"lng": 11.474375,
			"lat": 43.535943
		}, {
			"lng": 11.474301,
			"lat": 43.536525
		}, {
			"lng": 11.474207,
			"lat": 43.536876
		}, {
			"lng": 11.474354,
			"lat": 43.537181
		}, {
			"lng": 11.475202,
			"lat": 43.537702
		}, {
			"lng": 11.475046,
			"lat": 43.537801
		}, {
			"lng": 11.474513,
			"lat": 43.538249
		}, {
			"lng": 11.474043,
			"lat": 43.538647
		}, {
			"lng": 11.47357,
			"lat": 43.539174
		}, {
			"lng": 11.473454,
			"lat": 43.53918
		}, {
			"lng": 11.473129,
			"lat": 43.539325
		}, {
			"lng": 11.473192,
			"lat": 43.539406
		}, {
			"lng": 11.473768,
			"lat": 43.539549
		}, {
			"lng": 11.474279,
			"lat": 43.540219
		}, {
			"lng": 11.474818,
			"lat": 43.539893
		}, {
			"lng": 11.474889,
			"lat": 43.539945
		}, {
			"lng": 11.474956,
			"lat": 43.54004
		}, {
			"lng": 11.475022,
			"lat": 43.540142
		}, {
			"lng": 11.475248,
			"lat": 43.540513
		}, {
			"lng": 11.475342,
			"lat": 43.540751
		}, {
			"lng": 11.475312,
			"lat": 43.541042
		}, {
			"lng": 11.475217,
			"lat": 43.541247
		}, {
			"lng": 11.475225,
			"lat": 43.541389
		}, {
			"lng": 11.475381,
			"lat": 43.541674
		}, {
			"lng": 11.475572,
			"lat": 43.54202
		}, {
			"lng": 11.47575,
			"lat": 43.542276
		}, {
			"lng": 11.475898,
			"lat": 43.542427
		}, {
			"lng": 11.476163,
			"lat": 43.542518
		}, {
			"lng": 11.47645,
			"lat": 43.542613
		}, {
			"lng": 11.476552,
			"lat": 43.542773
		}, {
			"lng": 11.476449,
			"lat": 43.542977
		}, {
			"lng": 11.476277,
			"lat": 43.543076
		}, {
			"lng": 11.476113,
			"lat": 43.543116
		}, {
			"lng": 11.475899,
			"lat": 43.543088
		}, {
			"lng": 11.475755,
			"lat": 43.543037
		}, {
			"lng": 11.475605,
			"lat": 43.542918
		}, {
			"lng": 11.475461,
			"lat": 43.542783
		}, {
			"lng": 11.475313,
			"lat": 43.542651
		}, {
			"lng": 11.475201,
			"lat": 43.542517
		}, {
			"lng": 11.474998,
			"lat": 43.542271
		}, {
			"lng": 11.47487,
			"lat": 43.542107
		}, {
			"lng": 11.474771,
			"lat": 43.541903
		}, {
			"lng": 11.474925,
			"lat": 43.542324
		}, {
			"lng": 11.475167,
			"lat": 43.542778
		}, {
			"lng": 11.475207,
			"lat": 43.542883
		}, {
			"lng": 11.475294,
			"lat": 43.543056
		}, {
			"lng": 11.475233,
			"lat": 43.543182
		}, {
			"lng": 11.475381,
			"lat": 43.54325
		}, {
			"lng": 11.475751,
			"lat": 43.54346
		}, {
			"lng": 11.476026,
			"lat": 43.543613
		}, {
			"lng": 11.476196,
			"lat": 43.54369
		}, {
			"lng": 11.476673,
			"lat": 43.543698
		}, {
			"lng": 11.477054,
			"lat": 43.543721
		}, {
			"lng": 11.477202,
			"lat": 43.543728
		}, {
			"lng": 11.477382,
			"lat": 43.543636
		}, {
			"lng": 11.477446,
			"lat": 43.543613
		}, {
			"lng": 11.477615,
			"lat": 43.543713
		}, {
			"lng": 11.477774,
			"lat": 43.543713
		}, {
			"lng": 11.477933,
			"lat": 43.543667
		}, {
			"lng": 11.478155,
			"lat": 43.543605
		}, {
			"lng": 11.478335,
			"lat": 43.543597
		}, {
			"lng": 11.478494,
			"lat": 43.543597
		}, {
			"lng": 11.478674,
			"lat": 43.543597
		}, {
			"lng": 11.478738,
			"lat": 43.54372
		}, {
			"lng": 11.47877,
			"lat": 43.543843
		}, {
			"lng": 11.478727,
			"lat": 43.54399
		}, {
			"lng": 11.478727,
			"lat": 43.544097
		}, {
			"lng": 11.478886,
			"lat": 43.544205
		}, {
			"lng": 11.479024,
			"lat": 43.544328
		}, {
			"lng": 11.479406,
			"lat": 43.544413
		}, {
			"lng": 11.479681,
			"lat": 43.544443
		}, {
			"lng": 11.479935,
			"lat": 43.544497
		}, {
			"lng": 11.480158,
			"lat": 43.544497
		}, {
			"lng": 11.480422,
			"lat": 43.544482
		}, {
			"lng": 11.480528,
			"lat": 43.544528
		}, {
			"lng": 11.480285,
			"lat": 43.544751
		}, {
			"lng": 11.480169,
			"lat": 43.544882
		}, {
			"lng": 11.479904,
			"lat": 43.54489
		}, {
			"lng": 11.479364,
			"lat": 43.544821
		}, {
			"lng": 11.479226,
			"lat": 43.544929
		}, {
			"lng": 11.479036,
			"lat": 43.545214
		}, {
			"lng": 11.478898,
			"lat": 43.54543
		}, {
			"lng": 11.478898,
			"lat": 43.545507
		}, {
			"lng": 11.479513,
			"lat": 43.545583
		}, {
			"lng": 11.478412,
			"lat": 43.546831
		}, {
			"lng": 11.478571,
			"lat": 43.546939
		}, {
			"lng": 11.478624,
			"lat": 43.547047
		}, {
			"lng": 11.478317,
			"lat": 43.548135
		}, {
			"lng": 11.478115,
			"lat": 43.548204
		}, {
			"lng": 11.478283,
			"lat": 43.550745
		}, {
			"lng": 11.477952,
			"lat": 43.550835
		}, {
			"lng": 11.477785,
			"lat": 43.550896
		}, {
			"lng": 11.477726,
			"lat": 43.551043
		}, {
			"lng": 11.477714,
			"lat": 43.551216
		}, {
			"lng": 11.477762,
			"lat": 43.551414
		}, {
			"lng": 11.47781,
			"lat": 43.551578
		}, {
			"lng": 11.477881,
			"lat": 43.551743
		}, {
			"lng": 11.478083,
			"lat": 43.551829
		}, {
			"lng": 11.478321,
			"lat": 43.55182
		}, {
			"lng": 11.478725,
			"lat": 43.551829
		}, {
			"lng": 11.478986,
			"lat": 43.551889
		}, {
			"lng": 11.479153,
			"lat": 43.551898
		}, {
			"lng": 11.479343,
			"lat": 43.552044
		}, {
			"lng": 11.479771,
			"lat": 43.552035
		}, {
			"lng": 11.480068,
			"lat": 43.552079
		}, {
			"lng": 11.480449,
			"lat": 43.552122
		}, {
			"lng": 11.480496,
			"lat": 43.552199
		}, {
			"lng": 11.480473,
			"lat": 43.552294
		}, {
			"lng": 11.480615,
			"lat": 43.552363
		}, {
			"lng": 11.480687,
			"lat": 43.552424
		}, {
			"lng": 11.480496,
			"lat": 43.552493
		}, {
			"lng": 11.480247,
			"lat": 43.552536
		}, {
			"lng": 11.480069,
			"lat": 43.552554
		}, {
			"lng": 11.479902,
			"lat": 43.552554
		}, {
			"lng": 11.479736,
			"lat": 43.552563
		}, {
			"lng": 11.47957,
			"lat": 43.552675
		}, {
			"lng": 11.479522,
			"lat": 43.552753
		}, {
			"lng": 11.480381,
			"lat": 43.553334
		}, {
			"lng": 11.480512,
			"lat": 43.553481
		}, {
			"lng": 11.480381,
			"lat": 43.553567
		}, {
			"lng": 11.481036,
			"lat": 43.554379
		}, {
			"lng": 11.480668,
			"lat": 43.555261
		}, {
			"lng": 11.481025,
			"lat": 43.555209
		}, {
			"lng": 11.480989,
			"lat": 43.555485
		}, {
			"lng": 11.481156,
			"lat": 43.555701
		}, {
			"lng": 11.481227,
			"lat": 43.555909
		}, {
			"lng": 11.481227,
			"lat": 43.556038
		}, {
			"lng": 11.481358,
			"lat": 43.555952
		}, {
			"lng": 11.481524,
			"lat": 43.555891
		}, {
			"lng": 11.481762,
			"lat": 43.555831
		}, {
			"lng": 11.482047,
			"lat": 43.555787
		}, {
			"lng": 11.482261,
			"lat": 43.55577
		}, {
			"lng": 11.482486,
			"lat": 43.555723
		}, {
			"lng": 11.482728,
			"lat": 43.555661
		}, {
			"lng": 11.482976,
			"lat": 43.555572
		}, {
			"lng": 11.483179,
			"lat": 43.555575
		}, {
			"lng": 11.483654,
			"lat": 43.555464
		}, {
			"lng": 11.484176,
			"lat": 43.555411
		}, {
			"lng": 11.484557,
			"lat": 43.555423
		}, {
			"lng": 11.484845,
			"lat": 43.555088
		}, {
			"lng": 11.484889,
			"lat": 43.555318
		}, {
			"lng": 11.485071,
			"lat": 43.555567
		}, {
			"lng": 11.485142,
			"lat": 43.555491
		}, {
			"lng": 11.485335,
			"lat": 43.555697
		}, {
			"lng": 11.48536,
			"lat": 43.555747
		}, {
			"lng": 11.485435,
			"lat": 43.555816
		}, {
			"lng": 11.485225,
			"lat": 43.55572
		}, {
			"lng": 11.485147,
			"lat": 43.555724
		}, {
			"lng": 11.485216,
			"lat": 43.556164
		}, {
			"lng": 11.485299,
			"lat": 43.556234
		}, {
			"lng": 11.485208,
			"lat": 43.556349
		}, {
			"lng": 11.485146,
			"lat": 43.556508
		}, {
			"lng": 11.484877,
			"lat": 43.556825
		}, {
			"lng": 11.484623,
			"lat": 43.557077
		}, {
			"lng": 11.484561,
			"lat": 43.557117
		}, {
			"lng": 11.484553,
			"lat": 43.55725
		}, {
			"lng": 11.482781,
			"lat": 43.55823
		}, {
			"lng": 11.482175,
			"lat": 43.558573
		}, {
			"lng": 11.482107,
			"lat": 43.5587
		}, {
			"lng": 11.482178,
			"lat": 43.55988
		}, {
			"lng": 11.481944,
			"lat": 43.560267
		}, {
			"lng": 11.481783,
			"lat": 43.560798
		}, {
			"lng": 11.481648,
			"lat": 43.561113
		}, {
			"lng": 11.481573,
			"lat": 43.561194
		}, {
			"lng": 11.481474,
			"lat": 43.561203
		}, {
			"lng": 11.480906,
			"lat": 43.562202
		}, {
			"lng": 11.480965,
			"lat": 43.562414
		}, {
			"lng": 11.480769,
			"lat": 43.562363
		}, {
			"lng": 11.480266,
			"lat": 43.562347
		}, {
			"lng": 11.480175,
			"lat": 43.562235
		}, {
			"lng": 11.47998,
			"lat": 43.56206
		}, {
			"lng": 11.479796,
			"lat": 43.561844
		}, {
			"lng": 11.479728,
			"lat": 43.561786
		}, {
			"lng": 11.479469,
			"lat": 43.561497
		}, {
			"lng": 11.479266,
			"lat": 43.561271
		}, {
			"lng": 11.479098,
			"lat": 43.561082
		}, {
			"lng": 11.478944,
			"lat": 43.56088
		}, {
			"lng": 11.478769,
			"lat": 43.560656
		}, {
			"lng": 11.478666,
			"lat": 43.560537
		}, {
			"lng": 11.478499,
			"lat": 43.560375
		}, {
			"lng": 11.478147,
			"lat": 43.560024
		}, {
			"lng": 11.47783,
			"lat": 43.559822
		}, {
			"lng": 11.477556,
			"lat": 43.559693
		}, {
			"lng": 11.476748,
			"lat": 43.559506
		}, {
			"lng": 11.476387,
			"lat": 43.559499
		}, {
			"lng": 11.476321,
			"lat": 43.559504
		}, {
			"lng": 11.476531,
			"lat": 43.559405
		}, {
			"lng": 11.476681,
			"lat": 43.559348
		}, {
			"lng": 11.476874,
			"lat": 43.559222
		}, {
			"lng": 11.477033,
			"lat": 43.559103
		}, {
			"lng": 11.47723,
			"lat": 43.558924
		}, {
			"lng": 11.477397,
			"lat": 43.558682
		}, {
			"lng": 11.477485,
			"lat": 43.558531
		}, {
			"lng": 11.47755,
			"lat": 43.558441
		}, {
			"lng": 11.477611,
			"lat": 43.558348
		}, {
			"lng": 11.477724,
			"lat": 43.558185
		}, {
			"lng": 11.477809,
			"lat": 43.558075
		}, {
			"lng": 11.477872,
			"lat": 43.557961
		}, {
			"lng": 11.477909,
			"lat": 43.557822
		}, {
			"lng": 11.477869,
			"lat": 43.557695
		}, {
			"lng": 11.47782,
			"lat": 43.557569
		}, {
			"lng": 11.477731,
			"lat": 43.557434
		}, {
			"lng": 11.477676,
			"lat": 43.557344
		}, {
			"lng": 11.477656,
			"lat": 43.5572
		}, {
			"lng": 11.477656,
			"lat": 43.557057
		}, {
			"lng": 11.477677,
			"lat": 43.556848
		}, {
			"lng": 11.47765,
			"lat": 43.556725
		}, {
			"lng": 11.4776,
			"lat": 43.556637
		}, {
			"lng": 11.477414,
			"lat": 43.556313
		}, {
			"lng": 11.477362,
			"lat": 43.55624
		}, {
			"lng": 11.47729,
			"lat": 43.556133
		}, {
			"lng": 11.477232,
			"lat": 43.556055
		}, {
			"lng": 11.477183,
			"lat": 43.555978
		}, {
			"lng": 11.477096,
			"lat": 43.555853
		}, {
			"lng": 11.476923,
			"lat": 43.555596
		}, {
			"lng": 11.476331,
			"lat": 43.554831
		}, {
			"lng": 11.475633,
			"lat": 43.553951
		}, {
			"lng": 11.475353,
			"lat": 43.553765
		}, {
			"lng": 11.474663,
			"lat": 43.553356
		}, {
			"lng": 11.474351,
			"lat": 43.553237
		}, {
			"lng": 11.474073,
			"lat": 43.553251
		}, {
			"lng": 11.473952,
			"lat": 43.553279
		}, {
			"lng": 11.473594,
			"lat": 43.553507
		}, {
			"lng": 11.473428,
			"lat": 43.553688
		}, {
			"lng": 11.473348,
			"lat": 43.553852
		}, {
			"lng": 11.474131,
			"lat": 43.554932
		}, {
			"lng": 11.474278,
			"lat": 43.55536
		}, {
			"lng": 11.474349,
			"lat": 43.555394
		}, {
			"lng": 11.474536,
			"lat": 43.556231
		}, {
			"lng": 11.473808,
			"lat": 43.556736
		}, {
			"lng": 11.473349,
			"lat": 43.557127
		}, {
			"lng": 11.473184,
			"lat": 43.5573
		}, {
			"lng": 11.473067,
			"lat": 43.557287
		}, {
			"lng": 11.472373,
			"lat": 43.557623
		}, {
			"lng": 11.472042,
			"lat": 43.557779
		}, {
			"lng": 11.471828,
			"lat": 43.55788
		}, {
			"lng": 11.47174,
			"lat": 43.557958
		}, {
			"lng": 11.471524,
			"lat": 43.558158
		}, {
			"lng": 11.471375,
			"lat": 43.558297
		}, {
			"lng": 11.471222,
			"lat": 43.55844
		}, {
			"lng": 11.470802,
			"lat": 43.558717
		}, {
			"lng": 11.470458,
			"lat": 43.558942
		}, {
			"lng": 11.470357,
			"lat": 43.559008
		}, {
			"lng": 11.470206,
			"lat": 43.559107
		}, {
			"lng": 11.470091,
			"lat": 43.559183
		}, {
			"lng": 11.469983,
			"lat": 43.559254
		}, {
			"lng": 11.469625,
			"lat": 43.559489
		}, {
			"lng": 11.469495,
			"lat": 43.559542
		}]
	},
	"4": {
		"name": "Macrolotto C",
		"center": {
			"lng": 11.4771845,
			"lat": 43.5884585
		},
		"coords": [{
			"lng": 11.49147,
			"lat": 43.589399
		}, {
			"lng": 11.49165,
			"lat": 43.589623
		}, {
			"lng": 11.491704,
			"lat": 43.589671
		}, {
			"lng": 11.491772,
			"lat": 43.589731
		}, {
			"lng": 11.491843,
			"lat": 43.589793
		}, {
			"lng": 11.491965,
			"lat": 43.589899
		}, {
			"lng": 11.492,
			"lat": 43.589955
		}, {
			"lng": 11.49207,
			"lat": 43.590068
		}, {
			"lng": 11.492092,
			"lat": 43.590145
		}, {
			"lng": 11.492112,
			"lat": 43.590218
		}, {
			"lng": 11.492129,
			"lat": 43.590278
		}, {
			"lng": 11.492153,
			"lat": 43.590361
		}, {
			"lng": 11.492583,
			"lat": 43.59035
		}, {
			"lng": 11.492566,
			"lat": 43.590565
		}, {
			"lng": 11.492551,
			"lat": 43.590747
		}, {
			"lng": 11.492535,
			"lat": 43.590945
		}, {
			"lng": 11.492521,
			"lat": 43.59119
		}, {
			"lng": 11.492505,
			"lat": 43.591462
		}, {
			"lng": 11.492458,
			"lat": 43.591637
		}, {
			"lng": 11.492443,
			"lat": 43.591795
		}, {
			"lng": 11.492406,
			"lat": 43.591871
		}, {
			"lng": 11.492569,
			"lat": 43.591864
		}, {
			"lng": 11.492206,
			"lat": 43.592726
		}, {
			"lng": 11.492098,
			"lat": 43.592809
		}, {
			"lng": 11.491969,
			"lat": 43.593011
		}, {
			"lng": 11.491935,
			"lat": 43.593483
		}, {
			"lng": 11.491939,
			"lat": 43.594092
		}, {
			"lng": 11.491303,
			"lat": 43.594015
		}, {
			"lng": 11.490593,
			"lat": 43.59403
		}, {
			"lng": 11.490355,
			"lat": 43.594011
		}, {
			"lng": 11.489623,
			"lat": 43.593917
		}, {
			"lng": 11.489329,
			"lat": 43.593932
		}, {
			"lng": 11.488566,
			"lat": 43.594016
		}, {
			"lng": 11.488457,
			"lat": 43.594059
		}, {
			"lng": 11.488242,
			"lat": 43.594063
		}, {
			"lng": 11.48762,
			"lat": 43.59431
		}, {
			"lng": 11.487508,
			"lat": 43.594324
		}, {
			"lng": 11.487277,
			"lat": 43.594458
		}, {
			"lng": 11.487045,
			"lat": 43.594526
		}, {
			"lng": 11.486996,
			"lat": 43.594666
		}, {
			"lng": 11.486865,
			"lat": 43.594838
		}, {
			"lng": 11.486708,
			"lat": 43.594931
		}, {
			"lng": 11.486539,
			"lat": 43.595069
		}, {
			"lng": 11.486495,
			"lat": 43.595163
		}, {
			"lng": 11.486471,
			"lat": 43.595239
		}, {
			"lng": 11.486383,
			"lat": 43.595493
		}, {
			"lng": 11.486218,
			"lat": 43.595691
		}, {
			"lng": 11.485949,
			"lat": 43.595715
		}, {
			"lng": 11.485804,
			"lat": 43.595709
		}, {
			"lng": 11.485404,
			"lat": 43.595683
		}, {
			"lng": 11.485219,
			"lat": 43.595619
		}, {
			"lng": 11.485073,
			"lat": 43.595712
		}, {
			"lng": 11.484817,
			"lat": 43.595724
		}, {
			"lng": 11.484544,
			"lat": 43.595672
		}, {
			"lng": 11.484245,
			"lat": 43.595559
		}, {
			"lng": 11.484149,
			"lat": 43.595565
		}, {
			"lng": 11.483937,
			"lat": 43.595644
		}, {
			"lng": 11.483716,
			"lat": 43.595666
		}, {
			"lng": 11.483365,
			"lat": 43.595775
		}, {
			"lng": 11.483258,
			"lat": 43.595884
		}, {
			"lng": 11.48312,
			"lat": 43.595921
		}, {
			"lng": 11.482746,
			"lat": 43.595913
		}, {
			"lng": 11.482512,
			"lat": 43.595928
		}, {
			"lng": 11.482225,
			"lat": 43.595771
		}, {
			"lng": 11.482029,
			"lat": 43.595703
		}, {
			"lng": 11.481296,
			"lat": 43.595712
		}, {
			"lng": 11.481287,
			"lat": 43.595753
		}, {
			"lng": 11.480799,
			"lat": 43.595739
		}, {
			"lng": 11.480604,
			"lat": 43.595749
		}, {
			"lng": 11.480549,
			"lat": 43.595709
		}, {
			"lng": 11.480259,
			"lat": 43.595877
		}, {
			"lng": 11.480101,
			"lat": 43.59602
		}, {
			"lng": 11.479515,
			"lat": 43.596431
		}, {
			"lng": 11.478651,
			"lat": 43.596816
		}, {
			"lng": 11.479076,
			"lat": 43.597284
		}, {
			"lng": 11.474419,
			"lat": 43.597282
		}, {
			"lng": 11.47427,
			"lat": 43.59725
		}, {
			"lng": 11.474026,
			"lat": 43.597253
		}, {
			"lng": 11.473782,
			"lat": 43.597027
		}, {
			"lng": 11.473937,
			"lat": 43.596897
		}, {
			"lng": 11.474141,
			"lat": 43.596805
		}, {
			"lng": 11.473554,
			"lat": 43.596639
		}, {
			"lng": 11.473462,
			"lat": 43.596529
		}, {
			"lng": 11.47313,
			"lat": 43.596388
		}, {
			"lng": 11.472803,
			"lat": 43.596323
		}, {
			"lng": 11.472876,
			"lat": 43.596147
		}, {
			"lng": 11.472985,
			"lat": 43.595981
		}, {
			"lng": 11.472746,
			"lat": 43.595864
		}, {
			"lng": 11.471734,
			"lat": 43.595369
		}, {
			"lng": 11.470519,
			"lat": 43.594766
		}, {
			"lng": 11.470644,
			"lat": 43.594702
		}, {
			"lng": 11.470829,
			"lat": 43.594462
		}, {
			"lng": 11.470846,
			"lat": 43.59428
		}, {
			"lng": 11.470773,
			"lat": 43.594062
		}, {
			"lng": 11.470761,
			"lat": 43.593941
		}, {
			"lng": 11.4708,
			"lat": 43.593719
		}, {
			"lng": 11.470856,
			"lat": 43.593413
		}, {
			"lng": 11.470893,
			"lat": 43.593305
		}, {
			"lng": 11.470922,
			"lat": 43.593032
		}, {
			"lng": 11.470734,
			"lat": 43.592782
		}, {
			"lng": 11.470642,
			"lat": 43.592786
		}, {
			"lng": 11.470533,
			"lat": 43.592889
		}, {
			"lng": 11.470351,
			"lat": 43.592887
		}, {
			"lng": 11.469918,
			"lat": 43.592674
		}, {
			"lng": 11.469379,
			"lat": 43.592491
		}, {
			"lng": 11.468817,
			"lat": 43.592031
		}, {
			"lng": 11.468469,
			"lat": 43.591914
		}, {
			"lng": 11.468131,
			"lat": 43.591913
		}, {
			"lng": 11.467733,
			"lat": 43.592084
		}, {
			"lng": 11.467027,
			"lat": 43.592042
		}, {
			"lng": 11.466662,
			"lat": 43.591887
		}, {
			"lng": 11.466638,
			"lat": 43.591835
		}, {
			"lng": 11.466627,
			"lat": 43.591762
		}, {
			"lng": 11.466335,
			"lat": 43.591403
		}, {
			"lng": 11.466054,
			"lat": 43.591229
		}, {
			"lng": 11.465848,
			"lat": 43.59119
		}, {
			"lng": 11.465679,
			"lat": 43.591114
		}, {
			"lng": 11.464908,
			"lat": 43.590937
		}, {
			"lng": 11.464881,
			"lat": 43.590686
		}, {
			"lng": 11.464794,
			"lat": 43.590414
		}, {
			"lng": 11.464547,
			"lat": 43.590042
		}, {
			"lng": 11.464354,
			"lat": 43.589934
		}, {
			"lng": 11.46419,
			"lat": 43.589893
		}, {
			"lng": 11.464018,
			"lat": 43.589682
		}, {
			"lng": 11.463858,
			"lat": 43.58954
		}, {
			"lng": 11.463785,
			"lat": 43.589444
		}, {
			"lng": 11.46339,
			"lat": 43.589156
		}, {
			"lng": 11.462638,
			"lat": 43.588831
		}, {
			"lng": 11.462467,
			"lat": 43.58878
		}, {
			"lng": 11.462256,
			"lat": 43.588729
		}, {
			"lng": 11.462171,
			"lat": 43.588688
		}, {
			"lng": 11.462024,
			"lat": 43.588643
		}, {
			"lng": 11.46188,
			"lat": 43.588581
		}, {
			"lng": 11.461786,
			"lat": 43.588364
		}, {
			"lng": 11.461806,
			"lat": 43.588282
		}, {
			"lng": 11.461848,
			"lat": 43.588236
		}, {
			"lng": 11.461885,
			"lat": 43.588199
		}, {
			"lng": 11.462052,
			"lat": 43.588064
		}, {
			"lng": 11.462288,
			"lat": 43.587729
		}, {
			"lng": 11.462394,
			"lat": 43.58758
		}, {
			"lng": 11.462603,
			"lat": 43.58735
		}, {
			"lng": 11.462865,
			"lat": 43.587194
		}, {
			"lng": 11.462981,
			"lat": 43.587123
		}, {
			"lng": 11.463106,
			"lat": 43.586947
		}, {
			"lng": 11.463226,
			"lat": 43.586817
		}, {
			"lng": 11.463299,
			"lat": 43.586792
		}, {
			"lng": 11.463477,
			"lat": 43.586715
		}, {
			"lng": 11.463676,
			"lat": 43.586639
		}, {
			"lng": 11.465536,
			"lat": 43.585892
		}, {
			"lng": 11.467395,
			"lat": 43.585122
		}, {
			"lng": 11.4703,
			"lat": 43.583182
		}, {
			"lng": 11.47068,
			"lat": 43.582948
		}, {
			"lng": 11.468812,
			"lat": 43.580984
		}, {
			"lng": 11.469424,
			"lat": 43.580862
		}, {
			"lng": 11.469523,
			"lat": 43.580779
		}, {
			"lng": 11.470064,
			"lat": 43.580693
		}, {
			"lng": 11.470193,
			"lat": 43.581309
		}, {
			"lng": 11.470438,
			"lat": 43.581818
		}, {
			"lng": 11.470957,
			"lat": 43.581556
		}, {
			"lng": 11.471229,
			"lat": 43.582295
		}, {
			"lng": 11.471308,
			"lat": 43.58256
		}, {
			"lng": 11.472054,
			"lat": 43.582101
		}, {
			"lng": 11.472892,
			"lat": 43.581884
		}, {
			"lng": 11.473883,
			"lat": 43.581777
		}, {
			"lng": 11.474921,
			"lat": 43.581768
		}, {
			"lng": 11.474559,
			"lat": 43.580407
		}, {
			"lng": 11.474409,
			"lat": 43.580437
		}, {
			"lng": 11.474252,
			"lat": 43.580413
		}, {
			"lng": 11.474135,
			"lat": 43.580473
		}, {
			"lng": 11.474118,
			"lat": 43.580527
		}, {
			"lng": 11.474055,
			"lat": 43.580585
		}, {
			"lng": 11.473975,
			"lat": 43.580604
		}, {
			"lng": 11.473667,
			"lat": 43.580519
		}, {
			"lng": 11.473725,
			"lat": 43.580212
		}, {
			"lng": 11.473934,
			"lat": 43.580112
		}, {
			"lng": 11.474069,
			"lat": 43.580029
		}, {
			"lng": 11.474311,
			"lat": 43.579941
		}, {
			"lng": 11.474418,
			"lat": 43.579932
		}, {
			"lng": 11.474574,
			"lat": 43.57994
		}, {
			"lng": 11.47476,
			"lat": 43.57998
		}, {
			"lng": 11.475059,
			"lat": 43.580069
		}, {
			"lng": 11.47527,
			"lat": 43.580114
		}, {
			"lng": 11.475414,
			"lat": 43.580358
		}, {
			"lng": 11.475409,
			"lat": 43.580559
		}, {
			"lng": 11.476201,
			"lat": 43.581203
		}, {
			"lng": 11.476606,
			"lat": 43.581775
		}, {
			"lng": 11.477298,
			"lat": 43.581646
		}, {
			"lng": 11.47691,
			"lat": 43.581059
		}, {
			"lng": 11.476512,
			"lat": 43.580652
		}, {
			"lng": 11.476259,
			"lat": 43.580323
		}, {
			"lng": 11.476244,
			"lat": 43.579877
		}, {
			"lng": 11.476449,
			"lat": 43.579833
		}, {
			"lng": 11.476701,
			"lat": 43.579649
		}, {
			"lng": 11.4768,
			"lat": 43.579689
		}, {
			"lng": 11.476871,
			"lat": 43.579667
		}, {
			"lng": 11.477132,
			"lat": 43.579648
		}, {
			"lng": 11.477258,
			"lat": 43.579651
		}, {
			"lng": 11.477364,
			"lat": 43.579667
		}, {
			"lng": 11.477599,
			"lat": 43.579685
		}, {
			"lng": 11.477709,
			"lat": 43.57966
		}, {
			"lng": 11.477847,
			"lat": 43.579635
		}, {
			"lng": 11.477924,
			"lat": 43.579633
		}, {
			"lng": 11.478307,
			"lat": 43.57973
		}, {
			"lng": 11.478432,
			"lat": 43.57991
		}, {
			"lng": 11.47858,
			"lat": 43.579875
		}, {
			"lng": 11.478912,
			"lat": 43.579669
		}, {
			"lng": 11.478974,
			"lat": 43.57968
		}, {
			"lng": 11.47918,
			"lat": 43.581263
		}, {
			"lng": 11.480537,
			"lat": 43.582985
		}, {
			"lng": 11.480025,
			"lat": 43.583147
		}, {
			"lng": 11.480201,
			"lat": 43.583322
		}, {
			"lng": 11.480392,
			"lat": 43.583401
		}, {
			"lng": 11.480751,
			"lat": 43.583478
		}, {
			"lng": 11.480959,
			"lat": 43.583631
		}, {
			"lng": 11.481125,
			"lat": 43.583652
		}, {
			"lng": 11.480851,
			"lat": 43.585108
		}, {
			"lng": 11.481624,
			"lat": 43.585661
		}, {
			"lng": 11.48173,
			"lat": 43.585863
		}, {
			"lng": 11.481863,
			"lat": 43.585992
		}, {
			"lng": 11.482016,
			"lat": 43.586243
		}, {
			"lng": 11.482343,
			"lat": 43.586288
		}, {
			"lng": 11.482694,
			"lat": 43.58614
		}, {
			"lng": 11.482452,
			"lat": 43.586432
		}, {
			"lng": 11.482691,
			"lat": 43.586667
		}, {
			"lng": 11.483138,
			"lat": 43.586615
		}, {
			"lng": 11.483321,
			"lat": 43.586718
		}, {
			"lng": 11.483186,
			"lat": 43.587304
		}, {
			"lng": 11.483588,
			"lat": 43.587415
		}, {
			"lng": 11.483918,
			"lat": 43.587464
		}, {
			"lng": 11.484099,
			"lat": 43.587478
		}, {
			"lng": 11.484601,
			"lat": 43.587524
		}, {
			"lng": 11.484953,
			"lat": 43.587564
		}, {
			"lng": 11.485067,
			"lat": 43.587595
		}, {
			"lng": 11.485195,
			"lat": 43.587629
		}, {
			"lng": 11.485385,
			"lat": 43.587644
		}, {
			"lng": 11.485588,
			"lat": 43.587682
		}, {
			"lng": 11.485964,
			"lat": 43.587762
		}, {
			"lng": 11.486502,
			"lat": 43.587895
		}, {
			"lng": 11.487348,
			"lat": 43.588264
		}, {
			"lng": 11.488464,
			"lat": 43.588299
		}, {
			"lng": 11.488601,
			"lat": 43.588128
		}, {
			"lng": 11.488966,
			"lat": 43.587824
		}, {
			"lng": 11.489715,
			"lat": 43.587774
		}, {
			"lng": 11.490046,
			"lat": 43.5876
		}, {
			"lng": 11.490387,
			"lat": 43.587133
		}, {
			"lng": 11.490623,
			"lat": 43.586992
		}, {
			"lng": 11.490685,
			"lat": 43.587053
		}, {
			"lng": 11.490384,
			"lat": 43.587372
		}, {
			"lng": 11.490165,
			"lat": 43.587598
		}, {
			"lng": 11.490569,
			"lat": 43.58779
		}, {
			"lng": 11.49128,
			"lat": 43.588107
		}, {
			"lng": 11.491145,
			"lat": 43.589027
		}, {
			"lng": 11.491256,
			"lat": 43.589133
		}, {
			"lng": 11.49147,
			"lat": 43.589399
		}

		]
	},
	"5": {
		"name": "Macrolotto TAV",
		"center": {
			"lng": 11.47375,
			"lat": 43.55756
		},
		"coords": [{
			"lng": 11.476333,
			"lat": 43.5595
		}, {
			"lng": 11.476222,
			"lat": 43.559535
		}, {
			"lng": 11.476193,
			"lat": 43.559657
		}, {
			"lng": 11.475997,
			"lat": 43.559921
		}, {
			"lng": 11.475924,
			"lat": 43.560102
		}, {
			"lng": 11.475963,
			"lat": 43.560148
		}, {
			"lng": 11.47614,
			"lat": 43.560354
		}, {
			"lng": 11.47617,
			"lat": 43.560538
		}, {
			"lng": 11.4762,
			"lat": 43.560723
		}, {
			"lng": 11.476102,
			"lat": 43.560779
		}, {
			"lng": 11.475768,
			"lat": 43.560973
		}, {
			"lng": 11.475728,
			"lat": 43.561023
		}, {
			"lng": 11.475458,
			"lat": 43.560997
		}, {
			"lng": 11.475429,
			"lat": 43.56092
		}, {
			"lng": 11.475367,
			"lat": 43.560797
		}, {
			"lng": 11.475302,
			"lat": 43.560714
		}, {
			"lng": 11.475214,
			"lat": 43.560745
		}, {
			"lng": 11.47335,
			"lat": 43.561807
		}, {
			"lng": 11.473217,
			"lat": 43.561883
		}, {
			"lng": 11.473025,
			"lat": 43.561873
		}, {
			"lng": 11.472914,
			"lat": 43.561865
		}, {
			"lng": 11.472706,
			"lat": 43.561854
		}, {
			"lng": 11.472555,
			"lat": 43.561846
		}, {
			"lng": 11.472437,
			"lat": 43.561837
		}, {
			"lng": 11.472243,
			"lat": 43.561657
		}, {
			"lng": 11.471945,
			"lat": 43.561694
		}, {
			"lng": 11.47167,
			"lat": 43.561697
		}, {
			"lng": 11.471505,
			"lat": 43.561684
		}, {
			"lng": 11.47134,
			"lat": 43.561661
		}, {
			"lng": 11.471145,
			"lat": 43.56162
		}, {
			"lng": 11.47096,
			"lat": 43.561559
		}, {
			"lng": 11.470988,
			"lat": 43.561513
		}, {
			"lng": 11.470665,
			"lat": 43.561236
		}, {
			"lng": 11.470443,
			"lat": 43.561043
		}, {
			"lng": 11.470328,
			"lat": 43.560931
		}, {
			"lng": 11.47017,
			"lat": 43.560767
		}, {
			"lng": 11.470093,
			"lat": 43.560686
		}, {
			"lng": 11.470007,
			"lat": 43.560604
		}, {
			"lng": 11.469956,
			"lat": 43.560551
		}, {
			"lng": 11.469921,
			"lat": 43.560511
		}, {
			"lng": 11.469903,
			"lat": 43.560493
		}, {
			"lng": 11.469859,
			"lat": 43.560454
		}, {
			"lng": 11.469782,
			"lat": 43.56038
		}, {
			"lng": 11.469591,
			"lat": 43.560216
		}, {
			"lng": 11.469625,
			"lat": 43.559489
		}, {
			"lng": 11.469983,
			"lat": 43.559254
		}, {
			"lng": 11.470091,
			"lat": 43.559183
		}, {
			"lng": 11.470206,
			"lat": 43.559107
		}, {
			"lng": 11.470357,
			"lat": 43.559008
		}, {
			"lng": 11.470458,
			"lat": 43.558942
		}, {
			"lng": 11.470802,
			"lat": 43.558717
		}, {
			"lng": 11.471222,
			"lat": 43.55844
		}, {
			"lng": 11.471375,
			"lat": 43.558297
		}, {
			"lng": 11.471524,
			"lat": 43.558158
		}, {
			"lng": 11.47174,
			"lat": 43.557958
		}, {
			"lng": 11.471828,
			"lat": 43.55788
		}, {
			"lng": 11.472042,
			"lat": 43.557779
		}, {
			"lng": 11.472373,
			"lat": 43.557623
		}, {
			"lng": 11.473067,
			"lat": 43.557287
		}, {
			"lng": 11.473184,
			"lat": 43.5573
		}, {
			"lng": 11.473349,
			"lat": 43.557127
		}, {
			"lng": 11.473808,
			"lat": 43.556736
		}, {
			"lng": 11.474536,
			"lat": 43.556231
		}, {
			"lng": 11.474349,
			"lat": 43.555394
		}, {
			"lng": 11.474278,
			"lat": 43.55536
		}, {
			"lng": 11.474131,
			"lat": 43.554932
		}, {
			"lng": 11.473348,
			"lat": 43.553852
		}, {
			"lng": 11.473428,
			"lat": 43.553688
		}, {
			"lng": 11.473594,
			"lat": 43.553507
		}, {
			"lng": 11.473952,
			"lat": 43.553279
		}, {
			"lng": 11.474073,
			"lat": 43.553251
		}, {
			"lng": 11.474351,
			"lat": 43.553237
		}, {
			"lng": 11.474663,
			"lat": 43.553356
		}, {
			"lng": 11.475353,
			"lat": 43.553765
		}, {
			"lng": 11.475633,
			"lat": 43.553951
		}, {
			"lng": 11.476331,
			"lat": 43.554831
		}, {
			"lng": 11.476923,
			"lat": 43.555596
		}, {
			"lng": 11.477096,
			"lat": 43.555853
		}, {
			"lng": 11.477183,
			"lat": 43.555978
		}, {
			"lng": 11.477232,
			"lat": 43.556055
		}, {
			"lng": 11.47729,
			"lat": 43.556133
		}, {
			"lng": 11.477362,
			"lat": 43.55624
		}, {
			"lng": 11.477414,
			"lat": 43.556313
		}, {
			"lng": 11.4776,
			"lat": 43.556637
		}, {
			"lng": 11.47765,
			"lat": 43.556725
		}, {
			"lng": 11.477677,
			"lat": 43.556848
		}, {
			"lng": 11.477656,
			"lat": 43.557057
		}, {
			"lng": 11.477656,
			"lat": 43.5572
		}, {
			"lng": 11.477676,
			"lat": 43.557344
		}, {
			"lng": 11.477731,
			"lat": 43.557434
		}, {
			"lng": 11.47782,
			"lat": 43.557569
		}, {
			"lng": 11.477869,
			"lat": 43.557695
		}, {
			"lng": 11.477909,
			"lat": 43.557822
		}, {
			"lng": 11.477872,
			"lat": 43.557961
		}, {
			"lng": 11.477809,
			"lat": 43.558075
		}, {
			"lng": 11.477724,
			"lat": 43.558185
		}, {
			"lng": 11.477611,
			"lat": 43.558348
		}, {
			"lng": 11.47755,
			"lat": 43.558441
		}, {
			"lng": 11.477485,
			"lat": 43.558531
		}, {
			"lng": 11.477397,
			"lat": 43.558682
		}, {
			"lng": 11.47723,
			"lat": 43.558924
		}, {
			"lng": 11.477033,
			"lat": 43.559103
		}, {
			"lng": 11.476874,
			"lat": 43.559222
		}, {
			"lng": 11.476681,
			"lat": 43.559348
		}, {
			"lng": 11.476531,
			"lat": 43.559405
		}, {
			"lng": 11.476333,
			"lat": 43.5595
		}]
	},
	"6": {
		"name": "Macrolotto E (Lotto Emissario Castelnuovo)",
		"center": {
			"lng": 11.472652,
			"lat": 43.562223
		},
		"coords": [{
			"lng": 11.4775179562515,
			"lat": 43.5622068468829
		}, {
			"lng": 11.4775246683907,
			"lat": 43.5621072628257
		}, {
			"lng": 11.4774246316221,
			"lat": 43.5620975694403
		}, {
			"lng": 11.4772487088035,
			"lat": 43.5620837192374
		}, {
			"lng": 11.477092514138,
			"lat": 43.5620742013612
		}, {
			"lng": 11.4760481837008,
			"lat": 43.5620170934356
		}, {
			"lng": 11.4749874029815,
			"lat": 43.5619729312523
		}, {
			"lng": 11.4738962258558,
			"lat": 43.5619182139435
		}, {
			"lng": 11.472554577758,
			"lat": 43.561845796609
		}, {
			"lng": 11.472437219186,
			"lat": 43.5618365556195
		}, {
			"lng": 11.4722431622735,
			"lat": 43.5616565545495
		}, {
			"lng": 11.4719449510864,
			"lat": 43.56169375172
		}, {
			"lng": 11.4716699969698,
			"lat": 43.5616972625217
		}, {
			"lng": 11.471505054551,
			"lat": 43.5616837583772
		}, {
			"lng": 11.4713397149568,
			"lat": 43.5616605115007
		}, {
			"lng": 11.4711451388083,
			"lat": 43.5616196064362
		}, {
			"lng": 11.4709598193385,
			"lat": 43.5615589923861
		}, {
			"lng": 11.4709881403359,
			"lat": 43.5615132674253
		}, {
			"lng": 11.4707255946765,
			"lat": 43.5612875380927
		}, {
			"lng": 11.4703830315644,
			"lat": 43.5609901853697
		}, {
			"lng": 11.4699139280236,
			"lat": 43.5605049769686
		}, {
			"lng": 11.4695914168466,
			"lat": 43.5602168809239
		}, {
			"lng": 11.4696053407828,
			"lat": 43.5599284529168
		}, {
			"lng": 11.4696273376079,
			"lat": 43.5594952317873
		}, {
			"lng": 11.4695098284426,
			"lat": 43.5595393203828
		}, {
			"lng": 11.469507574982,
			"lat": 43.5595544351023
		}, {
			"lng": 11.4695063061747,
			"lat": 43.5595634086751
		}, {
			"lng": 11.4695048018938,
			"lat": 43.5595723765326
		}, {
			"lng": 11.4695017921305,
			"lat": 43.5595903131739
		}, {
			"lng": 11.469498783566,
			"lat": 43.5596082488887
		}, {
			"lng": 11.4694957749999,
			"lat": 43.5596261846035
		}, {
			"lng": 11.4694927664322,
			"lat": 43.5596441203181
		}, {
			"lng": 11.4694897578998,
			"lat": 43.5596620569323
		}, {
			"lng": 11.469486748092,
			"lat": 43.5596799926735
		}, {
			"lng": 11.4694840044865,
			"lat": 43.5596963533035
		}, {
			"lng": 11.4694790972234,
			"lat": 43.5597231492503
		}, {
			"lng": 11.4694731650327,
			"lat": 43.5597271986043
		}, {
			"lng": 11.469433852296,
			"lat": 43.5597651510011
		}, {
			"lng": 11.4693950089839,
			"lat": 43.5598040179267
		}, {
			"lng": 11.4693558357276,
			"lat": 43.5598445072467
		}, {
			"lng": 11.4693481057112,
			"lat": 43.5598543416566
		}, {
			"lng": 11.4692714447522,
			"lat": 43.5598524707128
		}, {
			"lng": 11.469200554397,
			"lat": 43.5598156592199
		}, {
			"lng": 11.4691407976883,
			"lat": 43.5597851924486
		}, {
			"lng": 11.4690792741044,
			"lat": 43.5597767807555
		}, {
			"lng": 11.4690800428545,
			"lat": 43.5597601125635
		}, {
			"lng": 11.4690804578074,
			"lat": 43.55975111783
		}, {
			"lng": 11.4690808591162,
			"lat": 43.559742122491
		}, {
			"lng": 11.4690766880759,
			"lat": 43.5597150068194
		}, {
			"lng": 11.4690755352656,
			"lat": 43.5597059739337
		}, {
			"lng": 11.4690743638637,
			"lat": 43.5596969405494
		}, {
			"lng": 11.4690728627917,
			"lat": 43.5596878989825
		}, {
			"lng": 11.4690718225541,
			"lat": 43.5596698643917
		}, {
			"lng": 11.4690707963571,
			"lat": 43.5596520825035
		}, {
			"lng": 11.4689078997111,
			"lat": 43.5596714373739
		}, {
			"lng": 11.4685207120547,
			"lat": 43.5597781862815
		}, {
			"lng": 11.4681871395076,
			"lat": 43.5598882722152
		}, {
			"lng": 11.4678315638749,
			"lat": 43.5600074075997
		}, {
			"lng": 11.4677971653097,
			"lat": 43.5600827720238
		}, {
			"lng": 11.4676079108815,
			"lat": 43.5606947500699
		}, {
			"lng": 11.4675665929042,
			"lat": 43.5608280203574
		}, {
			"lng": 11.4674106927751,
			"lat": 43.561321945935
		}, {
			"lng": 11.4677101120026,
			"lat": 43.5613837589119
		}, {
			"lng": 11.468013621799,
			"lat": 43.5614250288757
		}, {
			"lng": 11.4682522658754,
			"lat": 43.561492520877
		}, {
			"lng": 11.4685648242314,
			"lat": 43.5616019316343
		}, {
			"lng": 11.4686020901647,
			"lat": 43.5616203630667
		}, {
			"lng": 11.4687254847453,
			"lat": 43.5616621153613
		}, {
			"lng": 11.4690969112416,
			"lat": 43.5617838844361
		}, {
			"lng": 11.4694309891977,
			"lat": 43.5618997165669
		}, {
			"lng": 11.4697712609518,
			"lat": 43.5619968714678
		}, {
			"lng": 11.4700367633956,
			"lat": 43.5620804712574
		}, {
			"lng": 11.4705015390271,
			"lat": 43.5622514284595
		}, {
			"lng": 11.4707366370614,
			"lat": 43.5623209835485
		}, {
			"lng": 11.470954458581,
			"lat": 43.5623790700106
		}, {
			"lng": 11.4710601721516,
			"lat": 43.5624063017922
		}, {
			"lng": 11.4714829367833,
			"lat": 43.5625082312449
		}, {
			"lng": 11.4715198384655,
			"lat": 43.5625609163363
		}, {
			"lng": 11.4715247693336,
			"lat": 43.5625627445884
		}, {
			"lng": 11.4717869971455,
			"lat": 43.5626319762765
		}, {
			"lng": 11.4720525657467,
			"lat": 43.5627057378078
		}, {
			"lng": 11.4722661323459,
			"lat": 43.562756240801
		}, {
			"lng": 11.4724385030895,
			"lat": 43.5627980944324
		}, {
			"lng": 11.4726051316974,
			"lat": 43.5628421933515
		}, {
			"lng": 11.4728305360137,
			"lat": 43.5628926624077
		}, {
			"lng": 11.4729769466663,
			"lat": 43.5629340596264
		}, {
			"lng": 11.4730596962306,
			"lat": 43.5629656410802
		}, {
			"lng": 11.4731607694109,
			"lat": 43.5629771625292
		}, {
			"lng": 11.4733456482618,
			"lat": 43.5629777309804
		}, {
			"lng": 11.473575168913,
			"lat": 43.5629791631709
		}, {
			"lng": 11.4737976886181,
			"lat": 43.5629469292208
		}, {
			"lng": 11.4741694580114,
			"lat": 43.5629050659215
		}, {
			"lng": 11.4746327088253,
			"lat": 43.5628693919692
		}, {
			"lng": 11.4746360769788,
			"lat": 43.562869037204
		}, {
			"lng": 11.475114871057,
			"lat": 43.5628045547436
		}, {
			"lng": 11.4755588587699,
			"lat": 43.5627537817207
		}, {
			"lng": 11.4761822901655,
			"lat": 43.5627439885732
		}, {
			"lng": 11.4761882706699,
			"lat": 43.5627616360058
		}, {
			"lng": 11.4769880189725,
			"lat": 43.5626462377653
		}, {
			"lng": 11.4770872332384,
			"lat": 43.5626572305983
		}, {
			"lng": 11.4773330534199,
			"lat": 43.5626478574961
		}, {
			"lng": 11.4776911318554,
			"lat": 43.5626623370287
		}, {
			"lng": 11.4777805740518,
			"lat": 43.5626725300397
		}, {
			"lng": 11.4779507052181,
			"lat": 43.5626829962528
		}, {
			"lng": 11.4781365798093,
			"lat": 43.5627042413127
		}, {
			"lng": 11.4783186630584,
			"lat": 43.5627382501106
		}, {
			"lng": 11.478426386189,
			"lat": 43.5627556065587
		}, {
			"lng": 11.4787197157277,
			"lat": 43.5628377280364
		}, {
			"lng": 11.4788171330064,
			"lat": 43.5628644194989
		}, {
			"lng": 11.4791160859153,
			"lat": 43.5630197122185
		}, {
			"lng": 11.4791643481675,
			"lat": 43.5630385588728
		}, {
			"lng": 11.4793725392736,
			"lat": 43.5631300008637
		}, {
			"lng": 11.4797063834472,
			"lat": 43.5632716045879
		}, {
			"lng": 11.4799323131413,
			"lat": 43.5633638310685
		}, {
			"lng": 11.4801633842608,
			"lat": 43.5634629900431
		}, {
			"lng": 11.4802192274814,
			"lat": 43.5633785335573
		}, {
			"lng": 11.48021484871,
			"lat": 43.5633259466732
		}, {
			"lng": 11.4801965749893,
			"lat": 43.5632775798419
		}, {
			"lng": 11.4801671043915,
			"lat": 43.5632352139607
		}, {
			"lng": 11.4801217913891,
			"lat": 43.5631924869539
		}, {
			"lng": 11.4789646326425,
			"lat": 43.5626887243895
		}, {
			"lng": 11.4788836809659,
			"lat": 43.5626842203609
		}, {
			"lng": 11.4788163164932,
			"lat": 43.5626786489836
		}, {
			"lng": 11.4785749312133,
			"lat": 43.5625681276513
		}, {
			"lng": 11.4783082585577,
			"lat": 43.5624617107822
		}, {
			"lng": 11.4781886531143,
			"lat": 43.5624214362399
		}, {
			"lng": 11.477914930347,
			"lat": 43.5623454186142
		}, {
			"lng": 11.4776758321819,
			"lat": 43.5622969087406
		}, {
			"lng": 11.4775179562515,
			"lat": 43.5622068468829
		}]
	}

};

export const DEMO_SUBAREE = {
	"16": {
		"name": "MA01 - Lago di Castelnuovo sponda Nord-Est",
		"center": {
			"lat": 43.557686963065514,
			"lng": 11.471264234995212
		},
		"coords": [
			[{
				"lng": 11.470005887816072,
				"lat": 43.557952318468381
			},
			{
				"lng": 11.470002784907155,
				"lat": 43.557943050347127
			},
			{
				"lng": 11.469998801200147,
				"lat": 43.557933962066002
			},
			{
				"lng": 11.469993956075495,
				"lat": 43.557925097838023
			},
			{
				"lng": 11.469993956075495,
				"lat": 43.557925097838023
			},
			{
				"lng": 11.469933045535649,
				"lat": 43.557831506382655
			},
			{
				"lng": 11.469933045535655,
				"lat": 43.557831506382669
			},
			{
				"lng": 11.469878795532324,
				"lat": 43.557759176879642
			},
			{
				"lng": 11.469878795532324,
				"lat": 43.557759176879642
			},
			{
				"lng": 11.46987496328064,
				"lat": 43.557754688564145
			},
			{
				"lng": 11.469870793326253,
				"lat": 43.557750362395787
			},
			{
				"lng": 11.46986629860794,
				"lat": 43.557746211797969
			},
			{
				"lng": 11.469861493072186,
				"lat": 43.557742249649365
			},
			{
				"lng": 11.469861493072179,
				"lat": 43.557742249649358
			},
			{
				"lng": 11.4698583494337,
				"lat": 43.557739962344343
			},
			{
				"lng": 11.469854996472716,
				"lat": 43.557737838070196
			},
			{
				"lng": 11.469851450139863,
				"lat": 43.557735886932463
			},
			{
				"lng": 11.469847727305666,
				"lat": 43.557734118213034
			},
			{
				"lng": 11.469843845680298,
				"lat": 43.557732540326008
			},
			{
				"lng": 11.469839823729302,
				"lat": 43.557731160777635
			},
			{
				"lng": 11.469835680585811,
				"lat": 43.557729986130731
			},
			{
				"lng": 11.469835680585815,
				"lat": 43.55772998613071
			},
			{
				"lng": 11.469826816649928,
				"lat": 43.55772795504172
			},
			{
				"lng": 11.469817792249408,
				"lat": 43.557726340364532
			},
			{
				"lng": 11.469808644331085,
				"lat": 43.557725148709729
			},
			{
				"lng": 11.469799410347468,
				"lat": 43.557724384956096
			},
			{
				"lng": 11.469790128103435,
				"lat": 43.55772405223054
			},
			{
				"lng": 11.469790128103435,
				"lat": 43.55772405223054
			},
			{
				"lng": 11.469776216417785,
				"lat": 43.557724127657167
			},
			{
				"lng": 11.469762326834978,
				"lat": 43.55772470270918
			},
			{
				"lng": 11.469748493261305,
				"lat": 43.557725775982789
			},
			{
				"lng": 11.469748493261305,
				"lat": 43.557725775982789
			},
			{
				"lng": 11.46963049822606,
				"lat": 43.557739346089278
			},
			{
				"lng": 11.46963049822606,
				"lat": 43.557739346089278
			},
			{
				"lng": 11.469526859980196,
				"lat": 43.557755068261869
			},
			{
				"lng": 11.469424323183262,
				"lat": 43.557774233221288
			},
			{
				"lng": 11.469424323183262,
				"lat": 43.557774233221288
			},
			{
				"lng": 11.469419966856389,
				"lat": 43.557775242993991
			},
			{
				"lng": 11.469415715040229,
				"lat": 43.557776465879549
			},
			{
				"lng": 11.469411587421369,
				"lat": 43.557777896215789
			},
			{
				"lng": 11.469407603111328,
				"lat": 43.557779527379978
			},
			{
				"lng": 11.469403780558123,
				"lat": 43.557781351819642
			},
			{
				"lng": 11.46940013746077,
				"lat": 43.557783361087267
			},
			{
				"lng": 11.469396690687422,
				"lat": 43.557785545879682
			},
			{
				"lng": 11.469393456197201,
				"lat": 43.557787896080931
			},
			{
				"lng": 11.469393456197203,
				"lat": 43.557787896080931
			},
			{
				"lng": 11.469349217370491,
				"lat": 43.557822661876756
			},
			{
				"lng": 11.469349217370496,
				"lat": 43.55782266187677
			},
			{
				"lng": 11.469272408013165,
				"lat": 43.557883288653052
			},
			{
				"lng": 11.469272408013154,
				"lat": 43.557883288653031
			},
			{
				"lng": 11.469200300265857,
				"lat": 43.557939833769197
			},
			{
				"lng": 11.469200300265854,
				"lat": 43.557939833769197
			},
			{
				"lng": 11.469114494912398,
				"lat": 43.558007113509461
			},
			{
				"lng": 11.469114494912407,
				"lat": 43.558007113509461
			},
			{
				"lng": 11.468981040365977,
				"lat": 43.558118523824206
			},
			{
				"lng": 11.468981040365971,
				"lat": 43.558118523824206
			},
			{
				"lng": 11.46896671354358,
				"lat": 43.558132061057442
			},
			{
				"lng": 11.46895351977459,
				"lat": 43.55814619429426
			},
			{
				"lng": 11.468941505819245,
				"lat": 43.558160873445729
			},
			{
				"lng": 11.46894150581924,
				"lat": 43.558160873445715
			},
			{
				"lng": 11.468938211619099,
				"lat": 43.558165557313309
			},
			{
				"lng": 11.468935367017902,
				"lat": 43.558170394494198
			},
			{
				"lng": 11.468932985418913,
				"lat": 43.558175362196664
			},
			{
				"lng": 11.4689310780438,
				"lat": 43.558180437013952
			},
			{
				"lng": 11.468929653879851,
				"lat": 43.558185595034708
			},
			{
				"lng": 11.468928719637512,
				"lat": 43.558190811955399
			},
			{
				"lng": 11.468928719637512,
				"lat": 43.558190811955399
			},
			{
				"lng": 11.468923195990797,
				"lat": 43.558249768909604
			},
			{
				"lng": 11.468922079939652,
				"lat": 43.558308856979764
			},
			{
				"lng": 11.468922079939652,
				"lat": 43.558308856979764
			},
			{
				"lng": 11.468924674672191,
				"lat": 43.558365635293974
			},
			{
				"lng": 11.468930359861773,
				"lat": 43.558422294306375
			},
			{
				"lng": 11.468930359861774,
				"lat": 43.558422294306375
			},
			{
				"lng": 11.468936137094136,
				"lat": 43.558455338290379
			},
			{
				"lng": 11.468944971764902,
				"lat": 43.558488022805065
			},
			{
				"lng": 11.468944971764897,
				"lat": 43.558488022805065
			},
			{
				"lng": 11.468950410546746,
				"lat": 43.5585027439475
			},
			{
				"lng": 11.468957234701515,
				"lat": 43.558517156690876
			},
			{
				"lng": 11.468965411625737,
				"lat": 43.558531192174065
			},
			{
				"lng": 11.468965411625742,
				"lat": 43.558531192174065
			},
			{
				"lng": 11.468976035192464,
				"lat": 43.558546555766668
			},
			{
				"lng": 11.468987931736011,
				"lat": 43.55856141775002
			},
			{
				"lng": 11.469001056659367,
				"lat": 43.558575722409316
			},
			{
				"lng": 11.469001056659367,
				"lat": 43.558575722409316
			},
			{
				"lng": 11.469010015631783,
				"lat": 43.558584287177865
			},
			{
				"lng": 11.469019693549241,
				"lat": 43.55859242775449
			},
			{
				"lng": 11.469030052528879,
				"lat": 43.558600112273794
			},
			{
				"lng": 11.46904105202182,
				"lat": 43.558607310655589
			},
			{
				"lng": 11.469052648971962,
				"lat": 43.558613994722577
			},
			{
				"lng": 11.469064797984437,
				"lat": 43.558620138310708
			},
			{
				"lng": 11.469064797984442,
				"lat": 43.558620138310708
			},
			{
				"lng": 11.469068392491886,
				"lat": 43.558621713509638
			},
			{
				"lng": 11.469072125839682,
				"lat": 43.558623107489055
			},
			{
				"lng": 11.469075980778852,
				"lat": 43.558624313808451
			},
			{
				"lng": 11.469079939498599,
				"lat": 43.558625326894294
			},
			{
				"lng": 11.469083983708645,
				"lat": 43.558626142065854
			},
			{
				"lng": 11.469088094723727,
				"lat": 43.558626755556894
			},
			{
				"lng": 11.469092253549906,
				"lat": 43.558627164532886
			},
			{
				"lng": 11.469096440972379,
				"lat": 43.558627367104243
			},
			{
				"lng": 11.46910063764418,
				"lat": 43.558627362335088
			},
			{
				"lng": 11.469104824175632,
				"lat": 43.558627150247432
			},
			{
				"lng": 11.469108981223899,
				"lat": 43.558626731821178
			},
			{
				"lng": 11.469108981223899,
				"lat": 43.558626731821178
			},
			{
				"lng": 11.469134596732381,
				"lat": 43.558623147305006
			},
			{
				"lng": 11.469134596732381,
				"lat": 43.558623147305006
			},
			{
				"lng": 11.469177224274583,
				"lat": 43.558616943041294
			},
			{
				"lng": 11.469177224274583,
				"lat": 43.558616943041294
			},
			{
				"lng": 11.469229371831032,
				"lat": 43.558610587991055
			},
			{
				"lng": 11.46928183177222,
				"lat": 43.558605781325944
			},
			{
				"lng": 11.46928183177222,
				"lat": 43.558605781325944
			},
			{
				"lng": 11.4692974929005,
				"lat": 43.558604230844658
			},
			{
				"lng": 11.469312996019829,
				"lat": 43.558601992930143
			},
			{
				"lng": 11.469328284129624,
				"lat": 43.558599075810648
			},
			{
				"lng": 11.469328284129624,
				"lat": 43.558599075810648
			},
			{
				"lng": 11.469330206307204,
				"lat": 43.558598610133416
			},
			{
				"lng": 11.469332079525044,
				"lat": 43.558598048768332
			},
			{
				"lng": 11.469333894788656,
				"lat": 43.558597394410867
			},
			{
				"lng": 11.469335643381807,
				"lat": 43.558596650202993
			},
			{
				"lng": 11.469337316908403,
				"lat": 43.558595819718136
			},
			{
				"lng": 11.469338907332794,
				"lat": 43.558594906943988
			},
			{
				"lng": 11.469340407018338,
				"lat": 43.558593916263291
			},
			{
				"lng": 11.469341808764121,
				"lat": 43.558592852433023
			},
			{
				"lng": 11.469343105839476,
				"lat": 43.558591720561203
			},
			{
				"lng": 11.469344292016331,
				"lat": 43.55859052608276
			},
			{
				"lng": 11.469345361599123,
				"lat": 43.558589274733073
			},
			{
				"lng": 11.469346309452105,
				"lat": 43.558587972520669
			},
			{
				"lng": 11.469347131024051,
				"lat": 43.558586625698275
			},
			{
				"lng": 11.469347822370089,
				"lat": 43.558585240732874
			},
			{
				"lng": 11.469348380170636,
				"lat": 43.558583824274535
			},
			{
				"lng": 11.469348801747355,
				"lat": 43.558582383124552
			},
			{
				"lng": 11.469349085076002,
				"lat": 43.558580924202801
			},
			{
				"lng": 11.46934922879614,
				"lat": 43.558579454514501
			},
			{
				"lng": 11.469349232217709,
				"lat": 43.558577981116493
			},
			{
				"lng": 11.469349095324269,
				"lat": 43.558576511083572
			},
			{
				"lng": 11.469348818773145,
				"lat": 43.5585750514742
			},
			{
				"lng": 11.469348403892253,
				"lat": 43.558573609296914
			},
			{
				"lng": 11.4693478526737,
				"lat": 43.558572191476536
			},
			{
				"lng": 11.469347167764234,
				"lat": 43.558570804820832
			},
			{
				"lng": 11.469347167764235,
				"lat": 43.558570804820832
			},
			{
				"lng": 11.46934442220447,
				"lat": 43.558565255566428
			},
			{
				"lng": 11.469342203303906,
				"lat": 43.558559583089121
			},
			{
				"lng": 11.469340521389567,
				"lat": 43.558553813789693
			},
			{
				"lng": 11.469339384289237,
				"lat": 43.558547974519499
			},
			{
				"lng": 11.469338797295016,
				"lat": 43.55854209245549
			},
			{
				"lng": 11.469338763138731,
				"lat": 43.558536194973925
			},
			{
				"lng": 11.469339281979192,
				"lat": 43.558530309522702
			},
			{
				"lng": 11.469340351401456,
				"lat": 43.558524463493761
			},
			{
				"lng": 11.469341966428081,
				"lat": 43.558518684095525
			},
			{
				"lng": 11.469344119542303,
				"lat": 43.558512998226291
			},
			{
				"lng": 11.469346800723006,
				"lat": 43.558507432349131
			},
			{
				"lng": 11.469346800723009,
				"lat": 43.558507432349131
			},
			{
				"lng": 11.469370439495894,
				"lat": 43.558465460963674
			},
			{
				"lng": 11.469396102104513,
				"lat": 43.558424123003732
			},
			{
				"lng": 11.469396102104513,
				"lat": 43.558424123003732
			},
			{
				"lng": 11.469400316901961,
				"lat": 43.558418111938423
			},
			{
				"lng": 11.469405016741742,
				"lat": 43.558412294201105
			},
			{
				"lng": 11.469410184921006,
				"lat": 43.558406690467393
			},
			{
				"lng": 11.469415803072502,
				"lat": 43.558401320652365
			},
			{
				"lng": 11.469415803072501,
				"lat": 43.558401320652365
			},
			{
				"lng": 11.469491954287157,
				"lat": 43.558333049639174
			},
			{
				"lng": 11.469491954287163,
				"lat": 43.558333049639188
			},
			{
				"lng": 11.46962804779217,
				"lat": 43.558211179953652
			},
			{
				"lng": 11.46962804779217,
				"lat": 43.558211179953652
			},
			{
				"lng": 11.469696592137666,
				"lat": 43.558149635045247
			},
			{
				"lng": 11.469696592137666,
				"lat": 43.558149635045247
			},
			{
				"lng": 11.469740712735732,
				"lat": 43.558110046063653
			},
			{
				"lng": 11.469740712735732,
				"lat": 43.558110046063653
			},
			{
				"lng": 11.469746518348494,
				"lat": 43.558105190573905
			},
			{
				"lng": 11.469752760703965,
				"lat": 43.558100630651893
			},
			{
				"lng": 11.469759411419979,
				"lat": 43.558096387030197
			},
			{
				"lng": 11.469766440257697,
				"lat": 43.558092479003236
			},
			{
				"lng": 11.469773815259096,
				"lat": 43.558088924339643
			},
			{
				"lng": 11.469781502892261,
				"lat": 43.558085739201346
			},
			{
				"lng": 11.469789468203873,
				"lat": 43.558082938070143
			},
			{
				"lng": 11.469797674978093,
				"lat": 43.558080533681945
			},
			{
				"lng": 11.46980608590126,
				"lat": 43.558078536968743
			},
			{
				"lng": 11.469814662731521,
				"lat": 43.558076957008979
			},
			{
				"lng": 11.469814662731521,
				"lat": 43.558076957008979
			},
			{
				"lng": 11.469832938577357,
				"lat": 43.558073620054422
			},
			{
				"lng": 11.469850887893312,
				"lat": 43.558069449785116
			},
			{
				"lng": 11.469868438913981,
				"lat": 43.558064462874796
			},
			{
				"lng": 11.469885521466473,
				"lat": 43.558058679262224
			},
			{
				"lng": 11.46990206725102,
				"lat": 43.558052122071665
			},
			{
				"lng": 11.469918010114018,
				"lat": 43.558044817520219
			},
			{
				"lng": 11.469933286312555,
				"lat": 43.558036794813191
			},
			{
				"lng": 11.469933286312552,
				"lat": 43.558036794813191
			},
			{
				"lng": 11.469959846805164,
				"lat": 43.558020979769083
			},
			{
				"lng": 11.469985101266966,
				"lat": 43.558004071020328
			},
			{
				"lng": 11.469985101266973,
				"lat": 43.558004071020328
			},
			{
				"lng": 11.469988441242908,
				"lat": 43.558001537742477
			},
			{
				"lng": 11.469991542054917,
				"lat": 43.557998848469978
			},
			{
				"lng": 11.469994389961411,
				"lat": 43.557996015120644
			},
			{
				"lng": 11.469996972341606,
				"lat": 43.557993050250829
			},
			{
				"lng": 11.46999927775143,
				"lat": 43.557989966999706
			},
			{
				"lng": 11.46999927775143,
				"lat": 43.557989966999706
			},
			{
				"lng": 11.470001476541269,
				"lat": 43.557986489370677
			},
			{
				"lng": 11.470003347529788,
				"lat": 43.557982911735685
			},
			{
				"lng": 11.47000488218235,
				"lat": 43.55797925041437
			},
			{
				"lng": 11.470006073498556,
				"lat": 43.557975522108286
			},
			{
				"lng": 11.470006916044152,
				"lat": 43.557971743824424
			},
			{
				"lng": 11.47000691604415,
				"lat": 43.557971743824424
			},
			{
				"lng": 11.470007419526146,
				"lat": 43.557967855993105
			},
			{
				"lng": 11.470007568318181,
				"lat": 43.557963952457271
			},
			{
				"lng": 11.470007361768729,
				"lat": 43.557960050312047
			},
			{
				"lng": 11.47000680078242,
				"lat": 43.557956166646392
			},
			{
				"lng": 11.470005887816072,
				"lat": 43.557952318468381
			}
			],
			[{
				"lng": 11.472883077495037,
				"lat": 43.554737208633455
			},
			{
				"lng": 11.472880904939679,
				"lat": 43.5547283509461
			},
			{
				"lng": 11.472804323622853,
				"lat": 43.554749775241426
			},
			{
				"lng": 11.472803802924533,
				"lat": 43.554758786432693
			},
			{
				"lng": 11.472803156444927,
				"lat": 43.554767952655062
			},
			{
				"lng": 11.472802509965172,
				"lat": 43.554777118877396
			},
			{
				"lng": 11.472801623826493,
				"lat": 43.554786321716335
			},
			{
				"lng": 11.472798586306642,
				"lat": 43.554795853257012
			},
			{
				"lng": 11.472795548785896,
				"lat": 43.554805384797653
			},
			{
				"lng": 11.472792511264258,
				"lat": 43.554814916338181
			},
			{
				"lng": 11.472789473741699,
				"lat": 43.554824447878637
			},
			{
				"lng": 11.472786436218273,
				"lat": 43.554833979419065
			},
			{
				"lng": 11.472783445494345,
				"lat": 43.554843503808996
			},
			{
				"lng": 11.472780657764767,
				"lat": 43.554852997183936
			},
			{
				"lng": 11.472777889794347,
				"lat": 43.554862487539779
			},
			{
				"lng": 11.472775433918649,
				"lat": 43.554871930211711
			},
			{
				"lng": 11.472772687107794,
				"lat": 43.55488141733435
			},
			{
				"lng": 11.472769969796978,
				"lat": 43.554890899949562
			},
			{
				"lng": 11.472758131726396,
				"lat": 43.554901776087561
			},
			{
				"lng": 11.47274947856061,
				"lat": 43.554912165615896
			},
			{
				"lng": 11.472742700720518,
				"lat": 43.554922268620395
			},
			{
				"lng": 11.472735822496464,
				"lat": 43.554932386961426
			},
			{
				"lng": 11.472728944270147,
				"lat": 43.554942505302186
			},
			{
				"lng": 11.472723106979597,
				"lat": 43.554952464602309
			},
			{
				"lng": 11.472722123752762,
				"lat": 43.554961682272349
			},
			{
				"lng": 11.472721140525694,
				"lat": 43.554970899942383
			},
			{
				"lng": 11.472720157298385,
				"lat": 43.554980117612338
			},
			{
				"lng": 11.472719910972193,
				"lat": 43.555005838877484
			},
			{
				"lng": 11.472720162708308,
				"lat": 43.55500874540887
			},
			{
				"lng": 11.472720979987301,
				"lat": 43.555018181666178
			},
			{
				"lng": 11.472721797266656,
				"lat": 43.555027617923521
			},
			{
				"lng": 11.472721881715499,
				"lat": 43.555037263674222
			},
			{
				"lng": 11.472722639376325,
				"lat": 43.555046716974665
			},
			{
				"lng": 11.472723522847383,
				"lat": 43.555056134310064
			},
			{
				"lng": 11.472724406367202,
				"lat": 43.5550655516315
			},
			{
				"lng": 11.472725290220225,
				"lat": 43.555074968857888
			},
			{
				"lng": 11.472725975605394,
				"lat": 43.555084442819997
			},
			{
				"lng": 11.472726588825321,
				"lat": 43.555093937411911
			},
			{
				"lng": 11.472729228988896,
				"lat": 43.555102852564552
			},
			{
				"lng": 11.472733755812019,
				"lat": 43.555111228380916
			},
			{
				"lng": 11.472738282636426,
				"lat": 43.55511960419696
			},
			{
				"lng": 11.472742809462154,
				"lat": 43.555127980012841
			},
			{
				"lng": 11.472747336289126,
				"lat": 43.555136355828488
			},
			{
				"lng": 11.472751863117459,
				"lat": 43.555144731643949
			},
			{
				"lng": 11.472756389947051,
				"lat": 43.55515310745912
			},
			{
				"lng": 11.472695064807164,
				"lat": 43.555278501259558
			},
			{
				"lng": 11.472690935770258,
				"lat": 43.555347551926978
			},
			{
				"lng": 11.472699008883618,
				"lat": 43.555427690313692
			},
			{
				"lng": 11.472724427876418,
				"lat": 43.555513010395714
			},
			{
				"lng": 11.472749650106328,
				"lat": 43.555530998557579
			},
			{
				"lng": 11.47283059832588,
				"lat": 43.555532343292292
			},
			{
				"lng": 11.472800045558213,
				"lat": 43.555545077353649
			},
			{
				"lng": 11.472783416945123,
				"lat": 43.555558033218901
			},
			{
				"lng": 11.472783923537694,
				"lat": 43.555568903115201
			},
			{
				"lng": 11.472789683993563,
				"lat": 43.555577891917501
			},
			{
				"lng": 11.472813182649286,
				"lat": 43.555593057815408
			},
			{
				"lng": 11.472875045675313,
				"lat": 43.555672224001455
			},
			{
				"lng": 11.472914725347984,
				"lat": 43.555704070051291
			},
			{
				"lng": 11.472936383347951,
				"lat": 43.555771043788084
			},
			{
				"lng": 11.472955213102406,
				"lat": 43.555804624925315
			},
			{
				"lng": 11.473020287011165,
				"lat": 43.555878261759027
			},
			{
				"lng": 11.473023763069543,
				"lat": 43.555899678141948
			},
			{
				"lng": 11.473017134895652,
				"lat": 43.555967942860718
			},
			{
				"lng": 11.473039697304866,
				"lat": 43.556028300961444
			},
			{
				"lng": 11.473070331328437,
				"lat": 43.556050831300652
			},
			{
				"lng": 11.473180121738253,
				"lat": 43.556132314847758
			},
			{
				"lng": 11.473195658845331,
				"lat": 43.55614805002778
			},
			{
				"lng": 11.473228913317353,
				"lat": 43.556174107046459
			},
			{
				"lng": 11.473293652020073,
				"lat": 43.556203568176514
			},
			{
				"lng": 11.473198456655421,
				"lat": 43.556232786331293
			},
			{
				"lng": 11.473202496322566,
				"lat": 43.556241284642738
			},
			{
				"lng": 11.473206535990988,
				"lat": 43.556249782954289
			},
			{
				"lng": 11.473210575660543,
				"lat": 43.556258281265492
			},
			{
				"lng": 11.473214615331367,
				"lat": 43.556266779576696
			},
			{
				"lng": 11.473218655003251,
				"lat": 43.556275277887487
			},
			{
				"lng": 11.473222694676409,
				"lat": 43.556283776198235
			},
			{
				"lng": 11.473226734350758,
				"lat": 43.556292274508792
			},
			{
				"lng": 11.473230774026259,
				"lat": 43.556300772819142
			},
			{
				"lng": 11.473238445279158,
				"lat": 43.556315624003886
			},
			{
				"lng": 11.473239982900854,
				"lat": 43.556318675773383
			},
			{
				"lng": 11.473241831575139,
				"lat": 43.55632255419895
			},
			{
				"lng": 11.473243586410149,
				"lat": 43.556326455613622
			},
			{
				"lng": 11.473245246865753,
				"lat": 43.556330378816668
			},
			{
				"lng": 11.473246812430885,
				"lat": 43.556334322600634
			},
			{
				"lng": 11.473248282623645,
				"lat": 43.556338285751579
			},
			{
				"lng": 11.473249656991573,
				"lat": 43.556342267049871
			},
			{
				"lng": 11.473250935111627,
				"lat": 43.556346265270058
			},
			{
				"lng": 11.473252116590373,
				"lat": 43.556350279181636
			},
			{
				"lng": 11.473253201064257,
				"lat": 43.556354307549263
			},
			{
				"lng": 11.473254188199386,
				"lat": 43.55635834913295
			},
			{
				"lng": 11.473255077691961,
				"lat": 43.556362402688883
			},
			{
				"lng": 11.473255869268227,
				"lat": 43.556366466969443
			},
			{
				"lng": 11.473259242416429,
				"lat": 43.55637031680989
			},
			{
				"lng": 11.473264914130583,
				"lat": 43.556374074664717
			},
			{
				"lng": 11.47327056636064,
				"lat": 43.556377965354898
			},
			{
				"lng": 11.473276191301196,
				"lat": 43.556381990484311
			},
			{
				"lng": 11.473281780650817,
				"lat": 43.556386151429614
			},
			{
				"lng": 11.473287325603348,
				"lat": 43.556390449313199
			},
			{
				"lng": 11.473291766766717,
				"lat": 43.556394891947996
			},
			{
				"lng": 11.473287882318962,
				"lat": 43.556399395536211
			},
			{
				"lng": 11.473283893431836,
				"lat": 43.556403799334298
			},
			{
				"lng": 11.473246876346185,
				"lat": 43.55645156930867
			},
			{
				"lng": 11.473243540355179,
				"lat": 43.556455141746213
			},
			{
				"lng": 11.473240114399616,
				"lat": 43.556458643136828
			},
			{
				"lng": 11.473236602557874,
				"lat": 43.556462072467582
			},
			{
				"lng": 11.473233008878729,
				"lat": 43.556465428840951
			},
			{
				"lng": 11.473229337374962,
				"lat": 43.556468711471723
			},
			{
				"lng": 11.473225592017119,
				"lat": 43.556471919683894
			},
			{
				"lng": 11.473221776727735,
				"lat": 43.556475052906869
			},
			{
				"lng": 11.473217895375782,
				"lat": 43.556478110672266
			},
			{
				"lng": 11.473213951772022,
				"lat": 43.556481092610063
			},
			{
				"lng": 11.473209949664517,
				"lat": 43.556483998444662
			},
			{
				"lng": 11.473205892734503,
				"lat": 43.556486827991371
			},
			{
				"lng": 11.47320363977523,
				"lat": 43.556490227924776
			},
			{
				"lng": 11.473201328432674,
				"lat": 43.55649360627396
			},
			{
				"lng": 11.473198560897018,
				"lat": 43.556496811440411
			},
			{
				"lng": 11.473195265788901,
				"lat": 43.556499795295402
			},
			{
				"lng": 11.473191888236531,
				"lat": 43.556502717844104
			},
			{
				"lng": 11.473188860501073,
				"lat": 43.556505762935416
			},
			{
				"lng": 11.473185914379499,
				"lat": 43.556508830477092
			},
			{
				"lng": 11.473182871258818,
				"lat": 43.556511843871974
			},
			{
				"lng": 11.473179577363254,
				"lat": 43.556514725826666
			},
			{
				"lng": 11.47317579519094,
				"lat": 43.556517345342897
			},
			{
				"lng": 11.473171950335075,
				"lat": 43.556519898769054
			},
			{
				"lng": 11.473168529517599,
				"lat": 43.556522647546117
			},
			{
				"lng": 11.473165192907945,
				"lat": 43.556525427921976
			},
			{
				"lng": 11.473161770059365,
				"lat": 43.55652814813979
			},
			{
				"lng": 11.4731582634607,
				"lat": 43.556530806728041
			},
			{
				"lng": 11.47315459574842,
				"lat": 43.556533352312051
			},
			{
				"lng": 11.473150495164871,
				"lat": 43.556535600408004
			},
			{
				"lng": 11.473146345499751,
				"lat": 43.556537780645385
			},
			{
				"lng": 11.473142149358114,
				"lat": 43.556539892693245
			},
			{
				"lng": 11.473137909328859,
				"lat": 43.556541936276837
			},
			{
				"lng": 11.473133627981358,
				"lat": 43.55654391117659
			},
			{
				"lng": 11.473129261653163,
				"lat": 43.556545781537856
			},
			{
				"lng": 11.473125413203007,
				"lat": 43.556548023666963
			},
			{
				"lng": 11.473121581002443,
				"lat": 43.556550267365267
			},
			{
				"lng": 11.473117680585077,
				"lat": 43.556552444244097
			},
			{
				"lng": 11.473113714536899,
				"lat": 43.556554553174259
			},
			{
				"lng": 11.473109685490215,
				"lat": 43.556556593094889
			},
			{
				"lng": 11.473105239001811,
				"lat": 43.556558221443076
			},
			{
				"lng": 11.473100549912324,
				"lat": 43.556559569869691
			},
			{
				"lng": 11.473096558844633,
				"lat": 43.556561580456453
			},
			{
				"lng": 11.473091638533363,
				"lat": 43.556563934218154
			},
			{
				"lng": 11.473089955513588,
				"lat": 43.556564709212672
			},
			{
				"lng": 11.473080177232429,
				"lat": 43.556569158428083
			},
			{
				"lng": 11.473069513238473,
				"lat": 43.556573750878997
			},
			{
				"lng": 11.473058711847315,
				"lat": 43.55657819395789
			},
			{
				"lng": 11.473047910455108,
				"lat": 43.556582637035589
			},
			{
				"lng": 11.473037109060796,
				"lat": 43.556587080112386
			},
			{
				"lng": 11.473026307665359,
				"lat": 43.556591523188111
			},
			{
				"lng": 11.473015506267798,
				"lat": 43.556595966262982
			},
			{
				"lng": 11.473004704869174,
				"lat": 43.556600409336681
			},
			{
				"lng": 11.472993903468545,
				"lat": 43.556604852409528
			},
			{
				"lng": 11.472983102066134,
				"lat": 43.556609295481444
			},
			{
				"lng": 11.472972300662649,
				"lat": 43.55661373855218
			},
			{
				"lng": 11.472961499256851,
				"lat": 43.556618181622163
			},
			{
				"lng": 11.47295069785017,
				"lat": 43.556622624690888
			},
			{
				"lng": 11.472939896441167,
				"lat": 43.556627067758939
			},
			{
				"lng": 11.472929095031246,
				"lat": 43.556631510825653
			},
			{
				"lng": 11.472918293619035,
				"lat": 43.556635953891721
			},
			{
				"lng": 11.472907492205792,
				"lat": 43.556640396956503
			},
			{
				"lng": 11.472896690790691,
				"lat": 43.55664484002039
			},
			{
				"lng": 11.472886003195988,
				"lat": 43.556649406828107
			},
			{
				"lng": 11.472875249399642,
				"lat": 43.556653901663054
			},
			{
				"lng": 11.472864416352563,
				"lat": 43.556658310340367
			},
			{
				"lng": 11.472853583304378,
				"lat": 43.556662719016401
			},
			{
				"lng": 11.47284275025406,
				"lat": 43.556667127691732
			},
			{
				"lng": 11.47283191720271,
				"lat": 43.556671536365812
			},
			{
				"lng": 11.47282142448074,
				"lat": 43.556676315038303
			},
			{
				"lng": 11.472810989130325,
				"lat": 43.556681156084913
			},
			{
				"lng": 11.472800553778802,
				"lat": 43.556685997130366
			},
			{
				"lng": 11.472790118424864,
				"lat": 43.556690838175143
			},
			{
				"lng": 11.472779683069964,
				"lat": 43.556695679218706
			},
			{
				"lng": 11.472769247712725,
				"lat": 43.556700520261664
			},
			{
				"lng": 11.472758812354314,
				"lat": 43.556705361303415
			},
			{
				"lng": 11.472748376993735,
				"lat": 43.556710202344547
			},
			{
				"lng": 11.472737941631966,
				"lat": 43.556715043384479
			},
			{
				"lng": 11.472727506268271,
				"lat": 43.556719884423586
			},
			{
				"lng": 11.472717070902538,
				"lat": 43.556724725461997
			},
			{
				"lng": 11.472706635535641,
				"lat": 43.556729566499143
			},
			{
				"lng": 11.472696200166569,
				"lat": 43.556734407535664
			},
			{
				"lng": 11.47268576479633,
				"lat": 43.556739248571027
			},
			{
				"lng": 11.472675329423749,
				"lat": 43.556744089605715
			},
			{
				"lng": 11.472664894050183,
				"lat": 43.556748930639188
			},
			{
				"lng": 11.472654458674194,
				"lat": 43.556753771672057
			},
			{
				"lng": 11.472644084667417,
				"lat": 43.556758679423986
			},
			{
				"lng": 11.472633829061648,
				"lat": 43.556763715900296
			},
			{
				"lng": 11.472623603901365,
				"lat": 43.556768785477729
			},
			{
				"lng": 11.472613379831818,
				"lat": 43.556773856240973
			},
			{
				"lng": 11.472603155759854,
				"lat": 43.556778927003627
			},
			{
				"lng": 11.472592931686702,
				"lat": 43.55678399776513
			},
			{
				"lng": 11.472582707611339,
				"lat": 43.556789068525951
			},
			{
				"lng": 11.472572498343876,
				"lat": 43.55679415538588
			},
			{
				"lng": 11.472562204687771,
				"lat": 43.55679915050208
			},
			{
				"lng": 11.472551844114616,
				"lat": 43.556804072867621
			},
			{
				"lng": 11.472541369952436,
				"lat": 43.556808871743087
			},
			{
				"lng": 11.472530895788399,
				"lat": 43.556813670617757
			},
			{
				"lng": 11.472520561673862,
				"lat": 43.55681862175139
			},
			{
				"lng": 11.472510056537255,
				"lat": 43.556823386955294
			},
			{
				"lng": 11.472499454376976,
				"lat": 43.556828046676827
			},
			{
				"lng": 11.47248890343108,
				"lat": 43.556832762079509
			},
			{
				"lng": 11.472479194213703,
				"lat": 43.556838392592752
			},
			{
				"lng": 11.472469484994038,
				"lat": 43.556844023105505
			},
			{
				"lng": 11.472459775773011,
				"lat": 43.556849653617199
			},
			{
				"lng": 11.472450066549973,
				"lat": 43.556855284128211
			},
			{
				"lng": 11.472440357324789,
				"lat": 43.556860914638563
			},
			{
				"lng": 11.472430648098294,
				"lat": 43.556866545147919
			},
			{
				"lng": 11.47242093886949,
				"lat": 43.5568721756567
			},
			{
				"lng": 11.472411229639404,
				"lat": 43.556877806164444
			},
			{
				"lng": 11.47240152040686,
				"lat": 43.556883436671704
			},
			{
				"lng": 11.472391811173159,
				"lat": 43.556889067177806
			},
			{
				"lng": 11.472382008489689,
				"lat": 43.556894596089293
			},
			{
				"lng": 11.472371722840634,
				"lat": 43.556899599929395
			},
			{
				"lng": 11.472361437189454,
				"lat": 43.556904603768736
			},
			{
				"lng": 11.472351151536234,
				"lat": 43.556909607607381
			},
			{
				"lng": 11.472340865881973,
				"lat": 43.556914611444753
			},
			{
				"lng": 11.472330580225332,
				"lat": 43.556919615281608
			},
			{
				"lng": 11.472320294567528,
				"lat": 43.556924619117297
			},
			{
				"lng": 11.472310008907485,
				"lat": 43.556929622952275
			},
			{
				"lng": 11.472299723246261,
				"lat": 43.556934626786159
			},
			{
				"lng": 11.47228943758296,
				"lat": 43.556939630619318
			},
			{
				"lng": 11.472279151917739,
				"lat": 43.556944634451689
			},
			{
				"lng": 11.47226886625131,
				"lat": 43.556949638282887
			},
			{
				"lng": 11.472258580582633,
				"lat": 43.556954642113432
			},
			{
				"lng": 11.472248294912763,
				"lat": 43.556959645942896
			},
			{
				"lng": 11.472238009240552,
				"lat": 43.556964649771736
			},
			{
				"lng": 11.472227723567295,
				"lat": 43.556969653599339
			},
			{
				"lng": 11.472217437891643,
				"lat": 43.556974657426416
			},
			{
				"lng": 11.472207152214819,
				"lat": 43.556979661252335
			},
			{
				"lng": 11.472196866536095,
				"lat": 43.556984665077358
			},
			{
				"lng": 11.47218658085524,
				"lat": 43.556989668901799
			},
			{
				"lng": 11.472176295173311,
				"lat": 43.556994672724962
			},
			{
				"lng": 11.472166009489069,
				"lat": 43.556999676547569
			},
			{
				"lng": 11.472155723803606,
				"lat": 43.557004680368948
			},
			{
				"lng": 11.47214543811592,
				"lat": 43.557009684189751
			},
			{
				"lng": 11.472135152427096,
				"lat": 43.557014688009403
			},
			{
				"lng": 11.472124866735857,
				"lat": 43.557019691828515
			},
			{
				"lng": 11.472114581043588,
				"lat": 43.557024695646334
			},
			{
				"lng": 11.472104295349233,
				"lat": 43.557029699463477
			},
			{
				"lng": 11.472094009652922,
				"lat": 43.557034703279818
			},
			{
				"lng": 11.472083723955405,
				"lat": 43.557039707095029
			},
			{
				"lng": 11.472073438255551,
				"lat": 43.557044710909601
			},
			{
				"lng": 11.472063152554659,
				"lat": 43.557049714723014
			},
			{
				"lng": 11.472052866851406,
				"lat": 43.557054718535809
			},
			{
				"lng": 11.472042581146948,
				"lat": 43.557059722347489
			},
			{
				"lng": 11.472032295440274,
				"lat": 43.557064726158458
			},
			{
				"lng": 11.472022009732418,
				"lat": 43.557069729968362
			},
			{
				"lng": 11.472011724022485,
				"lat": 43.557074733777519
			},
			{
				"lng": 11.472001236091296,
				"lat": 43.557079517735176
			},
			{
				"lng": 11.471990140153576,
				"lat": 43.55708364067489
			},
			{
				"lng": 11.471979044213807,
				"lat": 43.557087763613758
			},
			{
				"lng": 11.471967948272994,
				"lat": 43.557091886551319
			},
			{
				"lng": 11.471956852330019,
				"lat": 43.557096009488134
			},
			{
				"lng": 11.4719457563862,
				"lat": 43.557100132423663
			},
			{
				"lng": 11.471934660440144,
				"lat": 43.557104255358333
			},
			{
				"lng": 11.471923564493109,
				"lat": 43.557108378291765
			},
			{
				"lng": 11.471912468544316,
				"lat": 43.557112501224182
			},
			{
				"lng": 11.471901372593553,
				"lat": 43.557116624155782
			},
			{
				"lng": 11.471890276641977,
				"lat": 43.557120747086039
			},
			{
				"lng": 11.471879180688173,
				"lat": 43.557124870015542
			},
			{
				"lng": 11.471868084733403,
				"lat": 43.557128992943731
			},
			{
				"lng": 11.471856988776528,
				"lat": 43.557133115871096
			},
			{
				"lng": 11.471845892818697,
				"lat": 43.557137238797232
			},
			{
				"lng": 11.471834796858969,
				"lat": 43.557141361722408
			},
			{
				"lng": 11.471823700897431,
				"lat": 43.557145484646632
			},
			{
				"lng": 11.471812604934911,
				"lat": 43.55714960756962
			},
			{
				"lng": 11.471801508970284,
				"lat": 43.557153730491784
			},
			{
				"lng": 11.471790413004721,
				"lat": 43.557157853412669
			},
			{
				"lng": 11.471779317036866,
				"lat": 43.557161976332779
			},
			{
				"lng": 11.471768221068265,
				"lat": 43.557166099251539
			},
			{
				"lng": 11.471757125097403,
				"lat": 43.557170222169525
			},
			{
				"lng": 11.471746029125555,
				"lat": 43.557174345086224
			},
			{
				"lng": 11.471734933151952,
				"lat": 43.557178468001979
			},
			{
				"lng": 11.471723837176439,
				"lat": 43.557182590916881
			},
			{
				"lng": 11.471712741199971,
				"lat": 43.557186713830447
			},
			{
				"lng": 11.471701751189737,
				"lat": 43.557190951951469
			},
			{
				"lng": 11.471691208822289,
				"lat": 43.557195676747625
			},
			{
				"lng": 11.471680694002529,
				"lat": 43.557200431495225
			},
			{
				"lng": 11.471670179181666,
				"lat": 43.55720518624161
			},
			{
				"lng": 11.471659664358429,
				"lat": 43.557209940987363
			},
			{
				"lng": 11.471649149534258,
				"lat": 43.557214695731872
			},
			{
				"lng": 11.471638634708054,
				"lat": 43.557219450475593
			},
			{
				"lng": 11.471628119879771,
				"lat": 43.557224205218553
			},
			{
				"lng": 11.471617605050552,
				"lat": 43.557228959960263
			},
			{
				"lng": 11.471607097347434,
				"lat": 43.557233722451514
			},
			{
				"lng": 11.471596755886257,
				"lat": 43.557238665680174
			},
			{
				"lng": 11.471586418601524,
				"lat": 43.557243613451639
			},
			{
				"lng": 11.471576081315661,
				"lat": 43.557248561221897
			},
			{
				"lng": 11.471565744027659,
				"lat": 43.557253508991394
			},
			{
				"lng": 11.471560285642942,
				"lat": 43.557256121555064
			},
			{
				"lng": 11.4715499483528,
				"lat": 43.557261069322955
			},
			{
				"lng": 11.471539611060267,
				"lat": 43.557266017090306
			},
			{
				"lng": 11.471529273766381,
				"lat": 43.557270964856649
			},
			{
				"lng": 11.47151893647108,
				"lat": 43.557275912621897
			},
			{
				"lng": 11.471508531921138,
				"lat": 43.55728078726991
			},
			{
				"lng": 11.471498124213536,
				"lat": 43.557285658485362
			},
			{
				"lng": 11.47148772666376,
				"lat": 43.557290540744901
			},
			{
				"lng": 11.471477318362002,
				"lat": 43.557295411316808
			},
			{
				"lng": 11.471466910058904,
				"lat": 43.557300281887649
			},
			{
				"lng": 11.471456501754377,
				"lat": 43.557305152457509
			},
			{
				"lng": 11.471447580665712,
				"lat": 43.55730932708282
			},
			{
				"lng": 11.471433891917892,
				"lat": 43.557315814530412
			},
			{
				"lng": 11.471419270455023,
				"lat": 43.557323016975452
			},
			{
				"lng": 11.471404722162488,
				"lat": 43.557330301123336
			},
			{
				"lng": 11.471390247437579,
				"lat": 43.557337667076695
			},
			{
				"lng": 11.471375888789908,
				"lat": 43.557345155771721
			},
			{
				"lng": 11.471361648330234,
				"lat": 43.557352766201085
			},
			{
				"lng": 11.471347528151089,
				"lat": 43.55736049733585
			},
			{
				"lng": 11.471333530326842,
				"lat": 43.557368348125166
			},
			{
				"lng": 11.471319656912186,
				"lat": 43.557376317497308
			},
			{
				"lng": 11.471305889360034,
				"lat": 43.557384386482561
			},
			{
				"lng": 11.471292247919196,
				"lat": 43.557392570619108
			},
			{
				"lng": 11.471278865878391,
				"lat": 43.557400978049024
			},
			{
				"lng": 11.471265625345184,
				"lat": 43.557409503154716
			},
			{
				"lng": 11.471252429657875,
				"lat": 43.55741806589581
			},
			{
				"lng": 11.471239370970732,
				"lat": 43.55742674009489
			},
			{
				"lng": 11.471226451184991,
				"lat": 43.557435524523981
			},
			{
				"lng": 11.471213672177706,
				"lat": 43.557444417936011
			},
			{
				"lng": 11.471201035802341,
				"lat": 43.557453419065261
			},
			{
				"lng": 11.471188566207045,
				"lat": 43.557462542585348
			},
			{
				"lng": 11.471176255498882,
				"lat": 43.557471779387214
			},
			{
				"lng": 11.471164093532016,
				"lat": 43.557481119437611
			},
			{
				"lng": 11.47115208204203,
				"lat": 43.557490561385279
			},
			{
				"lng": 11.471140222738502,
				"lat": 43.557500103861493
			},
			{
				"lng": 11.471128440790906,
				"lat": 43.557509696363397
			},
			{
				"lng": 11.47111676393946,
				"lat": 43.55751935703757
			},
			{
				"lng": 11.471105241973603,
				"lat": 43.557529116054781
			},
			{
				"lng": 11.471093876562055,
				"lat": 43.557538972019742
			},
			{
				"lng": 11.471082669347119,
				"lat": 43.557548923520102
			},
			{
				"lng": 11.47107206835933,
				"lat": 43.557558563193325
			},
			{
				"lng": 11.471066957727224,
				"lat": 43.557563292217331
			},
			{
				"lng": 11.471058947535006,
				"lat": 43.55757072772667
			},
			{
				"lng": 11.471051324095514,
				"lat": 43.557577816874151
			},
			{
				"lng": 11.471043711459288,
				"lat": 43.557584912175678
			},
			{
				"lng": 11.471036166462136,
				"lat": 43.55759204600642
			},
			{
				"lng": 11.471028728570669,
				"lat": 43.557599240846862
			},
			{
				"lng": 11.47102129067731,
				"lat": 43.557606435686893
			},
			{
				"lng": 11.471013577623484,
				"lat": 43.557613473790958
			},
			{
				"lng": 11.471005851619108,
				"lat": 43.557620504518731
			},
			{
				"lng": 11.47099812561307,
				"lat": 43.557627535245977
			},
			{
				"lng": 11.470990399605114,
				"lat": 43.557634565972812
			},
			{
				"lng": 11.470982673595506,
				"lat": 43.557641596699057
			},
			{
				"lng": 11.470974947583802,
				"lat": 43.557648627425095
			},
			{
				"lng": 11.470967221570826,
				"lat": 43.557655658150225
			},
			{
				"lng": 11.470959495555718,
				"lat": 43.557662688875112
			},
			{
				"lng": 11.470951769538969,
				"lat": 43.557669719599389
			},
			{
				"lng": 11.470944043520328,
				"lat": 43.557676750323367
			},
			{
				"lng": 11.470936317499977,
				"lat": 43.557683781046713
			},
			{
				"lng": 11.47092859147776,
				"lat": 43.557690811769611
			},
			{
				"lng": 11.470920865453818,
				"lat": 43.557697842492018
			},
			{
				"lng": 11.470913139428145,
				"lat": 43.5577048732139
			},
			{
				"lng": 11.470905413400578,
				"lat": 43.557711903935385
			},
			{
				"lng": 11.4708976873713,
				"lat": 43.557718934656265
			},
			{
				"lng": 11.470889961340161,
				"lat": 43.557725965376768
			},
			{
				"lng": 11.470882235307315,
				"lat": 43.557732996096711
			},
			{
				"lng": 11.470874495520258,
				"lat": 43.557740018982607
			},
			{
				"lng": 11.470866703068721,
				"lat": 43.557747011870212
			},
			{
				"lng": 11.47085900315626,
				"lat": 43.557754057470554
			},
			{
				"lng": 11.470851297737685,
				"lat": 43.557761099934844
			},
			{
				"lng": 11.470843586681747,
				"lat": 43.557768139188688
			},
			{
				"lng": 11.470835875624115,
				"lat": 43.557775178441936
			},
			{
				"lng": 11.470828164564614,
				"lat": 43.557782217694829
			},
			{
				"lng": 11.470820576300186,
				"lat": 43.55778932689455
			},
			{
				"lng": 11.470813103268343,
				"lat": 43.55779650173362
			},
			{
				"lng": 11.470805624265022,
				"lat": 43.557803673171676
			},
			{
				"lng": 11.470798240252698,
				"lat": 43.557810898719168
			},
			{
				"lng": 11.470790856238759,
				"lat": 43.55781812426607
			},
			{
				"lng": 11.470783564887247,
				"lat": 43.55782540259635
			},
			{
				"lng": 11.470776143864848,
				"lat": 43.557832607063439
			},
			{
				"lng": 11.470768751120781,
				"lat": 43.557839827639214
			},
			{
				"lng": 11.470761361006149,
				"lat": 43.557847049713416
			},
			{
				"lng": 11.47075397088982,
				"lat": 43.557854271787136
			},
			{
				"lng": 11.470746580771651,
				"lat": 43.55786149386045
			},
			{
				"lng": 11.470739190651988,
				"lat": 43.55786871593304
			},
			{
				"lng": 11.470737626360112,
				"lat": 43.55787024465355
			},
			{
				"lng": 11.470732733861961,
				"lat": 43.557874964665899
			},
			{
				"lng": 11.470728627382504,
				"lat": 43.557878826042867
			},
			{
				"lng": 11.470724454492389,
				"lat": 43.557882651096762
			},
			{
				"lng": 11.470720215819455,
				"lat": 43.55788643917667
			},
			{
				"lng": 11.470715912005543,
				"lat": 43.557890189637618
			},
			{
				"lng": 11.4707115437058,
				"lat": 43.557893901841098
			},
			{
				"lng": 11.470707111588679,
				"lat": 43.557897575155494
			},
			{
				"lng": 11.470702616336329,
				"lat": 43.557901208955379
			},
			{
				"lng": 11.470698058643761,
				"lat": 43.55790480262263
			},
			{
				"lng": 11.470693439218655,
				"lat": 43.557908355546523
			},
			{
				"lng": 11.470688758781764,
				"lat": 43.557911867123138
			},
			{
				"lng": 11.470684018066606,
				"lat": 43.55791533675616
			},
			{
				"lng": 11.470679217819088,
				"lat": 43.557918763856975
			},
			{
				"lng": 11.47067435879717,
				"lat": 43.55792214784465
			},
			{
				"lng": 11.470669441771351,
				"lat": 43.557925488146275
			},
			{
				"lng": 11.470664467523536,
				"lat": 43.557928784197124
			},
			{
				"lng": 11.470659436848067,
				"lat": 43.557932035440381
			},
			{
				"lng": 11.470654350550415,
				"lat": 43.557935241327939
			},
			{
				"lng": 11.47064920944754,
				"lat": 43.557938401320158
			},
			{
				"lng": 11.470644014367577,
				"lat": 43.557941514886018
			},
			{
				"lng": 11.470638743808154,
				"lat": 43.55794456078219
			},
			{
				"lng": 11.470633407111976,
				"lat": 43.557947545067947
			},
			{
				"lng": 11.470628020177944,
				"lat": 43.55795048086835
			},
			{
				"lng": 11.470622546724513,
				"lat": 43.557953330674884
			},
			{
				"lng": 11.470616975309392,
				"lat": 43.557956078703782
			},
			{
				"lng": 11.470611359391619,
				"lat": 43.557958775639875
			},
			{
				"lng": 11.47060569992602,
				"lat": 43.557961421098632
			},
			{
				"lng": 11.470599997873748,
				"lat": 43.557964014706315
			},
			{
				"lng": 11.470594254202146,
				"lat": 43.5579665560997
			},
			{
				"lng": 11.470588469884369,
				"lat": 43.557969044926622
			},
			{
				"lng": 11.470582645899675,
				"lat": 43.557971480845509
			},
			{
				"lng": 11.470576783232701,
				"lat": 43.55797386352549
			},
			{
				"lng": 11.47057088287295,
				"lat": 43.557976192646926
			},
			{
				"lng": 11.470564945815164,
				"lat": 43.557978467900796
			},
			{
				"lng": 11.470558973058939,
				"lat": 43.557980688989133
			},
			{
				"lng": 11.470552965607661,
				"lat": 43.557982855625063
			},
			{
				"lng": 11.470546924469026,
				"lat": 43.557984967532597
			},
			{
				"lng": 11.470540811968846,
				"lat": 43.557986969000488
			},
			{
				"lng": 11.470534658238112,
				"lat": 43.557988897873045
			},
			{
				"lng": 11.470528476550808,
				"lat": 43.557990771031967
			},
			{
				"lng": 11.470522267927386,
				"lat": 43.557992588295306
			},
			{
				"lng": 11.470516033389066,
				"lat": 43.557994349492212
			},
			{
				"lng": 11.470509773958002,
				"lat": 43.557996054462535
			},
			{
				"lng": 11.470503490656599,
				"lat": 43.557997703056962
			},
			{
				"lng": 11.470496291288496,
				"lat": 43.557999520643222
			},
			{
				"lng": 11.470494583282566,
				"lat": 43.557999940604702
			},
			{
				"lng": 11.470483290425614,
				"lat": 43.558002698502548
			},
			{
				"lng": 11.470471537185981,
				"lat": 43.558005568831923
			},
			{
				"lng": 11.470459783945186,
				"lat": 43.558008439160155
			},
			{
				"lng": 11.470448030703187,
				"lat": 43.558011309487121
			},
			{
				"lng": 11.470436277459694,
				"lat": 43.558014179813021
			},
			{
				"lng": 11.470428146021598,
				"lat": 43.558016306546051
			},
			{
				"lng": 11.470405834783113,
				"lat": 43.558022351641057
			},
			{
				"lng": 11.470380599295991,
				"lat": 43.558030496692481
			},
			{
				"lng": 11.470356395959621,
				"lat": 43.558040171961267
			},
			{
				"lng": 11.470331992579112,
				"lat": 43.558049518497562
			},
			{
				"lng": 11.470307913535423,
				"lat": 43.558059312995731
			},
			{
				"lng": 11.470284303598479,
				"lat": 43.558069703780568
			},
			{
				"lng": 11.470261193236997,
				"lat": 43.558080678001716
			},
			{
				"lng": 11.470238086151662,
				"lat": 43.558091694589123
			},
			{
				"lng": 11.470215332104958,
				"lat": 43.558103137640032
			},
			{
				"lng": 11.470193119616471,
				"lat": 43.558115161127873
			},
			{
				"lng": 11.470176484100906,
				"lat": 43.558131912239169
			},
			{
				"lng": 11.47016198543346,
				"lat": 43.558149921830065
			},
			{
				"lng": 11.470148755891337,
				"lat": 43.558168347419944
			},
			{
				"lng": 11.470136234710139,
				"lat": 43.558186732439147
			},
			{
				"lng": 11.470124404897851,
				"lat": 43.558205072502915
			},
			{
				"lng": 11.470113250119356,
				"lat": 43.558223363703846
			},
			{
				"lng": 11.470102754692139,
				"lat": 43.558241602575336
			},
			{
				"lng": 11.470088653555115,
				"lat": 43.558257484149024
			},
			{
				"lng": 11.470073513941953,
				"lat": 43.558272744801748
			},
			{
				"lng": 11.470059017064816,
				"lat": 43.558288332035318
			},
			{
				"lng": 11.470045176235145,
				"lat": 43.558304231537669
			},
			{
				"lng": 11.470032004161977,
				"lat": 43.55832042871009
			},
			{
				"lng": 11.470019512940285,
				"lat": 43.558336908680552
			},
			{
				"lng": 11.47000771403998,
				"lat": 43.55835365631723
			},
			{
				"lng": 11.469996618295376,
				"lat": 43.558370656242559
			},
			{
				"lng": 11.469987361195422,
				"lat": 43.558386024652037
			},
			{
				"lng": 11.469984816603228,
				"lat": 43.558390461339677
			},
			{
				"lng": 11.469979863652531,
				"lat": 43.558399159859626
			},
			{
				"lng": 11.46997512911337,
				"lat": 43.558407474796248
			},
			{
				"lng": 11.469970394572805,
				"lat": 43.558415789732919
			},
			{
				"lng": 11.469965660031173,
				"lat": 43.558424104669086
			},
			{
				"lng": 11.469960925488198,
				"lat": 43.558432419605296
			},
			{
				"lng": 11.469956190943888,
				"lat": 43.558440734541421
			},
			{
				"lng": 11.469951507462911,
				"lat": 43.558449064854713
			},
			{
				"lng": 11.469950621730954,
				"lat": 43.558451942780856
			},
			{
				"lng": 11.469948671839061,
				"lat": 43.55845809163268
			},
			{
				"lng": 11.469946917091448,
				"lat": 43.558463315194011
			},
			{
				"lng": 11.469945066064746,
				"lat": 43.55846853066717
			},
			{
				"lng": 11.469943118557634,
				"lat": 43.558473736973781
			},
			{
				"lng": 11.469941074393509,
				"lat": 43.558478933026535
			},
			{
				"lng": 11.469938933421169,
				"lat": 43.558484117730025
			},
			{
				"lng": 11.469936695515264,
				"lat": 43.558489289980677
			},
			{
				"lng": 11.469934360576554,
				"lat": 43.558494448667545
			},
			{
				"lng": 11.469931928532615,
				"lat": 43.558499592671943
			},
			{
				"lng": 11.469929399338087,
				"lat": 43.55850472086864
			},
			{
				"lng": 11.469926772975025,
				"lat": 43.558509832126255
			},
			{
				"lng": 11.46992404945375,
				"lat": 43.558514925306646
			},
			{
				"lng": 11.469921228812677,
				"lat": 43.558519999266565
			},
			{
				"lng": 11.469918311118882,
				"lat": 43.558525052857675
			},
			{
				"lng": 11.469915296468733,
				"lat": 43.558530084926595
			},
			{
				"lng": 11.469912184987873,
				"lat": 43.55853509431617
			},
			{
				"lng": 11.469908976831855,
				"lat": 43.55854007986504
			},
			{
				"lng": 11.469905672186337,
				"lat": 43.558545040408802
			},
			{
				"lng": 11.469902271267225,
				"lat": 43.558549974780355
			},
			{
				"lng": 11.4698987743214,
				"lat": 43.558554881810103
			},
			{
				"lng": 11.469895181626578,
				"lat": 43.558559760326922
			},
			{
				"lng": 11.469891493491671,
				"lat": 43.558564609158509
			},
			{
				"lng": 11.469887710257176,
				"lat": 43.55856942713168
			},
			{
				"lng": 11.469883832295285,
				"lat": 43.558574213073207
			},
			{
				"lng": 11.46987986001006,
				"lat": 43.55857896581044
			},
			{
				"lng": 11.469875793837586,
				"lat": 43.558583684171566
			},
			{
				"lng": 11.469871634246264,
				"lat": 43.558588366986314
			},
			{
				"lng": 11.469867381736929,
				"lat": 43.558593013086508
			},
			{
				"lng": 11.469863036842874,
				"lat": 43.558597621306809
			},
			{
				"lng": 11.469858600129955,
				"lat": 43.558602190485125
			},
			{
				"lng": 11.469854072196538,
				"lat": 43.558606719463448
			},
			{
				"lng": 11.469849453674149,
				"lat": 43.558611207087722
			},
			{
				"lng": 11.469845053425516,
				"lat": 43.558615870374346
			},
			{
				"lng": 11.469841430452433,
				"lat": 43.5586211278018
			},
			{
				"lng": 11.469837713383269,
				"lat": 43.55862637599224
			},
			{
				"lng": 11.469833901751105,
				"lat": 43.55863161400729
			},
			{
				"lng": 11.469829995103597,
				"lat": 43.558636840891182
			},
			{
				"lng": 11.469825769788054,
				"lat": 43.558642346522767
			},
			{
				"lng": 11.469823110543715,
				"lat": 43.558645738849421
			},
			{
				"lng": 11.469817013635987,
				"lat": 43.558653498357643
			},
			{
				"lng": 11.46980932235495,
				"lat": 43.558660732923606
			},
			{
				"lng": 11.469803137804707,
				"lat": 43.558669181312887
			},
			{
				"lng": 11.4697939518756,
				"lat": 43.558675211792263
			},
			{
				"lng": 11.469784765944588,
				"lat": 43.558681242271
			},
			{
				"lng": 11.469775580011589,
				"lat": 43.558687272749083
			},
			{
				"lng": 11.469766394076876,
				"lat": 43.558693303226441
			},
			{
				"lng": 11.46975720814023,
				"lat": 43.55869933370311
			},
			{
				"lng": 11.469748022201644,
				"lat": 43.558705364179175
			},
			{
				"lng": 11.469738836261509,
				"lat": 43.558711394654345
			},
			{
				"lng": 11.469729650319431,
				"lat": 43.55871742512884
			},
			{
				"lng": 11.46971964846272,
				"lat": 43.558722798302917
			},
			{
				"lng": 11.469709566327284,
				"lat": 43.558728106804764
			},
			{
				"lng": 11.469699484189977,
				"lat": 43.558733415305838
			},
			{
				"lng": 11.469689402050701,
				"lat": 43.558738723806201
			},
			{
				"lng": 11.469679319910004,
				"lat": 43.558744032305427
			},
			{
				"lng": 11.469669237767404,
				"lat": 43.558749340803907
			},
			{
				"lng": 11.4696591556229,
				"lat": 43.558754649301576
			},
			{
				"lng": 11.469649073476683,
				"lat": 43.558759957798351
			},
			{
				"lng": 11.469638956686689,
				"lat": 43.558765238386734
			},
			{
				"lng": 11.469629426209638,
				"lat": 43.558770991310375
			},
			{
				"lng": 11.469622228554448,
				"lat": 43.558778623560784
			},
			{
				"lng": 11.469615030897838,
				"lat": 43.558786255810332
			},
			{
				"lng": 11.469607833239197,
				"lat": 43.558793888059668
			},
			{
				"lng": 11.469600635578844,
				"lat": 43.558801520308599
			},
			{
				"lng": 11.469591860966716,
				"lat": 43.558807882163151
			},
			{
				"lng": 11.469582674995184,
				"lat": 43.558813912626476
			},
			{
				"lng": 11.46957348902151,
				"lat": 43.558819943089297
			},
			{
				"lng": 11.46956453288804,
				"lat": 43.558826158711867
			},
			{
				"lng": 11.469555687485727,
				"lat": 43.55883246354108
			},
			{
				"lng": 11.469546802284416,
				"lat": 43.558838736308829
			},
			{
				"lng": 11.469537941192423,
				"lat": 43.558845028499938
			},
			{
				"lng": 11.469529080098669,
				"lat": 43.558851320690486
			},
			{
				"lng": 11.469520219002794,
				"lat": 43.558857612880516
			},
			{
				"lng": 11.469511357905512,
				"lat": 43.558863905069607
			},
			{
				"lng": 11.469502948130202,
				"lat": 43.558870560846159
			},
			{
				"lng": 11.469494582441705,
				"lat": 43.558877252140014
			},
			{
				"lng": 11.469485874624247,
				"lat": 43.558883667814591
			},
			{
				"lng": 11.469476907410892,
				"lat": 43.558889874520119
			},
			{
				"lng": 11.469467940195768,
				"lat": 43.558896081224837
			},
			{
				"lng": 11.469458972978529,
				"lat": 43.558902287929129
			},
			{
				"lng": 11.469450005759953,
				"lat": 43.558908494632448
			},
			{
				"lng": 11.469441549704353,
				"lat": 43.558915113131633
			},
			{
				"lng": 11.469432798217317,
				"lat": 43.558921493630976
			},
			{
				"lng": 11.469424046728342,
				"lat": 43.558927874129736
			},
			{
				"lng": 11.469415295237576,
				"lat": 43.55893425462785
			},
			{
				"lng": 11.469406543744739,
				"lat": 43.558940635125523
			},
			{
				"lng": 11.469397583980916,
				"lat": 43.558946847839465
			},
			{
				"lng": 11.469388585185497,
				"lat": 43.558953029110612
			},
			{
				"lng": 11.469379437220615,
				"lat": 43.558959090210983
			},
			{
				"lng": 11.469369995597699,
				"lat": 43.558964914740123
			},
			{
				"lng": 11.469360553973054,
				"lat": 43.558970739268496
			},
			{
				"lng": 11.469351112346262,
				"lat": 43.558976563796264
			},
			{
				"lng": 11.469341648252628,
				"lat": 43.558982370224705
			},
			{
				"lng": 11.469332969360687,
				"lat": 43.558988809216245
			},
			{
				"lng": 11.46932349614611,
				"lat": 43.558994608298619
			},
			{
				"lng": 11.469314022929625,
				"lat": 43.559000407380324
			},
			{
				"lng": 11.469304549711438,
				"lat": 43.559006206461262
			},
			{
				"lng": 11.469295076491294,
				"lat": 43.559012005541447
			},
			{
				"lng": 11.469285603269237,
				"lat": 43.559017804621014
			},
			{
				"lng": 11.469276130045669,
				"lat": 43.559023603699558
			},
			{
				"lng": 11.469266656820121,
				"lat": 43.559029402777497
			},
			{
				"lng": 11.469261507954831,
				"lat": 43.559038685583346
			},
			{
				"lng": 11.469259325594397,
				"lat": 43.559050358221391
			},
			{
				"lng": 11.469257143233214,
				"lat": 43.559062030859536
			},
			{
				"lng": 11.469254960871233,
				"lat": 43.559073703497695
			},
			{
				"lng": 11.46925277850859,
				"lat": 43.559085376135535
			},
			{
				"lng": 11.4692475103214,
				"lat": 43.559094562819709
			},
			{
				"lng": 11.469238324271874,
				"lat": 43.559100593257
			},
			{
				"lng": 11.469229138220546,
				"lat": 43.559106623693495
			},
			{
				"lng": 11.469219952167359,
				"lat": 43.559112654129358
			},
			{
				"lng": 11.469210766112017,
				"lat": 43.559118684564709
			},
			{
				"lng": 11.469207071331276,
				"lat": 43.55912111010327
			},
			{
				"lng": 11.469192658741749,
				"lat": 43.559130863869385
			},
			{
				"lng": 11.469176925611764,
				"lat": 43.55914217726302
			},
			{
				"lng": 11.469161671047067,
				"lat": 43.55915383212227
			},
			{
				"lng": 11.469146909054651,
				"lat": 43.559165817745374
			},
			{
				"lng": 11.469132653188923,
				"lat": 43.559178123127694
			},
			{
				"lng": 11.469118916539895,
				"lat": 43.559190736970216
			},
			{
				"lng": 11.469105711720745,
				"lat": 43.559203647691312
			},
			{
				"lng": 11.469097393031664,
				"lat": 43.559218976354956
			},
			{
				"lng": 11.469099008941622,
				"lat": 43.559238616766976
			},
			{
				"lng": 11.469100781447162,
				"lat": 43.559257515929708
			},
			{
				"lng": 11.469101917855811,
				"lat": 43.559275418962841
			},
			{
				"lng": 11.469104070070262,
				"lat": 43.559293063027852
			},
			{
				"lng": 11.469098366316814,
				"lat": 43.55930736741648
			},
			{
				"lng": 11.469093197732741,
				"lat": 43.559321684761656
			},
			{
				"lng": 11.469088558800424,
				"lat": 43.559336007104392
			},
			{
				"lng": 11.469084443984169,
				"lat": 43.559350326781036
			},
			{
				"lng": 11.469080847746469,
				"lat": 43.55936463640964
			},
			{
				"lng": 11.469077764563306,
				"lat": 43.55937892887696
			},
			{
				"lng": 11.469075188937687,
				"lat": 43.559393197324603
			},
			{
				"lng": 11.469072803849144,
				"lat": 43.559407381983029
			},
			{
				"lng": 11.469069468501342,
				"lat": 43.559421330568767
			},
			{
				"lng": 11.469066623800853,
				"lat": 43.55943531600925
			},
			{
				"lng": 11.469064388846672,
				"lat": 43.559449343854567
			},
			{
				"lng": 11.469061639722021,
				"lat": 43.559463309896103
			},
			{
				"lng": 11.469060611513928,
				"lat": 43.559477403169105
			},
			{
				"lng": 11.469061561790822,
				"lat": 43.559490908661466
			},
			{
				"lng": 11.469061903199407,
				"lat": 43.559497908185662
			},
			{
				"lng": 11.469062459450672,
				"lat": 43.559507551441335
			},
			{
				"lng": 11.469062979600849,
				"lat": 43.55951656883898
			},
			{
				"lng": 11.469063499751218,
				"lat": 43.559525586236596
			},
			{
				"lng": 11.469064019901825,
				"lat": 43.559534603634141
			},
			{
				"lng": 11.469064540052619,
				"lat": 43.559543621031786
			},
			{
				"lng": 11.469065060203659,
				"lat": 43.559552638429302
			},
			{
				"lng": 11.469065580354918,
				"lat": 43.559561655826883
			},
			{
				"lng": 11.469066100506403,
				"lat": 43.5595706732244
			},
			{
				"lng": 11.469066620658058,
				"lat": 43.559579690621867
			},
			{
				"lng": 11.469067140809939,
				"lat": 43.559588708019355
			},
			{
				"lng": 11.469067660962061,
				"lat": 43.559597725416822
			},
			{
				"lng": 11.4690681811144,
				"lat": 43.559606742814282
			},
			{
				"lng": 11.469068701266954,
				"lat": 43.559615760211706
			},
			{
				"lng": 11.469069221419726,
				"lat": 43.559624777609123
			},
			{
				"lng": 11.469069741572678,
				"lat": 43.559633795006505
			},
			{
				"lng": 11.469070261725879,
				"lat": 43.559642812403865
			},
			{
				"lng": 11.469070781879276,
				"lat": 43.559651829801211
			},
			{
				"lng": 11.469071302032912,
				"lat": 43.5596608471986
			},
			{
				"lng": 11.469071822186736,
				"lat": 43.559669864595847
			},
			{
				"lng": 11.469072342340805,
				"lat": 43.559678881993165
			},
			{
				"lng": 11.469072862495089,
				"lat": 43.559687899390447
			},
			{
				"lng": 11.469074363399823,
				"lat": 43.559696940728578
			},
			{
				"lng": 11.469075535141412,
				"lat": 43.559705974031608
			},
			{
				"lng": 11.469076688532706,
				"lat": 43.559715006886535
			},
			{
				"lng": 11.469078078770364,
				"lat": 43.559724045523097
			},
			{
				"lng": 11.469079469008513,
				"lat": 43.559733084159596
			},
			{
				"lng": 11.469080859247136,
				"lat": 43.559742122796052
			},
			{
				"lng": 11.469080458283129,
				"lat": 43.559751117708025
			},
			{
				"lng": 11.469080043111109,
				"lat": 43.55976011227304
			},
			{
				"lng": 11.469079627939028,
				"lat": 43.55976910683809
			},
			{
				"lng": 11.46907927372475,
				"lat": 43.55977678077123
			},
			{
				"lng": 11.469140797223789,
				"lat": 43.559785192543934
			},
			{
				"lng": 11.469200553895909,
				"lat": 43.559815659090845
			},
			{
				"lng": 11.46926174793872,
				"lat": 43.559847435267322
			},
			{
				"lng": 11.469273299256285,
				"lat": 43.55985251595758
			},
			{
				"lng": 11.469348105727901,
				"lat": 43.559854341879401
			},
			{
				"lng": 11.469355835401247,
				"lat": 43.559844507328869
			},
			{
				"lng": 11.469395009285241,
				"lat": 43.559804018225861
			},
			{
				"lng": 11.469433852358053,
				"lat": 43.559765150735579
			},
			{
				"lng": 11.469473164989152,
				"lat": 43.559727198625808
			},
			{
				"lng": 11.469479096751403,
				"lat": 43.559723149586965
			},
			{
				"lng": 11.469480432261806,
				"lat": 43.559715857169131
			},
			{
				"lng": 11.46948207401477,
				"lat": 43.559706892542877
			},
			{
				"lng": 11.469483700460399,
				"lat": 43.559697927542999
			},
			{
				"lng": 11.469485244299209,
				"lat": 43.559688960526941
			},
			{
				"lng": 11.469486748699133,
				"lat": 43.55967999254824
			},
			{
				"lng": 11.469488253098636,
				"lat": 43.559671024569482
			},
			{
				"lng": 11.469489757497765,
				"lat": 43.559662056590788
			},
			{
				"lng": 11.469491261896492,
				"lat": 43.559653088612009
			},
			{
				"lng": 11.469492766294879,
				"lat": 43.559644120633216
			},
			{
				"lng": 11.469494270692868,
				"lat": 43.55963515265443
			},
			{
				"lng": 11.469495775090433,
				"lat": 43.559626184675551
			},
			{
				"lng": 11.469497279487626,
				"lat": 43.559617216696765
			},
			{
				"lng": 11.469498783884454,
				"lat": 43.5596082487179
			},
			{
				"lng": 11.469500288280855,
				"lat": 43.559599280738972
			},
			{
				"lng": 11.469501792676887,
				"lat": 43.559590312760101
			},
			{
				"lng": 11.469503297072551,
				"lat": 43.55958134478113
			},
			{
				"lng": 11.469504801467806,
				"lat": 43.55957237680218
			},
			{
				"lng": 11.469506305862661,
				"lat": 43.559563408823195
			},
			{
				"lng": 11.46950757448052,
				"lat": 43.559554435089566
			},
			{
				"lng": 11.469508912166445,
				"lat": 43.559545463041651
			},
			{
				"lng": 11.469510101614933,
				"lat": 43.559536487375702
			},
			{
				"lng": 11.469511692305433,
				"lat": 43.559527521502893
			},
			{
				"lng": 11.469513416570535,
				"lat": 43.559518558890247
			},
			{
				"lng": 11.46951500858183,
				"lat": 43.559510283721949
			},
			{
				"lng": 11.46951577995592,
				"lat": 43.559506596673245
			},
			{
				"lng": 11.469517079798955,
				"lat": 43.55950141810245
			},
			{
				"lng": 11.469518525914619,
				"lat": 43.559496617236732
			},
			{
				"lng": 11.469520195448762,
				"lat": 43.559491874797303
			},
			{
				"lng": 11.469522083990068,
				"lat": 43.559487195684767
			},
			{
				"lng": 11.469524186998822,
				"lat": 43.559482584621101
			},
			{
				"lng": 11.469526499819647,
				"lat": 43.559478046153117
			},
			{
				"lng": 11.469528900938579,
				"lat": 43.559473556710351
			},
			{
				"lng": 11.469531079460509,
				"lat": 43.559469027405392
			},
			{
				"lng": 11.469533487109851,
				"lat": 43.559464559869909
			},
			{
				"lng": 11.469536120584223,
				"lat": 43.559460160231573
			},
			{
				"lng": 11.469538976271542,
				"lat": 43.559455834524748
			},
			{
				"lng": 11.469542050254969,
				"lat": 43.559451588682585
			},
			{
				"lng": 11.46954533831823,
				"lat": 43.5594474285286
			},
			{
				"lng": 11.469548835951461,
				"lat": 43.559443359768707
			},
			{
				"lng": 11.46955253835732,
				"lat": 43.559439387983595
			},
			{
				"lng": 11.46955644045762,
				"lat": 43.559435518620873
			},
			{
				"lng": 11.469560536900239,
				"lat": 43.559431756987713
			},
			{
				"lng": 11.469564822066571,
				"lat": 43.559428108243416
			},
			{
				"lng": 11.469569290079187,
				"lat": 43.559424577392569
			},
			{
				"lng": 11.469573934809693,
				"lat": 43.559421169278131
			},
			{
				"lng": 11.469579803812401,
				"lat": 43.559417170493489
			},
			{
				"lng": 11.469580617339927,
				"lat": 43.559416636429091
			},
			{
				"lng": 11.469589803400794,
				"lat": 43.559410605964153
			},
			{
				"lng": 11.469598989459733,
				"lat": 43.559404575498618
			},
			{
				"lng": 11.469608175516717,
				"lat": 43.559398545032423
			},
			{
				"lng": 11.469617361571874,
				"lat": 43.55939251456558
			},
			{
				"lng": 11.469626547625259,
				"lat": 43.559386484097942
			},
			{
				"lng": 11.469635733676757,
				"lat": 43.559380453629636
			},
			{
				"lng": 11.469644919726438,
				"lat": 43.559374423160655
			},
			{
				"lng": 11.469654105774344,
				"lat": 43.559368392690864
			},
			{
				"lng": 11.469663291820256,
				"lat": 43.559362362220519
			},
			{
				"lng": 11.469672477864425,
				"lat": 43.559356331749413
			},
			{
				"lng": 11.469681663906711,
				"lat": 43.559350301277625
			},
			{
				"lng": 11.469690849947199,
				"lat": 43.55934427080507
			},
			{
				"lng": 11.469700035985838,
				"lat": 43.559338240331883
			},
			{
				"lng": 11.469709222022614,
				"lat": 43.55933220985797
			},
			{
				"lng": 11.469718408057661,
				"lat": 43.559326179383284
			},
			{
				"lng": 11.469727594090632,
				"lat": 43.559320148908078
			},
			{
				"lng": 11.469736780121945,
				"lat": 43.559314118432042
			},
			{
				"lng": 11.469745966151361,
				"lat": 43.559308087955387
			},
			{
				"lng": 11.469755152178955,
				"lat": 43.559302057477922
			},
			{
				"lng": 11.469764338204689,
				"lat": 43.559296026999824
			},
			{
				"lng": 11.469773524228604,
				"lat": 43.559289996521024
			},
			{
				"lng": 11.469782710250769,
				"lat": 43.55928396604142
			},
			{
				"lng": 11.469791896270891,
				"lat": 43.559277935561262
			},
			{
				"lng": 11.469801082289299,
				"lat": 43.559271905080365
			},
			{
				"lng": 11.469812052268241,
				"lat": 43.559267311743106
			},
			{
				"lng": 11.46982432542671,
				"lat": 43.559263768235681
			},
			{
				"lng": 11.469836408431,
				"lat": 43.559260071541942
			},
			{
				"lng": 11.469846253253698,
				"lat": 43.559254571789943
			},
			{
				"lng": 11.46985812733754,
				"lat": 43.559250706792028
			},
			{
				"lng": 11.469871251715698,
				"lat": 43.559247849019357
			},
			{
				"lng": 11.469884376092629,
				"lat": 43.559244991245102
			},
			{
				"lng": 11.469897500468315,
				"lat": 43.559242133469439
			},
			{
				"lng": 11.469908636186373,
				"lat": 43.559237673651417
			},
			{
				"lng": 11.469917822186758,
				"lat": 43.559231643161468
			},
			{
				"lng": 11.469927008185348,
				"lat": 43.559225612670794
			},
			{
				"lng": 11.469936194181964,
				"lat": 43.559219582179537
			},
			{
				"lng": 11.469945380176783,
				"lat": 43.559213551687542
			},
			{
				"lng": 11.469954566169806,
				"lat": 43.559207521194779
			},
			{
				"lng": 11.469963752160947,
				"lat": 43.559201490701398
			},
			{
				"lng": 11.46997293815029,
				"lat": 43.559195460207249
			},
			{
				"lng": 11.46998212413776,
				"lat": 43.559189429712433
			},
			{
				"lng": 11.469991310123525,
				"lat": 43.559183399216842
			},
			{
				"lng": 11.470000496107202,
				"lat": 43.559177368720704
			},
			{
				"lng": 11.470009682089197,
				"lat": 43.559171338223756
			},
			{
				"lng": 11.470018868069284,
				"lat": 43.55916530772619
			},
			{
				"lng": 11.470028054047596,
				"lat": 43.55915927722782
			},
			{
				"lng": 11.470037240024023,
				"lat": 43.559153246728805
			},
			{
				"lng": 11.470046425998612,
				"lat": 43.559147216229086
			},
			{
				"lng": 11.470055611971492,
				"lat": 43.559141185728528
			},
			{
				"lng": 11.47006479794231,
				"lat": 43.559135155227494
			},
			{
				"lng": 11.470073983911412,
				"lat": 43.559129124725686
			},
			{
				"lng": 11.470083169878638,
				"lat": 43.559123094223168
			},
			{
				"lng": 11.470092355844045,
				"lat": 43.559117063719903
			},
			{
				"lng": 11.470101541807592,
				"lat": 43.559111033216027
			},
			{
				"lng": 11.47011072776932,
				"lat": 43.559105002711362
			},
			{
				"lng": 11.470119913729297,
				"lat": 43.559098972205952
			},
			{
				"lng": 11.470129099687258,
				"lat": 43.559092941700001
			},
			{
				"lng": 11.470138285643419,
				"lat": 43.559086911193297
			},
			{
				"lng": 11.470147471597807,
				"lat": 43.559080880685819
			},
			{
				"lng": 11.47015665755031,
				"lat": 43.559074850177694
			},
			{
				"lng": 11.470165843500997,
				"lat": 43.55906881966883
			},
			{
				"lng": 11.47017502944991,
				"lat": 43.559062789159256
			},
			{
				"lng": 11.470184215396825,
				"lat": 43.559056758649071
			},
			{
				"lng": 11.470193401341968,
				"lat": 43.559050728138146
			},
			{
				"lng": 11.470202587285305,
				"lat": 43.559044697626518
			},
			{
				"lng": 11.470211773226756,
				"lat": 43.559038667114187
			},
			{
				"lng": 11.470220959166411,
				"lat": 43.559032636601117
			},
			{
				"lng": 11.47023014510418,
				"lat": 43.559026606087386
			},
			{
				"lng": 11.470239331040268,
				"lat": 43.559020575572873
			},
			{
				"lng": 11.470248516974245,
				"lat": 43.559014545057799
			},
			{
				"lng": 11.470257702906563,
				"lat": 43.559008514541951
			},
			{
				"lng": 11.470266997139129,
				"lat": 43.559002412925629
			},
			{
				"lng": 11.470270176984375,
				"lat": 43.559000319020981
			},
			{
				"lng": 11.470280547343043,
				"lat": 43.558993395086013
			},
			{
				"lng": 11.470291086844883,
				"lat": 43.558986204813593
			},
			{
				"lng": 11.470301519423,
				"lat": 43.558978932541955
			},
			{
				"lng": 11.47031184387102,
				"lat": 43.558971579112111
			},
			{
				"lng": 11.470322058995404,
				"lat": 43.558964145374148
			},
			{
				"lng": 11.470332163615026,
				"lat": 43.558956632187538
			},
			{
				"lng": 11.470342156561639,
				"lat": 43.558949040421155
			},
			{
				"lng": 11.470352036679769,
				"lat": 43.558941370952631
			},
			{
				"lng": 11.470361802827176,
				"lat": 43.558933624668747
			},
			{
				"lng": 11.470371453874707,
				"lat": 43.558925802465254
			},
			{
				"lng": 11.470380988706511,
				"lat": 43.558917905246481
			},
			{
				"lng": 11.470390406220211,
				"lat": 43.558909933925563
			},
			{
				"lng": 11.470399705326937,
				"lat": 43.558901889424213
			},
			{
				"lng": 11.470408884951613,
				"lat": 43.558893772672391
			},
			{
				"lng": 11.470417944032876,
				"lat": 43.558885584608802
			},
			{
				"lng": 11.470426881523318,
				"lat": 43.558877326179996
			},
			{
				"lng": 11.470435696389661,
				"lat": 43.558868998340891
			},
			{
				"lng": 11.470444387612796,
				"lat": 43.558860602054366
			},
			{
				"lng": 11.470452954187763,
				"lat": 43.558852138291293
			},
			{
				"lng": 11.470461395124172,
				"lat": 43.55884360803023
			},
			{
				"lng": 11.470469709446213,
				"lat": 43.558835012257383
			},
			{
				"lng": 11.470477896192506,
				"lat": 43.558826351966687
			},
			{
				"lng": 11.470485954416526,
				"lat": 43.558817628159574
			},
			{
				"lng": 11.470493883186736,
				"lat": 43.558808841844439
			},
			{
				"lng": 11.470501681586363,
				"lat": 43.558799994037386
			},
			{
				"lng": 11.470509348713822,
				"lat": 43.558791085761392
			},
			{
				"lng": 11.470516883682688,
				"lat": 43.558782118046423
			},
			{
				"lng": 11.470524628222144,
				"lat": 43.558773238705534
			},
			{
				"lng": 11.470533677101335,
				"lat": 43.55876489594074
			},
			{
				"lng": 11.470542982646629,
				"lat": 43.558756619623466
			},
			{
				"lng": 11.470551934496699,
				"lat": 43.558748157248694
			},
			{
				"lng": 11.47056076363231,
				"lat": 43.558739607027086
			},
			{
				"lng": 11.470569257117527,
				"lat": 43.558730890229079
			},
			{
				"lng": 11.470578386932029,
				"lat": 43.558722371874182
			},
			{
				"lng": 11.470586563618301,
				"lat": 43.558713462644107
			},
			{
				"lng": 11.470595964923472,
				"lat": 43.558704946145397
			},
			{
				"lng": 11.4706063414556,
				"lat": 43.558696700645029
			},
			{
				"lng": 11.470616623522089,
				"lat": 43.558688344704905
			},
			{
				"lng": 11.470626808479981,
				"lat": 43.558679878597339
			},
			{
				"lng": 11.470636587007984,
				"lat": 43.558671207462204
			},
			{
				"lng": 11.470642102310835,
				"lat": 43.558661666588122
			},
			{
				"lng": 11.470644356465236,
				"lat": 43.558657707701684
			},
			{
				"lng": 11.470649090929143,
				"lat": 43.558649392739284
			},
			{
				"lng": 11.470653825391759,
				"lat": 43.558641077776777
			},
			{
				"lng": 11.470658559853129,
				"lat": 43.558632762813971
			},
			{
				"lng": 11.470663294313278,
				"lat": 43.558624447851052
			},
			{
				"lng": 11.470668297069968,
				"lat": 43.558616213681525
			},
			{
				"lng": 11.47067410810288,
				"lat": 43.558608222910884
			},
			{
				"lng": 11.470679480073235,
				"lat": 43.55860079720739
			},
			{
				"lng": 11.470680076332057,
				"lat": 43.558600065511719
			},
			{
				"lng": 11.47068255679098,
				"lat": 43.558596882876842
			},
			{
				"lng": 11.47068450054533,
				"lat": 43.558594559882131
			},
			{
				"lng": 11.470686563863062,
				"lat": 43.558592301557688
			},
			{
				"lng": 11.470688691811819,
				"lat": 43.558590088390524
			},
			{
				"lng": 11.470690904081344,
				"lat": 43.558587929624977
			},
			{
				"lng": 11.470693199892391,
				"lat": 43.558585826867272
			},
			{
				"lng": 11.470695563412429,
				"lat": 43.55858377327025
			},
			{
				"lng": 11.470697999778254,
				"lat": 43.558581772425633
			},
			{
				"lng": 11.470700515856814,
				"lat": 43.558579830176193
			},
			{
				"lng": 11.470703101010848,
				"lat": 43.558577941449172
			},
			{
				"lng": 11.470705741267132,
				"lat": 43.558576096670144
			},
			{
				"lng": 11.470708476254922,
				"lat": 43.558574327729389
			},
			{
				"lng": 11.47071134593625,
				"lat": 43.558572676928115
			},
			{
				"lng": 11.470714244119977,
				"lat": 43.558571057731143
			},
			{
				"lng": 11.47071720716024,
				"lat": 43.558569502730926
			},
			{
				"lng": 11.470720233057428,
				"lat": 43.558568012546225
			},
			{
				"lng": 11.470723397899025,
				"lat": 43.558566683876066
			},
			{
				"lng": 11.470726676127434,
				"lat": 43.558565511528293
			},
			{
				"lng": 11.470729992788277,
				"lat": 43.558564413130227
			},
			{
				"lng": 11.470733248740014,
				"lat": 43.558563231763038
			},
			{
				"lng": 11.470738523966364,
				"lat": 43.55856142857192
			},
			{
				"lng": 11.470740944592963,
				"lat": 43.558560633279512
			},
			{
				"lng": 11.470752179214088,
				"lat": 43.55855683256538
			},
			{
				"lng": 11.470763434691497,
				"lat": 43.558553069260469
			},
			{
				"lng": 11.47077464807527,
				"lat": 43.558549230458489
			},
			{
				"lng": 11.470785905408077,
				"lat": 43.558545470484454
			},
			{
				"lng": 11.470797558163778,
				"lat": 43.55854185513094
			},
			{
				"lng": 11.47080386876396,
				"lat": 43.558539675598063
			},
			{
				"lng": 11.470816921253162,
				"lat": 43.558534973559738
			},
			{
				"lng": 11.470830338970577,
				"lat": 43.558530306946309
			},
			{
				"lng": 11.470843697917863,
				"lat": 43.558525564753708
			},
			{
				"lng": 11.470857133020177,
				"lat": 43.55852095981065
			},
			{
				"lng": 11.470870577696749,
				"lat": 43.558516373402917
			},
			{
				"lng": 11.470883953781964,
				"lat": 43.558511682126962
			},
			{
				"lng": 11.47089725972929,
				"lat": 43.558506886525244
			},
			{
				"lng": 11.470910494000353,
				"lat": 43.558501987152205
			},
			{
				"lng": 11.470923655064912,
				"lat": 43.55849698457434
			},
			{
				"lng": 11.47093674140112,
				"lat": 43.558491879370116
			},
			{
				"lng": 11.470949751496091,
				"lat": 43.558486672129753
			},
			{
				"lng": 11.47096268384542,
				"lat": 43.558481363455371
			},
			{
				"lng": 11.470975536953883,
				"lat": 43.558475953960844
			},
			{
				"lng": 11.470988309335352,
				"lat": 43.558470444271535
			},
			{
				"lng": 11.471000999513222,
				"lat": 43.558464835024509
			},
			{
				"lng": 11.471013606020069,
				"lat": 43.558459126868343
			},
			{
				"lng": 11.471026127398241,
				"lat": 43.558453320463066
			},
			{
				"lng": 11.471038562200066,
				"lat": 43.558447416480107
			},
			{
				"lng": 11.471050908987879,
				"lat": 43.558441415601919
			},
			{
				"lng": 11.471063166334083,
				"lat": 43.558435318522498
			},
			{
				"lng": 11.471075332821433,
				"lat": 43.558429125946773
			},
			{
				"lng": 11.471087407043193,
				"lat": 43.558422838590822
			},
			{
				"lng": 11.471099387603529,
				"lat": 43.558416457181416
			},
			{
				"lng": 11.471111273116966,
				"lat": 43.558409982456588
			},
			{
				"lng": 11.471123062209402,
				"lat": 43.558403415164932
			},
			{
				"lng": 11.471134753517804,
				"lat": 43.558396756065704
			},
			{
				"lng": 11.471146345690395,
				"lat": 43.558390005929013
			},
			{
				"lng": 11.471157837386867,
				"lat": 43.558383165535147
			},
			{
				"lng": 11.471169227278537,
				"lat": 43.558376235675141
			},
			{
				"lng": 11.471180514048484,
				"lat": 43.558369217150208
			},
			{
				"lng": 11.471191696391772,
				"lat": 43.558362110771938
			},
			{
				"lng": 11.471202773015582,
				"lat": 43.558354917361761
			},
			{
				"lng": 11.471213742639126,
				"lat": 43.558347637751652
			},
			{
				"lng": 11.471224603993992,
				"lat": 43.558340272783177
			},
			{
				"lng": 11.471235355824625,
				"lat": 43.558332823307992
			},
			{
				"lng": 11.471245996887799,
				"lat": 43.558325290187312
			},
			{
				"lng": 11.471256525953201,
				"lat": 43.55831767429229
			},
			{
				"lng": 11.471266941803451,
				"lat": 43.558309976503331
			},
			{
				"lng": 11.471277243234328,
				"lat": 43.558302197710553
			},
			{
				"lng": 11.471287429054771,
				"lat": 43.558294338813418
			},
			{
				"lng": 11.471297498087093,
				"lat": 43.558286400720561
			},
			{
				"lng": 11.471307449167231,
				"lat": 43.558278384349734
			},
			{
				"lng": 11.471317281144517,
				"lat": 43.558270290627917
			},
			{
				"lng": 11.471326992882242,
				"lat": 43.558262120490923
			},
			{
				"lng": 11.471336583257676,
				"lat": 43.558253874883299
			},
			{
				"lng": 11.471346051161815,
				"lat": 43.558245554758557
			},
			{
				"lng": 11.471355395500133,
				"lat": 43.558237161078615
			},
			{
				"lng": 11.471364230998994,
				"lat": 43.558229047611221
			},
			{
				"lng": 11.471367101475634,
				"lat": 43.558226382390721
			},
			{
				"lng": 11.471374732172388,
				"lat": 43.558219297332649
			},
			{
				"lng": 11.471382362867264,
				"lat": 43.558212212274164
			},
			{
				"lng": 11.471389993560445,
				"lat": 43.558205127215189
			},
			{
				"lng": 11.471397624251791,
				"lat": 43.558198042155738
			},
			{
				"lng": 11.471405254941386,
				"lat": 43.558190957095803
			},
			{
				"lng": 11.471412885629162,
				"lat": 43.55818387203545
			},
			{
				"lng": 11.471420516315293,
				"lat": 43.558176786974443
			},
			{
				"lng": 11.471428146999452,
				"lat": 43.558169701913201
			},
			{
				"lng": 11.471435777681956,
				"lat": 43.558162616851334
			},
			{
				"lng": 11.471443408362651,
				"lat": 43.558155531789069
			},
			{
				"lng": 11.471451039041591,
				"lat": 43.558148446726257
			},
			{
				"lng": 11.471458669718739,
				"lat": 43.558141361663054
			},
			{
				"lng": 11.471466300394084,
				"lat": 43.558134276599318
			},
			{
				"lng": 11.471473931067734,
				"lat": 43.558127191535078
			},
			{
				"lng": 11.471481561739518,
				"lat": 43.558120106470447
			},
			{
				"lng": 11.471489192409596,
				"lat": 43.558113021405255
			},
			{
				"lng": 11.471496823077864,
				"lat": 43.558105936339686
			},
			{
				"lng": 11.471504453744377,
				"lat": 43.558098851273513
			},
			{
				"lng": 11.471512084409072,
				"lat": 43.558091766207006
			},
			{
				"lng": 11.471519715072034,
				"lat": 43.558084681139924
			},
			{
				"lng": 11.4715273457332,
				"lat": 43.558077596072408
			},
			{
				"lng": 11.471534976392649,
				"lat": 43.558070511004367
			},
			{
				"lng": 11.471542607050242,
				"lat": 43.558063425935948
			},
			{
				"lng": 11.471550237706104,
				"lat": 43.558056340866983
			},
			{
				"lng": 11.471557868360145,
				"lat": 43.558049255797599
			},
			{
				"lng": 11.471565499012492,
				"lat": 43.558042170727667
			},
			{
				"lng": 11.471573129662971,
				"lat": 43.558035085657345
			},
			{
				"lng": 11.471580760311744,
				"lat": 43.558028000586447
			},
			{
				"lng": 11.47158839095874,
				"lat": 43.558020915515129
			},
			{
				"lng": 11.471596021603894,
				"lat": 43.558013830443336
			},
			{
				"lng": 11.471603652247417,
				"lat": 43.558006745370982
			},
			{
				"lng": 11.471611282888977,
				"lat": 43.557999660298321
			},
			{
				"lng": 11.471618913528859,
				"lat": 43.557992575225057
			},
			{
				"lng": 11.471626544166924,
				"lat": 43.557985490151403
			},
			{
				"lng": 11.471634174803292,
				"lat": 43.557978405077243
			},
			{
				"lng": 11.471641805437793,
				"lat": 43.557971320002594
			},
			{
				"lng": 11.471649436070587,
				"lat": 43.557964234927475
			},
			{
				"lng": 11.471657066701571,
				"lat": 43.557957149851873
			},
			{
				"lng": 11.4716646973308,
				"lat": 43.55795006477576
			},
			{
				"lng": 11.471672327958212,
				"lat": 43.557942979699263
			},
			{
				"lng": 11.471679958583891,
				"lat": 43.557935894622204
			},
			{
				"lng": 11.471687589207777,
				"lat": 43.557928809544748
			},
			{
				"lng": 11.471694990964812,
				"lat": 43.557921936969379
			},
			{
				"lng": 11.471698420944605,
				"lat": 43.55791877328145
			},
			{
				"lng": 11.471704694733896,
				"lat": 43.557913092149768
			},
			{
				"lng": 11.471710873508957,
				"lat": 43.557907626929513
			},
			{
				"lng": 11.471717138252064,
				"lat": 43.55790221371776
			},
			{
				"lng": 11.471723488135295,
				"lat": 43.557896853230005
			},
			{
				"lng": 11.471729922319888,
				"lat": 43.557891546174254
			},
			{
				"lng": 11.471736439955832,
				"lat": 43.557886293251585
			},
			{
				"lng": 11.471743040181895,
				"lat": 43.557881095156134
			},
			{
				"lng": 11.471749722126134,
				"lat": 43.557875952574527
			},
			{
				"lng": 11.471756484905798,
				"lat": 43.557870866186171
			},
			{
				"lng": 11.471763327627311,
				"lat": 43.557865836663105
			},
			{
				"lng": 11.471770249386678,
				"lat": 43.557860864669784
			},
			{
				"lng": 11.471777249269456,
				"lat": 43.557855950863015
			},
			{
				"lng": 11.471784326350836,
				"lat": 43.557851095892033
			},
			{
				"lng": 11.471791479695769,
				"lat": 43.557846300398317
			},
			{
				"lng": 11.471798708359236,
				"lat": 43.557841565015281
			},
			{
				"lng": 11.471806011386169,
				"lat": 43.557836890368563
			},
			{
				"lng": 11.471813387811771,
				"lat": 43.557832277075867
			},
			{
				"lng": 11.4718208366615,
				"lat": 43.557827725746485
			},
			{
				"lng": 11.471828356951246,
				"lat": 43.557823236981804
			},
			{
				"lng": 11.47183594768738,
				"lat": 43.557818811374858
			},
			{
				"lng": 11.471843607867079,
				"lat": 43.55781444951036
			},
			{
				"lng": 11.471851336478455,
				"lat": 43.557810151964446
			},
			{
				"lng": 11.471859132500263,
				"lat": 43.557805919305004
			},
			{
				"lng": 11.471866994902623,
				"lat": 43.557801752091137
			},
			{
				"lng": 11.471874922646743,
				"lat": 43.557797650873461
			},
			{
				"lng": 11.471882914685313,
				"lat": 43.557793616193756
			},
			{
				"lng": 11.471891517665581,
				"lat": 43.557789378815073
			},
			{
				"lng": 11.471898686799483,
				"lat": 43.557785891212816
			},
			{
				"lng": 11.47190897263768,
				"lat": 43.557780887411255
			},
			{
				"lng": 11.471919258473946,
				"lat": 43.557775883608919
			},
			{
				"lng": 11.471929544308725,
				"lat": 43.557770879805609
			},
			{
				"lng": 11.47193983014154,
				"lat": 43.557765876001511
			},
			{
				"lng": 11.471950115972888,
				"lat": 43.557760872196418
			},
			{
				"lng": 11.471960401802223,
				"lat": 43.557755868390494
			},
			{
				"lng": 11.471970687630114,
				"lat": 43.557750864583625
			},
			{
				"lng": 11.47198097345602,
				"lat": 43.557745860775952
			},
			{
				"lng": 11.471991259280458,
				"lat": 43.557740856967271
			},
			{
				"lng": 11.472001545102909,
				"lat": 43.557735853157872
			},
			{
				"lng": 11.472006976311079,
				"lat": 43.557733211002784
			},
			{
				"lng": 11.47201726213089,
				"lat": 43.557728207192
			},
			{
				"lng": 11.472027547949235,
				"lat": 43.557723203380206
			},
			{
				"lng": 11.472037833765592,
				"lat": 43.557718199567582
			},
			{
				"lng": 11.47204811958046,
				"lat": 43.557713195754047
			},
			{
				"lng": 11.472058405393364,
				"lat": 43.557708191939703
			},
			{
				"lng": 11.472068691204798,
				"lat": 43.557703188124322
			},
			{
				"lng": 11.472078977014247,
				"lat": 43.55769818430818
			},
			{
				"lng": 11.472089262822204,
				"lat": 43.557693180491029
			},
			{
				"lng": 11.472099548628199,
				"lat": 43.557688176673132
			},
			{
				"lng": 11.472109834432727,
				"lat": 43.557683172854254
			},
			{
				"lng": 11.472120120235276,
				"lat": 43.557678169034503
			},
			{
				"lng": 11.472130406036316,
				"lat": 43.557673165213835
			},
			{
				"lng": 11.472140691835399,
				"lat": 43.557668161392357
			},
			{
				"lng": 11.472150977633019,
				"lat": 43.557663157569856
			},
			{
				"lng": 11.472161263428626,
				"lat": 43.557658153746637
			},
			{
				"lng": 11.472171549222789,
				"lat": 43.557653149922359
			},
			{
				"lng": 11.472181835014977,
				"lat": 43.557648146097328
			},
			{
				"lng": 11.472192120805689,
				"lat": 43.557643142271317
			},
			{
				"lng": 11.472202406594377,
				"lat": 43.557638138444503
			},
			{
				"lng": 11.47221269238163,
				"lat": 43.55763313461668
			},
			{
				"lng": 11.472222978166908,
				"lat": 43.557628130788082
			},
			{
				"lng": 11.472233263950676,
				"lat": 43.557623126958504
			},
			{
				"lng": 11.472243549732502,
				"lat": 43.557618123128151
			},
			{
				"lng": 11.47225383551285,
				"lat": 43.557613119296796
			},
			{
				"lng": 11.472262861204058,
				"lat": 43.557606745534102
			},
			{
				"lng": 11.472270777829523,
				"lat": 43.557599166028034
			},
			{
				"lng": 11.472279509847761,
				"lat": 43.557592472995502
			},
			{
				"lng": 11.472287952656103,
				"lat": 43.557585465543411
			},
			{
				"lng": 11.472296395462321,
				"lat": 43.557578458090951
			},
			{
				"lng": 11.472304838266764,
				"lat": 43.557571450637703
			},
			{
				"lng": 11.47231328106907,
				"lat": 43.557564443184084
			},
			{
				"lng": 11.472321723869614,
				"lat": 43.557557435729663
			},
			{
				"lng": 11.472331744078341,
				"lat": 43.557552143188751
			},
			{
				"lng": 11.472341952412547,
				"lat": 43.557547055172989
			},
			{
				"lng": 11.47235220521849,
				"lat": 43.557542015506954
			},
			{
				"lng": 11.472362465525347,
				"lat": 43.5575369839963
			},
			{
				"lng": 11.472372752901219,
				"lat": 43.557531981915673
			},
			{
				"lng": 11.472383036761606,
				"lat": 43.557526976013698
			},
			{
				"lng": 11.472393266151501,
				"lat": 43.557521910894479
			},
			{
				"lng": 11.472403560588164,
				"lat": 43.557516916492673
			},
			{
				"lng": 11.472413771423426,
				"lat": 43.557511831203392
			},
			{
				"lng": 11.472424007309874,
				"lat": 43.557506773149704
			},
			{
				"lng": 11.472434212135315,
				"lat": 43.55750168132878
			},
			{
				"lng": 11.472444417645335,
				"lat": 43.557496590252711
			},
			{
				"lng": 11.47245456428452,
				"lat": 43.557491435175628
			},
			{
				"lng": 11.472464785637895,
				"lat": 43.557486361326006
			},
			{
				"lng": 11.47247509944135,
				"lat": 43.557481387986577
			},
			{
				"lng": 11.472485397062226,
				"lat": 43.557476397054543
			},
			{
				"lng": 11.47249558262604,
				"lat": 43.557471284299119
			},
			{
				"lng": 11.472505646721993,
				"lat": 43.557466039488439
			},
			{
				"lng": 11.472515839249516,
				"lat": 43.557460934305837
			},
			{
				"lng": 11.472525970833363,
				"lat": 43.557455762867846
			},
			{
				"lng": 11.472536185293938,
				"lat": 43.557450681532153
			},
			{
				"lng": 11.472546427084303,
				"lat": 43.557445629909054
			},
			{
				"lng": 11.472556693533104,
				"lat": 43.557440605095223
			},
			{
				"lng": 11.472566795848914,
				"lat": 43.557435401842206
			},
			{
				"lng": 11.472577018533599,
				"lat": 43.557430329451599
			},
			{
				"lng": 11.472586743467691,
				"lat": 43.557424715924142
			},
			{
				"lng": 11.472596551321432,
				"lat": 43.557419192545709
			},
			{
				"lng": 11.472606784026564,
				"lat": 43.557414131051715
			},
			{
				"lng": 11.472616894662021,
				"lat": 43.557408936849271
			},
			{
				"lng": 11.472627126470812,
				"lat": 43.557403874382914
			},
			{
				"lng": 11.472637353302339,
				"lat": 43.557398806506832
			},
			{
				"lng": 11.472647692493261,
				"lat": 43.557393860784472
			},
			{
				"lng": 11.472658104660146,
				"lat": 43.557388994400426
			},
			{
				"lng": 11.472668393779623,
				"lat": 43.557383994244091
			},
			{
				"lng": 11.4726786879401,
				"lat": 43.557378999569579
			},
			{
				"lng": 11.472689041487316,
				"lat": 43.557374069458774
			},
			{
				"lng": 11.472699355688141,
				"lat": 43.557369096573389
			},
			{
				"lng": 11.47270963229556,
				"lat": 43.557364082818339
			},
			{
				"lng": 11.472719897975061,
				"lat": 43.557359057184364
			},
			{
				"lng": 11.472730126221659,
				"lat": 43.557353990855205
			},
			{
				"lng": 11.472740418176956,
				"lat": 43.557348993789255
			},
			{
				"lng": 11.472750714361945,
				"lat": 43.55734400132215
			},
			{
				"lng": 11.472760983679986,
				"lat": 43.557338979647838
			},
			{
				"lng": 11.47277124241368,
				"lat": 43.557333946467068
			},
			{
				"lng": 11.472781474624981,
				"lat": 43.557328884453696
			},
			{
				"lng": 11.472791727887886,
				"lat": 43.557323845327318
			},
			{
				"lng": 11.472802014150444,
				"lat": 43.557318842078459
			},
			{
				"lng": 11.472812288958346,
				"lat": 43.557313826376891
			},
			{
				"lng": 11.472822556553401,
				"lat": 43.557308802835394
			},
			{
				"lng": 11.472832829091354,
				"lat": 43.557303784668143
			},
			{
				"lng": 11.472843105655951,
				"lat": 43.557298770879903
			},
			{
				"lng": 11.472853382219101,
				"lat": 43.557293757090655
			},
			{
				"lng": 11.472864026689377,
				"lat": 43.557289143276954
			},
			{
				"lng": 11.472874254304548,
				"lat": 43.557284076275316
			},
			{
				"lng": 11.472884466917428,
				"lat": 43.557278992965266
			},
			{
				"lng": 11.472894658317065,
				"lat": 43.557273886593542
			},
			{
				"lng": 11.472904901138088,
				"lat": 43.557268836126546
			},
			{
				"lng": 11.472915222285083,
				"lat": 43.557263870813017
			},
			{
				"lng": 11.472925605672573,
				"lat": 43.557258973166213
			},
			{
				"lng": 11.472937235158994,
				"lat": 43.557255430227642
			},
			{
				"lng": 11.472948864643627,
				"lat": 43.557251887288004
			},
			{
				"lng": 11.472960625216649,
				"lat": 43.557248486862129
			},
			{
				"lng": 11.472971159148599,
				"lat": 43.557243752884034
			},
			{
				"lng": 11.472981412536452,
				"lat": 43.557238713910536
			},
			{
				"lng": 11.472991875900124,
				"lat": 43.557233903215348
			},
			{
				"lng": 11.473002869112849,
				"lat": 43.557229668550221
			},
			{
				"lng": 11.473014299307644,
				"lat": 43.557225908954422
			},
			{
				"lng": 11.47302547545894,
				"lat": 43.557221873173525
			},
			{
				"lng": 11.473036212888562,
				"lat": 43.557217360434272
			},
			{
				"lng": 11.473047348208905,
				"lat": 43.557213280265032
			},
			{
				"lng": 11.473058550437383,
				"lat": 43.557209272836424
			},
			{
				"lng": 11.473069868320824,
				"lat": 43.557205391143029
			},
			{
				"lng": 11.473081622893456,
				"lat": 43.55720198419985
			},
			{
				"lng": 11.473094677547603,
				"lat": 43.557199990647639
			},
			{
				"lng": 11.473107501808524,
				"lat": 43.557197746622087
			},
			{
				"lng": 11.473117834884434,
				"lat": 43.55719279429136
			},
			{
				"lng": 11.473128120517721,
				"lat": 43.557187790384539
			},
			{
				"lng": 11.473138406149531,
				"lat": 43.557182786476666
			},
			{
				"lng": 11.473148691779318,
				"lat": 43.557177782568033
			},
			{
				"lng": 11.473158977407675,
				"lat": 43.557172778658433
			},
			{
				"lng": 11.473168895312858,
				"lat": 43.557167374978413
			},
			{
				"lng": 11.47317589481805,
				"lat": 43.557158798548564
			},
			{
				"lng": 11.473182874686358,
				"lat": 43.557150200772554
			},
			{
				"lng": 11.473189260147604,
				"lat": 43.55714095678573
			},
			{
				"lng": 11.47319794835084,
				"lat": 43.557134216236463
			},
			{
				"lng": 11.473205980803344,
				"lat": 43.557126762786268
			},
			{
				"lng": 11.473214295113575,
				"lat": 43.557119615760826
			},
			{
				"lng": 11.473222986672708,
				"lat": 43.557112878864068
			},
			{
				"lng": 11.47323177516054,
				"lat": 43.557106247345644
			},
			{
				"lng": 11.473240982835414,
				"lat": 43.557100071548874
			},
			{
				"lng": 11.47325014097302,
				"lat": 43.557093841899231
			},
			{
				"lng": 11.473259425484542,
				"lat": 43.557087749638427
			},
			{
				"lng": 11.473268599752055,
				"lat": 43.557081537527196
			},
			{
				"lng": 11.473278573428104,
				"lat": 43.557076194496219
			},
			{
				"lng": 11.473288845637972,
				"lat": 43.557071176018596
			},
			{
				"lng": 11.473298447512454,
				"lat": 43.557065428784803
			},
			{
				"lng": 11.473307097829752,
				"lat": 43.557058647064942
			},
			{
				"lng": 11.473315848514279,
				"lat": 43.557051974460627
			},
			{
				"lng": 11.473324580861838,
				"lat": 43.557045281923109
			},
			{
				"lng": 11.473333358771784,
				"lat": 43.557038638919984
			},
			{
				"lng": 11.473342231806592,
				"lat": 43.557032099333746
			},
			{
				"lng": 11.473351142672932,
				"lat": 43.557025600877303
			},
			{
				"lng": 11.473360160993106,
				"lat": 43.557019219241212
			},
			{
				"lng": 11.473369141825936,
				"lat": 43.557012796851801
			},
			{
				"lng": 11.47337832783478,
				"lat": 43.557006597521443
			},
			{
				"lng": 11.473387625523303,
				"lat": 43.557000519604898
			},
			{
				"lng": 11.47339655249843,
				"lat": 43.556994038668478
			},
			{
				"lng": 11.473405330126248,
				"lat": 43.556987395370086
			},
			{
				"lng": 11.473413596485392,
				"lat": 43.556980196247288
			},
			{
				"lng": 11.473421866709419,
				"lat": 43.556973001327449
			},
			{
				"lng": 11.473430166262888,
				"lat": 43.556965838295014
			},
			{
				"lng": 11.473438618168561,
				"lat": 43.556958840893614
			},
			{
				"lng": 11.473447104372923,
				"lat": 43.556951526082997
			},
			{
				"lng": 11.473452049405182,
				"lat": 43.556947460380982
			},
			{
				"lng": 11.473461669915936,
				"lat": 43.556939387150813
			},
			{
				"lng": 11.473471509220513,
				"lat": 43.556931336688642
			},
			{
				"lng": 11.473481164242983,
				"lat": 43.556923229423468
			},
			{
				"lng": 11.473490833364037,
				"lat": 43.556915252013496
			},
			{
				"lng": 11.473500382692725,
				"lat": 43.556907266557602
			},
			{
				"lng": 11.473510481084267,
				"lat": 43.556899855474391
			},
			{
				"lng": 11.473520986696183,
				"lat": 43.556892839340257
			},
			{
				"lng": 11.47353134935417,
				"lat": 43.55688572274881
			},
			{
				"lng": 11.473541584916839,
				"lat": 43.556878520753216
			},
			{
				"lng": 11.473551479290334,
				"lat": 43.556871069379589
			},
			{
				"lng": 11.473560881247661,
				"lat": 43.556863272202897
			},
			{
				"lng": 11.473570630900218,
				"lat": 43.556855763156705
			},
			{
				"lng": 11.473579861399568,
				"lat": 43.556847902104096
			},
			{
				"lng": 11.473588920771515,
				"lat": 43.5568399518625
			},
			{
				"lng": 11.473597889435876,
				"lat": 43.556831968063008
			},
			{
				"lng": 11.473606813849445,
				"lat": 43.556823977917333
			},
			{
				"lng": 11.473615312163734,
				"lat": 43.55681574083281
			},
			{
				"lng": 11.473623679448691,
				"lat": 43.556807450755095
			},
			{
				"lng": 11.473631849556551,
				"lat": 43.556799069344542
			},
			{
				"lng": 11.473639673917214,
				"lat": 43.556790517088757
			},
			{
				"lng": 11.47364823169303,
				"lat": 43.556782389883644
			},
			{
				"lng": 11.473656653649327,
				"lat": 43.556774186125132
			},
			{
				"lng": 11.473665054380728,
				"lat": 43.55676596480523
			},
			{
				"lng": 11.473673304652584,
				"lat": 43.556757657757444
			},
			{
				"lng": 11.473681403108898,
				"lat": 43.556749266062027
			},
			{
				"lng": 11.473689348394672,
				"lat": 43.556740790805669
			},
			{
				"lng": 11.47369713915583,
				"lat": 43.556732233081547
			},
			{
				"lng": 11.473704774038882,
				"lat": 43.556723593990277
			},
			{
				"lng": 11.473712251690888,
				"lat": 43.556714874639646
			},
			{
				"lng": 11.473719570759352,
				"lat": 43.556706076145453
			},
			{
				"lng": 11.473726729891947,
				"lat": 43.556697199631557
			},
			{
				"lng": 11.473733727736546,
				"lat": 43.556688246230685
			},
			{
				"lng": 11.473740562941215,
				"lat": 43.556679217084309
			},
			{
				"lng": 11.473747520322839,
				"lat": 43.556670209708912
			},
			{
				"lng": 11.473756003258343,
				"lat": 43.556661666799734
			},
			{
				"lng": 11.473764461303245,
				"lat": 43.556653041254187
			},
			{
				"lng": 11.473774095490262,
				"lat": 43.55664468496353
			},
			{
				"lng": 11.473783620732714,
				"lat": 43.556636184035774
			},
			{
				"lng": 11.473792197819765,
				"lat": 43.556627313556206
			},
			{
				"lng": 11.473800665111131,
				"lat": 43.556618321649026
			},
			{
				"lng": 11.473808999138715,
				"lat": 43.556609202846317
			},
			{
				"lng": 11.473817196535832,
				"lat": 43.556599957409468
			},
			{
				"lng": 11.473825253882922,
				"lat": 43.556590585643541
			},
			{
				"lng": 11.473833167707827,
				"lat": 43.556581087899289
			},
			{
				"lng": 11.473840934485962,
				"lat": 43.556571464574887
			},
			{
				"lng": 11.47384496217599,
				"lat": 43.556561068720711
			},
			{
				"lng": 11.473848423086176,
				"lat": 43.556550566454902
			},
			{
				"lng": 11.473851654348715,
				"lat": 43.55654002556156
			},
			{
				"lng": 11.473854655149523,
				"lat": 43.556529448696629
			},
			{
				"lng": 11.473857424732747,
				"lat": 43.556518838524767
			},
			{
				"lng": 11.473859962400683,
				"lat": 43.556508197719211
			},
			{
				"lng": 11.473862267514098,
				"lat": 43.556497528960961
			},
			{
				"lng": 11.473864339492353,
				"lat": 43.556486834938063
			},
			{
				"lng": 11.473866177813537,
				"lat": 43.556476118344733
			},
			{
				"lng": 11.47386731788,
				"lat": 43.556465347909885
			},
			{
				"lng": 11.473863786204864,
				"lat": 43.556454298010799
			},
			{
				"lng": 11.473860412895696,
				"lat": 43.55644336710585
			},
			{
				"lng": 11.473857882442108,
				"lat": 43.556432570132017
			},
			{
				"lng": 11.473855060222657,
				"lat": 43.556421841783084
			},
			{
				"lng": 11.473852883033294,
				"lat": 43.556411200920365
			},
			{
				"lng": 11.47385044585474,
				"lat": 43.55640061642579
			},
			{
				"lng": 11.473847538924904,
				"lat": 43.556390093594537
			},
			{
				"lng": 11.473844078406831,
				"lat": 43.556379645027413
			},
			{
				"lng": 11.473840156200747,
				"lat": 43.556369281836204
			},
			{
				"lng": 11.473836382556684,
				"lat": 43.556358988929773
			},
			{
				"lng": 11.473832876659333,
				"lat": 43.556348749609278
			},
			{
				"lng": 11.473831705262192,
				"lat": 43.556338413597167
			},
			{
				"lng": 11.473830308431811,
				"lat": 43.556328092408862
			},
			{
				"lng": 11.47382868652018,
				"lat": 43.556317788644769
			},
			{
				"lng": 11.473826839936052,
				"lat": 43.556307504901035
			},
			{
				"lng": 11.473824769144786,
				"lat": 43.556297243768455
			},
			{
				"lng": 11.47382243676641,
				"lat": 43.556287012550875
			},
			{
				"lng": 11.47381921064868,
				"lat": 43.556276901491998
			},
			{
				"lng": 11.473815772021174,
				"lat": 43.556266836290511
			},
			{
				"lng": 11.473812122204041,
				"lat": 43.556256819214987
			},
			{
				"lng": 11.473808262558235,
				"lat": 43.556246852512047
			},
			{
				"lng": 11.473804194484936,
				"lat": 43.556236938406244
			},
			{
				"lng": 11.473799946574921,
				"lat": 43.556227073746115
			},
			{
				"lng": 11.473795879412638,
				"lat": 43.55621718441548
			},
			{
				"lng": 11.473791605721358,
				"lat": 43.556207344396022
			},
			{
				"lng": 11.47378712663518,
				"lat": 43.556197555864983
			},
			{
				"lng": 11.473782443327265,
				"lat": 43.556187820985826
			},
			{
				"lng": 11.473777557009393,
				"lat": 43.556178141907644
			},
			{
				"lng": 11.473772342339894,
				"lat": 43.556168281390249
			},
			{
				"lng": 11.473766471508778,
				"lat": 43.556157916134765
			},
			{
				"lng": 11.473761507171885,
				"lat": 43.556149674649433
			},
			{
				"lng": 11.473756542836421,
				"lat": 43.556141433163766
			},
			{
				"lng": 11.473751578502343,
				"lat": 43.556133191677922
			},
			{
				"lng": 11.473746614169611,
				"lat": 43.556124950191752
			},
			{
				"lng": 11.473741694767575,
				"lat": 43.556116694908404
			},
			{
				"lng": 11.473736968575516,
				"lat": 43.55610838029375
			},
			{
				"lng": 11.473732258190712,
				"lat": 43.556100060825216
			},
			{
				"lng": 11.473727765671322,
				"lat": 43.556091674454166
			},
			{
				"lng": 11.473723287473351,
				"lat": 43.556083283685545
			},
			{
				"lng": 11.473718809276633,
				"lat": 43.556074892916612
			},
			{
				"lng": 11.473714331081206,
				"lat": 43.556066502147495
			},
			{
				"lng": 11.473709852887032,
				"lat": 43.556058111378135
			},
			{
				"lng": 11.473705374694216,
				"lat": 43.556049720608627
			},
			{
				"lng": 11.473700896502631,
				"lat": 43.556041329838827
			},
			{
				"lng": 11.473696418312384,
				"lat": 43.556032939068864
			},
			{
				"lng": 11.473691940123398,
				"lat": 43.556024548298645
			},
			{
				"lng": 11.473687461935704,
				"lat": 43.556016157528205
			},
			{
				"lng": 11.473682983749297,
				"lat": 43.556007766757588
			},
			{
				"lng": 11.47367850556418,
				"lat": 43.555999375986737
			},
			{
				"lng": 11.473674027380365,
				"lat": 43.555990985215686
			},
			{
				"lng": 11.473669549197824,
				"lat": 43.555982594444345
			},
			{
				"lng": 11.473665071016576,
				"lat": 43.555974203672911
			},
			{
				"lng": 11.473660592836614,
				"lat": 43.555965812901164
			},
			{
				"lng": 11.473656617221279,
				"lat": 43.555958363783247
			},
			{
				"lng": 11.473652886962107,
				"lat": 43.555950845104896
			},
			{
				"lng": 11.473648393659712,
				"lat": 43.555942459692517
			},
			{
				"lng": 11.473643866643929,
				"lat": 43.555934083918061
			},
			{
				"lng": 11.473639339629436,
				"lat": 43.555925708143413
			},
			{
				"lng": 11.473634812616254,
				"lat": 43.55591733236858
			},
			{
				"lng": 11.473630285604347,
				"lat": 43.555908956593449
			},
			{
				"lng": 11.473625758593801,
				"lat": 43.555900580818182
			},
			{
				"lng": 11.473621231584495,
				"lat": 43.555892205042653
			},
			{
				"lng": 11.473616704576523,
				"lat": 43.555883829266911
			},
			{
				"lng": 11.473612177569816,
				"lat": 43.555875453490913
			},
			{
				"lng": 11.473607650564444,
				"lat": 43.555867077714773
			},
			{
				"lng": 11.473603123560363,
				"lat": 43.555858701938334
			},
			{
				"lng": 11.473598596557592,
				"lat": 43.555850326161746
			},
			{
				"lng": 11.473594069556048,
				"lat": 43.555841950384853
			},
			{
				"lng": 11.473589542555914,
				"lat": 43.555833574607831
			},
			{
				"lng": 11.473585015557004,
				"lat": 43.555825198830497
			},
			{
				"lng": 11.473580488559417,
				"lat": 43.555816823052986
			},
			{
				"lng": 11.473575961563144,
				"lat": 43.555808447275211
			},
			{
				"lng": 11.473571434568138,
				"lat": 43.555800071497316
			},
			{
				"lng": 11.473566907574453,
				"lat": 43.555791695719101
			},
			{
				"lng": 11.473562380582079,
				"lat": 43.555783319940716
			},
			{
				"lng": 11.473557853590968,
				"lat": 43.555774944162103
			},
			{
				"lng": 11.473553326601195,
				"lat": 43.55576656838327
			},
			{
				"lng": 11.473548799612685,
				"lat": 43.555758192604209
			},
			{
				"lng": 11.473544272625501,
				"lat": 43.55574981682495
			},
			{
				"lng": 11.4735397456396,
				"lat": 43.555741441045406
			},
			{
				"lng": 11.473535218655051,
				"lat": 43.555733065265741
			},
			{
				"lng": 11.473530691671741,
				"lat": 43.555724689485764
			},
			{
				"lng": 11.473526164689753,
				"lat": 43.555716313705645
			},
			{
				"lng": 11.473521637709043,
				"lat": 43.555707937925227
			},
			{
				"lng": 11.473517110729665,
				"lat": 43.555699562144582
			},
			{
				"lng": 11.473512583751591,
				"lat": 43.555691186363809
			},
			{
				"lng": 11.473508056774778,
				"lat": 43.555682810582731
			},
			{
				"lng": 11.473503529799292,
				"lat": 43.555674434801517
			},
			{
				"lng": 11.473499002825077,
				"lat": 43.555666059019998
			},
			{
				"lng": 11.473494475852226,
				"lat": 43.55565768323833
			},
			{
				"lng": 11.473489948880612,
				"lat": 43.55564930745637
			},
			{
				"lng": 11.473485421910313,
				"lat": 43.555640931674269
			},
			{
				"lng": 11.473480894941323,
				"lat": 43.555632555891869
			},
			{
				"lng": 11.473476367973644,
				"lat": 43.55562418010927
			},
			{
				"lng": 11.47347184100723,
				"lat": 43.555615804326429
			},
			{
				"lng": 11.473467314042141,
				"lat": 43.555607428543389
			},
			{
				"lng": 11.47346278707834,
				"lat": 43.555599052760144
			},
			{
				"lng": 11.473458260115848,
				"lat": 43.555590676976685
			},
			{
				"lng": 11.473453733154669,
				"lat": 43.555582301192992
			},
			{
				"lng": 11.473449206194777,
				"lat": 43.555573925409078
			},
			{
				"lng": 11.473444679236163,
				"lat": 43.555565549624909
			},
			{
				"lng": 11.473440152278885,
				"lat": 43.555557173840604
			},
			{
				"lng": 11.473435625322869,
				"lat": 43.555548798055987
			},
			{
				"lng": 11.47343109836819,
				"lat": 43.55554042227125
			},
			{
				"lng": 11.47342657141477,
				"lat": 43.555532046486107
			},
			{
				"lng": 11.473422044462717,
				"lat": 43.555523670700993
			},
			{
				"lng": 11.4734175175119,
				"lat": 43.555515294915509
			},
			{
				"lng": 11.473412990562419,
				"lat": 43.555506919129833
			},
			{
				"lng": 11.4734084636142,
				"lat": 43.555498543343901
			},
			{
				"lng": 11.473403936667308,
				"lat": 43.555490167557778
			},
			{
				"lng": 11.473399409721727,
				"lat": 43.555481791771442
			},
			{
				"lng": 11.473394882777434,
				"lat": 43.555473415984935
			},
			{
				"lng": 11.473390355834415,
				"lat": 43.555465040198115
			},
			{
				"lng": 11.473383865926646,
				"lat": 43.555457225571296
			},
			{
				"lng": 11.473373399614051,
				"lat": 43.555450547693312
			},
			{
				"lng": 11.473362933303806,
				"lat": 43.555443869814361
			},
			{
				"lng": 11.473352466995864,
				"lat": 43.555437191934374
			},
			{
				"lng": 11.473344187808294,
				"lat": 43.55542988881475
			},
			{
				"lng": 11.473332925241964,
				"lat": 43.555423438563189
			},
			{
				"lng": 11.473324113719672,
				"lat": 43.55541628762343
			},
			{
				"lng": 11.473319422705044,
				"lat": 43.555407958741178
			},
			{
				"lng": 11.473314517998457,
				"lat": 43.55539969094783
			},
			{
				"lng": 11.473309613293223,
				"lat": 43.555391423154333
			},
			{
				"lng": 11.47330470858936,
				"lat": 43.555383155360524
			},
			{
				"lng": 11.473299803886926,
				"lat": 43.555374887566444
			},
			{
				"lng": 11.473294899185843,
				"lat": 43.555366619772137
			},
			{
				"lng": 11.473289994486167,
				"lat": 43.555358351977624
			},
			{
				"lng": 11.473285089787852,
				"lat": 43.555350084182756
			},
			{
				"lng": 11.473280185090982,
				"lat": 43.555341816387745
			},
			{
				"lng": 11.473275280395432,
				"lat": 43.555333548592344
			},
			{
				"lng": 11.473270375701272,
				"lat": 43.555325280796815
			},
			{
				"lng": 11.473265471008482,
				"lat": 43.55531701300098
			},
			{
				"lng": 11.473260566317125,
				"lat": 43.555308745204933
			},
			{
				"lng": 11.473255661627112,
				"lat": 43.555300477408551
			},
			{
				"lng": 11.473250756938512,
				"lat": 43.555292209612006
			},
			{
				"lng": 11.473245852251271,
				"lat": 43.555283941815141
			},
			{
				"lng": 11.473240947565436,
				"lat": 43.555275674018006
			},
			{
				"lng": 11.473236042880963,
				"lat": 43.555267406220644
			},
			{
				"lng": 11.47323113819791,
				"lat": 43.555259138423075
			},
			{
				"lng": 11.473226233516227,
				"lat": 43.555250870625215
			},
			{
				"lng": 11.473221328835908,
				"lat": 43.5552426028271
			},
			{
				"lng": 11.473216424156972,
				"lat": 43.555234335028736
			},
			{
				"lng": 11.473211519479442,
				"lat": 43.555226067230102
			},
			{
				"lng": 11.473206614803274,
				"lat": 43.555217799431226
			},
			{
				"lng": 11.473201710128514,
				"lat": 43.555209531632094
			},
			{
				"lng": 11.473196805455149,
				"lat": 43.555201263832693
			},
			{
				"lng": 11.473191900783133,
				"lat": 43.55519299603305
			},
			{
				"lng": 11.473186996112528,
				"lat": 43.555184728233208
			},
			{
				"lng": 11.473182091443281,
				"lat": 43.55517646043306
			},
			{
				"lng": 11.473177186775441,
				"lat": 43.555168192632657
			},
			{
				"lng": 11.473172282108962,
				"lat": 43.555159924831997
			},
			{
				"lng": 11.47316737744389,
				"lat": 43.555151657031089
			},
			{
				"lng": 11.473162472780182,
				"lat": 43.555143389229926
			},
			{
				"lng": 11.473157568117891,
				"lat": 43.55513512142857
			},
			{
				"lng": 11.473152663456945,
				"lat": 43.555126853626845
			},
			{
				"lng": 11.473147758797413,
				"lat": 43.55511858582495
			},
			{
				"lng": 11.473142854139239,
				"lat": 43.555110318022749
			},
			{
				"lng": 11.473137949482474,
				"lat": 43.555102050220356
			},
			{
				"lng": 11.473133044827067,
				"lat": 43.555093782417671
			},
			{
				"lng": 11.47312814017307,
				"lat": 43.555085514614738
			},
			{
				"lng": 11.473123235520433,
				"lat": 43.5550772468115
			},
			{
				"lng": 11.473118482226642,
				"lat": 43.555068935739143
			},
			{
				"lng": 11.473114096059243,
				"lat": 43.555060519715518
			},
			{
				"lng": 11.473107939998039,
				"lat": 43.555052609656173
			},
			{
				"lng": 11.473101783938487,
				"lat": 43.555044699596387
			},
			{
				"lng": 11.47309562788058,
				"lat": 43.555036789536246
			},
			{
				"lng": 11.473089471824283,
				"lat": 43.555028879475692
			},
			{
				"lng": 11.473083315769648,
				"lat": 43.555020969414748
			},
			{
				"lng": 11.47307715971664,
				"lat": 43.555013059353449
			},
			{
				"lng": 11.473071003665307,
				"lat": 43.555005149291773
			},
			{
				"lng": 11.473064847615618,
				"lat": 43.554997239229714
			},
			{
				"lng": 11.473058691567561,
				"lat": 43.554989329167242
			},
			{
				"lng": 11.47305144258528,
				"lat": 43.554981731544473
			},
			{
				"lng": 11.473045108081404,
				"lat": 43.554973872497762
			},
			{
				"lng": 11.473040581226847,
				"lat": 43.554965496694408
			},
			{
				"lng": 11.473036054373599,
				"lat": 43.554957120890812
			},
			{
				"lng": 11.473031527521618,
				"lat": 43.554948745087003
			},
			{
				"lng": 11.473027000670967,
				"lat": 43.554940369282932
			},
			{
				"lng": 11.473022473821612,
				"lat": 43.554931993478732
			},
			{
				"lng": 11.47301794697356,
				"lat": 43.554923617674213
			},
			{
				"lng": 11.473015871756175,
				"lat": 43.554919778000652
			},
			{
				"lng": 11.47300939349323,
				"lat": 43.554910609640189
			},
			{
				"lng": 11.473003765923279,
				"lat": 43.55490264522021
			},
			{
				"lng": 11.472998138354844,
				"lat": 43.554894680799883
			},
			{
				"lng": 11.472992510787929,
				"lat": 43.554886716379229
			},
			{
				"lng": 11.472986883222561,
				"lat": 43.554878751958313
			},
			{
				"lng": 11.472981255658677,
				"lat": 43.554870787536935
			},
			{
				"lng": 11.472975195513904,
				"lat": 43.554862984788663
			},
			{
				"lng": 11.472968519540689,
				"lat": 43.554855412200247
			},
			{
				"lng": 11.472961843569186,
				"lat": 43.554847839611327
			},
			{
				"lng": 11.472955167599368,
				"lat": 43.554840267022001
			},
			{
				"lng": 11.472948491631287,
				"lat": 43.554832694432264
			},
			{
				"lng": 11.472941815664845,
				"lat": 43.55482512184205
			},
			{
				"lng": 11.472935139700137,
				"lat": 43.554817549251439
			},
			{
				"lng": 11.472928463737151,
				"lat": 43.55480997666033
			},
			{
				"lng": 11.472922362204741,
				"lat": 43.554802189381952
			},
			{
				"lng": 11.472916631840514,
				"lat": 43.554794263383556
			},
			{
				"lng": 11.472910901477809,
				"lat": 43.554786337384776
			},
			{
				"lng": 11.472905114712365,
				"lat": 43.554778432466264
			},
			{
				"lng": 11.472899301676843,
				"lat": 43.554770537366046
			},
			{
				"lng": 11.472893267691536,
				"lat": 43.554762724843862
			},
			{
				"lng": 11.472887704065903,
				"lat": 43.554756444999406
			},
			{
				"lng": 11.472887407400014,
				"lat": 43.55475492712074
			},
			{
				"lng": 11.472885478223015,
				"lat": 43.554746019617845
			},
			{
				"lng": 11.472883077495037,
				"lat": 43.554737208633455
			}
			],
			[{
				"lng": 11.470003121997619,
				"lat": 43.557612497788519
			},
			{
				"lng": 11.469999554808041,
				"lat": 43.557617629380516
			},
			{
				"lng": 11.469996484798354,
				"lat": 43.557622928295906
			},
			{
				"lng": 11.469993926707366,
				"lat": 43.55762836909544
			},
			{
				"lng": 11.46999189281625,
				"lat": 43.557633925658564
			},
			{
				"lng": 11.469990392889558,
				"lat": 43.557639571309025
			},
			{
				"lng": 11.469989434128392,
				"lat": 43.557645278942864
			},
			{
				"lng": 11.469989021135769,
				"lat": 43.557651021158513
			},
			{
				"lng": 11.469989155894572,
				"lat": 43.557656770388441
			},
			{
				"lng": 11.469989837758002,
				"lat": 43.557662499031352
			},
			{
				"lng": 11.469991063452674,
				"lat": 43.55766817958483
			},
			{
				"lng": 11.469992827094341,
				"lat": 43.5576737847773
			},
			{
				"lng": 11.469995120216158,
				"lat": 43.557679287698988
			},
			{
				"lng": 11.469997931809282,
				"lat": 43.557684661931134
			},
			{
				"lng": 11.470001248375761,
				"lat": 43.557689881672687
			},
			{
				"lng": 11.470005053993322,
				"lat": 43.55769492186441
			},
			{
				"lng": 11.470009330391802,
				"lat": 43.557699758308942
			},
			{
				"lng": 11.470014057040862,
				"lat": 43.55770436778716
			},
			{
				"lng": 11.470019211248555,
				"lat": 43.557708728169544
			},
			{
				"lng": 11.470024768270273,
				"lat": 43.557712818522475
			},
			{
				"lng": 11.470030701427527,
				"lat": 43.557716619208641
			},
			{
				"lng": 11.470036982236021,
				"lat": 43.557720111981439
			},
			{
				"lng": 11.470043580542429,
				"lat": 43.55772328007248
			},
			{
				"lng": 11.470043580542422,
				"lat": 43.557723280072501
			},
			{
				"lng": 11.470054226393099,
				"lat": 43.557727654110124
			},
			{
				"lng": 11.470065262751328,
				"lat": 43.557731482177793
			},
			{
				"lng": 11.470076636756248,
				"lat": 43.557734745940188
			},
			{
				"lng": 11.470088293929734,
				"lat": 43.557737429764799
			},
			{
				"lng": 11.470100178437326,
				"lat": 43.557739520796972
			},
			{
				"lng": 11.470112233355698,
				"lat": 43.557741009021193
			},
			{
				"lng": 11.470124400945297,
				"lat": 43.557741887309355
			},
			{
				"lng": 11.470136622926875,
				"lat": 43.557742151454704
			},
			{
				"lng": 11.470148840760684,
				"lat": 43.557741800192112
			},
			{
				"lng": 11.470160995926838,
				"lat": 43.55774083520398
			},
			{
				"lng": 11.470173030205604,
				"lat": 43.557739261112346
			},
			{
				"lng": 11.470184885956296,
				"lat": 43.557737085456658
			},
			{
				"lng": 11.470196506393332,
				"lat": 43.557734318657729
			},
			{
				"lng": 11.470207835858236,
				"lat": 43.557730973967651
			},
			{
				"lng": 11.47021882008624,
				"lat": 43.557727067406582
			},
			{
				"lng": 11.470229406466178,
				"lat": 43.557722617685783
			},
			{
				"lng": 11.470239544292507,
				"lat": 43.557717646118135
			},
			{
				"lng": 11.4702395442925,
				"lat": 43.557717646118121
			},
			{
				"lng": 11.470327933416886,
				"lat": 43.557669457629764
			},
			{
				"lng": 11.47032793341689,
				"lat": 43.557669457629764
			},
			{
				"lng": 11.470383135947158,
				"lat": 43.557636822594297
			},
			{
				"lng": 11.47038313594715,
				"lat": 43.55763682259429
			},
			{
				"lng": 11.470437881319075,
				"lat": 43.557602779842163
			},
			{
				"lng": 11.470437881319086,
				"lat": 43.557602779842163
			},
			{
				"lng": 11.470444308913242,
				"lat": 43.557598708673396
			},
			{
				"lng": 11.470444308913242,
				"lat": 43.557598708673396
			},
			{
				"lng": 11.470459124302772,
				"lat": 43.557588484122995
			},
			{
				"lng": 11.470472933582212,
				"lat": 43.557577540031282
			},
			{
				"lng": 11.470472933582212,
				"lat": 43.557577540031282
			},
			{
				"lng": 11.470486624409357,
				"lat": 43.557566696593078
			},
			{
				"lng": 11.470501320742331,
				"lat": 43.557556573164604
			},
			{
				"lng": 11.470501320742331,
				"lat": 43.557556573164604
			},
			{
				"lng": 11.470512379039056,
				"lat": 43.557549938895406
			},
			{
				"lng": 11.470524025875056,
				"lat": 43.557543860569751
			},
			{
				"lng": 11.470536208499979,
				"lat": 43.5575383657172
			},
			{
				"lng": 11.470536208499983,
				"lat": 43.557538365717207
			},
			{
				"lng": 11.47057716145596,
				"lat": 43.557520346292272
			},
			{
				"lng": 11.470616951909797,
				"lat": 43.557500998346967
			},
			{
				"lng": 11.470616951909793,
				"lat": 43.557500998346967
			},
			{
				"lng": 11.470638707100736,
				"lat": 43.557489468658787
			},
			{
				"lng": 11.470659884668798,
				"lat": 43.557477383563793
			},
			{
				"lng": 11.470659884668796,
				"lat": 43.557477383563793
			},
			{
				"lng": 11.470675153269346,
				"lat": 43.557467897757263
			},
			{
				"lng": 11.470689782568465,
				"lat": 43.557457893279611
			},
			{
				"lng": 11.470689782568465,
				"lat": 43.557457893279611
			},
			{
				"lng": 11.470690944581186,
				"lat": 43.557456999823856
			},
			{
				"lng": 11.470692018585805,
				"lat": 43.557456049906868
			},
			{
				"lng": 11.470692999409509,
				"lat": 43.55745504810384
			},
			{
				"lng": 11.470693882328268,
				"lat": 43.557453999239776
			},
			{
				"lng": 11.470694663089615,
				"lat": 43.5574529083665
			},
			{
				"lng": 11.470695337933101,
				"lat": 43.557451780737999
			},
			{
				"lng": 11.470695903608435,
				"lat": 43.557450621785421
			},
			{
				"lng": 11.470696357391104,
				"lat": 43.557449437090703
			},
			{
				"lng": 11.47069669709553,
				"lat": 43.557448232359789
			},
			{
				"lng": 11.470696921085564,
				"lat": 43.557447013395112
			},
			{
				"lng": 11.470697028282391,
				"lat": 43.557445786067746
			},
			{
				"lng": 11.470697018169725,
				"lat": 43.557444556288921
			},
			{
				"lng": 11.470696890796271,
				"lat": 43.557443329981702
			},
			{
				"lng": 11.470696646775531,
				"lat": 43.557442113052502
			},
			{
				"lng": 11.470696287282786,
				"lat": 43.557440911362519
			},
			{
				"lng": 11.470695814049513,
				"lat": 43.557439730699507
			},
			{
				"lng": 11.470695229354986,
				"lat": 43.557438576750044
			},
			{
				"lng": 11.470694536015335,
				"lat": 43.557437455071955
			},
			{
				"lng": 11.470693737369942,
				"lat": 43.557436371067695
			},
			{
				"lng": 11.4706928372654,
				"lat": 43.557435329958231
			},
			{
				"lng": 11.470691840036958,
				"lat": 43.55743433675795
			},
			{
				"lng": 11.470690750487666,
				"lat": 43.557433396250495
			},
			{
				"lng": 11.470689573865199,
				"lat": 43.55743251296569
			},
			{
				"lng": 11.470688315836625,
				"lat": 43.55743169115776
			},
			{
				"lng": 11.470686982461105,
				"lat": 43.557430934784911
			},
			{
				"lng": 11.470685580160676,
				"lat": 43.557430247490046
			},
			{
				"lng": 11.470684115689359,
				"lat": 43.557429632583471
			},
			{
				"lng": 11.4706825961006,
				"lat": 43.557429093026805
			},
			{
				"lng": 11.470681028713335,
				"lat": 43.55742863141878
			},
			{
				"lng": 11.470679421076687,
				"lat": 43.557428249982664
			},
			{
				"lng": 11.470677780933647,
				"lat": 43.557427950555606
			},
			{
				"lng": 11.470677780933647,
				"lat": 43.557427950555606
			},
			{
				"lng": 11.470659208400349,
				"lat": 43.557425502260266
			},
			{
				"lng": 11.470640458907386,
				"lat": 43.557423920779129
			},
			{
				"lng": 11.47062160886659,
				"lat": 43.557423212557346
			},
			{
				"lng": 11.470602735099554,
				"lat": 43.55742338048119
			},
			{
				"lng": 11.470583914524576,
				"lat": 43.557424423866408
			},
			{
				"lng": 11.470565223843177,
				"lat": 43.557426338460708
			},
			{
				"lng": 11.47054673922754,
				"lat": 43.557429116461442
			},
			{
				"lng": 11.470528536010059,
				"lat": 43.557432746547093
			},
			{
				"lng": 11.470528536010063,
				"lat": 43.557432746547093
			},
			{
				"lng": 11.470433324944736,
				"lat": 43.557454377599463
			},
			{
				"lng": 11.470433324944739,
				"lat": 43.55745437759947
			},
			{
				"lng": 11.470373113713308,
				"lat": 43.557468458584033
			},
			{
				"lng": 11.470373113713302,
				"lat": 43.557468458584005
			},
			{
				"lng": 11.470328967320741,
				"lat": 43.557478967825872
			},
			{
				"lng": 11.470328967320741,
				"lat": 43.557478967825872
			},
			{
				"lng": 11.470282646355706,
				"lat": 43.557490003375321
			},
			{
				"lng": 11.470282646355706,
				"lat": 43.557490003375321
			},
			{
				"lng": 11.470216523192263,
				"lat": 43.557506283808209
			},
			{
				"lng": 11.470216523192263,
				"lat": 43.557506283808209
			},
			{
				"lng": 11.47010479031036,
				"lat": 43.557535205067843
			},
			{
				"lng": 11.47010479031036,
				"lat": 43.557535205067843
			},
			{
				"lng": 11.470097539073819,
				"lat": 43.557537314598591
			},
			{
				"lng": 11.470090493918461,
				"lat": 43.557539765791056
			},
			{
				"lng": 11.470083685243107,
				"lat": 43.557542548068717
			},
			{
				"lng": 11.470077142426236,
				"lat": 43.557545649426473
			},
			{
				"lng": 11.470070893699166,
				"lat": 43.557549056482408
			},
			{
				"lng": 11.470064966024294,
				"lat": 43.557552754535529
			},
			{
				"lng": 11.470059384978747,
				"lat": 43.557556727629347
			},
			{
				"lng": 11.470059384978745,
				"lat": 43.557556727629347
			},
			{
				"lng": 11.470043474313865,
				"lat": 43.557569640225481
			},
			{
				"lng": 11.470028752869716,
				"lat": 43.557583278470496
			},
			{
				"lng": 11.4700152830614,
				"lat": 43.557597584542606
			},
			{
				"lng": 11.470003121997612,
				"lat": 43.55761249778849
			}
			],
			[{
				"lng": 11.470616615305872,
				"lat": 43.557264692868152
			},
			{
				"lng": 11.470613183350771,
				"lat": 43.557267146890865
			},
			{
				"lng": 11.470609988900087,
				"lat": 43.557269765020216
			},
			{
				"lng": 11.470607046754493,
				"lat": 43.557272535125897
			},
			{
				"lng": 11.470604370545679,
				"lat": 43.557275444373268
			},
			{
				"lng": 11.470601972673206,
				"lat": 43.55727847928317
			},
			{
				"lng": 11.47059986424701,
				"lat": 43.557281625794069
			},
			{
				"lng": 11.470598055035989,
				"lat": 43.557284869327496
			},
			{
				"lng": 11.470596553422702,
				"lat": 43.557288194855346
			},
			{
				"lng": 11.470595366364527,
				"lat": 43.557291586969669
			},
			{
				"lng": 11.470594499361447,
				"lat": 43.557295029953977
			},
			{
				"lng": 11.470593956430553,
				"lat": 43.557298507856096
			},
			{
				"lng": 11.47059374008743,
				"lat": 43.557302004562047
			},
			{
				"lng": 11.470593851334508,
				"lat": 43.557305503870779
			},
			{
				"lng": 11.470594289656406,
				"lat": 43.557308989569115
			},
			{
				"lng": 11.470595053022326,
				"lat": 43.55731244550698
			},
			{
				"lng": 11.470596137895468,
				"lat": 43.557315855672165
			},
			{
				"lng": 11.470597539249393,
				"lat": 43.557319204264473
			},
			{
				"lng": 11.470599250591343,
				"lat": 43.557322475769176
			},
			{
				"lng": 11.470601263992286,
				"lat": 43.557325655028478
			},
			{
				"lng": 11.470603570123691,
				"lat": 43.557328727312097
			},
			{
				"lng": 11.470606158300717,
				"lat": 43.557331678385431
			},
			{
				"lng": 11.470609016531737,
				"lat": 43.557334494575386
			},
			{
				"lng": 11.470612131573885,
				"lat": 43.557337162833861
			},
			{
				"lng": 11.470615488994412,
				"lat": 43.557339670798115
			},
			{
				"lng": 11.470619073237584,
				"lat": 43.557342006848145
			},
			{
				"lng": 11.470622867696722,
				"lat": 43.557344160160461
			},
			{
				"lng": 11.470622867696727,
				"lat": 43.557344160160461
			},
			{
				"lng": 11.470631692244091,
				"lat": 43.557348496142296
			},
			{
				"lng": 11.470640905793818,
				"lat": 43.557352380672889
			},
			{
				"lng": 11.470650464749999,
				"lat": 43.55735579537177
			},
			{
				"lng": 11.470660323882331,
				"lat": 43.557358724081489
			},
			{
				"lng": 11.470670436540129,
				"lat": 43.55736115294421
			},
			{
				"lng": 11.470680754873088,
				"lat": 43.557363070467268
			},
			{
				"lng": 11.470691230057678,
				"lat": 43.557364467577415
			},
			{
				"lng": 11.470701812528194,
				"lat": 43.557365337663938
			},
			{
				"lng": 11.470712452211268,
				"lat": 43.557365676609848
			},
			{
				"lng": 11.470723098762809,
				"lat": 43.557365482811285
			},
			{
				"lng": 11.470733701806239,
				"lat": 43.557364757185361
			},
			{
				"lng": 11.470744211170848,
				"lat": 43.557363503165483
			},
			{
				"lng": 11.470754577129188,
				"lat": 43.557361726685322
			},
			{
				"lng": 11.470764750632398,
				"lat": 43.557359436150712
			},
			{
				"lng": 11.470774683542269,
				"lat": 43.557356642399903
			},
			{
				"lng": 11.470784328859036,
				"lat": 43.557353358652094
			},
			{
				"lng": 11.470784328859036,
				"lat": 43.557353358652094
			},
			{
				"lng": 11.470861379367923,
				"lat": 43.557323290633278
			},
			{
				"lng": 11.470861379367923,
				"lat": 43.557323290633278
			},
			{
				"lng": 11.470942552787731,
				"lat": 43.557288577606307
			},
			{
				"lng": 11.470942552787731,
				"lat": 43.557288577606307
			},
			{
				"lng": 11.471005462442623,
				"lat": 43.557260121303052
			},
			{
				"lng": 11.471005462442623,
				"lat": 43.557260121303052
			},
			{
				"lng": 11.471008145116979,
				"lat": 43.55725879505593
			},
			{
				"lng": 11.471010695434705,
				"lat": 43.557257337230638
			},
			{
				"lng": 11.471010695434707,
				"lat": 43.557257337230652
			},
			{
				"lng": 11.471011529620892,
				"lat": 43.557256791061398
			},
			{
				"lng": 11.471012313647725,
				"lat": 43.557256206912122
			},
			{
				"lng": 11.471013044252267,
				"lat": 43.557255587213916
			},
			{
				"lng": 11.471013718393896,
				"lat": 43.557254934545782
			},
			{
				"lng": 11.471014333266996,
				"lat": 43.557254251624052
			},
			{
				"lng": 11.4710148863126,
				"lat": 43.557253541290827
			},
			{
				"lng": 11.471015375229067,
				"lat": 43.557252806502362
			},
			{
				"lng": 11.471015797981629,
				"lat": 43.557252050316713
			},
			{
				"lng": 11.471016152810893,
				"lat": 43.557251275880944
			},
			{
				"lng": 11.471016152810893,
				"lat": 43.557251275880944
			},
			{
				"lng": 11.471019518825106,
				"lat": 43.557242245072601
			},
			{
				"lng": 11.471022268201496,
				"lat": 43.557233104506487
			},
			{
				"lng": 11.471024394246406,
				"lat": 43.557223876437355
			},
			{
				"lng": 11.471024394246406,
				"lat": 43.557223876437355
			},
			{
				"lng": 11.471025445826841,
				"lat": 43.557216927165022
			},
			{
				"lng": 11.471025889373349,
				"lat": 43.557209943383938
			},
			{
				"lng": 11.471025723100883,
				"lat": 43.557202953203159
			},
			{
				"lng": 11.471025723100885,
				"lat": 43.557202953203159
			},
			{
				"lng": 11.471025433023968,
				"lat": 43.557200290023985
			},
			{
				"lng": 11.471024923702712,
				"lat": 43.557197644305283
			},
			{
				"lng": 11.47102419697317,
				"lat": 43.55719502558447
			},
			{
				"lng": 11.471023255455115,
				"lat": 43.557192443301609
			},
			{
				"lng": 11.471022102542589,
				"lat": 43.557189906765444
			},
			{
				"lng": 11.471022102542586,
				"lat": 43.557189906765444
			},
			{
				"lng": 11.471021446071251,
				"lat": 43.557188722923577
			},
			{
				"lng": 11.471020680318048,
				"lat": 43.557187574324921
			},
			{
				"lng": 11.471019808835107,
				"lat": 43.55718646629753
			},
			{
				"lng": 11.471018835665031,
				"lat": 43.557185403981279
			},
			{
				"lng": 11.471017765322115,
				"lat": 43.557184392303938
			},
			{
				"lng": 11.471016602771423,
				"lat": 43.557183435958521
			},
			{
				"lng": 11.471015353405726,
				"lat": 43.557182539381195
			},
			{
				"lng": 11.471014023020528,
				"lat": 43.557181706730994
			},
			{
				"lng": 11.471012617787149,
				"lat": 43.557180941870335
			},
			{
				"lng": 11.471011144224125,
				"lat": 43.557180248347258
			},
			{
				"lng": 11.471009609166934,
				"lat": 43.557179629378815
			},
			{
				"lng": 11.471009609166936,
				"lat": 43.557179629378815
			},
			{
				"lng": 11.470997479060001,
				"lat": 43.557175478125622
			},
			{
				"lng": 11.47098500520835,
				"lat": 43.557171906043578
			},
			{
				"lng": 11.47097223983226,
				"lat": 43.557168928086803
			},
			{
				"lng": 11.470959236372416,
				"lat": 43.557166556722088
			},
			{
				"lng": 11.470959236372416,
				"lat": 43.557166556722088
			},
			{
				"lng": 11.470937784854103,
				"lat": 43.557163729197207
			},
			{
				"lng": 11.470916118554673,
				"lat": 43.557161969414302
			},
			{
				"lng": 11.470894337840656,
				"lat": 43.557161285525368
			},
			{
				"lng": 11.470872543608573,
				"lat": 43.557161680698478
			},
			{
				"lng": 11.470872543608573,
				"lat": 43.557161680698478
			},
			{
				"lng": 11.470861704534705,
				"lat": 43.557162387472339
			},
			{
				"lng": 11.470850944726973,
				"lat": 43.557163572813174
			},
			{
				"lng": 11.470840304098298,
				"lat": 43.557165232324024
			},
			{
				"lng": 11.470829822119523,
				"lat": 43.557167359849039
			},
			{
				"lng": 11.470819537673007,
				"lat": 43.55716994749627
			},
			{
				"lng": 11.470809488908385,
				"lat": 43.557172985666973
			},
			{
				"lng": 11.470809488908385,
				"lat": 43.557172985666973
			},
			{
				"lng": 11.47079136966792,
				"lat": 43.557179251594093
			},
			{
				"lng": 11.470773598505501,
				"lat": 43.557186024274039
			},
			{
				"lng": 11.470773598505499,
				"lat": 43.557186024274039
			},
			{
				"lng": 11.470711828022759,
				"lat": 43.557211980356044
			},
			{
				"lng": 11.470711828022759,
				"lat": 43.557211980356044
			},
			{
				"lng": 11.470688254131327,
				"lat": 43.557223017379123
			},
			{
				"lng": 11.470665508358033,
				"lat": 43.557234938092947
			},
			{
				"lng": 11.470665508358033,
				"lat": 43.557234938092947
			},
			{
				"lng": 11.47064059006849,
				"lat": 43.557249405478018
			},
			{
				"lng": 11.470616615305865,
				"lat": 43.557264692868152
			}
			]
		]
	},
	"17": {
		"name": "MA02 - Lago di Castelnuovo sponda Nord-Ovest",
		"center": {
			"lat": 43.556131946380994,
			"lng": 11.46182285926279
		},
		"coords": [
			[{
				"lng": 11.460629862475495,
				"lat": 43.555249760716265
			},
			{
				"lng": 11.460511205089793,
				"lat": 43.555273399378912
			},
			{
				"lng": 11.460554992070687,
				"lat": 43.555264029273154
			},
			{
				"lng": 11.460629862475495,
				"lat": 43.555249760716265
			},
			{
				"lng": 11.46062879513909,
				"lat": 43.5552400064716
			},
			{
				"lng": 11.460626346349711,
				"lat": 43.555239310010222
			},
			{
				"lng": 11.460615070247476,
				"lat": 43.555236102967434
			},
			{
				"lng": 11.460611205967844,
				"lat": 43.555236888898129
			},
			{
				"lng": 11.46061165653223,
				"lat": 43.555232951063495
			},
			{
				"lng": 11.460605961394148,
				"lat": 43.555225643683897
			},
			{
				"lng": 11.460596470459429,
				"lat": 43.555216320135038
			},
			{
				"lng": 11.460595086941495,
				"lat": 43.555206339351408
			},
			{
				"lng": 11.460587341162906,
				"lat": 43.555194885892142
			},
			{
				"lng": 11.46059322607563,
				"lat": 43.55517514561226
			},
			{
				"lng": 11.460597095497075,
				"lat": 43.555162217981895
			},
			{
				"lng": 11.460599738987231,
				"lat": 43.555160226896817
			},
			{
				"lng": 11.460613448213318,
				"lat": 43.555149901061576
			},
			{
				"lng": 11.46062816177014,
				"lat": 43.55513883881428
			},
			{
				"lng": 11.460637058934484,
				"lat": 43.555129569492173
			},
			{
				"lng": 11.460642582093163,
				"lat": 43.555037324587097
			},
			{
				"lng": 11.460732224508448,
				"lat": 43.554971070021168
			},
			{
				"lng": 11.460723237372612,
				"lat": 43.554969190278442
			},
			{
				"lng": 11.460719237628332,
				"lat": 43.554966657807363
			},
			{
				"lng": 11.460712441814074,
				"lat": 43.554962711043061
			},
			{
				"lng": 11.460704439698867,
				"lat": 43.55495721480402
			},
			{
				"lng": 11.460702184707268,
				"lat": 43.554955113971261
			},
			{
				"lng": 11.460700141609179,
				"lat": 43.554954070621399
			},
			{
				"lng": 11.4606967291075,
				"lat": 43.554950597048595
			},
			{
				"lng": 11.460694913788785,
				"lat": 43.554949626292846
			},
			{
				"lng": 11.46067813707548,
				"lat": 43.554932057333843
			},
			{
				"lng": 11.460628243231618,
				"lat": 43.554888722999713
			},
			{
				"lng": 11.460622146911026,
				"lat": 43.554884799243077
			},
			{
				"lng": 11.460559235841572,
				"lat": 43.554885888130897
			},
			{
				"lng": 11.460552728334878,
				"lat": 43.554885594467088
			},
			{
				"lng": 11.460528644943661,
				"lat": 43.554881905028466
			},
			{
				"lng": 11.460482380676083,
				"lat": 43.554870875622328
			},
			{
				"lng": 11.460479382383177,
				"lat": 43.554869465481836
			},
			{
				"lng": 11.460466350200544,
				"lat": 43.554865441679503
			},
			{
				"lng": 11.46046162994174,
				"lat": 43.554863138157707
			},
			{
				"lng": 11.460451845351951,
				"lat": 43.554859806432638
			},
			{
				"lng": 11.460449677142853,
				"lat": 43.554858901433654
			},
			{
				"lng": 11.460417229182685,
				"lat": 43.554847130630151
			},
			{
				"lng": 11.460410064684151,
				"lat": 43.554844513014537
			},
			{
				"lng": 11.460407107581871,
				"lat": 43.554843308959718
			},
			{
				"lng": 11.460362613089117,
				"lat": 43.554829528254807
			},
			{
				"lng": 11.460339847200911,
				"lat": 43.554819969805486
			},
			{
				"lng": 11.460288717508694,
				"lat": 43.554800656486556
			},
			{
				"lng": 11.460274304686946,
				"lat": 43.554774960828205
			},
			{
				"lng": 11.460250216605163,
				"lat": 43.554736196359329
			},
			{
				"lng": 11.460215192314768,
				"lat": 43.554681179840628
			},
			{
				"lng": 11.46007399344478,
				"lat": 43.554448948812002
			},
			{
				"lng": 11.459874654813316,
				"lat": 43.554346373863659
			},
			{
				"lng": 11.45977376831201,
				"lat": 43.554301426779062
			},
			{
				"lng": 11.459658950371564,
				"lat": 43.554235601762372
			},
			{
				"lng": 11.45960268506404,
				"lat": 43.554225601059429
			},
			{
				"lng": 11.45954285964695,
				"lat": 43.554227680009269
			},
			{
				"lng": 11.459495650622742,
				"lat": 43.554233441015242
			},
			{
				"lng": 11.459464794866452,
				"lat": 43.554233273257928
			},
			{
				"lng": 11.459377033697324,
				"lat": 43.554243053528403
			},
			{
				"lng": 11.459288158008169,
				"lat": 43.554239993310588
			},
			{
				"lng": 11.459255983035575,
				"lat": 43.554235807841444
			},
			{
				"lng": 11.459208750898231,
				"lat": 43.554187988577738
			},
			{
				"lng": 11.459181834556379,
				"lat": 43.554152155301985
			},
			{
				"lng": 11.459151281843397,
				"lat": 43.554124540429058
			},
			{
				"lng": 11.459119229368349,
				"lat": 43.554082875674077
			},
			{
				"lng": 11.459114403057729,
				"lat": 43.554075881368789
			},
			{
				"lng": 11.459108912852901,
				"lat": 43.554065440834599
			},
			{
				"lng": 11.4590968221046,
				"lat": 43.554050386407305
			},
			{
				"lng": 11.459080085265821,
				"lat": 43.554032757857257
			},
			{
				"lng": 11.459060944999386,
				"lat": 43.554014465779467
			},
			{
				"lng": 11.459048568658746,
				"lat": 43.554003801908898
			},
			{
				"lng": 11.459040756952275,
				"lat": 43.55398765897143
			},
			{
				"lng": 11.459038359411402,
				"lat": 43.553980063916249
			},
			{
				"lng": 11.459023349009088,
				"lat": 43.553920985496632
			},
			{
				"lng": 11.459017860132905,
				"lat": 43.55388446869366
			},
			{
				"lng": 11.459016527793077,
				"lat": 43.553864001612347
			},
			{
				"lng": 11.458996790279325,
				"lat": 43.553814545154438
			},
			{
				"lng": 11.458983607066633,
				"lat": 43.553768482791469
			},
			{
				"lng": 11.458965610673996,
				"lat": 43.553694569116658
			},
			{
				"lng": 11.45896287714776,
				"lat": 43.553677585155157
			},
			{
				"lng": 11.458961875520474,
				"lat": 43.55361121275142
			},
			{
				"lng": 11.458961917697467,
				"lat": 43.553609469582703
			},
			{
				"lng": 11.45879963396413,
				"lat": 43.553331104255228
			},
			{
				"lng": 11.458796318030034,
				"lat": 43.553317361681131
			},
			{
				"lng": 11.458657573621506,
				"lat": 43.553045056073586
			},
			{
				"lng": 11.45861281992984,
				"lat": 43.552908512904565
			},
			{
				"lng": 11.458535971013371,
				"lat": 43.552706804596831
			},
			{
				"lng": 11.458465634948494,
				"lat": 43.552584232942095
			},
			{
				"lng": 11.458446393763168,
				"lat": 43.552551553903591
			},
			{
				"lng": 11.458428444039331,
				"lat": 43.552501695770246
			},
			{
				"lng": 11.458419901590922,
				"lat": 43.552465822317039
			},
			{
				"lng": 11.458407514423314,
				"lat": 43.552439718053769
			},
			{
				"lng": 11.458400917407481,
				"lat": 43.552420451001517
			},
			{
				"lng": 11.458379292281592,
				"lat": 43.552288428022571
			},
			{
				"lng": 11.458373431870911,
				"lat": 43.552265864300168
			},
			{
				"lng": 11.458329871696668,
				"lat": 43.552159571429982
			},
			{
				"lng": 11.458299307865236,
				"lat": 43.552102773724378
			},
			{
				"lng": 11.458070919451208,
				"lat": 43.552013064227246
			},
			{
				"lng": 11.457995076906865,
				"lat": 43.551991410012604
			},
			{
				"lng": 11.457947602221756,
				"lat": 43.551994691935299
			},
			{
				"lng": 11.457898705798726,
				"lat": 43.551994122958035
			},
			{
				"lng": 11.457865250593676,
				"lat": 43.552004620433948
			},
			{
				"lng": 11.457757212182972,
				"lat": 43.552045002324022
			},
			{
				"lng": 11.457707675381505,
				"lat": 43.552049083899689
			},
			{
				"lng": 11.457666626414358,
				"lat": 43.552058844269403
			},
			{
				"lng": 11.457606512963407,
				"lat": 43.552088692018557
			},
			{
				"lng": 11.45769582555598,
				"lat": 43.552314662946863
			},
			{
				"lng": 11.45770362912064,
				"lat": 43.55232580016181
			},
			{
				"lng": 11.457705298725633,
				"lat": 43.552337445504961
			},
			{
				"lng": 11.457706691774769,
				"lat": 43.552348787334878
			},
			{
				"lng": 11.457708666943162,
				"lat": 43.552360267292627
			},
			{
				"lng": 11.457724927132368,
				"lat": 43.552389014372153
			},
			{
				"lng": 11.457726878997185,
				"lat": 43.552403355854892
			},
			{
				"lng": 11.45773213825923,
				"lat": 43.55242471279999
			},
			{
				"lng": 11.457736369215032,
				"lat": 43.552438240318018
			},
			{
				"lng": 11.457737257272322,
				"lat": 43.552439843885658
			},
			{
				"lng": 11.457746198432316,
				"lat": 43.552458954301507
			},
			{
				"lng": 11.457749258801021,
				"lat": 43.552479657519214
			},
			{
				"lng": 11.457752411058861,
				"lat": 43.552492746407111
			},
			{
				"lng": 11.457752500019703,
				"lat": 43.552493076209686
			},
			{
				"lng": 11.457755896194518,
				"lat": 43.552505723790489
			},
			{
				"lng": 11.457763018365135,
				"lat": 43.552524887933984
			},
			{
				"lng": 11.457766941622365,
				"lat": 43.55253941056592
			},
			{
				"lng": 11.457771139358192,
				"lat": 43.552552907200493
			},
			{
				"lng": 11.45777492108579,
				"lat": 43.552566621591133
			},
			{
				"lng": 11.457780246043388,
				"lat": 43.552578974669842
			},
			{
				"lng": 11.457783251334478,
				"lat": 43.552592378291223
			},
			{
				"lng": 11.45778510528584,
				"lat": 43.552604510820871
			},
			{
				"lng": 11.457786942924384,
				"lat": 43.552615664987812
			},
			{
				"lng": 11.457788750710806,
				"lat": 43.552627156529439
			},
			{
				"lng": 11.457798356357351,
				"lat": 43.55266759452347
			},
			{
				"lng": 11.457802171968984,
				"lat": 43.552680401746414
			},
			{
				"lng": 11.457806897897566,
				"lat": 43.552693178739979
			},
			{
				"lng": 11.457815256609562,
				"lat": 43.552709059244918
			},
			{
				"lng": 11.457831389000633,
				"lat": 43.552750248266562
			},
			{
				"lng": 11.457847256504071,
				"lat": 43.552786965775134
			},
			{
				"lng": 11.45785027671182,
				"lat": 43.552793636393879
			},
			{
				"lng": 11.457866006915649,
				"lat": 43.552828591636285
			},
			{
				"lng": 11.457872979832141,
				"lat": 43.552846233471385
			},
			{
				"lng": 11.457874119215287,
				"lat": 43.552849417288584
			},
			{
				"lng": 11.457875162993721,
				"lat": 43.552852155411209
			},
			{
				"lng": 11.457883273243482,
				"lat": 43.552884334176539
			},
			{
				"lng": 11.45788362838506,
				"lat": 43.552886891004555
			},
			{
				"lng": 11.457888961582295,
				"lat": 43.55290249818858
			},
			{
				"lng": 11.457889808453992,
				"lat": 43.552907240808999
			},
			{
				"lng": 11.457894622520516,
				"lat": 43.552924117243819
			},
			{
				"lng": 11.457895666261077,
				"lat": 43.552928762162026
			},
			{
				"lng": 11.457905699581902,
				"lat": 43.552959317821021
			},
			{
				"lng": 11.457942904388322,
				"lat": 43.553044753205455
			},
			{
				"lng": 11.457943516025944,
				"lat": 43.553046140645321
			},
			{
				"lng": 11.457945167329745,
				"lat": 43.553050119271056
			},
			{
				"lng": 11.457947598285147,
				"lat": 43.55305497044872
			},
			{
				"lng": 11.457955561773341,
				"lat": 43.553075269619107
			},
			{
				"lng": 11.457970477917835,
				"lat": 43.553108647403526
			},
			{
				"lng": 11.457973630746737,
				"lat": 43.553114855725582
			},
			{
				"lng": 11.45798354373777,
				"lat": 43.553138424511026
			},
			{
				"lng": 11.457995864349778,
				"lat": 43.55316289357885
			},
			{
				"lng": 11.458003547379114,
				"lat": 43.553182437984177
			},
			{
				"lng": 11.458005180184182,
				"lat": 43.553186452735524
			},
			{
				"lng": 11.458021165038243,
				"lat": 43.553209678035742
			},
			{
				"lng": 11.458021914753221,
				"lat": 43.553210743348991
			},
			{
				"lng": 11.458051062981902,
				"lat": 43.55325030687721
			},
			{
				"lng": 11.4580555043835,
				"lat": 43.553256297823957
			},
			{
				"lng": 11.458056803665897,
				"lat": 43.553258125740861
			},
			{
				"lng": 11.458069566141099,
				"lat": 43.553275025058106
			},
			{
				"lng": 11.458071274989361,
				"lat": 43.553277427623236
			},
			{
				"lng": 11.458084637901951,
				"lat": 43.553295366068269
			},
			{
				"lng": 11.458086982811855,
				"lat": 43.553298525892103
			},
			{
				"lng": 11.458088452713106,
				"lat": 43.553300532290251
			},
			{
				"lng": 11.458098484258775,
				"lat": 43.553314623432541
			},
			{
				"lng": 11.458099378789457,
				"lat": 43.553315865405828
			},
			{
				"lng": 11.458110179483219,
				"lat": 43.553331184865527
			},
			{
				"lng": 11.458111696871118,
				"lat": 43.553333056968903
			},
			{
				"lng": 11.458123686334968,
				"lat": 43.553350734041906
			},
			{
				"lng": 11.458134084714233,
				"lat": 43.553365965525728
			},
			{
				"lng": 11.458141705215363,
				"lat": 43.55337587369791
			},
			{
				"lng": 11.458151140225008,
				"lat": 43.553390536981361
			},
			{
				"lng": 11.458163712676258,
				"lat": 43.55341283632432
			},
			{
				"lng": 11.458174376042894,
				"lat": 43.553426568009016
			},
			{
				"lng": 11.45817965707632,
				"lat": 43.553435299179924
			},
			{
				"lng": 11.458192268144849,
				"lat": 43.553460322067423
			},
			{
				"lng": 11.458199216996363,
				"lat": 43.553474350484677
			},
			{
				"lng": 11.458224897007769,
				"lat": 43.553517697986074
			},
			{
				"lng": 11.458277380499785,
				"lat": 43.553606170595359
			},
			{
				"lng": 11.458324798021664,
				"lat": 43.553686626580074
			},
			{
				"lng": 11.458351630741571,
				"lat": 43.553732218457981
			},
			{
				"lng": 11.458358385640368,
				"lat": 43.553742928208855
			},
			{
				"lng": 11.458374722828843,
				"lat": 43.553769656101913
			},
			{
				"lng": 11.458384877457807,
				"lat": 43.553786971959759
			},
			{
				"lng": 11.458393212049161,
				"lat": 43.55380182921953
			},
			{
				"lng": 11.458402510913594,
				"lat": 43.553818809167595
			},
			{
				"lng": 11.458410586662463,
				"lat": 43.553833977816439
			},
			{
				"lng": 11.458449534643423,
				"lat": 43.55390486960777
			},
			{
				"lng": 11.458459516968009,
				"lat": 43.553923012863926
			},
			{
				"lng": 11.458469128387078,
				"lat": 43.553940500453756
			},
			{
				"lng": 11.458477939482307,
				"lat": 43.553956470541074
			},
			{
				"lng": 11.458516272048969,
				"lat": 43.554019141046304
			},
			{
				"lng": 11.458562764496973,
				"lat": 43.554123779740429
			},
			{
				"lng": 11.458594980802863,
				"lat": 43.554194009656001
			},
			{
				"lng": 11.458599747176375,
				"lat": 43.554205303751871
			},
			{
				"lng": 11.458601870096214,
				"lat": 43.554209988883628
			},
			{
				"lng": 11.458594442370753,
				"lat": 43.554218796753347
			},
			{
				"lng": 11.458581080308196,
				"lat": 43.55425490960193
			},
			{
				"lng": 11.458570353504008,
				"lat": 43.554273633799227
			},
			{
				"lng": 11.458561007629669,
				"lat": 43.554290698632364
			},
			{
				"lng": 11.458548283758217,
				"lat": 43.554313283323957
			},
			{
				"lng": 11.458537694221306,
				"lat": 43.554334165432017
			},
			{
				"lng": 11.458518896758132,
				"lat": 43.554349656286327
			},
			{
				"lng": 11.458455428396897,
				"lat": 43.554395102482907
			},
			{
				"lng": 11.45843692985876,
				"lat": 43.554412799980966
			},
			{
				"lng": 11.458398529707322,
				"lat": 43.554435065471196
			},
			{
				"lng": 11.458342458065093,
				"lat": 43.554457711998523
			},
			{
				"lng": 11.458272755657342,
				"lat": 43.554483509461839
			},
			{
				"lng": 11.458180072371537,
				"lat": 43.554524095351432
			},
			{
				"lng": 11.458101018400439,
				"lat": 43.554561528454798
			},
			{
				"lng": 11.458097894509702,
				"lat": 43.554564987310094
			},
			{
				"lng": 11.458074689887644,
				"lat": 43.554590682144514
			},
			{
				"lng": 11.458054565447952,
				"lat": 43.554611447870094
			},
			{
				"lng": 11.458052056170821,
				"lat": 43.554614038160835
			},
			{
				"lng": 11.458041145795246,
				"lat": 43.554635712238507
			},
			{
				"lng": 11.458058991587235,
				"lat": 43.554639616806973
			},
			{
				"lng": 11.4581254006142,
				"lat": 43.554630990577117
			},
			{
				"lng": 11.458191875817645,
				"lat": 43.554621035450872
			},
			{
				"lng": 11.458250144206364,
				"lat": 43.554604059937468
			},
			{
				"lng": 11.458318347165283,
				"lat": 43.554589728431409
			},
			{
				"lng": 11.458443318841098,
				"lat": 43.55456988812211
			},
			{
				"lng": 11.458511231311777,
				"lat": 43.554548416582861
			},
			{
				"lng": 11.458592830004054,
				"lat": 43.554525220782921
			},
			{
				"lng": 11.458643007796935,
				"lat": 43.554509031376803
			},
			{
				"lng": 11.458666452555711,
				"lat": 43.554504525764628
			},
			{
				"lng": 11.458695039474984,
				"lat": 43.554498184421774
			},
			{
				"lng": 11.458702110198773,
				"lat": 43.554499401603763
			},
			{
				"lng": 11.458741166863131,
				"lat": 43.554506124961335
			},
			{
				"lng": 11.458837593290921,
				"lat": 43.55452964252779
			},
			{
				"lng": 11.458927909076886,
				"lat": 43.554558910929288
			},
			{
				"lng": 11.458947605848037,
				"lat": 43.554570518356726
			},
			{
				"lng": 11.458954276083114,
				"lat": 43.554563570636816
			},
			{
				"lng": 11.458972174471207,
				"lat": 43.554561045939671
			},
			{
				"lng": 11.458999026064278,
				"lat": 43.554557169545845
			},
			{
				"lng": 11.459019343651144,
				"lat": 43.554552503977895
			},
			{
				"lng": 11.45902670354188,
				"lat": 43.554550068496653
			},
			{
				"lng": 11.459026471593964,
				"lat": 43.55454898352567
			},
			{
				"lng": 11.459030824414544,
				"lat": 43.554546006914244
			},
			{
				"lng": 11.459049174827037,
				"lat": 43.554536076857204
			},
			{
				"lng": 11.459056858169999,
				"lat": 43.55452839913427
			},
			{
				"lng": 11.459061598708901,
				"lat": 43.554524805112898
			},
			{
				"lng": 11.459067836223619,
				"lat": 43.554520807963627
			},
			{
				"lng": 11.459106247605972,
				"lat": 43.554540459971271
			},
			{
				"lng": 11.459137697607929,
				"lat": 43.554573353851673
			},
			{
				"lng": 11.459165778861653,
				"lat": 43.554610564615544
			},
			{
				"lng": 11.45918058115474,
				"lat": 43.554631069668822
			},
			{
				"lng": 11.459188851694957,
				"lat": 43.554630438823366
			},
			{
				"lng": 11.459193865442401,
				"lat": 43.554630343846235
			},
			{
				"lng": 11.459221490209519,
				"lat": 43.554628934858556
			},
			{
				"lng": 11.459224187058719,
				"lat": 43.55462878522971
			},
			{
				"lng": 11.459226272238025,
				"lat": 43.554628557403923
			},
			{
				"lng": 11.459247105661179,
				"lat": 43.554628276416402
			},
			{
				"lng": 11.459252241369688,
				"lat": 43.554654381540693
			},
			{
				"lng": 11.459253530548207,
				"lat": 43.554670697815062
			},
			{
				"lng": 11.459267287606586,
				"lat": 43.554669016162059
			},
			{
				"lng": 11.459269995201725,
				"lat": 43.554667947854902
			},
			{
				"lng": 11.459338053181568,
				"lat": 43.554656580643865
			},
			{
				"lng": 11.459366844997977,
				"lat": 43.554653593648787
			},
			{
				"lng": 11.459433911066554,
				"lat": 43.554646658278948
			},
			{
				"lng": 11.459473791022727,
				"lat": 43.554660389706328
			},
			{
				"lng": 11.459533602045871,
				"lat": 43.554685696189487
			},
			{
				"lng": 11.459569478129129,
				"lat": 43.554723032314911
			},
			{
				"lng": 11.459589411876435,
				"lat": 43.554753863988545
			},
			{
				"lng": 11.459612827043482,
				"lat": 43.554805828898516
			},
			{
				"lng": 11.459625503473697,
				"lat": 43.55484201548007
			},
			{
				"lng": 11.459634054250429,
				"lat": 43.55484650423918
			},
			{
				"lng": 11.459644132476356,
				"lat": 43.55485253494745
			},
			{
				"lng": 11.459653178247178,
				"lat": 43.554856012072136
			},
			{
				"lng": 11.459682668321788,
				"lat": 43.554865935496025
			},
			{
				"lng": 11.459718905076269,
				"lat": 43.554880921287015
			},
			{
				"lng": 11.459727605266565,
				"lat": 43.554892648622001
			},
			{
				"lng": 11.459751674092431,
				"lat": 43.554925259543907
			},
			{
				"lng": 11.459744797199086,
				"lat": 43.554928998155944
			},
			{
				"lng": 11.459736841901012,
				"lat": 43.554933237743249
			},
			{
				"lng": 11.459729412917502,
				"lat": 43.554938129050967
			},
			{
				"lng": 11.459728879857343,
				"lat": 43.554938488103993
			},
			{
				"lng": 11.459718249585819,
				"lat": 43.554945397602332
			},
			{
				"lng": 11.459704735738006,
				"lat": 43.554956357920005
			},
			{
				"lng": 11.459705681565147,
				"lat": 43.554963531296913
			},
			{
				"lng": 11.459713584731087,
				"lat": 43.55497101921874
			},
			{
				"lng": 11.459719523512403,
				"lat": 43.554974341315315
			},
			{
				"lng": 11.459749678683854,
				"lat": 43.554996094448867
			},
			{
				"lng": 11.459751846115784,
				"lat": 43.554997307447074
			},
			{
				"lng": 11.459765715982076,
				"lat": 43.55500508483852
			},
			{
				"lng": 11.459780614691256,
				"lat": 43.555012373812055
			},
			{
				"lng": 11.459800193612091,
				"lat": 43.555020822893162
			},
			{
				"lng": 11.459806762930997,
				"lat": 43.555023335328038
			},
			{
				"lng": 11.459822963424845,
				"lat": 43.555030260275899
			},
			{
				"lng": 11.459844656244528,
				"lat": 43.555039081524555
			},
			{
				"lng": 11.459871558301137,
				"lat": 43.555049246032731
			},
			{
				"lng": 11.459871588226608,
				"lat": 43.555049260514622
			},
			{
				"lng": 11.45987317679424,
				"lat": 43.55504908504431
			},
			{
				"lng": 11.459878804233803,
				"lat": 43.555048317642267
			},
			{
				"lng": 11.459938071604288,
				"lat": 43.555036302797696
			},
			{
				"lng": 11.459980662371262,
				"lat": 43.555059522436245
			},
			{
				"lng": 11.459975572323712,
				"lat": 43.555063947254148
			},
			{
				"lng": 11.459973086552068,
				"lat": 43.555068429490497
			},
			{
				"lng": 11.459972961853151,
				"lat": 43.555068734128142
			},
			{
				"lng": 11.459969443290065,
				"lat": 43.555070709481967
			},
			{
				"lng": 11.459964679793368,
				"lat": 43.555073487101104
			},
			{
				"lng": 11.459964626525217,
				"lat": 43.55507372386333
			},
			{
				"lng": 11.45996386860873,
				"lat": 43.555095236467217
			},
			{
				"lng": 11.459977492056845,
				"lat": 43.555105189344033
			},
			{
				"lng": 11.460014259630604,
				"lat": 43.555128175605184
			},
			{
				"lng": 11.460028165609344,
				"lat": 43.555134266268112
			},
			{
				"lng": 11.460045996949292,
				"lat": 43.555141474106257
			},
			{
				"lng": 11.460162214028236,
				"lat": 43.555174733333686
			},
			{
				"lng": 11.46019305795688,
				"lat": 43.555182974329632
			},
			{
				"lng": 11.460214002878445,
				"lat": 43.555186374142977
			},
			{
				"lng": 11.460242835087495,
				"lat": 43.555191120752667
			},
			{
				"lng": 11.460260721389071,
				"lat": 43.555195371158703
			},
			{
				"lng": 11.460271870876838,
				"lat": 43.55519448078261
			},
			{
				"lng": 11.460292840366979,
				"lat": 43.555204014195361
			},
			{
				"lng": 11.460294177828052,
				"lat": 43.555204430928782
			},
			{
				"lng": 11.460317097799296,
				"lat": 43.555209313282241
			},
			{
				"lng": 11.460320377583711,
				"lat": 43.555210355213426
			},
			{
				"lng": 11.460325952443016,
				"lat": 43.555210862356823
			},
			{
				"lng": 11.460341851744751,
				"lat": 43.555211547155906
			},
			{
				"lng": 11.460358635512975,
				"lat": 43.555207155152722
			},
			{
				"lng": 11.460373434318683,
				"lat": 43.555202568823319
			},
			{
				"lng": 11.460396033668079,
				"lat": 43.555202241945523
			},
			{
				"lng": 11.460400107538113,
				"lat": 43.555200812527104
			},
			{
				"lng": 11.460419921616255,
				"lat": 43.555201891674265
			},
			{
				"lng": 11.460407817005706,
				"lat": 43.55522308201185
			},
			{
				"lng": 11.460398590655295,
				"lat": 43.555240261154211
			},
			{
				"lng": 11.460397351797868,
				"lat": 43.555247281939927
			},
			{
				"lng": 11.460475376728168,
				"lat": 43.555280536998453
			},
			{
				"lng": 11.460469916445899,
				"lat": 43.555312252419398
			},
			{
				"lng": 11.460469151990324,
				"lat": 43.555346093838295
			},
			{
				"lng": 11.460475221815368,
				"lat": 43.555373700380635
			},
			{
				"lng": 11.460485300526207,
				"lat": 43.555392287419885
			},
			{
				"lng": 11.460559189098982,
				"lat": 43.555485659258252
			},
			{
				"lng": 11.460575566449075,
				"lat": 43.555587076063333
			},
			{
				"lng": 11.460604690485001,
				"lat": 43.55568077291781
			},
			{
				"lng": 11.460602311366115,
				"lat": 43.555701635982153
			},
			{
				"lng": 11.460444100360355,
				"lat": 43.555692095939733
			},
			{
				"lng": 11.460417327629981,
				"lat": 43.555690478429796
			},
			{
				"lng": 11.460403576052647,
				"lat": 43.555689648972049
			},
			{
				"lng": 11.460401202153347,
				"lat": 43.555694641314645
			},
			{
				"lng": 11.460396371956557,
				"lat": 43.555701546582114
			},
			{
				"lng": 11.460395399348771,
				"lat": 43.555702937025615
			},
			{
				"lng": 11.460397807910601,
				"lat": 43.555711818551565
			},
			{
				"lng": 11.460403707638447,
				"lat": 43.555719800333677
			},
			{
				"lng": 11.460410807247133,
				"lat": 43.555729405439415
			},
			{
				"lng": 11.460405479783812,
				"lat": 43.555738374060205
			},
			{
				"lng": 11.46040474773628,
				"lat": 43.555739606439502
			},
			{
				"lng": 11.460401052292397,
				"lat": 43.555745874839992
			},
			{
				"lng": 11.460399710250401,
				"lat": 43.555748151279708
			},
			{
				"lng": 11.460399497569254,
				"lat": 43.555748614443011
			},
			{
				"lng": 11.460395054081987,
				"lat": 43.555758291181739
			},
			{
				"lng": 11.460394797569769,
				"lat": 43.55575884979735
			},
			{
				"lng": 11.460392671164175,
				"lat": 43.555770187353197
			},
			{
				"lng": 11.460391433082233,
				"lat": 43.555776788548826
			},
			{
				"lng": 11.460389751073398,
				"lat": 43.555779838878919
			},
			{
				"lng": 11.460386423746694,
				"lat": 43.55578587299896
			},
			{
				"lng": 11.460386253316647,
				"lat": 43.555786171872917
			},
			{
				"lng": 11.460381397239829,
				"lat": 43.555794687710261
			},
			{
				"lng": 11.460375275223333,
				"lat": 43.55580380962121
			},
			{
				"lng": 11.460372359980845,
				"lat": 43.555808727647154
			},
			{
				"lng": 11.460361865552585,
				"lat": 43.55582643178348
			},
			{
				"lng": 11.460357061405832,
				"lat": 43.555832801727917
			},
			{
				"lng": 11.460346670510058,
				"lat": 43.555839089371368
			},
			{
				"lng": 11.460334739730921,
				"lat": 43.555844347740695
			},
			{
				"lng": 11.460325278828851,
				"lat": 43.555847630663173
			},
			{
				"lng": 11.460314556905356,
				"lat": 43.555848523264331
			},
			{
				"lng": 11.460298617539005,
				"lat": 43.555859288555375
			},
			{
				"lng": 11.460285505394566,
				"lat": 43.555863505425535
			},
			{
				"lng": 11.460269444293614,
				"lat": 43.555871295389252
			},
			{
				"lng": 11.460268303532066,
				"lat": 43.555871828671911
			},
			{
				"lng": 11.460258249102894,
				"lat": 43.555876528910609
			},
			{
				"lng": 11.460252833861107,
				"lat": 43.555879139494174
			},
			{
				"lng": 11.460232682271956,
				"lat": 43.555887017965901
			},
			{
				"lng": 11.460231199160321,
				"lat": 43.555893010285125
			},
			{
				"lng": 11.460221367980983,
				"lat": 43.555933124135478
			},
			{
				"lng": 11.460222732197735,
				"lat": 43.555937137386962
			},
			{
				"lng": 11.460241167832615,
				"lat": 43.555947460192513
			},
			{
				"lng": 11.460247673517379,
				"lat": 43.55595643178723
			},
			{
				"lng": 11.460251508269272,
				"lat": 43.555964416464654
			},
			{
				"lng": 11.460252130982028,
				"lat": 43.555974392563833
			},
			{
				"lng": 11.460254338344988,
				"lat": 43.555977616503789
			},
			{
				"lng": 11.460257354569643,
				"lat": 43.555982022310836
			},
			{
				"lng": 11.460258412160183,
				"lat": 43.555999032571734
			},
			{
				"lng": 11.460263733255061,
				"lat": 43.556009042574374
			},
			{
				"lng": 11.460264521004087,
				"lat": 43.556021704498718
			},
			{
				"lng": 11.460263744159775,
				"lat": 43.55603157947855
			},
			{
				"lng": 11.460263441610669,
				"lat": 43.556035425378937
			},
			{
				"lng": 11.460260712274307,
				"lat": 43.556049549577992
			},
			{
				"lng": 11.460259998271278,
				"lat": 43.556051276085689
			},
			{
				"lng": 11.460254748365656,
				"lat": 43.55606397120463
			},
			{
				"lng": 11.460251853283005,
				"lat": 43.5560789507132
			},
			{
				"lng": 11.460236791997653,
				"lat": 43.556091185838355
			},
			{
				"lng": 11.460203795302801,
				"lat": 43.556122269884767
			},
			{
				"lng": 11.460191237118705,
				"lat": 43.55613564229391
			},
			{
				"lng": 11.460186621467889,
				"lat": 43.556138416455781
			},
			{
				"lng": 11.460176849346519,
				"lat": 43.556144289829014
			},
			{
				"lng": 11.46017403761866,
				"lat": 43.556145797010558
			},
			{
				"lng": 11.460166431001714,
				"lat": 43.556149874414722
			},
			{
				"lng": 11.460149926597815,
				"lat": 43.55616127848792
			},
			{
				"lng": 11.46012955304519,
				"lat": 43.556175356023608
			},
			{
				"lng": 11.460126884880808,
				"lat": 43.556177199647351
			},
			{
				"lng": 11.460105611665917,
				"lat": 43.556191898811619
			},
			{
				"lng": 11.460102597369785,
				"lat": 43.556193981600416
			},
			{
				"lng": 11.460099083128537,
				"lat": 43.55619640983624
			},
			{
				"lng": 11.460087028293824,
				"lat": 43.556202029193933
			},
			{
				"lng": 11.460082355700816,
				"lat": 43.556203772543732
			},
			{
				"lng": 11.46007008892858,
				"lat": 43.55620834928925
			},
			{
				"lng": 11.460041743427112,
				"lat": 43.556216106099015
			},
			{
				"lng": 11.460022275735156,
				"lat": 43.556226788773095
			},
			{
				"lng": 11.460009323466318,
				"lat": 43.556233896179123
			},
			{
				"lng": 11.459997687853182,
				"lat": 43.556240281083113
			},
			{
				"lng": 11.45999243299304,
				"lat": 43.556246766388469
			},
			{
				"lng": 11.45998152877147,
				"lat": 43.556260223869366
			},
			{
				"lng": 11.459970560208694,
				"lat": 43.556273760750273
			},
			{
				"lng": 11.459961663063599,
				"lat": 43.556284741180427
			},
			{
				"lng": 11.459958475051582,
				"lat": 43.556287201141039
			},
			{
				"lng": 11.459946712096412,
				"lat": 43.556296277768894
			},
			{
				"lng": 11.459937050541805,
				"lat": 43.556303732893923
			},
			{
				"lng": 11.459935594679893,
				"lat": 43.556305270086497
			},
			{
				"lng": 11.459929334250139,
				"lat": 43.556311880199125
			},
			{
				"lng": 11.459919777232274,
				"lat": 43.556321971030812
			},
			{
				"lng": 11.459910918569042,
				"lat": 43.556327445507023
			},
			{
				"lng": 11.459895812803346,
				"lat": 43.55633678056347
			},
			{
				"lng": 11.45989005119486,
				"lat": 43.556341632232488
			},
			{
				"lng": 11.459878393564287,
				"lat": 43.556351448752743
			},
			{
				"lng": 11.459876131815047,
				"lat": 43.556353836769475
			},
			{
				"lng": 11.459869756886098,
				"lat": 43.556360567592506
			},
			{
				"lng": 11.459865474397924,
				"lat": 43.556366536820178
			},
			{
				"lng": 11.459858907692819,
				"lat": 43.556375689944538
			},
			{
				"lng": 11.459854422521961,
				"lat": 43.556378690481701
			},
			{
				"lng": 11.45983925611106,
				"lat": 43.556388836664667
			},
			{
				"lng": 11.459834992262923,
				"lat": 43.556391689137044
			},
			{
				"lng": 11.459828421398218,
				"lat": 43.556400089734169
			},
			{
				"lng": 11.459824094620656,
				"lat": 43.556405621351026
			},
			{
				"lng": 11.459821116748005,
				"lat": 43.556412451170516
			},
			{
				"lng": 11.459818851954857,
				"lat": 43.556417645524746
			},
			{
				"lng": 11.459815742847638,
				"lat": 43.55642546757425
			},
			{
				"lng": 11.459814425659287,
				"lat": 43.556428781422838
			},
			{
				"lng": 11.459812166545783,
				"lat": 43.556434465013247
			},
			{
				"lng": 11.45980805151731,
				"lat": 43.556441945837747
			},
			{
				"lng": 11.459801819654183,
				"lat": 43.556453274911149
			},
			{
				"lng": 11.459796916463366,
				"lat": 43.556462188551855
			},
			{
				"lng": 11.459796727378327,
				"lat": 43.556462852691226
			},
			{
				"lng": 11.459794322600475,
				"lat": 43.556471299194442
			},
			{
				"lng": 11.459793333831167,
				"lat": 43.556474772131111
			},
			{
				"lng": 11.459793260063265,
				"lat": 43.556477752587334
			},
			{
				"lng": 11.459793156061917,
				"lat": 43.55648195456925
			},
			{
				"lng": 11.459793119300697,
				"lat": 43.556483439838225
			},
			{
				"lng": 11.459793115517787,
				"lat": 43.556483592679662
			},
			{
				"lng": 11.459793111916923,
				"lat": 43.556483738165895
			},
			{
				"lng": 11.459793108485275,
				"lat": 43.556483876815406
			},
			{
				"lng": 11.459793105211197,
				"lat": 43.556484009099016
			},
			{
				"lng": 11.459793093484896,
				"lat": 43.556484482878147
			},
			{
				"lng": 11.459792714417565,
				"lat": 43.556499798391727
			},
			{
				"lng": 11.459794705570532,
				"lat": 43.556507824567589
			},
			{
				"lng": 11.459795722640658,
				"lat": 43.556532816053313
			},
			{
				"lng": 11.459812282370759,
				"lat": 43.556560057471842
			},
			{
				"lng": 11.459833339681113,
				"lat": 43.556582473381354
			},
			{
				"lng": 11.459836170698583,
				"lat": 43.556586456206936
			},
			{
				"lng": 11.459854186856854,
				"lat": 43.55661180227969
			},
			{
				"lng": 11.459885815000042,
				"lat": 43.556640422817203
			},
			{
				"lng": 11.459904493602833,
				"lat": 43.556656696333349
			},
			{
				"lng": 11.459924614316193,
				"lat": 43.556668174093552
			},
			{
				"lng": 11.459941326021502,
				"lat": 43.556692470291814
			},
			{
				"lng": 11.459953361902903,
				"lat": 43.556706504436058
			},
			{
				"lng": 11.459969009160188,
				"lat": 43.556728798631873
			},
			{
				"lng": 11.459988396532443,
				"lat": 43.556770546094405
			},
			{
				"lng": 11.459998941286676,
				"lat": 43.556788185864754
			},
			{
				"lng": 11.460014224067532,
				"lat": 43.556813584691277
			},
			{
				"lng": 11.460029145436639,
				"lat": 43.556818027742473
			},
			{
				"lng": 11.460052344811883,
				"lat": 43.556824674946093
			},
			{
				"lng": 11.46006409012244,
				"lat": 43.556831568718664
			},
			{
				"lng": 11.460071936170907,
				"lat": 43.556855341312414
			},
			{
				"lng": 11.460102117409562,
				"lat": 43.556872558352801
			},
			{
				"lng": 11.460121086756414,
				"lat": 43.556895971738122
			},
			{
				"lng": 11.460130780829642,
				"lat": 43.556916845447873
			},
			{
				"lng": 11.460155809269684,
				"lat": 43.55694024768642
			},
			{
				"lng": 11.460171228203535,
				"lat": 43.556952898951693
			},
			{
				"lng": 11.460179652176747,
				"lat": 43.556958673486797
			},
			{
				"lng": 11.460203887836437,
				"lat": 43.556970658198409
			},
			{
				"lng": 11.460317349673302,
				"lat": 43.556961664469782
			},
			{
				"lng": 11.46032522933281,
				"lat": 43.556945705210723
			},
			{
				"lng": 11.460325671467247,
				"lat": 43.556944809722779
			},
			{
				"lng": 11.460332216749203,
				"lat": 43.556944668806487
			},
			{
				"lng": 11.460344920399599,
				"lat": 43.556934866783585
			},
			{
				"lng": 11.4603472182943,
				"lat": 43.556933780499058
			},
			{
				"lng": 11.460349484265629,
				"lat": 43.55693270930562
			},
			{
				"lng": 11.460352741169453,
				"lat": 43.556931169668204
			},
			{
				"lng": 11.460357046897945,
				"lat": 43.556929134219132
			},
			{
				"lng": 11.460362403410642,
				"lat": 43.556926602031986
			},
			{
				"lng": 11.460368729408586,
				"lat": 43.556923611538998
			},
			{
				"lng": 11.460373641388882,
				"lat": 43.556921289494973
			},
			{
				"lng": 11.460375853813682,
				"lat": 43.556920243613703
			},
			{
				"lng": 11.460381878627748,
				"lat": 43.556917395498225
			},
			{
				"lng": 11.460382525341311,
				"lat": 43.556917223089059
			},
			{
				"lng": 11.460383542079105,
				"lat": 43.556916952034094
			},
			{
				"lng": 11.46039141334586,
				"lat": 43.556914853610635
			},
			{
				"lng": 11.460398452872914,
				"lat": 43.556912976922462
			},
			{
				"lng": 11.460403751781351,
				"lat": 43.556911564270557
			},
			{
				"lng": 11.46040538083076,
				"lat": 43.556911305612836
			},
			{
				"lng": 11.460412101674164,
				"lat": 43.556910238488442
			},
			{
				"lng": 11.46041862065195,
				"lat": 43.556909203415515
			},
			{
				"lng": 11.460424946724292,
				"lat": 43.556908198971421
			},
			{
				"lng": 11.460429788786898,
				"lat": 43.556907430155867
			},
			{
				"lng": 11.460431164660388,
				"lat": 43.556907002467163
			},
			{
				"lng": 11.460437565312343,
				"lat": 43.556905012831628
			},
			{
				"lng": 11.460443921906529,
				"lat": 43.556903036890922
			},
			{
				"lng": 11.460450234896349,
				"lat": 43.556901074504133
			},
			{
				"lng": 11.460452431739039,
				"lat": 43.556900391617553
			},
			{
				"lng": 11.460452653168987,
				"lat": 43.556900261538239
			},
			{
				"lng": 11.46046000459542,
				"lat": 43.556895942931703
			},
			{
				"lng": 11.46046266853225,
				"lat": 43.556894377997729
			},
			{
				"lng": 11.460472426199756,
				"lat": 43.556888645839088
			},
			{
				"lng": 11.460490074043822,
				"lat": 43.556878300672892
			},
			{
				"lng": 11.460521880547507,
				"lat": 43.556854984826096
			},
			{
				"lng": 11.460539299147094,
				"lat": 43.556840316553441
			},
			{
				"lng": 11.460553566538451,
				"lat": 43.556828694071733
			},
			{
				"lng": 11.460572524693498,
				"lat": 43.556811610290261
			},
			{
				"lng": 11.460606065102949,
				"lat": 43.556790638990897
			},
			{
				"lng": 11.460643981967415,
				"lat": 43.556756471395289
			},
			{
				"lng": 11.460667127532954,
				"lat": 43.556741679788686
			},
			{
				"lng": 11.46067987952012,
				"lat": 43.556733067414925
			},
			{
				"lng": 11.460700473478012,
				"lat": 43.556715948839319
			},
			{
				"lng": 11.460727856143881,
				"lat": 43.556704639066361
			},
			{
				"lng": 11.460754929990657,
				"lat": 43.556693457046308
			},
			{
				"lng": 11.460755238199193,
				"lat": 43.556693329750182
			},
			{
				"lng": 11.460784062894433,
				"lat": 43.556677224652567
			},
			{
				"lng": 11.460802111252299,
				"lat": 43.556678027185619
			},
			{
				"lng": 11.460823571748223,
				"lat": 43.5566590875302
			},
			{
				"lng": 11.460824245331743,
				"lat": 43.556658493068369
			},
			{
				"lng": 11.460829472080105,
				"lat": 43.556653442009406
			},
			{
				"lng": 11.460839329697063,
				"lat": 43.556643915738654
			},
			{
				"lng": 11.460843154901633,
				"lat": 43.55664021911052
			},
			{
				"lng": 11.460855210114484,
				"lat": 43.556645262654818
			},
			{
				"lng": 11.460864815335162,
				"lat": 43.556649281193373
			},
			{
				"lng": 11.4608693740551,
				"lat": 43.55664646398408
			},
			{
				"lng": 11.460883934401066,
				"lat": 43.556637465941918
			},
			{
				"lng": 11.460896766942057,
				"lat": 43.556629535649662
			},
			{
				"lng": 11.461008220683432,
				"lat": 43.556648887536667
			},
			{
				"lng": 11.461079857212649,
				"lat": 43.556661325834533
			},
			{
				"lng": 11.461086322891354,
				"lat": 43.55666486449789
			},
			{
				"lng": 11.461096608923917,
				"lat": 43.556670494037689
			},
			{
				"lng": 11.461098793854029,
				"lat": 43.556674423225893
			},
			{
				"lng": 11.461101686870862,
				"lat": 43.556679625774741
			},
			{
				"lng": 11.461105444820282,
				"lat": 43.556686383741365
			},
			{
				"lng": 11.461179122459818,
				"lat": 43.556746139015253
			},
			{
				"lng": 11.461318887087105,
				"lat": 43.556739555301839
			},
			{
				"lng": 11.461337399188388,
				"lat": 43.556729628065412
			},
			{
				"lng": 11.461365265736836,
				"lat": 43.556730218591845
			},
			{
				"lng": 11.461395932670767,
				"lat": 43.556727175712417
			},
			{
				"lng": 11.461433307261277,
				"lat": 43.556719938974929
			},
			{
				"lng": 11.461466592162745,
				"lat": 43.556716839687816
			},
			{
				"lng": 11.461504308674797,
				"lat": 43.55671554118932
			},
			{
				"lng": 11.461548484784471,
				"lat": 43.556714446706316
			},
			{
				"lng": 11.461575398923848,
				"lat": 43.556715773033119
			},
			{
				"lng": 11.461583497025289,
				"lat": 43.556715204847812
			},
			{
				"lng": 11.4615856876833,
				"lat": 43.556715051145034
			},
			{
				"lng": 11.461593507130074,
				"lat": 43.556715944017839
			},
			{
				"lng": 11.461617280360358,
				"lat": 43.556718658588785
			},
			{
				"lng": 11.461635660537826,
				"lat": 43.556719056716112
			},
			{
				"lng": 11.461653122546247,
				"lat": 43.556719434952555
			},
			{
				"lng": 11.461667678020858,
				"lat": 43.55672142094528
			},
			{
				"lng": 11.461695531650264,
				"lat": 43.556725221372687
			},
			{
				"lng": 11.461721945929051,
				"lat": 43.556730369660194
			},
			{
				"lng": 11.461772855379884,
				"lat": 43.556744092515267
			},
			{
				"lng": 11.461807856730937,
				"lat": 43.556750961412746
			},
			{
				"lng": 11.461874232725645,
				"lat": 43.55677216251545
			},
			{
				"lng": 11.461914547630839,
				"lat": 43.556780822974133
			},
			{
				"lng": 11.461953956746136,
				"lat": 43.556783308900073
			},
			{
				"lng": 11.461966770009207,
				"lat": 43.556789875826198
			},
			{
				"lng": 11.461978423384723,
				"lat": 43.556795848295749
			},
			{
				"lng": 11.461995092308218,
				"lat": 43.556804391278817
			},
			{
				"lng": 11.462007484063284,
				"lat": 43.556810742168821
			},
			{
				"lng": 11.462054669584349,
				"lat": 43.556811154909894
			},
			{
				"lng": 11.462094519157445,
				"lat": 43.556808390747491
			},
			{
				"lng": 11.462100866421665,
				"lat": 43.55681085015047
			},
			{
				"lng": 11.462125494155345,
				"lat": 43.556820392763704
			},
			{
				"lng": 11.462129464271966,
				"lat": 43.556821931080968
			},
			{
				"lng": 11.462140938983325,
				"lat": 43.556820176559448
			},
			{
				"lng": 11.462154855837111,
				"lat": 43.556818048624557
			},
			{
				"lng": 11.462181998152451,
				"lat": 43.556808868035652
			},
			{
				"lng": 11.462184343480903,
				"lat": 43.556808074753789
			},
			{
				"lng": 11.462202093476316,
				"lat": 43.556800366530332
			},
			{
				"lng": 11.462226570045303,
				"lat": 43.556807779083208
			},
			{
				"lng": 11.462253499649202,
				"lat": 43.556815934511746
			},
			{
				"lng": 11.462282596938904,
				"lat": 43.556813929116494
			},
			{
				"lng": 11.46231088791899,
				"lat": 43.556812781123831
			},
			{
				"lng": 11.462341751506987,
				"lat": 43.556817365297356
			},
			{
				"lng": 11.462366912622764,
				"lat": 43.556821102475027
			},
			{
				"lng": 11.462387858315756,
				"lat": 43.556820651149948
			},
			{
				"lng": 11.462409309032802,
				"lat": 43.556826891421309
			},
			{
				"lng": 11.462408000765191,
				"lat": 43.556832948327404
			},
			{
				"lng": 11.462404407454519,
				"lat": 43.556849584326152
			},
			{
				"lng": 11.462403907913796,
				"lat": 43.556851897055935
			},
			{
				"lng": 11.462403119731759,
				"lat": 43.55685582725927
			},
			{
				"lng": 11.462402755339728,
				"lat": 43.556857983871552
			},
			{
				"lng": 11.462401721636395,
				"lat": 43.556860384443866
			},
			{
				"lng": 11.462399463761047,
				"lat": 43.556865825408728
			},
			{
				"lng": 11.462397195892525,
				"lat": 43.556871505933913
			},
			{
				"lng": 11.462394922237953,
				"lat": 43.556877436674611
			},
			{
				"lng": 11.462394561188747,
				"lat": 43.556878419505857
			},
			{
				"lng": 11.462396897208812,
				"lat": 43.556879818138249
			},
			{
				"lng": 11.462397660803649,
				"lat": 43.556880261871811
			},
			{
				"lng": 11.462399721609689,
				"lat": 43.556881459429349
			},
			{
				"lng": 11.462402578675212,
				"lat": 43.556883070541197
			},
			{
				"lng": 11.462405389303171,
				"lat": 43.556884608188149
			},
			{
				"lng": 11.462405467795776,
				"lat": 43.556884651130133
			},
			{
				"lng": 11.462408388354847,
				"lat": 43.556886200858806
			},
			{
				"lng": 11.462411339729311,
				"lat": 43.556887719396506
			},
			{
				"lng": 11.462414321289318,
				"lat": 43.556889206419299
			},
			{
				"lng": 11.462417332398715,
				"lat": 43.556890661609863
			},
			{
				"lng": 11.462420372414957,
				"lat": 43.556892084657591
			},
			{
				"lng": 11.462423440689365,
				"lat": 43.55689347525891
			},
			{
				"lng": 11.462426536567222,
				"lat": 43.55689483311712
			},
			{
				"lng": 11.462429659387979,
				"lat": 43.556896157942454
			},
			{
				"lng": 11.462432808485216,
				"lat": 43.556897449452109
			},
			{
				"lng": 11.462435983186968,
				"lat": 43.556898707370678
			},
			{
				"lng": 11.462439182815872,
				"lat": 43.556899931429605
			},
			{
				"lng": 11.462442406689123,
				"lat": 43.556901121367765
			},
			{
				"lng": 11.46244565411884,
				"lat": 43.556902276931247
			},
			{
				"lng": 11.462445782502245,
				"lat": 43.556902320936601
			},
			{
				"lng": 11.462448847096637,
				"lat": 43.556903519469365
			},
			{
				"lng": 11.462452065967144,
				"lat": 43.556904730683421
			},
			{
				"lng": 11.462455230186332,
				"lat": 43.55690589818883
			},
			{
				"lng": 11.462474166202448,
				"lat": 43.556912885028382
			},
			{
				"lng": 11.462493074635223,
				"lat": 43.556919861685699
			},
			{
				"lng": 11.462496266443774,
				"lat": 43.55692103936898
			},
			{
				"lng": 11.462499462909129,
				"lat": 43.556922218770346
			},
			{
				"lng": 11.462518366690759,
				"lat": 43.556929193705081
			},
			{
				"lng": 11.46253044825546,
				"lat": 43.556933651441589
			},
			{
				"lng": 11.462537345787002,
				"lat": 43.55693599658094
			},
			{
				"lng": 11.462540613916882,
				"lat": 43.556937107734775
			},
			{
				"lng": 11.462543883802248,
				"lat": 43.556938219485325
			},
			{
				"lng": 11.462563038383813,
				"lat": 43.556944731978888
			},
			{
				"lng": 11.462582182685589,
				"lat": 43.556951240972751
			},
			{
				"lng": 11.462585462856401,
				"lat": 43.556952356218559
			},
			{
				"lng": 11.462588744789164,
				"lat": 43.556953472063313
			},
			{
				"lng": 11.462607887334327,
				"lat": 43.556959980453591
			},
			{
				"lng": 11.462626297807121,
				"lat": 43.556966239937736
			},
			{
				"lng": 11.462627007654378,
				"lat": 43.55696650415927
			},
			{
				"lng": 11.462630247370535,
				"lat": 43.556967710056377
			},
			{
				"lng": 11.462633492143466,
				"lat": 43.55696891783559
			},
			{
				"lng": 11.462634262936048,
				"lat": 43.556969204742337
			},
			{
				"lng": 11.462636354613107,
				"lat": 43.556969970501846
			},
			{
				"lng": 11.462652504943312,
				"lat": 43.556975607191845
			},
			{
				"lng": 11.462655539748731,
				"lat": 43.556976666380805
			},
			{
				"lng": 11.462656064857292,
				"lat": 43.556976849650873
			},
			{
				"lng": 11.462659371996043,
				"lat": 43.556977980511832
			},
			{
				"lng": 11.462662704544497,
				"lat": 43.556979073458422
			},
			{
				"lng": 11.462666061623677,
				"lat": 43.556980128149632
			},
			{
				"lng": 11.462669442344472,
				"lat": 43.556981144256859
			},
			{
				"lng": 11.462672845808026,
				"lat": 43.556982121464081
			},
			{
				"lng": 11.462676271106009,
				"lat": 43.556983059468017
			},
			{
				"lng": 11.462679717321246,
				"lat": 43.556983957978346
			},
			{
				"lng": 11.462683183527799,
				"lat": 43.556984816717815
			},
			{
				"lng": 11.462686668791806,
				"lat": 43.556985635422414
			},
			{
				"lng": 11.462690172171486,
				"lat": 43.55698641384167
			},
			{
				"lng": 11.462693692717837,
				"lat": 43.556987151738433
			},
			{
				"lng": 11.46269722947496,
				"lat": 43.556987848889499
			},
			{
				"lng": 11.462700781480541,
				"lat": 43.556988505085336
			},
			{
				"lng": 11.462704347766294,
				"lat": 43.556989120130453
			},
			{
				"lng": 11.462707927358361,
				"lat": 43.556989693843256
			},
			{
				"lng": 11.462711519277875,
				"lat": 43.556990226056513
			},
			{
				"lng": 11.462715122541336,
				"lat": 43.556990716617008
			},
			{
				"lng": 11.462718736160996,
				"lat": 43.556991165386002
			},
			{
				"lng": 11.462722359145548,
				"lat": 43.556991572239063
			},
			{
				"lng": 11.462725990500413,
				"lat": 43.556991937066236
			},
			{
				"lng": 11.462729629228257,
				"lat": 43.556992259772038
			},
			{
				"lng": 11.462733269704392,
				"lat": 43.556992561255953
			},
			{
				"lng": 11.462754220305495,
				"lat": 43.556994296265628
			},
			{
				"lng": 11.462757859016225,
				"lat": 43.556994597602525
			},
			{
				"lng": 11.462778811384029,
				"lat": 43.556996332753876
			},
			{
				"lng": 11.462799766761806,
				"lat": 43.556998068150492
			},
			{
				"lng": 11.462803402464228,
				"lat": 43.556998369236794
			},
			{
				"lng": 11.462807078521996,
				"lat": 43.556998673664971
			},
			{
				"lng": 11.4628279935457,
				"lat": 43.557000405714383
			},
			{
				"lng": 11.462830723561034,
				"lat": 43.55700063179664
			},
			{
				"lng": 11.462831897916175,
				"lat": 43.557000729049079
			},
			{
				"lng": 11.462852584628648,
				"lat": 43.557002442186615
			},
			{
				"lng": 11.462855303809286,
				"lat": 43.557002667371009
			},
			{
				"lng": 11.46285673879564,
				"lat": 43.557002786206958
			},
			{
				"lng": 11.462877175712986,
				"lat": 43.557004478653539
			},
			{
				"lng": 11.462879634223366,
				"lat": 43.557004682250415
			},
			{
				"lng": 11.462881603986302,
				"lat": 43.557004845372511
			},
			{
				"lng": 11.462896221720726,
				"lat": 43.557006055911046
			},
			{
				"lng": 11.462901771252509,
				"lat": 43.557006487888401
			},
			{
				"lng": 11.462903700581254,
				"lat": 43.557006638067861
			},
			{
				"lng": 11.462906503838797,
				"lat": 43.557006856274178
			},
			{
				"lng": 11.462926382090904,
				"lat": 43.557008403600605
			},
			{
				"lng": 11.46292749055517,
				"lat": 43.557008489883529
			},
			{
				"lng": 11.462931434406176,
				"lat": 43.557008796873134
			},
			{
				"lng": 11.462945530214631,
				"lat": 43.557009894090349
			},
			{
				"lng": 11.46295098482593,
				"lat": 43.557010368854733
			},
			{
				"lng": 11.462951858734554,
				"lat": 43.557010444918916
			},
			{
				"lng": 11.462954813654635,
				"lat": 43.557010793036561
			},
			{
				"lng": 11.462956387973096,
				"lat": 43.557010978506199
			},
			{
				"lng": 11.462973790462984,
				"lat": 43.557013028682924
			},
			{
				"lng": 11.462975453485594,
				"lat": 43.557013153745821
			},
			{
				"lng": 11.462977776221726,
				"lat": 43.557013328420489
			},
			{
				"lng": 11.462981316418626,
				"lat": 43.557013594650662
			},
			{
				"lng": 11.463000074817533,
				"lat": 43.557015005319563
			},
			{
				"lng": 11.463000494498536,
				"lat": 43.557015036880372
			},
			{
				"lng": 11.463004383987462,
				"lat": 43.557015329377293
			},
			{
				"lng": 11.463006387749353,
				"lat": 43.557015480063882
			},
			{
				"lng": 11.463024696150756,
				"lat": 43.557016856887998
			},
			{
				"lng": 11.463026611479915,
				"lat": 43.557017000923977
			},
			{
				"lng": 11.463030557534754,
				"lat": 43.557017297673802
			},
			{
				"lng": 11.463031512488104,
				"lat": 43.557017369487838
			},
			{
				"lng": 11.463041748393774,
				"lat": 43.557018139244043
			},
			{
				"lng": 11.463046697606364,
				"lat": 43.557018870922292
			},
			{
				"lng": 11.463049265623516,
				"lat": 43.5570190254967
			},
			{
				"lng": 11.463052204874714,
				"lat": 43.557019202416434
			},
			{
				"lng": 11.463056193828397,
				"lat": 43.557019442519795
			},
			{
				"lng": 11.463056672811781,
				"lat": 43.557019471350785
			},
			{
				"lng": 11.463073946820032,
				"lat": 43.557020511107481
			},
			{
				"lng": 11.46308205171017,
				"lat": 43.557020998955913
			},
			{
				"lng": 11.463098628017789,
				"lat": 43.557021996712933
			},
			{
				"lng": 11.463101033882879,
				"lat": 43.557022141525948
			},
			{
				"lng": 11.463103760871173,
				"lat": 43.557022305667864
			},
			{
				"lng": 11.463107845304153,
				"lat": 43.557022551516496
			},
			{
				"lng": 11.463123309216392,
				"lat": 43.557023482312978
			},
			{
				"lng": 11.463134424975168,
				"lat": 43.55702415138618
			},
			{
				"lng": 11.463146549623364,
				"lat": 43.557024881184596
			},
			{
				"lng": 11.463147992259193,
				"lat": 43.557024956639381
			},
			{
				"lng": 11.463152279581454,
				"lat": 43.557025180880913
			},
			{
				"lng": 11.463165694453357,
				"lat": 43.557025882523199
			},
			{
				"lng": 11.463175845358652,
				"lat": 43.5570274092048
			},
			{
				"lng": 11.463186030151606,
				"lat": 43.557028940982022
			},
			{
				"lng": 11.463200092436079,
				"lat": 43.557031055926373
			},
			{
				"lng": 11.463200830275255,
				"lat": 43.557031166896103
			},
			{
				"lng": 11.463202848999456,
				"lat": 43.557031470508747
			},
			{
				"lng": 11.463204699636778,
				"lat": 43.557031800897114
			},
			{
				"lng": 11.463208803479935,
				"lat": 43.557032533543072
			},
			{
				"lng": 11.463213158344921,
				"lat": 43.557033311002968
			},
			{
				"lng": 11.4632147427752,
				"lat": 43.557033593866116
			},
			{
				"lng": 11.46322415313937,
				"lat": 43.557035273867079
			},
			{
				"lng": 11.463226588133615,
				"lat": 43.557035708578276
			},
			{
				"lng": 11.463230524093474,
				"lat": 43.557036411251737
			},
			{
				"lng": 11.46323468301814,
				"lat": 43.557037153730079
			},
			{
				"lng": 11.463239064129208,
				"lat": 43.557037935874497
			},
			{
				"lng": 11.463243069014171,
				"lat": 43.557038650852412
			},
			{
				"lng": 11.463248189939373,
				"lat": 43.557039565072763
			},
			{
				"lng": 11.46324865847293,
				"lat": 43.557039648718366
			},
			{
				"lng": 11.463260190661469,
				"lat": 43.557041707517513
			},
			{
				"lng": 11.463267030292323,
				"lat": 43.557042928571036
			},
			{
				"lng": 11.463270894249302,
				"lat": 43.557046293510439
			},
			{
				"lng": 11.46327151042613,
				"lat": 43.557046830110018
			},
			{
				"lng": 11.46327911549883,
				"lat": 43.557053453010482
			},
			{
				"lng": 11.463280379897217,
				"lat": 43.557054535469902
			},
			{
				"lng": 11.463281562344855,
				"lat": 43.557055601763217
			},
			{
				"lng": 11.463284025790754,
				"lat": 43.557057750282077
			},
			{
				"lng": 11.463284070106878,
				"lat": 43.55705778766896
			},
			{
				"lng": 11.463286638592431,
				"lat": 43.557059795677191
			},
			{
				"lng": 11.463289303484848,
				"lat": 43.557061808393144
			},
			{
				"lng": 11.463292017965641,
				"lat": 43.557063789029783
			},
			{
				"lng": 11.463294781283491,
				"lat": 43.557065736844564
			},
			{
				"lng": 11.463297592662059,
				"lat": 43.557067651105335
			},
			{
				"lng": 11.463300451300594,
				"lat": 43.557069531091031
			},
			{
				"lng": 11.463301040993546,
				"lat": 43.557069905602752
			},
			{
				"lng": 11.463303356373862,
				"lat": 43.557071376091905
			},
			{
				"lng": 11.463306307032806,
				"lat": 43.557073185410438
			},
			{
				"lng": 11.463309302404671,
				"lat": 43.557074958361603
			},
			{
				"lng": 11.463320707934781,
				"lat": 43.557081590320493
			},
			{
				"lng": 11.463325654416627,
				"lat": 43.557084466544069
			},
			{
				"lng": 11.463328655665228,
				"lat": 43.557086211675454
			},
			{
				"lng": 11.463332411360053,
				"lat": 43.557088395493302
			},
			{
				"lng": 11.463334497002712,
				"lat": 43.557089608228438
			},
			{
				"lng": 11.463337763947946,
				"lat": 43.55709147196086
			},
			{
				"lng": 11.463341080039916,
				"lat": 43.557093292390427
			},
			{
				"lng": 11.463344444122965,
				"lat": 43.557095068729573
			},
			{
				"lng": 11.463345066728257,
				"lat": 43.557095384784596
			},
			{
				"lng": 11.463347855012961,
				"lat": 43.557096800209948
			},
			{
				"lng": 11.463351311497913,
				"lat": 43.557098486082957
			},
			{
				"lng": 11.463354812338736,
				"lat": 43.557100125620615
			},
			{
				"lng": 11.463357017101531,
				"lat": 43.557101137143277
			},
			{
				"lng": 11.463362693629536,
				"lat": 43.557103741475885
			},
			{
				"lng": 11.463370093093062,
				"lat": 43.557107136272897
			},
			{
				"lng": 11.46337449122883,
				"lat": 43.557111111162058
			},
			{
				"lng": 11.463378190513318,
				"lat": 43.557114369082797
			},
			{
				"lng": 11.463382647738829,
				"lat": 43.557118194739907
			},
			{
				"lng": 11.463385033276104,
				"lat": 43.557120242257298
			},
			{
				"lng": 11.463388659162746,
				"lat": 43.557123354371633
			},
			{
				"lng": 11.463391900567633,
				"lat": 43.557126136483326
			},
			{
				"lng": 11.463394231851,
				"lat": 43.557128137433509
			},
			{
				"lng": 11.463402785157125,
				"lat": 43.557135478770221
			},
			{
				"lng": 11.463403510077578,
				"lat": 43.557136100972265
			},
			{
				"lng": 11.463407008959258,
				"lat": 43.55713910407556
			},
			{
				"lng": 11.463410273195857,
				"lat": 43.557141905781691
			},
			{
				"lng": 11.463418959494604,
				"lat": 43.557149361261686
			},
			{
				"lng": 11.463423244408331,
				"lat": 43.557153039016974
			},
			{
				"lng": 11.463425812562903,
				"lat": 43.557155206018287
			},
			{
				"lng": 11.46342782464836,
				"lat": 43.557156847068299
			},
			{
				"lng": 11.463428432926307,
				"lat": 43.557157343177757
			},
			{
				"lng": 11.463431104837284,
				"lat": 43.557159449732019
			},
			{
				"lng": 11.46343315119192,
				"lat": 43.557161009386199
			},
			{
				"lng": 11.463433839278451,
				"lat": 43.557161515562647
			},
			{
				"lng": 11.463436658864973,
				"lat": 43.557163519784261
			},
			{
				"lng": 11.463436983175621,
				"lat": 43.557163742524232
			},
			{
				"lng": 11.463439526927914,
				"lat": 43.557165489599939
			},
			{
				"lng": 11.463441306419719,
				"lat": 43.557166670376269
			},
			{
				"lng": 11.463442442626048,
				"lat": 43.557167424302413
			},
			{
				"lng": 11.463445397457972,
				"lat": 43.557169318302357
			},
			{
				"lng": 11.463448413446562,
				"lat": 43.557171185603856
			},
			{
				"lng": 11.463451466771277,
				"lat": 43.557173010854456
			},
			{
				"lng": 11.463453047890178,
				"lat": 43.557173923293838
			},
			{
				"lng": 11.463454564136748,
				"lat": 43.557174798296344
			},
			{
				"lng": 11.463457704589347,
				"lat": 43.557176547291284
			},
			{
				"lng": 11.463459966605702,
				"lat": 43.557177762625052
			},
			{
				"lng": 11.463460887154321,
				"lat": 43.557178257216385
			},
			{
				"lng": 11.463464110836419,
				"lat": 43.557179927464361
			},
			{
				"lng": 11.463467374620489,
				"lat": 43.557181557443975
			},
			{
				"lng": 11.463470677471991,
				"lat": 43.557183146580741
			},
			{
				"lng": 11.463474018337658,
				"lat": 43.557184694316753
			},
			{
				"lng": 11.46347739614607,
				"lat": 43.557186200111651
			},
			{
				"lng": 11.463480809808305,
				"lat": 43.557187663442811
			},
			{
				"lng": 11.463484258218601,
				"lat": 43.557189083805433
			},
			{
				"lng": 11.463493816213342,
				"lat": 43.557192941617338
			},
			{
				"lng": 11.463503382913112,
				"lat": 43.557195419541017
			},
			{
				"lng": 11.463506994612489,
				"lat": 43.55719635502696
			},
			{
				"lng": 11.463510590088436,
				"lat": 43.557197286310561
			},
			{
				"lng": 11.463530597444436,
				"lat": 43.55720246852141
			},
			{
				"lng": 11.46355069508045,
				"lat": 43.557207674111673
			},
			{
				"lng": 11.46355420028134,
				"lat": 43.557208582010993
			},
			{
				"lng": 11.463560399609934,
				"lat": 43.557210187729311
			},
			{
				"lng": 11.463561472921151,
				"lat": 43.557210465732815
			},
			{
				"lng": 11.463565098660595,
				"lat": 43.557211378863542
			},
			{
				"lng": 11.46356873871952,
				"lat": 43.557212243979308
			},
			{
				"lng": 11.463572391695369,
				"lat": 43.55721306111564
			},
			{
				"lng": 11.463576056196571,
				"lat": 43.557213830332408
			},
			{
				"lng": 11.463579730843566,
				"lat": 43.557214551713074
			},
			{
				"lng": 11.463583414269564,
				"lat": 43.557215225364132
			},
			{
				"lng": 11.463585098604144,
				"lat": 43.557215511064811
			},
			{
				"lng": 11.463788951736802,
				"lat": 43.557055675972222
			},
			{
				"lng": 11.464403600463983,
				"lat": 43.557181029918084
			},
			{
				"lng": 11.464603514139634,
				"lat": 43.557241300729039
			},
			{
				"lng": 11.464814966902152,
				"lat": 43.557313965206667
			},
			{
				"lng": 11.464873786602491,
				"lat": 43.557334178142909
			},
			{
				"lng": 11.464979893889824,
				"lat": 43.557370640981155
			},
			{
				"lng": 11.465040617354843,
				"lat": 43.557391508002034
			},
			{
				"lng": 11.465047405369175,
				"lat": 43.557391361579249
			},
			{
				"lng": 11.465062575596889,
				"lat": 43.557398695014712
			},
			{
				"lng": 11.465097697822328,
				"lat": 43.557411202821548
			},
			{
				"lng": 11.465112926927837,
				"lat": 43.557415397931798
			},
			{
				"lng": 11.465162560141207,
				"lat": 43.557445031428159
			},
			{
				"lng": 11.465190576941515,
				"lat": 43.557467249191596
			},
			{
				"lng": 11.465206964103912,
				"lat": 43.557473666657536
			},
			{
				"lng": 11.465246743290635,
				"lat": 43.557495431814942
			},
			{
				"lng": 11.465248867276044,
				"lat": 43.557496067480344
			},
			{
				"lng": 11.465267039763129,
				"lat": 43.557507628627519
			},
			{
				"lng": 11.465276429405447,
				"lat": 43.557521004675777
			},
			{
				"lng": 11.465291957750974,
				"lat": 43.557530674942029
			},
			{
				"lng": 11.465350026885005,
				"lat": 43.557571444285927
			},
			{
				"lng": 11.465349590611776,
				"lat": 43.557594466105137
			},
			{
				"lng": 11.465346200455889,
				"lat": 43.557612548705883
			},
			{
				"lng": 11.465344819556851,
				"lat": 43.557626871811571
			},
			{
				"lng": 11.465339932953544,
				"lat": 43.557641985433442
			},
			{
				"lng": 11.465330882301954,
				"lat": 43.557656188046657
			},
			{
				"lng": 11.46532292033611,
				"lat": 43.557663363177298
			},
			{
				"lng": 11.46531657171027,
				"lat": 43.557676364039821
			},
			{
				"lng": 11.465306513040854,
				"lat": 43.55769959344385
			},
			{
				"lng": 11.4653072877577,
				"lat": 43.55771858640459
			},
			{
				"lng": 11.46530660548185,
				"lat": 43.557750046307746
			},
			{
				"lng": 11.465327515403082,
				"lat": 43.557756741736377
			},
			{
				"lng": 11.465341581193719,
				"lat": 43.557764299518794
			},
			{
				"lng": 11.465361436773156,
				"lat": 43.557778879365664
			},
			{
				"lng": 11.465374092858895,
				"lat": 43.557785609692857
			},
			{
				"lng": 11.465389784396377,
				"lat": 43.557799278527405
			},
			{
				"lng": 11.465404223284926,
				"lat": 43.557815976276714
			},
			{
				"lng": 11.465412689740287,
				"lat": 43.557830801642218
			},
			{
				"lng": 11.465423004506755,
				"lat": 43.557847588362918
			},
			{
				"lng": 11.465434694254499,
				"lat": 43.557864344788179
			},
			{
				"lng": 11.465440506300823,
				"lat": 43.557886373940377
			},
			{
				"lng": 11.465466217879259,
				"lat": 43.557909581635407
			},
			{
				"lng": 11.465483521056216,
				"lat": 43.557924216077083
			},
			{
				"lng": 11.46550246727327,
				"lat": 43.557930954109693
			},
			{
				"lng": 11.465551489806275,
				"lat": 43.557938234055953
			},
			{
				"lng": 11.465562493835616,
				"lat": 43.55794299931425
			},
			{
				"lng": 11.465582539608715,
				"lat": 43.557942566818056
			},
			{
				"lng": 11.465640833031594,
				"lat": 43.557966322549554
			},
			{
				"lng": 11.465648084629523,
				"lat": 43.557975456729224
			},
			{
				"lng": 11.465691634366239,
				"lat": 43.557989108060895
			},
			{
				"lng": 11.4657263389166,
				"lat": 43.557996696862588
			},
			{
				"lng": 11.465724782938615,
				"lat": 43.558006735512244
			},
			{
				"lng": 11.465800119043667,
				"lat": 43.558070858897217
			},
			{
				"lng": 11.465840550559998,
				"lat": 43.558078324720775
			},
			{
				"lng": 11.465872051000572,
				"lat": 43.558077645006705
			},
			{
				"lng": 11.465905782943425,
				"lat": 43.558085493065995
			},
			{
				"lng": 11.465925828758603,
				"lat": 43.558085060508496
			},
			{
				"lng": 11.465965495512554,
				"lat": 43.55807378206768
			},
			{
				"lng": 11.466005333074856,
				"lat": 43.558066669046653
			},
			{
				"lng": 11.46601451941331,
				"lat": 43.558075047016487
			},
			{
				"lng": 11.466023764004051,
				"lat": 43.558084852600665
			},
			{
				"lng": 11.466448923176852,
				"lat": 43.558144171699496
			},
			{
				"lng": 11.466841855281404,
				"lat": 43.558119792228517
			},
			{
				"lng": 11.466944929794327,
				"lat": 43.558124517068606
			},
			{
				"lng": 11.466988793247918,
				"lat": 43.558129860046876
			},
			{
				"lng": 11.467025927608615,
				"lat": 43.558136985857622
			},
			{
				"lng": 11.467055734118164,
				"lat": 43.558144483806423
			},
			{
				"lng": 11.467051669226144,
				"lat": 43.55813994957095
			},
			{
				"lng": 11.467050297194616,
				"lat": 43.558139021448348
			},
			{
				"lng": 11.467034232154253,
				"lat": 43.558126015633476
			},
			{
				"lng": 11.467027569134745,
				"lat": 43.558113321320711
			},
			{
				"lng": 11.467018684607901,
				"lat": 43.558107084410757
			},
			{
				"lng": 11.467013883530463,
				"lat": 43.55809956685443
			},
			{
				"lng": 11.467011261866904,
				"lat": 43.558087357959579
			},
			{
				"lng": 11.467043417462325,
				"lat": 43.558028990466667
			},
			{
				"lng": 11.467065902092299,
				"lat": 43.557924061152832
			},
			{
				"lng": 11.467067955724543,
				"lat": 43.557871521149657
			},
			{
				"lng": 11.46707348664607,
				"lat": 43.557822272433611
			},
			{
				"lng": 11.467067153825212,
				"lat": 43.557828330307913
			},
			{
				"lng": 11.467042198572004,
				"lat": 43.557842057328912
			},
			{
				"lng": 11.466997659308561,
				"lat": 43.557842243923126
			},
			{
				"lng": 11.466982299008631,
				"lat": 43.557838832764602
			},
			{
				"lng": 11.466974134352599,
				"lat": 43.557830953183306
			},
			{
				"lng": 11.466969942761693,
				"lat": 43.557830001586886
			},
			{
				"lng": 11.46696779895853,
				"lat": 43.557825733363806
			},
			{
				"lng": 11.46695308279493,
				"lat": 43.557816137281399
			},
			{
				"lng": 11.466925179059688,
				"lat": 43.557804474676487
			},
			{
				"lng": 11.466906196701899,
				"lat": 43.557795106604765
			},
			{
				"lng": 11.466902911262968,
				"lat": 43.557792881114594
			},
			{
				"lng": 11.46689009549099,
				"lat": 43.557791125634211
			},
			{
				"lng": 11.466882715221129,
				"lat": 43.557792246322506
			},
			{
				"lng": 11.466873784045589,
				"lat": 43.557796077975887
			},
			{
				"lng": 11.466870162294656,
				"lat": 43.557797708236059
			},
			{
				"lng": 11.466854513401254,
				"lat": 43.557817195305113
			},
			{
				"lng": 11.466846048120157,
				"lat": 43.557831064435931
			},
			{
				"lng": 11.466804357354107,
				"lat": 43.557817522102113
			},
			{
				"lng": 11.46680238093753,
				"lat": 43.557817564765436
			},
			{
				"lng": 11.466791769511079,
				"lat": 43.557809053422851
			},
			{
				"lng": 11.466779270008725,
				"lat": 43.557799911947328
			},
			{
				"lng": 11.466757979196684,
				"lat": 43.557795263867753
			},
			{
				"lng": 11.466755670395196,
				"lat": 43.557794484956048
			},
			{
				"lng": 11.466754507692075,
				"lat": 43.557793855969464
			},
			{
				"lng": 11.466750709313297,
				"lat": 43.557791757794696
			},
			{
				"lng": 11.466734689388229,
				"lat": 43.557784492799946
			},
			{
				"lng": 11.466729138853891,
				"lat": 43.557781233317598
			},
			{
				"lng": 11.466729876304687,
				"lat": 43.557774164620078
			},
			{
				"lng": 11.466727660487468,
				"lat": 43.557773078757585
			},
			{
				"lng": 11.466723456633213,
				"lat": 43.557773721180304
			},
			{
				"lng": 11.466698661242649,
				"lat": 43.557760965116913
			},
			{
				"lng": 11.466693065743854,
				"lat": 43.557760284474931
			},
			{
				"lng": 11.466674039767394,
				"lat": 43.557749478710576
			},
			{
				"lng": 11.466671710296573,
				"lat": 43.557748577957433
			},
			{
				"lng": 11.466661096352368,
				"lat": 43.55774607096491
			},
			{
				"lng": 11.466658943764386,
				"lat": 43.55774489321599
			},
			{
				"lng": 11.466648501240844,
				"lat": 43.557742259282037
			},
			{
				"lng": 11.466638473663808,
				"lat": 43.557739408517783
			},
			{
				"lng": 11.46662533344664,
				"lat": 43.557739692145532
			},
			{
				"lng": 11.466617261356451,
				"lat": 43.557737854532625
			},
			{
				"lng": 11.466607272870307,
				"lat": 43.557736983253989
			},
			{
				"lng": 11.466587238312664,
				"lat": 43.557741529156637
			},
			{
				"lng": 11.4665757159656,
				"lat": 43.557741646279666
			},
			{
				"lng": 11.466556458091672,
				"lat": 43.557730956280203
			},
			{
				"lng": 11.466541718540277,
				"lat": 43.557729142253621
			},
			{
				"lng": 11.466516728653657,
				"lat": 43.557732954923665
			},
			{
				"lng": 11.466507604290666,
				"lat": 43.557729983640925
			},
			{
				"lng": 11.466502642999217,
				"lat": 43.557729979804492
			},
			{
				"lng": 11.466495775321683,
				"lat": 43.557732196465849
			},
			{
				"lng": 11.466496664937626,
				"lat": 43.557728463953232
			},
			{
				"lng": 11.466456976724885,
				"lat": 43.557716789378823
			},
			{
				"lng": 11.466441777373594,
				"lat": 43.557723061550277
			},
			{
				"lng": 11.46641868498457,
				"lat": 43.557712773035583
			},
			{
				"lng": 11.46639513253732,
				"lat": 43.557701216042489
			},
			{
				"lng": 11.466379781050161,
				"lat": 43.557684065501988
			},
			{
				"lng": 11.466379576562861,
				"lat": 43.557679054469212
			},
			{
				"lng": 11.466392676688724,
				"lat": 43.557659686518832
			},
			{
				"lng": 11.466398429108477,
				"lat": 43.557641037724011
			},
			{
				"lng": 11.466422932560638,
				"lat": 43.557601687754449
			},
			{
				"lng": 11.466420749151256,
				"lat": 43.557489086328822
			},
			{
				"lng": 11.466395886505126,
				"lat": 43.557463654312166
			},
			{
				"lng": 11.466343448912355,
				"lat": 43.557432198878253
			},
			{
				"lng": 11.466306150843879,
				"lat": 43.557416175598355
			},
			{
				"lng": 11.466196220959766,
				"lat": 43.557395322369821
			},
			{
				"lng": 11.466129615599476,
				"lat": 43.557393403218086
			},
			{
				"lng": 11.466078997525054,
				"lat": 43.557403942647923
			},
			{
				"lng": 11.466078765632156,
				"lat": 43.557403899114917
			},
			{
				"lng": 11.46607861811354,
				"lat": 43.557403868520531
			},
			{
				"lng": 11.466077259966296,
				"lat": 43.557402086544101
			},
			{
				"lng": 11.466067151156965,
				"lat": 43.557395372080826
			},
			{
				"lng": 11.466062776725964,
				"lat": 43.55739438094713
			},
			{
				"lng": 11.466057152138488,
				"lat": 43.557392495701187
			},
			{
				"lng": 11.466050126201619,
				"lat": 43.557389524130585
			},
			{
				"lng": 11.466045997670525,
				"lat": 43.557387736882575
			},
			{
				"lng": 11.466041808073896,
				"lat": 43.557386908480666
			},
			{
				"lng": 11.466035208232839,
				"lat": 43.557388428823224
			},
			{
				"lng": 11.466039068613229,
				"lat": 43.557353221356763
			},
			{
				"lng": 11.46603500743057,
				"lat": 43.557339152182472
			},
			{
				"lng": 11.466022320201986,
				"lat": 43.557311852825165
			},
			{
				"lng": 11.4659963023286,
				"lat": 43.557267423849744
			},
			{
				"lng": 11.465988396908465,
				"lat": 43.557259368292257
			},
			{
				"lng": 11.465977271327803,
				"lat": 43.557252469871948
			},
			{
				"lng": 11.46596058769795,
				"lat": 43.557212618156377
			},
			{
				"lng": 11.465924126846682,
				"lat": 43.557188179189112
			},
			{
				"lng": 11.465877483992895,
				"lat": 43.557164304680761
			},
			{
				"lng": 11.465820976226954,
				"lat": 43.557135840492748
			},
			{
				"lng": 11.465806203937449,
				"lat": 43.557127890125301
			},
			{
				"lng": 11.465724678144131,
				"lat": 43.557074625546157
			},
			{
				"lng": 11.465696915370264,
				"lat": 43.557058479568177
			},
			{
				"lng": 11.465696855547231,
				"lat": 43.557058464731917
			},
			{
				"lng": 11.465333757237529,
				"lat": 43.556952806023872
			},
			{
				"lng": 11.465283500410376,
				"lat": 43.556932181901892
			},
			{
				"lng": 11.465259035178969,
				"lat": 43.556916277440465
			},
			{
				"lng": 11.465177181349206,
				"lat": 43.556869251324954
			},
			{
				"lng": 11.465100661875695,
				"lat": 43.556827991139414
			},
			{
				"lng": 11.4649899716647,
				"lat": 43.556779406132421
			},
			{
				"lng": 11.464931516939426,
				"lat": 43.556757271564088
			},
			{
				"lng": 11.464923260976057,
				"lat": 43.556739844558408
			},
			{
				"lng": 11.464891809192867,
				"lat": 43.556692330194998
			},
			{
				"lng": 11.464847795784802,
				"lat": 43.556642673358098
			},
			{
				"lng": 11.46482369142157,
				"lat": 43.556624737560398
			},
			{
				"lng": 11.464741787700383,
				"lat": 43.556574013285143
			},
			{
				"lng": 11.46469269467582,
				"lat": 43.556564378683319
			},
			{
				"lng": 11.46464369918133,
				"lat": 43.556555866383157
			},
			{
				"lng": 11.464596892556207,
				"lat": 43.556547032548934
			},
			{
				"lng": 11.464581093505011,
				"lat": 43.556547373283323
			},
			{
				"lng": 11.464565908764891,
				"lat": 43.556545514313129
			},
			{
				"lng": 11.464536466181723,
				"lat": 43.556540515020281
			},
			{
				"lng": 11.464515378540783,
				"lat": 43.556529659658317
			},
			{
				"lng": 11.464495590248241,
				"lat": 43.556517887565576
			},
			{
				"lng": 11.464465687999873,
				"lat": 43.556501974202561
			},
			{
				"lng": 11.464443864248725,
				"lat": 43.556490931047207
			},
			{
				"lng": 11.464443801653092,
				"lat": 43.556489395848466
			},
			{
				"lng": 11.464378424558006,
				"lat": 43.556490805718767
			},
			{
				"lng": 11.464369200144301,
				"lat": 43.556482188348411
			},
			{
				"lng": 11.464342643896742,
				"lat": 43.556459035601684
			},
			{
				"lng": 11.464307634188529,
				"lat": 43.556433791761634
			},
			{
				"lng": 11.464246483632477,
				"lat": 43.556403281590626
			},
			{
				"lng": 11.464184683168902,
				"lat": 43.556382199371647
			},
			{
				"lng": 11.464115826269493,
				"lat": 43.556367364059483
			},
			{
				"lng": 11.464044848310627,
				"lat": 43.556359984061693
			},
			{
				"lng": 11.464002660436046,
				"lat": 43.556359522329451
			},
			{
				"lng": 11.463967339594795,
				"lat": 43.556382670596605
			},
			{
				"lng": 11.463927152608154,
				"lat": 43.556365546398155
			},
			{
				"lng": 11.463837093070032,
				"lat": 43.556313725462857
			},
			{
				"lng": 11.463737575585867,
				"lat": 43.556283088345175
			},
			{
				"lng": 11.463641963795554,
				"lat": 43.556254720733456
			},
			{
				"lng": 11.463513692807982,
				"lat": 43.556209187574424
			},
			{
				"lng": 11.463455120688867,
				"lat": 43.556201546718043
			},
			{
				"lng": 11.463390251594857,
				"lat": 43.556197216453917
			},
			{
				"lng": 11.463353195778311,
				"lat": 43.556192382405783
			},
			{
				"lng": 11.463258755085208,
				"lat": 43.556189964361451
			},
			{
				"lng": 11.463187778600094,
				"lat": 43.556179916175552
			},
			{
				"lng": 11.463149302942677,
				"lat": 43.556179806392208
			},
			{
				"lng": 11.463097761732648,
				"lat": 43.556138524578365
			},
			{
				"lng": 11.463071158886592,
				"lat": 43.556050705810939
			},
			{
				"lng": 11.463053414828545,
				"lat": 43.556026010110607
			},
			{
				"lng": 11.463044756340729,
				"lat": 43.555976955389411
			},
			{
				"lng": 11.463030649714611,
				"lat": 43.555961801865955
			},
			{
				"lng": 11.463006811840431,
				"lat": 43.555921586581995
			},
			{
				"lng": 11.462974905672242,
				"lat": 43.555888469091798
			},
			{
				"lng": 11.462926116947912,
				"lat": 43.555863985412806
			},
			{
				"lng": 11.462887081013656,
				"lat": 43.555856790406722
			},
			{
				"lng": 11.46274550708711,
				"lat": 43.555831148312436
			},
			{
				"lng": 11.462723136283964,
				"lat": 43.55579344362399
			},
			{
				"lng": 11.46271142695166,
				"lat": 43.555765054348882
			},
			{
				"lng": 11.462641414737368,
				"lat": 43.55570044933021
			},
			{
				"lng": 11.462620857558788,
				"lat": 43.55568875580267
			},
			{
				"lng": 11.462576783137294,
				"lat": 43.555619612103783
			},
			{
				"lng": 11.462410414496224,
				"lat": 43.555527762586017
			},
			{
				"lng": 11.462223510096207,
				"lat": 43.555467745891271
			},
			{
				"lng": 11.462172114290084,
				"lat": 43.55545233855527
			},
			{
				"lng": 11.462160466874307,
				"lat": 43.555410217972927
			},
			{
				"lng": 11.462131225062162,
				"lat": 43.555374796440724
			},
			{
				"lng": 11.462117960447635,
				"lat": 43.555369456621321
			},
			{
				"lng": 11.462061558140325,
				"lat": 43.555375819407061
			},
			{
				"lng": 11.462078195487022,
				"lat": 43.555422809638841
			},
			{
				"lng": 11.461963876411577,
				"lat": 43.555421929942412
			},
			{
				"lng": 11.461923061525212,
				"lat": 43.555424849846943
			},
			{
				"lng": 11.461903209388474,
				"lat": 43.555431681797423
			},
			{
				"lng": 11.461859673334189,
				"lat": 43.555487426557754
			},
			{
				"lng": 11.461833446063929,
				"lat": 43.555526199432336
			},
			{
				"lng": 11.461843850279806,
				"lat": 43.555534273789249
			},
			{
				"lng": 11.461823757788398,
				"lat": 43.555536564543409
			},
			{
				"lng": 11.461819108605859,
				"lat": 43.555538851575406
			},
			{
				"lng": 11.461786451857293,
				"lat": 43.555547225563551
			},
			{
				"lng": 11.461778234911757,
				"lat": 43.555545574803048
			},
			{
				"lng": 11.46175443524128,
				"lat": 43.555549455314306
			},
			{
				"lng": 11.461752371631308,
				"lat": 43.555548778965402
			},
			{
				"lng": 11.461727833176777,
				"lat": 43.555565350143702
			},
			{
				"lng": 11.461770751388388,
				"lat": 43.555583976115493
			},
			{
				"lng": 11.461784738227358,
				"lat": 43.555591770562039
			},
			{
				"lng": 11.461804215412391,
				"lat": 43.555606854100532
			},
			{
				"lng": 11.461817600488716,
				"lat": 43.555618387334569
			},
			{
				"lng": 11.461813356483976,
				"lat": 43.555619512563169
			},
			{
				"lng": 11.461785291082384,
				"lat": 43.555641241423061
			},
			{
				"lng": 11.461768030276742,
				"lat": 43.555641403566085
			},
			{
				"lng": 11.461764870017328,
				"lat": 43.555639338322884
			},
			{
				"lng": 11.461761117310351,
				"lat": 43.555640128756728
			},
			{
				"lng": 11.461756743776707,
				"lat": 43.555635117146018
			},
			{
				"lng": 11.461741546356766,
				"lat": 43.555643316081138
			},
			{
				"lng": 11.461758074354368,
				"lat": 43.555661392425741
			},
			{
				"lng": 11.461759001375096,
				"lat": 43.555661622105596
			},
			{
				"lng": 11.461735234179445,
				"lat": 43.555664454975457
			},
			{
				"lng": 11.461722215245596,
				"lat": 43.55566396561639
			},
			{
				"lng": 11.461707956041007,
				"lat": 43.555667676146314
			},
			{
				"lng": 11.461701260438989,
				"lat": 43.555667572780031
			},
			{
				"lng": 11.461675434712875,
				"lat": 43.555670587085643
			},
			{
				"lng": 11.461675090766187,
				"lat": 43.555670465615705
			},
			{
				"lng": 11.46167449992994,
				"lat": 43.555670153551944
			},
			{
				"lng": 11.461669358981338,
				"lat": 43.555667769281769
			},
			{
				"lng": 11.461666184145315,
				"lat": 43.555667992174492
			},
			{
				"lng": 11.46165492801793,
				"lat": 43.555668782421954
			},
			{
				"lng": 11.461643773607872,
				"lat": 43.555669150120963
			},
			{
				"lng": 11.46164231734349,
				"lat": 43.555669198125841
			},
			{
				"lng": 11.461639883606818,
				"lat": 43.555663168992503
			},
			{
				"lng": 11.461638537699809,
				"lat": 43.555659834755836
			},
			{
				"lng": 11.461625703099051,
				"lat": 43.555656665665055
			},
			{
				"lng": 11.461617725809825,
				"lat": 43.555654695929825
			},
			{
				"lng": 11.46160570383123,
				"lat": 43.555651727487195
			},
			{
				"lng": 11.461603051683865,
				"lat": 43.555649184853984
			},
			{
				"lng": 11.46159808331692,
				"lat": 43.555644421643194
			},
			{
				"lng": 11.461597800110711,
				"lat": 43.555644150131272
			},
			{
				"lng": 11.461586938088947,
				"lat": 43.555636399218614
			},
			{
				"lng": 11.461581212463104,
				"lat": 43.555632313529905
			},
			{
				"lng": 11.461575123283218,
				"lat": 43.5556279684156
			},
			{
				"lng": 11.461569666694746,
				"lat": 43.555625769056689
			},
			{
				"lng": 11.461569440432585,
				"lat": 43.555625677858359
			},
			{
				"lng": 11.461565530653536,
				"lat": 43.555620165848751
			},
			{
				"lng": 11.461558653704378,
				"lat": 43.555610470717475
			},
			{
				"lng": 11.461554560305856,
				"lat": 43.555604699837488
			},
			{
				"lng": 11.46155070468598,
				"lat": 43.55559926417709
			},
			{
				"lng": 11.461550585528252,
				"lat": 43.555593808977669
			},
			{
				"lng": 11.461550504181499,
				"lat": 43.555590084813645
			},
			{
				"lng": 11.461549256401982,
				"lat": 43.555588053046705
			},
			{
				"lng": 11.461545618371654,
				"lat": 43.555582129219125
			},
			{
				"lng": 11.461545273415251,
				"lat": 43.555581567524371
			},
			{
				"lng": 11.461544406353998,
				"lat": 43.555572817787336
			},
			{
				"lng": 11.461544285606795,
				"lat": 43.555571599296385
			},
			{
				"lng": 11.46154047768165,
				"lat": 43.555564143937403
			},
			{
				"lng": 11.461539382139076,
				"lat": 43.555561999025372
			},
			{
				"lng": 11.461535633671451,
				"lat": 43.555557585990364
			},
			{
				"lng": 11.461533088484048,
				"lat": 43.555554589565233
			},
			{
				"lng": 11.461529204855806,
				"lat": 43.555551951934589
			},
			{
				"lng": 11.461525411009248,
				"lat": 43.555549375280251
			},
			{
				"lng": 11.461522971210073,
				"lat": 43.555546194163718
			},
			{
				"lng": 11.461521769848019,
				"lat": 43.555544627775333
			},
			{
				"lng": 11.461515121426601,
				"lat": 43.555542415224515
			},
			{
				"lng": 11.461510449689708,
				"lat": 43.555540860500926
			},
			{
				"lng": 11.461505119620162,
				"lat": 43.555539925015431
			},
			{
				"lng": 11.461496970592631,
				"lat": 43.55553849477149
			},
			{
				"lng": 11.46149604830121,
				"lat": 43.555537592480803
			},
			{
				"lng": 11.461489635485545,
				"lat": 43.555531318731674
			},
			{
				"lng": 11.461486281745714,
				"lat": 43.555528037719462
			},
			{
				"lng": 11.461482684491266,
				"lat": 43.555527375921649
			},
			{
				"lng": 11.461472043330259,
				"lat": 43.555525418234126
			},
			{
				"lng": 11.461471750227194,
				"lat": 43.555525414273255
			},
			{
				"lng": 11.461461372175659,
				"lat": 43.555525274028042
			},
			{
				"lng": 11.461457916194378,
				"lat": 43.555525227324935
			},
			{
				"lng": 11.461452597286087,
				"lat": 43.555521976585574
			},
			{
				"lng": 11.461448260919905,
				"lat": 43.555519326342711
			},
			{
				"lng": 11.461445824320805,
				"lat": 43.555519387585001
			},
			{
				"lng": 11.461438243394397,
				"lat": 43.555519578126265
			},
			{
				"lng": 11.461437110206763,
				"lat": 43.555519225625275
			},
			{
				"lng": 11.461432150676217,
				"lat": 43.555517682862579
			},
			{
				"lng": 11.46143022498299,
				"lat": 43.555517083836534
			},
			{
				"lng": 11.461428840197351,
				"lat": 43.555516653070789
			},
			{
				"lng": 11.461427253128244,
				"lat": 43.555516159380574
			},
			{
				"lng": 11.461420589014173,
				"lat": 43.555514438345142
			},
			{
				"lng": 11.461414892307339,
				"lat": 43.555512967146363
			},
			{
				"lng": 11.461414847923736,
				"lat": 43.555512955684073
			},
			{
				"lng": 11.46141015043696,
				"lat": 43.555512313334226
			},
			{
				"lng": 11.461407068848144,
				"lat": 43.555511891947475
			},
			{
				"lng": 11.461403449617105,
				"lat": 43.555511397041592
			},
			{
				"lng": 11.461402106069633,
				"lat": 43.555511213320365
			},
			{
				"lng": 11.461401321041878,
				"lat": 43.555510951998571
			},
			{
				"lng": 11.461396092136306,
				"lat": 43.55550921138888
			},
			{
				"lng": 11.461393006453561,
				"lat": 43.555508184219768
			},
			{
				"lng": 11.461391962630055,
				"lat": 43.555507836749378
			},
			{
				"lng": 11.461391370148625,
				"lat": 43.555507639522787
			},
			{
				"lng": 11.461390026603093,
				"lat": 43.555507192280231
			},
			{
				"lng": 11.461384981224091,
				"lat": 43.555506819498333
			},
			{
				"lng": 11.461381395985049,
				"lat": 43.55550655459993
			},
			{
				"lng": 11.461377336090006,
				"lat": 43.555506254630998
			},
			{
				"lng": 11.46137619141783,
				"lat": 43.555505921880531
			},
			{
				"lng": 11.461374018586827,
				"lat": 43.555505290249364
			},
			{
				"lng": 11.461370675524812,
				"lat": 43.555504318437706
			},
			{
				"lng": 11.461369237486149,
				"lat": 43.555503900406933
			},
			{
				"lng": 11.461369146607508,
				"lat": 43.555503873988968
			},
			{
				"lng": 11.461369109045997,
				"lat": 43.555503863070008
			},
			{
				"lng": 11.461367921091922,
				"lat": 43.555503517737613
			},
			{
				"lng": 11.46136689053589,
				"lat": 43.55550351541595
			},
			{
				"lng": 11.461359753733994,
				"lat": 43.555503499337895
			},
			{
				"lng": 11.461358103845621,
				"lat": 43.555503495620897
			},
			{
				"lng": 11.461357954874062,
				"lat": 43.555503495285279
			},
			{
				"lng": 11.461357902856577,
				"lat": 43.555503495168132
			},
			{
				"lng": 11.461345566772847,
				"lat": 43.555502549632635
			},
			{
				"lng": 11.46134386663101,
				"lat": 43.555502096808524
			},
			{
				"lng": 11.461340711001567,
				"lat": 43.555501256322664
			},
			{
				"lng": 11.461338588762102,
				"lat": 43.555500691326657
			},
			{
				"lng": 11.46133805985906,
				"lat": 43.555500550518751
			},
			{
				"lng": 11.46133278801546,
				"lat": 43.555499146140967
			},
			{
				"lng": 11.46133164930462,
				"lat": 43.555498842797256
			},
			{
				"lng": 11.461331290992252,
				"lat": 43.555498868398544
			},
			{
				"lng": 11.461317589443336,
				"lat": 43.555499847888505
			},
			{
				"lng": 11.461317447633402,
				"lat": 43.555499780877128
			},
			{
				"lng": 11.461314738474398,
				"lat": 43.555498500682177
			},
			{
				"lng": 11.461312155999702,
				"lat": 43.555497280350906
			},
			{
				"lng": 11.461311290574566,
				"lat": 43.555496871400052
			},
			{
				"lng": 11.461309990481428,
				"lat": 43.555496257049583
			},
			{
				"lng": 11.46130288186335,
				"lat": 43.55549669423759
			},
			{
				"lng": 11.461299487901416,
				"lat": 43.555496902969928
			},
			{
				"lng": 11.461293149473923,
				"lat": 43.555497292789731
			},
			{
				"lng": 11.461288526164154,
				"lat": 43.555496028538691
			},
			{
				"lng": 11.461288044700144,
				"lat": 43.555495896881609
			},
			{
				"lng": 11.461285339412452,
				"lat": 43.555494264078554
			},
			{
				"lng": 11.461279553821912,
				"lat": 43.555490772127818
			},
			{
				"lng": 11.461278521437757,
				"lat": 43.555489816350452
			},
			{
				"lng": 11.461275786087745,
				"lat": 43.555487283973456
			},
			{
				"lng": 11.461275557324248,
				"lat": 43.555487072185066
			},
			{
				"lng": 11.46127242598023,
				"lat": 43.555484172793129
			},
			{
				"lng": 11.461271661152368,
				"lat": 43.5554834646193
			},
			{
				"lng": 11.461270766965699,
				"lat": 43.555482600686091
			},
			{
				"lng": 11.461268500257571,
				"lat": 43.555480410668537
			},
			{
				"lng": 11.461267323336449,
				"lat": 43.555479273566647
			},
			{
				"lng": 11.461266209966647,
				"lat": 43.555478197865881
			},
			{
				"lng": 11.461262883357692,
				"lat": 43.555473138316778
			},
			{
				"lng": 11.461260581503046,
				"lat": 43.555469637349709
			},
			{
				"lng": 11.461260469143609,
				"lat": 43.555469466458511
			},
			{
				"lng": 11.461257953031293,
				"lat": 43.555463312659988
			},
			{
				"lng": 11.461257222964621,
				"lat": 43.55546311331922
			},
			{
				"lng": 11.46125258333459,
				"lat": 43.555461846492847
			},
			{
				"lng": 11.461252247218871,
				"lat": 43.555461754718209
			},
			{
				"lng": 11.461252042633708,
				"lat": 43.555461698857336
			},
			{
				"lng": 11.461244092543039,
				"lat": 43.555459528126654
			},
			{
				"lng": 11.461238899485465,
				"lat": 43.555458110189058
			},
			{
				"lng": 11.461233540514623,
				"lat": 43.555456646949416
			},
			{
				"lng": 11.461229710848258,
				"lat": 43.555455601278297
			},
			{
				"lng": 11.461227453934937,
				"lat": 43.555454985039439
			},
			{
				"lng": 11.461225756338738,
				"lat": 43.555454521519266
			},
			{
				"lng": 11.461221578231529,
				"lat": 43.555453380707768
			},
			{
				"lng": 11.461218277452629,
				"lat": 43.555452479446309
			},
			{
				"lng": 11.461218067016851,
				"lat": 43.555452421987866
			},
			{
				"lng": 11.461215504625992,
				"lat": 43.555451332177256
			},
			{
				"lng": 11.461213219324279,
				"lat": 43.55545036021541
			},
			{
				"lng": 11.461211578977297,
				"lat": 43.555449662559226
			},
			{
				"lng": 11.461201803861455,
				"lat": 43.555452835547619
			},
			{
				"lng": 11.461199873686445,
				"lat": 43.555453462079512
			},
			{
				"lng": 11.461193551195695,
				"lat": 43.555453400167544
			},
			{
				"lng": 11.461192813377599,
				"lat": 43.555453632958624
			},
			{
				"lng": 11.461178169089754,
				"lat": 43.555463863176072
			},
			{
				"lng": 11.461142607811416,
				"lat": 43.555476057973607
			},
			{
				"lng": 11.461070683344829,
				"lat": 43.5554875372843
			},
			{
				"lng": 11.461009582387105,
				"lat": 43.555473982006134
			},
			{
				"lng": 11.460974338302806,
				"lat": 43.555434221054597
			},
			{
				"lng": 11.460950740579825,
				"lat": 43.555394046415799
			},
			{
				"lng": 11.460888216567028,
				"lat": 43.555350670157182
			},
			{
				"lng": 11.46087837947241,
				"lat": 43.555343257685351
			},
			{
				"lng": 11.460856042109391,
				"lat": 43.555317414670355
			},
			{
				"lng": 11.460832506096983,
				"lat": 43.555291558942024
			},
			{
				"lng": 11.460784707939087,
				"lat": 43.555273544750342
			},
			{
				"lng": 11.460755630433448,
				"lat": 43.555275852830313
			},
			{
				"lng": 11.460711908216219,
				"lat": 43.555282011004287
			},
			{
				"lng": 11.460675667097668,
				"lat": 43.5552770328663
			},
			{
				"lng": 11.460629862475495,
				"lat": 43.555249760716265
			}
			],
			[{
				"lng": 11.467615824452023,
				"lat": 43.558534236352919
			},
			{
				"lng": 11.467657557739175,
				"lat": 43.558521635966379
			},
			{
				"lng": 11.467672189129068,
				"lat": 43.558530933308013
			},
			{
				"lng": 11.467691958865286,
				"lat": 43.558528100357535
			},
			{
				"lng": 11.467743521341514,
				"lat": 43.558502597629499
			},
			{
				"lng": 11.467758752136822,
				"lat": 43.558486850630615
			},
			{
				"lng": 11.467811152886549,
				"lat": 43.558395482909297
			},
			{
				"lng": 11.467783407643866,
				"lat": 43.558327868769943
			},
			{
				"lng": 11.467795079185279,
				"lat": 43.558307646995438
			},
			{
				"lng": 11.467757227303837,
				"lat": 43.558309477136739
			},
			{
				"lng": 11.467751337261188,
				"lat": 43.558305793103848
			},
			{
				"lng": 11.46773640151272,
				"lat": 43.558303310110269
			},
			{
				"lng": 11.467715030502903,
				"lat": 43.558304924063904
			},
			{
				"lng": 11.467651416223394,
				"lat": 43.558284320848443
			},
			{
				"lng": 11.467648901110502,
				"lat": 43.558281728099132
			},
			{
				"lng": 11.46764531782464,
				"lat": 43.558280051573099
			},
			{
				"lng": 11.467641351547368,
				"lat": 43.558278273473071
			},
			{
				"lng": 11.467638752101443,
				"lat": 43.558277375222325
			},
			{
				"lng": 11.467635322377902,
				"lat": 43.558277761707245
			},
			{
				"lng": 11.467583014199452,
				"lat": 43.558252158610451
			},
			{
				"lng": 11.467572955248285,
				"lat": 43.558249708045466
			},
			{
				"lng": 11.467558366804511,
				"lat": 43.558248514048266
			},
			{
				"lng": 11.467539611919669,
				"lat": 43.558254072681329
			},
			{
				"lng": 11.467518858766031,
				"lat": 43.558253353028071
			},
			{
				"lng": 11.467505784853984,
				"lat": 43.558251410535085
			},
			{
				"lng": 11.4674810952729,
				"lat": 43.558247702941451
			},
			{
				"lng": 11.467455830135025,
				"lat": 43.558247789283904
			},
			{
				"lng": 11.467432904409977,
				"lat": 43.558249985973866
			},
			{
				"lng": 11.467405883953267,
				"lat": 43.558259843102292
			},
			{
				"lng": 11.467383360257392,
				"lat": 43.558270674562408
			},
			{
				"lng": 11.467294781815854,
				"lat": 43.558235600244437
			},
			{
				"lng": 11.467286522695087,
				"lat": 43.558217978436332
			},
			{
				"lng": 11.467277420897243,
				"lat": 43.558198213956153
			},
			{
				"lng": 11.46726767743333,
				"lat": 43.558180624194037
			},
			{
				"lng": 11.467251233453384,
				"lat": 43.558162665890983
			},
			{
				"lng": 11.467232022151141,
				"lat": 43.558149098065869
			},
			{
				"lng": 11.467208502735316,
				"lat": 43.558138873550078
			},
			{
				"lng": 11.467181386051259,
				"lat": 43.558130905565299
			},
			{
				"lng": 11.467139092151015,
				"lat": 43.558116296448176
			},
			{
				"lng": 11.467119946618251,
				"lat": 43.55810433882943
			},
			{
				"lng": 11.467106945234924,
				"lat": 43.558128521693718
			},
			{
				"lng": 11.467026426532179,
				"lat": 43.558250155125947
			},
			{
				"lng": 11.467089370875776,
				"lat": 43.558272192266379
			},
			{
				"lng": 11.467113790035951,
				"lat": 43.558292629078295
			},
			{
				"lng": 11.467125040644545,
				"lat": 43.558311443218692
			},
			{
				"lng": 11.467136835394463,
				"lat": 43.558343587151768
			},
			{
				"lng": 11.467131954175199,
				"lat": 43.558374766494047
			},
			{
				"lng": 11.467123457722915,
				"lat": 43.558401048853135
			},
			{
				"lng": 11.467132556094221,
				"lat": 43.558431344935322
			},
			{
				"lng": 11.467159981346342,
				"lat": 43.558461244452133
			},
			{
				"lng": 11.467253486359308,
				"lat": 43.558504964011107
			},
			{
				"lng": 11.467293459682653,
				"lat": 43.558521252839235
			},
			{
				"lng": 11.46731873107762,
				"lat": 43.55852720796824
			},
			{
				"lng": 11.467330503456477,
				"lat": 43.558529982453187
			},
			{
				"lng": 11.467332074343437,
				"lat": 43.558530062501532
			},
			{
				"lng": 11.467356764078827,
				"lat": 43.558531320623572
			},
			{
				"lng": 11.46738771667024,
				"lat": 43.558519217741761
			},
			{
				"lng": 11.46741395608834,
				"lat": 43.558510971065786
			},
			{
				"lng": 11.467450010523299,
				"lat": 43.558504532975633
			},
			{
				"lng": 11.467497449928349,
				"lat": 43.55851113111013
			},
			{
				"lng": 11.467547276134855,
				"lat": 43.558544347255257
			},
			{
				"lng": 11.467615824452023,
				"lat": 43.558534236352919
			}
			]
		]
	},
	"18": {
		"name": "MA03 - Lago di Castelnuovo Sponda Sud-Ovest",
		"center": {
			"lat": 43.54682285024846,
			"lng": 11.462042818129751
		},
		"coords": [
			[{
				"lng": 11.463124388175839,
				"lat": 43.545647394662417
			},
			{
				"lng": 11.463123843578602,
				"lat": 43.545648054812112
			},
			{
				"lng": 11.463123583022213,
				"lat": 43.545648383002053
			},
			{
				"lng": 11.46312333451327,
				"lat": 43.54564870909217
			},
			{
				"lng": 11.46312310121623,
				"lat": 43.545649032450015
			},
			{
				"lng": 11.463122886295567,
				"lat": 43.545649352443164
			},
			{
				"lng": 11.463122692915766,
				"lat": 43.545649668439268
			},
			{
				"lng": 11.463122524241269,
				"lat": 43.545649979805745
			},
			{
				"lng": 11.46312238343657,
				"lat": 43.545650285910277
			},
			{
				"lng": 11.463122324474281,
				"lat": 43.545650436791661
			},
			{
				"lng": 11.46312227366613,
				"lat": 43.545650586120388
			},
			{
				"lng": 11.463122231407654,
				"lat": 43.545650733817432
			},
			{
				"lng": 11.463122198094402,
				"lat": 43.545650879803688
			},
			{
				"lng": 11.46312217412197,
				"lat": 43.545651024000115
			},
			{
				"lng": 11.463122159885883,
				"lat": 43.545651166327715
			},
			{
				"lng": 11.463122155781713,
				"lat": 43.545651306707356
			},
			{
				"lng": 11.463122162205025,
				"lat": 43.545651445060066
			},
			{
				"lng": 11.463122179551359,
				"lat": 43.545651581306693
			},
			{
				"lng": 11.463122208216305,
				"lat": 43.545651715368258
			},
			{
				"lng": 11.463122248595383,
				"lat": 43.545651847165686
			},
			{
				"lng": 11.463122301084175,
				"lat": 43.545651976619908
			},
			{
				"lng": 11.463122366078238,
				"lat": 43.545652103651911
			},
			{
				"lng": 11.463122443973125,
				"lat": 43.545652228182597
			},
			{
				"lng": 11.4631225351644,
				"lat": 43.545652350132912
			},
			{
				"lng": 11.463122640047617,
				"lat": 43.545652469423842
			},
			{
				"lng": 11.463122759018345,
				"lat": 43.545652585976299
			},
			{
				"lng": 11.46312289247212,
				"lat": 43.545652699711269
			},
			{
				"lng": 11.463123040804527,
				"lat": 43.545652810549633
			},
			{
				"lng": 11.463123204411094,
				"lat": 43.545652918412394
			},
			{
				"lng": 11.463123383687416,
				"lat": 43.545653023220467
			},
			{
				"lng": 11.463123579029039,
				"lat": 43.545653124894841
			},
			{
				"lng": 11.46312379083151,
				"lat": 43.54565322335641
			},
			{
				"lng": 11.463124019490383,
				"lat": 43.545653318526135
			},
			{
				"lng": 11.46312426540125,
				"lat": 43.545653410324988
			},
			{
				"lng": 11.463124528959634,
				"lat": 43.545653498673872
			},
			{
				"lng": 11.463124810561109,
				"lat": 43.54565358349376
			},
			{
				"lng": 11.46312511060122,
				"lat": 43.54565366470564
			},
			{
				"lng": 11.463125429475554,
				"lat": 43.545653742230336
			},
			{
				"lng": 11.463125767579644,
				"lat": 43.545653815988956
			},
			{
				"lng": 11.463126125309062,
				"lat": 43.545653885902325
			},
			{
				"lng": 11.463126503059371,
				"lat": 43.545653951891417
			},
			{
				"lng": 11.46312690122611,
				"lat": 43.545654013877197
			},
			{
				"lng": 11.463127320204837,
				"lat": 43.545654071780575
			},
			{
				"lng": 11.46312776039114,
				"lat": 43.545654125522567
			},
			{
				"lng": 11.463128222180563,
				"lat": 43.545654175024033
			},
			{
				"lng": 11.463128705968645,
				"lat": 43.545654220206025
			},
			{
				"lng": 11.463129212150974,
				"lat": 43.545654260989338
			},
			{
				"lng": 11.46312974112309,
				"lat": 43.545654297295087
			},
			{
				"lng": 11.463130293280559,
				"lat": 43.545654329044091
			},
			{
				"lng": 11.463130869018933,
				"lat": 43.54565435615735
			},
			{
				"lng": 11.463131468733774,
				"lat": 43.545654378555817
			},
			{
				"lng": 11.463132092820649,
				"lat": 43.545654396160394
			},
			{
				"lng": 11.463132741675096,
				"lat": 43.545654408892105
			},
			{
				"lng": 11.463133415692701,
				"lat": 43.54565441667178
			},
			{
				"lng": 11.463134115269,
				"lat": 43.545654419420458
			},
			{
				"lng": 11.463134840799533,
				"lat": 43.545654417059055
			},
			{
				"lng": 11.463135592679917,
				"lat": 43.545654409508536
			},
			{
				"lng": 11.46313637130568,
				"lat": 43.545654396689812
			},
			{
				"lng": 11.463137177072372,
				"lat": 43.545654378523849
			},
			{
				"lng": 11.463138010375552,
				"lat": 43.545654354931571
			},
			{
				"lng": 11.463138871610791,
				"lat": 43.545654325834015
			},
			{
				"lng": 11.463139761173634,
				"lat": 43.545654291151976
			},
			{
				"lng": 11.46314067945964,
				"lat": 43.545654250806521
			},
			{
				"lng": 11.463141626864383,
				"lat": 43.545654204718524
			},
			{
				"lng": 11.463142603783407,
				"lat": 43.545654152808972
			},
			{
				"lng": 11.463143103434373,
				"lat": 43.545654124646418
			},
			{
				"lng": 11.463143610612271,
				"lat": 43.545654094998817
			},
			{
				"lng": 11.463144125366499,
				"lat": 43.545654063856297
			},
			{
				"lng": 11.463144647746535,
				"lat": 43.545654031208947
			},
			{
				"lng": 11.463145177801797,
				"lat": 43.545653997046941
			},
			{
				"lng": 11.463145715581755,
				"lat": 43.545653961360379
			},
			{
				"lng": 11.463146261135835,
				"lat": 43.545653924139366
			},
			{
				"lng": 11.463146814513491,
				"lat": 43.545653885374008
			},
			{
				"lng": 11.463147375764175,
				"lat": 43.545653845054474
			},
			{
				"lng": 11.463147944937313,
				"lat": 43.545653803170808
			},
			{
				"lng": 11.46314852208236,
				"lat": 43.54565375971319
			},
			{
				"lng": 11.463149107248768,
				"lat": 43.545653714671708
			},
			{
				"lng": 11.463149700486269,
				"lat": 43.545653668035918
			},
			{
				"lng": 11.463150301858782,
				"lat": 43.545653619768018
			},
			{
				"lng": 11.463150911449924,
				"lat": 43.545653569792229
			},
			{
				"lng": 11.46315152934482,
				"lat": 43.54565351802993
			},
			{
				"lng": 11.463152155628594,
				"lat": 43.54565346440242
			},
			{
				"lng": 11.463152790386324,
				"lat": 43.545653408831036
			},
			{
				"lng": 11.463153433703159,
				"lat": 43.545653351237142
			},
			{
				"lng": 11.463154085664183,
				"lat": 43.545653291542109
			},
			{
				"lng": 11.463154746354517,
				"lat": 43.545653229667252
			},
			{
				"lng": 11.463155415859266,
				"lat": 43.545653165533921
			},
			{
				"lng": 11.463156094263551,
				"lat": 43.545653099063465
			},
			{
				"lng": 11.463156781652478,
				"lat": 43.545653030177206
			},
			{
				"lng": 11.463157478111166,
				"lat": 43.545652958796573
			},
			{
				"lng": 11.463158183724719,
				"lat": 43.545652884842823
			},
			{
				"lng": 11.463158898578236,
				"lat": 43.545652808237357
			},
			{
				"lng": 11.463159622756848,
				"lat": 43.545652728901494
			},
			{
				"lng": 11.463160356345668,
				"lat": 43.545652646756587
			},
			{
				"lng": 11.46316109942979,
				"lat": 43.545652561723955
			},
			{
				"lng": 11.463161852094334,
				"lat": 43.545652473725006
			},
			{
				"lng": 11.463162614424419,
				"lat": 43.545652382681048
			},
			{
				"lng": 11.463163386505139,
				"lat": 43.545652288513416
			},
			{
				"lng": 11.463164168421621,
				"lat": 43.545652191143489
			},
			{
				"lng": 11.463164960258961,
				"lat": 43.545652090492595
			},
			{
				"lng": 11.463165762102284,
				"lat": 43.545651986482071
			},
			{
				"lng": 11.463166574036686,
				"lat": 43.545651879033272
			},
			{
				"lng": 11.463167396147302,
				"lat": 43.545651768067543
			},
			{
				"lng": 11.463168228519223,
				"lat": 43.545651653506269
			},
			{
				"lng": 11.463169071237578,
				"lat": 43.545651535270736
			},
			{
				"lng": 11.463169924387444,
				"lat": 43.545651413282307
			},
			{
				"lng": 11.46317078805397,
				"lat": 43.545651287462363
			},
			{
				"lng": 11.463171662322251,
				"lat": 43.545651157732209
			},
			{
				"lng": 11.463172547277399,
				"lat": 43.545651024013182
			},
			{
				"lng": 11.463173443004523,
				"lat": 43.545650886226689
			},
			{
				"lng": 11.463174349588735,
				"lat": 43.545650744294022
			},
			{
				"lng": 11.463175267115151,
				"lat": 43.54565059813654
			},
			{
				"lng": 11.463176195668874,
				"lat": 43.545650447675619
			},
			{
				"lng": 11.46317713533503,
				"lat": 43.545650292832569
			},
			{
				"lng": 11.463178086198702,
				"lat": 43.545650133528738
			},
			{
				"lng": 11.463179048345031,
				"lat": 43.545649969685499
			},
			{
				"lng": 11.463180021859111,
				"lat": 43.545649801224144
			},
			{
				"lng": 11.463181006826055,
				"lat": 43.545649628066101
			},
			{
				"lng": 11.463182003330989,
				"lat": 43.545649450132686
			},
			{
				"lng": 11.463183011459003,
				"lat": 43.54564926734519
			},
			{
				"lng": 11.463184031295208,
				"lat": 43.545649079625036
			},
			{
				"lng": 11.463185062924738,
				"lat": 43.545648886893517
			},
			{
				"lng": 11.463186106432689,
				"lat": 43.545648689071996
			},
			{
				"lng": 11.463187161904168,
				"lat": 43.545648486081809
			},
			{
				"lng": 11.463188229424274,
				"lat": 43.545648277844329
			},
			{
				"lng": 11.463189309078153,
				"lat": 43.545648064280897
			},
			{
				"lng": 11.463190400950893,
				"lat": 43.54564784531285
			},
			{
				"lng": 11.463191505127602,
				"lat": 43.545647620861494
			},
			{
				"lng": 11.463192621693411,
				"lat": 43.545647390848245
			},
			{
				"lng": 11.463193750733421,
				"lat": 43.54564715519443
			},
			{
				"lng": 11.463194892332725,
				"lat": 43.545646913821358
			},
			{
				"lng": 11.463196046576464,
				"lat": 43.545646666650413
			},
			{
				"lng": 11.46319721354971,
				"lat": 43.545646413602931
			},
			{
				"lng": 11.463198393337615,
				"lat": 43.545646154600256
			},
			{
				"lng": 11.463199586025263,
				"lat": 43.54564588956373
			},
			{
				"lng": 11.463200791697787,
				"lat": 43.545645618414738
			},
			{
				"lng": 11.463202010440277,
				"lat": 43.545645341074547
			},
			{
				"lng": 11.463203242337848,
				"lat": 43.545645057464561
			},
			{
				"lng": 11.463204487475611,
				"lat": 43.545644767506097
			},
			{
				"lng": 11.463205745938682,
				"lat": 43.545644471120561
			},
			{
				"lng": 11.463207017812168,
				"lat": 43.545644168229245
			},
			{
				"lng": 11.463208303181181,
				"lat": 43.545643858753465
			},
			{
				"lng": 11.463209602130839,
				"lat": 43.545643542614656
			},
			{
				"lng": 11.46321091474624,
				"lat": 43.545643219734089
			},
			{
				"lng": 11.463212241112506,
				"lat": 43.54564289003315
			},
			{
				"lng": 11.463213581314736,
				"lat": 43.545642553433161
			},
			{
				"lng": 11.463214935438035,
				"lat": 43.54564220985548
			},
			{
				"lng": 11.463216303567553,
				"lat": 43.545641859221462
			},
			{
				"lng": 11.463217685788347,
				"lat": 43.545641501452444
			},
			{
				"lng": 11.463219082185555,
				"lat": 43.545641136469769
			},
			{
				"lng": 11.4632204928443,
				"lat": 43.5456407641948
			},
			{
				"lng": 11.463221917849671,
				"lat": 43.545640384548818
			},
			{
				"lng": 11.463223357286779,
				"lat": 43.545639997453257
			},
			{
				"lng": 11.463224811240744,
				"lat": 43.545639602829439
			},
			{
				"lng": 11.463226279796674,
				"lat": 43.54563920059865
			},
			{
				"lng": 11.463227763039676,
				"lat": 43.545638790682311
			},
			{
				"lng": 11.463229261054861,
				"lat": 43.545638373001751
			},
			{
				"lng": 11.463230773927348,
				"lat": 43.545637947478291
			},
			{
				"lng": 11.463232301742242,
				"lat": 43.545637514033295
			},
			{
				"lng": 11.463233844584646,
				"lat": 43.545637072588107
			},
			{
				"lng": 11.463235402539675,
				"lat": 43.545636623064055
			},
			{
				"lng": 11.463236975692451,
				"lat": 43.545636165382533
			},
			{
				"lng": 11.463238564128067,
				"lat": 43.545635699464825
			},
			{
				"lng": 11.463240167931639,
				"lat": 43.545635225232289
			},
			{
				"lng": 11.463241787188283,
				"lat": 43.545634742606339
			},
			{
				"lng": 11.463243421983096,
				"lat": 43.545634251508211
			},
			{
				"lng": 11.463245072401206,
				"lat": 43.545633751859341
			},
			{
				"lng": 11.463246738527701,
				"lat": 43.545633243581072
			},
			{
				"lng": 11.463248420447716,
				"lat": 43.545632726594675
			},
			{
				"lng": 11.463250118246334,
				"lat": 43.545632200821551
			},
			{
				"lng": 11.4632518320087,
				"lat": 43.545631666183041
			},
			{
				"lng": 11.463253561819883,
				"lat": 43.54563112260049
			},
			{
				"lng": 11.463255307765024,
				"lat": 43.545630569995254
			},
			{
				"lng": 11.46325706992922,
				"lat": 43.545630008288633
			},
			{
				"lng": 11.463258848397599,
				"lat": 43.54562943740202
			},
			{
				"lng": 11.463260643255241,
				"lat": 43.545628857256773
			},
			{
				"lng": 11.463262454587273,
				"lat": 43.545628267774163
			},
			{
				"lng": 11.463264282478798,
				"lat": 43.545627668875603
			},
			{
				"lng": 11.463266127014926,
				"lat": 43.545627060482438
			},
			{
				"lng": 11.463267988280792,
				"lat": 43.545626442515974
			},
			{
				"lng": 11.463269866361465,
				"lat": 43.545625814897591
			},
			{
				"lng": 11.463271761342078,
				"lat": 43.545625177548608
			},
			{
				"lng": 11.46327367330775,
				"lat": 43.545624530390413
			},
			{
				"lng": 11.463275602343565,
				"lat": 43.545623873344304
			},
			{
				"lng": 11.463277548534652,
				"lat": 43.545623206331605
			},
			{
				"lng": 11.463279511966116,
				"lat": 43.545622529273743
			},
			{
				"lng": 11.463281492723068,
				"lat": 43.545621842092046
			},
			{
				"lng": 11.463283490890596,
				"lat": 43.545621144707788
			},
			{
				"lng": 11.46328550655384,
				"lat": 43.545620437042381
			},
			{
				"lng": 11.463287539797898,
				"lat": 43.545619719017175
			},
			{
				"lng": 11.46328959070787,
				"lat": 43.545618990553436
			},
			{
				"lng": 11.463291659368895,
				"lat": 43.545618251572606
			},
			{
				"lng": 11.463293745866043,
				"lat": 43.54561750199602
			},
			{
				"lng": 11.463295850284448,
				"lat": 43.545616741744958
			},
			{
				"lng": 11.463297972709217,
				"lat": 43.545615970740798
			},
			{
				"lng": 11.463300113225442,
				"lat": 43.545615188904883
			},
			{
				"lng": 11.463302271918266,
				"lat": 43.545614396158555
			},
			{
				"lng": 11.463304448872762,
				"lat": 43.545613592423216
			},
			{
				"lng": 11.46330664417407,
				"lat": 43.545612777620143
			},
			{
				"lng": 11.463308857907277,
				"lat": 43.545611951670693
			},
			{
				"lng": 11.463311090157495,
				"lat": 43.545611114496239
			},
			{
				"lng": 11.463313341009842,
				"lat": 43.545610266018109
			},
			{
				"lng": 11.46331561054942,
				"lat": 43.545609406157638
			},
			{
				"lng": 11.463317898861348,
				"lat": 43.545608534836184
			},
			{
				"lng": 11.463320206030726,
				"lat": 43.545607651975111
			},
			{
				"lng": 11.463322532142662,
				"lat": 43.545606757495712
			},
			{
				"lng": 11.463324877282265,
				"lat": 43.545605851319394
			},
			{
				"lng": 11.463327241534655,
				"lat": 43.545604933367436
			},
			{
				"lng": 11.463329624984915,
				"lat": 43.545604003561238
			},
			{
				"lng": 11.463332027718193,
				"lat": 43.545603061822113
			},
			{
				"lng": 11.463334449819566,
				"lat": 43.545602108071471
			},
			{
				"lng": 11.463336891374144,
				"lat": 43.545601142230545
			},
			{
				"lng": 11.463339352467052,
				"lat": 43.545600164220765
			},
			{
				"lng": 11.463341833183394,
				"lat": 43.545599173963481
			},
			{
				"lng": 11.463344333608278,
				"lat": 43.545598171379993
			},
			{
				"lng": 11.463346853826804,
				"lat": 43.545597156391658
			},
			{
				"lng": 11.463349393924084,
				"lat": 43.545596128919811
			},
			{
				"lng": 11.463351953985221,
				"lat": 43.54559508888584
			},
			{
				"lng": 11.463354534095352,
				"lat": 43.545594036211057
			},
			{
				"lng": 11.463357134339551,
				"lat": 43.545592970816799
			},
			{
				"lng": 11.463359754802941,
				"lat": 43.545591892624429
			},
			{
				"lng": 11.463362395570616,
				"lat": 43.545590801555299
			},
			{
				"lng": 11.463365056727719,
				"lat": 43.545589697530737
			},
			{
				"lng": 11.463367738359334,
				"lat": 43.545588580472113
			},
			{
				"lng": 11.463370440550555,
				"lat": 43.545587450300722
			},
			{
				"lng": 11.463373163386519,
				"lat": 43.545586306937942
			},
			{
				"lng": 11.463375906952317,
				"lat": 43.545585150305136
			},
			{
				"lng": 11.463378671333063,
				"lat": 43.545583980323613
			},
			{
				"lng": 11.463381456613865,
				"lat": 43.545582796914751
			},
			{
				"lng": 11.463384262879813,
				"lat": 43.545581599999899
			},
			{
				"lng": 11.46338709021606,
				"lat": 43.545580389500337
			},
			{
				"lng": 11.463389938707675,
				"lat": 43.545579165337479
			},
			{
				"lng": 11.463392808439769,
				"lat": 43.545577927432618
			},
			{
				"lng": 11.463395699497452,
				"lat": 43.545576675707146
			},
			{
				"lng": 11.46339861196585,
				"lat": 43.545575410082392
			},
			{
				"lng": 11.463401545930035,
				"lat": 43.545574130479686
			},
			{
				"lng": 11.463404501475154,
				"lat": 43.545572836820391
			},
			{
				"lng": 11.463407478686285,
				"lat": 43.545571529025871
			},
			{
				"lng": 11.463410477623466,
				"lat": 43.545570207034352
			},
			{
				"lng": 11.4634134981247,
				"lat": 43.545568870934012
			},
			{
				"lng": 11.463416539912162,
				"lat": 43.545567520891218
			},
			{
				"lng": 11.463419602707035,
				"lat": 43.545566157073004
			},
			{
				"lng": 11.46342268623046,
				"lat": 43.545564779646455
			},
			{
				"lng": 11.463425790203619,
				"lat": 43.545563388778511
			},
			{
				"lng": 11.463428914347674,
				"lat": 43.545561984636301
			},
			{
				"lng": 11.463432058383781,
				"lat": 43.545560567386822
			},
			{
				"lng": 11.4634352220331,
				"lat": 43.545559137197095
			},
			{
				"lng": 11.46343840501684,
				"lat": 43.545557694234226
			},
			{
				"lng": 11.463441607056113,
				"lat": 43.545556238665199
			},
			{
				"lng": 11.463444827872111,
				"lat": 43.54555477065707
			},
			{
				"lng": 11.463448067185995,
				"lat": 43.545553290376873
			},
			{
				"lng": 11.463451324718942,
				"lat": 43.545551797991614
			},
			{
				"lng": 11.463454600192103,
				"lat": 43.545550293668434
			},
			{
				"lng": 11.463457893326652,
				"lat": 43.545548777574261
			},
			{
				"lng": 11.46346120384375,
				"lat": 43.545547249876179
			},
			{
				"lng": 11.463464531464567,
				"lat": 43.545545710741273
			},
			{
				"lng": 11.463467875910272,
				"lat": 43.545544160336483
			},
			{
				"lng": 11.463471236902022,
				"lat": 43.545542598828938
			},
			{
				"lng": 11.463474614160987,
				"lat": 43.545541026385663
			},
			{
				"lng": 11.463478007408336,
				"lat": 43.54553944317361
			},
			{
				"lng": 11.463481416365239,
				"lat": 43.545537849359938
			},
			{
				"lng": 11.463484840752848,
				"lat": 43.545536245111627
			},
			{
				"lng": 11.463488280292337,
				"lat": 43.545534630595711
			},
			{
				"lng": 11.463491734704879,
				"lat": 43.54553300597928
			},
			{
				"lng": 11.463495203711631,
				"lat": 43.545531371429284
			},
			{
				"lng": 11.463498687033759,
				"lat": 43.545529727112822
			},
			{
				"lng": 11.463502184392455,
				"lat": 43.545528073196955
			},
			{
				"lng": 11.463505695508845,
				"lat": 43.545526409848698
			},
			{
				"lng": 11.46350922010412,
				"lat": 43.545524737235034
			},
			{
				"lng": 11.463512757899451,
				"lat": 43.545523055523127
			},
			{
				"lng": 11.463516308615986,
				"lat": 43.545521364879917
			},
			{
				"lng": 11.463519871974906,
				"lat": 43.545519665472469
			},
			{
				"lng": 11.463523447697378,
				"lat": 43.545517957467801
			},
			{
				"lng": 11.463527035504562,
				"lat": 43.545516241033035
			},
			{
				"lng": 11.463530635117625,
				"lat": 43.545514516335061
			},
			{
				"lng": 11.463534246257735,
				"lat": 43.545512783541128
			},
			{
				"lng": 11.463537868646076,
				"lat": 43.545511042818063
			},
			{
				"lng": 11.463541502003793,
				"lat": 43.545509294333044
			},
			{
				"lng": 11.463545146052061,
				"lat": 43.545507538253062
			},
			{
				"lng": 11.463548800512049,
				"lat": 43.545505774745187
			},
			{
				"lng": 11.463552465104911,
				"lat": 43.545504003976419
			},
			{
				"lng": 11.463556139551834,
				"lat": 43.545502226113804
			},
			{
				"lng": 11.463559823573986,
				"lat": 43.545500441324421
			},
			{
				"lng": 11.463563516892522,
				"lat": 43.545498649775269
			},
			{
				"lng": 11.463567219228617,
				"lat": 43.545496851633402
			},
			{
				"lng": 11.463570930303439,
				"lat": 43.545495047065863
			},
			{
				"lng": 11.463574649838142,
				"lat": 43.545493236239665
			},
			{
				"lng": 11.46357837755391,
				"lat": 43.54549141932192
			},
			{
				"lng": 11.463582113171903,
				"lat": 43.545489596479605
			},
			{
				"lng": 11.463585856413303,
				"lat": 43.545487767879749
			},
			{
				"lng": 11.463589606999259,
				"lat": 43.545485933689456
			},
			{
				"lng": 11.463593364650954,
				"lat": 43.545484094075711
			},
			{
				"lng": 11.463597129089541,
				"lat": 43.545482249205584
			},
			{
				"lng": 11.463600900036205,
				"lat": 43.545480399246095
			},
			{
				"lng": 11.463604677212109,
				"lat": 43.545478544364286
			},
			{
				"lng": 11.46360846033841,
				"lat": 43.545476684727234
			},
			{
				"lng": 11.463612249136299,
				"lat": 43.545474820501916
			},
			{
				"lng": 11.463616043326914,
				"lat": 43.545472951855452
			},
			{
				"lng": 11.463619842631458,
				"lat": 43.545471078954826
			},
			{
				"lng": 11.463627455466945,
				"lat": 43.545467321059256
			},
			{
				"lng": 11.463635085412102,
				"lat": 43.545463548151595
			},
			{
				"lng": 11.463642730236289,
				"lat": 43.545459761568175
			},
			{
				"lng": 11.463650387708865,
				"lat": 43.545455962645285
			},
			{
				"lng": 11.463658055599179,
				"lat": 43.545452152719299
			},
			{
				"lng": 11.463665731676588,
				"lat": 43.54544833312648
			},
			{
				"lng": 11.463673413710445,
				"lat": 43.545444505203214
			},
			{
				"lng": 11.463681099470111,
				"lat": 43.545440670285849
			},
			{
				"lng": 11.463688786724958,
				"lat": 43.545436829710631
			},
			{
				"lng": 11.463704156797588,
				"lat": 43.545429136932128
			},
			{
				"lng": 11.463719506083267,
				"lat": 43.545421437558367
			},
			{
				"lng": 11.463727167354396,
				"lat": 43.545417588739092
			},
			{
				"lng": 11.463734816736897,
				"lat": 43.54541374227999
			},
			{
				"lng": 11.463742452000123,
				"lat": 43.545409899517466
			},
			{
				"lng": 11.463750070913438,
				"lat": 43.545406061787759
			},
			{
				"lng": 11.463757671246229,
				"lat": 43.545402230427243
			},
			{
				"lng": 11.463765250767857,
				"lat": 43.545398406772236
			},
			{
				"lng": 11.463772807247695,
				"lat": 43.545394592159106
			},
			{
				"lng": 11.46378033845513,
				"lat": 43.545390787924163
			},
			{
				"lng": 11.46378409388462,
				"lat": 43.545388890116151
			},
			{
				"lng": 11.463787842159535,
				"lat": 43.545386995403796
			},
			{
				"lng": 11.463791583001026,
				"lat": 43.545385103954168
			},
			{
				"lng": 11.463795316130264,
				"lat": 43.545383215934265
			},
			{
				"lng": 11.463799041268459,
				"lat": 43.545381331511187
			},
			{
				"lng": 11.463802758136747,
				"lat": 43.545379450851961
			},
			{
				"lng": 11.463806466456305,
				"lat": 43.545377574123627
			},
			{
				"lng": 11.463810165948308,
				"lat": 43.545375701493207
			},
			{
				"lng": 11.463813856333942,
				"lat": 43.545373833127776
			},
			{
				"lng": 11.463817537334378,
				"lat": 43.54537196919437
			},
			{
				"lng": 11.463821208670764,
				"lat": 43.545370109860002
			},
			{
				"lng": 11.463824870064283,
				"lat": 43.545368255291706
			},
			{
				"lng": 11.463828521236124,
				"lat": 43.545366405656587
			},
			{
				"lng": 11.463832161907462,
				"lat": 43.545364561121652
			},
			{
				"lng": 11.463835791799443,
				"lat": 43.545362721853955
			},
			{
				"lng": 11.463839410633261,
				"lat": 43.545360888020511
			},
			{
				"lng": 11.463843018130078,
				"lat": 43.545359059788396
			},
			{
				"lng": 11.463846614011089,
				"lat": 43.54535723732463
			},
			{
				"lng": 11.463850197997427,
				"lat": 43.545355420796263
			},
			{
				"lng": 11.463853769810312,
				"lat": 43.545353610370341
			},
			{
				"lng": 11.46385732917088,
				"lat": 43.545351806213866
			},
			{
				"lng": 11.463860875800323,
				"lat": 43.545350008493926
			},
			{
				"lng": 11.463864409419816,
				"lat": 43.545348217377601
			},
			{
				"lng": 11.463867929750524,
				"lat": 43.545346433031902
			},
			{
				"lng": 11.463871436513635,
				"lat": 43.545344655623779
			},
			{
				"lng": 11.463874929430299,
				"lat": 43.545342885320387
			},
			{
				"lng": 11.46387840822171,
				"lat": 43.545341122288782
			},
			{
				"lng": 11.463881872609036,
				"lat": 43.545339366695949
			},
			{
				"lng": 11.463885322313448,
				"lat": 43.545337618708921
			},
			{
				"lng": 11.463888757056136,
				"lat": 43.545335878494768
			},
			{
				"lng": 11.46389217655825,
				"lat": 43.545334146220512
			},
			{
				"lng": 11.463895580540974,
				"lat": 43.545332422053264
			},
			{
				"lng": 11.463898968725488,
				"lat": 43.545330706159966
			},
			{
				"lng": 11.463902340832956,
				"lat": 43.545328998707731
			},
			{
				"lng": 11.463905696584552,
				"lat": 43.545327299863573
			},
			{
				"lng": 11.463909035701471,
				"lat": 43.545325609794588
			},
			{
				"lng": 11.463912357904867,
				"lat": 43.545323928667727
			},
			{
				"lng": 11.463915662915925,
				"lat": 43.545322256650117
			},
			{
				"lng": 11.463918950455806,
				"lat": 43.545320593908734
			},
			{
				"lng": 11.463922220245694,
				"lat": 43.545318940610677
			},
			{
				"lng": 11.463925472006773,
				"lat": 43.545317296922967
			},
			{
				"lng": 11.463928705460201,
				"lat": 43.545315663012651
			},
			{
				"lng": 11.463931920327159,
				"lat": 43.545314039046758
			},
			{
				"lng": 11.46393511632883,
				"lat": 43.54531242519235
			},
			{
				"lng": 11.463938293186374,
				"lat": 43.545310821616454
			},
			{
				"lng": 11.463941450620968,
				"lat": 43.54530922848614
			},
			{
				"lng": 11.463944588353801,
				"lat": 43.545307645968435
			},
			{
				"lng": 11.463947706106049,
				"lat": 43.545306074230325
			},
			{
				"lng": 11.463950803598859,
				"lat": 43.545304513438957
			},
			{
				"lng": 11.463953880553429,
				"lat": 43.545302963761337
			},
			{
				"lng": 11.463956936690927,
				"lat": 43.545301425364478
			},
			{
				"lng": 11.463959971732544,
				"lat": 43.545299898415443
			},
			{
				"lng": 11.463962985399426,
				"lat": 43.545298383081274
			},
			{
				"lng": 11.463965977412768,
				"lat": 43.545296879529026
			},
			{
				"lng": 11.463968947493749,
				"lat": 43.545295387925741
			},
			{
				"lng": 11.463971895363537,
				"lat": 43.545293908438445
			},
			{
				"lng": 11.463974820743294,
				"lat": 43.545292441234217
			},
			{
				"lng": 11.463977723354336,
				"lat": 43.545290986479969
			},
			{
				"lng": 11.463980603016273,
				"lat": 43.545289544283705
			},
			{
				"lng": 11.463983459826302,
				"lat": 43.545288114586839
			},
			{
				"lng": 11.463986293930198,
				"lat": 43.545286697301506
			},
			{
				"lng": 11.463989105473782,
				"lat": 43.545285292340047
			},
			{
				"lng": 11.463991894602813,
				"lat": 43.545283899614567
			},
			{
				"lng": 11.463994661463104,
				"lat": 43.545282519037322
			},
			{
				"lng": 11.463997406200454,
				"lat": 43.54528115052058
			},
			{
				"lng": 11.464000128960645,
				"lat": 43.545279793976491
			},
			{
				"lng": 11.464002829889475,
				"lat": 43.545278449317294
			},
			{
				"lng": 11.464005509132743,
				"lat": 43.545277116455225
			},
			{
				"lng": 11.46400816683623,
				"lat": 43.545275795302452
			},
			{
				"lng": 11.464010803145737,
				"lat": 43.545274485771266
			},
			{
				"lng": 11.464013418207074,
				"lat": 43.54527318777383
			},
			{
				"lng": 11.464016012166011,
				"lat": 43.545271901222399
			},
			{
				"lng": 11.464018585168352,
				"lat": 43.545270626029172
			},
			{
				"lng": 11.464021137359873,
				"lat": 43.545269362106374
			},
			{
				"lng": 11.464023668886398,
				"lat": 43.545268109366141
			},
			{
				"lng": 11.464026179893713,
				"lat": 43.545266867720841
			},
			{
				"lng": 11.464028670527586,
				"lat": 43.545265637082601
			},
			{
				"lng": 11.464031140933828,
				"lat": 43.545264417363668
			},
			{
				"lng": 11.464033591258238,
				"lat": 43.545263208476221
			},
			{
				"lng": 11.464036021646603,
				"lat": 43.545262010332522
			},
			{
				"lng": 11.464038432244712,
				"lat": 43.545260822844746
			},
			{
				"lng": 11.464040823198355,
				"lat": 43.545259645925157
			},
			{
				"lng": 11.464043194653348,
				"lat": 43.545258479485923
			},
			{
				"lng": 11.464045546755456,
				"lat": 43.545257323439309
			},
			{
				"lng": 11.464047879650487,
				"lat": 43.545256177697539
			},
			{
				"lng": 11.464050193484219,
				"lat": 43.545255042172727
			},
			{
				"lng": 11.464052488402467,
				"lat": 43.545253916777227
			},
			{
				"lng": 11.464054764551022,
				"lat": 43.545252801423196
			},
			{
				"lng": 11.464057022075641,
				"lat": 43.545251696022831
			},
			{
				"lng": 11.464059261122177,
				"lat": 43.545250600488416
			},
			{
				"lng": 11.464061481836362,
				"lat": 43.545249514732028
			},
			{
				"lng": 11.464063684364024,
				"lat": 43.545248438666079
			},
			{
				"lng": 11.464065868850954,
				"lat": 43.545247372202624
			},
			{
				"lng": 11.464068035442919,
				"lat": 43.545246315253955
			},
			{
				"lng": 11.464070184285749,
				"lat": 43.545245267732327
			},
			{
				"lng": 11.464072315525211,
				"lat": 43.545244229549873
			},
			{
				"lng": 11.464074429307109,
				"lat": 43.545243200618863
			},
			{
				"lng": 11.464076525777209,
				"lat": 43.545242180851467
			},
			{
				"lng": 11.464078605081351,
				"lat": 43.545241170159912
			},
			{
				"lng": 11.464080667365279,
				"lat": 43.545240168456495
			},
			{
				"lng": 11.464082712774829,
				"lat": 43.54523917565335
			},
			{
				"lng": 11.464084741455752,
				"lat": 43.545238191662719
			},
			{
				"lng": 11.464086753553866,
				"lat": 43.545237216396821
			},
			{
				"lng": 11.464088749214966,
				"lat": 43.545236249767875
			},
			{
				"lng": 11.464090728584827,
				"lat": 43.545235291688101
			},
			{
				"lng": 11.464092691809233,
				"lat": 43.545234342069705
			},
			{
				"lng": 11.464094639034009,
				"lat": 43.545233400824884
			},
			{
				"lng": 11.464096570404928,
				"lat": 43.545232467865944
			},
			{
				"lng": 11.464098486067778,
				"lat": 43.545231543104975
			},
			{
				"lng": 11.464100386168361,
				"lat": 43.54523062645427
			},
			{
				"lng": 11.464102270852463,
				"lat": 43.545229717826039
			},
			{
				"lng": 11.464104140265887,
				"lat": 43.545228817132475
			},
			{
				"lng": 11.464105994554401,
				"lat": 43.545227924285868
			},
			{
				"lng": 11.464107833863817,
				"lat": 43.54522703919833
			},
			{
				"lng": 11.464109658339909,
				"lat": 43.545226161782153
			},
			{
				"lng": 11.464111468128491,
				"lat": 43.545225291949521
			},
			{
				"lng": 11.464113263375356,
				"lat": 43.545224429612709
			},
			{
				"lng": 11.464115044226261,
				"lat": 43.545223574683796
			},
			{
				"lng": 11.464116810827033,
				"lat": 43.545222727075156
			},
			{
				"lng": 11.464118563323455,
				"lat": 43.545221886698926
			},
			{
				"lng": 11.464120301861303,
				"lat": 43.545221053467309
			},
			{
				"lng": 11.464122026586381,
				"lat": 43.545220227292582
			},
			{
				"lng": 11.46412373764448,
				"lat": 43.545219408086908
			},
			{
				"lng": 11.464125435181398,
				"lat": 43.545218595762556
			},
			{
				"lng": 11.464127119342916,
				"lat": 43.545217790231675
			},
			{
				"lng": 11.464128790274822,
				"lat": 43.545216991406534
			},
			{
				"lng": 11.464130448122933,
				"lat": 43.545216199199331
			},
			{
				"lng": 11.464132093033005,
				"lat": 43.545215413522286
			},
			{
				"lng": 11.46413372515085,
				"lat": 43.545214634287596
			},
			{
				"lng": 11.464135344622266,
				"lat": 43.545213861407539
			},
			{
				"lng": 11.464136951593012,
				"lat": 43.545213094794278
			},
			{
				"lng": 11.464138546208908,
				"lat": 43.545212334360045
			},
			{
				"lng": 11.464140128615757,
				"lat": 43.54521158001706
			},
			{
				"lng": 11.464141698959322,
				"lat": 43.545210831677537
			},
			{
				"lng": 11.464143257385388,
				"lat": 43.545210089253693
			},
			{
				"lng": 11.464144804039782,
				"lat": 43.545209352657665
			},
			{
				"lng": 11.464146339068273,
				"lat": 43.545208621801862
			},
			{
				"lng": 11.464147862616642,
				"lat": 43.545207896598313
			},
			{
				"lng": 11.464149374830694,
				"lat": 43.545207176959323
			},
			{
				"lng": 11.464150875856234,
				"lat": 43.545206462797097
			},
			{
				"lng": 11.464152365839018,
				"lat": 43.545205754023868
			},
			{
				"lng": 11.464153844924873,
				"lat": 43.545205050551822
			},
			{
				"lng": 11.464155313259566,
				"lat": 43.54520435229319
			},
			{
				"lng": 11.46415677098889,
				"lat": 43.545203659160144
			},
			{
				"lng": 11.464158218258655,
				"lat": 43.545202971065009
			},
			{
				"lng": 11.464159655214633,
				"lat": 43.545202287919892
			},
			{
				"lng": 11.464161082002622,
				"lat": 43.54520160963709
			},
			{
				"lng": 11.464162498768408,
				"lat": 43.545200936128779
			},
			{
				"lng": 11.46416390565779,
				"lat": 43.545200267307123
			},
			{
				"lng": 11.464165302816543,
				"lat": 43.545199603084406
			},
			{
				"lng": 11.464166690390478,
				"lat": 43.545198943372917
			},
			{
				"lng": 11.464168068525373,
				"lat": 43.545198288084713
			},
			{
				"lng": 11.464169437367039,
				"lat": 43.545197637132119
			},
			{
				"lng": 11.464170797061231,
				"lat": 43.5451969904273
			},
			{
				"lng": 11.464172147753768,
				"lat": 43.545196347882531
			},
			{
				"lng": 11.464173489590431,
				"lat": 43.545195709409938
			},
			{
				"lng": 11.464174822717016,
				"lat": 43.545195074921814
			},
			{
				"lng": 11.4641761472793,
				"lat": 43.545194444330335
			},
			{
				"lng": 11.464177463423095,
				"lat": 43.545193817547784
			},
			{
				"lng": 11.464178771294177,
				"lat": 43.545193194486259
			},
			{
				"lng": 11.464180071038339,
				"lat": 43.545192575058067
			},
			{
				"lng": 11.464181362801366,
				"lat": 43.545191959175447
			},
			{
				"lng": 11.46418264672907,
				"lat": 43.545191346750542
			},
			{
				"lng": 11.464183922967212,
				"lat": 43.545190737695599
			},
			{
				"lng": 11.464185191661608,
				"lat": 43.545190131922823
			},
			{
				"lng": 11.464186452958026,
				"lat": 43.545189529344434
			},
			{
				"lng": 11.464187707002282,
				"lat": 43.545188929872701
			},
			{
				"lng": 11.464188953940146,
				"lat": 43.545188333419759
			},
			{
				"lng": 11.464190193917423,
				"lat": 43.54518773989787
			},
			{
				"lng": 11.464191427079896,
				"lat": 43.545187149219217
			},
			{
				"lng": 11.464193873543589,
				"lat": 43.545185976040614
			},
			{
				"lng": 11.464196294497544,
				"lat": 43.545184813181649
			},
			{
				"lng": 11.464198691108107,
				"lat": 43.545183659940051
			},
			{
				"lng": 11.464201064541587,
				"lat": 43.545182515613554
			},
			{
				"lng": 11.464203415964322,
				"lat": 43.545181379499887
			},
			{
				"lng": 11.464205746542607,
				"lat": 43.545180250896792
			},
			{
				"lng": 11.464208057442788,
				"lat": 43.54517912910201
			},
			{
				"lng": 11.464210349831193,
				"lat": 43.545178013413249
			},
			{
				"lng": 11.464212624874119,
				"lat": 43.545176903128237
			},
			{
				"lng": 11.464214883737904,
				"lat": 43.545175797544729
			},
			{
				"lng": 11.464217127588872,
				"lat": 43.545174695960448
			},
			{
				"lng": 11.464219357593343,
				"lat": 43.545173597673113
			},
			{
				"lng": 11.464221574917637,
				"lat": 43.545172501980467
			},
			{
				"lng": 11.46422378072808,
				"lat": 43.545171408180245
			},
			{
				"lng": 11.464225976190979,
				"lat": 43.545170315570189
			},
			{
				"lng": 11.464228162472672,
				"lat": 43.545169223447999
			},
			{
				"lng": 11.464230340739476,
				"lat": 43.545168131111403
			},
			{
				"lng": 11.464234677893698,
				"lat": 43.545165942985967
			},
			{
				"lng": 11.464238996984198,
				"lat": 43.545163745575735
			},
			{
				"lng": 11.464243307341551,
				"lat": 43.545161533262586
			},
			{
				"lng": 11.464245462161086,
				"lat": 43.545160419761714
			},
			{
				"lng": 11.46424761820607,
				"lat": 43.54515930048575
			},
			{
				"lng": 11.464249775754309,
				"lat": 43.545158175298297
			},
			{
				"lng": 11.46425193466701,
				"lat": 43.545157044328214
			},
			{
				"lng": 11.464256256016185,
				"lat": 43.545154765564952
			},
			{
				"lng": 11.464260581114386,
				"lat": 43.545152465245565
			},
			{
				"lng": 11.464264908822404,
				"lat": 43.545150144419537
			},
			{
				"lng": 11.464269238001025,
				"lat": 43.545147804136455
			},
			{
				"lng": 11.464273567511032,
				"lat": 43.545145445445812
			},
			{
				"lng": 11.464277896213218,
				"lat": 43.545143069397113
			},
			{
				"lng": 11.464282222968356,
				"lat": 43.545140677039953
			},
			{
				"lng": 11.464286546637243,
				"lat": 43.545138269423873
			},
			{
				"lng": 11.464290866080665,
				"lat": 43.545135847598395
			},
			{
				"lng": 11.464295180159423,
				"lat": 43.545133412613026
			},
			{
				"lng": 11.464299487734312,
				"lat": 43.545130965517338
			},
			{
				"lng": 11.464303787666086,
				"lat": 43.545128507360857
			},
			{
				"lng": 11.464308078815566,
				"lat": 43.545126039193114
			},
			{
				"lng": 11.464312360043539,
				"lat": 43.545123562063658
			},
			{
				"lng": 11.464316630210789,
				"lat": 43.54512107702201
			},
			{
				"lng": 11.464320888178102,
				"lat": 43.545118585117741
			},
			{
				"lng": 11.464325132806286,
				"lat": 43.545116087400352
			},
			{
				"lng": 11.46432936295613,
				"lat": 43.545113584919385
			},
			{
				"lng": 11.464333577488437,
				"lat": 43.54511107872441
			},
			{
				"lng": 11.464337775263985,
				"lat": 43.545108569864951
			},
			{
				"lng": 11.464341955143562,
				"lat": 43.545106059390527
			},
			{
				"lng": 11.464346115987983,
				"lat": 43.545103548350703
			},
			{
				"lng": 11.464350256658037,
				"lat": 43.545101037794986
			},
			{
				"lng": 11.464354376014512,
				"lat": 43.545098528772982
			},
			{
				"lng": 11.464358472918201,
				"lat": 43.545096022334135
			},
			{
				"lng": 11.464362546229932,
				"lat": 43.545093519528059
			},
			{
				"lng": 11.464366594810478,
				"lat": 43.545091021404254
			},
			{
				"lng": 11.464370617520636,
				"lat": 43.545088529012276
			},
			{
				"lng": 11.464374613221208,
				"lat": 43.545086043401675
			},
			{
				"lng": 11.464376600586895,
				"lat": 43.545084803467375
			},
			{
				"lng": 11.464378580772994,
				"lat": 43.545083565621994
			},
			{
				"lng": 11.464380553637087,
				"lat": 43.545082329996688
			},
			{
				"lng": 11.464382519036786,
				"lat": 43.54508109672274
			},
			{
				"lng": 11.464384476829691,
				"lat": 43.545079865931228
			},
			{
				"lng": 11.464386426873396,
				"lat": 43.545078637753456
			},
			{
				"lng": 11.464388369025503,
				"lat": 43.545077412320559
			},
			{
				"lng": 11.464390303143617,
				"lat": 43.545076189763691
			},
			{
				"lng": 11.464392229085322,
				"lat": 43.545074970214131
			},
			{
				"lng": 11.464394146708239,
				"lat": 43.545073753803024
			},
			{
				"lng": 11.464396055869958,
				"lat": 43.545072540661565
			},
			{
				"lng": 11.46439795642809,
				"lat": 43.545071330920948
			},
			{
				"lng": 11.464399848240218,
				"lat": 43.545070124712367
			},
			{
				"lng": 11.464401731163944,
				"lat": 43.545068922167012
			},
			{
				"lng": 11.464403605056875,
				"lat": 43.545067723416103
			},
			{
				"lng": 11.464405469776613,
				"lat": 43.54506652859078
			},
			{
				"lng": 11.464407325180758,
				"lat": 43.545065337822273
			},
			{
				"lng": 11.464409171126912,
				"lat": 43.54506415124176
			},
			{
				"lng": 11.464411007472657,
				"lat": 43.54506296898041
			},
			{
				"lng": 11.464412834081923,
				"lat": 43.545061791167505
			},
			{
				"lng": 11.464414651023631,
				"lat": 43.545060617865161
			},
			{
				"lng": 11.464416458612012,
				"lat": 43.545059449055884
			},
			{
				"lng": 11.464418257175748,
				"lat": 43.545058284717314
			},
			{
				"lng": 11.464420047043488,
				"lat": 43.545057124827139
			},
			{
				"lng": 11.464421828543921,
				"lat": 43.545055969363091
			},
			{
				"lng": 11.4644236020057,
				"lat": 43.545054818302781
			},
			{
				"lng": 11.464425367757487,
				"lat": 43.545053671623947
			},
			{
				"lng": 11.464427126127962,
				"lat": 43.545052529304222
			},
			{
				"lng": 11.464428877445791,
				"lat": 43.545051391321351
			},
			{
				"lng": 11.464430622039645,
				"lat": 43.545050257652953
			},
			{
				"lng": 11.46443236023817,
				"lat": 43.545049128276759
			},
			{
				"lng": 11.464434092370057,
				"lat": 43.545048003170443
			},
			{
				"lng": 11.464435818763965,
				"lat": 43.545046882311631
			},
			{
				"lng": 11.464437539748561,
				"lat": 43.545045765678097
			},
			{
				"lng": 11.464440966804478,
				"lat": 43.545043544997412
			},
			{
				"lng": 11.464444376167158,
				"lat": 43.545041340949822
			},
			{
				"lng": 11.464447770465926,
				"lat": 43.545039153356861
			},
			{
				"lng": 11.464451152330128,
				"lat": 43.54503698203991
			},
			{
				"lng": 11.464454524389094,
				"lat": 43.545034826820448
			},
			{
				"lng": 11.464457889272172,
				"lat": 43.545032687519964
			},
			{
				"lng": 11.46446124960867,
				"lat": 43.545030563959898
			},
			{
				"lng": 11.464464608027948,
				"lat": 43.54502845596167
			},
			{
				"lng": 11.464467967159329,
				"lat": 43.545026363346786
			},
			{
				"lng": 11.464471329632142,
				"lat": 43.545024285936705
			},
			{
				"lng": 11.464474698075742,
				"lat": 43.54502222355282
			},
			{
				"lng": 11.464478075119434,
				"lat": 43.545020176016656
			},
			{
				"lng": 11.464481463392568,
				"lat": 43.545018143149655
			},
			{
				"lng": 11.464484865524481,
				"lat": 43.545016124773248
			},
			{
				"lng": 11.46448828414449,
				"lat": 43.545014120708949
			},
			{
				"lng": 11.464491721881911,
				"lat": 43.545012130778112
			},
			{
				"lng": 11.46449518136613,
				"lat": 43.545010154802299
			},
			{
				"lng": 11.464496920084926,
				"lat": 43.545009171991666
			},
			{
				"lng": 11.464498665226433,
				"lat": 43.545008192602893
			},
			{
				"lng": 11.464500417119279,
				"lat": 43.545007216613548
			},
			{
				"lng": 11.464502176092154,
				"lat": 43.545006244001378
			},
			{
				"lng": 11.464503942473712,
				"lat": 43.545005274744049
			},
			{
				"lng": 11.464505716592628,
				"lat": 43.545004308819195
			},
			{
				"lng": 11.464507498777566,
				"lat": 43.545003346204581
			},
			{
				"lng": 11.464509289357185,
				"lat": 43.545002386877826
			},
			{
				"lng": 11.464511088660165,
				"lat": 43.545001430816626
			},
			{
				"lng": 11.464512897015164,
				"lat": 43.545000477998698
			},
			{
				"lng": 11.464514714750848,
				"lat": 43.544999528401682
			},
			{
				"lng": 11.464516542195881,
				"lat": 43.544998582003224
			},
			{
				"lng": 11.464518379678942,
				"lat": 43.54499763878114
			},
			{
				"lng": 11.464520227528677,
				"lat": 43.544996698712971
			},
			{
				"lng": 11.464522086073764,
				"lat": 43.544995761776505
			},
			{
				"lng": 11.464523955642862,
				"lat": 43.544994827949317
			},
			{
				"lng": 11.464525836564638,
				"lat": 43.544993897209167
			},
			{
				"lng": 11.46452772916777,
				"lat": 43.54499296953373
			},
			{
				"lng": 11.464529633780913,
				"lat": 43.544992044900631
			},
			{
				"lng": 11.464531550732737,
				"lat": 43.544991123287609
			},
			{
				"lng": 11.464533480351907,
				"lat": 43.544990204672331
			},
			{
				"lng": 11.464535422967085,
				"lat": 43.544989289032465
			},
			{
				"lng": 11.464537378906954,
				"lat": 43.544988376345707
			},
			{
				"lng": 11.46453934850015,
				"lat": 43.544987466589731
			},
			{
				"lng": 11.464541332075358,
				"lat": 43.544986559742213
			},
			{
				"lng": 11.46454332996125,
				"lat": 43.544985655780863
			},
			{
				"lng": 11.464545342486467,
				"lat": 43.544984754683306
			},
			{
				"lng": 11.464547369979705,
				"lat": 43.544983856427301
			},
			{
				"lng": 11.464549412769607,
				"lat": 43.544982960990467
			},
			{
				"lng": 11.464551471184839,
				"lat": 43.544982068350485
			},
			{
				"lng": 11.464553545554086,
				"lat": 43.544981178485088
			},
			{
				"lng": 11.464555636205837,
				"lat": 43.5449802913719
			},
			{
				"lng": 11.464557743326612,
				"lat": 43.544979406970349
			},
			{
				"lng": 11.464559866702237,
				"lat": 43.544978525188434
			},
			{
				"lng": 11.464562006048409,
				"lat": 43.544977645925158
			},
			{
				"lng": 11.464564161080746,
				"lat": 43.544976769079504
			},
			{
				"lng": 11.464566331514893,
				"lat": 43.544975894550475
			},
			{
				"lng": 11.464568517066528,
				"lat": 43.544975022237018
			},
			{
				"lng": 11.46457071745129,
				"lat": 43.544974152038151
			},
			{
				"lng": 11.464572932384813,
				"lat": 43.544973283852848
			},
			{
				"lng": 11.464575161582795,
				"lat": 43.544972417580126
			},
			{
				"lng": 11.46457740476084,
				"lat": 43.54497155311892
			},
			{
				"lng": 11.46457966163462,
				"lat": 43.544970690368238
			},
			{
				"lng": 11.464581931919788,
				"lat": 43.544969829227128
			},
			{
				"lng": 11.464584215331998,
				"lat": 43.544968969594507
			},
			{
				"lng": 11.464586511586882,
				"lat": 43.544968111369343
			},
			{
				"lng": 11.464588820400127,
				"lat": 43.544967254450711
			},
			{
				"lng": 11.464591141487357,
				"lat": 43.544966398737529
			},
			{
				"lng": 11.464593474564246,
				"lat": 43.544965544128843
			},
			{
				"lng": 11.464595819346409,
				"lat": 43.544964690523571
			},
			{
				"lng": 11.464598175549547,
				"lat": 43.544963837820745
			},
			{
				"lng": 11.464600542889269,
				"lat": 43.544962985919327
			},
			{
				"lng": 11.464602921081255,
				"lat": 43.544962134718325
			},
			{
				"lng": 11.464605309841145,
				"lat": 43.544961284116766
			},
			{
				"lng": 11.464607708884582,
				"lat": 43.544960434013575
			},
			{
				"lng": 11.464610117927238,
				"lat": 43.544959584307726
			},
			{
				"lng": 11.464612536684756,
				"lat": 43.544958734898294
			},
			{
				"lng": 11.464614964872778,
				"lat": 43.544957885684191
			},
			{
				"lng": 11.46461740220697,
				"lat": 43.544957036564391
			},
			{
				"lng": 11.464619848402995,
				"lat": 43.544956187438004
			},
			{
				"lng": 11.464622303176471,
				"lat": 43.54495533820387
			},
			{
				"lng": 11.464624766243073,
				"lat": 43.544954488761078
			},
			{
				"lng": 11.464627237318455,
				"lat": 43.544953639008547
			},
			{
				"lng": 11.464629716118257,
				"lat": 43.54495278884535
			},
			{
				"lng": 11.464634695753753,
				"lat": 43.544951086882676
			},
			{
				"lng": 11.464639702874768,
				"lat": 43.544949382064985
			},
			{
				"lng": 11.464644735206519,
				"lat": 43.544947673584225
			},
			{
				"lng": 11.464649790474246,
				"lat": 43.544945960632241
			},
			{
				"lng": 11.464654866403119,
				"lat": 43.544944242400966
			},
			{
				"lng": 11.464659960718402,
				"lat": 43.544942518082337
			},
			{
				"lng": 11.464665071145282,
				"lat": 43.54494078686821
			},
			{
				"lng": 11.464670195408978,
				"lat": 43.544939047950528
			},
			{
				"lng": 11.464675331234728,
				"lat": 43.544937300521191
			},
			{
				"lng": 11.464680476347711,
				"lat": 43.544935543772134
			},
			{
				"lng": 11.46468562847317,
				"lat": 43.544933776895185
			},
			{
				"lng": 11.464690785336311,
				"lat": 43.544931999082351
			},
			{
				"lng": 11.464695944662353,
				"lat": 43.544930209525482
			},
			{
				"lng": 11.464701104176509,
				"lat": 43.544928407416513
			},
			{
				"lng": 11.464706261603993,
				"lat": 43.544926591947373
			},
			{
				"lng": 11.464711414670019,
				"lat": 43.544924762309918
			},
			{
				"lng": 11.464716561099822,
				"lat": 43.544922917696105
			},
			{
				"lng": 11.464721698618593,
				"lat": 43.544921057297827
			},
			{
				"lng": 11.464726824951565,
				"lat": 43.544919180307041
			},
			{
				"lng": 11.464731937823938,
				"lat": 43.544917285915581
			},
			{
				"lng": 11.464737034960962,
				"lat": 43.544915373315462
			},
			{
				"lng": 11.464739576917832,
				"lat": 43.544914409934584
			},
			{
				"lng": 11.464742114087819,
				"lat": 43.544913441698483
			},
			{
				"lng": 11.464744646186558,
				"lat": 43.544912468506212
			},
			{
				"lng": 11.464747172929727,
				"lat": 43.544911490256695
			},
			{
				"lng": 11.464749694032969,
				"lat": 43.544910506848915
			},
			{
				"lng": 11.464752209211914,
				"lat": 43.544909518181875
			},
			{
				"lng": 11.464754718196945,
				"lat": 43.544908524165137
			},
			{
				"lng": 11.464757220825737,
				"lat": 43.544907524785444
			},
			{
				"lng": 11.46475971698357,
				"lat": 43.544906520063705
			},
			{
				"lng": 11.464762206555903,
				"lat": 43.544905510021032
			},
			{
				"lng": 11.464764689428216,
				"lat": 43.544904494678477
			},
			{
				"lng": 11.464767165485991,
				"lat": 43.544903474057122
			},
			{
				"lng": 11.464769634614692,
				"lat": 43.544902448178007
			},
			{
				"lng": 11.464772096699821,
				"lat": 43.544901417062299
			},
			{
				"lng": 11.464774551626844,
				"lat": 43.544900380731043
			},
			{
				"lng": 11.46477699928122,
				"lat": 43.544899339205308
			},
			{
				"lng": 11.464779439548453,
				"lat": 43.54489829250619
			},
			{
				"lng": 11.464781872314022,
				"lat": 43.544897240654784
			},
			{
				"lng": 11.46478429746338,
				"lat": 43.544896183672122
			},
			{
				"lng": 11.46478671488201,
				"lat": 43.54489512157933
			},
			{
				"lng": 11.464789124455402,
				"lat": 43.544894054397481
			},
			{
				"lng": 11.464791526069023,
				"lat": 43.544892982147651
			},
			{
				"lng": 11.464793919608354,
				"lat": 43.544891904850907
			},
			{
				"lng": 11.464796304958876,
				"lat": 43.544890822528373
			},
			{
				"lng": 11.464798682006069,
				"lat": 43.544889735201068
			},
			{
				"lng": 11.464801050635396,
				"lat": 43.54488864289015
			},
			{
				"lng": 11.46480341073234,
				"lat": 43.544887545616632
			},
			{
				"lng": 11.464805762182394,
				"lat": 43.544886443401637
			},
			{
				"lng": 11.464808104870999,
				"lat": 43.544885336266255
			},
			{
				"lng": 11.464810438683694,
				"lat": 43.544884224231481
			},
			{
				"lng": 11.464812763505886,
				"lat": 43.544883107318526
			},
			{
				"lng": 11.464815079223106,
				"lat": 43.544881985548365
			},
			{
				"lng": 11.46481738572079,
				"lat": 43.544880858942165
			},
			{
				"lng": 11.464819682884453,
				"lat": 43.544879727520943
			},
			{
				"lng": 11.464821970599543,
				"lat": 43.544878591305789
			},
			{
				"lng": 11.464824248751574,
				"lat": 43.544877450317834
			},
			{
				"lng": 11.464826517225976,
				"lat": 43.544876304578075
			},
			{
				"lng": 11.46482877590827,
				"lat": 43.544875154107679
			},
			{
				"lng": 11.464831024683908,
				"lat": 43.544873998927699
			},
			{
				"lng": 11.464833263438361,
				"lat": 43.544872839059181
			},
			{
				"lng": 11.464835492057132,
				"lat": 43.544871674523257
			},
			{
				"lng": 11.464837710425687,
				"lat": 43.54487050534096
			},
			{
				"lng": 11.464839918429503,
				"lat": 43.544869331533441
			},
			{
				"lng": 11.464842115954063,
				"lat": 43.544868153121705
			},
			{
				"lng": 11.464844302884824,
				"lat": 43.544866970126883
			},
			{
				"lng": 11.464846479107292,
				"lat": 43.544865782570028
			},
			{
				"lng": 11.464848644506931,
				"lat": 43.544864590472272
			},
			{
				"lng": 11.464850798969218,
				"lat": 43.544863393854627
			},
			{
				"lng": 11.464852942379627,
				"lat": 43.544862192738201
			},
			{
				"lng": 11.464855074623644,
				"lat": 43.544860987144119
			},
			{
				"lng": 11.464857195586754,
				"lat": 43.544859777093407
			},
			{
				"lng": 11.46485930515442,
				"lat": 43.544858562607153
			},
			{
				"lng": 11.464861403212128,
				"lat": 43.544857343706504
			},
			{
				"lng": 11.464863489645349,
				"lat": 43.544856120412454
			},
			{
				"lng": 11.46486556433956,
				"lat": 43.544854892746123
			},
			{
				"lng": 11.464867627180258,
				"lat": 43.544853660728542
			},
			{
				"lng": 11.464869678052903,
				"lat": 43.544852424380913
			},
			{
				"lng": 11.464871716842959,
				"lat": 43.544851183724234
			},
			{
				"lng": 11.464873743435948,
				"lat": 43.544849938779599
			},
			{
				"lng": 11.464875757717312,
				"lat": 43.544848689568099
			},
			{
				"lng": 11.464877759572541,
				"lat": 43.544847436110778
			},
			{
				"lng": 11.4648797488871,
				"lat": 43.544846178428756
			},
			{
				"lng": 11.464881725546482,
				"lat": 43.544844916543113
			},
			{
				"lng": 11.464883689436174,
				"lat": 43.544843650474945
			},
			{
				"lng": 11.464885640441629,
				"lat": 43.544842380245278
			},
			{
				"lng": 11.464887578448346,
				"lat": 43.544841105875257
			},
			{
				"lng": 11.464889503341793,
				"lat": 43.544839827385921
			},
			{
				"lng": 11.464891415007443,
				"lat": 43.544838544798367
			},
			{
				"lng": 11.464893313330776,
				"lat": 43.544837258133683
			},
			{
				"lng": 11.464895198197286,
				"lat": 43.544835967412922
			},
			{
				"lng": 11.464897069492446,
				"lat": 43.544834672657196
			},
			{
				"lng": 11.464898927101713,
				"lat": 43.544833373887606
			},
			{
				"lng": 11.464900770910591,
				"lat": 43.544832071125192
			},
			{
				"lng": 11.464902600804546,
				"lat": 43.544830764391044
			},
			{
				"lng": 11.464904416669045,
				"lat": 43.544829453706249
			},
			{
				"lng": 11.464906218389599,
				"lat": 43.544828139091898
			},
			{
				"lng": 11.464908005851656,
				"lat": 43.544826820569057
			},
			{
				"lng": 11.464909778940719,
				"lat": 43.544825498158829
			},
			{
				"lng": 11.464911537542241,
				"lat": 43.54482417188229
			},
			{
				"lng": 11.464913281541707,
				"lat": 43.544822841760521
			},
			{
				"lng": 11.46491501082461,
				"lat": 43.544821507814575
			},
			{
				"lng": 11.464916725276417,
				"lat": 43.544820170065549
			},
			{
				"lng": 11.464918424782599,
				"lat": 43.544818828534574
			},
			{
				"lng": 11.464920109228649,
				"lat": 43.544817483242653
			},
			{
				"lng": 11.464921778500045,
				"lat": 43.544816134210919
			},
			{
				"lng": 11.464923432482255,
				"lat": 43.544814781460424
			},
			{
				"lng": 11.464925071062449,
				"lat": 43.544813425017509
			},
			{
				"lng": 11.46492669416824,
				"lat": 43.544812065033987
			},
			{
				"lng": 11.464928301768801,
				"lat": 43.544810701790517
			},
			{
				"lng": 11.464929893835173,
				"lat": 43.544809335573639
			},
			{
				"lng": 11.464931470338392,
				"lat": 43.544807966669858
			},
			{
				"lng": 11.46493303124951,
				"lat": 43.544806595365763
			},
			{
				"lng": 11.464934576539566,
				"lat": 43.544805221947776
			},
			{
				"lng": 11.464936106179589,
				"lat": 43.544803846702465
			},
			{
				"lng": 11.464937620140654,
				"lat": 43.544802469916412
			},
			{
				"lng": 11.464939118393785,
				"lat": 43.54480109187606
			},
			{
				"lng": 11.464940600910028,
				"lat": 43.544799712867984
			},
			{
				"lng": 11.464942067660434,
				"lat": 43.544798333178655
			},
			{
				"lng": 11.464943518616025,
				"lat": 43.544796953094703
			},
			{
				"lng": 11.464944953747873,
				"lat": 43.544795572902537
			},
			{
				"lng": 11.464946373027008,
				"lat": 43.54479419288873
			},
			{
				"lng": 11.464947776424484,
				"lat": 43.544792813339832
			},
			{
				"lng": 11.464949163911319,
				"lat": 43.544791434542297
			},
			{
				"lng": 11.464950535458584,
				"lat": 43.544790056782702
			},
			{
				"lng": 11.464951891037311,
				"lat": 43.544788680347565
			},
			{
				"lng": 11.464953230618557,
				"lat": 43.5447873055234
			},
			{
				"lng": 11.464954554173344,
				"lat": 43.54478593259676
			},
			{
				"lng": 11.464955861672729,
				"lat": 43.544784561854122
			},
			{
				"lng": 11.464957153087759,
				"lat": 43.544783193582028
			},
			{
				"lng": 11.464958428389474,
				"lat": 43.544781828067052
			},
			{
				"lng": 11.464959687548927,
				"lat": 43.54478046559565
			},
			{
				"lng": 11.464960930537142,
				"lat": 43.544779106454371
			},
			{
				"lng": 11.464962157325173,
				"lat": 43.544777750929732
			},
			{
				"lng": 11.464963367884074,
				"lat": 43.544776399308276
			},
			{
				"lng": 11.464964562184875,
				"lat": 43.544775051876506
			},
			{
				"lng": 11.464965740198629,
				"lat": 43.544773708920964
			},
			{
				"lng": 11.464966901896384,
				"lat": 43.544772370728168
			},
			{
				"lng": 11.464968047249169,
				"lat": 43.54477103758466
			},
			{
				"lng": 11.464969176228047,
				"lat": 43.544769709776936
			},
			{
				"lng": 11.464970288804045,
				"lat": 43.544768387591503
			},
			{
				"lng": 11.464971384948221,
				"lat": 43.544767071314958
			},
			{
				"lng": 11.464972464631604,
				"lat": 43.544765761233755
			},
			{
				"lng": 11.464973527825256,
				"lat": 43.544764457634415
			},
			{
				"lng": 11.46497457450022,
				"lat": 43.544763160803548
			},
			{
				"lng": 11.464975604627528,
				"lat": 43.544761871027575
			},
			{
				"lng": 11.464976618178225,
				"lat": 43.544760588593086
			},
			{
				"lng": 11.464977615123363,
				"lat": 43.544759313786592
			},
			{
				"lng": 11.46497859543398,
				"lat": 43.544758046894621
			},
			{
				"lng": 11.46497955908114,
				"lat": 43.544756788203685
			},
			{
				"lng": 11.464980506035864,
				"lat": 43.544755538000281
			},
			{
				"lng": 11.464981436269197,
				"lat": 43.544754296570979
			},
			{
				"lng": 11.464982349752203,
				"lat": 43.544753064202261
			},
			{
				"lng": 11.464983246455901,
				"lat": 43.544751841180691
			},
			{
				"lng": 11.464984126351359,
				"lat": 43.544750627792766
			},
			{
				"lng": 11.464984989409608,
				"lat": 43.544749424325047
			},
			{
				"lng": 11.464985835601688,
				"lat": 43.544748231064055
			},
			{
				"lng": 11.46498666489866,
				"lat": 43.54474704829628
			},
			{
				"lng": 11.464987477271558,
				"lat": 43.544745876308248
			},
			{
				"lng": 11.464988272691418,
				"lat": 43.544744715386507
			},
			{
				"lng": 11.464989051129317,
				"lat": 43.544743565817548
			},
			{
				"lng": 11.464989812556269,
				"lat": 43.544742427887911
			},
			{
				"lng": 11.464990556943313,
				"lat": 43.544741301884152
			},
			{
				"lng": 11.464991284261526,
				"lat": 43.544740188092753
			},
			{
				"lng": 11.464991994481927,
				"lat": 43.544739086800256
			},
			{
				"lng": 11.464992687575556,
				"lat": 43.544737998293165
			},
			{
				"lng": 11.464993363513472,
				"lat": 43.54473692285805
			},
			{
				"lng": 11.464994022266715,
				"lat": 43.54473586078138
			},
			{
				"lng": 11.464994663806339,
				"lat": 43.544734812349709
			},
			{
				"lng": 11.464995288103371,
				"lat": 43.544733777849622
			},
			{
				"lng": 11.464995895128878,
				"lat": 43.544732757567523
			},
			{
				"lng": 11.46499648485387,
				"lat": 43.544731751789989
			},
			{
				"lng": 11.464997057249422,
				"lat": 43.544730760803539
			},
			{
				"lng": 11.464997612286568,
				"lat": 43.544729784894727
			},
			{
				"lng": 11.464998149936342,
				"lat": 43.544728824350038
			},
			{
				"lng": 11.464998670169802,
				"lat": 43.544727879456026
			},
			{
				"lng": 11.464999172958001,
				"lat": 43.544726950499239
			},
			{
				"lng": 11.464999658271946,
				"lat": 43.544726037766097
			},
			{
				"lng": 11.465000126082735,
				"lat": 43.544725141543232
			},
			{
				"lng": 11.465000576361366,
				"lat": 43.544724262117107
			},
			{
				"lng": 11.465001009078902,
				"lat": 43.544723399774291
			},
			{
				"lng": 11.465001424206395,
				"lat": 43.544722554801268
			},
			{
				"lng": 11.465001821714871,
				"lat": 43.544721727484585
			},
			{
				"lng": 11.465002201575402,
				"lat": 43.544720918110762
			},
			{
				"lng": 11.465002384878609,
				"lat": 43.54472052024196
			},
			{
				"lng": 11.465002563758983,
				"lat": 43.54472012696629
			},
			{
				"lng": 11.465002738212888,
				"lat": 43.54471973831965
			},
			{
				"lng": 11.465002908236709,
				"lat": 43.544719354337758
			},
			{
				"lng": 11.465003073826825,
				"lat": 43.544718975056469
			},
			{
				"lng": 11.465003234979598,
				"lat": 43.544718600511644
			},
			{
				"lng": 11.46500339169144,
				"lat": 43.544718230739015
			},
			{
				"lng": 11.465003543958913,
				"lat": 43.544717865773997
			},
			{
				"lng": 11.465003691789287,
				"lat": 43.544717505627112
			},
			{
				"lng": 11.465003835205543,
				"lat": 43.544717150272405
			},
			{
				"lng": 11.465003974231912,
				"lat": 43.544716799681034
			},
			{
				"lng": 11.465004108892636,
				"lat": 43.544716453824158
			},
			{
				"lng": 11.465004239211948,
				"lat": 43.544716112672944
			},
			{
				"lng": 11.465004365214083,
				"lat": 43.544715776198537
			},
			{
				"lng": 11.46500460436377,
				"lat": 43.544715117164657
			},
			{
				"lng": 11.465004826535569,
				"lat": 43.544714476491784
			},
			{
				"lng": 11.465005031923377,
				"lat": 43.544713853949055
			},
			{
				"lng": 11.465005220721075,
				"lat": 43.544713249305751
			},
			{
				"lng": 11.465005393122535,
				"lat": 43.544712662330987
			},
			{
				"lng": 11.465005549321654,
				"lat": 43.544712092794008
			},
			{
				"lng": 11.465005689512322,
				"lat": 43.544711540463979
			},
			{
				"lng": 11.465005813888407,
				"lat": 43.544711005110173
			},
			{
				"lng": 11.465005922643813,
				"lat": 43.544710486501714
			},
			{
				"lng": 11.465006015972399,
				"lat": 43.544709984407817
			},
			{
				"lng": 11.465006094068061,
				"lat": 43.544709498597705
			},
			{
				"lng": 11.465006157124694,
				"lat": 43.544709028840501
			},
			{
				"lng": 11.465006205336172,
				"lat": 43.54470857490557
			},
			{
				"lng": 11.465006238896377,
				"lat": 43.544708136561908
			},
			{
				"lng": 11.465006257999189,
				"lat": 43.544707713578887
			},
			{
				"lng": 11.465006262838495,
				"lat": 43.544707305725595
			},
			{
				"lng": 11.465006253608191,
				"lat": 43.544706912771275
			},
			{
				"lng": 11.465006230502146,
				"lat": 43.54470653448508
			},
			{
				"lng": 11.465006193714256,
				"lat": 43.544706170636267
			},
			{
				"lng": 11.465006143438405,
				"lat": 43.544705820994032
			},
			{
				"lng": 11.465006079868465,
				"lat": 43.544705485327547
			},
			{
				"lng": 11.465006003198315,
				"lat": 43.544705163405979
			},
			{
				"lng": 11.465005913621857,
				"lat": 43.544704854998599
			},
			{
				"lng": 11.465005811332961,
				"lat": 43.544704559874575
			},
			{
				"lng": 11.46500569652552,
				"lat": 43.544704277803099
			},
			{
				"lng": 11.465005569393409,
				"lat": 43.54470400855336
			},
			{
				"lng": 11.465005430130525,
				"lat": 43.544703751894573
			},
			{
				"lng": 11.465005278930731,
				"lat": 43.544703507595955
			},
			{
				"lng": 11.465005115987941,
				"lat": 43.544703275426677
			},
			{
				"lng": 11.465004941496005,
				"lat": 43.544703055155942
			},
			{
				"lng": 11.46500475564882,
				"lat": 43.544702846552923
			},
			{
				"lng": 11.465004558640279,
				"lat": 43.544702649386885
			},
			{
				"lng": 11.465004350664261,
				"lat": 43.544702463426972
			},
			{
				"lng": 11.465004131914645,
				"lat": 43.54470228844243
			},
			{
				"lng": 11.465003902585318,
				"lat": 43.544702124202374
			},
			{
				"lng": 11.465003662870155,
				"lat": 43.544701970476112
			},
			{
				"lng": 11.465003412963043,
				"lat": 43.544701827032725
			},
			{
				"lng": 11.465003153057877,
				"lat": 43.544701693641493
			},
			{
				"lng": 11.465002883348534,
				"lat": 43.544701570071631
			},
			{
				"lng": 11.465002604028889,
				"lat": 43.544701456092284
			},
			{
				"lng": 11.465002315292843,
				"lat": 43.544701351472675
			},
			{
				"lng": 11.465002017334257,
				"lat": 43.544701255982005
			},
			{
				"lng": 11.465001710347039,
				"lat": 43.544701169389434
			},
			{
				"lng": 11.465001394525052,
				"lat": 43.544701091464191
			},
			{
				"lng": 11.465001070062188,
				"lat": 43.544701021975442
			},
			{
				"lng": 11.465000737152334,
				"lat": 43.544700960692509
			},
			{
				"lng": 11.465000395989364,
				"lat": 43.544700907384481
			},
			{
				"lng": 11.465000046767171,
				"lat": 43.544700861820495
			},
			{
				"lng": 11.464999689679633,
				"lat": 43.544700823769915
			},
			{
				"lng": 11.464999324920639,
				"lat": 43.544700793001837
			},
			{
				"lng": 11.464998952684065,
				"lat": 43.54470076928547
			},
			{
				"lng": 11.46499857316379,
				"lat": 43.544700752390007
			},
			{
				"lng": 11.464998186553713,
				"lat": 43.544700742084643
			},
			{
				"lng": 11.464997793047722,
				"lat": 43.544700738138658
			},
			{
				"lng": 11.46499739283967,
				"lat": 43.544700740321147
			},
			{
				"lng": 11.46499698612347,
				"lat": 43.544700748401347
			},
			{
				"lng": 11.464996573092987,
				"lat": 43.544700762148473
			},
			{
				"lng": 11.464996153942117,
				"lat": 43.544700781331692
			},
			{
				"lng": 11.464995728864736,
				"lat": 43.54470080572024
			},
			{
				"lng": 11.464995298054729,
				"lat": 43.544700835083269
			},
			{
				"lng": 11.464994861705984,
				"lat": 43.544700869190052
			},
			{
				"lng": 11.464994420012371,
				"lat": 43.54470090780967
			},
			{
				"lng": 11.464993521366134,
				"lat": 43.544700997664513
			},
			{
				"lng": 11.464992603667051,
				"lat": 43.544701102801334
			},
			{
				"lng": 11.464991668466213,
				"lat": 43.544701221373771
			},
			{
				"lng": 11.464990717314679,
				"lat": 43.544701351535387
			},
			{
				"lng": 11.464989751763525,
				"lat": 43.544701491439788
			},
			{
				"lng": 11.464988773363807,
				"lat": 43.544701639240536
			},
			{
				"lng": 11.464987783666613,
				"lat": 43.544701793091242
			},
			{
				"lng": 11.464986784206223,
				"lat": 43.544701951170786
			},
			{
				"lng": 11.464985775971261,
				"lat": 43.544702112480309
			},
			{
				"lng": 11.464984759297508,
				"lat": 43.544702277004703
			},
			{
				"lng": 11.464983734482349,
				"lat": 43.5447024447868
			},
			{
				"lng": 11.464982701823144,
				"lat": 43.544702615869461
			},
			{
				"lng": 11.464981661617283,
				"lat": 43.544702790295432
			},
			{
				"lng": 11.464980614162128,
				"lat": 43.544702968107494
			},
			{
				"lng": 11.464979559755038,
				"lat": 43.544703149348535
			},
			{
				"lng": 11.464978498693412,
				"lat": 43.544703334061289
			},
			{
				"lng": 11.464977431274612,
				"lat": 43.5447035222886
			},
			{
				"lng": 11.464976357796015,
				"lat": 43.544703714073293
			},
			{
				"lng": 11.464974193848914,
				"lat": 43.544704108485917
			},
			{
				"lng": 11.464972009231092,
				"lat": 43.544704517641655
			},
			{
				"lng": 11.464969806321522,
				"lat": 43.544704941882983
			},
			{
				"lng": 11.464967587499205,
				"lat": 43.544705381552312
			},
			{
				"lng": 11.464965355143121,
				"lat": 43.544705836992115
			},
			{
				"lng": 11.464963111632262,
				"lat": 43.544706308544875
			},
			{
				"lng": 11.464960859345604,
				"lat": 43.544706796553001
			},
			{
				"lng": 11.464958600662134,
				"lat": 43.544707301359004
			},
			{
				"lng": 11.464956337960857,
				"lat": 43.544707823305259
			},
			{
				"lng": 11.464954073620717,
				"lat": 43.544708362734312
			},
			{
				"lng": 11.464951810020738,
				"lat": 43.544708919988622
			},
			{
				"lng": 11.464949549539888,
				"lat": 43.544709495410565
			},
			{
				"lng": 11.464947294557152,
				"lat": 43.544710089342658
			},
			{
				"lng": 11.464945047451529,
				"lat": 43.544710702127375
			},
			{
				"lng": 11.46494281060053,
				"lat": 43.544711334107134
			},
			{
				"lng": 11.464940585558182,
				"lat": 43.544711985638287
			},
			{
				"lng": 11.464938371682484,
				"lat": 43.544712657113919
			},
			{
				"lng": 11.464936167969352,
				"lat": 43.544713348933165
			},
			{
				"lng": 11.4649339734147,
				"lat": 43.544714061495164
			},
			{
				"lng": 11.464931787014443,
				"lat": 43.544714795199148
			},
			{
				"lng": 11.464929607764519,
				"lat": 43.544715550444295
			},
			{
				"lng": 11.464928520507147,
				"lat": 43.54471593626949
			},
			{
				"lng": 11.464927434660812,
				"lat": 43.544716327629665
			},
			{
				"lng": 11.464926350100031,
				"lat": 43.544716724574734
			},
			{
				"lng": 11.464925266699256,
				"lat": 43.544717127154534
			},
			{
				"lng": 11.464924184333011,
				"lat": 43.544717535419004
			},
			{
				"lng": 11.46492310287576,
				"lat": 43.544717949418001
			},
			{
				"lng": 11.464922022202016,
				"lat": 43.544718369201448
			},
			{
				"lng": 11.464920942186254,
				"lat": 43.544718794819232
			},
			{
				"lng": 11.46491986270297,
				"lat": 43.544719226321291
			},
			{
				"lng": 11.46491878362664,
				"lat": 43.544719663757448
			},
			{
				"lng": 11.464917704831763,
				"lat": 43.54472010717766
			},
			{
				"lng": 11.464916626192828,
				"lat": 43.544720556631766
			},
			{
				"lng": 11.464915547584333,
				"lat": 43.54472101216971
			},
			{
				"lng": 11.464914468880755,
				"lat": 43.544721473841385
			},
			{
				"lng": 11.464913389956587,
				"lat": 43.544721941696622
			},
			{
				"lng": 11.464912310686328,
				"lat": 43.544722415785387
			},
			{
				"lng": 11.464911230944448,
				"lat": 43.544722896157545
			},
			{
				"lng": 11.46491015060545,
				"lat": 43.544723382863026
			},
			{
				"lng": 11.464909069543824,
				"lat": 43.544723875951703
			},
			{
				"lng": 11.464907987634048,
				"lat": 43.544724375473443
			},
			{
				"lng": 11.464906904750622,
				"lat": 43.54472488147816
			},
			{
				"lng": 11.464905820768047,
				"lat": 43.544725394015778
			},
			{
				"lng": 11.464904735560776,
				"lat": 43.544725913136162
			},
			{
				"lng": 11.464903649003331,
				"lat": 43.544726438889214
			},
			{
				"lng": 11.464902560970192,
				"lat": 43.544726971324828
			},
			{
				"lng": 11.464901471335839,
				"lat": 43.544727510492891
			},
			{
				"lng": 11.464900379974781,
				"lat": 43.544728056443333
			},
			{
				"lng": 11.464899286761536,
				"lat": 43.544728609225899
			},
			{
				"lng": 11.464898191619996,
				"lat": 43.544729168805297
			},
			{
				"lng": 11.464897094613114,
				"lat": 43.544729734905822
			},
			{
				"lng": 11.464895995828279,
				"lat": 43.544730307209704
			},
			{
				"lng": 11.464894895352851,
				"lat": 43.544730885399225
			},
			{
				"lng": 11.464892689679727,
				"lat": 43.544732058164008
			},
			{
				"lng": 11.46489047829267,
				"lat": 43.544733250658155
			},
			{
				"lng": 11.464888261890634,
				"lat": 43.544734460339534
			},
			{
				"lng": 11.464886041172576,
				"lat": 43.544735684666101
			},
			{
				"lng": 11.464883816837441,
				"lat": 43.544736921095748
			},
			{
				"lng": 11.464881589584177,
				"lat": 43.544738167086429
			},
			{
				"lng": 11.464879360111748,
				"lat": 43.544739420096001
			},
			{
				"lng": 11.464874897305162,
				"lat": 43.544741937003629
			},
			{
				"lng": 11.46487043400932,
				"lat": 43.544744451481975
			},
			{
				"lng": 11.464868203925294,
				"lat": 43.54474570145495
			},
			{
				"lng": 11.464865975815826,
				"lat": 43.544746943194411
			},
			{
				"lng": 11.464863750379864,
				"lat": 43.544748174158222
			},
			{
				"lng": 11.464861528316348,
				"lat": 43.544749391804316
			},
			{
				"lng": 11.464859310324236,
				"lat": 43.544750593590599
			},
			{
				"lng": 11.464857097102501,
				"lat": 43.544751776975019
			},
			{
				"lng": 11.464855992498936,
				"lat": 43.544752360972105
			},
			{
				"lng": 11.464854889350072,
				"lat": 43.544752939415474
			},
			{
				"lng": 11.464853787753725,
				"lat": 43.544753512032663
			},
			{
				"lng": 11.464852687854714,
				"lat": 43.544754078755481
			},
			{
				"lng": 11.464851589811072,
				"lat": 43.544754639572993
			},
			{
				"lng": 11.464850493780849,
				"lat": 43.544755194474426
			},
			{
				"lng": 11.464849399922079,
				"lat": 43.54475574344886
			},
			{
				"lng": 11.464848308392783,
				"lat": 43.544756286485431
			},
			{
				"lng": 11.464847219351018,
				"lat": 43.544756823573302
			},
			{
				"lng": 11.464846132954811,
				"lat": 43.544757354701595
			},
			{
				"lng": 11.464845049362202,
				"lat": 43.544757879859468
			},
			{
				"lng": 11.464843968731238,
				"lat": 43.544758399036091
			},
			{
				"lng": 11.46484289121994,
				"lat": 43.544758912220509
			},
			{
				"lng": 11.464841816986366,
				"lat": 43.544759419401949
			},
			{
				"lng": 11.464840746188525,
				"lat": 43.544759920569518
			},
			{
				"lng": 11.464839678984481,
				"lat": 43.544760415712361
			},
			{
				"lng": 11.464838615532267,
				"lat": 43.544760904819604
			},
			{
				"lng": 11.464837555989909,
				"lat": 43.544761387880421
			},
			{
				"lng": 11.464836500515453,
				"lat": 43.544761864883924
			},
			{
				"lng": 11.46483544926693,
				"lat": 43.544762335819229
			},
			{
				"lng": 11.464834402402396,
				"lat": 43.544762800675535
			},
			{
				"lng": 11.464833360079862,
				"lat": 43.54476325944195
			},
			{
				"lng": 11.464832322457388,
				"lat": 43.54476371210761
			},
			{
				"lng": 11.464831289693008,
				"lat": 43.544764158661664
			},
			{
				"lng": 11.464830261944751,
				"lat": 43.54476459909322
			},
			{
				"lng": 11.464829239370657,
				"lat": 43.544765033391506
			},
			{
				"lng": 11.464828222128775,
				"lat": 43.544765461545566
			},
			{
				"lng": 11.464827210377111,
				"lat": 43.544765883544585
			},
			{
				"lng": 11.46482620427375,
				"lat": 43.544766299377685
			},
			{
				"lng": 11.464825203976684,
				"lat": 43.544766709033993
			},
			{
				"lng": 11.464824209643973,
				"lat": 43.544767112502733
			},
			{
				"lng": 11.46482322143367,
				"lat": 43.544767509772932
			},
			{
				"lng": 11.464822239503793,
				"lat": 43.544767900833783
			},
			{
				"lng": 11.464821264012372,
				"lat": 43.544768285674436
			},
			{
				"lng": 11.46482029511747,
				"lat": 43.544768664284021
			},
			{
				"lng": 11.464819332977093,
				"lat": 43.544769036651665
			},
			{
				"lng": 11.464818377749314,
				"lat": 43.544769402766555
			},
			{
				"lng": 11.464817429592141,
				"lat": 43.544769762617761
			},
			{
				"lng": 11.464816488663617,
				"lat": 43.544770116194449
			},
			{
				"lng": 11.464815555121788,
				"lat": 43.544770463485733
			},
			{
				"lng": 11.464814629124708,
				"lat": 43.544770804480905
			},
			{
				"lng": 11.464813710830382,
				"lat": 43.544771139168894
			},
			{
				"lng": 11.464812800369494,
				"lat": 43.54477146754936
			},
			{
				"lng": 11.464811897672918,
				"lat": 43.544771789697741
			},
			{
				"lng": 11.464811002582966,
				"lat": 43.544772105723197
			},
			{
				"lng": 11.464810114941583,
				"lat": 43.544772415734997
			},
			{
				"lng": 11.464809234590666,
				"lat": 43.544772719842456
			},
			{
				"lng": 11.464808361372135,
				"lat": 43.544773018154793
			},
			{
				"lng": 11.46480749512792,
				"lat": 43.544773310781352
			},
			{
				"lng": 11.464806635699954,
				"lat": 43.54477359783138
			},
			{
				"lng": 11.46480578293013,
				"lat": 43.544773879414215
			},
			{
				"lng": 11.464804936660375,
				"lat": 43.544774155639111
			},
			{
				"lng": 11.464804096732637,
				"lat": 43.544774426615334
			},
			{
				"lng": 11.464803262988795,
				"lat": 43.544774692452179
			},
			{
				"lng": 11.464802435270798,
				"lat": 43.544774953258965
			},
			{
				"lng": 11.46480161342056,
				"lat": 43.544775209144952
			},
			{
				"lng": 11.464800797280002,
				"lat": 43.544775460219405
			},
			{
				"lng": 11.46479998669103,
				"lat": 43.544775706591658
			},
			{
				"lng": 11.464799181495589,
				"lat": 43.544775948370962
			},
			{
				"lng": 11.464798381535578,
				"lat": 43.544776185666628
			},
			{
				"lng": 11.464796796689567,
				"lat": 43.544776647244106
			},
			{
				"lng": 11.464795230888367,
				"lat": 43.544777092198352
			},
			{
				"lng": 11.464793682867318,
				"lat": 43.544777521403681
			},
			{
				"lng": 11.464792151361806,
				"lat": 43.54477793573448
			},
			{
				"lng": 11.464790635107178,
				"lat": 43.544778336064844
			},
			{
				"lng": 11.464789132838801,
				"lat": 43.544778723269182
			},
			{
				"lng": 11.464787643292054,
				"lat": 43.544779098221731
			},
			{
				"lng": 11.464786165202259,
				"lat": 43.544779461796793
			},
			{
				"lng": 11.464784697304825,
				"lat": 43.544779814868647
			},
			{
				"lng": 11.464783238335093,
				"lat": 43.544780158311561
			},
			{
				"lng": 11.464781787028416,
				"lat": 43.544780492999834
			},
			{
				"lng": 11.464780341642797,
				"lat": 43.544780820085016
			},
			{
				"lng": 11.464777447200921,
				"lat": 43.544781464454438
			},
			{
				"lng": 11.464775985363621,
				"lat": 43.544781789441764
			},
			{
				"lng": 11.464774505258237,
				"lat": 43.5447821214347
			},
			{
				"lng": 11.46477375635725,
				"lat": 43.544782291262266
			},
			{
				"lng": 11.464773000491926,
				"lat": 43.544782464286101
			},
			{
				"lng": 11.464772236863141,
				"lat": 43.544782640987769
			},
			{
				"lng": 11.464771464671792,
				"lat": 43.544782821848955
			},
			{
				"lng": 11.464770683118768,
				"lat": 43.544783007351185
			},
			{
				"lng": 11.464769891404964,
				"lat": 43.544783197976088
			},
			{
				"lng": 11.464769088731277,
				"lat": 43.544783394205325
			},
			{
				"lng": 11.464768274298589,
				"lat": 43.544783596520453
			},
			{
				"lng": 11.464767447307787,
				"lat": 43.544783805403085
			},
			{
				"lng": 11.464766606959765,
				"lat": 43.544784021334877
			},
			{
				"lng": 11.464765752455438,
				"lat": 43.544784244797441
			},
			{
				"lng": 11.464764882995656,
				"lat": 43.544784476272362
			},
			{
				"lng": 11.464763997781333,
				"lat": 43.544784716241267
			},
			{
				"lng": 11.46476309601335,
				"lat": 43.544784965185741
			},
			{
				"lng": 11.464762176892615,
				"lat": 43.544785223587411
			},
			{
				"lng": 11.464761239619992,
				"lat": 43.544785491927897
			},
			{
				"lng": 11.464760283396389,
				"lat": 43.544785770688833
			},
			{
				"lng": 11.464759307422693,
				"lat": 43.544786060351775
			},
			{
				"lng": 11.464758310899807,
				"lat": 43.54478636139838
			},
			{
				"lng": 11.464757293028587,
				"lat": 43.544786674310231
			},
			{
				"lng": 11.464756253009952,
				"lat": 43.544786999568956
			},
			{
				"lng": 11.46475519004478,
				"lat": 43.544787337656217
			},
			{
				"lng": 11.46475410333397,
				"lat": 43.544787689053535
			},
			{
				"lng": 11.464753550824234,
				"lat": 43.54478786989398
			},
			{
				"lng": 11.464752992078417,
				"lat": 43.544788054242559
			},
			{
				"lng": 11.464752426996627,
				"lat": 43.544788242159477
			},
			{
				"lng": 11.464751855478985,
				"lat": 43.544788433704895
			},
			{
				"lng": 11.464751277425608,
				"lat": 43.544788628939088
			},
			{
				"lng": 11.464750692736581,
				"lat": 43.54478882792219
			},
			{
				"lng": 11.464750101312044,
				"lat": 43.544789030714469
			},
			{
				"lng": 11.464749503052092,
				"lat": 43.544789237376023
			},
			{
				"lng": 11.464748897856847,
				"lat": 43.544789447967148
			},
			{
				"lng": 11.464748285626406,
				"lat": 43.544789662548013
			},
			{
				"lng": 11.464747666260902,
				"lat": 43.544789881178836
			},
			{
				"lng": 11.464747039660429,
				"lat": 43.544790103919787
			},
			{
				"lng": 11.464746405725098,
				"lat": 43.544790330831077
			},
			{
				"lng": 11.464745764355019,
				"lat": 43.544790561972917
			},
			{
				"lng": 11.464745115450324,
				"lat": 43.544790797405533
			},
			{
				"lng": 11.464744458929736,
				"lat": 43.544791037178875
			},
			{
				"lng": 11.464743794791129,
				"lat": 43.544791281299865
			},
			{
				"lng": 11.46474312305333,
				"lat": 43.54479152976382
			},
			{
				"lng": 11.464742443735167,
				"lat": 43.544791782566193
			},
			{
				"lng": 11.464741756855453,
				"lat": 43.544792039702372
			},
			{
				"lng": 11.464741062433013,
				"lat": 43.544792301167739
			},
			{
				"lng": 11.464740360486694,
				"lat": 43.544792566957717
			},
			{
				"lng": 11.464739651035311,
				"lat": 43.544792837067646
			},
			{
				"lng": 11.46473893409768,
				"lat": 43.544793111492929
			},
			{
				"lng": 11.464738209692632,
				"lat": 43.544793390228982
			},
			{
				"lng": 11.464737477839003,
				"lat": 43.544793673271215
			},
			{
				"lng": 11.464736738555608,
				"lat": 43.544793960614975
			},
			{
				"lng": 11.464735991861293,
				"lat": 43.544794252255691
			},
			{
				"lng": 11.46473523777485,
				"lat": 43.544794548188733
			},
			{
				"lng": 11.464734476315131,
				"lat": 43.544794848409531
			},
			{
				"lng": 11.464733707500958,
				"lat": 43.544795152913437
			},
			{
				"lng": 11.464732931351149,
				"lat": 43.544795461695891
			},
			{
				"lng": 11.464732147884526,
				"lat": 43.544795774752231
			},
			{
				"lng": 11.464731357119945,
				"lat": 43.544796092077895
			},
			{
				"lng": 11.4647305590762,
				"lat": 43.544796413668244
			},
			{
				"lng": 11.464729753772126,
				"lat": 43.544796739518709
			},
			{
				"lng": 11.464728941226552,
				"lat": 43.54479706962465
			},
			{
				"lng": 11.464728121458307,
				"lat": 43.544797403981498
			},
			{
				"lng": 11.464727294486215,
				"lat": 43.544797742584599
			},
			{
				"lng": 11.464726460329103,
				"lat": 43.544798085429335
			},
			{
				"lng": 11.464725619005787,
				"lat": 43.544798432511207
			},
			{
				"lng": 11.464724770535094,
				"lat": 43.544798783825485
			},
			{
				"lng": 11.46472391493586,
				"lat": 43.544799139367633
			},
			{
				"lng": 11.464723052226921,
				"lat": 43.544799499133013
			},
			{
				"lng": 11.464722182427066,
				"lat": 43.544799863117056
			},
			{
				"lng": 11.464721305555164,
				"lat": 43.544800231315129
			},
			{
				"lng": 11.464720421630012,
				"lat": 43.544800603722649
			},
			{
				"lng": 11.464719530670452,
				"lat": 43.544800980334948
			},
			{
				"lng": 11.464718632695305,
				"lat": 43.544801361147471
			},
			{
				"lng": 11.464717727723386,
				"lat": 43.544801746155613
			},
			{
				"lng": 11.464716815773539,
				"lat": 43.54480213535475
			},
			{
				"lng": 11.464715896864591,
				"lat": 43.544802528740306
			},
			{
				"lng": 11.464714971015338,
				"lat": 43.544802926307632
			},
			{
				"lng": 11.464714038244635,
				"lat": 43.544803328052097
			},
			{
				"lng": 11.4647130985713,
				"lat": 43.544803733969218
			},
			{
				"lng": 11.464712152014162,
				"lat": 43.544804144054268
			},
			{
				"lng": 11.464711198592054,
				"lat": 43.544804558302701
			},
			{
				"lng": 11.464710238323768,
				"lat": 43.544804976709891
			},
			{
				"lng": 11.464709271228163,
				"lat": 43.544805399271219
			},
			{
				"lng": 11.464708297324066,
				"lat": 43.544805825982067
			},
			{
				"lng": 11.464707316630276,
				"lat": 43.544806256837902
			},
			{
				"lng": 11.464706329165649,
				"lat": 43.544806691834047
			},
			{
				"lng": 11.464705334948992,
				"lat": 43.544807130965907
			},
			{
				"lng": 11.464704333999126,
				"lat": 43.544807574228912
			},
			{
				"lng": 11.464703326334909,
				"lat": 43.544808021618429
			},
			{
				"lng": 11.464702311975138,
				"lat": 43.544808473129827
			},
			{
				"lng": 11.464701290938637,
				"lat": 43.544808928758592
			},
			{
				"lng": 11.464700263244264,
				"lat": 43.544809388499999
			},
			{
				"lng": 11.464699228910803,
				"lat": 43.544809852349495
			},
			{
				"lng": 11.464698187957111,
				"lat": 43.544810320302503
			},
			{
				"lng": 11.464697140401993,
				"lat": 43.544810792354355
			},
			{
				"lng": 11.464696086264276,
				"lat": 43.544811268500496
			},
			{
				"lng": 11.464695025562818,
				"lat": 43.544811748736301
			},
			{
				"lng": 11.464693958316408,
				"lat": 43.544812233057151
			},
			{
				"lng": 11.464692884543897,
				"lat": 43.544812721458491
			},
			{
				"lng": 11.464691804264085,
				"lat": 43.544813213935633
			},
			{
				"lng": 11.464690717495824,
				"lat": 43.544813710484064
			},
			{
				"lng": 11.46468962425792,
				"lat": 43.544814211099087
			},
			{
				"lng": 11.464688524569205,
				"lat": 43.544814715776134
			},
			{
				"lng": 11.464687418448515,
				"lat": 43.544815224510607
			},
			{
				"lng": 11.464686305914674,
				"lat": 43.544815737297924
			},
			{
				"lng": 11.464685186986493,
				"lat": 43.544816254133394
			},
			{
				"lng": 11.464684061682803,
				"lat": 43.544816775012485
			},
			{
				"lng": 11.464682930022446,
				"lat": 43.544817299930607
			},
			{
				"lng": 11.464681792024233,
				"lat": 43.544817828883083
			},
			{
				"lng": 11.464680647706986,
				"lat": 43.544818361865367
			},
			{
				"lng": 11.464679497089547,
				"lat": 43.544818898872819
			},
			{
				"lng": 11.464678340190737,
				"lat": 43.544819439900834
			},
			{
				"lng": 11.464677177029365,
				"lat": 43.544819984944802
			},
			{
				"lng": 11.464676007624274,
				"lat": 43.544820534000152
			},
			{
				"lng": 11.464674831994298,
				"lat": 43.54482108706226
			},
			{
				"lng": 11.464673650158227,
				"lat": 43.544821644126479
			},
			{
				"lng": 11.464672462134937,
				"lat": 43.544822205188261
			},
			{
				"lng": 11.464671267943215,
				"lat": 43.544822770242988
			},
			{
				"lng": 11.464670067601894,
				"lat": 43.544823339286026
			},
			{
				"lng": 11.464668861139128,
				"lat": 43.544823912307336
			},
			{
				"lng": 11.464667648691389,
				"lat": 43.544824489233889
			},
			{
				"lng": 11.464666430465034,
				"lat": 43.544825069951749
			},
			{
				"lng": 11.464663977506603,
				"lat": 43.544826242303685
			},
			{
				"lng": 11.464661503924054,
				"lat": 43.544827428447242
			},
			{
				"lng": 11.464659011377602,
				"lat": 43.544828627466522
			},
			{
				"lng": 11.464656501527489,
				"lat": 43.544829838445601
			},
			{
				"lng": 11.464653976033896,
				"lat": 43.544831060468553
			},
			{
				"lng": 11.464651436557073,
				"lat": 43.544832292619581
			},
			{
				"lng": 11.464648884757258,
				"lat": 43.544833533982676
			},
			{
				"lng": 11.464646322294641,
				"lat": 43.544834783641974
			},
			{
				"lng": 11.464643750829451,
				"lat": 43.544836040681517
			},
			{
				"lng": 11.464641172021929,
				"lat": 43.544837304185485
			},
			{
				"lng": 11.464635999020739,
				"lat": 43.544839846922855
			},
			{
				"lng": 11.464630816572869,
				"lat": 43.544842404526918
			},
			{
				"lng": 11.464625637960093,
				"lat": 43.5448449696704
			},
			{
				"lng": 11.464620476464219,
				"lat": 43.544847535026058
			},
			{
				"lng": 11.464617906285703,
				"lat": 43.544848815493744
			},
			{
				"lng": 11.464615345367072,
				"lat": 43.54485009326671
			},
			{
				"lng": 11.464612795368563,
				"lat": 43.544851367429104
			},
			{
				"lng": 11.464610257950437,
				"lat": 43.544852637065027
			},
			{
				"lng": 11.464607734772864,
				"lat": 43.544853901258563
			},
			{
				"lng": 11.464605227496126,
				"lat": 43.544855159093828
			},
			{
				"lng": 11.464602737780414,
				"lat": 43.544856409654948
			},
			{
				"lng": 11.464600267285984,
				"lat": 43.544857652025939
			},
			{
				"lng": 11.464597817673029,
				"lat": 43.544858885290928
			},
			{
				"lng": 11.464595390601792,
				"lat": 43.54486010853406
			},
			{
				"lng": 11.464592987732519,
				"lat": 43.544861320839352
			},
			{
				"lng": 11.46459179589244,
				"lat": 43.544861922604149
			},
			{
				"lng": 11.464590610725423,
				"lat": 43.544862521290995
			},
			{
				"lng": 11.464589432439016,
				"lat": 43.544863116785457
			},
			{
				"lng": 11.464588261240737,
				"lat": 43.54486370897299
			},
			{
				"lng": 11.46458709733812,
				"lat": 43.544864297739217
			},
			{
				"lng": 11.464585940938687,
				"lat": 43.544864882969541
			},
			{
				"lng": 11.464584792249969,
				"lat": 43.544865464549531
			},
			{
				"lng": 11.464583651479506,
				"lat": 43.544866042364653
			},
			{
				"lng": 11.464582518834801,
				"lat": 43.544866616300446
			},
			{
				"lng": 11.464581394523419,
				"lat": 43.54486718624247
			},
			{
				"lng": 11.464580278752853,
				"lat": 43.544867752076158
			},
			{
				"lng": 11.46457917173066,
				"lat": 43.544868313687033
			},
			{
				"lng": 11.464578073664343,
				"lat": 43.544868870960705
			},
			{
				"lng": 11.464576984761452,
				"lat": 43.544869423782536
			},
			{
				"lng": 11.464575905229511,
				"lat": 43.544869972038164
			},
			{
				"lng": 11.464574835276036,
				"lat": 43.544870515613027
			},
			{
				"lng": 11.464573775108578,
				"lat": 43.544871054392637
			},
			{
				"lng": 11.464572724934651,
				"lat": 43.544871588262552
			},
			{
				"lng": 11.464571684961768,
				"lat": 43.54487211710827
			},
			{
				"lng": 11.464570655394706,
				"lat": 43.54487264081709
			},
			{
				"lng": 11.464569636291627,
				"lat": 43.544873159369374
			},
			{
				"lng": 11.464568627495233,
				"lat": 43.544873672882431
			},
			{
				"lng": 11.46456762883092,
				"lat": 43.544874181484566
			},
			{
				"lng": 11.464566640124115,
				"lat": 43.544874685304052
			},
			{
				"lng": 11.464565661200247,
				"lat": 43.544875184469198
			},
			{
				"lng": 11.464564691884709,
				"lat": 43.544875679108316
			},
			{
				"lng": 11.464563732002949,
				"lat": 43.544876169349635
			},
			{
				"lng": 11.46456278138036,
				"lat": 43.544876655321445
			},
			{
				"lng": 11.464561839842354,
				"lat": 43.544877137152078
			},
			{
				"lng": 11.464560907214366,
				"lat": 43.544877614969764
			},
			{
				"lng": 11.464559983321811,
				"lat": 43.544878088902834
			},
			{
				"lng": 11.4645590679901,
				"lat": 43.544878559079557
			},
			{
				"lng": 11.464558161044652,
				"lat": 43.544879025628212
			},
			{
				"lng": 11.464557262310885,
				"lat": 43.544879488677083
			},
			{
				"lng": 11.464556371614211,
				"lat": 43.544879948354485
			},
			{
				"lng": 11.464555488780045,
				"lat": 43.544880404788678
			},
			{
				"lng": 11.464554613633837,
				"lat": 43.544880858107923
			},
			{
				"lng": 11.464553746000959,
				"lat": 43.544881308440587
			},
			{
				"lng": 11.464552885706857,
				"lat": 43.544881755914929
			},
			{
				"lng": 11.464552032576908,
				"lat": 43.54488220065916
			},
			{
				"lng": 11.46455034711127,
				"lat": 43.544883082470605
			},
			{
				"lng": 11.464548688207366,
				"lat": 43.54488395490128
			},
			{
				"lng": 11.464547054468518,
				"lat": 43.544884818977437
			},
			{
				"lng": 11.464545444498066,
				"lat": 43.544885675725368
			},
			{
				"lng": 11.464543856899367,
				"lat": 43.544886526171375
			},
			{
				"lng": 11.464542290275716,
				"lat": 43.544887371341709
			},
			{
				"lng": 11.46454074323049,
				"lat": 43.544888212262734
			},
			{
				"lng": 11.46453921436701,
				"lat": 43.544889049960652
			},
			{
				"lng": 11.464537702288592,
				"lat": 43.544889885461778
			},
			{
				"lng": 11.464536205598572,
				"lat": 43.544890719792413
			},
			{
				"lng": 11.464534722900313,
				"lat": 43.544891553978857
			},
			{
				"lng": 11.464533252797116,
				"lat": 43.544892389047376
			},
			{
				"lng": 11.46453179389232,
				"lat": 43.544893226024321
			},
			{
				"lng": 11.464530344789274,
				"lat": 43.544894065935864
			},
			{
				"lng": 11.464528904091317,
				"lat": 43.544894909808349
			},
			{
				"lng": 11.464527470401757,
				"lat": 43.544895758668098
			},
			{
				"lng": 11.464526042323929,
				"lat": 43.544896613541347
			},
			{
				"lng": 11.464524618461159,
				"lat": 43.54489747545437
			},
			{
				"lng": 11.464523197416822,
				"lat": 43.544898345433538
			},
			{
				"lng": 11.464521777794205,
				"lat": 43.544899224505066
			},
			{
				"lng": 11.464520358196664,
				"lat": 43.544900113695263
			},
			{
				"lng": 11.46451893722752,
				"lat": 43.544901014030437
			},
			{
				"lng": 11.46451751349011,
				"lat": 43.544901926536824
			},
			{
				"lng": 11.46451608558775,
				"lat": 43.544902852240739
			},
			{
				"lng": 11.464514652123794,
				"lat": 43.544903792168469
			},
			{
				"lng": 11.464513211701563,
				"lat": 43.544904747346315
			},
			{
				"lng": 11.464511762924378,
				"lat": 43.544905718800521
			},
			{
				"lng": 11.464510304395587,
				"lat": 43.544906707557452
			},
			{
				"lng": 11.464508834718517,
				"lat": 43.544907714643315
			},
			{
				"lng": 11.46450735249647,
				"lat": 43.544908741084434
			},
			{
				"lng": 11.464505856679152,
				"lat": 43.54490978758254
			},
			{
				"lng": 11.464504347522357,
				"lat": 43.544910853615328
			},
			{
				"lng": 11.464502825589781,
				"lat": 43.544911938371946
			},
			{
				"lng": 11.464501291445165,
				"lat": 43.544913041041582
			},
			{
				"lng": 11.464499745652201,
				"lat": 43.544914160813384
			},
			{
				"lng": 11.464498188774613,
				"lat": 43.544915296876546
			},
			{
				"lng": 11.464496621376098,
				"lat": 43.54491644842021
			},
			{
				"lng": 11.464495044020387,
				"lat": 43.544917614633569
			},
			{
				"lng": 11.46449345727118,
				"lat": 43.544918794705758
			},
			{
				"lng": 11.464491861692164,
				"lat": 43.544919987825935
			},
			{
				"lng": 11.464490257847094,
				"lat": 43.544921193183313
			},
			{
				"lng": 11.464488646299658,
				"lat": 43.544922409967043
			},
			{
				"lng": 11.464487027613576,
				"lat": 43.544923637366217
			},
			{
				"lng": 11.46448540235256,
				"lat": 43.544924874570121
			},
			{
				"lng": 11.4644837710803,
				"lat": 43.544926120767848
			},
			{
				"lng": 11.464482134360541,
				"lat": 43.544927375148646
			},
			{
				"lng": 11.464480492756989,
				"lat": 43.544928636901538
			},
			{
				"lng": 11.464478846833332,
				"lat": 43.54492990521581
			},
			{
				"lng": 11.464477197153309,
				"lat": 43.544931179280553
			},
			{
				"lng": 11.464473888778976,
				"lat": 43.544933741418269
			},
			{
				"lng": 11.464470572143705,
				"lat": 43.544936316828021
			},
			{
				"lng": 11.46446725175718,
				"lat": 43.544938899023109
			},
			{
				"lng": 11.464463932129121,
				"lat": 43.544941481516886
			},
			{
				"lng": 11.464460617769252,
				"lat": 43.544944057822697
			},
			{
				"lng": 11.464457313187259,
				"lat": 43.544946621453889
			},
			{
				"lng": 11.464455665972272,
				"lat": 43.544947896489425
			},
			{
				"lng": 11.464454022892882,
				"lat": 43.544949165923782
			},
			{
				"lng": 11.464452384512823,
				"lat": 43.544950428946137
			},
			{
				"lng": 11.464450751395828,
				"lat": 43.544951684745705
			},
			{
				"lng": 11.464449124105574,
				"lat": 43.544952932511592
			},
			{
				"lng": 11.464447503205799,
				"lat": 43.54495417143297
			},
			{
				"lng": 11.464445889260221,
				"lat": 43.544955400699045
			},
			{
				"lng": 11.46444428283254,
				"lat": 43.544956619498961
			},
			{
				"lng": 11.464442684486484,
				"lat": 43.544957827021918
			},
			{
				"lng": 11.464441094726151,
				"lat": 43.544959022542649
			},
			{
				"lng": 11.464439513694149,
				"lat": 43.544960205855503
			},
			{
				"lng": 11.464437941397463,
				"lat": 43.544961376949452
			},
			{
				"lng": 11.464436377842908,
				"lat": 43.544962535813944
			},
			{
				"lng": 11.464434823037246,
				"lat": 43.544963682438336
			},
			{
				"lng": 11.464433276987256,
				"lat": 43.544964816812048
			},
			{
				"lng": 11.464431739699714,
				"lat": 43.544965938924456
			},
			{
				"lng": 11.4644302111814,
				"lat": 43.544967048764924
			},
			{
				"lng": 11.464428691439098,
				"lat": 43.54496814632288
			},
			{
				"lng": 11.464427180479582,
				"lat": 43.544969231587729
			},
			{
				"lng": 11.464425678309642,
				"lat": 43.544970304548819
			},
			{
				"lng": 11.464424184936041,
				"lat": 43.544971365195586
			},
			{
				"lng": 11.464422700365562,
				"lat": 43.544972413517399
			},
			{
				"lng": 11.46442122460499,
				"lat": 43.544973449503658
			},
			{
				"lng": 11.464419757661092,
				"lat": 43.544974473143732
			},
			{
				"lng": 11.464418299540657,
				"lat": 43.544975484427049
			},
			{
				"lng": 11.46441685025048,
				"lat": 43.544976483342992
			},
			{
				"lng": 11.464415409797295,
				"lat": 43.544977469880926
			},
			{
				"lng": 11.464413978187913,
				"lat": 43.544978444030271
			},
			{
				"lng": 11.46441255542911,
				"lat": 43.544979405780374
			},
			{
				"lng": 11.464411141527671,
				"lat": 43.544980355120721
			},
			{
				"lng": 11.464409736490341,
				"lat": 43.544981292040639
			},
			{
				"lng": 11.46440834032394,
				"lat": 43.544982216529483
			},
			{
				"lng": 11.464406953035223,
				"lat": 43.544983128576725
			},
			{
				"lng": 11.464405574630966,
				"lat": 43.544984028171683
			},
			{
				"lng": 11.464404205117969,
				"lat": 43.544984915303857
			},
			{
				"lng": 11.46440284450299,
				"lat": 43.544985789962539
			},
			{
				"lng": 11.464401492792826,
				"lat": 43.544986652137105
			},
			{
				"lng": 11.464400149994226,
				"lat": 43.544987501817054
			},
			{
				"lng": 11.464398816113997,
				"lat": 43.544988338991693
			},
			{
				"lng": 11.4643974911589,
				"lat": 43.544989163650428
			},
			{
				"lng": 11.464396175135729,
				"lat": 43.54498997578267
			},
			{
				"lng": 11.464394868051267,
				"lat": 43.544990775377833
			},
			{
				"lng": 11.464393569912263,
				"lat": 43.544991562425238
			},
			{
				"lng": 11.464392280725514,
				"lat": 43.544992336914362
			},
			{
				"lng": 11.464391000497811,
				"lat": 43.544993098834496
			},
			{
				"lng": 11.464389729235908,
				"lat": 43.544993848175146
			},
			{
				"lng": 11.464388466946598,
				"lat": 43.544994584925604
			},
			{
				"lng": 11.46438721363665,
				"lat": 43.544995309075333
			},
			{
				"lng": 11.464385969312845,
				"lat": 43.544996020613716
			},
			{
				"lng": 11.464384733969961,
				"lat": 43.544996719544393
			},
			{
				"lng": 11.464383507481186,
				"lat": 43.544997406015895
			},
			{
				"lng": 11.464382289649194,
				"lat": 43.544998080260783
			},
			{
				"lng": 11.464381080275704,
				"lat": 43.54499874251259
			},
			{
				"lng": 11.464379879162536,
				"lat": 43.544999393004865
			},
			{
				"lng": 11.464378686111431,
				"lat": 43.545000031971227
			},
			{
				"lng": 11.464377500924158,
				"lat": 43.545000659645233
			},
			{
				"lng": 11.46437632340248,
				"lat": 43.545001276260429
			},
			{
				"lng": 11.464375153348191,
				"lat": 43.545001882050428
			},
			{
				"lng": 11.464373990563042,
				"lat": 43.545002477248779
			},
			{
				"lng": 11.464372834848808,
				"lat": 43.545003062089023
			},
			{
				"lng": 11.46437168600726,
				"lat": 43.545003636804793
			},
			{
				"lng": 11.464370543840154,
				"lat": 43.545004201629645
			},
			{
				"lng": 11.464369408149288,
				"lat": 43.545004756797127
			},
			{
				"lng": 11.464368278736389,
				"lat": 43.545005302540787
			},
			{
				"lng": 11.464367155403256,
				"lat": 43.545005839094252
			},
			{
				"lng": 11.464366037951649,
				"lat": 43.545006366691084
			},
			{
				"lng": 11.464364926183347,
				"lat": 43.545006885564817
			},
			{
				"lng": 11.4643638199001,
				"lat": 43.545007395949064
			},
			{
				"lng": 11.464362718903686,
				"lat": 43.545007898077344
			},
			{
				"lng": 11.464361622995881,
				"lat": 43.545008392183327
			},
			{
				"lng": 11.464360531978439,
				"lat": 43.545008878500461
			},
			{
				"lng": 11.464359445653152,
				"lat": 43.545009357262401
			},
			{
				"lng": 11.464358363821754,
				"lat": 43.545009828702696
			},
			{
				"lng": 11.464357286286031,
				"lat": 43.545010293054872
			},
			{
				"lng": 11.464356212847763,
				"lat": 43.545010750552585
			},
			{
				"lng": 11.464355143308708,
				"lat": 43.545011201429368
			},
			{
				"lng": 11.464354077470636,
				"lat": 43.545011645918805
			},
			{
				"lng": 11.464353015135321,
				"lat": 43.545012084254424
			},
			{
				"lng": 11.464351956104515,
				"lat": 43.545012516669793
			},
			{
				"lng": 11.464350900179996,
				"lat": 43.545012943398532
			},
			{
				"lng": 11.464348796856903,
				"lat": 43.545013780730379
			},
			{
				"lng": 11.464346703580182,
				"lat": 43.545014598118478
			},
			{
				"lng": 11.46434461876397,
				"lat": 43.545015397431428
			},
			{
				"lng": 11.464342540822436,
				"lat": 43.545016180537736
			},
			{
				"lng": 11.464340468184805,
				"lat": 43.545016949299097
			},
			{
				"lng": 11.464338400730835,
				"lat": 43.545017704913604
			},
			{
				"lng": 11.464336340974786,
				"lat": 43.545018447373948
			},
			{
				"lng": 11.464334291709593,
				"lat": 43.545019176545395
			},
			{
				"lng": 11.464332255728211,
				"lat": 43.54501989229319
			},
			{
				"lng": 11.464330235823578,
				"lat": 43.545020594482601
			},
			{
				"lng": 11.464328234788637,
				"lat": 43.545021282978816
			},
			{
				"lng": 11.464326255416331,
				"lat": 43.545021957647165
			},
			{
				"lng": 11.464325274726443,
				"lat": 43.545022289753732
			},
			{
				"lng": 11.464324300499584,
				"lat": 43.545022618352817
			},
			{
				"lng": 11.46432333308486,
				"lat": 43.545022943427561
			},
			{
				"lng": 11.464322372831379,
				"lat": 43.545023264961102
			},
			{
				"lng": 11.46432142008827,
				"lat": 43.545023582936594
			},
			{
				"lng": 11.464320475204643,
				"lat": 43.545023897337245
			},
			{
				"lng": 11.46431953852961,
				"lat": 43.545024208146096
			},
			{
				"lng": 11.464318610412299,
				"lat": 43.545024515346412
			},
			{
				"lng": 11.464317691201826,
				"lat": 43.545024818921313
			},
			{
				"lng": 11.464316781247312,
				"lat": 43.54502511885395
			},
			{
				"lng": 11.464315880897871,
				"lat": 43.545025415127498
			},
			{
				"lng": 11.464314990502626,
				"lat": 43.545025707725088
			},
			{
				"lng": 11.464314110410674,
				"lat": 43.545025996629874
			},
			{
				"lng": 11.464313240971162,
				"lat": 43.545026281825031
			},
			{
				"lng": 11.464312382533185,
				"lat": 43.545026563293746
			},
			{
				"lng": 11.464311535445894,
				"lat": 43.545026841019116
			},
			{
				"lng": 11.464310700058364,
				"lat": 43.5450271149843
			},
			{
				"lng": 11.464309876719744,
				"lat": 43.545027385172524
			},
			{
				"lng": 11.464309065779132,
				"lat": 43.545027651566855
			},
			{
				"lng": 11.464308267585666,
				"lat": 43.545027914150502
			},
			{
				"lng": 11.464307482488454,
				"lat": 43.545028172906598
			},
			{
				"lng": 11.464306710836587,
				"lat": 43.545028427818323
			},
			{
				"lng": 11.464305952979238,
				"lat": 43.545028678868817
			},
			{
				"lng": 11.464305209265492,
				"lat": 43.545028926041255
			},
			{
				"lng": 11.464304480044468,
				"lat": 43.545029169318752
			},
			{
				"lng": 11.464303765657522,
				"lat": 43.545029408685998
			},
			{
				"lng": 11.464303066130176,
				"lat": 43.545029644188524
			},
			{
				"lng": 11.464302381069015,
				"lat": 43.545029875952558
			},
			{
				"lng": 11.464301710051771,
				"lat": 43.545030104109934
			},
			{
				"lng": 11.464301052656205,
				"lat": 43.545030328792478
			},
			{
				"lng": 11.464300408460034,
				"lat": 43.545030550132026
			},
			{
				"lng": 11.464299777040988,
				"lat": 43.545030768260418
			},
			{
				"lng": 11.464299157976793,
				"lat": 43.545030983309459
			},
			{
				"lng": 11.464298550845212,
				"lat": 43.545031195410942
			},
			{
				"lng": 11.464297955223957,
				"lat": 43.545031404696743
			},
			{
				"lng": 11.464297370690767,
				"lat": 43.545031611298661
			},
			{
				"lng": 11.46429679682338,
				"lat": 43.54503181534853
			},
			{
				"lng": 11.464296233199535,
				"lat": 43.545032016978183
			},
			{
				"lng": 11.464295679396951,
				"lat": 43.545032216319413
			},
			{
				"lng": 11.464295134993366,
				"lat": 43.545032413504074
			},
			{
				"lng": 11.464294599566529,
				"lat": 43.545032608663995
			},
			{
				"lng": 11.464294072694166,
				"lat": 43.545032801930979
			},
			{
				"lng": 11.464293553953993,
				"lat": 43.545032993436855
			},
			{
				"lng": 11.464293042923778,
				"lat": 43.545033183313471
			},
			{
				"lng": 11.464292042304091,
				"lat": 43.545033558706159
			},
			{
				"lng": 11.464291067456976,
				"lat": 43.545033929163615
			},
			{
				"lng": 11.464290115004301,
				"lat": 43.545034295740443
			},
			{
				"lng": 11.464289181567933,
				"lat": 43.54503465949125
			},
			{
				"lng": 11.46428826376977,
				"lat": 43.545035021470639
			},
			{
				"lng": 11.46428735823166,
				"lat": 43.545035382733204
			},
			{
				"lng": 11.464286461575483,
				"lat": 43.545035744333561
			},
			{
				"lng": 11.464284681396427,
				"lat": 43.545036472765958
			},
			{
				"lng": 11.464283791117293,
				"lat": 43.545036841707208
			},
			{
				"lng": 11.464282896208745,
				"lat": 43.545037215204239
			},
			{
				"lng": 11.464281994294602,
				"lat": 43.545037594006267
			},
			{
				"lng": 11.464281085823185,
				"lat": 43.54503797800124
			},
			{
				"lng": 11.46428017173753,
				"lat": 43.545038366926491
			},
			{
				"lng": 11.464279252980701,
				"lat": 43.545038760519184
			},
			{
				"lng": 11.464277405225715,
				"lat": 43.545039560655866
			},
			{
				"lng": 11.464275550102622,
				"lat": 43.545040376309203
			},
			{
				"lng": 11.46427369515586,
				"lat": 43.545041205376975
			},
			{
				"lng": 11.464271847929831,
				"lat": 43.545042045757057
			},
			{
				"lng": 11.464270015968937,
				"lat": 43.545042895347265
			},
			{
				"lng": 11.464268206817632,
				"lat": 43.545043752045501
			},
			{
				"lng": 11.464267313153202,
				"lat": 43.545044182403174
			},
			{
				"lng": 11.464266428020299,
				"lat": 43.545044613749539
			},
			{
				"lng": 11.464265552362015,
				"lat": 43.545045045821809
			},
			{
				"lng": 11.464264687121359,
				"lat": 43.545045478357252
			},
			{
				"lng": 11.464263832958562,
				"lat": 43.545045911448796
			},
			{
				"lng": 11.464262989527937,
				"lat": 43.5450463464542
			},
			{
				"lng": 11.46426215626024,
				"lat": 43.545046785012453
			},
			{
				"lng": 11.464261332586268,
				"lat": 43.545047228762442
			},
			{
				"lng": 11.464260517936749,
				"lat": 43.545047679343199
			},
			{
				"lng": 11.46425971174248,
				"lat": 43.54504813839354
			},
			{
				"lng": 11.464258913434225,
				"lat": 43.545048607552516
			},
			{
				"lng": 11.464258122442743,
				"lat": 43.545049088458981
			},
			{
				"lng": 11.464257338198799,
				"lat": 43.545049582751929
			},
			{
				"lng": 11.464256560133174,
				"lat": 43.545050092070248
			},
			{
				"lng": 11.464255787676636,
				"lat": 43.545050618052933
			},
			{
				"lng": 11.464255020259932,
				"lat": 43.545051162338908
			},
			{
				"lng": 11.464254257313856,
				"lat": 43.545051726567081
			},
			{
				"lng": 11.464253877339413,
				"lat": 43.545052016671669
			},
			{
				"lng": 11.464253498269164,
				"lat": 43.54505231237642
			},
			{
				"lng": 11.464253120031945,
				"lat": 43.545052613886185
			},
			{
				"lng": 11.464252742556614,
				"lat": 43.545052921405841
			},
			{
				"lng": 11.464252365772021,
				"lat": 43.545053235140237
			},
			{
				"lng": 11.464251989606991,
				"lat": 43.545053555294295
			},
			{
				"lng": 11.464251613990395,
				"lat": 43.545053882072828
			},
			{
				"lng": 11.464251238851052,
				"lat": 43.545054215680722
			},
			{
				"lng": 11.464250864117826,
				"lat": 43.545054556322832
			},
			{
				"lng": 11.464250489719568,
				"lat": 43.545054904204036
			},
			{
				"lng": 11.4642501155851,
				"lat": 43.545055259529221
			},
			{
				"lng": 11.464249741643286,
				"lat": 43.54505562250322
			},
			{
				"lng": 11.464249367822974,
				"lat": 43.545055993330898
			},
			{
				"lng": 11.464248994052996,
				"lat": 43.545056372217147
			},
			{
				"lng": 11.464248620248885,
				"lat": 43.545056759319216
			},
			{
				"lng": 11.464248246258634,
				"lat": 43.54505715455312
			},
			{
				"lng": 11.464247871908888,
				"lat": 43.545057557758653
			},
			{
				"lng": 11.464247497026335,
				"lat": 43.545057968775566
			},
			{
				"lng": 11.464247121437609,
				"lat": 43.545058387443689
			},
			{
				"lng": 11.464246744969369,
				"lat": 43.545058813602829
			},
			{
				"lng": 11.464246367448295,
				"lat": 43.545059247092702
			},
			{
				"lng": 11.464245988701032,
				"lat": 43.545059687753181
			},
			{
				"lng": 11.464245608554233,
				"lat": 43.545060135423931
			},
			{
				"lng": 11.464245226834574,
				"lat": 43.545060589944853
			},
			{
				"lng": 11.464244843368688,
				"lat": 43.54506105115567
			},
			{
				"lng": 11.464244457983268,
				"lat": 43.545061518896169
			},
			{
				"lng": 11.464244070504934,
				"lat": 43.545061993006179
			},
			{
				"lng": 11.464243680760374,
				"lat": 43.54506247332543
			},
			{
				"lng": 11.464243288576224,
				"lat": 43.545062959693716
			},
			{
				"lng": 11.464242893779165,
				"lat": 43.545063451950831
			},
			{
				"lng": 11.464242496195844,
				"lat": 43.545063949936576
			},
			{
				"lng": 11.46424209565291,
				"lat": 43.545064453490703
			},
			{
				"lng": 11.46424169197704,
				"lat": 43.545064962452997
			},
			{
				"lng": 11.464241284994879,
				"lat": 43.545065476663318
			},
			{
				"lng": 11.464240460418329,
				"lat": 43.545066520186928
			},
			{
				"lng": 11.464239620536535,
				"lat": 43.545067582779843
			},
			{
				"lng": 11.464238763962777,
				"lat": 43.545068663160308
			},
			{
				"lng": 11.464237889310295,
				"lat": 43.54506976004658
			},
			{
				"lng": 11.464236995192376,
				"lat": 43.545070872156984
			},
			{
				"lng": 11.464236080222275,
				"lat": 43.545071998209764
			},
			{
				"lng": 11.464235143013253,
				"lat": 43.545073136923158
			},
			{
				"lng": 11.464234182178615,
				"lat": 43.545074287015559
			},
			{
				"lng": 11.46423319633158,
				"lat": 43.545075447205093
			},
			{
				"lng": 11.464232184085438,
				"lat": 43.545076616210181
			},
			{
				"lng": 11.4642311440754,
				"lat": 43.545077792939288
			},
			{
				"lng": 11.464230613268775,
				"lat": 43.545078384174758
			},
			{
				"lng": 11.464230075061877,
				"lat": 43.545078977387391
			},
			{
				"lng": 11.46422952930531,
				"lat": 43.5450795726248
			},
			{
				"lng": 11.464228975849675,
				"lat": 43.545080169934494
			},
			{
				"lng": 11.46422841454558,
				"lat": 43.545080769363977
			},
			{
				"lng": 11.464227845243659,
				"lat": 43.545081370960823
			},
			{
				"lng": 11.464227267794465,
				"lat": 43.545081974772643
			},
			{
				"lng": 11.464226682048652,
				"lat": 43.545082580846902
			},
			{
				"lng": 11.46422608785679,
				"lat": 43.545083189231143
			},
			{
				"lng": 11.464225485069527,
				"lat": 43.545083799972964
			},
			{
				"lng": 11.464224873537432,
				"lat": 43.545084413119909
			},
			{
				"lng": 11.464224253111123,
				"lat": 43.54508502871942
			},
			{
				"lng": 11.464223623641209,
				"lat": 43.545085646819196
			},
			{
				"lng": 11.464222984978303,
				"lat": 43.545086267466694
			},
			{
				"lng": 11.464222336972989,
				"lat": 43.545086890709428
			},
			{
				"lng": 11.464221679475905,
				"lat": 43.545087516595039
			},
			{
				"lng": 11.464221012337621,
				"lat": 43.545088145170979
			},
			{
				"lng": 11.464220335408788,
				"lat": 43.545088776484874
			},
			{
				"lng": 11.464219648539965,
				"lat": 43.545089410584175
			},
			{
				"lng": 11.464218951581802,
				"lat": 43.545090047516588
			},
			{
				"lng": 11.46421824438486,
				"lat": 43.545090687329449
			},
			{
				"lng": 11.464217526799787,
				"lat": 43.54509133007047
			},
			{
				"lng": 11.464216798677153,
				"lat": 43.545091975787081
			},
			{
				"lng": 11.464216059867601,
				"lat": 43.545092624526944
			},
			{
				"lng": 11.464215310221705,
				"lat": 43.545093276337496
			},
			{
				"lng": 11.464214549590093,
				"lat": 43.545093931266344
			},
			{
				"lng": 11.46421377782336,
				"lat": 43.545094589361028
			},
			{
				"lng": 11.464212994772115,
				"lat": 43.545095250669057
			},
			{
				"lng": 11.464212200286973,
				"lat": 43.545095915238001
			},
			{
				"lng": 11.464211394218509,
				"lat": 43.545096583115431
			},
			{
				"lng": 11.464210576417372,
				"lat": 43.545097254348832
			},
			{
				"lng": 11.464209746734133,
				"lat": 43.545097928985854
			},
			{
				"lng": 11.464208905019424,
				"lat": 43.545098607073889
			},
			{
				"lng": 11.464208051123823,
				"lat": 43.545099288660595
			},
			{
				"lng": 11.464207184897974,
				"lat": 43.545099973793505
			},
			{
				"lng": 11.464206306192452,
				"lat": 43.545100662520163
			},
			{
				"lng": 11.464205414857872,
				"lat": 43.545101354888068
			},
			{
				"lng": 11.464204510744846,
				"lat": 43.545102050944806
			},
			{
				"lng": 11.464203593712165,
				"lat": 43.545102750735204
			},
			{
				"lng": 11.464202663737394,
				"lat": 43.545103454264904
			},
			{
				"lng": 11.464201720887679,
				"lat": 43.545104161509997
			},
			{
				"lng": 11.464200765232361,
				"lat": 43.545104872445862
			},
			{
				"lng": 11.464199796840763,
				"lat": 43.545105587047807
			},
			{
				"lng": 11.46419881578225,
				"lat": 43.545106305291227
			},
			{
				"lng": 11.464197822126147,
				"lat": 43.54510702715141
			},
			{
				"lng": 11.464196815941788,
				"lat": 43.545107752603847
			},
			{
				"lng": 11.464195797298522,
				"lat": 43.545108481623778
			},
			{
				"lng": 11.464194766265679,
				"lat": 43.545109214186603
			},
			{
				"lng": 11.464193722912611,
				"lat": 43.545109950267673
			},
			{
				"lng": 11.46419266730865,
				"lat": 43.545110689842332
			},
			{
				"lng": 11.464191599523124,
				"lat": 43.545111432885967
			},
			{
				"lng": 11.46419051962539,
				"lat": 43.545112179373895
			},
			{
				"lng": 11.464189427684774,
				"lat": 43.545112929281537
			},
			{
				"lng": 11.464188323770628,
				"lat": 43.545113682584173
			},
			{
				"lng": 11.464187207952271,
				"lat": 43.54511443925719
			},
			{
				"lng": 11.464186080299063,
				"lat": 43.545115199275934
			},
			{
				"lng": 11.46418494088033,
				"lat": 43.545115962615789
			},
			{
				"lng": 11.464183789765414,
				"lat": 43.545116729252108
			},
			{
				"lng": 11.464182627023666,
				"lat": 43.545117499160234
			},
			{
				"lng": 11.464181452724405,
				"lat": 43.545118272315541
			},
			{
				"lng": 11.464180266936978,
				"lat": 43.545119048693351
			},
			{
				"lng": 11.464179069730726,
				"lat": 43.545119828269073
			},
			{
				"lng": 11.464177861174974,
				"lat": 43.545120611018
			},
			{
				"lng": 11.464176641339094,
				"lat": 43.545121396915519
			},
			{
				"lng": 11.464175410292398,
				"lat": 43.545122185937032
			},
			{
				"lng": 11.464174168104226,
				"lat": 43.545122978057798
			},
			{
				"lng": 11.464172914843937,
				"lat": 43.545123773253259
			},
			{
				"lng": 11.464171650580845,
				"lat": 43.545124571498761
			},
			{
				"lng": 11.464170375384301,
				"lat": 43.545125372769611
			},
			{
				"lng": 11.464169089323653,
				"lat": 43.545126177041205
			},
			{
				"lng": 11.464167792468222,
				"lat": 43.545126984288871
			},
			{
				"lng": 11.464166484887343,
				"lat": 43.545127794488025
			},
			{
				"lng": 11.464165166650384,
				"lat": 43.54512860761394
			},
			{
				"lng": 11.464163837826661,
				"lat": 43.545129423642059
			},
			{
				"lng": 11.464162498485519,
				"lat": 43.54513024254765
			},
			{
				"lng": 11.4641611486963,
				"lat": 43.545131064306162
			},
			{
				"lng": 11.464159788528331,
				"lat": 43.54513188889289
			},
			{
				"lng": 11.464158418050969,
				"lat": 43.545132716283177
			},
			{
				"lng": 11.464157037347629,
				"lat": 43.545133546445342
			},
			{
				"lng": 11.464155646914888,
				"lat": 43.545134379139995
			},
			{
				"lng": 11.46415424771874,
				"lat": 43.545135213891804
			},
			{
				"lng": 11.464152840750669,
				"lat": 43.545136050212541
			},
			{
				"lng": 11.464150007464674,
				"lat": 43.545137725608534
			},
			{
				"lng": 11.464147154988664,
				"lat": 43.545139401422787
			},
			{
				"lng": 11.464144291254435,
				"lat": 43.545141073750216
			},
			{
				"lng": 11.464141424193731,
				"lat": 43.545142738685662
			},
			{
				"lng": 11.46413856173837,
				"lat": 43.54514439232404
			},
			{
				"lng": 11.464135711820088,
				"lat": 43.545146030760179
			},
			{
				"lng": 11.464134294041056,
				"lat": 43.545146843057097
			},
			{
				"lng": 11.464132882370711,
				"lat": 43.545147650089049
			},
			{
				"lng": 11.464131477800528,
				"lat": 43.545148451367879
			},
			{
				"lng": 11.464130081321986,
				"lat": 43.54514924640543
			},
			{
				"lng": 11.464128693926559,
				"lat": 43.545150034713593
			},
			{
				"lng": 11.464127316605719,
				"lat": 43.545150815804234
			},
			{
				"lng": 11.464125950350939,
				"lat": 43.545151589189217
			},
			{
				"lng": 11.464124596153692,
				"lat": 43.545152354380384
			},
			{
				"lng": 11.464123255005452,
				"lat": 43.545153110889601
			},
			{
				"lng": 11.46412192789769,
				"lat": 43.545153858228758
			},
			{
				"lng": 11.464120615821885,
				"lat": 43.545154595909644
			},
			{
				"lng": 11.464119319769496,
				"lat": 43.54515532344417
			},
			{
				"lng": 11.464118040732012,
				"lat": 43.54515604034421
			},
			{
				"lng": 11.464116779700923,
				"lat": 43.54515674612157
			},
			{
				"lng": 11.464115537667675,
				"lat": 43.545157440288186
			},
			{
				"lng": 11.464114315623732,
				"lat": 43.545158122355836
			},
			{
				"lng": 11.464113114560616,
				"lat": 43.545158791836464
			},
			{
				"lng": 11.464111935469766,
				"lat": 43.545159448241861
			},
			{
				"lng": 11.464110779342638,
				"lat": 43.545160091083908
			},
			{
				"lng": 11.464110210200328,
				"lat": 43.545160407266117
			},
			{
				"lng": 11.464109647170746,
				"lat": 43.545160719874481
			},
			{
				"lng": 11.46410909037785,
				"lat": 43.545161028847893
			},
			{
				"lng": 11.464108539945558,
				"lat": 43.545161334125417
			},
			{
				"lng": 11.464107995997805,
				"lat": 43.545161635645975
			},
			{
				"lng": 11.464107458658521,
				"lat": 43.545161933348616
			},
			{
				"lng": 11.464106928051656,
				"lat": 43.545162227172248
			},
			{
				"lng": 11.464106404301136,
				"lat": 43.545162517055907
			},
			{
				"lng": 11.464105887530902,
				"lat": 43.545162802938556
			},
			{
				"lng": 11.464105377864877,
				"lat": 43.545163084759139
			},
			{
				"lng": 11.46410487542699,
				"lat": 43.545163362456719
			},
			{
				"lng": 11.464104380331824,
				"lat": 43.545163635974852
			},
			{
				"lng": 11.464103892546998,
				"lat": 43.545163905330192
			},
			{
				"lng": 11.464103411923455,
				"lat": 43.545164170597261
			},
			{
				"lng": 11.464102938308912,
				"lat": 43.54516443185215
			},
			{
				"lng": 11.464102471551154,
				"lat": 43.545164689170981
			},
			{
				"lng": 11.464102011497863,
				"lat": 43.545164942629889
			},
			{
				"lng": 11.464101557996829,
				"lat": 43.545165192304985
			},
			{
				"lng": 11.464101110895742,
				"lat": 43.545165438272413
			},
			{
				"lng": 11.464100670042367,
				"lat": 43.545165680608307
			},
			{
				"lng": 11.464099806469669,
				"lat": 43.545166154689831
			},
			{
				"lng": 11.464098966060597,
				"lat": 43.545166615158543
			},
			{
				"lng": 11.46409814759709,
				"lat": 43.545167062623491
			},
			{
				"lng": 11.464097349860999,
				"lat": 43.545167497693519
			},
			{
				"lng": 11.46409657163424,
				"lat": 43.545167920977697
			},
			{
				"lng": 11.464095811698682,
				"lat": 43.545168333084945
			},
			{
				"lng": 11.464095068836235,
				"lat": 43.545168734624262
			},
			{
				"lng": 11.464094341828776,
				"lat": 43.545169126204577
			},
			{
				"lng": 11.464093629458207,
				"lat": 43.545169508434874
			},
			{
				"lng": 11.464092930506421,
				"lat": 43.54516988192416
			},
			{
				"lng": 11.464092243755298,
				"lat": 43.545170247281298
			},
			{
				"lng": 11.464091567986721,
				"lat": 43.545170605115395
			},
			{
				"lng": 11.464090901982601,
				"lat": 43.545170956035342
			},
			{
				"lng": 11.464090244524821,
				"lat": 43.545171300650161
			},
			{
				"lng": 11.464089594395272,
				"lat": 43.5451716395687
			},
			{
				"lng": 11.464088950375825,
				"lat": 43.545171973400059
			},
			{
				"lng": 11.464088311248403,
				"lat": 43.545172302753123
			},
			{
				"lng": 11.464087042797145,
				"lat": 43.545172950460376
			},
			{
				"lng": 11.464085779296587,
				"lat": 43.545173587562168
			},
			{
				"lng": 11.464084511001891,
				"lat": 43.545174218930292
			},
			{
				"lng": 11.464083228168141,
				"lat": 43.545174849436478
			},
			{
				"lng": 11.464081921050466,
				"lat": 43.545175483952434
			},
			{
				"lng": 11.464081255339883,
				"lat": 43.545175804236543
			},
			{
				"lng": 11.464080579903992,
				"lat": 43.54517612734994
			},
			{
				"lng": 11.464079893524669,
				"lat": 43.545176453901718
			},
			{
				"lng": 11.464079194983823,
				"lat": 43.545176784500782
			},
			{
				"lng": 11.464078483063332,
				"lat": 43.545177119756097
			},
			{
				"lng": 11.464077756545084,
				"lat": 43.545177460276655
			},
			{
				"lng": 11.46407701421097,
				"lat": 43.545177806671397
			},
			{
				"lng": 11.464076254842885,
				"lat": 43.545178159549266
			},
			{
				"lng": 11.464075477222845,
				"lat": 43.545178519519254
			},
			{
				"lng": 11.464074680204723,
				"lat": 43.545178887154869
			},
			{
				"lng": 11.464073862834073,
				"lat": 43.545179262935548
			},
			{
				"lng": 11.464073024188018,
				"lat": 43.545179647325149
			},
			{
				"lng": 11.464072163343703,
				"lat": 43.54518004078755
			},
			{
				"lng": 11.464071279378256,
				"lat": 43.545180443786613
			},
			{
				"lng": 11.464070371368814,
				"lat": 43.545180856786246
			},
			{
				"lng": 11.464069438392519,
				"lat": 43.545181280250198
			},
			{
				"lng": 11.464068479526501,
				"lat": 43.545181714642489
			},
			{
				"lng": 11.464067990096449,
				"lat": 43.545181936081704
			},
			{
				"lng": 11.464067493847908,
				"lat": 43.545182160426954
			},
			{
				"lng": 11.464066990665488,
				"lat": 43.545182387736197
			},
			{
				"lng": 11.464066480433861,
				"lat": 43.545182618067422
			},
			{
				"lng": 11.464065963037644,
				"lat": 43.545182851478586
			},
			{
				"lng": 11.464065438361493,
				"lat": 43.545183088027734
			},
			{
				"lng": 11.464064906290051,
				"lat": 43.545183327772826
			},
			{
				"lng": 11.464064366707962,
				"lat": 43.545183570771854
			},
			{
				"lng": 11.464063819499858,
				"lat": 43.545183817082766
			},
			{
				"lng": 11.464063264550377,
				"lat": 43.545184066763568
			},
			{
				"lng": 11.464062701744172,
				"lat": 43.54518431987227
			},
			{
				"lng": 11.464062130965882,
				"lat": 43.545184576466802
			},
			{
				"lng": 11.464061552100151,
				"lat": 43.545184836605195
			},
			{
				"lng": 11.464060965031628,
				"lat": 43.545185100345428
			},
			{
				"lng": 11.464060369644935,
				"lat": 43.545185367745439
			},
			{
				"lng": 11.464059765824731,
				"lat": 43.545185638863231
			},
			{
				"lng": 11.464059153455644,
				"lat": 43.545185913756846
			},
			{
				"lng": 11.464058532422332,
				"lat": 43.545186192484181
			},
			{
				"lng": 11.464057902609413,
				"lat": 43.545186475103307
			},
			{
				"lng": 11.464057263901566,
				"lat": 43.545186761672127
			},
			{
				"lng": 11.464056616183388,
				"lat": 43.545187052248671
			},
			{
				"lng": 11.464055959339555,
				"lat": 43.54518734689092
			},
			{
				"lng": 11.464055293254702,
				"lat": 43.545187645656839
			},
			{
				"lng": 11.464054617813463,
				"lat": 43.545187948604408
			},
			{
				"lng": 11.464053932900477,
				"lat": 43.545188255791665
			},
			{
				"lng": 11.4640532384004,
				"lat": 43.545188567276512
			},
			{
				"lng": 11.464052534197858,
				"lat": 43.545188883117021
			},
			{
				"lng": 11.464051820177502,
				"lat": 43.545189203371059
			},
			{
				"lng": 11.464051096223976,
				"lat": 43.545189528096714
			},
			{
				"lng": 11.464050362221922,
				"lat": 43.545189857351929
			},
			{
				"lng": 11.464049618055961,
				"lat": 43.545190191194692
			},
			{
				"lng": 11.464048863610767,
				"lat": 43.545190529683012
			},
			{
				"lng": 11.464048098770956,
				"lat": 43.545190872874826
			},
			{
				"lng": 11.464047323421187,
				"lat": 43.545191220828137
			},
			{
				"lng": 11.464046537446096,
				"lat": 43.545191573600945
			},
			{
				"lng": 11.464045740730326,
				"lat": 43.545191931251232
			},
			{
				"lng": 11.464044933158496,
				"lat": 43.545192293836934
			},
			{
				"lng": 11.464044114615284,
				"lat": 43.545192661416081
			},
			{
				"lng": 11.464043284985317,
				"lat": 43.545193034046683
			},
			{
				"lng": 11.464042444153231,
				"lat": 43.545193411786641
			},
			{
				"lng": 11.464041592003671,
				"lat": 43.545193794694022
			},
			{
				"lng": 11.464040728421281,
				"lat": 43.545194182826748
			},
			{
				"lng": 11.464039853290693,
				"lat": 43.545194576242835
			},
			{
				"lng": 11.464038966496556,
				"lat": 43.545194975000264
			},
			{
				"lng": 11.464038067923525,
				"lat": 43.545195379157008
			},
			{
				"lng": 11.464037157456216,
				"lat": 43.545195788771053
			},
			{
				"lng": 11.464036234979282,
				"lat": 43.545196203900382
			},
			{
				"lng": 11.46403530037737,
				"lat": 43.545196624603001
			},
			{
				"lng": 11.464034353535125,
				"lat": 43.545197050936856
			},
			{
				"lng": 11.464033394337166,
				"lat": 43.545197482959971
			},
			{
				"lng": 11.464032422668165,
				"lat": 43.545197920730288
			},
			{
				"lng": 11.464031438412739,
				"lat": 43.545198364305804
			},
			{
				"lng": 11.464030441455522,
				"lat": 43.545198813744484
			},
			{
				"lng": 11.464029431681199,
				"lat": 43.545199269104373
			},
			{
				"lng": 11.464028408974372,
				"lat": 43.54519973044345
			},
			{
				"lng": 11.46402737321969,
				"lat": 43.545200197819632
			},
			{
				"lng": 11.464026324301807,
				"lat": 43.545200671290921
			},
			{
				"lng": 11.46402526210535,
				"lat": 43.545201150915339
			},
			{
				"lng": 11.464024186514967,
				"lat": 43.545201636750853
			},
			{
				"lng": 11.464023097415293,
				"lat": 43.545202128855408
			},
			{
				"lng": 11.464021994690986,
				"lat": 43.545202627287061
			},
			{
				"lng": 11.464020878226668,
				"lat": 43.545203132103723
			},
			{
				"lng": 11.464019747906994,
				"lat": 43.545203643363401
			},
			{
				"lng": 11.464018603616594,
				"lat": 43.545204161124133
			},
			{
				"lng": 11.464017445293543,
				"lat": 43.545204685420451
			},
			{
				"lng": 11.464016273116238,
				"lat": 43.54520521618214
			},
			{
				"lng": 11.464015087330683,
				"lat": 43.545205753309268
			},
			{
				"lng": 11.464013888182873,
				"lat": 43.545206296701934
			},
			{
				"lng": 11.464012675918827,
				"lat": 43.545206846260342
			},
			{
				"lng": 11.464011450784518,
				"lat": 43.545207401884561
			},
			{
				"lng": 11.464010213025981,
				"lat": 43.545207963474759
			},
			{
				"lng": 11.464008962889176,
				"lat": 43.545208530931063
			},
			{
				"lng": 11.464007700620137,
				"lat": 43.545209104153543
			},
			{
				"lng": 11.464006426464838,
				"lat": 43.545209683042444
			},
			{
				"lng": 11.4640051406693,
				"lat": 43.545210267497822
			},
			{
				"lng": 11.464003843479514,
				"lat": 43.545210857419811
			},
			{
				"lng": 11.464002535141477,
				"lat": 43.545211452708564
			},
			{
				"lng": 11.464001215901197,
				"lat": 43.54521205326418
			},
			{
				"lng": 11.463999886004666,
				"lat": 43.545212658986827
			},
			{
				"lng": 11.463998545697899,
				"lat": 43.545213269776625
			},
			{
				"lng": 11.463997195226895,
				"lat": 43.54521388553372
			},
			{
				"lng": 11.463995834837634,
				"lat": 43.545214506158182
			},
			{
				"lng": 11.463994464776132,
				"lat": 43.545215131550201
			},
			{
				"lng": 11.463993085288374,
				"lat": 43.54521576160991
			},
			{
				"lng": 11.463991696620386,
				"lat": 43.545216396237407
			},
			{
				"lng": 11.463990299018144,
				"lat": 43.545217035332826
			},
			{
				"lng": 11.463988892727665,
				"lat": 43.545217678796291
			},
			{
				"lng": 11.46398747799495,
				"lat": 43.54521832652798
			},
			{
				"lng": 11.463986055065979,
				"lat": 43.545218978427997
			},
			{
				"lng": 11.463984624186786,
				"lat": 43.545219634396489
			},
			{
				"lng": 11.463983185603327,
				"lat": 43.545220294333532
			},
			{
				"lng": 11.463981739561644,
				"lat": 43.545220958139318
			},
			{
				"lng": 11.463980286307724,
				"lat": 43.545221625713957
			},
			{
				"lng": 11.463978826087549,
				"lat": 43.545222296957583
			},
			{
				"lng": 11.463977359147156,
				"lat": 43.545222971770329
			},
			{
				"lng": 11.463975885732516,
				"lat": 43.545223650052279
			},
			{
				"lng": 11.463972920464528,
				"lat": 43.545225016624507
			},
			{
				"lng": 11.463969932251599,
				"lat": 43.545226395875275
			},
			{
				"lng": 11.463966923061719,
				"lat": 43.545227787005693
			},
			{
				"lng": 11.463963894862912,
				"lat": 43.545229189216748
			},
			{
				"lng": 11.463960849623184,
				"lat": 43.545230601709484
			},
			{
				"lng": 11.463957789310527,
				"lat": 43.545232023684989
			},
			{
				"lng": 11.463954715892971,
				"lat": 43.54523345434432
			},
			{
				"lng": 11.463951631338501,
				"lat": 43.54523489288853
			},
			{
				"lng": 11.463948537615137,
				"lat": 43.545236338518649
			},
			{
				"lng": 11.463945436690882,
				"lat": 43.545237790435692
			},
			{
				"lng": 11.463942330533747,
				"lat": 43.545239247840833
			},
			{
				"lng": 11.463936110392869,
				"lat": 43.54524217591927
			},
			{
				"lng": 11.463929892936582,
				"lat": 43.545245116362452
			},
			{
				"lng": 11.463923693908937,
				"lat": 43.545248062778747
			},
			{
				"lng": 11.463920606225903,
				"lat": 43.545249536229491
			},
			{
				"lng": 11.463917529054061,
				"lat": 43.545251008776646
			},
			{
				"lng": 11.463914464361432,
				"lat": 43.545252479621283
			},
			{
				"lng": 11.463911414116019,
				"lat": 43.54525394796449
			},
			{
				"lng": 11.463908380285845,
				"lat": 43.545255413007311
			},
			{
				"lng": 11.463905364838908,
				"lat": 43.545256873950805
			},
			{
				"lng": 11.463902369743233,
				"lat": 43.545258329995967
			},
			{
				"lng": 11.463899396781953,
				"lat": 43.545259780388285
			},
			{
				"lng": 11.463896446470448,
				"lat": 43.545261224676963
			},
			{
				"lng": 11.463893518792386,
				"lat": 43.545262662538875
			},
			{
				"lng": 11.46389061372958,
				"lat": 43.545264093651184
			},
			{
				"lng": 11.463887731263871,
				"lat": 43.545265517691135
			},
			{
				"lng": 11.463884871377076,
				"lat": 43.545266934335991
			},
			{
				"lng": 11.46388203405103,
				"lat": 43.545268343262933
			},
			{
				"lng": 11.463879219267573,
				"lat": 43.545269744149252
			},
			{
				"lng": 11.463876427008509,
				"lat": 43.545271136672085
			},
			{
				"lng": 11.463873657255684,
				"lat": 43.545272520508703
			},
			{
				"lng": 11.463870909990927,
				"lat": 43.545273895336365
			},
			{
				"lng": 11.463868185196054,
				"lat": 43.545275260832277
			},
			{
				"lng": 11.463865482852906,
				"lat": 43.545276616673654
			},
			{
				"lng": 11.463862802943302,
				"lat": 43.545277962537746
			},
			{
				"lng": 11.463860145449091,
				"lat": 43.545279298101747
			},
			{
				"lng": 11.46385751035209,
				"lat": 43.545280623042885
			},
			{
				"lng": 11.463854897634119,
				"lat": 43.545281937038439
			},
			{
				"lng": 11.463852307277016,
				"lat": 43.545283239765581
			},
			{
				"lng": 11.463849739262624,
				"lat": 43.545284530901576
			},
			{
				"lng": 11.463847193572748,
				"lat": 43.54528581012363
			},
			{
				"lng": 11.463844670189218,
				"lat": 43.545287077108995
			},
			{
				"lng": 11.463842169093898,
				"lat": 43.545288331534863
			},
			{
				"lng": 11.463839690268575,
				"lat": 43.545289573078463
			},
			{
				"lng": 11.4638372336951,
				"lat": 43.545290801417082
			},
			{
				"lng": 11.463834799355288,
				"lat": 43.545292016227826
			},
			{
				"lng": 11.463832387230989,
				"lat": 43.54529321718811
			},
			{
				"lng": 11.46382999730403,
				"lat": 43.545294403974978
			},
			{
				"lng": 11.463827629556208,
				"lat": 43.54529557626573
			},
			{
				"lng": 11.463825283969394,
				"lat": 43.545296733737636
			},
			{
				"lng": 11.4638229605254,
				"lat": 43.545297876067856
			},
			{
				"lng": 11.463821807101287,
				"lat": 43.54529844145398
			},
			{
				"lng": 11.463820659206066,
				"lat": 43.545299002933653
			},
			{
				"lng": 11.463819516837459,
				"lat": 43.545299560466511
			},
			{
				"lng": 11.463818379993191,
				"lat": 43.545300114012242
			},
			{
				"lng": 11.463817248671006,
				"lat": 43.54530066353044
			},
			{
				"lng": 11.463816122868629,
				"lat": 43.545301208980838
			},
			{
				"lng": 11.463815002583798,
				"lat": 43.545301750323027
			},
			{
				"lng": 11.463813887814204,
				"lat": 43.545302287516677
			},
			{
				"lng": 11.463812778557628,
				"lat": 43.545302820521485
			},
			{
				"lng": 11.463811674811753,
				"lat": 43.545303349296979
			},
			{
				"lng": 11.46381057657435,
				"lat": 43.545303873803007
			},
			{
				"lng": 11.463809483843105,
				"lat": 43.545304393999047
			},
			{
				"lng": 11.463808396615764,
				"lat": 43.545304909844837
			},
			{
				"lng": 11.463807314890074,
				"lat": 43.545305421300021
			},
			{
				"lng": 11.463806238663738,
				"lat": 43.545305928324225
			},
			{
				"lng": 11.463805167934506,
				"lat": 43.545306430877147
			},
			{
				"lng": 11.463804102700085,
				"lat": 43.545306928918379
			},
			{
				"lng": 11.463803042958222,
				"lat": 43.545307422407646
			},
			{
				"lng": 11.46380198870663,
				"lat": 43.545307911304562
			},
			{
				"lng": 11.46380093994304,
				"lat": 43.545308395568753
			},
			{
				"lng": 11.4637998966649,
				"lat": 43.545308875160416
			},
			{
				"lng": 11.463798858851519,
				"lat": 43.545309350068351
			},
			{
				"lng": 11.463797826454226,
				"lat": 43.545309820326047
			},
			{
				"lng": 11.463796799421864,
				"lat": 43.545310285970672
			},
			{
				"lng": 11.463795777703339,
				"lat": 43.54531074703948
			},
			{
				"lng": 11.463794761247543,
				"lat": 43.545311203569774
			},
			{
				"lng": 11.46379375000336,
				"lat": 43.545311655598688
			},
			{
				"lng": 11.463792743919658,
				"lat": 43.545312103163546
			},
			{
				"lng": 11.46379174294534,
				"lat": 43.545312546301567
			},
			{
				"lng": 11.463790747029275,
				"lat": 43.545312985049961
			},
			{
				"lng": 11.463789756120359,
				"lat": 43.545313419445968
			},
			{
				"lng": 11.463788770167458,
				"lat": 43.545313849526927
			},
			{
				"lng": 11.463786812925303,
				"lat": 43.545314696892298
			},
			{
				"lng": 11.463784874893872,
				"lat": 43.545315527444082
			},
			{
				"lng": 11.463782955664261,
				"lat": 43.545316341480174
			},
			{
				"lng": 11.463781054827511,
				"lat": 43.545317139298476
			},
			{
				"lng": 11.463779171974728,
				"lat": 43.545317921196897
			},
			{
				"lng": 11.463777306696977,
				"lat": 43.545318687473383
			},
			{
				"lng": 11.463775458585324,
				"lat": 43.545319438425835
			},
			{
				"lng": 11.463773627230859,
				"lat": 43.545320174352156
			},
			{
				"lng": 11.463771812224653,
				"lat": 43.545320895550354
			},
			{
				"lng": 11.463770013157784,
				"lat": 43.545321602318239
			},
			{
				"lng": 11.463768229621303,
				"lat": 43.545322294953806
			},
			{
				"lng": 11.463766461206324,
				"lat": 43.545322973754914
			},
			{
				"lng": 11.463764707503893,
				"lat": 43.545323639019514
			},
			{
				"lng": 11.463762968105101,
				"lat": 43.545324291045524
			},
			{
				"lng": 11.463761242601009,
				"lat": 43.545324930130867
			},
			{
				"lng": 11.463759530582704,
				"lat": 43.545325556573438
			},
			{
				"lng": 11.463757831641244,
				"lat": 43.54532617067116
			},
			{
				"lng": 11.463756145367745,
				"lat": 43.545326772722014
			},
			{
				"lng": 11.463754471353225,
				"lat": 43.545327363023844
			},
			{
				"lng": 11.463752809188792,
				"lat": 43.545327941874568
			},
			{
				"lng": 11.463751158465518,
				"lat": 43.545328509572158
			},
			{
				"lng": 11.463749518774476,
				"lat": 43.545329066414503
			},
			{
				"lng": 11.463747889706729,
				"lat": 43.545329612699504
			},
			{
				"lng": 11.463746270853351,
				"lat": 43.5453301487251
			},
			{
				"lng": 11.463744661805446,
				"lat": 43.545330674789234
			},
			{
				"lng": 11.463743062154046,
				"lat": 43.545331191189781
			},
			{
				"lng": 11.463741471490254,
				"lat": 43.545331698224672
			},
			{
				"lng": 11.463739889405137,
				"lat": 43.545332196191836
			},
			{
				"lng": 11.463738315489771,
				"lat": 43.545332685389205
			},
			{
				"lng": 11.463736749335215,
				"lat": 43.545333166114681
			},
			{
				"lng": 11.463735190532574,
				"lat": 43.545333638666143
			},
			{
				"lng": 11.463733638672885,
				"lat": 43.545334103341588
			},
			{
				"lng": 11.463732093347236,
				"lat": 43.545334560438867
			},
			{
				"lng": 11.463730554146709,
				"lat": 43.545335010255961
			},
			{
				"lng": 11.463729020680784,
				"lat": 43.545335453088086
			},
			{
				"lng": 11.463727492963354,
				"lat": 43.545335889173039
			},
			{
				"lng": 11.463725971402555,
				"lat": 43.545336318692534
			},
			{
				"lng": 11.463724456422884,
				"lat": 43.545336741825849
			},
			{
				"lng": 11.463722948448801,
				"lat": 43.545337158752368
			},
			{
				"lng": 11.463721447904829,
				"lat": 43.545337569651345
			},
			{
				"lng": 11.463719955215446,
				"lat": 43.545337974702214
			},
			{
				"lng": 11.463718470805118,
				"lat": 43.545338374084231
			},
			{
				"lng": 11.463716995098382,
				"lat": 43.545338767976794
			},
			{
				"lng": 11.463715528519668,
				"lat": 43.545339156559209
			},
			{
				"lng": 11.463714071493509,
				"lat": 43.545339540010836
			},
			{
				"lng": 11.463712624444366,
				"lat": 43.545339918510969
			},
			{
				"lng": 11.463711187796747,
				"lat": 43.545340292238976
			},
			{
				"lng": 11.463709761975132,
				"lat": 43.545340661374212
			},
			{
				"lng": 11.463708347404012,
				"lat": 43.545341026095969
			},
			{
				"lng": 11.463706944507855,
				"lat": 43.545341386583615
			},
			{
				"lng": 11.463705553711181,
				"lat": 43.5453417430165
			},
			{
				"lng": 11.463704175438469,
				"lat": 43.545342095573908
			},
			{
				"lng": 11.463702810114201,
				"lat": 43.545342444435249
			},
			{
				"lng": 11.463701458162875,
				"lat": 43.545342789779774
			},
			{
				"lng": 11.463700120008959,
				"lat": 43.545343131786872
			},
			{
				"lng": 11.463698796076951,
				"lat": 43.545343470635913
			},
			{
				"lng": 11.463697486791361,
				"lat": 43.545343806506189
			},
			{
				"lng": 11.463696192576649,
				"lat": 43.545344139577033
			},
			{
				"lng": 11.46369491385731,
				"lat": 43.545344470027779
			},
			{
				"lng": 11.463693651057833,
				"lat": 43.545344798037817
			},
			{
				"lng": 11.463692404602739,
				"lat": 43.545345123786454
			},
			{
				"lng": 11.463691174916464,
				"lat": 43.545345447452995
			},
			{
				"lng": 11.463689962423517,
				"lat": 43.545345769216766
			},
			{
				"lng": 11.463688767548401,
				"lat": 43.545346089257208
			},
			{
				"lng": 11.46368759071558,
				"lat": 43.545346407753563
			},
			{
				"lng": 11.463686432349563,
				"lat": 43.545346724885199
			},
			{
				"lng": 11.463685292874827,
				"lat": 43.54534704083143
			},
			{
				"lng": 11.463684172715862,
				"lat": 43.545347355771661
			},
			{
				"lng": 11.463683072297163,
				"lat": 43.545347669885167
			},
			{
				"lng": 11.463681992043204,
				"lat": 43.545347983351306
			},
			{
				"lng": 11.463680932378487,
				"lat": 43.545348296349403
			},
			{
				"lng": 11.4636798937275,
				"lat": 43.545348609058813
			},
			{
				"lng": 11.463678876514706,
				"lat": 43.545348921658835
			},
			{
				"lng": 11.463677881164635,
				"lat": 43.545349234328874
			},
			{
				"lng": 11.463676908093973,
				"lat": 43.545349547246573
			},
			{
				"lng": 11.463675957312258,
				"lat": 43.545349860503059
			},
			{
				"lng": 11.46367502823008,
				"lat": 43.545350174062115
			},
			{
				"lng": 11.463674120210083,
				"lat": 43.54535048787735
			},
			{
				"lng": 11.463673232614868,
				"lat": 43.545350801902366
			},
			{
				"lng": 11.463672364807097,
				"lat": 43.545351116090757
			},
			{
				"lng": 11.463671516149384,
				"lat": 43.545351430396153
			},
			{
				"lng": 11.463670686004352,
				"lat": 43.545351744772091
			},
			{
				"lng": 11.463669873734668,
				"lat": 43.545352059172238
			},
			{
				"lng": 11.463669078702921,
				"lat": 43.545352373550124
			},
			{
				"lng": 11.463668300271758,
				"lat": 43.545352687859406
			},
			{
				"lng": 11.463667537803822,
				"lat": 43.545353002053666
			},
			{
				"lng": 11.463666790661746,
				"lat": 43.545353316086462
			},
			{
				"lng": 11.463666058208126,
				"lat": 43.54535362991146
			},
			{
				"lng": 11.46366533980563,
				"lat": 43.545353943482226
			},
			{
				"lng": 11.463664634816876,
				"lat": 43.54535425675234
			},
			{
				"lng": 11.463663942604496,
				"lat": 43.545354569675425
			},
			{
				"lng": 11.463663262531123,
				"lat": 43.545354882205082
			},
			{
				"lng": 11.463662593959381,
				"lat": 43.545355194294906
			},
			{
				"lng": 11.463661936251906,
				"lat": 43.545355505898485
			},
			{
				"lng": 11.463661288771327,
				"lat": 43.545355816969398
			},
			{
				"lng": 11.46366065088028,
				"lat": 43.545356127461297
			},
			{
				"lng": 11.463660021941399,
				"lat": 43.545356437327754
			},
			{
				"lng": 11.463659401317301,
				"lat": 43.545356746522387
			},
			{
				"lng": 11.463658788370616,
				"lat": 43.54535705499876
			},
			{
				"lng": 11.463657582960064,
				"lat": 43.545357669611136
			},
			{
				"lng": 11.463656400610759,
				"lat": 43.545358280793693
			},
			{
				"lng": 11.463655236223779,
				"lat": 43.545358888175286
			},
			{
				"lng": 11.463654084700147,
				"lat": 43.545359491384666
			},
			{
				"lng": 11.463652940940932,
				"lat": 43.545360090050593
			},
			{
				"lng": 11.463650656319871,
				"lat": 43.545361272267279
			},
			{
				"lng": 11.463649505261277,
				"lat": 43.545361855075697
			},
			{
				"lng": 11.463648343164767,
				"lat": 43.545362431970076
			},
			{
				"lng": 11.463647171279101,
				"lat": 43.545363003034431
			},
			{
				"lng": 11.463645991737476,
				"lat": 43.545363568416164
			},
			{
				"lng": 11.463644806673098,
				"lat": 43.545364128262619
			},
			{
				"lng": 11.46364361821921,
				"lat": 43.545364682721278
			},
			{
				"lng": 11.463641239675651,
				"lat": 43.545365776064635
			},
			{
				"lng": 11.463640053852401,
				"lat": 43.545366315244152
			},
			{
				"lng": 11.463638873172469,
				"lat": 43.545366849625431
			},
			{
				"lng": 11.463637699769045,
				"lat": 43.545367379355888
			},
			{
				"lng": 11.463636535775345,
				"lat": 43.545367904582868
			},
			{
				"lng": 11.463635383324593,
				"lat": 43.545368425453852
			},
			{
				"lng": 11.463634244549988,
				"lat": 43.545368942116205
			},
			{
				"lng": 11.463633121584722,
				"lat": 43.545369454717296
			},
			{
				"lng": 11.463632016562034,
				"lat": 43.545369963404596
			},
			{
				"lng": 11.463630931615112,
				"lat": 43.545370468325409
			},
			{
				"lng": 11.463629868877206,
				"lat": 43.545370969627243
			},
			{
				"lng": 11.463628830481472,
				"lat": 43.545371467457464
			},
			{
				"lng": 11.463627818561157,
				"lat": 43.545371961963426
			},
			{
				"lng": 11.463626835249453,
				"lat": 43.545372453292579
			},
			{
				"lng": 11.463625881608277,
				"lat": 43.545372941751104
			},
			{
				"lng": 11.463624954659089,
				"lat": 43.545373428244154
			},
			{
				"lng": 11.463624050470971,
				"lat": 43.545373913818068
			},
			{
				"lng": 11.463623165112955,
				"lat": 43.545374399519105
			},
			{
				"lng": 11.463622294654114,
				"lat": 43.545374886393624
			},
			{
				"lng": 11.463621435163507,
				"lat": 43.545375375487971
			},
			{
				"lng": 11.463620582710222,
				"lat": 43.545375867848435
			},
			{
				"lng": 11.463618883191778,
				"lat": 43.545376866552914
			},
			{
				"lng": 11.463618028264751,
				"lat": 43.545377374989599
			},
			{
				"lng": 11.463617164651284,
				"lat": 43.54537789087766
			},
			{
				"lng": 11.463616288420425,
				"lat": 43.545378415263428
			},
			{
				"lng": 11.463615395641241,
				"lat": 43.545378949193207
			},
			{
				"lng": 11.463614482382788,
				"lat": 43.545379493713291
			},
			{
				"lng": 11.463614016845419,
				"lat": 43.545379770271708
			},
			{
				"lng": 11.463613544714132,
				"lat": 43.545380049870062
			},
			{
				"lng": 11.463613065497558,
				"lat": 43.545380332639155
			},
			{
				"lng": 11.463612578704318,
				"lat": 43.545380618709807
			},
			{
				"lng": 11.463612083843078,
				"lat": 43.545380908212771
			},
			{
				"lng": 11.463611580422432,
				"lat": 43.545381201278794
			},
			{
				"lng": 11.463611067951026,
				"lat": 43.545381498038793
			},
			{
				"lng": 11.46361054593752,
				"lat": 43.545381798623431
			},
			{
				"lng": 11.463610013890506,
				"lat": 43.545382103163554
			},
			{
				"lng": 11.463609471318621,
				"lat": 43.545382411789944
			},
			{
				"lng": 11.463608917730532,
				"lat": 43.54538272463342
			},
			{
				"lng": 11.463608352634836,
				"lat": 43.545383041824678
			},
			{
				"lng": 11.463607775622634,
				"lat": 43.545383363469725
			},
			{
				"lng": 11.463607186755699,
				"lat": 43.545383689532102
			},
			{
				"lng": 11.463606586262586,
				"lat": 43.545384019925152
			},
			{
				"lng": 11.463605974372047,
				"lat": 43.545384354562032
			},
			{
				"lng": 11.463605351312882,
				"lat": 43.545384693355921
			},
			{
				"lng": 11.463604717313789,
				"lat": 43.545385036220033
			},
			{
				"lng": 11.463604072603552,
				"lat": 43.545385383067575
			},
			{
				"lng": 11.463603417410924,
				"lat": 43.545385733811798
			},
			{
				"lng": 11.46360275196467,
				"lat": 43.545386088365817
			},
			{
				"lng": 11.463602076493514,
				"lat": 43.545386446642873
			},
			{
				"lng": 11.463601391226252,
				"lat": 43.545386808556131
			},
			{
				"lng": 11.463600696391609,
				"lat": 43.545387174018828
			},
			{
				"lng": 11.463599992218365,
				"lat": 43.545387542944141
			},
			{
				"lng": 11.463599278935247,
				"lat": 43.5453879152453
			},
			{
				"lng": 11.463598556771034,
				"lat": 43.545388290835461
			},
			{
				"lng": 11.463597825954478,
				"lat": 43.545388669627876
			},
			{
				"lng": 11.463597086714332,
				"lat": 43.545389051535693
			},
			{
				"lng": 11.46359633927934,
				"lat": 43.545389436472142
			},
			{
				"lng": 11.463595583878279,
				"lat": 43.54538982435038
			},
			{
				"lng": 11.463594820739893,
				"lat": 43.545390215083678
			},
			{
				"lng": 11.463594050092947,
				"lat": 43.545390608585194
			},
			{
				"lng": 11.463593272166174,
				"lat": 43.545391004768106
			},
			{
				"lng": 11.463591695388244,
				"lat": 43.545391804830984
			},
			{
				"lng": 11.463590092236128,
				"lat": 43.54539261457797
			},
			{
				"lng": 11.463588464539884,
				"lat": 43.54539343331458
			},
			{
				"lng": 11.463586814129561,
				"lat": 43.545394260346441
			},
			{
				"lng": 11.46358514283521,
				"lat": 43.545395094979156
			},
			{
				"lng": 11.463583452486867,
				"lat": 43.545395936518325
			},
			{
				"lng": 11.463581744914594,
				"lat": 43.545396784269542
			},
			{
				"lng": 11.463580021948424,
				"lat": 43.545397637538407
			},
			{
				"lng": 11.463578285418416,
				"lat": 43.545398495630444
			},
			{
				"lng": 11.463576537118829,
				"lat": 43.545399357947673
			},
			{
				"lng": 11.463574778626938,
				"lat": 43.545400224476317
			},
			{
				"lng": 11.463573011438623,
				"lat": 43.545401095421738
			},
			{
				"lng": 11.46357123704966,
				"lat": 43.545401970989708
			},
			{
				"lng": 11.463569456955774,
				"lat": 43.545402851385951
			},
			{
				"lng": 11.463565885636223,
				"lat": 43.545404627486427
			},
			{
				"lng": 11.463564097402044,
				"lat": 43.545405523602163
			},
			{
				"lng": 11.463562309445969,
				"lat": 43.545406425369208
			},
			{
				"lng": 11.463560523263695,
				"lat": 43.545407332993356
			},
			{
				"lng": 11.463558740350985,
				"lat": 43.545408246680353
			},
			{
				"lng": 11.46355696220359,
				"lat": 43.545409166635928
			},
			{
				"lng": 11.463555190317276,
				"lat": 43.545410093065883
			},
			{
				"lng": 11.463553426187772,
				"lat": 43.545411026175984
			},
			{
				"lng": 11.463551671310819,
				"lat": 43.545411966171933
			},
			{
				"lng": 11.463549927182173,
				"lat": 43.545412913259582
			},
			{
				"lng": 11.463548195297593,
				"lat": 43.545413867644591
			},
			{
				"lng": 11.463546477152827,
				"lat": 43.545414829532746
			},
			{
				"lng": 11.463544774243607,
				"lat": 43.545415799129827
			},
			{
				"lng": 11.463543088065697,
				"lat": 43.54541677664163
			},
			{
				"lng": 11.463541420081306,
				"lat": 43.545417762088618
			},
			{
				"lng": 11.463539771492075,
				"lat": 43.545418754051688
			},
			{
				"lng": 11.463538143377576,
				"lat": 43.545419750437368
			},
			{
				"lng": 11.463536536816674,
				"lat": 43.545420749148377
			},
			{
				"lng": 11.463534952888262,
				"lat": 43.545421748087463
			},
			{
				"lng": 11.463533392671208,
				"lat": 43.545422745157289
			},
			{
				"lng": 11.463531857244426,
				"lat": 43.545423738260652
			},
			{
				"lng": 11.463530347686756,
				"lat": 43.545424725300229
			},
			{
				"lng": 11.4635288650771,
				"lat": 43.545425704178747
			},
			{
				"lng": 11.463528134214929,
				"lat": 43.545426189902201
			},
			{
				"lng": 11.463527410494343,
				"lat": 43.545426672798925
			},
			{
				"lng": 11.463526694050195,
				"lat": 43.545427152606749
			},
			{
				"lng": 11.463525985017364,
				"lat": 43.545427629063511
			},
			{
				"lng": 11.463525283530684,
				"lat": 43.545428101907042
			},
			{
				"lng": 11.463524589725029,
				"lat": 43.545428570875181
			},
			{
				"lng": 11.46352390373527,
				"lat": 43.545429035705794
			},
			{
				"lng": 11.463523225696262,
				"lat": 43.545429496136705
			},
			{
				"lng": 11.463522555742836,
				"lat": 43.545429951905746
			},
			{
				"lng": 11.463521894009894,
				"lat": 43.545430402750753
			},
			{
				"lng": 11.463521240632275,
				"lat": 43.545430848409623
			},
			{
				"lng": 11.463520595744846,
				"lat": 43.545431288620115
			},
			{
				"lng": 11.463519959482465,
				"lat": 43.54543172312011
			},
			{
				"lng": 11.463519331979986,
				"lat": 43.545432151647432
			},
			{
				"lng": 11.463518713372286,
				"lat": 43.545432573939969
			},
			{
				"lng": 11.463518103794206,
				"lat": 43.545432989735524
			},
			{
				"lng": 11.463517503380615,
				"lat": 43.545433398771912
			},
			{
				"lng": 11.463516912266376,
				"lat": 43.545433800787023
			},
			{
				"lng": 11.463516330586343,
				"lat": 43.545434195518659
			},
			{
				"lng": 11.463515758475388,
				"lat": 43.545434582704708
			},
			{
				"lng": 11.463515196068368,
				"lat": 43.545434962082936
			},
			{
				"lng": 11.463514643500137,
				"lat": 43.545435333391247
			},
			{
				"lng": 11.463514100901676,
				"lat": 43.545435696372913
			},
			{
				"lng": 11.463513568263291,
				"lat": 43.54543605096908
			},
			{
				"lng": 11.463513045398106,
				"lat": 43.545436397370182
			},
			{
				"lng": 11.463512532107899,
				"lat": 43.545436735782481
			},
			{
				"lng": 11.463512028194504,
				"lat": 43.545437066412219
			},
			{
				"lng": 11.463511533459736,
				"lat": 43.545437389465761
			},
			{
				"lng": 11.463511047705374,
				"lat": 43.545437705149304
			},
			{
				"lng": 11.463510570733257,
				"lat": 43.545438013669184
			},
			{
				"lng": 11.463510102345197,
				"lat": 43.545438315231699
			},
			{
				"lng": 11.463509642342983,
				"lat": 43.545438610043064
			},
			{
				"lng": 11.463509190528447,
				"lat": 43.545438898309605
			},
			{
				"lng": 11.463508746703374,
				"lat": 43.545439180237601
			},
			{
				"lng": 11.463508310669603,
				"lat": 43.5454394560333
			},
			{
				"lng": 11.463507882228917,
				"lat": 43.545439725903023
			},
			{
				"lng": 11.463507461183148,
				"lat": 43.545439990053062
			},
			{
				"lng": 11.463507047334097,
				"lat": 43.545440248689673
			},
			{
				"lng": 11.463506640483581,
				"lat": 43.545440502019119
			},
			{
				"lng": 11.463506240433393,
				"lat": 43.545440750247714
			},
			{
				"lng": 11.463505846985365,
				"lat": 43.545440993581735
			},
			{
				"lng": 11.463505459941292,
				"lat": 43.545441232227482
			},
			{
				"lng": 11.46350507910299,
				"lat": 43.545441466391182
			},
			{
				"lng": 11.463504704272269,
				"lat": 43.545441696279177
			},
			{
				"lng": 11.463504335250942,
				"lat": 43.54544192209773
			},
			{
				"lng": 11.463503971840801,
				"lat": 43.545442144053034
			},
			{
				"lng": 11.463503261061385,
				"lat": 43.545442577199388
			},
			{
				"lng": 11.463502570348476,
				"lat": 43.545442997368461
			},
			{
				"lng": 11.463501898116576,
				"lat": 43.545443406210495
			},
			{
				"lng": 11.463501242780174,
				"lat": 43.545443805375747
			},
			{
				"lng": 11.463500602753722,
				"lat": 43.545444196514424
			},
			{
				"lng": 11.463499976451699,
				"lat": 43.545444581276882
			},
			{
				"lng": 11.463499362288641,
				"lat": 43.545444961313287
			},
			{
				"lng": 11.463498758678954,
				"lat": 43.545445338273915
			},
			{
				"lng": 11.463498164052034,
				"lat": 43.545445713758077
			},
			{
				"lng": 11.463496996407208,
				"lat": 43.545446463460728
			},
			{
				"lng": 11.463495849404211,
				"lat": 43.545447214251524
			},
			{
				"lng": 11.463494713248778,
				"lat": 43.54544796942718
			},
			{
				"lng": 11.463493578146643,
				"lat": 43.545448732284342
			},
			{
				"lng": 11.463492434303568,
				"lat": 43.545449506119851
			},
			{
				"lng": 11.463491856043445,
				"lat": 43.545449898184692
			},
			{
				"lng": 11.463491271925239,
				"lat": 43.545450294230342
			},
			{
				"lng": 11.463490680724679,
				"lat": 43.545450694668958
			},
			{
				"lng": 11.463490081217435,
				"lat": 43.54545109991254
			},
			{
				"lng": 11.463489472179264,
				"lat": 43.545451510373276
			},
			{
				"lng": 11.463488852385874,
				"lat": 43.545451926463173
			},
			{
				"lng": 11.463488220612966,
				"lat": 43.545452348594395
			},
			{
				"lng": 11.463487575636275,
				"lat": 43.545452777178973
			},
			{
				"lng": 11.463486916231515,
				"lat": 43.545453212629013
			},
			{
				"lng": 11.46348624115125,
				"lat": 43.545453655370395
			},
			{
				"lng": 11.463485548721138,
				"lat": 43.545454106083788
			},
			{
				"lng": 11.463484836891091,
				"lat": 43.5454545656739
			},
			{
				"lng": 11.463484103598246,
				"lat": 43.545455035053216
			},
			{
				"lng": 11.463483346779736,
				"lat": 43.545455515134101
			},
			{
				"lng": 11.463482958903692,
				"lat": 43.545455759472794
			},
			{
				"lng": 11.463482564372661,
				"lat": 43.545456006829049
			},
			{
				"lng": 11.463482162928765,
				"lat": 43.545456257316872
			},
			{
				"lng": 11.463481754314151,
				"lat": 43.545456511050403
			},
			{
				"lng": 11.463481338270972,
				"lat": 43.54545676814363
			},
			{
				"lng": 11.463480914541345,
				"lat": 43.545457028710643
			},
			{
				"lng": 11.463480482867414,
				"lat": 43.54545729286545
			},
			{
				"lng": 11.463480042991346,
				"lat": 43.545457560722127
			},
			{
				"lng": 11.463479594655258,
				"lat": 43.545457832394753
			},
			{
				"lng": 11.463479137601279,
				"lat": 43.545458107997348
			},
			{
				"lng": 11.46347867157157,
				"lat": 43.545458387643954
			},
			{
				"lng": 11.463478196308275,
				"lat": 43.545458671448678
			},
			{
				"lng": 11.463477711553518,
				"lat": 43.54545895952554
			},
			{
				"lng": 11.463477217049453,
				"lat": 43.545459251988554
			},
			{
				"lng": 11.463476712538194,
				"lat": 43.545459548951833
			},
			{
				"lng": 11.463476197761922,
				"lat": 43.545459850529397
			},
			{
				"lng": 11.463475672462742,
				"lat": 43.545460156835333
			},
			{
				"lng": 11.463475136382817,
				"lat": 43.545460467983652
			},
			{
				"lng": 11.463474589264273,
				"lat": 43.545460784088419
			},
			{
				"lng": 11.463474030849261,
				"lat": 43.545461105263698
			},
			{
				"lng": 11.463473460879902,
				"lat": 43.545461431623536
			},
			{
				"lng": 11.463472879098347,
				"lat": 43.545461763281949
			},
			{
				"lng": 11.463472285246761,
				"lat": 43.545462100353085
			},
			{
				"lng": 11.463471679067244,
				"lat": 43.545462442950893
			},
			{
				"lng": 11.463471060301945,
				"lat": 43.545462791189472
			},
			{
				"lng": 11.463470428693032,
				"lat": 43.545463145182879
			},
			{
				"lng": 11.463469783982603,
				"lat": 43.545463505045127
			},
			{
				"lng": 11.463469125912837,
				"lat": 43.545463870890366
			},
			{
				"lng": 11.463468454225865,
				"lat": 43.545464242832537
			},
			{
				"lng": 11.463467768663795,
				"lat": 43.545464620985769
			},
			{
				"lng": 11.463467068968795,
				"lat": 43.54546500546401
			},
			{
				"lng": 11.463466354894452,
				"lat": 43.545465396363184
			},
			{
				"lng": 11.463465626248874,
				"lat": 43.545465793691761
			},
			{
				"lng": 11.463464882856492,
				"lat": 43.54546619743234
			},
			{
				"lng": 11.463464124541721,
				"lat": 43.545466607567519
			},
			{
				"lng": 11.463463351128969,
				"lat": 43.545467024079834
			},
			{
				"lng": 11.463462562442654,
				"lat": 43.545467446951804
			},
			{
				"lng": 11.46346175830719,
				"lat": 43.545467876166065
			},
			{
				"lng": 11.463460938546978,
				"lat": 43.545468311705186
			},
			{
				"lng": 11.463460102986444,
				"lat": 43.545468753551688
			},
			{
				"lng": 11.463459251449995,
				"lat": 43.545469201688185
			},
			{
				"lng": 11.463458383762045,
				"lat": 43.545469656097204
			},
			{
				"lng": 11.463457499747026,
				"lat": 43.545470116761344
			},
			{
				"lng": 11.463456599229321,
				"lat": 43.545470583663139
			},
			{
				"lng": 11.46345568203337,
				"lat": 43.545471056785175
			},
			{
				"lng": 11.463454747983556,
				"lat": 43.545471536110036
			},
			{
				"lng": 11.463453796904338,
				"lat": 43.545472021620256
			},
			{
				"lng": 11.463452828620076,
				"lat": 43.545472513298428
			},
			{
				"lng": 11.463451842955235,
				"lat": 43.545473011127093
			},
			{
				"lng": 11.463450839734186,
				"lat": 43.54547351508883
			},
			{
				"lng": 11.463449818781363,
				"lat": 43.545474025166207
			},
			{
				"lng": 11.46344877992118,
				"lat": 43.545474541341818
			},
			{
				"lng": 11.463447722978044,
				"lat": 43.545475063598182
			},
			{
				"lng": 11.463446647776379,
				"lat": 43.545475591917899
			},
			{
				"lng": 11.463445554140577,
				"lat": 43.545476126283525
			},
			{
				"lng": 11.46344444189506,
				"lat": 43.545476666677601
			},
			{
				"lng": 11.463443310864267,
				"lat": 43.545477213082719
			},
			{
				"lng": 11.463442160872573,
				"lat": 43.545477765481472
			},
			{
				"lng": 11.463440991744408,
				"lat": 43.545478323856386
			},
			{
				"lng": 11.463439803304198,
				"lat": 43.54547888819004
			},
			{
				"lng": 11.463438595376337,
				"lat": 43.545479458465003
			},
			{
				"lng": 11.463437367785231,
				"lat": 43.545480034663882
			},
			{
				"lng": 11.463436120355324,
				"lat": 43.545480616769154
			},
			{
				"lng": 11.463434852911005,
				"lat": 43.545481204763419
			},
			{
				"lng": 11.46343356527669,
				"lat": 43.545481798629304
			},
			{
				"lng": 11.463432257276821,
				"lat": 43.545482398349314
			},
			{
				"lng": 11.463430928735761,
				"lat": 43.545483003906035
			},
			{
				"lng": 11.463429579477957,
				"lat": 43.545483615282023
			},
			{
				"lng": 11.463428209327803,
				"lat": 43.545484232459849
			},
			{
				"lng": 11.463426818109735,
				"lat": 43.545484855422096
			},
			{
				"lng": 11.463425405648154,
				"lat": 43.545485484151307
			},
			{
				"lng": 11.463423971771761,
				"lat": 43.545486118642629
			},
			{
				"lng": 11.463422516342696,
				"lat": 43.545486758988574
			},
			{
				"lng": 11.463421039238703,
				"lat": 43.545487405327457
			},
			{
				"lng": 11.463419540337632,
				"lat": 43.545488057797762
			},
			{
				"lng": 11.463418019517363,
				"lat": 43.545488716537982
			},
			{
				"lng": 11.463416476655729,
				"lat": 43.545489381686664
			},
			{
				"lng": 11.463414911630593,
				"lat": 43.545490053382252
			},
			{
				"lng": 11.463413324319795,
				"lat": 43.54549073176328
			},
			{
				"lng": 11.4634117146012,
				"lat": 43.545491416968297
			},
			{
				"lng": 11.463410082352647,
				"lat": 43.545492109135729
			},
			{
				"lng": 11.463408427452014,
				"lat": 43.545492808404141
			},
			{
				"lng": 11.463406749777123,
				"lat": 43.545493514911996
			},
			{
				"lng": 11.463405049205862,
				"lat": 43.5454942287978
			},
			{
				"lng": 11.463403325616044,
				"lat": 43.545494950200094
			},
			{
				"lng": 11.463401578885545,
				"lat": 43.545495679257364
			},
			{
				"lng": 11.463399808892222,
				"lat": 43.545496416108108
			},
			{
				"lng": 11.463398015513921,
				"lat": 43.545497160890839
			},
			{
				"lng": 11.46339619862848,
				"lat": 43.545497913744022
			},
			{
				"lng": 11.463394358113772,
				"lat": 43.545498674806225
			},
			{
				"lng": 11.463392493847664,
				"lat": 43.545499444215892
			},
			{
				"lng": 11.463390605707971,
				"lat": 43.54550022211162
			},
			{
				"lng": 11.463388693572561,
				"lat": 43.545501008631831
			},
			{
				"lng": 11.463386757319286,
				"lat": 43.545501803915045
			},
			{
				"lng": 11.463384796826009,
				"lat": 43.545502608099788
			},
			{
				"lng": 11.463382811970574,
				"lat": 43.545503421324526
			},
			{
				"lng": 11.463380802630821,
				"lat": 43.545504243727805
			},
			{
				"lng": 11.463378768684635,
				"lat": 43.545505075448105
			},
			{
				"lng": 11.463376710009829,
				"lat": 43.545505916623938
			},
			{
				"lng": 11.463374626484281,
				"lat": 43.545506767393803
			},
			{
				"lng": 11.463372517985826,
				"lat": 43.545507627896235
			},
			{
				"lng": 11.463370384392341,
				"lat": 43.545508498269719
			},
			{
				"lng": 11.46336822558165,
				"lat": 43.545509378652682
			},
			{
				"lng": 11.463366041431641,
				"lat": 43.545510269183765
			},
			{
				"lng": 11.463363831820111,
				"lat": 43.545511170001383
			},
			{
				"lng": 11.463361596624967,
				"lat": 43.545512081244084
			},
			{
				"lng": 11.463359335724034,
				"lat": 43.545513003050281
			},
			{
				"lng": 11.463357048995167,
				"lat": 43.545513935558617
			},
			{
				"lng": 11.463354736316216,
				"lat": 43.545514878907532
			},
			{
				"lng": 11.463352397565025,
				"lat": 43.545515833235498
			},
			{
				"lng": 11.46335003261947,
				"lat": 43.545516798681042
			},
			{
				"lng": 11.463347641418178,
				"lat": 43.545517775351861
			},
			{
				"lng": 11.463345224717603,
				"lat": 43.545518762941064
			},
			{
				"lng": 11.463342783859737,
				"lat": 43.54551976084494
			},
			{
				"lng": 11.463340320199276,
				"lat": 43.545520768453315
			},
			{
				"lng": 11.463337835090924,
				"lat": 43.545521785156012
			},
			{
				"lng": 11.463335329889409,
				"lat": 43.545522810342867
			},
			{
				"lng": 11.463332805949465,
				"lat": 43.545523843403757
			},
			{
				"lng": 11.463330264625771,
				"lat": 43.545524883728454
			},
			{
				"lng": 11.463327707273057,
				"lat": 43.545525930706845
			},
			{
				"lng": 11.463325135246043,
				"lat": 43.545526983728664
			},
			{
				"lng": 11.463322549899432,
				"lat": 43.545528042183882
			},
			{
				"lng": 11.463319952587948,
				"lat": 43.545529105462236
			},
			{
				"lng": 11.463317344666304,
				"lat": 43.545530172953569
			},
			{
				"lng": 11.463314727489223,
				"lat": 43.545531244047751
			},
			{
				"lng": 11.4633121024114,
				"lat": 43.545532318134612
			},
			{
				"lng": 11.463306833972426,
				"lat": 43.545534472845603
			},
			{
				"lng": 11.46329626189325,
				"lat": 43.545538791332291
			},
			{
				"lng": 11.4632909799285,
				"lat": 43.545540945345287
			},
			{
				"lng": 11.463285715130624,
				"lat": 43.545543089363001
			},
			{
				"lng": 11.463283092556054,
				"lat": 43.545544156098188
			},
			{
				"lng": 11.463280478337373,
				"lat": 43.545545218504067
			},
			{
				"lng": 11.46327787382927,
				"lat": 43.54554627597043
			},
			{
				"lng": 11.463275280386485,
				"lat": 43.545547327887142
			},
			{
				"lng": 11.463272699363717,
				"lat": 43.545548373644067
			},
			{
				"lng": 11.463270132115703,
				"lat": 43.545549412630969
			},
			{
				"lng": 11.463267579997147,
				"lat": 43.545550444237755
			},
			{
				"lng": 11.463265044362792,
				"lat": 43.545551467854231
			},
			{
				"lng": 11.463262526567332,
				"lat": 43.545552482870235
			},
			{
				"lng": 11.4632600279655,
				"lat": 43.545553488675544
			},
			{
				"lng": 11.463257549911994,
				"lat": 43.54555448466008
			},
			{
				"lng": 11.463255093761573,
				"lat": 43.54555547021365
			},
			{
				"lng": 11.463252660868932,
				"lat": 43.545556444726095
			},
			{
				"lng": 11.463250252588789,
				"lat": 43.545557407587225
			},
			{
				"lng": 11.463249058101749,
				"lat": 43.545557884457885
			},
			{
				"lng": 11.46324787027587,
				"lat": 43.545558358186923
			},
			{
				"lng": 11.463246689280476,
				"lat": 43.545558828698034
			},
			{
				"lng": 11.463245515260413,
				"lat": 43.545559295935995
			},
			{
				"lng": 11.463244348243695,
				"lat": 43.545559759945945
			},
			{
				"lng": 11.463243188223421,
				"lat": 43.545560220802898
			},
			{
				"lng": 11.463242035192755,
				"lat": 43.545560678581872
			},
			{
				"lng": 11.463240889144837,
				"lat": 43.545561133357914
			},
			{
				"lng": 11.463239750072786,
				"lat": 43.545561585206165
			},
			{
				"lng": 11.46323861796977,
				"lat": 43.545562034201517
			},
			{
				"lng": 11.463237492828899,
				"lat": 43.545562480419107
			},
			{
				"lng": 11.463236374643326,
				"lat": 43.545562923933943
			},
			{
				"lng": 11.463235263406172,
				"lat": 43.545563364821078
			},
			{
				"lng": 11.463234159110593,
				"lat": 43.545563803155545
			},
			{
				"lng": 11.463231971316679,
				"lat": 43.545564672466625
			},
			{
				"lng": 11.463229811206684,
				"lat": 43.54556553246757
			},
			{
				"lng": 11.46322767872571,
				"lat": 43.545566383758661
			},
			{
				"lng": 11.463225573818852,
				"lat": 43.545567226940221
			},
			{
				"lng": 11.463223496431223,
				"lat": 43.54556806261261
			},
			{
				"lng": 11.463221446507916,
				"lat": 43.54556889137617
			},
			{
				"lng": 11.46321942399401,
				"lat": 43.545569713831156
			},
			{
				"lng": 11.463217428834627,
				"lat": 43.545570530578004
			},
			{
				"lng": 11.463215460974878,
				"lat": 43.545571342216931
			},
			{
				"lng": 11.463213520359835,
				"lat": 43.545572149348324
			},
			{
				"lng": 11.463211606934605,
				"lat": 43.545572952572542
			},
			{
				"lng": 11.46320972064429,
				"lat": 43.545573752489837
			},
			{
				"lng": 11.463207861433999,
				"lat": 43.545574549700603
			},
			{
				"lng": 11.463206029248827,
				"lat": 43.545575344805123
			},
			{
				"lng": 11.463204224033861,
				"lat": 43.545576138403767
			},
			{
				"lng": 11.463202445734195,
				"lat": 43.545576931096853
			},
			{
				"lng": 11.463200694294962,
				"lat": 43.545577723484683
			},
			{
				"lng": 11.46319896966124,
				"lat": 43.545578516167595
			},
			{
				"lng": 11.463197271778112,
				"lat": 43.545579309745911
			},
			{
				"lng": 11.463195600590693,
				"lat": 43.545580104820004
			},
			{
				"lng": 11.463193956044094,
				"lat": 43.545580901990164
			},
			{
				"lng": 11.463192338083388,
				"lat": 43.54558170185674
			},
			{
				"lng": 11.463190746653689,
				"lat": 43.545582505020036
			},
			{
				"lng": 11.463189181700091,
				"lat": 43.545583312080389
			},
			{
				"lng": 11.463187643167705,
				"lat": 43.545584123638129
			},
			{
				"lng": 11.463186131001605,
				"lat": 43.545584940293587
			},
			{
				"lng": 11.463184645146892,
				"lat": 43.545585762647072
			},
			{
				"lng": 11.463183185548692,
				"lat": 43.545586591298942
			},
			{
				"lng": 11.463181752152085,
				"lat": 43.545587426849529
			},
			{
				"lng": 11.463180344902163,
				"lat": 43.545588269899127
			},
			{
				"lng": 11.46317896374404,
				"lat": 43.545589121048089
			},
			{
				"lng": 11.463177608622795,
				"lat": 43.545589980896757
			},
			{
				"lng": 11.463176279483537,
				"lat": 43.5455908500454
			},
			{
				"lng": 11.463174976271361,
				"lat": 43.545591729094404
			},
			{
				"lng": 11.463173698929701,
				"lat": 43.545592618637116
			},
			{
				"lng": 11.463172447286032,
				"lat": 43.545593518783384
			},
			{
				"lng": 11.463171220978372,
				"lat": 43.545594428853207
			},
			{
				"lng": 11.463170019627315,
				"lat": 43.545595348093713
			},
			{
				"lng": 11.463168842853415,
				"lat": 43.545596275751933
			},
			{
				"lng": 11.463167690277235,
				"lat": 43.54559721107502
			},
			{
				"lng": 11.463166561519337,
				"lat": 43.54559815331006
			},
			{
				"lng": 11.463165456200297,
				"lat": 43.545599101704148
			},
			{
				"lng": 11.463164373940668,
				"lat": 43.545600055504373
			},
			{
				"lng": 11.463163314361019,
				"lat": 43.545601013957857
			},
			{
				"lng": 11.463162277081903,
				"lat": 43.545601976311708
			},
			{
				"lng": 11.463161261723895,
				"lat": 43.545602941812994
			},
			{
				"lng": 11.463160267907561,
				"lat": 43.545603909708831
			},
			{
				"lng": 11.463159295253465,
				"lat": 43.545604879246291
			},
			{
				"lng": 11.463158343382155,
				"lat": 43.545605849672505
			},
			{
				"lng": 11.463157411914217,
				"lat": 43.545606820234568
			},
			{
				"lng": 11.463156500470211,
				"lat": 43.545607790179581
			},
			{
				"lng": 11.463155608670688,
				"lat": 43.545608758754568
			},
			{
				"lng": 11.463154736136232,
				"lat": 43.545609725206802
			},
			{
				"lng": 11.463153882487392,
				"lat": 43.545610688783199
			},
			{
				"lng": 11.463153047344742,
				"lat": 43.545611648730954
			},
			{
				"lng": 11.463152230328834,
				"lat": 43.545612604297141
			},
			{
				"lng": 11.463151431060256,
				"lat": 43.545613554728853
			},
			{
				"lng": 11.463150649159543,
				"lat": 43.545614499273192
			},
			{
				"lng": 11.463149884247274,
				"lat": 43.545615437177283
			},
			{
				"lng": 11.463149135944015,
				"lat": 43.545616367688204
			},
			{
				"lng": 11.463148403870324,
				"lat": 43.545617290053023
			},
			{
				"lng": 11.463147687646789,
				"lat": 43.545618203518892
			},
			{
				"lng": 11.463146986893943,
				"lat": 43.545619107332875
			},
			{
				"lng": 11.463146301232358,
				"lat": 43.545620000742105
			},
			{
				"lng": 11.46314563028262,
				"lat": 43.545620882993632
			},
			{
				"lng": 11.46314497366526,
				"lat": 43.545621753334572
			},
			{
				"lng": 11.463144331000862,
				"lat": 43.545622611012043
			},
			{
				"lng": 11.463143701909996,
				"lat": 43.545623455273137
			},
			{
				"lng": 11.463143086013208,
				"lat": 43.545624285364944
			},
			{
				"lng": 11.46314248293109,
				"lat": 43.545625100534558
			},
			{
				"lng": 11.463141892284181,
				"lat": 43.54562590002908
			},
			{
				"lng": 11.463141313693045,
				"lat": 43.545626683095641
			},
			{
				"lng": 11.463140746778267,
				"lat": 43.545627448981293
			},
			{
				"lng": 11.463140191160392,
				"lat": 43.54562819693313
			},
			{
				"lng": 11.463139646460119,
				"lat": 43.5456289261991
			},
			{
				"lng": 11.46313911234386,
				"lat": 43.545629636341019
			},
			{
				"lng": 11.463138588593459,
				"lat": 43.545630327712232
			},
			{
				"lng": 11.463138075008574,
				"lat": 43.545631000788838
			},
			{
				"lng": 11.463137571388934,
				"lat": 43.545631656046965
			},
			{
				"lng": 11.463137077534222,
				"lat": 43.545632293962726
			},
			{
				"lng": 11.463136593244139,
				"lat": 43.545632915012177
			},
			{
				"lng": 11.463136118318374,
				"lat": 43.545633519671483
			},
			{
				"lng": 11.463135652556648,
				"lat": 43.545634108416742
			},
			{
				"lng": 11.463135195758623,
				"lat": 43.545634681724003
			},
			{
				"lng": 11.463134747724036,
				"lat": 43.545635240069423
			},
			{
				"lng": 11.463134308252553,
				"lat": 43.545635783929164
			},
			{
				"lng": 11.463133877143894,
				"lat": 43.545636313779212
			},
			{
				"lng": 11.463133454197749,
				"lat": 43.545636830095766
			},
			{
				"lng": 11.463133039213812,
				"lat": 43.545637333354854
			},
			{
				"lng": 11.463132631991773,
				"lat": 43.545637824032667
			},
			{
				"lng": 11.463132232331356,
				"lat": 43.545638302605241
			},
			{
				"lng": 11.463131840032236,
				"lat": 43.545638769548738
			},
			{
				"lng": 11.463131454894111,
				"lat": 43.545639225339215
			},
			{
				"lng": 11.463131076716676,
				"lat": 43.545639670452822
			},
			{
				"lng": 11.463130705299653,
				"lat": 43.545640105365642
			},
			{
				"lng": 11.463130340442707,
				"lat": 43.545640530553811
			},
			{
				"lng": 11.463129981945563,
				"lat": 43.545640946493364
			},
			{
				"lng": 11.463129629607899,
				"lat": 43.5456413536605
			},
			{
				"lng": 11.463129283229422,
				"lat": 43.545641752531267
			},
			{
				"lng": 11.463128942609821,
				"lat": 43.545642143581773
			},
			{
				"lng": 11.463128607548809,
				"lat": 43.545642527288152
			},
			{
				"lng": 11.463128277846067,
				"lat": 43.54564290412651
			},
			{
				"lng": 11.463127953301306,
				"lat": 43.545643274572939
			},
			{
				"lng": 11.463127633714208,
				"lat": 43.545643639103531
			},
			{
				"lng": 11.46312731888448,
				"lat": 43.545643998194421
			},
			{
				"lng": 11.463126702695918,
				"lat": 43.545644701961436
			},
			{
				"lng": 11.463126103133193,
				"lat": 43.545645389682882
			},
			{
				"lng": 11.463125518593895,
				"lat": 43.545646065167666
			},
			{
				"lng": 11.463124947475585,
				"lat": 43.545646732224562
			},
			{
				"lng": 11.463124388175839,
				"lat": 43.545647394662417
			}
			],
			[{
				"lng": 11.457767538001931,
				"lat": 43.547834822727395
			},
			{
				"lng": 11.457826579284825,
				"lat": 43.547833458203087
			},
			{
				"lng": 11.457890243910969,
				"lat": 43.547832887009328
			},
			{
				"lng": 11.457958544304192,
				"lat": 43.547833058633316
			},
			{
				"lng": 11.458030084898693,
				"lat": 43.547833732332862
			},
			{
				"lng": 11.458103118130374,
				"lat": 43.54783461981183
			},
			{
				"lng": 11.458175896433895,
				"lat": 43.547835432778569
			},
			{
				"lng": 11.458246672242637,
				"lat": 43.547835882945826
			},
			{
				"lng": 11.458264731103352,
				"lat": 43.547834634333192
			},
			{
				"lng": 11.458268908767064,
				"lat": 43.547833088474469
			},
			{
				"lng": 11.458275958457563,
				"lat": 43.54782865505949
			},
			{
				"lng": 11.458280071416093,
				"lat": 43.547825031970895
			},
			{
				"lng": 11.458286570826425,
				"lat": 43.547818562902542
			},
			{
				"lng": 11.458299817766063,
				"lat": 43.54780848830795
			},
			{
				"lng": 11.458304201983957,
				"lat": 43.547803034602801
			},
			{
				"lng": 11.458306740734159,
				"lat": 43.547799979325511
			},
			{
				"lng": 11.458309373012046,
				"lat": 43.547796215667177
			},
			{
				"lng": 11.458311457080347,
				"lat": 43.547786256674286
			},
			{
				"lng": 11.458312881850739,
				"lat": 43.547771742728472
			},
			{
				"lng": 11.458316327420709,
				"lat": 43.547760288875843
			},
			{
				"lng": 11.458315403492536,
				"lat": 43.547740480427613
			},
			{
				"lng": 11.458318129570763,
				"lat": 43.547720076201649
			},
			{
				"lng": 11.458317897769895,
				"lat": 43.547711460177901
			},
			{
				"lng": 11.458314945813088,
				"lat": 43.547702988878804
			},
			{
				"lng": 11.458312446523609,
				"lat": 43.547693990581458
			},
			{
				"lng": 11.458309978754649,
				"lat": 43.547685767496908
			},
			{
				"lng": 11.458305935851714,
				"lat": 43.547673785051167
			},
			{
				"lng": 11.458300212006343,
				"lat": 43.547666278658902
			},
			{
				"lng": 11.458294656566599,
				"lat": 43.547660497561125
			},
			{
				"lng": 11.458290875355205,
				"lat": 43.547657542388414
			},
			{
				"lng": 11.458280073232128,
				"lat": 43.547653047567856
			},
			{
				"lng": 11.458273434047054,
				"lat": 43.547651746365055
			},
			{
				"lng": 11.458267440972786,
				"lat": 43.547651005812376
			},
			{
				"lng": 11.458263122200137,
				"lat": 43.547650624962081
			},
			{
				"lng": 11.458259165512979,
				"lat": 43.54765026287523
			},
			{
				"lng": 11.458255619772837,
				"lat": 43.547649936411048
			},
			{
				"lng": 11.458252436942914,
				"lat": 43.547649645661451
			},
			{
				"lng": 11.458249544762023,
				"lat": 43.547649386526565
			},
			{
				"lng": 11.458246870968839,
				"lat": 43.547649154906367
			},
			{
				"lng": 11.458244343302111,
				"lat": 43.547648946700917
			},
			{
				"lng": 11.458241889500545,
				"lat": 43.547648757810144
			},
			{
				"lng": 11.458239437302877,
				"lat": 43.54764858413423
			},
			{
				"lng": 11.458236914447879,
				"lat": 43.547648421573093
			},
			{
				"lng": 11.458234269031015,
				"lat": 43.547648267288679
			},
			{
				"lng": 11.458231530574988,
				"lat": 43.547648123490447
			},
			{
				"lng": 11.45822874895928,
				"lat": 43.547647993650045
			},
			{
				"lng": 11.458225974063343,
				"lat": 43.547647881238788
			},
			{
				"lng": 11.458223255766633,
				"lat": 43.547647789728174
			},
			{
				"lng": 11.458220643948639,
				"lat": 43.547647722589716
			},
			{
				"lng": 11.458218188488791,
				"lat": 43.547647683294855
			},
			{
				"lng": 11.458215939266546,
				"lat": 43.547647675315105
			},
			{
				"lng": 11.458213920609261,
				"lat": 43.547647702597359
			},
			{
				"lng": 11.458212054635409,
				"lat": 43.547647770990046
			},
			{
				"lng": 11.458210237911379,
				"lat": 43.547647886817117
			},
			{
				"lng": 11.458208367003566,
				"lat": 43.547648056402373
			},
			{
				"lng": 11.458206338478281,
				"lat": 43.54764828606973
			},
			{
				"lng": 11.458204048901965,
				"lat": 43.547648582142976
			},
			{
				"lng": 11.458201394840904,
				"lat": 43.547648950945991
			},
			{
				"lng": 11.458198272861447,
				"lat": 43.547649398802584
			},
			{
				"lng": 11.458194609662019,
				"lat": 43.547649927100451
			},
			{
				"lng": 11.458190452469095,
				"lat": 43.547650517482772
			},
			{
				"lng": 11.458185878641302,
				"lat": 43.547651146656435
			},
			{
				"lng": 11.458180965537149,
				"lat": 43.547651791328562
			},
			{
				"lng": 11.458175790515265,
				"lat": 43.547652428206085
			},
			{
				"lng": 11.458170430934254,
				"lat": 43.547653033996184
			},
			{
				"lng": 11.458164964152676,
				"lat": 43.54765358540579
			},
			{
				"lng": 11.458159467529168,
				"lat": 43.547654059141927
			},
			{
				"lng": 11.458153998743894,
				"lat": 43.547654435707265
			},
			{
				"lng": 11.45814853676298,
				"lat": 43.547654710786013
			},
			{
				"lng": 11.458143040874091,
				"lat": 43.547654883858094
			},
			{
				"lng": 11.458137470364841,
				"lat": 43.547654954403299
			},
			{
				"lng": 11.458131784522907,
				"lat": 43.547654921901412
			},
			{
				"lng": 11.458125942635901,
				"lat": 43.547654785832108
			},
			{
				"lng": 11.458119903991511,
				"lat": 43.547654545675329
			},
			{
				"lng": 11.458113627877369,
				"lat": 43.547654200910763
			},
			{
				"lng": 11.458107094494419,
				"lat": 43.547653752820793
			},
			{
				"lng": 11.458100367696911,
				"lat": 43.547653209898328
			},
			{
				"lng": 11.458093532252359,
				"lat": 43.547652582438786
			},
			{
				"lng": 11.458086672928282,
				"lat": 43.547651880737796
			},
			{
				"lng": 11.458079874492187,
				"lat": 43.547651115090815
			},
			{
				"lng": 11.458073221711572,
				"lat": 43.547650295793495
			},
			{
				"lng": 11.458066799353954,
				"lat": 43.54764943314138
			},
			{
				"lng": 11.458060692186768,
				"lat": 43.547648537430106
			},
			{
				"lng": 11.458054965382457,
				"lat": 43.547647620912151
			},
			{
				"lng": 11.458049605733237,
				"lat": 43.547646703667318
			},
			{
				"lng": 11.458044580436166,
				"lat": 43.547645807732323
			},
			{
				"lng": 11.458039856688327,
				"lat": 43.547644955143937
			},
			{
				"lng": 11.458035401686882,
				"lat": 43.547644167938749
			},
			{
				"lng": 11.458031182628847,
				"lat": 43.547643468153495
			},
			{
				"lng": 11.458027166711366,
				"lat": 43.547642877824813
			},
			{
				"lng": 11.458023321131559,
				"lat": 43.547642418989412
			},
			{
				"lng": 11.458019612471556,
				"lat": 43.54764210535955
			},
			{
				"lng": 11.458016004854244,
				"lat": 43.547641917349772
			},
			{
				"lng": 11.458012461787471,
				"lat": 43.547641827050299
			},
			{
				"lng": 11.458008946779199,
				"lat": 43.547641806551411
			},
			{
				"lng": 11.458005423337394,
				"lat": 43.547641827943238
			},
			{
				"lng": 11.458001854970039,
				"lat": 43.547641863316059
			},
			{
				"lng": 11.457998205185017,
				"lat": 43.547641884759912
			},
			{
				"lng": 11.457994437490314,
				"lat": 43.547641864365069
			},
			{
				"lng": 11.45799053246718,
				"lat": 43.547641780655077
			},
			{
				"lng": 11.457986538989761,
				"lat": 43.54764163788721
			},
			{
				"lng": 11.45798252300548,
				"lat": 43.547641446752039
			},
			{
				"lng": 11.45797855046172,
				"lat": 43.547641217940338
			},
			{
				"lng": 11.457974687305915,
				"lat": 43.547640962142594
			},
			{
				"lng": 11.457970999485459,
				"lat": 43.547640690049583
			},
			{
				"lng": 11.457967552947769,
				"lat": 43.547640412351939
			},
			{
				"lng": 11.457964413640203,
				"lat": 43.547640139740352
			},
			{
				"lng": 11.457961622629256,
				"lat": 43.547639881872023
			},
			{
				"lng": 11.457959121457577,
				"lat": 43.547639644269772
			},
			{
				"lng": 11.45795682678688,
				"lat": 43.547639431422994
			},
			{
				"lng": 11.45795465527898,
				"lat": 43.547639247821074
			},
			{
				"lng": 11.457952523595566,
				"lat": 43.547639097953279
			},
			{
				"lng": 11.457950348398395,
				"lat": 43.547638986308989
			},
			{
				"lng": 11.457948046349228,
				"lat": 43.547638917377569
			},
			{
				"lng": 11.457945534109774,
				"lat": 43.547638895648319
			},
			{
				"lng": 11.457942739830397,
				"lat": 43.547638921531728
			},
			{
				"lng": 11.457939637615752,
				"lat": 43.547638979122922
			},
			{
				"lng": 11.457936213059162,
				"lat": 43.547639048438299
			},
			{
				"lng": 11.457932451753894,
				"lat": 43.547639109494092
			},
			{
				"lng": 11.457928339293288,
				"lat": 43.547639142306735
			},
			{
				"lng": 11.457923861270585,
				"lat": 43.547639126892449
			},
			{
				"lng": 11.457919003279152,
				"lat": 43.54763904326758
			},
			{
				"lng": 11.457913750912263,
				"lat": 43.547638871448484
			},
			{
				"lng": 11.457908111791435,
				"lat": 43.547638596986054
			},
			{
				"lng": 11.457902181650905,
				"lat": 43.547638227570118
			},
			{
				"lng": 11.457896078252958,
				"lat": 43.54763777642529
			},
			{
				"lng": 11.457889919360012,
				"lat": 43.547637256775836
			},
			{
				"lng": 11.457883822734434,
				"lat": 43.547636681846519
			},
			{
				"lng": 11.45787790613854,
				"lat": 43.547636064861827
			},
			{
				"lng": 11.457872287334634,
				"lat": 43.547635419046379
			},
			{
				"lng": 11.457867084085111,
				"lat": 43.547634757624827
			},
			{
				"lng": 11.457862383525397,
				"lat": 43.547634091116151
			},
			{
				"lng": 11.45785815028368,
				"lat": 43.547633419217135
			},
			{
				"lng": 11.457854318361253,
				"lat": 43.547632738919098
			},
			{
				"lng": 11.457850821759477,
				"lat": 43.547632047213185
			},
			{
				"lng": 11.457847594479635,
				"lat": 43.54763134109055
			},
			{
				"lng": 11.457844570523058,
				"lat": 43.547630617542353
			},
			{
				"lng": 11.457841683891086,
				"lat": 43.547629873559806
			},
			{
				"lng": 11.457838868585043,
				"lat": 43.547629106133989
			},
			{
				"lng": 11.457836060773472,
				"lat": 43.547628315143776
			},
			{
				"lng": 11.457833205293538,
				"lat": 43.547627512018401
			},
			{
				"lng": 11.45783024914965,
				"lat": 43.547626711074706
			},
			{
				"lng": 11.457827139346163,
				"lat": 43.547625926629628
			},
			{
				"lng": 11.457823822887482,
				"lat": 43.547625173000107
			},
			{
				"lng": 11.45782024677797,
				"lat": 43.547624464502867
			},
			{
				"lng": 11.457816358022022,
				"lat": 43.547623815454905
			},
			{
				"lng": 11.457812103623988,
				"lat": 43.547623240173053
			},
			{
				"lng": 11.457807448348923,
				"lat": 43.547622749148466
			},
			{
				"lng": 11.457802428004797,
				"lat": 43.54762233756982
			},
			{
				"lng": 11.457797096160158,
				"lat": 43.54762199679994
			},
			{
				"lng": 11.457791506383636,
				"lat": 43.547621718201832
			},
			{
				"lng": 11.457785712243833,
				"lat": 43.547621493138408
			},
			{
				"lng": 11.45777976730939,
				"lat": 43.54762131297268
			},
			{
				"lng": 11.457773725148906,
				"lat": 43.547621169067519
			},
			{
				"lng": 11.457767639330967,
				"lat": 43.547621052786013
			},
			{
				"lng": 11.457761558979975,
				"lat": 43.547620955434823
			},
			{
				"lng": 11.457755515443294,
				"lat": 43.547620868095194
			},
			{
				"lng": 11.45774953562403,
				"lat": 43.547620781792233
			},
			{
				"lng": 11.457743646425351,
				"lat": 43.547620687551053
			},
			{
				"lng": 11.457737874750404,
				"lat": 43.547620576396625
			},
			{
				"lng": 11.457732247502268,
				"lat": 43.547620439354034
			},
			{
				"lng": 11.457726791584129,
				"lat": 43.547620267448309
			},
			{
				"lng": 11.457721533899088,
				"lat": 43.547620051704584
			},
			{
				"lng": 11.457716478707329,
				"lat": 43.547619783137527
			},
			{
				"lng": 11.457711539696861,
				"lat": 43.547619452720966
			},
			{
				"lng": 11.457706607912753,
				"lat": 43.547619051418259
			},
			{
				"lng": 11.457701574400046,
				"lat": 43.54761857019281
			},
			{
				"lng": 11.457696330203794,
				"lat": 43.547618000007951
			},
			{
				"lng": 11.457690766369089,
				"lat": 43.547617331827077
			},
			{
				"lng": 11.457684773940946,
				"lat": 43.547616556613534
			},
			{
				"lng": 11.457678243964486,
				"lat": 43.54761566533049
			},
			{
				"lng": 11.45767110946335,
				"lat": 43.547614654974886
			},
			{
				"lng": 11.457663471375238,
				"lat": 43.547613546677781
			},
			{
				"lng": 11.457655472616421,
				"lat": 43.547612367603797
			},
			{
				"lng": 11.457647256103142,
				"lat": 43.547611144917781
			},
			{
				"lng": 11.457638964751617,
				"lat": 43.54760990578437
			},
			{
				"lng": 11.45763074147802,
				"lat": 43.547608677368366
			},
			{
				"lng": 11.457622729198521,
				"lat": 43.547607486834664
			},
			{
				"lng": 11.457615070829229,
				"lat": 43.547606361348109
			},
			{
				"lng": 11.457607871872751,
				"lat": 43.547605323861973
			},
			{
				"lng": 11.457601088177542,
				"lat": 43.547604380482738
			},
			{
				"lng": 11.457594638178456,
				"lat": 43.547603533105523
			},
			{
				"lng": 11.45758844031038,
				"lat": 43.547602783625202
			},
			{
				"lng": 11.45758241300828,
				"lat": 43.54760213393655
			},
			{
				"lng": 11.457576474707038,
				"lat": 43.54760158593453
			},
			{
				"lng": 11.457570543841575,
				"lat": 43.547601141513965
			},
			{
				"lng": 11.457564538846801,
				"lat": 43.547600802569725
			},
			{
				"lng": 11.457558392714015,
				"lat": 43.547600564503576
			},
			{
				"lng": 11.457552096660024,
				"lat": 43.547600396745217
			},
			{
				"lng": 11.457545656458045,
				"lat": 43.547600262231398
			},
			{
				"lng": 11.457539077881222,
				"lat": 43.547600123898825
			},
			{
				"lng": 11.457532366702823,
				"lat": 43.547599944684137
			},
			{
				"lng": 11.457525528696046,
				"lat": 43.547599687524077
			},
			{
				"lng": 11.457518569634173,
				"lat": 43.547599315355377
			},
			{
				"lng": 11.457511495290502,
				"lat": 43.547598791114581
			},
			{
				"lng": 11.45750433034193,
				"lat": 43.547598091096582
			},
			{
				"lng": 11.457497175080073,
				"lat": 43.547597245027838
			},
			{
				"lng": 11.457490148700074,
				"lat": 43.547596295992953
			},
			{
				"lng": 11.457483370397181,
				"lat": 43.547595287076504
			},
			{
				"lng": 11.457476959366483,
				"lat": 43.547594261363173
			},
			{
				"lng": 11.457471034803106,
				"lat": 43.547593261937678
			},
			{
				"lng": 11.457465715902186,
				"lat": 43.54759233188453
			},
			{
				"lng": 11.457461121858763,
				"lat": 43.547591514288641
			},
			{
				"lng": 11.457457318370157,
				"lat": 43.547590844153156
			},
			{
				"lng": 11.457454157142568,
				"lat": 43.547590324156019
			},
			{
				"lng": 11.457451436384554,
				"lat": 43.547589948893624
			},
			{
				"lng": 11.45744895430453,
				"lat": 43.547589712962349
			},
			{
				"lng": 11.45744650911108,
				"lat": 43.547589610958553
			},
			{
				"lng": 11.457443899012699,
				"lat": 43.547589637478616
			},
			{
				"lng": 11.457440922217829,
				"lat": 43.547589787118923
			},
			{
				"lng": 11.45743737693503,
				"lat": 43.547590054475677
			},
			{
				"lng": 11.457433119090135,
				"lat": 43.547590431282941
			},
			{
				"lng": 11.457428235478575,
				"lat": 43.547590897825316
			},
			{
				"lng": 11.457422870613001,
				"lat": 43.547591431525241
			},
			{
				"lng": 11.45741716900624,
				"lat": 43.547592009805136
			},
			{
				"lng": 11.45741127517099,
				"lat": 43.547592610087413
			},
			{
				"lng": 11.457405333620075,
				"lat": 43.547593209794513
			},
			{
				"lng": 11.457399488866299,
				"lat": 43.547593786348941
			},
			{
				"lng": 11.457393885422395,
				"lat": 43.547594317173179
			},
			{
				"lng": 11.457388630339501,
				"lat": 43.547594785013892
			},
			{
				"lng": 11.457383680821636,
				"lat": 43.547595193914269
			},
			{
				"lng": 11.457378956611045,
				"lat": 43.547595553241401
			},
			{
				"lng": 11.457374377449936,
				"lat": 43.547595872362585
			},
			{
				"lng": 11.457369863080665,
				"lat": 43.547596160645035
			},
			{
				"lng": 11.457365333245347,
				"lat": 43.547596427455822
			},
			{
				"lng": 11.457360707686314,
				"lat": 43.547596682162222
			},
			{
				"lng": 11.457355906145764,
				"lat": 43.547596934131342
			},
			{
				"lng": 11.457350848456061,
				"lat": 43.547597195973118
			},
			{
				"lng": 11.45734545481036,
				"lat": 43.547597493268761
			},
			{
				"lng": 11.457339645491851,
				"lat": 43.547597854842053
			},
			{
				"lng": 11.457333340783787,
				"lat": 43.54759830951707
			},
			{
				"lng": 11.457326460969371,
				"lat": 43.547598886117662
			},
			{
				"lng": 11.457318926331807,
				"lat": 43.547599613467689
			},
			{
				"lng": 11.457310657154201,
				"lat": 43.547600520390965
			},
			{
				"lng": 11.457301573719723,
				"lat": 43.54760163571126
			},
			{
				"lng": 11.457291645592498,
				"lat": 43.547602974535792
			},
			{
				"lng": 11.457281039460943,
				"lat": 43.547604497105269
			},
			{
				"lng": 11.457269971294521,
				"lat": 43.547606149943846
			},
			{
				"lng": 11.457258657062823,
				"lat": 43.547607879575729
			},
			{
				"lng": 11.457247312735381,
				"lat": 43.547609632525251
			},
			{
				"lng": 11.457236154281986,
				"lat": 43.547611355316945
			},
			{
				"lng": 11.457225397672385,
				"lat": 43.547612994475138
			},
			{
				"lng": 11.457215258876314,
				"lat": 43.547614496524496
			},
			{
				"lng": 11.457205903650664,
				"lat": 43.547615820473389
			},
			{
				"lng": 11.457197296900125,
				"lat": 43.547616975265683
			},
			{
				"lng": 11.4571893533163,
				"lat": 43.547617982328831
			},
			{
				"lng": 11.457181987590857,
				"lat": 43.547618863090406
			},
			{
				"lng": 11.4571751144153,
				"lat": 43.54761963897792
			},
			{
				"lng": 11.457168648481227,
				"lat": 43.547620331418706
			},
			{
				"lng": 11.457162504480182,
				"lat": 43.547620961840366
			},
			{
				"lng": 11.45715659710368,
				"lat": 43.547621551670105
			},
			{
				"lng": 11.457150834965709,
				"lat": 43.547622118738261
			},
			{
				"lng": 11.457145102369983,
				"lat": 43.547622666486191
			},
			{
				"lng": 11.457139277542666,
				"lat": 43.547623194757961
			},
			{
				"lng": 11.457133238709973,
				"lat": 43.547623703397626
			},
			{
				"lng": 11.457126864098079,
				"lat": 43.547624192249401
			},
			{
				"lng": 11.45712003193313,
				"lat": 43.547624661157172
			},
			{
				"lng": 11.457112620441361,
				"lat": 43.547625109965125
			},
			{
				"lng": 11.457104507848864,
				"lat": 43.547625538517117
			},
			{
				"lng": 11.457095627381856,
				"lat": 43.547625946618041
			},
			{
				"lng": 11.457086132266523,
				"lat": 43.547626333916867
			},
			{
				"lng": 11.457076230729045,
				"lat": 43.547626700023443
			},
			{
				"lng": 11.457066130995681,
				"lat": 43.547627044547774
			},
			{
				"lng": 11.457056041292706,
				"lat": 43.547627367099849
			},
			{
				"lng": 11.457046169846308,
				"lat": 43.547627667289831
			},
			{
				"lng": 11.457036724882744,
				"lat": 43.547627944727921
			},
			{
				"lng": 11.457027914628284,
				"lat": 43.547628199024402
			},
			{
				"lng": 11.457019889965098,
				"lat": 43.547628431590816
			},
			{
				"lng": 11.457012572398817,
				"lat": 43.547628651044775
			},
			{
				"lng": 11.457005826090992,
				"lat": 43.547628867805059
			},
			{
				"lng": 11.456999515203137,
				"lat": 43.547629092290293
			},
			{
				"lng": 11.456993503896785,
				"lat": 43.54762933491925
			},
			{
				"lng": 11.456987656333473,
				"lat": 43.547629606110604
			},
			{
				"lng": 11.456981836674693,
				"lat": 43.547629916282965
			},
			{
				"lng": 11.456975909081912,
				"lat": 43.547630275854999
			},
			{
				"lng": 11.456969775168545,
				"lat": 43.547630692631742
			},
			{
				"lng": 11.456963486355539,
				"lat": 43.547631163964148
			},
			{
				"lng": 11.45695713151567,
				"lat": 43.547631684589746
			},
			{
				"lng": 11.456950799521817,
				"lat": 43.547632249245922
			},
			{
				"lng": 11.456944579246858,
				"lat": 43.547632852670162
			},
			{
				"lng": 11.456938559563573,
				"lat": 43.547633489600052
			},
			{
				"lng": 11.456932829344845,
				"lat": 43.547634154773107
			},
			{
				"lng": 11.456927477463534,
				"lat": 43.547634842926854
			},
			{
				"lng": 11.456922563726106,
				"lat": 43.547635552496672
			},
			{
				"lng": 11.456918031673252,
				"lat": 43.547636296709541
			},
			{
				"lng": 11.456913795779162,
				"lat": 43.547637092490099
			},
			{
				"lng": 11.456909770518161,
				"lat": 43.547637956763118
			},
			{
				"lng": 11.456905870364457,
				"lat": 43.547638906453344
			},
			{
				"lng": 11.456902009792287,
				"lat": 43.547639958485334
			},
			{
				"lng": 11.456898103275819,
				"lat": 43.547641129783877
			},
			{
				"lng": 11.456894065289339,
				"lat": 43.547642437273552
			},
			{
				"lng": 11.456889832465398,
				"lat": 43.547643889961897
			},
			{
				"lng": 11.4568854300704,
				"lat": 43.547645465187557
			},
			{
				"lng": 11.45688090552907,
				"lat": 43.547647132372063
			},
			{
				"lng": 11.456876306266164,
				"lat": 43.547648860936938
			},
			{
				"lng": 11.456871679706586,
				"lat": 43.547650620303671
			},
			{
				"lng": 11.456867073275022,
				"lat": 43.547652379893819
			},
			{
				"lng": 11.456862534396393,
				"lat": 43.54765410912897
			},
			{
				"lng": 11.456858110495517,
				"lat": 43.547655777430521
			},
			{
				"lng": 11.456853835993366,
				"lat": 43.547657359575915
			},
			{
				"lng": 11.45684969329513,
				"lat": 43.547658851765476
			},
			{
				"lng": 11.456845651802217,
				"lat": 43.547660255555193
			},
			{
				"lng": 11.456841680916003,
				"lat": 43.547661572501177
			},
			{
				"lng": 11.456837750037785,
				"lat": 43.547662804159501
			},
			{
				"lng": 11.456833828568872,
				"lat": 43.547663952086211
			},
			{
				"lng": 11.45682988591067,
				"lat": 43.547665017837375
			},
			{
				"lng": 11.45682589146446,
				"lat": 43.547666002969081
			},
			{
				"lng": 11.456821825708573,
				"lat": 43.547666909473222
			},
			{
				"lng": 11.456817713429126,
				"lat": 43.547667741085867
			},
			{
				"lng": 11.456813590489261,
				"lat": 43.547668501978762
			},
			{
				"lng": 11.456809492752111,
				"lat": 43.547669196323866
			},
			{
				"lng": 11.456805456080749,
				"lat": 43.547669828293024
			},
			{
				"lng": 11.456801516338347,
				"lat": 43.547670402058174
			},
			{
				"lng": 11.456797709387981,
				"lat": 43.547670921791237
			},
			{
				"lng": 11.4567940710928,
				"lat": 43.547671391663968
			},
			{
				"lng": 11.456790618133029,
				"lat": 43.547671821305499
			},
			{
				"lng": 11.456787290457566,
				"lat": 43.547672242173263
			},
			{
				"lng": 11.456784008832328,
				"lat": 43.547672691181695
			},
			{
				"lng": 11.456780694023308,
				"lat": 43.547673205245296
			},
			{
				"lng": 11.45677726679639,
				"lat": 43.547673821278543
			},
			{
				"lng": 11.456773647917601,
				"lat": 43.547674576195917
			},
			{
				"lng": 11.456769758152785,
				"lat": 43.547675506911837
			},
			{
				"lng": 11.456765518267847,
				"lat": 43.547676650340826
			},
			{
				"lng": 11.456760881857964,
				"lat": 43.547678028913744
			},
			{
				"lng": 11.456755933835298,
				"lat": 43.547679607127158
			},
			{
				"lng": 11.45675079194147,
				"lat": 43.547681334994344
			},
			{
				"lng": 11.456745573917964,
				"lat": 43.547683162528301
			},
			{
				"lng": 11.456740397506371,
				"lat": 43.547685039742341
			},
			{
				"lng": 11.456735380448329,
				"lat": 43.547686916649475
			},
			{
				"lng": 11.456730640485441,
				"lat": 43.547688743263009
			},
			{
				"lng": 11.456726295359406,
				"lat": 43.547690469596176
			},
			{
				"lng": 11.456722429014224,
				"lat": 43.547692058832432
			},
			{
				"lng": 11.456718990203386,
				"lat": 43.547693526836539
			},
			{
				"lng": 11.456715893882576,
				"lat": 43.547694902643372
			},
			{
				"lng": 11.456713055007555,
				"lat": 43.547696215288028
			},
			{
				"lng": 11.45671038853407,
				"lat": 43.547697493805366
			},
			{
				"lng": 11.456707809417729,
				"lat": 43.547698767230266
			},
			{
				"lng": 11.456705232614318,
				"lat": 43.54770006459777
			},
			{
				"lng": 11.456702573079433,
				"lat": 43.547701414942708
			},
			{
				"lng": 11.456699761991938,
				"lat": 43.547702839246988
			},
			{
				"lng": 11.456696795423227,
				"lat": 43.547704326280225
			},
			{
				"lng": 11.456693685667863,
				"lat": 43.547705856759038
			},
			{
				"lng": 11.456690445020444,
				"lat": 43.547707411400062
			},
			{
				"lng": 11.456687085775487,
				"lat": 43.547708970919743
			},
			{
				"lng": 11.456683620227635,
				"lat": 43.547710516034819
			},
			{
				"lng": 11.456680060671433,
				"lat": 43.547712027461827
			},
			{
				"lng": 11.456676419401521,
				"lat": 43.547713485917356
			},
			{
				"lng": 11.456672711984776,
				"lat": 43.547714875112931
			},
			{
				"lng": 11.456668967077668,
				"lat": 43.547716190739699
			},
			{
				"lng": 11.456665216608947,
				"lat": 43.547717431483605
			},
			{
				"lng": 11.456661492507362,
				"lat": 43.547718596030819
			},
			{
				"lng": 11.45665782670166,
				"lat": 43.547719683067328
			},
			{
				"lng": 11.456654251120639,
				"lat": 43.547720691279174
			},
			{
				"lng": 11.45665079769306,
				"lat": 43.54772161935238
			},
			{
				"lng": 11.456647498347706,
				"lat": 43.547722465973187
			},
			{
				"lng": 11.456644368136615,
				"lat": 43.547723231595739
			},
			{
				"lng": 11.456641354604992,
				"lat": 43.547723923747689
			},
			{
				"lng": 11.456638388421268,
				"lat": 43.547724551724748
			},
			{
				"lng": 11.456635400253884,
				"lat": 43.547725124822755
			},
			{
				"lng": 11.456632320771273,
				"lat": 43.547725652337427
			},
			{
				"lng": 11.456629080641932,
				"lat": 43.547726143564631
			},
			{
				"lng": 11.456625610534241,
				"lat": 43.547726607800122
			},
			{
				"lng": 11.456621841116663,
				"lat": 43.547727054339553
			},
			{
				"lng": 11.456617731271844,
				"lat": 43.547727490668102
			},
			{
				"lng": 11.456613352739604,
				"lat": 43.547727917028105
			},
			{
				"lng": 11.456608805474039,
				"lat": 43.547728331851225
			},
			{
				"lng": 11.456604189429211,
				"lat": 43.547728733569187
			},
			{
				"lng": 11.456599604559189,
				"lat": 43.54772912061371
			},
			{
				"lng": 11.456595150818057,
				"lat": 43.547729491416582
			},
			{
				"lng": 11.456590928159898,
				"lat": 43.547729844409503
			},
			{
				"lng": 11.456587036538812,
				"lat": 43.547730178024224
			},
			{
				"lng": 11.45658354704819,
				"lat": 43.547730493243925
			},
			{
				"lng": 11.456580415338824,
				"lat": 43.547730801257686
			},
			{
				"lng": 11.456577568200814,
				"lat": 43.547731115805703
			},
			{
				"lng": 11.45657493242423,
				"lat": 43.547731450628497
			},
			{
				"lng": 11.456572434799194,
				"lat": 43.54773181946625
			},
			{
				"lng": 11.456570002115757,
				"lat": 43.547732236059339
			},
			{
				"lng": 11.456567561163981,
				"lat": 43.547732714148118
			},
			{
				"lng": 11.456565038733981,
				"lat": 43.547733267472928
			},
			{
				"lng": 11.45656237249494,
				"lat": 43.54773390449617
			},
			{
				"lng": 11.456559543632645,
				"lat": 43.547734612568881
			},
			{
				"lng": 11.456556544212058,
				"lat": 43.547735373764205
			},
			{
				"lng": 11.45655336629806,
				"lat": 43.54773617015524
			},
			{
				"lng": 11.456550001955655,
				"lat": 43.547736983815277
			},
			{
				"lng": 11.456546443249687,
				"lat": 43.547737796817337
			},
			{
				"lng": 11.456542682245159,
				"lat": 43.547738591234619
			},
			{
				"lng": 11.456538711006969,
				"lat": 43.547739349140258
			},
			{
				"lng": 11.456534531445193,
				"lat": 43.54774005595889
			},
			{
				"lng": 11.456530184850013,
				"lat": 43.547740710521708
			},
			{
				"lng": 11.456525722356746,
				"lat": 43.547741315011095
			},
			{
				"lng": 11.456521195100718,
				"lat": 43.547741871609858
			},
			{
				"lng": 11.456516654217211,
				"lat": 43.547742382500488
			},
			{
				"lng": 11.456512150841533,
				"lat": 43.547742849865607
			},
			{
				"lng": 11.456507736108996,
				"lat": 43.547743275887967
			},
			{
				"lng": 11.456503461154893,
				"lat": 43.547743662750072
			},
			{
				"lng": 11.456499413649169,
				"lat": 43.547744039296319
			},
			{
				"lng": 11.456495827399989,
				"lat": 43.54774454101743
			},
			{
				"lng": 11.456492972750238,
				"lat": 43.54774533006595
			},
			{
				"lng": 11.456491120042681,
				"lat": 43.547746568594413
			},
			{
				"lng": 11.45649053962015,
				"lat": 43.547748418755184
			},
			{
				"lng": 11.456491501825601,
				"lat": 43.547751042700853
			},
			{
				"lng": 11.456494277002152,
				"lat": 43.547754602583737
			},
			{
				"lng": 11.456499135493138,
				"lat": 43.547759260556141
			},
			{
				"lng": 11.456506341447012,
				"lat": 43.547765136392968
			},
			{
				"lng": 11.456516134231698,
				"lat": 43.547772180360106
			},
			{
				"lng": 11.456528747020242,
				"lat": 43.547780300346062
			},
			{
				"lng": 11.456544412986029,
				"lat": 43.547789404238841
			},
			{
				"lng": 11.456563365302733,
				"lat": 43.547799399926404
			},
			{
				"lng": 11.456585837144424,
				"lat": 43.547810195295916
			},
			{
				"lng": 11.456612061685364,
				"lat": 43.547821698234245
			},
			{
				"lng": 11.456642272100153,
				"lat": 43.547833816627723
			},
			{
				"lng": 11.456676525176629,
				"lat": 43.54784642045729
			},
			{
				"lng": 11.456714172154598,
				"lat": 43.547859228085422
			},
			{
				"lng": 11.456754387885629,
				"lat": 43.547871919970682
			},
			{
				"lng": 11.456796347219873,
				"lat": 43.547884176572651
			},
			{
				"lng": 11.456839225005758,
				"lat": 43.547895678351935
			},
			{
				"lng": 11.456882196090323,
				"lat": 43.547906105770579
			},
			{
				"lng": 11.456924435319012,
				"lat": 43.547915139291597
			},
			{
				"lng": 11.456965117536063,
				"lat": 43.547922459379549
			},
			{
				"lng": 11.457003603352513,
				"lat": 43.547927821083391
			},
			{
				"lng": 11.457039996450501,
				"lat": 43.54793127778612
			},
			{
				"lng": 11.457074586280672,
				"lat": 43.547932957453774
			},
			{
				"lng": 11.457107662294279,
				"lat": 43.547932988051905
			},
			{
				"lng": 11.457139513943176,
				"lat": 43.547931497545676
			},
			{
				"lng": 11.457170430679554,
				"lat": 43.547928613899806
			},
			{
				"lng": 11.457200701956065,
				"lat": 43.547924465078751
			},
			{
				"lng": 11.457230617225553,
				"lat": 43.547919179046545
			},
			{
				"lng": 11.457260462260212,
				"lat": 43.547912900424002
			},
			{
				"lng": 11.457290508109031,
				"lat": 43.547905840459556
			},
			{
				"lng": 11.457321022140496,
				"lat": 43.547898227058546
			},
			{
				"lng": 11.457352271723336,
				"lat": 43.547890288125743
			},
			{
				"lng": 11.457384524226535,
				"lat": 43.54788225156576
			},
			{
				"lng": 11.457418047019427,
				"lat": 43.547874345283006
			},
			{
				"lng": 11.457453107471721,
				"lat": 43.5478667971812
			},
			{
				"lng": 11.457489972953482,
				"lat": 43.547859835164111
			},
			{
				"lng": 11.457528927010161,
				"lat": 43.547853648659427
			},
			{
				"lng": 11.457570317887024,
				"lat": 43.547848273193885
			},
			{
				"lng": 11.457614510004305,
				"lat": 43.547843705818295
			},
			{
				"lng": 11.457661867782299,
				"lat": 43.547839943582709
			},
			{
				"lng": 11.45771275564133,
				"lat": 43.547836983536314
			},
			{
				"lng": 11.457767538001931,
				"lat": 43.547834822727395
			}
			],
			[{
				"lng": 11.459721414505839,
				"lat": 43.547559013881511
			},
			{
				"lng": 11.459703136872154,
				"lat": 43.54750595702248
			},
			{
				"lng": 11.45969109004414,
				"lat": 43.547466214826912
			},
			{
				"lng": 11.459642612148132,
				"lat": 43.547428291266222
			},
			{
				"lng": 11.459572322870692,
				"lat": 43.547413596588434
			},
			{
				"lng": 11.459488692270211,
				"lat": 43.547420569101746
			},
			{
				"lng": 11.459405176595736,
				"lat": 43.547442022377545
			},
			{
				"lng": 11.45937571332481,
				"lat": 43.547451967144227
			},
			{
				"lng": 11.459314446394083,
				"lat": 43.547472596701276
			},
			{
				"lng": 11.459285972490425,
				"lat": 43.547483554674585
			},
			{
				"lng": 11.459227522329659,
				"lat": 43.547515158461167
			},
			{
				"lng": 11.459197627355531,
				"lat": 43.547526146993114
			},
			{
				"lng": 11.459079504888459,
				"lat": 43.547547655055297
			},
			{
				"lng": 11.458994758522111,
				"lat": 43.547550513131441
			},
			{
				"lng": 11.458922327781107,
				"lat": 43.54755310615257
			},
			{
				"lng": 11.458852641019392,
				"lat": 43.54755322620499
			},
			{
				"lng": 11.458822621654246,
				"lat": 43.547553872103059
			},
			{
				"lng": 11.458818574370827,
				"lat": 43.547553441923355
			},
			{
				"lng": 11.458809988611351,
				"lat": 43.547552161081455
			},
			{
				"lng": 11.45880340635223,
				"lat": 43.54755060005435
			},
			{
				"lng": 11.458787855053378,
				"lat": 43.547547076749019
			},
			{
				"lng": 11.458758007250443,
				"lat": 43.54754028331751
			},
			{
				"lng": 11.458713085344366,
				"lat": 43.547530042505784
			},
			{
				"lng": 11.458702292729484,
				"lat": 43.547526955618949
			},
			{
				"lng": 11.458639587382743,
				"lat": 43.54750347618878
			},
			{
				"lng": 11.458630195129226,
				"lat": 43.547501307478434
			},
			{
				"lng": 11.458553696965573,
				"lat": 43.54749131488763
			},
			{
				"lng": 11.458540186636135,
				"lat": 43.547491346911755
			},
			{
				"lng": 11.458462968602564,
				"lat": 43.547501542911306
			},
			{
				"lng": 11.458419151856273,
				"lat": 43.54751119274264
			},
			{
				"lng": 11.458409888431815,
				"lat": 43.547516564626797
			},
			{
				"lng": 11.458383433600261,
				"lat": 43.547539289724583
			},
			{
				"lng": 11.458369710062529,
				"lat": 43.547551568149736
			},
			{
				"lng": 11.458351926541674,
				"lat": 43.547568934096923
			},
			{
				"lng": 11.458345405578266,
				"lat": 43.547580540318094
			},
			{
				"lng": 11.458339225639932,
				"lat": 43.547606363869818
			},
			{
				"lng": 11.458338625002282,
				"lat": 43.547614911590721
			},
			{
				"lng": 11.458338399536224,
				"lat": 43.54765017637289
			},
			{
				"lng": 11.458338270387403,
				"lat": 43.547664490028097
			},
			{
				"lng": 11.458335660980602,
				"lat": 43.547708168472305
			},
			{
				"lng": 11.458339579123759,
				"lat": 43.547722912323984
			},
			{
				"lng": 11.458359611588881,
				"lat": 43.547778345535612
			},
			{
				"lng": 11.458367549021872,
				"lat": 43.547792830503425
			},
			{
				"lng": 11.45840801854075,
				"lat": 43.547843685978627
			},
			{
				"lng": 11.458413125062915,
				"lat": 43.547849761700178
			},
			{
				"lng": 11.458464620148328,
				"lat": 43.547862792365216
			},
			{
				"lng": 11.458482300449697,
				"lat": 43.547866205255588
			},
			{
				"lng": 11.458577917947034,
				"lat": 43.547880010859849
			},
			{
				"lng": 11.458645392150176,
				"lat": 43.547889594107225
			},
			{
				"lng": 11.458782979534449,
				"lat": 43.5479037035172
			},
			{
				"lng": 11.458897583697913,
				"lat": 43.547906410290423
			},
			{
				"lng": 11.45906404054525,
				"lat": 43.547901794065083
			},
			{
				"lng": 11.459159604983997,
				"lat": 43.547896806522054
			},
			{
				"lng": 11.459194594308718,
				"lat": 43.547894501803896
			},
			{
				"lng": 11.459280996214671,
				"lat": 43.547879883378201
			},
			{
				"lng": 11.459350440855735,
				"lat": 43.547856319127682
			},
			{
				"lng": 11.459384564047415,
				"lat": 43.54784437746013
			},
			{
				"lng": 11.459453515322705,
				"lat": 43.547826168790571
			},
			{
				"lng": 11.459495663007278,
				"lat": 43.547813364710073
			},
			{
				"lng": 11.459604464797481,
				"lat": 43.547760848769322
			},
			{
				"lng": 11.459629872429494,
				"lat": 43.547744439265948
			},
			{
				"lng": 11.459662842020323,
				"lat": 43.547715797585425
			},
			{
				"lng": 11.45968869237714,
				"lat": 43.547686964286029
			},
			{
				"lng": 11.459712392802404,
				"lat": 43.547640245554973
			},
			{
				"lng": 11.459717185218009,
				"lat": 43.54758324373941
			},
			{
				"lng": 11.459721414505839,
				"lat": 43.547559013881511
			}
			],
			[{
				"lng": 11.457585835243457,
				"lat": 43.547929466174509
			},
			{
				"lng": 11.457589042820825,
				"lat": 43.547929336241594
			},
			{
				"lng": 11.457592275437504,
				"lat": 43.547929273663236
			},
			{
				"lng": 11.457595526253421,
				"lat": 43.547929265146998
			},
			{
				"lng": 11.457598788428445,
				"lat": 43.547929297400422
			},
			{
				"lng": 11.4576053194953,
				"lat": 43.547929431046668
			},
			{
				"lng": 11.457611813917156,
				"lat": 43.547929568262639
			},
			{
				"lng": 11.457615030285899,
				"lat": 43.547929604978194
			},
			{
				"lng": 11.457618216972977,
				"lat": 43.547929602708933
			},
			{
				"lng": 11.45762136713828,
				"lat": 43.547929548162422
			},
			{
				"lng": 11.457624473941676,
				"lat": 43.547929428046295
			},
			{
				"lng": 11.457627530543016,
				"lat": 43.547929229068096
			},
			{
				"lng": 11.457629037880386,
				"lat": 43.547929095851842
			},
			{
				"lng": 11.457630530102167,
				"lat": 43.547928937935389
			},
			{
				"lng": 11.457632006418363,
				"lat": 43.547928754107836
			},
			{
				"lng": 11.457633466298811,
				"lat": 43.547928544960399
			},
			{
				"lng": 11.457634909278333,
				"lat": 43.547928311534953
			},
			{
				"lng": 11.457636334891788,
				"lat": 43.547928054873388
			},
			{
				"lng": 11.457637742674011,
				"lat": 43.547927776017552
			},
			{
				"lng": 11.45763913215986,
				"lat": 43.547927476009299
			},
			{
				"lng": 11.45764185438169,
				"lat": 43.547926816703061
			},
			{
				"lng": 11.457644497835982,
				"lat": 43.547926085289511
			},
			{
				"lng": 11.457647058801472,
				"lat": 43.547925290103684
			},
			{
				"lng": 11.45764953355684,
				"lat": 43.547924439480362
			},
			{
				"lng": 11.457651918380828,
				"lat": 43.547923541754628
			},
			{
				"lng": 11.457654209552139,
				"lat": 43.547922605261242
			},
			{
				"lng": 11.457656403349427,
				"lat": 43.547921638335175
			},
			{
				"lng": 11.457658496051508,
				"lat": 43.54792064931128
			},
			{
				"lng": 11.45766048393704,
				"lat": 43.547919646524527
			},
			{
				"lng": 11.457662363284761,
				"lat": 43.547918638309852
			},
			{
				"lng": 11.457664130373402,
				"lat": 43.547917633002101
			},
			{
				"lng": 11.457665781481651,
				"lat": 43.547916638936243
			},
			{
				"lng": 11.457667312888283,
				"lat": 43.547915664447125
			},
			{
				"lng": 11.457668722410743,
				"lat": 43.547914715587829
			},
			{
				"lng": 11.45767001402154,
				"lat": 43.547913789283847
			},
			{
				"lng": 11.457671193231889,
				"lat": 43.547912880178721
			},
			{
				"lng": 11.457672265553109,
				"lat": 43.547911982916176
			},
			{
				"lng": 11.457673236496396,
				"lat": 43.547911092139692
			},
			{
				"lng": 11.457674111573024,
				"lat": 43.54791020249295
			},
			{
				"lng": 11.457674896294227,
				"lat": 43.547909308619595
			},
			{
				"lng": 11.457675596171248,
				"lat": 43.547908405163106
			},
			{
				"lng": 11.457676216715342,
				"lat": 43.547907486767187
			},
			{
				"lng": 11.457676763437766,
				"lat": 43.547906548075453
			},
			{
				"lng": 11.457677241849774,
				"lat": 43.547905583731435
			},
			{
				"lng": 11.4576776574626,
				"lat": 43.547904588378799
			},
			{
				"lng": 11.457678015787451,
				"lat": 43.547903556661176
			},
			{
				"lng": 11.457678322335614,
				"lat": 43.547902483222039
			},
			{
				"lng": 11.457678582618355,
				"lat": 43.547901362705133
			},
			{
				"lng": 11.457678802146884,
				"lat": 43.547900189754003
			},
			{
				"lng": 11.457678985681737,
				"lat": 43.547898960955827
			},
			{
				"lng": 11.457679134980712,
				"lat": 43.547897680671852
			},
			{
				"lng": 11.457679251050873,
				"lat": 43.547896355206987
			},
			{
				"lng": 11.45767933489933,
				"lat": 43.547894990866027
			},
			{
				"lng": 11.457679387533151,
				"lat": 43.547893593953809
			},
			{
				"lng": 11.457679409959388,
				"lat": 43.547892170775206
			},
			{
				"lng": 11.457679403185114,
				"lat": 43.547890727635071
			},
			{
				"lng": 11.457679368217441,
				"lat": 43.547889270838283
			},
			{
				"lng": 11.45767921773019,
				"lat": 43.547886341493935
			},
			{
				"lng": 11.457678966554226,
				"lat": 43.547883433180921
			},
			{
				"lng": 11.457678805725667,
				"lat": 43.547882002673276
			},
			{
				"lng": 11.457678622746192,
				"lat": 43.547880596338075
			},
			{
				"lng": 11.45767841862283,
				"lat": 43.547879220480041
			},
			{
				"lng": 11.45767819436267,
				"lat": 43.547877881404062
			},
			{
				"lng": 11.457677948771234,
				"lat": 43.547876583921052
			},
			{
				"lng": 11.457677671847565,
				"lat": 43.547875326866347
			},
			{
				"lng": 11.457677351389268,
				"lat": 43.547874107581301
			},
			{
				"lng": 11.457676975193802,
				"lat": 43.547872923407262
			},
			{
				"lng": 11.457676531058752,
				"lat": 43.54787177168555
			},
			{
				"lng": 11.457676006781563,
				"lat": 43.54787064975762
			},
			{
				"lng": 11.457675390159826,
				"lat": 43.547869554964798
			},
			{
				"lng": 11.45767466899103,
				"lat": 43.547868484648355
			},
			{
				"lng": 11.457673831072755,
				"lat": 43.547867436149801
			},
			{
				"lng": 11.457673364519279,
				"lat": 43.547866919251376
			},
			{
				"lng": 11.457672864202499,
				"lat": 43.547866406810421
			},
			{
				"lng": 11.457672328597088,
				"lat": 43.547865898494614
			},
			{
				"lng": 11.457671756177769,
				"lat": 43.547865393971598
			},
			{
				"lng": 11.45767114541921,
				"lat": 43.547864892909089
			},
			{
				"lng": 11.457670494796094,
				"lat": 43.547864394974674
			},
			{
				"lng": 11.457669802783158,
				"lat": 43.547863899836173
			},
			{
				"lng": 11.457669067855051,
				"lat": 43.547863407161046
			},
			{
				"lng": 11.457668288486486,
				"lat": 43.547862916617063
			},
			{
				"lng": 11.457667463152116,
				"lat": 43.547862427871983
			},
			{
				"lng": 11.457666590326715,
				"lat": 43.5478619405934
			},
			{
				"lng": 11.457665668484905,
				"lat": 43.547861454448963
			},
			{
				"lng": 11.457664696101354,
				"lat": 43.547860969106388
			},
			{
				"lng": 11.45766367165082,
				"lat": 43.547860484233304
			},
			{
				"lng": 11.45766259388545,
				"lat": 43.547859999741334
			},
			{
				"lng": 11.45766146266711,
				"lat": 43.547859516518074
			},
			{
				"lng": 11.457660278135238,
				"lat": 43.54785903569497
			},
			{
				"lng": 11.457659040429192,
				"lat": 43.547858558403654
			},
			{
				"lng": 11.45765774968838,
				"lat": 43.547858085775559
			},
			{
				"lng": 11.457656406052177,
				"lat": 43.547857618942182
			},
			{
				"lng": 11.457655009659931,
				"lat": 43.547857159035075
			},
			{
				"lng": 11.457653560651059,
				"lat": 43.547856707185801
			},
			{
				"lng": 11.457652059164966,
				"lat": 43.547856264525741
			},
			{
				"lng": 11.457650505340991,
				"lat": 43.547855832186549
			},
			{
				"lng": 11.45764889931856,
				"lat": 43.547855411299686
			},
			{
				"lng": 11.457647241236987,
				"lat": 43.547855002996648
			},
			{
				"lng": 11.457645531235745,
				"lat": 43.547854608408947
			},
			{
				"lng": 11.457643769454142,
				"lat": 43.547854228668101
			},
			{
				"lng": 11.457641956031617,
				"lat": 43.547853864905683
			},
			{
				"lng": 11.457640091107491,
				"lat": 43.547853518253106
			},
			{
				"lng": 11.457638174821177,
				"lat": 43.547853189841938
			},
			{
				"lng": 11.457636207312081,
				"lat": 43.547852880803767
			},
			{
				"lng": 11.457634188719556,
				"lat": 43.547852592270026
			},
			{
				"lng": 11.45763211918297,
				"lat": 43.547852325372219
			},
			{
				"lng": 11.45762999884175,
				"lat": 43.547852081241871
			},
			{
				"lng": 11.457627827835227,
				"lat": 43.547851861010493
			},
			{
				"lng": 11.457625606302807,
				"lat": 43.547851665809667
			},
			{
				"lng": 11.457623334383847,
				"lat": 43.547851496770818
			},
			{
				"lng": 11.457621012217768,
				"lat": 43.547851355025493
			},
			{
				"lng": 11.457618639943917,
				"lat": 43.547851241705203
			},
			{
				"lng": 11.457616217701704,
				"lat": 43.547851157941516
			},
			{
				"lng": 11.457613745630441,
				"lat": 43.547851104865849
			},
			{
				"lng": 11.457611223869604,
				"lat": 43.547851083609764
			},
			{
				"lng": 11.45760865255847,
				"lat": 43.547851095304758
			},
			{
				"lng": 11.457606031836487,
				"lat": 43.547851141082397
			},
			{
				"lng": 11.457603361843004,
				"lat": 43.547851222074172
			},
			{
				"lng": 11.457600642969625,
				"lat": 43.547851338981786
			},
			{
				"lng": 11.457597876616823,
				"lat": 43.547851490788204
			},
			{
				"lng": 11.457595064437378,
				"lat": 43.547851676046385
			},
			{
				"lng": 11.457592208083939,
				"lat": 43.547851893309407
			},
			{
				"lng": 11.457589309209252,
				"lat": 43.547852141130456
			},
			{
				"lng": 11.45758636946603,
				"lat": 43.547852418062462
			},
			{
				"lng": 11.457583390507033,
				"lat": 43.547852722658696
			},
			{
				"lng": 11.457580373984925,
				"lat": 43.547853053472103
			},
			{
				"lng": 11.45757732155244,
				"lat": 43.547853409055747
			},
			{
				"lng": 11.457574234862308,
				"lat": 43.547853787962801
			},
			{
				"lng": 11.457571115567218,
				"lat": 43.547854188746321
			},
			{
				"lng": 11.457567965319955,
				"lat": 43.547854609959373
			},
			{
				"lng": 11.457564785773169,
				"lat": 43.547855050155043
			},
			{
				"lng": 11.457561578579616,
				"lat": 43.54785550788641
			},
			{
				"lng": 11.457555087863058,
				"lat": 43.54785647016859
			},
			{
				"lng": 11.457548506392047,
				"lat": 43.54785748523053
			},
			{
				"lng": 11.457541847388384,
				"lat": 43.547858541496971
			},
			{
				"lng": 11.457535124073797,
				"lat": 43.547859627392505
			},
			{
				"lng": 11.457528349670147,
				"lat": 43.547860731341927
			},
			{
				"lng": 11.457514700482619,
				"lat": 43.547862947100818
			},
			{
				"lng": 11.457507852142413,
				"lat": 43.547864035759652
			},
			{
				"lng": 11.457501005600268,
				"lat": 43.54786509617108
			},
			{
				"lng": 11.45749417488609,
				"lat": 43.547866119287171
			},
			{
				"lng": 11.457487377261749,
				"lat": 43.547867106170038
			},
			{
				"lng": 11.457480630797219,
				"lat": 43.54786806040903
			},
			{
				"lng": 11.457473953562465,
				"lat": 43.547868985593801
			},
			{
				"lng": 11.457467363627403,
				"lat": 43.547869885313808
			},
			{
				"lng": 11.457460879061994,
				"lat": 43.547870763158606
			},
			{
				"lng": 11.457457681939774,
				"lat": 43.547871194999516
			},
			{
				"lng": 11.457454517936178,
				"lat": 43.547871622717658
			},
			{
				"lng": 11.457451389310009,
				"lat": 43.547872046761817
			},
			{
				"lng": 11.457448298319926,
				"lat": 43.54787246758054
			},
			{
				"lng": 11.457445247224737,
				"lat": 43.547872885622674
			},
			{
				"lng": 11.45744223828317,
				"lat": 43.547873301336764
			},
			{
				"lng": 11.457439273753943,
				"lat": 43.547873715171619
			},
			{
				"lng": 11.457436355895849,
				"lat": 43.547874127575817
			},
			{
				"lng": 11.45743348696757,
				"lat": 43.547874538998165
			},
			{
				"lng": 11.457430669227881,
				"lat": 43.547874949887309
			},
			{
				"lng": 11.457427904935537,
				"lat": 43.547875360691904
			},
			{
				"lng": 11.457425196349272,
				"lat": 43.547875771860717
			},
			{
				"lng": 11.457422545727818,
				"lat": 43.547876183842426
			},
			{
				"lng": 11.457419955329902,
				"lat": 43.547876597085661
			},
			{
				"lng": 11.457417427414304,
				"lat": 43.547877012039095
			},
			{
				"lng": 11.457414964239769,
				"lat": 43.547877429151526
			},
			{
				"lng": 11.457412568064997,
				"lat": 43.547877848871622
			},
			{
				"lng": 11.457410241148782,
				"lat": 43.547878271648003
			},
			{
				"lng": 11.457407985749841,
				"lat": 43.547878697929406
			},
			{
				"lng": 11.457405804126886,
				"lat": 43.547879128164574
			},
			{
				"lng": 11.457403697858885,
				"lat": 43.547879562736199
			},
			{
				"lng": 11.457401665805316,
				"lat": 43.547880001763289
			},
			{
				"lng": 11.457399706145855,
				"lat": 43.547880445299
			},
			{
				"lng": 11.457397817060226,
				"lat": 43.547880893396389
			},
			{
				"lng": 11.457395996728074,
				"lat": 43.547881346108525
			},
			{
				"lng": 11.457394243329102,
				"lat": 43.547881803488501
			},
			{
				"lng": 11.457392555042968,
				"lat": 43.547882265589394
			},
			{
				"lng": 11.457390930049351,
				"lat": 43.547882732464359
			},
			{
				"lng": 11.457389366528,
				"lat": 43.547883204166332
			},
			{
				"lng": 11.457387862658505,
				"lat": 43.547883680748591
			},
			{
				"lng": 11.457386416620587,
				"lat": 43.547884162264019
			},
			{
				"lng": 11.45738502659394,
				"lat": 43.547884648765852
			},
			{
				"lng": 11.457383690758236,
				"lat": 43.547885140307137
			},
			{
				"lng": 11.457382407293183,
				"lat": 43.547885636940926
			},
			{
				"lng": 11.457381174378382,
				"lat": 43.54788613872028
			},
			{
				"lng": 11.457379990193584,
				"lat": 43.547886645698391
			},
			{
				"lng": 11.457378852918476,
				"lat": 43.547887157928209
			},
			{
				"lng": 11.457377760732671,
				"lat": 43.547887675462931
			},
			{
				"lng": 11.457376711815943,
				"lat": 43.547888198355587
			},
			{
				"lng": 11.457375704347859,
				"lat": 43.547888726659231
			},
			{
				"lng": 11.457374736508227,
				"lat": 43.547889260426999
			},
			{
				"lng": 11.457373806476634,
				"lat": 43.547889799711982
			},
			{
				"lng": 11.457372912432811,
				"lat": 43.547890344567236
			},
			{
				"lng": 11.457372052556423,
				"lat": 43.547890895045832
			},
			{
				"lng": 11.457370428024639,
				"lat": 43.547892013085416
			},
			{
				"lng": 11.45736891831875,
				"lat": 43.547893154255377
			},
			{
				"lng": 11.45736750887624,
				"lat": 43.547894318980397
			},
			{
				"lng": 11.457366185134514,
				"lat": 43.547895507685226
			},
			{
				"lng": 11.457364935327442,
				"lat": 43.547896720818478
			},
			{
				"lng": 11.45736375887472,
				"lat": 43.547897958924978
			},
			{
				"lng": 11.457362657992475,
				"lat": 43.547899222573704
			},
			{
				"lng": 11.457361634896779,
				"lat": 43.547900512333484
			},
			{
				"lng": 11.457360691803776,
				"lat": 43.547901828773313
			},
			{
				"lng": 11.457359830929535,
				"lat": 43.547903172462
			},
			{
				"lng": 11.45735905449026,
				"lat": 43.547904543968485
			},
			{
				"lng": 11.45735836470196,
				"lat": 43.547905943861657
			},
			{
				"lng": 11.45735776378082,
				"lat": 43.547907372710434
			},
			{
				"lng": 11.457357253942916,
				"lat": 43.547908831083618
			},
			{
				"lng": 11.457356837404355,
				"lat": 43.547910319550276
			},
			{
				"lng": 11.457356516381289,
				"lat": 43.547911838679148
			},
			{
				"lng": 11.457356293089829,
				"lat": 43.547913389039259
			},
			{
				"lng": 11.457356169746072,
				"lat": 43.547914971199418
			},
			{
				"lng": 11.457356148566141,
				"lat": 43.547916585728544
			},
			{
				"lng": 11.457356231766136,
				"lat": 43.547918233195553
			},
			{
				"lng": 11.457356421513317,
				"lat": 43.547919912527064
			},
			{
				"lng": 11.457356719779112,
				"lat": 43.547921616080572
			},
			{
				"lng": 11.457357128486167,
				"lat": 43.547923334571195
			},
			{
				"lng": 11.45735764955705,
				"lat": 43.547925058714249
			},
			{
				"lng": 11.457358284914354,
				"lat": 43.547926779224902
			},
			{
				"lng": 11.457359036480607,
				"lat": 43.547928486818364
			},
			{
				"lng": 11.457359906178491,
				"lat": 43.547930172209753
			},
			{
				"lng": 11.457360895930524,
				"lat": 43.547931826114436
			},
			{
				"lng": 11.457361436427695,
				"lat": 43.547932638357743
			},
			{
				"lng": 11.457362007659347,
				"lat": 43.547933439247529
			},
			{
				"lng": 11.457362609865838,
				"lat": 43.54793422762318
			},
			{
				"lng": 11.457363243287491,
				"lat": 43.547935002324174
			},
			{
				"lng": 11.457363908164623,
				"lat": 43.54793576218988
			},
			{
				"lng": 11.457364604737547,
				"lat": 43.547936506059656
			},
			{
				"lng": 11.457365333246619,
				"lat": 43.547937232772988
			},
			{
				"lng": 11.457366093932144,
				"lat": 43.547937941169209
			},
			{
				"lng": 11.457366887034421,
				"lat": 43.547938630087735
			},
			{
				"lng": 11.45736771279382,
				"lat": 43.547939298367922
			},
			{
				"lng": 11.4573685714506,
				"lat": 43.547939944849276
			},
			{
				"lng": 11.45736946324514,
				"lat": 43.547940568371097
			},
			{
				"lng": 11.457370388417749,
				"lat": 43.547941167772848
			},
			{
				"lng": 11.457371347208722,
				"lat": 43.547941741893851
			},
			{
				"lng": 11.457372339858406,
				"lat": 43.547942289573598
			},
			{
				"lng": 11.457373366607094,
				"lat": 43.54794280965146
			},
			{
				"lng": 11.457374427534202,
				"lat": 43.547943301316757
			},
			{
				"lng": 11.457375522075253,
				"lat": 43.547943765158209
			},
			{
				"lng": 11.457376649504793,
				"lat": 43.547944202114785
			},
			{
				"lng": 11.457377809097473,
				"lat": 43.547944613125011
			},
			{
				"lng": 11.457379000127885,
				"lat": 43.547944999127736
			},
			{
				"lng": 11.457380221870562,
				"lat": 43.547945361061736
			},
			{
				"lng": 11.457381473600105,
				"lat": 43.547945699865679
			},
			{
				"lng": 11.457382754591153,
				"lat": 43.547946016478349
			},
			{
				"lng": 11.457384064118282,
				"lat": 43.547946311838473
			},
			{
				"lng": 11.457385401456026,
				"lat": 43.547946586884834
			},
			{
				"lng": 11.457386765879068,
				"lat": 43.547946842556151
			},
			{
				"lng": 11.457388156661905,
				"lat": 43.547947079791186
			},
			{
				"lng": 11.457389573079153,
				"lat": 43.54794729952868
			},
			{
				"lng": 11.457391014405459,
				"lat": 43.547947502707423
			},
			{
				"lng": 11.457393968883439,
				"lat": 43.547947863143392
			},
			{
				"lng": 11.45739701429255,
				"lat": 43.547948168609075
			},
			{
				"lng": 11.45740014482954,
				"lat": 43.547948426614532
			},
			{
				"lng": 11.457403354691102,
				"lat": 43.547948644669638
			},
			{
				"lng": 11.457406638073998,
				"lat": 43.547948830284447
			},
			{
				"lng": 11.457409989174909,
				"lat": 43.547948990968848
			},
			{
				"lng": 11.457413402190557,
				"lat": 43.54794913423283
			},
			{
				"lng": 11.457416871317706,
				"lat": 43.547949267586432
			},
			{
				"lng": 11.457420390753091,
				"lat": 43.547949398539522
			},
			{
				"lng": 11.45742395370581,
				"lat": 43.547949533102198
			},
			{
				"lng": 11.457427549434422,
				"lat": 43.547949671284876
			},
			{
				"lng": 11.457434792303273,
				"lat": 43.547949952551946
			},
			{
				"lng": 11.457442025527433,
				"lat": 43.547950230424625
			},
			{
				"lng": 11.457445609200139,
				"lat": 43.547950364364205
			},
			{
				"lng": 11.457449155274606,
				"lat": 43.547950492986587
			},
			{
				"lng": 11.457452652021736,
				"lat": 43.547950614802261
			},
			{
				"lng": 11.457456087712536,
				"lat": 43.547950728321709
			},
			{
				"lng": 11.457459450617959,
				"lat": 43.547950832055442
			},
			{
				"lng": 11.457462729008993,
				"lat": 43.547950924513913
			},
			{
				"lng": 11.457465911156564,
				"lat": 43.547951004207555
			},
			{
				"lng": 11.457468985331667,
				"lat": 43.547951069646913
			},
			{
				"lng": 11.45747193980525,
				"lat": 43.54795111934245
			},
			{
				"lng": 11.457473368488657,
				"lat": 43.54795113782086
			},
			{
				"lng": 11.457474762848292,
				"lat": 43.547951151804675
			},
			{
				"lng": 11.457476121855052,
				"lat": 43.547951161147559
			},
			{
				"lng": 11.457477446227985,
				"lat": 43.547951165862052
			},
			{
				"lng": 11.457478737123187,
				"lat": 43.547951166000537
			},
			{
				"lng": 11.457479995696755,
				"lat": 43.547951161615252
			},
			{
				"lng": 11.457482420503077,
				"lat": 43.547951139482919
			},
			{
				"lng": 11.45748472989559,
				"lat": 43.547951099883591
			},
			{
				"lng": 11.45748693312291,
				"lat": 43.547951043236033
			},
			{
				"lng": 11.457489039433549,
				"lat": 43.547950969958727
			},
			{
				"lng": 11.457491058076226,
				"lat": 43.547950880470438
			},
			{
				"lng": 11.457492998299477,
				"lat": 43.547950775189733
			},
			{
				"lng": 11.45749486935185,
				"lat": 43.547950654535256
			},
			{
				"lng": 11.457496680481992,
				"lat": 43.547950518925582
			},
			{
				"lng": 11.457498440938489,
				"lat": 43.547950368779439
			},
			{
				"lng": 11.457500159969911,
				"lat": 43.547950204515423
			},
			{
				"lng": 11.457503510751962,
				"lat": 43.547949835308138
			},
			{
				"lng": 11.457506806816898,
				"lat": 43.547949414652869
			},
			{
				"lng": 11.457510114970722,
				"lat": 43.547948941681213
			},
			{
				"lng": 11.457513473288298,
				"lat": 43.547948398655933
			},
			{
				"lng": 11.457515180912299,
				"lat": 43.547948094012348
			},
			{
				"lng": 11.457516912661765,
				"lat": 43.547947763622346
			},
			{
				"lng": 11.457518672398249,
				"lat": 43.547947404741592
			},
			{
				"lng": 11.457520463983251,
				"lat": 43.547947014625791
			},
			{
				"lng": 11.457522291278309,
				"lat": 43.547946590530593
			},
			{
				"lng": 11.457524158144878,
				"lat": 43.547946129711654
			},
			{
				"lng": 11.457526068444537,
				"lat": 43.54794562942471
			},
			{
				"lng": 11.457528026038764,
				"lat": 43.547945086925381
			},
			{
				"lng": 11.457530034789087,
				"lat": 43.547944499469281
			},
			{
				"lng": 11.45753209855696,
				"lat": 43.54794386431216
			},
			{
				"lng": 11.457534221203964,
				"lat": 43.547943178709666
			},
			{
				"lng": 11.457536406591592,
				"lat": 43.547942439917442
			},
			{
				"lng": 11.457538657718532,
				"lat": 43.547941647348225
			},
			{
				"lng": 11.457540974132458,
				"lat": 43.547940809042885
			},
			{
				"lng": 11.45754335451814,
				"lat": 43.54793993519916
			},
			{
				"lng": 11.457545797560503,
				"lat": 43.547939036015002
			},
			{
				"lng": 11.457548301944266,
				"lat": 43.547938121688297
			},
			{
				"lng": 11.457550866354358,
				"lat": 43.547937202416875
			},
			{
				"lng": 11.457553489475554,
				"lat": 43.547936288398581
			},
			{
				"lng": 11.457556169992753,
				"lat": 43.547935389831288
			},
			{
				"lng": 11.457558906590743,
				"lat": 43.547934516912903
			},
			{
				"lng": 11.457561697954441,
				"lat": 43.547933679841293
			},
			{
				"lng": 11.457564542768623,
				"lat": 43.547932888814231
			},
			{
				"lng": 11.457567439718179,
				"lat": 43.547932154029738
			},
			{
				"lng": 11.457570387487969,
				"lat": 43.54793148568551
			},
			{
				"lng": 11.457573384762817,
				"lat": 43.547930893979469
			},
			{
				"lng": 11.457574901553663,
				"lat": 43.547930630052669
			},
			{
				"lng": 11.457576430227606,
				"lat": 43.547930389109546
			},
			{
				"lng": 11.457577970620239,
				"lat": 43.547930172424977
			},
			{
				"lng": 11.45757952256716,
				"lat": 43.547929981273555
			},
			{
				"lng": 11.457581085788895,
				"lat": 43.547929816440757
			},
			{
				"lng": 11.457582659545553,
				"lat": 43.547929676754386
			},
			{
				"lng": 11.457585835243457,
				"lat": 43.547929466174509
			}
			],
			[{
				"lng": 11.456786961330675,
				"lat": 43.548141023144098
			},
			{
				"lng": 11.456785669612431,
				"lat": 43.548141006704263
			},
			{
				"lng": 11.456784369543628,
				"lat": 43.548141044569618
			},
			{
				"lng": 11.456783057530915,
				"lat": 43.548141134709667
			},
			{
				"lng": 11.456781729980937,
				"lat": 43.548141275093897
			},
			{
				"lng": 11.45678038330027,
				"lat": 43.548141463691898
			},
			{
				"lng": 11.456779013895536,
				"lat": 43.548141698473195
			},
			{
				"lng": 11.456777618173399,
				"lat": 43.548141977407262
			},
			{
				"lng": 11.456776192540451,
				"lat": 43.548142298463688
			},
			{
				"lng": 11.456774733403282,
				"lat": 43.548142659611919
			},
			{
				"lng": 11.456773237168566,
				"lat": 43.548143058821523
			},
			{
				"lng": 11.456771700242886,
				"lat": 43.548143494062032
			},
			{
				"lng": 11.456770119703373,
				"lat": 43.548143963480108
			},
			{
				"lng": 11.456768499738375,
				"lat": 43.548144467101345
			},
			{
				"lng": 11.456766848819518,
				"lat": 43.548145006083153
			},
			{
				"lng": 11.456765175477143,
				"lat": 43.548145581598369
			},
			{
				"lng": 11.456763488241696,
				"lat": 43.548146194819864
			},
			{
				"lng": 11.456761795643581,
				"lat": 43.54814684692051
			},
			{
				"lng": 11.456760106213213,
				"lat": 43.548147539073241
			},
			{
				"lng": 11.456758428481017,
				"lat": 43.548148272450895
			},
			{
				"lng": 11.456756770977393,
				"lat": 43.548149048226378
			},
			{
				"lng": 11.456755142232772,
				"lat": 43.548149867572548
			},
			{
				"lng": 11.456753550777522,
				"lat": 43.548150731662325
			},
			{
				"lng": 11.456752005142127,
				"lat": 43.548151641668575
			},
			{
				"lng": 11.456750513856958,
				"lat": 43.54815259876419
			},
			{
				"lng": 11.456749085452435,
				"lat": 43.548153604122014
			},
			{
				"lng": 11.456747728458982,
				"lat": 43.548154658914996
			},
			{
				"lng": 11.456746451407023,
				"lat": 43.548155764315979
			},
			{
				"lng": 11.456745262826965,
				"lat": 43.548156921497942
			},
			{
				"lng": 11.456744171249261,
				"lat": 43.548158131633627
			},
			{
				"lng": 11.456743185204267,
				"lat": 43.548159395896008
			},
			{
				"lng": 11.456742313222481,
				"lat": 43.548160715457897
			},
			{
				"lng": 11.456741561755011,
				"lat": 43.548162090835035
			},
			{
				"lng": 11.456740928935828,
				"lat": 43.548163519913601
			},
			{
				"lng": 11.456740410819821,
				"lat": 43.548164999922655
			},
			{
				"lng": 11.456740003461681,
				"lat": 43.548166528091322
			},
			{
				"lng": 11.45673970291614,
				"lat": 43.548168101648514
			},
			{
				"lng": 11.45673950523803,
				"lat": 43.54816971782337
			},
			{
				"lng": 11.456739406482061,
				"lat": 43.548171373844838
			},
			{
				"lng": 11.456739402702983,
				"lat": 43.54817306694197
			},
			{
				"lng": 11.456739489955586,
				"lat": 43.548174794343844
			},
			{
				"lng": 11.456739664294606,
				"lat": 43.548176553279404
			},
			{
				"lng": 11.456739921774862,
				"lat": 43.548178340977756
			},
			{
				"lng": 11.456740258450994,
				"lat": 43.548180154667918
			},
			{
				"lng": 11.456740670377878,
				"lat": 43.548181991578922
			},
			{
				"lng": 11.456741153610217,
				"lat": 43.548183848939715
			},
			{
				"lng": 11.456741704202768,
				"lat": 43.548185723979437
			},
			{
				"lng": 11.456742318210303,
				"lat": 43.548187613927063
			},
			{
				"lng": 11.456742991687591,
				"lat": 43.548189516011632
			},
			{
				"lng": 11.456743720689332,
				"lat": 43.548191427462193
			},
			{
				"lng": 11.456744501270357,
				"lat": 43.548193345507727
			},
			{
				"lng": 11.456745329493256,
				"lat": 43.548195267392963
			},
			{
				"lng": 11.456747116356965,
				"lat": 43.548199118114773
			},
			{
				"lng": 11.45674906137844,
				"lat": 43.548202980670347
			},
			{
				"lng": 11.456751145965056,
				"lat": 43.548206858709349
			},
			{
				"lng": 11.456753351524183,
				"lat": 43.548210755881435
			},
			{
				"lng": 11.456755659463283,
				"lat": 43.548214675836256
			},
			{
				"lng": 11.456758051189766,
				"lat": 43.548218622223395
			},
			{
				"lng": 11.456760508110944,
				"lat": 43.548222598692597
			},
			{
				"lng": 11.456763011634299,
				"lat": 43.548226608893422
			},
			{
				"lng": 11.456765543167139,
				"lat": 43.548230656475553
			},
			{
				"lng": 11.456768084282816,
				"lat": 43.548234745093978
			},
			{
				"lng": 11.456770628626922,
				"lat": 43.548238878795736
			},
			{
				"lng": 11.456773189888686,
				"lat": 43.548243062278331
			},
			{
				"lng": 11.456775783647176,
				"lat": 43.548247300300787
			},
			{
				"lng": 11.456778425481453,
				"lat": 43.548251597622041
			},
			{
				"lng": 11.456781130970583,
				"lat": 43.54825595900104
			},
			{
				"lng": 11.456783915693554,
				"lat": 43.548260389196749
			},
			{
				"lng": 11.456786795229524,
				"lat": 43.548264892968099
			},
			{
				"lng": 11.456789785157504,
				"lat": 43.548269475074065
			},
			{
				"lng": 11.456792901056595,
				"lat": 43.548274140273577
			},
			{
				"lng": 11.456794511113781,
				"lat": 43.548276505520569
			},
			{
				"lng": 11.456796157853564,
				"lat": 43.548278892436251
			},
			{
				"lng": 11.456799552370073,
				"lat": 43.548283710748365
			},
			{
				"lng": 11.456803061411049,
				"lat": 43.548288547106715
			},
			{
				"lng": 11.456806660745455,
				"lat": 43.548293351995746
			},
			{
				"lng": 11.456810326142351,
				"lat": 43.548298075899993
			},
			{
				"lng": 11.456812176042016,
				"lat": 43.548300392009239
			},
			{
				"lng": 11.45681403337065,
				"lat": 43.548302669304
			},
			{
				"lng": 11.456815895099378,
				"lat": 43.548304901594769
			},
			{
				"lng": 11.456817758199319,
				"lat": 43.548307082692254
			},
			{
				"lng": 11.45681961964161,
				"lat": 43.548309206406898
			},
			{
				"lng": 11.456821476397341,
				"lat": 43.548311266549248
			},
			{
				"lng": 11.456823325437609,
				"lat": 43.54831325692998
			},
			{
				"lng": 11.456825163733519,
				"lat": 43.548315171359647
			},
			{
				"lng": 11.456826988256271,
				"lat": 43.548317003648656
			},
			{
				"lng": 11.456828795976856,
				"lat": 43.548318747607787
			},
			{
				"lng": 11.456830583875874,
				"lat": 43.54832039706541
			},
			{
				"lng": 11.456832350321584,
				"lat": 43.548321948491349
			},
			{
				"lng": 11.456834096524251,
				"lat": 43.548323403765075
			},
			{
				"lng": 11.456835824042274,
				"lat": 43.548324765428362
			},
			{
				"lng": 11.45683753443395,
				"lat": 43.548326036022836
			},
			{
				"lng": 11.456839229257588,
				"lat": 43.548327218090314
			},
			{
				"lng": 11.456840910071509,
				"lat": 43.54832831417248
			},
			{
				"lng": 11.456842578434021,
				"lat": 43.548329326811029
			},
			{
				"lng": 11.456844235903445,
				"lat": 43.548330258547757
			},
			{
				"lng": 11.456845884038092,
				"lat": 43.548331111924398
			},
			{
				"lng": 11.456847524396352,
				"lat": 43.54833188948264
			},
			{
				"lng": 11.456849158536475,
				"lat": 43.548332593764258
			},
			{
				"lng": 11.456850788016835,
				"lat": 43.548333227310934
			},
			{
				"lng": 11.456852414395691,
				"lat": 43.54833379266438
			},
			{
				"lng": 11.456854039231368,
				"lat": 43.548334292366434
			},
			{
				"lng": 11.456855664082248,
				"lat": 43.54833472895865
			},
			{
				"lng": 11.456857290506639,
				"lat": 43.548335104982947
			},
			{
				"lng": 11.456858920062814,
				"lat": 43.548335422980962
			},
			{
				"lng": 11.456860554309168,
				"lat": 43.548335685494372
			},
			{
				"lng": 11.456862194803977,
				"lat": 43.548335895064987
			},
			{
				"lng": 11.456863843009616,
				"lat": 43.54833605415493
			},
			{
				"lng": 11.456865498534158,
				"lat": 43.548336163688241
			},
			{
				"lng": 11.45686715930839,
				"lat": 43.548336223197758
			},
			{
				"lng": 11.456868823202802,
				"lat": 43.548336232166335
			},
			{
				"lng": 11.456870488087757,
				"lat": 43.548336190076576
			},
			{
				"lng": 11.456872151833684,
				"lat": 43.548336096411255
			},
			{
				"lng": 11.456873812311001,
				"lat": 43.548335950653147
			},
			{
				"lng": 11.456875467390113,
				"lat": 43.548335752285013
			},
			{
				"lng": 11.45687711494141,
				"lat": 43.548335500789584
			},
			{
				"lng": 11.456878752835353,
				"lat": 43.548335195649585
			},
			{
				"lng": 11.456880378942335,
				"lat": 43.548334836347777
			},
			{
				"lng": 11.456881991132738,
				"lat": 43.548334422366857
			},
			{
				"lng": 11.456883587277011,
				"lat": 43.548333953189591
			},
			{
				"lng": 11.456885165245586,
				"lat": 43.548333428298783
			},
			{
				"lng": 11.456886722908852,
				"lat": 43.548332847177093
			},
			{
				"lng": 11.456888258137166,
				"lat": 43.548332209307326
			},
			{
				"lng": 11.456889768801043,
				"lat": 43.54833151417224
			},
			{
				"lng": 11.456891252770809,
				"lat": 43.548330761254441
			},
			{
				"lng": 11.45689270791696,
				"lat": 43.548329950036873
			},
			{
				"lng": 11.45689413210985,
				"lat": 43.548329080002119
			},
			{
				"lng": 11.456895523246592,
				"lat": 43.548328150819508
			},
			{
				"lng": 11.456896879394709,
				"lat": 43.548327163348951
			},
			{
				"lng": 11.456898198688732,
				"lat": 43.548326118918816
			},
			{
				"lng": 11.456899479263361,
				"lat": 43.548325018858691
			},
			{
				"lng": 11.45690071925328,
				"lat": 43.548323864497902
			},
			{
				"lng": 11.456901916793212,
				"lat": 43.548322657165919
			},
			{
				"lng": 11.456903070017837,
				"lat": 43.548321398192286
			},
			{
				"lng": 11.45690417706183,
				"lat": 43.548320088906443
			},
			{
				"lng": 11.456905236059892,
				"lat": 43.548318730637867
			},
			{
				"lng": 11.456906245146795,
				"lat": 43.54831732471601
			},
			{
				"lng": 11.456907202457181,
				"lat": 43.548315872470283
			},
			{
				"lng": 11.456908106125754,
				"lat": 43.548314375230305
			},
			{
				"lng": 11.456908954287218,
				"lat": 43.548312834325372
			},
			{
				"lng": 11.456909745076274,
				"lat": 43.548311251085053
			},
			{
				"lng": 11.45691047662763,
				"lat": 43.548309626838808
			},
			{
				"lng": 11.456911147075974,
				"lat": 43.54830796291607
			},
			{
				"lng": 11.456911754556016,
				"lat": 43.548306260646378
			},
			{
				"lng": 11.456912297202482,
				"lat": 43.54830452135915
			},
			{
				"lng": 11.45691277315002,
				"lat": 43.548302746383811
			},
			{
				"lng": 11.456913180535182,
				"lat": 43.548300937048801
			},
			{
				"lng": 11.456913518244676,
				"lat": 43.548299094227161
			},
			{
				"lng": 11.456913787072654,
				"lat": 43.548297217634293
			},
			{
				"lng": 11.45691398811209,
				"lat": 43.548295306804441
			},
			{
				"lng": 11.456914122455842,
				"lat": 43.548293361271583
			},
			{
				"lng": 11.456914191196816,
				"lat": 43.548291380569886
			},
			{
				"lng": 11.456914195427922,
				"lat": 43.548289364233533
			},
			{
				"lng": 11.456914136242032,
				"lat": 43.548287311796656
			},
			{
				"lng": 11.456914014732041,
				"lat": 43.548285222793318
			},
			{
				"lng": 11.456913831990875,
				"lat": 43.548283096757729
			},
			{
				"lng": 11.456913589111428,
				"lat": 43.548280933224007
			},
			{
				"lng": 11.456913287186628,
				"lat": 43.548278731726214
			},
			{
				"lng": 11.456912927309331,
				"lat": 43.548276491798596
			},
			{
				"lng": 11.456912510572424,
				"lat": 43.54827421297513
			},
			{
				"lng": 11.456912038068866,
				"lat": 43.548271894790112
			},
			{
				"lng": 11.456911510891517,
				"lat": 43.548269536777525
			},
			{
				"lng": 11.456910930133287,
				"lat": 43.548267138471623
			},
			{
				"lng": 11.456910296887047,
				"lat": 43.548264699406452
			},
			{
				"lng": 11.456909612245772,
				"lat": 43.548262219116182
			},
			{
				"lng": 11.456908877302306,
				"lat": 43.548259697134938
			},
			{
				"lng": 11.45690809310025,
				"lat": 43.548257133084981
			},
			{
				"lng": 11.456907259315342,
				"lat": 43.548254529034615
			},
			{
				"lng": 11.456906374110945,
				"lat": 43.548251889756465
			},
			{
				"lng": 11.456905435572139,
				"lat": 43.54824922016315
			},
			{
				"lng": 11.456904441784106,
				"lat": 43.548246525167222
			},
			{
				"lng": 11.456903390831856,
				"lat": 43.548243809681281
			},
			{
				"lng": 11.456902280800572,
				"lat": 43.548241078617941
			},
			{
				"lng": 11.456901109775284,
				"lat": 43.54823833688976
			},
			{
				"lng": 11.456899875841145,
				"lat": 43.54823558940933
			},
			{
				"lng": 11.45689857708323,
				"lat": 43.548232841089174
			},
			{
				"lng": 11.456897211586679,
				"lat": 43.548230096841984
			},
			{
				"lng": 11.45689577743658,
				"lat": 43.54822736158026
			},
			{
				"lng": 11.456894272718035,
				"lat": 43.548224640216581
			},
			{
				"lng": 11.456892695516146,
				"lat": 43.548221937663641
			},
			{
				"lng": 11.456891043916034,
				"lat": 43.548219258833903
			},
			{
				"lng": 11.456889316002805,
				"lat": 43.54821660863999
			},
			{
				"lng": 11.456887509861495,
				"lat": 43.548213991994487
			},
			{
				"lng": 11.456885623577282,
				"lat": 43.548211413809987
			},
			{
				"lng": 11.456883655235243,
				"lat": 43.548208878999084
			},
			{
				"lng": 11.456881602920481,
				"lat": 43.548206392474263
			},
			{
				"lng": 11.456879465458044,
				"lat": 43.548203958684248
			},
			{
				"lng": 11.456877247716065,
				"lat": 43.548201578288008
			},
			{
				"lng": 11.456874957513612,
				"lat": 43.548199250094072
			},
			{
				"lng": 11.456872602689726,
				"lat": 43.548196972898559
			},
			{
				"lng": 11.456870191083459,
				"lat": 43.548194745497497
			},
			{
				"lng": 11.45686773053375,
				"lat": 43.548192566687021
			},
			{
				"lng": 11.456865228879714,
				"lat": 43.548190435263102
			},
			{
				"lng": 11.456862693960332,
				"lat": 43.548188350021867
			},
			{
				"lng": 11.456860133614663,
				"lat": 43.548186309759281
			},
			{
				"lng": 11.45685755568166,
				"lat": 43.548184313271491
			},
			{
				"lng": 11.456854968000432,
				"lat": 43.548182359354541
			},
			{
				"lng": 11.456852378409923,
				"lat": 43.548180446804452
			},
			{
				"lng": 11.456849794749189,
				"lat": 43.548178574417314
			},
			{
				"lng": 11.456847224857272,
				"lat": 43.548176740989199
			},
			{
				"lng": 11.456844676573159,
				"lat": 43.548174945316219
			},
			{
				"lng": 11.456842157735892,
				"lat": 43.548173186194333
			},
			{
				"lng": 11.456839676184448,
				"lat": 43.548171462419624
			},
			{
				"lng": 11.456837239757894,
				"lat": 43.548169772788285
			},
			{
				"lng": 11.456834856295201,
				"lat": 43.548168116096228
			},
			{
				"lng": 11.456832533634691,
				"lat": 43.54816649113986
			},
			{
				"lng": 11.456830277534756,
				"lat": 43.548164897416811
			},
			{
				"lng": 11.456828087140389,
				"lat": 43.548163336654994
			},
			{
				"lng": 11.456825960284931,
				"lat": 43.548161811024606
			},
			{
				"lng": 11.456823894801692,
				"lat": 43.548160322695914
			},
			{
				"lng": 11.456821888523919,
				"lat": 43.54815887383905
			},
			{
				"lng": 11.456819939285033,
				"lat": 43.548157466624232
			},
			{
				"lng": 11.45681804491824,
				"lat": 43.54815610322165
			},
			{
				"lng": 11.456816203256961,
				"lat": 43.54815478580155
			},
			{
				"lng": 11.456814412134474,
				"lat": 43.548153516534121
			},
			{
				"lng": 11.456812669384115,
				"lat": 43.54815229758951
			},
			{
				"lng": 11.456810972839165,
				"lat": 43.548151131138013
			},
			{
				"lng": 11.456809320332971,
				"lat": 43.548150019349769
			},
			{
				"lng": 11.45680770969885,
				"lat": 43.548148964395018
			},
			{
				"lng": 11.456806138770112,
				"lat": 43.548147968443935
			},
			{
				"lng": 11.456804605380098,
				"lat": 43.548147033666744
			},
			{
				"lng": 11.456803107362099,
				"lat": 43.548146162233607
			},
			{
				"lng": 11.456801642549461,
				"lat": 43.548145356314734
			},
			{
				"lng": 11.456800208775494,
				"lat": 43.548144618080364
			},
			{
				"lng": 11.456798803873518,
				"lat": 43.548143949700687
			},
			{
				"lng": 11.456797425663305,
				"lat": 43.548143353306088
			},
			{
				"lng": 11.456796071387597,
				"lat": 43.548142829327759
			},
			{
				"lng": 11.456794737508391,
				"lat": 43.548142375898429
			},
			{
				"lng": 11.45679342043235,
				"lat": 43.548141990987574
			},
			{
				"lng": 11.456792116566024,
				"lat": 43.548141672564718
			},
			{
				"lng": 11.456790822316114,
				"lat": 43.548141418599407
			},
			{
				"lng": 11.456789534089124,
				"lat": 43.548141227061194
			},
			{
				"lng": 11.456788248291801,
				"lat": 43.54814109591959
			},
			{
				"lng": 11.456786961330675,
				"lat": 43.548141023144098
			}
			],
			[{
				"lng": 11.457195587202204,
				"lat": 43.549046018004894
			},
			{
				"lng": 11.457193055967542,
				"lat": 43.54904606417481
			},
			{
				"lng": 11.457190486723151,
				"lat": 43.549046174076103
			},
			{
				"lng": 11.457187877572617,
				"lat": 43.549046344134737
			},
			{
				"lng": 11.457185226619506,
				"lat": 43.549046570776795
			},
			{
				"lng": 11.457182531967408,
				"lat": 43.549046850428233
			},
			{
				"lng": 11.457179791719902,
				"lat": 43.549047179515071
			},
			{
				"lng": 11.457177005706805,
				"lat": 43.549047554738181
			},
			{
				"lng": 11.457174180663484,
				"lat": 43.54904797389834
			},
			{
				"lng": 11.457171325051602,
				"lat": 43.549048435071207
			},
			{
				"lng": 11.457168447332743,
				"lat": 43.54904893633239
			},
			{
				"lng": 11.45716555596861,
				"lat": 43.54904947575767
			},
			{
				"lng": 11.457162659420813,
				"lat": 43.549050051422611
			},
			{
				"lng": 11.457159766151042,
				"lat": 43.549050661402937
			},
			{
				"lng": 11.457156884620884,
				"lat": 43.549051303774235
			},
			{
				"lng": 11.457154023292055,
				"lat": 43.549051976612283
			},
			{
				"lng": 11.457151190626151,
				"lat": 43.549052677992719
			},
			{
				"lng": 11.457148395084856,
				"lat": 43.549053405991174
			},
			{
				"lng": 11.457145645129794,
				"lat": 43.549054158683354
			},
			{
				"lng": 11.457142949222664,
				"lat": 43.549054934144905
			},
			{
				"lng": 11.457140315825033,
				"lat": 43.549055730451521
			},
			{
				"lng": 11.45713775339866,
				"lat": 43.549056545678873
			},
			{
				"lng": 11.45713527040515,
				"lat": 43.549057377902635
			},
			{
				"lng": 11.457132875306112,
				"lat": 43.549058225198493
			},
			{
				"lng": 11.457130576563287,
				"lat": 43.549059085642064
			},
			{
				"lng": 11.457128382638306,
				"lat": 43.549059957309126
			},
			{
				"lng": 11.457126301992794,
				"lat": 43.549060838275274
			},
			{
				"lng": 11.457124343088449,
				"lat": 43.549061726616223
			},
			{
				"lng": 11.457122513673962,
				"lat": 43.549062620498617
			},
			{
				"lng": 11.457120813209876,
				"lat": 43.549063519146259
			},
			{
				"lng": 11.457119235809497,
				"lat": 43.549064422465278
			},
			{
				"lng": 11.457117775497094,
				"lat": 43.549065330372919
			},
			{
				"lng": 11.457116426296848,
				"lat": 43.549066242786644
			},
			{
				"lng": 11.457115182232981,
				"lat": 43.549067159623775
			},
			{
				"lng": 11.457114037329735,
				"lat": 43.549068080801703
			},
			{
				"lng": 11.457112985611262,
				"lat": 43.549069006237865
			},
			{
				"lng": 11.457112021101864,
				"lat": 43.549069935849488
			},
			{
				"lng": 11.457111137825681,
				"lat": 43.549070869554036
			},
			{
				"lng": 11.457110329806987,
				"lat": 43.549071807268845
			},
			{
				"lng": 11.457109591069962,
				"lat": 43.549072748911357
			},
			{
				"lng": 11.45710891563883,
				"lat": 43.5490736943988
			},
			{
				"lng": 11.457108297537792,
				"lat": 43.549074643648723
			},
			{
				"lng": 11.457107730791096,
				"lat": 43.54907559657827
			},
			{
				"lng": 11.457107209422905,
				"lat": 43.549076553104982
			},
			{
				"lng": 11.457106727457457,
				"lat": 43.549077513146187
			},
			{
				"lng": 11.457105857831682,
				"lat": 43.549079443441435
			},
			{
				"lng": 11.457105074107439,
				"lat": 43.549081386802982
			},
			{
				"lng": 11.457104332785125,
				"lat": 43.549083342976125
			},
			{
				"lng": 11.457103640430997,
				"lat": 43.54908531642986
			},
			{
				"lng": 11.457103035911736,
				"lat": 43.549087314680598
			},
			{
				"lng": 11.457102778904245,
				"lat": 43.549088325469704
			},
			{
				"lng": 11.457102558632402,
				"lat": 43.549089345295741
			},
			{
				"lng": 11.457102380021796,
				"lat": 43.549090375104733
			},
			{
				"lng": 11.457102247998098,
				"lat": 43.54909141584254
			},
			{
				"lng": 11.457102167486896,
				"lat": 43.549092468455122
			},
			{
				"lng": 11.457102143413895,
				"lat": 43.549093533888303
			},
			{
				"lng": 11.457102180704638,
				"lat": 43.549094613088087
			},
			{
				"lng": 11.457102284284833,
				"lat": 43.549095707000369
			},
			{
				"lng": 11.45710245908009,
				"lat": 43.549096816571023
			},
			{
				"lng": 11.457102710016049,
				"lat": 43.549097942745959
			},
			{
				"lng": 11.457103042018348,
				"lat": 43.549099086471159
			},
			{
				"lng": 11.457103460012656,
				"lat": 43.549100248692454
			},
			{
				"lng": 11.45710396892456,
				"lat": 43.549101430355798
			},
			{
				"lng": 11.457104573679731,
				"lat": 43.549102632407106
			},
			{
				"lng": 11.457105279203773,
				"lat": 43.549103855792247
			},
			{
				"lng": 11.457106090422366,
				"lat": 43.549105101457215
			},
			{
				"lng": 11.457107009991761,
				"lat": 43.549106369931557
			},
			{
				"lng": 11.457108031490899,
				"lat": 43.549107660079677
			},
			{
				"lng": 11.457109146229305,
				"lat": 43.549108970349671
			},
			{
				"lng": 11.45711034551649,
				"lat": 43.549110299189763
			},
			{
				"lng": 11.457111620661975,
				"lat": 43.54911164504793
			},
			{
				"lng": 11.457112962975359,
				"lat": 43.54911300637233
			},
			{
				"lng": 11.457114363766141,
				"lat": 43.549114381611084
			},
			{
				"lng": 11.457115814343849,
				"lat": 43.549115769212307
			},
			{
				"lng": 11.45711730601802,
				"lat": 43.549117167624075
			},
			{
				"lng": 11.457118830098217,
				"lat": 43.549118575294557
			},
			{
				"lng": 11.4571219407147,
				"lat": 43.549121412203938
			},
			{
				"lng": 11.457125076669589,
				"lat": 43.549124267525457
			},
			{
				"lng": 11.457128168439066,
				"lat": 43.549127128843871
			},
			{
				"lng": 11.457129676028064,
				"lat": 43.549128557872322
			},
			{
				"lng": 11.45713114649933,
				"lat": 43.54912998374428
			},
			{
				"lng": 11.457132571162349,
				"lat": 43.549131404907989
			},
			{
				"lng": 11.457133941326632,
				"lat": 43.549132819811476
			},
			{
				"lng": 11.457135248301729,
				"lat": 43.549134226902936
			},
			{
				"lng": 11.457136484197731,
				"lat": 43.549135624780526
			},
			{
				"lng": 11.457137650431843,
				"lat": 43.54913701378721
			},
			{
				"lng": 11.457138754425827,
				"lat": 43.549138395391552
			},
			{
				"lng": 11.45713980370151,
				"lat": 43.54913977108091
			},
			{
				"lng": 11.457140805780686,
				"lat": 43.549141142342556
			},
			{
				"lng": 11.457142698436764,
				"lat": 43.54914387753211
			},
			{
				"lng": 11.457144492568741,
				"lat": 43.549146612859026
			},
			{
				"lng": 11.457146248351167,
				"lat": 43.549149360221897
			},
			{
				"lng": 11.457148025958649,
				"lat": 43.549152131519357
			},
			{
				"lng": 11.457149885565826,
				"lat": 43.549154938650155
			},
			{
				"lng": 11.457150864923848,
				"lat": 43.549156359371302
			},
			{
				"lng": 11.457151887347289,
				"lat": 43.549157793512776
			},
			{
				"lng": 11.457152960357986,
				"lat": 43.549159242561906
			},
			{
				"lng": 11.45715409147774,
				"lat": 43.549160708006006
			},
			{
				"lng": 11.457155288228368,
				"lat": 43.549162191332414
			},
			{
				"lng": 11.457156558131777,
				"lat": 43.549163694028422
			},
			{
				"lng": 11.457157908632015,
				"lat": 43.549165217549621
			},
			{
				"lng": 11.457159342511922,
				"lat": 43.549166761445086
			},
			{
				"lng": 11.457160855328956,
				"lat": 43.54916832230866
			},
			{
				"lng": 11.457162442019236,
				"lat": 43.549169896480286
			},
			{
				"lng": 11.457164097518749,
				"lat": 43.549171480299606
			},
			{
				"lng": 11.45716581676351,
				"lat": 43.54917307010642
			},
			{
				"lng": 11.457167594689592,
				"lat": 43.549174662240546
			},
			{
				"lng": 11.457169426233008,
				"lat": 43.549176253041608
			},
			{
				"lng": 11.457171306329768,
				"lat": 43.549177838849523
			},
			{
				"lng": 11.457173229915929,
				"lat": 43.54917941600398
			},
			{
				"lng": 11.457175191927483,
				"lat": 43.54918098084476
			},
			{
				"lng": 11.457177187300513,
				"lat": 43.549182529711629
			},
			{
				"lng": 11.457179210970995,
				"lat": 43.549184058944363
			},
			{
				"lng": 11.457181257874987,
				"lat": 43.549185564882741
			},
			{
				"lng": 11.457183322948474,
				"lat": 43.549187043866546
			},
			{
				"lng": 11.457185401127486,
				"lat": 43.549188492235416
			},
			{
				"lng": 11.457187487348047,
				"lat": 43.54918990632931
			},
			{
				"lng": 11.457189576546217,
				"lat": 43.549191282487904
			},
			{
				"lng": 11.457191663657934,
				"lat": 43.549192617050963
			},
			{
				"lng": 11.457193743619284,
				"lat": 43.549193906358255
			},
			{
				"lng": 11.457195811366271,
				"lat": 43.549195146749625
			},
			{
				"lng": 11.457197861834903,
				"lat": 43.549196334564719
			},
			{
				"lng": 11.457199890809841,
				"lat": 43.549197466781131
			},
			{
				"lng": 11.457201897470435,
				"lat": 43.549198542927016
			},
			{
				"lng": 11.457203881844681,
				"lat": 43.549199563168358
			},
			{
				"lng": 11.457205843960558,
				"lat": 43.54920052767109
			},
			{
				"lng": 11.457207783846064,
				"lat": 43.549201436601152
			},
			{
				"lng": 11.457209701529207,
				"lat": 43.549202290124612
			},
			{
				"lng": 11.457211597037961,
				"lat": 43.549203088407204
			},
			{
				"lng": 11.457213470400353,
				"lat": 43.549203831615003
			},
			{
				"lng": 11.457215321644346,
				"lat": 43.54920451991395
			},
			{
				"lng": 11.457217150797897,
				"lat": 43.54920515346997
			},
			{
				"lng": 11.457218957889079,
				"lat": 43.549205732449032
			},
			{
				"lng": 11.457220742945861,
				"lat": 43.549206257017048
			},
			{
				"lng": 11.457222505996207,
				"lat": 43.549206727340007
			},
			{
				"lng": 11.457224247068192,
				"lat": 43.549207143583793
			},
			{
				"lng": 11.457225966189696,
				"lat": 43.549207505914445
			},
			{
				"lng": 11.457227663388798,
				"lat": 43.549207814497791
			},
			{
				"lng": 11.457229338693468,
				"lat": 43.549208069499869
			},
			{
				"lng": 11.457230992131677,
				"lat": 43.549208271086563
			},
			{
				"lng": 11.457232623731448,
				"lat": 43.549208419423877
			},
			{
				"lng": 11.457234233520802,
				"lat": 43.549208514677737
			},
			{
				"lng": 11.457235821527696,
				"lat": 43.549208557014076
			},
			{
				"lng": 11.457237387829325,
				"lat": 43.549208546632727
			},
			{
				"lng": 11.457238933074567,
				"lat": 43.549208484127654
			},
			{
				"lng": 11.45724045828114,
				"lat": 43.549208370346946
			},
			{
				"lng": 11.457241964472992,
				"lat": 43.549208206143057
			},
			{
				"lng": 11.457243452673953,
				"lat": 43.549207992368338
			},
			{
				"lng": 11.457244923907947,
				"lat": 43.54920772987515
			},
			{
				"lng": 11.457246379198843,
				"lat": 43.549207419515952
			},
			{
				"lng": 11.457247819570544,
				"lat": 43.549207062143026
			},
			{
				"lng": 11.457249246046914,
				"lat": 43.54920665860886
			},
			{
				"lng": 11.457250659651859,
				"lat": 43.549206209765785
			},
			{
				"lng": 11.457252061409262,
				"lat": 43.549205716466211
			},
			{
				"lng": 11.457253452343007,
				"lat": 43.549205179562549
			},
			{
				"lng": 11.457254833477004,
				"lat": 43.549204599907178
			},
			{
				"lng": 11.457256205835085,
				"lat": 43.549203978352409
			},
			{
				"lng": 11.457257570441206,
				"lat": 43.549203315750724
			},
			{
				"lng": 11.457258928319218,
				"lat": 43.549202612954481
			},
			{
				"lng": 11.457260280493028,
				"lat": 43.549201870816056
			},
			{
				"lng": 11.457261627986504,
				"lat": 43.549201090187857
			},
			{
				"lng": 11.457262971823525,
				"lat": 43.549200271922231
			},
			{
				"lng": 11.457264313028029,
				"lat": 43.549199416871616
			},
			{
				"lng": 11.457265652623841,
				"lat": 43.54919852588835
			},
			{
				"lng": 11.45726699159855,
				"lat": 43.549197599804216
			},
			{
				"lng": 11.457268328757554,
				"lat": 43.549196638209779
			},
			{
				"lng": 11.457269659524064,
				"lat": 43.549195638772183
			},
			{
				"lng": 11.457270979030358,
				"lat": 43.549194598993061
			},
			{
				"lng": 11.457272282408701,
				"lat": 43.54919351637399
			},
			{
				"lng": 11.457273564791386,
				"lat": 43.549192388416643
			},
			{
				"lng": 11.457274821310692,
				"lat": 43.549191212622546
			},
			{
				"lng": 11.457276047098837,
				"lat": 43.549189986493388
			},
			{
				"lng": 11.457277237288121,
				"lat": 43.549188707530767
			},
			{
				"lng": 11.457278387010833,
				"lat": 43.549187373236286
			},
			{
				"lng": 11.457279491399232,
				"lat": 43.549185981111492
			},
			{
				"lng": 11.457280545585562,
				"lat": 43.549184528658159
			},
			{
				"lng": 11.457281544702173,
				"lat": 43.549183013377792
			},
			{
				"lng": 11.457282483881253,
				"lat": 43.549181432772031
			},
			{
				"lng": 11.457283358255163,
				"lat": 43.549179784342449
			},
			{
				"lng": 11.457284162956093,
				"lat": 43.549178065590745
			},
			{
				"lng": 11.457284893116382,
				"lat": 43.549176274018485
			},
			{
				"lng": 11.457285228722618,
				"lat": 43.549175350143926
			},
			{
				"lng": 11.457285543868268,
				"lat": 43.549174407127332
			},
			{
				"lng": 11.457285837944898,
				"lat": 43.549173444656397
			},
			{
				"lng": 11.457286110344066,
				"lat": 43.549172462418852
			},
			{
				"lng": 11.457286360457248,
				"lat": 43.549171460102315
			},
			{
				"lng": 11.457286587676016,
				"lat": 43.549170437394658
			},
			{
				"lng": 11.457286791391887,
				"lat": 43.549169393983398
			},
			{
				"lng": 11.45728697099644,
				"lat": 43.54916832955638
			},
			{
				"lng": 11.457287125881143,
				"lat": 43.549167243801236
			},
			{
				"lng": 11.45728725543759,
				"lat": 43.549166136405667
			},
			{
				"lng": 11.457287359203541,
				"lat": 43.54916500721491
			},
			{
				"lng": 11.457287437301755,
				"lat": 43.549163856704588
			},
			{
				"lng": 11.457287490001274,
				"lat": 43.549162685507767
			},
			{
				"lng": 11.457287517571146,
				"lat": 43.549161494257554
			},
			{
				"lng": 11.457287520280387,
				"lat": 43.549160283587007
			},
			{
				"lng": 11.457287498398008,
				"lat": 43.549159054129326
			},
			{
				"lng": 11.457287452193045,
				"lat": 43.549157806517513
			},
			{
				"lng": 11.457287381934549,
				"lat": 43.549156541384775
			},
			{
				"lng": 11.45728717033295,
				"lat": 43.54915396108882
			},
			{
				"lng": 11.457286865745454,
				"lat": 43.54915131830618
			},
			{
				"lng": 11.457286470324261,
				"lat": 43.549148618101775
			},
			{
				"lng": 11.457285986221617,
				"lat": 43.549145865540524
			},
			{
				"lng": 11.457285415589725,
				"lat": 43.549143065687119
			},
			{
				"lng": 11.457284760580784,
				"lat": 43.549140223606514
			},
			{
				"lng": 11.45728402334702,
				"lat": 43.549137344363466
			},
			{
				"lng": 11.457283206040639,
				"lat": 43.549134433022886
			},
			{
				"lng": 11.457282310813877,
				"lat": 43.549131494649615
			},
			{
				"lng": 11.457281339818946,
				"lat": 43.549128534308522
			},
			{
				"lng": 11.457280295208031,
				"lat": 43.549125557064386
			},
			{
				"lng": 11.457279179133355,
				"lat": 43.549122567982039
			},
			{
				"lng": 11.457277993747137,
				"lat": 43.549119572126429
			},
			{
				"lng": 11.457276741201614,
				"lat": 43.549116574562355
			},
			{
				"lng": 11.457275423648937,
				"lat": 43.549113580354557
			},
			{
				"lng": 11.457274043241359,
				"lat": 43.549110594568035
			},
			{
				"lng": 11.457272602131097,
				"lat": 43.54910762226752
			},
			{
				"lng": 11.457271102481618,
				"lat": 43.549104668503674
			},
			{
				"lng": 11.457269546587952,
				"lat": 43.549101738160523
			},
			{
				"lng": 11.457267936829822,
				"lat": 43.549098836014991
			},
			{
				"lng": 11.457266275588461,
				"lat": 43.549095966842124
			},
			{
				"lng": 11.45726456524504,
				"lat": 43.549093135416875
			},
			{
				"lng": 11.45726280818076,
				"lat": 43.549090346514369
			},
			{
				"lng": 11.45726100677679,
				"lat": 43.549087604909573
			},
			{
				"lng": 11.457259163414324,
				"lat": 43.549084915377634
			},
			{
				"lng": 11.457257280474604,
				"lat": 43.54908228269349
			},
			{
				"lng": 11.457255360338726,
				"lat": 43.549079711632267
			},
			{
				"lng": 11.45725340538794,
				"lat": 43.54907720696896
			},
			{
				"lng": 11.457251418003409,
				"lat": 43.549074773478644
			},
			{
				"lng": 11.457249400566312,
				"lat": 43.549072415936301
			},
			{
				"lng": 11.457247355457811,
				"lat": 43.549070139117084
			},
			{
				"lng": 11.457245285059106,
				"lat": 43.549067947795947
			},
			{
				"lng": 11.457243191751395,
				"lat": 43.549065846747915
			},
			{
				"lng": 11.457242137250766,
				"lat": 43.549064831568593
			},
			{
				"lng": 11.457241077915793,
				"lat": 43.549063840748126
			},
			{
				"lng": 11.457240014044181,
				"lat": 43.549062874883489
			},
			{
				"lng": 11.45723894593354,
				"lat": 43.549061934571561
			},
			{
				"lng": 11.457237873881532,
				"lat": 43.549061020409191
			},
			{
				"lng": 11.457236798185779,
				"lat": 43.54906013299329
			},
			{
				"lng": 11.457235719143942,
				"lat": 43.549059272920701
			},
			{
				"lng": 11.457234637053668,
				"lat": 43.549058440788357
			},
			{
				"lng": 11.457233552212607,
				"lat": 43.549057637193059
			},
			{
				"lng": 11.457232464918418,
				"lat": 43.549056862731803
			},
			{
				"lng": 11.457231375468725,
				"lat": 43.549056118001353
			},
			{
				"lng": 11.457230284134765,
				"lat": 43.549055403547101
			},
			{
				"lng": 11.457229190880845,
				"lat": 43.549054719315251
			},
			{
				"lng": 11.45722809547318,
				"lat": 43.549054064865516
			},
			{
				"lng": 11.457226997674741,
				"lat": 43.549053439751269
			},
			{
				"lng": 11.457225897248483,
				"lat": 43.549052843525494
			},
			{
				"lng": 11.45722479395732,
				"lat": 43.549052275741602
			},
			{
				"lng": 11.457223687564191,
				"lat": 43.549051735952844
			},
			{
				"lng": 11.457222577832079,
				"lat": 43.549051223712468
			},
			{
				"lng": 11.457221464523897,
				"lat": 43.549050738573655
			},
			{
				"lng": 11.457220347402624,
				"lat": 43.549050280089709
			},
			{
				"lng": 11.457219226231167,
				"lat": 43.549049847813855
			},
			{
				"lng": 11.45721810077251,
				"lat": 43.549049441299417
			},
			{
				"lng": 11.457216970789531,
				"lat": 43.549049060099563
			},
			{
				"lng": 11.457215836045231,
				"lat": 43.549048703767568
			},
			{
				"lng": 11.457214696302543,
				"lat": 43.549048371856692
			},
			{
				"lng": 11.457212400873807,
				"lat": 43.549047779511255
			},
			{
				"lng": 11.457210082606863,
				"lat": 43.549047279489237
			},
			{
				"lng": 11.457207739605254,
				"lat": 43.549046868216628
			},
			{
				"lng": 11.457205369972559,
				"lat": 43.549046542119427
			},
			{
				"lng": 11.457202971812356,
				"lat": 43.549046297623718
			},
			{
				"lng": 11.457200543228176,
				"lat": 43.549046131155436
			},
			{
				"lng": 11.457198082323629,
				"lat": 43.549046039140471
			},
			{
				"lng": 11.457195587202204,
				"lat": 43.549046018004894
			}
			],
			[{
				"lng": 11.456846413080127,
				"lat": 43.548758394940819
			},
			{
				"lng": 11.456845707886503,
				"lat": 43.548755782105459
			},
			{
				"lng": 11.456845021175662,
				"lat": 43.548753159329117
			},
			{
				"lng": 11.456844353079653,
				"lat": 43.548750526508812
			},
			{
				"lng": 11.456843703730495,
				"lat": 43.548747883541772
			},
			{
				"lng": 11.456843073260147,
				"lat": 43.548745230325046
			},
			{
				"lng": 11.456842461765476,
				"lat": 43.548742566802076
			},
			{
				"lng": 11.456841869127407,
				"lat": 43.548739893199695
			},
			{
				"lng": 11.456841295145228,
				"lat": 43.548737209852362
			},
			{
				"lng": 11.456840739617888,
				"lat": 43.548734517094616
			},
			{
				"lng": 11.456840202344541,
				"lat": 43.548731815261021
			},
			{
				"lng": 11.45683968312415,
				"lat": 43.548729104686132
			},
			{
				"lng": 11.456839181755832,
				"lat": 43.548726385704597
			},
			{
				"lng": 11.456838698038613,
				"lat": 43.548723658650864
			},
			{
				"lng": 11.456838231771517,
				"lat": 43.548720923859669
			},
			{
				"lng": 11.456837782753674,
				"lat": 43.548718181665521
			},
			{
				"lng": 11.456837350784078,
				"lat": 43.548715432402908
			},
			{
				"lng": 11.456836935661773,
				"lat": 43.548712676406559
			},
			{
				"lng": 11.456836537185865,
				"lat": 43.548709914010864
			},
			{
				"lng": 11.456836155155306,
				"lat": 43.548707145550587
			},
			{
				"lng": 11.456835789369268,
				"lat": 43.548704371360174
			},
			{
				"lng": 11.456835439626753,
				"lat": 43.548701591774282
			},
			{
				"lng": 11.456835105726769,
				"lat": 43.548698807127401
			},
			{
				"lng": 11.456834787468432,
				"lat": 43.548696017754104
			},
			{
				"lng": 11.456834484650754,
				"lat": 43.548693223989126
			},
			{
				"lng": 11.456834197072807,
				"lat": 43.548690426166864
			},
			{
				"lng": 11.45683392453366,
				"lat": 43.548687624621934
			},
			{
				"lng": 11.456833666832308,
				"lat": 43.548684819688937
			},
			{
				"lng": 11.456833423767865,
				"lat": 43.548682011702468
			},
			{
				"lng": 11.456833195139382,
				"lat": 43.548679200997064
			},
			{
				"lng": 11.45683298074583,
				"lat": 43.54867638790725
			},
			{
				"lng": 11.456832780386367,
				"lat": 43.548673572767761
			},
			{
				"lng": 11.456832593859968,
				"lat": 43.548670755913015
			},
			{
				"lng": 11.456832420965728,
				"lat": 43.548667937677678
			},
			{
				"lng": 11.456832261502671,
				"lat": 43.548665118396279
			},
			{
				"lng": 11.456832115269886,
				"lat": 43.548662298403372
			},
			{
				"lng": 11.456831982066383,
				"lat": 43.548659478033599
			},
			{
				"lng": 11.456831861691228,
				"lat": 43.548656657621457
			},
			{
				"lng": 11.456831753943501,
				"lat": 43.548653837501583
			},
			{
				"lng": 11.456831658622232,
				"lat": 43.54865101800857
			},
			{
				"lng": 11.456831575526474,
				"lat": 43.548648199476858
			},
			{
				"lng": 11.456831504455268,
				"lat": 43.54864538224119
			},
			{
				"lng": 11.456831445207706,
				"lat": 43.548642566636062
			},
			{
				"lng": 11.456831397582789,
				"lat": 43.548639752995989
			},
			{
				"lng": 11.456831361379624,
				"lat": 43.54863694165568
			},
			{
				"lng": 11.456831336397213,
				"lat": 43.548634132949616
			},
			{
				"lng": 11.456831322434613,
				"lat": 43.548631327212384
			},
			{
				"lng": 11.456831319290931,
				"lat": 43.548628524778557
			},
			{
				"lng": 11.456831326765181,
				"lat": 43.548625725982781
			},
			{
				"lng": 11.456831344656409,
				"lat": 43.548622931159493
			},
			{
				"lng": 11.456831372763688,
				"lat": 43.548620140643365
			},
			{
				"lng": 11.456831410886064,
				"lat": 43.548617354768965
			},
			{
				"lng": 11.456831458822554,
				"lat": 43.548614573870836
			},
			{
				"lng": 11.45683151637226,
				"lat": 43.548611798283567
			},
			{
				"lng": 11.456831583334235,
				"lat": 43.548609028341794
			},
			{
				"lng": 11.456831659507486,
				"lat": 43.548606264379977
			},
			{
				"lng": 11.456831744691135,
				"lat": 43.548603506732753
			},
			{
				"lng": 11.456831838684161,
				"lat": 43.548600755734654
			},
			{
				"lng": 11.456831941285667,
				"lat": 43.548598011720358
			},
			{
				"lng": 11.456832052294706,
				"lat": 43.548595275024333
			},
			{
				"lng": 11.456832171510289,
				"lat": 43.548592545981194
			},
			{
				"lng": 11.456832298731507,
				"lat": 43.548589824925472
			},
			{
				"lng": 11.456832433757429,
				"lat": 43.548587112191832
			},
			{
				"lng": 11.45683257638705,
				"lat": 43.548584408114813
			},
			{
				"lng": 11.45683272641949,
				"lat": 43.548581713028938
			},
			{
				"lng": 11.456832883653753,
				"lat": 43.548579027268822
			},
			{
				"lng": 11.456833047888894,
				"lat": 43.548576351168997
			},
			{
				"lng": 11.456833218924018,
				"lat": 43.548573685064163
			},
			{
				"lng": 11.456833396558128,
				"lat": 43.548571029288738
			},
			{
				"lng": 11.45683358059029,
				"lat": 43.548568384177386
			},
			{
				"lng": 11.456833770819589,
				"lat": 43.548565750064675
			},
			{
				"lng": 11.456833967044986,
				"lat": 43.548563127285114
			},
			{
				"lng": 11.456834169065631,
				"lat": 43.548560516173353
			},
			{
				"lng": 11.456834376680579,
				"lat": 43.54855791706396
			},
			{
				"lng": 11.456834589688837,
				"lat": 43.548555330291478
			},
			{
				"lng": 11.456834807889425,
				"lat": 43.548552756190468
			},
			{
				"lng": 11.456835031081503,
				"lat": 43.548550195095565
			},
			{
				"lng": 11.456835259064047,
				"lat": 43.54854764734133
			},
			{
				"lng": 11.456835491636127,
				"lat": 43.548545113262271
			},
			{
				"lng": 11.456835728596797,
				"lat": 43.548542593193019
			},
			{
				"lng": 11.456835969745162,
				"lat": 43.548540087468126
			},
			{
				"lng": 11.456836214880179,
				"lat": 43.548537596422214
			},
			{
				"lng": 11.456836463800967,
				"lat": 43.548535120389793
			},
			{
				"lng": 11.456836716306572,
				"lat": 43.548532659705465
			},
			{
				"lng": 11.456836972196026,
				"lat": 43.54853021470381
			},
			{
				"lng": 11.45683723126842,
				"lat": 43.548527785719351
			},
			{
				"lng": 11.456837493322807,
				"lat": 43.548525373086797
			},
			{
				"lng": 11.456837758158199,
				"lat": 43.548522977140564
			},
			{
				"lng": 11.456838025573672,
				"lat": 43.548520598215319
			},
			{
				"lng": 11.456838295368298,
				"lat": 43.548518236645613
			},
			{
				"lng": 11.456838567341112,
				"lat": 43.548515892766027
			},
			{
				"lng": 11.456838841291212,
				"lat": 43.548513566911112
			},
			{
				"lng": 11.456839117017569,
				"lat": 43.548511259415463
			},
			{
				"lng": 11.456839394319298,
				"lat": 43.548508970613618
			},
			{
				"lng": 11.456839672995429,
				"lat": 43.548506700840257
			},
			{
				"lng": 11.456839952845057,
				"lat": 43.548504450429846
			},
			{
				"lng": 11.456840233667162,
				"lat": 43.548502219716966
			},
			{
				"lng": 11.456840515260874,
				"lat": 43.548500009036239
			},
			{
				"lng": 11.456840797425214,
				"lat": 43.548497818722275
			},
			{
				"lng": 11.45684107995927,
				"lat": 43.548495649109469
			},
			{
				"lng": 11.456841362662027,
				"lat": 43.548493500532615
			},
			{
				"lng": 11.456841645332595,
				"lat": 43.548491373326151
			},
			{
				"lng": 11.456841927770022,
				"lat": 43.548489267824749
			},
			{
				"lng": 11.456842209773344,
				"lat": 43.548487184362855
			},
			{
				"lng": 11.456842491141639,
				"lat": 43.548485123275178
			},
			{
				"lng": 11.456842771673941,
				"lat": 43.548483084896183
			},
			{
				"lng": 11.456843051169351,
				"lat": 43.548481069560481
			},
			{
				"lng": 11.456843329426869,
				"lat": 43.548479077602707
			},
			{
				"lng": 11.456843606245572,
				"lat": 43.548477109357357
			},
			{
				"lng": 11.456843881424508,
				"lat": 43.548475165159005
			},
			{
				"lng": 11.45684415476275,
				"lat": 43.548473245342294
			},
			{
				"lng": 11.45684442605933,
				"lat": 43.548471350241776
			},
			{
				"lng": 11.456844695113315,
				"lat": 43.54846948019199
			},
			{
				"lng": 11.456844961723784,
				"lat": 43.548467635527494
			},
			{
				"lng": 11.456845225689738,
				"lat": 43.548465816582961
			},
			{
				"lng": 11.45684535661826,
				"lat": 43.548464916860134
			},
			{
				"lng": 11.456845486810284,
				"lat": 43.548464023692794
			},
			{
				"lng": 11.456845616240717,
				"lat": 43.548463137122738
			},
			{
				"lng": 11.456845744884456,
				"lat": 43.548462257191773
			},
			{
				"lng": 11.456845872716345,
				"lat": 43.548461383941678
			},
			{
				"lng": 11.456845999711311,
				"lat": 43.54846051741437
			},
			{
				"lng": 11.45684612584418,
				"lat": 43.548459657651492
			},
			{
				"lng": 11.456846251089873,
				"lat": 43.54845880469508
			},
			{
				"lng": 11.456846375423302,
				"lat": 43.548457958586859
			},
			{
				"lng": 11.456846498819258,
				"lat": 43.548457119368635
			},
			{
				"lng": 11.45684662125273,
				"lat": 43.54845628708221
			},
			{
				"lng": 11.456846742698509,
				"lat": 43.548455461769471
			},
			{
				"lng": 11.45684686313151,
				"lat": 43.54845464347224
			},
			{
				"lng": 11.456846982528807,
				"lat": 43.548453832218627
			},
			{
				"lng": 11.456847100877262,
				"lat": 43.548453027974915
			},
			{
				"lng": 11.456847218166578,
				"lat": 43.548452230689662
			},
			{
				"lng": 11.456847334386447,
				"lat": 43.548451440311581
			},
			{
				"lng": 11.456847449526537,
				"lat": 43.548450656789235
			},
			{
				"lng": 11.456847563576545,
				"lat": 43.548449880071331
			},
			{
				"lng": 11.456847676526172,
				"lat": 43.54844911010639
			},
			{
				"lng": 11.456847788365064,
				"lat": 43.548448346843131
			},
			{
				"lng": 11.456847899082936,
				"lat": 43.548447590230154
			},
			{
				"lng": 11.456848008669482,
				"lat": 43.548446840216137
			},
			{
				"lng": 11.45684811711436,
				"lat": 43.548446096749629
			},
			{
				"lng": 11.456848330537937,
				"lat": 43.548444629253815
			},
			{
				"lng": 11.45684853927116,
				"lat": 43.548443187331799
			},
			{
				"lng": 11.45684874323153,
				"lat": 43.548441770572573
			},
			{
				"lng": 11.456848942336492,
				"lat": 43.548440378565267
			},
			{
				"lng": 11.456849136503598,
				"lat": 43.548439010898839
			},
			{
				"lng": 11.4568493256503,
				"lat": 43.548437667162332
			},
			{
				"lng": 11.456849509694141,
				"lat": 43.54843634694496
			},
			{
				"lng": 11.456849688552571,
				"lat": 43.548435049835568
			},
			{
				"lng": 11.456849862143105,
				"lat": 43.548433775423355
			},
			{
				"lng": 11.45685003038324,
				"lat": 43.548432523297308
			},
			{
				"lng": 11.456850193190448,
				"lat": 43.548431293046413
			},
			{
				"lng": 11.456850350482251,
				"lat": 43.54843008425987
			},
			{
				"lng": 11.456850502176122,
				"lat": 43.548428896526595
			},
			{
				"lng": 11.456850648189556,
				"lat": 43.54842772943568
			},
			{
				"lng": 11.456850788440031,
				"lat": 43.548426582576212
			},
			{
				"lng": 11.456850922845067,
				"lat": 43.548425455537171
			},
			{
				"lng": 11.456851051322172,
				"lat": 43.548424347907677
			},
			{
				"lng": 11.456851173788813,
				"lat": 43.548423259276717
			},
			{
				"lng": 11.456851290162486,
				"lat": 43.548422189233364
			},
			{
				"lng": 11.456851400360708,
				"lat": 43.548421137366709
			},
			{
				"lng": 11.456851504300927,
				"lat": 43.548420103265741
			},
			{
				"lng": 11.456851601900652,
				"lat": 43.548419086519523
			},
			{
				"lng": 11.45685169307743,
				"lat": 43.54841808671712
			},
			{
				"lng": 11.456851777748696,
				"lat": 43.548417103447569
			},
			{
				"lng": 11.456851855831925,
				"lat": 43.548416136299899
			},
			{
				"lng": 11.456851927244697,
				"lat": 43.548415184863181
			},
			{
				"lng": 11.456851991904436,
				"lat": 43.548414248726516
			},
			{
				"lng": 11.456852049728623,
				"lat": 43.548413327478876
			},
			{
				"lng": 11.456852100634828,
				"lat": 43.548412420709333
			},
			{
				"lng": 11.456852144540479,
				"lat": 43.548411528006923
			},
			{
				"lng": 11.456852181363091,
				"lat": 43.54841064896074
			},
			{
				"lng": 11.45685221102017,
				"lat": 43.548409783159798
			},
			{
				"lng": 11.456852233429164,
				"lat": 43.548408930193169
			},
			{
				"lng": 11.456852248507641,
				"lat": 43.548408089649847
			},
			{
				"lng": 11.456852256173052,
				"lat": 43.54840726111896
			},
			{
				"lng": 11.456852256342859,
				"lat": 43.548406444189531
			},
			{
				"lng": 11.456852248934627,
				"lat": 43.548405638450561
			},
			{
				"lng": 11.456852233865803,
				"lat": 43.548404843491184
			},
			{
				"lng": 11.456852211053844,
				"lat": 43.548404058900338
			},
			{
				"lng": 11.456852180416332,
				"lat": 43.548403284267103
			},
			{
				"lng": 11.456852141870716,
				"lat": 43.548402519180648
			},
			{
				"lng": 11.456852095334472,
				"lat": 43.548401763229897
			},
			{
				"lng": 11.456852040725131,
				"lat": 43.548401016003965
			},
			{
				"lng": 11.456851977960149,
				"lat": 43.548400277091801
			},
			{
				"lng": 11.456851906957056,
				"lat": 43.54839954608255
			},
			{
				"lng": 11.456851827633322,
				"lat": 43.548398822565275
			},
			{
				"lng": 11.456851739906448,
				"lat": 43.548398106128928
			},
			{
				"lng": 11.45685164369392,
				"lat": 43.54839739636266
			},
			{
				"lng": 11.456851538913252,
				"lat": 43.548396692855412
			},
			{
				"lng": 11.456851425481929,
				"lat": 43.548395995196358
			},
			{
				"lng": 11.456851303317402,
				"lat": 43.548395302974441
			},
			{
				"lng": 11.45685117233724,
				"lat": 43.548394615778768
			},
			{
				"lng": 11.456851032458891,
				"lat": 43.548393933198405
			},
			{
				"lng": 11.456850883599852,
				"lat": 43.548393254822315
			},
			{
				"lng": 11.456850725677615,
				"lat": 43.548392580239693
			},
			{
				"lng": 11.456850558609688,
				"lat": 43.548391909039438
			},
			{
				"lng": 11.456850382313565,
				"lat": 43.548391240810638
			},
			{
				"lng": 11.456850196706728,
				"lat": 43.548390575142363
			},
			{
				"lng": 11.456850001706677,
				"lat": 43.548389911623708
			},
			{
				"lng": 11.456849797230896,
				"lat": 43.548389249843623
			},
			{
				"lng": 11.45684958319687,
				"lat": 43.54838858939123
			},
			{
				"lng": 11.45684935952214,
				"lat": 43.548387929855544
			},
			{
				"lng": 11.456849126124151,
				"lat": 43.548387270825664
			},
			{
				"lng": 11.456848882920408,
				"lat": 43.548386611890557
			},
			{
				"lng": 11.45684862982843,
				"lat": 43.54838595263935
			},
			{
				"lng": 11.456848366765662,
				"lat": 43.548385292661045
			},
			{
				"lng": 11.456848093649674,
				"lat": 43.548384631544685
			},
			{
				"lng": 11.456847810397873,
				"lat": 43.548383968879371
			},
			{
				"lng": 11.456847516927809,
				"lat": 43.548383304254102
			},
			{
				"lng": 11.456847213156951,
				"lat": 43.54838263725798
			},
			{
				"lng": 11.456846899002814,
				"lat": 43.548381967479997
			},
			{
				"lng": 11.456846574382848,
				"lat": 43.548381294509198
			},
			{
				"lng": 11.456846239214613,
				"lat": 43.548380617934683
			},
			{
				"lng": 11.456845893415556,
				"lat": 43.548379937345452
			},
			{
				"lng": 11.456845536903172,
				"lat": 43.548379252330591
			},
			{
				"lng": 11.456845169594992,
				"lat": 43.548378562479158
			},
			{
				"lng": 11.456844791408493,
				"lat": 43.548377867380182
			},
			{
				"lng": 11.456844402261114,
				"lat": 43.548377166622693
			},
			{
				"lng": 11.456844002070412,
				"lat": 43.548376459795762
			},
			{
				"lng": 11.456843590753873,
				"lat": 43.548375746488396
			},
			{
				"lng": 11.456843168228961,
				"lat": 43.548375026289762
			},
			{
				"lng": 11.456842734413252,
				"lat": 43.548374298788744
			},
			{
				"lng": 11.456842289224117,
				"lat": 43.548373563574501
			},
			{
				"lng": 11.456841832579132,
				"lat": 43.548372820236068
			},
			{
				"lng": 11.456841364395768,
				"lat": 43.548372068362482
			},
			{
				"lng": 11.456840884591527,
				"lat": 43.548371307542773
			},
			{
				"lng": 11.45684039308389,
				"lat": 43.548370537366011
			},
			{
				"lng": 11.456839889790354,
				"lat": 43.548369757421234
			},
			{
				"lng": 11.456839374628446,
				"lat": 43.54836896729752
			},
			{
				"lng": 11.456838847515616,
				"lat": 43.548368166583856
			},
			{
				"lng": 11.456838308369356,
				"lat": 43.548367354869406
			},
			{
				"lng": 11.456837757107227,
				"lat": 43.54836653174312
			},
			{
				"lng": 11.456837193646646,
				"lat": 43.548365696794058
			},
			{
				"lng": 11.456836617905147,
				"lat": 43.548364849611261
			},
			{
				"lng": 11.456836029800218,
				"lat": 43.548363989783802
			},
			{
				"lng": 11.456835429249338,
				"lat": 43.54836311690071
			},
			{
				"lng": 11.456834816170005,
				"lat": 43.548362230551099
			},
			{
				"lng": 11.456834190479746,
				"lat": 43.548361330323949
			},
			{
				"lng": 11.456833552096029,
				"lat": 43.548360415808304
			},
			{
				"lng": 11.456832900936364,
				"lat": 43.548359486593277
			},
			{
				"lng": 11.456832236918197,
				"lat": 43.548358542267877
			},
			{
				"lng": 11.456831559959101,
				"lat": 43.54835758242114
			},
			{
				"lng": 11.456830869976493,
				"lat": 43.548356606642152
			},
			{
				"lng": 11.456830166887912,
				"lat": 43.548355614519934
			},
			{
				"lng": 11.456829450610849,
				"lat": 43.548354605643503
			},
			{
				"lng": 11.456828721062804,
				"lat": 43.548353579601937
			},
			{
				"lng": 11.456827978161279,
				"lat": 43.5483525359843
			},
			{
				"lng": 11.456827221823701,
				"lat": 43.5483514743797
			},
			{
				"lng": 11.456826451967645,
				"lat": 43.548350394377053
			},
			{
				"lng": 11.456825668510621,
				"lat": 43.548349295565572
			},
			{
				"lng": 11.456824871416304,
				"lat": 43.548348177679721
			},
			{
				"lng": 11.456824060786223,
				"lat": 43.5483470408874
			},
			{
				"lng": 11.45682323674737,
				"lat": 43.548345885437037
			},
			{
				"lng": 11.45682239942688,
				"lat": 43.548344711577087
			},
			{
				"lng": 11.45682154895179,
				"lat": 43.548343519555871
			},
			{
				"lng": 11.456820685449138,
				"lat": 43.548342309621866
			},
			{
				"lng": 11.456819809046003,
				"lat": 43.548341082023498
			},
			{
				"lng": 11.456818919869459,
				"lat": 43.548339837009145
			},
			{
				"lng": 11.456818018046532,
				"lat": 43.54833857482727
			},
			{
				"lng": 11.456817103704317,
				"lat": 43.54833729572622
			},
			{
				"lng": 11.45681617696985,
				"lat": 43.548335999954482
			},
			{
				"lng": 11.456815237970218,
				"lat": 43.548334687760438
			},
			{
				"lng": 11.456814286832483,
				"lat": 43.548333359392529
			},
			{
				"lng": 11.456813323683692,
				"lat": 43.548332015099078
			},
			{
				"lng": 11.456812348650892,
				"lat": 43.548330655128623
			},
			{
				"lng": 11.456811361861197,
				"lat": 43.54832927972955
			},
			{
				"lng": 11.456810363441578,
				"lat": 43.548327889150201
			},
			{
				"lng": 11.45680935351921,
				"lat": 43.548326483639066
			},
			{
				"lng": 11.456808332221076,
				"lat": 43.548325063444558
			},
			{
				"lng": 11.456807299674242,
				"lat": 43.548323628815034
			},
			{
				"lng": 11.456806256005802,
				"lat": 43.548322179999026
			},
			{
				"lng": 11.456805201342817,
				"lat": 43.548320717244806
			},
			{
				"lng": 11.456804135812328,
				"lat": 43.548319240800843
			},
			{
				"lng": 11.456803059541389,
				"lat": 43.548317750915601
			},
			{
				"lng": 11.456801972657082,
				"lat": 43.548316247837448
			},
			{
				"lng": 11.456800875286431,
				"lat": 43.548314731814848
			},
			{
				"lng": 11.456799767556591,
				"lat": 43.548313203096093
			},
			{
				"lng": 11.456798649594518,
				"lat": 43.548311661929809
			},
			{
				"lng": 11.45679752152733,
				"lat": 43.548310108564188
			},
			{
				"lng": 11.456796383482052,
				"lat": 43.548308543247821
			},
			{
				"lng": 11.456795235585783,
				"lat": 43.548306966229021
			},
			{
				"lng": 11.456794077965583,
				"lat": 43.54830537775625
			},
			{
				"lng": 11.456792910748474,
				"lat": 43.548303778077894
			},
			{
				"lng": 11.456791734061554,
				"lat": 43.548302167442394
			},
			{
				"lng": 11.456790548031886,
				"lat": 43.548300546098176
			},
			{
				"lng": 11.456789352786512,
				"lat": 43.548298914293575
			},
			{
				"lng": 11.456788148452477,
				"lat": 43.548297272277111
			},
			{
				"lng": 11.456786935156904,
				"lat": 43.548295620297175
			},
			{
				"lng": 11.456785713026814,
				"lat": 43.548293958602095
			},
			{
				"lng": 11.45678448218923,
				"lat": 43.548292287440439
			},
			{
				"lng": 11.456783242771291,
				"lat": 43.548290607060459
			},
			{
				"lng": 11.456781994900014,
				"lat": 43.5482889177107
			},
			{
				"lng": 11.456780738702435,
				"lat": 43.548287219639484
			},
			{
				"lng": 11.456779474305659,
				"lat": 43.548285513095344
			},
			{
				"lng": 11.456778201836764,
				"lat": 43.54828379832658
			},
			{
				"lng": 11.456776921422732,
				"lat": 43.548282075581668
			},
			{
				"lng": 11.456775633190702,
				"lat": 43.548280345108992
			},
			{
				"lng": 11.45677433726769,
				"lat": 43.548278607157002
			},
			{
				"lng": 11.456773033780802,
				"lat": 43.548276861974124
			},
			{
				"lng": 11.456771722857038,
				"lat": 43.548275109808671
			},
			{
				"lng": 11.456770404623507,
				"lat": 43.548273350909163
			},
			{
				"lng": 11.45676907920727,
				"lat": 43.548271585523999
			},
			{
				"lng": 11.456767746735359,
				"lat": 43.548269813901591
			},
			{
				"lng": 11.45676640733484,
				"lat": 43.54826803629031
			},
			{
				"lng": 11.456765061132778,
				"lat": 43.548266252938639
			},
			{
				"lng": 11.456763708256252,
				"lat": 43.548264464094991
			},
			{
				"lng": 11.456762348832292,
				"lat": 43.548262670007674
			},
			{
				"lng": 11.456760982987976,
				"lat": 43.548260870925233
			},
			{
				"lng": 11.456759610850382,
				"lat": 43.548259067096076
			},
			{
				"lng": 11.456756848203476,
				"lat": 43.54825544619105
			},
			{
				"lng": 11.456754061908169,
				"lat": 43.548251809280003
			},
			{
				"lng": 11.456751252980826,
				"lat": 43.548248158350269
			},
			{
				"lng": 11.456748422438013,
				"lat": 43.548244495389135
			},
			{
				"lng": 11.456745571296183,
				"lat": 43.548240822383946
			},
			{
				"lng": 11.456742700571839,
				"lat": 43.548237141322083
			},
			{
				"lng": 11.456739811281416,
				"lat": 43.548233454190814
			},
			{
				"lng": 11.456736904441462,
				"lat": 43.548229762977464
			},
			{
				"lng": 11.456733981068377,
				"lat": 43.548226069669369
			},
			{
				"lng": 11.456731042178685,
				"lat": 43.548222376253854
			},
			{
				"lng": 11.456728088788855,
				"lat": 43.548218684718293
			},
			{
				"lng": 11.45672512191536,
				"lat": 43.548214997049961
			},
			{
				"lng": 11.456722142574709,
				"lat": 43.548211315236244
			},
			{
				"lng": 11.456719151783357,
				"lat": 43.548207641264447
			},
			{
				"lng": 11.456716150557737,
				"lat": 43.548203977121823
			},
			{
				"lng": 11.456713139914406,
				"lat": 43.548200324795829
			},
			{
				"lng": 11.456710120869758,
				"lat": 43.54819668627372
			},
			{
				"lng": 11.456707094440331,
				"lat": 43.548193063542818
			},
			{
				"lng": 11.456704061642572,
				"lat": 43.548189458590521
			},
			{
				"lng": 11.456701023492954,
				"lat": 43.548185873404037
			},
			{
				"lng": 11.45669798100797,
				"lat": 43.548182309970855
			},
			{
				"lng": 11.456694935204023,
				"lat": 43.548178770278142
			},
			{
				"lng": 11.456693411375133,
				"lat": 43.548177009955566
			},
			{
				"lng": 11.456691887097664,
				"lat": 43.548175256313357
			},
			{
				"lng": 11.456690362498712,
				"lat": 43.548173509599948
			},
			{
				"lng": 11.456688837705331,
				"lat": 43.548171770063774
			},
			{
				"lng": 11.456687312844558,
				"lat": 43.548170037953206
			},
			{
				"lng": 11.456685788043487,
				"lat": 43.548168313516726
			},
			{
				"lng": 11.456684263429153,
				"lat": 43.548166597002719
			},
			{
				"lng": 11.456682739128594,
				"lat": 43.548164888659571
			},
			{
				"lng": 11.456681215268913,
				"lat": 43.548163188735742
			},
			{
				"lng": 11.456679691977138,
				"lat": 43.548161497479583
			},
			{
				"lng": 11.456678169380345,
				"lat": 43.54815981513962
			},
			{
				"lng": 11.456676647605606,
				"lat": 43.548158141964208
			},
			{
				"lng": 11.456675126778297,
				"lat": 43.54815647818662
			},
			{
				"lng": 11.456673607008248,
				"lat": 43.548154823894116
			},
			{
				"lng": 11.456672088396372,
				"lat": 43.548153179091713
			},
			{
				"lng": 11.456670571043558,
				"lat": 43.548151543783625
			},
			{
				"lng": 11.456669055050604,
				"lat": 43.548149917974072
			},
			{
				"lng": 11.456667540518463,
				"lat": 43.548148301667226
			},
			{
				"lng": 11.456666027547886,
				"lat": 43.548146694867164
			},
			{
				"lng": 11.456664516239812,
				"lat": 43.548145097578235
			},
			{
				"lng": 11.456663006695093,
				"lat": 43.548143509804504
			},
			{
				"lng": 11.45666149901451,
				"lat": 43.548141931550234
			},
			{
				"lng": 11.456659993299017,
				"lat": 43.548140362819552
			},
			{
				"lng": 11.456658489649412,
				"lat": 43.548138803616716
			},
			{
				"lng": 11.45665698816658,
				"lat": 43.548137253945832
			},
			{
				"lng": 11.456655488951355,
				"lat": 43.548135713811078
			},
			{
				"lng": 11.456653992104622,
				"lat": 43.548134183216696
			},
			{
				"lng": 11.456652497727173,
				"lat": 43.54813266216685
			},
			{
				"lng": 11.456651005919968,
				"lat": 43.548131150665718
			},
			{
				"lng": 11.456649516783788,
				"lat": 43.548129648717492
			},
			{
				"lng": 11.456648030419517,
				"lat": 43.548128156326385
			},
			{
				"lng": 11.456646546928022,
				"lat": 43.548126673496519
			},
			{
				"lng": 11.456645066410131,
				"lat": 43.548125200232143
			},
			{
				"lng": 11.456643588966745,
				"lat": 43.548123736537363
			},
			{
				"lng": 11.456642114698649,
				"lat": 43.548122282416458
			},
			{
				"lng": 11.45664064370677,
				"lat": 43.54812083787354
			},
			{
				"lng": 11.456639176091944,
				"lat": 43.548119402912825
			},
			{
				"lng": 11.456637711955041,
				"lat": 43.548117977538517
			},
			{
				"lng": 11.456636251396864,
				"lat": 43.548116561754789
			},
			{
				"lng": 11.456634794518326,
				"lat": 43.548115155565704
			},
			{
				"lng": 11.456633341420272,
				"lat": 43.548113758975674
			},
			{
				"lng": 11.456631892203587,
				"lat": 43.548112371988708
			},
			{
				"lng": 11.456630446969058,
				"lat": 43.548110994609083
			},
			{
				"lng": 11.456629005817572,
				"lat": 43.54810962684094
			},
			{
				"lng": 11.456627568850028,
				"lat": 43.548108268688459
			},
			{
				"lng": 11.456626136167216,
				"lat": 43.548106920155874
			},
			{
				"lng": 11.456624707870057,
				"lat": 43.548105581247249
			},
			{
				"lng": 11.456623284059342,
				"lat": 43.548104251966961
			},
			{
				"lng": 11.456621864836002,
				"lat": 43.548102932319061
			},
			{
				"lng": 11.45662045030083,
				"lat": 43.548101622307733
			},
			{
				"lng": 11.456619040554724,
				"lat": 43.548100321937227
			},
			{
				"lng": 11.456617635698535,
				"lat": 43.548099031211663
			},
			{
				"lng": 11.456616235833108,
				"lat": 43.548097750135284
			},
			{
				"lng": 11.456614841059295,
				"lat": 43.548096478712168
			},
			{
				"lng": 11.456613451477985,
				"lat": 43.54809521694667
			},
			{
				"lng": 11.456612067190008,
				"lat": 43.548093964842828
			},
			{
				"lng": 11.456610688296207,
				"lat": 43.548092722404917
			},
			{
				"lng": 11.456609314897459,
				"lat": 43.548091489637095
			},
			{
				"lng": 11.456607947094637,
				"lat": 43.548090266543475
			},
			{
				"lng": 11.456606584988593,
				"lat": 43.548089053128393
			},
			{
				"lng": 11.456605228680178,
				"lat": 43.548087849395877
			},
			{
				"lng": 11.456603878270201,
				"lat": 43.548086655350218
			},
			{
				"lng": 11.456602533859598,
				"lat": 43.548085470995517
			},
			{
				"lng": 11.456601195549172,
				"lat": 43.548084296336036
			},
			{
				"lng": 11.456599863439841,
				"lat": 43.548083131375982
			},
			{
				"lng": 11.456598537632383,
				"lat": 43.548081976119427
			},
			{
				"lng": 11.456597218227701,
				"lat": 43.548080830570605
			},
			{
				"lng": 11.456595905326662,
				"lat": 43.548079694733779
			},
			{
				"lng": 11.456594599030081,
				"lat": 43.548078568613036
			},
			{
				"lng": 11.456593299438834,
				"lat": 43.548077452212567
			},
			{
				"lng": 11.456592006653839,
				"lat": 43.548076345536614
			},
			{
				"lng": 11.456590720775873,
				"lat": 43.548075248589342
			},
			{
				"lng": 11.456589441905784,
				"lat": 43.548074161374885
			},
			{
				"lng": 11.456588170144476,
				"lat": 43.548073083897485
			},
			{
				"lng": 11.456586905592811,
				"lat": 43.548072016161278
			},
			{
				"lng": 11.456585648351625,
				"lat": 43.548070958170534
			},
			{
				"lng": 11.456584398521779,
				"lat": 43.548069909929382
			},
			{
				"lng": 11.456583156204138,
				"lat": 43.548068871441998
			},
			{
				"lng": 11.456581921499543,
				"lat": 43.548067842712577
			},
			{
				"lng": 11.456580694508864,
				"lat": 43.548066823745295
			},
			{
				"lng": 11.456579475332973,
				"lat": 43.548065814544373
			},
			{
				"lng": 11.456578264072704,
				"lat": 43.548064815113968
			},
			{
				"lng": 11.456577060828881,
				"lat": 43.548063825458243
			},
			{
				"lng": 11.456575865702424,
				"lat": 43.548062845581391
			},
			{
				"lng": 11.45657467879416,
				"lat": 43.548061875487697
			},
			{
				"lng": 11.456573500204989,
				"lat": 43.548060915181175
			},
			{
				"lng": 11.456572330035659,
				"lat": 43.54805996466613
			},
			{
				"lng": 11.456571168387164,
				"lat": 43.548059023946728
			},
			{
				"lng": 11.456570015360285,
				"lat": 43.548058093027109
			},
			{
				"lng": 11.45656887105587,
				"lat": 43.548057171911523
			},
			{
				"lng": 11.45656773557479,
				"lat": 43.548056260604092
			},
			{
				"lng": 11.456566609017941,
				"lat": 43.548055359109085
			},
			{
				"lng": 11.456565491486129,
				"lat": 43.548054467430575
			},
			{
				"lng": 11.456564383080224,
				"lat": 43.548053585572852
			},
			{
				"lng": 11.456563283901101,
				"lat": 43.548052713540045
			},
			{
				"lng": 11.456562194049608,
				"lat": 43.548051851336311
			},
			{
				"lng": 11.456561113626597,
				"lat": 43.548050998965905
			},
			{
				"lng": 11.456560042732946,
				"lat": 43.548050156432957
			},
			{
				"lng": 11.456558981469495,
				"lat": 43.548049323741729
			},
			{
				"lng": 11.456557929937079,
				"lat": 43.548048500896286
			},
			{
				"lng": 11.45655688823658,
				"lat": 43.54804768790089
			},
			{
				"lng": 11.456555856468869,
				"lat": 43.548046884759749
			},
			{
				"lng": 11.45655483473476,
				"lat": 43.548046091476998
			},
			{
				"lng": 11.456553823135145,
				"lat": 43.5480453080568
			},
			{
				"lng": 11.45655282177089,
				"lat": 43.548044534503404
			},
			{
				"lng": 11.456551830742846,
				"lat": 43.548043770820975
			},
			{
				"lng": 11.456550850151832,
				"lat": 43.548043017013704
			},
			{
				"lng": 11.456549880098763,
				"lat": 43.548042273085777
			},
			{
				"lng": 11.45654892068444,
				"lat": 43.5480415390413
			},
			{
				"lng": 11.456547972009758,
				"lat": 43.548040814884594
			},
			{
				"lng": 11.456547034175554,
				"lat": 43.54804010061973
			},
			{
				"lng": 11.456546107282698,
				"lat": 43.548039396250978
			},
			{
				"lng": 11.456545191432051,
				"lat": 43.548038701782431
			},
			{
				"lng": 11.456544286724462,
				"lat": 43.548038017218403
			},
			{
				"lng": 11.456543393260782,
				"lat": 43.548037342562878
			},
			{
				"lng": 11.456542511141892,
				"lat": 43.548036677820221
			},
			{
				"lng": 11.456541640468629,
				"lat": 43.548036022994623
			},
			{
				"lng": 11.456540781341877,
				"lat": 43.548035378090113
			},
			{
				"lng": 11.456539933862425,
				"lat": 43.548034743111053
			},
			{
				"lng": 11.456539098131197,
				"lat": 43.548034118061473
			},
			{
				"lng": 11.456538274249054,
				"lat": 43.548033502945692
			},
			{
				"lng": 11.456537462316819,
				"lat": 43.548032897767804
			},
			{
				"lng": 11.456536662435317,
				"lat": 43.548032302531993
			},
			{
				"lng": 11.456535874705478,
				"lat": 43.548031717242452
			},
			{
				"lng": 11.45653509922813,
				"lat": 43.548031141903486
			},
			{
				"lng": 11.45653433610415,
				"lat": 43.548030576519125
			},
			{
				"lng": 11.456533585434347,
				"lat": 43.548030021093624
			},
			{
				"lng": 11.456532847318238,
				"lat": 43.548029475630706
			},
			{
				"lng": 11.456532121774494,
				"lat": 43.548028940109887
			},
			{
				"lng": 11.456531408698259,
				"lat": 43.548028414473329
			},
			{
				"lng": 11.456530707974208,
				"lat": 43.548027898660166
			},
			{
				"lng": 11.456530019486989,
				"lat": 43.548027392609484
			},
			{
				"lng": 11.456529343121233,
				"lat": 43.548026896260289
			},
			{
				"lng": 11.45652867876165,
				"lat": 43.548026409551731
			},
			{
				"lng": 11.456528026292865,
				"lat": 43.548025932422902
			},
			{
				"lng": 11.456527385599571,
				"lat": 43.54802546481281
			},
			{
				"lng": 11.456526756566417,
				"lat": 43.548025006660623
			},
			{
				"lng": 11.456526139078074,
				"lat": 43.548024557905372
			},
			{
				"lng": 11.4565255330192,
				"lat": 43.548024118486133
			},
			{
				"lng": 11.456524938274455,
				"lat": 43.548023688342028
			},
			{
				"lng": 11.456524354728479,
				"lat": 43.548023267412148
			},
			{
				"lng": 11.456523782265961,
				"lat": 43.548022855635502
			},
			{
				"lng": 11.456523220771563,
				"lat": 43.548022452951223
			},
			{
				"lng": 11.456522670129944,
				"lat": 43.548022059298383
			},
			{
				"lng": 11.456522130225803,
				"lat": 43.548021674616109
			},
			{
				"lng": 11.456521600943724,
				"lat": 43.548021298843388
			},
			{
				"lng": 11.456521082168415,
				"lat": 43.548020931919375
			},
			{
				"lng": 11.456520573784559,
				"lat": 43.548020573783084
			},
			{
				"lng": 11.456520075676782,
				"lat": 43.548020224373708
			},
			{
				"lng": 11.456519587729776,
				"lat": 43.548019883630204
			},
			{
				"lng": 11.456519109828184,
				"lat": 43.548019551491798
			},
			{
				"lng": 11.456518641856668,
				"lat": 43.548019227897434
			},
			{
				"lng": 11.456518183699892,
				"lat": 43.548018912786205
			},
			{
				"lng": 11.45651773524253,
				"lat": 43.548018606097301
			},
			{
				"lng": 11.45651729636924,
				"lat": 43.548018307769738
			},
			{
				"lng": 11.456516866964678,
				"lat": 43.548018017742564
			},
			{
				"lng": 11.456516446913501,
				"lat": 43.548017735954929
			},
			{
				"lng": 11.456516036100426,
				"lat": 43.548017462345818
			},
			{
				"lng": 11.456515634410053,
				"lat": 43.548017196854431
			},
			{
				"lng": 11.456515241727052,
				"lat": 43.548016939419782
			},
			{
				"lng": 11.456514857936092,
				"lat": 43.54801668998099
			},
			{
				"lng": 11.456514482921859,
				"lat": 43.548016448477114
			},
			{
				"lng": 11.456514116569,
				"lat": 43.548016214847223
			},
			{
				"lng": 11.456513758762183,
				"lat": 43.548015989030382
			},
			{
				"lng": 11.456513409386037,
				"lat": 43.548015770965733
			},
			{
				"lng": 11.456513068325295,
				"lat": 43.548015560592383
			},
			{
				"lng": 11.456512735464582,
				"lat": 43.548015357849202
			},
			{
				"lng": 11.456512410688521,
				"lat": 43.548015162675547
			},
			{
				"lng": 11.456512093881818,
				"lat": 43.548014975010361
			},
			{
				"lng": 11.456511784929154,
				"lat": 43.548014794792735
			},
			{
				"lng": 11.456511483715166,
				"lat": 43.548014621961791
			},
			{
				"lng": 11.456511190124491,
				"lat": 43.548014456456549
			},
			{
				"lng": 11.456510904041846,
				"lat": 43.548014298216096
			},
			{
				"lng": 11.456510625351846,
				"lat": 43.548014147179593
			},
			{
				"lng": 11.456510353939183,
				"lat": 43.548014003286035
			},
			{
				"lng": 11.456510089688523,
				"lat": 43.548013866474562
			},
			{
				"lng": 11.456509832484498,
				"lat": 43.548013736684247
			},
			{
				"lng": 11.456509582211826,
				"lat": 43.548013613854138
			},
			{
				"lng": 11.456509338755154,
				"lat": 43.548013497923307
			},
			{
				"lng": 11.456509101999078,
				"lat": 43.548013388830874
			},
			{
				"lng": 11.456508871828337,
				"lat": 43.548013286515967
			},
			{
				"lng": 11.456508648127553,
				"lat": 43.548013190917565
			},
			{
				"lng": 11.456508430781401,
				"lat": 43.548013101974796
			},
			{
				"lng": 11.456508219674562,
				"lat": 43.548013019626751
			},
			{
				"lng": 11.456508014691675,
				"lat": 43.548012943812509
			},
			{
				"lng": 11.456507815717423,
				"lat": 43.548012874471162
			},
			{
				"lng": 11.45650762263644,
				"lat": 43.548012811541732
			},
			{
				"lng": 11.456507435333414,
				"lat": 43.54801275496343
			},
			{
				"lng": 11.456507253693024,
				"lat": 43.548012704675145
			},
			{
				"lng": 11.456507077599909,
				"lat": 43.548012660616145
			},
			{
				"lng": 11.456506906938728,
				"lat": 43.548012622725388
			},
			{
				"lng": 11.456506741594131,
				"lat": 43.548012590942029
			},
			{
				"lng": 11.456506581450803,
				"lat": 43.548012565205148
			},
			{
				"lng": 11.456506426393407,
				"lat": 43.548012545453709
			},
			{
				"lng": 11.456506276306627,
				"lat": 43.548012531626952
			},
			{
				"lng": 11.456506131075079,
				"lat": 43.548012523663914
			},
			{
				"lng": 11.456505990583462,
				"lat": 43.548012521503637
			},
			{
				"lng": 11.456505854716434,
				"lat": 43.548012525085198
			},
			{
				"lng": 11.456505596394756,
				"lat": 43.548012549230258
			},
			{
				"lng": 11.456505355187359,
				"lat": 43.548012595611752
			},
			{
				"lng": 11.456505130171584,
				"lat": 43.548012663742355
			},
			{
				"lng": 11.45650492042469,
				"lat": 43.548012753134678
			},
			{
				"lng": 11.456504725023999,
				"lat": 43.548012863301388
			},
			{
				"lng": 11.456504543046844,
				"lat": 43.548012993755187
			},
			{
				"lng": 11.456504373570443,
				"lat": 43.5480131440086
			},
			{
				"lng": 11.456504215672233,
				"lat": 43.548013313574408
			},
			{
				"lng": 11.456504068429437,
				"lat": 43.548013501965251
			},
			{
				"lng": 11.456503930919354,
				"lat": 43.548013708693752
			},
			{
				"lng": 11.456503802219338,
				"lat": 43.548013933272514
			},
			{
				"lng": 11.456503681406684,
				"lat": 43.54801417521432
			},
			{
				"lng": 11.456503567558627,
				"lat": 43.548014434031764
			},
			{
				"lng": 11.456503459752556,
				"lat": 43.548014709237414
			},
			{
				"lng": 11.456503357065762,
				"lat": 43.548015000344051
			},
			{
				"lng": 11.456503258575523,
				"lat": 43.548015306864258
			},
			{
				"lng": 11.456503163359175,
				"lat": 43.548015628310722
			},
			{
				"lng": 11.456503070493978,
				"lat": 43.54801596419604
			},
			{
				"lng": 11.456502979057264,
				"lat": 43.548016314032985
			},
			{
				"lng": 11.456502888126364,
				"lat": 43.548016677334076
			},
			{
				"lng": 11.456502796778576,
				"lat": 43.548017053612057
			},
			{
				"lng": 11.45650270409118,
				"lat": 43.54801744237956
			},
			{
				"lng": 11.456502609157392,
				"lat": 43.548017843156018
			},
			{
				"lng": 11.456502511474897,
				"lat": 43.54801825563306
			},
			{
				"lng": 11.456502410968925,
				"lat": 43.548018679684503
			},
			{
				"lng": 11.45650230758501,
				"lat": 43.548019115192687
			},
			{
				"lng": 11.456502201268918,
				"lat": 43.548019562040196
			},
			{
				"lng": 11.456502091966209,
				"lat": 43.548020020109391
			},
			{
				"lng": 11.456501979622518,
				"lat": 43.548020489282742
			},
			{
				"lng": 11.456501864183521,
				"lat": 43.548020969442675
			},
			{
				"lng": 11.456501745594847,
				"lat": 43.548021460471745
			},
			{
				"lng": 11.45650162380212,
				"lat": 43.548021962252243
			},
			{
				"lng": 11.456501498751001,
				"lat": 43.548022474666695
			},
			{
				"lng": 11.456501370387111,
				"lat": 43.548022997597563
			},
			{
				"lng": 11.456501238656132,
				"lat": 43.548023530927289
			},
			{
				"lng": 11.456501103503667,
				"lat": 43.548024074538333
			},
			{
				"lng": 11.456500964875323,
				"lat": 43.548024628313094
			},
			{
				"lng": 11.456500822716826,
				"lat": 43.548025192134048
			},
			{
				"lng": 11.456500676973777,
				"lat": 43.548025765883693
			},
			{
				"lng": 11.456500527591773,
				"lat": 43.548026349444392
			},
			{
				"lng": 11.456500374516503,
				"lat": 43.548026942698691
			},
			{
				"lng": 11.456500217693627,
				"lat": 43.548027545528925
			},
			{
				"lng": 11.45650005706875,
				"lat": 43.548028157817654
			},
			{
				"lng": 11.456499892587487,
				"lat": 43.548028779447257
			},
			{
				"lng": 11.456499724195501,
				"lat": 43.548029410300174
			},
			{
				"lng": 11.456499551838455,
				"lat": 43.548030050258951
			},
			{
				"lng": 11.456499375461984,
				"lat": 43.548030699205945
			},
			{
				"lng": 11.456499195011718,
				"lat": 43.548031357023618
			},
			{
				"lng": 11.456499010433294,
				"lat": 43.548032023594459
			},
			{
				"lng": 11.456498821672344,
				"lat": 43.548032698800888
			},
			{
				"lng": 11.456498628674524,
				"lat": 43.548033382525311
			},
			{
				"lng": 11.456498431385443,
				"lat": 43.548034074650289
			},
			{
				"lng": 11.4564982297508,
				"lat": 43.548034775058134
			},
			{
				"lng": 11.456498023716188,
				"lat": 43.548035483631416
			},
			{
				"lng": 11.456497813227287,
				"lat": 43.548036200252533
			},
			{
				"lng": 11.456497598229713,
				"lat": 43.548036924803945
			},
			{
				"lng": 11.456497378669077,
				"lat": 43.548037657168059
			},
			{
				"lng": 11.456497154491061,
				"lat": 43.548038397227408
			},
			{
				"lng": 11.456496925641284,
				"lat": 43.548039144864347
			},
			{
				"lng": 11.4564966920654,
				"lat": 43.548039899961381
			},
			{
				"lng": 11.45649645370905,
				"lat": 43.548040662400972
			},
			{
				"lng": 11.456496210517869,
				"lat": 43.548041432065496
			},
			{
				"lng": 11.456495962437478,
				"lat": 43.548042208837522
			},
			{
				"lng": 11.456495709413542,
				"lat": 43.54804299259937
			},
			{
				"lng": 11.456495451391705,
				"lat": 43.548043783233545
			},
			{
				"lng": 11.456495188317559,
				"lat": 43.548044580622552
			},
			{
				"lng": 11.456494920136825,
				"lat": 43.548045384648766
			},
			{
				"lng": 11.456494646795088,
				"lat": 43.548046195194601
			},
			{
				"lng": 11.456494368237985,
				"lat": 43.548047012142604
			},
			{
				"lng": 11.456494084411188,
				"lat": 43.548047835375243
			},
			{
				"lng": 11.456493795260295,
				"lat": 43.548048664774825
			},
			{
				"lng": 11.456493500730984,
				"lat": 43.548049500223918
			},
			{
				"lng": 11.456493200768879,
				"lat": 43.54805034160492
			},
			{
				"lng": 11.456492895319634,
				"lat": 43.548051188800329
			},
			{
				"lng": 11.456492584328853,
				"lat": 43.548052041692586
			},
			{
				"lng": 11.45649226774224,
				"lat": 43.548052900164038
			},
			{
				"lng": 11.456491945505377,
				"lat": 43.548053764097226
			},
			{
				"lng": 11.456491617563897,
				"lat": 43.548054633374655
			},
			{
				"lng": 11.456491283863498,
				"lat": 43.54805550787863
			},
			{
				"lng": 11.456490944349779,
				"lat": 43.548056387491698
			},
			{
				"lng": 11.456490598983819,
				"lat": 43.548057272088471
			},
			{
				"lng": 11.456489891067731,
				"lat": 43.548059055464449
			},
			{
				"lng": 11.456489161135066,
				"lat": 43.54806085633016
			},
			{
				"lng": 11.45648841026161,
				"lat": 43.548062672980876
			},
			{
				"lng": 11.456487639523177,
				"lat": 43.548064503711878
			},
			{
				"lng": 11.456486849995573,
				"lat": 43.548066346818423
			},
			{
				"lng": 11.456486042754589,
				"lat": 43.548068200595786
			},
			{
				"lng": 11.456485218875985,
				"lat": 43.548070063339239
			},
			{
				"lng": 11.456484379435619,
				"lat": 43.548071933344026
			},
			{
				"lng": 11.456483525509224,
				"lat": 43.5480738089055
			},
			{
				"lng": 11.456482658172632,
				"lat": 43.548075688318931
			},
			{
				"lng": 11.456481778501642,
				"lat": 43.548077569879496
			},
			{
				"lng": 11.456480887572033,
				"lat": 43.548079451882572
			},
			{
				"lng": 11.456479986459593,
				"lat": 43.548081332623376
			},
			{
				"lng": 11.456479076240178,
				"lat": 43.548083210397188
			},
			{
				"lng": 11.456478157989499,
				"lat": 43.548085083499274
			},
			{
				"lng": 11.456477232783415,
				"lat": 43.548086950224985
			},
			{
				"lng": 11.456476301697712,
				"lat": 43.548088808869487
			},
			{
				"lng": 11.456475365808172,
				"lat": 43.548090657728096
			},
			{
				"lng": 11.45647442619063,
				"lat": 43.548092495096121
			},
			{
				"lng": 11.456473483920821,
				"lat": 43.548094319268834
			},
			{
				"lng": 11.456472540074609,
				"lat": 43.548096128541459
			},
			{
				"lng": 11.456471595727749,
				"lat": 43.548097921209319
			},
			{
				"lng": 11.45647065195608,
				"lat": 43.548099695567686
			},
			{
				"lng": 11.456469709835352,
				"lat": 43.548101449911783
			},
			{
				"lng": 11.45646877044139,
				"lat": 43.54810318253692
			},
			{
				"lng": 11.45646783485001,
				"lat": 43.548104891738411
			},
			{
				"lng": 11.456467368816469,
				"lat": 43.548105737022532
			},
			{
				"lng": 11.456466904137015,
				"lat": 43.548106575811445
			},
			{
				"lng": 11.456466440946071,
				"lat": 43.548107407892132
			},
			{
				"lng": 11.456465979378162,
				"lat": 43.548108233051401
			},
			{
				"lng": 11.456465519567713,
				"lat": 43.548109051076288
			},
			{
				"lng": 11.456465061603563,
				"lat": 43.548109861837965
			},
			{
				"lng": 11.456464605438585,
				"lat": 43.548110665459241
			},
			{
				"lng": 11.456464151000329,
				"lat": 43.548111462109482
			},
			{
				"lng": 11.456463698216396,
				"lat": 43.548112251958031
			},
			{
				"lng": 11.456463247014392,
				"lat": 43.548113035174374
			},
			{
				"lng": 11.456462349066399,
				"lat": 43.548114582387903
			},
			{
				"lng": 11.456461456577035,
				"lat": 43.548116105105208
			},
			{
				"lng": 11.456460568966953,
				"lat": 43.548117604681487
			},
			{
				"lng": 11.456459685656844,
				"lat": 43.548119082471985
			},
			{
				"lng": 11.456458806067417,
				"lat": 43.548120539831842
			},
			{
				"lng": 11.456457929619253,
				"lat": 43.548121978116257
			},
			{
				"lng": 11.456457055733116,
				"lat": 43.548123398680474
			},
			{
				"lng": 11.456456183829649,
				"lat": 43.548124802879649
			},
			{
				"lng": 11.456455313329474,
				"lat": 43.548126192068942
			},
			{
				"lng": 11.456454443653328,
				"lat": 43.54812756760365
			},
			{
				"lng": 11.456453574221822,
				"lat": 43.54812893083885
			},
			{
				"lng": 11.456452704455666,
				"lat": 43.548130283129801
			},
			{
				"lng": 11.456451833775542,
				"lat": 43.548131625831701
			},
			{
				"lng": 11.456450961602094,
				"lat": 43.548132960299675
			},
			{
				"lng": 11.456450087355966,
				"lat": 43.54813428788902
			},
			{
				"lng": 11.456448330328492,
				"lat": 43.548136927852376
			},
			{
				"lng": 11.456446558058444,
				"lat": 43.548139556563299
			},
			{
				"lng": 11.456444765911195,
				"lat": 43.548142184863387
			},
			{
				"lng": 11.456442949252121,
				"lat": 43.548144823594178
			},
			{
				"lng": 11.456442030282277,
				"lat": 43.548146150259051
			},
			{
				"lng": 11.456441103446503,
				"lat": 43.548147483597212
			},
			{
				"lng": 11.456440168165461,
				"lat": 43.548148824963803
			},
			{
				"lng": 11.456439223897879,
				"lat": 43.548150175618126
			},
			{
				"lng": 11.456438270490203,
				"lat": 43.548151535843978
			},
			{
				"lng": 11.45643730801493,
				"lat": 43.548152905356254
			},
			{
				"lng": 11.456436336547364,
				"lat": 43.548154283862658
			},
			{
				"lng": 11.456435356162828,
				"lat": 43.548155671070873
			},
			{
				"lng": 11.456434366936662,
				"lat": 43.548157066688731
			},
			{
				"lng": 11.456433368944152,
				"lat": 43.548158470423871
			},
			{
				"lng": 11.456432362260617,
				"lat": 43.54815988198412
			},
			{
				"lng": 11.456431346961436,
				"lat": 43.548161301077151
			},
			{
				"lng": 11.456430323121866,
				"lat": 43.54816272741072
			},
			{
				"lng": 11.456429290817262,
				"lat": 43.548164160692494
			},
			{
				"lng": 11.456428250122922,
				"lat": 43.548165600630362
			},
			{
				"lng": 11.456427201114192,
				"lat": 43.548167046931958
			},
			{
				"lng": 11.456426143866372,
				"lat": 43.548168499305014
			},
			{
				"lng": 11.456425078454776,
				"lat": 43.548169957457318
			},
			{
				"lng": 11.456424004954778,
				"lat": 43.548171421096562
			},
			{
				"lng": 11.456422923441618,
				"lat": 43.548172889930491
			},
			{
				"lng": 11.456421833990646,
				"lat": 43.54817436366676
			},
			{
				"lng": 11.456420736677238,
				"lat": 43.548175842013315
			},
			{
				"lng": 11.456419631576631,
				"lat": 43.548177324677688
			},
			{
				"lng": 11.456418518764179,
				"lat": 43.548178811367677
			},
			{
				"lng": 11.45641627030507,
				"lat": 43.548181795655552
			},
			{
				"lng": 11.456413991902423,
				"lat": 43.54818479253877
			},
			{
				"lng": 11.456411684158871,
				"lat": 43.548187799679219
			},
			{
				"lng": 11.456409347676901,
				"lat": 43.548190814738732
			},
			{
				"lng": 11.456406983961287,
				"lat": 43.548193834514564
			},
			{
				"lng": 11.456404598977123,
				"lat": 43.548196851528687
			},
			{
				"lng": 11.456402200065426,
				"lat": 43.548199856984425
			},
			{
				"lng": 11.456399794567631,
				"lat": 43.548202842084414
			},
			{
				"lng": 11.4563985916432,
				"lat": 43.548204324252019
			},
			{
				"lng": 11.456397389825247,
				"lat": 43.548205798031795
			},
			{
				"lng": 11.456396190031514,
				"lat": 43.548207262323999
			},
			{
				"lng": 11.456394993179634,
				"lat": 43.548208716029073
			},
			{
				"lng": 11.456393800187357,
				"lat": 43.548210158047446
			},
			{
				"lng": 11.456392611972309,
				"lat": 43.548211587279376
			},
			{
				"lng": 11.456391429452182,
				"lat": 43.548213002625218
			},
			{
				"lng": 11.456390253544672,
				"lat": 43.548214402985323
			},
			{
				"lng": 11.456389085167444,
				"lat": 43.548215787260176
			},
			{
				"lng": 11.456387925238213,
				"lat": 43.548217154349963
			},
			{
				"lng": 11.4563867746746,
				"lat": 43.54821850315512
			},
			{
				"lng": 11.456385634394321,
				"lat": 43.548219832575953
			},
			{
				"lng": 11.456384505315102,
				"lat": 43.548221141512947
			},
			{
				"lng": 11.456383388354558,
				"lat": 43.548222428866318
			},
			{
				"lng": 11.456382284430397,
				"lat": 43.548223693536457
			},
			{
				"lng": 11.456381737643746,
				"lat": 43.548224317021713
			},
			{
				"lng": 11.456381194460304,
				"lat": 43.548224934423736
			},
			{
				"lng": 11.456380654994806,
				"lat": 43.548225545605199
			},
			{
				"lng": 11.456380119361976,
				"lat": 43.548226150428576
			},
			{
				"lng": 11.45637958767648,
				"lat": 43.548226748756399
			},
			{
				"lng": 11.456379060053061,
				"lat": 43.548227340451199
			},
			{
				"lng": 11.456378536606389,
				"lat": 43.548227925375627
			},
			{
				"lng": 11.456378017451241,
				"lat": 43.548228503392046
			},
			{
				"lng": 11.456377502702312,
				"lat": 43.548229074363192
			},
			{
				"lng": 11.456376992474247,
				"lat": 43.548229638151483
			},
			{
				"lng": 11.456376486881803,
				"lat": 43.548230194619492
			},
			{
				"lng": 11.456375986039742,
				"lat": 43.548230743629837
			},
			{
				"lng": 11.456375490028242,
				"lat": 43.548231285092179
			},
			{
				"lng": 11.456374998801058,
				"lat": 43.548231819090155
			},
			{
				"lng": 11.456374512282773,
				"lat": 43.548232345747202
			},
			{
				"lng": 11.456374030398083,
				"lat": 43.548232865186726
			},
			{
				"lng": 11.456373553071554,
				"lat": 43.548233377532206
			},
			{
				"lng": 11.456373080227776,
				"lat": 43.548233882907091
			},
			{
				"lng": 11.456372611791423,
				"lat": 43.548234381434739
			},
			{
				"lng": 11.456372147687096,
				"lat": 43.548234873238712
			},
			{
				"lng": 11.456371687839386,
				"lat": 43.548235358442341
			},
			{
				"lng": 11.456371232172964,
				"lat": 43.548235837169187
			},
			{
				"lng": 11.456370780612415,
				"lat": 43.548236309542588
			},
			{
				"lng": 11.456370333082361,
				"lat": 43.548236775686036
			},
			{
				"lng": 11.456369889507448,
				"lat": 43.548237235722993
			},
			{
				"lng": 11.456369449812263,
				"lat": 43.548237689776812
			},
			{
				"lng": 11.456368581759584,
				"lat": 43.548238580429121
			},
			{
				"lng": 11.456367728321291,
				"lat": 43.548239448630326
			},
			{
				"lng": 11.45636688889434,
				"lat": 43.548240295368139
			},
			{
				"lng": 11.456366062875727,
				"lat": 43.548241121630099
			},
			{
				"lng": 11.456365249662337,
				"lat": 43.54824192840362
			},
			{
				"lng": 11.456364448651174,
				"lat": 43.548242716676391
			},
			{
				"lng": 11.456363659239178,
				"lat": 43.548243487435847
			},
			{
				"lng": 11.456362880823326,
				"lat": 43.548244241669579
			},
			{
				"lng": 11.456362112800521,
				"lat": 43.548244980365105
			},
			{
				"lng": 11.456361354567747,
				"lat": 43.548245704510016
			},
			{
				"lng": 11.456360605521972,
				"lat": 43.54824641509181
			},
			{
				"lng": 11.456359865060135,
				"lat": 43.548247113098043
			},
			{
				"lng": 11.456359132579205,
				"lat": 43.548247799516204
			},
			{
				"lng": 11.456358407476088,
				"lat": 43.548248475333914
			},
			{
				"lng": 11.456357689147813,
				"lat": 43.548249141538705
			},
			{
				"lng": 11.456356976991257,
				"lat": 43.548249799118089
			},
			{
				"lng": 11.45635627040344,
				"lat": 43.548250449059651
			},
			{
				"lng": 11.456355568781285,
				"lat": 43.548251092350917
			},
			{
				"lng": 11.456354178021806,
				"lat": 43.548252362932615
			},
			{
				"lng": 11.456352799889029,
				"lat": 43.548253618762672
			},
			{
				"lng": 11.456351430920792,
				"lat": 43.548254865901981
			},
			{
				"lng": 11.45635007188867,
				"lat": 43.548256104693692
			},
			{
				"lng": 11.456348724384718,
				"lat": 43.548257334372842
			},
			{
				"lng": 11.456347390001103,
				"lat": 43.548258554174595
			},
			{
				"lng": 11.456346070329914,
				"lat": 43.548259763333981
			},
			{
				"lng": 11.456344766963245,
				"lat": 43.548260961086079
			},
			{
				"lng": 11.456343481493269,
				"lat": 43.548262146665927
			},
			{
				"lng": 11.456342215512093,
				"lat": 43.548263319308703
			},
			{
				"lng": 11.456340970611762,
				"lat": 43.54826447824933
			},
			{
				"lng": 11.456339748384474,
				"lat": 43.548265622723022
			},
			{
				"lng": 11.45633855042232,
				"lat": 43.548266751964874
			},
			{
				"lng": 11.456337378317389,
				"lat": 43.548267865209809
			},
			{
				"lng": 11.456336802458942,
				"lat": 43.5482684155944
			},
			{
				"lng": 11.456336233661858,
				"lat": 43.548268961693047
			},
			{
				"lng": 11.456335672125125,
				"lat": 43.548269503409898
			},
			{
				"lng": 11.456335118047777,
				"lat": 43.548270040649541
			},
			{
				"lng": 11.456334571628394,
				"lat": 43.548270573315413
			},
			{
				"lng": 11.456334033035464,
				"lat": 43.548271101257114
			},
			{
				"lng": 11.456333502389839,
				"lat": 43.548271624238261
			},
			{
				"lng": 11.456332979808117,
				"lat": 43.548272142015023
			},
			{
				"lng": 11.456332465406886,
				"lat": 43.548272654343393
			},
			{
				"lng": 11.456331959302771,
				"lat": 43.54827316097942
			},
			{
				"lng": 11.456331461612388,
				"lat": 43.548273661679247
			},
			{
				"lng": 11.45633097245226,
				"lat": 43.548274156198872
			},
			{
				"lng": 11.456330491939005,
				"lat": 43.548274644294366
			},
			{
				"lng": 11.456330020189274,
				"lat": 43.54827512572178
			},
			{
				"lng": 11.456329557319634,
				"lat": 43.548275600237254
			},
			{
				"lng": 11.456329103446665,
				"lat": 43.548276067596809
			},
			{
				"lng": 11.456328658686949,
				"lat": 43.548276527556432
			},
			{
				"lng": 11.456328223157143,
				"lat": 43.54827697987227
			},
			{
				"lng": 11.456327796973767,
				"lat": 43.548277424300345
			},
			{
				"lng": 11.456327380253482,
				"lat": 43.548277860596762
			},
			{
				"lng": 11.45632697311285,
				"lat": 43.548278288517565
			},
			{
				"lng": 11.456326575668479,
				"lat": 43.548278707818817
			},
			{
				"lng": 11.456326188036973,
				"lat": 43.548279118256559
			},
			{
				"lng": 11.456325810334926,
				"lat": 43.54827951958687
			},
			{
				"lng": 11.456325442678898,
				"lat": 43.548279911565885
			},
			{
				"lng": 11.456325085185544,
				"lat": 43.548280293949546
			},
			{
				"lng": 11.456324737971421,
				"lat": 43.548280666493959
			},
			{
				"lng": 11.456324401153163,
				"lat": 43.548281028955223
			},
			{
				"lng": 11.456324074847306,
				"lat": 43.54828138108936
			},
			{
				"lng": 11.456323759170481,
				"lat": 43.54828172265244
			},
			{
				"lng": 11.456323454239303,
				"lat": 43.548282053400555
			},
			{
				"lng": 11.456323160170339,
				"lat": 43.548282373089719
			},
			{
				"lng": 11.456322877080195,
				"lat": 43.548282681476067
			},
			{
				"lng": 11.456322605077023,
				"lat": 43.548282978329844
			},
			{
				"lng": 11.456322344053286,
				"lat": 43.548283263783894
			},
			{
				"lng": 11.456322093673728,
				"lat": 43.548283538354106
			},
			{
				"lng": 11.456321853592117,
				"lat": 43.548283802574673
			},
			{
				"lng": 11.45632162346217,
				"lat": 43.548284056979867
			},
			{
				"lng": 11.456321402937728,
				"lat": 43.548284302103852
			},
			{
				"lng": 11.456321191672558,
				"lat": 43.548284538481013
			},
			{
				"lng": 11.4563209893204,
				"lat": 43.548284766645381
			},
			{
				"lng": 11.456320795535069,
				"lat": 43.548284987131375
			},
			{
				"lng": 11.456320609970359,
				"lat": 43.548285200473124
			},
			{
				"lng": 11.456320432279961,
				"lat": 43.548285407204936
			},
			{
				"lng": 11.456320262117714,
				"lat": 43.548285607860898
			},
			{
				"lng": 11.456320099137374,
				"lat": 43.548285802975435
			},
			{
				"lng": 11.456319793337562,
				"lat": 43.548286178716793
			},
			{
				"lng": 11.456319512110714,
				"lat": 43.548286538702882
			},
			{
				"lng": 11.456319252687027,
				"lat": 43.548286887207567
			},
			{
				"lng": 11.456319012296666,
				"lat": 43.548287228504655
			},
			{
				"lng": 11.456318788169931,
				"lat": 43.548287566868176
			},
			{
				"lng": 11.456318577536953,
				"lat": 43.548287906571836
			},
			{
				"lng": 11.456318377627923,
				"lat": 43.548288251889531
			},
			{
				"lng": 11.456318185673103,
				"lat": 43.548288607095202
			},
			{
				"lng": 11.45631799914703,
				"lat": 43.548288975990729
			},
			{
				"lng": 11.456317817235645,
				"lat": 43.548289359073422
			},
			{
				"lng": 11.456317639856186,
				"lat": 43.548289755428144
			},
			{
				"lng": 11.456317466928713,
				"lat": 43.548290164134599
			},
			{
				"lng": 11.456317298373236,
				"lat": 43.548290584272337
			},
			{
				"lng": 11.456317134109792,
				"lat": 43.548291014920991
			},
			{
				"lng": 11.456316974058437,
				"lat": 43.548291455160225
			},
			{
				"lng": 11.456316818139133,
				"lat": 43.548291904069522
			},
			{
				"lng": 11.456316666272006,
				"lat": 43.548292360728638
			},
			{
				"lng": 11.456316518377019,
				"lat": 43.548292824217057
			},
			{
				"lng": 11.456316374374246,
				"lat": 43.548293293614471
			},
			{
				"lng": 11.456316097725392,
				"lat": 43.548294246454695
			},
			{
				"lng": 11.456315835704466,
				"lat": 43.548295211948215
			},
			{
				"lng": 11.45631571077298,
				"lat": 43.54829569976642
			},
			{
				"lng": 11.456315591810911,
				"lat": 43.548296196438699
			},
			{
				"lng": 11.456315480572128,
				"lat": 43.548296707117309
			},
			{
				"lng": 11.456315378810523,
				"lat": 43.548297236954411
			},
			{
				"lng": 11.456315332031723,
				"lat": 43.548297510667481
			},
			{
				"lng": 11.456315288279898,
				"lat": 43.548297791102307
			},
			{
				"lng": 11.456315247774297,
				"lat": 43.548298078902853
			},
			{
				"lng": 11.456315210734132,
				"lat": 43.54829837471317
			},
			{
				"lng": 11.456315177378672,
				"lat": 43.548298679177286
			},
			{
				"lng": 11.456315147927134,
				"lat": 43.548298992939223
			},
			{
				"lng": 11.456315122598719,
				"lat": 43.548299316643039
			},
			{
				"lng": 11.456315101612701,
				"lat": 43.548299650932691
			},
			{
				"lng": 11.456315085188319,
				"lat": 43.548299996452293
			},
			{
				"lng": 11.456315073544761,
				"lat": 43.548300353845811
			},
			{
				"lng": 11.45631506690127,
				"lat": 43.548300723757286
			},
			{
				"lng": 11.45631506547714,
				"lat": 43.548301106830763
			},
			{
				"lng": 11.456315069491518,
				"lat": 43.548301503710299
			},
			{
				"lng": 11.456315079163675,
				"lat": 43.548301915039843
			},
			{
				"lng": 11.45631509471286,
				"lat": 43.548302341463476
			},
			{
				"lng": 11.456315116358303,
				"lat": 43.548302783625225
			},
			{
				"lng": 11.456315144319218,
				"lat": 43.548303242169126
			},
			{
				"lng": 11.456315178814849,
				"lat": 43.548303717739088
			},
			{
				"lng": 11.456315220064408,
				"lat": 43.548304210979332
			},
			{
				"lng": 11.45631526828714,
				"lat": 43.548304722533771
			},
			{
				"lng": 11.456315323637943,
				"lat": 43.548305252819979
			},
			{
				"lng": 11.456315385966599,
				"lat": 43.548305801182387
			},
			{
				"lng": 11.456315455032753,
				"lat": 43.548306366648021
			},
			{
				"lng": 11.456315530595962,
				"lat": 43.548306948243777
			},
			{
				"lng": 11.456315612415876,
				"lat": 43.548307544996661
			},
			{
				"lng": 11.456315700251963,
				"lat": 43.548308155933491
			},
			{
				"lng": 11.45631579386391,
				"lat": 43.548308780081314
			},
			{
				"lng": 11.456315893011306,
				"lat": 43.548309416466964
			},
			{
				"lng": 11.456315997453686,
				"lat": 43.548310064117395
			},
			{
				"lng": 11.456316106950696,
				"lat": 43.548310722059583
			},
			{
				"lng": 11.456316221261874,
				"lat": 43.548311389320396
			},
			{
				"lng": 11.456316340146822,
				"lat": 43.548312064926826
			},
			{
				"lng": 11.456316463365139,
				"lat": 43.548312747905804
			},
			{
				"lng": 11.456316590676398,
				"lat": 43.548313437284207
			},
			{
				"lng": 11.45631685661612,
				"lat": 43.548314831347099
			},
			{
				"lng": 11.456317136042685,
				"lat": 43.54831623933098
			},
			{
				"lng": 11.456317427032795,
				"lat": 43.548317653451306
			},
			{
				"lng": 11.456317727663167,
				"lat": 43.548319065923508
			},
			{
				"lng": 11.456318036010488,
				"lat": 43.54832046896302
			},
			{
				"lng": 11.456318350151445,
				"lat": 43.548321854785371
			},
			{
				"lng": 11.456318508793514,
				"lat": 43.548322538807405
			},
			{
				"lng": 11.456318668162769,
				"lat": 43.548323215605926
			},
			{
				"lng": 11.456318828018807,
				"lat": 43.548323884208109
			},
			{
				"lng": 11.456318988145073,
				"lat": 43.54832454397431
			},
			{
				"lng": 11.456319148396322,
				"lat": 43.548325195258762
			},
			{
				"lng": 11.456319308640452,
				"lat": 43.548325838600462
			},
			{
				"lng": 11.456319468745425,
				"lat": 43.5483264745383
			},
			{
				"lng": 11.456319628579141,
				"lat": 43.548327103611086
			},
			{
				"lng": 11.456319946904493,
				"lat": 43.548328343317216
			},
			{
				"lng": 11.456320262560045,
				"lat": 43.548329562030048
			},
			{
				"lng": 11.456320574489176,
				"lat": 43.548330764060744
			},
			{
				"lng": 11.456320881635326,
				"lat": 43.548331953720435
			},
			{
				"lng": 11.45632118294194,
				"lat": 43.548333135320313
			},
			{
				"lng": 11.456321763810315,
				"lat": 43.548335491584943
			},
			{
				"lng": 11.456322041258959,
				"lat": 43.548336674872139
			},
			{
				"lng": 11.456322308641798,
				"lat": 43.548337867344095
			},
			{
				"lng": 11.456322564902299,
				"lat": 43.548339073311872
			},
			{
				"lng": 11.456322808983881,
				"lat": 43.548340297086717
			},
			{
				"lng": 11.456322926127379,
				"lat": 43.548340916999017
			},
			{
				"lng": 11.456323039830037,
				"lat": 43.54834154297756
			},
			{
				"lng": 11.456323149967943,
				"lat": 43.54834217530702
			},
			{
				"lng": 11.456323256432873,
				"lat": 43.548342813787016
			},
			{
				"lng": 11.456323457918,
				"lat": 43.548344108176629
			},
			{
				"lng": 11.456323643433736,
				"lat": 43.548345424102784
			},
			{
				"lng": 11.456323812128421,
				"lat": 43.548346759521891
			},
			{
				"lng": 11.456323963150412,
				"lat": 43.54834811239035
			},
			{
				"lng": 11.456324095648039,
				"lat": 43.548349480664527
			},
			{
				"lng": 11.456324208769656,
				"lat": 43.548350862300758
			},
			{
				"lng": 11.456324301663615,
				"lat": 43.548352255255487
			},
			{
				"lng": 11.456324373478218,
				"lat": 43.548353657485059
			},
			{
				"lng": 11.456324423361812,
				"lat": 43.548355066945859
			},
			{
				"lng": 11.456324450462793,
				"lat": 43.548356481594304
			},
			{
				"lng": 11.456324453929447,
				"lat": 43.548357899386701
			},
			{
				"lng": 11.456324432910135,
				"lat": 43.548359318279488
			},
			{
				"lng": 11.456324386553185,
				"lat": 43.548360736229021
			},
			{
				"lng": 11.456324314124611,
				"lat": 43.548362151289517
			},
			{
				"lng": 11.456324216086685,
				"lat": 43.548363562509557
			},
			{
				"lng": 11.456324093599617,
				"lat": 43.548364969518062
			},
			{
				"lng": 11.456323947832274,
				"lat": 43.548366371951133
			},
			{
				"lng": 11.456323779953562,
				"lat": 43.548367769444653
			},
			{
				"lng": 11.456323591132358,
				"lat": 43.54836916163476
			},
			{
				"lng": 11.45632338253756,
				"lat": 43.548370548157479
			},
			{
				"lng": 11.456323155337996,
				"lat": 43.548371928648926
			},
			{
				"lng": 11.45632291070266,
				"lat": 43.548373302745127
			},
			{
				"lng": 11.456322649800343,
				"lat": 43.548374670082055
			},
			{
				"lng": 11.456322373799956,
				"lat": 43.548376030295827
			},
			{
				"lng": 11.456322083870363,
				"lat": 43.548377383022455
			},
			{
				"lng": 11.456321781180526,
				"lat": 43.54837872789809
			},
			{
				"lng": 11.456321466899244,
				"lat": 43.54838006455865
			},
			{
				"lng": 11.456321142201514,
				"lat": 43.548381392635584
			},
			{
				"lng": 11.456320808812398,
				"lat": 43.548382711337673
			},
			{
				"lng": 11.456320469436406,
				"lat": 43.548384019120917
			},
			{
				"lng": 11.456320126879362,
				"lat": 43.54838531436387
			},
			{
				"lng": 11.45631978394689,
				"lat": 43.548386595444839
			},
			{
				"lng": 11.456319443444833,
				"lat": 43.548387860742217
			},
			{
				"lng": 11.456319108178851,
				"lat": 43.548389108634481
			},
			{
				"lng": 11.45631878095471,
				"lat": 43.548390337499967
			},
			{
				"lng": 11.456318464578109,
				"lat": 43.548391545717223
			},
			{
				"lng": 11.456318161854822,
				"lat": 43.548392731664471
			},
			{
				"lng": 11.456318016489943,
				"lat": 43.54839331578021
			},
			{
				"lng": 11.456317875590539,
				"lat": 43.548393893720323
			},
			{
				"lng": 11.456317739507341,
				"lat": 43.548394465282136
			},
			{
				"lng": 11.456317608590991,
				"lat": 43.548395030263002
			},
			{
				"lng": 11.456317483192343,
				"lat": 43.548395588460188
			},
			{
				"lng": 11.45631736366199,
				"lat": 43.548396139671027
			},
			{
				"lng": 11.456317250350715,
				"lat": 43.548396683692744
			},
			{
				"lng": 11.4563171436092,
				"lat": 43.548397220322713
			},
			{
				"lng": 11.456317043788166,
				"lat": 43.548397749358223
			},
			{
				"lng": 11.456316951238339,
				"lat": 43.548398270596529
			},
			{
				"lng": 11.456316866295778,
				"lat": 43.548398783874603
			},
			{
				"lng": 11.456316789154451,
				"lat": 43.548399289413211
			},
			{
				"lng": 11.45631671992855,
				"lat": 43.548399787648627
			},
			{
				"lng": 11.456316658731419,
				"lat": 43.548400279019454
			},
			{
				"lng": 11.456316605676353,
				"lat": 43.548400763964345
			},
			{
				"lng": 11.456316560876637,
				"lat": 43.548401242922033
			},
			{
				"lng": 11.456316524445695,
				"lat": 43.548401716331092
			},
			{
				"lng": 11.456316496496756,
				"lat": 43.548402184630241
			},
			{
				"lng": 11.456316477143179,
				"lat": 43.548402648258104
			},
			{
				"lng": 11.45631646649826,
				"lat": 43.548403107653328
			},
			{
				"lng": 11.456316464675355,
				"lat": 43.548403563254595
			},
			{
				"lng": 11.456316471787758,
				"lat": 43.548404015500523
			},
			{
				"lng": 11.456316487948778,
				"lat": 43.548404464829808
			},
			{
				"lng": 11.456316513271759,
				"lat": 43.548404911681047
			},
			{
				"lng": 11.456316547869996,
				"lat": 43.548405356492943
			},
			{
				"lng": 11.456316591856853,
				"lat": 43.548405799704192
			},
			{
				"lng": 11.456316645345584,
				"lat": 43.548406241753383
			},
			{
				"lng": 11.456316708449569,
				"lat": 43.548406683079229
			},
			{
				"lng": 11.456316781282114,
				"lat": 43.548407124120295
			},
			{
				"lng": 11.456316863956495,
				"lat": 43.548407565315294
			},
			{
				"lng": 11.456316956586083,
				"lat": 43.548408007102893
			},
			{
				"lng": 11.456317059284196,
				"lat": 43.548408449921759
			},
			{
				"lng": 11.456317172164113,
				"lat": 43.548408894210496
			},
			{
				"lng": 11.456317295339181,
				"lat": 43.548409340407765
			},
			{
				"lng": 11.4563174289227,
				"lat": 43.548409788952291
			},
			{
				"lng": 11.456317573028038,
				"lat": 43.548410240282635
			},
			{
				"lng": 11.45631772776848,
				"lat": 43.548410694837536
			},
			{
				"lng": 11.456317893257326,
				"lat": 43.548411153055589
			},
			{
				"lng": 11.456318069607963,
				"lat": 43.548411615375507
			},
			{
				"lng": 11.45631825693887,
				"lat": 43.54841208222728
			},
			{
				"lng": 11.456318455399385,
				"lat": 43.548412553990673
			},
			{
				"lng": 11.45631866514999,
				"lat": 43.548413031026946
			},
			{
				"lng": 11.456318886351239,
				"lat": 43.548413513697383
			},
			{
				"lng": 11.456319119163533,
				"lat": 43.548414002363337
			},
			{
				"lng": 11.456319363747511,
				"lat": 43.548414497386133
			},
			{
				"lng": 11.456319620263587,
				"lat": 43.548414999126926
			},
			{
				"lng": 11.456319888872274,
				"lat": 43.548415507947283
			},
			{
				"lng": 11.456320169734092,
				"lat": 43.548416024208194
			},
			{
				"lng": 11.45632046300959,
				"lat": 43.548416548271199
			},
			{
				"lng": 11.456320768859202,
				"lat": 43.548417080497472
			},
			{
				"lng": 11.456321087443461,
				"lat": 43.548417621248426
			},
			{
				"lng": 11.456321418922906,
				"lat": 43.548418170885242
			},
			{
				"lng": 11.456321763458009,
				"lat": 43.548418729769274
			},
			{
				"lng": 11.456322121209242,
				"lat": 43.548419298261841
			},
			{
				"lng": 11.456322492337202,
				"lat": 43.548419876724168
			},
			{
				"lng": 11.4563228770023,
				"lat": 43.548420465517687
			},
			{
				"lng": 11.45632327536514,
				"lat": 43.548421065003602
			},
			{
				"lng": 11.456323687586146,
				"lat": 43.548421675543189
			},
			{
				"lng": 11.456324113825866,
				"lat": 43.548422297497858
			},
			{
				"lng": 11.456324554244773,
				"lat": 43.548422931228885
			},
			{
				"lng": 11.456325009003425,
				"lat": 43.548423577097509
			},
			{
				"lng": 11.456325478262285,
				"lat": 43.548424235465028
			},
			{
				"lng": 11.456325962181863,
				"lat": 43.548424906692823
			},
			{
				"lng": 11.4563264609227,
				"lat": 43.548425591142177
			},
			{
				"lng": 11.456326974645277,
				"lat": 43.548426289174301
			},
			{
				"lng": 11.45632750351006,
				"lat": 43.5484270011506
			},
			{
				"lng": 11.456328047677655,
				"lat": 43.548427727432312
			},
			{
				"lng": 11.456328607308469,
				"lat": 43.548428468380777
			},
			{
				"lng": 11.456329182355317,
				"lat": 43.548429224159186
			},
			{
				"lng": 11.456329772007278,
				"lat": 43.548429994202337
			},
			{
				"lng": 11.456330375278016,
				"lat": 43.548430777777831
			},
			{
				"lng": 11.456330991181174,
				"lat": 43.548431574153227
			},
			{
				"lng": 11.456331618730371,
				"lat": 43.548432382596182
			},
			{
				"lng": 11.456332256939323,
				"lat": 43.548433202374099
			},
			{
				"lng": 11.456332904821602,
				"lat": 43.548434032754571
			},
			{
				"lng": 11.456333561390922,
				"lat": 43.548434873005228
			},
			{
				"lng": 11.456334225660912,
				"lat": 43.54843572239357
			},
			{
				"lng": 11.456334896645222,
				"lat": 43.548436580187193
			},
			{
				"lng": 11.456335573357538,
				"lat": 43.548437445653633
			},
			{
				"lng": 11.456336254811422,
				"lat": 43.548438318060462
			},
			{
				"lng": 11.45633762799871,
				"lat": 43.548440080765445
			},
			{
				"lng": 11.456339008316277,
				"lat": 43.548441862442687
			},
			{
				"lng": 11.456340387873373,
				"lat": 43.548443657232617
			},
			{
				"lng": 11.45634175877912,
				"lat": 43.548445459275705
			},
			{
				"lng": 11.456343113142767,
				"lat": 43.548447262712443
			},
			{
				"lng": 11.45634444307354,
				"lat": 43.548449061683357
			},
			{
				"lng": 11.456345096410688,
				"lat": 43.548449957662982
			},
			{
				"lng": 11.456345740680565,
				"lat": 43.54845085032882
			},
			{
				"lng": 11.456346374896796,
				"lat": 43.548451738948451
			},
			{
				"lng": 11.456346998073046,
				"lat": 43.548452622789355
			},
			{
				"lng": 11.456347609224434,
				"lat": 43.548453501120825
			},
			{
				"lng": 11.456348207750015,
				"lat": 43.54845437365011
			},
			{
				"lng": 11.456348793947333,
				"lat": 43.548455241109302
			},
			{
				"lng": 11.456349368242236,
				"lat": 43.548456104377003
			},
			{
				"lng": 11.456349931060609,
				"lat": 43.548456964331656
			},
			{
				"lng": 11.456350482828279,
				"lat": 43.548457821851919
			},
			{
				"lng": 11.456351023971118,
				"lat": 43.548458677816207
			},
			{
				"lng": 11.456351554914958,
				"lat": 43.548459533103092
			},
			{
				"lng": 11.456352076085697,
				"lat": 43.548460388591188
			},
			{
				"lng": 11.456352587909134,
				"lat": 43.548461245158897
			},
			{
				"lng": 11.456353090811183,
				"lat": 43.548462103684834
			},
			{
				"lng": 11.456353585217634,
				"lat": 43.548462965047477
			},
			{
				"lng": 11.456354071554397,
				"lat": 43.548463830125421
			},
			{
				"lng": 11.45635455024731,
				"lat": 43.548464699797137
			},
			{
				"lng": 11.456355021722217,
				"lat": 43.548465574941183
			},
			{
				"lng": 11.456355486405,
				"lat": 43.548466456436145
			},
			{
				"lng": 11.456355944721476,
				"lat": 43.548467345160475
			},
			{
				"lng": 11.456356397097542,
				"lat": 43.548468241992673
			},
			{
				"lng": 11.456356843959011,
				"lat": 43.548469147811417
			},
			{
				"lng": 11.456357285731757,
				"lat": 43.548470063495117
			},
			{
				"lng": 11.456357722841657,
				"lat": 43.548470989922315
			},
			{
				"lng": 11.456358155714538,
				"lat": 43.548471927971605
			},
			{
				"lng": 11.456358584776249,
				"lat": 43.548472878521473
			},
			{
				"lng": 11.456359010452688,
				"lat": 43.548473842450456
			},
			{
				"lng": 11.456359433169668,
				"lat": 43.548474820637111
			},
			{
				"lng": 11.456359853353062,
				"lat": 43.548475813959897
			},
			{
				"lng": 11.456360271428725,
				"lat": 43.548476823297484
			},
			{
				"lng": 11.456360687822524,
				"lat": 43.548477849528254
			},
			{
				"lng": 11.456361102960301,
				"lat": 43.548478893530827
			},
			{
				"lng": 11.456361517263888,
				"lat": 43.548479956175044
			},
			{
				"lng": 11.45636193092284,
				"lat": 43.548481037830413
			},
			{
				"lng": 11.456362343771021,
				"lat": 43.548482138100226
			},
			{
				"lng": 11.456362755612261,
				"lat": 43.548483256523014
			},
			{
				"lng": 11.456363166250309,
				"lat": 43.548484392637342
			},
			{
				"lng": 11.456363575489009,
				"lat": 43.548485545981777
			},
			{
				"lng": 11.456363983132174,
				"lat": 43.5484867160948
			},
			{
				"lng": 11.45636438898358,
				"lat": 43.548487902514999
			},
			{
				"lng": 11.456364792847054,
				"lat": 43.548489104780963
			},
			{
				"lng": 11.456365194526423,
				"lat": 43.548490322431242
			},
			{
				"lng": 11.45636559382549,
				"lat": 43.548491555004247
			},
			{
				"lng": 11.456365990547997,
				"lat": 43.548492802038716
			},
			{
				"lng": 11.456366384497818,
				"lat": 43.548494063073058
			},
			{
				"lng": 11.456366775478736,
				"lat": 43.548495337645917
			},
			{
				"lng": 11.456367163294525,
				"lat": 43.548496625295734
			},
			{
				"lng": 11.456367547749046,
				"lat": 43.548497925561151
			},
			{
				"lng": 11.456367928646099,
				"lat": 43.548499237980693
			},
			{
				"lng": 11.456368305789447,
				"lat": 43.548500562092862
			},
			{
				"lng": 11.456368678982965,
				"lat": 43.54850189743626
			},
			{
				"lng": 11.456369048030357,
				"lat": 43.548503243549419
			},
			{
				"lng": 11.456369412735517,
				"lat": 43.548504599970876
			},
			{
				"lng": 11.45636977290223,
				"lat": 43.548505966239247
			},
			{
				"lng": 11.456370128334262,
				"lat": 43.548507341892993
			},
			{
				"lng": 11.456370478835499,
				"lat": 43.548508726470672
			},
			{
				"lng": 11.456370824209641,
				"lat": 43.548510119510915
			},
			{
				"lng": 11.456371164260608,
				"lat": 43.548511520552118
			},
			{
				"lng": 11.456371498792093,
				"lat": 43.54851292913299
			},
			{
				"lng": 11.456371827607981,
				"lat": 43.548514344791968
			},
			{
				"lng": 11.456372150512044,
				"lat": 43.548515767067641
			},
			{
				"lng": 11.456372467313892,
				"lat": 43.548517195506633
			},
			{
				"lng": 11.456372777960654,
				"lat": 43.54851862984691
			},
			{
				"lng": 11.456373082539608,
				"lat": 43.548520070021489
			},
			{
				"lng": 11.456373381144271,
				"lat": 43.548521515972041
			},
			{
				"lng": 11.456373673868246,
				"lat": 43.548522967640309
			},
			{
				"lng": 11.456373960805017,
				"lat": 43.548524424968015
			},
			{
				"lng": 11.456374242048192,
				"lat": 43.548525887896901
			},
			{
				"lng": 11.456374517691307,
				"lat": 43.54852735636868
			},
			{
				"lng": 11.456374787827896,
				"lat": 43.548528830325132
			},
			{
				"lng": 11.456375052551513,
				"lat": 43.548530309707921
			},
			{
				"lng": 11.456375566134083,
				"lat": 43.548533284519422
			},
			{
				"lng": 11.456376059187425,
				"lat": 43.548536280337117
			},
			{
				"lng": 11.45637653245995,
				"lat": 43.548539296694742
			},
			{
				"lng": 11.456376986700077,
				"lat": 43.548542333126107
			},
			{
				"lng": 11.456377422656177,
				"lat": 43.548545389165085
			},
			{
				"lng": 11.456377841076696,
				"lat": 43.548548464345458
			},
			{
				"lng": 11.456378242709999,
				"lat": 43.548551558201012
			},
			{
				"lng": 11.456378628304568,
				"lat": 43.548554670265595
			},
			{
				"lng": 11.456378998608779,
				"lat": 43.548557800072956
			},
			{
				"lng": 11.456379354404852,
				"lat": 43.54856094717428
			},
			{
				"lng": 11.456379698647268,
				"lat": 43.54856411223215
			},
			{
				"lng": 11.456380037743131,
				"lat": 43.548567297675916
			},
			{
				"lng": 11.456380378406909,
				"lat": 43.548570506091899
			},
			{
				"lng": 11.456380551424946,
				"lat": 43.548572119722785
			},
			{
				"lng": 11.456380727352904,
				"lat": 43.548573740066672
			},
			{
				"lng": 11.456380907029983,
				"lat": 43.548575367446887
			},
			{
				"lng": 11.45638109129551,
				"lat": 43.548577002186725
			},
			{
				"lng": 11.456381280988799,
				"lat": 43.548578644609449
			},
			{
				"lng": 11.456381476949156,
				"lat": 43.548580295038477
			},
			{
				"lng": 11.456381680015872,
				"lat": 43.548581953797047
			},
			{
				"lng": 11.456381891028201,
				"lat": 43.548583621208429
			},
			{
				"lng": 11.456382110825503,
				"lat": 43.548585297596041
			},
			{
				"lng": 11.456382340247051,
				"lat": 43.54858698328308
			},
			{
				"lng": 11.456382580132153,
				"lat": 43.548588678592985
			},
			{
				"lng": 11.456382831320067,
				"lat": 43.548590383848939
			},
			{
				"lng": 11.45638309465015,
				"lat": 43.548592099374311
			},
			{
				"lng": 11.456383370961646,
				"lat": 43.548593825492389
			},
			{
				"lng": 11.456383661093959,
				"lat": 43.548595562526522
			},
			{
				"lng": 11.456383965886246,
				"lat": 43.548597310800055
			},
			{
				"lng": 11.456384286177913,
				"lat": 43.548599070636115
			},
			{
				"lng": 11.456384622808185,
				"lat": 43.548600842358169
			},
			{
				"lng": 11.456384976616441,
				"lat": 43.548602626289565
			},
			{
				"lng": 11.4563853484419,
				"lat": 43.548604422753471
			},
			{
				"lng": 11.456385739123915,
				"lat": 43.548606232073247
			},
			{
				"lng": 11.456386149501773,
				"lat": 43.54860805457227
			},
			{
				"lng": 11.456386580241027,
				"lat": 43.5486098903528
			},
			{
				"lng": 11.456387030734815,
				"lat": 43.548611737898398
			},
			{
				"lng": 11.456387499810308,
				"lat": 43.548613594972927
			},
			{
				"lng": 11.456387986292247,
				"lat": 43.548615459337029
			},
			{
				"lng": 11.45638848900532,
				"lat": 43.548617328751135
			},
			{
				"lng": 11.456389006774213,
				"lat": 43.548619200975892
			},
			{
				"lng": 11.456389538423569,
				"lat": 43.548621073771784
			},
			{
				"lng": 11.4563900827781,
				"lat": 43.548622944899378
			},
			{
				"lng": 11.456390638662461,
				"lat": 43.548624812119307
			},
			{
				"lng": 11.456391204901346,
				"lat": 43.548626673192047
			},
			{
				"lng": 11.456391780319432,
				"lat": 43.548628525878179
			},
			{
				"lng": 11.456392363741445,
				"lat": 43.548630367938195
			},
			{
				"lng": 11.456392953991994,
				"lat": 43.548632197132733
			},
			{
				"lng": 11.456393549895777,
				"lat": 43.548634011222326
			},
			{
				"lng": 11.456394150277497,
				"lat": 43.548635807967507
			},
			{
				"lng": 11.456394753961852,
				"lat": 43.548637585128851
			},
			{
				"lng": 11.456395359773449,
				"lat": 43.548639340466941
			},
			{
				"lng": 11.456395966537036,
				"lat": 43.548641071742303
			},
			{
				"lng": 11.456396269908517,
				"lat": 43.54864192765659
			},
			{
				"lng": 11.456396573077239,
				"lat": 43.548642776715461
			},
			{
				"lng": 11.456396875896308,
				"lat": 43.548643618638906
			},
			{
				"lng": 11.456397178218779,
				"lat": 43.548644453146977
			},
			{
				"lng": 11.456397479897751,
				"lat": 43.5486452799598
			},
			{
				"lng": 11.456397780786295,
				"lat": 43.548646098797491
			},
			{
				"lng": 11.456398080737513,
				"lat": 43.548646909379997
			},
			{
				"lng": 11.456398379604497,
				"lat": 43.548647711427407
			},
			{
				"lng": 11.456398677240335,
				"lat": 43.548648504659866
			},
			{
				"lng": 11.456398973498077,
				"lat": 43.548649288797471
			},
			{
				"lng": 11.456399268230831,
				"lat": 43.548650063560125
			},
			{
				"lng": 11.456399561291663,
				"lat": 43.548650828668038
			},
			{
				"lng": 11.456399852533689,
				"lat": 43.548651583841249
			},
			{
				"lng": 11.456400141809953,
				"lat": 43.548652328799783
			},
			{
				"lng": 11.456400428973589,
				"lat": 43.548653063263778
			},
			{
				"lng": 11.456400713877667,
				"lat": 43.548653786953267
			},
			{
				"lng": 11.456400996375219,
				"lat": 43.548654499588316
			},
			{
				"lng": 11.456401276319411,
				"lat": 43.548655200888987
			},
			{
				"lng": 11.45640155356328,
				"lat": 43.548655890575368
			},
			{
				"lng": 11.456401827959883,
				"lat": 43.548656568367534
			},
			{
				"lng": 11.456402099362364,
				"lat": 43.548657233985551
			},
			{
				"lng": 11.45640236762379,
				"lat": 43.548657887149474
			},
			{
				"lng": 11.456402632632461,
				"lat": 43.548658527648534
			},
			{
				"lng": 11.456402894458595,
				"lat": 43.548659155628492
			},
			{
				"lng": 11.456403153230864,
				"lat": 43.548659771349818
			},
			{
				"lng": 11.456403409077916,
				"lat": 43.548660375073219
			},
			{
				"lng": 11.456403662128492,
				"lat": 43.548660967059178
			},
			{
				"lng": 11.456403912511213,
				"lat": 43.548661547568273
			},
			{
				"lng": 11.456404160354863,
				"lat": 43.548662116861003
			},
			{
				"lng": 11.456404405788025,
				"lat": 43.548662675198052
			},
			{
				"lng": 11.456404648939477,
				"lat": 43.548663222839878
			},
			{
				"lng": 11.456404889937893,
				"lat": 43.548663760047063
			},
			{
				"lng": 11.456405128911936,
				"lat": 43.548664287080243
			},
			{
				"lng": 11.456405365990326,
				"lat": 43.548664804199959
			},
			{
				"lng": 11.456405601301759,
				"lat": 43.548665311666646
			},
			{
				"lng": 11.456405834974859,
				"lat": 43.548665809741017
			},
			{
				"lng": 11.456406067138428,
				"lat": 43.548666298683592
			},
			{
				"lng": 11.456406297921045,
				"lat": 43.548666778754971
			},
			{
				"lng": 11.456406527451474,
				"lat": 43.548667250215686
			},
			{
				"lng": 11.456406755858406,
				"lat": 43.548667713326218
			},
			{
				"lng": 11.456406983270465,
				"lat": 43.548668168347277
			},
			{
				"lng": 11.456407209816428,
				"lat": 43.548668615539299
			},
			{
				"lng": 11.456407435624927,
				"lat": 43.548669055162947
			},
			{
				"lng": 11.456407660824693,
				"lat": 43.54866948747874
			},
			{
				"lng": 11.456407885544381,
				"lat": 43.548669912747222
			},
			{
				"lng": 11.45640810991271,
				"lat": 43.548670331228934
			},
			{
				"lng": 11.456408558110029,
				"lat": 43.548671148874583
			},
			{
				"lng": 11.456409006446124,
				"lat": 43.54867194250005
			},
			{
				"lng": 11.456409455950617,
				"lat": 43.548672714189991
			},
			{
				"lng": 11.45640990765299,
				"lat": 43.548673466028731
			},
			{
				"lng": 11.456410362582778,
				"lat": 43.548674200100898
			},
			{
				"lng": 11.456410821769477,
				"lat": 43.548674918490988
			},
			{
				"lng": 11.456411286242673,
				"lat": 43.548675623283486
			},
			{
				"lng": 11.456411757031873,
				"lat": 43.548676316562954
			},
			{
				"lng": 11.456412235166621,
				"lat": 43.548677000413853
			},
			{
				"lng": 11.456412721676427,
				"lat": 43.548677676920633
			},
			{
				"lng": 11.456413217590844,
				"lat": 43.548678348167975
			},
			{
				"lng": 11.456413723939376,
				"lat": 43.5486790162403
			},
			{
				"lng": 11.456414241751595,
				"lat": 43.548679683222076
			},
			{
				"lng": 11.45641477205702,
				"lat": 43.548680351197845
			},
			{
				"lng": 11.456415315885165,
				"lat": 43.548681022252133
			},
			{
				"lng": 11.456415874265565,
				"lat": 43.548681698469416
			},
			{
				"lng": 11.4564164482273,
				"lat": 43.548682381933766
			},
			{
				"lng": 11.456417038340771,
				"lat": 43.548683074213734
			},
			{
				"lng": 11.456417643863292,
				"lat": 43.548683775402942
			},
			{
				"lng": 11.456418263818447,
				"lat": 43.548684485332416
			},
			{
				"lng": 11.456418897230007,
				"lat": 43.548685203833216
			},
			{
				"lng": 11.456419543121621,
				"lat": 43.548685930736269
			},
			{
				"lng": 11.456420200516966,
				"lat": 43.5486866658728
			},
			{
				"lng": 11.456420868439725,
				"lat": 43.548687409073779
			},
			{
				"lng": 11.456421545913591,
				"lat": 43.548688160170244
			},
			{
				"lng": 11.456422231962254,
				"lat": 43.548688918993271
			},
			{
				"lng": 11.456422925609381,
				"lat": 43.548689685373951
			},
			{
				"lng": 11.456423625878649,
				"lat": 43.548690459143351
			},
			{
				"lng": 11.456424331793768,
				"lat": 43.548691240132371
			},
			{
				"lng": 11.456425042378434,
				"lat": 43.54869202817229
			},
			{
				"lng": 11.456425756656277,
				"lat": 43.548692823094015
			},
			{
				"lng": 11.456426473651018,
				"lat": 43.548693624728614
			},
			{
				"lng": 11.456427192386336,
				"lat": 43.548694432907162
			},
			{
				"lng": 11.456428631173434,
				"lat": 43.548696068220337
			},
			{
				"lng": 11.456430065206991,
				"lat": 43.548697727681997
			},
			{
				"lng": 11.456431486676522,
				"lat": 43.548699409940582
			},
			{
				"lng": 11.456432190258989,
				"lat": 43.548700259196416
			},
			{
				"lng": 11.456432887771472,
				"lat": 43.548701113644533
			},
			{
				"lng": 11.456433578237663,
				"lat": 43.548701973116202
			},
			{
				"lng": 11.456434260681286,
				"lat": 43.548702837442313
			},
			{
				"lng": 11.456434934125951,
				"lat": 43.548703706453963
			},
			{
				"lng": 11.456435597595444,
				"lat": 43.548704579982271
			},
			{
				"lng": 11.456436250116122,
				"lat": 43.548705457859214
			},
			{
				"lng": 11.456436890995322,
				"lat": 43.548706340021816
			},
			{
				"lng": 11.456437520060453,
				"lat": 43.548707226600754
			},
			{
				"lng": 11.456438137195098,
				"lat": 43.548708117747985
			},
			{
				"lng": 11.456438742282915,
				"lat": 43.548709013615309
			},
			{
				"lng": 11.456439335207532,
				"lat": 43.548709914354568
			},
			{
				"lng": 11.456439915852551,
				"lat": 43.548710820117641
			},
			{
				"lng": 11.456440484101691,
				"lat": 43.548711731056336
			},
			{
				"lng": 11.456441039838516,
				"lat": 43.54871264732251
			},
			{
				"lng": 11.456441582946645,
				"lat": 43.548713569067957
			},
			{
				"lng": 11.456442113309782,
				"lat": 43.548714496444596
			},
			{
				"lng": 11.456442630811534,
				"lat": 43.548715429604265
			},
			{
				"lng": 11.456443135335517,
				"lat": 43.548716368698727
			},
			{
				"lng": 11.456443626765379,
				"lat": 43.548717313879891
			},
			{
				"lng": 11.456444104984724,
				"lat": 43.548718265299556
			},
			{
				"lng": 11.456444569877261,
				"lat": 43.548719223109664
			},
			{
				"lng": 11.456445021326545,
				"lat": 43.548720187461946
			},
			{
				"lng": 11.456445459216232,
				"lat": 43.548721158508286
			},
			{
				"lng": 11.456445883429998,
				"lat": 43.548722136400556
			},
			{
				"lng": 11.456446293851434,
				"lat": 43.548723121290543
			},
			{
				"lng": 11.45644669036421,
				"lat": 43.548724113330131
			},
			{
				"lng": 11.456447072851928,
				"lat": 43.548725112671143
			},
			{
				"lng": 11.456447441198218,
				"lat": 43.548726119465435
			},
			{
				"lng": 11.456447795286728,
				"lat": 43.548727133864901
			},
			{
				"lng": 11.456448135001116,
				"lat": 43.548728156021262
			},
			{
				"lng": 11.456448460224991,
				"lat": 43.548729186086419
			},
			{
				"lng": 11.456448770842025,
				"lat": 43.548730224212257
			},
			{
				"lng": 11.456449066735752,
				"lat": 43.54873127055059
			},
			{
				"lng": 11.456449347789896,
				"lat": 43.548732325253233
			},
			{
				"lng": 11.456449613891502,
				"lat": 43.548733388462928
			},
			{
				"lng": 11.456449865043904,
				"lat": 43.548734460010245
			},
			{
				"lng": 11.456450101392861,
				"lat": 43.548735539343475
			},
			{
				"lng": 11.456450323092936,
				"lat": 43.54873662588772
			},
			{
				"lng": 11.456450530298566,
				"lat": 43.548737719068093
			},
			{
				"lng": 11.456450723164247,
				"lat": 43.548738818309523
			},
			{
				"lng": 11.456450901844452,
				"lat": 43.548739923037019
			},
			{
				"lng": 11.456451066493702,
				"lat": 43.548741032675807
			},
			{
				"lng": 11.456451217266432,
				"lat": 43.548742146650802
			},
			{
				"lng": 11.456451354317178,
				"lat": 43.548743264387014
			},
			{
				"lng": 11.456451477800407,
				"lat": 43.548744385309554
			},
			{
				"lng": 11.456451587870557,
				"lat": 43.548745508843481
			},
			{
				"lng": 11.456451684682216,
				"lat": 43.548746634413796
			},
			{
				"lng": 11.456451768389764,
				"lat": 43.548747761445561
			},
			{
				"lng": 11.456451839147745,
				"lat": 43.548748889363836
			},
			{
				"lng": 11.456451897110627,
				"lat": 43.548750017593626
			},
			{
				"lng": 11.456451942432915,
				"lat": 43.548751145560054
			},
			{
				"lng": 11.456451975269076,
				"lat": 43.548752272688041
			},
			{
				"lng": 11.456451995773591,
				"lat": 43.548753398402646
			},
			{
				"lng": 11.456452004100964,
				"lat": 43.548754522129023
			},
			{
				"lng": 11.456452000405642,
				"lat": 43.548755643292139
			},
			{
				"lng": 11.456451984842166,
				"lat": 43.548756761317058
			},
			{
				"lng": 11.45645195756501,
				"lat": 43.548757875628844
			},
			{
				"lng": 11.456451918728625,
				"lat": 43.548758985652483
			},
			{
				"lng": 11.456451868487493,
				"lat": 43.548760090813026
			},
			{
				"lng": 11.456451806996158,
				"lat": 43.548761190535586
			},
			{
				"lng": 11.456451734409084,
				"lat": 43.548762284245122
			},
			{
				"lng": 11.456451650880719,
				"lat": 43.548763371366782
			},
			{
				"lng": 11.456451556565566,
				"lat": 43.548764451325489
			},
			{
				"lng": 11.456451451605254,
				"lat": 43.548765523575263
			},
			{
				"lng": 11.456451335930225,
				"lat": 43.548766588043719
			},
			{
				"lng": 11.456451209298667,
				"lat": 43.548767645045515
			},
			{
				"lng": 11.456451071463533,
				"lat": 43.548768694906435
			},
			{
				"lng": 11.45645092217792,
				"lat": 43.548769737952334
			},
			{
				"lng": 11.456450761194874,
				"lat": 43.548770774509208
			},
			{
				"lng": 11.456450588267383,
				"lat": 43.548771804902863
			},
			{
				"lng": 11.456450403148544,
				"lat": 43.548772829459175
			},
			{
				"lng": 11.456450205591363,
				"lat": 43.548773848504005
			},
			{
				"lng": 11.456449995348915,
				"lat": 43.548774862363317
			},
			{
				"lng": 11.45644977217424,
				"lat": 43.548775871362928
			},
			{
				"lng": 11.456449535820385,
				"lat": 43.548776875828743
			},
			{
				"lng": 11.456449286040392,
				"lat": 43.548777876086582
			},
			{
				"lng": 11.456449022587266,
				"lat": 43.548778872462407
			},
			{
				"lng": 11.456448745214106,
				"lat": 43.548779865282057
			},
			{
				"lng": 11.456448453673923,
				"lat": 43.54878085487141
			},
			{
				"lng": 11.456448147719785,
				"lat": 43.548781841556377
			},
			{
				"lng": 11.456447827104736,
				"lat": 43.548782825662762
			},
			{
				"lng": 11.456447491581764,
				"lat": 43.548783807516536
			},
			{
				"lng": 11.456447140903963,
				"lat": 43.548784787443545
			},
			{
				"lng": 11.45644677482435,
				"lat": 43.548785765769637
			},
			{
				"lng": 11.456446393096044,
				"lat": 43.548786742820724
			},
			{
				"lng": 11.45644599547197,
				"lat": 43.548787718922682
			},
			{
				"lng": 11.456445581705248,
				"lat": 43.548788694401388
			},
			{
				"lng": 11.456445151548939,
				"lat": 43.548789669582725
			},
			{
				"lng": 11.456444704756013,
				"lat": 43.548790644792547
			},
			{
				"lng": 11.456444241079579,
				"lat": 43.548791620356774
			},
			{
				"lng": 11.456443760272641,
				"lat": 43.548792596601253
			},
			{
				"lng": 11.456443262088264,
				"lat": 43.548793573851945
			},
			{
				"lng": 11.456442746394352,
				"lat": 43.548794552333838
			},
			{
				"lng": 11.456442214119646,
				"lat": 43.548795531342002
			},
			{
				"lng": 11.456441666766011,
				"lat": 43.548796509668648
			},
			{
				"lng": 11.456441105840968,
				"lat": 43.548797486101137
			},
			{
				"lng": 11.456440532852026,
				"lat": 43.548798459426841
			},
			{
				"lng": 11.456439949306658,
				"lat": 43.54879942843322
			},
			{
				"lng": 11.456439356712393,
				"lat": 43.548800391907541
			},
			{
				"lng": 11.456438756576665,
				"lat": 43.548801348637262
			},
			{
				"lng": 11.456438150407038,
				"lat": 43.548802297409708
			},
			{
				"lng": 11.45643753971099,
				"lat": 43.548803237012358
			},
			{
				"lng": 11.456436925996007,
				"lat": 43.548804166232394
			},
			{
				"lng": 11.456436310769638,
				"lat": 43.54880508385741
			},
			{
				"lng": 11.456435695539282,
				"lat": 43.548805988674609
			},
			{
				"lng": 11.456435081812527,
				"lat": 43.548806879471471
			},
			{
				"lng": 11.456434471096825,
				"lat": 43.548807755035313
			},
			{
				"lng": 11.456433864899715,
				"lat": 43.548808614153558
			},
			{
				"lng": 11.456433264728684,
				"lat": 43.548809455613565
			},
			{
				"lng": 11.4564326720912,
				"lat": 43.54881027820268
			},
			{
				"lng": 11.456432088494777,
				"lat": 43.548811080708298
			},
			{
				"lng": 11.456431515446916,
				"lat": 43.548811861917805
			},
			{
				"lng": 11.456430954455145,
				"lat": 43.548812620618591
			},
			{
				"lng": 11.456430678951383,
				"lat": 43.548812991149262
			},
			{
				"lng": 11.456430407026939,
				"lat": 43.548813355597986
			},
			{
				"lng": 11.456430138870264,
				"lat": 43.548813713813281
			},
			{
				"lng": 11.456429874669805,
				"lat": 43.548814065643406
			},
			{
				"lng": 11.456429614613969,
				"lat": 43.548814410936963
			},
			{
				"lng": 11.456429358891231,
				"lat": 43.548814749542288
			},
			{
				"lng": 11.456429107689981,
				"lat": 43.548815081307787
			},
			{
				"lng": 11.456428861198708,
				"lat": 43.548815406081872
			},
			{
				"lng": 11.456428619605823,
				"lat": 43.548815723713005
			},
			{
				"lng": 11.456428383099784,
				"lat": 43.548816034049636
			},
			{
				"lng": 11.456428151868991,
				"lat": 43.548816336940114
			},
			{
				"lng": 11.456427926101917,
				"lat": 43.548816632232878
			},
			{
				"lng": 11.456427705986968,
				"lat": 43.548816919776378
			},
			{
				"lng": 11.456427491712622,
				"lat": 43.548817199419069
			},
			{
				"lng": 11.456427283467262,
				"lat": 43.548817471009272
			},
			{
				"lng": 11.456427081439385,
				"lat": 43.548817734395492
			},
			{
				"lng": 11.456426885795429,
				"lat": 43.548817989448345
			},
			{
				"lng": 11.456426696525662,
				"lat": 43.548818236216611
			},
			{
				"lng": 11.456426513535567,
				"lat": 43.548818474834846
			},
			{
				"lng": 11.456426336730084,
				"lat": 43.548818705438109
			},
			{
				"lng": 11.456426166014195,
				"lat": 43.548818928161495
			},
			{
				"lng": 11.456426001292822,
				"lat": 43.548819143140008
			},
			{
				"lng": 11.456425842470932,
				"lat": 43.548819350508808
			},
			{
				"lng": 11.456425689453456,
				"lat": 43.548819550402861
			},
			{
				"lng": 11.45642554214537,
				"lat": 43.548819742957399
			},
			{
				"lng": 11.456425400451591,
				"lat": 43.54881992830731
			},
			{
				"lng": 11.456425264277085,
				"lat": 43.548820106587804
			},
			{
				"lng": 11.456425133526805,
				"lat": 43.548820277933935
			},
			{
				"lng": 11.4564250081057,
				"lat": 43.548820442480704
			},
			{
				"lng": 11.456424887918718,
				"lat": 43.548820600363221
			},
			{
				"lng": 11.456424772870768,
				"lat": 43.548820751716519
			},
			{
				"lng": 11.456424662866885,
				"lat": 43.548820896675807
			},
			{
				"lng": 11.456424557811985,
				"lat": 43.548821035376015
			},
			{
				"lng": 11.456424457610986,
				"lat": 43.548821167952262
			},
			{
				"lng": 11.456424362168828,
				"lat": 43.548821294539607
			},
			{
				"lng": 11.456424271390514,
				"lat": 43.548821415273153
			},
			{
				"lng": 11.456424103445139,
				"lat": 43.54882163971903
			},
			{
				"lng": 11.456423953014415,
				"lat": 43.548821842370479
			},
			{
				"lng": 11.456423819337987,
				"lat": 43.548822024308116
			},
			{
				"lng": 11.456423701655385,
				"lat": 43.548822186612469
			},
			{
				"lng": 11.456423599206261,
				"lat": 43.548822330364082
			},
			{
				"lng": 11.456423511230165,
				"lat": 43.548822456643641
			},
			{
				"lng": 11.456423436966752,
				"lat": 43.548822566531683
			},
			{
				"lng": 11.456423375655559,
				"lat": 43.54882266110873
			},
			{
				"lng": 11.456423326536186,
				"lat": 43.548822741455375
			},
			{
				"lng": 11.456423288848267,
				"lat": 43.548822808652197
			},
			{
				"lng": 11.456423261831389,
				"lat": 43.548822863779733
			},
			{
				"lng": 11.456423244725128,
				"lat": 43.54882290791862
			},
			{
				"lng": 11.456423236985973,
				"lat": 43.548822954851076
			},
			{
				"lng": 11.456423252732133,
				"lat": 43.54882299070406
			},
			{
				"lng": 11.456423307628015,
				"lat": 43.548823002502083
			},
			{
				"lng": 11.456423373862998,
				"lat": 43.548822994720865
			},
			{
				"lng": 11.456423414695974,
				"lat": 43.548822986071912
			},
			{
				"lng": 11.456423462749509,
				"lat": 43.548822973066223
			},
			{
				"lng": 11.456423519669322,
				"lat": 43.548822954740672
			},
			{
				"lng": 11.456423587101169,
				"lat": 43.548822930132118
			},
			{
				"lng": 11.45642366669078,
				"lat": 43.548822898277493
			},
			{
				"lng": 11.456423760083922,
				"lat": 43.548822858213612
			},
			{
				"lng": 11.456423868926327,
				"lat": 43.54882280897732
			},
			{
				"lng": 11.456423994863686,
				"lat": 43.548822749605499
			},
			{
				"lng": 11.456424139541847,
				"lat": 43.548822679135029
			},
			{
				"lng": 11.4564243046065,
				"lat": 43.54882259660269
			},
			{
				"lng": 11.45642449170337,
				"lat": 43.548822501045493
			},
			{
				"lng": 11.45642470247822,
				"lat": 43.548822391500167
			},
			{
				"lng": 11.456424938576767,
				"lat": 43.548822267003615
			},
			{
				"lng": 11.456425201644814,
				"lat": 43.548822126592697
			},
			{
				"lng": 11.456425343806654,
				"lat": 43.548822050118396
			},
			{
				"lng": 11.456425493328046,
				"lat": 43.548821969304335
			},
			{
				"lng": 11.456425650414641,
				"lat": 43.548821884030126
			},
			{
				"lng": 11.456425815272201,
				"lat": 43.548821794175311
			},
			{
				"lng": 11.456425988106448,
				"lat": 43.548821699619587
			},
			{
				"lng": 11.45642616912308,
				"lat": 43.548821600242533
			},
			{
				"lng": 11.456426358527812,
				"lat": 43.548821495923754
			},
			{
				"lng": 11.456426556526374,
				"lat": 43.548821386542862
			},
			{
				"lng": 11.456426763324504,
				"lat": 43.548821271979413
			},
			{
				"lng": 11.45642697912788,
				"lat": 43.548821152113099
			},
			{
				"lng": 11.456427204142233,
				"lat": 43.548821026823482
			},
			{
				"lng": 11.456427438573256,
				"lat": 43.548820895990218
			},
			{
				"lng": 11.456427682626718,
				"lat": 43.548820759492791
			},
			{
				"lng": 11.456427936508327,
				"lat": 43.548820617210943
			},
			{
				"lng": 11.456428200423778,
				"lat": 43.548820469024243
			},
			{
				"lng": 11.456428474578777,
				"lat": 43.548820314812225
			},
			{
				"lng": 11.456428759179076,
				"lat": 43.54882015445461
			},
			{
				"lng": 11.456429054430393,
				"lat": 43.548819987830953
			},
			{
				"lng": 11.456429360538436,
				"lat": 43.548819814820895
			},
			{
				"lng": 11.456429677708856,
				"lat": 43.548819635303929
			},
			{
				"lng": 11.456430006147487,
				"lat": 43.548819449159801
			},
			{
				"lng": 11.456430346059982,
				"lat": 43.548819256268011
			},
			{
				"lng": 11.456430697652067,
				"lat": 43.548819056508272
			},
			{
				"lng": 11.45643106112947,
				"lat": 43.548818849760146
			},
			{
				"lng": 11.456431436697898,
				"lat": 43.548818635903196
			},
			{
				"lng": 11.456431824563094,
				"lat": 43.548818414817084
			},
			{
				"lng": 11.45643222493071,
				"lat": 43.548818186381361
			},
			{
				"lng": 11.456432638002944,
				"lat": 43.548817950478202
			},
			{
				"lng": 11.456433063838805,
				"lat": 43.548817707090443
			},
			{
				"lng": 11.456433502308494,
				"lat": 43.548817456333595
			},
			{
				"lng": 11.456433953269418,
				"lat": 43.548817198332358
			},
			{
				"lng": 11.456434416578785,
				"lat": 43.548816933211363
			},
			{
				"lng": 11.456434892093993,
				"lat": 43.54881666109533
			},
			{
				"lng": 11.456435379672435,
				"lat": 43.548816382108917
			},
			{
				"lng": 11.456435879171343,
				"lat": 43.548816096376711
			},
			{
				"lng": 11.456436390448085,
				"lat": 43.548815804023405
			},
			{
				"lng": 11.45643691336004,
				"lat": 43.548815505173742
			},
			{
				"lng": 11.45643744776449,
				"lat": 43.548815199952202
			},
			{
				"lng": 11.456437993518769,
				"lat": 43.548814888483662
			},
			{
				"lng": 11.456438550480238,
				"lat": 43.548814570892624
			},
			{
				"lng": 11.456439118506234,
				"lat": 43.548814247303852
			},
			{
				"lng": 11.456439697454075,
				"lat": 43.548813917841969
			},
			{
				"lng": 11.456440287181085,
				"lat": 43.54881358263156
			},
			{
				"lng": 11.456440887544593,
				"lat": 43.548813241797397
			},
			{
				"lng": 11.456441498402004,
				"lat": 43.54881289546411
			},
			{
				"lng": 11.456442119610562,
				"lat": 43.548812543756377
			},
			{
				"lng": 11.456442751027629,
				"lat": 43.548812186798791
			},
			{
				"lng": 11.45644339251057,
				"lat": 43.548811824716026
			},
			{
				"lng": 11.456444043916704,
				"lat": 43.54881145763283
			},
			{
				"lng": 11.456444705103344,
				"lat": 43.548811085673805
			},
			{
				"lng": 11.456445375927803,
				"lat": 43.548810708963607
			},
			{
				"lng": 11.456446056247499,
				"lat": 43.548810327626875
			},
			{
				"lng": 11.456446745919663,
				"lat": 43.548809941788321
			},
			{
				"lng": 11.456447444801729,
				"lat": 43.548809551572582
			},
			{
				"lng": 11.456448152750959,
				"lat": 43.548809157104373
			},
			{
				"lng": 11.456448869624714,
				"lat": 43.548808758508237
			},
			{
				"lng": 11.45644959528031,
				"lat": 43.548808355908918
			},
			{
				"lng": 11.456450329575128,
				"lat": 43.548807949431058
			},
			{
				"lng": 11.456451072366448,
				"lat": 43.548807539199373
			},
			{
				"lng": 11.456451823511618,
				"lat": 43.548807125338442
			},
			{
				"lng": 11.456452582868019,
				"lat": 43.548806707972915
			},
			{
				"lng": 11.456453350292898,
				"lat": 43.548806287227549
			},
			{
				"lng": 11.456454908777637,
				"lat": 43.54880543609579
			},
			{
				"lng": 11.456456497824437,
				"lat": 43.548804572940384
			},
			{
				"lng": 11.456458116292051,
				"lat": 43.54880369875869
			},
			{
				"lng": 11.456459763039105,
				"lat": 43.548802814547862
			},
			{
				"lng": 11.456461436924277,
				"lat": 43.548801921305369
			},
			{
				"lng": 11.456463136806274,
				"lat": 43.548801020028392
			},
			{
				"lng": 11.45646486154371,
				"lat": 43.548800111714229
			},
			{
				"lng": 11.456466609995315,
				"lat": 43.548799197360246
			},
			{
				"lng": 11.456468381019747,
				"lat": 43.548798277963634
			},
			{
				"lng": 11.456470173475637,
				"lat": 43.548797354521732
			},
			{
				"lng": 11.456471986221711,
				"lat": 43.548796428031842
			},
			{
				"lng": 11.456473818113363,
				"lat": 43.548795499490716
			},
			{
				"lng": 11.456475667836466,
				"lat": 43.548794569867681
			},
			{
				"lng": 11.456477533826677,
				"lat": 43.548793640091503
			},
			{
				"lng": 11.456479414499542,
				"lat": 43.548792711087771
			},
			{
				"lng": 11.456481308270739,
				"lat": 43.5487917837821
			},
			{
				"lng": 11.456483213555838,
				"lat": 43.548790859100002
			},
			{
				"lng": 11.456485128770433,
				"lat": 43.548789937967037
			},
			{
				"lng": 11.45648705233012,
				"lat": 43.548789021308828
			},
			{
				"lng": 11.456488982650548,
				"lat": 43.548788110050879
			},
			{
				"lng": 11.456490918147239,
				"lat": 43.548787205118771
			},
			{
				"lng": 11.456492857235883,
				"lat": 43.548786307438085
			},
			{
				"lng": 11.45649479833201,
				"lat": 43.548785417934347
			},
			{
				"lng": 11.456496739851261,
				"lat": 43.548784537533166
			},
			{
				"lng": 11.456498680209258,
				"lat": 43.548783667160123
			},
			{
				"lng": 11.456500617821574,
				"lat": 43.548782807740814
			},
			{
				"lng": 11.456502551103789,
				"lat": 43.548781960200664
			},
			{
				"lng": 11.456504478471537,
				"lat": 43.548781125465354
			},
			{
				"lng": 11.456506398340451,
				"lat": 43.548780304460401
			},
			{
				"lng": 11.456508309126066,
				"lat": 43.548779498111394
			},
			{
				"lng": 11.456510209244041,
				"lat": 43.548778707343892
			},
			{
				"lng": 11.456512097109973,
				"lat": 43.548777933083493
			},
			{
				"lng": 11.456513971139422,
				"lat": 43.548777176255712
			},
			{
				"lng": 11.456515829748067,
				"lat": 43.548776437786145
			},
			{
				"lng": 11.456517671351463,
				"lat": 43.548775718600375
			},
			{
				"lng": 11.456519494365217,
				"lat": 43.548775019623925
			},
			{
				"lng": 11.45652039840588,
				"lat": 43.548774678003483
			},
			{
				"lng": 11.456521297204949,
				"lat": 43.548774341782398
			},
			{
				"lng": 11.456522190564442,
				"lat": 43.548774011076446
			},
			{
				"lng": 11.456523078286281,
				"lat": 43.548773686001319
			},
			{
				"lng": 11.456523960172394,
				"lat": 43.548773366672719
			},
			{
				"lng": 11.456524836024782,
				"lat": 43.548773053206354
			},
			{
				"lng": 11.456525705645344,
				"lat": 43.548772745717848
			},
			{
				"lng": 11.456526568836054,
				"lat": 43.548772444322971
			},
			{
				"lng": 11.456527425398857,
				"lat": 43.548772149137378
			},
			{
				"lng": 11.45652827520489,
				"lat": 43.548771860242276
			},
			{
				"lng": 11.456529118390344,
				"lat": 43.548771577586741
			},
			{
				"lng": 11.456529955155069,
				"lat": 43.548771301088159
			},
			{
				"lng": 11.456530785698867,
				"lat": 43.5487710306639
			},
			{
				"lng": 11.456531610221502,
				"lat": 43.548770766231335
			},
			{
				"lng": 11.456532428922797,
				"lat": 43.548770507707765
			},
			{
				"lng": 11.456533242002555,
				"lat": 43.548770255010659
			},
			{
				"lng": 11.456534049660563,
				"lat": 43.548770008057289
			},
			{
				"lng": 11.456534852096636,
				"lat": 43.548769766765091
			},
			{
				"lng": 11.456536442102223,
				"lat": 43.548769300833705
			},
			{
				"lng": 11.456538013617639,
				"lat": 43.548768856555327
			},
			{
				"lng": 11.456539568241329,
				"lat": 43.548768433268968
			},
			{
				"lng": 11.456541107571741,
				"lat": 43.548768030313582
			},
			{
				"lng": 11.456542633207208,
				"lat": 43.548767647028171
			},
			{
				"lng": 11.456544146746197,
				"lat": 43.548767282751626
			},
			{
				"lng": 11.456545649787085,
				"lat": 43.548766936822908
			},
			{
				"lng": 11.45654714392831,
				"lat": 43.548766608581019
			},
			{
				"lng": 11.456548630768243,
				"lat": 43.548766297364878
			},
			{
				"lng": 11.456550111905326,
				"lat": 43.548766002513489
			},
			{
				"lng": 11.456551588937987,
				"lat": 43.548765723365747
			},
			{
				"lng": 11.456553063464536,
				"lat": 43.548765459260601
			},
			{
				"lng": 11.456554537083488,
				"lat": 43.548765209537088
			},
			{
				"lng": 11.456556011393184,
				"lat": 43.548764973534084
			},
			{
				"lng": 11.456557487992093,
				"lat": 43.548764750590614
			},
			{
				"lng": 11.456558968478582,
				"lat": 43.548764540045617
			},
			{
				"lng": 11.45656045445107,
				"lat": 43.548764341238034
			},
			{
				"lng": 11.456561947507947,
				"lat": 43.548764153506816
			},
			{
				"lng": 11.45656344924763,
				"lat": 43.548763976190912
			},
			{
				"lng": 11.456564961268537,
				"lat": 43.548763808629239
			},
			{
				"lng": 11.456566485169052,
				"lat": 43.548763650160922
			},
			{
				"lng": 11.45656802254762,
				"lat": 43.548763500124743
			},
			{
				"lng": 11.456569575002614,
				"lat": 43.548763357859727
			},
			{
				"lng": 11.456571144132486,
				"lat": 43.548763222704828
			},
			{
				"lng": 11.456572731394344,
				"lat": 43.548763094054955
			},
			{
				"lng": 11.456574336575393,
				"lat": 43.548762971967932
			},
			{
				"lng": 11.456575958371772,
				"lat": 43.548762856934253
			},
			{
				"lng": 11.456577595460779,
				"lat": 43.548762749451939
			},
			{
				"lng": 11.456579246519759,
				"lat": 43.548762650019029
			},
			{
				"lng": 11.456580910226021,
				"lat": 43.548762559133564
			},
			{
				"lng": 11.456582585256895,
				"lat": 43.548762477293693
			},
			{
				"lng": 11.456584270289728,
				"lat": 43.548762404997326
			},
			{
				"lng": 11.456585964001818,
				"lat": 43.548762342742542
			},
			{
				"lng": 11.456587665070527,
				"lat": 43.54876229102743
			},
			{
				"lng": 11.45658937217314,
				"lat": 43.548762250349931
			},
			{
				"lng": 11.456591083987014,
				"lat": 43.548762221208221
			},
			{
				"lng": 11.456592799189472,
				"lat": 43.548762204100193
			},
			{
				"lng": 11.456594516457811,
				"lat": 43.548762199524035
			},
			{
				"lng": 11.456596234469425,
				"lat": 43.548762207977695
			},
			{
				"lng": 11.456597951901555,
				"lat": 43.548762229959287
			},
			{
				"lng": 11.456599667431576,
				"lat": 43.548762265966722
			},
			{
				"lng": 11.456601379736819,
				"lat": 43.548762316498227
			},
			{
				"lng": 11.456603087494578,
				"lat": 43.548762382051734
			},
			{
				"lng": 11.456604789382245,
				"lat": 43.548762463125236
			},
			{
				"lng": 11.456606484077062,
				"lat": 43.548762560216886
			},
			{
				"lng": 11.456608170256445,
				"lat": 43.548762673824641
			},
			{
				"lng": 11.456609846597635,
				"lat": 43.548762804446604
			},
			{
				"lng": 11.456611511778025,
				"lat": 43.548762952580773
			},
			{
				"lng": 11.456613164474879,
				"lat": 43.548763118725276
			},
			{
				"lng": 11.4566148033656,
				"lat": 43.548763303378053
			},
			{
				"lng": 11.456616427127477,
				"lat": 43.548763507037194
			},
			{
				"lng": 11.456618034437843,
				"lat": 43.548763730200719
			},
			{
				"lng": 11.456619623974003,
				"lat": 43.548763973366704
			},
			{
				"lng": 11.456621194563597,
				"lat": 43.548764236924896
			},
			{
				"lng": 11.456622746086907,
				"lat": 43.548764520506801
			},
			{
				"lng": 11.45662427887396,
				"lat": 43.548764823419766
			},
			{
				"lng": 11.456625793256533,
				"lat": 43.548765144970069
			},
			{
				"lng": 11.456627289566415,
				"lat": 43.548765484463843
			},
			{
				"lng": 11.45662876813533,
				"lat": 43.548765841207398
			},
			{
				"lng": 11.456630229295154,
				"lat": 43.54876621450682
			},
			{
				"lng": 11.456631673377526,
				"lat": 43.548766603668319
			},
			{
				"lng": 11.456633100714317,
				"lat": 43.548767007998116
			},
			{
				"lng": 11.456634511637212,
				"lat": 43.548767426802456
			},
			{
				"lng": 11.45663590647807,
				"lat": 43.54876785938751
			},
			{
				"lng": 11.456637285568604,
				"lat": 43.548768305059362
			},
			{
				"lng": 11.456638649240611,
				"lat": 43.548768763124372
			},
			{
				"lng": 11.45663999782586,
				"lat": 43.548769232888645
			},
			{
				"lng": 11.456641331656076,
				"lat": 43.54876971365843
			},
			{
				"lng": 11.456642651063065,
				"lat": 43.548770204739888
			},
			{
				"lng": 11.456643956378629,
				"lat": 43.548770705439232
			},
			{
				"lng": 11.45664524793448,
				"lat": 43.548771215062715
			},
			{
				"lng": 11.456646526062432,
				"lat": 43.548771732916379
			},
			{
				"lng": 11.456647791094241,
				"lat": 43.548772258306563
			},
			{
				"lng": 11.45664904336164,
				"lat": 43.548772790539481
			},
			{
				"lng": 11.456650283196437,
				"lat": 43.548773328921172
			},
			{
				"lng": 11.45665151093041,
				"lat": 43.548773872757977
			},
			{
				"lng": 11.456652726895301,
				"lat": 43.548774421356086
			},
			{
				"lng": 11.45665393142292,
				"lat": 43.548774974021669
			},
			{
				"lng": 11.456655124845005,
				"lat": 43.548775530060865
			},
			{
				"lng": 11.456656307493301,
				"lat": 43.548776088779924
			},
			{
				"lng": 11.456657479699608,
				"lat": 43.54877664948512
			},
			{
				"lng": 11.456658641795707,
				"lat": 43.548777211482516
			},
			{
				"lng": 11.456659794072875,
				"lat": 43.548777774213256
			},
			{
				"lng": 11.456660936646179,
				"lat": 43.548778337705201
			},
			{
				"lng": 11.456662069582794,
				"lat": 43.548778902146111
			},
			{
				"lng": 11.456663192949888,
				"lat": 43.548779467723556
			},
			{
				"lng": 11.456664306814586,
				"lat": 43.548780034625125
			},
			{
				"lng": 11.456665411244042,
				"lat": 43.548780603038622
			},
			{
				"lng": 11.456666506305407,
				"lat": 43.548781173151504
			},
			{
				"lng": 11.45666759206588,
				"lat": 43.548781745151537
			},
			{
				"lng": 11.456668668592519,
				"lat": 43.548782319226362
			},
			{
				"lng": 11.456669735952577,
				"lat": 43.548782895563441
			},
			{
				"lng": 11.45667079421318,
				"lat": 43.54878347435065
			},
			{
				"lng": 11.456671843441447,
				"lat": 43.548784055775513
			},
			{
				"lng": 11.456672883704538,
				"lat": 43.548784640025659
			},
			{
				"lng": 11.456673915069613,
				"lat": 43.548785227288803
			},
			{
				"lng": 11.456674937603843,
				"lat": 43.548785817752481
			},
			{
				"lng": 11.456675951374352,
				"lat": 43.548786411604418
			},
			{
				"lng": 11.456676956448327,
				"lat": 43.548787009032253
			},
			{
				"lng": 11.45667795289291,
				"lat": 43.548787610223542
			},
			{
				"lng": 11.456678940775239,
				"lat": 43.548788215365953
			},
			{
				"lng": 11.456679920162467,
				"lat": 43.548788824647218
			},
			{
				"lng": 11.45668089112176,
				"lat": 43.548789438254886
			},
			{
				"lng": 11.456681853720246,
				"lat": 43.548790056376603
			},
			{
				"lng": 11.456682808025118,
				"lat": 43.548790679200046
			},
			{
				"lng": 11.456683754103523,
				"lat": 43.548791306912804
			},
			{
				"lng": 11.456684692022552,
				"lat": 43.548791939702582
			},
			{
				"lng": 11.45668562184945,
				"lat": 43.548792577756991
			},
			{
				"lng": 11.456686543651305,
				"lat": 43.548793221263672
			},
			{
				"lng": 11.456687457495319,
				"lat": 43.548793870410229
			},
			{
				"lng": 11.456688363448649,
				"lat": 43.548794525384466
			},
			{
				"lng": 11.456689261622106,
				"lat": 43.54879518644163
			},
			{
				"lng": 11.45669015224621,
				"lat": 43.548795854022671
			},
			{
				"lng": 11.456691035571879,
				"lat": 43.548796528600356
			},
			{
				"lng": 11.456691911850045,
				"lat": 43.548797210647315
			},
			{
				"lng": 11.456692781331592,
				"lat": 43.548797900636004
			},
			{
				"lng": 11.456693644267427,
				"lat": 43.548798599039259
			},
			{
				"lng": 11.456694500908499,
				"lat": 43.548799306329521
			},
			{
				"lng": 11.456695351505727,
				"lat": 43.548800022979641
			},
			{
				"lng": 11.456696196309977,
				"lat": 43.548800749462096
			},
			{
				"lng": 11.45669703557221,
				"lat": 43.548801486249566
			},
			{
				"lng": 11.456697869543325,
				"lat": 43.548802233814719
			},
			{
				"lng": 11.456698698474247,
				"lat": 43.548802992630101
			},
			{
				"lng": 11.456699522615903,
				"lat": 43.548803763168408
			},
			{
				"lng": 11.45670034221914,
				"lat": 43.548804545902286
			},
			{
				"lng": 11.456701157534976,
				"lat": 43.548805341304316
			},
			{
				"lng": 11.456701968814247,
				"lat": 43.548806149847138
			},
			{
				"lng": 11.456702776307916,
				"lat": 43.548806972003469
			},
			{
				"lng": 11.45670358026684,
				"lat": 43.548807808245847
			},
			{
				"lng": 11.456704380942003,
				"lat": 43.548808659046934
			},
			{
				"lng": 11.456705178584274,
				"lat": 43.548809524879353
			},
			{
				"lng": 11.45670597344462,
				"lat": 43.548810406215793
			},
			{
				"lng": 11.456706765773909,
				"lat": 43.548811303528858
			},
			{
				"lng": 11.456707555823071,
				"lat": 43.548812217291129
			},
			{
				"lng": 11.456708343843033,
				"lat": 43.548813147975309
			},
			{
				"lng": 11.456709130084672,
				"lat": 43.548814096053981
			},
			{
				"lng": 11.456709914798948,
				"lat": 43.548815061999797
			},
			{
				"lng": 11.456710698236773,
				"lat": 43.548816046285459
			},
			{
				"lng": 11.456711480649032,
				"lat": 43.548817049383466
			},
			{
				"lng": 11.456712262286597,
				"lat": 43.548818071764913
			},
			{
				"lng": 11.456713043392245,
				"lat": 43.548819113754391
			},
			{
				"lng": 11.456713824194518,
				"lat": 43.548820175415734
			},
			{
				"lng": 11.456714604920503,
				"lat": 43.548821256785843
			},
			{
				"lng": 11.456715385797242,
				"lat": 43.548822357901564
			},
			{
				"lng": 11.456716167051836,
				"lat": 43.548823478799903
			},
			{
				"lng": 11.456716948911327,
				"lat": 43.548824619517703
			},
			{
				"lng": 11.45671773160278,
				"lat": 43.548825780091946
			},
			{
				"lng": 11.456718515353273,
				"lat": 43.54882696055946
			},
			{
				"lng": 11.456719300389867,
				"lat": 43.548828160957129
			},
			{
				"lng": 11.456720086939637,
				"lat": 43.548829381321951
			},
			{
				"lng": 11.456720875229639,
				"lat": 43.54883062169084
			},
			{
				"lng": 11.456721665486935,
				"lat": 43.548831882100657
			},
			{
				"lng": 11.456722457938605,
				"lat": 43.548833162588267
			},
			{
				"lng": 11.456723252811747,
				"lat": 43.548834463190673
			},
			{
				"lng": 11.456724050333349,
				"lat": 43.548835783944739
			},
			{
				"lng": 11.456724850730552,
				"lat": 43.548837124887378
			},
			{
				"lng": 11.456725654230397,
				"lat": 43.548838486055473
			},
			{
				"lng": 11.456726461059901,
				"lat": 43.54883986748591
			},
			{
				"lng": 11.456727271446212,
				"lat": 43.548841269215721
			},
			{
				"lng": 11.456728085616376,
				"lat": 43.548842691281699
			},
			{
				"lng": 11.456728903797417,
				"lat": 43.548844133720785
			},
			{
				"lng": 11.456729726216437,
				"lat": 43.548845596569947
			},
			{
				"lng": 11.456730553100519,
				"lat": 43.548847079865951
			},
			{
				"lng": 11.456731384676695,
				"lat": 43.548848583645842
			},
			{
				"lng": 11.456732221172038,
				"lat": 43.548850107946436
			},
			{
				"lng": 11.456733062813653,
				"lat": 43.5488516528047
			},
			{
				"lng": 11.456733909828577,
				"lat": 43.548853218257591
			},
			{
				"lng": 11.456734762443871,
				"lat": 43.548854804341907
			},
			{
				"lng": 11.456735620884162,
				"lat": 43.548856411077615
			},
			{
				"lng": 11.456736485296194,
				"lat": 43.54885803794965
			},
			{
				"lng": 11.456737355734969,
				"lat": 43.548859683811287
			},
			{
				"lng": 11.45673823225013,
				"lat": 43.548861347479459
			},
			{
				"lng": 11.456739114891288,
				"lat": 43.54886302777107
			},
			{
				"lng": 11.456740003708193,
				"lat": 43.548864723503179
			},
			{
				"lng": 11.456740898750454,
				"lat": 43.548866433492677
			},
			{
				"lng": 11.45674180006773,
				"lat": 43.54886815655658
			},
			{
				"lng": 11.456742707709738,
				"lat": 43.54886989151175
			},
			{
				"lng": 11.456743621726073,
				"lat": 43.548871637175189
			},
			{
				"lng": 11.456744542166442,
				"lat": 43.548873392363859
			},
			{
				"lng": 11.456745469080472,
				"lat": 43.54887515589472
			},
			{
				"lng": 11.456746402517826,
				"lat": 43.548876926584711
			},
			{
				"lng": 11.456747342528205,
				"lat": 43.54887870325075
			},
			{
				"lng": 11.456749242466639,
				"lat": 43.548882269779078
			},
			{
				"lng": 11.456751169292994,
				"lat": 43.548885846015132
			},
			{
				"lng": 11.456753123404603,
				"lat": 43.548889422494682
			},
			{
				"lng": 11.456755105198766,
				"lat": 43.548892989753305
			},
			{
				"lng": 11.45675610660096,
				"lat": 43.548894766967194
			},
			{
				"lng": 11.456757115072721,
				"lat": 43.548896538326694
			},
			{
				"lng": 11.456758130663804,
				"lat": 43.548898302648801
			},
			{
				"lng": 11.456759153423814,
				"lat": 43.548900058750469
			},
			{
				"lng": 11.456760183402443,
				"lat": 43.548901805448629
			},
			{
				"lng": 11.456761220649332,
				"lat": 43.548903541560236
			},
			{
				"lng": 11.456762265214135,
				"lat": 43.54890526590227
			},
			{
				"lng": 11.456763317141734,
				"lat": 43.548906977343897
			},
			{
				"lng": 11.45676437640315,
				"lat": 43.548908675561883
			},
			{
				"lng": 11.456765442911189,
				"lat": 43.54891036086876
			},
			{
				"lng": 11.45676651657719,
				"lat": 43.548912033594362
			},
			{
				"lng": 11.456767597312375,
				"lat": 43.548913694068354
			},
			{
				"lng": 11.45676868502801,
				"lat": 43.548915342620454
			},
			{
				"lng": 11.456769779635382,
				"lat": 43.548916979580383
			},
			{
				"lng": 11.456770881045731,
				"lat": 43.548918605277905
			},
			{
				"lng": 11.456771989170377,
				"lat": 43.54892022004271
			},
			{
				"lng": 11.456773103920581,
				"lat": 43.548921824204591
			},
			{
				"lng": 11.456774225207582,
				"lat": 43.548923418093189
			},
			{
				"lng": 11.456775352942625,
				"lat": 43.548925002038189
			},
			{
				"lng": 11.456776487037066,
				"lat": 43.548926576369539
			},
			{
				"lng": 11.456777627402108,
				"lat": 43.548928141416781
			},
			{
				"lng": 11.456778773949063,
				"lat": 43.548929697509635
			},
			{
				"lng": 11.456779926589157,
				"lat": 43.548931244977936
			},
			{
				"lng": 11.456781085233708,
				"lat": 43.548932784151411
			},
			{
				"lng": 11.456782249793948,
				"lat": 43.548934315359674
			},
			{
				"lng": 11.456783420181145,
				"lat": 43.548935838932522
			},
			{
				"lng": 11.456784596306619,
				"lat": 43.548937355199669
			},
			{
				"lng": 11.456785778081604,
				"lat": 43.548938864490914
			},
			{
				"lng": 11.456786965417358,
				"lat": 43.548940367135842
			},
			{
				"lng": 11.456788158225182,
				"lat": 43.548941863464343
			},
			{
				"lng": 11.456789356416341,
				"lat": 43.54894335380601
			},
			{
				"lng": 11.456790559902071,
				"lat": 43.548944838490605
			},
			{
				"lng": 11.456792982402467,
				"lat": 43.54894779220762
			},
			{
				"lng": 11.456795425016477,
				"lat": 43.548950727253157
			},
			{
				"lng": 11.45679788793651,
				"lat": 43.548953646407398
			},
			{
				"lng": 11.456800376652433,
				"lat": 43.548956553285898
			},
			{
				"lng": 11.456801633001456,
				"lat": 43.548958003346776
			},
			{
				"lng": 11.456802898581241,
				"lat": 43.548959451808656
			},
			{
				"lng": 11.456804174319165,
				"lat": 43.5489608991616
			},
			{
				"lng": 11.456805461142743,
				"lat": 43.548962345895575
			},
			{
				"lng": 11.456806759979479,
				"lat": 43.54896379250075
			},
			{
				"lng": 11.456808071756795,
				"lat": 43.548965239466987
			},
			{
				"lng": 11.456809397402226,
				"lat": 43.548966687284356
			},
			{
				"lng": 11.456810737843194,
				"lat": 43.548968136442873
			},
			{
				"lng": 11.456812094007221,
				"lat": 43.54896958743263
			},
			{
				"lng": 11.456813466821744,
				"lat": 43.548971040743531
			},
			{
				"lng": 11.456814857214299,
				"lat": 43.548972496865673
			},
			{
				"lng": 11.456816266112266,
				"lat": 43.548973956289004
			},
			{
				"lng": 11.456817694443247,
				"lat": 43.548975419503613
			},
			{
				"lng": 11.456819143134629,
				"lat": 43.548976886999505
			},
			{
				"lng": 11.456820613113941,
				"lat": 43.548978359266677
			},
			{
				"lng": 11.456822105308602,
				"lat": 43.548979836795127
			},
			{
				"lng": 11.456823620646134,
				"lat": 43.548981320074908
			},
			{
				"lng": 11.456825160054025,
				"lat": 43.548982809596062
			},
			{
				"lng": 11.456826724459725,
				"lat": 43.548984305848549
			},
			{
				"lng": 11.456828314790766,
				"lat": 43.548985809322438
			},
			{
				"lng": 11.456829931974555,
				"lat": 43.548987320507706
			},
			{
				"lng": 11.456831576938585,
				"lat": 43.548988839894378
			},
			{
				"lng": 11.456833250610366,
				"lat": 43.548990367972479
			},
			{
				"lng": 11.456834953917392,
				"lat": 43.548991905232079
			},
			{
				"lng": 11.456836687787099,
				"lat": 43.548993452163089
			},
			{
				"lng": 11.456838453035331,
				"lat": 43.548995009312478
			},
			{
				"lng": 11.456840249876914,
				"lat": 43.548996577533167
			},
			{
				"lng": 11.456842078325097,
				"lat": 43.548998157780943
			},
			{
				"lng": 11.456843004405757,
				"lat": 43.548998952713596
			},
			{
				"lng": 11.456843938392971,
				"lat": 43.548999751011394
			},
			{
				"lng": 11.456844880288442,
				"lat": 43.549000552793856
			},
			{
				"lng": 11.456845830093734,
				"lat": 43.549001358180391
			},
			{
				"lng": 11.45684678781052,
				"lat": 43.549002167290425
			},
			{
				"lng": 11.456847753440465,
				"lat": 43.549002980243479
			},
			{
				"lng": 11.456848726985163,
				"lat": 43.549003797159024
			},
			{
				"lng": 11.456849708446311,
				"lat": 43.549004618156559
			},
			{
				"lng": 11.45685069782551,
				"lat": 43.549005443355412
			},
			{
				"lng": 11.456851695124449,
				"lat": 43.549006272875189
			},
			{
				"lng": 11.456852700344697,
				"lat": 43.54900710683529
			},
			{
				"lng": 11.456853713487941,
				"lat": 43.549007945355164
			},
			{
				"lng": 11.456854734555822,
				"lat": 43.549008788554367
			},
			{
				"lng": 11.456855763549976,
				"lat": 43.549009636552299
			},
			{
				"lng": 11.456856800472041,
				"lat": 43.54901048946838
			},
			{
				"lng": 11.456857845323686,
				"lat": 43.549011347422208
			},
			{
				"lng": 11.456858898106494,
				"lat": 43.54901221053305
			},
			{
				"lng": 11.456859958822141,
				"lat": 43.549013078920581
			},
			{
				"lng": 11.456861027472291,
				"lat": 43.549013952704122
			},
			{
				"lng": 11.456862104058553,
				"lat": 43.549014832003223
			},
			{
				"lng": 11.456863188582599,
				"lat": 43.549015716937262
			},
			{
				"lng": 11.456864281046013,
				"lat": 43.549016607625795
			},
			{
				"lng": 11.456865381450504,
				"lat": 43.549017504188271
			},
			{
				"lng": 11.456866489797672,
				"lat": 43.549018406744096
			},
			{
				"lng": 11.45686760608921,
				"lat": 43.549019315412764
			},
			{
				"lng": 11.456868730326709,
				"lat": 43.549020230313801
			},
			{
				"lng": 11.456869862511807,
				"lat": 43.549021151566571
			},
			{
				"lng": 11.456871002646157,
				"lat": 43.54902207929063
			},
			{
				"lng": 11.45687215073143,
				"lat": 43.549023013605364
			},
			{
				"lng": 11.456873306769237,
				"lat": 43.549023954630321
			},
			{
				"lng": 11.456874470761244,
				"lat": 43.549024902484895
			},
			{
				"lng": 11.456875642709054,
				"lat": 43.549025857288598
			},
			{
				"lng": 11.456876822614344,
				"lat": 43.549026819160851
			},
			{
				"lng": 11.45687801047875,
				"lat": 43.549027788221146
			},
			{
				"lng": 11.456879206303906,
				"lat": 43.54902876458894
			},
			{
				"lng": 11.456880410091442,
				"lat": 43.549029748383688
			},
			{
				"lng": 11.456881621843058,
				"lat": 43.549030739724955
			},
			{
				"lng": 11.456882841560287,
				"lat": 43.549031738732047
			},
			{
				"lng": 11.456884069244895,
				"lat": 43.549032745524492
			},
			{
				"lng": 11.456885304898458,
				"lat": 43.54903376022186
			},
			{
				"lng": 11.456886548522585,
				"lat": 43.549034782943416
			},
			{
				"lng": 11.456887800119006,
				"lat": 43.549035813808871
			},
			{
				"lng": 11.456889059689315,
				"lat": 43.549036852937462
			},
			{
				"lng": 11.456890327235136,
				"lat": 43.54903790044871
			},
			{
				"lng": 11.456891602758132,
				"lat": 43.549038956462176
			},
			{
				"lng": 11.456892886259967,
				"lat": 43.549040021097248
			},
			{
				"lng": 11.456894177742237,
				"lat": 43.549041094473395
			},
			{
				"lng": 11.456895477206617,
				"lat": 43.54904217671011
			},
			{
				"lng": 11.456896784654733,
				"lat": 43.549043267926848
			},
			{
				"lng": 11.456898100088241,
				"lat": 43.549044368243067
			},
			{
				"lng": 11.456899423508789,
				"lat": 43.54904547777825
			},
			{
				"lng": 11.456900754917964,
				"lat": 43.549046596651806
			},
			{
				"lng": 11.456902094282867,
				"lat": 43.549047724960126
			},
			{
				"lng": 11.456903441471905,
				"lat": 43.549048862733549
			},
			{
				"lng": 11.456904796335758,
				"lat": 43.549050009990765
			},
			{
				"lng": 11.4569061587253,
				"lat": 43.549051166750331
			},
			{
				"lng": 11.456907528491261,
				"lat": 43.549052333030872
			},
			{
				"lng": 11.456908905484422,
				"lat": 43.549053508850918
			},
			{
				"lng": 11.456910289555596,
				"lat": 43.549054694229149
			},
			{
				"lng": 11.456911680555489,
				"lat": 43.549055889184224
			},
			{
				"lng": 11.456913078334935,
				"lat": 43.549057093734753
			},
			{
				"lng": 11.456914482744702,
				"lat": 43.549058307899266
			},
			{
				"lng": 11.456915893635582,
				"lat": 43.549059531696379
			},
			{
				"lng": 11.4569173108583,
				"lat": 43.549060765144802
			},
			{
				"lng": 11.456918734263688,
				"lat": 43.549062008263022
			},
			{
				"lng": 11.456920163702511,
				"lat": 43.549063261069747
			},
			{
				"lng": 11.456921599025542,
				"lat": 43.549064523583503
			},
			{
				"lng": 11.456923040083543,
				"lat": 43.54906579582299
			},
			{
				"lng": 11.456924486727326,
				"lat": 43.549067077806733
			},
			{
				"lng": 11.456925938807652,
				"lat": 43.549068369553495
			},
			{
				"lng": 11.456927396175308,
				"lat": 43.549069671081703
			},
			{
				"lng": 11.456928858681051,
				"lat": 43.549070982410036
			},
			{
				"lng": 11.456930326175655,
				"lat": 43.549072303557182
			},
			{
				"lng": 11.456931798509929,
				"lat": 43.549073634541671
			},
			{
				"lng": 11.456933275534645,
				"lat": 43.549074975382105
			},
			{
				"lng": 11.45693475710056,
				"lat": 43.549076326097179
			},
			{
				"lng": 11.456936243058488,
				"lat": 43.549077686705395
			},
			{
				"lng": 11.456937733259151,
				"lat": 43.549079057225462
			},
			{
				"lng": 11.456939227553349,
				"lat": 43.549080437675912
			},
			{
				"lng": 11.456940725791918,
				"lat": 43.549081828075479
			},
			{
				"lng": 11.456942227825545,
				"lat": 43.549083228442562
			},
			{
				"lng": 11.456943733505099,
				"lat": 43.549084638795982
			},
			{
				"lng": 11.456945242681302,
				"lat": 43.549086059154241
			},
			{
				"lng": 11.45694675520491,
				"lat": 43.549087489536056
			},
			{
				"lng": 11.456948270926736,
				"lat": 43.549088929959886
			},
			{
				"lng": 11.456949789697569,
				"lat": 43.549090380444419
			},
			{
				"lng": 11.456951311368162,
				"lat": 43.549091841008277
			},
			{
				"lng": 11.456952835789314,
				"lat": 43.549093311670084
			},
			{
				"lng": 11.456954362811793,
				"lat": 43.549094792448436
			},
			{
				"lng": 11.456955892286368,
				"lat": 43.549096283361934
			},
			{
				"lng": 11.456957424063832,
				"lat": 43.549097784429229
			},
			{
				"lng": 11.45695895799494,
				"lat": 43.549099295668853
			},
			{
				"lng": 11.456960493930497,
				"lat": 43.549100817099472
			},
			{
				"lng": 11.456962031721279,
				"lat": 43.549102348739702
			},
			{
				"lng": 11.456963571218026,
				"lat": 43.54910389060818
			},
			{
				"lng": 11.456965112271581,
				"lat": 43.549105442723388
			},
			{
				"lng": 11.45696665473265,
				"lat": 43.549107005104148
			},
			{
				"lng": 11.456968198452074,
				"lat": 43.549108577768848
			},
			{
				"lng": 11.456969743280615,
				"lat": 43.549110160736248
			},
			{
				"lng": 11.456971289068983,
				"lat": 43.549111754024921
			},
			{
				"lng": 11.456972835668065,
				"lat": 43.54911335765356
			},
			{
				"lng": 11.456974382928564,
				"lat": 43.549114971640599
			},
			{
				"lng": 11.45697593070128,
				"lat": 43.549116596004794
			},
			{
				"lng": 11.456977478836984,
				"lat": 43.549118230764698
			},
			{
				"lng": 11.456979027186486,
				"lat": 43.549119875938906
			},
			{
				"lng": 11.456980575600515,
				"lat": 43.549121531546049
			},
			{
				"lng": 11.456982123929878,
				"lat": 43.5491231976048
			},
			{
				"lng": 11.456983672025318,
				"lat": 43.549124874133682
			},
			{
				"lng": 11.456985219737696,
				"lat": 43.549126561151404
			},
			{
				"lng": 11.456986766915337,
				"lat": 43.549128258667963
			},
			{
				"lng": 11.456988313325372,
				"lat": 43.549129966403768
			},
			{
				"lng": 11.456989858635435,
				"lat": 43.549131683724191
			},
			{
				"lng": 11.45699140250704,
				"lat": 43.549133409973038
			},
			{
				"lng": 11.456992944601785,
				"lat": 43.549135144494088
			},
			{
				"lng": 11.456994484581109,
				"lat": 43.549136886631025
			},
			{
				"lng": 11.456996022106635,
				"lat": 43.549138635727765
			},
			{
				"lng": 11.456999088442306,
				"lat": 43.549142152175513
			},
			{
				"lng": 11.457002140901162,
				"lat": 43.54914568858743
			},
			{
				"lng": 11.457005176775464,
				"lat": 43.549149239713813
			},
			{
				"lng": 11.457008193357492,
				"lat": 43.549152800304817
			},
			{
				"lng": 11.457011187939596,
				"lat": 43.549156365110548
			},
			{
				"lng": 11.457014157814065,
				"lat": 43.54915992888138
			},
			{
				"lng": 11.457017100273157,
				"lat": 43.549163486367398
			},
			{
				"lng": 11.457018560375801,
				"lat": 43.549165261112982
			},
			{
				"lng": 11.457020012609199,
				"lat": 43.549167032318771
			},
			{
				"lng": 11.457021456634902,
				"lat": 43.549168799328392
			},
			{
				"lng": 11.457022892114466,
				"lat": 43.549170561485745
			},
			{
				"lng": 11.457024318709408,
				"lat": 43.549172318134488
			},
			{
				"lng": 11.457025736081258,
				"lat": 43.549174068618498
			},
			{
				"lng": 11.457027143891585,
				"lat": 43.549175812281483
			},
			{
				"lng": 11.457028541801895,
				"lat": 43.549177548467235
			},
			{
				"lng": 11.457029929473704,
				"lat": 43.549179276519496
			},
			{
				"lng": 11.457031306568593,
				"lat": 43.549180995782137
			},
			{
				"lng": 11.457032672748078,
				"lat": 43.549182705598831
			},
			{
				"lng": 11.457034027673698,
				"lat": 43.549184405313412
			},
			{
				"lng": 11.457035371006988,
				"lat": 43.549186094269643
			},
			{
				"lng": 11.4570367024095,
				"lat": 43.549187771811262
			},
			{
				"lng": 11.457038021542704,
				"lat": 43.549189437282102
			},
			{
				"lng": 11.457039328068234,
				"lat": 43.549191090025921
			},
			{
				"lng": 11.457040621647552,
				"lat": 43.549192729386476
			},
			{
				"lng": 11.457041901942221,
				"lat": 43.549194354707524
			},
			{
				"lng": 11.457043168613772,
				"lat": 43.549195965332913
			},
			{
				"lng": 11.457044421323744,
				"lat": 43.549197560606309
			},
			{
				"lng": 11.457045659733677,
				"lat": 43.54919913987159
			},
			{
				"lng": 11.45704688350507,
				"lat": 43.549200702472447
			},
			{
				"lng": 11.457048092299484,
				"lat": 43.549202247752767
			},
			{
				"lng": 11.457049285778458,
				"lat": 43.549203775056149
			},
			{
				"lng": 11.457050463603546,
				"lat": 43.549205283726508
			},
			{
				"lng": 11.457051625436222,
				"lat": 43.54920677310762
			},
			{
				"lng": 11.45705277093808,
				"lat": 43.549208242543195
			},
			{
				"lng": 11.457053899770617,
				"lat": 43.549209691377072
			},
			{
				"lng": 11.457055011595406,
				"lat": 43.549211118952947
			},
			{
				"lng": 11.457056106073932,
				"lat": 43.549212524614646
			},
			{
				"lng": 11.457056646702604,
				"lat": 43.549213219022576
			},
			{
				"lng": 11.457057182867791,
				"lat": 43.549213907705948
			},
			{
				"lng": 11.457057714527163,
				"lat": 43.549214590582601
			},
			{
				"lng": 11.457058241638455,
				"lat": 43.549215267570602
			},
			{
				"lng": 11.457058764159342,
				"lat": 43.549215938587864
			},
			{
				"lng": 11.457059282047489,
				"lat": 43.549216603552402
			},
			{
				"lng": 11.457059795260623,
				"lat": 43.549217262382129
			},
			{
				"lng": 11.457060303756428,
				"lat": 43.549217914995111
			},
			{
				"lng": 11.457060807492597,
				"lat": 43.549218561309239
			},
			{
				"lng": 11.457061306426818,
				"lat": 43.549219201242487
			},
			{
				"lng": 11.457061800516765,
				"lat": 43.549219834712893
			},
			{
				"lng": 11.457062289720172,
				"lat": 43.549220461638363
			},
			{
				"lng": 11.457062773994657,
				"lat": 43.549221081936885
			},
			{
				"lng": 11.457063253297987,
				"lat": 43.549221695526469
			},
			{
				"lng": 11.457063727589867,
				"lat": 43.54922230232787
			},
			{
				"lng": 11.457064196885621,
				"lat": 43.549222902339523
			},
			{
				"lng": 11.457064661261542,
				"lat": 43.549223495644689
			},
			{
				"lng": 11.457065120797026,
				"lat": 43.549224082331179
			},
			{
				"lng": 11.457065575571477,
				"lat": 43.549224662486623
			},
			{
				"lng": 11.457066025664258,
				"lat": 43.549225236198801
			},
			{
				"lng": 11.457066471154798,
				"lat": 43.549225803555345
			},
			{
				"lng": 11.457066912122459,
				"lat": 43.549226364644056
			},
			{
				"lng": 11.457067348646703,
				"lat": 43.549226919552531
			},
			{
				"lng": 11.457067780806854,
				"lat": 43.549227468368549
			},
			{
				"lng": 11.457068208682319,
				"lat": 43.549228011179878
			},
			{
				"lng": 11.457068632352568,
				"lat": 43.549228548074055
			},
			{
				"lng": 11.457069467394756,
				"lat": 43.549229604462113
			},
			{
				"lng": 11.457070286568594,
				"lat": 43.549230638234498
			},
			{
				"lng": 11.457071090509272,
				"lat": 43.549231650092821
			},
			{
				"lng": 11.457071879851966,
				"lat": 43.549232640738673
			},
			{
				"lng": 11.457072655231833,
				"lat": 43.549233610873813
			},
			{
				"lng": 11.457073417284013,
				"lat": 43.54923456119991
			},
			{
				"lng": 11.457074166643723,
				"lat": 43.549235492418511
			},
			{
				"lng": 11.457074903946106,
				"lat": 43.549236405231397
			},
			{
				"lng": 11.457075629826301,
				"lat": 43.549237300340202
			},
			{
				"lng": 11.457076344919564,
				"lat": 43.549238178446579
			},
			{
				"lng": 11.457077049860953,
				"lat": 43.549239040252139
			},
			{
				"lng": 11.457077745285702,
				"lat": 43.549239886458679
			},
			{
				"lng": 11.457078431828993,
				"lat": 43.549240717767653
			},
			{
				"lng": 11.457079110125971,
				"lat": 43.549241534880906
			},
			{
				"lng": 11.457079780811778,
				"lat": 43.549242338500036
			},
			{
				"lng": 11.457080444521628,
				"lat": 43.549243129326648
			},
			{
				"lng": 11.457081101890715,
				"lat": 43.549243908062522
			},
			{
				"lng": 11.457081753554121,
				"lat": 43.549244675409277
			},
			{
				"lng": 11.457082400147108,
				"lat": 43.549245432068503
			},
			{
				"lng": 11.457083042304774,
				"lat": 43.549246178741896
			},
			{
				"lng": 11.45708368066231,
				"lat": 43.549246916131182
			},
			{
				"lng": 11.45708431585491,
				"lat": 43.549247644937985
			},
			{
				"lng": 11.457084948517714,
				"lat": 43.54924836586391
			},
			{
				"lng": 11.457086208794681,
				"lat": 43.549249786879976
			},
			{
				"lng": 11.457087466574556,
				"lat": 43.54925118479261
			},
			{
				"lng": 11.457088726938704,
				"lat": 43.549252565215234
			},
			{
				"lng": 11.457089994968472,
				"lat": 43.549253933761022
			},
			{
				"lng": 11.457091275745276,
				"lat": 43.549255296043235
			},
			{
				"lng": 11.457092574350423,
				"lat": 43.549256657675329
			},
			{
				"lng": 11.457093895865322,
				"lat": 43.549258024270429
			},
			{
				"lng": 11.457095245371301,
				"lat": 43.549259401441944
			},
			{
				"lng": 11.457095932208885,
				"lat": 43.54926009574794
			},
			{
				"lng": 11.457096627949735,
				"lat": 43.549260794803089
			},
			{
				"lng": 11.457097333229054,
				"lat": 43.549261499308891
			},
			{
				"lng": 11.457098048682035,
				"lat": 43.549262209967146
			},
			{
				"lng": 11.457098774943812,
				"lat": 43.549262927479504
			},
			{
				"lng": 11.457099512649542,
				"lat": 43.549263652547481
			},
			{
				"lng": 11.45710026243442,
				"lat": 43.549264385872888
			},
			{
				"lng": 11.45710102493361,
				"lat": 43.549265128157373
			},
			{
				"lng": 11.457101800782311,
				"lat": 43.549265880102546
			},
			{
				"lng": 11.457102590615667,
				"lat": 43.549266642410061
			},
			{
				"lng": 11.457103395068831,
				"lat": 43.549267415781578
			},
			{
				"lng": 11.457104214777029,
				"lat": 43.549268200918846
			},
			{
				"lng": 11.457105050375343,
				"lat": 43.549268998523416
			},
			{
				"lng": 11.457105902266646,
				"lat": 43.549269809077963
			},
			{
				"lng": 11.457106770034477,
				"lat": 43.549270632293322
			},
			{
				"lng": 11.457107653082199,
				"lat": 43.549271467710284
			},
			{
				"lng": 11.457108550813112,
				"lat": 43.549272314869697
			},
			{
				"lng": 11.457109462630461,
				"lat": 43.549273173312393
			},
			{
				"lng": 11.457110387937545,
				"lat": 43.549274042579221
			},
			{
				"lng": 11.457111326137682,
				"lat": 43.549274922210977
			},
			{
				"lng": 11.457112276634144,
				"lat": 43.549275811748466
			},
			{
				"lng": 11.45711323883021,
				"lat": 43.549276710732556
			},
			{
				"lng": 11.457114212129197,
				"lat": 43.549277618704082
			},
			{
				"lng": 11.457115195934357,
				"lat": 43.549278535203825
			},
			{
				"lng": 11.457116189648968,
				"lat": 43.549279459772656
			},
			{
				"lng": 11.457117192676403,
				"lat": 43.54928039195142
			},
			{
				"lng": 11.457118204419865,
				"lat": 43.549281331280923
			},
			{
				"lng": 11.457119224282682,
				"lat": 43.549282277301963
			},
			{
				"lng": 11.457120251668153,
				"lat": 43.549283229555371
			},
			{
				"lng": 11.457121285979536,
				"lat": 43.549284187582018
			},
			{
				"lng": 11.457123372993266,
				"lat": 43.549286119118356
			},
			{
				"lng": 11.457125480550115,
				"lat": 43.549288068237537
			},
			{
				"lng": 11.457127603876488,
				"lat": 43.549290031266167
			},
			{
				"lng": 11.457129738198633,
				"lat": 43.549292004530876
			},
			{
				"lng": 11.457131878742898,
				"lat": 43.549293984358329
			},
			{
				"lng": 11.457136159402948,
				"lat": 43.549297949008086
			},
			{
				"lng": 11.457138289971329,
				"lat": 43.549299926483592
			},
			{
				"lng": 11.45714040766701,
				"lat": 43.5493018958284
			},
			{
				"lng": 11.457142507716316,
				"lat": 43.549303853369125
			},
			{
				"lng": 11.457144585345533,
				"lat": 43.54930579543236
			},
			{
				"lng": 11.457145614260847,
				"lat": 43.549306759512078
			},
			{
				"lng": 11.457146635780996,
				"lat": 43.549307718344878
			},
			{
				"lng": 11.457147649309274,
				"lat": 43.549308671471579
			},
			{
				"lng": 11.457148654248964,
				"lat": 43.549309618433114
			},
			{
				"lng": 11.457149650003368,
				"lat": 43.54931055877028
			},
			{
				"lng": 11.457150635975742,
				"lat": 43.54931149202389
			},
			{
				"lng": 11.457151611569413,
				"lat": 43.549312417734768
			},
			{
				"lng": 11.45715257618763,
				"lat": 43.54931333544377
			},
			{
				"lng": 11.457153529233697,
				"lat": 43.549314244691665
			},
			{
				"lng": 11.457154470110895,
				"lat": 43.549315145019371
			},
			{
				"lng": 11.457155398222525,
				"lat": 43.549316035967635
			},
			{
				"lng": 11.457156312971897,
				"lat": 43.549316917077313
			},
			{
				"lng": 11.457157213762221,
				"lat": 43.549317787889308
			},
			{
				"lng": 11.457158099996878,
				"lat": 43.549318647944311
			},
			{
				"lng": 11.457158971079062,
				"lat": 43.549319496783284
			},
			{
				"lng": 11.457159826412123,
				"lat": 43.549320333947001
			},
			{
				"lng": 11.457160665399327,
				"lat": 43.549321158976262
			},
			{
				"lng": 11.457161487443965,
				"lat": 43.549321971411906
			},
			{
				"lng": 11.457162291955651,
				"lat": 43.549322770799577
			},
			{
				"lng": 11.457163078676457,
				"lat": 43.549323556934212
			},
			{
				"lng": 11.457163847838864,
				"lat": 43.549324329978575
			},
			{
				"lng": 11.45716459971452,
				"lat": 43.549325090124995
			},
			{
				"lng": 11.457165334575224,
				"lat": 43.549325837565668
			},
			{
				"lng": 11.457166052692713,
				"lat": 43.549326572492966
			},
			{
				"lng": 11.457166754338779,
				"lat": 43.549327295099246
			},
			{
				"lng": 11.457167439785096,
				"lat": 43.549328005576555
			},
			{
				"lng": 11.45716810930343,
				"lat": 43.549328704117393
			},
			{
				"lng": 11.457168763165559,
				"lat": 43.549329390914011
			},
			{
				"lng": 11.45716940164322,
				"lat": 43.549330066158625
			},
			{
				"lng": 11.457170025008141,
				"lat": 43.549330730043593
			},
			{
				"lng": 11.457170633532087,
				"lat": 43.549331382761174
			},
			{
				"lng": 11.457171227486821,
				"lat": 43.549332024503656
			},
			{
				"lng": 11.457171807144036,
				"lat": 43.549332655463353
			},
			{
				"lng": 11.457172372775549,
				"lat": 43.549333275832481
			},
			{
				"lng": 11.457172924653042,
				"lat": 43.549333885803421
			},
			{
				"lng": 11.457173463048314,
				"lat": 43.549334485568387
			},
			{
				"lng": 11.457173988233119,
				"lat": 43.549335075319718
			},
			{
				"lng": 11.457174500479134,
				"lat": 43.549335655249699
			},
			{
				"lng": 11.457175000058172,
				"lat": 43.549336225550583
			},
			{
				"lng": 11.457175487241965,
				"lat": 43.549336786414671
			},
			{
				"lng": 11.457175962302269,
				"lat": 43.549337338034242
			},
			{
				"lng": 11.457176425510793,
				"lat": 43.549337880601591
			},
			{
				"lng": 11.457176877139331,
				"lat": 43.54933841430902
			},
			{
				"lng": 11.457177317459577,
				"lat": 43.549338939348807
			},
			{
				"lng": 11.457177746743369,
				"lat": 43.54933945591327
			},
			{
				"lng": 11.457178165262381,
				"lat": 43.54933996419458
			},
			{
				"lng": 11.45717857328837,
				"lat": 43.54934046438516
			},
			{
				"lng": 11.457178971093105,
				"lat": 43.549340956677291
			},
			{
				"lng": 11.457179358948306,
				"lat": 43.549341441263152
			},
			{
				"lng": 11.457179737125751,
				"lat": 43.549341918335124
			},
			{
				"lng": 11.457180105897185,
				"lat": 43.549342388085456
			},
			{
				"lng": 11.457180465534332,
				"lat": 43.549342850706488
			},
			{
				"lng": 11.45718081630897,
				"lat": 43.54934330639044
			},
			{
				"lng": 11.457181158492826,
				"lat": 43.549343755329581
			},
			{
				"lng": 11.457181492357654,
				"lat": 43.549344197716302
			},
			{
				"lng": 11.457181818175192,
				"lat": 43.549344633742813
			},
			{
				"lng": 11.457182136217245,
				"lat": 43.549345063601415
			},
			{
				"lng": 11.457182446755455,
				"lat": 43.549345487484445
			},
			{
				"lng": 11.45718275006168,
				"lat": 43.549345905584111
			},
			{
				"lng": 11.457183046407604,
				"lat": 43.549346318092702
			},
			{
				"lng": 11.457183336064977,
				"lat": 43.549346725202597
			},
			{
				"lng": 11.457183619305562,
				"lat": 43.549347127105975
			},
			{
				"lng": 11.457184167623415,
				"lat": 43.549347916062551
			},
			{
				"lng": 11.457184693535051,
				"lat": 43.549348686500664
			},
			{
				"lng": 11.457185199214519,
				"lat": 43.549349439958696
			},
			{
				"lng": 11.45718568683578,
				"lat": 43.549350177974929
			},
			{
				"lng": 11.457186158572881,
				"lat": 43.549350902087639
			},
			{
				"lng": 11.457186616599737,
				"lat": 43.549351613835164
			},
			{
				"lng": 11.457187063090338,
				"lat": 43.549352314755737
			},
			{
				"lng": 11.457187500073987,
				"lat": 43.549353006319542
			},
			{
				"lng": 11.457187928610937,
				"lat": 43.54935368953975
			},
			{
				"lng": 11.457188349363349,
				"lat": 43.54935436524223
			},
			{
				"lng": 11.457188762992207,
				"lat": 43.549355034252024
			},
			{
				"lng": 11.457189170158538,
				"lat": 43.549355697394269
			},
			{
				"lng": 11.457189571523363,
				"lat": 43.54935635549419
			},
			{
				"lng": 11.457190359492342,
				"lat": 43.549357659867304
			},
			{
				"lng": 11.457191132187237,
				"lat": 43.549358953972536
			},
			{
				"lng": 11.457191894895976,
				"lat": 43.549360244410963
			},
			{
				"lng": 11.457192652906553,
				"lat": 43.549361537783611
			},
			{
				"lng": 11.457193411506971,
				"lat": 43.549362840691671
			},
			{
				"lng": 11.457194175985228,
				"lat": 43.549364159736164
			},
			{
				"lng": 11.457194562081064,
				"lat": 43.549364827372486
			},
			{
				"lng": 11.45719495162934,
				"lat": 43.549365501518317
			},
			{
				"lng": 11.457195345291078,
				"lat": 43.549366182998803
			},
			{
				"lng": 11.45719574372727,
				"lat": 43.549366872639084
			},
			{
				"lng": 11.457196147598927,
				"lat": 43.549367571264291
			},
			{
				"lng": 11.457196557567023,
				"lat": 43.549368279699621
			},
			{
				"lng": 11.457196974292609,
				"lat": 43.549368998770134
			},
			{
				"lng": 11.4571973984366,
				"lat": 43.549369729300984
			},
			{
				"lng": 11.457197830660087,
				"lat": 43.549370472117339
			},
			{
				"lng": 11.457198271624041,
				"lat": 43.549371228044272
			},
			{
				"lng": 11.457198721989441,
				"lat": 43.549371997907059
			},
			{
				"lng": 11.457199182261478,
				"lat": 43.549372782306975
			},
			{
				"lng": 11.457199652295346,
				"lat": 43.549373580912295
			},
			{
				"lng": 11.457200131776528,
				"lat": 43.549374393147588
			},
			{
				"lng": 11.457200620390713,
				"lat": 43.549375218437575
			},
			{
				"lng": 11.457201117823415,
				"lat": 43.549376056207016
			},
			{
				"lng": 11.45720162376025,
				"lat": 43.549376905880592
			},
			{
				"lng": 11.457202137886812,
				"lat": 43.549377766882984
			},
			{
				"lng": 11.45720265988866,
				"lat": 43.549378638638892
			},
			{
				"lng": 11.457203189451411,
				"lat": 43.549379520573005
			},
			{
				"lng": 11.457203726260634,
				"lat": 43.549380412110033
			},
			{
				"lng": 11.457204270001913,
				"lat": 43.549381312674683
			},
			{
				"lng": 11.457204820360866,
				"lat": 43.549382221691673
			},
			{
				"lng": 11.457205377023024,
				"lat": 43.549383138585618
			},
			{
				"lng": 11.457205939674012,
				"lat": 43.549384062781343
			},
			{
				"lng": 11.457206507999425,
				"lat": 43.549384993703462
			},
			{
				"lng": 11.457207081684805,
				"lat": 43.549385930776673
			},
			{
				"lng": 11.457207660415756,
				"lat": 43.549386873425711
			},
			{
				"lng": 11.457208831756827,
				"lat": 43.549388773150071
			},
			{
				"lng": 11.457210019507182,
				"lat": 43.549390688274016
			},
			{
				"lng": 11.457211221151608,
				"lat": 43.549392614195249
			},
			{
				"lng": 11.457212434174776,
				"lat": 43.549394546311291
			},
			{
				"lng": 11.457213656061333,
				"lat": 43.549396480019801
			},
			{
				"lng": 11.457214884296272,
				"lat": 43.549398410718645
			},
			{
				"lng": 11.45721611723714,
				"lat": 43.549400334874406
			},
			{
				"lng": 11.45721735607021,
				"lat": 43.549402252418005
			},
			{
				"lng": 11.457218602554059,
				"lat": 43.54940416398108
			},
			{
				"lng": 11.457219858447067,
				"lat": 43.549406070195218
			},
			{
				"lng": 11.457221125507795,
				"lat": 43.549407971691963
			},
			{
				"lng": 11.457222405494681,
				"lat": 43.549409869103052
			},
			{
				"lng": 11.457223700166216,
				"lat": 43.549411763060036
			},
			{
				"lng": 11.457225011280917,
				"lat": 43.549413654194502
			},
			{
				"lng": 11.457226340597236,
				"lat": 43.549415543138146
			},
			{
				"lng": 11.457227689873667,
				"lat": 43.549417430522453
			},
			{
				"lng": 11.457229060868674,
				"lat": 43.549419316979197
			},
			{
				"lng": 11.457230455340751,
				"lat": 43.549421203139765
			},
			{
				"lng": 11.45723187504843,
				"lat": 43.549423089635965
			},
			{
				"lng": 11.457233321750133,
				"lat": 43.549424977099363
			},
			{
				"lng": 11.45723479713471,
				"lat": 43.549426866275134
			},
			{
				"lng": 11.457236302023677,
				"lat": 43.549428759323376
			},
			{
				"lng": 11.457237836650247,
				"lat": 43.549430659363722
			},
			{
				"lng": 11.457239401236418,
				"lat": 43.549432569534211
			},
			{
				"lng": 11.457240194833753,
				"lat": 43.549433529398826
			},
			{
				"lng": 11.457240996004273,
				"lat": 43.549434492972729
			},
			{
				"lng": 11.457241804775659,
				"lat": 43.549435460648041
			},
			{
				"lng": 11.457242621175755,
				"lat": 43.54943643281716
			},
			{
				"lng": 11.457243445232235,
				"lat": 43.549437409872255
			},
			{
				"lng": 11.457244276972931,
				"lat": 43.549438392205516
			},
			{
				"lng": 11.457245116425563,
				"lat": 43.549439380209279
			},
			{
				"lng": 11.457245963617842,
				"lat": 43.549440374275711
			},
			{
				"lng": 11.457246818577589,
				"lat": 43.549441374797091
			},
			{
				"lng": 11.45724768133249,
				"lat": 43.549442382165658
			},
			{
				"lng": 11.457248551910338,
				"lat": 43.549443396773668
			},
			{
				"lng": 11.45724943033893,
				"lat": 43.549444419013334
			},
			{
				"lng": 11.457250316645958,
				"lat": 43.549445449276874
			},
			{
				"lng": 11.457251210859177,
				"lat": 43.549446487956601
			},
			{
				"lng": 11.45725211300636,
				"lat": 43.549447535444713
			},
			{
				"lng": 11.457253023115246,
				"lat": 43.54944859213348
			},
			{
				"lng": 11.457253941213631,
				"lat": 43.549449658415107
			},
			{
				"lng": 11.457254867329208,
				"lat": 43.549450734681855
			},
			{
				"lng": 11.457255801489749,
				"lat": 43.549451821325945
			},
			{
				"lng": 11.457256743723013,
				"lat": 43.549452918739675
			},
			{
				"lng": 11.457257694056791,
				"lat": 43.549454027315242
			},
			{
				"lng": 11.457258652503961,
				"lat": 43.549455147422137
			},
			{
				"lng": 11.457259618642002,
				"lat": 43.5494562787622
			},
			{
				"lng": 11.457260591553139,
				"lat": 43.549457420277911
			},
			{
				"lng": 11.457261570292776,
				"lat": 43.549458570870563
			},
			{
				"lng": 11.457262553916266,
				"lat": 43.549459729441502
			},
			{
				"lng": 11.457264532036303,
				"lat": 43.549462066123269
			},
			{
				"lng": 11.45726651835629,
				"lat": 43.5494644215336
			},
			{
				"lng": 11.457270485367971,
				"lat": 43.549469153381658
			},
			{
				"lng": 11.457272450945618,
				"lat": 43.549471512240146
			},
			{
				"lng": 11.45727342594626,
				"lat": 43.549472686057577
			},
			{
				"lng": 11.457274394495171,
				"lat": 43.549473854668776
			},
			{
				"lng": 11.457275355647848,
				"lat": 43.549475016975173
			},
			{
				"lng": 11.457276308459601,
				"lat": 43.549476171877963
			},
			{
				"lng": 11.457277251985799,
				"lat": 43.549477318278541
			},
			{
				"lng": 11.457278185281821,
				"lat": 43.549478455078102
			},
			{
				"lng": 11.457279107403069,
				"lat": 43.549479581178034
			},
			{
				"lng": 11.457280017404887,
				"lat": 43.549480695479566
			},
			{
				"lng": 11.457280914342643,
				"lat": 43.549481796884038
			},
			{
				"lng": 11.457281797271721,
				"lat": 43.549482884292793
			},
			{
				"lng": 11.45728266524749,
				"lat": 43.549483956606998
			},
			{
				"lng": 11.45728351732533,
				"lat": 43.549485012728113
			},
			{
				"lng": 11.457284352560551,
				"lat": 43.549486051557309
			},
			{
				"lng": 11.457285170008639,
				"lat": 43.549487071995969
			},
			{
				"lng": 11.457285968783873,
				"lat": 43.54948807302474
			},
			{
				"lng": 11.457286748863885,
				"lat": 43.549489054786036
			},
			{
				"lng": 11.457287510880994,
				"lat": 43.549490018303416
			},
			{
				"lng": 11.457288255483883,
				"lat": 43.549490964622407
			},
			{
				"lng": 11.457288983321169,
				"lat": 43.54949189478846
			},
			{
				"lng": 11.457289695041498,
				"lat": 43.549492809847045
			},
			{
				"lng": 11.45729039129353,
				"lat": 43.549493710843606
			},
			{
				"lng": 11.457291072725871,
				"lat": 43.549494598823685
			},
			{
				"lng": 11.457291739987168,
				"lat": 43.549495474832746
			},
			{
				"lng": 11.457292393726092,
				"lat": 43.549496339916274
			},
			{
				"lng": 11.45729303459124,
				"lat": 43.549497195119734
			},
			{
				"lng": 11.457293663231267,
				"lat": 43.549498041488562
			},
			{
				"lng": 11.45729428029486,
				"lat": 43.549498880068334
			},
			{
				"lng": 11.457294886430613,
				"lat": 43.549499711904438
			},
			{
				"lng": 11.45729548228716,
				"lat": 43.549500538042409
			},
			{
				"lng": 11.457296068513166,
				"lat": 43.549501359527731
			},
			{
				"lng": 11.457296645757266,
				"lat": 43.549502177405842
			},
			{
				"lng": 11.457297214668124,
				"lat": 43.549502992722246
			},
			{
				"lng": 11.457298330084551,
				"lat": 43.549504619851859
			},
			{
				"lng": 11.457299419951601,
				"lat": 43.549506249280327
			},
			{
				"lng": 11.457300489458468,
				"lat": 43.549507889371569
			},
			{
				"lng": 11.457301543794204,
				"lat": 43.549509548489382
			},
			{
				"lng": 11.457302066894538,
				"lat": 43.54951038779695
			},
			{
				"lng": 11.457302588148009,
				"lat": 43.54951123499756
			},
			{
				"lng": 11.457303108203281,
				"lat": 43.549512091136819
			},
			{
				"lng": 11.457303627652395,
				"lat": 43.54951295716004
			},
			{
				"lng": 11.457304146612383,
				"lat": 43.54951383317249
			},
			{
				"lng": 11.4573046649624,
				"lat": 43.549514718859157
			},
			{
				"lng": 11.457305182579923,
				"lat": 43.549515613901761
			},
			{
				"lng": 11.457305699342486,
				"lat": 43.549516517982106
			},
			{
				"lng": 11.457306215127575,
				"lat": 43.549517430781975
			},
			{
				"lng": 11.457306729812609,
				"lat": 43.549518351983274
			},
			{
				"lng": 11.457307243275148,
				"lat": 43.549519281267713
			},
			{
				"lng": 11.45730775539265,
				"lat": 43.54952021831707
			},
			{
				"lng": 11.457308266042567,
				"lat": 43.5495211628132
			},
			{
				"lng": 11.457308775102421,
				"lat": 43.549522114437927
			},
			{
				"lng": 11.457309282449687,
				"lat": 43.549523072872994
			},
			{
				"lng": 11.457309787961856,
				"lat": 43.549524037800218
			},
			{
				"lng": 11.457310792990812,
				"lat": 43.549525985858381
			},
			{
				"lng": 11.457311789209184,
				"lat": 43.549527956066811
			},
			{
				"lng": 11.457312775636835,
				"lat": 43.549529945879911
			},
			{
				"lng": 11.45731375129361,
				"lat": 43.549531952752083
			},
			{
				"lng": 11.457314715199445,
				"lat": 43.549533974137773
			},
			{
				"lng": 11.457315666374146,
				"lat": 43.549536007491348
			},
			{
				"lng": 11.457316603837684,
				"lat": 43.549538050267216
			},
			{
				"lng": 11.457317526609827,
				"lat": 43.549540099919895
			},
			{
				"lng": 11.457318433705774,
				"lat": 43.549542153650393
			},
			{
				"lng": 11.457319324118988,
				"lat": 43.549544207510351
			},
			{
				"lng": 11.457320196836916,
				"lat": 43.549546257225153
			},
			{
				"lng": 11.457321050846977,
				"lat": 43.549548298519973
			},
			{
				"lng": 11.457321885136516,
				"lat": 43.549550327120158
			},
			{
				"lng": 11.45732269869294,
				"lat": 43.549552338750971
			},
			{
				"lng": 11.457323097379792,
				"lat": 43.549553336867028
			},
			{
				"lng": 11.457323490503661,
				"lat": 43.549554329137727
			},
			{
				"lng": 11.457323877937947,
				"lat": 43.549555315028712
			},
			{
				"lng": 11.457324259556076,
				"lat": 43.549556294005697
			},
			{
				"lng": 11.45732463523149,
				"lat": 43.549557265534283
			},
			{
				"lng": 11.457325004837605,
				"lat": 43.549558229080183
			},
			{
				"lng": 11.457325368247819,
				"lat": 43.549559184109036
			},
			{
				"lng": 11.457325725335602,
				"lat": 43.54956013008654
			},
			{
				"lng": 11.457326075974329,
				"lat": 43.549561066478269
			},
			{
				"lng": 11.457326420037472,
				"lat": 43.549561992749979
			},
			{
				"lng": 11.457326757398441,
				"lat": 43.549562908367236
			},
			{
				"lng": 11.457327087930649,
				"lat": 43.549563812795782
			},
			{
				"lng": 11.457327411507528,
				"lat": 43.549564705501218
			},
			{
				"lng": 11.457327728002515,
				"lat": 43.549565585949246
			},
			{
				"lng": 11.45732803728901,
				"lat": 43.549566453605536
			},
			{
				"lng": 11.457328339240433,
				"lat": 43.549567307935732
			},
			{
				"lng": 11.457328633730238,
				"lat": 43.549568148405548
			},
			{
				"lng": 11.457328920717774,
				"lat": 43.549568974656616
			},
			{
				"lng": 11.457329200440501,
				"lat": 43.54956978690079
			},
			{
				"lng": 11.457329473192209,
				"lat": 43.549570585465389
			},
			{
				"lng": 11.457329739266742,
				"lat": 43.549571370677626
			},
			{
				"lng": 11.457329998957913,
				"lat": 43.549572142864776
			},
			{
				"lng": 11.457330252559526,
				"lat": 43.549572902353979
			},
			{
				"lng": 11.457330500365387,
				"lat": 43.549573649472642
			},
			{
				"lng": 11.457330742669301,
				"lat": 43.549574384547775
			},
			{
				"lng": 11.457330979765052,
				"lat": 43.549575107906911
			},
			{
				"lng": 11.457331211946521,
				"lat": 43.549575819877013
			},
			{
				"lng": 11.457331439507412,
				"lat": 43.54957652078555
			},
			{
				"lng": 11.457331662741613,
				"lat": 43.54957721095964
			},
			{
				"lng": 11.457331881942943,
				"lat": 43.549577890726511
			},
			{
				"lng": 11.457332097405095,
				"lat": 43.549578560413508
			},
			{
				"lng": 11.457332309422046,
				"lat": 43.549579220347852
			},
			{
				"lng": 11.45733251828749,
				"lat": 43.549579870856633
			},
			{
				"lng": 11.45733272429521,
				"lat": 43.549580512267305
			},
			{
				"lng": 11.457332927739104,
				"lat": 43.549581144907023
			},
			{
				"lng": 11.457333128912937,
				"lat": 43.549581769103035
			},
			{
				"lng": 11.457333328110547,
				"lat": 43.549582385182561
			},
			{
				"lng": 11.457333525625682,
				"lat": 43.549582993472846
			},
			{
				"lng": 11.457333721752191,
				"lat": 43.54958359430119
			},
			{
				"lng": 11.457333916783909,
				"lat": 43.549584187994824
			},
			{
				"lng": 11.457334304738053,
				"lat": 43.549585355286695
			},
			{
				"lng": 11.457334691838611,
				"lat": 43.549586497966658
			},
			{
				"lng": 11.457335080436016,
				"lat": 43.549587618653284
			},
			{
				"lng": 11.457335472851376,
				"lat": 43.549588720737724
			},
			{
				"lng": 11.457335871321595,
				"lat": 43.549589809822194
			},
			{
				"lng": 11.457336278068718,
				"lat": 43.549590891902341
			},
			{
				"lng": 11.457336695314783,
				"lat": 43.549591972973865
			},
			{
				"lng": 11.457337125281777,
				"lat": 43.549593059032254
			},
			{
				"lng": 11.457337570191756,
				"lat": 43.549594156073212
			},
			{
				"lng": 11.457338032266691,
				"lat": 43.549595270092354
			},
			{
				"lng": 11.457338270435427,
				"lat": 43.549595835342323
			},
			{
				"lng": 11.457338513728637,
				"lat": 43.549596407085239
			},
			{
				"lng": 11.457338762424119,
				"lat": 43.549596986070455
			},
			{
				"lng": 11.457339016799597,
				"lat": 43.549597573047521
			},
			{
				"lng": 11.457339277132856,
				"lat": 43.549598168765833
			},
			{
				"lng": 11.457339543701595,
				"lat": 43.549598773974765
			},
			{
				"lng": 11.457339816783639,
				"lat": 43.549599389423975
			},
			{
				"lng": 11.457340096656649,
				"lat": 43.549600015862694
			},
			{
				"lng": 11.457340383598494,
				"lat": 43.549600654040546
			},
			{
				"lng": 11.457340677886817,
				"lat": 43.549601304706876
			},
			{
				"lng": 11.457340979799437,
				"lat": 43.549601968611192
			},
			{
				"lng": 11.45734128961408,
				"lat": 43.549602646502919
			},
			{
				"lng": 11.457341607608493,
				"lat": 43.549603339131522
			},
			{
				"lng": 11.457341934060462,
				"lat": 43.549604047246405
			},
			{
				"lng": 11.457342269242334,
				"lat": 43.549604771589188
			},
			{
				"lng": 11.457342613191473,
				"lat": 43.549605512551651
			},
			{
				"lng": 11.457342965623647,
				"lat": 43.549606270047931
			},
			{
				"lng": 11.45734332623133,
				"lat": 43.549607043957202
			},
			{
				"lng": 11.457343694707074,
				"lat": 43.549607834158905
			},
			{
				"lng": 11.4573440707434,
				"lat": 43.549608640532405
			},
			{
				"lng": 11.457344454032857,
				"lat": 43.549609462956951
			},
			{
				"lng": 11.457344844267894,
				"lat": 43.549610301312029
			},
			{
				"lng": 11.457345241141041,
				"lat": 43.549611155476853
			},
			{
				"lng": 11.457345644344901,
				"lat": 43.549612025330909
			},
			{
				"lng": 11.457346053571939,
				"lat": 43.549612910753495
			},
			{
				"lng": 11.457346468514698,
				"lat": 43.549613811623942
			},
			{
				"lng": 11.457346888865654,
				"lat": 43.549614727821655
			},
			{
				"lng": 11.457347314317378,
				"lat": 43.549615659225978
			},
			{
				"lng": 11.457347744562362,
				"lat": 43.549616605716238
			},
			{
				"lng": 11.457348179293156,
				"lat": 43.549617567171801
			},
			{
				"lng": 11.457348618202255,
				"lat": 43.549618543472015
			},
			{
				"lng": 11.457349060982207,
				"lat": 43.549619534496237
			},
			{
				"lng": 11.457349507325535,
				"lat": 43.549620540123883
			},
			{
				"lng": 11.457349956924718,
				"lat": 43.549621560234165
			},
			{
				"lng": 11.457350409472308,
				"lat": 43.549622594706591
			},
			{
				"lng": 11.457350864660846,
				"lat": 43.549623643420382
			},
			{
				"lng": 11.457351322182813,
				"lat": 43.549624706255095
			},
			{
				"lng": 11.457351781730756,
				"lat": 43.549625783089823
			},
			{
				"lng": 11.457352242997187,
				"lat": 43.549626873804065
			},
			{
				"lng": 11.457352705674648,
				"lat": 43.549627978277201
			},
			{
				"lng": 11.457353169455629,
				"lat": 43.549629096388529
			},
			{
				"lng": 11.457353634032698,
				"lat": 43.549630228017428
			},
			{
				"lng": 11.457354099098298,
				"lat": 43.549631373043241
			},
			{
				"lng": 11.457354564346245,
				"lat": 43.549632531315929
			},
			{
				"lng": 11.457355029494726,
				"lat": 43.549633702109766
			},
			{
				"lng": 11.457355494284025,
				"lat": 43.549634884173798
			},
			{
				"lng": 11.457355958455375,
				"lat": 43.54963607623791
			},
			{
				"lng": 11.457356421749937,
				"lat": 43.549637277031913
			},
			{
				"lng": 11.457357344673554,
				"lat": 43.549639699728829
			},
			{
				"lng": 11.457358260984302,
				"lat": 43.549642142103281
			},
			{
				"lng": 11.45735916861174,
				"lat": 43.549644593993939
			},
			{
				"lng": 11.45736006548532,
				"lat": 43.549647045239375
			},
			{
				"lng": 11.457360949534559,
				"lat": 43.549649485678302
			},
			{
				"lng": 11.457361386103008,
				"lat": 43.549650698669872
			},
			{
				"lng": 11.457361818688911,
				"lat": 43.549651905149346
			},
			{
				"lng": 11.457362247033476,
				"lat": 43.549653103846538
			},
			{
				"lng": 11.457362670877899,
				"lat": 43.54965429349118
			},
			{
				"lng": 11.457363089963357,
				"lat": 43.549655472813235
			},
			{
				"lng": 11.457363504031019,
				"lat": 43.549656640542452
			},
			{
				"lng": 11.457363912822077,
				"lat": 43.54965779540872
			},
			{
				"lng": 11.457364316077744,
				"lat": 43.549658936141824
			},
			{
				"lng": 11.457364713539175,
				"lat": 43.549660061471663
			},
			{
				"lng": 11.45736510494754,
				"lat": 43.549661170127997
			},
			{
				"lng": 11.45736549004407,
				"lat": 43.54966226084067
			},
			{
				"lng": 11.457365868569919,
				"lat": 43.549663332339513
			},
			{
				"lng": 11.457366240266319,
				"lat": 43.549664383354411
			},
			{
				"lng": 11.45736660487441,
				"lat": 43.549665412615113
			},
			{
				"lng": 11.457366962282661,
				"lat": 43.549666418418795
			},
			{
				"lng": 11.457367138685065,
				"lat": 43.549666910719409
			},
			{
				"lng": 11.457367313953503,
				"lat": 43.549667394437499
			},
			{
				"lng": 11.457367488391577,
				"lat": 43.549667868426802
			},
			{
				"lng": 11.457367662302982,
				"lat": 43.54966833154127
			},
			{
				"lng": 11.457367835991393,
				"lat": 43.549668782634789
			},
			{
				"lng": 11.457368009760451,
				"lat": 43.549669220561157
			},
			{
				"lng": 11.457368183913834,
				"lat": 43.549669644174323
			},
			{
				"lng": 11.457368358755252,
				"lat": 43.549670052328075
			},
			{
				"lng": 11.457368534588298,
				"lat": 43.549670443876337
			},
			{
				"lng": 11.457368711716679,
				"lat": 43.549670817672961
			},
			{
				"lng": 11.457368890444091,
				"lat": 43.549671172571841
			},
			{
				"lng": 11.457369071074185,
				"lat": 43.549671507426773
			},
			{
				"lng": 11.457369253910572,
				"lat": 43.549671821091721
			},
			{
				"lng": 11.457369439256984,
				"lat": 43.549672112420467
			},
			{
				"lng": 11.457369627417101,
				"lat": 43.549672380266962
			},
			{
				"lng": 11.457369818694541,
				"lat": 43.549672623485044
			},
			{
				"lng": 11.457369915597171,
				"lat": 43.549672735500224
			},
			{
				"lng": 11.457370013392987,
				"lat": 43.549672840928544
			},
			{
				"lng": 11.457370112120017,
				"lat": 43.549672939626674
			},
			{
				"lng": 11.457370211816134,
				"lat": 43.549673031451363
			},
			{
				"lng": 11.457370312519364,
				"lat": 43.549673116259335
			},
			{
				"lng": 11.457370414267629,
				"lat": 43.549673193907346
			},
			{
				"lng": 11.457370517098891,
				"lat": 43.549673264252164
			},
			{
				"lng": 11.457370621051121,
				"lat": 43.549673327150437
			},
			{
				"lng": 11.457370726162294,
				"lat": 43.54967338245892
			},
			{
				"lng": 11.457370832470303,
				"lat": 43.54967343003441
			},
			{
				"lng": 11.457370940013192,
				"lat": 43.549673469733541
			},
			{
				"lng": 11.457371048828858,
				"lat": 43.549673501413203
			},
			{
				"lng": 11.457371158955301,
				"lat": 43.54967352492995
			},
			{
				"lng": 11.457371270430432,
				"lat": 43.549673540140589
			},
			{
				"lng": 11.457371383292244,
				"lat": 43.549673546901886
			},
			{
				"lng": 11.457371497578681,
				"lat": 43.54967354507054
			},
			{
				"lng": 11.457371613327728,
				"lat": 43.549673534503327
			},
			{
				"lng": 11.457371730577311,
				"lat": 43.549673515056945
			},
			{
				"lng": 11.457371849365391,
				"lat": 43.549673486588084
			},
			{
				"lng": 11.45737196972993,
				"lat": 43.549673448953541
			},
			{
				"lng": 11.457372091708908,
				"lat": 43.549673402010065
			},
			{
				"lng": 11.45737221534027,
				"lat": 43.549673345614345
			},
			{
				"lng": 11.457372340662001,
				"lat": 43.549673279623072
			},
			{
				"lng": 11.457372467711977,
				"lat": 43.549673203893086
			},
			{
				"lng": 11.457372596528236,
				"lat": 43.549673118281049
			},
			{
				"lng": 11.45737272714871,
				"lat": 43.549673022643788
			},
			{
				"lng": 11.457372859611366,
				"lat": 43.549672916837856
			},
			{
				"lng": 11.457372993954117,
				"lat": 43.549672800720103
			},
			{
				"lng": 11.457373130214984,
				"lat": 43.54967267414726
			},
			{
				"lng": 11.45737326843191,
				"lat": 43.549672536976132
			},
			{
				"lng": 11.457373408642832,
				"lat": 43.549672389063296
			},
			{
				"lng": 11.457373550885745,
				"lat": 43.549672230265614
			},
			{
				"lng": 11.457373695198557,
				"lat": 43.549672060439718
			},
			{
				"lng": 11.457373841619258,
				"lat": 43.549671879442421
			},
			{
				"lng": 11.457373990185802,
				"lat": 43.549671687130463
			},
			{
				"lng": 11.457374140936144,
				"lat": 43.549671483360477
			},
			{
				"lng": 11.45737429390825,
				"lat": 43.549671267989282
			},
			{
				"lng": 11.457374449140083,
				"lat": 43.549671040873584
			},
			{
				"lng": 11.457374606669571,
				"lat": 43.549670801870171
			},
			{
				"lng": 11.457374766534734,
				"lat": 43.549670550835735
			},
			{
				"lng": 11.457374928773429,
				"lat": 43.549670287626974
			},
			{
				"lng": 11.4573750934237,
				"lat": 43.54967001210067
			},
			{
				"lng": 11.457375260523484,
				"lat": 43.549669724113485
			},
			{
				"lng": 11.45737543011076,
				"lat": 43.549669423522239
			},
			{
				"lng": 11.45737560222344,
				"lat": 43.549669110183665
			},
			{
				"lng": 11.457375776899498,
				"lat": 43.549668783954417
			},
			{
				"lng": 11.457375954176873,
				"lat": 43.549668444691264
			},
			{
				"lng": 11.457376134093614,
				"lat": 43.549668092251032
			},
			{
				"lng": 11.457376316687574,
				"lat": 43.549667726490341
			},
			{
				"lng": 11.457376501996748,
				"lat": 43.549667347265896
			},
			{
				"lng": 11.457376690059114,
				"lat": 43.549666954434556
			},
			{
				"lng": 11.457376880912621,
				"lat": 43.549666547852979
			},
			{
				"lng": 11.457377074595207,
				"lat": 43.549666127377925
			},
			{
				"lng": 11.457377271144818,
				"lat": 43.549665692866107
			},
			{
				"lng": 11.457377470599475,
				"lat": 43.549665244174257
			},
			{
				"lng": 11.457377672997124,
				"lat": 43.549664781159109
			},
			{
				"lng": 11.457377878375635,
				"lat": 43.549664303677417
			},
			{
				"lng": 11.457378086773071,
				"lat": 43.54966381158593
			},
			{
				"lng": 11.457378298227361,
				"lat": 43.549663304741323
			},
			{
				"lng": 11.457378512776456,
				"lat": 43.549662783000372
			},
			{
				"lng": 11.457378730458283,
				"lat": 43.549662246219739
			},
			{
				"lng": 11.457378951310806,
				"lat": 43.549661694256287
			},
			{
				"lng": 11.457379175372056,
				"lat": 43.549661126966683
			},
			{
				"lng": 11.457379402679914,
				"lat": 43.549660544207676
			},
			{
				"lng": 11.457379633272385,
				"lat": 43.549659945835906
			},
			{
				"lng": 11.457379867187392,
				"lat": 43.549659331708256
			},
			{
				"lng": 11.457380104462912,
				"lat": 43.549658701681331
			},
			{
				"lng": 11.457380345136903,
				"lat": 43.549658055611971
			},
			{
				"lng": 11.457380589247299,
				"lat": 43.54965739335676
			},
			{
				"lng": 11.457380836832099,
				"lat": 43.549656714772659
			},
			{
				"lng": 11.457381087929232,
				"lat": 43.549656019716174
			},
			{
				"lng": 11.457381342576671,
				"lat": 43.549655308044208
			},
			{
				"lng": 11.457381600812374,
				"lat": 43.549654579613396
			},
			{
				"lng": 11.457381862674309,
				"lat": 43.549653834280498
			},
			{
				"lng": 11.457382128200374,
				"lat": 43.54965307190222
			},
			{
				"lng": 11.457382397428631,
				"lat": 43.549652292335402
			},
			{
				"lng": 11.457382670396921,
				"lat": 43.549651495436599
			},
			{
				"lng": 11.457382947143289,
				"lat": 43.549650681062666
			},
			{
				"lng": 11.457383227705662,
				"lat": 43.549649849070398
			},
			{
				"lng": 11.457383512121991,
				"lat": 43.549648999316375
			},
			{
				"lng": 11.457383800428119,
				"lat": 43.549648131660291
			},
			{
				"lng": 11.457384092566576,
				"lat": 43.549647246085769
			},
			{
				"lng": 11.457384388352212,
				"lat": 43.549646342746833
			},
			{
				"lng": 11.457384687590647,
				"lat": 43.549645421809394
			},
			{
				"lng": 11.457384990087487,
				"lat": 43.549644483439479
			},
			{
				"lng": 11.457385295648388,
				"lat": 43.549643527803163
			},
			{
				"lng": 11.457385604079027,
				"lat": 43.549642555066576
			},
			{
				"lng": 11.457385915184991,
				"lat": 43.549641565395618
			},
			{
				"lng": 11.45738622877194,
				"lat": 43.549640558956433
			},
			{
				"lng": 11.457386544645468,
				"lat": 43.549639535915119
			},
			{
				"lng": 11.457386862611248,
				"lat": 43.549638496437659
			},
			{
				"lng": 11.457387182474884,
				"lat": 43.549637440690034
			},
			{
				"lng": 11.457387504042055,
				"lat": 43.549636368838435
			},
			{
				"lng": 11.457387827118366,
				"lat": 43.549635281048843
			},
			{
				"lng": 11.457388151509422,
				"lat": 43.549634177487277
			},
			{
				"lng": 11.457388477020903,
				"lat": 43.549633058319877
			},
			{
				"lng": 11.457388803458468,
				"lat": 43.549631923712617
			},
			{
				"lng": 11.457389130627668,
				"lat": 43.549630773831552
			},
			{
				"lng": 11.457389458334189,
				"lat": 43.549629608842807
			},
			{
				"lng": 11.457389786383636,
				"lat": 43.5496284289123
			},
			{
				"lng": 11.457390114581678,
				"lat": 43.549627234206149
			},
			{
				"lng": 11.457390442733953,
				"lat": 43.549626024890458
			},
			{
				"lng": 11.457390770646029,
				"lat": 43.549624801131174
			},
			{
				"lng": 11.457391098123647,
				"lat": 43.549623563094471
			},
			{
				"lng": 11.457391424972327,
				"lat": 43.549622310946305
			},
			{
				"lng": 11.457391750997806,
				"lat": 43.549621044852756
			},
			{
				"lng": 11.457392076005627,
				"lat": 43.549619764979852
			},
			{
				"lng": 11.457392399801485,
				"lat": 43.54961847149368
			},
			{
				"lng": 11.45739272219099,
				"lat": 43.549617164560267
			},
			{
				"lng": 11.457393042979835,
				"lat": 43.54961584434561
			},
			{
				"lng": 11.457393361973534,
				"lat": 43.549614511015896
			},
			{
				"lng": 11.457393678977828,
				"lat": 43.549613164737082
			},
			{
				"lng": 11.457393993798306,
				"lat": 43.549611805675177
			},
			{
				"lng": 11.457394306240596,
				"lat": 43.549610433996357
			},
			{
				"lng": 11.457394616110358,
				"lat": 43.549609049866568
			},
			{
				"lng": 11.457394923213201,
				"lat": 43.549607653451844
			},
			{
				"lng": 11.457395227354793,
				"lat": 43.549606244918351
			},
			{
				"lng": 11.457395528340747,
				"lat": 43.549604824432024
			},
			{
				"lng": 11.457395825976688,
				"lat": 43.549603392158993
			},
			{
				"lng": 11.457396120068251,
				"lat": 43.54960194826527
			},
			{
				"lng": 11.457396410421088,
				"lat": 43.549600492916881
			},
			{
				"lng": 11.457396696840849,
				"lat": 43.549599026279971
			},
			{
				"lng": 11.45739697913312,
				"lat": 43.549597548520453
			},
			{
				"lng": 11.457397257103583,
				"lat": 43.549596059804486
			},
			{
				"lng": 11.457397530557843,
				"lat": 43.549594560298083
			},
			{
				"lng": 11.45739779930155,
				"lat": 43.549593050167253
			},
			{
				"lng": 11.45739806314033,
				"lat": 43.549591529578144
			},
			{
				"lng": 11.457398321879817,
				"lat": 43.549589998696717
			},
			{
				"lng": 11.457398575325644,
				"lat": 43.549588457689062
			},
			{
				"lng": 11.457398823283476,
				"lat": 43.549586906721217
			},
			{
				"lng": 11.457399065558887,
				"lat": 43.549585345959244
			},
			{
				"lng": 11.457399301957562,
				"lat": 43.549583775569154
			},
			{
				"lng": 11.45739953228512,
				"lat": 43.549582195717036
			},
			{
				"lng": 11.457399756347217,
				"lat": 43.549580606568988
			},
			{
				"lng": 11.457399973949459,
				"lat": 43.549579008290976
			},
			{
				"lng": 11.457400184897459,
				"lat": 43.549577401049028
			},
			{
				"lng": 11.457400388996938,
				"lat": 43.549575785009289
			},
			{
				"lng": 11.45740058605343,
				"lat": 43.549574160337812
			},
			{
				"lng": 11.457400775872649,
				"lat": 43.549572527200496
			},
			{
				"lng": 11.457400958260159,
				"lat": 43.549570885763565
			},
			{
				"lng": 11.457401133021664,
				"lat": 43.549569236192987
			},
			{
				"lng": 11.457401299962784,
				"lat": 43.549567578654845
			},
			{
				"lng": 11.457401458889112,
				"lat": 43.549565913315107
			},
			{
				"lng": 11.457401609606308,
				"lat": 43.549564240339933
			},
			{
				"lng": 11.457401751920017,
				"lat": 43.549562559895286
			},
			{
				"lng": 11.457401885635889,
				"lat": 43.549560872147318
			},
			{
				"lng": 11.457402010559502,
				"lat": 43.549559177261948
			},
			{
				"lng": 11.457402126496547,
				"lat": 43.549557475405308
			},
			{
				"lng": 11.457402233252648,
				"lat": 43.549555766743467
			},
			{
				"lng": 11.457402330633441,
				"lat": 43.549554051442449
			},
			{
				"lng": 11.457402418444522,
				"lat": 43.549552329668245
			},
			{
				"lng": 11.457402496491571,
				"lat": 43.549550601586972
			},
			{
				"lng": 11.457402564580169,
				"lat": 43.549548867364642
			},
			{
				"lng": 11.457402622516033,
				"lat": 43.549547127167344
			},
			{
				"lng": 11.457402670104743,
				"lat": 43.549545381161145
			},
			{
				"lng": 11.457402707151992,
				"lat": 43.549543629512087
			},
			{
				"lng": 11.457402733463326,
				"lat": 43.54954187238615
			},
			{
				"lng": 11.457402748844432,
				"lat": 43.549540109949412
			},
			{
				"lng": 11.45740275310097,
				"lat": 43.549538342367981
			},
			{
				"lng": 11.457402746038499,
				"lat": 43.549536569807856
			},
			{
				"lng": 11.457402727462727,
				"lat": 43.54953479243509
			},
			{
				"lng": 11.457402697179266,
				"lat": 43.549533010415729
			},
			{
				"lng": 11.457402654993738,
				"lat": 43.549531223915842
			},
			{
				"lng": 11.457402600711811,
				"lat": 43.549529433101469
			},
			{
				"lng": 11.457402534139092,
				"lat": 43.549527638138656
			},
			{
				"lng": 11.457402455081219,
				"lat": 43.5495258391935
			},
			{
				"lng": 11.457402363343846,
				"lat": 43.549524036431954
			},
			{
				"lng": 11.457402258732603,
				"lat": 43.549522230020187
			},
			{
				"lng": 11.457402141053112,
				"lat": 43.549520420124153
			},
			{
				"lng": 11.457402010111029,
				"lat": 43.549518606909942
			},
			{
				"lng": 11.457401865711956,
				"lat": 43.549516790543578
			},
			{
				"lng": 11.457401707661562,
				"lat": 43.549514971191108
			},
			{
				"lng": 11.457401535765483,
				"lat": 43.549513149018651
			},
			{
				"lng": 11.45740134982932,
				"lat": 43.549511324192217
			},
			{
				"lng": 11.457401149658754,
				"lat": 43.549509496877796
			},
			{
				"lng": 11.457400935059393,
				"lat": 43.549507667241528
			},
			{
				"lng": 11.457400705836891,
				"lat": 43.549505835449416
			},
			{
				"lng": 11.457400461796857,
				"lat": 43.549504001667522
			},
			{
				"lng": 11.457400202744969,
				"lat": 43.549502166061949
			},
			{
				"lng": 11.457399928486833,
				"lat": 43.549500328798622
			},
			{
				"lng": 11.457399638828095,
				"lat": 43.549498490043703
			},
			{
				"lng": 11.457399333574362,
				"lat": 43.549496649963146
			},
			{
				"lng": 11.457399012531301,
				"lat": 43.549494808723111
			},
			{
				"lng": 11.457398675504551,
				"lat": 43.549492966489524
			},
			{
				"lng": 11.45739832229974,
				"lat": 43.549491123428602
			},
			{
				"lng": 11.457397952722525,
				"lat": 43.549489279706187
			},
			{
				"lng": 11.457397566578477,
				"lat": 43.549487435488516
			},
			{
				"lng": 11.457397163673303,
				"lat": 43.549485590941551
			},
			{
				"lng": 11.457396743812598,
				"lat": 43.549483746231317
			},
			{
				"lng": 11.457396306802048,
				"lat": 43.549481901523912
			},
			{
				"lng": 11.457395852447208,
				"lat": 43.549480056985381
			},
			{
				"lng": 11.457395380553805,
				"lat": 43.549478212781757
			},
			{
				"lng": 11.457394890927389,
				"lat": 43.549476369079088
			},
			{
				"lng": 11.457394383373677,
				"lat": 43.549474526043468
			},
			{
				"lng": 11.457393857698269,
				"lat": 43.549472683840897
			},
			{
				"lng": 11.457393313706792,
				"lat": 43.549470842637419
			},
			{
				"lng": 11.457392751257331,
				"lat": 43.549469002563953
			},
			{
				"lng": 11.45739217041783,
				"lat": 43.549467163610856
			},
			{
				"lng": 11.45739157130863,
				"lat": 43.549465325733436
			},
			{
				"lng": 11.457390954050128,
				"lat": 43.549463488886822
			},
			{
				"lng": 11.457390318762705,
				"lat": 43.549461653026171
			},
			{
				"lng": 11.4573896655667,
				"lat": 43.549459818106826
			},
			{
				"lng": 11.457388994582479,
				"lat": 43.549457984083915
			},
			{
				"lng": 11.457388305930456,
				"lat": 43.549456150912711
			},
			{
				"lng": 11.457387599730973,
				"lat": 43.549454318548413
			},
			{
				"lng": 11.457386876104376,
				"lat": 43.549452486946201
			},
			{
				"lng": 11.457386135171081,
				"lat": 43.54945065606136
			},
			{
				"lng": 11.457385377051425,
				"lat": 43.549448825849048
			},
			{
				"lng": 11.457384601865815,
				"lat": 43.549446996264514
			},
			{
				"lng": 11.457383809734608,
				"lat": 43.549445167262988
			},
			{
				"lng": 11.457383000778142,
				"lat": 43.549443338799648
			},
			{
				"lng": 11.457382175116813,
				"lat": 43.54944151082973
			},
			{
				"lng": 11.457381332870987,
				"lat": 43.549439683308492
			},
			{
				"lng": 11.457380474161084,
				"lat": 43.549437856191048
			},
			{
				"lng": 11.4573795991074,
				"lat": 43.549436029432734
			},
			{
				"lng": 11.457378707830353,
				"lat": 43.549434202988699
			},
			{
				"lng": 11.457377800450271,
				"lat": 43.549432376814146
			},
			{
				"lng": 11.457376877087555,
				"lat": 43.549430550864322
			},
			{
				"lng": 11.457375937862588,
				"lat": 43.549428725094479
			},
			{
				"lng": 11.457374982895704,
				"lat": 43.549426899459803
			},
			{
				"lng": 11.457374012307307,
				"lat": 43.549425073915522
			},
			{
				"lng": 11.457373026217738,
				"lat": 43.549423248416751
			},
			{
				"lng": 11.457372024747386,
				"lat": 43.549421422918854
			},
			{
				"lng": 11.457371008016645,
				"lat": 43.549419597377003
			},
			{
				"lng": 11.457369976145834,
				"lat": 43.549417771746363
			},
			{
				"lng": 11.457368929255329,
				"lat": 43.549415945982219
			},
			{
				"lng": 11.457367867465587,
				"lat": 43.549414120039792
			},
			{
				"lng": 11.457366790896838,
				"lat": 43.549412293874191
			},
			{
				"lng": 11.457365699669596,
				"lat": 43.549410467440715
			},
			{
				"lng": 11.457364593904114,
				"lat": 43.549408640694601
			},
			{
				"lng": 11.457363473720809,
				"lat": 43.549406813591041
			},
			{
				"lng": 11.457362339240056,
				"lat": 43.549404986085214
			},
			{
				"lng": 11.457361190582231,
				"lat": 43.549403158132378
			},
			{
				"lng": 11.457360027867683,
				"lat": 43.549401329687761
			},
			{
				"lng": 11.457358851216812,
				"lat": 43.549399500706571
			},
			{
				"lng": 11.457357660749983,
				"lat": 43.549397671144028
			},
			{
				"lng": 11.457356456587519,
				"lat": 43.549395840955313
			},
			{
				"lng": 11.457355238849846,
				"lat": 43.549394010095732
			},
			{
				"lng": 11.457354007657322,
				"lat": 43.549392178520385
			},
			{
				"lng": 11.457352763130281,
				"lat": 43.549390346184623
			},
			{
				"lng": 11.457351505389148,
				"lat": 43.549388513043461
			},
			{
				"lng": 11.457350234554244,
				"lat": 43.549386679052297
			},
			{
				"lng": 11.457348950745981,
				"lat": 43.549384844166326
			},
			{
				"lng": 11.457347654084694,
				"lat": 43.549383008340691
			},
			{
				"lng": 11.457346344690805,
				"lat": 43.549381171530655
			},
			{
				"lng": 11.457345022684597,
				"lat": 43.549379333691448
			},
			{
				"lng": 11.457343688186526,
				"lat": 43.549377494778263
			},
			{
				"lng": 11.457342341316945,
				"lat": 43.549375654746356
			},
			{
				"lng": 11.457340982196175,
				"lat": 43.549373813550879
			},
			{
				"lng": 11.457339610944643,
				"lat": 43.549371971147067
			},
			{
				"lng": 11.457338227682699,
				"lat": 43.549370127490192
			},
			{
				"lng": 11.457336832530672,
				"lat": 43.549368282535411
			},
			{
				"lng": 11.457335425609013,
				"lat": 43.549366436237904
			},
			{
				"lng": 11.457334007038009,
				"lat": 43.549364588553019
			},
			{
				"lng": 11.45733257693808,
				"lat": 43.549362739435942
			},
			{
				"lng": 11.457331135429653,
				"lat": 43.549360888841761
			},
			{
				"lng": 11.457329682632947,
				"lat": 43.549359036725832
			},
			{
				"lng": 11.457328218668463,
				"lat": 43.549357183043313
			},
			{
				"lng": 11.4573267436565,
				"lat": 43.549355327749403
			},
			{
				"lng": 11.457325257717461,
				"lat": 43.549353470799353
			},
			{
				"lng": 11.457323760971732,
				"lat": 43.549351612148399
			},
			{
				"lng": 11.457322253539624,
				"lat": 43.54934975175172
			},
			{
				"lng": 11.457320735541554,
				"lat": 43.54934788956453
			},
			{
				"lng": 11.457319207097903,
				"lat": 43.549346025542079
			},
			{
				"lng": 11.457317668329036,
				"lat": 43.549344159639617
			},
			{
				"lng": 11.457316119355244,
				"lat": 43.549342291812266
			},
			{
				"lng": 11.457314560296993,
				"lat": 43.549340422015277
			},
			{
				"lng": 11.457312991274625,
				"lat": 43.549338550203899
			},
			{
				"lng": 11.45731141240849,
				"lat": 43.549336676333269
			},
			{
				"lng": 11.457309823818989,
				"lat": 43.549334800358729
			},
			{
				"lng": 11.457308225626482,
				"lat": 43.549332922235479
			},
			{
				"lng": 11.457306617951318,
				"lat": 43.54933104191862
			},
			{
				"lng": 11.457305000913861,
				"lat": 43.549329159363452
			},
			{
				"lng": 11.457303374634556,
				"lat": 43.549327274525176
			},
			{
				"lng": 11.457301739233673,
				"lat": 43.54932538735904
			},
			{
				"lng": 11.457300094831643,
				"lat": 43.549323497820225
			},
			{
				"lng": 11.457298441548819,
				"lat": 43.549321605863966
			},
			{
				"lng": 11.457296779505572,
				"lat": 43.54931971144547
			},
			{
				"lng": 11.45729510882229,
				"lat": 43.549317814519917
			},
			{
				"lng": 11.457293429619325,
				"lat": 43.549315915042619
			},
			{
				"lng": 11.457291742017038,
				"lat": 43.549314012968729
			},
			{
				"lng": 11.457290046135814,
				"lat": 43.54931210825346
			},
			{
				"lng": 11.457286630018009,
				"lat": 43.549308290719701
			},
			{
				"lng": 11.457283182228895,
				"lat": 43.549304462083128
			},
			{
				"lng": 11.457279703731418,
				"lat": 43.549300621985424
			},
			{
				"lng": 11.45727619548852,
				"lat": 43.549296770068317
			},
			{
				"lng": 11.457272658463165,
				"lat": 43.549292905973587
			},
			{
				"lng": 11.457269093618345,
				"lat": 43.549289029343043
			},
			{
				"lng": 11.457265501917004,
				"lat": 43.549285139818288
			},
			{
				"lng": 11.45726188432209,
				"lat": 43.549281237041114
			},
			{
				"lng": 11.457258241796563,
				"lat": 43.549277320653296
			},
			{
				"lng": 11.457254575303354,
				"lat": 43.549273390296563
			},
			{
				"lng": 11.457250885805493,
				"lat": 43.549269445612616
			},
			{
				"lng": 11.4572471742659,
				"lat": 43.549265486243222
			},
			{
				"lng": 11.457243441647547,
				"lat": 43.54926151183011
			},
			{
				"lng": 11.45723968891331,
				"lat": 43.549257522015083
			},
			{
				"lng": 11.457235917024413,
				"lat": 43.549253516443436
			},
			{
				"lng": 11.457232126807332,
				"lat": 43.549249495023155
			},
			{
				"lng": 11.457228318866731,
				"lat": 43.549245458095335
			},
			{
				"lng": 11.457224493786466,
				"lat": 43.549241406041617
			},
			{
				"lng": 11.45722065215036,
				"lat": 43.54923733924381
			},
			{
				"lng": 11.457216794542253,
				"lat": 43.549233258083454
			},
			{
				"lng": 11.457212921546013,
				"lat": 43.549229162942282
			},
			{
				"lng": 11.457209033745446,
				"lat": 43.549225054201969
			},
			{
				"lng": 11.45720513172442,
				"lat": 43.549220932244204
			},
			{
				"lng": 11.457201216066801,
				"lat": 43.549216797450676
			},
			{
				"lng": 11.457197287356394,
				"lat": 43.549212650202989
			},
			{
				"lng": 11.457193346177069,
				"lat": 43.549208490882897
			},
			{
				"lng": 11.457189393112662,
				"lat": 43.549204319872061
			},
			{
				"lng": 11.457185428747005,
				"lat": 43.549200137552155
			},
			{
				"lng": 11.457181453663905,
				"lat": 43.54919594430482
			},
			{
				"lng": 11.457177468447274,
				"lat": 43.549191740511802
			},
			{
				"lng": 11.457173473680939,
				"lat": 43.549187526554746
			},
			{
				"lng": 11.457169469948729,
				"lat": 43.549183302815386
			},
			{
				"lng": 11.457165457834439,
				"lat": 43.549179069675226
			},
			{
				"lng": 11.457161437921989,
				"lat": 43.549174827516175
			},
			{
				"lng": 11.457157410795171,
				"lat": 43.549170576719739
			},
			{
				"lng": 11.45715337703783,
				"lat": 43.549166317667705
			},
			{
				"lng": 11.457149337233846,
				"lat": 43.549162050741693
			},
			{
				"lng": 11.457145291967011,
				"lat": 43.549157776323398
			},
			{
				"lng": 11.457141241821194,
				"lat": 43.549153494794531
			},
			{
				"lng": 11.457137187380191,
				"lat": 43.549149206536704
			},
			{
				"lng": 11.457133129227866,
				"lat": 43.549144911931663
			},
			{
				"lng": 11.457125004124661,
				"lat": 43.549136305206531
			},
			{
				"lng": 11.457116871182256,
				"lat": 43.549127677672665
			},
			{
				"lng": 11.457108735071339,
				"lat": 43.549119032383288
			},
			{
				"lng": 11.457100600462645,
				"lat": 43.549110372392086
			},
			{
				"lng": 11.45709247202681,
				"lat": 43.549101700752367
			},
			{
				"lng": 11.457084354434539,
				"lat": 43.549093020517617
			},
			{
				"lng": 11.457076252356584,
				"lat": 43.549084334741295
			},
			{
				"lng": 11.457068170463554,
				"lat": 43.549075646476773
			},
			{
				"lng": 11.457060113426147,
				"lat": 43.549066958777594
			},
			{
				"lng": 11.457052085915025,
				"lat": 43.549058274697202
			},
			{
				"lng": 11.457048084691454,
				"lat": 43.549053934968235
			},
			{
				"lng": 11.457044092600908,
				"lat": 43.549049597288985
			},
			{
				"lng": 11.45704011022729,
				"lat": 43.549045262041197
			},
			{
				"lng": 11.457036138154393,
				"lat": 43.549040929606463
			},
			{
				"lng": 11.457032176966088,
				"lat": 43.549036600366513
			},
			{
				"lng": 11.457028227246168,
				"lat": 43.549032274702981
			},
			{
				"lng": 11.4570242895785,
				"lat": 43.549027952997655
			},
			{
				"lng": 11.457020364546903,
				"lat": 43.549023635632118
			},
			{
				"lng": 11.457016452735219,
				"lat": 43.549019322988109
			},
			{
				"lng": 11.457012554727232,
				"lat": 43.549015015447289
			},
			{
				"lng": 11.457008671106816,
				"lat": 43.549010713391333
			},
			{
				"lng": 11.457004802476524,
				"lat": 43.549006417154224
			},
			{
				"lng": 11.457000949698449,
				"lat": 43.549002126407643
			},
			{
				"lng": 11.456997113824283,
				"lat": 43.54899784033973
			},
			{
				"lng": 11.456993295910159,
				"lat": 43.548993558127449
			},
			{
				"lng": 11.456989497012087,
				"lat": 43.548989278947801
			},
			{
				"lng": 11.456985718186154,
				"lat": 43.548985001977755
			},
			{
				"lng": 11.456981960488449,
				"lat": 43.548980726394269
			},
			{
				"lng": 11.456978224975012,
				"lat": 43.548976451374344
			},
			{
				"lng": 11.456974512701869,
				"lat": 43.548972176095013
			},
			{
				"lng": 11.456970824725163,
				"lat": 43.548967899733235
			},
			{
				"lng": 11.456967162100915,
				"lat": 43.54896362146593
			},
			{
				"lng": 11.456963525885186,
				"lat": 43.548959340470198
			},
			{
				"lng": 11.456959917134078,
				"lat": 43.548955055922875
			},
			{
				"lng": 11.456956336903627,
				"lat": 43.548950767001138
			},
			{
				"lng": 11.456952786249879,
				"lat": 43.548946472881838
			},
			{
				"lng": 11.456949266228969,
				"lat": 43.548942172741931
			},
			{
				"lng": 11.456945777896864,
				"lat": 43.548937865758496
			},
			{
				"lng": 11.456942322309706,
				"lat": 43.548933551108519
			},
			{
				"lng": 11.456940607125514,
				"lat": 43.548931390651354
			},
			{
				"lng": 11.456938900523546,
				"lat": 43.548929227968927
			},
			{
				"lng": 11.456937202635881,
				"lat": 43.54892706295837
			},
			{
				"lng": 11.45693551359444,
				"lat": 43.548924895516727
			},
			{
				"lng": 11.456933833531293,
				"lat": 43.548922725541239
			},
			{
				"lng": 11.456932162578429,
				"lat": 43.548920552928926
			},
			{
				"lng": 11.456930500867847,
				"lat": 43.548918377576953
			},
			{
				"lng": 11.456928848531611,
				"lat": 43.548916199382468
			},
			{
				"lng": 11.45692720570168,
				"lat": 43.548914018242584
			},
			{
				"lng": 11.456925572510027,
				"lat": 43.548911834054408
			},
			{
				"lng": 11.456923949088727,
				"lat": 43.548909646715067
			},
			{
				"lng": 11.456922335569766,
				"lat": 43.54890745612169
			},
			{
				"lng": 11.456920732085134,
				"lat": 43.548905262171374
			},
			{
				"lng": 11.456919138766866,
				"lat": 43.548903064761284
			},
			{
				"lng": 11.456917555746941,
				"lat": 43.548900863788489
			},
			{
				"lng": 11.45691598315738,
				"lat": 43.548898659150154
			},
			{
				"lng": 11.456914421130223,
				"lat": 43.548896450743413
			},
			{
				"lng": 11.456912869797417,
				"lat": 43.548894238465373
			},
			{
				"lng": 11.456911329291007,
				"lat": 43.548892022213117
			},
			{
				"lng": 11.45690979974302,
				"lat": 43.548889801883895
			},
			{
				"lng": 11.456908281285427,
				"lat": 43.548887577374622
			},
			{
				"lng": 11.456906774050239,
				"lat": 43.54888534858263
			},
			{
				"lng": 11.456905278169479,
				"lat": 43.548883115404955
			},
			{
				"lng": 11.456903793775135,
				"lat": 43.548880877738696
			},
			{
				"lng": 11.456902320999246,
				"lat": 43.548878635480975
			},
			{
				"lng": 11.456900859973809,
				"lat": 43.548876388528974
			},
			{
				"lng": 11.456899410830792,
				"lat": 43.548874136779745
			},
			{
				"lng": 11.456897973702263,
				"lat": 43.548871880130505
			},
			{
				"lng": 11.456896548720213,
				"lat": 43.5488696184783
			},
			{
				"lng": 11.456895136016628,
				"lat": 43.548867351720283
			},
			{
				"lng": 11.456893735723503,
				"lat": 43.548865079753547
			},
			{
				"lng": 11.456892347972898,
				"lat": 43.548862802475199
			},
			{
				"lng": 11.45689097289678,
				"lat": 43.54886051978248
			},
			{
				"lng": 11.456889610627172,
				"lat": 43.54885823157241
			},
			{
				"lng": 11.456888261296081,
				"lat": 43.548855937742083
			},
			{
				"lng": 11.456886925035507,
				"lat": 43.548853638188731
			},
			{
				"lng": 11.456885601977472,
				"lat": 43.548851332809413
			},
			{
				"lng": 11.456884292253953,
				"lat": 43.54884902150129
			},
			{
				"lng": 11.456882995997022,
				"lat": 43.548846704161392
			},
			{
				"lng": 11.456881713338609,
				"lat": 43.548844380686965
			},
			{
				"lng": 11.456880444410759,
				"lat": 43.548842050975033
			},
			{
				"lng": 11.456879189345484,
				"lat": 43.548839714922785
			},
			{
				"lng": 11.456877948274801,
				"lat": 43.548837372427336
			},
			{
				"lng": 11.456876721330678,
				"lat": 43.54883502338577
			},
			{
				"lng": 11.456875508645149,
				"lat": 43.548832667695237
			},
			{
				"lng": 11.456874310350226,
				"lat": 43.548830305252864
			},
			{
				"lng": 11.456873126577911,
				"lat": 43.548827935955778
			},
			{
				"lng": 11.456871957460189,
				"lat": 43.548825559701037
			},
			{
				"lng": 11.456870803129098,
				"lat": 43.548823176385916
			},
			{
				"lng": 11.456869663716649,
				"lat": 43.548820785907367
			},
			{
				"lng": 11.456868539354815,
				"lat": 43.54881838816263
			},
			{
				"lng": 11.456867430175636,
				"lat": 43.54881598304874
			},
			{
				"lng": 11.4568663363111,
				"lat": 43.548813570462926
			},
			{
				"lng": 11.456865257893217,
				"lat": 43.548811150302207
			},
			{
				"lng": 11.456864195053999,
				"lat": 43.548808722463797
			},
			{
				"lng": 11.456863147925459,
				"lat": 43.548806286844737
			},
			{
				"lng": 11.456862116639616,
				"lat": 43.548803843342235
			},
			{
				"lng": 11.456861101328428,
				"lat": 43.54880139185331
			},
			{
				"lng": 11.456860102123928,
				"lat": 43.548798932275169
			},
			{
				"lng": 11.456859119158153,
				"lat": 43.548796464504932
			},
			{
				"lng": 11.456858152563061,
				"lat": 43.548793988439634
			},
			{
				"lng": 11.456857202470719,
				"lat": 43.548791503976545
			},
			{
				"lng": 11.456856269013073,
				"lat": 43.548789011012687
			},
			{
				"lng": 11.456855352322151,
				"lat": 43.548786509445193
			},
			{
				"lng": 11.456854452529972,
				"lat": 43.548783999171178
			},
			{
				"lng": 11.45685356976853,
				"lat": 43.548781480087825
			},
			{
				"lng": 11.456852704169838,
				"lat": 43.548778952092178
			},
			{
				"lng": 11.456851855865905,
				"lat": 43.548776415081413
			},
			{
				"lng": 11.456851024988749,
				"lat": 43.548773868952672
			},
			{
				"lng": 11.456850211670341,
				"lat": 43.548771313603048
			},
			{
				"lng": 11.456849416042717,
				"lat": 43.548768748929646
			},
			{
				"lng": 11.456848638237883,
				"lat": 43.548766174829566
			},
			{
				"lng": 11.456847878387835,
				"lat": 43.548763591200007
			},
			{
				"lng": 11.456847136624589,
				"lat": 43.548760997938025
			},
			{
				"lng": 11.456846413080127,
				"lat": 43.548758394940819
			}
			],
			[{
				"lng": 11.461215893751076,
				"lat": 43.54685962019888
			},
			{
				"lng": 11.461202997328131,
				"lat": 43.546887875257447
			},
			{
				"lng": 11.461192330989251,
				"lat": 43.54691661807923
			},
			{
				"lng": 11.461183929265511,
				"lat": 43.546945755621252
			},
			{
				"lng": 11.461177819357362,
				"lat": 43.546975193562623
			},
			{
				"lng": 11.461174021046537,
				"lat": 43.547004836609965
			},
			{
				"lng": 11.461174021046537,
				"lat": 43.547004836609965
			},
			{
				"lng": 11.461172673259727,
				"lat": 43.547031132672799
			},
			{
				"lng": 11.461173294490459,
				"lat": 43.547057443123393
			},
			{
				"lng": 11.46117588290085,
				"lat": 43.547083690013885
			},
			{
				"lng": 11.461180430824957,
				"lat": 43.547109795584646
			},
			{
				"lng": 11.461180430824957,
				"lat": 43.547109795584646
			},
			{
				"lng": 11.461182920168891,
				"lat": 43.54711941360145
			},
			{
				"lng": 11.461186271410169,
				"lat": 43.547128892150987
			},
			{
				"lng": 11.461190470117607,
				"lat": 43.547138190415389
			},
			{
				"lng": 11.461195498210502,
				"lat": 43.547147268353129
			},
			{
				"lng": 11.461201334036522,
				"lat": 43.547156086871453
			},
			{
				"lng": 11.461207952464909,
				"lat": 43.54716460799483
			},
			{
				"lng": 11.46120795246491,
				"lat": 43.54716460799483
			},
			{
				"lng": 11.461214740509245,
				"lat": 43.547172188703932
			},
			{
				"lng": 11.46122214586455,
				"lat": 43.547179457236155
			},
			{
				"lng": 11.461230141471328,
				"lat": 43.547186387031807
			},
			{
				"lng": 11.461238698113252,
				"lat": 43.54719295276891
			},
			{
				"lng": 11.46124778452387,
				"lat": 43.54719913045578
			},
			{
				"lng": 11.46125736750091,
				"lat": 43.547204897518647
			},
			{
				"lng": 11.461267412027567,
				"lat": 43.547210232884275
			},
			{
				"lng": 11.461267412027562,
				"lat": 43.547210232884282
			},
			{
				"lng": 11.461277347152782,
				"lat": 43.54721485033938
			},
			{
				"lng": 11.46128766731195,
				"lat": 43.547218996986729
			},
			{
				"lng": 11.461298330393706,
				"lat": 43.547222655905891
			},
			{
				"lng": 11.461309292887366,
				"lat": 43.547225812166651
			},
			{
				"lng": 11.461320510060455,
				"lat": 43.54722845288989
			},
			{
				"lng": 11.461331936141283,
				"lat": 43.547230567300133
			},
			{
				"lng": 11.461343524505688,
				"lat": 43.547232146769517
			},
			{
				"lng": 11.461343524505692,
				"lat": 43.54723214676951
			},
			{
				"lng": 11.461364964288205,
				"lat": 43.547234041432645
			},
			{
				"lng": 11.461386527721166,
				"lat": 43.547234922619147
			},
			{
				"lng": 11.461408124348978,
				"lat": 43.547234786632522
			},
			{
				"lng": 11.461429663576807,
				"lat": 43.547233634043288
			},
			{
				"lng": 11.461451055050619,
				"lat": 43.547231469686402
			},
			{
				"lng": 11.461451055050617,
				"lat": 43.547231469686416
			},
			{
				"lng": 11.461623599853553,
				"lat": 43.547206646488419
			},
			{
				"lng": 11.461794252000285,
				"lat": 43.547175665281763
			},
			{
				"lng": 11.461794252000285,
				"lat": 43.547175665281763
			},
			{
				"lng": 11.462032620519276,
				"lat": 43.547123340947543
			},
			{
				"lng": 11.462267289938026,
				"lat": 43.547062813641311
			},
			{
				"lng": 11.462267289938032,
				"lat": 43.547062813641311
			},
			{
				"lng": 11.46229331749017,
				"lat": 43.547054842426292
			},
			{
				"lng": 11.462318542340345,
				"lat": 43.547045606274587
			},
			{
				"lng": 11.462342848455556,
				"lat": 43.547035147672261
			},
			{
				"lng": 11.462366124029145,
				"lat": 43.547023514728487
			},
			{
				"lng": 11.462388261995068,
				"lat": 43.547010760954343
			},
			{
				"lng": 11.462388261995072,
				"lat": 43.547010760954358
			},
			{
				"lng": 11.462416068684755,
				"lat": 43.546992603390358
			},
			{
				"lng": 11.46244244606889,
				"lat": 43.546973350560776
			},
			{
				"lng": 11.462467312727863,
				"lat": 43.546953061894747
			},
			{
				"lng": 11.462467312727858,
				"lat": 43.546953061894747
			},
			{
				"lng": 11.462682781586892,
				"lat": 43.546756585655359
			},
			{
				"lng": 11.462682781586889,
				"lat": 43.546756585655359
			},
			{
				"lng": 11.462771117217144,
				"lat": 43.546667771518834
			},
			{
				"lng": 11.462854487829544,
				"lat": 43.54657645342958
			},
			{
				"lng": 11.462854487829544,
				"lat": 43.54657645342958
			},
			{
				"lng": 11.462866285726305,
				"lat": 43.546561922041676
			},
			{
				"lng": 11.46287675210978,
				"lat": 43.546546860635075
			},
			{
				"lng": 11.46288584218558,
				"lat": 43.546531333671588
			},
			{
				"lng": 11.462893517049913,
				"lat": 43.546515407605526
			},
			{
				"lng": 11.46289351704992,
				"lat": 43.546515407605526
			},
			{
				"lng": 11.462895089663229,
				"lat": 43.546511294507205
			},
			{
				"lng": 11.462896283897839,
				"lat": 43.546507114616738
			},
			{
				"lng": 11.462897094498164,
				"lat": 43.546502886329243
			},
			{
				"lng": 11.462897517896954,
				"lat": 43.546498628252806
			},
			{
				"lng": 11.462897552230965,
				"lat": 43.546494359126633
			},
			{
				"lng": 11.462897197349182,
				"lat": 43.546490097738513
			},
			{
				"lng": 11.462896454813475,
				"lat": 43.54648586284226
			},
			{
				"lng": 11.462895327891713,
				"lat": 43.546481673074972
			},
			{
				"lng": 11.462893821543394,
				"lat": 43.546477546875252
			},
			{
				"lng": 11.462891942397821,
				"lat": 43.546473502401909
			},
			{
				"lng": 11.462889698724901,
				"lat": 43.546469557454039
			},
			{
				"lng": 11.462889698724901,
				"lat": 43.546469557454039
			},
			{
				"lng": 11.462882863970368,
				"lat": 43.546459407838704
			},
			{
				"lng": 11.462875203784636,
				"lat": 43.546449575015828
			},
			{
				"lng": 11.46286674580554,
				"lat": 43.546440094461587
			},
			{
				"lng": 11.462857520549289,
				"lat": 43.546431000381197
			},
			{
				"lng": 11.462847561300295,
				"lat": 43.546422325585482
			},
			{
				"lng": 11.462836903991146,
				"lat": 43.546414101372534
			},
			{
				"lng": 11.462825587072922,
				"lat": 43.546406357414732
			},
			{
				"lng": 11.462825587072928,
				"lat": 43.546406357414739
			},
			{
				"lng": 11.462813658780121,
				"lat": 43.546399185627855
			},
			{
				"lng": 11.462801086359301,
				"lat": 43.546392621735066
			},
			{
				"lng": 11.462787928255342,
				"lat": 43.546386696249577
			},
			{
				"lng": 11.462774245635693,
				"lat": 43.546381436716864
			},
			{
				"lng": 11.462760102106046,
				"lat": 43.546376867586581
			},
			{
				"lng": 11.462745563414641,
				"lat": 43.546373010098982
			},
			{
				"lng": 11.462730697146645,
				"lat": 43.546369882186148
			},
			{
				"lng": 11.462715572409984,
				"lat": 43.546367498388648
			},
			{
				"lng": 11.462715572409984,
				"lat": 43.546367498388648
			},
			{
				"lng": 11.462693825416657,
				"lat": 43.54636513643819
			},
			{
				"lng": 11.462671918775293,
				"lat": 43.546363761127537
			},
			{
				"lng": 11.462649937006887,
				"lat": 43.546363377763043
			},
			{
				"lng": 11.462627964922271,
				"lat": 43.546363987823852
			},
			{
				"lng": 11.462606087294933,
				"lat": 43.546365588956213
			},
			{
				"lng": 11.462584388533928,
				"lat": 43.546368174982582
			},
			{
				"lng": 11.462562952358264,
				"lat": 43.546371735925561
			},
			{
				"lng": 11.462562952358264,
				"lat": 43.546371735925561
			},
			{
				"lng": 11.462530823780778,
				"lat": 43.546378548384652
			},
			{
				"lng": 11.462499271045289,
				"lat": 43.54638666081599
			},
			{
				"lng": 11.462468393479636,
				"lat": 43.546396047681839
			},
			{
				"lng": 11.462438288286343,
				"lat": 43.546406679432422
			},
			{
				"lng": 11.462409050236692,
				"lat": 43.546418522599218
			},
			{
				"lng": 11.462409050236692,
				"lat": 43.546418522599218
			},
			{
				"lng": 11.46238193540267,
				"lat": 43.546431037210418
			},
			{
				"lng": 11.462355873088272,
				"lat": 43.546444683769536
			},
			{
				"lng": 11.462330952496551,
				"lat": 43.546459415569117
			},
			{
				"lng": 11.462307258923021,
				"lat": 43.546475182187365
			},
			{
				"lng": 11.462284873463711,
				"lat": 43.546491929660455
			},
			{
				"lng": 11.462284873463711,
				"lat": 43.546491929660455
			},
			{
				"lng": 11.462268449607159,
				"lat": 43.546505837034694
			},
			{
				"lng": 11.462253297478961,
				"lat": 43.546520488350886
			},
			{
				"lng": 11.462239480600983,
				"lat": 43.546535822187629
			},
			{
				"lng": 11.462227056897596,
				"lat": 43.546551774262298
			},
			{
				"lng": 11.462216078452785,
				"lat": 43.546568277700239
			},
			{
				"lng": 11.462206591291835,
				"lat": 43.546585263315507
			},
			{
				"lng": 11.462206591291835,
				"lat": 43.546585263315507
			},
			{
				"lng": 11.462201027704239,
				"lat": 43.546595257261934
			},
			{
				"lng": 11.462194617430873,
				"lat": 43.54660497914864
			},
			{
				"lng": 11.46218738546615,
				"lat": 43.546614391068175
			},
			{
				"lng": 11.462179360008465,
				"lat": 43.546623456321726
			},
			{
				"lng": 11.46217057235023,
				"lat": 43.546632139562213
			},
			{
				"lng": 11.462161056755845,
				"lat": 43.546640406931949
			},
			{
				"lng": 11.462150850328142,
				"lat": 43.546648226194968
			},
			{
				"lng": 11.462139992863678,
				"lat": 43.546655566862398
			},
			{
				"lng": 11.462139992863678,
				"lat": 43.546655566862398
			},
			{
				"lng": 11.46211770164539,
				"lat": 43.546668783053072
			},
			{
				"lng": 11.462094235188379,
				"lat": 43.546680875027427
			},
			{
				"lng": 11.462069700462356,
				"lat": 43.546691787664884
			},
			{
				"lng": 11.462069700462358,
				"lat": 43.546691787664891
			},
			{
				"lng": 11.462052056588384,
				"lat": 43.546698595088593
			},
			{
				"lng": 11.46203392718048,
				"lat": 43.546704690281594
			},
			{
				"lng": 11.462015366528776,
				"lat": 43.54671005499128
			},
			{
				"lng": 11.461996430214832,
				"lat": 43.546714673152458
			},
			{
				"lng": 11.461996430214832,
				"lat": 43.546714673152458
			},
			{
				"lng": 11.461981317275528,
				"lat": 43.546717620731442
			},
			{
				"lng": 11.461965962914984,
				"lat": 43.546719810847335
			},
			{
				"lng": 11.461950438800168,
				"lat": 43.546721233277644
			},
			{
				"lng": 11.461934817390397,
				"lat": 43.546721881383164
			},
			{
				"lng": 11.461919171599163,
				"lat": 43.546721752138758
			},
			{
				"lng": 11.461903574453723,
				"lat": 43.546720846147771
			},
			{
				"lng": 11.461888098754311,
				"lat": 43.546719167638798
			},
			{
				"lng": 11.461872816734267,
				"lat": 43.546716724446448
			},
			{
				"lng": 11.461857799722928,
				"lat": 43.546713527974305
			},
			{
				"lng": 11.461843117812656,
				"lat": 43.546709593142033
			},
			{
				"lng": 11.461843117812649,
				"lat": 43.546709593142033
			},
			{
				"lng": 11.461830322857844,
				"lat": 43.54670614642437
			},
			{
				"lng": 11.461817247117201,
				"lat": 43.546703311543901
			},
			{
				"lng": 11.461803945823963,
				"lat": 43.546701100475509
			},
			{
				"lng": 11.461790475164067,
				"lat": 43.546699522558917
			},
			{
				"lng": 11.461776892038895,
				"lat": 43.546698584459442
			},
			{
				"lng": 11.461763253824849,
				"lat": 43.546698290139659
			},
			{
				"lng": 11.461749618131062,
				"lat": 43.546698640842898
			},
			{
				"lng": 11.461736042556,
				"lat": 43.546699635087712
			},
			{
				"lng": 11.461722584444191,
				"lat": 43.546701268674312
			},
			{
				"lng": 11.46170930064401,
				"lat": 43.546703534702338
			},
			{
				"lng": 11.461696247267536,
				"lat": 43.546706423599822
			},
			{
				"lng": 11.461696247267536,
				"lat": 43.546706423599822
			},
			{
				"lng": 11.461666900540877,
				"lat": 43.546714164824856
			},
			{
				"lng": 11.461638003717981,
				"lat": 43.546722754977232
			},
			{
				"lng": 11.461638003717981,
				"lat": 43.546722754977232
			},
			{
				"lng": 11.46162067467748,
				"lat": 43.54672770761762
			},
			{
				"lng": 11.461602927292216,
				"lat": 43.546731802117549
			},
			{
				"lng": 11.461602927292217,
				"lat": 43.54673180211757
			},
			{
				"lng": 11.461577526957099,
				"lat": 43.546736602782353
			},
			{
				"lng": 11.461551890781987,
				"lat": 43.546740686676941
			},
			{
				"lng": 11.461551890781987,
				"lat": 43.546740686676941
			},
			{
				"lng": 11.461464886751159,
				"lat": 43.546754773749718
			},
			{
				"lng": 11.461464886751159,
				"lat": 43.546754773749718
			},
			{
				"lng": 11.461429650585016,
				"lat": 43.546761733115879
			},
			{
				"lng": 11.4613949002407,
				"lat": 43.546769883096268
			},
			{
				"lng": 11.461360711710839,
				"lat": 43.546779205868546
			},
			{
				"lng": 11.461360711710846,
				"lat": 43.546779205868546
			},
			{
				"lng": 11.461329976813424,
				"lat": 43.546788857915324
			},
			{
				"lng": 11.461299958668461,
				"lat": 43.546799637566558
			},
			{
				"lng": 11.461270735405867,
				"lat": 43.546811516765558
			},
			{
				"lng": 11.461270735405858,
				"lat": 43.546811516765551
			},
			{
				"lng": 11.461263357153438,
				"lat": 43.546814952616984
			},
			{
				"lng": 11.461256320390708,
				"lat": 43.546818748603037
			},
			{
				"lng": 11.461249658284242,
				"lat": 43.546822886832047
			},
			{
				"lng": 11.461243402234755,
				"lat": 43.546827347799216
			},
			{
				"lng": 11.461237581729103,
				"lat": 43.546832110478576
			},
			{
				"lng": 11.461232224201307,
				"lat": 43.546837152422064
			},
			{
				"lng": 11.461227354903249,
				"lat": 43.546842449865423
			},
			{
				"lng": 11.461222996785644,
				"lat": 43.546847977840045
			},
			{
				"lng": 11.461219170389846,
				"lat": 43.54685371029084
			},
			{
				"lng": 11.461215893751076,
				"lat": 43.54685962019888
			}
			],
			[{
				"lng": 11.466923299067625,
				"lat": 43.544924425365075
			},
			{
				"lng": 11.466914421655158,
				"lat": 43.544925178200842
			},
			{
				"lng": 11.466905511983356,
				"lat": 43.544925691190684
			},
			{
				"lng": 11.466905511983356,
				"lat": 43.544925691190684
			},
			{
				"lng": 11.466903960783794,
				"lat": 43.544925750204222
			},
			{
				"lng": 11.466903960783794,
				"lat": 43.544925750204222
			},
			{
				"lng": 11.46690063277711,
				"lat": 43.544925797484623
			},
			{
				"lng": 11.46690063277711,
				"lat": 43.544925797484623
			},
			{
				"lng": 11.46689437702832,
				"lat": 43.544925728891052
			},
			{
				"lng": 11.46689437702832,
				"lat": 43.544925728891052
			},
			{
				"lng": 11.466893552333657,
				"lat": 43.544925694067956
			},
			{
				"lng": 11.466892732169248,
				"lat": 43.544925622266845
			},
			{
				"lng": 11.466892732169248,
				"lat": 43.544925622266845
			},
			{
				"lng": 11.466892640460799,
				"lat": 43.544925614246573
			},
			{
				"lng": 11.466892548245193,
				"lat": 43.544925610377504
			},
			{
				"lng": 11.466892455877209,
				"lat": 43.544925610674582
			},
			{
				"lng": 11.466892363712237,
				"lat": 43.544925615136606
			},
			{
				"lng": 11.466892272104877,
				"lat": 43.544925623746472
			},
			{
				"lng": 11.466892181407569,
				"lat": 43.544925636470985
			},
			{
				"lng": 11.466892181407569,
				"lat": 43.544925636470985
			},
			{
				"lng": 11.466891981060996,
				"lat": 43.544925672894948
			},
			{
				"lng": 11.466891783272427,
				"lat": 43.544925716087178
			},
			{
				"lng": 11.46689178327243,
				"lat": 43.544925716087185
			},
			{
				"lng": 11.466884766528528,
				"lat": 43.544927394084944
			},
			{
				"lng": 11.466884766528528,
				"lat": 43.544927394084937
			},
			{
				"lng": 11.466868188488899,
				"lat": 43.544931393513714
			},
			{
				"lng": 11.466868188488899,
				"lat": 43.544931393513714
			},
			{
				"lng": 11.466867939647786,
				"lat": 43.544931452999343
			},
			{
				"lng": 11.466867939647786,
				"lat": 43.544931452999343
			},
			{
				"lng": 11.466863183817001,
				"lat": 43.544932578900656
			},
			{
				"lng": 11.466863183817001,
				"lat": 43.544932578900656
			},
			{
				"lng": 11.466846903953726,
				"lat": 43.544936171863242
			},
			{
				"lng": 11.466846903953721,
				"lat": 43.544936171863235
			},
			{
				"lng": 11.466825647280604,
				"lat": 43.544940272560858
			},
			{
				"lng": 11.466825647280611,
				"lat": 43.544940272560886
			},
			{
				"lng": 11.466818206377157,
				"lat": 43.544941516034179
			},
			{
				"lng": 11.466810708751408,
				"lat": 43.544942563834503
			},
			{
				"lng": 11.466810708751405,
				"lat": 43.544942563834503
			},
			{
				"lng": 11.466805490011406,
				"lat": 43.544943121003762
			},
			{
				"lng": 11.46680023844133,
				"lat": 43.544943479556984
			},
			{
				"lng": 11.466800238441328,
				"lat": 43.54494347955697
			},
			{
				"lng": 11.466793030758115,
				"lat": 43.544943734513787
			},
			{
				"lng": 11.466793030758115,
				"lat": 43.544943734513787
			},
			{
				"lng": 11.466785535143757,
				"lat": 43.544943796937389
			},
			{
				"lng": 11.466785535143757,
				"lat": 43.544943796937417
			},
			{
				"lng": 11.466777207159081,
				"lat": 43.544943667958663
			},
			{
				"lng": 11.466777207159081,
				"lat": 43.544943667958655
			},
			{
				"lng": 11.466771170444902,
				"lat": 43.544943422633501
			},
			{
				"lng": 11.466771170444902,
				"lat": 43.544943422633501
			},
			{
				"lng": 11.466765853713575,
				"lat": 43.544943055045607
			},
			{
				"lng": 11.466760559947124,
				"lat": 43.544942541188966
			},
			{
				"lng": 11.466760559947124,
				"lat": 43.544942541188959
			},
			{
				"lng": 11.466755727824273,
				"lat": 43.544941929704059
			},
			{
				"lng": 11.466750934499908,
				"lat": 43.544941173720083
			},
			{
				"lng": 11.466750934499908,
				"lat": 43.544941173720083
			},
			{
				"lng": 11.466740490316825,
				"lat": 43.544939343340829
			},
			{
				"lng": 11.466740490316822,
				"lat": 43.544939343340829
			},
			{
				"lng": 11.466732441048364,
				"lat": 43.544937900301221
			},
			{
				"lng": 11.466732441048364,
				"lat": 43.544937900301221
			},
			{
				"lng": 11.46673205502114,
				"lat": 43.544937829955423
			},
			{
				"lng": 11.46673205502114,
				"lat": 43.544937829955423
			},
			{
				"lng": 11.466731587817003,
				"lat": 43.544937744762365
			},
			{
				"lng": 11.466731587817003,
				"lat": 43.544937744762365
			},
			{
				"lng": 11.466730137846957,
				"lat": 43.544937518538106
			},
			{
				"lng": 11.466728670262453,
				"lat": 43.544937363664744
			},
			{
				"lng": 11.46672719169155,
				"lat": 43.544937280841793
			},
			{
				"lng": 11.466725708811913,
				"lat": 43.544937270443263
			},
			{
				"lng": 11.466724228320684,
				"lat": 43.544937332516113
			},
			{
				"lng": 11.466722756904204,
				"lat": 43.544937466780048
			},
			{
				"lng": 11.46672130120783,
				"lat": 43.54493767262862
			},
			{
				"lng": 11.46672130120783,
				"lat": 43.54493767262862
			},
			{
				"lng": 11.466716377344683,
				"lat": 43.544938382345727
			},
			{
				"lng": 11.46671140384208,
				"lat": 43.544938876052214
			},
			{
				"lng": 11.466706398593534,
				"lat": 43.544939151971853
			},
			{
				"lng": 11.466701379606745,
				"lat": 43.544939209111945
			},
			{
				"lng": 11.466701379606745,
				"lat": 43.544939209111945
			},
			{
				"lng": 11.466684703413675,
				"lat": 43.544938960909498
			},
			{
				"lng": 11.466684703413675,
				"lat": 43.544938960909498
			},
			{
				"lng": 11.466674219254692,
				"lat": 43.544938684021126
			},
			{
				"lng": 11.466674219254692,
				"lat": 43.544938684021126
			},
			{
				"lng": 11.46665078019341,
				"lat": 43.544937622345081
			},
			{
				"lng": 11.46665078019341,
				"lat": 43.544937622345081
			},
			{
				"lng": 11.466647057068942,
				"lat": 43.544937340327763
			},
			{
				"lng": 11.466643358425946,
				"lat": 43.544936921196481
			},
			{
				"lng": 11.466643358425946,
				"lat": 43.544936921196481
			},
			{
				"lng": 11.466636580092189,
				"lat": 43.544935935704558
			},
			{
				"lng": 11.466636580092189,
				"lat": 43.544935935704558
			},
			{
				"lng": 11.466629653965164,
				"lat": 43.544934748360618
			},
			{
				"lng": 11.466629653965164,
				"lat": 43.544934748360618
			},
			{
				"lng": 11.466626424352993,
				"lat": 43.544934122537832
			},
			{
				"lng": 11.466626424352993,
				"lat": 43.544934122537832
			},
			{
				"lng": 11.466625957815051,
				"lat": 43.544934035349478
			},
			{
				"lng": 11.466625486670459,
				"lat": 43.544933962436723
			},
			{
				"lng": 11.466625486670459,
				"lat": 43.544933962436723
			},
			{
				"lng": 11.466624724725836,
				"lat": 43.544933858298641
			},
			{
				"lng": 11.466624724725836,
				"lat": 43.544933858298641
			},
			{
				"lng": 11.466622048561877,
				"lat": 43.54493350022787
			},
			{
				"lng": 11.466622048561877,
				"lat": 43.54493350022787
			},
			{
				"lng": 11.466620647466168,
				"lat": 43.54493331508003
			},
			{
				"lng": 11.466620647466168,
				"lat": 43.54493331508003
			},
			{
				"lng": 11.466620583992901,
				"lat": 43.544933308182856
			},
			{
				"lng": 11.466620583992901,
				"lat": 43.544933308182856
			},
			{
				"lng": 11.466620575167052,
				"lat": 43.544933307590284
			},
			{
				"lng": 11.466620566310665,
				"lat": 43.54493330733456
			},
			{
				"lng": 11.466620557448019,
				"lat": 43.544933307416414
			},
			{
				"lng": 11.466620548603412,
				"lat": 43.544933307835642
			},
			{
				"lng": 11.466620548603411,
				"lat": 43.544933307835656
			},
			{
				"lng": 11.466618917702412,
				"lat": 43.544933419093056
			},
			{
				"lng": 11.466618917702412,
				"lat": 43.544933419093056
			},
			{
				"lng": 11.466613885284552,
				"lat": 43.544933787434758
			},
			{
				"lng": 11.466613885284552,
				"lat": 43.544933787434758
			},
			{
				"lng": 11.46661252215528,
				"lat": 43.54493390844398
			},
			{
				"lng": 11.46661252215528,
				"lat": 43.54493390844398
			},
			{
				"lng": 11.466611977044707,
				"lat": 43.544933974760106
			},
			{
				"lng": 11.466611437802918,
				"lat": 43.544934062879371
			},
			{
				"lng": 11.466610906076779,
				"lat": 43.544934172532628
			},
			{
				"lng": 11.466610906076779,
				"lat": 43.544934172532628
			},
			{
				"lng": 11.466609505159781,
				"lat": 43.5449344659486
			},
			{
				"lng": 11.466608086813029,
				"lat": 43.544934711087116
			},
			{
				"lng": 11.466608086813029,
				"lat": 43.544934711087116
			},
			{
				"lng": 11.466599570509967,
				"lat": 43.544935944404557
			},
			{
				"lng": 11.466599570509963,
				"lat": 43.544935944404536
			},
			{
				"lng": 11.466581841031241,
				"lat": 43.544938250218387
			},
			{
				"lng": 11.466581841031241,
				"lat": 43.544938250218387
			},
			{
				"lng": 11.466572383112037,
				"lat": 43.544939415033184
			},
			{
				"lng": 11.466572383112037,
				"lat": 43.544939415033184
			},
			{
				"lng": 11.466569616486732,
				"lat": 43.544939729894573
			},
			{
				"lng": 11.46656961648673,
				"lat": 43.544939729894601
			},
			{
				"lng": 11.466567086760927,
				"lat": 43.54493996347172
			},
			{
				"lng": 11.466567086760927,
				"lat": 43.544939963471698
			},
			{
				"lng": 11.466558249071742,
				"lat": 43.544940618154442
			},
			{
				"lng": 11.466558249071742,
				"lat": 43.544940618154442
			},
			{
				"lng": 11.466556131566499,
				"lat": 43.544940738153947
			},
			{
				"lng": 11.466554009457678,
				"lat": 43.544940801974043
			},
			{
				"lng": 11.466554009457678,
				"lat": 43.544940801974057
			},
			{
				"lng": 11.466552640349359,
				"lat": 43.544940853149186
			},
			{
				"lng": 11.466551277394233,
				"lat": 43.544940960451321
			},
			{
				"lng": 11.466551277394233,
				"lat": 43.544940960451328
			},
			{
				"lng": 11.466550827557008,
				"lat": 43.544941015208366
			},
			{
				"lng": 11.466550382994415,
				"lat": 43.544941089333179
			},
			{
				"lng": 11.466549945281004,
				"lat": 43.54494118256325
			},
			{
				"lng": 11.466549945281002,
				"lat": 43.544941182563221
			},
			{
				"lng": 11.466548699390179,
				"lat": 43.544941500795609
			},
			{
				"lng": 11.466547475019004,
				"lat": 43.544941860516346
			},
			{
				"lng": 11.466547475019006,
				"lat": 43.544941860516367
			},
			{
				"lng": 11.466546972615024,
				"lat": 43.544942027639266
			},
			{
				"lng": 11.466546480784107,
				"lat": 43.544942210647854
			},
			{
				"lng": 11.466546480784102,
				"lat": 43.544942210647854
			},
			{
				"lng": 11.46654261698848,
				"lat": 43.544943767217688
			},
			{
				"lng": 11.466542616988475,
				"lat": 43.544943767217688
			},
			{
				"lng": 11.466539513515563,
				"lat": 43.544945136126003
			},
			{
				"lng": 11.466536521638043,
				"lat": 43.544946630722578
			},
			{
				"lng": 11.466533650965404,
				"lat": 43.544948246207028
			},
			{
				"lng": 11.466530910717832,
				"lat": 43.544949977390573
			},
			{
				"lng": 11.46652830969661,
				"lat": 43.544951818712988
			},
			{
				"lng": 11.466528309696605,
				"lat": 43.544951818712988
			},
			{
				"lng": 11.466524769682653,
				"lat": 43.544954303314647
			},
			{
				"lng": 11.466521014405236,
				"lat": 43.544956614661452
			},
			{
				"lng": 11.466517059859102,
				"lat": 43.544958742908726
			},
			{
				"lng": 11.466512922887743,
				"lat": 43.544960678991693
			},
			{
				"lng": 11.466512922887745,
				"lat": 43.5449606789917
			},
			{
				"lng": 11.466503413842251,
				"lat": 43.544964579319938
			},
			{
				"lng": 11.466503413842259,
				"lat": 43.544964579319959
			},
			{
				"lng": 11.466495260475568,
				"lat": 43.544967495704867
			},
			{
				"lng": 11.466495260475568,
				"lat": 43.544967495704867
			},
			{
				"lng": 11.466485506385876,
				"lat": 43.54497042519521
			},
			{
				"lng": 11.466485506385869,
				"lat": 43.544970425195203
			},
			{
				"lng": 11.466480928565035,
				"lat": 43.54497159586834
			},
			{
				"lng": 11.466476293350954,
				"lat": 43.544972640234192
			},
			{
				"lng": 11.466476293350961,
				"lat": 43.544972640234192
			},
			{
				"lng": 11.466469756687877,
				"lat": 43.544973860856437
			},
			{
				"lng": 11.466463130542975,
				"lat": 43.544974791831997
			},
			{
				"lng": 11.466463130542975,
				"lat": 43.544974791831997
			},
			{
				"lng": 11.466451876045705,
				"lat": 43.544975967410508
			},
			{
				"lng": 11.466440570822341,
				"lat": 43.544976848597585
			},
			{
				"lng": 11.466440570822341,
				"lat": 43.544976848597585
			},
			{
				"lng": 11.466409971352599,
				"lat": 43.544978320972469
			},
			{
				"lng": 11.466409971352597,
				"lat": 43.544978320972476
			},
			{
				"lng": 11.466402369878304,
				"lat": 43.544978433446403
			},
			{
				"lng": 11.46639476931864,
				"lat": 43.54497829199849
			},
			{
				"lng": 11.46639476931864,
				"lat": 43.54497829199849
			},
			{
				"lng": 11.466384545552042,
				"lat": 43.544977883013118
			},
			{
				"lng": 11.466384545552042,
				"lat": 43.544977883013082
			},
			{
				"lng": 11.466375375038416,
				"lat": 43.544977521081876
			},
			{
				"lng": 11.466375375038416,
				"lat": 43.544977521081883
			},
			{
				"lng": 11.466367340946968,
				"lat": 43.544977277163788
			},
			{
				"lng": 11.466367340946968,
				"lat": 43.544977277163788
			},
			{
				"lng": 11.466366817717917,
				"lat": 43.544977271154508
			},
			{
				"lng": 11.466366294591902,
				"lat": 43.544977280806293
			},
			{
				"lng": 11.466366294591902,
				"lat": 43.544977280806293
			},
			{
				"lng": 11.466366007737944,
				"lat": 43.54497729614225
			},
			{
				"lng": 11.466365722471872,
				"lat": 43.544977322897978
			},
			{
				"lng": 11.466365439652256,
				"lat": 43.544977360992974
			},
			{
				"lng": 11.4663651601303,
				"lat": 43.544977410312512
			},
			{
				"lng": 11.4663651601303,
				"lat": 43.544977410312512
			},
			{
				"lng": 11.466354840161245,
				"lat": 43.544979545563862
			},
			{
				"lng": 11.466354840161245,
				"lat": 43.544979545563862
			},
			{
				"lng": 11.466347679429285,
				"lat": 43.544981179694503
			},
			{
				"lng": 11.466347679429289,
				"lat": 43.544981179694517
			},
			{
				"lng": 11.466341904563631,
				"lat": 43.544982480693591
			},
			{
				"lng": 11.466341904563627,
				"lat": 43.544982480693584
			},
			{
				"lng": 11.466338699363124,
				"lat": 43.544983073631919
			},
			{
				"lng": 11.466335448000111,
				"lat": 43.544983513942952
			},
			{
				"lng": 11.466335448000111,
				"lat": 43.544983513942952
			},
			{
				"lng": 11.466313195303492,
				"lat": 43.544985670639377
			},
			{
				"lng": 11.466313195303492,
				"lat": 43.544985670639377
			},
			{
				"lng": 11.466307596408011,
				"lat": 43.544986021189743
			},
			{
				"lng": 11.466301979494997,
				"lat": 43.544986147531986
			},
			{
				"lng": 11.466296361520508,
				"lat": 43.544986049284738
			},
			{
				"lng": 11.466296361520508,
				"lat": 43.544986049284745
			},
			{
				"lng": 11.466293308333963,
				"lat": 43.544985998160229
			},
			{
				"lng": 11.466290256101221,
				"lat": 43.54498607362499
			},
			{
				"lng": 11.466287214733812,
				"lat": 43.544986275434006
			},
			{
				"lng": 11.466284194107992,
				"lat": 43.544986602931893
			},
			{
				"lng": 11.466284194107985,
				"lat": 43.544986602931885
			},
			{
				"lng": 11.466279549486561,
				"lat": 43.544987309613894
			},
			{
				"lng": 11.466274970826259,
				"lat": 43.544988215869544
			},
			{
				"lng": 11.466270474319156,
				"lat": 43.544989318493919
			},
			{
				"lng": 11.466266075866802,
				"lat": 43.544990613587672
			},
			{
				"lng": 11.466266075866796,
				"lat": 43.544990613587665
			},
			{
				"lng": 11.466257295656101,
				"lat": 43.544993223859962
			},
			{
				"lng": 11.466248338423998,
				"lat": 43.544995493698309
			},
			{
				"lng": 11.466239229097436,
				"lat": 43.544997416785996
			},
			{
				"lng": 11.46623922909744,
				"lat": 43.544997416786018
			},
			{
				"lng": 11.466223823443805,
				"lat": 43.54500030451652
			},
			{
				"lng": 11.466223823443805,
				"lat": 43.54500030451652
			},
			{
				"lng": 11.466209963617709,
				"lat": 43.545002814448623
			},
			{
				"lng": 11.466209963617709,
				"lat": 43.545002814448623
			},
			{
				"lng": 11.466177896628409,
				"lat": 43.545007976703047
			},
			{
				"lng": 11.466177896628409,
				"lat": 43.545007976703047
			},
			{
				"lng": 11.466168302440913,
				"lat": 43.545009228605018
			},
			{
				"lng": 11.466158651343168,
				"lat": 43.545010222461244
			},
			{
				"lng": 11.466158651343164,
				"lat": 43.545010222461244
			},
			{
				"lng": 11.46615184865934,
				"lat": 43.545010661568732
			},
			{
				"lng": 11.466145020765474,
				"lat": 43.545010766443873
			},
			{
				"lng": 11.466145020765474,
				"lat": 43.545010766443873
			},
			{
				"lng": 11.466107746952197,
				"lat": 43.545009756454299
			},
			{
				"lng": 11.466107746952197,
				"lat": 43.545009756454299
			},
			{
				"lng": 11.466088029925226,
				"lat": 43.545008514132419
			},
			{
				"lng": 11.466088029925222,
				"lat": 43.545008514132434
			},
			{
				"lng": 11.466070668630735,
				"lat": 43.545006752369709
			},
			{
				"lng": 11.466070668630735,
				"lat": 43.545006752369709
			},
			{
				"lng": 11.46606556885172,
				"lat": 43.545006019767584
			},
			{
				"lng": 11.466060535208337,
				"lat": 43.545005075677999
			},
			{
				"lng": 11.466055584261932,
				"lat": 43.545003923207219
			},
			{
				"lng": 11.466050732301776,
				"lat": 43.54500256614697
			},
			{
				"lng": 11.466050732301776,
				"lat": 43.54500256614697
			},
			{
				"lng": 11.466042419566339,
				"lat": 43.544999831219307
			},
			{
				"lng": 11.46603433876067,
				"lat": 43.544996750377756
			},
			{
				"lng": 11.46602651706127,
				"lat": 43.544993333983491
			},
			{
				"lng": 11.466026517061266,
				"lat": 43.544993333983491
			},
			{
				"lng": 11.466019055420034,
				"lat": 43.544989597468984
			},
			{
				"lng": 11.466011950496616,
				"lat": 43.544985509574836
			},
			{
				"lng": 11.46600523351109,
				"lat": 43.544981088263846
			},
			{
				"lng": 11.465998933978835,
				"lat": 43.544976352963928
			},
			{
				"lng": 11.465998933978829,
				"lat": 43.544976352963928
			},
			{
				"lng": 11.465991273649784,
				"lat": 43.544970523876621
			},
			{
				"lng": 11.465983191401424,
				"lat": 43.544965004470448
			},
			{
				"lng": 11.465974710860648,
				"lat": 43.544959810880279
			},
			{
				"lng": 11.465965856818663,
				"lat": 43.544954958288493
			},
			{
				"lng": 11.465965856818666,
				"lat": 43.544954958288493
			},
			{
				"lng": 11.465917288852342,
				"lat": 43.544930958929392
			},
			{
				"lng": 11.465917288852342,
				"lat": 43.544930958929392
			},
			{
				"lng": 11.465912322178825,
				"lat": 43.544928743309335
			},
			{
				"lng": 11.465907211550549,
				"lat": 43.544926708266033
			},
			{
				"lng": 11.465901969365687,
				"lat": 43.544924858736309
			},
			{
				"lng": 11.465901969365683,
				"lat": 43.544924858736309
			},
			{
				"lng": 11.465891064437315,
				"lat": 43.544921265123811
			},
			{
				"lng": 11.465891064437315,
				"lat": 43.544921265123811
			},
			{
				"lng": 11.465884854564656,
				"lat": 43.544919242696814
			},
			{
				"lng": 11.465884854564662,
				"lat": 43.544919242696814
			},
			{
				"lng": 11.465875231203336,
				"lat": 43.544916160449127
			},
			{
				"lng": 11.465875231203334,
				"lat": 43.544916160449127
			},
			{
				"lng": 11.465870929406398,
				"lat": 43.544914823417301
			},
			{
				"lng": 11.465870929406401,
				"lat": 43.544914823417301
			},
			{
				"lng": 11.465870299096521,
				"lat": 43.544914645594126
			},
			{
				"lng": 11.465869656836238,
				"lat": 43.544914492054211
			},
			{
				"lng": 11.465869004392317,
				"lat": 43.54491436322003
			},
			{
				"lng": 11.465868343559515,
				"lat": 43.544914259445875
			},
			{
				"lng": 11.465868343559515,
				"lat": 43.544914259445875
			},
			{
				"lng": 11.465859670380219,
				"lat": 43.544913278944286
			},
			{
				"lng": 11.465859670380219,
				"lat": 43.544913278944286
			},
			{
				"lng": 11.465856642332817,
				"lat": 43.544913073954838
			},
			{
				"lng": 11.465853603005389,
				"lat": 43.544912997743744
			},
			{
				"lng": 11.465850562739911,
				"lat": 43.544913050570209
			},
			{
				"lng": 11.465847531881545,
				"lat": 43.544913232254594
			},
			{
				"lng": 11.465844520743463,
				"lat": 43.54491354217862
			},
			{
				"lng": 11.465844520743463,
				"lat": 43.54491354217862
			},
			{
				"lng": 11.465839781612756,
				"lat": 43.544914030971341
			},
			{
				"lng": 11.46583501159186,
				"lat": 43.544914319930399
			},
			{
				"lng": 11.465830226592759,
				"lat": 43.544914408091877
			},
			{
				"lng": 11.465825442577389,
				"lat": 43.544914295161654
			},
			{
				"lng": 11.465825442577389,
				"lat": 43.544914295161654
			},
			{
				"lng": 11.465818219086415,
				"lat": 43.54491385788539
			},
			{
				"lng": 11.465811028491695,
				"lat": 43.54491319298009
			},
			{
				"lng": 11.465811028491695,
				"lat": 43.54491319298009
			},
			{
				"lng": 11.465774047251418,
				"lat": 43.544908715654692
			},
			{
				"lng": 11.465774047251418,
				"lat": 43.544908715654692
			},
			{
				"lng": 11.465752290766552,
				"lat": 43.544905425444334
			},
			{
				"lng": 11.465730768314407,
				"lat": 43.544901402426468
			},
			{
				"lng": 11.465730768314403,
				"lat": 43.544901402426468
			},
			{
				"lng": 11.465721670233995,
				"lat": 43.544899362708456
			},
			{
				"lng": 11.465712718267982,
				"lat": 43.544897005610011
			},
			{
				"lng": 11.465703933327651,
				"lat": 43.544894336637128
			},
			{
				"lng": 11.465703933327651,
				"lat": 43.544894336637128
			},
			{
				"lng": 11.465697025621674,
				"lat": 43.544891914247366
			},
			{
				"lng": 11.465690325647698,
				"lat": 43.54488920064459
			},
			{
				"lng": 11.465683856583006,
				"lat": 43.544886205216059
			},
			{
				"lng": 11.465677640806078,
				"lat": 43.544882938323859
			},
			{
				"lng": 11.465677640806076,
				"lat": 43.54488293832388
			},
			{
				"lng": 11.465668396989694,
				"lat": 43.544877405042435
			},
			{
				"lng": 11.465659682392877,
				"lat": 43.544871434627403
			},
			{
				"lng": 11.465651536006616,
				"lat": 43.544865053791831
			},
			{
				"lng": 11.465651536006627,
				"lat": 43.544865053791831
			},
			{
				"lng": 11.465635010097245,
				"lat": 43.544850262270614
			},
			{
				"lng": 11.465635010097245,
				"lat": 43.544850262270614
			},
			{
				"lng": 11.465629600227821,
				"lat": 43.54484534102486
			},
			{
				"lng": 11.465623863840555,
				"lat": 43.544840619481221
			},
			{
				"lng": 11.465623863840555,
				"lat": 43.544840619481221
			},
			{
				"lng": 11.465610986283647,
				"lat": 43.544830672197563
			},
			{
				"lng": 11.465610986283638,
				"lat": 43.544830672197563
			},
			{
				"lng": 11.465600918879753,
				"lat": 43.544823141738604
			},
			{
				"lng": 11.465600918879757,
				"lat": 43.544823141738604
			},
			{
				"lng": 11.465589702441665,
				"lat": 43.544815314337541
			},
			{
				"lng": 11.465589702441669,
				"lat": 43.544815314337541
			},
			{
				"lng": 11.465589011332849,
				"lat": 43.544814880761045
			},
			{
				"lng": 11.465588288652208,
				"lat": 43.544814475333979
			},
			{
				"lng": 11.465587536563975,
				"lat": 43.544814099270496
			},
			{
				"lng": 11.465586757320439,
				"lat": 43.544813753696829
			},
			{
				"lng": 11.465586757320436,
				"lat": 43.544813753696829
			},
			{
				"lng": 11.465586138702575,
				"lat": 43.544813510417704
			},
			{
				"lng": 11.46558550444345,
				"lat": 43.544813289474554
			},
			{
				"lng": 11.46558485606608,
				"lat": 43.544813091397813
			},
			{
				"lng": 11.465584856066082,
				"lat": 43.544813091397813
			},
			{
				"lng": 11.465572364540089,
				"lat": 43.544809655531672
			},
			{
				"lng": 11.465572364540087,
				"lat": 43.544809655531679
			},
			{
				"lng": 11.465559160197822,
				"lat": 43.544806351538071
			},
			{
				"lng": 11.465545795978258,
				"lat": 43.544803407248409
			},
			{
				"lng": 11.465545795978262,
				"lat": 43.544803407248395
			},
			{
				"lng": 11.465534058738827,
				"lat": 43.544800797466266
			},
			{
				"lng": 11.465522483931133,
				"lat": 43.544797828542279
			},
			{
				"lng": 11.465522483931133,
				"lat": 43.544797828542279
			},
			{
				"lng": 11.465507647902166,
				"lat": 43.544793409484086
			},
			{
				"lng": 11.465493181648498,
				"lat": 43.544788383436789
			},
			{
				"lng": 11.465493181648498,
				"lat": 43.544788383436774
			},
			{
				"lng": 11.465475356620566,
				"lat": 43.544781357720012
			},
			{
				"lng": 11.465457984237998,
				"lat": 43.544773755714715
			},
			{
				"lng": 11.465457984237995,
				"lat": 43.544773755714715
			},
			{
				"lng": 11.46542486628953,
				"lat": 43.544758244310565
			},
			{
				"lng": 11.46542486628953,
				"lat": 43.544758244310565
			},
			{
				"lng": 11.465385889223825,
				"lat": 43.544739393387054
			},
			{
				"lng": 11.46538588922383,
				"lat": 43.544739393387054
			},
			{
				"lng": 11.465358249461374,
				"lat": 43.5447254149001
			},
			{
				"lng": 11.465358249461371,
				"lat": 43.5447254149001
			},
			{
				"lng": 11.465342364199728,
				"lat": 43.544717561119036
			},
			{
				"lng": 11.46534236419973,
				"lat": 43.544717561119036
			},
			{
				"lng": 11.465339161912212,
				"lat": 43.544716141573751
			},
			{
				"lng": 11.465335866030394,
				"lat": 43.544714840303264
			},
			{
				"lng": 11.465335866030397,
				"lat": 43.544714840303243
			},
			{
				"lng": 11.465333090113969,
				"lat": 43.544713885503064
			},
			{
				"lng": 11.46533023919525,
				"lat": 43.544713055838663
			},
			{
				"lng": 11.46533023919525,
				"lat": 43.54471305583867
			},
			{
				"lng": 11.465327176106726,
				"lat": 43.544712315196513
			},
			{
				"lng": 11.465324058997165,
				"lat": 43.544711705360761
			},
			{
				"lng": 11.465320898413975,
				"lat": 43.54471122839491
			},
			{
				"lng": 11.465320898413975,
				"lat": 43.54471122839491
			},
			{
				"lng": 11.465295775156395,
				"lat": 43.544708611119837
			},
			{
				"lng": 11.465295775156395,
				"lat": 43.544708611119837
			},
			{
				"lng": 11.465269494987028,
				"lat": 43.544706578659131
			},
			{
				"lng": 11.465269494987028,
				"lat": 43.544706578659131
			},
			{
				"lng": 11.465254818879073,
				"lat": 43.544705537146598
			},
			{
				"lng": 11.465254818879073,
				"lat": 43.544705537146598
			},
			{
				"lng": 11.465230152923818,
				"lat": 43.544703997042262
			},
			{
				"lng": 11.465230152923818,
				"lat": 43.544703997042262
			},
			{
				"lng": 11.465212696911255,
				"lat": 43.544703094112343
			},
			{
				"lng": 11.465212696911255,
				"lat": 43.544703094112343
			},
			{
				"lng": 11.465203953367602,
				"lat": 43.54470283068185
			},
			{
				"lng": 11.465195202328934,
				"lat": 43.544702834785944
			},
			{
				"lng": 11.465195202328934,
				"lat": 43.544702834785944
			},
			{
				"lng": 11.465151673496131,
				"lat": 43.544702985792014
			},
			{
				"lng": 11.465151673496131,
				"lat": 43.544702985792021
			},
			{
				"lng": 11.465147417264212,
				"lat": 43.544702891686356
			},
			{
				"lng": 11.465143168593798,
				"lat": 43.544702684603713
			},
			{
				"lng": 11.465143168593798,
				"lat": 43.544702684603713
			},
			{
				"lng": 11.465128180585252,
				"lat": 43.544701980811148
			},
			{
				"lng": 11.465128180585252,
				"lat": 43.544701980811148
			},
			{
				"lng": 11.46512627016917,
				"lat": 43.544701967225528
			},
			{
				"lng": 11.465124362896464,
				"lat": 43.54470204805996
			},
			{
				"lng": 11.465122467576562,
				"lat": 43.544702222941062
			},
			{
				"lng": 11.465120592963686,
				"lat": 43.544702491061173
			},
			{
				"lng": 11.465118747716396,
				"lat": 43.544702851181789
			},
			{
				"lng": 11.465116940357634,
				"lat": 43.544703301639601
			},
			{
				"lng": 11.465115179235342,
				"lat": 43.544703840354003
			},
			{
				"lng": 11.465113472483889,
				"lat": 43.544704464836762
			},
			{
				"lng": 11.465111827986524,
				"lat": 43.544705172203479
			},
			{
				"lng": 11.465110253338954,
				"lat": 43.544705959186892
			},
			{
				"lng": 11.46510875581426,
				"lat": 43.544706822152101
			},
			{
				"lng": 11.465107342329294,
				"lat": 43.544707757113123
			},
			{
				"lng": 11.465106019412753,
				"lat": 43.544708759751522
			},
			{
				"lng": 11.465104793175016,
				"lat": 43.544709825436293
			},
			{
				"lng": 11.4651036692799,
				"lat": 43.544710949245136
			},
			{
				"lng": 11.465102652918523,
				"lat": 43.544712125987346
			},
			{
				"lng": 11.465101748785331,
				"lat": 43.544713350227738
			},
			{
				"lng": 11.465100961056404,
				"lat": 43.544714616311708
			},
			{
				"lng": 11.465100293370147,
				"lat": 43.544715918391361
			},
			{
				"lng": 11.46509974881052,
				"lat": 43.544717250452607
			},
			{
				"lng": 11.46509932989278,
				"lat": 43.544718606342826
			},
			{
				"lng": 11.465099038551859,
				"lat": 43.544719979799318
			},
			{
				"lng": 11.465098876133434,
				"lat": 43.544721364478349
			},
			{
				"lng": 11.46509884338769,
				"lat": 43.544722753984196
			},
			{
				"lng": 11.465098940465895,
				"lat": 43.544724141898968
			},
			{
				"lng": 11.465099166919668,
				"lat": 43.544725521812055
			},
			{
				"lng": 11.465099521703049,
				"lat": 43.544726887349846
			},
			{
				"lng": 11.465099521703054,
				"lat": 43.544726887349846
			},
			{
				"lng": 11.465105079280098,
				"lat": 43.544742452875148
			},
			{
				"lng": 11.465112049821004,
				"lat": 43.544757714569222
			},
			{
				"lng": 11.465120402367772,
				"lat": 43.544772604648536
			},
			{
				"lng": 11.465130099824274,
				"lat": 43.54478705698012
			},
			{
				"lng": 11.465141099120999,
				"lat": 43.544801007375092
			},
			{
				"lng": 11.465153351406297,
				"lat": 43.544814393873963
			},
			{
				"lng": 11.465166802263386,
				"lat": 43.544827157021615
			},
			{
				"lng": 11.465166802263386,
				"lat": 43.544827157021615
			},
			{
				"lng": 11.465204579451276,
				"lat": 43.5448593839387
			},
			{
				"lng": 11.465243985151089,
				"lat": 43.544890561959534
			},
			{
				"lng": 11.465243985151082,
				"lat": 43.544890561959534
			},
			{
				"lng": 11.465285899931036,
				"lat": 43.544923652127324
			},
			{
				"lng": 11.465326189520715,
				"lat": 43.544957793719291
			},
			{
				"lng": 11.465326189520722,
				"lat": 43.544957793719291
			},
			{
				"lng": 11.465357673312614,
				"lat": 43.544987479087986
			},
			{
				"lng": 11.46538625472151,
				"lat": 43.545018679450898
			},
			{
				"lng": 11.465386254721508,
				"lat": 43.545018679450898
			},
			{
				"lng": 11.465387799888639,
				"lat": 43.545020374445777
			},
			{
				"lng": 11.465389492765754,
				"lat": 43.545021993068239
			},
			{
				"lng": 11.4653913262409,
				"lat": 43.545023528518293
			},
			{
				"lng": 11.465393292611427,
				"lat": 43.545024974345296
			},
			{
				"lng": 11.465395383616404,
				"lat": 43.545026324475202
			},
			{
				"lng": 11.465397590471275,
				"lat": 43.54502757323592
			},
			{
				"lng": 11.465399903904776,
				"lat": 43.545028715381257
			},
			{
				"lng": 11.465402314197915,
				"lat": 43.545029746112931
			},
			{
				"lng": 11.46540481122477,
				"lat": 43.545030661100725
			},
			{
				"lng": 11.465404811224767,
				"lat": 43.545030661100725
			},
			{
				"lng": 11.46540725906134,
				"lat": 43.545031421060443
			},
			{
				"lng": 11.465409766625218,
				"lat": 43.545032069856767
			},
			{
				"lng": 11.465412324385838,
				"lat": 43.545032605023756
			},
			{
				"lng": 11.465414922621814,
				"lat": 43.545033024527392
			},
			{
				"lng": 11.465417551457952,
				"lat": 43.545033326773293
			},
			{
				"lng": 11.465420200902745,
				"lat": 43.545033510612647
			},
			{
				"lng": 11.465420200902745,
				"lat": 43.545033510612647
			},
			{
				"lng": 11.4654615572359,
				"lat": 43.545035979216522
			},
			{
				"lng": 11.465502768483626,
				"lat": 43.545039505186026
			},
			{
				"lng": 11.465502768483626,
				"lat": 43.545039505186026
			},
			{
				"lng": 11.465624067666566,
				"lat": 43.54505332285116
			},
			{
				"lng": 11.465624067666567,
				"lat": 43.54505332285116
			},
			{
				"lng": 11.465755289910732,
				"lat": 43.545072171052226
			},
			{
				"lng": 11.465755289910726,
				"lat": 43.545072171052233
			},
			{
				"lng": 11.465922296435407,
				"lat": 43.545103531629231
			},
			{
				"lng": 11.465922296435403,
				"lat": 43.545103531629245
			},
			{
				"lng": 11.466035252012409,
				"lat": 43.545120011362044
			},
			{
				"lng": 11.466035252012412,
				"lat": 43.545120011362044
			},
			{
				"lng": 11.46625195067068,
				"lat": 43.545145017204447
			},
			{
				"lng": 11.46625195067068,
				"lat": 43.545145017204447
			},
			{
				"lng": 11.4662650835729,
				"lat": 43.545146140127891
			},
			{
				"lng": 11.466278289004954,
				"lat": 43.545146640323154
			},
			{
				"lng": 11.466278289004954,
				"lat": 43.545146640323154
			},
			{
				"lng": 11.466290414889523,
				"lat": 43.545146533412122
			},
			{
				"lng": 11.466302507183832,
				"lat": 43.545145868690227
			},
			{
				"lng": 11.46631451743929,
				"lat": 43.54514464882071
			},
			{
				"lng": 11.466326397536042,
				"lat": 43.545142878691081
			},
			{
				"lng": 11.46632639753604,
				"lat": 43.545142878691074
			},
			{
				"lng": 11.466350551661773,
				"lat": 43.545139204923679
			},
			{
				"lng": 11.466374947428902,
				"lat": 43.545136505070523
			},
			{
				"lng": 11.46639951067867,
				"lat": 43.545134787338675
			},
			{
				"lng": 11.46639951067867,
				"lat": 43.545134787338675
			},
			{
				"lng": 11.466418930778264,
				"lat": 43.54513428361669
			},
			{
				"lng": 11.46643835469966,
				"lat": 43.545134702166642
			},
			{
				"lng": 11.466457699751933,
				"lat": 43.54513604120671
			},
			{
				"lng": 11.466476883579896,
				"lat": 43.545138295036324
			},
			{
				"lng": 11.466495824514716,
				"lat": 43.545141454060541
			},
			{
				"lng": 11.466495824514716,
				"lat": 43.545141454060541
			},
			{
				"lng": 11.466503550240672,
				"lat": 43.545142748460023
			},
			{
				"lng": 11.466511373022964,
				"lat": 43.545143684944733
			},
			{
				"lng": 11.466519261555835,
				"lat": 43.545144259767049
			},
			{
				"lng": 11.466527184270376,
				"lat": 43.545144470626489
			},
			{
				"lng": 11.466535109460912,
				"lat": 43.545144316679327
			},
			{
				"lng": 11.466543005411845,
				"lat": 43.545143798541595
			},
			{
				"lng": 11.466550840524585,
				"lat": 43.545142918286842
			},
			{
				"lng": 11.466558583444032,
				"lat": 43.545141679437734
			},
			{
				"lng": 11.466558583444032,
				"lat": 43.545141679437734
			},
			{
				"lng": 11.46657577201257,
				"lat": 43.545138095654842
			},
			{
				"lng": 11.466592622231106,
				"lat": 43.545133743961991
			},
			{
				"lng": 11.466592622231106,
				"lat": 43.545133743961991
			},
			{
				"lng": 11.466665208898437,
				"lat": 43.545111403771898
			},
			{
				"lng": 11.466665208898432,
				"lat": 43.545111403771898
			},
			{
				"lng": 11.466719023807697,
				"lat": 43.545091868888584
			},
			{
				"lng": 11.466770859091792,
				"lat": 43.545069681672132
			},
			{
				"lng": 11.466770859091804,
				"lat": 43.545069681672146
			},
			{
				"lng": 11.466787075850442,
				"lat": 43.545062629125255
			},
			{
				"lng": 11.466803801492023,
				"lat": 43.545056236279144
			},
			{
				"lng": 11.466820985346503,
				"lat": 43.545050522500773
			},
			{
				"lng": 11.466838575355732,
				"lat": 43.545045505099836
			},
			{
				"lng": 11.466838575355732,
				"lat": 43.545045505099836
			},
			{
				"lng": 11.466862744966194,
				"lat": 43.545039647307554
			},
			{
				"lng": 11.466887280914309,
				"lat": 43.545034660031199
			},
			{
				"lng": 11.466887280914309,
				"lat": 43.545034660031199
			},
			{
				"lng": 11.466919525779026,
				"lat": 43.545029192320612
			},
			{
				"lng": 11.466952031634181,
				"lat": 43.545024614750375
			},
			{
				"lng": 11.466952031634179,
				"lat": 43.545024614750375
			},
			{
				"lng": 11.467004203715055,
				"lat": 43.545019126855514
			},
			{
				"lng": 11.467004203715057,
				"lat": 43.545019126855514
			},
			{
				"lng": 11.46711264261093,
				"lat": 43.545011132790073
			},
			{
				"lng": 11.46711264261093,
				"lat": 43.545011132790073
			},
			{
				"lng": 11.467129353107774,
				"lat": 43.545010439967953
			},
			{
				"lng": 11.467146090628994,
				"lat": 43.545010481555984
			},
			{
				"lng": 11.467162794228722,
				"lat": 43.545011257402784
			},
			{
				"lng": 11.467162794228722,
				"lat": 43.545011257402784
			},
			{
				"lng": 11.46718336247006,
				"lat": 43.54501229842294
			},
			{
				"lng": 11.467203976101921,
				"lat": 43.545012606117076
			},
			{
				"lng": 11.467224585739642,
				"lat": 43.54501217974807
			},
			{
				"lng": 11.46722458573964,
				"lat": 43.545012179748085
			},
			{
				"lng": 11.467238937338518,
				"lat": 43.545011263169201
			},
			{
				"lng": 11.467253167158454,
				"lat": 43.545009625566934
			},
			{
				"lng": 11.467267206820388,
				"lat": 43.545007274810494
			},
			{
				"lng": 11.467280988859084,
				"lat": 43.545004222196027
			},
			{
				"lng": 11.467294447047275,
				"lat": 43.545000482392474
			},
			{
				"lng": 11.467307516713953,
				"lat": 43.544996073370733
			},
			{
				"lng": 11.467320135055116,
				"lat": 43.544991016317709
			},
			{
				"lng": 11.467332241435582,
				"lat": 43.5449853355342
			},
			{
				"lng": 11.467343777680362,
				"lat": 43.544979058318226
			},
			{
				"lng": 11.467354688354208,
				"lat": 43.54497221483394
			},
			{
				"lng": 11.467354688354208,
				"lat": 43.54497221483394
			},
			{
				"lng": 11.467356274992305,
				"lat": 43.544971070679928
			},
			{
				"lng": 11.467357748368617,
				"lat": 43.544969849013391
			},
			{
				"lng": 11.467359101344817,
				"lat": 43.544968555753137
			},
			{
				"lng": 11.467360327365903,
				"lat": 43.544967197164901
			},
			{
				"lng": 11.467361420491928,
				"lat": 43.544965779830854
			},
			{
				"lng": 11.467362375426845,
				"lat": 43.544964310617857
			},
			{
				"lng": 11.467363187544121,
				"lat": 43.544962796644043
			},
			{
				"lng": 11.467363852909134,
				"lat": 43.544961245244473
			},
			{
				"lng": 11.46736436829829,
				"lat": 43.544959663935451
			},
			{
				"lng": 11.467364731214593,
				"lat": 43.544958060378313
			},
			{
				"lng": 11.467364939899774,
				"lat": 43.544956442342041
			},
			{
				"lng": 11.467364993342782,
				"lat": 43.544954817665861
			},
			{
				"lng": 11.467364891284717,
				"lat": 43.544953194221151
			},
			{
				"lng": 11.467364634220033,
				"lat": 43.544951579873278
			},
			{
				"lng": 11.467364223394208,
				"lat": 43.544949982443612
			},
			{
				"lng": 11.467363660797648,
				"lat": 43.544948409671477
			},
			{
				"lng": 11.467362949156083,
				"lat": 43.544946869176783
			},
			{
				"lng": 11.467362091917341,
				"lat": 43.544945368423043
			},
			{
				"lng": 11.467361093234649,
				"lat": 43.54494391468122
			},
			{
				"lng": 11.46735995794652,
				"lat": 43.544942514994538
			},
			{
				"lng": 11.467358691553297,
				"lat": 43.544941176144299
			},
			{
				"lng": 11.467357300190521,
				"lat": 43.544939904617124
			},
			{
				"lng": 11.467355790599168,
				"lat": 43.544938706573291
			},
			{
				"lng": 11.467354170093046,
				"lat": 43.544937587817302
			},
			{
				"lng": 11.467352446523313,
				"lat": 43.544936553769325
			},
			{
				"lng": 11.467350628240469,
				"lat": 43.544935609439236
			},
			{
				"lng": 11.467348724053871,
				"lat": 43.544934759402167
			},
			{
				"lng": 11.467346743189079,
				"lat": 43.544934007776497
			},
			{
				"lng": 11.467344695243145,
				"lat": 43.5449333582037
			},
			{
				"lng": 11.467342590138117,
				"lat": 43.544932813830897
			},
			{
				"lng": 11.467342590138117,
				"lat": 43.544932813830897
			},
			{
				"lng": 11.467312332424189,
				"lat": 43.544925983392424
			},
			{
				"lng": 11.467312332424193,
				"lat": 43.544925983392424
			},
			{
				"lng": 11.467302154778016,
				"lat": 43.544923874068957
			},
			{
				"lng": 11.467302154778016,
				"lat": 43.544923874068957
			},
			{
				"lng": 11.467229259013525,
				"lat": 43.544909771318459
			},
			{
				"lng": 11.467229259013525,
				"lat": 43.544909771318459
			},
			{
				"lng": 11.467217881310356,
				"lat": 43.544907577420531
			},
			{
				"lng": 11.467217881310361,
				"lat": 43.544907577420517
			},
			{
				"lng": 11.467207030005762,
				"lat": 43.544905496232687
			},
			{
				"lng": 11.467207030005762,
				"lat": 43.544905496232687
			},
			{
				"lng": 11.467187934786866,
				"lat": 43.544901848267045
			},
			{
				"lng": 11.46718793478686,
				"lat": 43.544901848267045
			},
			{
				"lng": 11.467172754660046,
				"lat": 43.54489920235573
			},
			{
				"lng": 11.467157433410854,
				"lat": 43.544897029037408
			},
			{
				"lng": 11.467157433410861,
				"lat": 43.544897029037408
			},
			{
				"lng": 11.46715150167257,
				"lat": 43.544896391822178
			},
			{
				"lng": 11.467145533946063,
				"lat": 43.544895968200208
			},
			{
				"lng": 11.467139544758345,
				"lat": 43.544895759202689
			},
			{
				"lng": 11.467139544758345,
				"lat": 43.544895759202689
			},
			{
				"lng": 11.467132542416786,
				"lat": 43.5448957856945
			},
			{
				"lng": 11.467132542416786,
				"lat": 43.5448957856945
			},
			{
				"lng": 11.467130929246034,
				"lat": 43.544895861513552
			},
			{
				"lng": 11.467129325574813,
				"lat": 43.544896009558883
			},
			{
				"lng": 11.467129325574813,
				"lat": 43.544896009558883
			},
			{
				"lng": 11.467127215908121,
				"lat": 43.544896288154391
			},
			{
				"lng": 11.467125125601532,
				"lat": 43.544896635485166
			},
			{
				"lng": 11.467125125601534,
				"lat": 43.544896635485181
			},
			{
				"lng": 11.467123714013841,
				"lat": 43.544896858268466
			},
			{
				"lng": 11.467122285123839,
				"lat": 43.544897011983082
			},
			{
				"lng": 11.467122285123839,
				"lat": 43.544897011983082
			},
			{
				"lng": 11.467118939022052,
				"lat": 43.544897282436409
			},
			{
				"lng": 11.467118939022052,
				"lat": 43.544897282436409
			},
			{
				"lng": 11.467108218314655,
				"lat": 43.54489812049227
			},
			{
				"lng": 11.467108218314655,
				"lat": 43.544898120492263
			},
			{
				"lng": 11.467099634714879,
				"lat": 43.544898753593124
			},
			{
				"lng": 11.467099634714881,
				"lat": 43.544898753593145
			},
			{
				"lng": 11.467094537339971,
				"lat": 43.544899142735474
			},
			{
				"lng": 11.467094537339971,
				"lat": 43.544899142735474
			},
			{
				"lng": 11.467092930823641,
				"lat": 43.544899308852344
			},
			{
				"lng": 11.467091339592862,
				"lat": 43.544899540061053
			},
			{
				"lng": 11.467089768628112,
				"lat": 43.544899835638049
			},
			{
				"lng": 11.467088222846433,
				"lat": 43.544900194658105
			},
			{
				"lng": 11.467086707086047,
				"lat": 43.544900615997534
			},
			{
				"lng": 11.467086707086047,
				"lat": 43.544900615997534
			},
			{
				"lng": 11.467081689753769,
				"lat": 43.544902030180438
			},
			{
				"lng": 11.467076587228089,
				"lat": 43.544903272654658
			},
			{
				"lng": 11.467071410608352,
				"lat": 43.544904340717522
			},
			{
				"lng": 11.467071410608352,
				"lat": 43.544904340717522
			},
			{
				"lng": 11.467052670909686,
				"lat": 43.54490781349746
			},
			{
				"lng": 11.467052670909686,
				"lat": 43.54490781349746
			},
			{
				"lng": 11.467039303940343,
				"lat": 43.544910201031819
			},
			{
				"lng": 11.467039303940345,
				"lat": 43.544910201031819
			},
			{
				"lng": 11.467028168484415,
				"lat": 43.544912094982465
			},
			{
				"lng": 11.467028168484413,
				"lat": 43.544912094982458
			},
			{
				"lng": 11.467020593091293,
				"lat": 43.544913297050954
			},
			{
				"lng": 11.467020593091295,
				"lat": 43.544913297050954
			},
			{
				"lng": 11.467015940579346,
				"lat": 43.544913922253627
			},
			{
				"lng": 11.467011253188581,
				"lat": 43.54491438970684
			},
			{
				"lng": 11.467011253188582,
				"lat": 43.544914389706832
			},
			{
				"lng": 11.466994867916201,
				"lat": 43.544915421254387
			},
			{
				"lng": 11.466994867916201,
				"lat": 43.544915421254387
			},
			{
				"lng": 11.466982776933403,
				"lat": 43.544915803182313
			},
			{
				"lng": 11.466982776933403,
				"lat": 43.544915803182313
			},
			{
				"lng": 11.466976523376546,
				"lat": 43.544915783803184
			},
			{
				"lng": 11.466976523376546,
				"lat": 43.544915783803184
			},
			{
				"lng": 11.466974069224909,
				"lat": 43.544915681324312
			},
			{
				"lng": 11.466971623476772,
				"lat": 43.544915501633461
			},
			{
				"lng": 11.466971623476772,
				"lat": 43.544915501633461
			},
			{
				"lng": 11.466970665018804,
				"lat": 43.544915433285432
			},
			{
				"lng": 11.466969703099512,
				"lat": 43.544915399308501
			},
			{
				"lng": 11.466968740047021,
				"lat": 43.544915399784905
			},
			{
				"lng": 11.466968740047019,
				"lat": 43.544915399784927
			},
			{
				"lng": 11.466968493594258,
				"lat": 43.544915405222781
			},
			{
				"lng": 11.466968493594255,
				"lat": 43.544915405222774
			},
			{
				"lng": 11.466968032929145,
				"lat": 43.544915417984093
			},
			{
				"lng": 11.466968032929145,
				"lat": 43.544915417984093
			},
			{
				"lng": 11.466966375755558,
				"lat": 43.544915499884517
			},
			{
				"lng": 11.466964727105402,
				"lat": 43.544915646909828
			},
			{
				"lng": 11.466964727105402,
				"lat": 43.544915646909828
			},
			{
				"lng": 11.466963127241549,
				"lat": 43.544915854759722
			},
			{
				"lng": 11.466961545634739,
				"lat": 43.544916126669065
			},
			{
				"lng": 11.466961545634739,
				"lat": 43.544916126669065
			},
			{
				"lng": 11.46696019800069,
				"lat": 43.544916420005656
			},
			{
				"lng": 11.466958877939639,
				"lat": 43.544916773510863
			},
			{
				"lng": 11.466957590523304,
				"lat": 43.544917185826492
			},
			{
				"lng": 11.466957590523304,
				"lat": 43.544917185826492
			},
			{
				"lng": 11.466954567952527,
				"lat": 43.544918157422643
			},
			{
				"lng": 11.466951471561222,
				"lat": 43.544918997063377
			},
			{
				"lng": 11.466951471561218,
				"lat": 43.544918997063377
			},
			{
				"lng": 11.466943354289857,
				"lat": 43.544920920718667
			},
			{
				"lng": 11.466943354289862,
				"lat": 43.544920920718688
			},
			{
				"lng": 11.466937537162057,
				"lat": 43.544922162548232
			},
			{
				"lng": 11.466937537162057,
				"lat": 43.544922162548232
			},
			{
				"lng": 11.466929309148588,
				"lat": 43.544923637757414
			},
			{
				"lng": 11.466929309148588,
				"lat": 43.544923637757414
			},
			{
				"lng": 11.466926314086674,
				"lat": 43.54492407185019
			},
			{
				"lng": 11.466923299067625,
				"lat": 43.544924425365075
			}
			]
		]
	},
	"19": {
		"name": "MA04 - Lago di Castelnuovo Sponda Est",
		"center": {
			"lat": 43.551933200887596,
			"lng": 11.469933859323826
		},
		"coords": [
			[{
				"lng": 11.471100241393474,
				"lat": 43.554125331662597
			},
			{
				"lng": 11.471106450716055,
				"lat": 43.554089296831329
			},
			{
				"lng": 11.471111055122348,
				"lat": 43.554091147614436
			},
			{
				"lng": 11.471144340405329,
				"lat": 43.554107095650537
			},
			{
				"lng": 11.471164937020784,
				"lat": 43.554117969355858
			},
			{
				"lng": 11.47119700907006,
				"lat": 43.554135399917811
			},
			{
				"lng": 11.471218796745385,
				"lat": 43.554147499136711
			},
			{
				"lng": 11.47122756508622,
				"lat": 43.554151156815898
			},
			{
				"lng": 11.47123044150077,
				"lat": 43.5541487379638
			},
			{
				"lng": 11.47135562946459,
				"lat": 43.554132265708404
			},
			{
				"lng": 11.471339511061045,
				"lat": 43.554111584718079
			},
			{
				"lng": 11.471337644279108,
				"lat": 43.554065924741963
			},
			{
				"lng": 11.471332261546323,
				"lat": 43.554043246909849
			},
			{
				"lng": 11.471323073299306,
				"lat": 43.55402561545344
			},
			{
				"lng": 11.471311595879593,
				"lat": 43.55399082396147
			},
			{
				"lng": 11.471275952990997,
				"lat": 43.553921264050238
			},
			{
				"lng": 11.471230237829232,
				"lat": 43.553845274588184
			},
			{
				"lng": 11.471207647524569,
				"lat": 43.553812168387388
			},
			{
				"lng": 11.471193071178554,
				"lat": 43.553800257979908
			},
			{
				"lng": 11.47098191715121,
				"lat": 43.553691978299845
			},
			{
				"lng": 11.470975568246264,
				"lat": 43.553690547540917
			},
			{
				"lng": 11.470952393499525,
				"lat": 43.553679590927182
			},
			{
				"lng": 11.470949439881602,
				"lat": 43.55365987454762
			},
			{
				"lng": 11.470918899208296,
				"lat": 43.553598740966621
			},
			{
				"lng": 11.470921847481188,
				"lat": 43.553566186270736
			},
			{
				"lng": 11.470918668613054,
				"lat": 43.553542434192593
			},
			{
				"lng": 11.470931567355194,
				"lat": 43.553479632602119
			},
			{
				"lng": 11.470960701653386,
				"lat": 43.553397049222731
			},
			{
				"lng": 11.470922639683574,
				"lat": 43.553295715563443
			},
			{
				"lng": 11.470874187190793,
				"lat": 43.553271398996131
			},
			{
				"lng": 11.470846178644896,
				"lat": 43.553262905488182
			},
			{
				"lng": 11.470785312363667,
				"lat": 43.553271725961288
			},
			{
				"lng": 11.470776365190355,
				"lat": 43.553275467484205
			},
			{
				"lng": 11.470722301953906,
				"lat": 43.553274614050622
			},
			{
				"lng": 11.470814719036939,
				"lat": 43.553178621277162
			},
			{
				"lng": 11.470849350485629,
				"lat": 43.553146934422763
			},
			{
				"lng": 11.470949087912338,
				"lat": 43.553102117477614
			},
			{
				"lng": 11.470923805853124,
				"lat": 43.553088411418067
			},
			{
				"lng": 11.470869822454933,
				"lat": 43.553093342151534
			},
			{
				"lng": 11.470840131713175,
				"lat": 43.553090499714152
			},
			{
				"lng": 11.470833223529105,
				"lat": 43.553090670687368
			},
			{
				"lng": 11.470810758392929,
				"lat": 43.553094817279749
			},
			{
				"lng": 11.47074737278674,
				"lat": 43.553115679648187
			},
			{
				"lng": 11.47072996461379,
				"lat": 43.553121036819249
			},
			{
				"lng": 11.470712024835999,
				"lat": 43.553122686089786
			},
			{
				"lng": 11.470686620439942,
				"lat": 43.553120511342918
			},
			{
				"lng": 11.470679595983031,
				"lat": 43.553119910012292
			},
			{
				"lng": 11.470661646593706,
				"lat": 43.553110803270066
			},
			{
				"lng": 11.470668829448124,
				"lat": 43.553111784159171
			},
			{
				"lng": 11.470683861114168,
				"lat": 43.553109345612803
			},
			{
				"lng": 11.47072684749298,
				"lat": 43.553087127093022
			},
			{
				"lng": 11.470771423263832,
				"lat": 43.553063879789931
			},
			{
				"lng": 11.470801386842599,
				"lat": 43.553038277155309
			},
			{
				"lng": 11.470818746645138,
				"lat": 43.553019115726144
			},
			{
				"lng": 11.470806894399816,
				"lat": 43.552992673566408
			},
			{
				"lng": 11.470785948535104,
				"lat": 43.552959156284679
			},
			{
				"lng": 11.470727673094055,
				"lat": 43.5528670795482
			},
			{
				"lng": 11.470678638526513,
				"lat": 43.552832052631651
			},
			{
				"lng": 11.470610042573004,
				"lat": 43.55282197034321
			},
			{
				"lng": 11.470596666111488,
				"lat": 43.552820004254912
			},
			{
				"lng": 11.470504722197008,
				"lat": 43.552770838661246
			},
			{
				"lng": 11.470451575241148,
				"lat": 43.552730343702358
			},
			{
				"lng": 11.470413921339386,
				"lat": 43.552714297825524
			},
			{
				"lng": 11.470400982337816,
				"lat": 43.552705073928955
			},
			{
				"lng": 11.470383915991068,
				"lat": 43.552696091068
			},
			{
				"lng": 11.470354318273188,
				"lat": 43.55267798947763
			},
			{
				"lng": 11.470313571593634,
				"lat": 43.552640051306369
			},
			{
				"lng": 11.47030500054246,
				"lat": 43.552636443831851
			},
			{
				"lng": 11.470247206258977,
				"lat": 43.552535013477303
			},
			{
				"lng": 11.470203394015018,
				"lat": 43.552437718178119
			},
			{
				"lng": 11.470172662161719,
				"lat": 43.552325662669148
			},
			{
				"lng": 11.470171559522297,
				"lat": 43.552298678566807
			},
			{
				"lng": 11.470166621127996,
				"lat": 43.552217761502682
			},
			{
				"lng": 11.470161682751799,
				"lat": 43.552136844437051
			},
			{
				"lng": 11.470157437574843,
				"lat": 43.552067285451258
			},
			{
				"lng": 11.47015736736553,
				"lat": 43.5520661350401
			},
			{
				"lng": 11.470106493363188,
				"lat": 43.551958267006746
			},
			{
				"lng": 11.470052935803967,
				"lat": 43.551870285151942
			},
			{
				"lng": 11.470025326127214,
				"lat": 43.551756831936579
			},
			{
				"lng": 11.470034810640291,
				"lat": 43.551649348392502
			},
			{
				"lng": 11.470057165697757,
				"lat": 43.551609986173901
			},
			{
				"lng": 11.470104157400712,
				"lat": 43.55155359419215
			},
			{
				"lng": 11.470148189301209,
				"lat": 43.551507038267886
			},
			{
				"lng": 11.47014929094575,
				"lat": 43.551502396068571
			},
			{
				"lng": 11.470160574520591,
				"lat": 43.551489749014138
			},
			{
				"lng": 11.470212328435029,
				"lat": 43.551501324564946
			},
			{
				"lng": 11.470218352693635,
				"lat": 43.551498513769054
			},
			{
				"lng": 11.470230132436333,
				"lat": 43.551500390467744
			},
			{
				"lng": 11.470241988469068,
				"lat": 43.551488925445831
			},
			{
				"lng": 11.470275198227379,
				"lat": 43.551500959672161
			},
			{
				"lng": 11.470300374502925,
				"lat": 43.551494012099894
			},
			{
				"lng": 11.470310518102274,
				"lat": 43.551488319412385
			},
			{
				"lng": 11.470311970323074,
				"lat": 43.551464848081764
			},
			{
				"lng": 11.470306524889866,
				"lat": 43.551455824095207
			},
			{
				"lng": 11.470289220810653,
				"lat": 43.551441869577161
			},
			{
				"lng": 11.470428141311157,
				"lat": 43.55146622272364
			},
			{
				"lng": 11.470453192303369,
				"lat": 43.551423902770509
			},
			{
				"lng": 11.470502269687554,
				"lat": 43.551346306137056
			},
			{
				"lng": 11.470511210299509,
				"lat": 43.551320055894948
			},
			{
				"lng": 11.470560336409706,
				"lat": 43.551231010050216
			},
			{
				"lng": 11.470594792896939,
				"lat": 43.551190267970803
			},
			{
				"lng": 11.470673515751388,
				"lat": 43.551138106670393
			},
			{
				"lng": 11.470838443286981,
				"lat": 43.550975562266501
			},
			{
				"lng": 11.471014598221807,
				"lat": 43.55083300436501
			},
			{
				"lng": 11.471094971596028,
				"lat": 43.550715344066724
			},
			{
				"lng": 11.471157560884349,
				"lat": 43.550491391741396
			},
			{
				"lng": 11.471177344827131,
				"lat": 43.550205646720691
			},
			{
				"lng": 11.471150640182127,
				"lat": 43.550058452562631
			},
			{
				"lng": 11.471151759137372,
				"lat": 43.55004958169134
			},
			{
				"lng": 11.471174162925292,
				"lat": 43.549994743223813
			},
			{
				"lng": 11.4711909439481,
				"lat": 43.549919239285018
			},
			{
				"lng": 11.471189584932178,
				"lat": 43.549811697377407
			},
			{
				"lng": 11.471155483763129,
				"lat": 43.549698410437465
			},
			{
				"lng": 11.471115432693582,
				"lat": 43.549581871558694
			},
			{
				"lng": 11.471074798541423,
				"lat": 43.549500169955358
			},
			{
				"lng": 11.471021657999623,
				"lat": 43.549432160565608
			},
			{
				"lng": 11.470989649355717,
				"lat": 43.549405593836461
			},
			{
				"lng": 11.470859785922805,
				"lat": 43.549325340074091
			},
			{
				"lng": 11.470695547881503,
				"lat": 43.549253768633562
			},
			{
				"lng": 11.470533859020172,
				"lat": 43.549205521425812
			},
			{
				"lng": 11.470470916603654,
				"lat": 43.549174170862322
			},
			{
				"lng": 11.470164026901868,
				"lat": 43.54912108438932
			},
			{
				"lng": 11.470112819694869,
				"lat": 43.549121418258444
			},
			{
				"lng": 11.470020020144515,
				"lat": 43.549116098375727
			},
			{
				"lng": 11.470017425692983,
				"lat": 43.549115002205468
			},
			{
				"lng": 11.469956839598893,
				"lat": 43.549118246916741
			},
			{
				"lng": 11.46993008255764,
				"lat": 43.549115922911021
			},
			{
				"lng": 11.46990126094453,
				"lat": 43.549107277625147
			},
			{
				"lng": 11.469836900434638,
				"lat": 43.54908520078385
			},
			{
				"lng": 11.469807463828236,
				"lat": 43.549072512018917
			},
			{
				"lng": 11.46973537224431,
				"lat": 43.549067196369819
			},
			{
				"lng": 11.469657415541324,
				"lat": 43.5490254706665
			},
			{
				"lng": 11.469649742612845,
				"lat": 43.54899883120293
			},
			{
				"lng": 11.46963241427879,
				"lat": 43.548958000610249
			},
			{
				"lng": 11.469620488334561,
				"lat": 43.548960501812104
			},
			{
				"lng": 11.469605685719589,
				"lat": 43.548970066033448
			},
			{
				"lng": 11.46958650512043,
				"lat": 43.548979577468792
			},
			{
				"lng": 11.469557940245569,
				"lat": 43.54899017557436
			},
			{
				"lng": 11.46955023412165,
				"lat": 43.548991964972942
			},
			{
				"lng": 11.469547396815885,
				"lat": 43.548994121487986
			},
			{
				"lng": 11.469514396879294,
				"lat": 43.549003788170509
			},
			{
				"lng": 11.469501445250145,
				"lat": 43.549019491623184
			},
			{
				"lng": 11.46947943433414,
				"lat": 43.549044408665992
			},
			{
				"lng": 11.46945992580436,
				"lat": 43.549064580239566
			},
			{
				"lng": 11.469457440382579,
				"lat": 43.549065413087192
			},
			{
				"lng": 11.469452155122928,
				"lat": 43.549067629843144
			},
			{
				"lng": 11.469451771078152,
				"lat": 43.549068672544635
			},
			{
				"lng": 11.469440522211785,
				"lat": 43.549076374327377
			},
			{
				"lng": 11.469416095185649,
				"lat": 43.549091409572689
			},
			{
				"lng": 11.469392158714172,
				"lat": 43.549108699144
			},
			{
				"lng": 11.469373022043179,
				"lat": 43.549122761182218
			},
			{
				"lng": 11.469358112264041,
				"lat": 43.549132276112886
			},
			{
				"lng": 11.469355167919593,
				"lat": 43.54913553180036
			},
			{
				"lng": 11.469350092874587,
				"lat": 43.549142316989538
			},
			{
				"lng": 11.46934790711261,
				"lat": 43.549147306330525
			},
			{
				"lng": 11.46934096431899,
				"lat": 43.549153223829045
			},
			{
				"lng": 11.469317979445327,
				"lat": 43.54916401192601
			},
			{
				"lng": 11.469313884715111,
				"lat": 43.549168923947903
			},
			{
				"lng": 11.469309766038856,
				"lat": 43.549173675016021
			},
			{
				"lng": 11.469305737311618,
				"lat": 43.54917965853609
			},
			{
				"lng": 11.469295673918134,
				"lat": 43.549190247248724
			},
			{
				"lng": 11.469290166066241,
				"lat": 43.549194354862642
			},
			{
				"lng": 11.46927707524522,
				"lat": 43.549204529096571
			},
			{
				"lng": 11.469272029288849,
				"lat": 43.549213641743123
			},
			{
				"lng": 11.469268978506152,
				"lat": 43.549224414762719
			},
			{
				"lng": 11.469266705614524,
				"lat": 43.549226107934459
			},
			{
				"lng": 11.469259440837696,
				"lat": 43.549228266411625
			},
			{
				"lng": 11.469244778526816,
				"lat": 43.549234061025281
			},
			{
				"lng": 11.469240705179422,
				"lat": 43.549240013094142
			},
			{
				"lng": 11.469239028728815,
				"lat": 43.549250369261891
			},
			{
				"lng": 11.469235396514129,
				"lat": 43.549262606226634
			},
			{
				"lng": 11.469229483535308,
				"lat": 43.549277586353845
			},
			{
				"lng": 11.469232242247815,
				"lat": 43.549291546275761
			},
			{
				"lng": 11.469210178526161,
				"lat": 43.549310066254364
			},
			{
				"lng": 11.469211156593849,
				"lat": 43.549334013646238
			},
			{
				"lng": 11.469201964640687,
				"lat": 43.549353362046404
			},
			{
				"lng": 11.469196740562456,
				"lat": 43.549359326372318
			},
			{
				"lng": 11.469178029559496,
				"lat": 43.549386741503817
			},
			{
				"lng": 11.46917057548006,
				"lat": 43.549410543354959
			},
			{
				"lng": 11.469169966715587,
				"lat": 43.549427613857858
			},
			{
				"lng": 11.469145961819381,
				"lat": 43.54947747053258
			},
			{
				"lng": 11.469148461428357,
				"lat": 43.549486420140276
			},
			{
				"lng": 11.469107643845293,
				"lat": 43.549574773980488
			},
			{
				"lng": 11.469108038868693,
				"lat": 43.54959590323314
			},
			{
				"lng": 11.469097556662033,
				"lat": 43.549630883667263
			},
			{
				"lng": 11.469104459827818,
				"lat": 43.5496686379363
			},
			{
				"lng": 11.469100400558929,
				"lat": 43.549703638959528
			},
			{
				"lng": 11.469105700848285,
				"lat": 43.549751763109711
			},
			{
				"lng": 11.469121023248025,
				"lat": 43.549783737922482
			},
			{
				"lng": 11.469127881204296,
				"lat": 43.549784498212382
			},
			{
				"lng": 11.469130489776035,
				"lat": 43.549821817657303
			},
			{
				"lng": 11.469135057548092,
				"lat": 43.549843912875325
			},
			{
				"lng": 11.469133520985006,
				"lat": 43.54991137234601
			},
			{
				"lng": 11.469141110430995,
				"lat": 43.549953562269998
			},
			{
				"lng": 11.469155242288714,
				"lat": 43.549977309542022
			},
			{
				"lng": 11.469145528216794,
				"lat": 43.549981982758027
			},
			{
				"lng": 11.4691174193119,
				"lat": 43.549999546506882
			},
			{
				"lng": 11.469114460510232,
				"lat": 43.550008010470343
			},
			{
				"lng": 11.469102544092472,
				"lat": 43.550017501109544
			},
			{
				"lng": 11.469091858749938,
				"lat": 43.550028728389783
			},
			{
				"lng": 11.469088645484806,
				"lat": 43.550035786950723
			},
			{
				"lng": 11.469085368550218,
				"lat": 43.550052171881688
			},
			{
				"lng": 11.469089692513164,
				"lat": 43.55008283953098
			},
			{
				"lng": 11.469088546161789,
				"lat": 43.550088040895922
			},
			{
				"lng": 11.469077237967726,
				"lat": 43.550122953393917
			},
			{
				"lng": 11.469070241019757,
				"lat": 43.55014875795095
			},
			{
				"lng": 11.469068497079794,
				"lat": 43.55017765264369
			},
			{
				"lng": 11.469062302495926,
				"lat": 43.550190991158267
			},
			{
				"lng": 11.469057238786625,
				"lat": 43.55020579089193
			},
			{
				"lng": 11.469056112317995,
				"lat": 43.550213044170363
			},
			{
				"lng": 11.469040746118866,
				"lat": 43.550241419866069
			},
			{
				"lng": 11.469029411984781,
				"lat": 43.550271613399417
			},
			{
				"lng": 11.469026656876103,
				"lat": 43.550293266871748
			},
			{
				"lng": 11.469026948613738,
				"lat": 43.550298026310436
			},
			{
				"lng": 11.469023193438824,
				"lat": 43.550308390490912
			},
			{
				"lng": 11.469026761061839,
				"lat": 43.550318060214011
			},
			{
				"lng": 11.469028885301004,
				"lat": 43.550319260640507
			},
			{
				"lng": 11.469031310724631,
				"lat": 43.550324269331433
			},
			{
				"lng": 11.469050425393959,
				"lat": 43.550327158005622
			},
			{
				"lng": 11.469093556621154,
				"lat": 43.550329516615115
			},
			{
				"lng": 11.469103586969412,
				"lat": 43.550333891751819
			},
			{
				"lng": 11.469129879087751,
				"lat": 43.550347605776096
			},
			{
				"lng": 11.469132681509537,
				"lat": 43.550356319295446
			},
			{
				"lng": 11.469142028714757,
				"lat": 43.550369945690775
			},
			{
				"lng": 11.469149458386893,
				"lat": 43.550392368770773
			},
			{
				"lng": 11.469142711903602,
				"lat": 43.550412338001991
			},
			{
				"lng": 11.469143884398022,
				"lat": 43.550434923136933
			},
			{
				"lng": 11.46914172915336,
				"lat": 43.550444172297219
			},
			{
				"lng": 11.469118148544403,
				"lat": 43.550452941989079
			},
			{
				"lng": 11.469074246856149,
				"lat": 43.550471425531505
			},
			{
				"lng": 11.469044115824294,
				"lat": 43.550469301098175
			},
			{
				"lng": 11.469008615023958,
				"lat": 43.550470555997151
			},
			{
				"lng": 11.468975201708361,
				"lat": 43.550481408205115
			},
			{
				"lng": 11.468942617992276,
				"lat": 43.550494318492504
			},
			{
				"lng": 11.468903413012491,
				"lat": 43.550519845150966
			},
			{
				"lng": 11.468874248203093,
				"lat": 43.550542873543137
			},
			{
				"lng": 11.468863012160485,
				"lat": 43.550563796236609
			},
			{
				"lng": 11.468837216170904,
				"lat": 43.550629013147592
			},
			{
				"lng": 11.468823366776913,
				"lat": 43.550675619593811
			},
			{
				"lng": 11.46882221383048,
				"lat": 43.55070087703065
			},
			{
				"lng": 11.468828214806317,
				"lat": 43.550739342540609
			},
			{
				"lng": 11.468825463100654,
				"lat": 43.550757412257518
			},
			{
				"lng": 11.468838506759932,
				"lat": 43.550812393253274
			},
			{
				"lng": 11.468857584721022,
				"lat": 43.550867342719414
			},
			{
				"lng": 11.468856487756836,
				"lat": 43.550878573554556
			},
			{
				"lng": 11.468860986623575,
				"lat": 43.550902943875911
			},
			{
				"lng": 11.468904811369837,
				"lat": 43.551010925627679
			},
			{
				"lng": 11.468923213477689,
				"lat": 43.551048309588936
			},
			{
				"lng": 11.468960322153938,
				"lat": 43.551090569803961
			},
			{
				"lng": 11.468999194133659,
				"lat": 43.55113072655449
			},
			{
				"lng": 11.469034622379299,
				"lat": 43.551159428934334
			},
			{
				"lng": 11.469085042174822,
				"lat": 43.551198321109908
			},
			{
				"lng": 11.469118627786644,
				"lat": 43.551231003486542
			},
			{
				"lng": 11.469138724145665,
				"lat": 43.551247576846592
			},
			{
				"lng": 11.469195234439711,
				"lat": 43.551277755395589
			},
			{
				"lng": 11.46926769324654,
				"lat": 43.551309605253522
			},
			{
				"lng": 11.469313415729367,
				"lat": 43.551327107204493
			},
			{
				"lng": 11.469360094144808,
				"lat": 43.551340200096554
			},
			{
				"lng": 11.46938719315534,
				"lat": 43.551346625257338
			},
			{
				"lng": 11.469439414703862,
				"lat": 43.551358114337219
			},
			{
				"lng": 11.469489728776486,
				"lat": 43.551366416656492
			},
			{
				"lng": 11.469535847253452,
				"lat": 43.551369460222695
			},
			{
				"lng": 11.469569546247968,
				"lat": 43.551346847903197
			},
			{
				"lng": 11.469624637427053,
				"lat": 43.551315753106351
			},
			{
				"lng": 11.469659179951195,
				"lat": 43.551297768010805
			},
			{
				"lng": 11.469667198218666,
				"lat": 43.551277422735019
			},
			{
				"lng": 11.46967170291062,
				"lat": 43.551262515049174
			},
			{
				"lng": 11.469671869951279,
				"lat": 43.551253761853452
			},
			{
				"lng": 11.469675431192327,
				"lat": 43.551245380809974
			},
			{
				"lng": 11.469682988990821,
				"lat": 43.551218938302249
			},
			{
				"lng": 11.469687392427748,
				"lat": 43.551210093584466
			},
			{
				"lng": 11.46968974878698,
				"lat": 43.55121028476875
			},
			{
				"lng": 11.469764416605685,
				"lat": 43.551184691108645
			},
			{
				"lng": 11.469803735822714,
				"lat": 43.551165066191501
			},
			{
				"lng": 11.46982153725534,
				"lat": 43.551118116733768
			},
			{
				"lng": 11.469850831592579,
				"lat": 43.55116888267834
			},
			{
				"lng": 11.469878008037666,
				"lat": 43.551209439129316
			},
			{
				"lng": 11.46992828055879,
				"lat": 43.551278030641797
			},
			{
				"lng": 11.469951819571035,
				"lat": 43.551307332844083
			},
			{
				"lng": 11.469977978947284,
				"lat": 43.551339081409651
			},
			{
				"lng": 11.469977684514065,
				"lat": 43.551366081504661
			},
			{
				"lng": 11.469971086198516,
				"lat": 43.551386466041173
			},
			{
				"lng": 11.469934087631001,
				"lat": 43.551422191626436
			},
			{
				"lng": 11.469903162930775,
				"lat": 43.551457934484027
			},
			{
				"lng": 11.469885192941661,
				"lat": 43.5514886470378
			},
			{
				"lng": 11.46989837427507,
				"lat": 43.551540614477652
			},
			{
				"lng": 11.46989765172418,
				"lat": 43.551541016482155
			},
			{
				"lng": 11.469887922559366,
				"lat": 43.55155285355233
			},
			{
				"lng": 11.469858813264935,
				"lat": 43.551543381147312
			},
			{
				"lng": 11.469839153688705,
				"lat": 43.551524820639244
			},
			{
				"lng": 11.469816559924501,
				"lat": 43.551523385828226
			},
			{
				"lng": 11.469806830608432,
				"lat": 43.551521752248632
			},
			{
				"lng": 11.469773495479178,
				"lat": 43.55152041291408
			},
			{
				"lng": 11.469758994669057,
				"lat": 43.551506752748637
			},
			{
				"lng": 11.469737777193094,
				"lat": 43.551490878709288
			},
			{
				"lng": 11.469713586648297,
				"lat": 43.551469390784831
			},
			{
				"lng": 11.469686231471552,
				"lat": 43.551447447858351
			},
			{
				"lng": 11.469617971944908,
				"lat": 43.551444213184652
			},
			{
				"lng": 11.469545841212243,
				"lat": 43.551449932967309
			},
			{
				"lng": 11.469505653899438,
				"lat": 43.551507840016249
			},
			{
				"lng": 11.469479590395139,
				"lat": 43.55155871035182
			},
			{
				"lng": 11.469451912762768,
				"lat": 43.551666499895454
			},
			{
				"lng": 11.469437693880506,
				"lat": 43.551755004147644
			},
			{
				"lng": 11.469440674154974,
				"lat": 43.551818235378619
			},
			{
				"lng": 11.469464879158913,
				"lat": 43.551928127457643
			},
			{
				"lng": 11.4694803640818,
				"lat": 43.551983876490056
			},
			{
				"lng": 11.469498443145724,
				"lat": 43.552020426938405
			},
			{
				"lng": 11.469550115724763,
				"lat": 43.552107899548517
			},
			{
				"lng": 11.469560129212677,
				"lat": 43.552135326451072
			},
			{
				"lng": 11.469564483552844,
				"lat": 43.552147903567139
			},
			{
				"lng": 11.469558806164418,
				"lat": 43.552189633858482
			},
			{
				"lng": 11.469547400987292,
				"lat": 43.552254700910574
			},
			{
				"lng": 11.469541931625843,
				"lat": 43.552336238814483
			},
			{
				"lng": 11.469547308349991,
				"lat": 43.552421156533065
			},
			{
				"lng": 11.469568027206565,
				"lat": 43.552527115392046
			},
			{
				"lng": 11.469596632101773,
				"lat": 43.552623579616224
			},
			{
				"lng": 11.469638039234921,
				"lat": 43.552725895744722
			},
			{
				"lng": 11.469673327419168,
				"lat": 43.552796461585828
			},
			{
				"lng": 11.469687532167761,
				"lat": 43.552835396469206
			},
			{
				"lng": 11.469700441291851,
				"lat": 43.552858373372331
			},
			{
				"lng": 11.46971845982349,
				"lat": 43.552887486645943
			},
			{
				"lng": 11.469743170652608,
				"lat": 43.552918026988479
			},
			{
				"lng": 11.469769058215141,
				"lat": 43.552950021626529
			},
			{
				"lng": 11.46979965264323,
				"lat": 43.552987833462822
			},
			{
				"lng": 11.469837307377471,
				"lat": 43.553034371094732
			},
			{
				"lng": 11.469865720117161,
				"lat": 43.553069486452031
			},
			{
				"lng": 11.46988257985158,
				"lat": 43.553077922002906
			},
			{
				"lng": 11.469966002592329,
				"lat": 43.553126134464158
			},
			{
				"lng": 11.470054662928758,
				"lat": 43.553182168574111
			},
			{
				"lng": 11.470098163507306,
				"lat": 43.553209661256481
			},
			{
				"lng": 11.470118364957695,
				"lat": 43.553233008384105
			},
			{
				"lng": 11.47013902970189,
				"lat": 43.553256890924388
			},
			{
				"lng": 11.47019928835123,
				"lat": 43.553300895211379
			},
			{
				"lng": 11.470229057327945,
				"lat": 43.553322968941615
			},
			{
				"lng": 11.470259721019492,
				"lat": 43.553359368542374
			},
			{
				"lng": 11.470318871718987,
				"lat": 43.553404741383062
			},
			{
				"lng": 11.470326296533097,
				"lat": 43.553415602297989
			},
			{
				"lng": 11.470365830111044,
				"lat": 43.553520856595775
			},
			{
				"lng": 11.470396852001896,
				"lat": 43.553541525274575
			},
			{
				"lng": 11.470425067993068,
				"lat": 43.553560324471476
			},
			{
				"lng": 11.470430754044804,
				"lat": 43.55356411286013
			},
			{
				"lng": 11.470459308056247,
				"lat": 43.55364516066895
			},
			{
				"lng": 11.470478304876323,
				"lat": 43.55365973503735
			},
			{
				"lng": 11.470487919731244,
				"lat": 43.553685567075874
			},
			{
				"lng": 11.470499205741602,
				"lat": 43.553712124975725
			},
			{
				"lng": 11.470514186566518,
				"lat": 43.553737698131251
			},
			{
				"lng": 11.470542442641634,
				"lat": 43.553775544446964
			},
			{
				"lng": 11.470571848515791,
				"lat": 43.553814044788147
			},
			{
				"lng": 11.470574951893942,
				"lat": 43.553809611464338
			},
			{
				"lng": 11.470576346556808,
				"lat": 43.553808143811523
			},
			{
				"lng": 11.470578539300455,
				"lat": 43.553804413958176
			},
			{
				"lng": 11.470597466401898,
				"lat": 43.553787718438279
			},
			{
				"lng": 11.470608123961981,
				"lat": 43.553768920546048
			},
			{
				"lng": 11.470641069545037,
				"lat": 43.553812162431349
			},
			{
				"lng": 11.470673924156609,
				"lat": 43.553846875843234
			},
			{
				"lng": 11.470695659553828,
				"lat": 43.553863943790454
			},
			{
				"lng": 11.470889264032698,
				"lat": 43.553996857707602
			},
			{
				"lng": 11.471088775892115,
				"lat": 43.554246083580317
			},
			{
				"lng": 11.471097073965121,
				"lat": 43.554190211827034
			},
			{
				"lng": 11.47109888924213,
				"lat": 43.554163005016285
			},
			{
				"lng": 11.471097858359199,
				"lat": 43.55414865618966
			},
			{
				"lng": 11.471100241393474,
				"lat": 43.554125331662597
			}
			],
			[{
				"lng": 11.471034094263892,
				"lat": 43.553913280940534
			},
			{
				"lng": 11.470974717338986,
				"lat": 43.553858582502933
			},
			{
				"lng": 11.471043377379385,
				"lat": 43.553921074121064
			},
			{
				"lng": 11.471034094263892,
				"lat": 43.553913280940534
			}
			],
			[{
				"lng": 11.470677440489879,
				"lat": 43.553396148173114
			},
			{
				"lng": 11.470686749868836,
				"lat": 43.553362226563522
			},
			{
				"lng": 11.470671542940712,
				"lat": 43.553418443271724
			},
			{
				"lng": 11.470677440489879,
				"lat": 43.553396148173114
			}
			],
			[{
				"lng": 11.469724878460264,
				"lat": 43.550864136945727
			},
			{
				"lng": 11.469716955129231,
				"lat": 43.55084138172063
			},
			{
				"lng": 11.46972760260712,
				"lat": 43.550845433283811
			},
			{
				"lng": 11.469724878460264,
				"lat": 43.550864136945727
			}
			],
			[{
				"lng": 11.469669184727953,
				"lat": 43.550431142377455
			},
			{
				"lng": 11.46967821241604,
				"lat": 43.550418329489368
			},
			{
				"lng": 11.469669152074104,
				"lat": 43.550431416119586
			},
			{
				"lng": 11.469669184727953,
				"lat": 43.550431142377455
			}
			],
			[{
				"lng": 11.471700300380578,
				"lat": 43.554242852796293
			},
			{
				"lng": 11.471682569272515,
				"lat": 43.554234701296835
			},
			{
				"lng": 11.471604156921785,
				"lat": 43.554222114428534
			},
			{
				"lng": 11.47152033211918,
				"lat": 43.554242069382298
			},
			{
				"lng": 11.47150255847043,
				"lat": 43.554240357377019
			},
			{
				"lng": 11.471446488733937,
				"lat": 43.554245763697871
			},
			{
				"lng": 11.471348448328627,
				"lat": 43.554419416330241
			},
			{
				"lng": 11.471371643687364,
				"lat": 43.554432613985014
			},
			{
				"lng": 11.471409784889374,
				"lat": 43.554469749063927
			},
			{
				"lng": 11.471501790594385,
				"lat": 43.554537269473194
			},
			{
				"lng": 11.471555844592993,
				"lat": 43.554572842508691
			},
			{
				"lng": 11.471612645370412,
				"lat": 43.554634414422345
			},
			{
				"lng": 11.471638226152079,
				"lat": 43.554651854040983
			},
			{
				"lng": 11.471648993405378,
				"lat": 43.554661889537535
			},
			{
				"lng": 11.471675230619052,
				"lat": 43.554675327172454
			},
			{
				"lng": 11.47173005656399,
				"lat": 43.554706992997176
			},
			{
				"lng": 11.471732215717896,
				"lat": 43.55470946898933
			},
			{
				"lng": 11.471754494178564,
				"lat": 43.554729349278695
			},
			{
				"lng": 11.471760077290268,
				"lat": 43.554732751234006
			},
			{
				"lng": 11.471801885014822,
				"lat": 43.554765060233272
			},
			{
				"lng": 11.471820742053071,
				"lat": 43.554784764058219
			},
			{
				"lng": 11.471833963673955,
				"lat": 43.554796726425124
			},
			{
				"lng": 11.471858567270615,
				"lat": 43.554812478203708
			},
			{
				"lng": 11.47192017949116,
				"lat": 43.554848142678317
			},
			{
				"lng": 11.471965655876483,
				"lat": 43.554875117770173
			},
			{
				"lng": 11.471977598212483,
				"lat": 43.554881565506065
			},
			{
				"lng": 11.471996120545604,
				"lat": 43.554888892677269
			},
			{
				"lng": 11.472005380925506,
				"lat": 43.55489445713917
			},
			{
				"lng": 11.47203315971225,
				"lat": 43.55490533996295
			},
			{
				"lng": 11.472045534066222,
				"lat": 43.554913049328917
			},
			{
				"lng": 11.472089064703667,
				"lat": 43.554934385407485
			},
			{
				"lng": 11.472252297161827,
				"lat": 43.554992902838784
			},
			{
				"lng": 11.472371925585342,
				"lat": 43.555050215343542
			},
			{
				"lng": 11.47240958468765,
				"lat": 43.555061539082033
			},
			{
				"lng": 11.472471844612175,
				"lat": 43.555073687780798
			},
			{
				"lng": 11.472724659909499,
				"lat": 43.554951861895084
			},
			{
				"lng": 11.47272308109109,
				"lat": 43.554951246802652
			},
			{
				"lng": 11.472727194551144,
				"lat": 43.554904171391101
			},
			{
				"lng": 11.472643733227532,
				"lat": 43.554832529675195
			},
			{
				"lng": 11.472574632467426,
				"lat": 43.554811844143906
			},
			{
				"lng": 11.472481281260778,
				"lat": 43.554745064306843
			},
			{
				"lng": 11.472434583527905,
				"lat": 43.554724128562796
			},
			{
				"lng": 11.472365136314567,
				"lat": 43.554689663943549
			},
			{
				"lng": 11.472340446698224,
				"lat": 43.554675977084301
			},
			{
				"lng": 11.472291463337889,
				"lat": 43.554649086961888
			},
			{
				"lng": 11.472265933565602,
				"lat": 43.554635617468918
			},
			{
				"lng": 11.472255482159841,
				"lat": 43.554627261458194
			},
			{
				"lng": 11.472197459972779,
				"lat": 43.554590050601696
			},
			{
				"lng": 11.472148963033153,
				"lat": 43.554560432521633
			},
			{
				"lng": 11.472128591040617,
				"lat": 43.55453627754747
			},
			{
				"lng": 11.472112068209917,
				"lat": 43.554509288397306
			},
			{
				"lng": 11.472096237661024,
				"lat": 43.554496761601207
			},
			{
				"lng": 11.472016174658854,
				"lat": 43.554418952331247
			},
			{
				"lng": 11.471993254716764,
				"lat": 43.554400374719066
			},
			{
				"lng": 11.471888460887124,
				"lat": 43.554329558727723
			},
			{
				"lng": 11.47178802328248,
				"lat": 43.55429691948018
			},
			{
				"lng": 11.471781188828208,
				"lat": 43.554292665922169
			},
			{
				"lng": 11.471754392441397,
				"lat": 43.554270878932748
			},
			{
				"lng": 11.471734499403119,
				"lat": 43.554258705729012
			},
			{
				"lng": 11.47172378593625,
				"lat": 43.554254725027903
			},
			{
				"lng": 11.471714422834955,
				"lat": 43.554247491729349
			},
			{
				"lng": 11.471700300380578,
				"lat": 43.554242852796293
			}
			]
		]
	},
	"20": {
		"name": "MA05 - Casa Basi",
		"center": {
			"lat": 43.54345698056268,
			"lng": 11.475093375740814
		},
		"coords": [
			[{
				"lng": 11.474729308151582,
				"lat": 43.543538399033494
			},
			{
				"lng": 11.474866237664491,
				"lat": 43.543629920521639
			},
			{
				"lng": 11.475087473227527,
				"lat": 43.543744229044236
			},
			{
				"lng": 11.475315237832239,
				"lat": 43.543860408455885
			},
			{
				"lng": 11.475474842812432,
				"lat": 43.543894332888399
			},
			{
				"lng": 11.475596275634862,
				"lat": 43.543809186555649
			},
			{
				"lng": 11.475635899726194,
				"lat": 43.543653441954554
			},
			{
				"lng": 11.475604982758769,
				"lat": 43.543476874607229
			},
			{
				"lng": 11.475547811238151,
				"lat": 43.543430352439749
			},
			{
				"lng": 11.475437275464866,
				"lat": 43.543367538514062
			},
			{
				"lng": 11.475237962970676,
				"lat": 43.543267556946375
			},
			{
				"lng": 11.475180785757756,
				"lat": 43.543243135223427
			},
			{
				"lng": 11.474888584718686,
				"lat": 43.543252934256458
			},
			{
				"lng": 11.474636749273746,
				"lat": 43.543249068454791
			},
			{
				"lng": 11.474556948189921,
				"lat": 43.543260127611973
			},
			{
				"lng": 11.474510841498775,
				"lat": 43.543310113787044
			},
			{
				"lng": 11.474542919699561,
				"lat": 43.543370069811367
			},
			{
				"lng": 11.474599743468726,
				"lat": 43.543427070891767
			},
			{
				"lng": 11.474729308151582,
				"lat": 43.543538399033494
			}
			]
		]
	},
	"21": {
		"name": "MA06 - Casa Vanni",
		"center": {
			"lat": 43.539302298928,
			"lng": 11.471087881203642
		},
		"coords": [
			[{
				"lng": 11.468643892139532,
				"lat": 43.537736061315009
			},
			{
				"lng": 11.468512907258228,
				"lat": 43.537641180688631
			},
			{
				"lng": 11.468491919469258,
				"lat": 43.537606103032701
			},
			{
				"lng": 11.468506842585532,
				"lat": 43.537552484046095
			},
			{
				"lng": 11.468452169868895,
				"lat": 43.537530570019968
			},
			{
				"lng": 11.46836397679377,
				"lat": 43.537585771310056
			},
			{
				"lng": 11.468292101161671,
				"lat": 43.537631893411273
			},
			{
				"lng": 11.468191771458446,
				"lat": 43.537678687153033
			},
			{
				"lng": 11.468041556025037,
				"lat": 43.537693088058631
			},
			{
				"lng": 11.467945779113583,
				"lat": 43.537663545791382
			},
			{
				"lng": 11.467741253009688,
				"lat": 43.537662384100692
			},
			{
				"lng": 11.467582035286346,
				"lat": 43.537706730002029
			},
			{
				"lng": 11.467563727684963,
				"lat": 43.537759189917786
			},
			{
				"lng": 11.46761285226478,
				"lat": 43.53786690705369
			},
			{
				"lng": 11.467721322270251,
				"lat": 43.537894316060502
			},
			{
				"lng": 11.467829754467676,
				"lat": 43.537920796055097
			},
			{
				"lng": 11.4679231296097,
				"lat": 43.537954109185577
			},
			{
				"lng": 11.468049893091292,
				"lat": 43.537991349801317
			},
			{
				"lng": 11.468162383661873,
				"lat": 43.538023320183328
			},
			{
				"lng": 11.468261169907754,
				"lat": 43.53806395397136
			},
			{
				"lng": 11.468395860446025,
				"lat": 43.538107531066181
			},
			{
				"lng": 11.468556695322178,
				"lat": 43.538165418866207
			},
			{
				"lng": 11.46878304275076,
				"lat": 43.538262799104501
			},
			{
				"lng": 11.469027974694415,
				"lat": 43.538439733732375
			},
			{
				"lng": 11.469288458252068,
				"lat": 43.538621910149701
			},
			{
				"lng": 11.469905665175652,
				"lat": 43.539026948560853
			},
			{
				"lng": 11.470336324199678,
				"lat": 43.539307714218566
			},
			{
				"lng": 11.470910357968895,
				"lat": 43.539719258717106
			},
			{
				"lng": 11.471373039013317,
				"lat": 43.540032798133986
			},
			{
				"lng": 11.47183789901497,
				"lat": 43.540336991271836
			},
			{
				"lng": 11.472155039461741,
				"lat": 43.540529092267114
			},
			{
				"lng": 11.472438146323125,
				"lat": 43.540701474749049
			},
			{
				"lng": 11.472654094827663,
				"lat": 43.540856715144464
			},
			{
				"lng": 11.472882813767447,
				"lat": 43.541011678787918
			},
			{
				"lng": 11.473027682751093,
				"lat": 43.541116391946716
			},
			{
				"lng": 11.473180792311632,
				"lat": 43.541172580902561
			},
			{
				"lng": 11.473268155799532,
				"lat": 43.541183706336156
			},
			{
				"lng": 11.473334252534253,
				"lat": 43.54117483803725
			},
			{
				"lng": 11.473386060217443,
				"lat": 43.541129089980018
			},
			{
				"lng": 11.473427537768535,
				"lat": 43.541082261221945
			},
			{
				"lng": 11.47345911059123,
				"lat": 43.540948456051964
			},
			{
				"lng": 11.473475546798355,
				"lat": 43.540809981101887
			},
			{
				"lng": 11.473481825728454,
				"lat": 43.540647156919761
			},
			{
				"lng": 11.473505978543956,
				"lat": 43.540477985401544
			},
			{
				"lng": 11.473510387007869,
				"lat": 43.540397000771492
			},
			{
				"lng": 11.473483956513375,
				"lat": 43.540313115276426
			},
			{
				"lng": 11.473416442642431,
				"lat": 43.540257754869259
			},
			{
				"lng": 11.473296049648773,
				"lat": 43.540171432769135
			},
			{
				"lng": 11.473192866166375,
				"lat": 43.540106747551306
			},
			{
				"lng": 11.473096478163084,
				"lat": 43.540047378067584
			},
			{
				"lng": 11.472876413852026,
				"lat": 43.539919852021931
			},
			{
				"lng": 11.472700713373742,
				"lat": 43.539799541158331
			},
			{
				"lng": 11.472643271704314,
				"lat": 43.539688907592883
			},
			{
				"lng": 11.472561869561378,
				"lat": 43.53958054064536
			},
			{
				"lng": 11.472373373239561,
				"lat": 43.539443922482803
			},
			{
				"lng": 11.472194737507174,
				"lat": 43.539302697460784
			},
			{
				"lng": 11.472095894186277,
				"lat": 43.539207519578817
			},
			{
				"lng": 11.47196695362501,
				"lat": 43.539064674447118
			},
			{
				"lng": 11.471826094129316,
				"lat": 43.538907831955107
			},
			{
				"lng": 11.471754910814179,
				"lat": 43.538782832080756
			},
			{
				"lng": 11.47165381040343,
				"lat": 43.538719187878456
			},
			{
				"lng": 11.471453029337424,
				"lat": 43.538711094170701
			},
			{
				"lng": 11.471268546456233,
				"lat": 43.538683105778659
			},
			{
				"lng": 11.471090109089642,
				"lat": 43.538683411214912
			},
			{
				"lng": 11.470962961087974,
				"lat": 43.538682607406187
			},
			{
				"lng": 11.470871958260396,
				"lat": 43.538618907456026
			},
			{
				"lng": 11.47084589960785,
				"lat": 43.538569662794302
			},
			{
				"lng": 11.470813660036034,
				"lat": 43.538483134438636
			},
			{
				"lng": 11.470693496185483,
				"lat": 43.538432445953838
			},
			{
				"lng": 11.470473783751622,
				"lat": 43.538417599899432
			},
			{
				"lng": 11.470273889972844,
				"lat": 43.538391734292226
			},
			{
				"lng": 11.470112543056734,
				"lat": 43.538344999198493
			},
			{
				"lng": 11.469903131107454,
				"lat": 43.538305111671264
			},
			{
				"lng": 11.469672671320996,
				"lat": 43.538247589252478
			},
			{
				"lng": 11.46949501068638,
				"lat": 43.538207014803149
			},
			{
				"lng": 11.469345715614715,
				"lat": 43.538142731916331
			},
			{
				"lng": 11.468962183372941,
				"lat": 43.537928158968562
			},
			{
				"lng": 11.468814100292219,
				"lat": 43.537833647805073
			},
			{
				"lng": 11.468643892139532,
				"lat": 43.537736061315009
			}
			]
		]
	},
	"22": {
		"name": "MA08 - Cave Vecchie",
		"center": {
			"lat": 43.55414146646824,
			"lng": 11.453969351267185
		},
		"coords": [
			[{ "lng": 11.455925220460411, "lat": 43.555807364293457 },
			{ "lng": 11.456048820316846, "lat": 43.555843759402308 },
			{ "lng": 11.456156076786462, "lat": 43.555875341905555 },
			{ "lng": 11.456288307478793, "lat": 43.555882096995944 },
			{ "lng": 11.456451805452389, "lat": 43.555890449181376 },
			{ "lng": 11.456525648815337, "lat": 43.555833510453994 },
			{ "lng": 11.456653072994476, "lat": 43.555735256572945 },
			{ "lng": 11.457015496519244, "lat": 43.555371036561702 },
			{ "lng": 11.457035672329805, "lat": 43.555350760583266 },
			{ "lng": 11.457062847794166, "lat": 43.555323450172928 },
			{ "lng": 11.456902044402682, "lat": 43.555083525659661 },
			{ "lng": 11.456877108204729, "lat": 43.555042017102764 },
			{ "lng": 11.456774873027021, "lat": 43.554871836719812 },
			{ "lng": 11.456609221955336, "lat": 43.554673882943675 },
			{ "lng": 11.456546621383247, "lat": 43.554599074563946 },
			{ "lng": 11.456511467192158, "lat": 43.554557064815093 },
			{ "lng": 11.456497417169908, "lat": 43.554555941862624 },
			{ "lng": 11.456233560532755, "lat": 43.554534852706908 },
			{ "lng": 11.456175525796484, "lat": 43.55453021410549 },
			{ "lng": 11.456020226967166, "lat": 43.554423819654595 },
			{ "lng": 11.455745270031523, "lat": 43.554233912979896 },
			{ "lng": 11.45592098171057, "lat": 43.554037456026364 },
			{ "lng": 11.45608695293422, "lat": 43.553851888142916 },
			{ "lng": 11.456139437866009, "lat": 43.553793205896859 },
			{ "lng": 11.456139958707176, "lat": 43.553792623555132 },
			{ "lng": 11.456133313996535, "lat": 43.553652501195266 },
			{ "lng": 11.456130738887772, "lat": 43.553598197546897 },
			{ "lng": 11.456128507971293, "lat": 43.553551152075023 },
			{ "lng": 11.456142342777996, "lat": 43.553520618511612 },
			{ "lng": 11.45615616589671, "lat": 43.553490110712794 },
			{ "lng": 11.456169723499993, "lat": 43.553460188879853 },
			{ "lng": 11.456178073686896, "lat": 43.553441759877849 },
			{ "lng": 11.456188233084486, "lat": 43.553419337902341 },
			{ "lng": 11.456193721702659, "lat": 43.553407224415132 },
			{ "lng": 11.456241756843637, "lat": 43.553301209715336 },
			{ "lng": 11.456238208065738, "lat": 43.553285291953564 },
			{ "lng": 11.456221698573264, "lat": 43.553211239811347 },
			{ "lng": 11.456212233874254, "lat": 43.553168786492193 },
			{ "lng": 11.456194971356831, "lat": 43.553091356370864 },
			{ "lng": 11.456191873119101, "lat": 43.553077459363585 },
			{ "lng": 11.456173792311485, "lat": 43.553063934974439 },
			{ "lng": 11.456076367861227, "lat": 43.552991061624446 },
			{ "lng": 11.456055649388487, "lat": 43.552975564202086 },
			{ "lng": 11.456046097515712, "lat": 43.552968419395043 },
			{ "lng": 11.455962476156856, "lat": 43.552905870455206 },
			{ "lng": 11.45524116467088, "lat": 43.552872232226328 },
			{ "lng": 11.455112600088611, "lat": 43.552571209745317 },
			{ "lng": 11.454898584774364, "lat": 43.552232691194853 },
			{ "lng": 11.454463424150834, "lat": 43.552122678464826 },
			{ "lng": 11.453948221376905, "lat": 43.552044256305919 },
			{ "lng": 11.453450327794267, "lat": 43.552114073405178 },
			{ "lng": 11.453284805482351, "lat": 43.552133393418814 },
			{ "lng": 11.453229235884818, "lat": 43.552177367183653 },
			{ "lng": 11.45315168709708, "lat": 43.552238733542524 },
			{ "lng": 11.452938893162125, "lat": 43.55243295919793 },
			{ "lng": 11.452679209402088, "lat": 43.552715767809268 },
			{ "lng": 11.452545018716837, "lat": 43.552885699856709 },
			{ "lng": 11.45225823659071, "lat": 43.55277448956101 },
			{ "lng": 11.452170756901946, "lat": 43.552740565872362 },
			{ "lng": 11.452093452460424, "lat": 43.5526355378882 },
			{ "lng": 11.452050588210536, "lat": 43.552621658451287 },
			{ "lng": 11.451996825554083, "lat": 43.552604250079966 },
			{ "lng": 11.451983735111746, "lat": 43.552600011383639 },
			{ "lng": 11.451966755336123, "lat": 43.55260591330574 },
			{ "lng": 11.451733574802683, "lat": 43.552686963086522 },
			{ "lng": 11.451699733717227, "lat": 43.552718418341939 },
			{ "lng": 11.451535419454256, "lat": 43.552871147692031 },
			{ "lng": 11.451527696166986, "lat": 43.552878326427638 },
			{ "lng": 11.451482945885827, "lat": 43.552938917967332 },
			{ "lng": 11.451380272585885, "lat": 43.553077936323184 },
			{ "lng": 11.451258878088064, "lat": 43.553245578300043 },
			{ "lng": 11.451228529360682, "lat": 43.553287488775894 },
			{ "lng": 11.451227739024313, "lat": 43.553291471776021 },
			{ "lng": 11.451174164321838, "lat": 43.553561467165892 },
			{ "lng": 11.451183389653824, "lat": 43.553701465570938 },
			{ "lng": 11.451184711875007, "lat": 43.5537215307778 },
			{ "lng": 11.451254619694915, "lat": 43.553757252584248 },
			{ "lng": 11.451272745092039, "lat": 43.553766514365606 },
			{ "lng": 11.451598524647066, "lat": 43.55398540707354 },
			{ "lng": 11.452066218521187, "lat": 43.554299648131561 },
			{ "lng": 11.452590540033361, "lat": 43.554651930692671 },
			{ "lng": 11.452425491504904, "lat": 43.554926185060253 },
			{ "lng": 11.452503463357179, "lat": 43.555160282471959 },
			{ "lng": 11.452595651325993, "lat": 43.555397782130257 },
			{ "lng": 11.452621794992783, "lat": 43.555439117889811 },
			{ "lng": 11.452819726112205, "lat": 43.555554158205986 },
			{ "lng": 11.453014512369341, "lat": 43.555661824094123 },
			{ "lng": 11.453182990469726, "lat": 43.555760288434413 },
			{ "lng": 11.45331657997454, "lat": 43.555829869012037 },
			{ "lng": 11.453389612523399, "lat": 43.555841879882372 },
			{ "lng": 11.45339401090656, "lat": 43.555844674769638 },
			{ "lng": 11.453533579175883, "lat": 43.555864670090756 },
			{ "lng": 11.453627270597691, "lat": 43.555859203427509 },
			{ "lng": 11.453702515049127, "lat": 43.555838584983753 },
			{ "lng": 11.453758965989058, "lat": 43.555823552561741 },
			{ "lng": 11.453813058646936, "lat": 43.555802427532541 },
			{ "lng": 11.453824498304479, "lat": 43.555797959950667 },
			{ "lng": 11.453842026084569, "lat": 43.55578534966557 },
			{ "lng": 11.453874894935122, "lat": 43.555774633119377 },
			{ "lng": 11.454196819225597, "lat": 43.555894655288014 },
			{ "lng": 11.454224798803548, "lat": 43.555927461923382 },
			{ "lng": 11.454365652850319, "lat": 43.556092615546447 },
			{ "lng": 11.454386720584491, "lat": 43.556117317706004 },
			{ "lng": 11.454396719808052, "lat": 43.556363563086613 },
			{ "lng": 11.454459818483947, "lat": 43.556517669190718 },
			{ "lng": 11.454602742841917, "lat": 43.556546792703834 },
			{ "lng": 11.454895956819637, "lat": 43.556568819622633 },
			{ "lng": 11.45501570162557, "lat": 43.556550797457085 },
			{ "lng": 11.455493148780224, "lat": 43.556090850062233 },
			{ "lng": 11.455925220460411, "lat": 43.555807364293457 }
			]
		]
	},
	"23": {
		"name": "MA09 - Le Piagge",
		"center": {
			"lat": 43.54560334439756,
			"lng": 11.474454524067651
		},
		"coords": [
			[{
				"lng": 11.472729097863342,
				"lat": 43.547786406864176
			},
			{
				"lng": 11.473131739952059,
				"lat": 43.547756221229619
			},
			{
				"lng": 11.473364838130196,
				"lat": 43.547771761269601
			},
			{
				"lng": 11.473600587559631,
				"lat": 43.547679170871454
			},
			{
				"lng": 11.473829085037803,
				"lat": 43.547639912213313
			},
			{
				"lng": 11.4740565169535,
				"lat": 43.547578204173917
			},
			{
				"lng": 11.47413155871301,
				"lat": 43.547428363427443
			},
			{
				"lng": 11.474340636345284,
				"lat": 43.54723170270973
			},
			{
				"lng": 11.475003034005502,
				"lat": 43.546970818062348
			},
			{
				"lng": 11.4756542490729,
				"lat": 43.546703756355583
			},
			{
				"lng": 11.476710127538858,
				"lat": 43.546522779497785
			},
			{
				"lng": 11.477350091164714,
				"lat": 43.546217307458789
			},
			{
				"lng": 11.477741970452776,
				"lat": 43.545990988897145
			},
			{
				"lng": 11.477863431481286,
				"lat": 43.545747471809115
			},
			{
				"lng": 11.478055962729174,
				"lat": 43.545374398512429
			},
			{
				"lng": 11.478044991228444,
				"lat": 43.544752786236558
			},
			{
				"lng": 11.477665350112268,
				"lat": 43.544451848277021
			},
			{
				"lng": 11.477220782993296,
				"lat": 43.544099618561013
			},
			{
				"lng": 11.476855461665346,
				"lat": 43.544030243535289
			},
			{
				"lng": 11.475670567819259,
				"lat": 43.544010247329581
			},
			{
				"lng": 11.47543755303133,
				"lat": 43.543925366822982
			},
			{
				"lng": 11.47486397094824,
				"lat": 43.543699627756929
			},
			{
				"lng": 11.474632314784992,
				"lat": 43.543591757877479
			},
			{
				"lng": 11.474475028364113,
				"lat": 43.543450610301626
			},
			{
				"lng": 11.474113594723958,
				"lat": 43.543343488188178
			},
			{
				"lng": 11.473938568097331,
				"lat": 43.543323872900579
			},
			{
				"lng": 11.473857991413078,
				"lat": 43.543344890406033
			},
			{
				"lng": 11.473673214404412,
				"lat": 43.543549884629009
			},
			{
				"lng": 11.473556943323638,
				"lat": 43.543623984316397
			},
			{
				"lng": 11.473385404248225,
				"lat": 43.54368964795065
			},
			{
				"lng": 11.473176424375648,
				"lat": 43.543907010176902
			},
			{
				"lng": 11.473159604484982,
				"lat": 43.544056210509616
			},
			{
				"lng": 11.473031484478936,
				"lat": 43.544284885452484
			},
			{
				"lng": 11.472958747374209,
				"lat": 43.544544537311083
			},
			{
				"lng": 11.472803522861199,
				"lat": 43.544749872100908
			},
			{
				"lng": 11.472616147341101,
				"lat": 43.544848182149344
			},
			{
				"lng": 11.472409701510728,
				"lat": 43.54493344001169
			},
			{
				"lng": 11.472053585677509,
				"lat": 43.545057840462029
			},
			{
				"lng": 11.471817720010813,
				"lat": 43.545124384621239
			},
			{
				"lng": 11.471497000236333,
				"lat": 43.54509812406684
			},
			{
				"lng": 11.471232377379579,
				"lat": 43.545103846728907
			},
			{
				"lng": 11.471014414690917,
				"lat": 43.545208146937888
			},
			{
				"lng": 11.470922952072051,
				"lat": 43.545353964124502
			},
			{
				"lng": 11.470844112500178,
				"lat": 43.54551057701056
			},
			{
				"lng": 11.470884861684178,
				"lat": 43.545613708715528
			},
			{
				"lng": 11.470973444808026,
				"lat": 43.545923059820666
			},
			{
				"lng": 11.471179278287018,
				"lat": 43.546117774222921
			},
			{
				"lng": 11.471450014341611,
				"lat": 43.54641067169613
			},
			{
				"lng": 11.471662190174895,
				"lat": 43.546760156264909
			},
			{
				"lng": 11.472010937460718,
				"lat": 43.547085878357542
			},
			{
				"lng": 11.472101200112682,
				"lat": 43.547283090955595
			},
			{
				"lng": 11.472118184894549,
				"lat": 43.547475250135712
			},
			{
				"lng": 11.472063948886719,
				"lat": 43.547637970119368
			},
			{
				"lng": 11.472068740314031,
				"lat": 43.547755156273226
			},
			{
				"lng": 11.472154249433991,
				"lat": 43.547816658169218
			},
			{
				"lng": 11.472188608104714,
				"lat": 43.547824369215384
			},
			{
				"lng": 11.472729097863342,
				"lat": 43.547786406864176
			}
			]
		]
	},
	"24": {
		"name": "MA10 - Ronco",
		"center": {
			"lat": 43.54348878522245,
			"lng": 11.46052821434416
		},
		"coords": [
			[
				{ "lng": 11.458845165977959, "lat": 43.544634637481352 },
				{ "lng": 11.458913532268472, "lat": 43.544618114076385 },
				{ "lng": 11.459286485441231, "lat": 43.544527974391464 },
				{ "lng": 11.459349192046925, "lat": 43.544512818580927 },
				{ "lng": 11.459614987611626, "lat": 43.544448576924388 },
				{ "lng": 11.459620994731443, "lat": 43.544506968949115 },
				{ "lng": 11.459640101962409, "lat": 43.54469269928331 },
				{ "lng": 11.459888610144722, "lat": 43.544799247154209 },
				{ "lng": 11.460741969410503, "lat": 43.545177739908759 },
				{ "lng": 11.460764565541805, "lat": 43.545187761878552 },
				{ "lng": 11.4607702504478, "lat": 43.545190283280391 },
				{ "lng": 11.460856360971361, "lat": 43.54514675962514 },
				{ "lng": 11.460415966399919, "lat": 43.54454090455318 },
				{ "lng": 11.460589082285079, "lat": 43.544486128886533 },
				{ "lng": 11.46123536668941, "lat": 43.544281634618727 },
				{ "lng": 11.461372017155034, "lat": 43.544238395683408 },
				{ "lng": 11.461385207230421, "lat": 43.5442784074136 },
				{ "lng": 11.461419920646119, "lat": 43.544383709323519 },
				{ "lng": 11.461420245576516, "lat": 43.544373457725229 },
				{ "lng": 11.461482775599714, "lat": 43.544556292215603 },
				{ "lng": 11.461453970610107, "lat": 43.54463666225633 },
				{ "lng": 11.461449467745432, "lat": 43.544685934265694 },
				{ "lng": 11.46143105023698, "lat": 43.544706481401214 },
				{ "lng": 11.461409109413419, "lat": 43.544741740409577 },
				{ "lng": 11.461407535766167, "lat": 43.544774453192801 },
				{ "lng": 11.461461187818312, "lat": 43.544777461220363 },
				{ "lng": 11.461845929201651, "lat": 43.544799031178059 },
				{ "lng": 11.462098637728948, "lat": 43.544714905376814 },
				{ "lng": 11.462306660920794, "lat": 43.544657332800583 },
				{ "lng": 11.46232257917033, "lat": 43.544540461099388 },
				{ "lng": 11.462271123798448, "lat": 43.544413671165266 },
				{ "lng": 11.462178982322598, "lat": 43.544289161426228 },
				{ "lng": 11.46223573371196, "lat": 43.544268565957026 },
				{ "lng": 11.462232997794159, "lat": 43.544264709193008 },
				{ "lng": 11.461992041033822, "lat": 43.544053744057152 },
				{ "lng": 11.461857226842326, "lat": 43.543946216991905 },
				{ "lng": 11.461943991928946, "lat": 43.54383740525541 },
				{ "lng": 11.461925023098132, "lat": 43.543678065859858 },
				{ "lng": 11.462002458852881, "lat": 43.543544958528834 },
				{ "lng": 11.461975426738267, "lat": 43.543436008357887 },
				{ "lng": 11.461906978283139, "lat": 43.543234847467424 },
				{ "lng": 11.46145690025801, "lat": 43.542910467900093 },
				{ "lng": 11.461324321971421, "lat": 43.542772538075205 },
				{ "lng": 11.460986794901345, "lat": 43.542421383035695 },
				{ "lng": 11.460951809600974, "lat": 43.542384984871518 },
				{ "lng": 11.460721137226766, "lat": 43.542310261868394 },
				{ "lng": 11.460560481050123, "lat": 43.542212754733164 },
				{ "lng": 11.460401029633216, "lat": 43.542187927953584 },
				{ "lng": 11.45969919338698, "lat": 43.542344026432261 },
				{ "lng": 11.459505515893884, "lat": 43.542685841195855 },
				{ "lng": 11.459512490784929, "lat": 43.542857331116359 },
				{ "lng": 11.459634474489764, "lat": 43.543055459280019 },
				{ "lng": 11.459654129751375, "lat": 43.543531813295694 },
				{ "lng": 11.459268391058853, "lat": 43.543696265324513 },
				{ "lng": 11.458950828014265, "lat": 43.543972819133856 },
				{ "lng": 11.458710028031412, "lat": 43.544063820155095 },
				{ "lng": 11.458616624471011, "lat": 43.544142461198469 },
				{ "lng": 11.458749608478636, "lat": 43.544324737875137 },
				{ "lng": 11.458845165977959, "lat": 43.544634637481352 }
			]
		]
	},
	"25": {
		"name": "MA11 - Poggi Vecchi",
		"center": {
			"lat": 43.563623034869686,
			"lng": 11.454116637698316
		},
		"coords": [
			[{
				"lng": 11.451900822645607,
				"lat": 43.565371867733248
			},
			{
				"lng": 11.452023725348813,
				"lat": 43.565205751398253
			},
			{
				"lng": 11.453890538492221,
				"lat": 43.563066937189895
			},
			{
				"lng": 11.45322950621814,
				"lat": 43.563531433494845
			},
			{
				"lng": 11.452782864078634,
				"lat": 43.563792232113052
			},
			{
				"lng": 11.452501975827117,
				"lat": 43.56397707134613
			},
			{
				"lng": 11.452180806773351,
				"lat": 43.564331955822659
			},
			{
				"lng": 11.451904214423768,
				"lat": 43.564652389883328
			},
			{
				"lng": 11.451809830010413,
				"lat": 43.564765826517593
			},
			{
				"lng": 11.451729464291434,
				"lat": 43.565070749073826
			},
			{
				"lng": 11.451728646270402,
				"lat": 43.565111097528728
			},
			{
				"lng": 11.451902247271152,
				"lat": 43.565371222990436
			},
			{
				"lng": 11.451900822645607,
				"lat": 43.565371867733248
			}
			],
			[{
				"lng": 11.456432457149448,
				"lat": 43.563150700381769
			},
			{
				"lng": 11.456424712493261,
				"lat": 43.563110366959485
			},
			{
				"lng": 11.456422884892707,
				"lat": 43.56310084898324
			},
			{
				"lng": 11.456369720122551,
				"lat": 43.563067543629742
			},
			{
				"lng": 11.456331924336055,
				"lat": 43.563024549671312
			},
			{
				"lng": 11.456303645077041,
				"lat": 43.562977848634773
			},
			{
				"lng": 11.456273555389867,
				"lat": 43.562931749749822
			},
			{
				"lng": 11.456244072287044,
				"lat": 43.562885444080443
			},
			{
				"lng": 11.456214002482033,
				"lat": 43.562839338349747
			},
			{
				"lng": 11.456171543107018,
				"lat": 43.562798711275889
			},
			{
				"lng": 11.456129941159872,
				"lat": 43.562757617824374
			},
			{
				"lng": 11.456055204679766,
				"lat": 43.562683794655349
			},
			{
				"lng": 11.456025634144158,
				"lat": 43.562637518510805
			},
			{
				"lng": 11.45598268816037,
				"lat": 43.562597162880614
			},
			{
				"lng": 11.454816481064302,
				"lat": 43.562599790029367
			},
			{
				"lng": 11.454436243086976,
				"lat": 43.562811088215128
			},
			{
				"lng": 11.454063714946221,
				"lat": 43.563026193387429
			},
			{
				"lng": 11.453834417970226,
				"lat": 43.563314783071654
			},
			{
				"lng": 11.453674479881888,
				"lat": 43.563546136341479
			},
			{
				"lng": 11.453696331451637,
				"lat": 43.563605308326032
			},
			{
				"lng": 11.453714351534746,
				"lat": 43.56365410491059
			},
			{
				"lng": 11.453753831172799,
				"lat": 43.56369857259871
			},
			{
				"lng": 11.453762642623378,
				"lat": 43.563752962975983
			},
			{
				"lng": 11.453793892133858,
				"lat": 43.563798349904992
			},
			{
				"lng": 11.453835140339383,
				"lat": 43.563844430236216
			},
			{
				"lng": 11.453833457914016,
				"lat": 43.563900343970687
			},
			{
				"lng": 11.45386294129514,
				"lat": 43.5639595578198
			},
			{
				"lng": 11.453883035333737,
				"lat": 43.564011963976213
			},
			{
				"lng": 11.453923010490357,
				"lat": 43.564052076464634
			},
			{
				"lng": 11.453962414511649,
				"lat": 43.564106970140926
			},
			{
				"lng": 11.453999504635883,
				"lat": 43.564185960169851
			},
			{
				"lng": 11.453998244451022,
				"lat": 43.564236980116448
			},
			{
				"lng": 11.454047003435624,
				"lat": 43.564273556933003
			},
			{
				"lng": 11.454079077707361,
				"lat": 43.564319666585632
			},
			{
				"lng": 11.454091664366837,
				"lat": 43.564362359002693
			},
			{
				"lng": 11.454093735890936,
				"lat": 43.564413364936449
			},
			{
				"lng": 11.454108215581243,
				"lat": 43.564465505433184
			},
			{
				"lng": 11.454132056152382,
				"lat": 43.564510753113886
			},
			{
				"lng": 11.454167763803923,
				"lat": 43.564551942312029
			},
			{
				"lng": 11.456041900793677,
				"lat": 43.564591488511581
			},
			{
				"lng": 11.456197382659772,
				"lat": 43.564478731293562
			},
			{
				"lng": 11.45624692420677,
				"lat": 43.564260445736792
			},
			{
				"lng": 11.456246478372636,
				"lat": 43.564103931207868
			},
			{
				"lng": 11.4563395655415,
				"lat": 43.563750851369427
			},
			{
				"lng": 11.456348835229555,
				"lat": 43.563482491896572
			},
			{
				"lng": 11.456430060508188,
				"lat": 43.5633456956147
			},
			{
				"lng": 11.456423537270892,
				"lat": 43.563245422296291
			},
			{
				"lng": 11.45623622123051,
				"lat": 43.563235895099417
			},
			{
				"lng": 11.456068520124161,
				"lat": 43.563203477660622
			},
			{
				"lng": 11.456012315572043,
				"lat": 43.563178233269142
			},
			{
				"lng": 11.456102340001422,
				"lat": 43.563147029851542
			},
			{
				"lng": 11.456268495087555,
				"lat": 43.563123411201786
			},
			{
				"lng": 11.456432457149448,
				"lat": 43.563150700381769
			}
			]
		]
	},
	"26": {
		"name": "MA13 - Strada Vecchio Borgo",
		"center": {
			"lat": 43.54697200027264,
			"lng": 11.454665671883392
		},
		"coords": [
			[{
				"lng": 11.453903717363495,
				"lat": 43.547169301129898
			},
			{
				"lng": 11.454342867569624,
				"lat": 43.547246081443681
			},
			{
				"lng": 11.454369673354346,
				"lat": 43.547166249325748
			},
			{
				"lng": 11.453930523703491,
				"lat": 43.547089469101046
			},
			{
				"lng": 11.453903717363495,
				"lat": 43.547169301129898
			}
			],
			[{
				"lng": 11.454439519525137,
				"lat": 43.547281652252067
			},
			{
				"lng": 11.454546877003819,
				"lat": 43.547267834309821
			},
			{
				"lng": 11.454625886042528,
				"lat": 43.547173734686176
			},
			{
				"lng": 11.454665990606768,
				"lat": 43.547118878360301
			},
			{
				"lng": 11.454705789295113,
				"lat": 43.547056489678496
			},
			{
				"lng": 11.454714457163732,
				"lat": 43.547006179918348
			},
			{
				"lng": 11.454716059511686,
				"lat": 43.546913742891469
			},
			{
				"lng": 11.454747693253935,
				"lat": 43.54678215120996
			},
			{
				"lng": 11.454784987308711,
				"lat": 43.546658078720569
			},
			{
				"lng": 11.454823690444449,
				"lat": 43.546568716071612
			},
			{
				"lng": 11.454930714210299,
				"lat": 43.546466271780744
			},
			{
				"lng": 11.455015440119247,
				"lat": 43.546329668158762
			},
			{
				"lng": 11.454993100094107,
				"lat": 43.546307021953091
			},
			{
				"lng": 11.454932783254158,
				"lat": 43.546385336841986
			},
			{
				"lng": 11.454856045579261,
				"lat": 43.546448620981316
			},
			{
				"lng": 11.454756343728036,
				"lat": 43.546473888768112
			},
			{
				"lng": 11.454704286558039,
				"lat": 43.546498133080107
			},
			{
				"lng": 11.454631235088494,
				"lat": 43.546526597766167
			},
			{
				"lng": 11.454607806301391,
				"lat": 43.546596479362812
			},
			{
				"lng": 11.454589154992552,
				"lat": 43.546658413795988
			},
			{
				"lng": 11.454575446471949,
				"lat": 43.546716472605191
			},
			{
				"lng": 11.454546353001943,
				"lat": 43.546778733190919
			},
			{
				"lng": 11.454506460683218,
				"lat": 43.546845097040944
			},
			{
				"lng": 11.454504488845483,
				"lat": 43.546922158547069
			},
			{
				"lng": 11.454481271919169,
				"lat": 43.547003547686352
			},
			{
				"lng": 11.454425735462392,
				"lat": 43.547074016963919
			},
			{
				"lng": 11.454397265611005,
				"lat": 43.547151647570551
			},
			{
				"lng": 11.454367445936054,
				"lat": 43.547202309705433
			},
			{
				"lng": 11.454375139303854,
				"lat": 43.547259908839315
			},
			{
				"lng": 11.454439519525137,
				"lat": 43.547281652252067
			}
			]
		]
	},
	"1": {
		"name": "VI - Vignale",
		"center": {
			"lat": 43.5751,
			"lng": 11.4325
		},
		"coords": [

			[
				{
					"lng": 11.434269428489484,
					"lat": 43.57584848446392
				},
				{
					"lng": 11.434310418161965,
					"lat": 43.57584725617684
				},
				{
					"lng": 11.434349797678532,
					"lat": 43.57585191319872
				},
				{
					"lng": 11.434389828825578,
					"lat": 43.575854189977484
				},
				{
					"lng": 11.434430462109589,
					"lat": 43.57584644557722
				},
				{
					"lng": 11.434475982463239,
					"lat": 43.57583643951773
				},
				{
					"lng": 11.434519823116661,
					"lat": 43.57582476178919
				},
				{
					"lng": 11.434562380884769,
					"lat": 43.57580933050063
				},
				{
					"lng": 11.434610540436502,
					"lat": 43.575793223144956
				},
				{
					"lng": 11.434657273375894,
					"lat": 43.575768016006435
				},
				{
					"lng": 11.434704902204537,
					"lat": 43.57574247651736
				},
				{
					"lng": 11.43474666323695,
					"lat": 43.57567651652413
				},
				{
					"lng": 11.434830820657362,
					"lat": 43.57556673735835
				},
				{
					"lng": 11.434879704722066,
					"lat": 43.5755080301121
				},
				{
					"lng": 11.434937403644701,
					"lat": 43.575426822318995
				},
				{
					"lng": 11.434956633821155,
					"lat": 43.57538141126892
				},
				{
					"lng": 11.43495221072315,
					"lat": 43.575337079110334
				},
				{
					"lng": 11.434935522210935,
					"lat": 43.57530458177842
				},
				{
					"lng": 11.434912220651158,
					"lat": 43.57525778164593
				},
				{
					"lng": 11.434899672743729,
					"lat": 43.57521871911841
				},
				{
					"lng": 11.434898792721334,
					"lat": 43.57518294207695
				},
				{
					"lng": 11.434902659703367,
					"lat": 43.57515198616155
				},
				{
					"lng": 11.434909981764315,
					"lat": 43.575118761179866
				},
				{
					"lng": 11.434911652078167,
					"lat": 43.57508752179822
				},
				{
					"lng": 11.434908522332137,
					"lat": 43.575051607501344
				},
				{
					"lng": 11.434897307064958,
					"lat": 43.575001951546156
				},
				{
					"lng": 11.434882917618214,
					"lat": 43.574941601466584
				},
				{
					"lng": 11.434905266068766,
					"lat": 43.574859752800116
				},
				{
					"lng": 11.434954567272081,
					"lat": 43.57482908711934
				},
				{
					"lng": 11.435032221759714,
					"lat": 43.57478272663276
				},
				{
					"lng": 11.435047598182084,
					"lat": 43.57477548399838
				},
				{
					"lng": 11.435067082057445,
					"lat": 43.574769555168416
				},
				{
					"lng": 11.435091188813306,
					"lat": 43.574765500684194
				},
				{
					"lng": 11.43511152102947,
					"lat": 43.574761921761905
				},
				{
					"lng": 11.435119971973142,
					"lat": 43.57476026117698
				},
				{
					"lng": 11.435134380713112,
					"lat": 43.574756051767054
				},
				{
					"lng": 11.435140596042672,
					"lat": 43.57475331005845
				},
				{
					"lng": 11.435143847563744,
					"lat": 43.5747521982717
				},
				{
					"lng": 11.43515870635814,
					"lat": 43.57474390987669
				},
				{
					"lng": 11.435176232738414,
					"lat": 43.57472979439047
				},
				{
					"lng": 11.435193311590961,
					"lat": 43.57471624018409
				},
				{
					"lng": 11.435199803908404,
					"lat": 43.57470912037856
				},
				{
					"lng": 11.435258509326648,
					"lat": 43.57463301328627
				},
				{
					"lng": 11.435320424444797,
					"lat": 43.574551349433236
				},
				{
					"lng": 11.43533147965324,
					"lat": 43.574536144162074
				},
				{
					"lng": 11.435339089667348,
					"lat": 43.574515916377926
				},
				{
					"lng": 11.435348570765939,
					"lat": 43.57448199358605
				},
				{
					"lng": 11.43535510234642,
					"lat": 43.57444735550222
				},
				{
					"lng": 11.43536300450612,
					"lat": 43.57436778972135
				},
				{
					"lng": 11.435366488314457,
					"lat": 43.57429539572017
				},
				{
					"lng": 11.43536696548965,
					"lat": 43.57426141589294
				},
				{
					"lng": 11.43537004732495,
					"lat": 43.57422794108634
				},
				{
					"lng": 11.435378119594528,
					"lat": 43.574190235566455
				},
				{
					"lng": 11.4353870723068,
					"lat": 43.5741606060972
				},
				{
					"lng": 11.43539575273494,
					"lat": 43.574127242218374
				},
				{
					"lng": 11.435429938797213,
					"lat": 43.57398311053498
				},
				{
					"lng": 11.435457791417292,
					"lat": 43.57387140847778
				},
				{
					"lng": 11.435469994070102,
					"lat": 43.57384085628268
				},
				{
					"lng": 11.435482932211768,
					"lat": 43.57383193668877
				},
				{
					"lng": 11.435501564373887,
					"lat": 43.57382896271484
				},
				{
					"lng": 11.43554177724348,
					"lat": 43.57382749335845
				},
				{
					"lng": 11.435561162073963,
					"lat": 43.57382678339893
				},
				{
					"lng": 11.435589807654441,
					"lat": 43.57382013107481
				},
				{
					"lng": 11.435618716059679,
					"lat": 43.573805301386685
				},
				{
					"lng": 11.43565073107986,
					"lat": 43.57377454116409
				},
				{
					"lng": 11.435692027885297,
					"lat": 43.573724023068415
				},
				{
					"lng": 11.435708185154045,
					"lat": 43.57370372626139
				},
				{
					"lng": 11.435720464198177,
					"lat": 43.5736890169315
				},
				{
					"lng": 11.435734401488881,
					"lat": 43.573680677763114
				},
				{
					"lng": 11.435748682275076,
					"lat": 43.573676301743006
				},
				{
					"lng": 11.435810471156906,
					"lat": 43.57362042887014
				},
				{
					"lng": 11.435816384402122,
					"lat": 43.57361241187434
				},
				{
					"lng": 11.435816706098986,
					"lat": 43.57360828122038
				},
				{
					"lng": 11.435833984611472,
					"lat": 43.57356151137515
				},
				{
					"lng": 11.435856766852813,
					"lat": 43.57357952287476
				},
				{
					"lng": 11.435862671006145,
					"lat": 43.5735826382312
				},
				{
					"lng": 11.435869862479771,
					"lat": 43.57358352575975
				},
				{
					"lng": 11.435873604524538,
					"lat": 43.57358290248298
				},
				{
					"lng": 11.435878738758214,
					"lat": 43.57358143345004
				},
				{
					"lng": 11.43588636864053,
					"lat": 43.573577523433705
				},
				{
					"lng": 11.435899123210248,
					"lat": 43.573567747116456
				},
				{
					"lng": 11.43591731993298,
					"lat": 43.57355049305309
				},
				{
					"lng": 11.435939459680021,
					"lat": 43.57352463036119
				},
				{
					"lng": 11.435949312008605,
					"lat": 43.57351375472041
				},
				{
					"lng": 11.435958769558958,
					"lat": 43.57351329370535
				},
				{
					"lng": 11.435957524306286,
					"lat": 43.57352104357816
				},
				{
					"lng": 11.435956759522105,
					"lat": 43.573525844783184
				},
				{
					"lng": 11.435942951279026,
					"lat": 43.57356348853556
				},
				{
					"lng": 11.435909338392113,
					"lat": 43.57364589410202
				},
				{
					"lng": 11.435976760292169,
					"lat": 43.57363953003159
				},
				{
					"lng": 11.43599639516327,
					"lat": 43.57364264115882
				},
				{
					"lng": 11.43601171700318,
					"lat": 43.573618519142265
				},
				{
					"lng": 11.436014754273351,
					"lat": 43.57351406475789
				},
				{
					"lng": 11.436017788520264,
					"lat": 43.573409610436336
				},
				{
					"lng": 11.43602584053326,
					"lat": 43.57339611501559
				},
				{
					"lng": 11.436054031563877,
					"lat": 43.57334772707417
				},
				{
					"lng": 11.43605787341603,
					"lat": 43.573341164364315
				},
				{
					"lng": 11.436062261944848,
					"lat": 43.573333669508806
				},
				{
					"lng": 11.436066131520793,
					"lat": 43.57332706334296
				},
				{
					"lng": 11.436069697687538,
					"lat": 43.573320974174365
				},
				{
					"lng": 11.43607327387277,
					"lat": 43.57331487105341
				},
				{
					"lng": 11.43607687474659,
					"lat": 43.57330866793807
				},
				{
					"lng": 11.436079332297776,
					"lat": 43.573303333851605
				},
				{
					"lng": 11.436082256394373,
					"lat": 43.57329699239139
				},
				{
					"lng": 11.436085272270958,
					"lat": 43.57329045278625
				},
				{
					"lng": 11.436088023180998,
					"lat": 43.57328448376395
				},
				{
					"lng": 11.436091879235219,
					"lat": 43.57327611823794
				},
				{
					"lng": 11.436095140502317,
					"lat": 43.57326904748476
				},
				{
					"lng": 11.436098588574174,
					"lat": 43.573261567183444
				},
				{
					"lng": 11.436101685542058,
					"lat": 43.5732548455977
				},
				{
					"lng": 11.436105391535314,
					"lat": 43.573246807503
				},
				{
					"lng": 11.436107803313266,
					"lat": 43.57324157550832
				},
				{
					"lng": 11.43611055428548,
					"lat": 43.573235608132755
				},
				{
					"lng": 11.436113754184294,
					"lat": 43.57322866508309
				},
				{
					"lng": 11.436116052095777,
					"lat": 43.57322368336139
				},
				{
					"lng": 11.436117728583675,
					"lat": 43.573220048088444
				},
				{
					"lng": 11.436120236228218,
					"lat": 43.57321460687055
				},
				{
					"lng": 11.436120568468587,
					"lat": 43.57321388647569
				},
				{
					"lng": 11.436122239472473,
					"lat": 43.573210227689096
				},
				{
					"lng": 11.436123998449421,
					"lat": 43.57320644502752
				},
				{
					"lng": 11.436126535230116,
					"lat": 43.573202344631035
				},
				{
					"lng": 11.436128399998303,
					"lat": 43.57319932962833
				},
				{
					"lng": 11.436130288337013,
					"lat": 43.573196280600705
				},
				{
					"lng": 11.43613199690434,
					"lat": 43.57319351567461
				},
				{
					"lng": 11.436134852305932,
					"lat": 43.57318890070376
				},
				{
					"lng": 11.436136833551501,
					"lat": 43.573185700218545
				},
				{
					"lng": 11.436138430749299,
					"lat": 43.57318311626944
				},
				{
					"lng": 11.436140463091286,
					"lat": 43.57317983336188
				},
				{
					"lng": 11.436142095878468,
					"lat": 43.57317719479837
				},
				{
					"lng": 11.436143639224007,
					"lat": 43.57317469992479
				},
				{
					"lng": 11.436145034189012,
					"lat": 43.57317244287113
				},
				{
					"lng": 11.436146594507512,
					"lat": 43.57316991905923
				},
				{
					"lng": 11.436148078269325,
					"lat": 43.57316752107706
				},
				{
					"lng": 11.436149666379412,
					"lat": 43.573164955456576
				},
				{
					"lng": 11.436153261344584,
					"lat": 43.573162166796486
				},
				{
					"lng": 11.436156432564456,
					"lat": 43.57315966634058
				},
				{
					"lng": 11.436159054728996,
					"lat": 43.57315757051676
				},
				{
					"lng": 11.436162214314772,
					"lat": 43.573155025245946
				},
				{
					"lng": 11.436164757375552,
					"lat": 43.573152992108234
				},
				{
					"lng": 11.436167963657036,
					"lat": 43.573150386490646
				},
				{
					"lng": 11.436171242036623,
					"lat": 43.57314760073315
				},
				{
					"lng": 11.43617302450394,
					"lat": 43.57314610588115
				},
				{
					"lng": 11.436174726295425,
					"lat": 43.573144634731094
				},
				{
					"lng": 11.436176996717055,
					"lat": 43.57314270082904
				},
				{
					"lng": 11.436182164014863,
					"lat": 43.57313811734758
				},
				{
					"lng": 11.436183620241907,
					"lat": 43.57313694818823
				},
				{
					"lng": 11.43618516968625,
					"lat": 43.57313563525835
				},
				{
					"lng": 11.436186493327975,
					"lat": 43.57313449585363
				},
				{
					"lng": 11.436188149328459,
					"lat": 43.573133126246695
				},
				{
					"lng": 11.436188823480508,
					"lat": 43.57313252495725
				},
				{
					"lng": 11.436190240598558,
					"lat": 43.57313130442476
				},
				{
					"lng": 11.43619094038086,
					"lat": 43.573130720174326
				},
				{
					"lng": 11.436192155441915,
					"lat": 43.57312966221933
				},
				{
					"lng": 11.436193530549914,
					"lat": 43.57312850578033
				},
				{
					"lng": 11.436193588328232,
					"lat": 43.57312845783698
				},
				{
					"lng": 11.436193643152187,
					"lat": 43.57312841160524
				},
				{
					"lng": 11.436193691334372,
					"lat": 43.573128369361946
				},
				{
					"lng": 11.436193787142862,
					"lat": 43.57312828983313
				},
				{
					"lng": 11.436193918583047,
					"lat": 43.573128175472704
				},
				{
					"lng": 11.436194026720562,
					"lat": 43.573128083041446
				},
				{
					"lng": 11.436194131992302,
					"lat": 43.57312799451811
				},
				{
					"lng": 11.43619554155814,
					"lat": 43.57312677414658
				},
				{
					"lng": 11.436197535858847,
					"lat": 43.573125078039986
				},
				{
					"lng": 11.436198831287538,
					"lat": 43.57312397001126
				},
				{
					"lng": 11.436199818096455,
					"lat": 43.57312313729096
				},
				{
					"lng": 11.436200996145791,
					"lat": 43.573122136178746
				},
				{
					"lng": 11.436202220023075,
					"lat": 43.573121090675215
				},
				{
					"lng": 11.436203299621772,
					"lat": 43.573120159805846
				},
				{
					"lng": 11.436204947721759,
					"lat": 43.57311872552065
				},
				{
					"lng": 11.436207065285554,
					"lat": 43.573116937209655
				},
				{
					"lng": 11.436208592606619,
					"lat": 43.5731156192557
				},
				{
					"lng": 11.436208974090817,
					"lat": 43.57311525776351
				},
				{
					"lng": 11.436209470015427,
					"lat": 43.57311484766937
				},
				{
					"lng": 11.436209928397103,
					"lat": 43.57311448124032
				},
				{
					"lng": 11.436210536259512,
					"lat": 43.57311396049884
				},
				{
					"lng": 11.436213409823921,
					"lat": 43.5731113889018
				},
				{
					"lng": 11.436219564781808,
					"lat": 43.57310605016612
				},
				{
					"lng": 11.43623217974841,
					"lat": 43.573095383775005
				},
				{
					"lng": 11.436243929243794,
					"lat": 43.57308518536495
				},
				{
					"lng": 11.436256733707626,
					"lat": 43.573074176410074
				},
				{
					"lng": 11.436267069832159,
					"lat": 43.573064073529565
				},
				{
					"lng": 11.436302975208928,
					"lat": 43.573033237315755
				},
				{
					"lng": 11.43630700274017,
					"lat": 43.573029611261
				},
				{
					"lng": 11.436308790307326,
					"lat": 43.573027943191015
				},
				{
					"lng": 11.436310582392519,
					"lat": 43.57302638713214
				},
				{
					"lng": 11.436312822273944,
					"lat": 43.57302437089703
				},
				{
					"lng": 11.436326301018578,
					"lat": 43.57301160274711
				},
				{
					"lng": 11.436346769395001,
					"lat": 43.572992639997196
				},
				{
					"lng": 11.436386469219592,
					"lat": 43.572954631501766
				},
				{
					"lng": 11.43644135600826,
					"lat": 43.57289881698171
				},
				{
					"lng": 11.436492266384192,
					"lat": 43.57284645484888
				},
				{
					"lng": 11.43652183628198,
					"lat": 43.57281721765552
				},
				{
					"lng": 11.436550941460538,
					"lat": 43.572763158010275
				},
				{
					"lng": 11.436537712075694,
					"lat": 43.572738935296194
				},
				{
					"lng": 11.436515621221904,
					"lat": 43.57272357613556
				},
				{
					"lng": 11.436491156019805,
					"lat": 43.572706561809255
				},
				{
					"lng": 11.436465128595461,
					"lat": 43.57268846301279
				},
				{
					"lng": 11.43643494227523,
					"lat": 43.57266747215303
				},
				{
					"lng": 11.436419983342647,
					"lat": 43.57265392387522
				},
				{
					"lng": 11.43639755966065,
					"lat": 43.572635333860866
				},
				{
					"lng": 11.436333305981334,
					"lat": 43.572587714072725
				},
				{
					"lng": 11.436210110854072,
					"lat": 43.57250064168705
				},
				{
					"lng": 11.436128059289874,
					"lat": 43.57245897146248
				},
				{
					"lng": 11.436008328601933,
					"lat": 43.5724148127136
				},
				{
					"lng": 11.435963079013952,
					"lat": 43.57242777071978
				},
				{
					"lng": 11.435853408071281,
					"lat": 43.57247811277114
				},
				{
					"lng": 11.435756145829881,
					"lat": 43.57253466440066
				},
				{
					"lng": 11.435706629516373,
					"lat": 43.57255090612652
				},
				{
					"lng": 11.435623459691671,
					"lat": 43.57253675483496
				},
				{
					"lng": 11.43557767291187,
					"lat": 43.57240079814678
				},
				{
					"lng": 11.435509475375316,
					"lat": 43.57249783224737
				},
				{
					"lng": 11.43546373196961,
					"lat": 43.572516486738984
				},
				{
					"lng": 11.435415532559508,
					"lat": 43.572544133033446
				},
				{
					"lng": 11.435354071258306,
					"lat": 43.57262035446772
				},
				{
					"lng": 11.435307726038557,
					"lat": 43.57264122045929
				},
				{
					"lng": 11.435262537043595,
					"lat": 43.572657845119124
				},
				{
					"lng": 11.435216022272078,
					"lat": 43.5726793252333
				},
				{
					"lng": 11.435164506049338,
					"lat": 43.57271912169306
				},
				{
					"lng": 11.435116396585197,
					"lat": 43.572746437864836
				},
				{
					"lng": 11.435070240545429,
					"lat": 43.572766601254635
				},
				{
					"lng": 11.43502536819692,
					"lat": 43.57278206612391
				},
				{
					"lng": 11.43497819786822,
					"lat": 43.57280594459393
				},
				{
					"lng": 11.434930144405577,
					"lat": 43.57283306000839
				},
				{
					"lng": 11.434885542068432,
					"lat": 43.57284753757874
				},
				{
					"lng": 11.43484434517525,
					"lat": 43.572849537101355
				},
				{
					"lng": 11.434804369973321,
					"lat": 43.5728470614477
				},
				{
					"lng": 11.434764262412681,
					"lat": 43.57284507110225
				},
				{
					"lng": 11.434724133852795,
					"lat": 43.572843159775296
				},
				{
					"lng": 11.434683920913299,
					"lat": 43.572841555230475
				},
				{
					"lng": 11.43464471180347,
					"lat": 43.572836276996256
				},
				{
					"lng": 11.434606106377379,
					"lat": 43.572828780006056
				},
				{
					"lng": 11.434565702037167,
					"lat": 43.57282788346684
				},
				{
					"lng": 11.434524253972535,
					"lat": 43.572830796076424
				},
				{
					"lng": 11.434482388897923,
					"lat": 43.5728352518897
				},
				{
					"lng": 11.4344400689451,
					"lat": 43.57284136162229
				},
				{
					"lng": 11.434396902370166,
					"lat": 43.572850582774116
				},
				{
					"lng": 11.434353804009426,
					"lat": 43.57285954636766
				},
				{
					"lng": 11.43431078066304,
					"lat": 43.57286823357353
				},
				{
					"lng": 11.43426783957661,
					"lat": 43.57287661785924
				},
				{
					"lng": 11.434224989638981,
					"lat": 43.57288467595452
				},
				{
					"lng": 11.434181714656347,
					"lat": 43.572894284566644
				},
				{
					"lng": 11.434137989999185,
					"lat": 43.57290554533637
				},
				{
					"lng": 11.434093937853254,
					"lat": 43.57291800173486
				},
				{
					"lng": 11.43404887335478,
					"lat": 43.572934165490295
				},
				{
					"lng": 11.4340020666063,
					"lat": 43.57295670645932
				},
				{
					"lng": 11.433950379024152,
					"lat": 43.572997134153674
				},
				{
					"lng": 11.433894621926708,
					"lat": 43.57305245603986
				},
				{
					"lng": 11.433838850591751,
					"lat": 43.57310783975106
				},
				{
					"lng": 11.433783564253671,
					"lat": 43.57316143751964
				},
				{
					"lng": 11.433732764474533,
					"lat": 43.57319860113267
				},
				{
					"lng": 11.43367609044352,
					"lat": 43.57325728808069
				},
				{
					"lng": 11.433628647094835,
					"lat": 43.57328216044248
				},
				{
					"lng": 11.433579424888437,
					"lat": 43.573313553671035
				},
				{
					"lng": 11.433530507535858,
					"lat": 43.57334382865306
				},
				{
					"lng": 11.433481549129453,
					"lat": 43.57337424901918
				},
				{
					"lng": 11.433431070560513,
					"lat": 43.57341023896946
				},
				{
					"lng": 11.433379664648907,
					"lat": 43.57344962835739
				},
				{
					"lng": 11.433325413672637,
					"lat": 43.573499431216824
				},
				{
					"lng": 11.433229346632107,
					"lat": 43.57370237473995
				},
				{
					"lng": 11.433191103115856,
					"lat": 43.57369717271481
				},
				{
					"lng": 11.433139532836021,
					"lat": 43.57373354243926
				},
				{
					"lng": 11.433094337955751,
					"lat": 43.57375018724917
				},
				{
					"lng": 11.433047720644767,
					"lat": 43.573772032463005
				},
				{
					"lng": 11.43298360736541,
					"lat": 43.573857954176724
				},
				{
					"lng": 11.432931595993692,
					"lat": 43.573899554989254
				},
				{
					"lng": 11.43288570587735,
					"lat": 43.573918741334516
				},
				{
					"lng": 11.432841169258733,
					"lat": 43.57393296831216
				},
				{
					"lng": 11.432797214657098,
					"lat": 43.57394505668524
				},
				{
					"lng": 11.4327534166852,
					"lat": 43.57395658666468
				},
				{
					"lng": 11.43270945738026,
					"lat": 43.57396869049144
				},
				{
					"lng": 11.432689412012992,
					"lat": 43.57396867269195
				},
				{
					"lng": 11.43264451709165,
					"lat": 43.57396693080835
				},
				{
					"lng": 11.43257957378433,
					"lat": 43.57396517115257
				},
				{
					"lng": 11.432532517400864,
					"lat": 43.57396013345033
				},
				{
					"lng": 11.432485459866438,
					"lat": 43.57395176385326
				},
				{
					"lng": 11.4324569774534,
					"lat": 43.57394213326142
				},
				{
					"lng": 11.432427629088243,
					"lat": 43.57392746032434
				},
				{
					"lng": 11.432407442140233,
					"lat": 43.57390855538083
				},
				{
					"lng": 11.432382176388618,
					"lat": 43.573892441987034
				},
				{
					"lng": 11.432249673141548,
					"lat": 43.57385446102878
				},
				{
					"lng": 11.432167942911837,
					"lat": 43.573843123779035
				},
				{
					"lng": 11.432093145582002,
					"lat": 43.573821522299966
				},
				{
					"lng": 11.431979859570168,
					"lat": 43.573800040970205
				},
				{
					"lng": 11.431917719978301,
					"lat": 43.57378825798446
				},
				{
					"lng": 11.431880152160455,
					"lat": 43.573785437710306
				},
				{
					"lng": 11.431833149392885,
					"lat": 43.57379039977357
				},
				{
					"lng": 11.431753847800348,
					"lat": 43.57379877222732
				},
				{
					"lng": 11.431643329551024,
					"lat": 43.57380016807767
				},
				{
					"lng": 11.431591403292728,
					"lat": 43.57380175564264
				},
				{
					"lng": 11.431542910008867,
					"lat": 43.573806175030306
				},
				{
					"lng": 11.43149888393997,
					"lat": 43.573814276915776
				},
				{
					"lng": 11.43148146298425,
					"lat": 43.573822427018044
				},
				{
					"lng": 11.431442807772566,
					"lat": 43.57384051140563
				},
				{
					"lng": 11.431406881934869,
					"lat": 43.57385731880629
				},
				{
					"lng": 11.4313759284977,
					"lat": 43.57387685824445
				},
				{
					"lng": 11.431308321210793,
					"lat": 43.57390693262486
				},
				{
					"lng": 11.431253960658697,
					"lat": 43.5739197221323
				},
				{
					"lng": 11.43117136933575,
					"lat": 43.573937014626644
				},
				{
					"lng": 11.431130010428948,
					"lat": 43.57393827821635
				},
				{
					"lng": 11.431062197148687,
					"lat": 43.57393691178672
				},
				{
					"lng": 11.430986166902896,
					"lat": 43.573936840665354
				},
				{
					"lng": 11.43090476071879,
					"lat": 43.57393676296716
				},
				{
					"lng": 11.430868910448714,
					"lat": 43.573933104580426
				},
				{
					"lng": 11.430633323182313,
					"lat": 43.57405148290486
				},
				{
					"lng": 11.43036978972288,
					"lat": 43.57427217072468
				},
				{
					"lng": 11.430110841795889,
					"lat": 43.57447606573657
				},
				{
					"lng": 11.429942428941393,
					"lat": 43.57459300294259
				},
				{
					"lng": 11.429860016402047,
					"lat": 43.574650224026485
				},
				{
					"lng": 11.429677949520354,
					"lat": 43.57489760083094
				},
				{
					"lng": 11.429523315986186,
					"lat": 43.575107705759116
				},
				{
					"lng": 11.429522541988398,
					"lat": 43.57511123876399
				},
				{
					"lng": 11.429489282855085,
					"lat": 43.57526338774282
				},
				{
					"lng": 11.429517076840682,
					"lat": 43.57536433919111
				},
				{
					"lng": 11.429591322725662,
					"lat": 43.57563400281241
				},
				{
					"lng": 11.42974331221958,
					"lat": 43.57582173545255
				},
				{
					"lng": 11.429888648758231,
					"lat": 43.576033838313975
				},
				{
					"lng": 11.430025351293564,
					"lat": 43.576242602563646
				},
				{
					"lng": 11.430050540210866,
					"lat": 43.576318526877024
				},
				{
					"lng": 11.43011204478018,
					"lat": 43.5765039024107
				},
				{
					"lng": 11.430142075994233,
					"lat": 43.5765944180302
				},
				{
					"lng": 11.43018415394353,
					"lat": 43.576608028358145
				},
				{
					"lng": 11.43021511398427,
					"lat": 43.57661351764078
				},
				{
					"lng": 11.430282259905328,
					"lat": 43.576640170194736
				},
				{
					"lng": 11.430340071146354,
					"lat": 43.57666311728428
				},
				{
					"lng": 11.430373656322041,
					"lat": 43.57668473812035
				},
				{
					"lng": 11.430411632958746,
					"lat": 43.57670918747338
				},
				{
					"lng": 11.430442985651926,
					"lat": 43.57672937145137
				},
				{
					"lng": 11.430471470120647,
					"lat": 43.57673405053495
				},
				{
					"lng": 11.4305070094638,
					"lat": 43.576726260913645
				},
				{
					"lng": 11.430542549552584,
					"lat": 43.57671847126544
				},
				{
					"lng": 11.430567687571896,
					"lat": 43.57671711879998
				},
				{
					"lng": 11.43060818741546,
					"lat": 43.57675600924415
				},
				{
					"lng": 11.430645651080885,
					"lat": 43.576785852236256
				},
				{
					"lng": 11.430685654423076,
					"lat": 43.57681272364759
				},
				{
					"lng": 11.430711476790039,
					"lat": 43.57682829800295
				},
				{
					"lng": 11.43074231503433,
					"lat": 43.57684134929084
				},
				{
					"lng": 11.430786276927591,
					"lat": 43.576856291533744
				},
				{
					"lng": 11.430830241840923,
					"lat": 43.57687123314584
				},
				{
					"lng": 11.430853896488403,
					"lat": 43.576883655776626
				},
				{
					"lng": 11.430898858529293,
					"lat": 43.576909584658125
				},
				{
					"lng": 11.430947276365863,
					"lat": 43.57694027820235
				},
				{
					"lng": 11.430992232726785,
					"lat": 43.57695787659659
				},
				{
					"lng": 11.431056816350303,
					"lat": 43.57697848819037
				},
				{
					"lng": 11.431115168464045,
					"lat": 43.576993768747805
				},
				{
					"lng": 11.431164867288228,
					"lat": 43.577004453993055
				},
				{
					"lng": 11.43121477247468,
					"lat": 43.577000399293944
				},
				{
					"lng": 11.431261274186793,
					"lat": 43.57699571467347
				},
				{
					"lng": 11.43131588477346,
					"lat": 43.57698769704656
				},
				{
					"lng": 11.431373961136503,
					"lat": 43.57698056185442
				},
				{
					"lng": 11.43143173209076,
					"lat": 43.576973463906384
				},
				{
					"lng": 11.431488082861215,
					"lat": 43.57696943019572
				},
				{
					"lng": 11.431542688797252,
					"lat": 43.57696265013733
				},
				{
					"lng": 11.431568693482236,
					"lat": 43.57696201924658
				},
				{
					"lng": 11.43159420419698,
					"lat": 43.57695625401077
				},
				{
					"lng": 11.431621630832733,
					"lat": 43.5769436484605
				},
				{
					"lng": 11.43164905814578,
					"lat": 43.576931041240584
				},
				{
					"lng": 11.431671842331491,
					"lat": 43.57691384355144
				},
				{
					"lng": 11.431689051147465,
					"lat": 43.57689439651907
				},
				{
					"lng": 11.43172693773846,
					"lat": 43.57683281094566
				},
				{
					"lng": 11.431753311774678,
					"lat": 43.57681687498424
				},
				{
					"lng": 11.431786375408596,
					"lat": 43.57680750770055
				},
				{
					"lng": 11.431932501525376,
					"lat": 43.5768022747109
				},
				{
					"lng": 11.43197185191918,
					"lat": 43.57681862366783
				},
				{
					"lng": 11.432008686847665,
					"lat": 43.57683261089713
				},
				{
					"lng": 11.432046499896959,
					"lat": 43.57684301238877
				},
				{
					"lng": 11.432084666629827,
					"lat": 43.576852116554555
				},
				{
					"lng": 11.43212339278525,
					"lat": 43.576859176028364
				},
				{
					"lng": 11.432171582540626,
					"lat": 43.576831581894176
				},
				{
					"lng": 11.432220638850675,
					"lat": 43.57680080555604
				},
				{
					"lng": 11.432271163985959,
					"lat": 43.57676466568288
				},
				{
					"lng": 11.432325688690572,
					"lat": 43.57671387272563
				},
				{
					"lng": 11.432409707107066,
					"lat": 43.576703944806994
				},
				{
					"lng": 11.432445244773442,
					"lat": 43.576722675717626
				},
				{
					"lng": 11.432478488206463,
					"lat": 43.57674981130898
				},
				{
					"lng": 11.432502844684576,
					"lat": 43.57680949006964
				},
				{
					"lng": 11.43254140883915,
					"lat": 43.576817143612594
				},
				{
					"lng": 11.43258599550976,
					"lat": 43.57680273543612
				},
				{
					"lng": 11.432630836659845,
					"lat": 43.57678740188397
				},
				{
					"lng": 11.432675779297963,
					"lat": 43.576771698507045
				},
				{
					"lng": 11.432720862055177,
					"lat": 43.57675547720437
				},
				{
					"lng": 11.432766104756476,
					"lat": 43.57673866721177
				},
				{
					"lng": 11.432807314957763,
					"lat": 43.576736630232325
				},
				{
					"lng": 11.432846952173866,
					"lat": 43.5767403546503
				},
				{
					"lng": 11.432886040523085,
					"lat": 43.576746084494864
				},
				{
					"lng": 11.432919068871593,
					"lat": 43.576774011487124
				},
				{
					"lng": 11.432952051041635,
					"lat": 43.576802104866346
				},
				{
					"lng": 11.432990729555593,
					"lat": 43.57680933102307
				},
				{
					"lng": 11.433044406004498,
					"lat": 43.57675933669148
				},
				{
					"lng": 11.433101803589292,
					"lat": 43.57670172387076
				},
				{
					"lng": 11.433164408703204,
					"lat": 43.576620047056885
				},
				{
					"lng": 11.433215349873704,
					"lat": 43.57658226245741
				},
				{
					"lng": 11.43325341993548,
					"lat": 43.57659172494674
				},
				{
					"lng": 11.433296935482923,
					"lat": 43.576581245477506
				},
				{
					"lng": 11.433340383537004,
					"lat": 43.576571004833035
				},
				{
					"lng": 11.43338391212259,
					"lat": 43.57656047449476
				},
				{
					"lng": 11.433427477698308,
					"lat": 43.576549812010576
				},
				{
					"lng": 11.43347100371787,
					"lat": 43.57653929378378
				},
				{
					"lng": 11.433514540768625,
					"lat": 43.576528730792226
				},
				{
					"lng": 11.433558760538808,
					"lat": 43.57651567698806
				},
				{
					"lng": 11.4336040995649,
					"lat": 43.57649851015468
				},
				{
					"lng": 11.433652632112265,
					"lat": 43.57647141807356
				},
				{
					"lng": 11.433702966898725,
					"lat": 43.57643420286243
				},
				{
					"lng": 11.433754634598365,
					"lat": 43.57639386364399
				},
				{
					"lng": 11.433790125290527,
					"lat": 43.57641277373918
				},
				{
					"lng": 11.433833092283008,
					"lat": 43.57640429345879
				},
				{
					"lng": 11.433879180518419,
					"lat": 43.57638439524966
				},
				{
					"lng": 11.433925989071648,
					"lat": 43.5763618520994
				},
				{
					"lng": 11.433999800593675,
					"lat": 43.576177910110594
				},
				{
					"lng": 11.43408692542985,
					"lat": 43.57592133944389
				},
				{
					"lng": 11.43416194178503,
					"lat": 43.57580245993
				},
				{
					"lng": 11.434205285764534,
					"lat": 43.575787179087186
				},
				{
					"lng": 11.434236264708609,
					"lat": 43.57582106302959
				},
				{
					"lng": 11.434269428489484,
					"lat": 43.57584848446392
				}
			]
		]
	},
	"5": {
		"name": "SD - San Donato",
		"center": {
			"lat": 43.5758,
			"lng": 11.4399
		},
		"coords": [
			[
				{
					"lng": 11.4424872273467,
					"lat": 43.58053282546714
				},
				{
					"lng": 11.442496667571001,
					"lat": 43.58048065308122
				},
				{
					"lng": 11.442497310478041,
					"lat": 43.58047538924737
				},
				{
					"lng": 11.442519655495996,
					"lat": 43.58042754731505
				},
				{
					"lng": 11.442534677453791,
					"lat": 43.58040963014575
				},
				{
					"lng": 11.442534166835518,
					"lat": 43.580407478359035
				},
				{
					"lng": 11.442558481824499,
					"lat": 43.58036651369314
				},
				{
					"lng": 11.442554279768412,
					"lat": 43.58031397926561
				},
				{
					"lng": 11.442571274950634,
					"lat": 43.58024867185286
				},
				{
					"lng": 11.44257617616303,
					"lat": 43.58024362851597
				},
				{
					"lng": 11.442576770372897,
					"lat": 43.5802371304071
				},
				{
					"lng": 11.442574550680545,
					"lat": 43.58023470542726
				},
				{
					"lng": 11.44260208399631,
					"lat": 43.58016623300186
				},
				{
					"lng": 11.442599381453636,
					"lat": 43.58016222017792
				},
				{
					"lng": 11.442608672877256,
					"lat": 43.58013934828618
				},
				{
					"lng": 11.442602845223375,
					"lat": 43.58013355199861
				},
				{
					"lng": 11.442599893797222,
					"lat": 43.58011031247033
				},
				{
					"lng": 11.442594648247981,
					"lat": 43.580106353109855
				},
				{
					"lng": 11.442593383102853,
					"lat": 43.58010009193197
				},
				{
					"lng": 11.442581292682014,
					"lat": 43.5800903571279
				},
				{
					"lng": 11.442564824311901,
					"lat": 43.580073279709445
				},
				{
					"lng": 11.442525947599323,
					"lat": 43.580043349455195
				},
				{
					"lng": 11.442499327234694,
					"lat": 43.580028327615054
				},
				{
					"lng": 11.442487178296002,
					"lat": 43.580017114734474
				},
				{
					"lng": 11.442472514993094,
					"lat": 43.580006693909574
				},
				{
					"lng": 11.442459974563587,
					"lat": 43.57999844802945
				},
				{
					"lng": 11.442430465312125,
					"lat": 43.579973855708175
				},
				{
					"lng": 11.442419769674375,
					"lat": 43.57997370888479
				},
				{
					"lng": 11.442409728672038,
					"lat": 43.579964301208115
				},
				{
					"lng": 11.442406981323558,
					"lat": 43.57995918007434
				},
				{
					"lng": 11.442397173305118,
					"lat": 43.57995568558588
				},
				{
					"lng": 11.44236133501847,
					"lat": 43.57992637190949
				},
				{
					"lng": 11.442354127352981,
					"lat": 43.57992430295083
				},
				{
					"lng": 11.442352848520342,
					"lat": 43.579917672008214
				},
				{
					"lng": 11.442346222947476,
					"lat": 43.57991743997819
				},
				{
					"lng": 11.442344071451162,
					"lat": 43.5799145264327
				},
				{
					"lng": 11.44232365409135,
					"lat": 43.57990015708559
				},
				{
					"lng": 11.44230819197659,
					"lat": 43.579882355827145
				},
				{
					"lng": 11.442306013013633,
					"lat": 43.57987870185878
				},
				{
					"lng": 11.442303367845666,
					"lat": 43.57987616801891
				},
				{
					"lng": 11.442301187682169,
					"lat": 43.57987251497649
				},
				{
					"lng": 11.442293529974782,
					"lat": 43.579871934951086
				},
				{
					"lng": 11.44228916961318,
					"lat": 43.57986462796618
				},
				{
					"lng": 11.442276839896733,
					"lat": 43.57986502026837
				},
				{
					"lng": 11.44227496796333,
					"lat": 43.57986188375534
				},
				{
					"lng": 11.442270600886998,
					"lat": 43.57986197440035
				},
				{
					"lng": 11.442267805176106,
					"lat": 43.57985758630233
				},
				{
					"lng": 11.442257299292566,
					"lat": 43.57985716979686
				},
				{
					"lng": 11.442252304710157,
					"lat": 43.57985237130807
				},
				{
					"lng": 11.442248592789966,
					"lat": 43.57984704119206
				},
				{
					"lng": 11.442242763713788,
					"lat": 43.57984350485924
				},
				{
					"lng": 11.442234871582754,
					"lat": 43.579843191849946
				},
				{
					"lng": 11.442215521085423,
					"lat": 43.57983532560286
				},
				{
					"lng": 11.442188296769961,
					"lat": 43.57982205612441
				},
				{
					"lng": 11.442165063490235,
					"lat": 43.579816914562585
				},
				{
					"lng": 11.442159777085562,
					"lat": 43.57981050433189
				},
				{
					"lng": 11.442150198481249,
					"lat": 43.57980625040367
				},
				{
					"lng": 11.442145111861633,
					"lat": 43.57979935960332
				},
				{
					"lng": 11.442137679805148,
					"lat": 43.579794712248976
				},
				{
					"lng": 11.442126508666622,
					"lat": 43.57978890139325
				},
				{
					"lng": 11.442113417643037,
					"lat": 43.57978440290183
				},
				{
					"lng": 11.442094279768956,
					"lat": 43.579776372722996
				},
				{
					"lng": 11.44208006528928,
					"lat": 43.5797720242924
				},
				{
					"lng": 11.442062231479795,
					"lat": 43.57976380776989
				},
				{
					"lng": 11.442059963777204,
					"lat": 43.57976178717426
				},
				{
					"lng": 11.44205389640962,
					"lat": 43.57975777872558
				},
				{
					"lng": 11.442044360855688,
					"lat": 43.579743778200985
				},
				{
					"lng": 11.442042380432172,
					"lat": 43.57974350179548
				},
				{
					"lng": 11.44204074933388,
					"lat": 43.579740991294564
				},
				{
					"lng": 11.442027128390434,
					"lat": 43.57972884012056
				},
				{
					"lng": 11.442012381196166,
					"lat": 43.57971006284047
				},
				{
					"lng": 11.442008343853173,
					"lat": 43.57969647062052
				},
				{
					"lng": 11.442004001800987,
					"lat": 43.57969178962925
				},
				{
					"lng": 11.442002440570768,
					"lat": 43.57968589222158
				},
				{
					"lng": 11.442002588932787,
					"lat": 43.57966187512836
				},
				{
					"lng": 11.442000894828917,
					"lat": 43.579657775909794
				},
				{
					"lng": 11.442002240168453,
					"lat": 43.579642103127235
				},
				{
					"lng": 11.441999247176701,
					"lat": 43.579638348601506
				},
				{
					"lng": 11.441998440007092,
					"lat": 43.579595848307505
				},
				{
					"lng": 11.441997314259773,
					"lat": 43.579589510312275
				},
				{
					"lng": 11.44199298965414,
					"lat": 43.57957417390053
				},
				{
					"lng": 11.441992741353383,
					"lat": 43.57956855455978
				},
				{
					"lng": 11.44198010071819,
					"lat": 43.57955323291359
				},
				{
					"lng": 11.44197327072227,
					"lat": 43.57954653603074
				},
				{
					"lng": 11.441961299739706,
					"lat": 43.57953708492655
				},
				{
					"lng": 11.441955901089532,
					"lat": 43.57953338001313
				},
				{
					"lng": 11.441944689260993,
					"lat": 43.5795272044563
				},
				{
					"lng": 11.441935229449413,
					"lat": 43.57952040440924
				},
				{
					"lng": 11.441926337996223,
					"lat": 43.57951136558512
				},
				{
					"lng": 11.441886701838335,
					"lat": 43.57947810464306
				},
				{
					"lng": 11.44186142168186,
					"lat": 43.57944215718741
				},
				{
					"lng": 11.441851154941327,
					"lat": 43.57942042453839
				},
				{
					"lng": 11.441843075847402,
					"lat": 43.57941021856652
				},
				{
					"lng": 11.441832456011271,
					"lat": 43.579374148674205
				},
				{
					"lng": 11.441836045757666,
					"lat": 43.579359705560705
				},
				{
					"lng": 11.44182674746835,
					"lat": 43.57934590343121
				},
				{
					"lng": 11.441823082862765,
					"lat": 43.57930841806807
				},
				{
					"lng": 11.441852457783513,
					"lat": 43.57929298001041
				},
				{
					"lng": 11.441855756682987,
					"lat": 43.57928782238524
				},
				{
					"lng": 11.44185235134722,
					"lat": 43.57928471233308
				},
				{
					"lng": 11.441849201123707,
					"lat": 43.57928255122714
				},
				{
					"lng": 11.441841260471872,
					"lat": 43.579275400872916
				},
				{
					"lng": 11.441836392629872,
					"lat": 43.57927407150597
				},
				{
					"lng": 11.441823214368892,
					"lat": 43.579268882455956
				},
				{
					"lng": 11.441801232988189,
					"lat": 43.579260911194766
				},
				{
					"lng": 11.441767780539001,
					"lat": 43.57924506818448
				},
				{
					"lng": 11.441737326225928,
					"lat": 43.579233138053496
				},
				{
					"lng": 11.441716208462646,
					"lat": 43.57922159183551
				},
				{
					"lng": 11.441671564208974,
					"lat": 43.579205027264926
				},
				{
					"lng": 11.441668858487605,
					"lat": 43.5792030160216
				},
				{
					"lng": 11.441627628319777,
					"lat": 43.57918012896704
				},
				{
					"lng": 11.441625347814211,
					"lat": 43.579177790803435
				},
				{
					"lng": 11.441606015649366,
					"lat": 43.579170401259006
				},
				{
					"lng": 11.44160059261188,
					"lat": 43.579166061184246
				},
				{
					"lng": 11.441579008042199,
					"lat": 43.57915803908283
				},
				{
					"lng": 11.441560576436823,
					"lat": 43.57915126595207
				},
				{
					"lng": 11.441559375752929,
					"lat": 43.57914858688005
				},
				{
					"lng": 11.441552790628641,
					"lat": 43.579142522204954
				},
				{
					"lng": 11.441546124074202,
					"lat": 43.579139957229756
				},
				{
					"lng": 11.441527180637612,
					"lat": 43.57912092290766
				},
				{
					"lng": 11.441523356552617,
					"lat": 43.57911829899275
				},
				{
					"lng": 11.441511091903275,
					"lat": 43.57910197884545
				},
				{
					"lng": 11.441500869580224,
					"lat": 43.57909249032616
				},
				{
					"lng": 11.441491503760941,
					"lat": 43.57908807332885
				},
				{
					"lng": 11.441471342326265,
					"lat": 43.5790715977809
				},
				{
					"lng": 11.441459539985319,
					"lat": 43.579066436011686
				},
				{
					"lng": 11.44144042608121,
					"lat": 43.57905439583568
				},
				{
					"lng": 11.441427761717874,
					"lat": 43.57904957031523
				},
				{
					"lng": 11.441418308441076,
					"lat": 43.57904292855107
				},
				{
					"lng": 11.441395477139876,
					"lat": 43.57903004491346
				},
				{
					"lng": 11.441381804930042,
					"lat": 43.5790226532425
				},
				{
					"lng": 11.441373644104209,
					"lat": 43.57901550755975
				},
				{
					"lng": 11.441368526353395,
					"lat": 43.57901338758027
				},
				{
					"lng": 11.441354710685067,
					"lat": 43.57900201840951
				},
				{
					"lng": 11.441350581359767,
					"lat": 43.578997174381215
				},
				{
					"lng": 11.441346763691273,
					"lat": 43.578994708789374
				},
				{
					"lng": 11.441337109822827,
					"lat": 43.57898298237988
				},
				{
					"lng": 11.441319349107976,
					"lat": 43.57895450842132
				},
				{
					"lng": 11.441308338964976,
					"lat": 43.57893613109948
				},
				{
					"lng": 11.441301861954862,
					"lat": 43.57891616589725
				},
				{
					"lng": 11.441297068563891,
					"lat": 43.57888334607
				},
				{
					"lng": 11.44129441722897,
					"lat": 43.578832621518295
				},
				{
					"lng": 11.441293711083182,
					"lat": 43.57882557045592
				},
				{
					"lng": 11.441293991337993,
					"lat": 43.57879932481268
				},
				{
					"lng": 11.441291811162081,
					"lat": 43.57879952896088
				},
				{
					"lng": 11.441293080269602,
					"lat": 43.5787757472269
				},
				{
					"lng": 11.441292460767572,
					"lat": 43.57875444946579
				},
				{
					"lng": 11.441292066381141,
					"lat": 43.578738873285566
				},
				{
					"lng": 11.441292745486406,
					"lat": 43.57872255476835
				},
				{
					"lng": 11.441294295027802,
					"lat": 43.578711867511984
				},
				{
					"lng": 11.441302278693083,
					"lat": 43.578692299230894
				},
				{
					"lng": 11.441307713655467,
					"lat": 43.57868005594164
				},
				{
					"lng": 11.441311706485585,
					"lat": 43.57866470565535
				},
				{
					"lng": 11.441317097250678,
					"lat": 43.5786515530299
				},
				{
					"lng": 11.44132373598837,
					"lat": 43.57862494103064
				},
				{
					"lng": 11.441327984292778,
					"lat": 43.5786049735595
				},
				{
					"lng": 11.441329626834882,
					"lat": 43.578591103287195
				},
				{
					"lng": 11.441329300382813,
					"lat": 43.57857705449358
				},
				{
					"lng": 11.441333361010527,
					"lat": 43.57856901831226
				},
				{
					"lng": 11.441335597253813,
					"lat": 43.57855911141451
				},
				{
					"lng": 11.441353413156866,
					"lat": 43.57852750030575
				},
				{
					"lng": 11.441356936284846,
					"lat": 43.57852249726991
				},
				{
					"lng": 11.441363546447914,
					"lat": 43.57850136736727
				},
				{
					"lng": 11.441368343929907,
					"lat": 43.57849538270349
				},
				{
					"lng": 11.441372339507929,
					"lat": 43.57847722138228
				},
				{
					"lng": 11.441376450528752,
					"lat": 43.57847052388201
				},
				{
					"lng": 11.441373543043982,
					"lat": 43.57846333707958
				},
				{
					"lng": 11.44138619001973,
					"lat": 43.57843762222586
				},
				{
					"lng": 11.441394242742495,
					"lat": 43.57841654703354
				},
				{
					"lng": 11.441399683910047,
					"lat": 43.57838283054059
				},
				{
					"lng": 11.44140000134984,
					"lat": 43.5783813696506
				},
				{
					"lng": 11.441390123805986,
					"lat": 43.57836499668144
				},
				{
					"lng": 11.44139146101582,
					"lat": 43.57836262893226
				},
				{
					"lng": 11.441377555394393,
					"lat": 43.578354729032775
				},
				{
					"lng": 11.441378880749083,
					"lat": 43.57835203740169
				},
				{
					"lng": 11.441379205977288,
					"lat": 43.57834804268735
				},
				{
					"lng": 11.441377326386831,
					"lat": 43.578344959444486
				},
				{
					"lng": 11.441373562882864,
					"lat": 43.57834361816583
				},
				{
					"lng": 11.441357239342238,
					"lat": 43.57833089889358
				},
				{
					"lng": 11.441319692295927,
					"lat": 43.57830125043582
				},
				{
					"lng": 11.441309001464072,
					"lat": 43.57828770490998
				},
				{
					"lng": 11.441283224047247,
					"lat": 43.578263637599456
				},
				{
					"lng": 11.441267849664165,
					"lat": 43.578255156812666
				},
				{
					"lng": 11.441260516771619,
					"lat": 43.57824750272616
				},
				{
					"lng": 11.441256449993265,
					"lat": 43.578243989913865
				},
				{
					"lng": 11.441248106551036,
					"lat": 43.57824047303659
				},
				{
					"lng": 11.441236734829323,
					"lat": 43.57820962421984
				},
				{
					"lng": 11.441243952954451,
					"lat": 43.578203379855104
				},
				{
					"lng": 11.441227600285591,
					"lat": 43.578187334296956
				},
				{
					"lng": 11.441225911592309,
					"lat": 43.57816461697533
				},
				{
					"lng": 11.44122578445162,
					"lat": 43.5781371159061
				},
				{
					"lng": 11.44123037372475,
					"lat": 43.578128217577756
				},
				{
					"lng": 11.441259114447387,
					"lat": 43.578103964134215
				},
				{
					"lng": 11.441258960946294,
					"lat": 43.57810004447567
				},
				{
					"lng": 11.441256661938159,
					"lat": 43.57809409168986
				},
				{
					"lng": 11.441258839524695,
					"lat": 43.57807666790656
				},
				{
					"lng": 11.441258616520662,
					"lat": 43.57806294103675
				},
				{
					"lng": 11.44126148570671,
					"lat": 43.57805515000556
				},
				{
					"lng": 11.441261359131369,
					"lat": 43.57804788307404
				},
				{
					"lng": 11.441268416161227,
					"lat": 43.57802592068406
				},
				{
					"lng": 11.441266578468484,
					"lat": 43.57802074857202
				},
				{
					"lng": 11.441268086150549,
					"lat": 43.57801236537117
				},
				{
					"lng": 11.441271572782545,
					"lat": 43.578005234628534
				},
				{
					"lng": 11.44127238728352,
					"lat": 43.57800075136073
				},
				{
					"lng": 11.44127504068379,
					"lat": 43.57799767120511
				},
				{
					"lng": 11.44127545463051,
					"lat": 43.577993052435446
				},
				{
					"lng": 11.441280199789238,
					"lat": 43.577980933730736
				},
				{
					"lng": 11.441288085893195,
					"lat": 43.57796786914855
				},
				{
					"lng": 11.44129032983908,
					"lat": 43.57796045072564
				},
				{
					"lng": 11.441302413081704,
					"lat": 43.57791647299217
				},
				{
					"lng": 11.441304951800479,
					"lat": 43.577908472930396
				},
				{
					"lng": 11.441307400159907,
					"lat": 43.57790623360431
				},
				{
					"lng": 11.441319687674044,
					"lat": 43.5778752745431
				},
				{
					"lng": 11.441321505894376,
					"lat": 43.57787316392875
				},
				{
					"lng": 11.441323387778974,
					"lat": 43.577864601660146
				},
				{
					"lng": 11.44133191310929,
					"lat": 43.5778435766978
				},
				{
					"lng": 11.441337457578797,
					"lat": 43.57782647713881
				},
				{
					"lng": 11.441341376311533,
					"lat": 43.57780923404176
				},
				{
					"lng": 11.44135234884049,
					"lat": 43.57778888249215
				},
				{
					"lng": 11.441357047936483,
					"lat": 43.577780281637004
				},
				{
					"lng": 11.441366246942586,
					"lat": 43.57777040694051
				},
				{
					"lng": 11.441383696251906,
					"lat": 43.57774695025945
				},
				{
					"lng": 11.441392338611243,
					"lat": 43.577735315514694
				},
				{
					"lng": 11.441394616651047,
					"lat": 43.577731252962955
				},
				{
					"lng": 11.441395122165021,
					"lat": 43.57772758213289
				},
				{
					"lng": 11.441401504602128,
					"lat": 43.577717578536706
				},
				{
					"lng": 11.441403930871116,
					"lat": 43.577704744955525
				},
				{
					"lng": 11.441407713976636,
					"lat": 43.577695022894
				},
				{
					"lng": 11.441410521126532,
					"lat": 43.57769182510215
				},
				{
					"lng": 11.441420420664501,
					"lat": 43.57766401884957
				},
				{
					"lng": 11.441425788610784,
					"lat": 43.577626624079514
				},
				{
					"lng": 11.441425281404468,
					"lat": 43.5775847917404
				},
				{
					"lng": 11.44142709214048,
					"lat": 43.57755354691537
				},
				{
					"lng": 11.441434122281448,
					"lat": 43.577539040202275
				},
				{
					"lng": 11.44144153166449,
					"lat": 43.57751485984806
				},
				{
					"lng": 11.441441266794605,
					"lat": 43.577470658843005
				},
				{
					"lng": 11.44144120613151,
					"lat": 43.577453657437296
				},
				{
					"lng": 11.44143985378647,
					"lat": 43.57740372536498
				},
				{
					"lng": 11.44143954536178,
					"lat": 43.577360683173545
				},
				{
					"lng": 11.441435561061423,
					"lat": 43.57733559019118
				},
				{
					"lng": 11.441434727104086,
					"lat": 43.57729281313468
				},
				{
					"lng": 11.44143455708323,
					"lat": 43.57727445449731
				},
				{
					"lng": 11.44144497677385,
					"lat": 43.577229678542686
				},
				{
					"lng": 11.441452846845307,
					"lat": 43.57720632569272
				},
				{
					"lng": 11.44148382001897,
					"lat": 43.577160690076084
				},
				{
					"lng": 11.44148670801095,
					"lat": 43.57715740952091
				},
				{
					"lng": 11.441504947063066,
					"lat": 43.57713302926578
				},
				{
					"lng": 11.441521067525194,
					"lat": 43.577121066346685
				},
				{
					"lng": 11.441525022882118,
					"lat": 43.5771162188377
				},
				{
					"lng": 11.441551871214259,
					"lat": 43.57711149259593
				},
				{
					"lng": 11.441573362894664,
					"lat": 43.57709704870566
				},
				{
					"lng": 11.441587640206103,
					"lat": 43.577079166473744
				},
				{
					"lng": 11.441592905470962,
					"lat": 43.577057951845525
				},
				{
					"lng": 11.441593638140084,
					"lat": 43.57705147599046
				},
				{
					"lng": 11.441591790667623,
					"lat": 43.577029336503685
				},
				{
					"lng": 11.441592222813444,
					"lat": 43.577027772319624
				},
				{
					"lng": 11.441593392501813,
					"lat": 43.57701985282671
				},
				{
					"lng": 11.441595235645687,
					"lat": 43.57698304027853
				},
				{
					"lng": 11.441601189127043,
					"lat": 43.57696255195277
				},
				{
					"lng": 11.44161020853993,
					"lat": 43.576940427854595
				},
				{
					"lng": 11.441612881457667,
					"lat": 43.57692888733946
				},
				{
					"lng": 11.441628841287333,
					"lat": 43.57689503339073
				},
				{
					"lng": 11.441636976937788,
					"lat": 43.57687975302684
				},
				{
					"lng": 11.441641144795833,
					"lat": 43.57687691511416
				},
				{
					"lng": 11.441645177465086,
					"lat": 43.57687061094093
				},
				{
					"lng": 11.441666216258291,
					"lat": 43.576844692412976
				},
				{
					"lng": 11.44168477685922,
					"lat": 43.57682514477887
				},
				{
					"lng": 11.441704379372027,
					"lat": 43.57679338468338
				},
				{
					"lng": 11.441706359165005,
					"lat": 43.5767706132796
				},
				{
					"lng": 11.441716571427968,
					"lat": 43.57675603134313
				},
				{
					"lng": 11.441721661611966,
					"lat": 43.57673005926046
				},
				{
					"lng": 11.441726255844513,
					"lat": 43.576716631912646
				},
				{
					"lng": 11.441727309098514,
					"lat": 43.57670218807943
				},
				{
					"lng": 11.441729711114604,
					"lat": 43.57669031931086
				},
				{
					"lng": 11.441739880525228,
					"lat": 43.576669562607755
				},
				{
					"lng": 11.441741543011934,
					"lat": 43.5766594662767
				},
				{
					"lng": 11.441743051700707,
					"lat": 43.57664927239017
				},
				{
					"lng": 11.441745442341352,
					"lat": 43.5766396034833
				},
				{
					"lng": 11.441750007412832,
					"lat": 43.57663225519716
				},
				{
					"lng": 11.441763431353298,
					"lat": 43.57661284343254
				},
				{
					"lng": 11.441770803793588,
					"lat": 43.576597648697714
				},
				{
					"lng": 11.441773621814479,
					"lat": 43.57658887103305
				},
				{
					"lng": 11.441777663229674,
					"lat": 43.576580701088595
				},
				{
					"lng": 11.441786204969926,
					"lat": 43.57654753146448
				},
				{
					"lng": 11.441791045330488,
					"lat": 43.57651412580881
				},
				{
					"lng": 11.441795225786295,
					"lat": 43.576500175178225
				},
				{
					"lng": 11.441800557325838,
					"lat": 43.57648973032306
				},
				{
					"lng": 11.441801016924053,
					"lat": 43.576466669069696
				},
				{
					"lng": 11.44180370667764,
					"lat": 43.57645818046496
				},
				{
					"lng": 11.441802659371401,
					"lat": 43.57643157332012
				},
				{
					"lng": 11.441811027265132,
					"lat": 43.57640794959579
				},
				{
					"lng": 11.441819872827244,
					"lat": 43.57637430077798
				},
				{
					"lng": 11.44182824894098,
					"lat": 43.576364786672166
				},
				{
					"lng": 11.441830942133297,
					"lat": 43.576356781495214
				},
				{
					"lng": 11.441838248441659,
					"lat": 43.57634788540012
				},
				{
					"lng": 11.44184691398734,
					"lat": 43.57633180766748
				},
				{
					"lng": 11.44187260525338,
					"lat": 43.576303650377554
				},
				{
					"lng": 11.441903794990862,
					"lat": 43.57626078587441
				},
				{
					"lng": 11.44192814428812,
					"lat": 43.576240207806876
				},
				{
					"lng": 11.441950396674056,
					"lat": 43.57621150813701
				},
				{
					"lng": 11.44197484563215,
					"lat": 43.57618123627975
				},
				{
					"lng": 11.441977468770576,
					"lat": 43.57617174427448
				},
				{
					"lng": 11.441994588121608,
					"lat": 43.576149853099444
				},
				{
					"lng": 11.442000975905088,
					"lat": 43.57613447500805
				},
				{
					"lng": 11.442019653969403,
					"lat": 43.57607343006836
				},
				{
					"lng": 11.442015653428868,
					"lat": 43.57607351286922
				},
				{
					"lng": 11.442017089390399,
					"lat": 43.57605187404951
				},
				{
					"lng": 11.442002542372531,
					"lat": 43.576045527574244
				},
				{
					"lng": 11.442010410495136,
					"lat": 43.576027495047605
				},
				{
					"lng": 11.442027769280966,
					"lat": 43.5759359069266
				},
				{
					"lng": 11.442040898454865,
					"lat": 43.57589775649449
				},
				{
					"lng": 11.442043505842896,
					"lat": 43.57583611503052
				},
				{
					"lng": 11.442052759761337,
					"lat": 43.57580402501975
				},
				{
					"lng": 11.442065167789412,
					"lat": 43.5757588220434
				},
				{
					"lng": 11.44208166428369,
					"lat": 43.575713292181995
				},
				{
					"lng": 11.442116264605009,
					"lat": 43.5756384318817
				},
				{
					"lng": 11.44213905479134,
					"lat": 43.575585889518706
				},
				{
					"lng": 11.44214232232964,
					"lat": 43.57556630222232
				},
				{
					"lng": 11.442142527657442,
					"lat": 43.575515823638284
				},
				{
					"lng": 11.442163903598363,
					"lat": 43.57547277805378
				},
				{
					"lng": 11.442172627345013,
					"lat": 43.57545293817899
				},
				{
					"lng": 11.442177876553083,
					"lat": 43.575446984341056
				},
				{
					"lng": 11.44220305651866,
					"lat": 43.575408737481304
				},
				{
					"lng": 11.442220697193767,
					"lat": 43.57538302383473
				},
				{
					"lng": 11.442232562081998,
					"lat": 43.5753593991614
				},
				{
					"lng": 11.442238206534954,
					"lat": 43.57534493641956
				},
				{
					"lng": 11.44223825871713,
					"lat": 43.575327667886924
				},
				{
					"lng": 11.442243601297095,
					"lat": 43.575314805263254
				},
				{
					"lng": 11.442244247204558,
					"lat": 43.57530336838272
				},
				{
					"lng": 11.442237413312823,
					"lat": 43.57529898285989
				},
				{
					"lng": 11.442237064019501,
					"lat": 43.57525922970678
				},
				{
					"lng": 11.442128834147892,
					"lat": 43.57525883108147
				},
				{
					"lng": 11.442108144342761,
					"lat": 43.57522745309377
				},
				{
					"lng": 11.442154933162266,
					"lat": 43.57508825158132
				},
				{
					"lng": 11.442111679762018,
					"lat": 43.57503967156803
				},
				{
					"lng": 11.44215020564117,
					"lat": 43.57496818389353
				},
				{
					"lng": 11.441793992036642,
					"lat": 43.574845711469166
				},
				{
					"lng": 11.442341379532271,
					"lat": 43.57464718134973
				},
				{
					"lng": 11.442337159663326,
					"lat": 43.57461984968682
				},
				{
					"lng": 11.442304931684646,
					"lat": 43.57459995596179
				},
				{
					"lng": 11.442304482420559,
					"lat": 43.574588539788024
				},
				{
					"lng": 11.44222921215569,
					"lat": 43.574553546567685
				},
				{
					"lng": 11.44217534979922,
					"lat": 43.57450325572362
				},
				{
					"lng": 11.442184145916451,
					"lat": 43.57448707703004
				},
				{
					"lng": 11.442156179981168,
					"lat": 43.57441568247082
				},
				{
					"lng": 11.442117712978437,
					"lat": 43.57435707350013
				},
				{
					"lng": 11.442064662604869,
					"lat": 43.574367317365
				},
				{
					"lng": 11.44160670343926,
					"lat": 43.573888402530095
				},
				{
					"lng": 11.441535198497442,
					"lat": 43.57387875771931
				},
				{
					"lng": 11.441531636616668,
					"lat": 43.57387167493671
				},
				{
					"lng": 11.44137419216024,
					"lat": 43.57384711846724
				},
				{
					"lng": 11.44154369274487,
					"lat": 43.57384438711317
				},
				{
					"lng": 11.441546284305055,
					"lat": 43.57379900678018
				},
				{
					"lng": 11.441568993937217,
					"lat": 43.573792172954384
				},
				{
					"lng": 11.441548125459953,
					"lat": 43.573762389640066
				},
				{
					"lng": 11.441549602065484,
					"lat": 43.57366749351221
				},
				{
					"lng": 11.441612981454837,
					"lat": 43.57366190830755
				},
				{
					"lng": 11.441640409932381,
					"lat": 43.573637873678756
				},
				{
					"lng": 11.441703843729723,
					"lat": 43.57360882254723
				},
				{
					"lng": 11.441767220750377,
					"lat": 43.57355346449064
				},
				{
					"lng": 11.441799298703792,
					"lat": 43.57352132881595
				},
				{
					"lng": 11.441829855671095,
					"lat": 43.57350220636617
				},
				{
					"lng": 11.441899209317086,
					"lat": 43.57342468109197
				},
				{
					"lng": 11.441918061794361,
					"lat": 43.5733816264456
				},
				{
					"lng": 11.441902809674046,
					"lat": 43.573367012458576
				},
				{
					"lng": 11.441907529782602,
					"lat": 43.57336264739908
				},
				{
					"lng": 11.441870294192508,
					"lat": 43.57333640306516
				},
				{
					"lng": 11.441878675433328,
					"lat": 43.57332521864428
				},
				{
					"lng": 11.441867530675639,
					"lat": 43.57331549595526
				},
				{
					"lng": 11.441875713618213,
					"lat": 43.573299682434445
				},
				{
					"lng": 11.441847136914676,
					"lat": 43.57326970195556
				},
				{
					"lng": 11.441826968053794,
					"lat": 43.573229592625374
				},
				{
					"lng": 11.4418526917602,
					"lat": 43.57318710604352
				},
				{
					"lng": 11.44187492303725,
					"lat": 43.5730306370825
				},
				{
					"lng": 11.441932656714929,
					"lat": 43.572981085414845
				},
				{
					"lng": 11.441971227637454,
					"lat": 43.57289211330557
				},
				{
					"lng": 11.441931166850777,
					"lat": 43.57283191223875
				},
				{
					"lng": 11.441911200412662,
					"lat": 43.57282152633108
				},
				{
					"lng": 11.441909501599488,
					"lat": 43.57279825278579
				},
				{
					"lng": 11.441875241228173,
					"lat": 43.572762580948066
				},
				{
					"lng": 11.441815788883078,
					"lat": 43.572742782688884
				},
				{
					"lng": 11.441734732626044,
					"lat": 43.57267209039089
				},
				{
					"lng": 11.441709672639986,
					"lat": 43.57263167858891
				},
				{
					"lng": 11.441699377598626,
					"lat": 43.572628481661745
				},
				{
					"lng": 11.441656068500604,
					"lat": 43.572581501713
				},
				{
					"lng": 11.441678446535786,
					"lat": 43.57257364492035
				},
				{
					"lng": 11.441649363645002,
					"lat": 43.57247078160615
				},
				{
					"lng": 11.441702913581857,
					"lat": 43.5723776637888
				},
				{
					"lng": 11.441938130419603,
					"lat": 43.57231006174595
				},
				{
					"lng": 11.441952324204673,
					"lat": 43.57230123093059
				},
				{
					"lng": 11.442082610751276,
					"lat": 43.57228332545786
				},
				{
					"lng": 11.442140392971723,
					"lat": 43.572273587303414
				},
				{
					"lng": 11.442160174493248,
					"lat": 43.57226464063383
				},
				{
					"lng": 11.442243614135567,
					"lat": 43.572224698321236
				},
				{
					"lng": 11.44224904262658,
					"lat": 43.57222052069063
				},
				{
					"lng": 11.442248865704137,
					"lat": 43.57221605320139
				},
				{
					"lng": 11.442234913264915,
					"lat": 43.572189811021886
				},
				{
					"lng": 11.442224566928395,
					"lat": 43.572182710304276
				},
				{
					"lng": 11.442168969660639,
					"lat": 43.57214850663357
				},
				{
					"lng": 11.442141138533957,
					"lat": 43.572123479465915
				},
				{
					"lng": 11.442092025972558,
					"lat": 43.572103225350894
				},
				{
					"lng": 11.442059198074876,
					"lat": 43.57207911619891
				},
				{
					"lng": 11.441994834715729,
					"lat": 43.572021114661595
				},
				{
					"lng": 11.441962771612978,
					"lat": 43.57198804659388
				},
				{
					"lng": 11.441935820614644,
					"lat": 43.57197207366189
				},
				{
					"lng": 11.44192902988628,
					"lat": 43.57196038333867
				},
				{
					"lng": 11.441905996219415,
					"lat": 43.57194968842322
				},
				{
					"lng": 11.441877902390807,
					"lat": 43.5719252952675
				},
				{
					"lng": 11.441806581333015,
					"lat": 43.571882739718085
				},
				{
					"lng": 11.4417213437606,
					"lat": 43.57183127066379
				},
				{
					"lng": 11.441687800375593,
					"lat": 43.57180633394051
				},
				{
					"lng": 11.441627325862537,
					"lat": 43.57176355189349
				},
				{
					"lng": 11.441587947858675,
					"lat": 43.57173206982899
				},
				{
					"lng": 11.44155812371088,
					"lat": 43.57170968449277
				},
				{
					"lng": 11.441518590497989,
					"lat": 43.571693416686635
				},
				{
					"lng": 11.44148179481421,
					"lat": 43.57167774944773
				},
				{
					"lng": 11.441435935260415,
					"lat": 43.571661613190834
				},
				{
					"lng": 11.441394536810176,
					"lat": 43.57165259811547
				},
				{
					"lng": 11.441371710748742,
					"lat": 43.571647156856024
				},
				{
					"lng": 11.441343359105838,
					"lat": 43.57163920185322
				},
				{
					"lng": 11.441328047231849,
					"lat": 43.571640834560455
				},
				{
					"lng": 11.441300315327453,
					"lat": 43.571648641807954
				},
				{
					"lng": 11.441195352563632,
					"lat": 43.571647539511766
				},
				{
					"lng": 11.441144356770922,
					"lat": 43.57166174662837
				},
				{
					"lng": 11.441112984072245,
					"lat": 43.57166897163897
				},
				{
					"lng": 11.441040298154936,
					"lat": 43.57168363040144
				},
				{
					"lng": 11.44100222397217,
					"lat": 43.57170272685997
				},
				{
					"lng": 11.440955605685852,
					"lat": 43.57173366571517
				},
				{
					"lng": 11.44092052407182,
					"lat": 43.57176436439839
				},
				{
					"lng": 11.44088916188019,
					"lat": 43.57180577463077
				},
				{
					"lng": 11.440865759681804,
					"lat": 43.571839827102124
				},
				{
					"lng": 11.440819658755236,
					"lat": 43.571883940868176
				},
				{
					"lng": 11.440762491422179,
					"lat": 43.5719402732254
				},
				{
					"lng": 11.440725384204761,
					"lat": 43.571961424304185
				},
				{
					"lng": 11.440677023141479,
					"lat": 43.571990001669064
				},
				{
					"lng": 11.440626682529151,
					"lat": 43.57201022798449
				},
				{
					"lng": 11.440593012908733,
					"lat": 43.5720349034979
				},
				{
					"lng": 11.440591413203181,
					"lat": 43.57207809272812
				},
				{
					"lng": 11.440580848650788,
					"lat": 43.572085967087155
				},
				{
					"lng": 11.440572877652512,
					"lat": 43.57209287126457
				},
				{
					"lng": 11.440559847614733,
					"lat": 43.57210212724009
				},
				{
					"lng": 11.44055499521414,
					"lat": 43.57210971571816
				},
				{
					"lng": 11.440540700099616,
					"lat": 43.57211300850619
				},
				{
					"lng": 11.440484285615897,
					"lat": 43.572119423059206
				},
				{
					"lng": 11.440432988134583,
					"lat": 43.57212498188013
				},
				{
					"lng": 11.44037245459357,
					"lat": 43.57210527618685
				},
				{
					"lng": 11.440287738369738,
					"lat": 43.57205528685068
				},
				{
					"lng": 11.440233647411807,
					"lat": 43.57206839187636
				},
				{
					"lng": 11.440221234774807,
					"lat": 43.57206715244066
				},
				{
					"lng": 11.440169202684643,
					"lat": 43.57208021436552
				},
				{
					"lng": 11.440144584009973,
					"lat": 43.572082972160096
				},
				{
					"lng": 11.440113905812135,
					"lat": 43.57208885130762
				},
				{
					"lng": 11.440072933097856,
					"lat": 43.572094944888896
				},
				{
					"lng": 11.440028972795021,
					"lat": 43.57210936051183
				},
				{
					"lng": 11.43999014714743,
					"lat": 43.57211765555325
				},
				{
					"lng": 11.43987664025078,
					"lat": 43.57211327615564
				},
				{
					"lng": 11.439700846369663,
					"lat": 43.57212965675632
				},
				{
					"lng": 11.439637313787447,
					"lat": 43.57213846571612
				},
				{
					"lng": 11.439608753590838,
					"lat": 43.572145797732254
				},
				{
					"lng": 11.439578309611571,
					"lat": 43.57215766194209
				},
				{
					"lng": 11.439500188266372,
					"lat": 43.57216228132698
				},
				{
					"lng": 11.43946836212269,
					"lat": 43.57216518925648
				},
				{
					"lng": 11.439416006066839,
					"lat": 43.57217002110769
				},
				{
					"lng": 11.439278201957018,
					"lat": 43.5721431840337
				},
				{
					"lng": 11.439273289530972,
					"lat": 43.572143218676956
				},
				{
					"lng": 11.439271184807536,
					"lat": 43.572143936190976
				},
				{
					"lng": 11.439269086713633,
					"lat": 43.57214509384769
				},
				{
					"lng": 11.439264325699517,
					"lat": 43.572147957843725
				},
				{
					"lng": 11.439247487774209,
					"lat": 43.572152468041565
				},
				{
					"lng": 11.439247477588813,
					"lat": 43.57215825678173
				},
				{
					"lng": 11.439239817957008,
					"lat": 43.572169042046426
				},
				{
					"lng": 11.439235231999975,
					"lat": 43.572176394284156
				},
				{
					"lng": 11.439224694930761,
					"lat": 43.57218654858578
				},
				{
					"lng": 11.439212219005514,
					"lat": 43.572195793479004
				},
				{
					"lng": 11.439210210161674,
					"lat": 43.57220084786105
				},
				{
					"lng": 11.439205203816567,
					"lat": 43.57220809382371
				},
				{
					"lng": 11.439203853075716,
					"lat": 43.57221987707871
				},
				{
					"lng": 11.439201397205402,
					"lat": 43.57222278550148
				},
				{
					"lng": 11.439202117958947,
					"lat": 43.57223342697521
				},
				{
					"lng": 11.43919667317771,
					"lat": 43.57224898197077
				},
				{
					"lng": 11.439196103595568,
					"lat": 43.57224987289786
				},
				{
					"lng": 11.439189987091787,
					"lat": 43.57226351362567
				},
				{
					"lng": 11.439182598938125,
					"lat": 43.57227553290988
				},
				{
					"lng": 11.439171740307469,
					"lat": 43.57228388881556
				},
				{
					"lng": 11.439165533725827,
					"lat": 43.57229180326757
				},
				{
					"lng": 11.439155260904966,
					"lat": 43.57230810329615
				},
				{
					"lng": 11.43915798195614,
					"lat": 43.57232249445607
				},
				{
					"lng": 11.439162076040184,
					"lat": 43.57233279920717
				},
				{
					"lng": 11.439164809910872,
					"lat": 43.572339779991964
				},
				{
					"lng": 11.439178108853241,
					"lat": 43.572357323553355
				},
				{
					"lng": 11.439189931377264,
					"lat": 43.572384335480706
				},
				{
					"lng": 11.439193577630475,
					"lat": 43.572414798423054
				},
				{
					"lng": 11.43919276602195,
					"lat": 43.572417607817535
				},
				{
					"lng": 11.439191260883323,
					"lat": 43.5724344301756
				},
				{
					"lng": 11.439170338095675,
					"lat": 43.57245585200552
				},
				{
					"lng": 11.439168681817604,
					"lat": 43.57245749363518
				},
				{
					"lng": 11.439144962576988,
					"lat": 43.572467840197746
				},
				{
					"lng": 11.439145047837428,
					"lat": 43.57246998217484
				},
				{
					"lng": 11.439143658196011,
					"lat": 43.57247215473674
				},
				{
					"lng": 11.439122493467021,
					"lat": 43.57248090081571
				},
				{
					"lng": 11.439121970291952,
					"lat": 43.572482665017624
				},
				{
					"lng": 11.439089802308047,
					"lat": 43.57248928699045
				},
				{
					"lng": 11.439087541889725,
					"lat": 43.57249255859215
				},
				{
					"lng": 11.439082639559974,
					"lat": 43.5724981186242
				},
				{
					"lng": 11.439064474971271,
					"lat": 43.5725223105399
				},
				{
					"lng": 11.439052843997358,
					"lat": 43.57254171793911
				},
				{
					"lng": 11.439047493732927,
					"lat": 43.572544557589
				},
				{
					"lng": 11.439034991791521,
					"lat": 43.57254779390318
				},
				{
					"lng": 11.439018035398425,
					"lat": 43.572559309726806
				},
				{
					"lng": 11.438979700935318,
					"lat": 43.57258444089022
				},
				{
					"lng": 11.438974722201559,
					"lat": 43.57258801721766
				},
				{
					"lng": 11.438966584824167,
					"lat": 43.57258942713373
				},
				{
					"lng": 11.438907656779527,
					"lat": 43.572602090955165
				},
				{
					"lng": 11.438899879672675,
					"lat": 43.57260398928403
				},
				{
					"lng": 11.438894393002625,
					"lat": 43.57260335908504
				},
				{
					"lng": 11.438857830458295,
					"lat": 43.57261974664247
				},
				{
					"lng": 11.438851418133023,
					"lat": 43.57262161673741
				},
				{
					"lng": 11.438830222298238,
					"lat": 43.572638182298235
				},
				{
					"lng": 11.438814040749769,
					"lat": 43.57266527067664
				},
				{
					"lng": 11.438815950966626,
					"lat": 43.572671573959035
				},
				{
					"lng": 11.438808914001779,
					"lat": 43.57270404048259
				},
				{
					"lng": 11.438810622893186,
					"lat": 43.572715785437616
				},
				{
					"lng": 11.438803704916186,
					"lat": 43.572761841508836
				},
				{
					"lng": 11.438801166270181,
					"lat": 43.57277125781226
				},
				{
					"lng": 11.438802049012324,
					"lat": 43.572795941708016
				},
				{
					"lng": 11.438811688264778,
					"lat": 43.57282979451657
				},
				{
					"lng": 11.438822627387726,
					"lat": 43.57283753656444
				},
				{
					"lng": 11.438824167558158,
					"lat": 43.572846605599025
				},
				{
					"lng": 11.438821232133492,
					"lat": 43.57285508947812
				},
				{
					"lng": 11.438822572375557,
					"lat": 43.572866506460784
				},
				{
					"lng": 11.43882034108182,
					"lat": 43.57287022402231
				},
				{
					"lng": 11.43880683572793,
					"lat": 43.57288194977232
				},
				{
					"lng": 11.438794809981019,
					"lat": 43.57290274764906
				},
				{
					"lng": 11.438763377072124,
					"lat": 43.572929850917404
				},
				{
					"lng": 11.438738996185524,
					"lat": 43.57294893616841
				},
				{
					"lng": 11.438731760240431,
					"lat": 43.572963257138426
				},
				{
					"lng": 11.438723230032405,
					"lat": 43.57298226698271
				},
				{
					"lng": 11.438718755140355,
					"lat": 43.5729866374819
				},
				{
					"lng": 11.438717004388579,
					"lat": 43.572989375079096
				},
				{
					"lng": 11.438707691858834,
					"lat": 43.573004651550534
				},
				{
					"lng": 11.43870449834877,
					"lat": 43.573018000268256
				},
				{
					"lng": 11.438702261339266,
					"lat": 43.57303200475376
				},
				{
					"lng": 11.438695866699419,
					"lat": 43.57304271796294
				},
				{
					"lng": 11.438694416988492,
					"lat": 43.57304340347857
				},
				{
					"lng": 11.438687402726076,
					"lat": 43.57304772643267
				},
				{
					"lng": 11.438690109541746,
					"lat": 43.573061766759295
				},
				{
					"lng": 11.438672594307803,
					"lat": 43.57307309547548
				},
				{
					"lng": 11.438673844767687,
					"lat": 43.5730866446672
				},
				{
					"lng": 11.438664717154495,
					"lat": 43.57309205536182
				},
				{
					"lng": 11.438653928452773,
					"lat": 43.5731100311511
				},
				{
					"lng": 11.438650975795744,
					"lat": 43.5731262784416
				},
				{
					"lng": 11.43864506822167,
					"lat": 43.5731404981239
				},
				{
					"lng": 11.438660923380954,
					"lat": 43.573160008532014
				},
				{
					"lng": 11.438662051188508,
					"lat": 43.573170427930826
				},
				{
					"lng": 11.43866211072613,
					"lat": 43.573213217064186
				},
				{
					"lng": 11.438610097106,
					"lat": 43.57323348630084
				},
				{
					"lng": 11.43861009994146,
					"lat": 43.5732335258569
				},
				{
					"lng": 11.438549717547856,
					"lat": 43.57325647042222
				},
				{
					"lng": 11.438532351378182,
					"lat": 43.573249316603494
				},
				{
					"lng": 11.438458814772071,
					"lat": 43.57325443888233
				},
				{
					"lng": 11.438405161912906,
					"lat": 43.57327352389913
				},
				{
					"lng": 11.438403505320784,
					"lat": 43.57327715265572
				},
				{
					"lng": 11.438415018797116,
					"lat": 43.573306973227865
				},
				{
					"lng": 11.438417883690324,
					"lat": 43.573322752415976
				},
				{
					"lng": 11.438418230878648,
					"lat": 43.57333156689774
				},
				{
					"lng": 11.438427459283002,
					"lat": 43.57334901913869
				},
				{
					"lng": 11.438430719297415,
					"lat": 43.57336332768228
				},
				{
					"lng": 11.438428665819522,
					"lat": 43.57339114362542
				},
				{
					"lng": 11.438434557156679,
					"lat": 43.57341520021554
				},
				{
					"lng": 11.438438163168577,
					"lat": 43.57343832416613
				},
				{
					"lng": 11.438440692499215,
					"lat": 43.57345689537979
				},
				{
					"lng": 11.438444766381462,
					"lat": 43.573480780067584
				},
				{
					"lng": 11.43844421404053,
					"lat": 43.57348961374611
				},
				{
					"lng": 11.438465001433897,
					"lat": 43.57352752076115
				},
				{
					"lng": 11.438453462065153,
					"lat": 43.573531354127454
				},
				{
					"lng": 11.438470559570646,
					"lat": 43.5735659607744
				},
				{
					"lng": 11.438477927723428,
					"lat": 43.5735932533112
				},
				{
					"lng": 11.43841687963899,
					"lat": 43.57360726496972
				},
				{
					"lng": 11.438351054021313,
					"lat": 43.573651926530225
				},
				{
					"lng": 11.438408848899812,
					"lat": 43.573674785429226
				},
				{
					"lng": 11.438223147892668,
					"lat": 43.573727763911016
				},
				{
					"lng": 11.438224449930306,
					"lat": 43.57374455606311
				},
				{
					"lng": 11.438188578049576,
					"lat": 43.57377239856554
				},
				{
					"lng": 11.438193215652415,
					"lat": 43.57380908359213
				},
				{
					"lng": 11.43820979884925,
					"lat": 43.573838406136645
				},
				{
					"lng": 11.438249753906085,
					"lat": 43.57382449445909
				},
				{
					"lng": 11.438213110934207,
					"lat": 43.57384090603483
				},
				{
					"lng": 11.438220570992046,
					"lat": 43.5738753240078
				},
				{
					"lng": 11.438222960581875,
					"lat": 43.57388684555685
				},
				{
					"lng": 11.438220510588776,
					"lat": 43.5738899330076
				},
				{
					"lng": 11.438221610908727,
					"lat": 43.57390976553391
				},
				{
					"lng": 11.438217023299934,
					"lat": 43.57393205321259
				},
				{
					"lng": 11.438203557347192,
					"lat": 43.5739501320074
				},
				{
					"lng": 11.438203365102282,
					"lat": 43.5739534071781
				},
				{
					"lng": 11.438177284262208,
					"lat": 43.57397684138724
				},
				{
					"lng": 11.438171640916684,
					"lat": 43.57398046247417
				},
				{
					"lng": 11.43814895591039,
					"lat": 43.57401503660393
				},
				{
					"lng": 11.438147072207045,
					"lat": 43.574054823025875
				},
				{
					"lng": 11.438141524916148,
					"lat": 43.574070947392705
				},
				{
					"lng": 11.438135075591497,
					"lat": 43.574074880999795
				},
				{
					"lng": 11.438131681045387,
					"lat": 43.57410755066988
				},
				{
					"lng": 11.43812683902219,
					"lat": 43.57413182009991
				},
				{
					"lng": 11.43812099737799,
					"lat": 43.57414838382778
				},
				{
					"lng": 11.438118694628997,
					"lat": 43.57416487474226
				},
				{
					"lng": 11.438116510523713,
					"lat": 43.574194888582525
				},
				{
					"lng": 11.438114505516578,
					"lat": 43.574203937833374
				},
				{
					"lng": 11.438117071928797,
					"lat": 43.57423419695025
				},
				{
					"lng": 11.43811317904067,
					"lat": 43.57424528802251
				},
				{
					"lng": 11.438113994583789,
					"lat": 43.57426110374287
				},
				{
					"lng": 11.43811731911428,
					"lat": 43.57429063178347
				},
				{
					"lng": 11.438118964039239,
					"lat": 43.574329017553865
				},
				{
					"lng": 11.438120275642907,
					"lat": 43.57434236556111
				},
				{
					"lng": 11.438118544845443,
					"lat": 43.574354434226024
				},
				{
					"lng": 11.43811400410746,
					"lat": 43.5743589870817
				},
				{
					"lng": 11.438112961984002,
					"lat": 43.57436866585788
				},
				{
					"lng": 11.438113113808104,
					"lat": 43.57437254954398
				},
				{
					"lng": 11.438109405073813,
					"lat": 43.57439449162658
				},
				{
					"lng": 11.43811113864652,
					"lat": 43.574406573703996
				},
				{
					"lng": 11.438112331596878,
					"lat": 43.574437107029866
				},
				{
					"lng": 11.438112991571032,
					"lat": 43.57444989720254
				},
				{
					"lng": 11.438113446145012,
					"lat": 43.574481006318166
				},
				{
					"lng": 11.438110812437658,
					"lat": 43.574494882397204
				},
				{
					"lng": 11.438107977313496,
					"lat": 43.574515794715126
				},
				{
					"lng": 11.438108656178239,
					"lat": 43.57451877578217
				},
				{
					"lng": 11.438106406789542,
					"lat": 43.574536711561706
				},
				{
					"lng": 11.438102836933899,
					"lat": 43.574538932433235
				},
				{
					"lng": 11.438104756424218,
					"lat": 43.57454482135477
				},
				{
					"lng": 11.438103983960406,
					"lat": 43.57455243701608
				},
				{
					"lng": 11.43809713964205,
					"lat": 43.574558183403994
				},
				{
					"lng": 11.438100962170912,
					"lat": 43.57456277389208
				},
				{
					"lng": 11.43810073631532,
					"lat": 43.57456791626014
				},
				{
					"lng": 11.438095677866823,
					"lat": 43.57457004464341
				},
				{
					"lng": 11.438097836894544,
					"lat": 43.574575915848456
				},
				{
					"lng": 11.438096718299901,
					"lat": 43.57458014177472
				},
				{
					"lng": 11.438097311029361,
					"lat": 43.57458433298513
				},
				{
					"lng": 11.438094736243679,
					"lat": 43.574595128518474
				},
				{
					"lng": 11.438094452833997,
					"lat": 43.574608109892615
				},
				{
					"lng": 11.438092197727833,
					"lat": 43.574612436601896
				},
				{
					"lng": 11.438090199772482,
					"lat": 43.57464092663207
				},
				{
					"lng": 11.43808866681144,
					"lat": 43.57464599334796
				},
				{
					"lng": 11.438088779174803,
					"lat": 43.5746576427234
				},
				{
					"lng": 11.438085515161845,
					"lat": 43.57466274637662
				},
				{
					"lng": 11.4380755364053,
					"lat": 43.5747003060231
				},
				{
					"lng": 11.438074636694454,
					"lat": 43.57470384929497
				},
				{
					"lng": 11.438067139342166,
					"lat": 43.57472464950538
				},
				{
					"lng": 11.438065556846169,
					"lat": 43.57472845855146
				},
				{
					"lng": 11.438056922547606,
					"lat": 43.57475557665329
				},
				{
					"lng": 11.438047283539598,
					"lat": 43.57478661302231
				},
				{
					"lng": 11.43803906416035,
					"lat": 43.57483956397619
				},
				{
					"lng": 11.438060981089059,
					"lat": 43.574873448383116
				},
				{
					"lng": 11.438048626031847,
					"lat": 43.574905461990944
				},
				{
					"lng": 11.438028430958601,
					"lat": 43.57492730116004
				},
				{
					"lng": 11.4380112006195,
					"lat": 43.57495315847243
				},
				{
					"lng": 11.438008608688548,
					"lat": 43.57495865205184
				},
				{
					"lng": 11.437970017683893,
					"lat": 43.57503812786932
				},
				{
					"lng": 11.437964247303919,
					"lat": 43.575069866813216
				},
				{
					"lng": 11.437954878569386,
					"lat": 43.575141562911185
				},
				{
					"lng": 11.43795088452778,
					"lat": 43.57515898578177
				},
				{
					"lng": 11.437951596526993,
					"lat": 43.575199142688014
				},
				{
					"lng": 11.437934304731481,
					"lat": 43.57526465207913
				},
				{
					"lng": 11.437934736081706,
					"lat": 43.57534310888503
				},
				{
					"lng": 11.437930656021557,
					"lat": 43.575351897178656
				},
				{
					"lng": 11.437929792817181,
					"lat": 43.57538294437063
				},
				{
					"lng": 11.437923705291634,
					"lat": 43.57539366628736
				},
				{
					"lng": 11.437886599737691,
					"lat": 43.57543248359112
				},
				{
					"lng": 11.437871339559678,
					"lat": 43.575447664498455
				},
				{
					"lng": 11.437865568839758,
					"lat": 43.57544914629193
				},
				{
					"lng": 11.437859090973673,
					"lat": 43.57545381880068
				},
				{
					"lng": 11.437829738570397,
					"lat": 43.575459118017896
				},
				{
					"lng": 11.43781668163239,
					"lat": 43.575465894615476
				},
				{
					"lng": 11.437793663983163,
					"lat": 43.575478776693416
				},
				{
					"lng": 11.43777846934366,
					"lat": 43.57549564349548
				},
				{
					"lng": 11.437766719459994,
					"lat": 43.57550390573356
				},
				{
					"lng": 11.437748586988826,
					"lat": 43.57552984797958
				},
				{
					"lng": 11.437735648871788,
					"lat": 43.57554558257929
				},
				{
					"lng": 11.4377193250192,
					"lat": 43.57557055614465
				},
				{
					"lng": 11.437710301252656,
					"lat": 43.575582355418526
				},
				{
					"lng": 11.437695633158263,
					"lat": 43.5756077276365
				},
				{
					"lng": 11.437683797383894,
					"lat": 43.57562438680846
				},
				{
					"lng": 11.437668055784656,
					"lat": 43.575646543271525
				},
				{
					"lng": 11.437663975885936,
					"lat": 43.57565374148712
				},
				{
					"lng": 11.437648603428519,
					"lat": 43.5756697639107
				},
				{
					"lng": 11.437622324981481,
					"lat": 43.57569835866106
				},
				{
					"lng": 11.43761900799414,
					"lat": 43.57570466813423
				},
				{
					"lng": 11.437614710108553,
					"lat": 43.5757077544775
				},
				{
					"lng": 11.437611652537656,
					"lat": 43.57571242153169
				},
				{
					"lng": 11.437597663603661,
					"lat": 43.575723846822584
				},
				{
					"lng": 11.437596119075673,
					"lat": 43.57572580567852
				},
				{
					"lng": 11.437587881279313,
					"lat": 43.57573179605318
				},
				{
					"lng": 11.437568261376532,
					"lat": 43.57573488063279
				},
				{
					"lng": 11.437554065928746,
					"lat": 43.57574481029686
				},
				{
					"lng": 11.437536543736224,
					"lat": 43.575745067055976
				},
				{
					"lng": 11.43751242286303,
					"lat": 43.5757573450501
				},
				{
					"lng": 11.437473203363174,
					"lat": 43.57573609458318
				},
				{
					"lng": 11.437456886370995,
					"lat": 43.57572604602195
				},
				{
					"lng": 11.437418584629041,
					"lat": 43.5757260923702
				},
				{
					"lng": 11.43740423367892,
					"lat": 43.57574705224321
				},
				{
					"lng": 11.437397894534087,
					"lat": 43.575746970480026
				},
				{
					"lng": 11.437393920875836,
					"lat": 43.57575480748764
				},
				{
					"lng": 11.437383268079092,
					"lat": 43.57576487854907
				},
				{
					"lng": 11.437368058913039,
					"lat": 43.575782893586066
				},
				{
					"lng": 11.43736721761588,
					"lat": 43.575791475913164
				},
				{
					"lng": 11.437364294307736,
					"lat": 43.57579581866226
				},
				{
					"lng": 11.437356123048625,
					"lat": 43.57582085776544
				},
				{
					"lng": 11.437357459859637,
					"lat": 43.57584772169216
				},
				{
					"lng": 11.437356354392794,
					"lat": 43.5758535635062
				},
				{
					"lng": 11.437353028040114,
					"lat": 43.57585513088872
				},
				{
					"lng": 11.437354824161792,
					"lat": 43.5758595899546
				},
				{
					"lng": 11.437349465566877,
					"lat": 43.575869443634446
				},
				{
					"lng": 11.437345633248999,
					"lat": 43.57587351045028
				},
				{
					"lng": 11.437344279124295,
					"lat": 43.57587653578876
				},
				{
					"lng": 11.437325403305403,
					"lat": 43.5758948064097
				},
				{
					"lng": 11.437315216498227,
					"lat": 43.57590255445738
				},
				{
					"lng": 11.43730796509581,
					"lat": 43.57590923596838
				},
				{
					"lng": 11.437301948540112,
					"lat": 43.575921260082666
				},
				{
					"lng": 11.437296341401083,
					"lat": 43.57592480202076
				},
				{
					"lng": 11.4372800095603,
					"lat": 43.575940439689866
				},
				{
					"lng": 11.437266962177716,
					"lat": 43.57595012693758
				},
				{
					"lng": 11.437261132076959,
					"lat": 43.57595600020259
				},
				{
					"lng": 11.437252789780487,
					"lat": 43.5759644355033
				},
				{
					"lng": 11.437243207733108,
					"lat": 43.57597590720662
				},
				{
					"lng": 11.437237894073942,
					"lat": 43.575977852816926
				},
				{
					"lng": 11.4372391004617,
					"lat": 43.5759813241458
				},
				{
					"lng": 11.437230961947488,
					"lat": 43.57599137217412
				},
				{
					"lng": 11.437225123966313,
					"lat": 43.57599002278577
				},
				{
					"lng": 11.437224764502137,
					"lat": 43.575995600181855
				},
				{
					"lng": 11.437220573250073,
					"lat": 43.57599936582063
				},
				{
					"lng": 11.437214624366876,
					"lat": 43.57599885884856
				},
				{
					"lng": 11.43721481433391,
					"lat": 43.57600368891742
				},
				{
					"lng": 11.437210759542088,
					"lat": 43.57600356291933
				},
				{
					"lng": 11.437204265374906,
					"lat": 43.5760023409741
				},
				{
					"lng": 11.437203760862527,
					"lat": 43.57600920360008
				},
				{
					"lng": 11.437199555472814,
					"lat": 43.57600982632558
				},
				{
					"lng": 11.43719204715235,
					"lat": 43.57601532841397
				},
				{
					"lng": 11.437182968335799,
					"lat": 43.576013645683226
				},
				{
					"lng": 11.437166433661567,
					"lat": 43.57602815588933
				},
				{
					"lng": 11.437154756562808,
					"lat": 43.576025858697875
				},
				{
					"lng": 11.437142284292438,
					"lat": 43.576024418517335
				},
				{
					"lng": 11.437130968732141,
					"lat": 43.57603617479032
				},
				{
					"lng": 11.437092037116491,
					"lat": 43.57604513828683
				},
				{
					"lng": 11.437079812765255,
					"lat": 43.576045391821786
				},
				{
					"lng": 11.43704920605245,
					"lat": 43.57608007616584
				},
				{
					"lng": 11.437017442769243,
					"lat": 43.57610647829711
				},
				{
					"lng": 11.436990211415308,
					"lat": 43.57615916388834
				},
				{
					"lng": 11.436981745355716,
					"lat": 43.57617745462779
				},
				{
					"lng": 11.436971385740724,
					"lat": 43.5761964214188
				},
				{
					"lng": 11.436953622137988,
					"lat": 43.576237687279004
				},
				{
					"lng": 11.436949542924301,
					"lat": 43.5762532535523
				},
				{
					"lng": 11.436949104338451,
					"lat": 43.57626598612533
				},
				{
					"lng": 11.436945784775434,
					"lat": 43.57629058768027
				},
				{
					"lng": 11.4369490264786,
					"lat": 43.57630481471686
				},
				{
					"lng": 11.436950494183481,
					"lat": 43.57631371874858
				},
				{
					"lng": 11.436947784091345,
					"lat": 43.57632822669054
				},
				{
					"lng": 11.436925253701054,
					"lat": 43.57636820493177
				},
				{
					"lng": 11.4369270641783,
					"lat": 43.576373419113686
				},
				{
					"lng": 11.43691719028178,
					"lat": 43.576394633683904
				},
				{
					"lng": 11.436907334331723,
					"lat": 43.57641923958826
				},
				{
					"lng": 11.4369074133696,
					"lat": 43.57644311228236
				},
				{
					"lng": 11.436912666398111,
					"lat": 43.57651694455565
				},
				{
					"lng": 11.436909769536841,
					"lat": 43.57654177119123
				},
				{
					"lng": 11.436909353262337,
					"lat": 43.576563865401056
				},
				{
					"lng": 11.436905690742147,
					"lat": 43.57658033666694
				},
				{
					"lng": 11.436904939808597,
					"lat": 43.576582996187696
				},
				{
					"lng": 11.436863340558785,
					"lat": 43.576624533592934
				},
				{
					"lng": 11.436866394472874,
					"lat": 43.57663214236826
				},
				{
					"lng": 11.436860119985454,
					"lat": 43.576633389052304
				},
				{
					"lng": 11.436863065025268,
					"lat": 43.576637716477194
				},
				{
					"lng": 11.436822068749633,
					"lat": 43.57667965067855
				},
				{
					"lng": 11.436820801690079,
					"lat": 43.576683545718
				},
				{
					"lng": 11.436786814128217,
					"lat": 43.57672223493702
				},
				{
					"lng": 11.436785121135559,
					"lat": 43.57672969284526
				},
				{
					"lng": 11.436760056480143,
					"lat": 43.576756193343954
				},
				{
					"lng": 11.436761483024679,
					"lat": 43.57676358652352
				},
				{
					"lng": 11.436751409163346,
					"lat": 43.57678181249213
				},
				{
					"lng": 11.436753531754704,
					"lat": 43.57679249070675
				},
				{
					"lng": 11.436741270782473,
					"lat": 43.576814952768856
				},
				{
					"lng": 11.43674371281761,
					"lat": 43.57682685678624
				},
				{
					"lng": 11.43672573262373,
					"lat": 43.57685496642644
				},
				{
					"lng": 11.43669624481766,
					"lat": 43.57687344254675
				},
				{
					"lng": 11.4367095067494,
					"lat": 43.57692624861064
				},
				{
					"lng": 11.43671444620317,
					"lat": 43.57695149066502
				},
				{
					"lng": 11.436732726155102,
					"lat": 43.576981239118325
				},
				{
					"lng": 11.436732461920283,
					"lat": 43.577008023745464
				},
				{
					"lng": 11.436773184466379,
					"lat": 43.57704754165466
				},
				{
					"lng": 11.436768121901789,
					"lat": 43.57705899706468
				},
				{
					"lng": 11.43679571512196,
					"lat": 43.577083127521306
				},
				{
					"lng": 11.436796185996139,
					"lat": 43.57709513480135
				},
				{
					"lng": 11.43680817282127,
					"lat": 43.57711958998617
				},
				{
					"lng": 11.436839018431451,
					"lat": 43.577156338270406
				},
				{
					"lng": 11.436857692965502,
					"lat": 43.5771873298102
				},
				{
					"lng": 11.436864879780035,
					"lat": 43.57720654272692
				},
				{
					"lng": 11.436877233111945,
					"lat": 43.5772169685277
				},
				{
					"lng": 11.436892116006947,
					"lat": 43.577243675903894
				},
				{
					"lng": 11.43690641014503,
					"lat": 43.577280100090256
				},
				{
					"lng": 11.436921806719093,
					"lat": 43.577297807150046
				},
				{
					"lng": 11.436925399175138,
					"lat": 43.577319098259395
				},
				{
					"lng": 11.436940770066672,
					"lat": 43.577336137785075
				},
				{
					"lng": 11.43694336604461,
					"lat": 43.577355445909234
				},
				{
					"lng": 11.436965293121155,
					"lat": 43.57739905616138
				},
				{
					"lng": 11.436971378310563,
					"lat": 43.57741361781311
				},
				{
					"lng": 11.43697754108828,
					"lat": 43.57745354951158
				},
				{
					"lng": 11.436989761436493,
					"lat": 43.57753074373446
				},
				{
					"lng": 11.436992336245995,
					"lat": 43.57757306592458
				},
				{
					"lng": 11.43698808519517,
					"lat": 43.57762856934734
				},
				{
					"lng": 11.436955348583416,
					"lat": 43.57768399693622
				},
				{
					"lng": 11.436931531470151,
					"lat": 43.57770919502863
				},
				{
					"lng": 11.436910520985833,
					"lat": 43.57771230195124
				},
				{
					"lng": 11.436888695518212,
					"lat": 43.5777414642311
				},
				{
					"lng": 11.436881560934273,
					"lat": 43.57777032128888
				},
				{
					"lng": 11.436864923258637,
					"lat": 43.577816543994814
				},
				{
					"lng": 11.436848174354807,
					"lat": 43.577852798304384
				},
				{
					"lng": 11.436846822860105,
					"lat": 43.57785475483362
				},
				{
					"lng": 11.436831980622362,
					"lat": 43.577888079169334
				},
				{
					"lng": 11.436826209739403,
					"lat": 43.57790748740358
				},
				{
					"lng": 11.436825918564137,
					"lat": 43.5779104612534
				},
				{
					"lng": 11.436823720460632,
					"lat": 43.57791169392817
				},
				{
					"lng": 11.436828620841553,
					"lat": 43.57796892717252
				},
				{
					"lng": 11.436827618127374,
					"lat": 43.577974585812825
				},
				{
					"lng": 11.436827620390904,
					"lat": 43.57800594766731
				},
				{
					"lng": 11.436826238038712,
					"lat": 43.57801235721452
				},
				{
					"lng": 11.436825437791963,
					"lat": 43.57802914108649
				},
				{
					"lng": 11.436820907503268,
					"lat": 43.57803644791699
				},
				{
					"lng": 11.436821769461783,
					"lat": 43.578043537103305
				},
				{
					"lng": 11.436820344679878,
					"lat": 43.57804812789509
				},
				{
					"lng": 11.436821545939171,
					"lat": 43.57806086330701
				},
				{
					"lng": 11.436814855836523,
					"lat": 43.57807731900287
				},
				{
					"lng": 11.436808204224366,
					"lat": 43.57808343395762
				},
				{
					"lng": 11.436809904807918,
					"lat": 43.57809276790389
				},
				{
					"lng": 11.436810758031015,
					"lat": 43.57811624502294
				},
				{
					"lng": 11.43681520822428,
					"lat": 43.578130892872494
				},
				{
					"lng": 11.436818182338193,
					"lat": 43.57814855334778
				},
				{
					"lng": 11.436820667984223,
					"lat": 43.57815380175086
				},
				{
					"lng": 11.43682272526801,
					"lat": 43.5781681080699
				},
				{
					"lng": 11.436834988202488,
					"lat": 43.57819261678383
				},
				{
					"lng": 11.436837178357104,
					"lat": 43.57823891243373
				},
				{
					"lng": 11.436839035584802,
					"lat": 43.57824727873572
				},
				{
					"lng": 11.436836598662142,
					"lat": 43.5782574788481
				},
				{
					"lng": 11.436836143568547,
					"lat": 43.57827127601375
				},
				{
					"lng": 11.436837626664127,
					"lat": 43.57827328643643
				},
				{
					"lng": 11.436834213717088,
					"lat": 43.578289683944945
				},
				{
					"lng": 11.436831711180032,
					"lat": 43.57830611515899
				},
				{
					"lng": 11.436828430308001,
					"lat": 43.578316547559744
				},
				{
					"lng": 11.436823148295097,
					"lat": 43.5783344138267
				},
				{
					"lng": 11.436820174466476,
					"lat": 43.57833941131118
				},
				{
					"lng": 11.436818444233872,
					"lat": 43.57834174237044
				},
				{
					"lng": 11.436811619897338,
					"lat": 43.578356621668625
				},
				{
					"lng": 11.436809030419553,
					"lat": 43.578364882922536
				},
				{
					"lng": 11.436804376084282,
					"lat": 43.578379398107735
				},
				{
					"lng": 11.436803962777912,
					"lat": 43.57838434818647
				},
				{
					"lng": 11.436804244014537,
					"lat": 43.57838840198446
				},
				{
					"lng": 11.436810637243477,
					"lat": 43.57839288636609
				},
				{
					"lng": 11.436813760177706,
					"lat": 43.57840438239316
				},
				{
					"lng": 11.43685258694669,
					"lat": 43.57840330942234
				},
				{
					"lng": 11.436868437924957,
					"lat": 43.57840636667899
				},
				{
					"lng": 11.436903378162905,
					"lat": 43.57840529014496
				},
				{
					"lng": 11.436910554991211,
					"lat": 43.578405775444914
				},
				{
					"lng": 11.436923977425735,
					"lat": 43.57841623245908
				},
				{
					"lng": 11.436934475451185,
					"lat": 43.578426128783626
				},
				{
					"lng": 11.436939907293482,
					"lat": 43.57842520349424
				},
				{
					"lng": 11.436956211292788,
					"lat": 43.578428929059754
				},
				{
					"lng": 11.436968521218395,
					"lat": 43.57842903476268
				},
				{
					"lng": 11.436976231572249,
					"lat": 43.57841650094558
				},
				{
					"lng": 11.43699183087216,
					"lat": 43.57840138315856
				},
				{
					"lng": 11.43702076964356,
					"lat": 43.57840743321511
				},
				{
					"lng": 11.437025977313715,
					"lat": 43.578408809562454
				},
				{
					"lng": 11.437036529759865,
					"lat": 43.5784216498471
				},
				{
					"lng": 11.437043792750826,
					"lat": 43.57842417805504
				},
				{
					"lng": 11.437047788100482,
					"lat": 43.578434734382924
				},
				{
					"lng": 11.437045222353037,
					"lat": 43.578437475830384
				},
				{
					"lng": 11.437065937386622,
					"lat": 43.57845607334819
				},
				{
					"lng": 11.437071287199371,
					"lat": 43.57846385643909
				},
				{
					"lng": 11.43708300698076,
					"lat": 43.57847244725613
				},
				{
					"lng": 11.43709376553371,
					"lat": 43.578482936759066
				},
				{
					"lng": 11.437109443984356,
					"lat": 43.57850408981931
				},
				{
					"lng": 11.437114868468315,
					"lat": 43.578508045617355
				},
				{
					"lng": 11.437127953965614,
					"lat": 43.57851423390795
				},
				{
					"lng": 11.437176180741321,
					"lat": 43.57856826952849
				},
				{
					"lng": 11.43718808898472,
					"lat": 43.5785812222382
				},
				{
					"lng": 11.437229359213225,
					"lat": 43.578623780565174
				},
				{
					"lng": 11.437252957151344,
					"lat": 43.578650928650866
				},
				{
					"lng": 11.437271504140947,
					"lat": 43.578662601665364
				},
				{
					"lng": 11.437294031786855,
					"lat": 43.57868050680278
				},
				{
					"lng": 11.43733819521945,
					"lat": 43.57871023694147
				},
				{
					"lng": 11.437340534077236,
					"lat": 43.57872126707743
				},
				{
					"lng": 11.437347704727925,
					"lat": 43.57872972981341
				},
				{
					"lng": 11.43736322755116,
					"lat": 43.57873833941717
				},
				{
					"lng": 11.437379420093803,
					"lat": 43.57875261790597
				},
				{
					"lng": 11.437398539298536,
					"lat": 43.578777116254706
				},
				{
					"lng": 11.437402225230116,
					"lat": 43.57878150799261
				},
				{
					"lng": 11.437423793957267,
					"lat": 43.57880127482882
				},
				{
					"lng": 11.437461577763578,
					"lat": 43.57881433729371
				},
				{
					"lng": 11.43747929326696,
					"lat": 43.57881762030042
				},
				{
					"lng": 11.437500761520429,
					"lat": 43.578825845544095
				},
				{
					"lng": 11.437521135690753,
					"lat": 43.578838200739234
				},
				{
					"lng": 11.43753786442818,
					"lat": 43.57884302552289
				},
				{
					"lng": 11.437574901124515,
					"lat": 43.578858534003416
				},
				{
					"lng": 11.437591922404318,
					"lat": 43.578865481927394
				},
				{
					"lng": 11.437595182793984,
					"lat": 43.578867799267314
				},
				{
					"lng": 11.437624197374856,
					"lat": 43.578888637129104
				},
				{
					"lng": 11.437664873002088,
					"lat": 43.5789058984109
				},
				{
					"lng": 11.437683442843747,
					"lat": 43.578911230422186
				},
				{
					"lng": 11.437702348689681,
					"lat": 43.57892513134342
				},
				{
					"lng": 11.437756466358731,
					"lat": 43.5789506890916
				},
				{
					"lng": 11.437775671614869,
					"lat": 43.57895553123208
				},
				{
					"lng": 11.437777880369898,
					"lat": 43.578961679594435
				},
				{
					"lng": 11.437817190409659,
					"lat": 43.57897753925962
				},
				{
					"lng": 11.43784717830606,
					"lat": 43.57898978021607
				},
				{
					"lng": 11.43788169710775,
					"lat": 43.5790004982956
				},
				{
					"lng": 11.437905419017207,
					"lat": 43.57901186991163
				},
				{
					"lng": 11.437907524427118,
					"lat": 43.57901416956827
				},
				{
					"lng": 11.437928667092216,
					"lat": 43.57902383687725
				},
				{
					"lng": 11.437952795088595,
					"lat": 43.579037689358344
				},
				{
					"lng": 11.437981185015415,
					"lat": 43.57905191549015
				},
				{
					"lng": 11.437987456013337,
					"lat": 43.57905974911071
				},
				{
					"lng": 11.438001603165159,
					"lat": 43.57907526415149
				},
				{
					"lng": 11.438007387295508,
					"lat": 43.57909064070501
				},
				{
					"lng": 11.438012734318283,
					"lat": 43.579099546579044
				},
				{
					"lng": 11.438019014019659,
					"lat": 43.57910351559837
				},
				{
					"lng": 11.438019897421789,
					"lat": 43.57910548747992
				},
				{
					"lng": 11.438028565063878,
					"lat": 43.579112802664156
				},
				{
					"lng": 11.438064438424256,
					"lat": 43.579123417053516
				},
				{
					"lng": 11.438074446180142,
					"lat": 43.57912901543382
				},
				{
					"lng": 11.438103786960705,
					"lat": 43.579138017072125
				},
				{
					"lng": 11.438120690766032,
					"lat": 43.579145640904606
				},
				{
					"lng": 11.43814570950563,
					"lat": 43.57915207414715
				},
				{
					"lng": 11.438155928930454,
					"lat": 43.57916147299236
				},
				{
					"lng": 11.438168319964355,
					"lat": 43.579180178602314
				},
				{
					"lng": 11.438165124893633,
					"lat": 43.57920082937649
				},
				{
					"lng": 11.438166366819882,
					"lat": 43.57921057645619
				},
				{
					"lng": 11.43816549305751,
					"lat": 43.57922473280479
				},
				{
					"lng": 11.4381651491138,
					"lat": 43.57923783971409
				},
				{
					"lng": 11.4381620231452,
					"lat": 43.57927026322988
				},
				{
					"lng": 11.438154681726532,
					"lat": 43.579286470889876
				},
				{
					"lng": 11.438153701054452,
					"lat": 43.57929273412281
				},
				{
					"lng": 11.43814913823709,
					"lat": 43.57930398804651
				},
				{
					"lng": 11.438140108234615,
					"lat": 43.57931723888821
				},
				{
					"lng": 11.438136603310374,
					"lat": 43.57932812989515
				},
				{
					"lng": 11.438138039407383,
					"lat": 43.57933606037486
				},
				{
					"lng": 11.438135384335375,
					"lat": 43.57933999404952
				},
				{
					"lng": 11.438133123554167,
					"lat": 43.57938249681834
				},
				{
					"lng": 11.43813409800834,
					"lat": 43.57941503632001
				},
				{
					"lng": 11.438138772698684,
					"lat": 43.579479527737085
				},
				{
					"lng": 11.4381392155809,
					"lat": 43.57948506730341
				},
				{
					"lng": 11.438144953524198,
					"lat": 43.57949963539647
				},
				{
					"lng": 11.438162474037743,
					"lat": 43.579542468768516
				},
				{
					"lng": 11.438178823910194,
					"lat": 43.57956416108089
				},
				{
					"lng": 11.438182048968947,
					"lat": 43.57956621534744
				},
				{
					"lng": 11.438216807711784,
					"lat": 43.57958197661145
				},
				{
					"lng": 11.438265301029489,
					"lat": 43.57959849010831
				},
				{
					"lng": 11.438324624969269,
					"lat": 43.57960926215495
				},
				{
					"lng": 11.438340589360077,
					"lat": 43.579608799917104
				},
				{
					"lng": 11.438368333510402,
					"lat": 43.57961843430903
				},
				{
					"lng": 11.438380862183797,
					"lat": 43.579621957519606
				},
				{
					"lng": 11.438427714769206,
					"lat": 43.579642095760526
				},
				{
					"lng": 11.43848737838154,
					"lat": 43.57966495792385
				},
				{
					"lng": 11.438495251016578,
					"lat": 43.57966662937535
				},
				{
					"lng": 11.438536009382734,
					"lat": 43.57966527960816
				},
				{
					"lng": 11.43855329311122,
					"lat": 43.57966108323574
				},
				{
					"lng": 11.438569140955757,
					"lat": 43.57965301167545
				},
				{
					"lng": 11.43857244254734,
					"lat": 43.5796529430119
				},
				{
					"lng": 11.438593630198602,
					"lat": 43.57964089847195
				},
				{
					"lng": 11.438612622429217,
					"lat": 43.57964070381236
				},
				{
					"lng": 11.438629432336729,
					"lat": 43.57963566218401
				},
				{
					"lng": 11.438631599651442,
					"lat": 43.57962774754196
				},
				{
					"lng": 11.438634855260842,
					"lat": 43.57962586560057
				},
				{
					"lng": 11.43864032697329,
					"lat": 43.579620282635126
				},
				{
					"lng": 11.438657413399595,
					"lat": 43.57961132386801
				},
				{
					"lng": 11.438662502972564,
					"lat": 43.579610017739746
				},
				{
					"lng": 11.438673246149824,
					"lat": 43.5796087674178
				},
				{
					"lng": 11.438677336451292,
					"lat": 43.57959884891226
				},
				{
					"lng": 11.43867934839956,
					"lat": 43.5795977903463
				},
				{
					"lng": 11.438699777745432,
					"lat": 43.57959282271931
				},
				{
					"lng": 11.438717367302706,
					"lat": 43.57959632251038
				},
				{
					"lng": 11.43871827846842,
					"lat": 43.57959576103634
				},
				{
					"lng": 11.438724108610705,
					"lat": 43.57959552675284
				},
				{
					"lng": 11.438738121979153,
					"lat": 43.579599073157944
				},
				{
					"lng": 11.438753690035982,
					"lat": 43.57959677084995
				},
				{
					"lng": 11.438757086880031,
					"lat": 43.57959657679648
				},
				{
					"lng": 11.438761270237343,
					"lat": 43.57959475878444
				},
				{
					"lng": 11.438778096109742,
					"lat": 43.5795941610489
				},
				{
					"lng": 11.438784879805999,
					"lat": 43.57959352555031
				},
				{
					"lng": 11.43880594770784,
					"lat": 43.57959259326515
				},
				{
					"lng": 11.438816417641167,
					"lat": 43.57958482283751
				},
				{
					"lng": 11.438828953247244,
					"lat": 43.57959198246913
				},
				{
					"lng": 11.43885717885599,
					"lat": 43.5795912728513
				},
				{
					"lng": 11.438860104526444,
					"lat": 43.57959207746472
				},
				{
					"lng": 11.438874767464043,
					"lat": 43.57958334146601
				},
				{
					"lng": 11.43888569097789,
					"lat": 43.57958410321639
				},
				{
					"lng": 11.43888870759156,
					"lat": 43.57958292776202
				},
				{
					"lng": 11.438890705536743,
					"lat": 43.57957744414372
				},
				{
					"lng": 11.438895214217533,
					"lat": 43.57957524822778
				},
				{
					"lng": 11.438910543709035,
					"lat": 43.57956256245359
				},
				{
					"lng": 11.438923335838934,
					"lat": 43.57955264547222
				},
				{
					"lng": 11.43894560374646,
					"lat": 43.57954327803558
				},
				{
					"lng": 11.438947887297692,
					"lat": 43.579540756859096
				},
				{
					"lng": 11.438974105754392,
					"lat": 43.57953662541024
				},
				{
					"lng": 11.43897582196334,
					"lat": 43.57953422438884
				},
				{
					"lng": 11.438981943307596,
					"lat": 43.57953439264681
				},
				{
					"lng": 11.438994621907685,
					"lat": 43.57954064613086
				},
				{
					"lng": 11.439017379813594,
					"lat": 43.5795440238459
				},
				{
					"lng": 11.439026723605872,
					"lat": 43.57954323734377
				},
				{
					"lng": 11.439031076783927,
					"lat": 43.57954507212328
				},
				{
					"lng": 11.439088442606089,
					"lat": 43.57957022225707
				},
				{
					"lng": 11.439098858821446,
					"lat": 43.57957403178424
				},
				{
					"lng": 11.439110699702278,
					"lat": 43.57957674665348
				},
				{
					"lng": 11.43913117905332,
					"lat": 43.57957951841336
				},
				{
					"lng": 11.43916924175354,
					"lat": 43.579578522189315
				},
				{
					"lng": 11.439190758074709,
					"lat": 43.57958093416055
				},
				{
					"lng": 11.439256641253536,
					"lat": 43.57959133609995
				},
				{
					"lng": 11.439271526729588,
					"lat": 43.57959534642272
				},
				{
					"lng": 11.439292227536159,
					"lat": 43.579594402076516
				},
				{
					"lng": 11.439300986525836,
					"lat": 43.5795954188844
				},
				{
					"lng": 11.439303623710032,
					"lat": 43.579596562784374
				},
				{
					"lng": 11.43936975696059,
					"lat": 43.57961830495598
				},
				{
					"lng": 11.439374021715441,
					"lat": 43.57961890089219
				},
				{
					"lng": 11.439389893674868,
					"lat": 43.57962403001434
				},
				{
					"lng": 11.43940572437975,
					"lat": 43.5796289043083
				},
				{
					"lng": 11.43942984461274,
					"lat": 43.5796385338775
				},
				{
					"lng": 11.439443205480075,
					"lat": 43.5796429116681
				},
				{
					"lng": 11.439461057620257,
					"lat": 43.579645030864235
				},
				{
					"lng": 11.439477109536323,
					"lat": 43.57965072066773
				},
				{
					"lng": 11.43949482797679,
					"lat": 43.57965569240274
				},
				{
					"lng": 11.439511486793165,
					"lat": 43.579657673200764
				},
				{
					"lng": 11.439548618299021,
					"lat": 43.57966636766894
				},
				{
					"lng": 11.43956603735502,
					"lat": 43.57967205258008
				},
				{
					"lng": 11.439636470268168,
					"lat": 43.57968071937338
				},
				{
					"lng": 11.43965532015534,
					"lat": 43.57968898751105
				},
				{
					"lng": 11.439682381896885,
					"lat": 43.579696776877476
				},
				{
					"lng": 11.439694344796244,
					"lat": 43.57970392073055
				},
				{
					"lng": 11.439722467454235,
					"lat": 43.579713506193556
				},
				{
					"lng": 11.439754860830583,
					"lat": 43.5797274825284
				},
				{
					"lng": 11.439755516625832,
					"lat": 43.579729796897205
				},
				{
					"lng": 11.439759146942423,
					"lat": 43.57973108975136
				},
				{
					"lng": 11.439786877504297,
					"lat": 43.57973985972691
				},
				{
					"lng": 11.439816149986106,
					"lat": 43.579741578340716
				},
				{
					"lng": 11.439827321465142,
					"lat": 43.57974298927918
				},
				{
					"lng": 11.439846809776578,
					"lat": 43.579745048266254
				},
				{
					"lng": 11.439866002339455,
					"lat": 43.57974916732267
				},
				{
					"lng": 11.439893836544522,
					"lat": 43.57975789634281
				},
				{
					"lng": 11.43991601420509,
					"lat": 43.57976490307859
				},
				{
					"lng": 11.43996107856962,
					"lat": 43.57977381247154
				},
				{
					"lng": 11.439969285616959,
					"lat": 43.579785597804644
				},
				{
					"lng": 11.439971427607134,
					"lat": 43.57979493037753
				},
				{
					"lng": 11.439977220508224,
					"lat": 43.579798678287176
				},
				{
					"lng": 11.439988245908843,
					"lat": 43.579800090528565
				},
				{
					"lng": 11.440007854568474,
					"lat": 43.57979559488312
				},
				{
					"lng": 11.440048036735512,
					"lat": 43.57981140093668
				},
				{
					"lng": 11.440068661623014,
					"lat": 43.5798182004025
				},
				{
					"lng": 11.440117448912327,
					"lat": 43.57983406396382
				},
				{
					"lng": 11.440120658705856,
					"lat": 43.5798357997683
				},
				{
					"lng": 11.440164017478237,
					"lat": 43.5798513848769
				},
				{
					"lng": 11.440201697763593,
					"lat": 43.579860444669286
				},
				{
					"lng": 11.440202690841833,
					"lat": 43.57986151201464
				},
				{
					"lng": 11.440240217868459,
					"lat": 43.57988332889074
				},
				{
					"lng": 11.440247711326727,
					"lat": 43.57988591319694
				},
				{
					"lng": 11.440290522025004,
					"lat": 43.5799100005064
				},
				{
					"lng": 11.440293113724891,
					"lat": 43.57991081491688
				},
				{
					"lng": 11.440315585493437,
					"lat": 43.57991369607387
				},
				{
					"lng": 11.440388510796836,
					"lat": 43.579943817346795
				},
				{
					"lng": 11.440424699420621,
					"lat": 43.57996297602656
				},
				{
					"lng": 11.440440894680341,
					"lat": 43.5799696953632
				},
				{
					"lng": 11.440459117582854,
					"lat": 43.579977338392574
				},
				{
					"lng": 11.4404944219591,
					"lat": 43.57998914275943
				},
				{
					"lng": 11.440529897005106,
					"lat": 43.58000893880682
				},
				{
					"lng": 11.440545146194072,
					"lat": 43.58001887917226
				},
				{
					"lng": 11.440549232329339,
					"lat": 43.5800201415563
				},
				{
					"lng": 11.440595020433076,
					"lat": 43.58003110790397
				},
				{
					"lng": 11.44059691777349,
					"lat": 43.58003217843994
				},
				{
					"lng": 11.440612251676503,
					"lat": 43.58004200804138
				},
				{
					"lng": 11.440624367080627,
					"lat": 43.580041521455435
				},
				{
					"lng": 11.440635023395444,
					"lat": 43.58004336109314
				},
				{
					"lng": 11.440642610688528,
					"lat": 43.58003931840394
				},
				{
					"lng": 11.440644794323601,
					"lat": 43.5800393518934
				},
				{
					"lng": 11.44066153264868,
					"lat": 43.58002665740072
				},
				{
					"lng": 11.44066220195849,
					"lat": 43.580025934507944
				},
				{
					"lng": 11.440688788926554,
					"lat": 43.58002736361765
				},
				{
					"lng": 11.44069035776778,
					"lat": 43.580028243086495
				},
				{
					"lng": 11.440702148283107,
					"lat": 43.58003007559728
				},
				{
					"lng": 11.440703305150363,
					"lat": 43.58002934228944
				},
				{
					"lng": 11.44070835703238,
					"lat": 43.580029187555404
				},
				{
					"lng": 11.440736863522956,
					"lat": 43.58003710787668
				},
				{
					"lng": 11.440767896896137,
					"lat": 43.58005306318801
				},
				{
					"lng": 11.440773472817122,
					"lat": 43.580059438486614
				},
				{
					"lng": 11.440783229857983,
					"lat": 43.58008811681355
				},
				{
					"lng": 11.440783882798135,
					"lat": 43.58009596674739
				},
				{
					"lng": 11.440784337008907,
					"lat": 43.5801069893488
				},
				{
					"lng": 11.440795385452978,
					"lat": 43.580117120258585
				},
				{
					"lng": 11.440797568177945,
					"lat": 43.580120195233874
				},
				{
					"lng": 11.440833927530136,
					"lat": 43.580130825378056
				},
				{
					"lng": 11.440840911637835,
					"lat": 43.580133676232734
				},
				{
					"lng": 11.440865804485266,
					"lat": 43.5801376517392
				},
				{
					"lng": 11.440865534834355,
					"lat": 43.58013952938086
				},
				{
					"lng": 11.440876333593954,
					"lat": 43.580143299059685
				},
				{
					"lng": 11.44088597785607,
					"lat": 43.5801446434784
				},
				{
					"lng": 11.440967929247066,
					"lat": 43.580173027411185
				},
				{
					"lng": 11.440984009811478,
					"lat": 43.58018349378331
				},
				{
					"lng": 11.44104153849712,
					"lat": 43.580195725361065
				},
				{
					"lng": 11.441046538518622,
					"lat": 43.580200292389996
				},
				{
					"lng": 11.441080650352323,
					"lat": 43.58020808116599
				},
				{
					"lng": 11.441086660158485,
					"lat": 43.580207663748475
				},
				{
					"lng": 11.441100446223663,
					"lat": 43.58021088067937
				},
				{
					"lng": 11.441113589228001,
					"lat": 43.58021819635219
				},
				{
					"lng": 11.441143557681563,
					"lat": 43.58022428728639
				},
				{
					"lng": 11.441149326676165,
					"lat": 43.58022796181599
				},
				{
					"lng": 11.441202371484351,
					"lat": 43.58024673760198
				},
				{
					"lng": 11.44121144363395,
					"lat": 43.58025267892985
				},
				{
					"lng": 11.441231399655305,
					"lat": 43.58025956180416
				},
				{
					"lng": 11.441248522968127,
					"lat": 43.5802659190541
				},
				{
					"lng": 11.441267817888493,
					"lat": 43.580272042624344
				},
				{
					"lng": 11.441291263334698,
					"lat": 43.580271554287535
				},
				{
					"lng": 11.441309251297566,
					"lat": 43.58027335065835
				},
				{
					"lng": 11.44135811578131,
					"lat": 43.58029000346749
				},
				{
					"lng": 11.441372280023616,
					"lat": 43.580292188557735
				},
				{
					"lng": 11.441384507505742,
					"lat": 43.580299374298825
				},
				{
					"lng": 11.44138759002824,
					"lat": 43.580301789869374
				},
				{
					"lng": 11.44140271588933,
					"lat": 43.58030674467303
				},
				{
					"lng": 11.44141098565723,
					"lat": 43.58031091318277
				},
				{
					"lng": 11.441437061918514,
					"lat": 43.580323080106496
				},
				{
					"lng": 11.441441057214096,
					"lat": 43.58032702661872
				},
				{
					"lng": 11.44145049631573,
					"lat": 43.58032838077565
				},
				{
					"lng": 11.441490676285227,
					"lat": 43.580348586501344
				},
				{
					"lng": 11.44156525079484,
					"lat": 43.580374133883836
				},
				{
					"lng": 11.441620239546928,
					"lat": 43.58039120494092
				},
				{
					"lng": 11.441655899605502,
					"lat": 43.580396479024465
				},
				{
					"lng": 11.441689207362373,
					"lat": 43.58040673742406
				},
				{
					"lng": 11.441716860942892,
					"lat": 43.58042210382543
				},
				{
					"lng": 11.441729382247118,
					"lat": 43.58042739606282
				},
				{
					"lng": 11.44176725472553,
					"lat": 43.58044033635
				},
				{
					"lng": 11.441815400689293,
					"lat": 43.58045097540194
				},
				{
					"lng": 11.441847536718015,
					"lat": 43.580460097311466
				},
				{
					"lng": 11.441869397233953,
					"lat": 43.580466477479476
				},
				{
					"lng": 11.441915364433537,
					"lat": 43.5804806331003
				},
				{
					"lng": 11.441951434693088,
					"lat": 43.58049332282228
				},
				{
					"lng": 11.441963992595328,
					"lat": 43.58049734472192
				},
				{
					"lng": 11.441971727779041,
					"lat": 43.580492457833046
				},
				{
					"lng": 11.4419859378676,
					"lat": 43.58049718362756
				},
				{
					"lng": 11.442004821003435,
					"lat": 43.58049664318942
				},
				{
					"lng": 11.442044767175343,
					"lat": 43.580509345483044
				},
				{
					"lng": 11.442077305261767,
					"lat": 43.58052081231645
				},
				{
					"lng": 11.44209643727721,
					"lat": 43.58052284251852
				},
				{
					"lng": 11.442111360623425,
					"lat": 43.580528360689556
				},
				{
					"lng": 11.44214051085946,
					"lat": 43.58053868260741
				},
				{
					"lng": 11.44217908719077,
					"lat": 43.580547585735246
				},
				{
					"lng": 11.442228755013995,
					"lat": 43.58056755328942
				},
				{
					"lng": 11.442247587237883,
					"lat": 43.58057086750708
				},
				{
					"lng": 11.44232546762851,
					"lat": 43.58058066638728
				},
				{
					"lng": 11.442355112316742,
					"lat": 43.58058869702943
				},
				{
					"lng": 11.442405651613479,
					"lat": 43.58058764551639
				},
				{
					"lng": 11.442426764676911,
					"lat": 43.580584117614585
				},
				{
					"lng": 11.442428767108874,
					"lat": 43.58058098742179
				},
				{
					"lng": 11.442470337784142,
					"lat": 43.58056807696868
				},
				{
					"lng": 11.442473978122232,
					"lat": 43.580563368518156
				},
				{
					"lng": 11.4424872273467,
					"lat": 43.58053282546714
				}
			]
		]
	},
	"29": {
		"name": "MA07 - Buche di Calonica",
		"center": {
			"lat": 43.5293,
			"lng": 11.4693
		},
		"coords": [
			[
				{
					"lng": 11.467261506746139,
					"lat": 43.52972612191154
				},
				{
					"lng": 11.467263830864038,
					"lat": 43.529717576471654
				},
				{
					"lng": 11.467276627789373,
					"lat": 43.52966884666737
				},
				{
					"lng": 11.467281246907426,
					"lat": 43.52964975791417
				},
				{
					"lng": 11.467291474062689,
					"lat": 43.52961294605232
				},
				{
					"lng": 11.467298955606982,
					"lat": 43.52959379727584
				},
				{
					"lng": 11.467305285338423,
					"lat": 43.52958521277982
				},
				{
					"lng": 11.467308619241992,
					"lat": 43.52957792239996
				},
				{
					"lng": 11.467325646926419,
					"lat": 43.52955423321471
				},
				{
					"lng": 11.467336236620042,
					"lat": 43.529532381108595
				},
				{
					"lng": 11.467338077026302,
					"lat": 43.52952670646957
				},
				{
					"lng": 11.467337280072158,
					"lat": 43.52952136504588
				},
				{
					"lng": 11.467298906215179,
					"lat": 43.529497821707494
				},
				{
					"lng": 11.467292838845328,
					"lat": 43.529497406139846
				},
				{
					"lng": 11.467253279826512,
					"lat": 43.5294960129868
				},
				{
					"lng": 11.467251187419219,
					"lat": 43.52949612261986
				},
				{
					"lng": 11.467234048753038,
					"lat": 43.529495046958466
				},
				{
					"lng": 11.46723193031306,
					"lat": 43.529495559946774
				},
				{
					"lng": 11.467214636312429,
					"lat": 43.52949421322218
				},
				{
					"lng": 11.467205577670509,
					"lat": 43.52949520683964
				},
				{
					"lng": 11.467160431356715,
					"lat": 43.529505520388646
				},
				{
					"lng": 11.467128340267863,
					"lat": 43.52951564727912
				},
				{
					"lng": 11.467124500484408,
					"lat": 43.52951853778956
				},
				{
					"lng": 11.467096763071519,
					"lat": 43.5295279562605
				},
				{
					"lng": 11.467090485447772,
					"lat": 43.52952870895219
				},
				{
					"lng": 11.467087323436864,
					"lat": 43.529529756363175
				},
				{
					"lng": 11.467074960830448,
					"lat": 43.52953110683026
				},
				{
					"lng": 11.467067722104089,
					"lat": 43.529533957357074
				},
				{
					"lng": 11.467048985522604,
					"lat": 43.52954560904579
				},
				{
					"lng": 11.467047227133431,
					"lat": 43.52954802345529
				},
				{
					"lng": 11.467049218097511,
					"lat": 43.52957431751389
				},
				{
					"lng": 11.467047898502724,
					"lat": 43.529586513287505
				},
				{
					"lng": 11.467042228475378,
					"lat": 43.529590273495934
				},
				{
					"lng": 11.46706287745463,
					"lat": 43.52962594068469
				},
				{
					"lng": 11.46707317574646,
					"lat": 43.529658065053454
				},
				{
					"lng": 11.46707007011417,
					"lat": 43.529676633279244
				},
				{
					"lng": 11.46708069210084,
					"lat": 43.52969879514377
				},
				{
					"lng": 11.467082514166481,
					"lat": 43.52970883992302
				},
				{
					"lng": 11.467093327310694,
					"lat": 43.52973290808132
				},
				{
					"lng": 11.46709591477729,
					"lat": 43.52974736888619
				},
				{
					"lng": 11.46709893595037,
					"lat": 43.52975528856332
				},
				{
					"lng": 11.467126158524493,
					"lat": 43.52981836219181
				},
				{
					"lng": 11.46712771391781,
					"lat": 43.5298461085681
				},
				{
					"lng": 11.467126372711522,
					"lat": 43.52988500366833
				},
				{
					"lng": 11.467130054677027,
					"lat": 43.52989287008484
				},
				{
					"lng": 11.467137056531543,
					"lat": 43.52989899589635
				},
				{
					"lng": 11.467137950015779,
					"lat": 43.529901266807606
				},
				{
					"lng": 11.467139778173769,
					"lat": 43.52990277838836
				},
				{
					"lng": 11.467146170121136,
					"lat": 43.52991344083806
				},
				{
					"lng": 11.46714884853699,
					"lat": 43.52992019261094
				},
				{
					"lng": 11.46714966695476,
					"lat": 43.52993500409951
				},
				{
					"lng": 11.46715843642025,
					"lat": 43.529942059611486
				},
				{
					"lng": 11.467169304771033,
					"lat": 43.52994557002815
				},
				{
					"lng": 11.467172400869721,
					"lat": 43.529947163291865
				},
				{
					"lng": 11.467175357155304,
					"lat": 43.52994817696108
				},
				{
					"lng": 11.467178614945064,
					"lat": 43.52994978388494
				},
				{
					"lng": 11.46722786823532,
					"lat": 43.52993334272689
				},
				{
					"lng": 11.467226085226583,
					"lat": 43.52993137619983
				},
				{
					"lng": 11.467230531481853,
					"lat": 43.529916613206304
				},
				{
					"lng": 11.467231062607413,
					"lat": 43.52991347038661
				},
				{
					"lng": 11.467237265927048,
					"lat": 43.52990267295214
				},
				{
					"lng": 11.467237733607849,
					"lat": 43.52989866994723
				},
				{
					"lng": 11.46724013684486,
					"lat": 43.52989200571714
				},
				{
					"lng": 11.467246437209786,
					"lat": 43.52984608688374
				},
				{
					"lng": 11.467238565706404,
					"lat": 43.529835313715985
				},
				{
					"lng": 11.467240636825446,
					"lat": 43.52981645249378
				},
				{
					"lng": 11.467250239456767,
					"lat": 43.529804108174424
				},
				{
					"lng": 11.467252587924147,
					"lat": 43.52978247062107
				},
				{
					"lng": 11.467252341246143,
					"lat": 43.529758314187134
				},
				{
					"lng": 11.467261506746139,
					"lat": 43.52972612191154
				}
			], [
				{
					"lng": 11.467815180116748,
					"lat": 43.52981400912701
				},
				{
					"lng": 11.467815211790365,
					"lat": 43.52981294081208
				},
				{
					"lng": 11.467817326539533,
					"lat": 43.52980357488753
				},
				{
					"lng": 11.467822017604917,
					"lat": 43.529786255052024
				},
				{
					"lng": 11.467824944278885,
					"lat": 43.52977535157337
				},
				{
					"lng": 11.46782774728961,
					"lat": 43.52976337285253
				},
				{
					"lng": 11.46783055110551,
					"lat": 43.52974965569606
				},
				{
					"lng": 11.467834368365065,
					"lat": 43.529730950980884
				},
				{
					"lng": 11.46783627887227,
					"lat": 43.52972158893595
				},
				{
					"lng": 11.467838444879987,
					"lat": 43.52971239980124
				},
				{
					"lng": 11.467840982440938,
					"lat": 43.52970311708536
				},
				{
					"lng": 11.467843654596678,
					"lat": 43.52969333061351
				},
				{
					"lng": 11.467846066325016,
					"lat": 43.52968447662999
				},
				{
					"lng": 11.46784960485431,
					"lat": 43.529674319187485
				},
				{
					"lng": 11.467853956617045,
					"lat": 43.529665660089805
				},
				{
					"lng": 11.467858960717754,
					"lat": 43.529657332665096
				},
				{
					"lng": 11.467872471849516,
					"lat": 43.529634978105655
				},
				{
					"lng": 11.46787793175422,
					"lat": 43.529624435721985
				},
				{
					"lng": 11.46788327686695,
					"lat": 43.52961307174477
				},
				{
					"lng": 11.467890224621398,
					"lat": 43.52960559155772
				},
				{
					"lng": 11.46789798173014,
					"lat": 43.52959786119783
				},
				{
					"lng": 11.467908245064946,
					"lat": 43.52958768419223
				},
				{
					"lng": 11.467917427454603,
					"lat": 43.52957997423638
				},
				{
					"lng": 11.467927397141903,
					"lat": 43.529571011738405
				},
				{
					"lng": 11.467934260426834,
					"lat": 43.52956312727106
				},
				{
					"lng": 11.467940916249544,
					"lat": 43.5295553731183
				},
				{
					"lng": 11.467951345395633,
					"lat": 43.5295434251443
				},
				{
					"lng": 11.467965339339528,
					"lat": 43.52952649571962
				},
				{
					"lng": 11.467952056173624,
					"lat": 43.52951372346757
				},
				{
					"lng": 11.467935396088322,
					"lat": 43.52949737660774
				},
				{
					"lng": 11.467923239208407,
					"lat": 43.52949071661917
				},
				{
					"lng": 11.467914315028057,
					"lat": 43.529482239563706
				},
				{
					"lng": 11.467906074836923,
					"lat": 43.529474560615384
				},
				{
					"lng": 11.4678951812844,
					"lat": 43.52946871659175
				},
				{
					"lng": 11.467882535462062,
					"lat": 43.52946345860105
				},
				{
					"lng": 11.467869783886036,
					"lat": 43.529456724975994
				},
				{
					"lng": 11.467860128700073,
					"lat": 43.529448973386984
				},
				{
					"lng": 11.467850284412608,
					"lat": 43.52944234984742
				},
				{
					"lng": 11.467838092641404,
					"lat": 43.52943501831981
				},
				{
					"lng": 11.467827560108773,
					"lat": 43.52942869517956
				},
				{
					"lng": 11.467815729022604,
					"lat": 43.529423384460756
				},
				{
					"lng": 11.467804234223946,
					"lat": 43.52941895755196
				},
				{
					"lng": 11.467794259272276,
					"lat": 43.52941331628294
				},
				{
					"lng": 11.467783114216612,
					"lat": 43.52940672706505
				},
				{
					"lng": 11.467772629296794,
					"lat": 43.529401419437626
				},
				{
					"lng": 11.467761366626013,
					"lat": 43.529395949245135
				},
				{
					"lng": 11.467750276690237,
					"lat": 43.52939116659018
				},
				{
					"lng": 11.467738210420848,
					"lat": 43.52938811226753
				},
				{
					"lng": 11.467724612550159,
					"lat": 43.52938409715726
				},
				{
					"lng": 11.46771441058432,
					"lat": 43.52937840907666
				},
				{
					"lng": 11.467698990740988,
					"lat": 43.52936929663331
				},
				{
					"lng": 11.467687490233846,
					"lat": 43.52936454816005
				},
				{
					"lng": 11.467675114055854,
					"lat": 43.52936740299052
				},
				{
					"lng": 11.467662271417991,
					"lat": 43.52937088190837
				},
				{
					"lng": 11.46764826391119,
					"lat": 43.529375638951215
				},
				{
					"lng": 11.467640927184192,
					"lat": 43.5293830231931
				},
				{
					"lng": 11.467638624495825,
					"lat": 43.52939209549542
				},
				{
					"lng": 11.467636247733203,
					"lat": 43.52940282773669
				},
				{
					"lng": 11.467635972612243,
					"lat": 43.52941208829357
				},
				{
					"lng": 11.467636555334632,
					"lat": 43.52942197226165
				},
				{
					"lng": 11.467638836903795,
					"lat": 43.5294326836824
				},
				{
					"lng": 11.467643787537847,
					"lat": 43.52944258407489
				},
				{
					"lng": 11.467648554256808,
					"lat": 43.52945380117639
				},
				{
					"lng": 11.467652027272635,
					"lat": 43.529463315747506
				},
				{
					"lng": 11.46765668220145,
					"lat": 43.52947613472679
				},
				{
					"lng": 11.467659794873263,
					"lat": 43.52948559253991
				},
				{
					"lng": 11.467665837568777,
					"lat": 43.52950450519478
				},
				{
					"lng": 11.467671406068709,
					"lat": 43.529512810796135
				},
				{
					"lng": 11.46767805896045,
					"lat": 43.52952055015893
				},
				{
					"lng": 11.467685320217228,
					"lat": 43.52952952185982
				},
				{
					"lng": 11.46769295692933,
					"lat": 43.52953969125785
				},
				{
					"lng": 11.46769841024722,
					"lat": 43.52954790659582
				},
				{
					"lng": 11.46770288439894,
					"lat": 43.52955702248333
				},
				{
					"lng": 11.467707845193278,
					"lat": 43.52956725695595
				},
				{
					"lng": 11.467713561746296,
					"lat": 43.529576599756176
				},
				{
					"lng": 11.467719981499108,
					"lat": 43.52958466015486
				},
				{
					"lng": 11.467725715040944,
					"lat": 43.52959272700242
				},
				{
					"lng": 11.467735269701553,
					"lat": 43.529606672347654
				},
				{
					"lng": 11.467745654091473,
					"lat": 43.52962250627187
				},
				{
					"lng": 11.467745416450077,
					"lat": 43.52963176678932
				},
				{
					"lng": 11.467742508196851,
					"lat": 43.529640762191974
				},
				{
					"lng": 11.46773812567005,
					"lat": 43.52964989467485
				},
				{
					"lng": 11.467735164764777,
					"lat": 43.529659315098016
				},
				{
					"lng": 11.467731274854417,
					"lat": 43.529672841365986
				},
				{
					"lng": 11.467730263263824,
					"lat": 43.52968258765442
				},
				{
					"lng": 11.467728455619413,
					"lat": 43.529694232849536
				},
				{
					"lng": 11.467724457335153,
					"lat": 43.52970285229112
				},
				{
					"lng": 11.467720893231705,
					"lat": 43.5297129873556
				},
				{
					"lng": 11.46771816153471,
					"lat": 43.529722325608745
				},
				{
					"lng": 11.467711093758513,
					"lat": 43.52974646621713
				},
				{
					"lng": 11.46770709827016,
					"lat": 43.52976005421247
				},
				{
					"lng": 11.467704087755168,
					"lat": 43.52977030142413
				},
				{
					"lng": 11.467701886262873,
					"lat": 43.5297798825437
				},
				{
					"lng": 11.467700600622566,
					"lat": 43.52979006169146
				},
				{
					"lng": 11.46769840157653,
					"lat": 43.529806030048086
				},
				{
					"lng": 11.467696381986213,
					"lat": 43.529815859585945
				},
				{
					"lng": 11.46769378968104,
					"lat": 43.52982911844035
				},
				{
					"lng": 11.467691685836865,
					"lat": 43.5298399219985
				},
				{
					"lng": 11.467689849400452,
					"lat": 43.529849406302716
				},
				{
					"lng": 11.46768795775635,
					"lat": 43.529859029073435
				},
				{
					"lng": 11.467685108115605,
					"lat": 43.52986814012895
				},
				{
					"lng": 11.467681161050669,
					"lat": 43.5298776554437
				},
				{
					"lng": 11.467676594202253,
					"lat": 43.52988736059094
				},
				{
					"lng": 11.4676723146573,
					"lat": 43.529896397795056
				},
				{
					"lng": 11.46766337110552,
					"lat": 43.5299152595723
				},
				{
					"lng": 11.467658595129063,
					"lat": 43.52992578512274
				},
				{
					"lng": 11.467654812267956,
					"lat": 43.52993549423483
				},
				{
					"lng": 11.467652288168518,
					"lat": 43.52994501114374
				},
				{
					"lng": 11.467650225718673,
					"lat": 43.52995456501211
				},
				{
					"lng": 11.467648177664445,
					"lat": 43.529964037920294
				},
				{
					"lng": 11.467642642261701,
					"lat": 43.5299895452617
				},
				{
					"lng": 11.467639974968032,
					"lat": 43.53000628315977
				},
				{
					"lng": 11.467636925610552,
					"lat": 43.53001582561056
				},
				{
					"lng": 11.467634736223586,
					"lat": 43.53002515808306
				},
				{
					"lng": 11.467632095328607,
					"lat": 43.53003562146331
				},
				{
					"lng": 11.467629564791624,
					"lat": 43.53004560983021
				},
				{
					"lng": 11.467627115998326,
					"lat": 43.53005786323313
				},
				{
					"lng": 11.4676272243626,
					"lat": 43.530066993658465
				},
				{
					"lng": 11.467627621386738,
					"lat": 43.530084971341076
				},
				{
					"lng": 11.467628116990106,
					"lat": 43.530107107430574
				},
				{
					"lng": 11.467628321914896,
					"lat": 43.53011625899093
				},
				{
					"lng": 11.467626095442013,
					"lat": 43.530125432981144
				},
				{
					"lng": 11.46764531308145,
					"lat": 43.53015296509041
				},
				{
					"lng": 11.467651852802195,
					"lat": 43.53016561810542
				},
				{
					"lng": 11.467663314105717,
					"lat": 43.53017279649608
				},
				{
					"lng": 11.467683248126699,
					"lat": 43.5301816582294
				},
				{
					"lng": 11.467766892718206,
					"lat": 43.53020005514096
				},
				{
					"lng": 11.467772527284023,
					"lat": 43.530169098690216
				},
				{
					"lng": 11.46780543593967,
					"lat": 43.53017483364364
				},
				{
					"lng": 11.467806705789842,
					"lat": 43.53016469700619
				},
				{
					"lng": 11.467818529421304,
					"lat": 43.53015496641287
				},
				{
					"lng": 11.46781917151084,
					"lat": 43.530143032882854
				},
				{
					"lng": 11.46781987128162,
					"lat": 43.530130027317405
				},
				{
					"lng": 11.467802415766762,
					"lat": 43.530097028396355
				},
				{
					"lng": 11.467805144496092,
					"lat": 43.53008678657973
				},
				{
					"lng": 11.467801995101537,
					"lat": 43.530076617118716
				},
				{
					"lng": 11.467808420339448,
					"lat": 43.53006799650895
				},
				{
					"lng": 11.467826717553544,
					"lat": 43.53006156869293
				},
				{
					"lng": 11.467825962361859,
					"lat": 43.53005245881473
				},
				{
					"lng": 11.467827384439609,
					"lat": 43.530036557644294
				},
				{
					"lng": 11.46782719094955,
					"lat": 43.52998572908492
				},
				{
					"lng": 11.467827614747739,
					"lat": 43.52997091651299
				},
				{
					"lng": 11.467827991503146,
					"lat": 43.5299609671282
				},
				{
					"lng": 11.467824393350236,
					"lat": 43.52994461111227
				},
				{
					"lng": 11.467813747169291,
					"lat": 43.52992861695123
				},
				{
					"lng": 11.467826734430838,
					"lat": 43.52992313168584
				},
				{
					"lng": 11.467825895604076,
					"lat": 43.52991413616674
				},
				{
					"lng": 11.467824175165793,
					"lat": 43.5298955389468
				},
				{
					"lng": 11.467823233161084,
					"lat": 43.52988531334502
				},
				{
					"lng": 11.467820779257433,
					"lat": 43.52985875245574
				},
				{
					"lng": 11.467819893514447,
					"lat": 43.52984914791954
				},
				{
					"lng": 11.467818988545096,
					"lat": 43.52983984694422
				},
				{
					"lng": 11.467817513950756,
					"lat": 43.529829907521176
				},
				{
					"lng": 11.467815180116748,
					"lat": 43.52981400912701
				}
			], [
				{
					"lng": 11.467915511982222,
					"lat": 43.528988619380804
				},
				{
					"lng": 11.467914039077016,
					"lat": 43.528982787846594
				},
				{
					"lng": 11.467913362176306,
					"lat": 43.5289811162425
				},
				{
					"lng": 11.467879610311888,
					"lat": 43.52898240395155
				},
				{
					"lng": 11.467863120170687,
					"lat": 43.528982263167116
				},
				{
					"lng": 11.467839753683172,
					"lat": 43.52898120444465
				},
				{
					"lng": 11.467822802371344,
					"lat": 43.528980516381196
				},
				{
					"lng": 11.467790316700505,
					"lat": 43.52897588402954
				},
				{
					"lng": 11.467753296570317,
					"lat": 43.528977324433434
				},
				{
					"lng": 11.467747405343028,
					"lat": 43.52897619023297
				},
				{
					"lng": 11.467745758532827,
					"lat": 43.52897627408401
				},
				{
					"lng": 11.46773564354375,
					"lat": 43.52897388153293
				},
				{
					"lng": 11.467732909015918,
					"lat": 43.528973900944756
				},
				{
					"lng": 11.467730248314918,
					"lat": 43.528973441309795
				},
				{
					"lng": 11.46772205271632,
					"lat": 43.52897203103829
				},
				{
					"lng": 11.467715231730324,
					"lat": 43.528972359189915
				},
				{
					"lng": 11.467701861816332,
					"lat": 43.5289738971224
				},
				{
					"lng": 11.467697998818771,
					"lat": 43.52897508762532
				},
				{
					"lng": 11.467695209730552,
					"lat": 43.52897594699931
				},
				{
					"lng": 11.467686260116698,
					"lat": 43.52897934882932
				},
				{
					"lng": 11.467683493028568,
					"lat": 43.52898117467806
				},
				{
					"lng": 11.467674109015048,
					"lat": 43.528985443264425
				},
				{
					"lng": 11.467672231652514,
					"lat": 43.528988532287904
				},
				{
					"lng": 11.467670446110239,
					"lat": 43.52898931717204
				},
				{
					"lng": 11.46766450905475,
					"lat": 43.52900289404213
				},
				{
					"lng": 11.467665596178243,
					"lat": 43.52900494638707
				},
				{
					"lng": 11.467663054097953,
					"lat": 43.529009797520764
				},
				{
					"lng": 11.467664933756089,
					"lat": 43.529013440338616
				},
				{
					"lng": 11.467664437314388,
					"lat": 43.52901441936951
				},
				{
					"lng": 11.467664759578373,
					"lat": 43.529017480376986
				},
				{
					"lng": 11.467665719758074,
					"lat": 43.529018835622686
				},
				{
					"lng": 11.467667741405348,
					"lat": 43.52902158705777
				},
				{
					"lng": 11.467669454327773,
					"lat": 43.52902515523777
				},
				{
					"lng": 11.467673905868772,
					"lat": 43.52902811837502
				},
				{
					"lng": 11.467676493761301,
					"lat": 43.52903060506433
				},
				{
					"lng": 11.467684457570304,
					"lat": 43.529035608700674
				},
				{
					"lng": 11.467697005227468,
					"lat": 43.52903863916702
				},
				{
					"lng": 11.467711414967335,
					"lat": 43.529048851737926
				},
				{
					"lng": 11.467713553686243,
					"lat": 43.529054596053996
				},
				{
					"lng": 11.467712057733406,
					"lat": 43.52907683346197
				},
				{
					"lng": 11.467714396344112,
					"lat": 43.529081801313275
				},
				{
					"lng": 11.467717374993569,
					"lat": 43.529085508052475
				},
				{
					"lng": 11.467731357241982,
					"lat": 43.52909301916653
				},
				{
					"lng": 11.46773515218822,
					"lat": 43.52909256917171
				},
				{
					"lng": 11.467738523570654,
					"lat": 43.52909636779322
				},
				{
					"lng": 11.467739748671653,
					"lat": 43.52909622910666
				},
				{
					"lng": 11.467742687296461,
					"lat": 43.52909959481665
				},
				{
					"lng": 11.467743438510132,
					"lat": 43.52909955673929
				},
				{
					"lng": 11.46774592294302,
					"lat": 43.529101855532474
				},
				{
					"lng": 11.467747644997104,
					"lat": 43.529102910509785
				},
				{
					"lng": 11.467749861984004,
					"lat": 43.52910383185362
				},
				{
					"lng": 11.467756537134827,
					"lat": 43.529103966058756
				},
				{
					"lng": 11.46776162579767,
					"lat": 43.529104932149664
				},
				{
					"lng": 11.467761610767901,
					"lat": 43.52910618795056
				},
				{
					"lng": 11.467768727724975,
					"lat": 43.52910688240882
				},
				{
					"lng": 11.467768673607571,
					"lat": 43.52910884133108
				},
				{
					"lng": 11.467786734524617,
					"lat": 43.52911463170001
				},
				{
					"lng": 11.467786750750653,
					"lat": 43.52911530499594
				},
				{
					"lng": 11.467799577245144,
					"lat": 43.52913347499062
				},
				{
					"lng": 11.467837099254353,
					"lat": 43.52913218759018
				},
				{
					"lng": 11.467850274625208,
					"lat": 43.52912288890072
				},
				{
					"lng": 11.467880843445716,
					"lat": 43.52912070532647
				},
				{
					"lng": 11.467888045322956,
					"lat": 43.529116832675435
				},
				{
					"lng": 11.467899781867736,
					"lat": 43.52911646759092
				},
				{
					"lng": 11.467921868363835,
					"lat": 43.52910394790724
				},
				{
					"lng": 11.46793031777454,
					"lat": 43.52910362405713
				},
				{
					"lng": 11.467945685100332,
					"lat": 43.529094309496365
				},
				{
					"lng": 11.467952194861361,
					"lat": 43.5290869118566
				},
				{
					"lng": 11.467951175873788,
					"lat": 43.52908296756144
				},
				{
					"lng": 11.467974516227272,
					"lat": 43.529072385802756
				},
				{
					"lng": 11.467973429983545,
					"lat": 43.52906705067562
				},
				{
					"lng": 11.467980744518059,
					"lat": 43.52901008676994
				},
				{
					"lng": 11.467980467660546,
					"lat": 43.52900839897982
				},
				{
					"lng": 11.467950396471025,
					"lat": 43.52899131136783
				},
				{
					"lng": 11.467948580739318,
					"lat": 43.5289888080337
				},
				{
					"lng": 11.467915511982222,
					"lat": 43.528988619380804
				}
			], [
				{
					"lng": 11.468344903398444,
					"lat": 43.528816826531724
				},
				{
					"lng": 11.468335298328324,
					"lat": 43.52882136186236
				},
				{
					"lng": 11.468326839626423,
					"lat": 43.52882610432714
				},
				{
					"lng": 11.46831009610392,
					"lat": 43.52883888902541
				},
				{
					"lng": 11.468297131407029,
					"lat": 43.52885061728569
				},
				{
					"lng": 11.468271938503172,
					"lat": 43.52888742218166
				},
				{
					"lng": 11.468272094182188,
					"lat": 43.52888851942147
				},
				{
					"lng": 11.468266198051781,
					"lat": 43.5288947011068
				},
				{
					"lng": 11.468278319692605,
					"lat": 43.52889981808162
				},
				{
					"lng": 11.468276089908697,
					"lat": 43.528902157433286
				},
				{
					"lng": 11.468279906502216,
					"lat": 43.52890408650217
				},
				{
					"lng": 11.46827817968196,
					"lat": 43.528907390147104
				},
				{
					"lng": 11.468303022552929,
					"lat": 43.528929133669095
				},
				{
					"lng": 11.468306674246636,
					"lat": 43.528928949752554
				},
				{
					"lng": 11.468308320465487,
					"lat": 43.528929397855855
				},
				{
					"lng": 11.468311778988898,
					"lat": 43.528929424278274
				},
				{
					"lng": 11.468314203076561,
					"lat": 43.5289299303513
				},
				{
					"lng": 11.468317583797964,
					"lat": 43.52892966001806
				},
				{
					"lng": 11.468320374546808,
					"lat": 43.52892989212358
				},
				{
					"lng": 11.468329996380424,
					"lat": 43.528931632661575
				},
				{
					"lng": 11.468332449417717,
					"lat": 43.52893163061981
				},
				{
					"lng": 11.4683424858801,
					"lat": 43.5289334775908
				},
				{
					"lng": 11.468349112918462,
					"lat": 43.52893334197195
				},
				{
					"lng": 11.468353566753317,
					"lat": 43.528933907377194
				},
				{
					"lng": 11.46835906185412,
					"lat": 43.528933080760495
				},
				{
					"lng": 11.468369115521156,
					"lat": 43.52892024850575
				},
				{
					"lng": 11.468377236543645,
					"lat": 43.5289184337954
				},
				{
					"lng": 11.468409896820674,
					"lat": 43.52892912583486
				},
				{
					"lng": 11.468435714741092,
					"lat": 43.5289254009819
				},
				{
					"lng": 11.468447844617327,
					"lat": 43.52892432776565
				},
				{
					"lng": 11.468454580568391,
					"lat": 43.52892291775188
				},
				{
					"lng": 11.468457768042343,
					"lat": 43.52892300035377
				},
				{
					"lng": 11.46848861251076,
					"lat": 43.528919208523234
				},
				{
					"lng": 11.468518661558413,
					"lat": 43.52888133636391
				},
				{
					"lng": 11.468521014907497,
					"lat": 43.52887636459561
				},
				{
					"lng": 11.468499094412117,
					"lat": 43.52885383661369
				},
				{
					"lng": 11.46849370852143,
					"lat": 43.52885315761265
				},
				{
					"lng": 11.468476529165212,
					"lat": 43.5288457509559
				},
				{
					"lng": 11.468450500535141,
					"lat": 43.52883462867933
				},
				{
					"lng": 11.468443578231241,
					"lat": 43.528832666331745
				},
				{
					"lng": 11.468439797382986,
					"lat": 43.52883133954783
				},
				{
					"lng": 11.468431948304891,
					"lat": 43.52882745828889
				},
				{
					"lng": 11.468414815687902,
					"lat": 43.52881764448425
				},
				{
					"lng": 11.468409792731736,
					"lat": 43.52881646752037
				},
				{
					"lng": 11.46840660128414,
					"lat": 43.52881624634712
				},
				{
					"lng": 11.468404821898906,
					"lat": 43.528815562899204
				},
				{
					"lng": 11.46839798947965,
					"lat": 43.52881561372309
				},
				{
					"lng": 11.468391810214573,
					"lat": 43.52881402195873
				},
				{
					"lng": 11.468383854351332,
					"lat": 43.52881401096421
				},
				{
					"lng": 11.468376971295756,
					"lat": 43.52881305042526
				},
				{
					"lng": 11.468357738695723,
					"lat": 43.528813485967724
				},
				{
					"lng": 11.468344903398444,
					"lat": 43.528816826531724
				}
			], [
				{
					"lng": 11.469582890192882,
					"lat": 43.527933482069216
				},
				{
					"lng": 11.469594820215791,
					"lat": 43.52791550523971
				},
				{
					"lng": 11.46961644399329,
					"lat": 43.527871826187045
				},
				{
					"lng": 11.46967119432652,
					"lat": 43.527791865484424
				},
				{
					"lng": 11.469729071796657,
					"lat": 43.52771629816866
				},
				{
					"lng": 11.469739425442695,
					"lat": 43.527704727573116
				},
				{
					"lng": 11.469761816309823,
					"lat": 43.52766051697045
				},
				{
					"lng": 11.469756612071569,
					"lat": 43.52758353469171
				},
				{
					"lng": 11.46978633154962,
					"lat": 43.52755961837687
				},
				{
					"lng": 11.469726838589528,
					"lat": 43.527541179129834
				},
				{
					"lng": 11.469700898238514,
					"lat": 43.52756405555893
				},
				{
					"lng": 11.469639052533573,
					"lat": 43.52758866636299
				},
				{
					"lng": 11.469614118286303,
					"lat": 43.527616014937415
				},
				{
					"lng": 11.469517716724319,
					"lat": 43.5276872097245
				},
				{
					"lng": 11.4694084447119,
					"lat": 43.527799839181036
				},
				{
					"lng": 11.469335105891032,
					"lat": 43.52787871039999
				},
				{
					"lng": 11.469201515974696,
					"lat": 43.52803361415089
				},
				{
					"lng": 11.469200339263208,
					"lat": 43.52804753743096
				},
				{
					"lng": 11.469176824498081,
					"lat": 43.52807581840479
				},
				{
					"lng": 11.469177488933765,
					"lat": 43.52808359682928
				},
				{
					"lng": 11.46915863030132,
					"lat": 43.52811707468852
				},
				{
					"lng": 11.469158374376091,
					"lat": 43.52813753869859
				},
				{
					"lng": 11.469094529717582,
					"lat": 43.52817265410824
				},
				{
					"lng": 11.469105772488858,
					"lat": 43.528217485728774
				},
				{
					"lng": 11.469095637489728,
					"lat": 43.52823712486956
				},
				{
					"lng": 11.468975318172701,
					"lat": 43.52824921472355
				},
				{
					"lng": 11.468914758395757,
					"lat": 43.52826864563809
				},
				{
					"lng": 11.468895430474484,
					"lat": 43.52828303201948
				},
				{
					"lng": 11.468922276315185,
					"lat": 43.52833877293852
				},
				{
					"lng": 11.468937768803913,
					"lat": 43.52836620476946
				},
				{
					"lng": 11.468944823840383,
					"lat": 43.52840162372756
				},
				{
					"lng": 11.468944883146639,
					"lat": 43.52842168485639
				},
				{
					"lng": 11.4689373500412,
					"lat": 43.52843747316314
				},
				{
					"lng": 11.468934208828893,
					"lat": 43.52844992390671
				},
				{
					"lng": 11.468941067955086,
					"lat": 43.528482661098465
				},
				{
					"lng": 11.468957213643032,
					"lat": 43.52849867915023
				},
				{
					"lng": 11.468960563884691,
					"lat": 43.52850668807355
				},
				{
					"lng": 11.468953589562883,
					"lat": 43.528536373320605
				},
				{
					"lng": 11.468953779090207,
					"lat": 43.52855100415135
				},
				{
					"lng": 11.468961922010875,
					"lat": 43.52856045565135
				},
				{
					"lng": 11.4689637043965,
					"lat": 43.528579063622026
				},
				{
					"lng": 11.4689712005437,
					"lat": 43.528590903113574
				},
				{
					"lng": 11.468998125105129,
					"lat": 43.52861586899415
				},
				{
					"lng": 11.469005218881756,
					"lat": 43.528615639231944
				},
				{
					"lng": 11.46903321694696,
					"lat": 43.52862477914715
				},
				{
					"lng": 11.469065252342956,
					"lat": 43.52862456451597
				},
				{
					"lng": 11.469087146458252,
					"lat": 43.528627956911244
				},
				{
					"lng": 11.469095061542536,
					"lat": 43.528633380656515
				},
				{
					"lng": 11.46912368667959,
					"lat": 43.52862997790836
				},
				{
					"lng": 11.469180515045437,
					"lat": 43.52861126830818
				},
				{
					"lng": 11.469218586171829,
					"lat": 43.52858686011026
				},
				{
					"lng": 11.469259118175394,
					"lat": 43.52858534251171
				},
				{
					"lng": 11.469372495397364,
					"lat": 43.52853141994861
				},
				{
					"lng": 11.469396404429624,
					"lat": 43.52852769120952
				},
				{
					"lng": 11.469459736421701,
					"lat": 43.52849937225945
				},
				{
					"lng": 11.469465811292896,
					"lat": 43.528479879065564
				},
				{
					"lng": 11.469496182217917,
					"lat": 43.52846035706653
				},
				{
					"lng": 11.469501899974404,
					"lat": 43.52844103598841
				},
				{
					"lng": 11.469498009132508,
					"lat": 43.528412114808965
				},
				{
					"lng": 11.469479223550517,
					"lat": 43.528397025648694
				},
				{
					"lng": 11.469460900221907,
					"lat": 43.52837339387432
				},
				{
					"lng": 11.469446686731986,
					"lat": 43.528357984229686
				},
				{
					"lng": 11.469442601054713,
					"lat": 43.52833634643854
				},
				{
					"lng": 11.469456111205849,
					"lat": 43.52832490502262
				},
				{
					"lng": 11.469508357382141,
					"lat": 43.52829910314106
				},
				{
					"lng": 11.469542726559594,
					"lat": 43.528264192969885
				},
				{
					"lng": 11.469542540018974,
					"lat": 43.52824097680299
				},
				{
					"lng": 11.469529535062911,
					"lat": 43.528220449841236
				},
				{
					"lng": 11.469528504804058,
					"lat": 43.528201624441394
				},
				{
					"lng": 11.4695280891907,
					"lat": 43.52820035803499
				},
				{
					"lng": 11.469517767393405,
					"lat": 43.52818653844744
				},
				{
					"lng": 11.469518018573801,
					"lat": 43.52817775641743
				},
				{
					"lng": 11.469490511435149,
					"lat": 43.528128065972346
				},
				{
					"lng": 11.46946845017638,
					"lat": 43.528076648840866
				},
				{
					"lng": 11.469440660660057,
					"lat": 43.528059620927785
				},
				{
					"lng": 11.469432782536927,
					"lat": 43.528045624994434
				},
				{
					"lng": 11.469464204599017,
					"lat": 43.5280119096681
				},
				{
					"lng": 11.469582890192882,
					"lat": 43.527933482069216
				}
			], [
				{
					"lng": 11.467238027019459,
					"lat": 43.53021293610901
				},
				{
					"lng": 11.467238247996772,
					"lat": 43.53021257405043
				},
				{
					"lng": 11.467238733174572,
					"lat": 43.530211861045906
				},
				{
					"lng": 11.467239228446171,
					"lat": 43.53021118580713
				},
				{
					"lng": 11.467239724493462,
					"lat": 43.530210543490114
				},
				{
					"lng": 11.467240695934086,
					"lat": 43.530209342355455
				},
				{
					"lng": 11.467240682343459,
					"lat": 43.530208901895605
				},
				{
					"lng": 11.467242457411947,
					"lat": 43.53020648768367
				},
				{
					"lng": 11.467243010362488,
					"lat": 43.5302057476972
				},
				{
					"lng": 11.467244013806889,
					"lat": 43.53020440483692
				},
				{
					"lng": 11.467243959396338,
					"lat": 43.530203303339505
				},
				{
					"lng": 11.467244657669703,
					"lat": 43.530202272067754
				},
				{
					"lng": 11.467245316506245,
					"lat": 43.53020135928318
				},
				{
					"lng": 11.467245632832128,
					"lat": 43.530200947418656
				},
				{
					"lng": 11.467245940356785,
					"lat": 43.53020056879355
				},
				{
					"lng": 11.467246239237486,
					"lat": 43.53020022869532
				},
				{
					"lng": 11.467246529778318,
					"lat": 43.530199934984765
				},
				{
					"lng": 11.467246812429163,
					"lat": 43.530199698660695
				},
				{
					"lng": 11.46726062974235,
					"lat": 43.530185273434725
				},
				{
					"lng": 11.46726693883466,
					"lat": 43.53017868676193
				},
				{
					"lng": 11.467263858903,
					"lat": 43.530166767623236
				},
				{
					"lng": 11.467262527602696,
					"lat": 43.53016161557451
				},
				{
					"lng": 11.467259350464884,
					"lat": 43.53014932024637
				},
				{
					"lng": 11.467254842029595,
					"lat": 43.53013187286923
				},
				{
					"lng": 11.467254679197298,
					"lat": 43.530131242717715
				},
				{
					"lng": 11.467254208496419,
					"lat": 43.53012942113254
				},
				{
					"lng": 11.467250436464056,
					"lat": 43.53011482358112
				},
				{
					"lng": 11.467250178867493,
					"lat": 43.53011382669674
				},
				{
					"lng": 11.467249518890485,
					"lat": 43.53011210885282
				},
				{
					"lng": 11.467248930682272,
					"lat": 43.530110577814746
				},
				{
					"lng": 11.467248446581413,
					"lat": 43.530109317756
				},
				{
					"lng": 11.467247814590852,
					"lat": 43.530107672757325
				},
				{
					"lng": 11.467247457158136,
					"lat": 43.53010674240106
				},
				{
					"lng": 11.467246929137175,
					"lat": 43.53010536802318
				},
				{
					"lng": 11.46724802718542,
					"lat": 43.530103209833825
				},
				{
					"lng": 11.467256502998541,
					"lat": 43.53008925460255
				},
				{
					"lng": 11.467269270420426,
					"lat": 43.530068233323306
				},
				{
					"lng": 11.467270450308751,
					"lat": 43.53006629066236
				},
				{
					"lng": 11.467259850930652,
					"lat": 43.53003870169408
				},
				{
					"lng": 11.467257925982869,
					"lat": 43.530033691272315
				},
				{
					"lng": 11.46725718251913,
					"lat": 43.53003175611987
				},
				{
					"lng": 11.467251360451792,
					"lat": 43.53001660192913
				},
				{
					"lng": 11.467247081784695,
					"lat": 43.53000546503138
				},
				{
					"lng": 11.467246425485046,
					"lat": 43.53000375675552
				},
				{
					"lng": 11.46724503762365,
					"lat": 43.53000014430441
				},
				{
					"lng": 11.467244794924643,
					"lat": 43.52999951258547
				},
				{
					"lng": 11.467238229401401,
					"lat": 43.529982423241265
				},
				{
					"lng": 11.467232346447961,
					"lat": 43.52996711054308
				},
				{
					"lng": 11.467232143017528,
					"lat": 43.529963882187744
				},
				{
					"lng": 11.46721306989949,
					"lat": 43.52993828253762
				},
				{
					"lng": 11.467178614945064,
					"lat": 43.52994978388494
				},
				{
					"lng": 11.467167079577479,
					"lat": 43.52996365443792
				},
				{
					"lng": 11.46716707145401,
					"lat": 43.52996368768513
				},
				{
					"lng": 11.467167063577245,
					"lat": 43.5299637199226
				},
				{
					"lng": 11.467166883167655,
					"lat": 43.52996445829129
				},
				{
					"lng": 11.467166868116902,
					"lat": 43.52996451989006
				},
				{
					"lng": 11.46716669417911,
					"lat": 43.529965231771406
				},
				{
					"lng": 11.46716664677977,
					"lat": 43.529965425764345
				},
				{
					"lng": 11.467166478368139,
					"lat": 43.52996611502856
				},
				{
					"lng": 11.46716646576062,
					"lat": 43.529966166627766
				},
				{
					"lng": 11.467166412544085,
					"lat": 43.52996638442893
				},
				{
					"lng": 11.467166395637607,
					"lat": 43.52996645362267
				},
				{
					"lng": 11.467166229916469,
					"lat": 43.52996713187537
				},
				{
					"lng": 11.467166073350779,
					"lat": 43.52996777265724
				},
				{
					"lng": 11.467165966588166,
					"lat": 43.52996820960832
				},
				{
					"lng": 11.467165834669965,
					"lat": 43.52996874951447
				},
				{
					"lng": 11.467165821034083,
					"lat": 43.529968904250154
				},
				{
					"lng": 11.467165763544985,
					"lat": 43.52996955661844
				},
				{
					"lng": 11.467164892549416,
					"lat": 43.52997944039971
				},
				{
					"lng": 11.467164728809406,
					"lat": 43.5299812984691
				},
				{
					"lng": 11.467164194257304,
					"lat": 43.529987364395204
				},
				{
					"lng": 11.467162633647813,
					"lat": 43.53000507368691
				},
				{
					"lng": 11.467161073037657,
					"lat": 43.53002278297859
				},
				{
					"lng": 11.467160918191968,
					"lat": 43.53002454011622
				},
				{
					"lng": 11.467159978413163,
					"lat": 43.530035204413366
				},
				{
					"lng": 11.467159780119736,
					"lat": 43.530037454580764
				},
				{
					"lng": 11.467159675405034,
					"lat": 43.530038642848126
				},
				{
					"lng": 11.467159514159512,
					"lat": 43.53004047260821
				},
				{
					"lng": 11.467159512426813,
					"lat": 43.53004049227022
				},
				{
					"lng": 11.467159346259363,
					"lat": 43.53004237788261
				},
				{
					"lng": 11.467158396761084,
					"lat": 43.53005315246831
				},
				{
					"lng": 11.467158323318198,
					"lat": 43.53005398587321
				},
				{
					"lng": 11.467157951815288,
					"lat": 43.530058201561786
				},
				{
					"lng": 11.46715639120308,
					"lat": 43.5300759108533
				},
				{
					"lng": 11.467155969158942,
					"lat": 43.530080700063856
				},
				{
					"lng": 11.46716790627385,
					"lat": 43.530094230132065
				},
				{
					"lng": 11.467172737895314,
					"lat": 43.53009970650916
				},
				{
					"lng": 11.467178050081207,
					"lat": 43.53011248543924
				},
				{
					"lng": 11.467179537974165,
					"lat": 43.53011606469544
				},
				{
					"lng": 11.4671823927293,
					"lat": 43.53013123497398
				},
				{
					"lng": 11.467183266648577,
					"lat": 43.53013348204416
				},
				{
					"lng": 11.467184539241948,
					"lat": 43.530136754207255
				},
				{
					"lng": 11.467182506468996,
					"lat": 43.53015133838895
				},
				{
					"lng": 11.467181740845202,
					"lat": 43.53015683137491
				},
				{
					"lng": 11.467179250845835,
					"lat": 43.530168922692205
				},
				{
					"lng": 11.467178631026673,
					"lat": 43.53017193250362
				},
				{
					"lng": 11.467178593358428,
					"lat": 43.53017211541872
				},
				{
					"lng": 11.467177080590229,
					"lat": 43.53017946134561
				},
				{
					"lng": 11.467175637685283,
					"lat": 43.53018646801854
				},
				{
					"lng": 11.467169149774016,
					"lat": 43.53021797296679
				},
				{
					"lng": 11.46716949380698,
					"lat": 43.530218235728015
				},
				{
					"lng": 11.467169515453271,
					"lat": 43.53021825905573
				},
				{
					"lng": 11.467172490586247,
					"lat": 43.53022200336885
				},
				{
					"lng": 11.467188096409071,
					"lat": 43.530241643855625
				},
				{
					"lng": 11.467198980336324,
					"lat": 43.530255341658616
				},
				{
					"lng": 11.467197887091952,
					"lat": 43.53026065040198
				},
				{
					"lng": 11.46719702417093,
					"lat": 43.53026484070546
				},
				{
					"lng": 11.467195825304612,
					"lat": 43.53027066234236
				},
				{
					"lng": 11.467204237965984,
					"lat": 43.53027928195647
				},
				{
					"lng": 11.467214076763105,
					"lat": 43.53028936278549
				},
				{
					"lng": 11.467213668722431,
					"lat": 43.5302897623646
				},
				{
					"lng": 11.467213643346495,
					"lat": 43.530290402770596
				},
				{
					"lng": 11.467213570845411,
					"lat": 43.53029313948048
				},
				{
					"lng": 11.467213544786107,
					"lat": 43.5302938831531
				},
				{
					"lng": 11.467213513380337,
					"lat": 43.53029464450464
				},
				{
					"lng": 11.467213438024846,
					"lat": 43.53029622001611
				},
				{
					"lng": 11.46721331497541,
					"lat": 43.53029846459984
				},
				{
					"lng": 11.467213277281592,
					"lat": 43.530299152184384
				},
				{
					"lng": 11.467213166069252,
					"lat": 43.53029949621542
				},
				{
					"lng": 11.467204432292215,
					"lat": 43.53031566730892
				},
				{
					"lng": 11.467201195596983,
					"lat": 43.530321660235145
				},
				{
					"lng": 11.467195486357252,
					"lat": 43.53032966125601
				},
				{
					"lng": 11.4671948805551,
					"lat": 43.53033050031231
				},
				{
					"lng": 11.467194358899384,
					"lat": 43.53033157320769
				},
				{
					"lng": 11.467194163167033,
					"lat": 43.5303317455968
				},
				{
					"lng": 11.467179059463309,
					"lat": 43.53034504801407
				},
				{
					"lng": 11.467174956799447,
					"lat": 43.530348661387805
				},
				{
					"lng": 11.467175024623474,
					"lat": 43.53034957591294
				},
				{
					"lng": 11.46716865781209,
					"lat": 43.53035848043412
				},
				{
					"lng": 11.467167209702117,
					"lat": 43.53035800618903
				},
				{
					"lng": 11.467164932603895,
					"lat": 43.53035721898496
				},
				{
					"lng": 11.46715829992268,
					"lat": 43.530362812795914
				},
				{
					"lng": 11.467152756017493,
					"lat": 43.530367488363694
				},
				{
					"lng": 11.46713425172589,
					"lat": 43.53037164805926
				},
				{
					"lng": 11.467121642125186,
					"lat": 43.530374482648305
				},
				{
					"lng": 11.467115987867361,
					"lat": 43.53037875155353
				},
				{
					"lng": 11.467115780783931,
					"lat": 43.53037890789932
				},
				{
					"lng": 11.467115553272892,
					"lat": 43.53037907966772
				},
				{
					"lng": 11.467115292570417,
					"lat": 43.53037927649534
				},
				{
					"lng": 11.467115006920901,
					"lat": 43.53037949215769
				},
				{
					"lng": 11.467114697971171,
					"lat": 43.53037972541146
				},
				{
					"lng": 11.467114366687635,
					"lat": 43.53037997552702
				},
				{
					"lng": 11.467113638061367,
					"lat": 43.53038052563209
				},
				{
					"lng": 11.46711335191426,
					"lat": 43.53038074167011
				},
				{
					"lng": 11.467112370921118,
					"lat": 43.530381482309444
				},
				{
					"lng": 11.46710820456108,
					"lat": 43.53038462786651
				},
				{
					"lng": 11.467099965718335,
					"lat": 43.53038565000304
				},
				{
					"lng": 11.467099643368899,
					"lat": 43.53038568999471
				},
				{
					"lng": 11.467092348964275,
					"lat": 43.53038659496075
				},
				{
					"lng": 11.467091177756824,
					"lat": 43.53038674026426
				},
				{
					"lng": 11.467060422917518,
					"lat": 43.53039055579757
				},
				{
					"lng": 11.467058099763898,
					"lat": 43.5303908440143
				},
				{
					"lng": 11.467055525455782,
					"lat": 43.53039363795149
				},
				{
					"lng": 11.467055417755109,
					"lat": 43.53039369096973
				},
				{
					"lng": 11.467053418653608,
					"lat": 43.5303956935058
				},
				{
					"lng": 11.467052646311158,
					"lat": 43.530396001484725
				},
				{
					"lng": 11.467051617447256,
					"lat": 43.53039689170967
				},
				{
					"lng": 11.46705065228824,
					"lat": 43.53039767157704
				},
				{
					"lng": 11.467049767106229,
					"lat": 43.53039832370591
				},
				{
					"lng": 11.467049188109819,
					"lat": 43.53039856797608
				},
				{
					"lng": 11.467047697982734,
					"lat": 43.53039953263194
				},
				{
					"lng": 11.467047461151626,
					"lat": 43.53039968594808
				},
				{
					"lng": 11.467047127997688,
					"lat": 43.530399849801036
				},
				{
					"lng": 11.467046795910061,
					"lat": 43.53040003592309
				},
				{
					"lng": 11.467046086836632,
					"lat": 43.53040048760068
				},
				{
					"lng": 11.467042878320116,
					"lat": 43.530402402971255
				},
				{
					"lng": 11.46704158220046,
					"lat": 43.53040333227374
				},
				{
					"lng": 11.467040839894068,
					"lat": 43.5304038219748
				},
				{
					"lng": 11.467040056167662,
					"lat": 43.53040447157029
				},
				{
					"lng": 11.467039276485439,
					"lat": 43.530405271321044
				},
				{
					"lng": 11.467032646825096,
					"lat": 43.53041019836067
				},
				{
					"lng": 11.467031814744878,
					"lat": 43.53041108022097
				},
				{
					"lng": 11.46703106874446,
					"lat": 43.530411977937355
				},
				{
					"lng": 11.467028185686427,
					"lat": 43.53041393333873
				},
				{
					"lng": 11.467027227875027,
					"lat": 43.53041578054252
				},
				{
					"lng": 11.46702545781305,
					"lat": 43.530434786078565
				},
				{
					"lng": 11.467043771307162,
					"lat": 43.53045021280512
				},
				{
					"lng": 11.467046445249188,
					"lat": 43.5304486757268
				},
				{
					"lng": 11.467067422737793,
					"lat": 43.530436617105174
				},
				{
					"lng": 11.467076385702216,
					"lat": 43.53043146486538
				},
				{
					"lng": 11.467076396804574,
					"lat": 43.53043145894499
				},
				{
					"lng": 11.46707660790659,
					"lat": 43.53043135069619
				},
				{
					"lng": 11.46707662789211,
					"lat": 43.530431348106454
				},
				{
					"lng": 11.467076632444511,
					"lat": 43.530431347516526
				},
				{
					"lng": 11.467077061978339,
					"lat": 43.53043129185691
				},
				{
					"lng": 11.467077139646138,
					"lat": 43.530431281792595
				},
				{
					"lng": 11.467077889964711,
					"lat": 43.5304311845652
				},
				{
					"lng": 11.467078259308833,
					"lat": 43.530431136705026
				},
				{
					"lng": 11.467087887281181,
					"lat": 43.53042246302341
				},
				{
					"lng": 11.467090977603352,
					"lat": 43.53041967900239
				},
				{
					"lng": 11.467092739185308,
					"lat": 43.53041861139378
				},
				{
					"lng": 11.467105750040934,
					"lat": 43.53041205436607
				},
				{
					"lng": 11.46710884166226,
					"lat": 43.53041031006659
				},
				{
					"lng": 11.46711687660687,
					"lat": 43.53040577673249
				},
				{
					"lng": 11.46711987718834,
					"lat": 43.53040433260247
				},
				{
					"lng": 11.46712206557559,
					"lat": 43.530403230106906
				},
				{
					"lng": 11.46712323071418,
					"lat": 43.53040261315627
				},
				{
					"lng": 11.467129849210764,
					"lat": 43.53039837434052
				},
				{
					"lng": 11.46713019534994,
					"lat": 43.530398152655685
				},
				{
					"lng": 11.467131934568,
					"lat": 43.530396868583956
				},
				{
					"lng": 11.467131954113064,
					"lat": 43.5303968573158
				},
				{
					"lng": 11.467132118185972,
					"lat": 43.53039673093535
				},
				{
					"lng": 11.467132207510202,
					"lat": 43.53039671936056
				},
				{
					"lng": 11.46713224825558,
					"lat": 43.53039671408065
				},
				{
					"lng": 11.46713315085452,
					"lat": 43.53039659712006
				},
				{
					"lng": 11.467140384266681,
					"lat": 43.53039565979943
				},
				{
					"lng": 11.467152722599515,
					"lat": 43.53039406097146
				},
				{
					"lng": 11.467162921636538,
					"lat": 43.530392739357026
				},
				{
					"lng": 11.467165160681155,
					"lat": 43.530390818213874
				},
				{
					"lng": 11.467168674258163,
					"lat": 43.53039199391877
				},
				{
					"lng": 11.4671731699828,
					"lat": 43.53039284554338
				},
				{
					"lng": 11.467173216264248,
					"lat": 43.53039281932978
				},
				{
					"lng": 11.467176482813427,
					"lat": 43.53039337046193
				},
				{
					"lng": 11.467177087824256,
					"lat": 43.53039347253933
				},
				{
					"lng": 11.467198145951285,
					"lat": 43.53039228129049
				},
				{
					"lng": 11.46720149781283,
					"lat": 43.53039158598166
				},
				{
					"lng": 11.46720167604019,
					"lat": 43.53039150334761
				},
				{
					"lng": 11.467205123473363,
					"lat": 43.5303907584651
				},
				{
					"lng": 11.467205279907773,
					"lat": 43.53039067632162
				},
				{
					"lng": 11.467210898025794,
					"lat": 43.530389438183754
				},
				{
					"lng": 11.467213294453623,
					"lat": 43.5303825711748
				},
				{
					"lng": 11.467213940933522,
					"lat": 43.53037802744566
				},
				{
					"lng": 11.467216864386781,
					"lat": 43.53035748019495
				},
				{
					"lng": 11.467217917218193,
					"lat": 43.5303500804531
				},
				{
					"lng": 11.467218174169876,
					"lat": 43.530348962315735
				},
				{
					"lng": 11.467218492449557,
					"lat": 43.53034799484141
				},
				{
					"lng": 11.467218888474715,
					"lat": 43.5303472404391
				},
				{
					"lng": 11.467219958568181,
					"lat": 43.530340530916945
				},
				{
					"lng": 11.46722003040357,
					"lat": 43.53033707156637
				},
				{
					"lng": 11.467220124694993,
					"lat": 43.5303325308079
				},
				{
					"lng": 11.467220690568665,
					"lat": 43.53033200663502
				},
				{
					"lng": 11.467221316974785,
					"lat": 43.53033142639048
				},
				{
					"lng": 11.467221982553076,
					"lat": 43.53033080986044
				},
				{
					"lng": 11.467222672039373,
					"lat": 43.53033017118421
				},
				{
					"lng": 11.46722337477945,
					"lat": 43.53032952023094
				},
				{
					"lng": 11.467224793319694,
					"lat": 43.530328206226606
				},
				{
					"lng": 11.467230301639939,
					"lat": 43.53032310382813
				},
				{
					"lng": 11.46723189089114,
					"lat": 43.5303216316926
				},
				{
					"lng": 11.467235426540297,
					"lat": 43.530318356593426
				},
				{
					"lng": 11.46723785500766,
					"lat": 43.53031610708504
				},
				{
					"lng": 11.467239030441453,
					"lat": 43.530315018271416
				},
				{
					"lng": 11.467248860827839,
					"lat": 43.53030591230471
				},
				{
					"lng": 11.46724978815185,
					"lat": 43.530301304913124
				},
				{
					"lng": 11.467251044310018,
					"lat": 43.53029506371424
				},
				{
					"lng": 11.467251076538174,
					"lat": 43.530294903589244
				},
				{
					"lng": 11.467251096110358,
					"lat": 43.53029480634517
				},
				{
					"lng": 11.467251502682121,
					"lat": 43.530292786300514
				},
				{
					"lng": 11.46725150286031,
					"lat": 43.53029278541521
				},
				{
					"lng": 11.467251503339785,
					"lat": 43.53029278303297
				},
				{
					"lng": 11.46725063216488,
					"lat": 43.530292229796274
				},
				{
					"lng": 11.467235978361943,
					"lat": 43.53028292826217
				},
				{
					"lng": 11.467236038173622,
					"lat": 43.53028282045998
				},
				{
					"lng": 11.467236506139209,
					"lat": 43.53028201304711
				},
				{
					"lng": 11.46723673128248,
					"lat": 43.530281648199676
				},
				{
					"lng": 11.467236952287083,
					"lat": 43.53028131507722
				},
				{
					"lng": 11.467237170809005,
					"lat": 43.53028102015271
				},
				{
					"lng": 11.46723738888471,
					"lat": 43.53028077213084
				},
				{
					"lng": 11.467237481730928,
					"lat": 43.53027876032412
				},
				{
					"lng": 11.46723814272062,
					"lat": 43.53026443789278
				},
				{
					"lng": 11.467238309485671,
					"lat": 43.530264138388866
				},
				{
					"lng": 11.467238467463837,
					"lat": 43.53026391013444
				},
				{
					"lng": 11.467238625740304,
					"lat": 43.53026372367172
				},
				{
					"lng": 11.467250506652558,
					"lat": 43.530261231498066
				},
				{
					"lng": 11.467249928386384,
					"lat": 43.530258993646505
				},
				{
					"lng": 11.46724988779436,
					"lat": 43.53025883655806
				},
				{
					"lng": 11.467249460839675,
					"lat": 43.53025718427181
				},
				{
					"lng": 11.467245419944186,
					"lat": 43.53024154626942
				},
				{
					"lng": 11.467245215474952,
					"lat": 43.53024075498657
				},
				{
					"lng": 11.467244942251996,
					"lat": 43.53023969763117
				},
				{
					"lng": 11.467244811273542,
					"lat": 43.530239190752916
				},
				{
					"lng": 11.467244675938147,
					"lat": 43.53023866701357
				},
				{
					"lng": 11.467244554193197,
					"lat": 43.53023819586836
				},
				{
					"lng": 11.467244279146113,
					"lat": 43.53023713145358
				},
				{
					"lng": 11.467244224756278,
					"lat": 43.53023692096836
				},
				{
					"lng": 11.467243794112893,
					"lat": 43.530235254405675
				},
				{
					"lng": 11.467243748844053,
					"lat": 43.53023507921815
				},
				{
					"lng": 11.467243702159198,
					"lat": 43.53023489855073
				},
				{
					"lng": 11.467243108116367,
					"lat": 43.530232599642304
				},
				{
					"lng": 11.467243065581584,
					"lat": 43.53023243503536
				},
				{
					"lng": 11.467243020253168,
					"lat": 43.53023225961724
				},
				{
					"lng": 11.467241919797795,
					"lat": 43.53022800092365
				},
				{
					"lng": 11.467241883312404,
					"lat": 43.53022785972741
				},
				{
					"lng": 11.467241844361592,
					"lat": 43.53022770899023
				},
				{
					"lng": 11.46724180332429,
					"lat": 43.53022755017836
				},
				{
					"lng": 11.4672417604689,
					"lat": 43.53022738433071
				},
				{
					"lng": 11.467241715978657,
					"lat": 43.53022721215622
				},
				{
					"lng": 11.467240911504797,
					"lat": 43.53022409889207
				},
				{
					"lng": 11.46723982860073,
					"lat": 43.53021990811959
				},
				{
					"lng": 11.46723977514837,
					"lat": 43.530219701262226
				},
				{
					"lng": 11.46723896322114,
					"lat": 43.530216559153125
				},
				{
					"lng": 11.467238738844749,
					"lat": 43.530215690830055
				},
				{
					"lng": 11.467238583740022,
					"lat": 43.530215090584136
				},
				{
					"lng": 11.467238445870665,
					"lat": 43.530214557037986
				},
				{
					"lng": 11.467238386832584,
					"lat": 43.530214328564185
				},
				{
					"lng": 11.467238308832291,
					"lat": 43.53021402670771
				},
				{
					"lng": 11.46723826224645,
					"lat": 43.5302138464233
				},
				{
					"lng": 11.467238182273007,
					"lat": 43.53021353693089
				},
				{
					"lng": 11.467238151522517,
					"lat": 43.530213417928366
				},
				{
					"lng": 11.467238027019459,
					"lat": 43.53021293610901
				}
			], [
				{
					"lng": 11.467638093552129,
					"lat": 43.52976271994633
				},
				{
					"lng": 11.467633629046288,
					"lat": 43.52974118095693
				},
				{
					"lng": 11.467626318707639,
					"lat": 43.5297179104069
				},
				{
					"lng": 11.467626843868896,
					"lat": 43.52970691961235
				},
				{
					"lng": 11.467636117591544,
					"lat": 43.52969398085432
				},
				{
					"lng": 11.46764573009469,
					"lat": 43.52966630690537
				},
				{
					"lng": 11.467647372417478,
					"lat": 43.52965894712452
				},
				{
					"lng": 11.467644220295865,
					"lat": 43.529648301538316
				},
				{
					"lng": 11.467646461779758,
					"lat": 43.52962231918131
				},
				{
					"lng": 11.467643409950817,
					"lat": 43.529547433375534
				},
				{
					"lng": 11.467639668893003,
					"lat": 43.52952644776203
				},
				{
					"lng": 11.467637243027232,
					"lat": 43.529510059770466
				},
				{
					"lng": 11.467645020480049,
					"lat": 43.52945296901944
				},
				{
					"lng": 11.467643564487481,
					"lat": 43.529446460253276
				},
				{
					"lng": 11.467636088207106,
					"lat": 43.52943268805255
				},
				{
					"lng": 11.46763302582269,
					"lat": 43.52941406213863
				},
				{
					"lng": 11.467632538303073,
					"lat": 43.529401230887665
				},
				{
					"lng": 11.467629786940096,
					"lat": 43.52938737452467
				},
				{
					"lng": 11.467635622486911,
					"lat": 43.52937543989503
				},
				{
					"lng": 11.467640370925075,
					"lat": 43.52937087087606
				},
				{
					"lng": 11.467646479399994,
					"lat": 43.52936495856521
				},
				{
					"lng": 11.467714001291501,
					"lat": 43.52932244978957
				},
				{
					"lng": 11.46773768530764,
					"lat": 43.52932024871586
				},
				{
					"lng": 11.467759668066268,
					"lat": 43.5292969194875
				},
				{
					"lng": 11.467783866869437,
					"lat": 43.529264997337776
				},
				{
					"lng": 11.467787390010544,
					"lat": 43.52925039212286
				},
				{
					"lng": 11.46779182675608,
					"lat": 43.529243385512906
				},
				{
					"lng": 11.467795146009818,
					"lat": 43.529194044016705
				},
				{
					"lng": 11.467809587826801,
					"lat": 43.529174954794456
				},
				{
					"lng": 11.467814740000122,
					"lat": 43.52914036093234
				},
				{
					"lng": 11.467815571838344,
					"lat": 43.52913292620897
				},
				{
					"lng": 11.467799577245144,
					"lat": 43.52913347499062
				},
				{
					"lng": 11.467794728774892,
					"lat": 43.529126606655765
				},
				{
					"lng": 11.467788633893583,
					"lat": 43.529129533752354
				},
				{
					"lng": 11.467742644241962,
					"lat": 43.52915094173255
				},
				{
					"lng": 11.467729478196803,
					"lat": 43.529164320917474
				},
				{
					"lng": 11.467727742105366,
					"lat": 43.52916497340272
				},
				{
					"lng": 11.467721832953293,
					"lat": 43.529167456248864
				},
				{
					"lng": 11.467716626637134,
					"lat": 43.52916961620202
				},
				{
					"lng": 11.467711976156686,
					"lat": 43.52917151138661
				},
				{
					"lng": 11.467707767297627,
					"lat": 43.529173184958836
				},
				{
					"lng": 11.467703911313041,
					"lat": 43.529174668564046
				},
				{
					"lng": 11.46770060234884,
					"lat": 43.52917589427715
				},
				{
					"lng": 11.467698216974897,
					"lat": 43.52917692204569
				},
				{
					"lng": 11.467693959541574,
					"lat": 43.52917876479258
				},
				{
					"lng": 11.467687179934673,
					"lat": 43.52918171821213
				},
				{
					"lng": 11.467684000235375,
					"lat": 43.529182938863876
				},
				{
					"lng": 11.467679661106704,
					"lat": 43.52918486431488
				},
				{
					"lng": 11.46767423846641,
					"lat": 43.52918728607523
				},
				{
					"lng": 11.46767194537389,
					"lat": 43.52918818128843
				},
				{
					"lng": 11.467666424872863,
					"lat": 43.52919069780996
				},
				{
					"lng": 11.467660893019945,
					"lat": 43.529193236208705
				},
				{
					"lng": 11.46765983098621,
					"lat": 43.5291936591347
				},
				{
					"lng": 11.467650726467985,
					"lat": 43.529197923785304
				},
				{
					"lng": 11.467648191133382,
					"lat": 43.52919833049255
				},
				{
					"lng": 11.46763412058846,
					"lat": 43.52920061136685
				},
				{
					"lng": 11.467606308434867,
					"lat": 43.52920514498139
				},
				{
					"lng": 11.46759797097323,
					"lat": 43.529212762383665
				},
				{
					"lng": 11.46757404396135,
					"lat": 43.52922575494712
				},
				{
					"lng": 11.467567995757227,
					"lat": 43.52922793558468
				},
				{
					"lng": 11.467564261069988,
					"lat": 43.52923121597479
				},
				{
					"lng": 11.46752117633224,
					"lat": 43.529249993645266
				},
				{
					"lng": 11.467490173521302,
					"lat": 43.5292627397654
				},
				{
					"lng": 11.4674782590844,
					"lat": 43.52926945867958
				},
				{
					"lng": 11.46747125686168,
					"lat": 43.5292706535578
				},
				{
					"lng": 11.467469696233671,
					"lat": 43.52927093630214
				},
				{
					"lng": 11.467465048145137,
					"lat": 43.52927170989877
				},
				{
					"lng": 11.467451233032307,
					"lat": 43.52927404716621
				},
				{
					"lng": 11.467433123580811,
					"lat": 43.529280106555866
				},
				{
					"lng": 11.46742991150975,
					"lat": 43.52928092741704
				},
				{
					"lng": 11.467428143226694,
					"lat": 43.52928140192525
				},
				{
					"lng": 11.467424299352244,
					"lat": 43.52928297164387
				},
				{
					"lng": 11.467423322868484,
					"lat": 43.529283693034806
				},
				{
					"lng": 11.467422970211741,
					"lat": 43.529283919300546
				},
				{
					"lng": 11.467422577861859,
					"lat": 43.52928412606485
				},
				{
					"lng": 11.467422128183228,
					"lat": 43.52928430195812
				},
				{
					"lng": 11.467421612601433,
					"lat": 43.52928443238364
				},
				{
					"lng": 11.467420970211215,
					"lat": 43.52928453362569
				},
				{
					"lng": 11.467420263949517,
					"lat": 43.52928460837411
				},
				{
					"lng": 11.467419551001406,
					"lat": 43.52928466084625
				},
				{
					"lng": 11.467419413292365,
					"lat": 43.52928466795416
				},
				{
					"lng": 11.467404449901833,
					"lat": 43.52929122980091
				},
				{
					"lng": 11.467361500073112,
					"lat": 43.52931339638427
				},
				{
					"lng": 11.46737917270973,
					"lat": 43.52933826731284
				},
				{
					"lng": 11.467379779653934,
					"lat": 43.52934258547613
				},
				{
					"lng": 11.467377636038268,
					"lat": 43.5293433521393
				},
				{
					"lng": 11.467379630613182,
					"lat": 43.529374684466575
				},
				{
					"lng": 11.467378299738044,
					"lat": 43.52938351945078
				},
				{
					"lng": 11.467377802839161,
					"lat": 43.52938385435413
				},
				{
					"lng": 11.467377583318711,
					"lat": 43.52938399595077
				},
				{
					"lng": 11.467376781759512,
					"lat": 43.52938453666811
				},
				{
					"lng": 11.467367550764202,
					"lat": 43.529419217040356
				},
				{
					"lng": 11.467367499756003,
					"lat": 43.52941955188331
				},
				{
					"lng": 11.467364891075674,
					"lat": 43.52943163628027
				},
				{
					"lng": 11.467364179000755,
					"lat": 43.529444608350325
				},
				{
					"lng": 11.467363193982786,
					"lat": 43.529462046093485
				},
				{
					"lng": 11.467366558227887,
					"lat": 43.52946888266211
				},
				{
					"lng": 11.467366604216553,
					"lat": 43.529469251356744
				},
				{
					"lng": 11.467366649009278,
					"lat": 43.529469659279584
				},
				{
					"lng": 11.467366690282118,
					"lat": 43.52947011477444
				},
				{
					"lng": 11.467366724536786,
					"lat": 43.529470628919086
				},
				{
					"lng": 11.46736674788582,
					"lat": 43.52947120584984
				},
				{
					"lng": 11.467366761827952,
					"lat": 43.529471861982636
				},
				{
					"lng": 11.4673667681717,
					"lat": 43.52947260825581
				},
				{
					"lng": 11.467366768302398,
					"lat": 43.5294734593409
				},
				{
					"lng": 11.467366753647461,
					"lat": 43.52947556045209
				},
				{
					"lng": 11.467366722008686,
					"lat": 43.529478414899856
				},
				{
					"lng": 11.467366125691893,
					"lat": 43.52949478267692
				},
				{
					"lng": 11.467365967914207,
					"lat": 43.52949493324175
				},
				{
					"lng": 11.467366293584789,
					"lat": 43.52949743403584
				},
				{
					"lng": 11.467366452626464,
					"lat": 43.529498757224154
				},
				{
					"lng": 11.467361239792753,
					"lat": 43.52950274249008
				},
				{
					"lng": 11.467355089767649,
					"lat": 43.52951579194424
				},
				{
					"lng": 11.4673532909095,
					"lat": 43.529517537318384
				},
				{
					"lng": 11.467353351666471,
					"lat": 43.52951899157453
				},
				{
					"lng": 11.467351699806152,
					"lat": 43.52952067314445
				},
				{
					"lng": 11.467350106178944,
					"lat": 43.529522316066114
				},
				{
					"lng": 11.46735016633076,
					"lat": 43.52952274147045
				},
				{
					"lng": 11.46735018846685,
					"lat": 43.52952296934803
				},
				{
					"lng": 11.467350200492746,
					"lat": 43.52952320847464
				},
				{
					"lng": 11.467349863898438,
					"lat": 43.52952356641432
				},
				{
					"lng": 11.467325646926419,
					"lat": 43.52955423321471
				},
				{
					"lng": 11.467308619241992,
					"lat": 43.52957792239996
				},
				{
					"lng": 11.467305285338423,
					"lat": 43.52958521277982
				},
				{
					"lng": 11.467298955606982,
					"lat": 43.52959379727584
				},
				{
					"lng": 11.467291474062689,
					"lat": 43.52961294605232
				},
				{
					"lng": 11.467276627789373,
					"lat": 43.52966884666737
				},
				{
					"lng": 11.467257237451799,
					"lat": 43.52974178001397
				},
				{
					"lng": 11.467264020004595,
					"lat": 43.52976019548445
				},
				{
					"lng": 11.467264114414316,
					"lat": 43.529776449003435
				},
				{
					"lng": 11.467256530424073,
					"lat": 43.52984114824389
				},
				{
					"lng": 11.467255990618865,
					"lat": 43.5299072845325
				},
				{
					"lng": 11.467266553797673,
					"lat": 43.52989532073644
				},
				{
					"lng": 11.46732578852376,
					"lat": 43.52992558186338
				},
				{
					"lng": 11.467330716350586,
					"lat": 43.52992705344338
				},
				{
					"lng": 11.467336558536331,
					"lat": 43.52995157927402
				},
				{
					"lng": 11.467337563855878,
					"lat": 43.52996367919667
				},
				{
					"lng": 11.467351505356024,
					"lat": 43.52998434870102
				},
				{
					"lng": 11.467370528347693,
					"lat": 43.5299985700888
				},
				{
					"lng": 11.467471677878208,
					"lat": 43.53003116212959
				},
				{
					"lng": 11.467527758897887,
					"lat": 43.53003473749778
				},
				{
					"lng": 11.467536487170221,
					"lat": 43.530027113309636
				},
				{
					"lng": 11.467554164521129,
					"lat": 43.5300208722358
				},
				{
					"lng": 11.467570153202747,
					"lat": 43.53001758810702
				},
				{
					"lng": 11.46758161156143,
					"lat": 43.530016254043126
				},
				{
					"lng": 11.46762335476061,
					"lat": 43.529977821353896
				},
				{
					"lng": 11.467625257128649,
					"lat": 43.52995135110996
				},
				{
					"lng": 11.467627158380255,
					"lat": 43.52994060562553
				},
				{
					"lng": 11.467638244528075,
					"lat": 43.529900418527816
				},
				{
					"lng": 11.467647302384425,
					"lat": 43.52987376922465
				},
				{
					"lng": 11.467653970309229,
					"lat": 43.529848550137146
				},
				{
					"lng": 11.467655317586168,
					"lat": 43.529821460449064
				},
				{
					"lng": 11.467645041859388,
					"lat": 43.52980302733167
				},
				{
					"lng": 11.467638093552129,
					"lat": 43.52976271994633
				}
			], [
				{
					"lng": 11.469267204834663,
					"lat": 43.530347894208525
				},
				{
					"lng": 11.469296648504939,
					"lat": 43.5303610117325
				},
				{
					"lng": 11.469337640898882,
					"lat": 43.53036535978684
				},
				{
					"lng": 11.469437510013991,
					"lat": 43.53031357857618
				},
				{
					"lng": 11.4695597121734,
					"lat": 43.53027272871909
				},
				{
					"lng": 11.46966205478527,
					"lat": 43.530233354824354
				},
				{
					"lng": 11.469732760636775,
					"lat": 43.53021973591367
				},
				{
					"lng": 11.46981131066821,
					"lat": 43.530222220328454
				},
				{
					"lng": 11.469863460471107,
					"lat": 43.53023149801657
				},
				{
					"lng": 11.4699047943265,
					"lat": 43.530247418127644
				},
				{
					"lng": 11.469950600040717,
					"lat": 43.530243874452935
				},
				{
					"lng": 11.469970940548952,
					"lat": 43.530225837718035
				},
				{
					"lng": 11.469971742721702,
					"lat": 43.5301825308706
				},
				{
					"lng": 11.469952836909119,
					"lat": 43.53016694054948
				},
				{
					"lng": 11.469919972391239,
					"lat": 43.530183085858454
				},
				{
					"lng": 11.469913682189633,
					"lat": 43.53017958384767
				},
				{
					"lng": 11.469910404258165,
					"lat": 43.53017997056523
				},
				{
					"lng": 11.469867387336926,
					"lat": 43.53018456840949
				},
				{
					"lng": 11.469838520892907,
					"lat": 43.53017905733239
				},
				{
					"lng": 11.469793429629776,
					"lat": 43.53017699117813
				},
				{
					"lng": 11.46970866327985,
					"lat": 43.5301787204821
				},
				{
					"lng": 11.469699740955027,
					"lat": 43.53018040919567
				},
				{
					"lng": 11.469690681785886,
					"lat": 43.530176068121655
				},
				{
					"lng": 11.469659871501806,
					"lat": 43.53017988156643
				},
				{
					"lng": 11.469629905330283,
					"lat": 43.53018167920718
				},
				{
					"lng": 11.469630284858527,
					"lat": 43.53018336258219
				},
				{
					"lng": 11.46959024692973,
					"lat": 43.53019235859952
				},
				{
					"lng": 11.469537589763258,
					"lat": 43.53019867759381
				},
				{
					"lng": 11.469517914998068,
					"lat": 43.5302295884927
				},
				{
					"lng": 11.469488984932033,
					"lat": 43.530224895220975
				},
				{
					"lng": 11.469482127821639,
					"lat": 43.530227304623565
				},
				{
					"lng": 11.469464191230403,
					"lat": 43.53024837783322
				},
				{
					"lng": 11.46944237530494,
					"lat": 43.530245126570755
				},
				{
					"lng": 11.4693538275239,
					"lat": 43.53028080025089
				},
				{
					"lng": 11.469361117675522,
					"lat": 43.5302818205803
				},
				{
					"lng": 11.469350481626673,
					"lat": 43.53029276908173
				},
				{
					"lng": 11.469332225070254,
					"lat": 43.53029547777305
				},
				{
					"lng": 11.469295057549674,
					"lat": 43.530329948533925
				},
				{
					"lng": 11.469283616552346,
					"lat": 43.5303264537377
				},
				{
					"lng": 11.469260957834178,
					"lat": 43.53033382336778
				},
				{
					"lng": 11.469267204834663,
					"lat": 43.530347894208525
				}
			], [
				{
					"lng": 11.47036295850835,
					"lat": 43.530351045464286
				},
				{
					"lng": 11.470509821533474,
					"lat": 43.53038315102346
				},
				{
					"lng": 11.470770954786799,
					"lat": 43.530457239160064
				},
				{
					"lng": 11.470871445854803,
					"lat": 43.530470589554476
				},
				{
					"lng": 11.471068065956578,
					"lat": 43.5304633131966
				},
				{
					"lng": 11.471262605451985,
					"lat": 43.53045379116679
				},
				{
					"lng": 11.471352211860003,
					"lat": 43.530440336724894
				},
				{
					"lng": 11.47145524187694,
					"lat": 43.530427477816964
				},
				{
					"lng": 11.471520931872018,
					"lat": 43.530431098226714
				},
				{
					"lng": 11.471600344182708,
					"lat": 43.53043216172606
				},
				{
					"lng": 11.471634702720191,
					"lat": 43.53040708074033
				},
				{
					"lng": 11.471651600183257,
					"lat": 43.530352477603564
				},
				{
					"lng": 11.471626870620085,
					"lat": 43.53028556295622
				},
				{
					"lng": 11.47157852035414,
					"lat": 43.53024905893746
				},
				{
					"lng": 11.471451865007106,
					"lat": 43.53023858624714
				},
				{
					"lng": 11.471265619540993,
					"lat": 43.53025725563512
				},
				{
					"lng": 11.470891509481554,
					"lat": 43.53027312967945
				},
				{
					"lng": 11.470597895131833,
					"lat": 43.53027502943807
				},
				{
					"lng": 11.470463935513603,
					"lat": 43.530253454924456
				},
				{
					"lng": 11.47031082477335,
					"lat": 43.53021227190045
				},
				{
					"lng": 11.470241595003554,
					"lat": 43.530202646900506
				},
				{
					"lng": 11.47018873975431,
					"lat": 43.530219361258546
				},
				{
					"lng": 11.47015157838192,
					"lat": 43.53024574637655
				},
				{
					"lng": 11.470151545440109,
					"lat": 43.530282452745446
				},
				{
					"lng": 11.470186623383945,
					"lat": 43.53031728875518
				},
				{
					"lng": 11.470219212149273,
					"lat": 43.53032881956733
				},
				{
					"lng": 11.470253616960017,
					"lat": 43.53033859046522
				},
				{
					"lng": 11.47036295850835,
					"lat": 43.530351045464286
				}
			], [
				{
					"lng": 11.470090191216325,
					"lat": 43.52980727623121
				},
				{
					"lng": 11.47003913901065,
					"lat": 43.529783133675565
				},
				{
					"lng": 11.470011705529005,
					"lat": 43.529778773924434
				},
				{
					"lng": 11.469957749005701,
					"lat": 43.52977126940808
				},
				{
					"lng": 11.469944540386368,
					"lat": 43.5297814625746
				},
				{
					"lng": 11.46994177782863,
					"lat": 43.52981805820077
				},
				{
					"lng": 11.469954875552864,
					"lat": 43.529846882017736
				},
				{
					"lng": 11.469991724228946,
					"lat": 43.52987333234005
				},
				{
					"lng": 11.470018707770652,
					"lat": 43.52988760951178
				},
				{
					"lng": 11.470174198641688,
					"lat": 43.52998333028284
				},
				{
					"lng": 11.470344181041886,
					"lat": 43.530016810451116
				},
				{
					"lng": 11.470543909653717,
					"lat": 43.53002797409715
				},
				{
					"lng": 11.4706850243358,
					"lat": 43.530021826223106
				},
				{
					"lng": 11.470715956841104,
					"lat": 43.530010538279065
				},
				{
					"lng": 11.470746854149676,
					"lat": 43.529971932275366
				},
				{
					"lng": 11.470742282089335,
					"lat": 43.52993978752945
				},
				{
					"lng": 11.470708604728395,
					"lat": 43.5299145361244
				},
				{
					"lng": 11.470620841435851,
					"lat": 43.52989745693454
				},
				{
					"lng": 11.470518772105873,
					"lat": 43.52988764973127
				},
				{
					"lng": 11.470437987258702,
					"lat": 43.529899624659784
				},
				{
					"lng": 11.470381004788422,
					"lat": 43.52990423495936
				},
				{
					"lng": 11.470371791340627,
					"lat": 43.52990383862282
				},
				{
					"lng": 11.470217396948394,
					"lat": 43.52986402278144
				},
				{
					"lng": 11.470090191216325,
					"lat": 43.52980727623121
				}
			], [
				{
					"lng": 11.470817916839266,
					"lat": 43.52949798899283
				},
				{
					"lng": 11.470818624184663,
					"lat": 43.52950063070621
				},
				{
					"lng": 11.470818368120543,
					"lat": 43.52950812508737
				},
				{
					"lng": 11.470817494849033,
					"lat": 43.5295155950115
				},
				{
					"lng": 11.47081673730098,
					"lat": 43.52952207504116
				},
				{
					"lng": 11.470815978391412,
					"lat": 43.52952856671613
				},
				{
					"lng": 11.470815220500983,
					"lat": 43.529535049672305
				},
				{
					"lng": 11.470814462844867,
					"lat": 43.529541530623064
				},
				{
					"lng": 11.470813820140297,
					"lat": 43.5295470282834
				},
				{
					"lng": 11.470812963013545,
					"lat": 43.52955436009824
				},
				{
					"lng": 11.470813363407434,
					"lat": 43.52956134802006
				},
				{
					"lng": 11.470815245049957,
					"lat": 43.52957097013157
				},
				{
					"lng": 11.470816856788018,
					"lat": 43.52957921203616
				},
				{
					"lng": 11.470819515718018,
					"lat": 43.52959280893443
				},
				{
					"lng": 11.470821447466937,
					"lat": 43.529602687262226
				},
				{
					"lng": 11.470822539303931,
					"lat": 43.52960827055539
				},
				{
					"lng": 11.470824848224227,
					"lat": 43.52962007760605
				},
				{
					"lng": 11.470826092299149,
					"lat": 43.529626439389396
				},
				{
					"lng": 11.470827185539779,
					"lat": 43.529632029855286
				},
				{
					"lng": 11.47082836106677,
					"lat": 43.529638041104796
				},
				{
					"lng": 11.470829371953693,
					"lat": 43.52964321043924
				},
				{
					"lng": 11.470833536742024,
					"lat": 43.52966450775027
				},
				{
					"lng": 11.47083524189532,
					"lat": 43.52967322731942
				},
				{
					"lng": 11.470836699429118,
					"lat": 43.52968068064511
				},
				{
					"lng": 11.470837751499442,
					"lat": 43.529686060568956
				},
				{
					"lng": 11.470838981705594,
					"lat": 43.52969235141642
				},
				{
					"lng": 11.47084068821256,
					"lat": 43.52970107789866
				},
				{
					"lng": 11.470841187057779,
					"lat": 43.529706717261696
				},
				{
					"lng": 11.470840360358746,
					"lat": 43.52971177543922
				},
				{
					"lng": 11.470839202833083,
					"lat": 43.5297188577859
				},
				{
					"lng": 11.47083766214799,
					"lat": 43.52972828450001
				},
				{
					"lng": 11.470835847506612,
					"lat": 43.52973938741811
				},
				{
					"lng": 11.470834721149775,
					"lat": 43.529746279052155
				},
				{
					"lng": 11.470833853596503,
					"lat": 43.52975158719121
				},
				{
					"lng": 11.470832754631711,
					"lat": 43.52975831122429
				},
				{
					"lng": 11.470831722500051,
					"lat": 43.5297646263366
				},
				{
					"lng": 11.470830401899779,
					"lat": 43.52977270644662
				},
				{
					"lng": 11.470829181804252,
					"lat": 43.529780171615286
				},
				{
					"lng": 11.470828037634588,
					"lat": 43.529787172229256
				},
				{
					"lng": 11.4708264841342,
					"lat": 43.52979667733528
				},
				{
					"lng": 11.47082479245154,
					"lat": 43.52980702790779
				},
				{
					"lng": 11.470819444280766,
					"lat": 43.529815854459784
				},
				{
					"lng": 11.470815542983157,
					"lat": 43.52982229310925
				},
				{
					"lng": 11.470812000501398,
					"lat": 43.52982813957257
				},
				{
					"lng": 11.470805956030679,
					"lat": 43.52983811528143
				},
				{
					"lng": 11.470802349666279,
					"lat": 43.52984406717252
				},
				{
					"lng": 11.470796670748156,
					"lat": 43.529853439573415
				},
				{
					"lng": 11.470794055340201,
					"lat": 43.52986057268897
				},
				{
					"lng": 11.470796269765682,
					"lat": 43.52986674351307
				},
				{
					"lng": 11.470800266012509,
					"lat": 43.529877879642385
				},
				{
					"lng": 11.47081612897237,
					"lat": 43.52988748665058
				},
				{
					"lng": 11.470826126947722,
					"lat": 43.52989354167362
				},
				{
					"lng": 11.470845525105526,
					"lat": 43.52990528967536
				},
				{
					"lng": 11.470853986499858,
					"lat": 43.529910414101465
				},
				{
					"lng": 11.470863339599145,
					"lat": 43.529910762818076
				},
				{
					"lng": 11.470872307889735,
					"lat": 43.52991109718693
				},
				{
					"lng": 11.470881903571655,
					"lat": 43.52991145494629
				},
				{
					"lng": 11.470890657530587,
					"lat": 43.5299117813227
				},
				{
					"lng": 11.470902673552066,
					"lat": 43.529912229318434
				},
				{
					"lng": 11.47090923312411,
					"lat": 43.52991247387974
				},
				{
					"lng": 11.47092388548824,
					"lat": 43.529910620489886
				},
				{
					"lng": 11.470931382819012,
					"lat": 43.52990687415527
				},
				{
					"lng": 11.470960218809365,
					"lat": 43.529892465115836
				},
				{
					"lng": 11.470966686156165,
					"lat": 43.5298892334491
				},
				{
					"lng": 11.47097573387784,
					"lat": 43.529884712394434
				},
				{
					"lng": 11.470987047510466,
					"lat": 43.52987905908508
				},
				{
					"lng": 11.471001744760143,
					"lat": 43.52987171501289
				},
				{
					"lng": 11.471009019327484,
					"lat": 43.529853019974205
				},
				{
					"lng": 11.471012030388062,
					"lat": 43.529845281793285
				},
				{
					"lng": 11.471020029942457,
					"lat": 43.52982472357931
				},
				{
					"lng": 11.471033107938453,
					"lat": 43.52979111414767
				},
				{
					"lng": 11.471033364536966,
					"lat": 43.52976212109408
				},
				{
					"lng": 11.4710334323459,
					"lat": 43.52975445937286
				},
				{
					"lng": 11.471033659582448,
					"lat": 43.52972878397087
				},
				{
					"lng": 11.471033807046961,
					"lat": 43.52971212201184
				},
				{
					"lng": 11.471033906368577,
					"lat": 43.5296854787647
				},
				{
					"lng": 11.471023689485966,
					"lat": 43.52966314597848
				},
				{
					"lng": 11.471009966665672,
					"lat": 43.52963314963624
				},
				{
					"lng": 11.470998947188669,
					"lat": 43.52960906243502
				},
				{
					"lng": 11.470993801750378,
					"lat": 43.529597815141884
				},
				{
					"lng": 11.470990416532057,
					"lat": 43.529590259115494
				},
				{
					"lng": 11.4709795657289,
					"lat": 43.52956603940632
				},
				{
					"lng": 11.470970151917182,
					"lat": 43.529545027139406
				},
				{
					"lng": 11.470937518905616,
					"lat": 43.52947763117198
				},
				{
					"lng": 11.47093370235021,
					"lat": 43.529469748945075
				},
				{
					"lng": 11.470930830675298,
					"lat": 43.52946381815234
				},
				{
					"lng": 11.470913741251671,
					"lat": 43.52942852379971
				},
				{
					"lng": 11.47090457257819,
					"lat": 43.52941029582424
				},
				{
					"lng": 11.470888291114141,
					"lat": 43.52938680428663
				},
				{
					"lng": 11.470883484584343,
					"lat": 43.529379869231995
				},
				{
					"lng": 11.47087776660412,
					"lat": 43.52937161909762
				},
				{
					"lng": 11.470874293885702,
					"lat": 43.529366608516945
				},
				{
					"lng": 11.470870061761008,
					"lat": 43.52936050223247
				},
				{
					"lng": 11.470866253640096,
					"lat": 43.5293550077169
				},
				{
					"lng": 11.470863221107331,
					"lat": 43.52935063225144
				},
				{
					"lng": 11.47085742120192,
					"lat": 43.52934226390254
				},
				{
					"lng": 11.47084772438593,
					"lat": 43.52932827292013
				},
				{
					"lng": 11.470832936634134,
					"lat": 43.52930693650236
				},
				{
					"lng": 11.470820514145291,
					"lat": 43.52929316277214
				},
				{
					"lng": 11.47081351899009,
					"lat": 43.52928540672384
				},
				{
					"lng": 11.470809844870379,
					"lat": 43.52928133295332
				},
				{
					"lng": 11.470806430086144,
					"lat": 43.52927754672677
				},
				{
					"lng": 11.470801210171745,
					"lat": 43.52927203698139
				},
				{
					"lng": 11.470794257754257,
					"lat": 43.52926592941109
				},
				{
					"lng": 11.470786250261876,
					"lat": 43.529258894974824
				},
				{
					"lng": 11.470778260563018,
					"lat": 43.529251876167656
				},
				{
					"lng": 11.470769385444571,
					"lat": 43.52924407953261
				},
				{
					"lng": 11.470763117475462,
					"lat": 43.5292385732306
				},
				{
					"lng": 11.470746452267996,
					"lat": 43.52922393312852
				},
				{
					"lng": 11.470740444706252,
					"lat": 43.52921865558502
				},
				{
					"lng": 11.47072314816919,
					"lat": 43.529203460856564
				},
				{
					"lng": 11.470713687119963,
					"lat": 43.52919671711691
				},
				{
					"lng": 11.470698061639046,
					"lat": 43.529199342980824
				},
				{
					"lng": 11.470688490781365,
					"lat": 43.529200951363386
				},
				{
					"lng": 11.470687828766234,
					"lat": 43.52920658864319
				},
				{
					"lng": 11.470687097410575,
					"lat": 43.52921281637967
				},
				{
					"lng": 11.470685972718556,
					"lat": 43.5292223935039
				},
				{
					"lng": 11.470685290509314,
					"lat": 43.52922820273986
				},
				{
					"lng": 11.470684123045912,
					"lat": 43.52923814407241
				},
				{
					"lng": 11.470685703643701,
					"lat": 43.52924386013048
				},
				{
					"lng": 11.470689822356547,
					"lat": 43.52924829469155
				},
				{
					"lng": 11.470695443561741,
					"lat": 43.52925434696395
				},
				{
					"lng": 11.470710768919922,
					"lat": 43.529270847553384
				},
				{
					"lng": 11.470714606869334,
					"lat": 43.5292749798157
				},
				{
					"lng": 11.470721494903655,
					"lat": 43.52928239605668
				},
				{
					"lng": 11.470726927714278,
					"lat": 43.529288245479
				},
				{
					"lng": 11.47073220735689,
					"lat": 43.5292939299863
				},
				{
					"lng": 11.470736362672572,
					"lat": 43.52929840394774
				},
				{
					"lng": 11.470741408938864,
					"lat": 43.52930383718021
				},
				{
					"lng": 11.470745998946292,
					"lat": 43.52930877916511
				},
				{
					"lng": 11.470749438127484,
					"lat": 43.529313720126005
				},
				{
					"lng": 11.470752558758202,
					"lat": 43.52932018466513
				},
				{
					"lng": 11.470755689607161,
					"lat": 43.52932667037031
				},
				{
					"lng": 11.470760430821107,
					"lat": 43.52933649202156
				},
				{
					"lng": 11.470762509050576,
					"lat": 43.52934079717209
				},
				{
					"lng": 11.470765384095376,
					"lat": 43.52934675296206
				},
				{
					"lng": 11.47076761106961,
					"lat": 43.529351366242636
				},
				{
					"lng": 11.470771238978791,
					"lat": 43.5293588816233
				},
				{
					"lng": 11.470774366370893,
					"lat": 43.52936536015817
				},
				{
					"lng": 11.470778392721382,
					"lat": 43.52937370092389
				},
				{
					"lng": 11.470781687604092,
					"lat": 43.52938052641935
				},
				{
					"lng": 11.470784417574226,
					"lat": 43.529386181672095
				},
				{
					"lng": 11.470786685059709,
					"lat": 43.52939087886672
				},
				{
					"lng": 11.470789389858352,
					"lat": 43.52939648197348
				},
				{
					"lng": 11.470792545677767,
					"lat": 43.52940323548707
				},
				{
					"lng": 11.470794331599528,
					"lat": 43.52940990536783
				},
				{
					"lng": 11.470796068578018,
					"lat": 43.52941639245865
				},
				{
					"lng": 11.470798405159837,
					"lat": 43.52942511888458
				},
				{
					"lng": 11.470800095206215,
					"lat": 43.529431430694565
				},
				{
					"lng": 11.47080175238342,
					"lat": 43.529437619746766
				},
				{
					"lng": 11.470803992837219,
					"lat": 43.529445987157196
				},
				{
					"lng": 11.470805669469376,
					"lat": 43.529452248864345
				},
				{
					"lng": 11.470807296197279,
					"lat": 43.529458324192994
				},
				{
					"lng": 11.470809295494703,
					"lat": 43.52946579095251
				},
				{
					"lng": 11.470811692411107,
					"lat": 43.52947474269353
				},
				{
					"lng": 11.470813273132485,
					"lat": 43.52948064619712
				},
				{
					"lng": 11.470815419703566,
					"lat": 43.52948866297161
				},
				{
					"lng": 11.470817916839266,
					"lat": 43.52949798899283
				}
			], [
				{
					"lng": 11.469531559190063,
					"lat": 43.52940393088108
				},
				{
					"lng": 11.469539524163535,
					"lat": 43.52937081288106
				},
				{
					"lng": 11.469532404925658,
					"lat": 43.52937002922197
				},
				{
					"lng": 11.469507905649229,
					"lat": 43.52936733317794
				},
				{
					"lng": 11.469483415219983,
					"lat": 43.52936460682962
				},
				{
					"lng": 11.46945890228892,
					"lat": 43.529361957561754
				},
				{
					"lng": 11.469427525849152,
					"lat": 43.52935857317223
				},
				{
					"lng": 11.469394822448855,
					"lat": 43.52935504730912
				},
				{
					"lng": 11.469364535749516,
					"lat": 43.52935139624711
				},
				{
					"lng": 11.469338888335152,
					"lat": 43.5293476220599
				},
				{
					"lng": 11.469312511515012,
					"lat": 43.52934370935308
				},
				{
					"lng": 11.469264024215382,
					"lat": 43.5293365660398
				},
				{
					"lng": 11.469240942241916,
					"lat": 43.529329015164095
				},
				{
					"lng": 11.46921798644785,
					"lat": 43.52932103208639
				},
				{
					"lng": 11.46918861434638,
					"lat": 43.52931337474356
				},
				{
					"lng": 11.469152078837933,
					"lat": 43.52931860515208
				},
				{
					"lng": 11.469064417917979,
					"lat": 43.52934073862778
				},
				{
					"lng": 11.469040498662132,
					"lat": 43.529345474211134
				},
				{
					"lng": 11.46895761155821,
					"lat": 43.5293582420181
				},
				{
					"lng": 11.468831414235446,
					"lat": 43.5293898940638
				},
				{
					"lng": 11.468760829407822,
					"lat": 43.52939568986016
				},
				{
					"lng": 11.468736783292709,
					"lat": 43.52940113747442
				},
				{
					"lng": 11.468689047776644,
					"lat": 43.529414332609875
				},
				{
					"lng": 11.468665173786514,
					"lat": 43.529420890042296
				},
				{
					"lng": 11.468641298489635,
					"lat": 43.52942743907959
				},
				{
					"lng": 11.468649938715288,
					"lat": 43.529460271927746
				},
				{
					"lng": 11.468675231551094,
					"lat": 43.5294616303321
				},
				{
					"lng": 11.468751276145856,
					"lat": 43.5294665092426
				},
				{
					"lng": 11.468783292358163,
					"lat": 43.52946808879398
				},
				{
					"lng": 11.46885508833373,
					"lat": 43.52946023487739
				},
				{
					"lng": 11.46897386170205,
					"lat": 43.5294270103271
				},
				{
					"lng": 11.469013547052883,
					"lat": 43.529414931473966
				},
				{
					"lng": 11.469167232919313,
					"lat": 43.529371568355124
				},
				{
					"lng": 11.469189002895241,
					"lat": 43.52936087032451
				},
				{
					"lng": 11.469216819422895,
					"lat": 43.52935548080099
				},
				{
					"lng": 11.469261713713557,
					"lat": 43.529353267321014
				},
				{
					"lng": 11.469290679125828,
					"lat": 43.52935810534801
				},
				{
					"lng": 11.469315783999491,
					"lat": 43.52936165537081
				},
				{
					"lng": 11.469364497482887,
					"lat": 43.5293679219059
				},
				{
					"lng": 11.46938855764834,
					"lat": 43.52937228162057
				},
				{
					"lng": 11.469412575702917,
					"lat": 43.52937681548627
				},
				{
					"lng": 11.469436555553656,
					"lat": 43.52938150734676
				},
				{
					"lng": 11.46946053634283,
					"lat": 43.52938619533594
				},
				{
					"lng": 11.469484581586945,
					"lat": 43.529390616790224
				},
				{
					"lng": 11.469508628224586,
					"lat": 43.52939503249031
				},
				{
					"lng": 11.469531559190063,
					"lat": 43.52940393088108
				}
			], [
				{
					"lng": 11.469804556468484,
					"lat": 43.52950793439583
				},
				{
					"lng": 11.469808416028503,
					"lat": 43.529508613297345
				},
				{
					"lng": 11.469831744853993,
					"lat": 43.52951005048139
				},
				{
					"lng": 11.469835889044926,
					"lat": 43.52951080676703
				},
				{
					"lng": 11.469843793589897,
					"lat": 43.52951074413864
				},
				{
					"lng": 11.469871026090063,
					"lat": 43.5295124559133
				},
				{
					"lng": 11.469873308299166,
					"lat": 43.529512406589994
				},
				{
					"lng": 11.469897000694097,
					"lat": 43.52951409855198
				},
				{
					"lng": 11.469901290744694,
					"lat": 43.529514767933286
				},
				{
					"lng": 11.46990594897854,
					"lat": 43.5295158154757
				},
				{
					"lng": 11.469916257812985,
					"lat": 43.52951816840432
				},
				{
					"lng": 11.469926660097647,
					"lat": 43.52951954722825
				},
				{
					"lng": 11.469943767390241,
					"lat": 43.52952237584998
				},
				{
					"lng": 11.469964459756152,
					"lat": 43.52952677546913
				},
				{
					"lng": 11.469990592255364,
					"lat": 43.529532645019714
				},
				{
					"lng": 11.469997534869359,
					"lat": 43.52953522435464
				},
				{
					"lng": 11.47002986616318,
					"lat": 43.52954234995839
				},
				{
					"lng": 11.470077572053047,
					"lat": 43.52954942954331
				},
				{
					"lng": 11.470089256417461,
					"lat": 43.52955144735014
				},
				{
					"lng": 11.470096796644748,
					"lat": 43.52955239921643
				},
				{
					"lng": 11.470117977035672,
					"lat": 43.52955236547129
				},
				{
					"lng": 11.470136591941186,
					"lat": 43.52954406006549
				},
				{
					"lng": 11.470144763670053,
					"lat": 43.52954048506605
				},
				{
					"lng": 11.470149568398284,
					"lat": 43.52953916194852
				},
				{
					"lng": 11.470159206791978,
					"lat": 43.52953780718624
				},
				{
					"lng": 11.470161201487615,
					"lat": 43.529532743895295
				},
				{
					"lng": 11.470146454755737,
					"lat": 43.529500588237546
				},
				{
					"lng": 11.470116730247565,
					"lat": 43.529488468922544
				},
				{
					"lng": 11.470083693065723,
					"lat": 43.529478136486546
				},
				{
					"lng": 11.47005766612708,
					"lat": 43.529469329840616
				},
				{
					"lng": 11.47004321513024,
					"lat": 43.52946216647297
				},
				{
					"lng": 11.470023345844593,
					"lat": 43.529441487582936
				},
				{
					"lng": 11.469986794845763,
					"lat": 43.52946121245718
				},
				{
					"lng": 11.469984545884222,
					"lat": 43.5294605998526
				},
				{
					"lng": 11.469978181537313,
					"lat": 43.529461202727724
				},
				{
					"lng": 11.469937824468989,
					"lat": 43.52945376350343
				},
				{
					"lng": 11.469913371781733,
					"lat": 43.52944997586244
				},
				{
					"lng": 11.469876468220944,
					"lat": 43.529444562696234
				},
				{
					"lng": 11.469864845537877,
					"lat": 43.52944166376201
				},
				{
					"lng": 11.469856155962235,
					"lat": 43.52944070148638
				},
				{
					"lng": 11.469831952561016,
					"lat": 43.52944181550417
				},
				{
					"lng": 11.469819247028367,
					"lat": 43.529444402313004
				},
				{
					"lng": 11.4698056508849,
					"lat": 43.52944523858017
				},
				{
					"lng": 11.469804707169144,
					"lat": 43.52944500631845
				},
				{
					"lng": 11.469802329136684,
					"lat": 43.52945012141153
				},
				{
					"lng": 11.469799028555894,
					"lat": 43.52950537708017
				},
				{
					"lng": 11.469804556468484,
					"lat": 43.52950793439583
				}
			], [
				{
					"lng": 11.46822685625685,
					"lat": 43.52893217975138
				},
				{
					"lng": 11.468193182747546,
					"lat": 43.52894063695564
				},
				{
					"lng": 11.468189061131824,
					"lat": 43.52893425120214
				},
				{
					"lng": 11.468184246119996,
					"lat": 43.52892674749822
				},
				{
					"lng": 11.468178151637632,
					"lat": 43.528915821213964
				},
				{
					"lng": 11.468165980608141,
					"lat": 43.52891582146871
				},
				{
					"lng": 11.468130018414518,
					"lat": 43.52892790999558
				},
				{
					"lng": 11.46812115762306,
					"lat": 43.52893013540322
				},
				{
					"lng": 11.468119945944947,
					"lat": 43.528932770493384
				},
				{
					"lng": 11.468119662351738,
					"lat": 43.528932884137824
				},
				{
					"lng": 11.468113116721085,
					"lat": 43.528945163274805
				},
				{
					"lng": 11.46811209984383,
					"lat": 43.528945576322066
				},
				{
					"lng": 11.468111584266744,
					"lat": 43.528945821944305
				},
				{
					"lng": 11.468111047052139,
					"lat": 43.528946111910045
				},
				{
					"lng": 11.468109929092448,
					"lat": 43.52894679419776
				},
				{
					"lng": 11.468108732628018,
					"lat": 43.52894758721107
				},
				{
					"lng": 11.468106753196393,
					"lat": 43.52894895196101
				},
				{
					"lng": 11.46810368556301,
					"lat": 43.528951113793916
				},
				{
					"lng": 11.468101910537719,
					"lat": 43.52895240326783
				},
				{
					"lng": 11.468099895168269,
					"lat": 43.528953942043685
				},
				{
					"lng": 11.468098755332303,
					"lat": 43.52895486414577
				},
				{
					"lng": 11.46809231973553,
					"lat": 43.52896089354202
				},
				{
					"lng": 11.468089907919424,
					"lat": 43.52896335239976
				},
				{
					"lng": 11.468085818577363,
					"lat": 43.528967601712225
				},
				{
					"lng": 11.468086907759051,
					"lat": 43.528969260705274
				},
				{
					"lng": 11.468086956620633,
					"lat": 43.52896938226386
				},
				{
					"lng": 11.468087723804919,
					"lat": 43.52897046553726
				},
				{
					"lng": 11.468087897887381,
					"lat": 43.52897094744266
				},
				{
					"lng": 11.46808865339593,
					"lat": 43.528971979399806
				},
				{
					"lng": 11.468089366546298,
					"lat": 43.52897280391525
				},
				{
					"lng": 11.468089851748065,
					"lat": 43.5289743978676
				},
				{
					"lng": 11.468090549975553,
					"lat": 43.52897517386048
				},
				{
					"lng": 11.468091212174134,
					"lat": 43.52897577164223
				},
				{
					"lng": 11.468091845259934,
					"lat": 43.52897624960285
				},
				{
					"lng": 11.468093036942625,
					"lat": 43.52897698441528
				},
				{
					"lng": 11.468094904189108,
					"lat": 43.528993720968636
				},
				{
					"lng": 11.46808877172979,
					"lat": 43.52899414192497
				},
				{
					"lng": 11.46808770855119,
					"lat": 43.528994206755925
				},
				{
					"lng": 11.468083539616318,
					"lat": 43.52899676491375
				},
				{
					"lng": 11.467998765860134,
					"lat": 43.529018055937655
				},
				{
					"lng": 11.467991483408964,
					"lat": 43.52902229164321
				},
				{
					"lng": 11.467978311018943,
					"lat": 43.52902903830906
				},
				{
					"lng": 11.467975963434212,
					"lat": 43.529047320756995
				},
				{
					"lng": 11.468006860674974,
					"lat": 43.52904935498933
				},
				{
					"lng": 11.468017774691083,
					"lat": 43.5290449135152
				},
				{
					"lng": 11.468029351614591,
					"lat": 43.5290381515766
				},
				{
					"lng": 11.468045100356267,
					"lat": 43.52903421443466
				},
				{
					"lng": 11.468064567425502,
					"lat": 43.52902666017637
				},
				{
					"lng": 11.468074988277255,
					"lat": 43.52902103229769
				},
				{
					"lng": 11.468086658741806,
					"lat": 43.52901811470808
				},
				{
					"lng": 11.468091552820079,
					"lat": 43.52901621787221
				},
				{
					"lng": 11.468124766234494,
					"lat": 43.52900334241194
				},
				{
					"lng": 11.468158894183397,
					"lat": 43.52899470837713
				},
				{
					"lng": 11.468168130755918,
					"lat": 43.52899456330444
				},
				{
					"lng": 11.468187758433757,
					"lat": 43.52898765328823
				},
				{
					"lng": 11.46819214650183,
					"lat": 43.528986152942466
				},
				{
					"lng": 11.468198351535424,
					"lat": 43.5289853235909
				},
				{
					"lng": 11.468212641101147,
					"lat": 43.52897890953807
				},
				{
					"lng": 11.468227990264161,
					"lat": 43.52897460617561
				},
				{
					"lng": 11.46822888763649,
					"lat": 43.52897388934556
				},
				{
					"lng": 11.468239792680528,
					"lat": 43.5289705597921
				},
				{
					"lng": 11.468260071819765,
					"lat": 43.52896454031116
				},
				{
					"lng": 11.468266938429288,
					"lat": 43.528962581318964
				},
				{
					"lng": 11.46826905464097,
					"lat": 43.52896189028374
				},
				{
					"lng": 11.468278010720889,
					"lat": 43.528961878787506
				},
				{
					"lng": 11.468283815957763,
					"lat": 43.52895899375965
				},
				{
					"lng": 11.46829062149065,
					"lat": 43.52895985193551
				},
				{
					"lng": 11.468300698492992,
					"lat": 43.52895060364501
				},
				{
					"lng": 11.46830512476356,
					"lat": 43.5289499581813
				},
				{
					"lng": 11.46835602162379,
					"lat": 43.52893353809613
				},
				{
					"lng": 11.468353566753317,
					"lat": 43.528933907377194
				},
				{
					"lng": 11.468349112918462,
					"lat": 43.52893334197195
				},
				{
					"lng": 11.4683424858801,
					"lat": 43.5289334775908
				},
				{
					"lng": 11.468332449417717,
					"lat": 43.52893163061981
				},
				{
					"lng": 11.468329996380424,
					"lat": 43.528931632661575
				},
				{
					"lng": 11.468320374546808,
					"lat": 43.52892989212358
				},
				{
					"lng": 11.468317583797964,
					"lat": 43.52892966001806
				},
				{
					"lng": 11.468314203076561,
					"lat": 43.5289299303513
				},
				{
					"lng": 11.468311778988898,
					"lat": 43.528929424278274
				},
				{
					"lng": 11.468308320465487,
					"lat": 43.528929397855855
				},
				{
					"lng": 11.468294404383565,
					"lat": 43.52893198953695
				},
				{
					"lng": 11.46822685625685,
					"lat": 43.52893217975138
				}
			], [
				{
					"lng": 11.468547614084986,
					"lat": 43.52885161983675
				},
				{
					"lng": 11.46854735198131,
					"lat": 43.52885168566583
				},
				{
					"lng": 11.468545904814368,
					"lat": 43.52885204913146
				},
				{
					"lng": 11.46853251877074,
					"lat": 43.528855411124354
				},
				{
					"lng": 11.46853227625537,
					"lat": 43.52885547203364
				},
				{
					"lng": 11.468532042129253,
					"lat": 43.52885553083596
				},
				{
					"lng": 11.46853182031913,
					"lat": 43.528855586545006
				},
				{
					"lng": 11.468531624000267,
					"lat": 43.52885563585177
				},
				{
					"lng": 11.468531443692031,
					"lat": 43.52885568113736
				},
				{
					"lng": 11.4685312806443,
					"lat": 43.528855722087854
				},
				{
					"lng": 11.468522561923537,
					"lat": 43.528857911850764
				},
				{
					"lng": 11.468521884392368,
					"lat": 43.52885808201703
				},
				{
					"lng": 11.468521592182375,
					"lat": 43.52885815540745
				},
				{
					"lng": 11.468521331512514,
					"lat": 43.52885822087636
				},
				{
					"lng": 11.468520789749682,
					"lat": 43.5288590439235
				},
				{
					"lng": 11.468513910565779,
					"lat": 43.52886906337241
				},
				{
					"lng": 11.468521014907497,
					"lat": 43.52887636459561
				},
				{
					"lng": 11.468518661558413,
					"lat": 43.52888133636391
				},
				{
					"lng": 11.468514699435348,
					"lat": 43.52888633000798
				},
				{
					"lng": 11.468534875863085,
					"lat": 43.52888760715192
				},
				{
					"lng": 11.468544508534512,
					"lat": 43.528886053346184
				},
				{
					"lng": 11.46856721646674,
					"lat": 43.52887805891587
				},
				{
					"lng": 11.468577244868051,
					"lat": 43.52886771385921
				},
				{
					"lng": 11.46858727664554,
					"lat": 43.528865704895246
				},
				{
					"lng": 11.468598923032836,
					"lat": 43.52885995322311
				},
				{
					"lng": 11.46862689356057,
					"lat": 43.5288634482039
				},
				{
					"lng": 11.468630014101901,
					"lat": 43.52886423586537
				},
				{
					"lng": 11.46865325927451,
					"lat": 43.528861442014325
				},
				{
					"lng": 11.468655912014349,
					"lat": 43.52886030813809
				},
				{
					"lng": 11.468663064236955,
					"lat": 43.528859307863094
				},
				{
					"lng": 11.46867912754345,
					"lat": 43.528855401669425
				},
				{
					"lng": 11.468686141080704,
					"lat": 43.52885364984805
				},
				{
					"lng": 11.468709408250572,
					"lat": 43.52884884818541
				},
				{
					"lng": 11.468769886672643,
					"lat": 43.52882247632205
				},
				{
					"lng": 11.468789945812532,
					"lat": 43.52881256836843
				},
				{
					"lng": 11.468833189253672,
					"lat": 43.52879120880532
				},
				{
					"lng": 11.468874658301306,
					"lat": 43.528809685577095
				},
				{
					"lng": 11.468956025767614,
					"lat": 43.52884593923996
				},
				{
					"lng": 11.468957754595918,
					"lat": 43.52884040859568
				},
				{
					"lng": 11.468960464981178,
					"lat": 43.528836863907884
				},
				{
					"lng": 11.468963314939959,
					"lat": 43.528835651353795
				},
				{
					"lng": 11.468979219374782,
					"lat": 43.52878902250253
				},
				{
					"lng": 11.468976630268067,
					"lat": 43.5287846954874
				},
				{
					"lng": 11.468971657848941,
					"lat": 43.528756114300876
				},
				{
					"lng": 11.468974863647173,
					"lat": 43.52873178401689
				},
				{
					"lng": 11.468975143370075,
					"lat": 43.528728714267615
				},
				{
					"lng": 11.46896869552895,
					"lat": 43.528712672941694
				},
				{
					"lng": 11.468965700579469,
					"lat": 43.52870341891537
				},
				{
					"lng": 11.468964809792539,
					"lat": 43.528696391983146
				},
				{
					"lng": 11.468969163235197,
					"lat": 43.528681672760236
				},
				{
					"lng": 11.468981181681418,
					"lat": 43.528622691588055
				},
				{
					"lng": 11.468987336149675,
					"lat": 43.5286058649061
				},
				{
					"lng": 11.468973484229346,
					"lat": 43.52859302066906
				},
				{
					"lng": 11.46894467047368,
					"lat": 43.52859679989263
				},
				{
					"lng": 11.468941992184186,
					"lat": 43.52859694388921
				},
				{
					"lng": 11.468936533202172,
					"lat": 43.52859750876852
				},
				{
					"lng": 11.468929936520043,
					"lat": 43.52859822147007
				},
				{
					"lng": 11.468927850615472,
					"lat": 43.528598439671555
				},
				{
					"lng": 11.468925793526921,
					"lat": 43.52859864458648
				},
				{
					"lng": 11.468923864654558,
					"lat": 43.528598825182925
				},
				{
					"lng": 11.468922130110117,
					"lat": 43.528598974262735
				},
				{
					"lng": 11.468908170850781,
					"lat": 43.52858705007712
				},
				{
					"lng": 11.468903871419949,
					"lat": 43.5285898460594
				},
				{
					"lng": 11.46890075989041,
					"lat": 43.528591869531965
				},
				{
					"lng": 11.468905945703652,
					"lat": 43.528581146277176
				},
				{
					"lng": 11.46890613873722,
					"lat": 43.528579254409706
				},
				{
					"lng": 11.468891486860686,
					"lat": 43.52854804097058
				},
				{
					"lng": 11.468889800441504,
					"lat": 43.52853822439479
				},
				{
					"lng": 11.46888663964418,
					"lat": 43.52853437105768
				},
				{
					"lng": 11.468870331318502,
					"lat": 43.52853264982575
				},
				{
					"lng": 11.46884548740612,
					"lat": 43.52853964302438
				},
				{
					"lng": 11.468822405078578,
					"lat": 43.52855048886054
				},
				{
					"lng": 11.468818012175218,
					"lat": 43.528552552980265
				},
				{
					"lng": 11.468803276450394,
					"lat": 43.52856187892721
				},
				{
					"lng": 11.468792848468864,
					"lat": 43.5285684785863
				},
				{
					"lng": 11.4687842202322,
					"lat": 43.52857332794356
				},
				{
					"lng": 11.468772832179992,
					"lat": 43.5285797284072
				},
				{
					"lng": 11.468771291549965,
					"lat": 43.52858976521667
				},
				{
					"lng": 11.468768937677154,
					"lat": 43.52860510008884
				},
				{
					"lng": 11.46876769664863,
					"lat": 43.52860700081291
				},
				{
					"lng": 11.468762466077548,
					"lat": 43.52860954280068
				},
				{
					"lng": 11.468761041147534,
					"lat": 43.52861023529759
				},
				{
					"lng": 11.468741295747227,
					"lat": 43.52861927079011
				},
				{
					"lng": 11.46873895392501,
					"lat": 43.52862034240725
				},
				{
					"lng": 11.468734979003017,
					"lat": 43.52862216892525
				},
				{
					"lng": 11.468732129610393,
					"lat": 43.52862349164445
				},
				{
					"lng": 11.468730295103297,
					"lat": 43.52862435825124
				},
				{
					"lng": 11.468728516993494,
					"lat": 43.5286252208632
				},
				{
					"lng": 11.468726876535193,
					"lat": 43.528626045489524
				},
				{
					"lng": 11.468723700988617,
					"lat": 43.52862766775113
				},
				{
					"lng": 11.46872179547715,
					"lat": 43.52863035833087
				},
				{
					"lng": 11.468714707424047,
					"lat": 43.528640366650514
				},
				{
					"lng": 11.46871350030397,
					"lat": 43.528641151653915
				},
				{
					"lng": 11.468712896921302,
					"lat": 43.52864154404028
				},
				{
					"lng": 11.468712289470027,
					"lat": 43.52864193907247
				},
				{
					"lng": 11.468711674923684,
					"lat": 43.52864233871868
				},
				{
					"lng": 11.468711050668315,
					"lat": 43.52864274467874
				},
				{
					"lng": 11.468710414971182,
					"lat": 43.52864315807952
				},
				{
					"lng": 11.4687097390354,
					"lat": 43.5286435976479
				},
				{
					"lng": 11.46870707030747,
					"lat": 43.52864533315061
				},
				{
					"lng": 11.468704323582168,
					"lat": 43.52864711937565
				},
				{
					"lng": 11.468704259246264,
					"lat": 43.52865429010203
				},
				{
					"lng": 11.468696389574482,
					"lat": 43.5286636004376
				},
				{
					"lng": 11.46869071364424,
					"lat": 43.52867031543162
				},
				{
					"lng": 11.468684403804787,
					"lat": 43.528680805334986
				},
				{
					"lng": 11.468674883256554,
					"lat": 43.528696632930306
				},
				{
					"lng": 11.468673516762827,
					"lat": 43.52869890468004
				},
				{
					"lng": 11.468670410680605,
					"lat": 43.52870406843629
				},
				{
					"lng": 11.468664914984359,
					"lat": 43.52871886439817
				},
				{
					"lng": 11.468657273153317,
					"lat": 43.52873943834764
				},
				{
					"lng": 11.468657168829418,
					"lat": 43.528739520659016
				},
				{
					"lng": 11.468640349728647,
					"lat": 43.528752790894885
				},
				{
					"lng": 11.468625884131951,
					"lat": 43.528764204214404
				},
				{
					"lng": 11.46862378040792,
					"lat": 43.52876478051021
				},
				{
					"lng": 11.468618637027456,
					"lat": 43.528772851308766
				},
				{
					"lng": 11.468604722690971,
					"lat": 43.52879468514903
				},
				{
					"lng": 11.468602783532898,
					"lat": 43.52879772799978
				},
				{
					"lng": 11.468587837095594,
					"lat": 43.52880752877718
				},
				{
					"lng": 11.468587350411362,
					"lat": 43.528810708846656
				},
				{
					"lng": 11.468586602920901,
					"lat": 43.528815593063534
				},
				{
					"lng": 11.46858350270699,
					"lat": 43.528817907634625
				},
				{
					"lng": 11.468571401283485,
					"lat": 43.5288291237875
				},
				{
					"lng": 11.468570266698391,
					"lat": 43.52883017537258
				},
				{
					"lng": 11.468564066498102,
					"lat": 43.52883710790401
				},
				{
					"lng": 11.468548406118222,
					"lat": 43.52885091892
				},
				{
					"lng": 11.468547882665739,
					"lat": 43.528851552380914
				},
				{
					"lng": 11.468547614084986,
					"lat": 43.52885161983675
				}
			], [
				{
					"lng": 11.469283616552346,
					"lat": 43.5303264537377
				},
				{
					"lng": 11.469295057549674,
					"lat": 43.530329948533925
				},
				{
					"lng": 11.469332225070254,
					"lat": 43.53029547777305
				},
				{
					"lng": 11.469350481626673,
					"lat": 43.53029276908173
				},
				{
					"lng": 11.469361117675522,
					"lat": 43.5302818205803
				},
				{
					"lng": 11.4693538275239,
					"lat": 43.53028080025089
				},
				{
					"lng": 11.46944237530494,
					"lat": 43.530245126570755
				},
				{
					"lng": 11.469464191230403,
					"lat": 43.53024837783322
				},
				{
					"lng": 11.469482127821639,
					"lat": 43.530227304623565
				},
				{
					"lng": 11.469488984932033,
					"lat": 43.530224895220975
				},
				{
					"lng": 11.469517914998068,
					"lat": 43.5302295884927
				},
				{
					"lng": 11.469537589763258,
					"lat": 43.53019867759381
				},
				{
					"lng": 11.46959024692973,
					"lat": 43.53019235859952
				},
				{
					"lng": 11.469630284858527,
					"lat": 43.53018336258219
				},
				{
					"lng": 11.469629905330283,
					"lat": 43.53018167920718
				},
				{
					"lng": 11.469659871501806,
					"lat": 43.53017988156643
				},
				{
					"lng": 11.469690681785886,
					"lat": 43.530176068121655
				},
				{
					"lng": 11.469699740955027,
					"lat": 43.53018040919567
				},
				{
					"lng": 11.46970866327985,
					"lat": 43.5301787204821
				},
				{
					"lng": 11.469793429629776,
					"lat": 43.53017699117813
				},
				{
					"lng": 11.469838520892907,
					"lat": 43.53017905733239
				},
				{
					"lng": 11.469867387336926,
					"lat": 43.53018456840949
				},
				{
					"lng": 11.469910404258165,
					"lat": 43.53017997056523
				},
				{
					"lng": 11.469913682189633,
					"lat": 43.53017958384767
				},
				{
					"lng": 11.469919972391239,
					"lat": 43.530183085858454
				},
				{
					"lng": 11.469952836909105,
					"lat": 43.53016694054948
				},
				{
					"lng": 11.469943478896914,
					"lat": 43.53015922363732
				},
				{
					"lng": 11.469830797678968,
					"lat": 43.530128793509064
				},
				{
					"lng": 11.469676406168485,
					"lat": 43.53012399058337
				},
				{
					"lng": 11.46956601579517,
					"lat": 43.530135935845365
				},
				{
					"lng": 11.46949554027471,
					"lat": 43.530155509867896
				},
				{
					"lng": 11.469377932083178,
					"lat": 43.530198871191395
				},
				{
					"lng": 11.469301545017998,
					"lat": 43.53025182288454
				},
				{
					"lng": 11.469269432898603,
					"lat": 43.53028547266046
				},
				{
					"lng": 11.469256591161853,
					"lat": 43.53032398780302
				},
				{
					"lng": 11.469260957834178,
					"lat": 43.53033382336778
				},
				{
					"lng": 11.469283616552346,
					"lat": 43.5303264537377
				}
			]
		]
	},
	"3": {
		"name": "BO - Area Industriale Bomba",
		"center": {
			"lat": 43.5651,
			"lng": 11.4530
		},
		"coords": [
			[
				{
					"lng": 11.452592559707233,
					"lat": 43.566194521002764
				},
				{
					"lng": 11.453181268947096,
					"lat": 43.56604762040541
				},
				{
					"lng": 11.453848942766985,
					"lat": 43.56572387386488
				},
				{
					"lng": 11.45405327714139,
					"lat": 43.56542132669363
				},
				{
					"lng": 11.454100078773905,
					"lat": 43.56524030210242
				},
				{
					"lng": 11.454044340320591,
					"lat": 43.56501084736778
				},
				{
					"lng": 11.453720508399092,
					"lat": 43.564466491301324
				},
				{
					"lng": 11.453562687024595,
					"lat": 43.56419984958895
				},
				{
					"lng": 11.453332334918652,
					"lat": 43.563861630765345
				},
				{
					"lng": 11.453136326623746,
					"lat": 43.56360706141953
				},
				{
					"lng": 11.45303062452413,
					"lat": 43.563671211920294
				},
				{
					"lng": 11.452984785707361,
					"lat": 43.5637191437926
				},
				{
					"lng": 11.452910289384366,
					"lat": 43.56378045738007
				},
				{
					"lng": 11.45276581700341,
					"lat": 43.56388805948612
				},
				{
					"lng": 11.452498594800254,
					"lat": 43.564132653772546
				},
				{
					"lng": 11.452213128128143,
					"lat": 43.56443362131342
				},
				{
					"lng": 11.452100935249563,
					"lat": 43.564577850620054
				},
				{
					"lng": 11.451993868879189,
					"lat": 43.56472196980178
				},
				{
					"lng": 11.451940940167377,
					"lat": 43.56480894701791
				},
				{
					"lng": 11.451909734586241,
					"lat": 43.56492531273155
				},
				{
					"lng": 11.451916695873727,
					"lat": 43.56509684174316
				},
				{
					"lng": 11.451928179768856,
					"lat": 43.56525334636228
				},
				{
					"lng": 11.452009810359526,
					"lat": 43.56549418485549
				},
				{
					"lng": 11.45211104730964,
					"lat": 43.56571220958908
				},
				{
					"lng": 11.452275334852517,
					"lat": 43.56596620350072
				},
				{
					"lng": 11.452428742974375,
					"lat": 43.56607860698164
				},
				{
					"lng": 11.45249345819366,
					"lat": 43.56615559373755
				},
				{
					"lng": 11.452592559707233,
					"lat": 43.566194521002764
				}
			]
		]
	},
	"11": {
		"name": "B2 - Sponda Ovest Lago Allori",
		"center": {
			"lat": 43.5579,
			"lng": 11.4420
		},
		"coords": [
			[
				{
					"lng": 11.442606019929682,
					"lat": 43.55631037978862
				},
				{
					"lng": 11.442602213862958,
					"lat": 43.55631070811676
				},
				{
					"lng": 11.442611498713315,
					"lat": 43.556324006860144
				},
				{
					"lng": 11.442602512945212,
					"lat": 43.556337896383276
				},
				{
					"lng": 11.442601877035369,
					"lat": 43.55633887932455
				},
				{
					"lng": 11.442590362123676,
					"lat": 43.5563566781966
				},
				{
					"lng": 11.442582853400703,
					"lat": 43.55636828460166
				},
				{
					"lng": 11.442582730870376,
					"lat": 43.55636845050233
				},
				{
					"lng": 11.442582695687689,
					"lat": 43.55636849813817
				},
				{
					"lng": 11.442582674646799,
					"lat": 43.55636852662659
				},
				{
					"lng": 11.442581116055711,
					"lat": 43.55637063689037
				},
				{
					"lng": 11.442580890156501,
					"lat": 43.556370991616824
				},
				{
					"lng": 11.442580867108871,
					"lat": 43.556371027808176
				},
				{
					"lng": 11.442579517333861,
					"lat": 43.556388384579435
				},
				{
					"lng": 11.442579064759775,
					"lat": 43.55638875771331
				},
				{
					"lng": 11.442577808204197,
					"lat": 43.55638979370596
				},
				{
					"lng": 11.442570720304706,
					"lat": 43.55639563746705
				},
				{
					"lng": 11.442564311208393,
					"lat": 43.55639640194333
				},
				{
					"lng": 11.442559612218647,
					"lat": 43.55639918743462
				},
				{
					"lng": 11.44255605989385,
					"lat": 43.55639785913753
				},
				{
					"lng": 11.442522152551796,
					"lat": 43.55637624210112
				},
				{
					"lng": 11.442515167889802,
					"lat": 43.556373615682446
				},
				{
					"lng": 11.44250991429635,
					"lat": 43.55637164019117
				},
				{
					"lng": 11.442492439218645,
					"lat": 43.556365069093005
				},
				{
					"lng": 11.442489806369306,
					"lat": 43.556365474781785
				},
				{
					"lng": 11.442476765406274,
					"lat": 43.556367484228346
				},
				{
					"lng": 11.442456412739949,
					"lat": 43.556370620312144
				},
				{
					"lng": 11.442448699277088,
					"lat": 43.55637227915904
				},
				{
					"lng": 11.442444306578697,
					"lat": 43.5563732238466
				},
				{
					"lng": 11.442443610066212,
					"lat": 43.55637383754392
				},
				{
					"lng": 11.44244331252125,
					"lat": 43.55637409971091
				},
				{
					"lng": 11.442429695728762,
					"lat": 43.55638609746775
				},
				{
					"lng": 11.442421705149838,
					"lat": 43.5563852381327
				},
				{
					"lng": 11.442416681442962,
					"lat": 43.55638194784629
				},
				{
					"lng": 11.44241237804252,
					"lat": 43.55638089346953
				},
				{
					"lng": 11.44240763546992,
					"lat": 43.556379731490935
				},
				{
					"lng": 11.442395954281514,
					"lat": 43.556376869479685
				},
				{
					"lng": 11.442395334439581,
					"lat": 43.55637644119014
				},
				{
					"lng": 11.442394908122107,
					"lat": 43.55637657772924
				},
				{
					"lng": 11.442394841704235,
					"lat": 43.556376599001275
				},
				{
					"lng": 11.4423941315843,
					"lat": 43.55637653478069
				},
				{
					"lng": 11.442371646786041,
					"lat": 43.55637357222512
				},
				{
					"lng": 11.442369026662137,
					"lat": 43.5563732270021
				},
				{
					"lng": 11.442363720310215,
					"lat": 43.556372527846136
				},
				{
					"lng": 11.442355362207628,
					"lat": 43.556370324677665
				},
				{
					"lng": 11.442329067262248,
					"lat": 43.55636425987294
				},
				{
					"lng": 11.442320608065458,
					"lat": 43.55636278030686
				},
				{
					"lng": 11.442316396657528,
					"lat": 43.55636067471817
				},
				{
					"lng": 11.442313877897252,
					"lat": 43.55635941540685
				},
				{
					"lng": 11.442305081530831,
					"lat": 43.55635504823214
				},
				{
					"lng": 11.442276586346127,
					"lat": 43.55634090108047
				},
				{
					"lng": 11.442276401394864,
					"lat": 43.5563408214091
				},
				{
					"lng": 11.44227612313283,
					"lat": 43.55634061359152
				},
				{
					"lng": 11.44227253560052,
					"lat": 43.55633798069219
				},
				{
					"lng": 11.442270983461373,
					"lat": 43.556336841573135
				},
				{
					"lng": 11.442266741546947,
					"lat": 43.55633372842043
				},
				{
					"lng": 11.442251722737169,
					"lat": 43.556322706070546
				},
				{
					"lng": 11.442238123219449,
					"lat": 43.55631605429661
				},
				{
					"lng": 11.442234525480009,
					"lat": 43.55631429716975
				},
				{
					"lng": 11.44221424661388,
					"lat": 43.55630439301888
				},
				{
					"lng": 11.442200797767164,
					"lat": 43.55629937437783
				},
				{
					"lng": 11.442200374984548,
					"lat": 43.55629906918493
				},
				{
					"lng": 11.442199991792762,
					"lat": 43.55629879361491
				},
				{
					"lng": 11.442199701396435,
					"lat": 43.55629859972547
				},
				{
					"lng": 11.442199210183828,
					"lat": 43.55629827622912
				},
				{
					"lng": 11.442198823919867,
					"lat": 43.556298028199166
				},
				{
					"lng": 11.442198186715702,
					"lat": 43.556297625398955
				},
				{
					"lng": 11.442197654166627,
					"lat": 43.55629729406631
				},
				{
					"lng": 11.442196801100906,
					"lat": 43.556296765187895
				},
				{
					"lng": 11.442196033039323,
					"lat": 43.55629629752729
				},
				{
					"lng": 11.442194826780293,
					"lat": 43.55629555986376
				},
				{
					"lng": 11.442193633838865,
					"lat": 43.55629484969999
				},
				{
					"lng": 11.442191783131163,
					"lat": 43.55629372911648
				},
				{
					"lng": 11.442189985385417,
					"lat": 43.55629274401863
				},
				{
					"lng": 11.442189951597788,
					"lat": 43.556292725504264
				},
				{
					"lng": 11.442189061671462,
					"lat": 43.556292563734004
				},
				{
					"lng": 11.442189001669938,
					"lat": 43.556292550395895
				},
				{
					"lng": 11.442188599254317,
					"lat": 43.556292460940256
				},
				{
					"lng": 11.442188585155064,
					"lat": 43.556292457806045
				},
				{
					"lng": 11.442185195334584,
					"lat": 43.556291750827675
				},
				{
					"lng": 11.442185065734655,
					"lat": 43.55629172379843
				},
				{
					"lng": 11.442182586539257,
					"lat": 43.556291246048914
				},
				{
					"lng": 11.442182413610166,
					"lat": 43.55629121272491
				},
				{
					"lng": 11.442180078852246,
					"lat": 43.5562907592922
				},
				{
					"lng": 11.442179834698017,
					"lat": 43.55629071187507
				},
				{
					"lng": 11.442178070011963,
					"lat": 43.55629037915031
				},
				{
					"lng": 11.4421778263536,
					"lat": 43.55629033320947
				},
				{
					"lng": 11.442176201490069,
					"lat": 43.556290023088316
				},
				{
					"lng": 11.442175920492163,
					"lat": 43.55628996945712
				},
				{
					"lng": 11.442175660675991,
					"lat": 43.55628992142104
				},
				{
					"lng": 11.442174342817472,
					"lat": 43.556289677768994
				},
				{
					"lng": 11.442174067116534,
					"lat": 43.55628962560385
				},
				{
					"lng": 11.442172891399656,
					"lat": 43.556289403147545
				},
				{
					"lng": 11.442172617757796,
					"lat": 43.55628935363487
				},
				{
					"lng": 11.442171614080234,
					"lat": 43.556289172029686
				},
				{
					"lng": 11.442171346172902,
					"lat": 43.55628912131481
				},
				{
					"lng": 11.442170482011083,
					"lat": 43.55628895772886
				},
				{
					"lng": 11.442170208553994,
					"lat": 43.556288909419926
				},
				{
					"lng": 11.442169422674244,
					"lat": 43.55628877058629
				},
				{
					"lng": 11.442169172170619,
					"lat": 43.55628872279676
				},
				{
					"lng": 11.44216852179243,
					"lat": 43.556288598721636
				},
				{
					"lng": 11.44216826814232,
					"lat": 43.556288547432914
				},
				{
					"lng": 11.442167666234786,
					"lat": 43.556288425725555
				},
				{
					"lng": 11.442167438597153,
					"lat": 43.55628838061838
				},
				{
					"lng": 11.442166940407246,
					"lat": 43.556288281900336
				},
				{
					"lng": 11.442159275346395,
					"lat": 43.5562871765664
				},
				{
					"lng": 11.442155921082627,
					"lat": 43.55628669286729
				},
				{
					"lng": 11.442150218817275,
					"lat": 43.5562856877236
				},
				{
					"lng": 11.442142396333471,
					"lat": 43.556284308846465
				},
				{
					"lng": 11.442137574725946,
					"lat": 43.55628319189152
				},
				{
					"lng": 11.442135708970286,
					"lat": 43.55628275967773
				},
				{
					"lng": 11.442131980559084,
					"lat": 43.55628165021831
				},
				{
					"lng": 11.442109558584749,
					"lat": 43.556274978131334
				},
				{
					"lng": 11.442108674377153,
					"lat": 43.55627471501832
				},
				{
					"lng": 11.442107936287002,
					"lat": 43.556274521500065
				},
				{
					"lng": 11.442105595607126,
					"lat": 43.556273907802286
				},
				{
					"lng": 11.442104951466701,
					"lat": 43.556273884494466
				},
				{
					"lng": 11.442104099596104,
					"lat": 43.556273853670135
				},
				{
					"lng": 11.44210152482395,
					"lat": 43.55627345968785
				},
				{
					"lng": 11.442078321526164,
					"lat": 43.55626990920073
				},
				{
					"lng": 11.442076981268764,
					"lat": 43.55626985751253
				},
				{
					"lng": 11.44206173415874,
					"lat": 43.55626695748674
				},
				{
					"lng": 11.442060604991491,
					"lat": 43.556266742717156
				},
				{
					"lng": 11.442051659041594,
					"lat": 43.55626691188225
				},
				{
					"lng": 11.442051624086208,
					"lat": 43.556266912543244
				},
				{
					"lng": 11.4420503731742,
					"lat": 43.55626665830455
				},
				{
					"lng": 11.442022180829758,
					"lat": 43.55626092841314
				},
				{
					"lng": 11.442022053035299,
					"lat": 43.55626089730346
				},
				{
					"lng": 11.442022026202187,
					"lat": 43.55626089077136
				},
				{
					"lng": 11.441999640758619,
					"lat": 43.55626446101714
				},
				{
					"lng": 11.441985921793657,
					"lat": 43.55626247187414
				},
				{
					"lng": 11.441970126249842,
					"lat": 43.55626018164108
				},
				{
					"lng": 11.441965726489864,
					"lat": 43.556259543709096
				},
				{
					"lng": 11.441965333629946,
					"lat": 43.556259486747365
				},
				{
					"lng": 11.441963160080073,
					"lat": 43.556259185476776
				},
				{
					"lng": 11.441961514847046,
					"lat": 43.556258957434856
				},
				{
					"lng": 11.441956950312305,
					"lat": 43.55625832475527
				},
				{
					"lng": 11.441952278651582,
					"lat": 43.55625767722698
				},
				{
					"lng": 11.441909500957628,
					"lat": 43.556282409050255
				},
				{
					"lng": 11.4418880915324,
					"lat": 43.55629478684573
				},
				{
					"lng": 11.441882289102246,
					"lat": 43.556299464248674
				},
				{
					"lng": 11.441881105893764,
					"lat": 43.55630058614191
				},
				{
					"lng": 11.441867518950737,
					"lat": 43.556313468989785
				},
				{
					"lng": 11.441865991144153,
					"lat": 43.55631491762279
				},
				{
					"lng": 11.441865117851252,
					"lat": 43.55631574566009
				},
				{
					"lng": 11.441860600650767,
					"lat": 43.55632002877073
				},
				{
					"lng": 11.441847352391317,
					"lat": 43.55633259047594
				},
				{
					"lng": 11.44184637234806,
					"lat": 43.55633351973092
				},
				{
					"lng": 11.441845592675211,
					"lat": 43.55633425899919
				},
				{
					"lng": 11.44184543787397,
					"lat": 43.55633434455797
				},
				{
					"lng": 11.441845378718039,
					"lat": 43.55633441611126
				},
				{
					"lng": 11.441845300165324,
					"lat": 43.55633454318342
				},
				{
					"lng": 11.44184480171065,
					"lat": 43.55633515619199
				},
				{
					"lng": 11.44182892247099,
					"lat": 43.556356778904195
				},
				{
					"lng": 11.44183245882803,
					"lat": 43.55636624794779
				},
				{
					"lng": 11.441807306682401,
					"lat": 43.55638786688303
				},
				{
					"lng": 11.441804465242353,
					"lat": 43.556392709830654
				},
				{
					"lng": 11.441799795768086,
					"lat": 43.55639500029653
				},
				{
					"lng": 11.441783296401018,
					"lat": 43.55640046657271
				},
				{
					"lng": 11.441783004984853,
					"lat": 43.55640051024684
				},
				{
					"lng": 11.441782209535702,
					"lat": 43.55640092918789
				},
				{
					"lng": 11.441780803297624,
					"lat": 43.55640230518581
				},
				{
					"lng": 11.44177744177776,
					"lat": 43.55640559441818
				},
				{
					"lng": 11.441773019603938,
					"lat": 43.55641031564805
				},
				{
					"lng": 11.441770852319138,
					"lat": 43.55641262949831
				},
				{
					"lng": 11.44176983273866,
					"lat": 43.556413718029184
				},
				{
					"lng": 11.441766598000935,
					"lat": 43.55643914114312
				},
				{
					"lng": 11.441766503191992,
					"lat": 43.556439886284835
				},
				{
					"lng": 11.441763934657017,
					"lat": 43.55646007342859
				},
				{
					"lng": 11.441763934218399,
					"lat": 43.55646008725675
				},
				{
					"lng": 11.441763923304128,
					"lat": 43.5564600983922
				},
				{
					"lng": 11.4417639044545,
					"lat": 43.55646011311764
				},
				{
					"lng": 11.441736317103159,
					"lat": 43.556481664498456
				},
				{
					"lng": 11.441728147709421,
					"lat": 43.55648804646673
				},
				{
					"lng": 11.441729403890944,
					"lat": 43.55650707315713
				},
				{
					"lng": 11.441730428256891,
					"lat": 43.55652258865177
				},
				{
					"lng": 11.441720151414145,
					"lat": 43.55653181412223
				},
				{
					"lng": 11.441719133949317,
					"lat": 43.55654097008558
				},
				{
					"lng": 11.441718828338841,
					"lat": 43.55654602604895
				},
				{
					"lng": 11.44171869022984,
					"lat": 43.556548310897966
				},
				{
					"lng": 11.441718556913274,
					"lat": 43.55654894353265
				},
				{
					"lng": 11.441718553827757,
					"lat": 43.55654924115418
				},
				{
					"lng": 11.441718356476317,
					"lat": 43.55654957674058
				},
				{
					"lng": 11.441718018846764,
					"lat": 43.556550150863
				},
				{
					"lng": 11.441717830355227,
					"lat": 43.55655047138351
				},
				{
					"lng": 11.441717511491744,
					"lat": 43.556551013595055
				},
				{
					"lng": 11.441716687356207,
					"lat": 43.5565524149968
				},
				{
					"lng": 11.441715594525629,
					"lat": 43.55655427330095
				},
				{
					"lng": 11.441715561871442,
					"lat": 43.55655445134319
				},
				{
					"lng": 11.441714657098307,
					"lat": 43.55655938448603
				},
				{
					"lng": 11.441714306675964,
					"lat": 43.55656129511226
				},
				{
					"lng": 11.441714117227422,
					"lat": 43.55656232805243
				},
				{
					"lng": 11.441711078973638,
					"lat": 43.55657693861627
				},
				{
					"lng": 11.441710225676408,
					"lat": 43.55657812810663
				},
				{
					"lng": 11.441709316948284,
					"lat": 43.556580399678964
				},
				{
					"lng": 11.441706952487113,
					"lat": 43.55658794378514
				},
				{
					"lng": 11.44169917789323,
					"lat": 43.55660552847243
				},
				{
					"lng": 11.44169832249961,
					"lat": 43.55660851775225
				},
				{
					"lng": 11.441698036022729,
					"lat": 43.5566095188815
				},
				{
					"lng": 11.44169533479598,
					"lat": 43.556623395822996
				},
				{
					"lng": 11.441695291333772,
					"lat": 43.55662361910023
				},
				{
					"lng": 11.441694139261298,
					"lat": 43.55662828815767
				},
				{
					"lng": 11.44169303596382,
					"lat": 43.55663161681766
				},
				{
					"lng": 11.441692222138805,
					"lat": 43.556634072136006
				},
				{
					"lng": 11.441691591234854,
					"lat": 43.55663597557942
				},
				{
					"lng": 11.441691506616827,
					"lat": 43.55663623087287
				},
				{
					"lng": 11.44169121756682,
					"lat": 43.55663710293956
				},
				{
					"lng": 11.441686105506344,
					"lat": 43.55665252607192
				},
				{
					"lng": 11.441686059996194,
					"lat": 43.556652663376354
				},
				{
					"lng": 11.44168503821603,
					"lat": 43.55665411191099
				},
				{
					"lng": 11.441684986567145,
					"lat": 43.55665418513142
				},
				{
					"lng": 11.441684968377976,
					"lat": 43.55665420334577
				},
				{
					"lng": 11.441682701421378,
					"lat": 43.556656473441365
				},
				{
					"lng": 11.441680042735342,
					"lat": 43.556659135808566
				},
				{
					"lng": 11.441679596418757,
					"lat": 43.556659582743116
				},
				{
					"lng": 11.441658187176543,
					"lat": 43.55668102161706
				},
				{
					"lng": 11.441640656002127,
					"lat": 43.556698577041836
				},
				{
					"lng": 11.441636764466287,
					"lat": 43.55670247395896
				},
				{
					"lng": 11.441635968382492,
					"lat": 43.556703816776945
				},
				{
					"lng": 11.441635675713346,
					"lat": 43.556704310445305
				},
				{
					"lng": 11.441635330958018,
					"lat": 43.556705693958996
				},
				{
					"lng": 11.441635137429476,
					"lat": 43.55670625752235
				},
				{
					"lng": 11.441632107617124,
					"lat": 43.55670734570412
				},
				{
					"lng": 11.44163130273542,
					"lat": 43.556707634783926
				},
				{
					"lng": 11.441625114436908,
					"lat": 43.5567117538042
				},
				{
					"lng": 11.441611211816454,
					"lat": 43.55672091784553
				},
				{
					"lng": 11.441610378397698,
					"lat": 43.55672261282461
				},
				{
					"lng": 11.441602217162593,
					"lat": 43.55673812165728
				},
				{
					"lng": 11.441599603973525,
					"lat": 43.55674308751077
				},
				{
					"lng": 11.4415989657045,
					"lat": 43.556744300415765
				},
				{
					"lng": 11.44159871438797,
					"lat": 43.55674477799349
				},
				{
					"lng": 11.441597750872154,
					"lat": 43.55674660896606
				},
				{
					"lng": 11.441594447820064,
					"lat": 43.55675288576701
				},
				{
					"lng": 11.441593936366345,
					"lat": 43.55675421114268
				},
				{
					"lng": 11.441592510723563,
					"lat": 43.55676148612435
				},
				{
					"lng": 11.441591591153966,
					"lat": 43.55676617863995
				},
				{
					"lng": 11.441590968706826,
					"lat": 43.55676935495477
				},
				{
					"lng": 11.44159089792502,
					"lat": 43.55676941847247
				},
				{
					"lng": 11.4415899643395,
					"lat": 43.55677025624779
				},
				{
					"lng": 11.441589109657055,
					"lat": 43.55677102321744
				},
				{
					"lng": 11.441584538519749,
					"lat": 43.55677512523609
				},
				{
					"lng": 11.441562966159346,
					"lat": 43.556794483696486
				},
				{
					"lng": 11.441559013835619,
					"lat": 43.55679785895118
				},
				{
					"lng": 11.44155640608697,
					"lat": 43.556799855766855
				},
				{
					"lng": 11.441555627562737,
					"lat": 43.55680036320961
				},
				{
					"lng": 11.441555250263795,
					"lat": 43.55680060913339
				},
				{
					"lng": 11.441554732275707,
					"lat": 43.55680094675843
				},
				{
					"lng": 11.441550081914993,
					"lat": 43.556805896194135
				},
				{
					"lng": 11.441549439176708,
					"lat": 43.556806580268265
				},
				{
					"lng": 11.441547608423335,
					"lat": 43.556807559723495
				},
				{
					"lng": 11.441543423604962,
					"lat": 43.55680979860598
				},
				{
					"lng": 11.441532010758,
					"lat": 43.55681590449027
				},
				{
					"lng": 11.441531247905422,
					"lat": 43.556816312617066
				},
				{
					"lng": 11.441528445492063,
					"lat": 43.55681781191057
				},
				{
					"lng": 11.44151542250572,
					"lat": 43.556845044959566
				},
				{
					"lng": 11.441514784898771,
					"lat": 43.556845832203365
				},
				{
					"lng": 11.441514479503981,
					"lat": 43.55684620926975
				},
				{
					"lng": 11.441514282269146,
					"lat": 43.55684641198462
				},
				{
					"lng": 11.441512862921138,
					"lat": 43.55684787076812
				},
				{
					"lng": 11.441510416667004,
					"lat": 43.55685038498944
				},
				{
					"lng": 11.441502835900927,
					"lat": 43.556857518904756
				},
				{
					"lng": 11.441496455011938,
					"lat": 43.55686365006691
				},
				{
					"lng": 11.441495601010645,
					"lat": 43.55686423555364
				},
				{
					"lng": 11.44148544329456,
					"lat": 43.55686943330712
				},
				{
					"lng": 11.441473552385046,
					"lat": 43.55687551794191
				},
				{
					"lng": 11.441466323577938,
					"lat": 43.556879216955636
				},
				{
					"lng": 11.441464130403265,
					"lat": 43.55688049802572
				},
				{
					"lng": 11.441453076340757,
					"lat": 43.55688695488751
				},
				{
					"lng": 11.441451834639171,
					"lat": 43.55688768018588
				},
				{
					"lng": 11.441450902262112,
					"lat": 43.55688832223065
				},
				{
					"lng": 11.441448082007216,
					"lat": 43.55689075654508
				},
				{
					"lng": 11.441440173461658,
					"lat": 43.55689758283692
				},
				{
					"lng": 11.441438271261786,
					"lat": 43.55689922472781
				},
				{
					"lng": 11.441436216446524,
					"lat": 43.55690168075655
				},
				{
					"lng": 11.441435804669043,
					"lat": 43.55690238206421
				},
				{
					"lng": 11.441430179871599,
					"lat": 43.55691196178375
				},
				{
					"lng": 11.441424999180937,
					"lat": 43.55691770588613
				},
				{
					"lng": 11.44141767569343,
					"lat": 43.55692582581714
				},
				{
					"lng": 11.441416158257603,
					"lat": 43.556927508276715
				},
				{
					"lng": 11.441414700142648,
					"lat": 43.556929854434664
				},
				{
					"lng": 11.441414044198943,
					"lat": 43.55693092499917
				},
				{
					"lng": 11.441411195337144,
					"lat": 43.55693557462065
				},
				{
					"lng": 11.441409700006798,
					"lat": 43.556938015145896
				},
				{
					"lng": 11.441405856636536,
					"lat": 43.55694210226506
				},
				{
					"lng": 11.44140428573615,
					"lat": 43.55694377279267
				},
				{
					"lng": 11.441402833944345,
					"lat": 43.55695014861118
				},
				{
					"lng": 11.441400820739132,
					"lat": 43.55695303593656
				},
				{
					"lng": 11.441397261132671,
					"lat": 43.55695814109946
				},
				{
					"lng": 11.441389012721647,
					"lat": 43.556969970909705
				},
				{
					"lng": 11.441385234679094,
					"lat": 43.55697538934877
				},
				{
					"lng": 11.44137354611848,
					"lat": 43.556992152984286
				},
				{
					"lng": 11.441371345451254,
					"lat": 43.556994860425775
				},
				{
					"lng": 11.441371295394537,
					"lat": 43.556994948716785
				},
				{
					"lng": 11.441369545788652,
					"lat": 43.55699803470715
				},
				{
					"lng": 11.4413692878104,
					"lat": 43.556998509670606
				},
				{
					"lng": 11.441364972164145,
					"lat": 43.5570064552016
				},
				{
					"lng": 11.441359986410161,
					"lat": 43.55701563446438
				},
				{
					"lng": 11.44135939442614,
					"lat": 43.557016724364885
				},
				{
					"lng": 11.441358930540853,
					"lat": 43.557017578423114
				},
				{
					"lng": 11.44135634902111,
					"lat": 43.5570246314471
				},
				{
					"lng": 11.441351760755524,
					"lat": 43.55703549115011
				},
				{
					"lng": 11.441350524025031,
					"lat": 43.557041487037665
				},
				{
					"lng": 11.441348834559383,
					"lat": 43.55704967786352
				},
				{
					"lng": 11.441347760785295,
					"lat": 43.55705488370762
				},
				{
					"lng": 11.441346461961066,
					"lat": 43.55706179320706
				},
				{
					"lng": 11.441345950854728,
					"lat": 43.5570626534818
				},
				{
					"lng": 11.441344050532562,
					"lat": 43.557065852031535
				},
				{
					"lng": 11.441332815026488,
					"lat": 43.55708476319929
				},
				{
					"lng": 11.441327174701978,
					"lat": 43.55709425676992
				},
				{
					"lng": 11.441321687049658,
					"lat": 43.55710349336571
				},
				{
					"lng": 11.441319057732889,
					"lat": 43.55710791892503
				},
				{
					"lng": 11.441318909747473,
					"lat": 43.55710864204425
				},
				{
					"lng": 11.441318485180387,
					"lat": 43.55710924700535
				},
				{
					"lng": 11.441314706978236,
					"lat": 43.55712446847615
				},
				{
					"lng": 11.441311850119078,
					"lat": 43.55712711706223
				},
				{
					"lng": 11.441304091547908,
					"lat": 43.557134310010156
				},
				{
					"lng": 11.441300833899309,
					"lat": 43.55714245535698
				},
				{
					"lng": 11.441300092419363,
					"lat": 43.55714361223166
				},
				{
					"lng": 11.441299014243638,
					"lat": 43.55714529442699
				},
				{
					"lng": 11.441296759097671,
					"lat": 43.55714881295895
				},
				{
					"lng": 11.441289959879892,
					"lat": 43.55715711435132
				},
				{
					"lng": 11.441288957547194,
					"lat": 43.55715833813263
				},
				{
					"lng": 11.441283396733947,
					"lat": 43.55716734966404
				},
				{
					"lng": 11.44128318290923,
					"lat": 43.557167696175874
				},
				{
					"lng": 11.441280201447897,
					"lat": 43.55717252775796
				},
				{
					"lng": 11.441277772939534,
					"lat": 43.557176672185264
				},
				{
					"lng": 11.441272887782059,
					"lat": 43.55718500906217
				},
				{
					"lng": 11.441265879251754,
					"lat": 43.55719696962523
				},
				{
					"lng": 11.441265302557692,
					"lat": 43.55719785550905
				},
				{
					"lng": 11.441265081762593,
					"lat": 43.55719820250906
				},
				{
					"lng": 11.441262063836707,
					"lat": 43.557200601481576
				},
				{
					"lng": 11.44125336634698,
					"lat": 43.557207135551444
				},
				{
					"lng": 11.441245103533783,
					"lat": 43.55721334306464
				},
				{
					"lng": 11.441243556561847,
					"lat": 43.55721520549759
				},
				{
					"lng": 11.441241999247167,
					"lat": 43.55721741565441
				},
				{
					"lng": 11.441239343158168,
					"lat": 43.55722024221274
				},
				{
					"lng": 11.441235545124584,
					"lat": 43.55722428400575
				},
				{
					"lng": 11.44123095692129,
					"lat": 43.557229166681104
				},
				{
					"lng": 11.441221101575497,
					"lat": 43.5572393820577
				},
				{
					"lng": 11.441214817698796,
					"lat": 43.55724429074781
				},
				{
					"lng": 11.44121455384999,
					"lat": 43.55724443372651
				},
				{
					"lng": 11.441205614672095,
					"lat": 43.55724927783351
				},
				{
					"lng": 11.441201988577934,
					"lat": 43.55725216439657
				},
				{
					"lng": 11.441201925563455,
					"lat": 43.55725222063593
				},
				{
					"lng": 11.441201314193519,
					"lat": 43.55725276627287
				},
				{
					"lng": 11.44120025164348,
					"lat": 43.55725371458016
				},
				{
					"lng": 11.441188879355932,
					"lat": 43.55726695561556
				},
				{
					"lng": 11.44118472970341,
					"lat": 43.55727143964655
				},
				{
					"lng": 11.441178647985225,
					"lat": 43.557276729461506
				},
				{
					"lng": 11.441177260127203,
					"lat": 43.55727841931824
				},
				{
					"lng": 11.441174766369965,
					"lat": 43.55728145571815
				},
				{
					"lng": 11.441173463914826,
					"lat": 43.55728304158795
				},
				{
					"lng": 11.441173313616567,
					"lat": 43.557284005003176
				},
				{
					"lng": 11.441173990131574,
					"lat": 43.55728694221673
				},
				{
					"lng": 11.44117455196052,
					"lat": 43.55729147950383
				},
				{
					"lng": 11.44117463458637,
					"lat": 43.55729214678387
				},
				{
					"lng": 11.441174797850703,
					"lat": 43.557293465293824
				},
				{
					"lng": 11.441178562992219,
					"lat": 43.55730099026731
				},
				{
					"lng": 11.44118033403767,
					"lat": 43.55730452986
				},
				{
					"lng": 11.441182998309097,
					"lat": 43.557316423166945
				},
				{
					"lng": 11.441183040306225,
					"lat": 43.5573166726202
				},
				{
					"lng": 11.441182923447403,
					"lat": 43.55731701136054
				},
				{
					"lng": 11.441182920278901,
					"lat": 43.55731701741976
				},
				{
					"lng": 11.441176069877008,
					"lat": 43.55733011760064
				},
				{
					"lng": 11.441174732120741,
					"lat": 43.557332675821975
				},
				{
					"lng": 11.441169105658442,
					"lat": 43.55734150050719
				},
				{
					"lng": 11.441169093989854,
					"lat": 43.55734151880851
				},
				{
					"lng": 11.441167884758942,
					"lat": 43.557343567393765
				},
				{
					"lng": 11.441164668221193,
					"lat": 43.55734901660196
				},
				{
					"lng": 11.44116149436938,
					"lat": 43.55735278806407
				},
				{
					"lng": 11.441156412328205,
					"lat": 43.55735809503637
				},
				{
					"lng": 11.441154434259454,
					"lat": 43.55736327354381
				},
				{
					"lng": 11.441149429888016,
					"lat": 43.55737086390565
				},
				{
					"lng": 11.441143647898034,
					"lat": 43.55737963371506
				},
				{
					"lng": 11.441142976083102,
					"lat": 43.557380652687385
				},
				{
					"lng": 11.441141212857124,
					"lat": 43.5573829525888
				},
				{
					"lng": 11.441136593080154,
					"lat": 43.557388978492426
				},
				{
					"lng": 11.441119875348596,
					"lat": 43.55741078460728
				},
				{
					"lng": 11.441119417185945,
					"lat": 43.55741138222081
				},
				{
					"lng": 11.44111493463603,
					"lat": 43.557414848004505
				},
				{
					"lng": 11.441113417080217,
					"lat": 43.55741634700633
				},
				{
					"lng": 11.441112130633442,
					"lat": 43.55741774917597
				},
				{
					"lng": 11.441110281555455,
					"lat": 43.55741976458841
				},
				{
					"lng": 11.44110115262795,
					"lat": 43.5574297147094
				},
				{
					"lng": 11.441099741846278,
					"lat": 43.557431848421466
				},
				{
					"lng": 11.441098248345765,
					"lat": 43.55743311566862
				},
				{
					"lng": 11.441093674337294,
					"lat": 43.55743667259981
				},
				{
					"lng": 11.441081169068308,
					"lat": 43.557448112888316
				},
				{
					"lng": 11.441075372311811,
					"lat": 43.5574534159764
				},
				{
					"lng": 11.441074873648164,
					"lat": 43.55745387217234
				},
				{
					"lng": 11.441072384040982,
					"lat": 43.55745614975704
				},
				{
					"lng": 11.441064809840322,
					"lat": 43.557463078914395
				},
				{
					"lng": 11.441058720005701,
					"lat": 43.55746867683163
				},
				{
					"lng": 11.441053640340597,
					"lat": 43.55747334617658
				},
				{
					"lng": 11.441040734554623,
					"lat": 43.55748247856073
				},
				{
					"lng": 11.441038439681002,
					"lat": 43.55748430153917
				},
				{
					"lng": 11.44103625278628,
					"lat": 43.5574860387423
				},
				{
					"lng": 11.441031485749473,
					"lat": 43.55748982553182
				},
				{
					"lng": 11.441029026084724,
					"lat": 43.55749177941469
				},
				{
					"lng": 11.441020626556165,
					"lat": 43.55749706302159
				},
				{
					"lng": 11.441020636610425,
					"lat": 43.55749704424953
				},
				{
					"lng": 11.441006681099708,
					"lat": 43.557502113183745
				},
				{
					"lng": 11.44099622335406,
					"lat": 43.55750591165465
				},
				{
					"lng": 11.440995982229003,
					"lat": 43.55750598362698
				},
				{
					"lng": 11.440994797407285,
					"lat": 43.5575063372792
				},
				{
					"lng": 11.440994658546783,
					"lat": 43.55750637752483
				},
				{
					"lng": 11.440993940573161,
					"lat": 43.55750658561362
				},
				{
					"lng": 11.440993706339208,
					"lat": 43.55750666794424
				},
				{
					"lng": 11.440992421038583,
					"lat": 43.55750711971324
				},
				{
					"lng": 11.440992285828791,
					"lat": 43.55750716555031
				},
				{
					"lng": 11.440991495335805,
					"lat": 43.55750743353296
				},
				{
					"lng": 11.44099127952782,
					"lat": 43.557507497761215
				},
				{
					"lng": 11.44098993980342,
					"lat": 43.557507896486754
				},
				{
					"lng": 11.44098980701165,
					"lat": 43.55750794813195
				},
				{
					"lng": 11.440988929153841,
					"lat": 43.557508289546995
				},
				{
					"lng": 11.440988734464256,
					"lat": 43.557508334145226
				},
				{
					"lng": 11.440987365941858,
					"lat": 43.557508647637384
				},
				{
					"lng": 11.440987246262969,
					"lat": 43.55750868171154
				},
				{
					"lng": 11.44098636222965,
					"lat": 43.55750893340727
				},
				{
					"lng": 11.44098617941894,
					"lat": 43.55750897371115
				},
				{
					"lng": 11.44098475673606,
					"lat": 43.557509287366656
				},
				{
					"lng": 11.440984648969726,
					"lat": 43.5575093081834
				},
				{
					"lng": 11.440983771240102,
					"lat": 43.55750947773045
				},
				{
					"lng": 11.440983596249556,
					"lat": 43.557509518139426
				},
				{
					"lng": 11.440982105730592,
					"lat": 43.55750986233139
				},
				{
					"lng": 11.44098200067782,
					"lat": 43.55750988559459
				},
				{
					"lng": 11.44098105874043,
					"lat": 43.55751009418014
				},
				{
					"lng": 11.44098089116976,
					"lat": 43.557510136045536
				},
				{
					"lng": 11.440979309917045,
					"lat": 43.55751053110114
				},
				{
					"lng": 11.440979207233536,
					"lat": 43.55751055769005
				},
				{
					"lng": 11.44097817749234,
					"lat": 43.5575108243315
				},
				{
					"lng": 11.44097801849703,
					"lat": 43.55751086724244
				},
				{
					"lng": 11.440976324409798,
					"lat": 43.55751132445643
				},
				{
					"lng": 11.440976226180004,
					"lat": 43.55751135229349
				},
				{
					"lng": 11.440975100785389,
					"lat": 43.55751167121609
				},
				{
					"lng": 11.440974951810782,
					"lat": 43.5575117144652
				},
				{
					"lng": 11.440973119240766,
					"lat": 43.55751224648187
				},
				{
					"lng": 11.440973027309708,
					"lat": 43.557512274276434
				},
				{
					"lng": 11.440971792236896,
					"lat": 43.55751264769039
				},
				{
					"lng": 11.440971655625356,
					"lat": 43.557512689837615
				},
				{
					"lng": 11.440969659116687,
					"lat": 43.55751330579766
				},
				{
					"lng": 11.440969575290318,
					"lat": 43.5575133326338
				},
				{
					"lng": 11.440968208385842,
					"lat": 43.557513770233946
				},
				{
					"lng": 11.44096808552391,
					"lat": 43.55751381126683
				},
				{
					"lng": 11.440965862698928,
					"lat": 43.55751455363627
				},
				{
					"lng": 11.44096578768531,
					"lat": 43.5575145802493
				},
				{
					"lng": 11.440964213056485,
					"lat": 43.557515138890054
				},
				{
					"lng": 11.440964113696657,
					"lat": 43.557515171873966
				},
				{
					"lng": 11.440961714284782,
					"lat": 43.55751596839314
				},
				{
					"lng": 11.44096165360506,
					"lat": 43.557515990751135
				},
				{
					"lng": 11.440959876218868,
					"lat": 43.55751664564586
				},
				{
					"lng": 11.44095946887111,
					"lat": 43.55751672771363
				},
				{
					"lng": 11.440959322256697,
					"lat": 43.55751675725185
				},
				{
					"lng": 11.440958934514123,
					"lat": 43.55751683536983
				},
				{
					"lng": 11.440957514904552,
					"lat": 43.557517121376655
				},
				{
					"lng": 11.440955007656484,
					"lat": 43.557517626508464
				},
				{
					"lng": 11.44095337303884,
					"lat": 43.55751795583263
				},
				{
					"lng": 11.440951948242564,
					"lat": 43.55751824288432
				},
				{
					"lng": 11.440951198043642,
					"lat": 43.557518738850135
				},
				{
					"lng": 11.440950736577163,
					"lat": 43.55751918045515
				},
				{
					"lng": 11.440949944968445,
					"lat": 43.55751992272718
				},
				{
					"lng": 11.440949530207579,
					"lat": 43.55752042790626
				},
				{
					"lng": 11.44094949531011,
					"lat": 43.557520470411426
				},
				{
					"lng": 11.44094940567538,
					"lat": 43.557520579586566
				},
				{
					"lng": 11.440949398204381,
					"lat": 43.557520587507504
				},
				{
					"lng": 11.440949305988799,
					"lat": 43.557520676926096
				},
				{
					"lng": 11.44094496141812,
					"lat": 43.55752484619393
				},
				{
					"lng": 11.44094363519009,
					"lat": 43.55752611890869
				},
				{
					"lng": 11.44093610400304,
					"lat": 43.5575327398324
				},
				{
					"lng": 11.440927783192741,
					"lat": 43.55754005493867
				},
				{
					"lng": 11.440911247460432,
					"lat": 43.557545709877516
				},
				{
					"lng": 11.440908291023824,
					"lat": 43.55754606906257
				},
				{
					"lng": 11.44090479251848,
					"lat": 43.55754699180456
				},
				{
					"lng": 11.440899478199917,
					"lat": 43.557548884926604
				},
				{
					"lng": 11.440888708882127,
					"lat": 43.5575510289068
				},
				{
					"lng": 11.440887641032997,
					"lat": 43.55755124149654
				},
				{
					"lng": 11.440874866706626,
					"lat": 43.55755378463678
				},
				{
					"lng": 11.440870847543923,
					"lat": 43.557557421137005
				},
				{
					"lng": 11.440868083397934,
					"lat": 43.55755992210971
				},
				{
					"lng": 11.44086551083084,
					"lat": 43.5575628303837
				},
				{
					"lng": 11.44086445001127,
					"lat": 43.55756402963476
				},
				{
					"lng": 11.440862855908104,
					"lat": 43.557568920516346
				},
				{
					"lng": 11.440863376502255,
					"lat": 43.55757515498417
				},
				{
					"lng": 11.440863499974478,
					"lat": 43.55757663364757
				},
				{
					"lng": 11.440864505472703,
					"lat": 43.557592980530366
				},
				{
					"lng": 11.440864565902542,
					"lat": 43.55759396296747
				},
				{
					"lng": 11.440865446808877,
					"lat": 43.55760828428747
				},
				{
					"lng": 11.440865849425341,
					"lat": 43.55761018468545
				},
				{
					"lng": 11.440863531740883,
					"lat": 43.557611548112426
				},
				{
					"lng": 11.440842976111389,
					"lat": 43.55762013910056
				},
				{
					"lng": 11.440840240150793,
					"lat": 43.55762128256324
				},
				{
					"lng": 11.440836247013461,
					"lat": 43.5576223478364
				},
				{
					"lng": 11.440833077666648,
					"lat": 43.55762319334189
				},
				{
					"lng": 11.440819991262691,
					"lat": 43.5576266844786
				},
				{
					"lng": 11.440819945375637,
					"lat": 43.55762671268853
				},
				{
					"lng": 11.440817787467438,
					"lat": 43.5576280393031
				},
				{
					"lng": 11.44081528250031,
					"lat": 43.55762957927849
				},
				{
					"lng": 11.440808622859949,
					"lat": 43.55763523799641
				},
				{
					"lng": 11.440808616944146,
					"lat": 43.5576352835403
				},
				{
					"lng": 11.44080818004071,
					"lat": 43.557638067841
				},
				{
					"lng": 11.440807890844672,
					"lat": 43.55763991083117
				},
				{
					"lng": 11.440806971018374,
					"lat": 43.557645772704305
				},
				{
					"lng": 11.440811846620555,
					"lat": 43.55765002028769
				},
				{
					"lng": 11.440814700055466,
					"lat": 43.557652924597555
				},
				{
					"lng": 11.440821837319179,
					"lat": 43.557663429513546
				},
				{
					"lng": 11.4408240956689,
					"lat": 43.557667320427115
				},
				{
					"lng": 11.440825337342316,
					"lat": 43.557668651582645
				},
				{
					"lng": 11.440835993027596,
					"lat": 43.55768007517505
				},
				{
					"lng": 11.440833452540875,
					"lat": 43.55768076950767
				},
				{
					"lng": 11.44082670134756,
					"lat": 43.55768261465525
				},
				{
					"lng": 11.440825030447536,
					"lat": 43.55768307132367
				},
				{
					"lng": 11.44082410458857,
					"lat": 43.55768695072484
				},
				{
					"lng": 11.44082386193886,
					"lat": 43.557687967440785
				},
				{
					"lng": 11.440823101165721,
					"lat": 43.55769115512263
				},
				{
					"lng": 11.440811290181657,
					"lat": 43.55770255070321
				},
				{
					"lng": 11.440811236058664,
					"lat": 43.55770260100414
				},
				{
					"lng": 11.440811088716897,
					"lat": 43.5577026687516
				},
				{
					"lng": 11.440810151865378,
					"lat": 43.55770338928967
				},
				{
					"lng": 11.440794196387749,
					"lat": 43.55771794203262
				},
				{
					"lng": 11.440791552139844,
					"lat": 43.557720353809124
				},
				{
					"lng": 11.44078917636303,
					"lat": 43.55772252071723
				},
				{
					"lng": 11.440789703459538,
					"lat": 43.55772443719926
				},
				{
					"lng": 11.440789727857863,
					"lat": 43.5577245259097
				},
				{
					"lng": 11.440789803804904,
					"lat": 43.55772480204729
				},
				{
					"lng": 11.44078987195318,
					"lat": 43.55772504982913
				},
				{
					"lng": 11.440789887419964,
					"lat": 43.55772510606523
				},
				{
					"lng": 11.440790094711026,
					"lat": 43.55772585975936
				},
				{
					"lng": 11.440790157333312,
					"lat": 43.557726087449105
				},
				{
					"lng": 11.440790161964548,
					"lat": 43.55772610428784
				},
				{
					"lng": 11.440790165619877,
					"lat": 43.55772611757842
				},
				{
					"lng": 11.440790363791082,
					"lat": 43.5577268381134
				},
				{
					"lng": 11.440790526754649,
					"lat": 43.55772743063624
				},
				{
					"lng": 11.440790661955889,
					"lat": 43.55772792221747
				},
				{
					"lng": 11.440790602328825,
					"lat": 43.557728270653556
				},
				{
					"lng": 11.440790351839093,
					"lat": 43.55772973441316
				},
				{
					"lng": 11.440790211299596,
					"lat": 43.557730555668314
				},
				{
					"lng": 11.440790164001987,
					"lat": 43.557730832056215
				},
				{
					"lng": 11.44079007478642,
					"lat": 43.55773135339539
				},
				{
					"lng": 11.440789855242633,
					"lat": 43.55773263631932
				},
				{
					"lng": 11.440789806311477,
					"lat": 43.557732922252995
				},
				{
					"lng": 11.440789799064904,
					"lat": 43.55773296459887
				},
				{
					"lng": 11.440789788054511,
					"lat": 43.55773302893904
				},
				{
					"lng": 11.440782433000688,
					"lat": 43.55774141326389
				},
				{
					"lng": 11.440775814484608,
					"lat": 43.557742236878035
				},
				{
					"lng": 11.440775346740919,
					"lat": 43.55774229508449
				},
				{
					"lng": 11.440775054958516,
					"lat": 43.55774233139413
				},
				{
					"lng": 11.440773520627271,
					"lat": 43.55774252232768
				},
				{
					"lng": 11.440765090202653,
					"lat": 43.55774357141663
				},
				{
					"lng": 11.440759548123268,
					"lat": 43.55774495244208
				},
				{
					"lng": 11.440734432080001,
					"lat": 43.55774183500151
				},
				{
					"lng": 11.440731600277672,
					"lat": 43.557741483513645
				},
				{
					"lng": 11.440728990731264,
					"lat": 43.557741739320704
				},
				{
					"lng": 11.440725484166897,
					"lat": 43.55774130359485
				},
				{
					"lng": 11.440724542008372,
					"lat": 43.55774118652216
				},
				{
					"lng": 11.44072221885774,
					"lat": 43.55774123866525
				},
				{
					"lng": 11.44071966919969,
					"lat": 43.55774129589221
				},
				{
					"lng": 11.44071784465561,
					"lat": 43.55774113381587
				},
				{
					"lng": 11.44071345803373,
					"lat": 43.55774074414708
				},
				{
					"lng": 11.440707394882084,
					"lat": 43.55774020554987
				},
				{
					"lng": 11.440704175641644,
					"lat": 43.5577399195807
				},
				{
					"lng": 11.440699985564327,
					"lat": 43.557739547370694
				},
				{
					"lng": 11.440698411396506,
					"lat": 43.55773940753529
				},
				{
					"lng": 11.440695276811155,
					"lat": 43.55773912908587
				},
				{
					"lng": 11.44069392267525,
					"lat": 43.557739008796126
				},
				{
					"lng": 11.4406922635625,
					"lat": 43.557738861414826
				},
				{
					"lng": 11.440692044382505,
					"lat": 43.557738841944754
				},
				{
					"lng": 11.440691078376332,
					"lat": 43.55773866584043
				},
				{
					"lng": 11.440690631773721,
					"lat": 43.557738584424094
				},
				{
					"lng": 11.44068802189323,
					"lat": 43.557738108638986
				},
				{
					"lng": 11.440684620791673,
					"lat": 43.557736939611125
				},
				{
					"lng": 11.440684015244045,
					"lat": 43.55773673147207
				},
				{
					"lng": 11.44068205962185,
					"lat": 43.55773605928486
				},
				{
					"lng": 11.440677164133408,
					"lat": 43.55773437660541
				},
				{
					"lng": 11.440675202494175,
					"lat": 43.557734176230994
				},
				{
					"lng": 11.44067437728216,
					"lat": 43.557734091938535
				},
				{
					"lng": 11.440670579314547,
					"lat": 43.55773226567906
				},
				{
					"lng": 11.440667112591148,
					"lat": 43.55773059869867
				},
				{
					"lng": 11.44066527342591,
					"lat": 43.55772971433261
				},
				{
					"lng": 11.440660022097548,
					"lat": 43.55772718922115
				},
				{
					"lng": 11.440655594527678,
					"lat": 43.55772506021518
				},
				{
					"lng": 11.44064877547563,
					"lat": 43.557725040891235
				},
				{
					"lng": 11.440647350739766,
					"lat": 43.55772503685376
				},
				{
					"lng": 11.440644538231568,
					"lat": 43.55772502888347
				},
				{
					"lng": 11.440644308505542,
					"lat": 43.55772418063627
				},
				{
					"lng": 11.440644189671913,
					"lat": 43.557723741851454
				},
				{
					"lng": 11.440642652789107,
					"lat": 43.55771806701943
				},
				{
					"lng": 11.440640098475333,
					"lat": 43.557715337996385
				},
				{
					"lng": 11.440639983755926,
					"lat": 43.5577152154304
				},
				{
					"lng": 11.44063728403104,
					"lat": 43.55771415152413
				},
				{
					"lng": 11.440624373507637,
					"lat": 43.55770906374987
				},
				{
					"lng": 11.440625062973465,
					"lat": 43.55770772386256
				},
				{
					"lng": 11.44062542754051,
					"lat": 43.557707015373886
				},
				{
					"lng": 11.44062650693348,
					"lat": 43.55770491771365
				},
				{
					"lng": 11.440628416519788,
					"lat": 43.55770120668004
				},
				{
					"lng": 11.440626257600991,
					"lat": 43.557698625747264
				},
				{
					"lng": 11.44062476792852,
					"lat": 43.557696844881434
				},
				{
					"lng": 11.440622940232041,
					"lat": 43.557694659916265
				},
				{
					"lng": 11.440622906351079,
					"lat": 43.5576946194124
				},
				{
					"lng": 11.440622863416115,
					"lat": 43.55769456808475
				},
				{
					"lng": 11.440620280586092,
					"lat": 43.55769349141482
				},
				{
					"lng": 11.440617893728431,
					"lat": 43.55769107130891
				},
				{
					"lng": 11.440617575323616,
					"lat": 43.557690861834544
				},
				{
					"lng": 11.440616164622684,
					"lat": 43.55768993375299
				},
				{
					"lng": 11.44061457738885,
					"lat": 43.557688889532685
				},
				{
					"lng": 11.440614064067814,
					"lat": 43.557688551825514
				},
				{
					"lng": 11.440609710491248,
					"lat": 43.55768789930193
				},
				{
					"lng": 11.440595211528894,
					"lat": 43.5576857261644
				},
				{
					"lng": 11.440593542712325,
					"lat": 43.55768609313472
				},
				{
					"lng": 11.44059428786045,
					"lat": 43.55769132420813
				},
				{
					"lng": 11.440595556428315,
					"lat": 43.55770022977957
				},
				{
					"lng": 11.440595922604306,
					"lat": 43.55770280039922
				},
				{
					"lng": 11.440595808417473,
					"lat": 43.557703629252195
				},
				{
					"lng": 11.44059624997605,
					"lat": 43.5577091799982
				},
				{
					"lng": 11.44059632987502,
					"lat": 43.55771018439216
				},
				{
					"lng": 11.440596636735407,
					"lat": 43.55771404187257
				},
				{
					"lng": 11.440599106957249,
					"lat": 43.557716863881325
				},
				{
					"lng": 11.440603193039177,
					"lat": 43.55772153186573
				},
				{
					"lng": 11.440604414808462,
					"lat": 43.557724288214786
				},
				{
					"lng": 11.440594497904662,
					"lat": 43.55773265760631
				},
				{
					"lng": 11.440593840281348,
					"lat": 43.557733212608774
				},
				{
					"lng": 11.440593414682814,
					"lat": 43.557733571793484
				},
				{
					"lng": 11.440593017950338,
					"lat": 43.55773390661658
				},
				{
					"lng": 11.440592983833582,
					"lat": 43.55773393540948
				},
				{
					"lng": 11.440592818863406,
					"lat": 43.55773407463635
				},
				{
					"lng": 11.440591560414527,
					"lat": 43.55773513670662
				},
				{
					"lng": 11.440591036143214,
					"lat": 43.55773557916633
				},
				{
					"lng": 11.440590618275591,
					"lat": 43.55773593182646
				},
				{
					"lng": 11.440589909684585,
					"lat": 43.55773652984314
				},
				{
					"lng": 11.440589847629234,
					"lat": 43.55773658221485
				},
				{
					"lng": 11.440589825669857,
					"lat": 43.55773660074754
				},
				{
					"lng": 11.440588109270003,
					"lat": 43.557738049306145
				},
				{
					"lng": 11.440587767173508,
					"lat": 43.55773833801907
				},
				{
					"lng": 11.440588302652467,
					"lat": 43.5577385672584
				},
				{
					"lng": 11.440590071411126,
					"lat": 43.55773932446657
				},
				{
					"lng": 11.440594178343682,
					"lat": 43.55774108265017
				},
				{
					"lng": 11.440600398696482,
					"lat": 43.55774374559149
				},
				{
					"lng": 11.440613895179965,
					"lat": 43.557749523451974
				},
				{
					"lng": 11.440616111757944,
					"lat": 43.557750077895186
				},
				{
					"lng": 11.440616526736846,
					"lat": 43.557751536630185
				},
				{
					"lng": 11.440616869083835,
					"lat": 43.55775274004929
				},
				{
					"lng": 11.44061769996243,
					"lat": 43.55775566075567
				},
				{
					"lng": 11.440614373940198,
					"lat": 43.55775771166879
				},
				{
					"lng": 11.440614327707813,
					"lat": 43.55775774017689
				},
				{
					"lng": 11.440613400109092,
					"lat": 43.55775831215874
				},
				{
					"lng": 11.440613242638786,
					"lat": 43.55775840925906
				},
				{
					"lng": 11.440613149148975,
					"lat": 43.55775846690739
				},
				{
					"lng": 11.440613140005633,
					"lat": 43.55775847254539
				},
				{
					"lng": 11.440612379805444,
					"lat": 43.557758941304805
				},
				{
					"lng": 11.440612086070301,
					"lat": 43.557759122429644
				},
				{
					"lng": 11.440611270425281,
					"lat": 43.55775962537785
				},
				{
					"lng": 11.440610171430809,
					"lat": 43.55776030304672
				},
				{
					"lng": 11.440605181626777,
					"lat": 43.55776098463851
				},
				{
					"lng": 11.440603728244348,
					"lat": 43.55776118316603
				},
				{
					"lng": 11.440603326450146,
					"lat": 43.5577612380499
				},
				{
					"lng": 11.44059726551535,
					"lat": 43.55776206595438
				},
				{
					"lng": 11.44059668176651,
					"lat": 43.557762145692635
				},
				{
					"lng": 11.440596296415208,
					"lat": 43.557762198330416
				},
				{
					"lng": 11.440595568928108,
					"lat": 43.55776160828695
				},
				{
					"lng": 11.440590781094702,
					"lat": 43.557757725015094
				},
				{
					"lng": 11.440590608104749,
					"lat": 43.55775750000362
				},
				{
					"lng": 11.440589975469196,
					"lat": 43.55775667712191
				},
				{
					"lng": 11.440586622097925,
					"lat": 43.55775231532439
				},
				{
					"lng": 11.440585795933112,
					"lat": 43.55775124071512
				},
				{
					"lng": 11.440585495666696,
					"lat": 43.55775085015248
				},
				{
					"lng": 11.440584711713857,
					"lat": 43.55774983044904
				},
				{
					"lng": 11.44058470222418,
					"lat": 43.55774981810566
				},
				{
					"lng": 11.440584605109542,
					"lat": 43.55774969178668
				},
				{
					"lng": 11.440584441189701,
					"lat": 43.557749478572774
				},
				{
					"lng": 11.440583466749308,
					"lat": 43.55774821109827
				},
				{
					"lng": 11.440582337431852,
					"lat": 43.557746742171915
				},
				{
					"lng": 11.440577740998307,
					"lat": 43.55774743475488
				},
				{
					"lng": 11.440577372837248,
					"lat": 43.5577474902288
				},
				{
					"lng": 11.440550163034876,
					"lat": 43.55773931704192
				},
				{
					"lng": 11.440547201152325,
					"lat": 43.5577384273613
				},
				{
					"lng": 11.440541009058657,
					"lat": 43.55773746127525
				},
				{
					"lng": 11.440538557842554,
					"lat": 43.55773707883818
				},
				{
					"lng": 11.440531572294931,
					"lat": 43.557735988957376
				},
				{
					"lng": 11.440524064789239,
					"lat": 43.55773273384693
				},
				{
					"lng": 11.440521397454027,
					"lat": 43.55773155887651
				},
				{
					"lng": 11.440511718825267,
					"lat": 43.557727295405975
				},
				{
					"lng": 11.44050661075533,
					"lat": 43.557725045282375
				},
				{
					"lng": 11.440504412989185,
					"lat": 43.55772407715812
				},
				{
					"lng": 11.440502042243189,
					"lat": 43.5577230328356
				},
				{
					"lng": 11.440493168596124,
					"lat": 43.55771912395978
				},
				{
					"lng": 11.440493133125901,
					"lat": 43.55771908715121
				},
				{
					"lng": 11.440493032822975,
					"lat": 43.557718983063644
				},
				{
					"lng": 11.440491880422387,
					"lat": 43.557717787181154
				},
				{
					"lng": 11.440491194678645,
					"lat": 43.5577170755632
				},
				{
					"lng": 11.440490327776446,
					"lat": 43.55771617595127
				},
				{
					"lng": 11.440488216627111,
					"lat": 43.55771398514456
				},
				{
					"lng": 11.440487936659046,
					"lat": 43.55771369461278
				},
				{
					"lng": 11.440487878665872,
					"lat": 43.55771363443138
				},
				{
					"lng": 11.440487201901359,
					"lat": 43.5577129321313
				},
				{
					"lng": 11.440485331477017,
					"lat": 43.55771099113228
				},
				{
					"lng": 11.440476035197973,
					"lat": 43.55771076216946
				},
				{
					"lng": 11.44047253495237,
					"lat": 43.557710675959875
				},
				{
					"lng": 11.440472231492361,
					"lat": 43.55771066848579
				},
				{
					"lng": 11.440471696536745,
					"lat": 43.55771051430214
				},
				{
					"lng": 11.440465356990622,
					"lat": 43.557708687133015
				},
				{
					"lng": 11.440464790816064,
					"lat": 43.55770948606084
				},
				{
					"lng": 11.440463597851712,
					"lat": 43.557711169450364
				},
				{
					"lng": 11.44046310200762,
					"lat": 43.557711869134884
				},
				{
					"lng": 11.440461988952913,
					"lat": 43.55771229413078
				},
				{
					"lng": 11.440460095181566,
					"lat": 43.557713017226476
				},
				{
					"lng": 11.440455247277802,
					"lat": 43.55771486829359
				},
				{
					"lng": 11.440453955195569,
					"lat": 43.55771536164717
				},
				{
					"lng": 11.440449573116858,
					"lat": 43.557716904590116
				},
				{
					"lng": 11.440447987983655,
					"lat": 43.55771746272018
				},
				{
					"lng": 11.440441018037795,
					"lat": 43.55771991685825
				},
				{
					"lng": 11.440435400014685,
					"lat": 43.557721894979885
				},
				{
					"lng": 11.440399492310132,
					"lat": 43.55773453817386
				},
				{
					"lng": 11.440396294397429,
					"lat": 43.5577357507394
				},
				{
					"lng": 11.440377098757523,
					"lat": 43.55774302922538
				},
				{
					"lng": 11.440376453146067,
					"lat": 43.557743274024304
				},
				{
					"lng": 11.440373513549313,
					"lat": 43.55774365151711
				},
				{
					"lng": 11.440369665822738,
					"lat": 43.55774414562869
				},
				{
					"lng": 11.44036822955617,
					"lat": 43.557745234282066
				},
				{
					"lng": 11.440368227825662,
					"lat": 43.5577452355937
				},
				{
					"lng": 11.440367840482114,
					"lat": 43.55774552919019
				},
				{
					"lng": 11.440349135797787,
					"lat": 43.55775970685733
				},
				{
					"lng": 11.440340647681479,
					"lat": 43.55777481227045
				},
				{
					"lng": 11.440338671865439,
					"lat": 43.55777874226726
				},
				{
					"lng": 11.440338466285482,
					"lat": 43.55777897532668
				},
				{
					"lng": 11.44033793706289,
					"lat": 43.5577795494454
				},
				{
					"lng": 11.440335461940663,
					"lat": 43.557781033521515
				},
				{
					"lng": 11.44033531278828,
					"lat": 43.55778112295287
				},
				{
					"lng": 11.44032896484326,
					"lat": 43.557784929161656
				},
				{
					"lng": 11.440319888626766,
					"lat": 43.55779017726597
				},
				{
					"lng": 11.440319439770732,
					"lat": 43.5577906479333
				},
				{
					"lng": 11.440314758791528,
					"lat": 43.55779555637494
				},
				{
					"lng": 11.440305699271597,
					"lat": 43.557804759477165
				},
				{
					"lng": 11.440305064003613,
					"lat": 43.55780552767727
				},
				{
					"lng": 11.440300229367388,
					"lat": 43.55781137397771
				},
				{
					"lng": 11.440299560052221,
					"lat": 43.55781218334928
				},
				{
					"lng": 11.440295573213458,
					"lat": 43.55781815847914
				},
				{
					"lng": 11.440293887002651,
					"lat": 43.5578206856259
				},
				{
					"lng": 11.440290757478046,
					"lat": 43.55782537588592
				},
				{
					"lng": 11.440290521632159,
					"lat": 43.55782572935124
				},
				{
					"lng": 11.440289769746549,
					"lat": 43.55782685621204
				},
				{
					"lng": 11.440287853014368,
					"lat": 43.55785757846502
				},
				{
					"lng": 11.440287865674945,
					"lat": 43.5578579466775
				},
				{
					"lng": 11.440287869081166,
					"lat": 43.55785804574221
				},
				{
					"lng": 11.440285550320118,
					"lat": 43.5578636120666
				},
				{
					"lng": 11.440284446702629,
					"lat": 43.55786626136608
				},
				{
					"lng": 11.440284282869493,
					"lat": 43.557866654657154
				},
				{
					"lng": 11.440283759899643,
					"lat": 43.55786719843565
				},
				{
					"lng": 11.440266371409477,
					"lat": 43.55787856425821
				},
				{
					"lng": 11.44025200351335,
					"lat": 43.55788684376644
				},
				{
					"lng": 11.440251445856422,
					"lat": 43.5578873349802
				},
				{
					"lng": 11.440249365838604,
					"lat": 43.55789042447282
				},
				{
					"lng": 11.440248765402805,
					"lat": 43.557891280608054
				},
				{
					"lng": 11.440248161915944,
					"lat": 43.55789214109361
				},
				{
					"lng": 11.440242795137571,
					"lat": 43.55789979334739
				},
				{
					"lng": 11.440242018985554,
					"lat": 43.557900900028294
				},
				{
					"lng": 11.440240049863867,
					"lat": 43.55790370771186
				},
				{
					"lng": 11.44023512664566,
					"lat": 43.55790858956029
				},
				{
					"lng": 11.440224585286952,
					"lat": 43.557913493435755
				},
				{
					"lng": 11.440223827894387,
					"lat": 43.55791391111693
				},
				{
					"lng": 11.440222138130606,
					"lat": 43.557914547503515
				},
				{
					"lng": 11.440204217853232,
					"lat": 43.557918603603035
				},
				{
					"lng": 11.440202696748862,
					"lat": 43.5579189478917
				},
				{
					"lng": 11.440201369051964,
					"lat": 43.55791924840419
				},
				{
					"lng": 11.440200041126989,
					"lat": 43.55791948173784
				},
				{
					"lng": 11.440192838023012,
					"lat": 43.55792074741644
				},
				{
					"lng": 11.440185687254948,
					"lat": 43.557923117576614
				},
				{
					"lng": 11.440185566402441,
					"lat": 43.55792319879252
				},
				{
					"lng": 11.44018557770893,
					"lat": 43.5579234189651
				},
				{
					"lng": 11.440183711538179,
					"lat": 43.557930047875765
				},
				{
					"lng": 11.440183889194632,
					"lat": 43.557930346545795
				},
				{
					"lng": 11.440184642424905,
					"lat": 43.55793161285102
				},
				{
					"lng": 11.440188398624956,
					"lat": 43.5579379276465
				},
				{
					"lng": 11.440188312962242,
					"lat": 43.557938265749954
				},
				{
					"lng": 11.440189084374229,
					"lat": 43.55793916835064
				},
				{
					"lng": 11.440193970884373,
					"lat": 43.55794504442573
				},
				{
					"lng": 11.440206596979111,
					"lat": 43.55795719889212
				},
				{
					"lng": 11.44020628368123,
					"lat": 43.55795890808236
				},
				{
					"lng": 11.44020533610043,
					"lat": 43.55796407758949
				},
				{
					"lng": 11.440205401044421,
					"lat": 43.55796963249847
				},
				{
					"lng": 11.440205451377658,
					"lat": 43.557973937688864
				},
				{
					"lng": 11.440205025667694,
					"lat": 43.557975853756325
				},
				{
					"lng": 11.440204447633178,
					"lat": 43.55797845541746
				},
				{
					"lng": 11.440202971787462,
					"lat": 43.557985098013575
				},
				{
					"lng": 11.440202076336226,
					"lat": 43.55798912832657
				},
				{
					"lng": 11.440201844741567,
					"lat": 43.55799017070472
				},
				{
					"lng": 11.440195829363976,
					"lat": 43.557998333918135
				},
				{
					"lng": 11.440195422966706,
					"lat": 43.55799876507306
				},
				{
					"lng": 11.440182014225895,
					"lat": 43.55800962748322
				},
				{
					"lng": 11.44017756497788,
					"lat": 43.55801323666913
				},
				{
					"lng": 11.440176486718197,
					"lat": 43.558014111342594
				},
				{
					"lng": 11.440167699794822,
					"lat": 43.558021239205736
				},
				{
					"lng": 11.440166214637147,
					"lat": 43.55802297841143
				},
				{
					"lng": 11.440165054784039,
					"lat": 43.558024336666534
				},
				{
					"lng": 11.440158426364803,
					"lat": 43.55803209892771
				},
				{
					"lng": 11.440149800478938,
					"lat": 43.55805093468618
				},
				{
					"lng": 11.440148884497315,
					"lat": 43.558052934852
				},
				{
					"lng": 11.440148371534724,
					"lat": 43.55805405497292
				},
				{
					"lng": 11.440143468762324,
					"lat": 43.55806482789126
				},
				{
					"lng": 11.4401431694333,
					"lat": 43.55806548561026
				},
				{
					"lng": 11.440142758294959,
					"lat": 43.55806638900906
				},
				{
					"lng": 11.440141142076556,
					"lat": 43.558068691065685
				},
				{
					"lng": 11.44012727382231,
					"lat": 43.55808844427075
				},
				{
					"lng": 11.440123855599149,
					"lat": 43.55809331300417
				},
				{
					"lng": 11.440121505523626,
					"lat": 43.55809666032497
				},
				{
					"lng": 11.440120866395574,
					"lat": 43.5580975634621
				},
				{
					"lng": 11.44012013560607,
					"lat": 43.55809796350143
				},
				{
					"lng": 11.440115184790168,
					"lat": 43.55810067361284
				},
				{
					"lng": 11.440109785217153,
					"lat": 43.55810357897903
				},
				{
					"lng": 11.440109513880502,
					"lat": 43.55810372497803
				},
				{
					"lng": 11.44010211509469,
					"lat": 43.558107706066416
				},
				{
					"lng": 11.440101608868034,
					"lat": 43.558108220786586
				},
				{
					"lng": 11.440101028788982,
					"lat": 43.5581099047263
				},
				{
					"lng": 11.440099392807136,
					"lat": 43.55811389996225
				},
				{
					"lng": 11.440092783594402,
					"lat": 43.558130040334056
				},
				{
					"lng": 11.44009163152441,
					"lat": 43.55813285380563
				},
				{
					"lng": 11.440084609981975,
					"lat": 43.55814474028435
				},
				{
					"lng": 11.440074540263968,
					"lat": 43.558161786884774
				},
				{
					"lng": 11.440074537193771,
					"lat": 43.55816179208213
				},
				{
					"lng": 11.440074499470196,
					"lat": 43.55816186556623
				},
				{
					"lng": 11.440074506746177,
					"lat": 43.55816195644101
				},
				{
					"lng": 11.440074175242765,
					"lat": 43.55817429737616
				},
				{
					"lng": 11.44007412299588,
					"lat": 43.55817624238048
				},
				{
					"lng": 11.440073777106551,
					"lat": 43.55818911886159
				},
				{
					"lng": 11.440073492159588,
					"lat": 43.55818958807857
				},
				{
					"lng": 11.440073338961518,
					"lat": 43.55818984034703
				},
				{
					"lng": 11.440072461781329,
					"lat": 43.558191284783554
				},
				{
					"lng": 11.440069362944106,
					"lat": 43.558196387581575
				},
				{
					"lng": 11.440068863374607,
					"lat": 43.5581972102133
				},
				{
					"lng": 11.440067726943914,
					"lat": 43.55819908155245
				},
				{
					"lng": 11.440060767002533,
					"lat": 43.558210542354765
				},
				{
					"lng": 11.440060397888837,
					"lat": 43.55821128463017
				},
				{
					"lng": 11.440060319318722,
					"lat": 43.558211442407995
				},
				{
					"lng": 11.44006010768682,
					"lat": 43.55821164481658
				},
				{
					"lng": 11.44005988423348,
					"lat": 43.55821208101393
				},
				{
					"lng": 11.44005542054492,
					"lat": 43.558227510968415
				},
				{
					"lng": 11.440033226121981,
					"lat": 43.558286654022986
				},
				{
					"lng": 11.440032948292444,
					"lat": 43.55828802752044
				},
				{
					"lng": 11.440032500495771,
					"lat": 43.55828918604895
				},
				{
					"lng": 11.44002203385478,
					"lat": 43.558318229451885
				},
				{
					"lng": 11.440021908420496,
					"lat": 43.55831836599978
				},
				{
					"lng": 11.440021820142425,
					"lat": 43.558318708351926
				},
				{
					"lng": 11.440016438642484,
					"lat": 43.55833524285844
				},
				{
					"lng": 11.440015556911382,
					"lat": 43.55833795195143
				},
				{
					"lng": 11.44000412718646,
					"lat": 43.558373069426416
				},
				{
					"lng": 11.440004117424255,
					"lat": 43.55837412428843
				},
				{
					"lng": 11.44000410751874,
					"lat": 43.558375194635964
				},
				{
					"lng": 11.440004047921512,
					"lat": 43.5583816344602
				},
				{
					"lng": 11.440003324615507,
					"lat": 43.55838405889827
				},
				{
					"lng": 11.439999521990936,
					"lat": 43.55839680485285
				},
				{
					"lng": 11.439994420274664,
					"lat": 43.55841390520361
				},
				{
					"lng": 11.439985309761965,
					"lat": 43.55842891783522
				},
				{
					"lng": 11.439978905766976,
					"lat": 43.55843947056462
				},
				{
					"lng": 11.43997825263799,
					"lat": 43.55844054681347
				},
				{
					"lng": 11.439976234496553,
					"lat": 43.55844145583241
				},
				{
					"lng": 11.439974508185779,
					"lat": 43.558442233403866
				},
				{
					"lng": 11.439972672665617,
					"lat": 43.55844306016571
				},
				{
					"lng": 11.439966451185581,
					"lat": 43.55846084307084
				},
				{
					"lng": 11.439965424785088,
					"lat": 43.55846377683845
				},
				{
					"lng": 11.439963316775279,
					"lat": 43.55846688116317
				},
				{
					"lng": 11.439963096068391,
					"lat": 43.55846720618343
				},
				{
					"lng": 11.439958126171337,
					"lat": 43.5584745250161
				},
				{
					"lng": 11.439955611875085,
					"lat": 43.55847822765019
				},
				{
					"lng": 11.439952279185563,
					"lat": 43.55848313547591
				},
				{
					"lng": 11.439951349522707,
					"lat": 43.5584845045272
				},
				{
					"lng": 11.439941536788035,
					"lat": 43.558497732465106
				},
				{
					"lng": 11.439930481981351,
					"lat": 43.55851048968313
				},
				{
					"lng": 11.439921742957297,
					"lat": 43.55851826489559
				},
				{
					"lng": 11.43991970581101,
					"lat": 43.5585200773682
				},
				{
					"lng": 11.439907521043706,
					"lat": 43.5585309182937
				},
				{
					"lng": 11.439907460606141,
					"lat": 43.55853099096881
				},
				{
					"lng": 11.439905355946866,
					"lat": 43.558533521785606
				},
				{
					"lng": 11.439898883849407,
					"lat": 43.55854130437051
				},
				{
					"lng": 11.439892778229096,
					"lat": 43.55854864627088
				},
				{
					"lng": 11.439889335975284,
					"lat": 43.55855278551919
				},
				{
					"lng": 11.439878813097902,
					"lat": 43.558560962882716
				},
				{
					"lng": 11.439877412895004,
					"lat": 43.55856205174979
				},
				{
					"lng": 11.43987353172018,
					"lat": 43.55856506994315
				},
				{
					"lng": 11.439867519568585,
					"lat": 43.55857027559149
				},
				{
					"lng": 11.439858384189288,
					"lat": 43.55857818557639
				},
				{
					"lng": 11.439858211237249,
					"lat": 43.558578335329074
				},
				{
					"lng": 11.439857358628595,
					"lat": 43.55857882151326
				},
				{
					"lng": 11.439856240959122,
					"lat": 43.558579458843404
				},
				{
					"lng": 11.439855742085838,
					"lat": 43.558579567449826
				},
				{
					"lng": 11.439851388178571,
					"lat": 43.5585815002686
				},
				{
					"lng": 11.43985133135796,
					"lat": 43.55858152546778
				},
				{
					"lng": 11.439850619445629,
					"lat": 43.558581841191526
				},
				{
					"lng": 11.439850576414655,
					"lat": 43.558581860283816
				},
				{
					"lng": 11.439849558089216,
					"lat": 43.558582312102544
				},
				{
					"lng": 11.439849537607614,
					"lat": 43.55858232118996
				},
				{
					"lng": 11.439847289851436,
					"lat": 43.55858256041191
				},
				{
					"lng": 11.439847003197157,
					"lat": 43.55858259091965
				},
				{
					"lng": 11.439840842235869,
					"lat": 43.5585832466122
				},
				{
					"lng": 11.439836199601118,
					"lat": 43.55858374071355
				},
				{
					"lng": 11.439826251285671,
					"lat": 43.55858247119181
				},
				{
					"lng": 11.439825635309003,
					"lat": 43.55858264580967
				},
				{
					"lng": 11.439823958344011,
					"lat": 43.55858312119789
				},
				{
					"lng": 11.439819279080444,
					"lat": 43.55858444768142
				},
				{
					"lng": 11.43981827028863,
					"lat": 43.558584733654996
				},
				{
					"lng": 11.439817623951877,
					"lat": 43.558584916879326
				},
				{
					"lng": 11.439816770195103,
					"lat": 43.558585569278534
				},
				{
					"lng": 11.43981535741514,
					"lat": 43.558587029195245
				},
				{
					"lng": 11.439813898229524,
					"lat": 43.558588537065845
				},
				{
					"lng": 11.439812599615617,
					"lat": 43.55858987900724
				},
				{
					"lng": 11.439810575867554,
					"lat": 43.558591970276275
				},
				{
					"lng": 11.439809927025232,
					"lat": 43.55859264076677
				},
				{
					"lng": 11.43979380270574,
					"lat": 43.55860930438796
				},
				{
					"lng": 11.439791409608846,
					"lat": 43.558611777524604
				},
				{
					"lng": 11.439791041259031,
					"lat": 43.55861269661857
				},
				{
					"lng": 11.439790496357931,
					"lat": 43.55861377789772
				},
				{
					"lng": 11.439790158397368,
					"lat": 43.558614773227966
				},
				{
					"lng": 11.439789646814615,
					"lat": 43.55861589594877
				},
				{
					"lng": 11.439789371738724,
					"lat": 43.55861696255281
				},
				{
					"lng": 11.439788904277226,
					"lat": 43.558618118239224
				},
				{
					"lng": 11.439788873141802,
					"lat": 43.55861922777308
				},
				{
					"lng": 11.439788490138982,
					"lat": 43.55862039638227
				},
				{
					"lng": 11.43978828709428,
					"lat": 43.55862079348566
				},
				{
					"lng": 11.439786868925596,
					"lat": 43.55862186331798
				},
				{
					"lng": 11.439786257325874,
					"lat": 43.55862304425279
				},
				{
					"lng": 11.439783506743975,
					"lat": 43.55862457195358
				},
				{
					"lng": 11.439783514911388,
					"lat": 43.55862553400437
				},
				{
					"lng": 11.439780595671046,
					"lat": 43.55862688117595
				},
				{
					"lng": 11.439778407216917,
					"lat": 43.55862790416991
				},
				{
					"lng": 11.439775630543405,
					"lat": 43.55862897353373
				},
				{
					"lng": 11.439773324092972,
					"lat": 43.55862975015678
				},
				{
					"lng": 11.439771175141308,
					"lat": 43.55863055633804
				},
				{
					"lng": 11.439769526665579,
					"lat": 43.55863111599651
				},
				{
					"lng": 11.439767823657071,
					"lat": 43.558631744503
				},
				{
					"lng": 11.439766596314444,
					"lat": 43.5586321646297
				},
				{
					"lng": 11.439765226801844,
					"lat": 43.55863267023194
				},
				{
					"lng": 11.43976429799571,
					"lat": 43.558632997622205
				},
				{
					"lng": 11.4397631716459,
					"lat": 43.55863341568028
				},
				{
					"lng": 11.43976245366678,
					"lat": 43.558633679022975
				},
				{
					"lng": 11.439761518332135,
					"lat": 43.55863403463928
				},
				{
					"lng": 11.43976095042321,
					"lat": 43.55863425175892
				},
				{
					"lng": 11.439760159576474,
					"lat": 43.55863456077699
				},
				{
					"lng": 11.439759699869114,
					"lat": 43.558634742803235
				},
				{
					"lng": 11.43975901949077,
					"lat": 43.55863501564038
				},
				{
					"lng": 11.439758640107678,
					"lat": 43.5586351700407
				},
				{
					"lng": 11.43975804502617,
					"lat": 43.5586354135725
				},
				{
					"lng": 11.439757727958677,
					"lat": 43.55863554598739
				},
				{
					"lng": 11.439757200513585,
					"lat": 43.55863576525726
				},
				{
					"lng": 11.439756932535824,
					"lat": 43.55863587974113
				},
				{
					"lng": 11.439756459881679,
					"lat": 43.558636078550755
				},
				{
					"lng": 11.43975623161398,
					"lat": 43.558636178325756
				},
				{
					"lng": 11.439755802885127,
					"lat": 43.55863635900073
				},
				{
					"lng": 11.439755605834325,
					"lat": 43.55863644584837
				},
				{
					"lng": 11.439755206721973,
					"lat": 43.55863660673888
				},
				{
					"lng": 11.439755033666689,
					"lat": 43.55863668141263
				},
				{
					"lng": 11.439754758116637,
					"lat": 43.55863688226909
				},
				{
					"lng": 11.439754618429475,
					"lat": 43.55863695567002
				},
				{
					"lng": 11.43975439217394,
					"lat": 43.558637165448026
				},
				{
					"lng": 11.439754314147743,
					"lat": 43.55863726094088
				},
				{
					"lng": 11.439754125615881,
					"lat": 43.55863747971859
				},
				{
					"lng": 11.439754058938574,
					"lat": 43.55863756968885
				},
				{
					"lng": 11.439753900685556,
					"lat": 43.558637796967055
				},
				{
					"lng": 11.43975384756987,
					"lat": 43.55863788503077
				},
				{
					"lng": 11.439753714064352,
					"lat": 43.55863812061499
				},
				{
					"lng": 11.439753670824743,
					"lat": 43.55863820590132
				},
				{
					"lng": 11.439753558757653,
					"lat": 43.55863845037648
				},
				{
					"lng": 11.439753524381723,
					"lat": 43.55863853358538
				},
				{
					"lng": 11.439753429649283,
					"lat": 43.55863878626015
				},
				{
					"lng": 11.43975284655469,
					"lat": 43.5586406469672
				},
				{
					"lng": 11.439752697521914,
					"lat": 43.55864112245833
				},
				{
					"lng": 11.439752278485184,
					"lat": 43.55864245940072
				},
				{
					"lng": 11.439752061770648,
					"lat": 43.55864315082972
				},
				{
					"lng": 11.439751793805213,
					"lat": 43.5586440057749
				},
				{
					"lng": 11.439751426909137,
					"lat": 43.55864517635577
				},
				{
					"lng": 11.439751170059418,
					"lat": 43.5586459958341
				},
				{
					"lng": 11.439750890012375,
					"lat": 43.558646889321096
				},
				{
					"lng": 11.439750770186436,
					"lat": 43.55864727162449
				},
				{
					"lng": 11.43975032658509,
					"lat": 43.55864868692662
				},
				{
					"lng": 11.439750207206654,
					"lat": 43.55864906780143
				},
				{
					"lng": 11.439750204848973,
					"lat": 43.558649075323544
				},
				{
					"lng": 11.439750204326259,
					"lat": 43.558649076991195
				},
				{
					"lng": 11.439750194130125,
					"lat": 43.55864910952179
				},
				{
					"lng": 11.439750191889209,
					"lat": 43.558649116671404
				},
				{
					"lng": 11.439750189280337,
					"lat": 43.558649124994936
				},
				{
					"lng": 11.439750188710299,
					"lat": 43.55864912681362
				},
				{
					"lng": 11.439750177804658,
					"lat": 43.55864916160779
				},
				{
					"lng": 11.439750175444072,
					"lat": 43.5586491691393
				},
				{
					"lng": 11.439750172551706,
					"lat": 43.55864917836725
				},
				{
					"lng": 11.43975017192957,
					"lat": 43.55864918035209
				},
				{
					"lng": 11.43975016024016,
					"lat": 43.5586492176469
				},
				{
					"lng": 11.43975015775125,
					"lat": 43.55864922558774
				},
				{
					"lng": 11.439750154537723,
					"lat": 43.558649235840456
				},
				{
					"lng": 11.439750153858194,
					"lat": 43.55864923800852
				},
				{
					"lng": 11.439750150718536,
					"lat": 43.55864924802545
				},
				{
					"lng": 11.439750150057039,
					"lat": 43.55864925013599
				},
				{
					"lng": 11.439750139074734,
					"lat": 43.5586492851747
				},
				{
					"lng": 11.439750136783298,
					"lat": 43.55864929248548
				},
				{
					"lng": 11.439750125517508,
					"lat": 43.55864932842877
				},
				{
					"lng": 11.439750123197122,
					"lat": 43.55864933583195
				},
				{
					"lng": 11.43975008167937,
					"lat": 43.5586494682933
				},
				{
					"lng": 11.43975007344192,
					"lat": 43.55864949457469
				},
				{
					"lng": 11.439750063098252,
					"lat": 43.558649527575966
				},
				{
					"lng": 11.439750061093358,
					"lat": 43.55864953397251
				},
				{
					"lng": 11.439750021596492,
					"lat": 43.55864965998622
				},
				{
					"lng": 11.439750014214269,
					"lat": 43.558649683539095
				},
				{
					"lng": 11.439750004705944,
					"lat": 43.55864971387514
				},
				{
					"lng": 11.439750002967129,
					"lat": 43.55864971942277
				},
				{
					"lng": 11.439749965331666,
					"lat": 43.5586498394978
				},
				{
					"lng": 11.43974995868871,
					"lat": 43.55864986069197
				},
				{
					"lng": 11.439749949939447,
					"lat": 43.55864988860627
				},
				{
					"lng": 11.439749948426376,
					"lat": 43.55864989343367
				},
				{
					"lng": 11.439749912488331,
					"lat": 43.5586500080931
				},
				{
					"lng": 11.43974990648477,
					"lat": 43.55865002724732
				},
				{
					"lng": 11.43974989842906,
					"lat": 43.55865005294876
				},
				{
					"lng": 11.439749897108928,
					"lat": 43.55865005716064
				},
				{
					"lng": 11.439749862744803,
					"lat": 43.55865016679857
				},
				{
					"lng": 11.439749857300969,
					"lat": 43.55865018416685
				},
				{
					"lng": 11.439749849875945,
					"lat": 43.55865020785623
				},
				{
					"lng": 11.439749848720785,
					"lat": 43.55865021154179
				},
				{
					"lng": 11.439749815819686,
					"lat": 43.55865031651175
				},
				{
					"lng": 11.439749810868394,
					"lat": 43.55865033230874
				},
				{
					"lng": 11.43974980402396,
					"lat": 43.55865035414575
				},
				{
					"lng": 11.439749803011333,
					"lat": 43.55865035737645
				},
				{
					"lng": 11.439749781462757,
					"lat": 43.55865042612659
				},
				{
					"lng": 11.439749778346973,
					"lat": 43.558650436067396
				},
				{
					"lng": 11.439749773959395,
					"lat": 43.5586504500659
				},
				{
					"lng": 11.439749773331961,
					"lat": 43.558650452067724
				},
				{
					"lng": 11.439749767737613,
					"lat": 43.558650469916245
				},
				{
					"lng": 11.439749766943065,
					"lat": 43.55865047245129
				},
				{
					"lng": 11.439749760630361,
					"lat": 43.558650492591745
				},
				{
					"lng": 11.439749759740899,
					"lat": 43.55865049542962
				},
				{
					"lng": 11.439749744027582,
					"lat": 43.55865054556245
				},
				{
					"lng": 11.439749741852031,
					"lat": 43.55865055250347
				},
				{
					"lng": 11.439749727290122,
					"lat": 43.55865059896288
				},
				{
					"lng": 11.439749725312911,
					"lat": 43.55865060527109
				},
				{
					"lng": 11.439749719489507,
					"lat": 43.5586506238505
				},
				{
					"lng": 11.439749718706949,
					"lat": 43.55865062634719
				},
				{
					"lng": 11.439749689583056,
					"lat": 43.5586507192661
				},
				{
					"lng": 11.439749685791657,
					"lat": 43.55865073136254
				},
				{
					"lng": 11.439749680419492,
					"lat": 43.558650748502245
				},
				{
					"lng": 11.439749679730166,
					"lat": 43.55865075070153
				},
				{
					"lng": 11.43974965170458,
					"lat": 43.55865084011629
				},
				{
					"lng": 11.439749648219335,
					"lat": 43.55865085123589
				},
				{
					"lng": 11.439749643265843,
					"lat": 43.5586508670398
				},
				{
					"lng": 11.439749642658214,
					"lat": 43.55865086897841
				},
				{
					"lng": 11.439749615659995,
					"lat": 43.55865095511547
				},
				{
					"lng": 11.43974961244913,
					"lat": 43.55865096535964
				},
				{
					"lng": 11.439749607880405,
					"lat": 43.55865097993605
				},
				{
					"lng": 11.439749607344051,
					"lat": 43.558650981647205
				},
				{
					"lng": 11.439749581304008,
					"lat": 43.558651064727165
				},
				{
					"lng": 11.439749578339361,
					"lat": 43.558651074185725
				},
				{
					"lng": 11.439749574128776,
					"lat": 43.558651087619516
				},
				{
					"lng": 11.439749573655309,
					"lat": 43.5586510891301
				},
				{
					"lng": 11.439749548519483,
					"lat": 43.558651169325245
				},
				{
					"lng": 11.439749545777458,
					"lat": 43.55865117807352
				},
				{
					"lng": 11.439749541899364,
					"lat": 43.55865119044648
				},
				{
					"lng": 11.43974954148125,
					"lat": 43.558651191780456
				},
				{
					"lng": 11.43974951719562,
					"lat": 43.558651269262995
				},
				{
					"lng": 11.439749514655,
					"lat": 43.55865127736869
				},
				{
					"lng": 11.439749511085918,
					"lat": 43.55865128875582
				},
				{
					"lng": 11.439749510716682,
					"lat": 43.55865128993383
				},
				{
					"lng": 11.439749487231635,
					"lat": 43.558651364862065
				},
				{
					"lng": 11.43974948487367,
					"lat": 43.55865137238511
				},
				{
					"lng": 11.439749481592244,
					"lat": 43.55865138285446
				},
				{
					"lng": 11.439749481266258,
					"lat": 43.558651383894464
				},
				{
					"lng": 11.439749458536303,
					"lat": 43.55865145641364
				},
				{
					"lng": 11.439749456344439,
					"lat": 43.55865146340672
				},
				{
					"lng": 11.439749453330577,
					"lat": 43.55865147302233
				},
				{
					"lng": 11.4397494530429,
					"lat": 43.55865147394022
				},
				{
					"lng": 11.439749431029563,
					"lat": 43.558651544173
				},
				{
					"lng": 11.439749428989431,
					"lat": 43.55865155068201
				},
				{
					"lng": 11.439749425972096,
					"lat": 43.55865156030867
				},
				{
					"lng": 11.439749404629497,
					"lat": 43.55865162840153
				},
				{
					"lng": 11.439749402727356,
					"lat": 43.5586516344703
				},
				{
					"lng": 11.439749399974556,
					"lat": 43.55865164325301
				},
				{
					"lng": 11.439749379276911,
					"lat": 43.55865170928818
				},
				{
					"lng": 11.439749377501919,
					"lat": 43.558651714951154
				},
				{
					"lng": 11.439749374994284,
					"lat": 43.55865172295165
				},
				{
					"lng": 11.439749354898401,
					"lat": 43.558651787066864
				},
				{
					"lng": 11.439749353239302,
					"lat": 43.55865179236017
				},
				{
					"lng": 11.439749350960438,
					"lat": 43.55865179963085
				},
				{
					"lng": 11.439749331444718,
					"lat": 43.55865186189508
				},
				{
					"lng": 11.439749329892841,
					"lat": 43.55865186684629
				},
				{
					"lng": 11.439749327827311,
					"lat": 43.558651873436254
				},
				{
					"lng": 11.439749326329578,
					"lat": 43.55865187821477
				},
				{
					"lng": 11.439749307269874,
					"lat": 43.558651939024095
				},
				{
					"lng": 11.439749305536361,
					"lat": 43.55865194455484
				},
				{
					"lng": 11.439749304119104,
					"lat": 43.55865194907652
				},
				{
					"lng": 11.439749285721597,
					"lat": 43.55865200777308
				},
				{
					"lng": 11.43974920110903,
					"lat": 43.558652277726
				},
				{
					"lng": 11.439748602843576,
					"lat": 43.558654186467045
				},
				{
					"lng": 11.439748120433169,
					"lat": 43.55865506224613
				},
				{
					"lng": 11.439748084137907,
					"lat": 43.55865512813719
				},
				{
					"lng": 11.439746624867553,
					"lat": 43.55865777732127
				},
				{
					"lng": 11.439746480634449,
					"lat": 43.558658039163596
				},
				{
					"lng": 11.439745049006014,
					"lat": 43.5586606381572
				},
				{
					"lng": 11.439745036436832,
					"lat": 43.55866066097534
				},
				{
					"lng": 11.439744966955342,
					"lat": 43.558660787112565
				},
				{
					"lng": 11.439744957317393,
					"lat": 43.55866080460937
				},
				{
					"lng": 11.439744905217141,
					"lat": 43.55866089919257
				},
				{
					"lng": 11.439744897097931,
					"lat": 43.558660913932165
				},
				{
					"lng": 11.439744853923603,
					"lat": 43.55866099231122
				},
				{
					"lng": 11.439744724281383,
					"lat": 43.55866122766434
				},
				{
					"lng": 11.439744040092133,
					"lat": 43.55866246974519
				},
				{
					"lng": 11.439741887874488,
					"lat": 43.5586663773387
				},
				{
					"lng": 11.439741464810842,
					"lat": 43.55866684379499
				},
				{
					"lng": 11.439701422714132,
					"lat": 43.558710992877565
				},
				{
					"lng": 11.439699549558238,
					"lat": 43.558713058155014
				},
				{
					"lng": 11.4396983284675,
					"lat": 43.558714279190134
				},
				{
					"lng": 11.43969772810604,
					"lat": 43.55871487952424
				},
				{
					"lng": 11.439697004434786,
					"lat": 43.55871560308421
				},
				{
					"lng": 11.439696868821866,
					"lat": 43.55871573867627
				},
				{
					"lng": 11.439696807533798,
					"lat": 43.55871579995475
				},
				{
					"lng": 11.439694155943682,
					"lat": 43.55871773824903
				},
				{
					"lng": 11.439694101484413,
					"lat": 43.558717778058394
				},
				{
					"lng": 11.439694097480137,
					"lat": 43.5587177809855
				},
				{
					"lng": 11.439692993312496,
					"lat": 43.55871847084706
				},
				{
					"lng": 11.439692813206348,
					"lat": 43.558718583373526
				},
				{
					"lng": 11.439691629242372,
					"lat": 43.558719323089136
				},
				{
					"lng": 11.439691285484843,
					"lat": 43.558719537861194
				},
				{
					"lng": 11.439690030977545,
					"lat": 43.55872032164938
				},
				{
					"lng": 11.439689452397907,
					"lat": 43.5587206831322
				},
				{
					"lng": 11.439687827743342,
					"lat": 43.55872169817776
				},
				{
					"lng": 11.439687125166847,
					"lat": 43.55872213712959
				},
				{
					"lng": 11.439685568540275,
					"lat": 43.55872310967008
				},
				{
					"lng": 11.439685542464607,
					"lat": 43.558723125961464
				},
				{
					"lng": 11.439685499764586,
					"lat": 43.55872315263928
				},
				{
					"lng": 11.439685385897752,
					"lat": 43.558723223780284
				},
				{
					"lng": 11.439685196532434,
					"lat": 43.55872334209067
				},
				{
					"lng": 11.439684236486729,
					"lat": 43.558723941900844
				},
				{
					"lng": 11.439683526728194,
					"lat": 43.55872438533841
				},
				{
					"lng": 11.439683433953647,
					"lat": 43.55872444330131
				},
				{
					"lng": 11.43968337224951,
					"lat": 43.55872448185233
				},
				{
					"lng": 11.439683187182142,
					"lat": 43.55872459747714
				},
				{
					"lng": 11.439683061846036,
					"lat": 43.55872467578357
				},
				{
					"lng": 11.439682789885033,
					"lat": 43.55872484569698
				},
				{
					"lng": 11.43968260194295,
					"lat": 43.55872496311776
				},
				{
					"lng": 11.43968216479665,
					"lat": 43.55872523623393
				},
				{
					"lng": 11.439681852455859,
					"lat": 43.558725431375336
				},
				{
					"lng": 11.439681278120192,
					"lat": 43.558725790202956
				},
				{
					"lng": 11.439680854587417,
					"lat": 43.55872605481343
				},
				{
					"lng": 11.439680736036351,
					"lat": 43.55872612888052
				},
				{
					"lng": 11.439680652366286,
					"lat": 43.55872618115503
				},
				{
					"lng": 11.43968062680708,
					"lat": 43.558726197123626
				},
				{
					"lng": 11.439680608917637,
					"lat": 43.558726208300385
				},
				{
					"lng": 11.43967970047801,
					"lat": 43.55872677586488
				},
				{
					"lng": 11.439678990085108,
					"lat": 43.55872721969599
				},
				{
					"lng": 11.43967898742706,
					"lat": 43.558727221356655
				},
				{
					"lng": 11.439678985522496,
					"lat": 43.55872722254655
				},
				{
					"lng": 11.439678541087247,
					"lat": 43.55872750021523
				},
				{
					"lng": 11.439678206299495,
					"lat": 43.558727709379696
				},
				{
					"lng": 11.439677678913354,
					"lat": 43.55872803887299
				},
				{
					"lng": 11.439677274690583,
					"lat": 43.55872829141789
				},
				{
					"lng": 11.439674607347191,
					"lat": 43.558729957683724
				},
				{
					"lng": 11.439673964402294,
					"lat": 43.55873035932575
				},
				{
					"lng": 11.439670878623074,
					"lat": 43.558738293506245
				},
				{
					"lng": 11.439664704574739,
					"lat": 43.5587541682632
				},
				{
					"lng": 11.439661223725635,
					"lat": 43.55875867102214
				},
				{
					"lng": 11.439660865312435,
					"lat": 43.55875913465846
				},
				{
					"lng": 11.439641027535595,
					"lat": 43.55878479889372
				},
				{
					"lng": 11.439622393118828,
					"lat": 43.55879296618873
				},
				{
					"lng": 11.439621041621296,
					"lat": 43.558793558537594
				},
				{
					"lng": 11.439620816125258,
					"lat": 43.55879365738217
				},
				{
					"lng": 11.439620767057317,
					"lat": 43.55879367889075
				},
				{
					"lng": 11.439616914765544,
					"lat": 43.558795367513106
				},
				{
					"lng": 11.43961500276001,
					"lat": 43.558797380431706
				},
				{
					"lng": 11.439614689248582,
					"lat": 43.55879771048978
				},
				{
					"lng": 11.439611871082752,
					"lat": 43.55879756501431
				},
				{
					"lng": 11.439608974597471,
					"lat": 43.55879868633166
				},
				{
					"lng": 11.439604217378513,
					"lat": 43.55879963307161
				},
				{
					"lng": 11.439602166857794,
					"lat": 43.55880004106501
				},
				{
					"lng": 11.439602053902435,
					"lat": 43.558800063539834
				},
				{
					"lng": 11.439584519984058,
					"lat": 43.55880935523028
				},
				{
					"lng": 11.439584139945055,
					"lat": 43.558810097305624
				},
				{
					"lng": 11.439583199358154,
					"lat": 43.558815812493464
				},
				{
					"lng": 11.439582718722406,
					"lat": 43.5588187329287
				},
				{
					"lng": 11.439582229210263,
					"lat": 43.558826271652286
				},
				{
					"lng": 11.439582061891103,
					"lat": 43.55882750685794
				},
				{
					"lng": 11.439582082470611,
					"lat": 43.55882762661184
				},
				{
					"lng": 11.439581144928454,
					"lat": 43.55882927485379
				},
				{
					"lng": 11.439580917385774,
					"lat": 43.55882965884822
				},
				{
					"lng": 11.43958074101398,
					"lat": 43.55882995647393
				},
				{
					"lng": 11.439575829259812,
					"lat": 43.55883824500955
				},
				{
					"lng": 11.439575260830859,
					"lat": 43.55883897058694
				},
				{
					"lng": 11.439555626982976,
					"lat": 43.558852290925046
				},
				{
					"lng": 11.439554819556438,
					"lat": 43.55885287176325
				},
				{
					"lng": 11.43955477002293,
					"lat": 43.55885294076661
				},
				{
					"lng": 11.439551322388175,
					"lat": 43.55885774354412
				},
				{
					"lng": 11.439544877610444,
					"lat": 43.55886672219051
				},
				{
					"lng": 11.439544482448964,
					"lat": 43.558867422557405
				},
				{
					"lng": 11.43953912274548,
					"lat": 43.55887595957754
				},
				{
					"lng": 11.439538404153387,
					"lat": 43.55887710416217
				},
				{
					"lng": 11.439518785139606,
					"lat": 43.55890835333874
				},
				{
					"lng": 11.439517500778958,
					"lat": 43.55891039906793
				},
				{
					"lng": 11.439517431390009,
					"lat": 43.558910925829316
				},
				{
					"lng": 11.439516994947688,
					"lat": 43.55891423905066
				},
				{
					"lng": 11.43957654375673,
					"lat": 43.558934866960435
				},
				{
					"lng": 11.43962307736367,
					"lat": 43.5589394399882
				},
				{
					"lng": 11.439642635983345,
					"lat": 43.558940809799466
				},
				{
					"lng": 11.439657881369149,
					"lat": 43.558941877525875
				},
				{
					"lng": 11.439699535041917,
					"lat": 43.55894181319763
				},
				{
					"lng": 11.439729746938015,
					"lat": 43.55894768485035
				},
				{
					"lng": 11.43977697866483,
					"lat": 43.558955343423484
				},
				{
					"lng": 11.439792443361432,
					"lat": 43.55895976028658
				},
				{
					"lng": 11.439792881210446,
					"lat": 43.558960117929644
				},
				{
					"lng": 11.43979292792616,
					"lat": 43.55896014823706
				},
				{
					"lng": 11.43979337874397,
					"lat": 43.558960468556364
				},
				{
					"lng": 11.439793437276185,
					"lat": 43.558960503150495
				},
				{
					"lng": 11.439793942853605,
					"lat": 43.55896081990999
				},
				{
					"lng": 11.439794015637263,
					"lat": 43.55896085951463
				},
				{
					"lng": 11.439794581791759,
					"lat": 43.55896118046764
				},
				{
					"lng": 11.439794672447821,
					"lat": 43.55896122533515
				},
				{
					"lng": 11.43979519266141,
					"lat": 43.558961488056596
				},
				{
					"lng": 11.43979672516887,
					"lat": 43.5589621945756
				},
				{
					"lng": 11.439797112924262,
					"lat": 43.55896236687482
				},
				{
					"lng": 11.439797280891437,
					"lat": 43.55896244209402
				},
				{
					"lng": 11.439798212835358,
					"lat": 43.558962846785455
				},
				{
					"lng": 11.439807627826964,
					"lat": 43.55896749725791
				},
				{
					"lng": 11.439810627728514,
					"lat": 43.55896817385395
				},
				{
					"lng": 11.439811579997988,
					"lat": 43.55896843214641
				},
				{
					"lng": 11.439814347515174,
					"lat": 43.55896913653227
				},
				{
					"lng": 11.4398150956563,
					"lat": 43.5589693767234
				},
				{
					"lng": 11.439817193491738,
					"lat": 43.558969997316616
				},
				{
					"lng": 11.439817788640735,
					"lat": 43.55897023204375
				},
				{
					"lng": 11.439819399038873,
					"lat": 43.558970807470345
				},
				{
					"lng": 11.439819871552858,
					"lat": 43.5589710477329
				},
				{
					"lng": 11.439821116328233,
					"lat": 43.558971604168256
				},
				{
					"lng": 11.439821489920059,
					"lat": 43.55897185780713
				},
				{
					"lng": 11.439822475132159,
					"lat": 43.55897240177246
				},
				{
					"lng": 11.43982277982077,
					"lat": 43.558972667642685
				},
				{
					"lng": 11.439823567908816,
					"lat": 43.558973207098624
				},
				{
					"lng": 11.43982386833475,
					"lat": 43.55897345602385
				},
				{
					"lng": 11.439838483434569,
					"lat": 43.55897610493638
				},
				{
					"lng": 11.439852411235933,
					"lat": 43.558974754695505
				},
				{
					"lng": 11.439861873505793,
					"lat": 43.55897814962417
				},
				{
					"lng": 11.439884553930327,
					"lat": 43.55898885023007
				},
				{
					"lng": 11.439888337759955,
					"lat": 43.55899049641442
				},
				{
					"lng": 11.439890160067787,
					"lat": 43.55899222682938
				},
				{
					"lng": 11.439890338948016,
					"lat": 43.55899293825701
				},
				{
					"lng": 11.43989111264157,
					"lat": 43.55899587840128
				},
				{
					"lng": 11.439895132656458,
					"lat": 43.559011155017494
				},
				{
					"lng": 11.439895452208223,
					"lat": 43.559012369358236
				},
				{
					"lng": 11.439898051031792,
					"lat": 43.559013942801414
				},
				{
					"lng": 11.43989847503087,
					"lat": 43.55901682658326
				},
				{
					"lng": 11.439898625753239,
					"lat": 43.55901785170456
				},
				{
					"lng": 11.43989881800513,
					"lat": 43.559019159283935
				},
				{
					"lng": 11.43989924564442,
					"lat": 43.55902012796833
				},
				{
					"lng": 11.439904220476034,
					"lat": 43.55903139690588
				},
				{
					"lng": 11.439921061805435,
					"lat": 43.55906954567779
				},
				{
					"lng": 11.43992194629049,
					"lat": 43.559071549200965
				},
				{
					"lng": 11.43992225890554,
					"lat": 43.55907225733217
				},
				{
					"lng": 11.439937240766998,
					"lat": 43.55909443143255
				},
				{
					"lng": 11.439938625541219,
					"lat": 43.559096470687464
				},
				{
					"lng": 11.4399421199763,
					"lat": 43.55910161668361
				},
				{
					"lng": 11.439951517489995,
					"lat": 43.5591201086848
				},
				{
					"lng": 11.43995206855145,
					"lat": 43.55912157444824
				},
				{
					"lng": 11.439954637738781,
					"lat": 43.55912840820578
				},
				{
					"lng": 11.43995488807896,
					"lat": 43.55912867170479
				},
				{
					"lng": 11.43997720530156,
					"lat": 43.559136741891336
				},
				{
					"lng": 11.43997716464992,
					"lat": 43.55913779055444
				},
				{
					"lng": 11.439977160526913,
					"lat": 43.55913789691314
				},
				{
					"lng": 11.43997695545871,
					"lat": 43.559143186919066
				},
				{
					"lng": 11.439976951602196,
					"lat": 43.55914328640315
				},
				{
					"lng": 11.43997693930778,
					"lat": 43.55914360355359
				},
				{
					"lng": 11.439976939118786,
					"lat": 43.559143608428705
				},
				{
					"lng": 11.439976938863653,
					"lat": 43.55914361501072
				},
				{
					"lng": 11.439976938608188,
					"lat": 43.559143621600484
				},
				{
					"lng": 11.439976938350057,
					"lat": 43.559143628259264
				},
				{
					"lng": 11.43997693808754,
					"lat": 43.55914363503107
				},
				{
					"lng": 11.439976937818168,
					"lat": 43.5591436419803
				},
				{
					"lng": 11.439976937503827,
					"lat": 43.55914365008878
				},
				{
					"lng": 11.439976937214752,
					"lat": 43.559143657546095
				},
				{
					"lng": 11.439976936912744,
					"lat": 43.559143665336315
				},
				{
					"lng": 11.439976936594407,
					"lat": 43.559143673548505
				},
				{
					"lng": 11.439976936254277,
					"lat": 43.5591436823227
				},
				{
					"lng": 11.439976935877125,
					"lat": 43.55914369205191
				},
				{
					"lng": 11.439976935428287,
					"lat": 43.55914370362999
				},
				{
					"lng": 11.43997693495179,
					"lat": 43.55914371592172
				},
				{
					"lng": 11.439976934525841,
					"lat": 43.559143726910065
				},
				{
					"lng": 11.43997693406926,
					"lat": 43.55914373868809
				},
				{
					"lng": 11.4399769335707,
					"lat": 43.55914375154882
				},
				{
					"lng": 11.439976933030513,
					"lat": 43.559143765483924
				},
				{
					"lng": 11.439976932453183,
					"lat": 43.55914378037723
				},
				{
					"lng": 11.439976931833913,
					"lat": 43.5591437963514
				},
				{
					"lng": 11.43997693113092,
					"lat": 43.55914381448624
				},
				{
					"lng": 11.43997693041504,
					"lat": 43.559143832953914
				},
				{
					"lng": 11.439976929641826,
					"lat": 43.55914385289927
				},
				{
					"lng": 11.439976928802997,
					"lat": 43.55914387453817
				},
				{
					"lng": 11.43997692876597,
					"lat": 43.559143875493675
				},
				{
					"lng": 11.439976927853209,
					"lat": 43.559143899039185
				},
				{
					"lng": 11.439976926856948,
					"lat": 43.55914392473941
				},
				{
					"lng": 11.439976925768505,
					"lat": 43.559143952817195
				},
				{
					"lng": 11.43997692453184,
					"lat": 43.55914398471853
				},
				{
					"lng": 11.439976923237476,
					"lat": 43.5591440181081
				},
				{
					"lng": 11.439976921838351,
					"lat": 43.559144054200154
				},
				{
					"lng": 11.43997692180028,
					"lat": 43.559144055182315
				},
				{
					"lng": 11.439976920303994,
					"lat": 43.55914409378128
				},
				{
					"lng": 11.439976918865568,
					"lat": 43.55914413088755
				},
				{
					"lng": 11.439976918685348,
					"lat": 43.559144135536485
				},
				{
					"lng": 11.439976917196084,
					"lat": 43.559144173953825
				},
				{
					"lng": 11.439976917037644,
					"lat": 43.55914417804097
				},
				{
					"lng": 11.439976915348172,
					"lat": 43.559144221622866
				},
				{
					"lng": 11.439976915299189,
					"lat": 43.55914422288649
				},
				{
					"lng": 11.439976915108518,
					"lat": 43.559144227805184
				},
				{
					"lng": 11.439976913170598,
					"lat": 43.55914427779652
				},
				{
					"lng": 11.439976912904237,
					"lat": 43.55914428466781
				},
				{
					"lng": 11.439976910697597,
					"lat": 43.55914434159087
				},
				{
					"lng": 11.439976910415936,
					"lat": 43.55914434885662
				},
				{
					"lng": 11.43997690788424,
					"lat": 43.559144414164976
				},
				{
					"lng": 11.4399769078483,
					"lat": 43.55914441509284
				},
				{
					"lng": 11.439976907503805,
					"lat": 43.55914442397909
				},
				{
					"lng": 11.439976904568057,
					"lat": 43.55914449971039
				},
				{
					"lng": 11.439976656341933,
					"lat": 43.55915090303154
				},
				{
					"lng": 11.43997665543693,
					"lat": 43.559150926377015
				},
				{
					"lng": 11.439976601833385,
					"lat": 43.55915230915154
				},
				{
					"lng": 11.439976550715768,
					"lat": 43.55915362779788
				},
				{
					"lng": 11.439976150093402,
					"lat": 43.55915508891522
				},
				{
					"lng": 11.439976137304614,
					"lat": 43.55915513555744
				},
				{
					"lng": 11.439976135925683,
					"lat": 43.55915514058658
				},
				{
					"lng": 11.439976045102544,
					"lat": 43.55915547182935
				},
				{
					"lng": 11.439976032867776,
					"lat": 43.559155516451
				},
				{
					"lng": 11.439976019167942,
					"lat": 43.559155566415946
				},
				{
					"lng": 11.43997601725686,
					"lat": 43.55915557338587
				},
				{
					"lng": 11.439975924188008,
					"lat": 43.559155912819094
				},
				{
					"lng": 11.439975908547249,
					"lat": 43.55915596986275
				},
				{
					"lng": 11.43997589392536,
					"lat": 43.559156023190475
				},
				{
					"lng": 11.439975891388428,
					"lat": 43.55915603244298
				},
				{
					"lng": 11.439975796349431,
					"lat": 43.559156379061434
				},
				{
					"lng": 11.439975776981683,
					"lat": 43.559156449698015
				},
				{
					"lng": 11.439975761405652,
					"lat": 43.559156506505666
				},
				{
					"lng": 11.439975758135,
					"lat": 43.559156518434015
				},
				{
					"lng": 11.439975661210271,
					"lat": 43.55915687193005
				},
				{
					"lng": 11.439975637744023,
					"lat": 43.55915695751421
				},
				{
					"lng": 11.439975621137101,
					"lat": 43.55915701808165
				},
				{
					"lng": 11.43997561699947,
					"lat": 43.55915703317209
				},
				{
					"lng": 11.439975518054805,
					"lat": 43.559157394034926
				},
				{
					"lng": 11.43997549002003,
					"lat": 43.55915749628115
				},
				{
					"lng": 11.439975472355863,
					"lat": 43.55915756070443
				},
				{
					"lng": 11.439975467209486,
					"lat": 43.559157579473975
				},
				{
					"lng": 11.439975366265129,
					"lat": 43.559157947629856
				},
				{
					"lng": 11.439975333177895,
					"lat": 43.55915806830301
				},
				{
					"lng": 11.439975314376502,
					"lat": 43.55915813687388
				},
				{
					"lng": 11.4399753080423,
					"lat": 43.55915815997545
				},
				{
					"lng": 11.439975204795674,
					"lat": 43.55915853652811
				},
				{
					"lng": 11.439975165984146,
					"lat": 43.559158678078354
				},
				{
					"lng": 11.439975145982,
					"lat": 43.5591587510286
				},
				{
					"lng": 11.439975138254614,
					"lat": 43.55915877921125
				},
				{
					"lng": 11.439975032227617,
					"lat": 43.55915916590427
				},
				{
					"lng": 11.439974986807826,
					"lat": 43.55915933155562
				},
				{
					"lng": 11.439973432153277,
					"lat": 43.55916500156415
				},
				{
					"lng": 11.439964960351352,
					"lat": 43.559195899207396
				},
				{
					"lng": 11.439959889741,
					"lat": 43.559209733433
				},
				{
					"lng": 11.43995258791469,
					"lat": 43.559225290460404
				},
				{
					"lng": 11.439952540613273,
					"lat": 43.55922539123912
				},
				{
					"lng": 11.439952534478559,
					"lat": 43.559225404309586
				},
				{
					"lng": 11.439952284937327,
					"lat": 43.559225935973636
				},
				{
					"lng": 11.439952254040705,
					"lat": 43.55922600180093
				},
				{
					"lng": 11.439952200651044,
					"lat": 43.55922611555113
				},
				{
					"lng": 11.43995219433752,
					"lat": 43.55922612900249
				},
				{
					"lng": 11.439951920416572,
					"lat": 43.559226712609195
				},
				{
					"lng": 11.439951889680387,
					"lat": 43.559226778094654
				},
				{
					"lng": 11.439951824887302,
					"lat": 43.55922691614059
				},
				{
					"lng": 11.43995181796909,
					"lat": 43.559226930880264
				},
				{
					"lng": 11.439951507997037,
					"lat": 43.55922759129617
				},
				{
					"lng": 11.439951476890679,
					"lat": 43.5592276575703
				},
				{
					"lng": 11.439951468379551,
					"lat": 43.55922767570382
				},
				{
					"lng": 11.439951467561285,
					"lat": 43.55922767744718
				},
				{
					"lng": 11.439951458637548,
					"lat": 43.55922769645981
				},
				{
					"lng": 11.439951457781943,
					"lat": 43.55922769828277
				},
				{
					"lng": 11.4399514105376,
					"lat": 43.559227798939894
				},
				{
					"lng": 11.43995140605048,
					"lat": 43.55922780850004
				},
				{
					"lng": 11.439950665371667,
					"lat": 43.559229386564986
				},
				{
					"lng": 11.439950604517263,
					"lat": 43.559229516219276
				},
				{
					"lng": 11.439950341959126,
					"lat": 43.55923007561665
				},
				{
					"lng": 11.439950323279517,
					"lat": 43.5592301154148
				},
				{
					"lng": 11.439950255982227,
					"lat": 43.55923025879613
				},
				{
					"lng": 11.439950251400631,
					"lat": 43.55923026855751
				},
				{
					"lng": 11.439949997416388,
					"lat": 43.55923080968764
				},
				{
					"lng": 11.439949981176447,
					"lat": 43.55923084428791
				},
				{
					"lng": 11.439949914412992,
					"lat": 43.55923098653179
				},
				{
					"lng": 11.439949910322353,
					"lat": 43.55923099524719
				},
				{
					"lng": 11.439949665704201,
					"lat": 43.55923151642222
				},
				{
					"lng": 11.439949651643984,
					"lat": 43.55923154637843
				},
				{
					"lng": 11.439949585482722,
					"lat": 43.55923168733931
				},
				{
					"lng": 11.4399495818344,
					"lat": 43.559231695112324
				},
				{
					"lng": 11.439949346912465,
					"lat": 43.55923219562891
				},
				{
					"lng": 11.439949334775278,
					"lat": 43.559232221487974
				},
				{
					"lng": 11.439949269276687,
					"lat": 43.559232361037076
				},
				{
					"lng": 11.43994926602716,
					"lat": 43.55923236796036
				},
				{
					"lng": 11.439949041047903,
					"lat": 43.55923284729342
				},
				{
					"lng": 11.439949030604273,
					"lat": 43.55923286954425
				},
				{
					"lng": 11.439948965854281,
					"lat": 43.55923300749832
				},
				{
					"lng": 11.439948962965946,
					"lat": 43.55923301365209
				},
				{
					"lng": 11.439948748119454,
					"lat": 43.559233471396674
				},
				{
					"lng": 11.439948739165038,
					"lat": 43.55923349047461
				},
				{
					"lng": 11.43994867525628,
					"lat": 43.559233626636434
				},
				{
					"lng": 11.439948672695468,
					"lat": 43.5592336320924
				},
				{
					"lng": 11.439948467941832,
					"lat": 43.55923406833342
				},
				{
					"lng": 11.439948460288264,
					"lat": 43.55923408463982
				},
				{
					"lng": 11.439948397295947,
					"lat": 43.559234218849085
				},
				{
					"lng": 11.439948395031676,
					"lat": 43.559234223673265
				},
				{
					"lng": 11.439948200507304,
					"lat": 43.55923463812017
				},
				{
					"lng": 11.439948193995457,
					"lat": 43.55923465199403
				},
				{
					"lng": 11.439948132110155,
					"lat": 43.559234783844744
				},
				{
					"lng": 11.439948130117903,
					"lat": 43.55923478808944
				},
				{
					"lng": 11.439947945987964,
					"lat": 43.55923518039025
				},
				{
					"lng": 11.43994794047712,
					"lat": 43.55923519213149
				},
				{
					"lng": 11.439947879903299,
					"lat": 43.55923532118797
				},
				{
					"lng": 11.439947878160096,
					"lat": 43.559235324902
				},
				{
					"lng": 11.439947704971887,
					"lat": 43.559235693890784
				},
				{
					"lng": 11.439947700345721,
					"lat": 43.55923570374717
				},
				{
					"lng": 11.439947641421817,
					"lat": 43.55923582928833
				},
				{
					"lng": 11.439947639908668,
					"lat": 43.559235832512194
				},
				{
					"lng": 11.439947479386134,
					"lat": 43.559236174515966
				},
				{
					"lng": 11.439947475563198,
					"lat": 43.55923618266095
				},
				{
					"lng": 11.439947418019592,
					"lat": 43.55923630526142
				},
				{
					"lng": 11.439947416702617,
					"lat": 43.55923630806724
				},
				{
					"lng": 11.439947271330931,
					"lat": 43.55923661779113
				},
				{
					"lng": 11.439947268243744,
					"lat": 43.559236624368594
				},
				{
					"lng": 11.439947209008361,
					"lat": 43.55923675057346
				},
				{
					"lng": 11.439947207801959,
					"lat": 43.559236753143765
				},
				{
					"lng": 11.439947059712201,
					"lat": 43.559237068658604
				},
				{
					"lng": 11.439947056938749,
					"lat": 43.55923707456774
				},
				{
					"lng": 11.439946995338452,
					"lat": 43.55923720581114
				},
				{
					"lng": 11.439946994237317,
					"lat": 43.55923720815714
				},
				{
					"lng": 11.439946807451458,
					"lat": 43.55923760611663
				},
				{
					"lng": 11.439946804484839,
					"lat": 43.55923761243721
				},
				{
					"lng": 11.439946744778078,
					"lat": 43.55923773964637
				},
				{
					"lng": 11.439946743879352,
					"lat": 43.55923774156112
				},
				{
					"lng": 11.439946574753106,
					"lat": 43.55923810189562
				},
				{
					"lng": 11.439946572504697,
					"lat": 43.55923810668602
				},
				{
					"lng": 11.439946513477826,
					"lat": 43.55923823244663
				},
				{
					"lng": 11.439946512737535,
					"lat": 43.55923823402391
				},
				{
					"lng": 11.439946355049702,
					"lat": 43.55923856998802
				},
				{
					"lng": 11.439946353324238,
					"lat": 43.55923857366421
				},
				{
					"lng": 11.43994629560009,
					"lat": 43.55923869664928
				},
				{
					"lng": 11.439946295008088,
					"lat": 43.55923869791056
				},
				{
					"lng": 11.43994614619638,
					"lat": 43.55923901496361
				},
				{
					"lng": 11.439946144889655,
					"lat": 43.5592390177477
				},
				{
					"lng": 11.439946088570236,
					"lat": 43.55923913773984
				},
				{
					"lng": 11.439946088111242,
					"lat": 43.559239138717764
				},
				{
					"lng": 11.439945947355199,
					"lat": 43.55923943860771
				},
				{
					"lng": 11.439945946399925,
					"lat": 43.559239440642955
				},
				{
					"lng": 11.439945890968545,
					"lat": 43.55923955874318
				},
				{
					"lng": 11.439945757441205,
					"lat": 43.5592398432318
				},
				{
					"lng": 11.43994575678204,
					"lat": 43.55923984463619
				},
				{
					"lng": 11.439945702645852,
					"lat": 43.55923995997686
				},
				{
					"lng": 11.43994557540779,
					"lat": 43.55924023106586
				},
				{
					"lng": 11.439945522508625,
					"lat": 43.55924034377093
				},
				{
					"lng": 11.439945401799884,
					"lat": 43.55924060094874
				},
				{
					"lng": 11.439945350106264,
					"lat": 43.55924071108543
				},
				{
					"lng": 11.439945235448468,
					"lat": 43.55924095537122
				},
				{
					"lng": 11.43994522325885,
					"lat": 43.559240981342036
				},
				{
					"lng": 11.43994518649823,
					"lat": 43.559241065325736
				},
				{
					"lng": 11.439945082437307,
					"lat": 43.55924130306439
				},
				{
					"lng": 11.439945035456939,
					"lat": 43.55924141039623
				},
				{
					"lng": 11.4399449838353,
					"lat": 43.55924152833155
				},
				{
					"lng": 11.439941192254954,
					"lat": 43.55925019061374
				},
				{
					"lng": 11.439937668416718,
					"lat": 43.55925824120743
				},
				{
					"lng": 11.439939357718734,
					"lat": 43.55926478224738
				},
				{
					"lng": 11.43994441454805,
					"lat": 43.55928436246832
				},
				{
					"lng": 11.439975560842896,
					"lat": 43.55929403149754
				},
				{
					"lng": 11.439997252381126,
					"lat": 43.55930303673641
				},
				{
					"lng": 11.439997552121593,
					"lat": 43.55930317157715
				},
				{
					"lng": 11.43999851101675,
					"lat": 43.559303591129996
				},
				{
					"lng": 11.439999197020269,
					"lat": 43.55930388481802
				},
				{
					"lng": 11.439999511416014,
					"lat": 43.55930402350482
				},
				{
					"lng": 11.4400002340653,
					"lat": 43.55930432813702
				},
				{
					"lng": 11.440000556391832,
					"lat": 43.55930446858062
				},
				{
					"lng": 11.440001318308447,
					"lat": 43.55930478420305
				},
				{
					"lng": 11.44000164882544,
					"lat": 43.5593049263547
				},
				{
					"lng": 11.440002452531573,
					"lat": 43.559305253111255
				},
				{
					"lng": 11.44000279157755,
					"lat": 43.55930539684854
				},
				{
					"lng": 11.440003640123644,
					"lat": 43.559305734533176
				},
				{
					"lng": 11.440003988015754,
					"lat": 43.559305879714366
				},
				{
					"lng": 11.44000488537904,
					"lat": 43.559306227364495
				},
				{
					"lng": 11.440013419710827,
					"lat": 43.55930977904294
				},
				{
					"lng": 11.440013821659077,
					"lat": 43.55930995308445
				},
				{
					"lng": 11.440015043833975,
					"lat": 43.55931051505332
				},
				{
					"lng": 11.440015458685142,
					"lat": 43.55931069078525
				},
				{
					"lng": 11.440016761582678,
					"lat": 43.55931127574713
				},
				{
					"lng": 11.440017188841201,
					"lat": 43.559311454050196
				},
				{
					"lng": 11.440018575375142,
					"lat": 43.559312066408246
				},
				{
					"lng": 11.440019014969586,
					"lat": 43.55931224787246
				},
				{
					"lng": 11.440020489665384,
					"lat": 43.55931289144473
				},
				{
					"lng": 11.440020941647342,
					"lat": 43.55931307673405
				},
				{
					"lng": 11.440022509870197,
					"lat": 43.55931375597688
				},
				{
					"lng": 11.440022974636399,
					"lat": 43.559313945409755
				},
				{
					"lng": 11.440024643024714,
					"lat": 43.55931466488698
				},
				{
					"lng": 11.440025121017047,
					"lat": 43.55931485891704
				},
				{
					"lng": 11.44002689687782,
					"lat": 43.55931562526844
				},
				{
					"lng": 11.440027388666175,
					"lat": 43.55931582442933
				},
				{
					"lng": 11.440029280760523,
					"lat": 43.55931664621546
				},
				{
					"lng": 11.440029787102764,
					"lat": 43.55931685105081
				},
				{
					"lng": 11.440031806173826,
					"lat": 43.55931773962513
				},
				{
					"lng": 11.440032328007128,
					"lat": 43.55931795090398
				},
				{
					"lng": 11.440034487365676,
					"lat": 43.55931892407491
				},
				{
					"lng": 11.440039315398748,
					"lat": 43.55931973392068
				},
				{
					"lng": 11.440039431076897,
					"lat": 43.559319880607646
				},
				{
					"lng": 11.440039674574114,
					"lat": 43.55932058041269
				},
				{
					"lng": 11.44003968381178,
					"lat": 43.55932060696144
				},
				{
					"lng": 11.440039805225691,
					"lat": 43.559320759661645
				},
				{
					"lng": 11.440040736174327,
					"lat": 43.55932130001508
				},
				{
					"lng": 11.440040877538275,
					"lat": 43.559321421451834
				},
				{
					"lng": 11.440040949201297,
					"lat": 43.55932145064583
				},
				{
					"lng": 11.440043230336691,
					"lat": 43.5593220346497
				},
				{
					"lng": 11.440043713582975,
					"lat": 43.55932215770603
				},
				{
					"lng": 11.440045893817313,
					"lat": 43.559322835317275
				},
				{
					"lng": 11.440046332861401,
					"lat": 43.55932298053119
				},
				{
					"lng": 11.440048427938414,
					"lat": 43.55932369096605
				},
				{
					"lng": 11.440048834228929,
					"lat": 43.5593238328824
				},
				{
					"lng": 11.440050861146362,
					"lat": 43.55932453812572
				},
				{
					"lng": 11.440051239461516,
					"lat": 43.55932467073331
				},
				{
					"lng": 11.44005320705874,
					"lat": 43.55932535871683
				},
				{
					"lng": 11.44005355989379,
					"lat": 43.559325481251115
				},
				{
					"lng": 11.440055473318967,
					"lat": 43.559326148955996
				},
				{
					"lng": 11.44005580224819,
					"lat": 43.559326262112194
				},
				{
					"lng": 11.4400576656066,
					"lat": 43.55932690872655
				},
				{
					"lng": 11.44005797223161,
					"lat": 43.55932701296195
				},
				{
					"lng": 11.44005978726445,
					"lat": 43.55932764074189
				},
				{
					"lng": 11.44008327446231,
					"lat": 43.55933679186936
				},
				{
					"lng": 11.440121627815703,
					"lat": 43.559357046104004
				},
				{
					"lng": 11.440122153041441,
					"lat": 43.55935727605398
				},
				{
					"lng": 11.440123532154637,
					"lat": 43.559357891928435
				},
				{
					"lng": 11.440123566005088,
					"lat": 43.55935790593691
				},
				{
					"lng": 11.440123876456294,
					"lat": 43.559358042748116
				},
				{
					"lng": 11.440123903769596,
					"lat": 43.55935805326294
				},
				{
					"lng": 11.440127696661776,
					"lat": 43.55935948397765
				},
				{
					"lng": 11.440127701056264,
					"lat": 43.559359485524375
				},
				{
					"lng": 11.440129417480193,
					"lat": 43.55935967924848
				},
				{
					"lng": 11.440203874964586,
					"lat": 43.559369991181335
				},
				{
					"lng": 11.440230533919651,
					"lat": 43.55938529432941
				},
				{
					"lng": 11.440231699940552,
					"lat": 43.55938566719116
				},
				{
					"lng": 11.440254391004416,
					"lat": 43.559392923172894
				},
				{
					"lng": 11.440285714764462,
					"lat": 43.559404513184276
				},
				{
					"lng": 11.440308126521048,
					"lat": 43.55941280568369
				},
				{
					"lng": 11.44031599082352,
					"lat": 43.55941612624511
				},
				{
					"lng": 11.440321145698219,
					"lat": 43.55941794849067
				},
				{
					"lng": 11.440360464733011,
					"lat": 43.55944439442386
				},
				{
					"lng": 11.440367133210406,
					"lat": 43.5594483388844
				},
				{
					"lng": 11.440381518523438,
					"lat": 43.55945066789762
				},
				{
					"lng": 11.440397748372275,
					"lat": 43.55945727774
				},
				{
					"lng": 11.440416461024908,
					"lat": 43.55946121912464
				},
				{
					"lng": 11.440423903352215,
					"lat": 43.55946278667664
				},
				{
					"lng": 11.440444251821729,
					"lat": 43.559461647756066
				},
				{
					"lng": 11.440444590825937,
					"lat": 43.559461628781634
				},
				{
					"lng": 11.44045584874153,
					"lat": 43.55946099866528
				},
				{
					"lng": 11.4404511762659,
					"lat": 43.55948324377716
				},
				{
					"lng": 11.44044974257865,
					"lat": 43.55949006918823
				},
				{
					"lng": 11.440449632657065,
					"lat": 43.55949059249617
				},
				{
					"lng": 11.44045298746881,
					"lat": 43.559497807469974
				},
				{
					"lng": 11.440455512059712,
					"lat": 43.55950323693696
				},
				{
					"lng": 11.440455764254738,
					"lat": 43.55950377931568
				},
				{
					"lng": 11.440455989405647,
					"lat": 43.55950448127432
				},
				{
					"lng": 11.440456012821498,
					"lat": 43.55950502372978
				},
				{
					"lng": 11.440456046993303,
					"lat": 43.55950581535794
				},
				{
					"lng": 11.440456136984228,
					"lat": 43.55950790009697
				},
				{
					"lng": 11.440456147171961,
					"lat": 43.559508136106736
				},
				{
					"lng": 11.44045618259594,
					"lat": 43.55950895674156
				},
				{
					"lng": 11.44045621887135,
					"lat": 43.55950979709766
				},
				{
					"lng": 11.440456654470662,
					"lat": 43.55951988818828
				},
				{
					"lng": 11.44045672342775,
					"lat": 43.55952148563215
				},
				{
					"lng": 11.440457313745153,
					"lat": 43.559535160783135
				},
				{
					"lng": 11.440457284493297,
					"lat": 43.55953573985238
				},
				{
					"lng": 11.440456849320636,
					"lat": 43.5595367025551
				},
				{
					"lng": 11.440456819310413,
					"lat": 43.55953676894465
				},
				{
					"lng": 11.440456803957002,
					"lat": 43.559536802909925
				},
				{
					"lng": 11.440455047336643,
					"lat": 43.55954068896064
				},
				{
					"lng": 11.440450613020856,
					"lat": 43.55954913320188
				},
				{
					"lng": 11.440450395684366,
					"lat": 43.55954954707445
				},
				{
					"lng": 11.440449687665547,
					"lat": 43.55955018037601
				},
				{
					"lng": 11.440445159716658,
					"lat": 43.55955583983369
				},
				{
					"lng": 11.440444734860707,
					"lat": 43.55955627820805
				},
				{
					"lng": 11.440444698402176,
					"lat": 43.559556315826946
				},
				{
					"lng": 11.440441757277373,
					"lat": 43.55955935055876
				},
				{
					"lng": 11.440441270339164,
					"lat": 43.559559852994745
				},
				{
					"lng": 11.440418383952572,
					"lat": 43.55958346777223
				},
				{
					"lng": 11.44041681595734,
					"lat": 43.55958803288503
				},
				{
					"lng": 11.440416781583384,
					"lat": 43.559588132961544
				},
				{
					"lng": 11.440416618850993,
					"lat": 43.55958860674162
				},
				{
					"lng": 11.44041660327231,
					"lat": 43.559588652097474
				},
				{
					"lng": 11.44041655236196,
					"lat": 43.55958880031823
				},
				{
					"lng": 11.440416320610964,
					"lat": 43.55958947503967
				},
				{
					"lng": 11.440413676310625,
					"lat": 43.559591844527
				},
				{
					"lng": 11.440413080484644,
					"lat": 43.5595976078093
				},
				{
					"lng": 11.440413048235193,
					"lat": 43.5595979197508
				},
				{
					"lng": 11.440413020997202,
					"lat": 43.55959818321767
				},
				{
					"lng": 11.440412913719754,
					"lat": 43.55959922088789
				},
				{
					"lng": 11.440412859487623,
					"lat": 43.55959974546325
				},
				{
					"lng": 11.440412548329483,
					"lat": 43.559602755227935
				},
				{
					"lng": 11.440414037299224,
					"lat": 43.55961449214975
				},
				{
					"lng": 11.440414276076432,
					"lat": 43.559616374327916
				},
				{
					"lng": 11.440414673362946,
					"lat": 43.55961663156336
				},
				{
					"lng": 11.440418091258904,
					"lat": 43.559618844585444
				},
				{
					"lng": 11.440421386193162,
					"lat": 43.559620977991734
				},
				{
					"lng": 11.440424781102596,
					"lat": 43.55962317612969
				},
				{
					"lng": 11.44042560087321,
					"lat": 43.55962370691521
				},
				{
					"lng": 11.440427513181312,
					"lat": 43.55962494509748
				},
				{
					"lng": 11.440428160672523,
					"lat": 43.55962589007149
				},
				{
					"lng": 11.440428297491241,
					"lat": 43.559626098617734
				},
				{
					"lng": 11.440428721045713,
					"lat": 43.55962674422157
				},
				{
					"lng": 11.440431158913546,
					"lat": 43.559630460146465
				},
				{
					"lng": 11.440434664156077,
					"lat": 43.559632099760826
				},
				{
					"lng": 11.440438939046105,
					"lat": 43.55963416166099
				},
				{
					"lng": 11.440444833489767,
					"lat": 43.55964146641231
				},
				{
					"lng": 11.440446466335375,
					"lat": 43.55964328981552
				},
				{
					"lng": 11.440455398483078,
					"lat": 43.559653264367064
				},
				{
					"lng": 11.440455713294108,
					"lat": 43.559653314276986
				},
				{
					"lng": 11.440457990421637,
					"lat": 43.55965367529113
				},
				{
					"lng": 11.440465235245624,
					"lat": 43.559657316249165
				},
				{
					"lng": 11.440470814248368,
					"lat": 43.559660858173324
				},
				{
					"lng": 11.440471099077108,
					"lat": 43.559661038695644
				},
				{
					"lng": 11.440471563153237,
					"lat": 43.55966133282366
				},
				{
					"lng": 11.440473366707412,
					"lat": 43.55966247590245
				},
				{
					"lng": 11.440475964092702,
					"lat": 43.55966412210519
				},
				{
					"lng": 11.440476173635437,
					"lat": 43.55966425487309
				},
				{
					"lng": 11.440476274901727,
					"lat": 43.559664319036216
				},
				{
					"lng": 11.440477316001123,
					"lat": 43.55966497868484
				},
				{
					"lng": 11.44047790231296,
					"lat": 43.55966535017657
				},
				{
					"lng": 11.440482102465566,
					"lat": 43.559668006930686
				},
				{
					"lng": 11.440484684225483,
					"lat": 43.55966934465997
				},
				{
					"lng": 11.44049563625974,
					"lat": 43.559675019411756
				},
				{
					"lng": 11.440501344135193,
					"lat": 43.559680557697504
				},
				{
					"lng": 11.440508585825587,
					"lat": 43.559687584224356
				},
				{
					"lng": 11.440513754950212,
					"lat": 43.55969259976369
				},
				{
					"lng": 11.440516102989596,
					"lat": 43.55969485627116
				},
				{
					"lng": 11.440516361353293,
					"lat": 43.55969553008888
				},
				{
					"lng": 11.44051639091187,
					"lat": 43.559695607178256
				},
				{
					"lng": 11.44051766133576,
					"lat": 43.559697752332674
				},
				{
					"lng": 11.440518593889323,
					"lat": 43.55969932698128
				},
				{
					"lng": 11.440519411424747,
					"lat": 43.559700707417775
				},
				{
					"lng": 11.440520688663812,
					"lat": 43.55970286407937
				},
				{
					"lng": 11.440529729459419,
					"lat": 43.5597181297655
				},
				{
					"lng": 11.440530907480797,
					"lat": 43.5597201188925
				},
				{
					"lng": 11.440531621949408,
					"lat": 43.55972132529572
				},
				{
					"lng": 11.440532041332983,
					"lat": 43.55972203343835
				},
				{
					"lng": 11.440533608124019,
					"lat": 43.55972346383702
				},
				{
					"lng": 11.440533952234222,
					"lat": 43.55972377799166
				},
				{
					"lng": 11.440536199853318,
					"lat": 43.55972582995069
				},
				{
					"lng": 11.440540272140003,
					"lat": 43.55972954773562
				},
				{
					"lng": 11.440544677246683,
					"lat": 43.559733569366664
				},
				{
					"lng": 11.44054518694475,
					"lat": 43.55973403469418
				},
				{
					"lng": 11.440551630224897,
					"lat": 43.559737254246876
				},
				{
					"lng": 11.44055262853437,
					"lat": 43.559737753078146
				},
				{
					"lng": 11.440553254302406,
					"lat": 43.559738065759376
				},
				{
					"lng": 11.440553594203864,
					"lat": 43.55973823559996
				},
				{
					"lng": 11.440553955874607,
					"lat": 43.55973841631813
				},
				{
					"lng": 11.440554891263929,
					"lat": 43.55973888370965
				},
				{
					"lng": 11.440554947746339,
					"lat": 43.55973891193258
				},
				{
					"lng": 11.44055543901763,
					"lat": 43.559739157409
				},
				{
					"lng": 11.440563289652731,
					"lat": 43.55974308018179
				},
				{
					"lng": 11.440563314837018,
					"lat": 43.559743092732646
				},
				{
					"lng": 11.44056366313575,
					"lat": 43.559743266311315
				},
				{
					"lng": 11.44056368949347,
					"lat": 43.559743279447005
				},
				{
					"lng": 11.440564074222728,
					"lat": 43.559743471181086
				},
				{
					"lng": 11.440564116316823,
					"lat": 43.55974349215426
				},
				{
					"lng": 11.440565173805057,
					"lat": 43.55974401904241
				},
				{
					"lng": 11.440565495337445,
					"lat": 43.55974507390547
				},
				{
					"lng": 11.440565508014442,
					"lat": 43.55974511549535
				},
				{
					"lng": 11.440565515924376,
					"lat": 43.55974514144578
				},
				{
					"lng": 11.440565587858009,
					"lat": 43.55974537728605
				},
				{
					"lng": 11.440565634173778,
					"lat": 43.55974552913605
				},
				{
					"lng": 11.440565642245929,
					"lat": 43.55974555560125
				},
				{
					"lng": 11.44056573328107,
					"lat": 43.55974585406689
				},
				{
					"lng": 11.44056574856556,
					"lat": 43.55974590417829
				},
				{
					"lng": 11.440565756228157,
					"lat": 43.55974592930073
				},
				{
					"lng": 11.440565760808456,
					"lat": 43.55974594431752
				},
				{
					"lng": 11.440565915791828,
					"lat": 43.559746448708765
				},
				{
					"lng": 11.440573527521726,
					"lat": 43.55975623608213
				},
				{
					"lng": 11.440574965116435,
					"lat": 43.55975808458083
				},
				{
					"lng": 11.440579406841682,
					"lat": 43.5597633060308
				},
				{
					"lng": 11.44057982906294,
					"lat": 43.55976380237112
				},
				{
					"lng": 11.440581146718111,
					"lat": 43.559768109967614
				},
				{
					"lng": 11.440581243059144,
					"lat": 43.55976842491971
				},
				{
					"lng": 11.440581266471993,
					"lat": 43.559768501459544
				},
				{
					"lng": 11.44058128017883,
					"lat": 43.55976854626914
				},
				{
					"lng": 11.440581505352023,
					"lat": 43.55976928239126
				},
				{
					"lng": 11.440581591504683,
					"lat": 43.55976956403616
				},
				{
					"lng": 11.440581672014638,
					"lat": 43.55976982723427
				},
				{
					"lng": 11.440581819089758,
					"lat": 43.55977030804307
				},
				{
					"lng": 11.440582050697145,
					"lat": 43.55977106519942
				},
				{
					"lng": 11.440583210135525,
					"lat": 43.559774855562566
				},
				{
					"lng": 11.440591293489872,
					"lat": 43.559783116343404
				},
				{
					"lng": 11.440592502665577,
					"lat": 43.55978435205982
				},
				{
					"lng": 11.440592616424267,
					"lat": 43.55978456742955
				},
				{
					"lng": 11.440593256980085,
					"lat": 43.55978578013955
				},
				{
					"lng": 11.44059331778303,
					"lat": 43.559785895252695
				},
				{
					"lng": 11.440593945690527,
					"lat": 43.55978708401664
				},
				{
					"lng": 11.440594024055153,
					"lat": 43.559787232377765
				},
				{
					"lng": 11.440594678042228,
					"lat": 43.559788470515954
				},
				{
					"lng": 11.440595247758237,
					"lat": 43.55978954911038
				},
				{
					"lng": 11.440595548888655,
					"lat": 43.55979011921465
				},
				{
					"lng": 11.440595594193029,
					"lat": 43.55979020498557
				},
				{
					"lng": 11.440595797864088,
					"lat": 43.55979059057849
				},
				{
					"lng": 11.440596725370835,
					"lat": 43.55979234654715
				},
				{
					"lng": 11.440598304036197,
					"lat": 43.55979533529828
				},
				{
					"lng": 11.440601316435595,
					"lat": 43.55980103841339
				},
				{
					"lng": 11.440611703341101,
					"lat": 43.559815255374204
				},
				{
					"lng": 11.440627573493405,
					"lat": 43.55983697745244
				},
				{
					"lng": 11.44063134082439,
					"lat": 43.55984213393824
				},
				{
					"lng": 11.440697075118758,
					"lat": 43.55992416561875
				},
				{
					"lng": 11.440697844593162,
					"lat": 43.559923817770354
				},
				{
					"lng": 11.440693725961761,
					"lat": 43.55993087248303
				},
				{
					"lng": 11.44069362519659,
					"lat": 43.55993104508153
				},
				{
					"lng": 11.440693543137133,
					"lat": 43.55993122725897
				},
				{
					"lng": 11.440693410868464,
					"lat": 43.55993152090423
				},
				{
					"lng": 11.440692772630472,
					"lat": 43.55993524813466
				},
				{
					"lng": 11.44069060196118,
					"lat": 43.559956561950216
				},
				{
					"lng": 11.440690254343172,
					"lat": 43.55995970188573
				},
				{
					"lng": 11.440690119450238,
					"lat": 43.5599697134721
				},
				{
					"lng": 11.440690118523378,
					"lat": 43.559969782263195
				},
				{
					"lng": 11.440690139295157,
					"lat": 43.55996981908754
				},
				{
					"lng": 11.440693502189683,
					"lat": 43.559975780850166
				},
				{
					"lng": 11.44069433009847,
					"lat": 43.55997760180656
				},
				{
					"lng": 11.440706162556928,
					"lat": 43.55999083166805
				},
				{
					"lng": 11.440709238772557,
					"lat": 43.55999427118085
				},
				{
					"lng": 11.44071160980272,
					"lat": 43.55999692222638
				},
				{
					"lng": 11.44071311733258,
					"lat": 43.56000526927632
				},
				{
					"lng": 11.440715190229433,
					"lat": 43.560016746705216
				},
				{
					"lng": 11.440715501184828,
					"lat": 43.56001846843472
				},
				{
					"lng": 11.440715855686445,
					"lat": 43.56002065240192
				},
				{
					"lng": 11.440716360224709,
					"lat": 43.56002376069519
				},
				{
					"lng": 11.440713598308303,
					"lat": 43.56003174479724
				},
				{
					"lng": 11.44071075442647,
					"lat": 43.5600399658415
				},
				{
					"lng": 11.440709483724316,
					"lat": 43.560043639164654
				},
				{
					"lng": 11.440709383906896,
					"lat": 43.56004392771501
				},
				{
					"lng": 11.440708902722232,
					"lat": 43.56004531871484
				},
				{
					"lng": 11.440706926328065,
					"lat": 43.56005103203855
				},
				{
					"lng": 11.440706230064873,
					"lat": 43.560054970355296
				},
				{
					"lng": 11.44070451355279,
					"lat": 43.56005730427463
				},
				{
					"lng": 11.440704443409132,
					"lat": 43.56005739964799
				},
				{
					"lng": 11.44070441517454,
					"lat": 43.560057438038235
				},
				{
					"lng": 11.440703039313052,
					"lat": 43.56005930877916
				},
				{
					"lng": 11.440702798727811,
					"lat": 43.56005963589974
				},
				{
					"lng": 11.440701425581898,
					"lat": 43.560061502948194
				},
				{
					"lng": 11.440699519590604,
					"lat": 43.56006327483578
				},
				{
					"lng": 11.440698839085773,
					"lat": 43.56006390746091
				},
				{
					"lng": 11.440697631685497,
					"lat": 43.56006502990965
				},
				{
					"lng": 11.440749566323175,
					"lat": 43.560135509802755
				},
				{
					"lng": 11.440754460531226,
					"lat": 43.56013759731132
				},
				{
					"lng": 11.44076842226719,
					"lat": 43.560147705759064
				},
				{
					"lng": 11.44077324353387,
					"lat": 43.56015454936485
				},
				{
					"lng": 11.440783183954471,
					"lat": 43.5601626253967
				},
				{
					"lng": 11.440783989119549,
					"lat": 43.56016340184838
				},
				{
					"lng": 11.44080639204309,
					"lat": 43.560170839780525
				},
				{
					"lng": 11.440809488075367,
					"lat": 43.5601715823138
				},
				{
					"lng": 11.440844649015613,
					"lat": 43.56019172377864
				},
				{
					"lng": 11.440879053906897,
					"lat": 43.56021028020686
				},
				{
					"lng": 11.440883559884705,
					"lat": 43.560208167068595
				},
				{
					"lng": 11.440954954593943,
					"lat": 43.56017766687442
				},
				{
					"lng": 11.441024957922641,
					"lat": 43.56014553664569
				},
				{
					"lng": 11.441093517160363,
					"lat": 43.560111801534994
				},
				{
					"lng": 11.441160579597183,
					"lat": 43.56007648669483
				},
				{
					"lng": 11.441166340637663,
					"lat": 43.560073896696366
				},
				{
					"lng": 11.441168771163182,
					"lat": 43.56007178297424
				},
				{
					"lng": 11.441284733412605,
					"lat": 43.56008517810048
				},
				{
					"lng": 11.441328726742952,
					"lat": 43.55997529109039
				},
				{
					"lng": 11.44145735586221,
					"lat": 43.5599273392586
				},
				{
					"lng": 11.44185796060613,
					"lat": 43.55981601176315
				},
				{
					"lng": 11.44223046361289,
					"lat": 43.55970870907744
				},
				{
					"lng": 11.44248669678689,
					"lat": 43.559288738441104
				},
				{
					"lng": 11.442861562558923,
					"lat": 43.55842433274758
				},
				{
					"lng": 11.442875767201281,
					"lat": 43.55805414460864
				},
				{
					"lng": 11.442898224138606,
					"lat": 43.558012213332105
				},
				{
					"lng": 11.442920681045829,
					"lat": 43.55797028205161
				},
				{
					"lng": 11.442943137922981,
					"lat": 43.55792835076715
				},
				{
					"lng": 11.442965594770076,
					"lat": 43.557886419478734
				},
				{
					"lng": 11.442988051587124,
					"lat": 43.55784448818636
				},
				{
					"lng": 11.443010508374067,
					"lat": 43.55780255689001
				},
				{
					"lng": 11.443032965130946,
					"lat": 43.55776062558978
				},
				{
					"lng": 11.443055421857789,
					"lat": 43.55771869428554
				},
				{
					"lng": 11.443077878554536,
					"lat": 43.55767676297733
				},
				{
					"lng": 11.443100335221239,
					"lat": 43.557634831665155
				},
				{
					"lng": 11.443122791857839,
					"lat": 43.557592900349036
				},
				{
					"lng": 11.443145248464369,
					"lat": 43.55755096902896
				},
				{
					"lng": 11.443167705040844,
					"lat": 43.55750903770493
				},
				{
					"lng": 11.44321429314456,
					"lat": 43.55742204736696
				},
				{
					"lng": 11.44322576795841,
					"lat": 43.55740385025387
				},
				{
					"lng": 11.443244131519766,
					"lat": 43.55738263871235
				},
				{
					"lng": 11.443252623294887,
					"lat": 43.55737475574723
				},
				{
					"lng": 11.443287069863121,
					"lat": 43.557350253374544
				},
				{
					"lng": 11.44333163536135,
					"lat": 43.55732448748787
				},
				{
					"lng": 11.443380070632152,
					"lat": 43.55729648421842
				},
				{
					"lng": 11.443428505857709,
					"lat": 43.55726848092932
				},
				{
					"lng": 11.443476941038025,
					"lat": 43.55724047762061
				},
				{
					"lng": 11.4435253761731,
					"lat": 43.557212474292335
				},
				{
					"lng": 11.443573811262933,
					"lat": 43.55718447094449
				},
				{
					"lng": 11.443622246307523,
					"lat": 43.557156467577
				},
				{
					"lng": 11.443670681306873,
					"lat": 43.55712846418991
				},
				{
					"lng": 11.443719116260977,
					"lat": 43.55710046078321
				},
				{
					"lng": 11.443767551169842,
					"lat": 43.55707245735692
				},
				{
					"lng": 11.443815986033465,
					"lat": 43.557044453911075
				},
				{
					"lng": 11.443864420851845,
					"lat": 43.55701645044558
				},
				{
					"lng": 11.443912855624973,
					"lat": 43.556988446960496
				},
				{
					"lng": 11.44396129035287,
					"lat": 43.55696044345582
				},
				{
					"lng": 11.444009725035526,
					"lat": 43.556932439931565
				},
				{
					"lng": 11.444047571624738,
					"lat": 43.556910558103
				},
				{
					"lng": 11.444058102558655,
					"lat": 43.556904384620374
				},
				{
					"lng": 11.444076399052053,
					"lat": 43.55689324305894
				},
				{
					"lng": 11.44410477460285,
					"lat": 43.556874851313104
				},
				{
					"lng": 11.444148673563593,
					"lat": 43.55684341668727
				},
				{
					"lng": 11.44414885255709,
					"lat": 43.55684328035228
				},
				{
					"lng": 11.444190168520416,
					"lat": 43.5568097920007
				},
				{
					"lng": 11.444202149275029,
					"lat": 43.55679925754787
				},
				{
					"lng": 11.444213792908684,
					"lat": 43.556788620583376
				},
				{
					"lng": 11.44422856511388,
					"lat": 43.556774513824735
				},
				{
					"lng": 11.444263896079965,
					"lat": 43.556737580208285
				},
				{
					"lng": 11.44427111433659,
					"lat": 43.556729395621716
				},
				{
					"lng": 11.444320072072324,
					"lat": 43.55666632639087
				},
				{
					"lng": 11.444324886669317,
					"lat": 43.55665933382976
				},
				{
					"lng": 11.444352590965327,
					"lat": 43.55661909699443
				},
				{
					"lng": 11.444380295225349,
					"lat": 43.55657886015295
				},
				{
					"lng": 11.444404241888092,
					"lat": 43.556544080686706
				},
				{
					"lng": 11.444404960574467,
					"lat": 43.55653751664661
				},
				{
					"lng": 11.444404999877886,
					"lat": 43.556537157673205
				},
				{
					"lng": 11.444406004409014,
					"lat": 43.556527982900654
				},
				{
					"lng": 11.44440602146553,
					"lat": 43.55652782711674
				},
				{
					"lng": 11.444406032192026,
					"lat": 43.55652772914763
				},
				{
					"lng": 11.444406079989195,
					"lat": 43.55652729259742
				},
				{
					"lng": 11.444407097039747,
					"lat": 43.556518003477805
				},
				{
					"lng": 11.444400497555637,
					"lat": 43.556494339072884
				},
				{
					"lng": 11.44439909348295,
					"lat": 43.55648930435168
				},
				{
					"lng": 11.444398654591973,
					"lat": 43.556487617367694
				},
				{
					"lng": 11.44439787203309,
					"lat": 43.55648460941245
				},
				{
					"lng": 11.444397712436816,
					"lat": 43.556483995965316
				},
				{
					"lng": 11.44439596161953,
					"lat": 43.55647726627215
				},
				{
					"lng": 11.444395607248007,
					"lat": 43.55647049980681
				},
				{
					"lng": 11.444400766637157,
					"lat": 43.55644907688756
				},
				{
					"lng": 11.444400978729616,
					"lat": 43.55644335493439
				},
				{
					"lng": 11.444401479978445,
					"lat": 43.55644237551543
				},
				{
					"lng": 11.444401926820357,
					"lat": 43.55644150240531
				},
				{
					"lng": 11.444404403902931,
					"lat": 43.556436662290416
				},
				{
					"lng": 11.444406542058449,
					"lat": 43.55643248442414
				},
				{
					"lng": 11.444406574390426,
					"lat": 43.55643242124879
				},
				{
					"lng": 11.44440684239816,
					"lat": 43.55643051093306
				},
				{
					"lng": 11.444408836382044,
					"lat": 43.556416298136014
				},
				{
					"lng": 11.444409369914291,
					"lat": 43.556412495202665
				},
				{
					"lng": 11.44440987431927,
					"lat": 43.55641097610626
				},
				{
					"lng": 11.444409644603347,
					"lat": 43.55640908745976
				},
				{
					"lng": 11.444411148152202,
					"lat": 43.556406120792474
				},
				{
					"lng": 11.444414960147704,
					"lat": 43.55640163474362
				},
				{
					"lng": 11.444415759277376,
					"lat": 43.55639791741378
				},
				{
					"lng": 11.444417243694465,
					"lat": 43.55639101231527
				},
				{
					"lng": 11.444418260570371,
					"lat": 43.55638628208854
				},
				{
					"lng": 11.444420104893785,
					"lat": 43.556383217676355
				},
				{
					"lng": 11.444420447032925,
					"lat": 43.556382649199364
				},
				{
					"lng": 11.444431742396372,
					"lat": 43.55636388152388
				},
				{
					"lng": 11.444434323804941,
					"lat": 43.5563595924137
				},
				{
					"lng": 11.444439152157297,
					"lat": 43.55634867620464
				},
				{
					"lng": 11.444439155551585,
					"lat": 43.55634866853068
				},
				{
					"lng": 11.444439156313601,
					"lat": 43.55634866638078
				},
				{
					"lng": 11.444439157041401,
					"lat": 43.55634866432736
				},
				{
					"lng": 11.444441720999551,
					"lat": 43.55634143055331
				},
				{
					"lng": 11.444441858388444,
					"lat": 43.556321414060385
				},
				{
					"lng": 11.444441116626884,
					"lat": 43.55631059092108
				},
				{
					"lng": 11.44444103634537,
					"lat": 43.55630941952257
				},
				{
					"lng": 11.444441415358355,
					"lat": 43.55630722398687
				},
				{
					"lng": 11.444440199377791,
					"lat": 43.55629872042224
				},
				{
					"lng": 11.444439585377804,
					"lat": 43.55629442661211
				},
				{
					"lng": 11.444438165223712,
					"lat": 43.55628449522137
				},
				{
					"lng": 11.444437765355367,
					"lat": 43.556281698870166
				},
				{
					"lng": 11.444445690225962,
					"lat": 43.55626980058002
				},
				{
					"lng": 11.44443633926839,
					"lat": 43.55626040537844
				},
				{
					"lng": 11.444442303104273,
					"lat": 43.55624916072337
				},
				{
					"lng": 11.444444534190852,
					"lat": 43.556244954067466
				},
				{
					"lng": 11.444446750502431,
					"lat": 43.556240775268776
				},
				{
					"lng": 11.444448826143383,
					"lat": 43.55623593081505
				},
				{
					"lng": 11.44444972327705,
					"lat": 43.55623383694473
				},
				{
					"lng": 11.444449699709654,
					"lat": 43.55622675329422
				},
				{
					"lng": 11.444449659615353,
					"lat": 43.55621470212182
				},
				{
					"lng": 11.444449615685105,
					"lat": 43.5562014979283
				},
				{
					"lng": 11.444449592257703,
					"lat": 43.55619445629426
				},
				{
					"lng": 11.444451453045392,
					"lat": 43.55619133691612
				},
				{
					"lng": 11.444451392797479,
					"lat": 43.55619116842385
				},
				{
					"lng": 11.44445134482619,
					"lat": 43.556191034264934
				},
				{
					"lng": 11.444461797295908,
					"lat": 43.5561739779247
				},
				{
					"lng": 11.444469965259174,
					"lat": 43.55616138410083
				},
				{
					"lng": 11.444470258969309,
					"lat": 43.55616093124204
				},
				{
					"lng": 11.444469605087628,
					"lat": 43.556160468163924
				},
				{
					"lng": 11.444469668038973,
					"lat": 43.556160370347534
				},
				{
					"lng": 11.444470656448383,
					"lat": 43.5561588345168
				},
				{
					"lng": 11.444471506335885,
					"lat": 43.5561575139269
				},
				{
					"lng": 11.444472145692089,
					"lat": 43.55615630742329
				},
				{
					"lng": 11.444476275093846,
					"lat": 43.55614851499217
				},
				{
					"lng": 11.444475568867968,
					"lat": 43.55614404053589
				},
				{
					"lng": 11.44447519958599,
					"lat": 43.556141700864714
				},
				{
					"lng": 11.444473392829927,
					"lat": 43.55614055488789
				},
				{
					"lng": 11.444473359521327,
					"lat": 43.556140533761166
				},
				{
					"lng": 11.444472965983737,
					"lat": 43.5561402841508
				},
				{
					"lng": 11.44446566880399,
					"lat": 43.556136613421195
				},
				{
					"lng": 11.444466021890575,
					"lat": 43.556136409668184
				},
				{
					"lng": 11.444474327377907,
					"lat": 43.55613161688164
				},
				{
					"lng": 11.444475606430647,
					"lat": 43.556127224494176
				},
				{
					"lng": 11.444477014820908,
					"lat": 43.55612510279568
				},
				{
					"lng": 11.444477145976144,
					"lat": 43.55612478123271
				},
				{
					"lng": 11.444477600268883,
					"lat": 43.556123317613306
				},
				{
					"lng": 11.44447753795555,
					"lat": 43.55612294550096
				},
				{
					"lng": 11.444477987226241,
					"lat": 43.55612224960675
				},
				{
					"lng": 11.44447809585434,
					"lat": 43.55612141314729
				},
				{
					"lng": 11.444479399497444,
					"lat": 43.55611988015711
				},
				{
					"lng": 11.444481274837099,
					"lat": 43.556113194510225
				},
				{
					"lng": 11.444481483252323,
					"lat": 43.55611245150302
				},
				{
					"lng": 11.444482271437584,
					"lat": 43.55610964159645
				},
				{
					"lng": 11.444482813846104,
					"lat": 43.55610770640448
				},
				{
					"lng": 11.444482834308891,
					"lat": 43.55610763339788
				},
				{
					"lng": 11.444482836841951,
					"lat": 43.556107530035604
				},
				{
					"lng": 11.444482852254405,
					"lat": 43.55610690113175
				},
				{
					"lng": 11.444482442164293,
					"lat": 43.55610483300806
				},
				{
					"lng": 11.444483096341964,
					"lat": 43.55610391326863
				},
				{
					"lng": 11.444484413045844,
					"lat": 43.55609675190793
				},
				{
					"lng": 11.444484357068259,
					"lat": 43.55609612094618
				},
				{
					"lng": 11.44448459758329,
					"lat": 43.55609578310864
				},
				{
					"lng": 11.44448467485871,
					"lat": 43.55609498004534
				},
				{
					"lng": 11.444484755057653,
					"lat": 43.55609477112929
				},
				{
					"lng": 11.444485597229903,
					"lat": 43.55609257729264
				},
				{
					"lng": 11.4444861071671,
					"lat": 43.5560912489196
				},
				{
					"lng": 11.444485697796129,
					"lat": 43.55608786109519
				},
				{
					"lng": 11.444485945467473,
					"lat": 43.556085961837354
				},
				{
					"lng": 11.444485743520854,
					"lat": 43.556085024248546
				},
				{
					"lng": 11.44448570313808,
					"lat": 43.55608483676108
				},
				{
					"lng": 11.444485565927293,
					"lat": 43.55608419972492
				},
				{
					"lng": 11.444485443396724,
					"lat": 43.556083630845336
				},
				{
					"lng": 11.44448644584957,
					"lat": 43.5560815167304
				},
				{
					"lng": 11.444488701781388,
					"lat": 43.55607675910042
				},
				{
					"lng": 11.444492267270848,
					"lat": 43.556069239687446
				},
				{
					"lng": 11.444493555839314,
					"lat": 43.55606652216989
				},
				{
					"lng": 11.4444940121346,
					"lat": 43.556065559869104
				},
				{
					"lng": 11.444495045704203,
					"lat": 43.556063380129316
				},
				{
					"lng": 11.444495905603606,
					"lat": 43.55606156665021
				},
				{
					"lng": 11.444496358618784,
					"lat": 43.55606061126679
				},
				{
					"lng": 11.444498274788142,
					"lat": 43.55605657017342
				},
				{
					"lng": 11.444496148303474,
					"lat": 43.55605407567234
				},
				{
					"lng": 11.44449744764944,
					"lat": 43.55605089202154
				},
				{
					"lng": 11.444497672519185,
					"lat": 43.55605034104685
				},
				{
					"lng": 11.44449811922316,
					"lat": 43.55604924653484
				},
				{
					"lng": 11.444498147578443,
					"lat": 43.55604919807311
				},
				{
					"lng": 11.44449862950646,
					"lat": 43.55604837441396
				},
				{
					"lng": 11.444499167942457,
					"lat": 43.55604745417744
				},
				{
					"lng": 11.444500369449093,
					"lat": 43.55604540069246
				},
				{
					"lng": 11.444502140728098,
					"lat": 43.55604237341383
				},
				{
					"lng": 11.444502276203643,
					"lat": 43.55604214187371
				},
				{
					"lng": 11.444502458173359,
					"lat": 43.55604183087068
				},
				{
					"lng": 11.44450314160668,
					"lat": 43.556040662820216
				},
				{
					"lng": 11.444503742159055,
					"lat": 43.55603963642089
				},
				{
					"lng": 11.444503744587617,
					"lat": 43.55603963227026
				},
				{
					"lng": 11.44450399751322,
					"lat": 43.55603919999708
				},
				{
					"lng": 11.444504005892648,
					"lat": 43.55603918567586
				},
				{
					"lng": 11.444503681356219,
					"lat": 43.55603911394347
				},
				{
					"lng": 11.444493400701301,
					"lat": 43.55603684160597
				},
				{
					"lng": 11.444493386032267,
					"lat": 43.55603684269236
				},
				{
					"lng": 11.444489708098908,
					"lat": 43.55603711508524
				},
				{
					"lng": 11.4444853966248,
					"lat": 43.556037434398846
				},
				{
					"lng": 11.444484225275616,
					"lat": 43.55603752115053
				},
				{
					"lng": 11.444483169862842,
					"lat": 43.55603754118346
				},
				{
					"lng": 11.444468557102125,
					"lat": 43.55603781854883
				},
				{
					"lng": 11.4444549113097,
					"lat": 43.55603864648561
				},
				{
					"lng": 11.4444509003738,
					"lat": 43.55603888984251
				},
				{
					"lng": 11.444446516856232,
					"lat": 43.556039476596254
				},
				{
					"lng": 11.44444436119636,
					"lat": 43.556039765141065
				},
				{
					"lng": 11.444441624807617,
					"lat": 43.556040131419
				},
				{
					"lng": 11.444436293668515,
					"lat": 43.5560408450157
				},
				{
					"lng": 11.444429636884683,
					"lat": 43.556041736055505
				},
				{
					"lng": 11.444426607398379,
					"lat": 43.556042141565456
				},
				{
					"lng": 11.44441773454474,
					"lat": 43.5560433292351
				},
				{
					"lng": 11.44441114195204,
					"lat": 43.55604421168151
				},
				{
					"lng": 11.444409932096951,
					"lat": 43.55604437362567
				},
				{
					"lng": 11.44440957338249,
					"lat": 43.55604442164113
				},
				{
					"lng": 11.44440897356883,
					"lat": 43.556043861753274
				},
				{
					"lng": 11.44439467110275,
					"lat": 43.55603051130802
				},
				{
					"lng": 11.444391626301716,
					"lat": 43.556027669178334
				},
				{
					"lng": 11.444384430186972,
					"lat": 43.55602095205764
				},
				{
					"lng": 11.444369851191588,
					"lat": 43.556011788291364
				},
				{
					"lng": 11.444361527968221,
					"lat": 43.556006556647986
				},
				{
					"lng": 11.44435249132397,
					"lat": 43.55600087657522
				},
				{
					"lng": 11.444343850240077,
					"lat": 43.5559848463566
				},
				{
					"lng": 11.444334472688661,
					"lat": 43.55597859747199
				},
				{
					"lng": 11.444309295115886,
					"lat": 43.55596181997455
				},
				{
					"lng": 11.444307541060049,
					"lat": 43.555961218084846
				},
				{
					"lng": 11.444294665722751,
					"lat": 43.55595680001862
				},
				{
					"lng": 11.444281969055428,
					"lat": 43.555952443259386
				},
				{
					"lng": 11.44427918572039,
					"lat": 43.555949784753196
				},
				{
					"lng": 11.444275446114561,
					"lat": 43.55594621286318
				},
				{
					"lng": 11.444251727318115,
					"lat": 43.55595620458812
				},
				{
					"lng": 11.444223398075358,
					"lat": 43.55596813848821
				},
				{
					"lng": 11.444222589164106,
					"lat": 43.55596847924782
				},
				{
					"lng": 11.444222356196189,
					"lat": 43.555968653473265
				},
				{
					"lng": 11.444200455949236,
					"lat": 43.55598503160413
				},
				{
					"lng": 11.444193169369873,
					"lat": 43.555990228330714
				},
				{
					"lng": 11.44418931455571,
					"lat": 43.555992977550915
				},
				{
					"lng": 11.444188281182127,
					"lat": 43.55599371454396
				},
				{
					"lng": 11.444175344897124,
					"lat": 43.55600096470419
				},
				{
					"lng": 11.444169964602382,
					"lat": 43.556003980097444
				},
				{
					"lng": 11.444165725715973,
					"lat": 43.556006355786565
				},
				{
					"lng": 11.444157565608126,
					"lat": 43.55601075384328
				},
				{
					"lng": 11.44414216403389,
					"lat": 43.5560190548329
				},
				{
					"lng": 11.444130202904065,
					"lat": 43.556025501522534
				},
				{
					"lng": 11.444120428575424,
					"lat": 43.556031291543775
				},
				{
					"lng": 11.444110490107018,
					"lat": 43.5560371787946
				},
				{
					"lng": 11.444096120215116,
					"lat": 43.5560412605813
				},
				{
					"lng": 11.44408674842052,
					"lat": 43.55604392265054
				},
				{
					"lng": 11.444082863862109,
					"lat": 43.55604740693868
				},
				{
					"lng": 11.444080343502486,
					"lat": 43.55604966759667
				},
				{
					"lng": 11.444066584487423,
					"lat": 43.55606200885815
				},
				{
					"lng": 11.444057866093774,
					"lat": 43.556069828889555
				},
				{
					"lng": 11.444052534620566,
					"lat": 43.556074610994834
				},
				{
					"lng": 11.444045386888813,
					"lat": 43.55608102220544
				},
				{
					"lng": 11.444043826708251,
					"lat": 43.556082382987036
				},
				{
					"lng": 11.444024955339101,
					"lat": 43.556097174537086
				},
				{
					"lng": 11.444019353127558,
					"lat": 43.55610156559924
				},
				{
					"lng": 11.444019112374187,
					"lat": 43.55610175430381
				},
				{
					"lng": 11.44401845424669,
					"lat": 43.55610217288383
				},
				{
					"lng": 11.444017431695995,
					"lat": 43.556103150525814
				},
				{
					"lng": 11.444013525570222,
					"lat": 43.556106616382344
				},
				{
					"lng": 11.444010429503301,
					"lat": 43.556109363483486
				},
				{
					"lng": 11.443984182531864,
					"lat": 43.55613265207697
				},
				{
					"lng": 11.443968161619406,
					"lat": 43.55614686721087
				},
				{
					"lng": 11.443955033039297,
					"lat": 43.55615210539568
				},
				{
					"lng": 11.443944221964943,
					"lat": 43.55615641891482
				},
				{
					"lng": 11.443935660276075,
					"lat": 43.55616143016048
				},
				{
					"lng": 11.443931576688417,
					"lat": 43.55616382032636
				},
				{
					"lng": 11.443928573321093,
					"lat": 43.55616557822796
				},
				{
					"lng": 11.44392068608525,
					"lat": 43.556170194706844
				},
				{
					"lng": 11.443906954634057,
					"lat": 43.55617989193608
				},
				{
					"lng": 11.44390693550716,
					"lat": 43.556179905443614
				},
				{
					"lng": 11.443906894561959,
					"lat": 43.55617982088912
				},
				{
					"lng": 11.443899980221538,
					"lat": 43.55616554232161
				},
				{
					"lng": 11.443892248437695,
					"lat": 43.556155452503425
				},
				{
					"lng": 11.44388591922541,
					"lat": 43.556147193009174
				},
				{
					"lng": 11.443880611293304,
					"lat": 43.55614026626278
				},
				{
					"lng": 11.4438776716709,
					"lat": 43.55613643011291
				},
				{
					"lng": 11.443872026793018,
					"lat": 43.55612906365571
				},
				{
					"lng": 11.443866927037147,
					"lat": 43.55611727846495
				},
				{
					"lng": 11.443865175774057,
					"lat": 43.55611501270644
				},
				{
					"lng": 11.443859059619005,
					"lat": 43.556105418775616
				},
				{
					"lng": 11.443858908668657,
					"lat": 43.55610518199167
				},
				{
					"lng": 11.443858245928087,
					"lat": 43.556105078920616
				},
				{
					"lng": 11.443855987423127,
					"lat": 43.55610472767239
				},
				{
					"lng": 11.443839417544648,
					"lat": 43.556103734442196
				},
				{
					"lng": 11.443835803204763,
					"lat": 43.55610351779143
				},
				{
					"lng": 11.443822016392343,
					"lat": 43.55610269138126
				},
				{
					"lng": 11.443820820406277,
					"lat": 43.556102619691266
				},
				{
					"lng": 11.443820409625834,
					"lat": 43.55610255099019
				},
				{
					"lng": 11.443812758177781,
					"lat": 43.556101271321346
				},
				{
					"lng": 11.443809904632534,
					"lat": 43.556100794079136
				},
				{
					"lng": 11.443808745163688,
					"lat": 43.556100600163276
				},
				{
					"lng": 11.443805226263342,
					"lat": 43.55610151265183
				},
				{
					"lng": 11.443802661033162,
					"lat": 43.556102177843364
				},
				{
					"lng": 11.443802629742535,
					"lat": 43.556102185957364
				},
				{
					"lng": 11.443802358011501,
					"lat": 43.55610216519454
				},
				{
					"lng": 11.44379703027663,
					"lat": 43.556101758105406
				},
				{
					"lng": 11.4437956734337,
					"lat": 43.556102038579844
				},
				{
					"lng": 11.443791664630336,
					"lat": 43.556102867243794
				},
				{
					"lng": 11.443789362076304,
					"lat": 43.556103343207084
				},
				{
					"lng": 11.443788123186888,
					"lat": 43.556103381333266
				},
				{
					"lng": 11.443767369525338,
					"lat": 43.55610402001461
				},
				{
					"lng": 11.443766780536304,
					"lat": 43.55610403814037
				},
				{
					"lng": 11.443759301435868,
					"lat": 43.55610426830417
				},
				{
					"lng": 11.443758176424408,
					"lat": 43.55610397275522
				},
				{
					"lng": 11.443755346952095,
					"lat": 43.556103117597885
				},
				{
					"lng": 11.443749364178375,
					"lat": 43.55610130941126
				},
				{
					"lng": 11.443722549639354,
					"lat": 43.55609320519014
				},
				{
					"lng": 11.443721265166015,
					"lat": 43.55609323707147
				},
				{
					"lng": 11.443720339706523,
					"lat": 43.55609343050138
				},
				{
					"lng": 11.443718830271687,
					"lat": 43.55609374598768
				},
				{
					"lng": 11.443708736025688,
					"lat": 43.55609585578095
				},
				{
					"lng": 11.443704277383654,
					"lat": 43.55609678767909
				},
				{
					"lng": 11.443698647732258,
					"lat": 43.556097964329
				},
				{
					"lng": 11.443695000122903,
					"lat": 43.5560927317362
				},
				{
					"lng": 11.443692615812322,
					"lat": 43.55608931137857
				},
				{
					"lng": 11.443692326627719,
					"lat": 43.55608889653548
				},
				{
					"lng": 11.44369221288569,
					"lat": 43.55608873336947
				},
				{
					"lng": 11.44369176875976,
					"lat": 43.55608786926787
				},
				{
					"lng": 11.443691709146567,
					"lat": 43.55608775328304
				},
				{
					"lng": 11.443684238416884,
					"lat": 43.55608003592069
				},
				{
					"lng": 11.443683034327657,
					"lat": 43.556078792080385
				},
				{
					"lng": 11.443682812467063,
					"lat": 43.55607856289544
				},
				{
					"lng": 11.443682539890164,
					"lat": 43.55607813414499
				},
				{
					"lng": 11.44368216722922,
					"lat": 43.556077547967156
				},
				{
					"lng": 11.443680742150246,
					"lat": 43.55607530638592
				},
				{
					"lng": 11.443680465743101,
					"lat": 43.55607487161064
				},
				{
					"lng": 11.443680339558977,
					"lat": 43.55607467312902
				},
				{
					"lng": 11.443680263862475,
					"lat": 43.55607455406205
				},
				{
					"lng": 11.443678732547962,
					"lat": 43.55607214537707
				},
				{
					"lng": 11.443678528902584,
					"lat": 43.55607182505254
				},
				{
					"lng": 11.443678397519339,
					"lat": 43.556071618392956
				},
				{
					"lng": 11.443674713363109,
					"lat": 43.55606582338927
				},
				{
					"lng": 11.443674405396978,
					"lat": 43.556065080268255
				},
				{
					"lng": 11.443674387460218,
					"lat": 43.556065036986894
				},
				{
					"lng": 11.443674270002319,
					"lat": 43.55606475356145
				},
				{
					"lng": 11.443673902772462,
					"lat": 43.55606386743719
				},
				{
					"lng": 11.443673279898938,
					"lat": 43.55606236444576
				},
				{
					"lng": 11.443670416289562,
					"lat": 43.556055454565985
				},
				{
					"lng": 11.443662004610264,
					"lat": 43.556035157202
				},
				{
					"lng": 11.44366174477704,
					"lat": 43.55603453022473
				},
				{
					"lng": 11.443661152770275,
					"lat": 43.55603310171311
				},
				{
					"lng": 11.443661123293202,
					"lat": 43.556033030584985
				},
				{
					"lng": 11.443661117142948,
					"lat": 43.55603301574438
				},
				{
					"lng": 11.443660619211238,
					"lat": 43.55603181423569
				},
				{
					"lng": 11.443659955742776,
					"lat": 43.556030213286874
				},
				{
					"lng": 11.443659866380852,
					"lat": 43.5560299976566
				},
				{
					"lng": 11.443659649893531,
					"lat": 43.55602947527292
				},
				{
					"lng": 11.443659092485193,
					"lat": 43.55602813024696
				},
				{
					"lng": 11.443659063471445,
					"lat": 43.55602806023679
				},
				{
					"lng": 11.44365894885617,
					"lat": 43.55602778367015
				},
				{
					"lng": 11.443657701604103,
					"lat": 43.556024774051544
				},
				{
					"lng": 11.44365739560681,
					"lat": 43.55602403568019
				},
				{
					"lng": 11.443656091168165,
					"lat": 43.55602088806987
				},
				{
					"lng": 11.443655969080812,
					"lat": 43.556020593473164
				},
				{
					"lng": 11.443655933600827,
					"lat": 43.5560205078599
				},
				{
					"lng": 11.44365471645344,
					"lat": 43.55601757088311
				},
				{
					"lng": 11.443652323520025,
					"lat": 43.55601179673348
				},
				{
					"lng": 11.44364844319974,
					"lat": 43.55600243351582
				},
				{
					"lng": 11.443644549553959,
					"lat": 43.55599493353084
				},
				{
					"lng": 11.443643768581556,
					"lat": 43.555993429212606
				},
				{
					"lng": 11.443642166569491,
					"lat": 43.55599034339788
				},
				{
					"lng": 11.443638394867099,
					"lat": 43.55598718908312
				},
				{
					"lng": 11.443634940128321,
					"lat": 43.55598531269409
				},
				{
					"lng": 11.443624544733337,
					"lat": 43.55597966659148
				},
				{
					"lng": 11.443620389272612,
					"lat": 43.55597740961485
				},
				{
					"lng": 11.443606375527773,
					"lat": 43.55596979825554
				},
				{
					"lng": 11.443593867137418,
					"lat": 43.55596523776451
				},
				{
					"lng": 11.44358527155677,
					"lat": 43.55596210386139
				},
				{
					"lng": 11.443581530248174,
					"lat": 43.555962709967
				},
				{
					"lng": 11.443571257724042,
					"lat": 43.555964374152715
				},
				{
					"lng": 11.44356111656662,
					"lat": 43.55596601705551
				},
				{
					"lng": 11.4435549691527,
					"lat": 43.5559670129575
				},
				{
					"lng": 11.443554728041121,
					"lat": 43.55596701999242
				},
				{
					"lng": 11.443554616712511,
					"lat": 43.555967061980404
				},
				{
					"lng": 11.443554399937353,
					"lat": 43.55596703606174
				},
				{
					"lng": 11.443538277608313,
					"lat": 43.555965466544
				},
				{
					"lng": 11.443537407390279,
					"lat": 43.55596538182771
				},
				{
					"lng": 11.443537314519734,
					"lat": 43.55596532646324
				},
				{
					"lng": 11.443536407464075,
					"lat": 43.55596478572462
				},
				{
					"lng": 11.443536406135944,
					"lat": 43.555964784932854
				},
				{
					"lng": 11.443536344303508,
					"lat": 43.555964748071645
				},
				{
					"lng": 11.443536304028997,
					"lat": 43.5559647240621
				},
				{
					"lng": 11.443534782377323,
					"lat": 43.55596381693378
				},
				{
					"lng": 11.443533283963669,
					"lat": 43.55596292365876
				},
				{
					"lng": 11.443532377470135,
					"lat": 43.55596238325514
				},
				{
					"lng": 11.44353213233051,
					"lat": 43.55596223711584
				},
				{
					"lng": 11.443530921374245,
					"lat": 43.555961515207635
				},
				{
					"lng": 11.443521897773579,
					"lat": 43.555957556997384
				},
				{
					"lng": 11.443520130218687,
					"lat": 43.55595678165777
				},
				{
					"lng": 11.443506731217495,
					"lat": 43.55595877493494
				},
				{
					"lng": 11.443505877611987,
					"lat": 43.55595890191986
				},
				{
					"lng": 11.443503100439116,
					"lat": 43.55595931506055
				},
				{
					"lng": 11.443495746503444,
					"lat": 43.55596051372578
				},
				{
					"lng": 11.443479380169437,
					"lat": 43.55596061471796
				},
				{
					"lng": 11.44347553048207,
					"lat": 43.555960638472975
				},
				{
					"lng": 11.44346120846991,
					"lat": 43.55596052860373
				},
				{
					"lng": 11.443449411856314,
					"lat": 43.55595683645491
				},
				{
					"lng": 11.443447418081842,
					"lat": 43.555956212435675
				},
				{
					"lng": 11.443439290481445,
					"lat": 43.55595680403528
				},
				{
					"lng": 11.443439184994848,
					"lat": 43.55595681171356
				},
				{
					"lng": 11.443438378727176,
					"lat": 43.555956520721104
				},
				{
					"lng": 11.443423452966153,
					"lat": 43.55595113381927
				},
				{
					"lng": 11.443418456391797,
					"lat": 43.55594922953784
				},
				{
					"lng": 11.443415267687742,
					"lat": 43.55594852684625
				},
				{
					"lng": 11.443414819518031,
					"lat": 43.55594842808354
				},
				{
					"lng": 11.443407380201625,
					"lat": 43.555943342991114
				},
				{
					"lng": 11.443401571903713,
					"lat": 43.555939372768975
				},
				{
					"lng": 11.443400970921507,
					"lat": 43.555938961971684
				},
				{
					"lng": 11.44339101649305,
					"lat": 43.555932223084625
				},
				{
					"lng": 11.44339082388817,
					"lat": 43.5559319704739
				},
				{
					"lng": 11.443390037495298,
					"lat": 43.55593093908109
				},
				{
					"lng": 11.44338999704017,
					"lat": 43.555930886022225
				},
				{
					"lng": 11.443389653370224,
					"lat": 43.55593043528218
				},
				{
					"lng": 11.44338958479553,
					"lat": 43.555930345343164
				},
				{
					"lng": 11.44338884207096,
					"lat": 43.55592964646921
				},
				{
					"lng": 11.443388239004396,
					"lat": 43.555929079007804
				},
				{
					"lng": 11.443384622837211,
					"lat": 43.55592567633957
				},
				{
					"lng": 11.443381852955897,
					"lat": 43.55592306999203
				},
				{
					"lng": 11.443379125444741,
					"lat": 43.55592050351284
				},
				{
					"lng": 11.44337661133262,
					"lat": 43.55591813783336
				},
				{
					"lng": 11.443376418558204,
					"lat": 43.55591795644024
				},
				{
					"lng": 11.44337635231465,
					"lat": 43.55591789410772
				},
				{
					"lng": 11.443372401622279,
					"lat": 43.555914176662846
				},
				{
					"lng": 11.443372117084193,
					"lat": 43.55591390892377
				},
				{
					"lng": 11.443370810311773,
					"lat": 43.55591267930256
				},
				{
					"lng": 11.443370711222126,
					"lat": 43.55591260337084
				},
				{
					"lng": 11.443368709407885,
					"lat": 43.55591106939423
				},
				{
					"lng": 11.443367349548016,
					"lat": 43.55590980902886
				},
				{
					"lng": 11.443367106840254,
					"lat": 43.555909584078876
				},
				{
					"lng": 11.443366837648442,
					"lat": 43.55590933458252
				},
				{
					"lng": 11.44336594095032,
					"lat": 43.55590850349152
				},
				{
					"lng": 11.443365201083006,
					"lat": 43.55590781775673
				},
				{
					"lng": 11.443364465924429,
					"lat": 43.55590713638615
				},
				{
					"lng": 11.443364229780263,
					"lat": 43.55590691751955
				},
				{
					"lng": 11.443364160419723,
					"lat": 43.555906853233765
				},
				{
					"lng": 11.443363234681959,
					"lat": 43.55590599522767
				},
				{
					"lng": 11.44336264253223,
					"lat": 43.55590544640262
				},
				{
					"lng": 11.443359340467717,
					"lat": 43.55590281779165
				},
				{
					"lng": 11.443359250620468,
					"lat": 43.55590275745409
				},
				{
					"lng": 11.44335870056246,
					"lat": 43.55590238805895
				},
				{
					"lng": 11.443355602078837,
					"lat": 43.55590030725142
				},
				{
					"lng": 11.443354345037484,
					"lat": 43.555899009938166
				},
				{
					"lng": 11.44335315628522,
					"lat": 43.555897783101656
				},
				{
					"lng": 11.443353150540949,
					"lat": 43.55589777717337
				},
				{
					"lng": 11.443352268057364,
					"lat": 43.555896137744575
				},
				{
					"lng": 11.443351227679997,
					"lat": 43.55589500063173
				},
				{
					"lng": 11.443350908089197,
					"lat": 43.55589465132498
				},
				{
					"lng": 11.443344960316722,
					"lat": 43.55589074711575
				},
				{
					"lng": 11.443344816566952,
					"lat": 43.555890652756176
				},
				{
					"lng": 11.443343933580868,
					"lat": 43.55589007315047
				},
				{
					"lng": 11.44334228789336,
					"lat": 43.555888431544936
				},
				{
					"lng": 11.443341712326056,
					"lat": 43.55588785740523
				},
				{
					"lng": 11.443339180864548,
					"lat": 43.55588533222249
				},
				{
					"lng": 11.44333734226604,
					"lat": 43.55588172080025
				},
				{
					"lng": 11.443337035788685,
					"lat": 43.55588118584641
				},
				{
					"lng": 11.443336501429883,
					"lat": 43.55588025312729
				},
				{
					"lng": 11.443336001085408,
					"lat": 43.55587949853229
				},
				{
					"lng": 11.443333841711631,
					"lat": 43.555875670692636
				},
				{
					"lng": 11.443333228732175,
					"lat": 43.55587331605924
				},
				{
					"lng": 11.443330260094454,
					"lat": 43.555871580940696
				},
				{
					"lng": 11.443330057476306,
					"lat": 43.55587146251379
				},
				{
					"lng": 11.443331068889838,
					"lat": 43.55586109098286
				},
				{
					"lng": 11.44333144029555,
					"lat": 43.55585960272287
				},
				{
					"lng": 11.443334679097012,
					"lat": 43.5558509969607
				},
				{
					"lng": 11.44333474127428,
					"lat": 43.555849383482666
				},
				{
					"lng": 11.443334904540478,
					"lat": 43.55584514678272
				},
				{
					"lng": 11.44333557549096,
					"lat": 43.55582773585123
				},
				{
					"lng": 11.443335183551628,
					"lat": 43.55582006604375
				},
				{
					"lng": 11.443336099673674,
					"lat": 43.55580870676574
				},
				{
					"lng": 11.443336237442788,
					"lat": 43.55580699852402
				},
				{
					"lng": 11.443336374052484,
					"lat": 43.55580530465822
				},
				{
					"lng": 11.443336310986279,
					"lat": 43.55580161519096
				},
				{
					"lng": 11.443336276821983,
					"lat": 43.555799616527075
				},
				{
					"lng": 11.443336260154345,
					"lat": 43.55579864144582
				},
				{
					"lng": 11.44333626012008,
					"lat": 43.55579863944042
				},
				{
					"lng": 11.44333625995418,
					"lat": 43.55579862973531
				},
				{
					"lng": 11.443336259284356,
					"lat": 43.55579859054981
				},
				{
					"lng": 11.443336258973256,
					"lat": 43.555798572349865
				},
				{
					"lng": 11.443336258347255,
					"lat": 43.55579853572789
				},
				{
					"lng": 11.443336257909387,
					"lat": 43.55579851011156
				},
				{
					"lng": 11.443336257166633,
					"lat": 43.5557984666606
				},
				{
					"lng": 11.443336252034921,
					"lat": 43.555798166446955
				},
				{
					"lng": 11.443336245938628,
					"lat": 43.55579780980506
				},
				{
					"lng": 11.443336243506897,
					"lat": 43.5557976675447
				},
				{
					"lng": 11.443336234590715,
					"lat": 43.555797145934896
				},
				{
					"lng": 11.443336230057543,
					"lat": 43.55579688073681
				},
				{
					"lng": 11.44333622657171,
					"lat": 43.555796676810864
				},
				{
					"lng": 11.443336192683578,
					"lat": 43.555794694303195
				},
				{
					"lng": 11.443336178568085,
					"lat": 43.555793868525186
				},
				{
					"lng": 11.443336176252272,
					"lat": 43.55579373304636
				},
				{
					"lng": 11.44333617522142,
					"lat": 43.55579367274098
				},
				{
					"lng": 11.443336173394085,
					"lat": 43.55579356583839
				},
				{
					"lng": 11.443336170386631,
					"lat": 43.55579338989748
				},
				{
					"lng": 11.443336169447234,
					"lat": 43.555793334940276
				},
				{
					"lng": 11.443336151171248,
					"lat": 43.55579226576652
				},
				{
					"lng": 11.44333613194241,
					"lat": 43.555791140851895
				},
				{
					"lng": 11.443335823525674,
					"lat": 43.55577309798185
				},
				{
					"lng": 11.443335356296927,
					"lat": 43.55577273145782
				},
				{
					"lng": 11.443327587812815,
					"lat": 43.555766637363206
				},
				{
					"lng": 11.44332656315036,
					"lat": 43.55574940253758
				},
				{
					"lng": 11.443326500462318,
					"lat": 43.55574834812378
				},
				{
					"lng": 11.443326490892119,
					"lat": 43.55574818715312
				},
				{
					"lng": 11.443326487493156,
					"lat": 43.55574812998242
				},
				{
					"lng": 11.443326454003685,
					"lat": 43.55574756668925
				},
				{
					"lng": 11.443326341359345,
					"lat": 43.555745672010346
				},
				{
					"lng": 11.443326290626578,
					"lat": 43.555744818684396
				},
				{
					"lng": 11.443326198775564,
					"lat": 43.55574327374904
				},
				{
					"lng": 11.44332606646743,
					"lat": 43.5557410483244
				},
				{
					"lng": 11.443325619341485,
					"lat": 43.55573352765745
				},
				{
					"lng": 11.44332561825401,
					"lat": 43.55573350936607
				},
				{
					"lng": 11.443325584247946,
					"lat": 43.55573342172836
				},
				{
					"lng": 11.443325514889635,
					"lat": 43.555733233934546
				},
				{
					"lng": 11.443325482565058,
					"lat": 43.55573313048363
				},
				{
					"lng": 11.443325405921733,
					"lat": 43.55573289022148
				},
				{
					"lng": 11.443325193689207,
					"lat": 43.55573222701506
				},
				{
					"lng": 11.443325115931499,
					"lat": 43.555731984029585
				},
				{
					"lng": 11.44332494078456,
					"lat": 43.55573143671196
				},
				{
					"lng": 11.443323749708277,
					"lat": 43.555727714711395
				},
				{
					"lng": 11.443323652132142,
					"lat": 43.5557274819562
				},
				{
					"lng": 11.443323121723274,
					"lat": 43.555726256978375
				},
				{
					"lng": 11.443322557515879,
					"lat": 43.55572500252295
				},
				{
					"lng": 11.443322117589084,
					"lat": 43.555724046894554
				},
				{
					"lng": 11.443316625989869,
					"lat": 43.555702243488035
				},
				{
					"lng": 11.443315220998235,
					"lat": 43.555699761523904
				},
				{
					"lng": 11.443315056643781,
					"lat": 43.55569947118635
				},
				{
					"lng": 11.44331350005544,
					"lat": 43.555696721421285
				},
				{
					"lng": 11.443313513379739,
					"lat": 43.55569621783839
				},
				{
					"lng": 11.443313538622899,
					"lat": 43.55569526379067
				},
				{
					"lng": 11.443313561735323,
					"lat": 43.55569439027271
				},
				{
					"lng": 11.443313658662321,
					"lat": 43.55569072698362
				},
				{
					"lng": 11.443313889448017,
					"lat": 43.55568200459586
				},
				{
					"lng": 11.443313899570585,
					"lat": 43.55568162201975
				},
				{
					"lng": 11.443311232738717,
					"lat": 43.555678805372914
				},
				{
					"lng": 11.443305519529666,
					"lat": 43.555678449221915
				},
				{
					"lng": 11.443309336627877,
					"lat": 43.55567120418517
				},
				{
					"lng": 11.443308905818084,
					"lat": 43.55566853763961
				},
				{
					"lng": 11.443308395700203,
					"lat": 43.55566538020732
				},
				{
					"lng": 11.44330856926265,
					"lat": 43.555664917606066
				},
				{
					"lng": 11.443309370242659,
					"lat": 43.555662782729236
				},
				{
					"lng": 11.4433095090049,
					"lat": 43.55566070584934
				},
				{
					"lng": 11.443309529981821,
					"lat": 43.55566039188361
				},
				{
					"lng": 11.443308982468844,
					"lat": 43.5556592727598
				},
				{
					"lng": 11.443308824601838,
					"lat": 43.55565862854291
				},
				{
					"lng": 11.443308695374046,
					"lat": 43.555658101195455
				},
				{
					"lng": 11.443308559833293,
					"lat": 43.55565754808657
				},
				{
					"lng": 11.44330827109682,
					"lat": 43.555656369822806
				},
				{
					"lng": 11.443307464524752,
					"lat": 43.55565558470294
				},
				{
					"lng": 11.44330726643131,
					"lat": 43.55565539187815
				},
				{
					"lng": 11.443307013268234,
					"lat": 43.55565514544838
				},
				{
					"lng": 11.443305198962062,
					"lat": 43.555653379396766
				},
				{
					"lng": 11.443304019775184,
					"lat": 43.555652231572296
				},
				{
					"lng": 11.443302745202692,
					"lat": 43.55565099089911
				},
				{
					"lng": 11.443296043195067,
					"lat": 43.55564813793201
				},
				{
					"lng": 11.443294447133601,
					"lat": 43.55564745850699
				},
				{
					"lng": 11.443294282637147,
					"lat": 43.55564738848276
				},
				{
					"lng": 11.443294090383434,
					"lat": 43.55564730664258
				},
				{
					"lng": 11.443290319953002,
					"lat": 43.55564542128822
				},
				{
					"lng": 11.443287496530324,
					"lat": 43.55563619863232
				},
				{
					"lng": 11.443287444293741,
					"lat": 43.555636028002525
				},
				{
					"lng": 11.443287102203866,
					"lat": 43.555636065554715
				},
				{
					"lng": 11.443257421240418,
					"lat": 43.55563570240972
				},
				{
					"lng": 11.443256969388067,
					"lat": 43.55563904281088
				},
				{
					"lng": 11.443256834526041,
					"lat": 43.55564003980302
				},
				{
					"lng": 11.443256623256246,
					"lat": 43.55564160165326
				},
				{
					"lng": 11.443256593405785,
					"lat": 43.55564182232832
				},
				{
					"lng": 11.443256569984422,
					"lat": 43.55564199547491
				},
				{
					"lng": 11.443256287909128,
					"lat": 43.55564408076783
				},
				{
					"lng": 11.443247642898221,
					"lat": 43.555639611872266
				},
				{
					"lng": 11.443246894858474,
					"lat": 43.5556392251854
				},
				{
					"lng": 11.443245934454302,
					"lat": 43.555638728720254
				},
				{
					"lng": 11.443238903428973,
					"lat": 43.55563509414666
				},
				{
					"lng": 11.44323418941997,
					"lat": 43.55563265731629
				},
				{
					"lng": 11.443230330698448,
					"lat": 43.55563272966207
				},
				{
					"lng": 11.443224052772969,
					"lat": 43.55563284736441
				},
				{
					"lng": 11.443221350058755,
					"lat": 43.55563238462032
				},
				{
					"lng": 11.443219190725053,
					"lat": 43.55563201491086
				},
				{
					"lng": 11.44321209006759,
					"lat": 43.55563349268763
				},
				{
					"lng": 11.443210431698676,
					"lat": 43.55563383782448
				},
				{
					"lng": 11.443206186980538,
					"lat": 43.5556357825384
				},
				{
					"lng": 11.443195829080835,
					"lat": 43.555640527999905
				},
				{
					"lng": 11.443186967552172,
					"lat": 43.55564458789918
				},
				{
					"lng": 11.443178293081932,
					"lat": 43.555648562096685
				},
				{
					"lng": 11.44317294881735,
					"lat": 43.55564848337223
				},
				{
					"lng": 11.44317060444051,
					"lat": 43.55564960969669
				},
				{
					"lng": 11.44316639197342,
					"lat": 43.555653821739696
				},
				{
					"lng": 11.443165757443486,
					"lat": 43.55565411573918
				},
				{
					"lng": 11.443165218119201,
					"lat": 43.555654365626616
				},
				{
					"lng": 11.443140857317967,
					"lat": 43.55566565281636
				},
				{
					"lng": 11.443128861923839,
					"lat": 43.55566701013879
				},
				{
					"lng": 11.443119915471064,
					"lat": 43.555668022461575
				},
				{
					"lng": 11.443116726102772,
					"lat": 43.55566933313046
				},
				{
					"lng": 11.443109394107585,
					"lat": 43.555672346208695
				},
				{
					"lng": 11.443107144813023,
					"lat": 43.55567327055458
				},
				{
					"lng": 11.44310671630014,
					"lat": 43.555673297523654
				},
				{
					"lng": 11.443105503518549,
					"lat": 43.55567337385185
				},
				{
					"lng": 11.443093794004529,
					"lat": 43.55567272580548
				},
				{
					"lng": 11.443081531271675,
					"lat": 43.55567204714066
				},
				{
					"lng": 11.443071280352152,
					"lat": 43.55567242076318
				},
				{
					"lng": 11.443070735633908,
					"lat": 43.55567244061688
				},
				{
					"lng": 11.443069681213993,
					"lat": 43.55567282251366
				},
				{
					"lng": 11.443069037230075,
					"lat": 43.55567305575599
				},
				{
					"lng": 11.443068439128748,
					"lat": 43.555673082417535
				},
				{
					"lng": 11.443067832112044,
					"lat": 43.55567347669909
				},
				{
					"lng": 11.443044354406103,
					"lat": 43.555677764920645
				},
				{
					"lng": 11.443041451358239,
					"lat": 43.55567766796718
				},
				{
					"lng": 11.443037604706937,
					"lat": 43.55567753949999
				},
				{
					"lng": 11.443029793893931,
					"lat": 43.555677278640644
				},
				{
					"lng": 11.443027605089672,
					"lat": 43.55567720554065
				},
				{
					"lng": 11.443022002818534,
					"lat": 43.55567701844003
				},
				{
					"lng": 11.443017155146864,
					"lat": 43.55567685654074
				},
				{
					"lng": 11.443016443248684,
					"lat": 43.555676832765236
				},
				{
					"lng": 11.443016022314575,
					"lat": 43.55567681870715
				},
				{
					"lng": 11.443015418932799,
					"lat": 43.55567679855577
				},
				{
					"lng": 11.443014957909531,
					"lat": 43.55567672765881
				},
				{
					"lng": 11.443014236090699,
					"lat": 43.55567667840382
				},
				{
					"lng": 11.44301405689973,
					"lat": 43.555676666176346
				},
				{
					"lng": 11.443014019852777,
					"lat": 43.555676663648335
				},
				{
					"lng": 11.443013619924997,
					"lat": 43.55567650075417
				},
				{
					"lng": 11.443011689226092,
					"lat": 43.555675713893464
				},
				{
					"lng": 11.44299874799918,
					"lat": 43.55567025295307
				},
				{
					"lng": 11.442995072279725,
					"lat": 43.55566870187208
				},
				{
					"lng": 11.442994145840288,
					"lat": 43.55566808761526
				},
				{
					"lng": 11.442987628833206,
					"lat": 43.555663766645736
				},
				{
					"lng": 11.442986236618363,
					"lat": 43.55566104032655
				},
				{
					"lng": 11.442985678748418,
					"lat": 43.55565994787184
				},
				{
					"lng": 11.442981697174284,
					"lat": 43.55565514742424
				},
				{
					"lng": 11.442981082406499,
					"lat": 43.55565325373552
				},
				{
					"lng": 11.442979758262025,
					"lat": 43.55565251377687
				},
				{
					"lng": 11.442979131554914,
					"lat": 43.555652453070614
				},
				{
					"lng": 11.442979815496843,
					"lat": 43.555641668121986
				},
				{
					"lng": 11.442979896766955,
					"lat": 43.55564038658917
				},
				{
					"lng": 11.442976937379205,
					"lat": 43.55563890865598
				},
				{
					"lng": 11.442976531080268,
					"lat": 43.55563143499599
				},
				{
					"lng": 11.442976400025213,
					"lat": 43.55563123488946
				},
				{
					"lng": 11.44297599172654,
					"lat": 43.55563061146275
				},
				{
					"lng": 11.44297567450867,
					"lat": 43.5556301271063
				},
				{
					"lng": 11.442975610488519,
					"lat": 43.555630029354624
				},
				{
					"lng": 11.442974712898673,
					"lat": 43.55562865883456
				},
				{
					"lng": 11.442974555523143,
					"lat": 43.55562841853958
				},
				{
					"lng": 11.442974531477272,
					"lat": 43.55562838182419
				},
				{
					"lng": 11.44297426701741,
					"lat": 43.555628439477566
				},
				{
					"lng": 11.442973517975224,
					"lat": 43.555622099255324
				},
				{
					"lng": 11.442972114939899,
					"lat": 43.555618689221475
				},
				{
					"lng": 11.442971136490307,
					"lat": 43.55561631112988
				},
				{
					"lng": 11.442970984778414,
					"lat": 43.555615942398724
				},
				{
					"lng": 11.442970836105909,
					"lat": 43.5556155810547
				},
				{
					"lng": 11.442970681946464,
					"lat": 43.555615206374895
				},
				{
					"lng": 11.442967474298996,
					"lat": 43.55561428373593
				},
				{
					"lng": 11.442963574842734,
					"lat": 43.55561316210676
				},
				{
					"lng": 11.442963434989382,
					"lat": 43.55561350632719
				},
				{
					"lng": 11.442956672062778,
					"lat": 43.555630151886405
				},
				{
					"lng": 11.442955553033126,
					"lat": 43.55563290614788
				},
				{
					"lng": 11.442955113113129,
					"lat": 43.55563316875222
				},
				{
					"lng": 11.442946636087628,
					"lat": 43.555635619583185
				},
				{
					"lng": 11.442934388688627,
					"lat": 43.55563966666677
				},
				{
					"lng": 11.442933682283714,
					"lat": 43.55563990009425
				},
				{
					"lng": 11.442919400106467,
					"lat": 43.555644619556354
				},
				{
					"lng": 11.442919217914975,
					"lat": 43.555644680334744
				},
				{
					"lng": 11.442914848496113,
					"lat": 43.55564613795516
				},
				{
					"lng": 11.442913278839129,
					"lat": 43.555646661586316
				},
				{
					"lng": 11.442908263042503,
					"lat": 43.55564941863575
				},
				{
					"lng": 11.442901667620964,
					"lat": 43.555653043962096
				},
				{
					"lng": 11.442893829840838,
					"lat": 43.555656086572036
				},
				{
					"lng": 11.442888478362082,
					"lat": 43.55565816400447
				},
				{
					"lng": 11.442886747034324,
					"lat": 43.555658836102054
				},
				{
					"lng": 11.44288572667607,
					"lat": 43.55565936419011
				},
				{
					"lng": 11.442885623268113,
					"lat": 43.55565958200242
				},
				{
					"lng": 11.442871678178525,
					"lat": 43.55567834448301
				},
				{
					"lng": 11.44287090873949,
					"lat": 43.5556793797277
				},
				{
					"lng": 11.442868961383319,
					"lat": 43.5556797526694
				},
				{
					"lng": 11.442864922851028,
					"lat": 43.55568052609593
				},
				{
					"lng": 11.442860915342791,
					"lat": 43.555681293580804
				},
				{
					"lng": 11.442848776349086,
					"lat": 43.555692112224214
				},
				{
					"lng": 11.442846712981524,
					"lat": 43.55569487670028
				},
				{
					"lng": 11.442845268426609,
					"lat": 43.55569544767571
				},
				{
					"lng": 11.442845049702681,
					"lat": 43.55569543381555
				},
				{
					"lng": 11.442844446311012,
					"lat": 43.55569539557958
				},
				{
					"lng": 11.442836410383682,
					"lat": 43.55569488635522
				},
				{
					"lng": 11.442819986665315,
					"lat": 43.55569653073099
				},
				{
					"lng": 11.442807774267651,
					"lat": 43.55569811900344
				},
				{
					"lng": 11.442806376244139,
					"lat": 43.555698094791715
				},
				{
					"lng": 11.442807197820581,
					"lat": 43.555700250159354
				},
				{
					"lng": 11.442810444534045,
					"lat": 43.55570876775971
				},
				{
					"lng": 11.442812677400221,
					"lat": 43.555714625577735
				},
				{
					"lng": 11.442815734299337,
					"lat": 43.55571846127741
				},
				{
					"lng": 11.44281831226107,
					"lat": 43.55572157333018
				},
				{
					"lng": 11.442811519748412,
					"lat": 43.555731428758975
				},
				{
					"lng": 11.442808138022142,
					"lat": 43.55573633539003
				},
				{
					"lng": 11.442807708459956,
					"lat": 43.55573695865246
				},
				{
					"lng": 11.442807649338288,
					"lat": 43.55573817021779
				},
				{
					"lng": 11.442807174371122,
					"lat": 43.5557383948186
				},
				{
					"lng": 11.442805963793882,
					"lat": 43.55573892750788
				},
				{
					"lng": 11.442805420516446,
					"lat": 43.55573917622377
				},
				{
					"lng": 11.44280410980149,
					"lat": 43.5557397344089
				},
				{
					"lng": 11.442803491002628,
					"lat": 43.555740012111144
				},
				{
					"lng": 11.442802073549377,
					"lat": 43.555740599622226
				},
				{
					"lng": 11.442801369318385,
					"lat": 43.55574091119587
				},
				{
					"lng": 11.442799822133425,
					"lat": 43.55574150540741
				},
				{
					"lng": 11.442799013876543,
					"lat": 43.55574184071519
				},
				{
					"lng": 11.442797306126245,
					"lat": 43.55574236328024
				},
				{
					"lng": 11.44279638358663,
					"lat": 43.555742709637585
				},
				{
					"lng": 11.442794528362137,
					"lat": 43.55574308382886
				},
				{
					"lng": 11.442793953502548,
					"lat": 43.55574333708413
				},
				{
					"lng": 11.442793156764925,
					"lat": 43.555748815517774
				},
				{
					"lng": 11.442792606708467,
					"lat": 43.55575259775087
				},
				{
					"lng": 11.442792365541399,
					"lat": 43.55575425603534
				},
				{
					"lng": 11.442792151183685,
					"lat": 43.555757210022804
				},
				{
					"lng": 11.442791340318038,
					"lat": 43.55576063256956
				},
				{
					"lng": 11.44279123860959,
					"lat": 43.55576081016171
				},
				{
					"lng": 11.44279438006198,
					"lat": 43.55577772736124
				},
				{
					"lng": 11.442795671903632,
					"lat": 43.55578468412207
				},
				{
					"lng": 11.442789669382432,
					"lat": 43.55579887973291
				},
				{
					"lng": 11.442789612356524,
					"lat": 43.55579892641896
				},
				{
					"lng": 11.442789595443065,
					"lat": 43.55579893267103
				},
				{
					"lng": 11.442789534805412,
					"lat": 43.555798955085876
				},
				{
					"lng": 11.442789442731756,
					"lat": 43.55579903427995
				},
				{
					"lng": 11.442788587183045,
					"lat": 43.55579962279384
				},
				{
					"lng": 11.44278567098463,
					"lat": 43.5558003981843
				},
				{
					"lng": 11.442783356843847,
					"lat": 43.55580101349309
				},
				{
					"lng": 11.442776247338548,
					"lat": 43.555802903844835
				},
				{
					"lng": 11.44277169899205,
					"lat": 43.555806027876734
				},
				{
					"lng": 11.442771868081099,
					"lat": 43.555806974041396
				},
				{
					"lng": 11.442772413973938,
					"lat": 43.555810028671374
				},
				{
					"lng": 11.442772276377447,
					"lat": 43.555810110339216
				},
				{
					"lng": 11.442772104283925,
					"lat": 43.55581021248216
				},
				{
					"lng": 11.44277178446879,
					"lat": 43.5558104023026
				},
				{
					"lng": 11.442771627304879,
					"lat": 43.55581049558433
				},
				{
					"lng": 11.442771995774267,
					"lat": 43.55581052066535
				},
				{
					"lng": 11.442772751869262,
					"lat": 43.555810572131264
				},
				{
					"lng": 11.442773162257755,
					"lat": 43.55581060006562
				},
				{
					"lng": 11.442779784377507,
					"lat": 43.55581105082036
				},
				{
					"lng": 11.442792408740138,
					"lat": 43.55582123977327
				},
				{
					"lng": 11.442792521600147,
					"lat": 43.55582155163088
				},
				{
					"lng": 11.442792539330656,
					"lat": 43.555822028134365
				},
				{
					"lng": 11.442793029227781,
					"lat": 43.55583519400993
				},
				{
					"lng": 11.442792473475622,
					"lat": 43.5558383802102
				},
				{
					"lng": 11.442792466377828,
					"lat": 43.55583842090278
				},
				{
					"lng": 11.442786929867824,
					"lat": 43.555850034171954
				},
				{
					"lng": 11.442785941588408,
					"lat": 43.555850662224685
				},
				{
					"lng": 11.44278578067329,
					"lat": 43.5558507644864
				},
				{
					"lng": 11.442777446092132,
					"lat": 43.55585606112149
				},
				{
					"lng": 11.44276980248299,
					"lat": 43.55586141764705
				},
				{
					"lng": 11.442769170376229,
					"lat": 43.55586186061784
				},
				{
					"lng": 11.442767193396863,
					"lat": 43.5558632460548
				},
				{
					"lng": 11.44276403168926,
					"lat": 43.555865001786806
				},
				{
					"lng": 11.44274060608161,
					"lat": 43.55587038435212
				},
				{
					"lng": 11.442744419545846,
					"lat": 43.5558853579006
				},
				{
					"lng": 11.44274460752863,
					"lat": 43.55588609601389
				},
				{
					"lng": 11.442746548219247,
					"lat": 43.55589371612258
				},
				{
					"lng": 11.442746978786776,
					"lat": 43.555895406742934
				},
				{
					"lng": 11.442747889768455,
					"lat": 43.555898983705454
				},
				{
					"lng": 11.442748123943062,
					"lat": 43.555899903190145
				},
				{
					"lng": 11.442748085902908,
					"lat": 43.55590043581227
				},
				{
					"lng": 11.442756017289044,
					"lat": 43.555900993993866
				},
				{
					"lng": 11.44275708859877,
					"lat": 43.55591221952834
				},
				{
					"lng": 11.442761965845845,
					"lat": 43.55592052457294
				},
				{
					"lng": 11.442762023592248,
					"lat": 43.555920622904324
				},
				{
					"lng": 11.442762192917021,
					"lat": 43.55592091123286
				},
				{
					"lng": 11.442762350202827,
					"lat": 43.555927135343595
				},
				{
					"lng": 11.442762591076718,
					"lat": 43.555936667195375
				},
				{
					"lng": 11.442762795660936,
					"lat": 43.55594476298885
				},
				{
					"lng": 11.442762926018746,
					"lat": 43.55594992149812
				},
				{
					"lng": 11.442763038395919,
					"lat": 43.55595436847717
				},
				{
					"lng": 11.442763015656617,
					"lat": 43.555955589967105
				},
				{
					"lng": 11.442763000378818,
					"lat": 43.55595641064844
				},
				{
					"lng": 11.442762995828394,
					"lat": 43.55595665508416
				},
				{
					"lng": 11.442763182287072,
					"lat": 43.55595794379533
				},
				{
					"lng": 11.442763255306438,
					"lat": 43.555958697077955
				},
				{
					"lng": 11.442763291495485,
					"lat": 43.555959070411696
				},
				{
					"lng": 11.442764000607221,
					"lat": 43.55595933121009
				},
				{
					"lng": 11.442772494656078,
					"lat": 43.5559758970041
				},
				{
					"lng": 11.44277396522843,
					"lat": 43.55597861408205
				},
				{
					"lng": 11.44277402244957,
					"lat": 43.555978719805694
				},
				{
					"lng": 11.442774433177519,
					"lat": 43.55597947868015
				},
				{
					"lng": 11.44277511377865,
					"lat": 43.55598037975415
				},
				{
					"lng": 11.442775489417961,
					"lat": 43.55598087707748
				},
				{
					"lng": 11.442777641018019,
					"lat": 43.55598372566322
				},
				{
					"lng": 11.442779125995322,
					"lat": 43.55598797846118
				},
				{
					"lng": 11.44277940239103,
					"lat": 43.555988770025486
				},
				{
					"lng": 11.442782370705041,
					"lat": 43.555993353896866
				},
				{
					"lng": 11.442783219407143,
					"lat": 43.55599466451999
				},
				{
					"lng": 11.442786471764487,
					"lat": 43.555999550514
				},
				{
					"lng": 11.442789450838283,
					"lat": 43.556004025955254
				},
				{
					"lng": 11.442794772211414,
					"lat": 43.55601202021401
				},
				{
					"lng": 11.442798957111522,
					"lat": 43.55601830715624
				},
				{
					"lng": 11.442798086125585,
					"lat": 43.5560202566258
				},
				{
					"lng": 11.442797999643389,
					"lat": 43.55602046284371
				},
				{
					"lng": 11.442797914726917,
					"lat": 43.556020665328155
				},
				{
					"lng": 11.442797787271326,
					"lat": 43.556020969247754
				},
				{
					"lng": 11.442797692836148,
					"lat": 43.55602119442966
				},
				{
					"lng": 11.442796738015621,
					"lat": 43.55602348307431
				},
				{
					"lng": 11.442796018377162,
					"lat": 43.5560334460802
				},
				{
					"lng": 11.442795752113787,
					"lat": 43.55603713235272
				},
				{
					"lng": 11.442794942613405,
					"lat": 43.556040055521414
				},
				{
					"lng": 11.442794880798346,
					"lat": 43.55604027874043
				},
				{
					"lng": 11.442792770424532,
					"lat": 43.55604820016983
				},
				{
					"lng": 11.442792685484926,
					"lat": 43.55604851899636
				},
				{
					"lng": 11.442792369946496,
					"lat": 43.556048974195654
				},
				{
					"lng": 11.442784876320149,
					"lat": 43.556059784583454
				},
				{
					"lng": 11.442781864741685,
					"lat": 43.556064134765926
				},
				{
					"lng": 11.442780184679366,
					"lat": 43.55606656159185
				},
				{
					"lng": 11.442779505019795,
					"lat": 43.55606754335026
				},
				{
					"lng": 11.44277938922316,
					"lat": 43.55606964519528
				},
				{
					"lng": 11.442778582378489,
					"lat": 43.55607220448667
				},
				{
					"lng": 11.442779233396733,
					"lat": 43.55608269527633
				},
				{
					"lng": 11.442780678013007,
					"lat": 43.556091947832
				},
				{
					"lng": 11.44278685209656,
					"lat": 43.556116290229944
				},
				{
					"lng": 11.44278685054147,
					"lat": 43.55611631261003
				},
				{
					"lng": 11.44278509683405,
					"lat": 43.556116354650264
				},
				{
					"lng": 11.442778352396555,
					"lat": 43.55611651632894
				},
				{
					"lng": 11.442765916969726,
					"lat": 43.556116904313626
				},
				{
					"lng": 11.442765256369176,
					"lat": 43.55611682256743
				},
				{
					"lng": 11.442765238789988,
					"lat": 43.556116821352404
				},
				{
					"lng": 11.442765215144886,
					"lat": 43.55611680991946
				},
				{
					"lng": 11.442764989993117,
					"lat": 43.55611673724292
				},
				{
					"lng": 11.442753270806145,
					"lat": 43.556112954416726
				},
				{
					"lng": 11.442749754117013,
					"lat": 43.55611103509616
				},
				{
					"lng": 11.442747585067382,
					"lat": 43.55610985128328
				},
				{
					"lng": 11.442740081851717,
					"lat": 43.556106154135314
				},
				{
					"lng": 11.442727612148333,
					"lat": 43.55610000978909
				},
				{
					"lng": 11.442727418426806,
					"lat": 43.556099937581784
				},
				{
					"lng": 11.4427268995079,
					"lat": 43.556099720029884
				},
				{
					"lng": 11.44271356608604,
					"lat": 43.55609481150152
				},
				{
					"lng": 11.442709252730273,
					"lat": 43.556093223594395
				},
				{
					"lng": 11.442704119655893,
					"lat": 43.55609133391795
				},
				{
					"lng": 11.44270091534457,
					"lat": 43.556089310204015
				},
				{
					"lng": 11.442688318466535,
					"lat": 43.556078632278506
				},
				{
					"lng": 11.442683409298132,
					"lat": 43.55607428072053
				},
				{
					"lng": 11.442683038718295,
					"lat": 43.55607403514998
				},
				{
					"lng": 11.442682946830072,
					"lat": 43.556073974258865
				},
				{
					"lng": 11.442682626401716,
					"lat": 43.55607376192198
				},
				{
					"lng": 11.442682496908153,
					"lat": 43.55607367611108
				},
				{
					"lng": 11.442680951918593,
					"lat": 43.55607265229953
				},
				{
					"lng": 11.442680730892315,
					"lat": 43.556072541114624
				},
				{
					"lng": 11.442675358200818,
					"lat": 43.55606983843916
				},
				{
					"lng": 11.442673191512117,
					"lat": 43.556068055102074
				},
				{
					"lng": 11.442668013358642,
					"lat": 43.556064964669304
				},
				{
					"lng": 11.442653887198064,
					"lat": 43.55606154193061
				},
				{
					"lng": 11.442653596100746,
					"lat": 43.55606147139829
				},
				{
					"lng": 11.442643647611307,
					"lat": 43.55606294495213
				},
				{
					"lng": 11.442641220761905,
					"lat": 43.556063051379915
				},
				{
					"lng": 11.442630093362437,
					"lat": 43.55606142190559
				},
				{
					"lng": 11.442627629637881,
					"lat": 43.55606189306788
				},
				{
					"lng": 11.442623989430263,
					"lat": 43.556060895569715
				},
				{
					"lng": 11.44262044794591,
					"lat": 43.55605992512386
				},
				{
					"lng": 11.442615037761287,
					"lat": 43.556057648245506
				},
				{
					"lng": 11.442614193162903,
					"lat": 43.55605745965728
				},
				{
					"lng": 11.442611929463203,
					"lat": 43.55605695420155
				},
				{
					"lng": 11.442611913269577,
					"lat": 43.55605695058572
				},
				{
					"lng": 11.442611911882478,
					"lat": 43.556056950276
				},
				{
					"lng": 11.442611907626285,
					"lat": 43.55605694932567
				},
				{
					"lng": 11.442611862143085,
					"lat": 43.55605693916982
				},
				{
					"lng": 11.44261185680675,
					"lat": 43.556056937978305
				},
				{
					"lng": 11.442611812563593,
					"lat": 43.55605692809933
				},
				{
					"lng": 11.442611652256646,
					"lat": 43.55605689230485
				},
				{
					"lng": 11.44261160388305,
					"lat": 43.556056881503636
				},
				{
					"lng": 11.442611518800524,
					"lat": 43.556056862505756
				},
				{
					"lng": 11.442611484495858,
					"lat": 43.55605685484594
				},
				{
					"lng": 11.442611446121507,
					"lat": 43.55605684627742
				},
				{
					"lng": 11.442611417071594,
					"lat": 43.556056839790955
				},
				{
					"lng": 11.44261139082449,
					"lat": 43.556056833930306
				},
				{
					"lng": 11.44261136928474,
					"lat": 43.55605682912075
				},
				{
					"lng": 11.442611340678964,
					"lat": 43.55605682273346
				},
				{
					"lng": 11.44261126313084,
					"lat": 43.556056805417896
				},
				{
					"lng": 11.442611161756115,
					"lat": 43.556056782782186
				},
				{
					"lng": 11.44261104846665,
					"lat": 43.55605675748608
				},
				{
					"lng": 11.442610982035488,
					"lat": 43.556056742652835
				},
				{
					"lng": 11.442610899506956,
					"lat": 43.55605672422524
				},
				{
					"lng": 11.442610825018338,
					"lat": 43.556056707592866
				},
				{
					"lng": 11.442610550862964,
					"lat": 43.55605664637742
				},
				{
					"lng": 11.44261039933484,
					"lat": 43.556056612543095
				},
				{
					"lng": 11.442610385359988,
					"lat": 43.55605660942267
				},
				{
					"lng": 11.4426099455902,
					"lat": 43.556056511227595
				},
				{
					"lng": 11.442609937470122,
					"lat": 43.55605650941448
				},
				{
					"lng": 11.442609906481419,
					"lat": 43.55605650249509
				},
				{
					"lng": 11.442609786594842,
					"lat": 43.55605647572593
				},
				{
					"lng": 11.44260932793058,
					"lat": 43.55605637331195
				},
				{
					"lng": 11.442609282032763,
					"lat": 43.55605636306352
				},
				{
					"lng": 11.442609120736964,
					"lat": 43.55605632704819
				},
				{
					"lng": 11.44260889641508,
					"lat": 43.55605627695991
				},
				{
					"lng": 11.442608868125799,
					"lat": 43.55605627064329
				},
				{
					"lng": 11.44260883194543,
					"lat": 43.556056262564645
				},
				{
					"lng": 11.442608212961625,
					"lat": 43.556056124353304
				},
				{
					"lng": 11.44260770685487,
					"lat": 43.55605601134602
				},
				{
					"lng": 11.442607344945113,
					"lat": 43.55605593053612
				},
				{
					"lng": 11.442605748191001,
					"lat": 43.55605557400084
				},
				{
					"lng": 11.44260487156446,
					"lat": 43.556055378261085
				},
				{
					"lng": 11.44260226848016,
					"lat": 43.556054797024785
				},
				{
					"lng": 11.442602243371223,
					"lat": 43.55605479141827
				},
				{
					"lng": 11.442602190499297,
					"lat": 43.55605477961263
				},
				{
					"lng": 11.442602173339298,
					"lat": 43.556054775781
				},
				{
					"lng": 11.442602013817297,
					"lat": 43.55605474016172
				},
				{
					"lng": 11.442601701184566,
					"lat": 43.556054670354754
				},
				{
					"lng": 11.442599509833464,
					"lat": 43.55605474923721
				},
				{
					"lng": 11.442598072416516,
					"lat": 43.55605480098023
				},
				{
					"lng": 11.44259695294712,
					"lat": 43.556054495945034
				},
				{
					"lng": 11.442593557834755,
					"lat": 43.55605357083807
				},
				{
					"lng": 11.442591866668193,
					"lat": 43.55605311002558
				},
				{
					"lng": 11.442590905998618,
					"lat": 43.55605284826039
				},
				{
					"lng": 11.442590743484526,
					"lat": 43.556052803978226
				},
				{
					"lng": 11.442590388748636,
					"lat": 43.556052875186836
				},
				{
					"lng": 11.442577080598241,
					"lat": 43.55605554739332
				},
				{
					"lng": 11.44257579843016,
					"lat": 43.55606007089519
				},
				{
					"lng": 11.442575507031622,
					"lat": 43.55606438491209
				},
				{
					"lng": 11.44257642528524,
					"lat": 43.556069283841694
				},
				{
					"lng": 11.442577421530435,
					"lat": 43.556070418929714
				},
				{
					"lng": 11.44257858401597,
					"lat": 43.55607061309673
				},
				{
					"lng": 11.442578708701127,
					"lat": 43.556070633922566
				},
				{
					"lng": 11.442578380758011,
					"lat": 43.55607118698908
				},
				{
					"lng": 11.442578388870235,
					"lat": 43.556071341966614
				},
				{
					"lng": 11.442595362899706,
					"lat": 43.55607862554905
				},
				{
					"lng": 11.4426024065856,
					"lat": 43.55607987412879
				},
				{
					"lng": 11.442615809176228,
					"lat": 43.55608545947534
				},
				{
					"lng": 11.442619200218395,
					"lat": 43.556086893915854
				},
				{
					"lng": 11.442624141152105,
					"lat": 43.55608889369414
				},
				{
					"lng": 11.442631617955902,
					"lat": 43.55609318856166
				},
				{
					"lng": 11.44263323384898,
					"lat": 43.55609528925282
				},
				{
					"lng": 11.442633651619909,
					"lat": 43.55609555696242
				},
				{
					"lng": 11.442637108382783,
					"lat": 43.55609777207215
				},
				{
					"lng": 11.442639763587385,
					"lat": 43.55609947353945
				},
				{
					"lng": 11.442640571190324,
					"lat": 43.556100009277046
				},
				{
					"lng": 11.442649508331828,
					"lat": 43.556105937885846
				},
				{
					"lng": 11.44265213950376,
					"lat": 43.556107683319276
				},
				{
					"lng": 11.442655570612343,
					"lat": 43.556111433384025
				},
				{
					"lng": 11.442655744005124,
					"lat": 43.55611153592913
				},
				{
					"lng": 11.442665870853324,
					"lat": 43.556117524981715
				},
				{
					"lng": 11.442666218281651,
					"lat": 43.55611773045195
				},
				{
					"lng": 11.44266926690784,
					"lat": 43.55611914045879
				},
				{
					"lng": 11.442675004423293,
					"lat": 43.556121794091645
				},
				{
					"lng": 11.44267661500635,
					"lat": 43.55612253899518
				},
				{
					"lng": 11.442679104660257,
					"lat": 43.556124046946955
				},
				{
					"lng": 11.442681172465864,
					"lat": 43.55612529939047
				},
				{
					"lng": 11.442684837562732,
					"lat": 43.55612751929272
				},
				{
					"lng": 11.44268771342091,
					"lat": 43.55612907053484
				},
				{
					"lng": 11.442689975038375,
					"lat": 43.55613029045451
				},
				{
					"lng": 11.442690823240545,
					"lat": 43.55613074797595
				},
				{
					"lng": 11.442691466983298,
					"lat": 43.55613109521167
				},
				{
					"lng": 11.44269225735823,
					"lat": 43.55613152154099
				},
				{
					"lng": 11.442693558048456,
					"lat": 43.55613238226798
				},
				{
					"lng": 11.442695314453058,
					"lat": 43.55613354456226
				},
				{
					"lng": 11.44269692266149,
					"lat": 43.556134608788184
				},
				{
					"lng": 11.44269992142458,
					"lat": 43.55613631902425
				},
				{
					"lng": 11.442701671460297,
					"lat": 43.556137317093736
				},
				{
					"lng": 11.442711149062095,
					"lat": 43.55614376461964
				},
				{
					"lng": 11.442713674335922,
					"lat": 43.556145421989555
				},
				{
					"lng": 11.4427139843953,
					"lat": 43.556145625485506
				},
				{
					"lng": 11.442716676641595,
					"lat": 43.55614739244146
				},
				{
					"lng": 11.442724964366429,
					"lat": 43.556154489957045
				},
				{
					"lng": 11.442727937772208,
					"lat": 43.556157036348196
				},
				{
					"lng": 11.442730218729205,
					"lat": 43.55615877862501
				},
				{
					"lng": 11.442731688903587,
					"lat": 43.55616100062484
				},
				{
					"lng": 11.442735520142143,
					"lat": 43.556166791101305
				},
				{
					"lng": 11.442736672908216,
					"lat": 43.556168533374404
				},
				{
					"lng": 11.442737053838274,
					"lat": 43.55616949879785
				},
				{
					"lng": 11.442738430682848,
					"lat": 43.556172988252
				},
				{
					"lng": 11.442738847485181,
					"lat": 43.55617404458948
				},
				{
					"lng": 11.442740986699171,
					"lat": 43.556177018839385
				},
				{
					"lng": 11.442743029100614,
					"lat": 43.55617985848594
				},
				{
					"lng": 11.442750770731728,
					"lat": 43.5561886756804
				},
				{
					"lng": 11.442758736272005,
					"lat": 43.55620111301107
				},
				{
					"lng": 11.442759680836167,
					"lat": 43.556203654939
				},
				{
					"lng": 11.442756294456698,
					"lat": 43.55620423279475
				},
				{
					"lng": 11.442735807826518,
					"lat": 43.556207728654975
				},
				{
					"lng": 11.442731802855468,
					"lat": 43.556208412066994
				},
				{
					"lng": 11.442718846020497,
					"lat": 43.55621881146753
				},
				{
					"lng": 11.442713854629563,
					"lat": 43.55622281765091
				},
				{
					"lng": 11.442712887164728,
					"lat": 43.55622359415609
				},
				{
					"lng": 11.44269972831716,
					"lat": 43.556240857579766
				},
				{
					"lng": 11.44269873305368,
					"lat": 43.55624146342338
				},
				{
					"lng": 11.44269435964968,
					"lat": 43.556244125631636
				},
				{
					"lng": 11.4426924305033,
					"lat": 43.55624529995462
				},
				{
					"lng": 11.44268280382351,
					"lat": 43.55624628399294
				},
				{
					"lng": 11.442682327760282,
					"lat": 43.55624633265603
				},
				{
					"lng": 11.442677014052578,
					"lat": 43.556247337696824
				},
				{
					"lng": 11.442674767115275,
					"lat": 43.55624560633785
				},
				{
					"lng": 11.442674595255042,
					"lat": 43.55624553432502
				},
				{
					"lng": 11.44266838517217,
					"lat": 43.55624293217774
				},
				{
					"lng": 11.442667726117552,
					"lat": 43.55624255071413
				},
				{
					"lng": 11.442661858326822,
					"lat": 43.556239154411706
				},
				{
					"lng": 11.442660334957194,
					"lat": 43.55623785474545
				},
				{
					"lng": 11.442650333251228,
					"lat": 43.5562293217651
				},
				{
					"lng": 11.442647622668359,
					"lat": 43.55622735214816
				},
				{
					"lng": 11.442647013392454,
					"lat": 43.55622791481887
				},
				{
					"lng": 11.442647166844067,
					"lat": 43.556228415639815
				},
				{
					"lng": 11.442647673985636,
					"lat": 43.55623007080079
				},
				{
					"lng": 11.442644474378666,
					"lat": 43.55623165922184
				},
				{
					"lng": 11.442641742430027,
					"lat": 43.55623301547725
				},
				{
					"lng": 11.442638301595675,
					"lat": 43.55623472365347
				},
				{
					"lng": 11.442636598603283,
					"lat": 43.55623689238573
				},
				{
					"lng": 11.4426369911235,
					"lat": 43.556240663525294
				},
				{
					"lng": 11.44263651366454,
					"lat": 43.55624165326121
				},
				{
					"lng": 11.442640618189646,
					"lat": 43.55625561403891
				},
				{
					"lng": 11.442640034117552,
					"lat": 43.556263090855545
				},
				{
					"lng": 11.442643417092995,
					"lat": 43.55626784018472
				},
				{
					"lng": 11.442643969561058,
					"lat": 43.55626861578965
				},
				{
					"lng": 11.442645406894263,
					"lat": 43.556271506280915
				},
				{
					"lng": 11.442650380084107,
					"lat": 43.556281507412336
				},
				{
					"lng": 11.442648616299676,
					"lat": 43.5562865546416
				},
				{
					"lng": 11.442644633079059,
					"lat": 43.556297952985744
				},
				{
					"lng": 11.442640802678886,
					"lat": 43.556300426155296
				},
				{
					"lng": 11.442640708520884,
					"lat": 43.55630052631952
				},
				{
					"lng": 11.442639260466287,
					"lat": 43.5563020667434
				},
				{
					"lng": 11.44263368969177,
					"lat": 43.556307992868796
				},
				{
					"lng": 11.44260995384735,
					"lat": 43.55631004043135
				},
				{
					"lng": 11.442608605169937,
					"lat": 43.556310156774295
				},
				{
					"lng": 11.442606019929682,
					"lat": 43.55631037978862
				}
			]
		]
	},
	"6": {
		"name": "PC - Podere Capanna",
		"center": {
			"lat": 43.5706,
			"lng": 11.4543
		},
		"coords": [
			[
				{
					"lng": 11.445504206437967,
					"lat": 43.567729761488884
				},
				{
					"lng": 11.44570707693632,
					"lat": 43.56784210398323
				},
				{
					"lng": 11.446101663490484,
					"lat": 43.56806061511526
				},
				{
					"lng": 11.446934243940827,
					"lat": 43.568399521306446
				},
				{
					"lng": 11.448270636134607,
					"lat": 43.56896483404512
				},
				{
					"lng": 11.449757249640946,
					"lat": 43.56959484692801
				},
				{
					"lng": 11.45006835194929,
					"lat": 43.56975570507355
				},
				{
					"lng": 11.450354819341308,
					"lat": 43.569934686048256
				},
				{
					"lng": 11.450398811242355,
					"lat": 43.569968932265
				},
				{
					"lng": 11.450504467024633,
					"lat": 43.57005117997336
				},
				{
					"lng": 11.45083154106326,
					"lat": 43.57065347375213
				},
				{
					"lng": 11.451582796686775,
					"lat": 43.571605350383805
				},
				{
					"lng": 11.454033055601583,
					"lat": 43.572403942103456
				},
				{
					"lng": 11.455527201239194,
					"lat": 43.57288699960443
				},
				{
					"lng": 11.458461316216447,
					"lat": 43.57383551723076
				},
				{
					"lng": 11.457455869918304,
					"lat": 43.57432894166562
				},
				{
					"lng": 11.45743386508561,
					"lat": 43.574693772783206
				},
				{
					"lng": 11.45787391591109,
					"lat": 43.57468460822736
				},
				{
					"lng": 11.458590152077337,
					"lat": 43.5744709496146
				},
				{
					"lng": 11.459775918316303,
					"lat": 43.574363323849305
				},
				{
					"lng": 11.46140294008697,
					"lat": 43.57443878159599
				},
				{
					"lng": 11.462438941239476,
					"lat": 43.57412833523882
				},
				{
					"lng": 11.463325149126192,
					"lat": 43.57383906624479
				},
				{
					"lng": 11.46333208858348,
					"lat": 43.573708076927964
				},
				{
					"lng": 11.46377495154232,
					"lat": 43.57360617213862
				},
				{
					"lng": 11.46365551484649,
					"lat": 43.57352218525541
				},
				{
					"lng": 11.463731574861795,
					"lat": 43.57350004221025
				},
				{
					"lng": 11.46376794190262,
					"lat": 43.57342358832057
				},
				{
					"lng": 11.463809983796597,
					"lat": 43.57333751809592
				},
				{
					"lng": 11.463825055036443,
					"lat": 43.57322837204482
				},
				{
					"lng": 11.463820619846741,
					"lat": 43.57311964716944
				},
				{
					"lng": 11.463741196537347,
					"lat": 43.57292200324674
				},
				{
					"lng": 11.46361298402481,
					"lat": 43.57274251806488
				},
				{
					"lng": 11.463196072434256,
					"lat": 43.572460295131876
				},
				{
					"lng": 11.463211083664923,
					"lat": 43.572294144944394
				},
				{
					"lng": 11.463552865770673,
					"lat": 43.572251681678615
				},
				{
					"lng": 11.463308226908113,
					"lat": 43.57215571822296
				},
				{
					"lng": 11.462468390725986,
					"lat": 43.57182627130164
				},
				{
					"lng": 11.461406633598209,
					"lat": 43.57140975784895
				},
				{
					"lng": 11.460202482027883,
					"lat": 43.5709373628358
				},
				{
					"lng": 11.459498817825947,
					"lat": 43.57069189451732
				},
				{
					"lng": 11.458426477057364,
					"lat": 43.5703187093752
				},
				{
					"lng": 11.458238280360229,
					"lat": 43.570311784609245
				},
				{
					"lng": 11.458116122827821,
					"lat": 43.57039681330772
				},
				{
					"lng": 11.45722911905341,
					"lat": 43.57011491364212
				},
				{
					"lng": 11.456638441835238,
					"lat": 43.56992718453999
				},
				{
					"lng": 11.456537492051067,
					"lat": 43.56980897796391
				},
				{
					"lng": 11.456438250208477,
					"lat": 43.569715699363975
				},
				{
					"lng": 11.456032466384853,
					"lat": 43.56949763353675
				},
				{
					"lng": 11.455858212340818,
					"lat": 43.569462093062526
				},
				{
					"lng": 11.455382565611247,
					"lat": 43.56936507919408
				},
				{
					"lng": 11.454737531088298,
					"lat": 43.56927100189105
				},
				{
					"lng": 11.453771701637148,
					"lat": 43.56913922368144
				},
				{
					"lng": 11.453083562734516,
					"lat": 43.5689094487463
				},
				{
					"lng": 11.452358235128626,
					"lat": 43.56866725130461
				},
				{
					"lng": 11.452019026503649,
					"lat": 43.56855398232953
				},
				{
					"lng": 11.451712935748999,
					"lat": 43.56845121964636
				},
				{
					"lng": 11.45163313476073,
					"lat": 43.568424152196606
				},
				{
					"lng": 11.451557701608523,
					"lat": 43.56839856618492
				},
				{
					"lng": 11.451244481985654,
					"lat": 43.56829232510646
				},
				{
					"lng": 11.451109478113466,
					"lat": 43.56824653270806
				},
				{
					"lng": 11.450741637942517,
					"lat": 43.568121762636295
				},
				{
					"lng": 11.450479811794732,
					"lat": 43.56803295109175
				},
				{
					"lng": 11.450225074361557,
					"lat": 43.56794654320368
				},
				{
					"lng": 11.449838894526854,
					"lat": 43.567814961830486
				},
				{
					"lng": 11.449643204112851,
					"lat": 43.56774821406265
				},
				{
					"lng": 11.449607944551005,
					"lat": 43.56773754415222
				},
				{
					"lng": 11.449266155503944,
					"lat": 43.567634114459594
				},
				{
					"lng": 11.448885131560322,
					"lat": 43.56751678248142
				},
				{
					"lng": 11.448679356341973,
					"lat": 43.56745078945939
				},
				{
					"lng": 11.448569805289463,
					"lat": 43.567419607724936
				},
				{
					"lng": 11.44812800941661,
					"lat": 43.56729425687243
				},
				{
					"lng": 11.447705809791108,
					"lat": 43.567215845058925
				},
				{
					"lng": 11.447507072099599,
					"lat": 43.56713512414933
				},
				{
					"lng": 11.44711407308441,
					"lat": 43.566975498807246
				},
				{
					"lng": 11.447024452743447,
					"lat": 43.566929005587546
				},
				{
					"lng": 11.44685056405041,
					"lat": 43.56677965321967
				},
				{
					"lng": 11.445790922316563,
					"lat": 43.56639501635248
				},
				{
					"lng": 11.44556781073762,
					"lat": 43.56638695065374
				},
				{
					"lng": 11.445358029710164,
					"lat": 43.56649596262474
				},
				{
					"lng": 11.445191541013893,
					"lat": 43.56659578037753
				},
				{
					"lng": 11.445025054762008,
					"lat": 43.56669559728539
				},
				{
					"lng": 11.4448779421287,
					"lat": 43.56689444757969
				},
				{
					"lng": 11.444904887337412,
					"lat": 43.56716464422046
				},
				{
					"lng": 11.445130235195492,
					"lat": 43.5674520226566
				},
				{
					"lng": 11.445504206437967,
					"lat": 43.567729761488884
				}
			]
		]
	},
	"2": {
		"name": "SM - San Martino",
		"center": {
			"lat": 43.5552,
			"lng": 11.4370
		},
		"coords": [
			[
				{
					"lng": 11.435801862315625,
					"lat": 43.55577424791075
				},
				{
					"lng": 11.436510110229067,
					"lat": 43.55570272763512
				},
				{
					"lng": 11.43667290570375,
					"lat": 43.55574723009664
				},
				{
					"lng": 11.43696274897716,
					"lat": 43.55572567230528
				},
				{
					"lng": 11.437151415079027,
					"lat": 43.55573355964161
				},
				{
					"lng": 11.437166556004277,
					"lat": 43.55590595037328
				},
				{
					"lng": 11.43719203880288,
					"lat": 43.556131721304816
				},
				{
					"lng": 11.437387470837246,
					"lat": 43.555901238179366
				},
				{
					"lng": 11.43767604512608,
					"lat": 43.55554369914341
				},
				{
					"lng": 11.438066900357274,
					"lat": 43.5550827310626
				},
				{
					"lng": 11.438414439713325,
					"lat": 43.55456312955943
				},
				{
					"lng": 11.438726586736697,
					"lat": 43.55418126219541
				},
				{
					"lng": 11.438355985965655,
					"lat": 43.55433210681085
				},
				{
					"lng": 11.437979601792051,
					"lat": 43.55454263007108
				},
				{
					"lng": 11.437642204331963,
					"lat": 43.55470467521322
				},
				{
					"lng": 11.437337532597866,
					"lat": 43.55486602129503
				},
				{
					"lng": 11.437120940652612,
					"lat": 43.55497784278853
				},
				{
					"lng": 11.436988350570116,
					"lat": 43.55493898120687
				},
				{
					"lng": 11.436829055661493,
					"lat": 43.5548470881872
				},
				{
					"lng": 11.436661099545885,
					"lat": 43.554743468352626
				},
				{
					"lng": 11.436599268340213,
					"lat": 43.55463162962402
				},
				{
					"lng": 11.436519394456395,
					"lat": 43.55447848608
				},
				{
					"lng": 11.436439760871355,
					"lat": 43.55433129299735
				},
				{
					"lng": 11.43636998858862,
					"lat": 43.5542255791086
				},
				{
					"lng": 11.436226100681889,
					"lat": 43.554109534133836
				},
				{
					"lng": 11.436124081607938,
					"lat": 43.5540164189138
				},
				{
					"lng": 11.435940964621143,
					"lat": 43.55394289946021
				},
				{
					"lng": 11.435951065017067,
					"lat": 43.55399032930087
				},
				{
					"lng": 11.43600567187213,
					"lat": 43.55412614499572
				},
				{
					"lng": 11.436062197716254,
					"lat": 43.55430956491391
				},
				{
					"lng": 11.436143749170567,
					"lat": 43.55450436253642
				},
				{
					"lng": 11.436192813536222,
					"lat": 43.55470580839527
				},
				{
					"lng": 11.436187243390433,
					"lat": 43.554973931185174
				},
				{
					"lng": 11.436138364938818,
					"lat": 43.55518342087364
				},
				{
					"lng": 11.436056278602942,
					"lat": 43.555381707231604
				},
				{
					"lng": 11.435915238923501,
					"lat": 43.555539560821636
				},
				{
					"lng": 11.43578912358369,
					"lat": 43.55566136222262
				},
				{
					"lng": 11.435801862315625,
					"lat": 43.55577424791075
				}
			]
		]
	},
	"4": {
		"name": "CN - Emissario Lago Castelnuovo",
		"center": {
			"lat": 43.5618,
			"lng": 11.4737
		},
		"coords": [
			[
				{
					"lng": 11.469251941191196,
					"lat": 43.5601390226696
				},
				{
					"lng": 11.469458494037719,
					"lat": 43.56056109468383
				},
				{
					"lng": 11.469737067238814,
					"lat": 43.5607841277838
				},
				{
					"lng": 11.469854232202225,
					"lat": 43.561084898750714
				},
				{
					"lng": 11.470137390049153,
					"lat": 43.56112664026237
				},
				{
					"lng": 11.4701684110157,
					"lat": 43.56127660944024
				},
				{
					"lng": 11.470581424706992,
					"lat": 43.56150095263636
				},
				{
					"lng": 11.470742665046547,
					"lat": 43.56158791796594
				},
				{
					"lng": 11.471110945310535,
					"lat": 43.5617355800956
				},
				{
					"lng": 11.471504841586817,
					"lat": 43.56181098739046
				},
				{
					"lng": 11.471769481808392,
					"lat": 43.561861649098326
				},
				{
					"lng": 11.47215556005489,
					"lat": 43.56188992777652
				},
				{
					"lng": 11.472361348521371,
					"lat": 43.56192803389763
				},
				{
					"lng": 11.472687269904004,
					"lat": 43.56195949871287
				},
				{
					"lng": 11.47291534021276,
					"lat": 43.561978116269955
				},
				{
					"lng": 11.473247404112968,
					"lat": 43.5620147009133
				},
				{
					"lng": 11.474054377788866,
					"lat": 43.56148324841372
				},
				{
					"lng": 11.474711549991175,
					"lat": 43.561058911954085
				},
				{
					"lng": 11.475143363025545,
					"lat": 43.560794498841354
				},
				{
					"lng": 11.475321257799271,
					"lat": 43.56100962701163
				},
				{
					"lng": 11.475666253772934,
					"lat": 43.561043908856824
				},
				{
					"lng": 11.475779676370724,
					"lat": 43.561173691671016
				},
				{
					"lng": 11.475819453851594,
					"lat": 43.56126665728583
				},
				{
					"lng": 11.475865130928549,
					"lat": 43.56128226051357
				},
				{
					"lng": 11.4759895636263,
					"lat": 43.56157047329802
				},
				{
					"lng": 11.476148038318556,
					"lat": 43.56194222451477
				},
				{
					"lng": 11.476198188048743,
					"lat": 43.56207134002261
				},
				{
					"lng": 11.47620998680372,
					"lat": 43.562101717011274
				},
				{
					"lng": 11.476317186680191,
					"lat": 43.56210639733489
				},
				{
					"lng": 11.476610597634531,
					"lat": 43.562120081953566
				},
				{
					"lng": 11.47696781786903,
					"lat": 43.56212817151123
				},
				{
					"lng": 11.47718434146045,
					"lat": 43.562186046819235
				},
				{
					"lng": 11.477531235415876,
					"lat": 43.56226678027661
				},
				{
					"lng": 11.47812490444819,
					"lat": 43.56241989138222
				},
				{
					"lng": 11.47848731533076,
					"lat": 43.56255555560261
				},
				{
					"lng": 11.478814942906252,
					"lat": 43.56267786701677
				},
				{
					"lng": 11.47930010093735,
					"lat": 43.56294502021507
				},
				{
					"lng": 11.479563785143235,
					"lat": 43.56310541243253
				},
				{
					"lng": 11.479734221682525,
					"lat": 43.56318056630701
				},
				{
					"lng": 11.480031761700753,
					"lat": 43.563317298663094
				},
				{
					"lng": 11.480219254962257,
					"lat": 43.563362984966986
				},
				{
					"lng": 11.480146990950269,
					"lat": 43.56345132915499
				},
				{
					"lng": 11.478812749685707,
					"lat": 43.56286932562601
				},
				{
					"lng": 11.478415561464358,
					"lat": 43.562720541594416
				},
				{
					"lng": 11.477939873771016,
					"lat": 43.562604706767914
				},
				{
					"lng": 11.477593683425088,
					"lat": 43.56254453569275
				},
				{
					"lng": 11.477131058491858,
					"lat": 43.5624998611431
				},
				{
					"lng": 11.476720275465633,
					"lat": 43.56247510485084
				},
				{
					"lng": 11.476444146750978,
					"lat": 43.5624824604953
				},
				{
					"lng": 11.476266522909345,
					"lat": 43.56246486987553
				},
				{
					"lng": 11.476234972229303,
					"lat": 43.562520237510086
				},
				{
					"lng": 11.476021280760767,
					"lat": 43.56255594562471
				},
				{
					"lng": 11.47593944172829,
					"lat": 43.56251691910511
				},
				{
					"lng": 11.475874933925066,
					"lat": 43.56252803968248
				},
				{
					"lng": 11.475861250649258,
					"lat": 43.562593848106076
				},
				{
					"lng": 11.475879365413176,
					"lat": 43.562613855345425
				},
				{
					"lng": 11.475763420557024,
					"lat": 43.56264481313762
				},
				{
					"lng": 11.475667591953226,
					"lat": 43.562655106573835
				},
				{
					"lng": 11.475482696392733,
					"lat": 43.562674966907394
				},
				{
					"lng": 11.475249575085744,
					"lat": 43.56276876986627
				},
				{
					"lng": 11.474827875608328,
					"lat": 43.5628219286918
				},
				{
					"lng": 11.474439974779017,
					"lat": 43.562870240187294
				},
				{
					"lng": 11.474101582828535,
					"lat": 43.56282254440612
				},
				{
					"lng": 11.473731018367799,
					"lat": 43.562631838357305
				},
				{
					"lng": 11.473462156419027,
					"lat": 43.562620203425276
				},
				{
					"lng": 11.473169382084512,
					"lat": 43.56265810128352
				},
				{
					"lng": 11.473031980606173,
					"lat": 43.56270276468147
				},
				{
					"lng": 11.472849281635238,
					"lat": 43.562641206925065
				},
				{
					"lng": 11.47248012615353,
					"lat": 43.56244505419717
				},
				{
					"lng": 11.472300168211163,
					"lat": 43.562441235411264
				},
				{
					"lng": 11.472129307980275,
					"lat": 43.56243760941964
				},
				{
					"lng": 11.471854323123091,
					"lat": 43.5624162753399
				},
				{
					"lng": 11.471626500324602,
					"lat": 43.562398401867
				},
				{
					"lng": 11.471039837332418,
					"lat": 43.562265045766765
				},
				{
					"lng": 11.470800747382233,
					"lat": 43.56221069647918
				},
				{
					"lng": 11.470541615345834,
					"lat": 43.56210360407238
				},
				{
					"lng": 11.470344678056325,
					"lat": 43.56202221444898
				},
				{
					"lng": 11.470200415840102,
					"lat": 43.56192943342319
				},
				{
					"lng": 11.469840584440274,
					"lat": 43.56169800881443
				},
				{
					"lng": 11.469669041310512,
					"lat": 43.56158768025934
				},
				{
					"lng": 11.469604659655579,
					"lat": 43.56152117256541
				},
				{
					"lng": 11.46956553986717,
					"lat": 43.56144963359918
				},
				{
					"lng": 11.4695097389228,
					"lat": 43.56138459652638
				},
				{
					"lng": 11.469423393832582,
					"lat": 43.5612839593235
				},
				{
					"lng": 11.46899907854021,
					"lat": 43.56102215877021
				},
				{
					"lng": 11.469153455149355,
					"lat": 43.56066465366302
				},
				{
					"lng": 11.468729258307023,
					"lat": 43.56030457046881
				},
				{
					"lng": 11.468328536955802,
					"lat": 43.560219558344905
				},
				{
					"lng": 11.469658721146304,
					"lat": 43.55980207832129
				},
				{
					"lng": 11.469251941191196,
					"lat": 43.5601390226696
				}
			]
		]
	},
	"12": {
		"name": "IA01 - Borro Valli",
		"center": {
			"lat": 43.5387,
			"lng": 11.4647
		},
		"coords": [
			[
				{
					"lng": 11.465296773979007,
					"lat": 43.54467956376206
				},
				{
					"lng": 11.465288289738979,
					"lat": 43.544659439466095
				},
				{
					"lng": 11.46528311305302,
					"lat": 43.544647160555776
				},
				{
					"lng": 11.46527825168868,
					"lat": 43.5446356295718
				},
				{
					"lng": 11.465273170283327,
					"lat": 43.54462357665312
				},
				{
					"lng": 11.46526906659636,
					"lat": 43.54461384284492
				},
				{
					"lng": 11.465263647190987,
					"lat": 43.544600988191334
				},
				{
					"lng": 11.465258522690599,
					"lat": 43.5445888330372
				},
				{
					"lng": 11.465252145991279,
					"lat": 43.54457370769894
				},
				{
					"lng": 11.465247611300342,
					"lat": 43.5445629515438
				},
				{
					"lng": 11.465244244877546,
					"lat": 43.54455496648402
				},
				{
					"lng": 11.46523933135377,
					"lat": 43.54454331174019
				},
				{
					"lng": 11.465069328147521,
					"lat": 43.54414006571695
				},
				{
					"lng": 11.46482644935839,
					"lat": 43.543563949122145
				},
				{
					"lng": 11.464685395741903,
					"lat": 43.54308136923158
				},
				{
					"lng": 11.464682579440197,
					"lat": 43.542691783969495
				},
				{
					"lng": 11.464678854598295,
					"lat": 43.542176486452
				},
				{
					"lng": 11.464629658168798,
					"lat": 43.54171399874866
				},
				{
					"lng": 11.464785344563879,
					"lat": 43.54141921073142
				},
				{
					"lng": 11.464902698289407,
					"lat": 43.541197002640125
				},
				{
					"lng": 11.46513671513715,
					"lat": 43.54075388908671
				},
				{
					"lng": 11.464883388528582,
					"lat": 43.540494468950314
				},
				{
					"lng": 11.464864921903274,
					"lat": 43.5402356810394
				},
				{
					"lng": 11.46484626076509,
					"lat": 43.53997416428061
				},
				{
					"lng": 11.464812617183275,
					"lat": 43.539502676334564
				},
				{
					"lng": 11.46472321838701,
					"lat": 43.53879824428038
				},
				{
					"lng": 11.464663605636018,
					"lat": 43.53848222609343
				},
				{
					"lng": 11.464607101435856,
					"lat": 43.53818268344172
				},
				{
					"lng": 11.46459721422974,
					"lat": 43.53794008525812
				},
				{
					"lng": 11.464888686940899,
					"lat": 43.537646839091664
				},
				{
					"lng": 11.465003411437413,
					"lat": 43.53741880723621
				},
				{
					"lng": 11.465225504362909,
					"lat": 43.536977359803636
				},
				{
					"lng": 11.465637331310287,
					"lat": 43.53665944127652
				},
				{
					"lng": 11.465652360602162,
					"lat": 43.5362838628533
				},
				{
					"lng": 11.46563527667172,
					"lat": 43.53586482980958
				},
				{
					"lng": 11.465465720932977,
					"lat": 43.535427012893315
				},
				{
					"lng": 11.465454932178167,
					"lat": 43.53516236037188
				},
				{
					"lng": 11.465778500505419,
					"lat": 43.53491256689414
				},
				{
					"lng": 11.465981708527194,
					"lat": 43.534687443848235
				},
				{
					"lng": 11.466030646745702,
					"lat": 43.53439942858969
				},
				{
					"lng": 11.465984146655842,
					"lat": 43.53400310411133
				},
				{
					"lng": 11.466030646745702,
					"lat": 43.53439942858969
				},
				{
					"lng": 11.465981708527194,
					"lat": 43.534687443848235
				},
				{
					"lng": 11.465778500505419,
					"lat": 43.53491256689414
				},
				{
					"lng": 11.465454932178167,
					"lat": 43.53516236037188
				},
				{
					"lng": 11.465465720932977,
					"lat": 43.535427012893315
				},
				{
					"lng": 11.46563527667172,
					"lat": 43.53586482980958
				},
				{
					"lng": 11.465652360602162,
					"lat": 43.5362838628533
				},
				{
					"lng": 11.465637331310287,
					"lat": 43.53665944127652
				},
				{
					"lng": 11.465225504362909,
					"lat": 43.536977359803636
				},
				{
					"lng": 11.465003411437413,
					"lat": 43.53741880723621
				},
				{
					"lng": 11.464888686940899,
					"lat": 43.537646839091664
				},
				{
					"lng": 11.46459721422974,
					"lat": 43.53794008525812
				},
				{
					"lng": 11.464607101435856,
					"lat": 43.53818268344172
				},
				{
					"lng": 11.464663605636018,
					"lat": 43.53848222609343
				},
				{
					"lng": 11.46472321838701,
					"lat": 43.53879824428038
				},
				{
					"lng": 11.464812617183275,
					"lat": 43.539502676334564
				},
				{
					"lng": 11.46484626076509,
					"lat": 43.53997416428061
				},
				{
					"lng": 11.464864921903274,
					"lat": 43.5402356810394
				},
				{
					"lng": 11.464883388528582,
					"lat": 43.540494468950314
				},
				{
					"lng": 11.46513671513715,
					"lat": 43.54075388908671
				},
				{
					"lng": 11.464902698289407,
					"lat": 43.541197002640125
				},
				{
					"lng": 11.464785344563879,
					"lat": 43.54141921073142
				},
				{
					"lng": 11.464629658168798,
					"lat": 43.54171399874866
				},
				{
					"lng": 11.464678854598295,
					"lat": 43.542176486452
				},
				{
					"lng": 11.464682579440197,
					"lat": 43.542691783969495
				},
				{
					"lng": 11.464685395741903,
					"lat": 43.54308136923158
				},
				{
					"lng": 11.46482644935839,
					"lat": 43.543563949122145
				},
				{
					"lng": 11.465069328147521,
					"lat": 43.54414006571695
				},
				{
					"lng": 11.46523933135377,
					"lat": 43.54454331174019
				},
				{
					"lng": 11.465244244877546,
					"lat": 43.54455496648402
				},
				{
					"lng": 11.465247611300342,
					"lat": 43.5445629515438
				},
				{
					"lng": 11.465252145991279,
					"lat": 43.54457370769894
				},
				{
					"lng": 11.465258522690599,
					"lat": 43.5445888330372
				},
				{
					"lng": 11.465263647190987,
					"lat": 43.544600988191334
				},
				{
					"lng": 11.46526906659636,
					"lat": 43.54461384284492
				},
				{
					"lng": 11.465273170283327,
					"lat": 43.54462357665312
				},
				{
					"lng": 11.46527825168868,
					"lat": 43.5446356295718
				},
				{
					"lng": 11.46528311305302,
					"lat": 43.544647160555776
				},
				{
					"lng": 11.465288289738979,
					"lat": 43.544659439466095
				}
			]
		]
	},
	"13": {
		"name": "IA02 - Borro Percussente",
		"center": {
			"lat": 43.5446,
			"lng": 11.4586
		},
		"coords": [
			[
				{
					"lng": 11.460234575404655,
					"lat": 43.54717606506883
				},
				{
					"lng": 11.460009528674686,
					"lat": 43.546940600784666
				},
				{
					"lng": 11.45995236447638,
					"lat": 43.54688079004527
				},
				{
					"lng": 11.459833272764428,
					"lat": 43.54675618423586
				},
				{
					"lng": 11.459750249122168,
					"lat": 43.54666931610401
				},
				{
					"lng": 11.459688321808613,
					"lat": 43.546604520978285
				},
				{
					"lng": 11.459566652691244,
					"lat": 43.546477216927485
				},
				{
					"lng": 11.459400253166399,
					"lat": 43.54620358463009
				},
				{
					"lng": 11.459327759391954,
					"lat": 43.546084372835665
				},
				{
					"lng": 11.459237823915716,
					"lat": 43.54593647842768
				},
				{
					"lng": 11.459155247195818,
					"lat": 43.54580068439655
				},
				{
					"lng": 11.459064082384971,
					"lat": 43.54565076678898
				},
				{
					"lng": 11.458968257667498,
					"lat": 43.54546060083566
				},
				{
					"lng": 11.45890413066254,
					"lat": 43.54533333883827
				},
				{
					"lng": 11.458825041076109,
					"lat": 43.54517638231281
				},
				{
					"lng": 11.45875450207525,
					"lat": 43.545036394002594
				},
				{
					"lng": 11.458646713734067,
					"lat": 43.54482248103581
				},
				{
					"lng": 11.458638082733906,
					"lat": 43.54461024140298
				},
				{
					"lng": 11.458631113708323,
					"lat": 43.54443886867091
				},
				{
					"lng": 11.458623563999913,
					"lat": 43.54425321487101
				},
				{
					"lng": 11.458611435582773,
					"lat": 43.54395496297385
				},
				{
					"lng": 11.458614759683051,
					"lat": 43.54375466175274
				},
				{
					"lng": 11.458617622017496,
					"lat": 43.543582185658465
				},
				{
					"lng": 11.458619280200127,
					"lat": 43.54348226847078
				},
				{
					"lng": 11.458621412152114,
					"lat": 43.543353803513035
				},
				{
					"lng": 11.45862379103487,
					"lat": 43.543210459484364
				},
				{
					"lng": 11.458565982312363,
					"lat": 43.543034797368165
				},
				{
					"lng": 11.458503311613189,
					"lat": 43.542844359992834
				},
				{
					"lng": 11.458456495383096,
					"lat": 43.54270209870689
				},
				{
					"lng": 11.458380594023579,
					"lat": 43.54247145436277
				},
				{
					"lng": 11.458197492292383,
					"lat": 43.542325052158986
				},
				{
					"lng": 11.458001087692061,
					"lat": 43.542168012268206
				},
				{
					"lng": 11.457851856401959,
					"lat": 43.542048690108736
				},
				{
					"lng": 11.45733068109841,
					"lat": 43.5418118201986
				},
				{
					"lng": 11.457851856401959,
					"lat": 43.542048690108736
				},
				{
					"lng": 11.458001087692061,
					"lat": 43.542168012268206
				},
				{
					"lng": 11.458197492292383,
					"lat": 43.542325052158986
				},
				{
					"lng": 11.458380594023579,
					"lat": 43.54247145436277
				},
				{
					"lng": 11.458456495383096,
					"lat": 43.54270209870689
				},
				{
					"lng": 11.458503311613189,
					"lat": 43.542844359992834
				},
				{
					"lng": 11.458565982312363,
					"lat": 43.543034797368165
				},
				{
					"lng": 11.45862379103487,
					"lat": 43.543210459484364
				},
				{
					"lng": 11.458621412152114,
					"lat": 43.543353803513035
				},
				{
					"lng": 11.458619280200127,
					"lat": 43.54348226847078
				},
				{
					"lng": 11.458617622017496,
					"lat": 43.543582185658465
				},
				{
					"lng": 11.458614759683051,
					"lat": 43.54375466175274
				},
				{
					"lng": 11.458611435582773,
					"lat": 43.54395496297385
				},
				{
					"lng": 11.458623563999913,
					"lat": 43.54425321487101
				},
				{
					"lng": 11.458631113708323,
					"lat": 43.54443886867091
				},
				{
					"lng": 11.458638082733906,
					"lat": 43.54461024140298
				},
				{
					"lng": 11.458646713734067,
					"lat": 43.54482248103581
				},
				{
					"lng": 11.45875450207525,
					"lat": 43.545036394002594
				},
				{
					"lng": 11.458825041076109,
					"lat": 43.54517638231281
				},
				{
					"lng": 11.45890413066254,
					"lat": 43.54533333883827
				},
				{
					"lng": 11.458968257667498,
					"lat": 43.54546060083566
				},
				{
					"lng": 11.459064082384971,
					"lat": 43.54565076678898
				},
				{
					"lng": 11.459155247195818,
					"lat": 43.54580068439655
				},
				{
					"lng": 11.459237823915716,
					"lat": 43.54593647842768
				},
				{
					"lng": 11.459327759391954,
					"lat": 43.546084372835665
				},
				{
					"lng": 11.459400253166399,
					"lat": 43.54620358463009
				},
				{
					"lng": 11.459566652691244,
					"lat": 43.546477216927485
				},
				{
					"lng": 11.459688321808613,
					"lat": 43.546604520978285
				},
				{
					"lng": 11.459750249122168,
					"lat": 43.54666931610401
				},
				{
					"lng": 11.459833272764428,
					"lat": 43.54675618423586
				},
				{
					"lng": 11.45995236447638,
					"lat": 43.54688079004527
				},
				{
					"lng": 11.460009528674686,
					"lat": 43.546940600784666
				}
			]
		]
	},
	"14": {
		"name": "IA03 - Borro Percussente",
		"center": {
			"lat": 43.5480,
			"lng": 11.4553
		},
		"coords": [
			[
				{
					"lng": 11.456369631276367,
					"lat": 43.547842739023075
				},
				{
					"lng": 11.456268403156157,
					"lat": 43.547839662337864
				},
				{
					"lng": 11.456199888734858,
					"lat": 43.547837579888004
				},
				{
					"lng": 11.456034355231008,
					"lat": 43.547832548437796
				},
				{
					"lng": 11.455873311633113,
					"lat": 43.54787547857339
				},
				{
					"lng": 11.455750405572267,
					"lat": 43.54790824201768
				},
				{
					"lng": 11.455640306844534,
					"lat": 43.54793370369457
				},
				{
					"lng": 11.455501595986059,
					"lat": 43.54796578209645
				},
				{
					"lng": 11.455336075658533,
					"lat": 43.54801283309258
				},
				{
					"lng": 11.455182504038254,
					"lat": 43.548059627107946
				},
				{
					"lng": 11.455110457217495,
					"lat": 43.548052476329666
				},
				{
					"lng": 11.455012041752843,
					"lat": 43.54798500028155
				},
				{
					"lng": 11.454868654211408,
					"lat": 43.54798808094257
				},
				{
					"lng": 11.454713670598274,
					"lat": 43.548000109365425
				},
				{
					"lng": 11.454615255649216,
					"lat": 43.54793263296223
				},
				{
					"lng": 11.454504186209771,
					"lat": 43.54784803065575
				},
				{
					"lng": 11.454406830349216,
					"lat": 43.547806627794465
				},
				{
					"lng": 11.454504186209771,
					"lat": 43.54784803065575
				},
				{
					"lng": 11.454615255649216,
					"lat": 43.54793263296223
				},
				{
					"lng": 11.454713670598274,
					"lat": 43.548000109365425
				},
				{
					"lng": 11.454868654211408,
					"lat": 43.54798808094257
				},
				{
					"lng": 11.455012041752843,
					"lat": 43.54798500028155
				},
				{
					"lng": 11.455110457217495,
					"lat": 43.548052476329666
				},
				{
					"lng": 11.455182504038254,
					"lat": 43.548059627107946
				},
				{
					"lng": 11.455336075658533,
					"lat": 43.54801283309258
				},
				{
					"lng": 11.455501595986059,
					"lat": 43.54796578209645
				},
				{
					"lng": 11.455640306844534,
					"lat": 43.54793370369457
				},
				{
					"lng": 11.455750405572267,
					"lat": 43.54790824201768
				},
				{
					"lng": 11.455873311633113,
					"lat": 43.54787547857339
				},
				{
					"lng": 11.456034355231008,
					"lat": 43.547832548437796
				},
				{
					"lng": 11.456199888734858,
					"lat": 43.547837579888004
				},
				{
					"lng": 11.456268403156157,
					"lat": 43.547839662337864
				}


			]
		]
	},
	"15": {
		"name": "IA04 - Borro Lanzi",
		"center": {
			"lat": 43.5604,
			"lng": 11.4673
		},
		"coords": [
			[
				{
					"lng": 11.46625688259621,
					"lat": 43.56103167909164
				},
				{
					"lng": 11.466383432713133,
					"lat": 43.560997937687766
				},
				{
					"lng": 11.466479554781538,
					"lat": 43.56097230903953
				},
				{
					"lng": 11.466577339932222,
					"lat": 43.56094623686592
				},
				{
					"lng": 11.46663653250633,
					"lat": 43.56093045446893
				},
				{
					"lng": 11.466738052604505,
					"lat": 43.56094919701409
				},
				{
					"lng": 11.46682041780037,
					"lat": 43.560964403123705
				},
				{
					"lng": 11.46693729616247,
					"lat": 43.56098598087395
				},
				{
					"lng": 11.46701814182086,
					"lat": 43.56095003031232
				},
				{
					"lng": 11.467100090242935,
					"lat": 43.56091358927149
				},
				{
					"lng": 11.46718109663031,
					"lat": 43.560877567037544
				},
				{
					"lng": 11.467230469907305,
					"lat": 43.560855611489
				},
				{
					"lng": 11.467257274664973,
					"lat": 43.56080234715719
				},
				{
					"lng": 11.467309353914509,
					"lat": 43.56069885904472
				},
				{
					"lng": 11.46731558762994,
					"lat": 43.560642996451605
				},
				{
					"lng": 11.467321471215001,
					"lat": 43.560590271427955
				},
				{
					"lng": 11.467327593315074,
					"lat": 43.560535408902794
				},
				{
					"lng": 11.467332960083807,
					"lat": 43.5604873151303
				},
				{
					"lng": 11.467340572559067,
					"lat": 43.56041909657302
				},
				{
					"lng": 11.467365372666606,
					"lat": 43.560380179919086
				},
				{
					"lng": 11.467399685596055,
					"lat": 43.560326335531855
				},
				{
					"lng": 11.467441530551493,
					"lat": 43.56026067163239
				},
				{
					"lng": 11.467460794942303,
					"lat": 43.56023044153285
				},
				{
					"lng": 11.46745028291507,
					"lat": 43.560176329810844
				},
				{
					"lng": 11.467439763904347,
					"lat": 43.56012218203059
				},
				{
					"lng": 11.467430963702364,
					"lat": 43.560076881925404
				},
				{
					"lng": 11.467421407249681,
					"lat": 43.56002768884092
				},
				{
					"lng": 11.467406804495019,
					"lat": 43.559952519084526
				},
				{
					"lng": 11.467422810145965,
					"lat": 43.55989929285672
				},
				{
					"lng": 11.467441027828267,
					"lat": 43.559838710488236
				},
				{
					"lng": 11.467456939447079,
					"lat": 43.55978579677185
				},
				{
					"lng": 11.46747538766838,
					"lat": 43.55972444753295
				},
				{
					"lng": 11.467494988865388,
					"lat": 43.55965926396368
				},
				{
					"lng": 11.467510900396432,
					"lat": 43.55960635024053
				},
				{
					"lng": 11.46754103221284,
					"lat": 43.55952573040537
				},
				{
					"lng": 11.467561699056494,
					"lat": 43.5594757424754
				},
				{
					"lng": 11.467583176330162,
					"lat": 43.55942379423093
				},
				{
					"lng": 11.467610732026104,
					"lat": 43.55935714364786
				},
				{
					"lng": 11.467632614449364,
					"lat": 43.559304215239464
				},
				{
					"lng": 11.467657333439217,
					"lat": 43.559244425736594
				},
				{
					"lng": 11.467674667445918,
					"lat": 43.559202498725114
				},

				{
					"lng": 11.467657333439217,
					"lat": 43.559244425736594
				},
				{
					"lng": 11.467632614449364,
					"lat": 43.559304215239464
				},
				{
					"lng": 11.467610732026104,
					"lat": 43.55935714364786
				},
				{
					"lng": 11.467583176330162,
					"lat": 43.55942379423093
				},
				{
					"lng": 11.467561699056494,
					"lat": 43.5594757424754
				},
				{
					"lng": 11.46754103221284,
					"lat": 43.55952573040537
				},
				{
					"lng": 11.467510900396432,
					"lat": 43.55960635024053
				},
				{
					"lng": 11.467494988865388,
					"lat": 43.55965926396368
				},
				{
					"lng": 11.46747538766838,
					"lat": 43.55972444753295
				},
				{
					"lng": 11.467456939447079,
					"lat": 43.55978579677185
				},
				{
					"lng": 11.467441027828267,
					"lat": 43.559838710488236
				},
				{
					"lng": 11.467422810145965,
					"lat": 43.55989929285672
				},
				{
					"lng": 11.467406804495019,
					"lat": 43.559952519084526
				},
				{
					"lng": 11.467421407249681,
					"lat": 43.56002768884092
				},
				{
					"lng": 11.467430963702364,
					"lat": 43.560076881925404
				},
				{
					"lng": 11.467439763904347,
					"lat": 43.56012218203059
				},
				{
					"lng": 11.46745028291507,
					"lat": 43.560176329810844
				},
				{
					"lng": 11.467460794942303,
					"lat": 43.56023044153285
				},
				{
					"lng": 11.467441530551493,
					"lat": 43.56026067163239
				},
				{
					"lng": 11.467399685596055,
					"lat": 43.560326335531855
				},
				{
					"lng": 11.467365372666606,
					"lat": 43.560380179919086
				},
				{
					"lng": 11.467340572559067,
					"lat": 43.56041909657302
				},
				{
					"lng": 11.467332960083807,
					"lat": 43.5604873151303
				},
				{
					"lng": 11.467327593315074,
					"lat": 43.560535408902794
				},
				{
					"lng": 11.467321471215001,
					"lat": 43.560590271427955
				},
				{
					"lng": 11.46731558762994,
					"lat": 43.560642996451605
				},
				{
					"lng": 11.467309353914509,
					"lat": 43.56069885904472
				},
				{
					"lng": 11.467257274664973,
					"lat": 43.56080234715719
				},
				{
					"lng": 11.467230469907305,
					"lat": 43.560855611489
				},
				{
					"lng": 11.46718109663031,
					"lat": 43.560877567037544
				},
				{
					"lng": 11.467100090242935,
					"lat": 43.56091358927149
				},
				{
					"lng": 11.46701814182086,
					"lat": 43.56095003031232
				},
				{
					"lng": 11.46693729616247,
					"lat": 43.56098598087395
				},
				{
					"lng": 11.46682041780037,
					"lat": 43.560964403123705
				},
				{
					"lng": 11.466738052604505,
					"lat": 43.56094919701409
				},
				{
					"lng": 11.46663653250633,
					"lat": 43.56093045446893
				},
				{
					"lng": 11.466577339932222,
					"lat": 43.56094623686592
				},
				{
					"lng": 11.466479554781538,
					"lat": 43.56097230903953
				},
				{
					"lng": 11.466383432713133,
					"lat": 43.560997937687766
				}
			]
		]
	},
	"30": {
		"name": "IA07 - Borro Carpinete",
		"center": {
			"lat": 43.5491,
			"lng": 11.4805
		},
		"coords": [
			[
				{
					"lng": 11.47075857083676,
					"lat": 43.55311221696971
				},
				{
					"lng": 11.471099332645283,
					"lat": 43.552946877324885
				},
				{
					"lng": 11.471520441842635,
					"lat": 43.55262182812505
				},
				{
					"lng": 11.471903309129138,
					"lat": 43.55242398119101
				},
				{
					"lng": 11.472290047346338,
					"lat": 43.55232083159636
				},
				{
					"lng": 11.472550454647038,
					"lat": 43.55231519685577
				},
				{
					"lng": 11.472859428896733,
					"lat": 43.55243488694492
				},
				{
					"lng": 11.47325908209162,
					"lat": 43.552647395804854
				},
				{
					"lng": 11.473698263881602,
					"lat": 43.55276426512182
				},
				{
					"lng": 11.474138739453583,
					"lat": 43.55291269884921
				},
				{
					"lng": 11.474484659753948,
					"lat": 43.55287361390117
				},
				{
					"lng": 11.47469649771483,
					"lat": 43.55274264959578
				},
				{
					"lng": 11.474896701991272,
					"lat": 43.552327589781115
				},
				{
					"lng": 11.474970578729007,
					"lat": 43.552010048359996
				},
				{
					"lng": 11.475179827360243,
					"lat": 43.551815950987354
				},
				{
					"lng": 11.47547458310467,
					"lat": 43.5515884066304
				},
				{
					"lng": 11.475765457848597,
					"lat": 43.551266163222
				},
				{
					"lng": 11.476057622597818,
					"lat": 43.55097548523786
				},
				{
					"lng": 11.476393184480466,
					"lat": 43.55068386596506
				},
				{
					"lng": 11.476556437651162,
					"lat": 43.55042757464122
				},
				{
					"lng": 11.476894581065485,
					"lat": 43.55019908619137
				},
				{
					"lng": 11.477230134655676,
					"lat": 43.54990746462428
				},
				{
					"lng": 11.477658952443175,
					"lat": 43.54977179042124
				},
				{
					"lng": 11.47800355806948,
					"lat": 43.54970112921206
				},
				{
					"lng": 11.478348162846371,
					"lat": 43.54963046698177
				},
				{
					"lng": 11.478780859255304,
					"lat": 43.54958948683256
				},
				{
					"lng": 11.479210965714028,
					"lat": 43.549485372978744
				},
				{
					"lng": 11.479596376912541,
					"lat": 43.5493506333139
				},
				{
					"lng": 11.480154086178329,
					"lat": 43.54918055847379
				},
				{
					"lng": 11.480540788533332,
					"lat": 43.54907738172785
				},
				{
					"lng": 11.48091712545861,
					"lat": 43.54872167568315
				},
				{
					"lng": 11.481206661808438,
					"lat": 43.54836785330006
				},
				{
					"lng": 11.481456684245494,
					"lat": 43.54810967071368
				},
				{
					"lng": 11.481484532992823,
					"lat": 43.54772993629616
				},
				{
					"lng": 11.481472871327497,
					"lat": 43.54744584233094
				},
				{
					"lng": 11.481074521300583,
					"lat": 43.54726492790966
				},
				{
					"lng": 11.480973476641037,
					"lat": 43.54691958640215
				},
				{
					"lng": 11.480911943845628,
					"lat": 43.54647860447015
				},
				{
					"lng": 11.480980601385395,
					"lat": 43.5460347957306
				},
				{
					"lng": 11.4809637612271,
					"lat": 43.54562443749671
				},
				{
					"lng": 11.480940444671496,
					"lat": 43.54505624911547
				},
				{
					"lng": 11.480926958726958,
					"lat": 43.54472760990607
				},
				{
					"lng": 11.480910652286285,
					"lat": 43.54433023053127
				},
				{
					"lng": 11.480934617936152,
					"lat": 43.543855797889314
				},
				{
					"lng": 11.480919074631792,
					"lat": 43.54347700551668
				},
				{
					"lng": 11.48102982868525,
					"lat": 43.54300068838721
				},
				{
					"lng": 11.48096182456236,
					"lat": 43.542401875940826
				},
				{
					"lng": 11.48098967542625,
					"lat": 43.54202214128758
				},
				{
					"lng": 11.480928149124935,
					"lat": 43.54158115890346
				},
				{
					"lng": 11.480998097816943,
					"lat": 43.54116891598841
				},
				{
					"lng": 11.480769477411686,
					"lat": 43.540889532282065
				},
				{
					"lng": 11.480494876783336,
					"lat": 43.54054795793513
				},
				{
					"lng": 11.480388669041464,
					"lat": 43.540076350942094
				},
				{
					"lng": 11.480277284114104,
					"lat": 43.539478479497525
				},
				{
					"lng": 11.480381563469246,
					"lat": 43.53884433239048
				},
				{
					"lng": 11.480497494208516,
					"lat": 43.53849427981497
				},
				{
					"lng": 11.48016915876008,
					"lat": 43.53790111757722
				},

				{
					"lng": 11.480497494208516,
					"lat": 43.53849427981497
				},
				{
					"lng": 11.480381563469246,
					"lat": 43.53884433239048
				},
				{
					"lng": 11.480277284114104,
					"lat": 43.539478479497525
				},
				{
					"lng": 11.480388669041464,
					"lat": 43.540076350942094
				},
				{
					"lng": 11.480494876783336,
					"lat": 43.54054795793513
				},
				{
					"lng": 11.480769477411686,
					"lat": 43.540889532282065
				},
				{
					"lng": 11.480998097816943,
					"lat": 43.54116891598841
				},
				{
					"lng": 11.480928149124935,
					"lat": 43.54158115890346
				},
				{
					"lng": 11.48098967542625,
					"lat": 43.54202214128758
				},
				{
					"lng": 11.48096182456236,
					"lat": 43.542401875940826
				},
				{
					"lng": 11.48102982868525,
					"lat": 43.54300068838721
				},
				{
					"lng": 11.480919074631792,
					"lat": 43.54347700551668
				},
				{
					"lng": 11.480934617936152,
					"lat": 43.543855797889314
				},
				{
					"lng": 11.480910652286285,
					"lat": 43.54433023053127
				},
				{
					"lng": 11.480926958726958,
					"lat": 43.54472760990607
				},
				{
					"lng": 11.480940444671496,
					"lat": 43.54505624911547
				},
				{
					"lng": 11.4809637612271,
					"lat": 43.54562443749671
				},
				{
					"lng": 11.480980601385395,
					"lat": 43.5460347957306
				},
				{
					"lng": 11.480911943845628,
					"lat": 43.54647860447015
				},
				{
					"lng": 11.480973476641037,
					"lat": 43.54691958640215
				},
				{
					"lng": 11.481074521300583,
					"lat": 43.54726492790966
				},
				{
					"lng": 11.481472871327497,
					"lat": 43.54744584233094
				},
				{
					"lng": 11.481484532992823,
					"lat": 43.54772993629616
				},
				{
					"lng": 11.481456684245494,
					"lat": 43.54810967071368
				},
				{
					"lng": 11.481206661808438,
					"lat": 43.54836785330006
				},
				{
					"lng": 11.48091712545861,
					"lat": 43.54872167568315
				},
				{
					"lng": 11.480540788533332,
					"lat": 43.54907738172785
				},
				{
					"lng": 11.480154086178329,
					"lat": 43.54918055847379
				},
				{
					"lng": 11.479596376912541,
					"lat": 43.5493506333139
				},
				{
					"lng": 11.479210965714028,
					"lat": 43.549485372978744
				},
				{
					"lng": 11.478780859255304,
					"lat": 43.54958948683256
				},
				{
					"lng": 11.478348162846371,
					"lat": 43.54963046698177
				},
				{
					"lng": 11.47800355806948,
					"lat": 43.54970112921206
				},
				{
					"lng": 11.477658952443175,
					"lat": 43.54977179042124
				},
				{
					"lng": 11.477230134655676,
					"lat": 43.54990746462428
				},
				{
					"lng": 11.476894581065485,
					"lat": 43.55019908619137
				},
				{
					"lng": 11.476556437651162,
					"lat": 43.55042757464122
				},
				{
					"lng": 11.476393184480466,
					"lat": 43.55068386596506
				},
				{
					"lng": 11.476057622597818,
					"lat": 43.55097548523786
				},
				{
					"lng": 11.475765457848597,
					"lat": 43.551266163222
				},
				{
					"lng": 11.47547458310467,
					"lat": 43.5515884066304
				},
				{
					"lng": 11.475179827360243,
					"lat": 43.551815950987354
				},
				{
					"lng": 11.474970578729007,
					"lat": 43.552010048359996
				},
				{
					"lng": 11.474896701991272,
					"lat": 43.552327589781115
				},
				{
					"lng": 11.47469649771483,
					"lat": 43.55274264959578
				},
				{
					"lng": 11.474484659753948,
					"lat": 43.55287361390117
				},
				{
					"lng": 11.474138739453583,
					"lat": 43.55291269884921
				},
				{
					"lng": 11.473698263881602,
					"lat": 43.55276426512182
				},
				{
					"lng": 11.47325908209162,
					"lat": 43.552647395804854
				},
				{
					"lng": 11.472859428896733,
					"lat": 43.55243488694492
				},
				{
					"lng": 11.472550454647038,
					"lat": 43.55231519685577
				},
				{
					"lng": 11.472290047346338,
					"lat": 43.55232083159636
				},
				{
					"lng": 11.471903309129138,
					"lat": 43.55242398119101
				},
				{
					"lng": 11.471520441842635,
					"lat": 43.55262182812505
				},
				{
					"lng": 11.471099332645283,
					"lat": 43.552946877324885
				}


			]
		]
	},
	"8": {
		"name": "BC - Bicchieraie",
		"center": {
			"lat": 43.5410,
			"lng": 11.4683
		},
		"coords": [
			[
				{
					"lng": 11.469732236787458,
					"lat": 43.543892680073526
				},
				{
					"lng": 11.469638709514498,
					"lat": 43.54338138980658
				},
				{
					"lng": 11.469665702901496,
					"lat": 43.54302601731576
				},
				{
					"lng": 11.469883943162769,
					"lat": 43.54277974152531
				},
				{
					"lng": 11.469916788828714,
					"lat": 43.542567667821714
				},
				{
					"lng": 11.470032886708273,
					"lat": 43.54236134314954
				},
				{
					"lng": 11.470063574910386,
					"lat": 43.542096475100756
				},
				{
					"lng": 11.470105863296032,
					"lat": 43.54186155108171
				},
				{
					"lng": 11.470314962375793,
					"lat": 43.5416456668722
				},
				{
					"lng": 11.470462160880851,
					"lat": 43.541438669352004
				},
				{
					"lng": 11.470515739675374,
					"lat": 43.54122614716869
				},
				{
					"lng": 11.470602886867532,
					"lat": 43.54107328877856
				},
				{
					"lng": 11.470835490825381,
					"lat": 43.54092483372019
				},
				{
					"lng": 11.471053830748252,
					"lat": 43.540935209479
				},
				{
					"lng": 11.471185529577882,
					"lat": 43.54085687420536
				},
				{
					"lng": 11.471205381415205,
					"lat": 43.54054637029888
				},
				{
					"lng": 11.471390809190122,
					"lat": 43.54029383015081
				},
				{
					"lng": 11.471625257934951,
					"lat": 43.54019062581262
				},
				{
					"lng": 11.472112229195744,
					"lat": 43.540172542308994
				},
				{
					"lng": 11.472467196246452,
					"lat": 43.540225251535134
				},
				{
					"lng": 11.472674549289568,
					"lat": 43.54022076452747
				},
				{
					"lng": 11.472706767308841,
					"lat": 43.53999360614046
				},
				{
					"lng": 11.472647409136966,
					"lat": 43.53955706571836
				},
				{
					"lng": 11.472528005886216,
					"lat": 43.539174665517955
				},
				{
					"lng": 11.472359542462305,
					"lat": 43.53886126508607
				},
				{
					"lng": 11.47205106361159,
					"lat": 43.538422565654336
				},
				{
					"lng": 11.471668168818354,
					"lat": 43.53794018285068
				},
				{
					"lng": 11.471312178968365,
					"lat": 43.53760819098765
				},
				{
					"lng": 11.471021169624551,
					"lat": 43.537342731137215
				},
				{
					"lng": 11.470601244548655,
					"lat": 43.537223483510125
				},
				{
					"lng": 11.470071287320673,
					"lat": 43.537204746224916
				},
				{
					"lng": 11.46967733536109,
					"lat": 43.53721326178068
				},
				{
					"lng": 11.46937360797542,
					"lat": 43.53714433903999
				},
				{
					"lng": 11.469025333415399,
					"lat": 43.53700089098344
				},
				{
					"lng": 11.46818539814095,
					"lat": 43.53650572511756
				},
				{
					"lng": 11.467556103943728,
					"lat": 43.536139931162886
				},
				{
					"lng": 11.467116787777083,
					"lat": 43.53600039324868
				},
				{
					"lng": 11.466425094129004,
					"lat": 43.53557750055543
				},
				{
					"lng": 11.465905429848958,
					"lat": 43.535301865467744
				},
				{
					"lng": 11.46544950846207,
					"lat": 43.53506259620396
				},
				{
					"lng": 11.465153396317604,
					"lat": 43.53492555943707
				},
				{
					"lng": 11.46483141061908,
					"lat": 43.53491740816247
				},
				{
					"lng": 11.464478939226733,
					"lat": 43.53492501093719
				},
				{
					"lng": 11.464159719218129,
					"lat": 43.53498473654009
				},
				{
					"lng": 11.463946010502351,
					"lat": 43.535087478369014
				},
				{
					"lng": 11.463785057105554,
					"lat": 43.53521172842553
				},
				{
					"lng": 11.463667414032876,
					"lat": 43.53538033671849
				},
				{
					"lng": 11.463540939535797,
					"lat": 43.535586878861714
				},
				{
					"lng": 11.463390965369452,
					"lat": 43.53572598907051
				},
				{
					"lng": 11.46312326760613,
					"lat": 43.53577705229399
				},
				{
					"lng": 11.462700986102547,
					"lat": 43.53585409284948
				},
				{
					"lng": 11.462454942391844,
					"lat": 43.535927333938886
				},
				{
					"lng": 11.46237753399129,
					"lat": 43.536064878953056
				},
				{
					"lng": 11.462374537087166,
					"lat": 43.53624611264976
				},
				{
					"lng": 11.462379757626993,
					"lat": 43.53637432826633
				},
				{
					"lng": 11.462439270475404,
					"lat": 43.536561763565416
				},
				{
					"lng": 11.462579338810773,
					"lat": 43.53694372926037
				},
				{
					"lng": 11.46262211120584,
					"lat": 43.53722965848609
				},
				{
					"lng": 11.462504637519949,
					"lat": 43.53746152451512
				},
				{
					"lng": 11.462269159155296,
					"lat": 43.53773547979353
				},
				{
					"lng": 11.462069796775035,
					"lat": 43.53793604219384
				},
				{
					"lng": 11.461899385867303,
					"lat": 43.538083139484456
				},
				{
					"lng": 11.461761304458387,
					"lat": 43.53825973483974
				},
				{
					"lng": 11.461667455209355,
					"lat": 43.53850331549973
				},
				{
					"lng": 11.461665070439441,
					"lat": 43.538699633353225
				},
				{
					"lng": 11.46179777034837,
					"lat": 43.5389005895906
				},
				{
					"lng": 11.461968870640549,
					"lat": 43.53902523117737
				},
				{
					"lng": 11.462142735466166,
					"lat": 43.53921775132218
				},
				{
					"lng": 11.46213059890808,
					"lat": 43.539429376712576
				},
				{
					"lng": 11.462133743472698,
					"lat": 43.53976145216811
				},
				{
					"lng": 11.462157930680798,
					"lat": 43.54010062288717
				},
				{
					"lng": 11.462154393114487,
					"lat": 43.54052342679916
				},
				{
					"lng": 11.462140561707836,
					"lat": 43.54120310856456
				},
				{
					"lng": 11.462122356712802,
					"lat": 43.54152054656178
				},
				{
					"lng": 11.462133105798536,
					"lat": 43.54178451969248
				},
				{
					"lng": 11.462172195032052,
					"lat": 43.54197994376941
				},
				{
					"lng": 11.462264046301113,
					"lat": 43.54219687697845
				},
				{
					"lng": 11.462429703660536,
					"lat": 43.54244241438333
				},
				{
					"lng": 11.46268683258346,
					"lat": 43.54264068785606
				},
				{
					"lng": 11.462849113514414,
					"lat": 43.542803261638795
				},
				{
					"lng": 11.46293758901989,
					"lat": 43.542937231273086
				},
				{
					"lng": 11.462997110966231,
					"lat": 43.54312466588997
				},
				{
					"lng": 11.463016696509523,
					"lat": 43.54335070486567
				},
				{
					"lng": 11.463247177401273,
					"lat": 43.5431494700873
				},
				{
					"lng": 11.46353041963374,
					"lat": 43.542969743417295
				},
				{
					"lng": 11.463826794402873,
					"lat": 43.54285767121723
				},
				{
					"lng": 11.46410243174634,
					"lat": 43.54274604545981
				},
				{
					"lng": 11.464403108066449,
					"lat": 43.54273956087576
				},
				{
					"lng": 11.464711385378113,
					"lat": 43.542664973193475
				},
				{
					"lng": 11.464947392552816,
					"lat": 43.54259949247256
				},
				{
					"lng": 11.465320952284044,
					"lat": 43.54259898185882
				},
				{
					"lng": 11.465746660095144,
					"lat": 43.54260489339689
				},
				{
					"lng": 11.466346164572307,
					"lat": 43.542546662438305
				},
				{
					"lng": 11.466769410303217,
					"lat": 43.54249223366622
				},
				{
					"lng": 11.467213391350363,
					"lat": 43.5424373555983
				},
				{
					"lng": 11.467566213583751,
					"lat": 43.54243728541106
				},
				{
					"lng": 11.467898915320125,
					"lat": 43.54245274611854
				},
				{
					"lng": 11.468243524693772,
					"lat": 43.54250569215445
				},
				{
					"lng": 11.468624473800354,
					"lat": 43.54268618000725
				},
				{
					"lng": 11.468882547403322,
					"lat": 43.54290706516362
				},
				{
					"lng": 11.46911475443914,
					"lat": 43.543256836644986
				},
				{
					"lng": 11.469441510741222,
					"lat": 43.54363475906722
				},
				{
					"lng": 11.469732236787458,
					"lat": 43.543892680073526
				}
			]
		]
	},
	"9": {
		"name": "VN - Vincesimo",
		"center": {
			"lat": 43.5913,
			"lng": 11.4815
		},
		"coords": [
			[
				{
					"lng": 11.473367354895759,
					"lat": 43.5881347753109
				},
				{
					"lng": 11.473570837350264,
					"lat": 43.58828678460364
				},
				{
					"lng": 11.473188492104013,
					"lat": 43.58847428485468
				},
				{
					"lng": 11.472925427347407,
					"lat": 43.588509306856324
				},
				{
					"lng": 11.472530119381574,
					"lat": 43.58859932889052
				},
				{
					"lng": 11.472521348033782,
					"lat": 43.58871356970167
				},
				{
					"lng": 11.472594192526504,
					"lat": 43.588959649531255
				},
				{
					"lng": 11.472938930220135,
					"lat": 43.58916725858584
				},
				{
					"lng": 11.473089545864902,
					"lat": 43.58923242941765
				},
				{
					"lng": 11.473125889760146,
					"lat": 43.589463004549835
				},
				{
					"lng": 11.473025593335068,
					"lat": 43.58964114042462
				},
				{
					"lng": 11.473021967727924,
					"lat": 43.589771563734395
				},
				{
					"lng": 11.473020080012436,
					"lat": 43.589944313458766
				},
				{
					"lng": 11.473037840968741,
					"lat": 43.59015899696571
				},
				{
					"lng": 11.473256846970123,
					"lat": 43.59025201505613
				},
				{
					"lng": 11.47330489794947,
					"lat": 43.59043997538561
				},
				{
					"lng": 11.473124183887911,
					"lat": 43.59051557640767
				},
				{
					"lng": 11.472890995521562,
					"lat": 43.59051410679057
				},
				{
					"lng": 11.472611014958902,
					"lat": 43.59046476943794
				},
				{
					"lng": 11.472437523697753,
					"lat": 43.590497851777634
				},
				{
					"lng": 11.472333086627776,
					"lat": 43.59057505910632
				},
				{
					"lng": 11.472227507361994,
					"lat": 43.590733758145745
				},
				{
					"lng": 11.472195139315517,
					"lat": 43.59081918384105
				},
				{
					"lng": 11.472599948649542,
					"lat": 43.591115509929466
				},
				{
					"lng": 11.472775936314981,
					"lat": 43.59120742475029
				},
				{
					"lng": 11.472722960387449,
					"lat": 43.591446450058285
				},
				{
					"lng": 11.472392158218693,
					"lat": 43.59146990340316
				},
				{
					"lng": 11.471854637697556,
					"lat": 43.591481533920685
				},
				{
					"lng": 11.471326822216605,
					"lat": 43.59140171023239
				},
				{
					"lng": 11.47086814520855,
					"lat": 43.5912584744473
				},
				{
					"lng": 11.470098900833724,
					"lat": 43.59130443563872
				},
				{
					"lng": 11.469763583558919,
					"lat": 43.59154630513139
				},
				{
					"lng": 11.469798238552176,
					"lat": 43.59184535088108
				},
				{
					"lng": 11.469963592524229,
					"lat": 43.592161121602246
				},
				{
					"lng": 11.470148302865377,
					"lat": 43.59273064507594
				},
				{
					"lng": 11.470408743730976,
					"lat": 43.59295963453359
				},
				{
					"lng": 11.47060301068234,
					"lat": 43.59310533126329
				},
				{
					"lng": 11.470839193548805,
					"lat": 43.593289224233246
				},
				{
					"lng": 11.471136092432648,
					"lat": 43.59342292305252
				},
				{
					"lng": 11.471518100783584,
					"lat": 43.59355478002782
				},
				{
					"lng": 11.471741329421564,
					"lat": 43.59364119262375
				},
				{
					"lng": 11.472228293215576,
					"lat": 43.59392719146933
				},
				{
					"lng": 11.472600532560692,
					"lat": 43.59413841264836
				},
				{
					"lng": 11.47309125460795,
					"lat": 43.59441686071365
				},
				{
					"lng": 11.473471366348747,
					"lat": 43.59417401177682
				},
				{
					"lng": 11.473623405158177,
					"lat": 43.594164203158954
				},
				{
					"lng": 11.474088333110828,
					"lat": 43.59436954642405
				},
				{
					"lng": 11.474522825951446,
					"lat": 43.59455857003532
				},
				{
					"lng": 11.475084030982991,
					"lat": 43.594686535946174
				},
				{
					"lng": 11.475668777996843,
					"lat": 43.594732520838654
				},
				{
					"lng": 11.476519156129172,
					"lat": 43.59480533291722
				},
				{
					"lng": 11.477415535095375,
					"lat": 43.59490646900883
				},
				{
					"lng": 11.477996143805049,
					"lat": 43.59463318827519
				},
				{
					"lng": 11.47881737180437,
					"lat": 43.5942145638627
				},
				{
					"lng": 11.479510020899141,
					"lat": 43.59383130844778
				},
				{
					"lng": 11.479880677995574,
					"lat": 43.59368640207323
				},
				{
					"lng": 11.480735185982953,
					"lat": 43.59364178182933
				},
				{
					"lng": 11.481215230584532,
					"lat": 43.59375844416255
				},
				{
					"lng": 11.481636372498789,
					"lat": 43.593860091702226
				},
				{
					"lng": 11.48221369017752,
					"lat": 43.59383451481725
				},
				{
					"lng": 11.482614297851594,
					"lat": 43.593763896709284
				},
				{
					"lng": 11.482798283150796,
					"lat": 43.59365888178813
				},
				{
					"lng": 11.483043240209966,
					"lat": 43.59351017968224
				},
				{
					"lng": 11.483283923724947,
					"lat": 43.593475620805116
				},
				{
					"lng": 11.483437505100133,
					"lat": 43.593612402494486
				},
				{
					"lng": 11.483872089862126,
					"lat": 43.5937137495756
				},
				{
					"lng": 11.484091774398788,
					"lat": 43.593604696035285
				},
				{
					"lng": 11.48443462625441,
					"lat": 43.593655896769285
				},
				{
					"lng": 11.484711816112458,
					"lat": 43.5936368348771
				},
				{
					"lng": 11.484854330969897,
					"lat": 43.59339585518716
				},
				{
					"lng": 11.484850022489518,
					"lat": 43.59307334671261
				},
				{
					"lng": 11.484886234644978,
					"lat": 43.59286400670976
				},
				{
					"lng": 11.485030973758658,
					"lat": 43.5927859108113
				},
				{
					"lng": 11.485275729750244,
					"lat": 43.592741483951656
				},
				{
					"lng": 11.485533925532108,
					"lat": 43.59269676198871
				},
				{
					"lng": 11.485855556414435,
					"lat": 43.592559421966506
				},
				{
					"lng": 11.48618657686441,
					"lat": 43.59241197282025
				},
				{
					"lng": 11.486493933023649,
					"lat": 43.59227506316918
				},
				{
					"lng": 11.486826879872439,
					"lat": 43.59213227294206
				},
				{
					"lng": 11.487062244057727,
					"lat": 43.59203133181031
				},
				{
					"lng": 11.48762526576829,
					"lat": 43.5917681601733
				},
				{
					"lng": 11.487729061158086,
					"lat": 43.59156712458711
				},
				{
					"lng": 11.487780047542056,
					"lat": 43.591390049642804
				},
				{
					"lng": 11.487801688687359,
					"lat": 43.591262491904445
				},
				{
					"lng": 11.487842992062484,
					"lat": 43.591176867269745
				},
				{
					"lng": 11.487977504123842,
					"lat": 43.59117719694693
				},
				{
					"lng": 11.48802130706193,
					"lat": 43.59126096778072
				},
				{
					"lng": 11.488066049515908,
					"lat": 43.59136752732367
				},
				{
					"lng": 11.488083781104285,
					"lat": 43.591471418500625
				},
				{
					"lng": 11.48809443334889,
					"lat": 43.59162108221506
				},
				{
					"lng": 11.488266073491689,
					"lat": 43.591760724571635
				},
				{
					"lng": 11.488459622693862,
					"lat": 43.59177931831901
				},
				{
					"lng": 11.488685078039431,
					"lat": 43.59178376397698
				},
				{
					"lng": 11.489050059223127,
					"lat": 43.59178600884124
				},
				{
					"lng": 11.4892846946717,
					"lat": 43.591749562318604
				},
				{
					"lng": 11.489561310150412,
					"lat": 43.59164126680569
				},
				{
					"lng": 11.48970308251427,
					"lat": 43.59149153836291
				},
				{
					"lng": 11.489833116462714,
					"lat": 43.59149196343508
				},
				{
					"lng": 11.490051526706736,
					"lat": 43.59146113610602
				},
				{
					"lng": 11.490237909409856,
					"lat": 43.59141471039568
				},
				{
					"lng": 11.490386759391157,
					"lat": 43.59121920681948
				},
				{
					"lng": 11.490445886756653,
					"lat": 43.59102240062618
				},
				{
					"lng": 11.490570949174279,
					"lat": 43.59090236536279
				},
				{
					"lng": 11.490953521500968,
					"lat": 43.59072131905398
				},
				{
					"lng": 11.491162612227347,
					"lat": 43.590573379293424
				},
				{
					"lng": 11.491254703978557,
					"lat": 43.590414957488555
				},
				{
					"lng": 11.49135956304874,
					"lat": 43.59023996445688
				},
				{
					"lng": 11.491365340875502,
					"lat": 43.5900540962995
				},
				{
					"lng": 11.49137409823992,
					"lat": 43.58985447028797
				},
				{
					"lng": 11.491310577195296,
					"lat": 43.58972221617909
				},
				{
					"lng": 11.491086590038737,
					"lat": 43.589398637014135
				},
				{
					"lng": 11.490961563812855,
					"lat": 43.58923747372145
				},
				{
					"lng": 11.490738717953848,
					"lat": 43.58899615370002
				},
				{
					"lng": 11.490583161415698,
					"lat": 43.588978443015286
				},
				{
					"lng": 11.490343489690257,
					"lat": 43.589032904479524
				},
				{
					"lng": 11.490218964576936,
					"lat": 43.58906375181015
				},
				{
					"lng": 11.490058088471619,
					"lat": 43.589151662471494
				},
				{
					"lng": 11.489895181982943,
					"lat": 43.58919038005067
				},
				{
					"lng": 11.48967426635343,
					"lat": 43.58923036314249
				},
				{
					"lng": 11.489486516937962,
					"lat": 43.58913598278858
				},
				{
					"lng": 11.489402217552678,
					"lat": 43.58896901309687
				},
				{
					"lng": 11.489388763134375,
					"lat": 43.58878926092542
				},
				{
					"lng": 11.48938066761683,
					"lat": 43.588681103446476
				},
				{
					"lng": 11.48935998660335,
					"lat": 43.5884142760735
				},
				{
					"lng": 11.489302085275272,
					"lat": 43.588183426886275
				},
				{
					"lng": 11.489251352873081,
					"lat": 43.58800013086246
				},
				{
					"lng": 11.489182454531894,
					"lat": 43.58777179354092
				},
				{
					"lng": 11.489002360096164,
					"lat": 43.58758001550693
				},
				{
					"lng": 11.488757238534452,
					"lat": 43.587407530213675
				},
				{
					"lng": 11.488455220689318,
					"lat": 43.58735783798235
				},
				{
					"lng": 11.488306041618882,
					"lat": 43.58749472634479
				},
				{
					"lng": 11.48814690460652,
					"lat": 43.587624798911065
				},
				{
					"lng": 11.487941743143773,
					"lat": 43.587812140864756
				},
				{
					"lng": 11.487810736559574,
					"lat": 43.58792049916379
				},
				{
					"lng": 11.487698779043487,
					"lat": 43.588021406236926
				},
				{
					"lng": 11.48753789879324,
					"lat": 43.58810931345015
				},
				{
					"lng": 11.487239642429921,
					"lat": 43.58815097404077
				},
				{
					"lng": 11.486975137142071,
					"lat": 43.58807232756953
				},
				{
					"lng": 11.486922746058525,
					"lat": 43.58797499868524
				},
				{
					"lng": 11.487043039021243,
					"lat": 43.58760663014372
				},
				{
					"lng": 11.486985147419034,
					"lat": 43.58737577952034
				},
				{
					"lng": 11.486872722493114,
					"lat": 43.587230521895165
				},
				{
					"lng": 11.486615572872914,
					"lat": 43.58709544597565
				},
				{
					"lng": 11.486311821566169,
					"lat": 43.587003584971455
				},
				{
					"lng": 11.486056697708268,
					"lat": 43.586917700276636
				},
				{
					"lng": 11.4858012881439,
					"lat": 43.58682478601476
				},
				{
					"lng": 11.485564054842369,
					"lat": 43.586703342058826
				},
				{
					"lng": 11.485524348373987,
					"lat": 43.58644396188305
				},
				{
					"lng": 11.48544237839965,
					"lat": 43.58633320533995
				},
				{
					"lng": 11.485169947903522,
					"lat": 43.58629693061447
				},
				{
					"lng": 11.484810801862523,
					"lat": 43.58626957255473
				},
				{
					"lng": 11.484507346597978,
					"lat": 43.586184736042135
				},
				{
					"lng": 11.484309078764836,
					"lat": 43.586069474030495
				},
				{
					"lng": 11.4840592125831,
					"lat": 43.58593821267911
				},
				{
					"lng": 11.483808459314169,
					"lat": 43.58577510006365
				},
				{
					"lng": 11.483623225195284,
					"lat": 43.58562719914554
				},
				{
					"lng": 11.483379011144105,
					"lat": 43.58545558169265
				},
				{
					"lng": 11.4831195199779,
					"lat": 43.585275482313335
				},
				{
					"lng": 11.482819717368697,
					"lat": 43.585070203573835
				},
				{
					"lng": 11.482706941509669,
					"lat": 43.58499298389989
				},
				{
					"lng": 11.482391847120548,
					"lat": 43.5848274471433
				},
				{
					"lng": 11.482192678461708,
					"lat": 43.584722811739844
				},
				{
					"lng": 11.482008686571596,
					"lat": 43.58464790396629
				},
				{
					"lng": 11.481700644588452,
					"lat": 43.584522491149926
				},
				{
					"lng": 11.481567140771794,
					"lat": 43.58447626537924
				},
				{
					"lng": 11.48133746594746,
					"lat": 43.584396739805015
				},
				{
					"lng": 11.48101526713786,
					"lat": 43.58432636869726
				},
				{
					"lng": 11.480795231000462,
					"lat": 43.584387415096145
				},
				{
					"lng": 11.480576924540443,
					"lat": 43.58449062490877
				},
				{
					"lng": 11.480367418474499,
					"lat": 43.58457254365719
				},
				{
					"lng": 11.480185760373624,
					"lat": 43.584625724346346
				},
				{
					"lng": 11.48002026093283,
					"lat": 43.58460118148916
				},
				{
					"lng": 11.479803609955153,
					"lat": 43.584719071924994
				},
				{
					"lng": 11.479358906066699,
					"lat": 43.58496105446059
				},
				{
					"lng": 11.478957294264553,
					"lat": 43.585179585630215
				},
				{
					"lng": 11.478517478791382,
					"lat": 43.58541890138491
				},
				{
					"lng": 11.478108804422378,
					"lat": 43.58562521490457
				},
				{
					"lng": 11.47749273962571,
					"lat": 43.585936221222305
				},
				{
					"lng": 11.476880732531953,
					"lat": 43.586245172733165
				},
				{
					"lng": 11.476190086351282,
					"lat": 43.58661274099669
				},
				{
					"lng": 11.475706609394146,
					"lat": 43.586883869463676
				},
				{
					"lng": 11.475188422542812,
					"lat": 43.58717445795286
				},
				{
					"lng": 11.474529940375184,
					"lat": 43.58753669125423
				},
				{
					"lng": 11.4738775116036,
					"lat": 43.58787233159491
				},
				{
					"lng": 11.473367354895759,
					"lat": 43.5881347753109
				}
			]
		]
	},
	"10": {
		"name": "MO - Morbuio",
		"center": {
			"lat": 43.5865,
			"lng": 11.4713
		},
		"coords": [
			[
				{
					"lng": 11.473367354895759,
					"lat": 43.5881347753109
				},
				{
					"lng": 11.474681586635969,
					"lat": 43.587458676164275
				},
				{
					"lng": 11.47652808927695,
					"lat": 43.58642319011837
				},
				{
					"lng": 11.478517478791382,
					"lat": 43.58541890138491
				},
				{
					"lng": 11.48002026093283,
					"lat": 43.58460118148916
				},
				{
					"lng": 11.479702965728242,
					"lat": 43.58417901536794
				},
				{
					"lng": 11.479386685193024,
					"lat": 43.58354581712289
				},
				{
					"lng": 11.479242975167995,
					"lat": 43.58287370663936
				},
				{
					"lng": 11.479141689441402,
					"lat": 43.582292110648005
				},
				{
					"lng": 11.47882340082598,
					"lat": 43.5820809732468
				},
				{
					"lng": 11.478476545082598,
					"lat": 43.5821166333812
				},
				{
					"lng": 11.478057254087991,
					"lat": 43.58227343529133
				},
				{
					"lng": 11.477309724352802,
					"lat": 43.5822122756859
				},
				{
					"lng": 11.47677675376013,
					"lat": 43.58195655220968
				},
				{
					"lng": 11.476602324941577,
					"lat": 43.581714156749975
				},
				{
					"lng": 11.47695250720374,
					"lat": 43.58152368893152
				},
				{
					"lng": 11.47728738741912,
					"lat": 43.58143202673564
				},
				{
					"lng": 11.477723122264532,
					"lat": 43.581204534802346
				},
				{
					"lng": 11.477537009101082,
					"lat": 43.58091315695128
				},
				{
					"lng": 11.477221905556094,
					"lat": 43.58077931631184
				},
				{
					"lng": 11.47692642492018,
					"lat": 43.58065208296184
				},
				{
					"lng": 11.476765283155535,
					"lat": 43.58026169247258
				},
				{
					"lng": 11.476679878988703,
					"lat": 43.5800665999799
				},
				{
					"lng": 11.476093539761429,
					"lat": 43.57992456992014
				},
				{
					"lng": 11.475686675995467,
					"lat": 43.5799122853765
				},
				{
					"lng": 11.475104949867292,
					"lat": 43.579882685209334
				},
				{
					"lng": 11.474873527811688,
					"lat": 43.57990176597929
				},
				{
					"lng": 11.47427851470198,
					"lat": 43.580020159351236
				},
				{
					"lng": 11.474070166495359,
					"lat": 43.58013017468464
				},
				{
					"lng": 11.473740759050253,
					"lat": 43.58035535065732
				},
				{
					"lng": 11.473512211104376,
					"lat": 43.580444702702955
				},
				{
					"lng": 11.47300361764224,
					"lat": 43.58054715025098
				},
				{
					"lng": 11.472559520492984,
					"lat": 43.58057082777087
				},
				{
					"lng": 11.472162031496978,
					"lat": 43.580551295318415
				},
				{
					"lng": 11.471871743424785,
					"lat": 43.58055054242937
				},
				{
					"lng": 11.471331265914515,
					"lat": 43.58058333551545
				},
				{
					"lng": 11.470969392877725,
					"lat": 43.58072480177278
				},
				{
					"lng": 11.470656141399798,
					"lat": 43.58087224686866
				},
				{
					"lng": 11.470661604891522,
					"lat": 43.581005769878054
				},
				{
					"lng": 11.47063127527376,
					"lat": 43.58121040148927
				},
				{
					"lng": 11.470440525322356,
					"lat": 43.58127782877969
				},
				{
					"lng": 11.470040839697424,
					"lat": 43.581441210941904
				},
				{
					"lng": 11.469851238129397,
					"lat": 43.58153674615585
				},
				{
					"lng": 11.469709396845401,
					"lat": 43.58161718264296
				},
				{
					"lng": 11.469625268855014,
					"lat": 43.58168933736843
				},
				{
					"lng": 11.469517025511337,
					"lat": 43.581881585069446
				},
				{
					"lng": 11.4693911706794,
					"lat": 43.5821164163756
				},
				{
					"lng": 11.469225211535239,
					"lat": 43.58231694476373
				},
				{
					"lng": 11.468821311373192,
					"lat": 43.58261405321883
				},
				{
					"lng": 11.46841998920132,
					"lat": 43.58297440667363
				},
				{
					"lng": 11.468109015007542,
					"lat": 43.58317806687656
				},
				{
					"lng": 11.467636281561735,
					"lat": 43.5834485221072
				},
				{
					"lng": 11.467198193002499,
					"lat": 43.58361975729167
				},
				{
					"lng": 11.466956796855115,
					"lat": 43.583632003842744
				},
				{
					"lng": 11.466511908598992,
					"lat": 43.58387371780898
				},
				{
					"lng": 11.466226194737782,
					"lat": 43.58398539115649
				},
				{
					"lng": 11.46598910460006,
					"lat": 43.584103046258285
				},
				{
					"lng": 11.465741195239211,
					"lat": 43.58419280118113
				},
				{
					"lng": 11.465185651635288,
					"lat": 43.584331394455866
				},
				{
					"lng": 11.464943967376703,
					"lat": 43.58433660885212
				},
				{
					"lng": 11.464401530830497,
					"lat": 43.58455931947061
				},
				{
					"lng": 11.464021142088045,
					"lat": 43.584722264332285
				},
				{
					"lng": 11.463601219795466,
					"lat": 43.58486495911581
				},
				{
					"lng": 11.463304967193983,
					"lat": 43.58495575058926
				},
				{
					"lng": 11.462847519209365,
					"lat": 43.585127387019774
				},
				{
					"lng": 11.462544466064939,
					"lat": 43.585288657704574
				},
				{
					"lng": 11.462352547315538,
					"lat": 43.58532796294902
				},
				{
					"lng": 11.462065669097036,
					"lat": 43.58541151560657
				},
				{
					"lng": 11.461850193341167,
					"lat": 43.58558496544701
				},
				{
					"lng": 11.461616237162575,
					"lat": 43.585779915947406
				},
				{
					"lng": 11.461449096031059,
					"lat": 43.58595232364373
				},
				{
					"lng": 11.461369249906493,
					"lat": 43.58612988575455
				},
				{
					"lng": 11.461184776545492,
					"lat": 43.58635190142362
				},
				{
					"lng": 11.461006819062037,
					"lat": 43.58649640773863
				},
				{
					"lng": 11.460889158048197,
					"lat": 43.58669588582529
				},
				{
					"lng": 11.461108153673258,
					"lat": 43.586845907223804
				},
				{
					"lng": 11.461431778201861,
					"lat": 43.586951475513175
				},
				{
					"lng": 11.46172811837019,
					"lat": 43.5870998310614
				},
				{
					"lng": 11.461952773762178,
					"lat": 43.58715125948248
				},
				{
					"lng": 11.462239161719165,
					"lat": 43.5872927945774
				},
				{
					"lng": 11.462606046982518,
					"lat": 43.58750996263956
				},
				{
					"lng": 11.46279604477581,
					"lat": 43.587660607972865
				},
				{
					"lng": 11.462945077416556,
					"lat": 43.587755865338515
				},
				{
					"lng": 11.463406930289425,
					"lat": 43.587928784363264
				},
				{
					"lng": 11.463606024182289,
					"lat": 43.5880651645297
				},
				{
					"lng": 11.463855183398229,
					"lat": 43.58824266610258
				},
				{
					"lng": 11.463968416571854,
					"lat": 43.588409032522826
				},
				{
					"lng": 11.464042116289985,
					"lat": 43.58855514963212
				},
				{
					"lng": 11.464236137989127,
					"lat": 43.5888041756607
				},
				{
					"lng": 11.464291651859513,
					"lat": 43.58897882019042
				},
				{
					"lng": 11.464308492903479,
					"lat": 43.589154297171696
				},
				{
					"lng": 11.464363144370738,
					"lat": 43.589307859014326
				},
				{
					"lng": 11.464883882770401,
					"lat": 43.58950060144692
				},
				{
					"lng": 11.465275204089693,
					"lat": 43.58960469605
				},
				{
					"lng": 11.465973613522083,
					"lat": 43.58964589320605
				},
				{
					"lng": 11.466448506819884,
					"lat": 43.58966377776479
				},
				{
					"lng": 11.466825120788933,
					"lat": 43.58963506229705
				},
				{
					"lng": 11.467427282532821,
					"lat": 43.58923102437733
				},
				{
					"lng": 11.467780206558709,
					"lat": 43.589200591183804
				},
				{
					"lng": 11.468276377485886,
					"lat": 43.58927459800133
				},
				{
					"lng": 11.468914684743144,
					"lat": 43.589316201797345
				},
				{
					"lng": 11.469171730712741,
					"lat": 43.58935301045662
				},
				{
					"lng": 11.469352229940853,
					"lat": 43.58938169609827
				},
				{
					"lng": 11.469695263853389,
					"lat": 43.589328659328935
				},
				{
					"lng": 11.469972306209376,
					"lat": 43.589306378233154
				},
				{
					"lng": 11.47050501115603,
					"lat": 43.58917754988738
				},
				{
					"lng": 11.470997186435897,
					"lat": 43.58915387248802
				},
				{
					"lng": 11.471245302427258,
					"lat": 43.58897254119499
				},
				{
					"lng": 11.471587939639138,
					"lat": 43.588759113301826
				},
				{
					"lng": 11.472036561663478,
					"lat": 43.588479663952995
				},
				{
					"lng": 11.47226768711097,
					"lat": 43.58832150725761
				},
				{
					"lng": 11.472383156623135,
					"lat": 43.58818540497622
				},
				{
					"lng": 11.472571622435934,
					"lat": 43.58808030950417
				},
				{
					"lng": 11.472769578802946,
					"lat": 43.58798804176063
				},
				{
					"lng": 11.473367354895759,
					"lat": 43.5881347753109
				}
			]
		]
	},
	"32": {
		"name": "MC01 - MC01",
		"center": {
			"lat": 43.595940,
			"lng": 11.476665
		},
		"coords": [
			[
				{
					"lat": 43.59516887962269,
					"lng": 11.475787780581937
				},
				{
					"lat": 43.59514782105196,
					"lng": 11.475882852193996
				},
				{
					"lat": 43.5952415969762,
					"lng": 11.476212141316656
				},
				{
					"lat": 43.59522925762322,
					"lng": 11.476668190104359
				},
				{
					"lat": 43.59515820470236,
					"lng": 11.477005756858897
				},
				{
					"lat": 43.59502530984878,
					"lng": 11.47736462309947
				},
				{
					"lat": 43.59503051885819,
					"lng": 11.477431321561912
				},
				{
					"lat": 43.59508013573516,
					"lng": 11.477471640044321
				},
				{
					"lat": 43.59509441990493,
					"lng": 11.477493846043343
				},
				{
					"lat": 43.59509113309604,
					"lng": 11.477521808313176
				},
				{
					"lat": 43.59507105063471,
					"lng": 11.477574181058198
				},
				{
					"lat": 43.59504668097881,
					"lng": 11.477633429493075
				},
				{
					"lat": 43.594936487523235,
					"lng": 11.477839924161122
				},
				{
					"lat": 43.59487434047381,
					"lng": 11.47820964270699
				},
				{
					"lat": 43.59484618734489,
					"lng": 11.478245548483626
				},
				{
					"lat": 43.59473988128771,
					"lng": 11.478381307016615
				},
				{
					"lat": 43.594631901964235,
					"lng": 11.478523727498334
				},
				{
					"lat": 43.59459344051968,
					"lng": 11.478591902049313
				},
				{
					"lat": 43.59459344051966,
					"lng": 11.478591902049303
				},
				{
					"lat": 43.59453969148189,
					"lng": 11.478687174249076
				},
				{
					"lat": 43.59448340138632,
					"lng": 11.478701213906207
				},
				{
					"lat": 43.594374616151015,
					"lng": 11.47870886623576
				},
				{
					"lat": 43.59428553719717,
					"lng": 11.478678696825552
				},
				{
					"lat": 43.59423241165962,
					"lng": 11.478642934165752
				},
				{
					"lat": 43.59418616583335,
					"lng": 11.478593135320315
				},
				{
					"lat": 43.59413208413693,
					"lng": 11.478324934343204
				},
				{
					"lat": 43.59426072818446,
					"lng": 11.478055925321236
				},
				{
					"lat": 43.594383410377624,
					"lng": 11.47786236292852
				},
				{
					"lat": 43.59439991601749,
					"lng": 11.47781533185552
				},
				{
					"lat": 43.594421093242204,
					"lng": 11.477585988550242
				},
				{
					"lat": 43.59442243449222,
					"lng": 11.47756492427329
				},
				{
					"lat": 43.594526923744475,
					"lng": 11.477322971306238
				},
				{
					"lat": 43.59457528439927,
					"lng": 11.477080739465462
				},
				{
					"lat": 43.59459851741351,
					"lng": 11.476739558628328
				},
				{
					"lat": 43.59463592042329,
					"lng": 11.476514222108033
				},
				{
					"lat": 43.59463632102164,
					"lng": 11.47632443044711
				},
				{
					"lat": 43.59461407415706,
					"lng": 11.4761631557279
				},
				{
					"lat": 43.5945675266441,
					"lng": 11.476049275697772
				},
				{
					"lat": 43.59458420339517,
					"lng": 11.475919575074593
				},
				{
					"lat": 43.59457097499653,
					"lng": 11.475845504569344
				},
				{
					"lat": 43.59455347895591,
					"lng": 11.475748073787722
				},
				{
					"lat": 43.59453457341303,
					"lng": 11.47563432099499
				},
				{
					"lat": 43.59452256940198,
					"lng": 11.475535028835964
				},
				{
					"lat": 43.594528175322445,
					"lng": 11.475490495300928
				},
				{
					"lat": 43.594520936319526,
					"lng": 11.475317323792396
				},
				{
					"lat": 43.59454794682446,
					"lng": 11.47524604308917
				},
				{
					"lat": 43.59456086153682,
					"lng": 11.47519420218593
				},
				{
					"lat": 43.59456000244914,
					"lng": 11.475173652011486
				},
				{
					"lat": 43.5945809488157,
					"lng": 11.475050414368525
				},
				{
					"lat": 43.594605430170894,
					"lng": 11.474959177753862
				},
				{
					"lat": 43.59461300886065,
					"lng": 11.474900488174487
				},
				{
					"lat": 43.5947059542307,
					"lng": 11.474690751551393
				},
				{
					"lat": 43.5947662072274,
					"lng": 11.474633191755439
				},
				{
					"lat": 43.59481277505868,
					"lng": 11.474635760821267
				},
				{
					"lat": 43.59485225630837,
					"lng": 11.474688410196167
				},
				{
					"lat": 43.59481238063849,
					"lng": 11.474633839085147
				},
				{
					"lat": 43.59492222948228,
					"lng": 11.47466050062874
				},
				{
					"lat": 43.59493677494229,
					"lng": 11.474712465576882
				},
				{
					"lat": 43.59493677494229,
					"lng": 11.47471246557687
				},
				{
					"lat": 43.59491552898352,
					"lng": 11.474615261024859
				},
				{
					"lat": 43.59491357312347,
					"lng": 11.474611189201491
				},
				{
					"lat": 43.59493103850093,
					"lng": 11.474559554663887
				},
				{
					"lat": 43.59491638602902,
					"lng": 11.474459831898356
				},
				{
					"lat": 43.59494567085112,
					"lng": 11.474377710240296
				},
				{
					"lat": 43.59496207371279,
					"lng": 11.474365430162594
				},
				{
					"lat": 43.59497613089613,
					"lng": 11.474356090432078
				},
				{
					"lat": 43.595005782467084,
					"lng": 11.474352067260144
				},
				{
					"lat": 43.5950317954298,
					"lng": 11.47436409170735
				},
				{
					"lat": 43.59505636294657,
					"lng": 11.474375448010276
				},
				{
					"lat": 43.595073415538934,
					"lng": 11.474385700090862
				},
				{
					"lat": 43.59508862442324,
					"lng": 11.474398970362346
				},
				{
					"lat": 43.59510403840159,
					"lng": 11.474412419593854
				},
				{
					"lat": 43.59512058446394,
					"lng": 11.47442685661749
				},
				{
					"lat": 43.59513970312408,
					"lng": 11.474446324193336
				},
				{
					"lat": 43.59515492983932,
					"lng": 11.474467229810664
				},
				{
					"lat": 43.59517873046975,
					"lng": 11.47449990707286
				},
				{
					"lat": 43.59519482281555,
					"lng": 11.474522001207639
				},
				{
					"lat": 43.59517294568905,
					"lng": 11.4747464839792
				},
				{
					"lat": 43.5951093202974,
					"lng": 11.475052377180141
				},
				{
					"lat": 43.59513260966584,
					"lng": 11.47544776660612
				},
				{
					"lat": 43.59518889952923,
					"lng": 11.475697397762682
				},
				{
					"lat": 43.59520782976557,
					"lng": 11.475913231047874
				},
				{
					"lat": 43.59516887962269,
					"lng": 11.475787780581937
				}
			],
			[
				{
					"lat": 43.59594347510898,
					"lng": 11.475510405226968
				},
				{
					"lat": 43.59599104766218,
					"lng": 11.475614533766533
				},
				{
					"lat": 43.59608731367534,
					"lng": 11.475702628653202
				},
				{
					"lat": 43.59618300352373,
					"lng": 11.475854921651807
				},
				{
					"lat": 43.59627717681807,
					"lng": 11.476045920101333
				},
				{
					"lat": 43.59630114749457,
					"lng": 11.476261183713788
				},
				{
					"lat": 43.59629829050848,
					"lng": 11.47636612815089
				},
				{
					"lat": 43.59630042809246,
					"lng": 11.476556712187563
				},
				{
					"lat": 43.5963351032318,
					"lng": 11.476748886297539
				},
				{
					"lat": 43.59637344190925,
					"lng": 11.477010838220988
				},
				{
					"lat": 43.596387306648936,
					"lng": 11.477156566314763
				},
				{
					"lat": 43.59641379600868,
					"lng": 11.477336617247449
				},
				{
					"lat": 43.596433176600605,
					"lng": 11.47742188331705
				},
				{
					"lat": 43.59632686350303,
					"lng": 11.47748877650376
				},
				{
					"lat": 43.596094844177856,
					"lng": 11.47759725294861
				},
				{
					"lat": 43.5960665779589,
					"lng": 11.477598347011146
				},
				{
					"lat": 43.59605445979481,
					"lng": 11.477598816073426
				},
				{
					"lat": 43.596054365454634,
					"lng": 11.477599172174607
				},
				{
					"lat": 43.59605284151355,
					"lng": 11.477608447375598
				},
				{
					"lat": 43.596052453439256,
					"lng": 11.477617339278526
				},
				{
					"lat": 43.59605245037809,
					"lng": 11.477617343337263
				},
				{
					"lat": 43.5960217677824,
					"lng": 11.477751663171063
				},
				{
					"lat": 43.59598073657798,
					"lng": 11.477895949665498
				},
				{
					"lat": 43.59597663565947,
					"lng": 11.478042131116094
				},
				{
					"lat": 43.59592326261238,
					"lng": 11.478198237126184
				},
				{
					"lat": 43.59581592481096,
					"lng": 11.47832014075947
				},
				{
					"lat": 43.595690278306805,
					"lng": 11.478425153809823
				},
				{
					"lat": 43.59557436394369,
					"lng": 11.478497435137141
				},
				{
					"lat": 43.59555512468292,
					"lng": 11.478355166213795
				},
				{
					"lat": 43.595565843902726,
					"lng": 11.478213252660968
				},
				{
					"lat": 43.5955660364628,
					"lng": 11.478070760089462
				},
				{
					"lat": 43.595565621469134,
					"lng": 11.477937429211057
				},
				{
					"lat": 43.595587721589766,
					"lng": 11.477807787708702
				},
				{
					"lat": 43.59559642885987,
					"lng": 11.4776585957413
				},
				{
					"lat": 43.595596897133795,
					"lng": 11.477540523224633
				},
				{
					"lat": 43.5956092502513,
					"lng": 11.477396263775987
				},
				{
					"lat": 43.5956169810911,
					"lng": 11.477305525400737
				},
				{
					"lat": 43.595622896695154,
					"lng": 11.477237241003026
				},
				{
					"lat": 43.59564340861252,
					"lng": 11.477065289967285
				},
				{
					"lat": 43.59565601753454,
					"lng": 11.476975203921715
				},
				{
					"lat": 43.595660888453075,
					"lng": 11.47679270129354
				},
				{
					"lat": 43.595666997915544,
					"lng": 11.476623439810012
				},
				{
					"lat": 43.595674070036075,
					"lng": 11.476482955737497
				},
				{
					"lat": 43.59567862590583,
					"lng": 11.476394069565291
				},
				{
					"lat": 43.59568343028847,
					"lng": 11.476300333370284
				},
				{
					"lat": 43.59560165825683,
					"lng": 11.476181320266354
				},
				{
					"lat": 43.59555582855574,
					"lng": 11.476001787976287
				},
				{
					"lat": 43.595537767572814,
					"lng": 11.475847423520808
				},
				{
					"lat": 43.59553215224092,
					"lng": 11.475679245511499
				},
				{
					"lat": 43.59553215224091,
					"lng": 11.475679245511488
				},
				{
					"lat": 43.59542710419965,
					"lng": 11.475662252463408
				},
				{
					"lat": 43.59539760376728,
					"lng": 11.475846087582942
				},
				{
					"lat": 43.59532812832026,
					"lng": 11.475646241738275
				},
				{
					"lat": 43.59527484754078,
					"lng": 11.475409954926532
				},
				{
					"lat": 43.59525495696812,
					"lng": 11.475072267015813
				},
				{
					"lat": 43.595302773141285,
					"lng": 11.474842380285528
				},
				{
					"lat": 43.59538445347862,
					"lng": 11.474626870646969
				},
				{
					"lat": 43.595417944263396,
					"lng": 11.474634746631459
				},
				{
					"lat": 43.595427560916825,
					"lng": 11.474647341358068
				},
				{
					"lat": 43.59543477524448,
					"lng": 11.474650145708965
				},
				{
					"lat": 43.59544118936556,
					"lng": 11.474655594344416
				},
				{
					"lat": 43.595445797701274,
					"lng": 11.474663169269189
				},
				{
					"lat": 43.59545151946527,
					"lng": 11.47466729579909
				},
				{
					"lat": 43.59545873135127,
					"lng": 11.474680960875824
				},
				{
					"lat": 43.59546250421193,
					"lng": 11.474686643165425
				},
				{
					"lat": 43.59546878786067,
					"lng": 11.474701834422632
				},
				{
					"lat": 43.595477018744155,
					"lng": 11.474713815395964
				},
				{
					"lat": 43.595498185212904,
					"lng": 11.47473847157848
				},
				{
					"lat": 43.59552049001228,
					"lng": 11.47476787705332
				},
				{
					"lat": 43.595527686851284,
					"lng": 11.474771359998542
				},
				{
					"lat": 43.59553323078409,
					"lng": 11.474777036778296
				},
				{
					"lat": 43.59554747192722,
					"lng": 11.474784515705181
				},
				{
					"lat": 43.59555957855729,
					"lng": 11.474785618026345
				},
				{
					"lat": 43.595570000307106,
					"lng": 11.474787967527027
				},
				{
					"lat": 43.59558098443198,
					"lng": 11.474787707872439
				},
				{
					"lat": 43.5955925773989,
					"lng": 11.47478890193332
				},
				{
					"lat": 43.59560999141417,
					"lng": 11.474803293198503
				},
				{
					"lat": 43.59562857571298,
					"lng": 11.474822715291861
				},
				{
					"lat": 43.5956331801845,
					"lng": 11.474829535259031
				},
				{
					"lat": 43.595632127475774,
					"lng": 11.474838009660244
				},
				{
					"lat": 43.59564683483444,
					"lng": 11.474920899014668
				},
				{
					"lat": 43.59565910897991,
					"lng": 11.474974162466737
				},
				{
					"lat": 43.595684067241955,
					"lng": 11.475036397530376
				},
				{
					"lat": 43.595690926562625,
					"lng": 11.475052245413798
				},
				{
					"lat": 43.595695423159995,
					"lng": 11.47508031189787
				},
				{
					"lat": 43.59569043971958,
					"lng": 11.475115623229888
				},
				{
					"lat": 43.59573180066906,
					"lng": 11.475265465037621
				},
				{
					"lat": 43.59573370589871,
					"lng": 11.475271343209942
				},
				{
					"lat": 43.59573879407277,
					"lng": 11.475278004009995
				},
				{
					"lat": 43.595743603221216,
					"lng": 11.475297581189562
				},
				{
					"lat": 43.59578828583394,
					"lng": 11.475358191070068
				},
				{
					"lat": 43.5958191619458,
					"lng": 11.475411809305633
				},
				{
					"lat": 43.595824297763805,
					"lng": 11.475432716441183
				},
				{
					"lat": 43.59580689406256,
					"lng": 11.475468747779713
				},
				{
					"lat": 43.59594253472397,
					"lng": 11.475509419949539
				},
				{
					"lat": 43.59594347510898,
					"lng": 11.475510405226968
				}
			]
		]
	},
	"33": {
		"name": "MC02 - MC02",
		"center": {
			"lat": 43.58753453638207,
			"lng": 11.468587032768625
		},
		"coords": [
			[
				{
					"lat": 43.589740730975414,
					"lng": 11.4677994052071
				},
				{
					"lat": 43.58936034527834,
					"lng": 11.46833197473166
				},
				{
					"lat": 43.58894432255545,
					"lng": 11.468897648884443
				},
				{
					"lat": 43.58874111570591,
					"lng": 11.469143645666849
				},
				{
					"lat": 43.588316991522696,
					"lng": 11.469323353461267
				},
				{
					"lat": 43.587637952027976,
					"lng": 11.469786871820125
				},
				{
					"lat": 43.58706241990368,
					"lng": 11.470492918504702
				},
				{
					"lat": 43.58655520990664,
					"lng": 11.470836673010538
				},
				{
					"lat": 43.58608721758716,
					"lng": 11.471341172862935
				},
				{
					"lat": 43.5857197513306,
					"lng": 11.471623871710307
				},
				{
					"lat": 43.58549818285972,
					"lng": 11.471663231664564
				},
				{
					"lat": 43.5853042874953,
					"lng": 11.471636461068456
				},
				{
					"lat": 43.5851697826889,
					"lng": 11.471569747530767
				},
				{
					"lat": 43.585151692751225,
					"lng": 11.471414443952835
				},
				{
					"lat": 43.585414668014344,
					"lng": 11.470954915300302
				},
				{
					"lat": 43.58573690634187,
					"lng": 11.470528170995909
				},
				{
					"lat": 43.58621699845905,
					"lng": 11.469862037504113
				},
				{
					"lat": 43.586728654581286,
					"lng": 11.46958188067976
				},
				{
					"lat": 43.58726570671835,
					"lng": 11.468825731748415
				},
				{
					"lat": 43.587936971477006,
					"lng": 11.468273842430301
				},
				{
					"lat": 43.58830186375138,
					"lng": 11.468048676630971
				},
				{
					"lat": 43.58863471826793,
					"lng": 11.467747926318463
				},
				{
					"lat": 43.589091989937955,
					"lng": 11.467288333405813
				},
				{
					"lat": 43.589595174736225,
					"lng": 11.466901346099426
				},
				{
					"lat": 43.589799338851826,
					"lng": 11.466761770842869
				},
				{
					"lat": 43.589841042137294,
					"lng": 11.466762975206922
				},
				{
					"lat": 43.58989126160208,
					"lng": 11.466868592820992
				},
				{
					"lat": 43.589881395645946,
					"lng": 11.466950336562237
				},
				{
					"lat": 43.589818096672396,
					"lng": 11.467182512255565
				},
				{
					"lat": 43.58979329633309,
					"lng": 11.467333244834775
				},
				{
					"lat": 43.589768336682916,
					"lng": 11.467610449050987
				},
				{
					"lat": 43.589740730975414,
					"lng": 11.4677994052071
				}
			],
			[
				{
					"lat": 43.58975916115348,
					"lng": 11.466547047139269
				},
				{
					"lat": 43.58972944007597,
					"lng": 11.466601145117568
				},
				{
					"lat": 43.58964257371095,
					"lng": 11.466675013328372
				},
				{
					"lat": 43.589498448028145,
					"lng": 11.466796034863442
				},
				{
					"lat": 43.58935578443238,
					"lng": 11.466914794301639
				},
				{
					"lat": 43.58904881825978,
					"lng": 11.467072491561549
				},
				{
					"lat": 43.588545129392976,
					"lng": 11.467536008029764
				},
				{
					"lat": 43.58820801957725,
					"lng": 11.467814747046123
				},
				{
					"lat": 43.58780815565867,
					"lng": 11.467918097688308
				},
				{
					"lat": 43.58709436505953,
					"lng": 11.468399580243053
				},
				{
					"lat": 43.58659579083517,
					"lng": 11.468833837345404
				},
				{
					"lat": 43.58620619046609,
					"lng": 11.468963189388383
				},
				{
					"lat": 43.586020074614886,
					"lng": 11.469092939676777
				},
				{
					"lat": 43.58588729418837,
					"lng": 11.469123698210913
				},
				{
					"lat": 43.58579991126563,
					"lng": 11.469049710454446
				},
				{
					"lat": 43.58574405635804,
					"lng": 11.468782793653272
				},
				{
					"lat": 43.58576228865975,
					"lng": 11.468534652355684
				},
				{
					"lat": 43.58576876389196,
					"lng": 11.468446522766738
				},
				{
					"lat": 43.585816352370294,
					"lng": 11.46821466991751
				},
				{
					"lat": 43.58586989556944,
					"lng": 11.468086245214808
				},
				{
					"lat": 43.58595186804289,
					"lng": 11.468041329520478
				},
				{
					"lat": 43.58604666306017,
					"lng": 11.46794913613265
				},
				{
					"lat": 43.58633309719532,
					"lng": 11.467697367118005
				},
				{
					"lat": 43.58674151895337,
					"lng": 11.467472331567112
				},
				{
					"lat": 43.58738269414263,
					"lng": 11.466743153148999
				},
				{
					"lat": 43.587781757242205,
					"lng": 11.466752208382058
				},
				{
					"lat": 43.58818812723335,
					"lng": 11.466691551890907
				},
				{
					"lat": 43.58875683886888,
					"lng": 11.466404835040352
				},
				{
					"lat": 43.589092045466316,
					"lng": 11.466308735466749
				},
				{
					"lat": 43.58946750068504,
					"lng": 11.46645624166009
				},
				{
					"lat": 43.58965399351389,
					"lng": 11.46642777172912
				},
				{
					"lat": 43.58970877037462,
					"lng": 11.466434600073027
				},
				{
					"lat": 43.5897478516135,
					"lng": 11.4664604021847
				},
				{
					"lat": 43.58975916115348,
					"lng": 11.466547047139269
				}
			],
			[
				{
					"lat": 43.58790175664776,
					"lng": 11.468229641348774
				},
				{
					"lat": 43.5875560636372,
					"lng": 11.468532697255254
				},
				{
					"lat": 43.58741674562079,
					"lng": 11.4686282270597
				},
				{
					"lat": 43.58718047576832,
					"lng": 11.468832407526953
				},
				{
					"lat": 43.58694418008349,
					"lng": 11.469105020069343
				},
				{
					"lat": 43.58681524609732,
					"lng": 11.469274124850498
				},
				{
					"lat": 43.586635282054154,
					"lng": 11.469465579102328
				},
				{
					"lat": 43.58649607191947,
					"lng": 11.469487949793876
				},
				{
					"lat": 43.586289298573405,
					"lng": 11.469541361525206
				},
				{
					"lat": 43.58619850789105,
					"lng": 11.469520778467732
				},
				{
					"lat": 43.58617309794893,
					"lng": 11.469447147511039
				},
				{
					"lat": 43.58614468697691,
					"lng": 11.469364820642884
				},
				{
					"lat": 43.58615588644931,
					"lng": 11.469286214689072
				},
				{
					"lat": 43.586239485750895,
					"lng": 11.469199948030404
				},
				{
					"lat": 43.58641446136579,
					"lng": 11.46907734791466
				},
				{
					"lat": 43.58653359437259,
					"lng": 11.468980776407259
				},
				{
					"lat": 43.586558367474474,
					"lng": 11.468926442524493
				},
				{
					"lat": 43.58675781738403,
					"lng": 11.468830053872022
				},
				{
					"lat": 43.58693324296827,
					"lng": 11.46867392543264
				},
				{
					"lat": 43.58730459854162,
					"lng": 11.468360851079336
				},
				{
					"lat": 43.58739891025367,
					"lng": 11.468288408390205
				},
				{
					"lat": 43.58788878786965,
					"lng": 11.468061000970529
				},
				{
					"lat": 43.58791343427603,
					"lng": 11.468092065498684
				},
				{
					"lat": 43.58792911731964,
					"lng": 11.46811183255182
				},
				{
					"lat": 43.58790175664776,
					"lng": 11.468229641348774
				}
			]
		]
	},
	"34": {
		"name": "MC04 - MC04",
		"center": {
			"lat": 43.587378072927294,
			"lng": 11.464560280055851
		},
		"coords": [
			[
				{
					"lat": 43.58706606867053,
					"lng": 11.46476711788047
				},
				{
					"lat": 43.58706087671383,
					"lng": 11.464779953672393
				},
				{
					"lat": 43.58700571561998,
					"lng": 11.464916931891693
				},
				{
					"lat": 43.58696209199579,
					"lng": 11.46504967215246
				},
				{
					"lat": 43.5869027405771,
					"lng": 11.465230268724467
				},
				{
					"lat": 43.58686564579947,
					"lng": 11.465343141396351
				},
				{
					"lat": 43.58683604519179,
					"lng": 11.46542517879353
				},
				{
					"lat": 43.58681800265352,
					"lng": 11.465504141865049
				},
				{
					"lat": 43.5868070671534,
					"lng": 11.46555200088419
				},
				{
					"lat": 43.58678770079424,
					"lng": 11.465621731688977
				},
				{
					"lat": 43.586767701129006,
					"lng": 11.46569102267936
				},
				{
					"lat": 43.5867228263027,
					"lng": 11.465843641171539
				},
				{
					"lat": 43.586718381384486,
					"lng": 11.465965655494632
				},
				{
					"lat": 43.586714198360326,
					"lng": 11.466000212041063
				},
				{
					"lat": 43.586706079770636,
					"lng": 11.466055645407183
				},
				{
					"lat": 43.58669940761788,
					"lng": 11.46608914098477
				},
				{
					"lat": 43.58668724803887,
					"lng": 11.466133361520633
				},
				{
					"lat": 43.58667577010686,
					"lng": 11.46615794001512
				},
				{
					"lat": 43.58665885890314,
					"lng": 11.466186832697115
				},
				{
					"lat": 43.586633368085934,
					"lng": 11.466222446566302
				},
				{
					"lat": 43.586594909499084,
					"lng": 11.466266536484563
				},
				{
					"lat": 43.58650459488477,
					"lng": 11.466378789071607
				},
				{
					"lat": 43.586391451717574,
					"lng": 11.466519576401756
				},
				{
					"lat": 43.5863594583187,
					"lng": 11.46662193401694
				},
				{
					"lat": 43.58630969599101,
					"lng": 11.466781139605468
				},
				{
					"lat": 43.58628040562192,
					"lng": 11.466874848406805
				},
				{
					"lat": 43.58624062849985,
					"lng": 11.46698282281528
				},
				{
					"lat": 43.58614436037546,
					"lng": 11.467249261703722
				},
				{
					"lat": 43.586129704179996,
					"lng": 11.467294489519128
				},
				{
					"lat": 43.586118814534856,
					"lng": 11.467325756913926
				},
				{
					"lat": 43.58608520620489,
					"lng": 11.467416316120724
				},
				{
					"lat": 43.58603798156154,
					"lng": 11.467542605316874
				},
				{
					"lat": 43.585980735829544,
					"lng": 11.467699319837124
				},
				{
					"lat": 43.585968097347916,
					"lng": 11.467853285113485
				},
				{
					"lat": 43.58595285741846,
					"lng": 11.468035521693348
				},
				{
					"lat": 43.58595154503294,
					"lng": 11.46805036219761
				},
				{
					"lat": 43.58593136525872,
					"lng": 11.468097472477693
				},
				{
					"lat": 43.58592647878437,
					"lng": 11.468109729766903
				},
				{
					"lat": 43.58591950968518,
					"lng": 11.468128851583518
				},
				{
					"lat": 43.58590517873552,
					"lng": 11.468164592964554
				},
				{
					"lat": 43.585893567435186,
					"lng": 11.468193974801995
				},
				{
					"lat": 43.5858691997163,
					"lng": 11.468244719214411
				},
				{
					"lat": 43.58584072430789,
					"lng": 11.468315181756862
				},
				{
					"lat": 43.5858041829923,
					"lng": 11.468411674291502
				},
				{
					"lat": 43.58579683688137,
					"lng": 11.468432811557
				},
				{
					"lat": 43.58578450644453,
					"lng": 11.46846803158592
				},
				{
					"lat": 43.58577381680112,
					"lng": 11.468492900875463
				},
				{
					"lat": 43.58576362684795,
					"lng": 11.468516439344334
				},
				{
					"lat": 43.58574879093286,
					"lng": 11.468553113766765
				},
				{
					"lat": 43.585722561274316,
					"lng": 11.468624151601912
				},
				{
					"lat": 43.58570409417596,
					"lng": 11.468638146992369
				},
				{
					"lat": 43.58568930410338,
					"lng": 11.46862759931963
				},
				{
					"lat": 43.58567707078304,
					"lng": 11.468619518019008
				},
				{
					"lat": 43.5856376799599,
					"lng": 11.468570500305685
				},
				{
					"lat": 43.58560891409385,
					"lng": 11.468550132731224
				},
				{
					"lat": 43.585573862241205,
					"lng": 11.46850945295839
				},
				{
					"lat": 43.58556335974499,
					"lng": 11.468460346876556
				},
				{
					"lat": 43.585549433923106,
					"lng": 11.46835631193436
				},
				{
					"lat": 43.585549822571814,
					"lng": 11.468237654760681
				},
				{
					"lat": 43.58555910507551,
					"lng": 11.468130095608993
				},
				{
					"lat": 43.585571068642246,
					"lng": 11.468028042986646
				},
				{
					"lat": 43.58557889970843,
					"lng": 11.467924228248016
				},
				{
					"lat": 43.58561300151774,
					"lng": 11.467667257394178
				},
				{
					"lat": 43.58561135761743,
					"lng": 11.467642762290977
				},
				{
					"lat": 43.585612910469244,
					"lng": 11.46756701013003
				},
				{
					"lat": 43.585634839306316,
					"lng": 11.467524289288269
				},
				{
					"lat": 43.58564078944217,
					"lng": 11.46750136556451
				},
				{
					"lat": 43.585677990078224,
					"lng": 11.467390448069418
				},
				{
					"lat": 43.585841727691296,
					"lng": 11.46692110195429
				},
				{
					"lat": 43.58591842109469,
					"lng": 11.466734990216617
				},
				{
					"lat": 43.58600346109957,
					"lng": 11.466487861592164
				},
				{
					"lat": 43.586071686796785,
					"lng": 11.466304685037144
				},
				{
					"lat": 43.58607972493017,
					"lng": 11.466280549268074
				},
				{
					"lat": 43.58639239761001,
					"lng": 11.465915815542235
				},
				{
					"lat": 43.5866065568,
					"lng": 11.46549936815046
				},
				{
					"lat": 43.58687843785523,
					"lng": 11.46484569536212
				},
				{
					"lat": 43.58709725394585,
					"lng": 11.464428785036143
				},
				{
					"lat": 43.58694827159734,
					"lng": 11.464363769255106
				},
				{
					"lat": 43.586941652032095,
					"lng": 11.464335688835611
				},
				{
					"lat": 43.58693108173314,
					"lng": 11.464278399520735
				},
				{
					"lat": 43.5868685564708,
					"lng": 11.46425378588604
				},
				{
					"lat": 43.58686654945873,
					"lng": 11.464219750065473
				},
				{
					"lat": 43.58687821530251,
					"lng": 11.464154416747288
				},
				{
					"lat": 43.586835935625025,
					"lng": 11.46412173102225
				},
				{
					"lat": 43.58680224106926,
					"lng": 11.464088907019857
				},
				{
					"lat": 43.586786357446336,
					"lng": 11.464087434553047
				},
				{
					"lat": 43.58677216153965,
					"lng": 11.464087056248317
				},
				{
					"lat": 43.58676646527176,
					"lng": 11.464048622949193
				},
				{
					"lat": 43.58676523484652,
					"lng": 11.464031727252264
				},
				{
					"lat": 43.58676805928333,
					"lng": 11.464024977439133
				},
				{
					"lat": 43.58678950491256,
					"lng": 11.463990296251723
				},
				{
					"lat": 43.586789883022874,
					"lng": 11.463965655658091
				},
				{
					"lat": 43.58679051888019,
					"lng": 11.463963953184493
				},
				{
					"lat": 43.5867987383842,
					"lng": 11.463941945896025
				},
				{
					"lat": 43.58681100942253,
					"lng": 11.463903621884805
				},
				{
					"lat": 43.58682147351548,
					"lng": 11.46387387128626
				},
				{
					"lat": 43.5868303058128,
					"lng": 11.463846127556856
				},
				{
					"lat": 43.58683744046823,
					"lng": 11.463803719361126
				},
				{
					"lat": 43.586843922383395,
					"lng": 11.463778954669962
				},
				{
					"lat": 43.58685339510511,
					"lng": 11.463755042252528
				},
				{
					"lat": 43.58686754599,
					"lng": 11.46371836427737
				},
				{
					"lat": 43.586894310422615,
					"lng": 11.463698887304284
				},
				{
					"lat": 43.58691237428537,
					"lng": 11.463697038597807
				},
				{
					"lat": 43.58693228980703,
					"lng": 11.463682234376229
				},
				{
					"lat": 43.58694657808941,
					"lng": 11.463664160035535
				},
				{
					"lat": 43.58695353014428,
					"lng": 11.463651317716462
				},
				{
					"lat": 43.586976221759116,
					"lng": 11.463617763943938
				},
				{
					"lat": 43.58701698998793,
					"lng": 11.463602420756228
				},
				{
					"lat": 43.5870511804266,
					"lng": 11.463595599245103
				},
				{
					"lat": 43.58709673439963,
					"lng": 11.46358199195528
				},
				{
					"lat": 43.587117590150214,
					"lng": 11.463572162195936
				},
				{
					"lat": 43.58715276472193,
					"lng": 11.463536585187699
				},
				{
					"lat": 43.58716102498815,
					"lng": 11.4634983847272
				},
				{
					"lat": 43.587171345793436,
					"lng": 11.463462136398865
				},
				{
					"lat": 43.58718478152377,
					"lng": 11.463425791315
				},
				{
					"lat": 43.587195635443614,
					"lng": 11.463399005825153
				},
				{
					"lat": 43.587211693316206,
					"lng": 11.463365219664176
				},
				{
					"lat": 43.587220594414056,
					"lng": 11.463344076940508
				},
				{
					"lat": 43.58723022013862,
					"lng": 11.463320793957614
				},
				{
					"lat": 43.5872297057972,
					"lng": 11.46329136398084
				},
				{
					"lat": 43.58722958599021,
					"lng": 11.463290148026548
				},
				{
					"lat": 43.58725312763545,
					"lng": 11.463233505229496
				},
				{
					"lat": 43.587246705633106,
					"lng": 11.46313149940083
				},
				{
					"lat": 43.58738953242167,
					"lng": 11.46281599315711
				},
				{
					"lat": 43.58742106282777,
					"lng": 11.462775714814299
				},
				{
					"lat": 43.587453571533864,
					"lng": 11.462745034199132
				},
				{
					"lat": 43.58747561130725,
					"lng": 11.462728839569369
				},
				{
					"lat": 43.587508714190456,
					"lng": 11.46270309004659
				},
				{
					"lat": 43.58755512453318,
					"lng": 11.462685163043986
				},
				{
					"lat": 43.58757489282325,
					"lng": 11.462674549512107
				},
				{
					"lat": 43.58759090963689,
					"lng": 11.46266014694348
				},
				{
					"lat": 43.58760466550115,
					"lng": 11.462641588057497
				},
				{
					"lat": 43.58761716091715,
					"lng": 11.462618207755055
				},
				{
					"lat": 43.58763346403027,
					"lng": 11.46259225848496
				},
				{
					"lat": 43.58764954430686,
					"lng": 11.462574497067825
				},
				{
					"lat": 43.587666552443544,
					"lng": 11.46256213648108
				},
				{
					"lat": 43.58770223363733,
					"lng": 11.46254561169009
				},
				{
					"lat": 43.58772836616395,
					"lng": 11.462530075517785
				},
				{
					"lat": 43.587753529754245,
					"lng": 11.46250527100451
				},
				{
					"lat": 43.58777106907037,
					"lng": 11.462485980509538
				},
				{
					"lat": 43.58780839199848,
					"lng": 11.462451706886673
				},
				{
					"lat": 43.58782766919353,
					"lng": 11.462436263562655
				},
				{
					"lat": 43.587868704305095,
					"lng": 11.462422482632464
				},
				{
					"lat": 43.58789065019837,
					"lng": 11.46241782103467
				},
				{
					"lat": 43.58791642777483,
					"lng": 11.46240070540023
				},
				{
					"lat": 43.587939880787516,
					"lng": 11.462374691384003
				},
				{
					"lat": 43.58795771561771,
					"lng": 11.462357159623751
				},
				{
					"lat": 43.587973884042356,
					"lng": 11.462345996572571
				},
				{
					"lat": 43.58799214847157,
					"lng": 11.462334449170216
				},
				{
					"lat": 43.5880082239776,
					"lng": 11.462318396905614
				},
				{
					"lat": 43.58801439553552,
					"lng": 11.462303143360044
				},
				{
					"lat": 43.58802138193082,
					"lng": 11.462285875862783
				},
				{
					"lat": 43.58803217356713,
					"lng": 11.46224406126036
				},
				{
					"lat": 43.588048835558304,
					"lng": 11.462210285049032
				},
				{
					"lat": 43.58807651405075,
					"lng": 11.46217368460208
				},
				{
					"lat": 43.58809480614257,
					"lng": 11.462162131208029
				},
				{
					"lat": 43.588116459090486,
					"lng": 11.462155758749294
				},
				{
					"lat": 43.58814094332219,
					"lng": 11.462131461640379
				},
				{
					"lat": 43.58815369194749,
					"lng": 11.462063996917912
				},
				{
					"lat": 43.58817960635137,
					"lng": 11.462023392856343
				},
				{
					"lat": 43.58823204558664,
					"lng": 11.461981052258118
				},
				{
					"lat": 43.58840127941427,
					"lng": 11.461981313128977
				},
				{
					"lat": 43.58849849880864,
					"lng": 11.462028148517744
				},
				{
					"lat": 43.58863058965015,
					"lng": 11.462348665420143
				},
				{
					"lat": 43.58883137071839,
					"lng": 11.462878353033146
				},
				{
					"lat": 43.58895634956271,
					"lng": 11.463223714407334
				},
				{
					"lat": 43.58893434391998,
					"lng": 11.463235333066494
				},
				{
					"lat": 43.5889207050682,
					"lng": 11.463253056446831
				},
				{
					"lat": 43.588899913483644,
					"lng": 11.463269728851165
				},
				{
					"lat": 43.5888846839732,
					"lng": 11.463286085543729
				},
				{
					"lat": 43.5888705157221,
					"lng": 11.46330711430329
				},
				{
					"lat": 43.58886087374838,
					"lng": 11.463318726285902
				},
				{
					"lat": 43.58884940541866,
					"lng": 11.463331560283825
				},
				{
					"lat": 43.58884087054117,
					"lng": 11.463340594070365
				},
				{
					"lat": 43.58882495924542,
					"lng": 11.463355714170401
				},
				{
					"lat": 43.588808684069946,
					"lng": 11.463367948580105
				},
				{
					"lat": 43.588796400063714,
					"lng": 11.463372735796542
				},
				{
					"lat": 43.5887797989456,
					"lng": 11.463379205437388
				},
				{
					"lat": 43.58876096669065,
					"lng": 11.4633897738781
				},
				{
					"lat": 43.58873922203273,
					"lng": 11.463409378290088
				},
				{
					"lat": 43.58871827156734,
					"lng": 11.463441797112692
				},
				{
					"lat": 43.58869678108542,
					"lng": 11.46347900114872
				},
				{
					"lat": 43.58868945178907,
					"lng": 11.463497596117435
				},
				{
					"lat": 43.58868112647358,
					"lng": 11.463520951762266
				},
				{
					"lat": 43.588669456400595,
					"lng": 11.4635511814704
				},
				{
					"lat": 43.5886579756995,
					"lng": 11.463571414902846
				},
				{
					"lat": 43.588632632588606,
					"lng": 11.463583006385138
				},
				{
					"lat": 43.58861229589657,
					"lng": 11.463559421609467
				},
				{
					"lat": 43.58860428585061,
					"lng": 11.463536880623556
				},
				{
					"lat": 43.58858820312672,
					"lng": 11.463502663237463
				},
				{
					"lat": 43.5885804770004,
					"lng": 11.46347765838729
				},
				{
					"lat": 43.58857444940171,
					"lng": 11.463454121304496
				},
				{
					"lat": 43.58856381471333,
					"lng": 11.463432001003524
				},
				{
					"lat": 43.58855089570414,
					"lng": 11.463412878470779
				},
				{
					"lat": 43.58851735229897,
					"lng": 11.46337264808843
				},
				{
					"lat": 43.58850073512452,
					"lng": 11.463357798947541
				},
				{
					"lat": 43.588479593094014,
					"lng": 11.463351870722551
				},
				{
					"lat": 43.588453057311526,
					"lng": 11.463361443036199
				},
				{
					"lat": 43.588427371682265,
					"lng": 11.463380171532592
				},
				{
					"lat": 43.58839507335451,
					"lng": 11.463410325016019
				},
				{
					"lat": 43.58838119031784,
					"lng": 11.463431971016277
				},
				{
					"lat": 43.58837112779909,
					"lng": 11.463470224349386
				},
				{
					"lat": 43.588368029750384,
					"lng": 11.463499475528497
				},
				{
					"lat": 43.588375377393625,
					"lng": 11.46352606965443
				},
				{
					"lat": 43.588385045500864,
					"lng": 11.46354626714867
				},
				{
					"lat": 43.58839329577781,
					"lng": 11.463565996785402
				},
				{
					"lat": 43.58840206712119,
					"lng": 11.46360282149605
				},
				{
					"lat": 43.588407464390755,
					"lng": 11.463631739190603
				},
				{
					"lat": 43.5884071590683,
					"lng": 11.46366461852488
				},
				{
					"lat": 43.58839841149218,
					"lng": 11.463691875297107
				},
				{
					"lat": 43.588382167134526,
					"lng": 11.463715886110249
				},
				{
					"lat": 43.588365330238766,
					"lng": 11.463729053128468
				},
				{
					"lat": 43.588344259720174,
					"lng": 11.463729772849272
				},
				{
					"lat": 43.588317476366065,
					"lng": 11.463725548932432
				},
				{
					"lat": 43.588305732518435,
					"lng": 11.463722652551818
				},
				{
					"lat": 43.58828617439801,
					"lng": 11.46372769487952
				},
				{
					"lat": 43.58826867005446,
					"lng": 11.463743146736281
				},
				{
					"lat": 43.58825630731136,
					"lng": 11.46376879204155
				},
				{
					"lat": 43.588256585630326,
					"lng": 11.463794379723145
				},
				{
					"lat": 43.588263901548046,
					"lng": 11.463823670308258
				},
				{
					"lat": 43.588266401417535,
					"lng": 11.463852293603335
				},
				{
					"lat": 43.588264656193374,
					"lng": 11.463887884414191
				},
				{
					"lat": 43.58826188606929,
					"lng": 11.463912023139601
				},
				{
					"lat": 43.58825808851689,
					"lng": 11.463936102515655
				},
				{
					"lat": 43.58825549263117,
					"lng": 11.46396258410764
				},
				{
					"lat": 43.58825760198878,
					"lng": 11.463988948751556
				},
				{
					"lat": 43.58826984858671,
					"lng": 11.464007837686477
				},
				{
					"lat": 43.58828374262206,
					"lng": 11.464024843041436
				},
				{
					"lat": 43.58829219586309,
					"lng": 11.464048443395793
				},
				{
					"lat": 43.58829114110555,
					"lng": 11.464079269570215
				},
				{
					"lat": 43.58828002295872,
					"lng": 11.464103517618348
				},
				{
					"lat": 43.58826307283497,
					"lng": 11.464114121486285
				},
				{
					"lat": 43.58824261478,
					"lng": 11.464108820606665
				},
				{
					"lat": 43.58822254821455,
					"lng": 11.464094090900193
				},
				{
					"lat": 43.58820435395289,
					"lng": 11.464086925133806
				},
				{
					"lat": 43.588191550546405,
					"lng": 11.464085341086962
				},
				{
					"lat": 43.588176538562635,
					"lng": 11.464083325660784
				},
				{
					"lat": 43.58816387690975,
					"lng": 11.464081416126067
				},
				{
					"lat": 43.588143310062776,
					"lng": 11.464074938662554
				},
				{
					"lat": 43.5881261892089,
					"lng": 11.464063200377137
				},
				{
					"lat": 43.588104938392405,
					"lng": 11.464063825962864
				},
				{
					"lat": 43.58809890344449,
					"lng": 11.46408764831579
				},
				{
					"lat": 43.588108008367854,
					"lng": 11.464140605249854
				},
				{
					"lat": 43.58810703851156,
					"lng": 11.464172952221642
				},
				{
					"lat": 43.58810130396028,
					"lng": 11.464199950281444
				},
				{
					"lat": 43.58808124784114,
					"lng": 11.464247911617258
				},
				{
					"lat": 43.5880705479895,
					"lng": 11.464264589127524
				},
				{
					"lat": 43.58806028229123,
					"lng": 11.464279704254318
				},
				{
					"lat": 43.58804935116073,
					"lng": 11.464299111151053
				},
				{
					"lat": 43.58803272779231,
					"lng": 11.464317898756468
				},
				{
					"lat": 43.588013299874476,
					"lng": 11.464330910484051
				},
				{
					"lat": 43.58800083235947,
					"lng": 11.464351006585723
				},
				{
					"lat": 43.587990696638514,
					"lng": 11.464380208171308
				},
				{
					"lat": 43.587988693225974,
					"lng": 11.464410057123231
				},
				{
					"lat": 43.5880002787732,
					"lng": 11.464440725823826
				},
				{
					"lat": 43.58800502162427,
					"lng": 11.464454935419681
				},
				{
					"lat": 43.588009484647095,
					"lng": 11.464471970351019
				},
				{
					"lat": 43.58801530739436,
					"lng": 11.464499657546984
				},
				{
					"lat": 43.58801698993775,
					"lng": 11.464525096917697
				},
				{
					"lat": 43.58801101846575,
					"lng": 11.464552231002521
				},
				{
					"lat": 43.587997472076836,
					"lng": 11.464569201025459
				},
				{
					"lat": 43.5879869335024,
					"lng": 11.46457630525732
				},
				{
					"lat": 43.58796104049313,
					"lng": 11.464595147086785
				},
				{
					"lat": 43.5879469686065,
					"lng": 11.464610818145225
				},
				{
					"lat": 43.5879344115102,
					"lng": 11.4646240568422
				},
				{
					"lat": 43.587909538245064,
					"lng": 11.464649445982976
				},
				{
					"lat": 43.58789739050133,
					"lng": 11.464665576391663
				},
				{
					"lat": 43.587885175173646,
					"lng": 11.4646880099626
				},
				{
					"lat": 43.58787320153288,
					"lng": 11.464708404440684
				},
				{
					"lat": 43.587853637718965,
					"lng": 11.464736886369296
				},
				{
					"lat": 43.58783280378399,
					"lng": 11.464764122771113
				},
				{
					"lat": 43.587820606414354,
					"lng": 11.464802332352212
				},
				{
					"lat": 43.587810668953985,
					"lng": 11.464838970447188
				},
				{
					"lat": 43.58780504191592,
					"lng": 11.464888011924224
				},
				{
					"lat": 43.58783770265675,
					"lng": 11.464921973630398
				},
				{
					"lat": 43.58785112470044,
					"lng": 11.464964994212094
				},
				{
					"lat": 43.587855123100304,
					"lng": 11.465001804137275
				},
				{
					"lat": 43.58786715849325,
					"lng": 11.46506911357724
				},
				{
					"lat": 43.587872479833514,
					"lng": 11.46509492611601
				},
				{
					"lat": 43.58788452648237,
					"lng": 11.465116879765223
				},
				{
					"lat": 43.58789409760974,
					"lng": 11.465163292166753
				},
				{
					"lat": 43.58793152905524,
					"lng": 11.465224925726517
				},
				{
					"lat": 43.58801869432827,
					"lng": 11.46525600559171
				},
				{
					"lat": 43.58805859104743,
					"lng": 11.465274221729961
				},
				{
					"lat": 43.58802454072321,
					"lng": 11.465393206789203
				},
				{
					"lat": 43.58798599235734,
					"lng": 11.465444983418772
				},
				{
					"lat": 43.58795144931394,
					"lng": 11.46547991450402
				},
				{
					"lat": 43.58791448921032,
					"lng": 11.46552821915776
				},
				{
					"lat": 43.58787037537678,
					"lng": 11.465585608682982
				},
				{
					"lat": 43.58783507255359,
					"lng": 11.465612967189163
				},
				{
					"lat": 43.58781655680485,
					"lng": 11.46562787326036
				},
				{
					"lat": 43.58765485963583,
					"lng": 11.465712642303778
				},
				{
					"lat": 43.587322078339504,
					"lng": 11.46580254350352
				},
				{
					"lat": 43.58710762375143,
					"lng": 11.465878353697875
				},
				{
					"lat": 43.587085657343835,
					"lng": 11.465884832980457
				},
				{
					"lat": 43.58706828623162,
					"lng": 11.465891796699026
				},
				{
					"lat": 43.58703986709804,
					"lng": 11.465901520521427
				},
				{
					"lat": 43.58700631093232,
					"lng": 11.465915667240766
				},
				{
					"lat": 43.587005564666484,
					"lng": 11.465916006207143
				},
				{
					"lat": 43.586989042835604,
					"lng": 11.465885270025082
				},
				{
					"lat": 43.586948926419126,
					"lng": 11.465806289208926
				},
				{
					"lat": 43.58693488889964,
					"lng": 11.46577861142825
				},
				{
					"lat": 43.586924715947426,
					"lng": 11.465755156232298
				},
				{
					"lat": 43.586929798068276,
					"lng": 11.465730703134527
				},
				{
					"lat": 43.586896058797585,
					"lng": 11.465451953298546
				},
				{
					"lat": 43.586903056037684,
					"lng": 11.46540518593685
				},
				{
					"lat": 43.58705768732352,
					"lng": 11.46479992477532
				},
				{
					"lat": 43.58706606867053,
					"lng": 11.46476711788047
				}
			]
		]
	},
	"35": {
		"name": "MC03 - MC03",
		"center": {
			"lat": 43.59377389529964,
			"lng": 11.47223476642006
		},
		"coords": [
			[
				{
					"lat": 43.59279971006385,
					"lng": 11.471232870827155
				},
				{
					"lat": 43.592820379877374,
					"lng": 11.471204857932658
				},
				{
					"lat": 43.59286750161971,
					"lng": 11.471231087919103
				},
				{
					"lat": 43.59287493696289,
					"lng": 11.471239130789217
				},
				{
					"lat": 43.59288129086247,
					"lng": 11.471246438155065
				},
				{
					"lat": 43.59288687794691,
					"lng": 11.471253286656669
				},
				{
					"lat": 43.59289201284461,
					"lng": 11.471259952934348
				},
				{
					"lat": 43.592897010184004,
					"lng": 11.471266713628683
				},
				{
					"lat": 43.592902125098455,
					"lng": 11.471273794437177
				},
				{
					"lat": 43.592907374741884,
					"lng": 11.47128121728432
				},
				{
					"lat": 43.592912716773306,
					"lng": 11.471288953151289
				},
				{
					"lat": 43.59291810885173,
					"lng": 11.471296973019244
				},
				{
					"lat": 43.59292350863618,
					"lng": 11.471305247869289
				},
				{
					"lat": 43.59292887378571,
					"lng": 11.471313748682531
				},
				{
					"lat": 43.59293416195936,
					"lng": 11.471322446440013
				},
				{
					"lat": 43.59293933081617,
					"lng": 11.47133131212275
				},
				{
					"lat": 43.59294434503928,
					"lng": 11.471340323062757
				},
				{
					"lat": 43.59294919740805,
					"lng": 11.471349481996096
				},
				{
					"lat": 43.59295388772594,
					"lng": 11.471358798009888
				},
				{
					"lat": 43.59295841579636,
					"lng": 11.47136828019122
				},
				{
					"lat": 43.59296278142273,
					"lng": 11.471377937627196
				},
				{
					"lat": 43.59296698440849,
					"lng": 11.471387779404926
				},
				{
					"lat": 43.59297102455708,
					"lng": 11.4713978146115
				},
				{
					"lat": 43.59297490167185,
					"lng": 11.471408052334025
				},
				{
					"lat": 43.59297861568731,
					"lng": 11.4714184956015
				},
				{
					"lat": 43.59298216706195,
					"lng": 11.471429123210527
				},
				{
					"lat": 43.59298555638534,
					"lng": 11.471439907899615
				},
				{
					"lat": 43.59298878424702,
					"lng": 11.47145082240725
				},
				{
					"lat": 43.59299185123665,
					"lng": 11.47146183947193
				},
				{
					"lat": 43.592994757943764,
					"lng": 11.471472931832125
				},
				{
					"lat": 43.59299750495795,
					"lng": 11.471484072226307
				},
				{
					"lat": 43.593000092868884,
					"lng": 11.471495233392957
				},
				{
					"lat": 43.593002523530686,
					"lng": 11.47150638054298
				},
				{
					"lat": 43.593004803855926,
					"lng": 11.471517448777062
				},
				{
					"lat": 43.593006942021574,
					"lng": 11.471528365668329
				},
				{
					"lat": 43.59300894620481,
					"lng": 11.471539058789912
				},
				{
					"lat": 43.59301082458271,
					"lng": 11.47154945571494
				},
				{
					"lat": 43.59301258533244,
					"lng": 11.471559484016542
				},
				{
					"lat": 43.59301423663116,
					"lng": 11.471569071267847
				},
				{
					"lat": 43.59301578665608,
					"lng": 11.47157814504199
				},
				{
					"lat": 43.593017247528906,
					"lng": 11.471586654295741
				},
				{
					"lat": 43.59301864714939,
					"lng": 11.471594633520434
				},
				{
					"lat": 43.59302001736183,
					"lng": 11.47160213859105
				},
				{
					"lat": 43.59302139001043,
					"lng": 11.4716092253826
				},
				{
					"lat": 43.593022796939366,
					"lng": 11.471615949770099
				},
				{
					"lat": 43.59302426999292,
					"lng": 11.471622367628601
				},
				{
					"lat": 43.593025841015184,
					"lng": 11.471628534833167
				},
				{
					"lat": 43.59302754185038,
					"lng": 11.471634507258864
				},
				{
					"lat": 43.59302939790175,
					"lng": 11.471640332937728
				},
				{
					"lat": 43.593031408808955,
					"lng": 11.471646028529587
				},
				{
					"lat": 43.5930335677708,
					"lng": 11.47165160285118
				},
				{
					"lat": 43.593035867986025,
					"lng": 11.471657064719267
				},
				{
					"lat": 43.59303830265341,
					"lng": 11.471662422950581
				},
				{
					"lat": 43.59304086497175,
					"lng": 11.471667686361885
				},
				{
					"lat": 43.59304354813976,
					"lng": 11.471672863769907
				},
				{
					"lat": 43.59304634535626,
					"lng": 11.471677963991391
				},
				{
					"lat": 43.59304925098629,
					"lng": 11.471682992859096
				},
				{
					"lat": 43.5930522640601,
					"lng": 11.47168794426987
				},
				{
					"lat": 43.59305538477431,
					"lng": 11.471692809136563
				},
				{
					"lat": 43.59305861332545,
					"lng": 11.471697578372035
				},
				{
					"lat": 43.59306194991006,
					"lng": 11.471702242889146
				},
				{
					"lat": 43.593065394724796,
					"lng": 11.471706793600749
				},
				{
					"lat": 43.59306894796613,
					"lng": 11.471711221419682
				},
				{
					"lat": 43.593072609830735,
					"lng": 11.471715517258803
				},
				{
					"lat": 43.59307637938156,
					"lng": 11.471719673500395
				},
				{
					"lat": 43.593080251147505,
					"lng": 11.471723688404571
				},
				{
					"lat": 43.593084218523906,
					"lng": 11.471727561700883
				},
				{
					"lat": 43.59308827490611,
					"lng": 11.471731293118877
				},
				{
					"lat": 43.593092413689405,
					"lng": 11.4717348823881
				},
				{
					"lat": 43.59309662826914,
					"lng": 11.471738329238105
				},
				{
					"lat": 43.59310091204059,
					"lng": 11.471741633398429
				},
				{
					"lat": 43.59310525839914,
					"lng": 11.471744794598608
				},
				{
					"lat": 43.59310966177536,
					"lng": 11.471747815642312
				},
				{
					"lat": 43.59311412074087,
					"lng": 11.471750711629719
				},
				{
					"lat": 43.59311863490253,
					"lng": 11.471753500735133
				},
				{
					"lat": 43.593123203867286,
					"lng": 11.47175620113288
				},
				{
					"lat": 43.593127827241936,
					"lng": 11.471758830997274
				},
				{
					"lat": 43.593132504633424,
					"lng": 11.47176140850265
				},
				{
					"lat": 43.59313723564857,
					"lng": 11.471763951823327
				},
				{
					"lat": 43.5931420198943,
					"lng": 11.471766479133645
				},
				{
					"lat": 43.59314686037808,
					"lng": 11.471769004199592
				},
				{
					"lat": 43.59315177370996,
					"lng": 11.471771523153697
				},
				{
					"lat": 43.59315677990049,
					"lng": 11.471774027720146
				},
				{
					"lat": 43.59316189896036,
					"lng": 11.471776509623107
				},
				{
					"lat": 43.59316715090017,
					"lng": 11.471778960586771
				},
				{
					"lat": 43.593172555730554,
					"lng": 11.47178137233531
				},
				{
					"lat": 43.59317813346215,
					"lng": 11.471783736592911
				},
				{
					"lat": 43.593183904105594,
					"lng": 11.471786045083752
				},
				{
					"lat": 43.5931898832684,
					"lng": 11.471788289351714
				},
				{
					"lat": 43.593196068945566,
					"lng": 11.471790460219466
				},
				{
					"lat": 43.59320245472893,
					"lng": 11.471792548329397
				},
				{
					"lat": 43.593209034210446,
					"lng": 11.471794544323883
				},
				{
					"lat": 43.59321580098199,
					"lng": 11.471796438845269
				},
				{
					"lat": 43.59322274863536,
					"lng": 11.471798222535924
				},
				{
					"lat": 43.59322987076256,
					"lng": 11.471799886038193
				},
				{
					"lat": 43.593237160955404,
					"lng": 11.471801419994415
				},
				{
					"lat": 43.59324461267473,
					"lng": 11.471802821105051
				},
				{
					"lat": 43.59325221885721,
					"lng": 11.471804110303045
				},
				{
					"lat": 43.593259972308495,
					"lng": 11.471805314579475
				},
				{
					"lat": 43.59326786583415,
					"lng": 11.47180646092543
				},
				{
					"lat": 43.59327589223979,
					"lng": 11.471807576332008
				},
				{
					"lat": 43.59328404433104,
					"lng": 11.471808687790327
				},
				{
					"lat": 43.593292314913484,
					"lng": 11.471809822291505
				},
				{
					"lat": 43.593300696792774,
					"lng": 11.471811006826696
				},
				{
					"lat": 43.593309177270584,
					"lng": 11.471812268161681
				},
				{
					"lat": 43.59331772163295,
					"lng": 11.47181363216074
				},
				{
					"lat": 43.5933262896621,
					"lng": 11.471815124462786
				},
				{
					"lat": 43.59333484114014,
					"lng": 11.47181677070676
				},
				{
					"lat": 43.593343335849276,
					"lng": 11.471818596531593
				},
				{
					"lat": 43.59335173357165,
					"lng": 11.471820627576234
				},
				{
					"lat": 43.593359994089404,
					"lng": 11.471822889479636
				},
				{
					"lat": 43.59336807718471,
					"lng": 11.471825407880747
				},
				{
					"lat": 43.59337594934266,
					"lng": 11.471828204145389
				},
				{
					"lat": 43.59338360386028,
					"lng": 11.471831282546773
				},
				{
					"lat": 43.59339104073756,
					"lng": 11.471834643084975
				},
				{
					"lat": 43.59339825997443,
					"lng": 11.471838285760061
				},
				{
					"lat": 43.593405261570894,
					"lng": 11.471842210572074
				},
				{
					"lat": 43.593412045526925,
					"lng": 11.471846417521084
				},
				{
					"lat": 43.5934186118425,
					"lng": 11.471850906607127
				},
				{
					"lat": 43.59342496051757,
					"lng": 11.471855677830236
				},
				{
					"lat": 43.593431087411055,
					"lng": 11.471860718893865
				},
				{
					"lat": 43.59343697181781,
					"lng": 11.471865968315086
				},
				{
					"lat": 43.59344258889163,
					"lng": 11.471871352314343
				},
				{
					"lat": 43.59344791378635,
					"lng": 11.471876797112063
				},
				{
					"lat": 43.59345292165579,
					"lng": 11.471882228928592
				},
				{
					"lat": 43.59345758765384,
					"lng": 11.471887573984286
				},
				{
					"lat": 43.593461886934335,
					"lng": 11.471892758499452
				},
				{
					"lat": 43.59346579465117,
					"lng": 11.471897708694371
				},
				{
					"lat": 43.59346929450239,
					"lng": 11.471902363266228
				},
				{
					"lat": 43.59347240436264,
					"lng": 11.471906710819807
				},
				{
					"lat": 43.59347515065071,
					"lng": 11.471910752436848
				},
				{
					"lat": 43.593477559785356,
					"lng": 11.471914489199087
				},
				{
					"lat": 43.59347965818539,
					"lng": 11.471917922188293
				},
				{
					"lat": 43.59348147226957,
					"lng": 11.471921052486241
				},
				{
					"lat": 43.59348302845666,
					"lng": 11.47192388117473
				},
				{
					"lat": 43.593484353165486,
					"lng": 11.471926409335557
				},
				{
					"lat": 43.593485473817246,
					"lng": 11.47192864263924
				},
				{
					"lat": 43.593486421843195,
					"lng": 11.47193060511104
				},
				{
					"lat": 43.59348722967703,
					"lng": 11.471932325364916
				},
				{
					"lat": 43.59348792975247,
					"lng": 11.471933832014846
				},
				{
					"lat": 43.59348855450322,
					"lng": 11.471935153674815
				},
				{
					"lat": 43.593489136363,
					"lng": 11.4719363189588
				},
				{
					"lat": 43.593489707765485,
					"lng": 11.471937356480797
				},
				{
					"lat": 43.59349030114439,
					"lng": 11.471938294854807
				},
				{
					"lat": 43.593490944530295,
					"lng": 11.471939162514504
				},
				{
					"lat": 43.59349164834125,
					"lng": 11.471939987172334
				},
				{
					"lat": 43.59349241859224,
					"lng": 11.471940796360425
				},
				{
					"lat": 43.59349326129822,
					"lng": 11.471941617610915
				},
				{
					"lat": 43.59349418247407,
					"lng": 11.471942478455919
				},
				{
					"lat": 43.593495188134824,
					"lng": 11.471943406427592
				},
				{
					"lat": 43.593496284295355,
					"lng": 11.471944429058055
				},
				{
					"lat": 43.593497476970676,
					"lng": 11.471945573879465
				},
				{
					"lat": 43.593498769069896,
					"lng": 11.471946859201495
				},
				{
					"lat": 43.59350015107919,
					"lng": 11.471948266444022
				},
				{
					"lat": 43.5935016103789,
					"lng": 11.471949767804457
				},
				{
					"lat": 43.59350313434943,
					"lng": 11.47195133548022
				},
				{
					"lat": 43.593504710371086,
					"lng": 11.471952941668697
				},
				{
					"lat": 43.59350632582427,
					"lng": 11.471954558567305
				},
				{
					"lat": 43.59350796808931,
					"lng": 11.471956158373436
				},
				{
					"lat": 43.593509624546606,
					"lng": 11.471957713284484
				},
				{
					"lat": 43.593511282445476,
					"lng": 11.47195920155598
				},
				{
					"lat": 43.593512928511,
					"lng": 11.471960625676061
				},
				{
					"lat": 43.593514549337286,
					"lng": 11.471961994191004
				},
				{
					"lat": 43.59351613151832,
					"lng": 11.471963315647072
				},
				{
					"lat": 43.593517661648164,
					"lng": 11.471964598590548
				},
				{
					"lat": 43.59351912632084,
					"lng": 11.471965851567708
				},
				{
					"lat": 43.593520512130475,
					"lng": 11.47196708312483
				},
				{
					"lat": 43.59352180567102,
					"lng": 11.471968301808177
				},
				{
					"lat": 43.593522998038026,
					"lng": 11.47196951180074
				},
				{
					"lat": 43.59352409833253,
					"lng": 11.471970699832289
				},
				{
					"lat": 43.59352512015712,
					"lng": 11.471971848269325
				},
				{
					"lat": 43.593526077114355,
					"lng": 11.471972939478333
				},
				{
					"lat": 43.59352698280671,
					"lng": 11.4719739558258
				},
				{
					"lat": 43.59352785083677,
					"lng": 11.471974879678209
				},
				{
					"lat": 43.59352869480704,
					"lng": 11.471975693402054
				},
				{
					"lat": 43.593529528320104,
					"lng": 11.471976379363824
				},
				{
					"lat": 43.59353036261309,
					"lng": 11.471976927412538
				},
				{
					"lat": 43.593531199461616,
					"lng": 11.471977357327331
				},
				{
					"lat": 43.593532038275995,
					"lng": 11.471977696369876
				},
				{
					"lat": 43.59353287846644,
					"lng": 11.471977971801854
				},
				{
					"lat": 43.59353371944319,
					"lng": 11.47197821088494
				},
				{
					"lat": 43.59353456061655,
					"lng": 11.47197844088081
				},
				{
					"lat": 43.59353540139674,
					"lng": 11.471978689051129
				},
				{
					"lat": 43.59353624119399,
					"lng": 11.471978982657589
				},
				{
					"lat": 43.59353707848166,
					"lng": 11.471979341344106
				},
				{
					"lat": 43.59353790798513,
					"lng": 11.471979754283524
				},
				{
					"lat": 43.59353872349289,
					"lng": 11.471980203030906
				},
				{
					"lat": 43.59353951879342,
					"lng": 11.47198066914134
				},
				{
					"lat": 43.593540287675204,
					"lng": 11.47198113416989
				},
				{
					"lat": 43.593541023926726,
					"lng": 11.471981579671635
				},
				{
					"lat": 43.593541721336464,
					"lng": 11.471981987201644
				},
				{
					"lat": 43.593542373692856,
					"lng": 11.471982338314987
				},
				{
					"lat": 43.59354297798852,
					"lng": 11.471982619245585
				},
				{
					"lat": 43.5935435440321,
					"lng": 11.471982834942754
				},
				{
					"lat": 43.593544084836445,
					"lng": 11.47198299503467
				},
				{
					"lat": 43.59354461341436,
					"lng": 11.47198310914951
				},
				{
					"lat": 43.59354514277855,
					"lng": 11.471983186915432
				},
				{
					"lat": 43.5935456859419,
					"lng": 11.471983237960629
				},
				{
					"lat": 43.59354625591715,
					"lng": 11.471983271913256
				},
				{
					"lat": 43.59354686571711,
					"lng": 11.471983298401502
				},
				{
					"lat": 43.5935475262185,
					"lng": 11.471983323934301
				},
				{
					"lat": 43.593548239754,
					"lng": 11.471983342543663
				},
				{
					"lat": 43.593549006520114,
					"lng": 11.47198334514235
				},
				{
					"lat": 43.59354982671347,
					"lng": 11.471983322643144
				},
				{
					"lat": 43.593550700530706,
					"lng": 11.471983265958812
				},
				{
					"lat": 43.59355162816829,
					"lng": 11.471983166002119
				},
				{
					"lat": 43.59355260982289,
					"lng": 11.47198301368584
				},
				{
					"lat": 43.59355364569106,
					"lng": 11.471982799922749
				},
				{
					"lat": 43.59355473480306,
					"lng": 11.47198251860959
				},
				{
					"lat": 43.59355587152394,
					"lng": 11.471982175579136
				},
				{
					"lat": 43.59355704905244,
					"lng": 11.471981779648134
				},
				{
					"lat": 43.5935582605873,
					"lng": 11.471981339633336
				},
				{
					"lat": 43.59355949932721,
					"lng": 11.471980864351499
				},
				{
					"lat": 43.59356075847095,
					"lng": 11.471980362619366
				},
				{
					"lat": 43.593562031217196,
					"lng": 11.4719798432537
				},
				{
					"lat": 43.59356331076473,
					"lng": 11.47197931507126
				},
				{
					"lat": 43.593564591445805,
					"lng": 11.471978785419337
				},
				{
					"lat": 43.59356587212687,
					"lng": 11.471978255767386
				},
				{
					"lat": 43.593567152807914,
					"lng": 11.471977726115423
				},
				{
					"lat": 43.59356843348899,
					"lng": 11.47197719646344
				},
				{
					"lat": 43.593569714170066,
					"lng": 11.47197666681143
				},
				{
					"lat": 43.593570994851106,
					"lng": 11.471976137159398
				},
				{
					"lat": 43.59357227553216,
					"lng": 11.471975607507344
				},
				{
					"lat": 43.593573556213215,
					"lng": 11.47197507785527
				},
				{
					"lat": 43.59357483799506,
					"lng": 11.471974548248262
				},
				{
					"lat": 43.59357612638159,
					"lng": 11.471974018911695
				},
				{
					"lat": 43.593577427977465,
					"lng": 11.471973490116051
				},
				{
					"lat": 43.59357874938743,
					"lng": 11.471972962131808
				},
				{
					"lat": 43.59358009721611,
					"lng": 11.471972435229432
				},
				{
					"lat": 43.593581478068224,
					"lng": 11.471971909679398
				},
				{
					"lat": 43.59358289854845,
					"lng": 11.47197138575217
				},
				{
					"lat": 43.593584365261506,
					"lng": 11.471970863718228
				},
				{
					"lat": 43.593585882610455,
					"lng": 11.471970343757887
				},
				{
					"lat": 43.59358744619224,
					"lng": 11.471969825690824
				},
				{
					"lat": 43.59358904940212,
					"lng": 11.47196930924657
				},
				{
					"lat": 43.593590685635434,
					"lng": 11.471968794154641
				},
				{
					"lat": 43.593592348287494,
					"lng": 11.47196828014459
				},
				{
					"lat": 43.59359403075359,
					"lng": 11.471967766945921
				},
				{
					"lat": 43.59359572642911,
					"lng": 11.471967254288174
				},
				{
					"lat": 43.59359742870927,
					"lng": 11.47196674190087
				},
				{
					"lat": 43.59359913209022,
					"lng": 11.471966229558618
				},
				{
					"lat": 43.59360083547118,
					"lng": 11.471965717216339
				},
				{
					"lat": 43.59360253885212,
					"lng": 11.471965204874031
				},
				{
					"lat": 43.59360424223307,
					"lng": 11.4719646925317
				},
				{
					"lat": 43.593605945614,
					"lng": 11.471964180189342
				},
				{
					"lat": 43.59360764899497,
					"lng": 11.471963667846953
				},
				{
					"lat": 43.59360935237587,
					"lng": 11.471963155504541
				},
				{
					"lat": 43.593611055756824,
					"lng": 11.4719626431621
				},
				{
					"lat": 43.593612760238535,
					"lng": 11.47196213086471
				},
				{
					"lat": 43.59361447132495,
					"lng": 11.471961618837769
				},
				{
					"lat": 43.5936161956207,
					"lng": 11.47196110735174
				},
				{
					"lat": 43.593617939730535,
					"lng": 11.471960596677098
				},
				{
					"lat": 43.59361971025911,
					"lng": 11.471960087084318
				},
				{
					"lat": 43.593621513811115,
					"lng": 11.471959578843867
				},
				{
					"lat": 43.593623356991245,
					"lng": 11.471959072226216
				},
				{
					"lat": 43.59362524640415,
					"lng": 11.471958567501838
				},
				{
					"lat": 43.59362718645302,
					"lng": 11.471958064851043
				},
				{
					"lat": 43.59362917273467,
					"lng": 11.471957564093518
				},
				{
					"lat": 43.59363119864442,
					"lng": 11.471957064958788
				},
				{
					"lat": 43.59363325757764,
					"lng": 11.47195656717639
				},
				{
					"lat": 43.59363534292957,
					"lng": 11.471956070475837
				},
				{
					"lat": 43.59363744809558,
					"lng": 11.471955574586673
				},
				{
					"lat": 43.59363956647097,
					"lng": 11.471955079238423
				},
				{
					"lat": 43.59364169145101,
					"lng": 11.471954584160608
				},
				{
					"lat": 43.593643813095944,
					"lng": 11.47195409046206
				},
				{
					"lat": 43.5936459081256,
					"lng": 11.471953604768853
				},
				{
					"lat": 43.59364794992455,
					"lng": 11.471953135086322
				},
				{
					"lat": 43.593649911877506,
					"lng": 11.471952689419846
				},
				{
					"lat": 43.59365176736919,
					"lng": 11.47195227577478
				},
				{
					"lat": 43.59365348978426,
					"lng": 11.471951902156501
				},
				{
					"lat": 43.5936550525073,
					"lng": 11.47195157657036
				},
				{
					"lat": 43.59365642892313,
					"lng": 11.47195130702174
				},
				{
					"lat": 43.593657605723955,
					"lng": 11.471951097513315
				},
				{
					"lat": 43.593658622832855,
					"lng": 11.471950936037048
				},
				{
					"lat": 43.593659533480455,
					"lng": 11.471950806582221
				},
				{
					"lat": 43.59366039089738,
					"lng": 11.471950693138114
				},
				{
					"lat": 43.59366124831432,
					"lng": 11.471950579694012
				},
				{
					"lat": 43.5936621589619,
					"lng": 11.471950450239179
				},
				{
					"lat": 43.59366317607076,
					"lng": 11.471950288762887
				},
				{
					"lat": 43.59366435287161,
					"lng": 11.471950079254425
				},
				{
					"lat": 43.59366572540193,
					"lng": 11.471949811062498
				},
				{
					"lat": 43.59366726092651,
					"lng": 11.471949494973622
				},
				{
					"lat": 43.5936689095171,
					"lng": 11.47194914713374
				},
				{
					"lat": 43.59367062124535,
					"lng": 11.47194878368883
				},
				{
					"lat": 43.59367234618302,
					"lng": 11.471948420784837
				},
				{
					"lat": 43.593674034401694,
					"lng": 11.471948074567733
				},
				{
					"lat": 43.59367563597316,
					"lng": 11.471947761183483
				},
				{
					"lat": 43.593677100969096,
					"lng": 11.471947496778055
				},
				{
					"lat": 43.593678395553475,
					"lng": 11.47194729209289
				},
				{
					"lat": 43.59367955026,
					"lng": 11.471947136251325
				},
				{
					"lat": 43.59368061171458,
					"lng": 11.47194701297216
				},
				{
					"lat": 43.59368162654321,
					"lng": 11.471946905974196
				},
				{
					"lat": 43.59368264137182,
					"lng": 11.471946798976225
				},
				{
					"lat": 43.59368370282639,
					"lng": 11.471946675697046
				},
				{
					"lat": 43.59368485753293,
					"lng": 11.47194651985546
				},
				{
					"lat": 43.59368615211732,
					"lng": 11.471946315170257
				},
				{
					"lat": 43.59368761711324,
					"lng": 11.471946050764762
				},
				{
					"lat": 43.593689218684695,
					"lng": 11.471945737380404
				},
				{
					"lat": 43.593690906903376,
					"lng": 11.471945391163148
				},
				{
					"lat": 43.593692631841016,
					"lng": 11.471945028258967
				},
				{
					"lat": 43.59369434356926,
					"lng": 11.471944664813815
				},
				{
					"lat": 43.59369599215986,
					"lng": 11.47194431697369
				},
				{
					"lat": 43.59369752768442,
					"lng": 11.471944000884545
				},
				{
					"lat": 43.5936989002147,
					"lng": 11.471943732692369
				},
				{
					"lat": 43.593700078116306,
					"lng": 11.471943523228758
				},
				{
					"lat": 43.59370110293065,
					"lng": 11.471943362067831
				},
				{
					"lat": 43.59370203449309,
					"lng": 11.47194323346932
				},
				{
					"lat": 43.59370293263889,
					"lng": 11.471943121692956
				},
				{
					"lat": 43.593703857203465,
					"lng": 11.471943010998471
				},
				{
					"lat": 43.59370486802211,
					"lng": 11.471942885645598
				},
				{
					"lat": 43.59370602493018,
					"lng": 11.471942729894058
				},
				{
					"lat": 43.59370738776304,
					"lng": 11.471942528003588
				},
				{
					"lat": 43.593709000813945,
					"lng": 11.471942269660971
				},
				{
					"lat": 43.59371084620841,
					"lng": 11.471941966261292
				},
				{
					"lat": 43.59371289052976,
					"lng": 11.471941634626695
				},
				{
					"lat": 43.59371510036146,
					"lng": 11.471941291579327
				},
				{
					"lat": 43.59371744228687,
					"lng": 11.471940953941349
				},
				{
					"lat": 43.5937198828894,
					"lng": 11.471940638534916
				},
				{
					"lat": 43.59372238875248,
					"lng": 11.471940362182178
				},
				{
					"lat": 43.59372492645952,
					"lng": 11.471940141705302
				},
				{
					"lat": 43.59372746269222,
					"lng": 11.471939989382824
				},
				{
					"lat": 43.59372996452541,
					"lng": 11.471939899318787
				},
				{
					"lat": 43.59373239913224,
					"lng": 11.471939861073572
				},
				{
					"lat": 43.59373473368592,
					"lng": 11.471939864207593
				},
				{
					"lat": 43.59373693535951,
					"lng": 11.471939898281226
				},
				{
					"lat": 43.59373897132621,
					"lng": 11.47193995285488
				},
				{
					"lat": 43.59374080875917,
					"lng": 11.471940017488944
				},
				{
					"lat": 43.59374241483152,
					"lng": 11.471940081743812
				},
				{
					"lat": 43.59374377319536,
					"lng": 11.471940137370568
				},
				{
					"lat": 43.59374493341861,
					"lng": 11.471940184883225
				},
				{
					"lat": 43.593745961548116,
					"lng": 11.471940226986467
				},
				{
					"lat": 43.59374692363078,
					"lng": 11.47194026638501
				},
				{
					"lat": 43.59374788571342,
					"lng": 11.47194030578355
				},
				{
					"lat": 43.59374891384295,
					"lng": 11.471940347886806
				},
				{
					"lat": 43.59375007406618,
					"lng": 11.47194039539947
				},
				{
					"lat": 43.59375143243004,
					"lng": 11.471940451026258
				},
				{
					"lat": 43.593753038469615,
					"lng": 11.471940516795698
				},
				{
					"lat": 43.5937548756732,
					"lng": 11.471940592031617
				},
				{
					"lat": 43.593756911017415,
					"lng": 11.47194067538166
				},
				{
					"lat": 43.593759111478754,
					"lng": 11.471940765493484
				},
				{
					"lat": 43.593761444033824,
					"lng": 11.471940861014724
				},
				{
					"lat": 43.593763875659214,
					"lng": 11.47194096059305
				},
				{
					"lat": 43.593766373331455,
					"lng": 11.47194106287609
				},
				{
					"lat": 43.59376890402711,
					"lng": 11.471941166511494
				},
				{
					"lat": 43.593771434722775,
					"lng": 11.471941270146917
				},
				{
					"lat": 43.59377393239502,
					"lng": 11.471941372429997
				},
				{
					"lat": 43.59377636402037,
					"lng": 11.471941472008384
				},
				{
					"lat": 43.59377869657545,
					"lng": 11.471941567529711
				},
				{
					"lat": 43.5937808970368,
					"lng": 11.471941657641636
				},
				{
					"lat": 43.59378293238099,
					"lng": 11.471941740991797
				},
				{
					"lat": 43.593784769584566,
					"lng": 11.471941816227826
				},
				{
					"lat": 43.59378637562413,
					"lng": 11.471941881997374
				},
				{
					"lat": 43.593787733955196,
					"lng": 11.471941939138814
				},
				{
					"lat": 43.593788893949096,
					"lng": 11.471941997253381
				},
				{
					"lat": 43.5937899214561,
					"lng": 11.471942068133062
				},
				{
					"lat": 43.593790882326495,
					"lng": 11.471942163569826
				},
				{
					"lat": 43.59379184241058,
					"lng": 11.471942295355655
				},
				{
					"lat": 43.59379286755861,
					"lng": 11.471942475282525
				},
				{
					"lat": 43.59379402362088,
					"lng": 11.471942715142418
				},
				{
					"lat": 43.593795376447694,
					"lng": 11.47194302672732
				},
				{
					"lat": 43.59379697544314,
					"lng": 11.471943418123958
				},
				{
					"lat": 43.593798804226516,
					"lng": 11.471943882597973
				},
				{
					"lat": 43.593800829971,
					"lng": 11.471944409709765
				},
				{
					"lat": 43.593803019849766,
					"lng": 11.47194498901972
				},
				{
					"lat": 43.59380534103591,
					"lng": 11.471945610088216
				},
				{
					"lat": 43.593807760702596,
					"lng": 11.471946262475647
				},
				{
					"lat": 43.59381024602297,
					"lng": 11.471946935742393
				},
				{
					"lat": 43.59381276417021,
					"lng": 11.47194761944882
				},
				{
					"lat": 43.59381528231741,
					"lng": 11.471948303155308
				},
				{
					"lat": 43.59381776763779,
					"lng": 11.471948976422231
				},
				{
					"lat": 43.593820187304445,
					"lng": 11.471949628809952
				},
				{
					"lat": 43.59382250849055,
					"lng": 11.471950249878837
				},
				{
					"lat": 43.593824698369254,
					"lng": 11.471950829189248
				},
				{
					"lat": 43.5938267241137,
					"lng": 11.471951356301533
				},
				{
					"lat": 43.59382855289704,
					"lng": 11.47195182077606
				},
				{
					"lat": 43.593830151892426,
					"lng": 11.471952212173182
				},
				{
					"lat": 43.59383150355288,
					"lng": 11.471952526742532
				},
				{
					"lat": 43.59383265145097,
					"lng": 11.471952787490885
				},
				{
					"lat": 43.593833654439116,
					"lng": 11.471953024114306
				},
				{
					"lat": 43.59383457136979,
					"lng": 11.471953266308864
				},
				{
					"lat": 43.59383546109535,
					"lng": 11.471953543770622
				},
				{
					"lat": 43.59383638246829,
					"lng": 11.471953886195664
				},
				{
					"lat": 43.59383739434103,
					"lng": 11.471954323280045
				},
				{
					"lat": 43.59383855556595,
					"lng": 11.471954884719851
				},
				{
					"lat": 43.59383990651167,
					"lng": 11.471955588843034
				},
				{
					"lat": 43.59384141361082,
					"lng": 11.471956408504864
				},
				{
					"lat": 43.59384302481229,
					"lng": 11.47195730519249
				},
				{
					"lat": 43.59384468806492,
					"lng": 11.471958240393047
				},
				{
					"lat": 43.59384635131755,
					"lng": 11.471959175593655
				},
				{
					"lat": 43.593847962518986,
					"lng": 11.471960072281428
				},
				{
					"lat": 43.59384946961813,
					"lng": 11.471960891943489
				},
				{
					"lat": 43.593850820563745,
					"lng": 11.471961596066935
				},
				{
					"lat": 43.59385198062235,
					"lng": 11.471962160491033
				},
				{
					"lat": 43.59385298433087,
					"lng": 11.471962618463765
				},
				{
					"lat": 43.59385388354392,
					"lng": 11.471963017585283
				},
				{
					"lat": 43.59385473011605,
					"lng": 11.471963405455753
				},
				{
					"lat": 43.59385557590186,
					"lng": 11.471963829675321
				},
				{
					"lat": 43.59385647275592,
					"lng": 11.47196433784417
				},
				{
					"lat": 43.593857472532804,
					"lng": 11.471964977562475
				},
				{
					"lat": 43.59385862708707,
					"lng": 11.471965796430407
				},
				{
					"lat": 43.593859971021224,
					"lng": 11.471966824666886
				},
				{
					"lat": 43.59386146992935,
					"lng": 11.471968022965761
				},
				{
					"lat": 43.59386307215343,
					"lng": 11.4719693346396
				},
				{
					"lat": 43.593864726035484,
					"lng": 11.471970703000965
				},
				{
					"lat": 43.59386637991754,
					"lng": 11.471972071362405
				},
				{
					"lat": 43.59386798214157,
					"lng": 11.47197338303646
				},
				{
					"lat": 43.593869481049616,
					"lng": 11.471974581335665
				},
				{
					"lat": 43.593870824983654,
					"lng": 11.471975609572528
				},
				{
					"lat": 43.593871978404295,
					"lng": 11.471976429910322
				},
				{
					"lat": 43.59387297024629,
					"lng": 11.471977079915263
				},
				{
					"lat": 43.59387384556295,
					"lng": 11.471977616004336
				},
				{
					"lat": 43.59387464940749,
					"lng": 11.47197809459453
				},
				{
					"lat": 43.593875426833335,
					"lng": 11.471978572102834
				},
				{
					"lat": 43.59387622289372,
					"lng": 11.471979104946236
				},
				{
					"lat": 43.59387708264196,
					"lng": 11.471979749541749
				},
				{
					"lat": 43.59387805113135,
					"lng": 11.471980562306374
				},
				{
					"lat": 43.59387915946546,
					"lng": 11.471981582411088
				},
				{
					"lat": 43.59388038294882,
					"lng": 11.471982780042694
				},
				{
					"lat": 43.593881682936185,
					"lng": 11.471984108141967
				},
				{
					"lat": 43.5938830207824,
					"lng": 11.471985519649666
				},
				{
					"lat": 43.59388435784229,
					"lng": 11.471986967506544
				},
				{
					"lat": 43.59388565547062,
					"lng": 11.471988404653338
				},
				{
					"lat": 43.59388687502217,
					"lng": 11.471989784030793
				},
				{
					"lat": 43.59388797785181,
					"lng": 11.47199105857965
				},
				{
					"lat": 43.593888938228815,
					"lng": 11.471992195412488
				},
				{
					"lat": 43.593889782080474,
					"lng": 11.471993218329413
				},
				{
					"lat": 43.593890548248574,
					"lng": 11.471994165302398
				},
				{
					"lat": 43.59389127557492,
					"lng": 11.471995074303418
				},
				{
					"lat": 43.59389200290121,
					"lng": 11.471995983304462
				},
				{
					"lat": 43.59389276906929,
					"lng": 11.47199693027752
				},
				{
					"lat": 43.59389361292091,
					"lng": 11.471997953194576
				},
				{
					"lat": 43.593894573297845,
					"lng": 11.471999090027632
				},
				{
					"lat": 43.5938956760946,
					"lng": 11.472000366091363
				},
				{
					"lat": 43.59389689541666,
					"lng": 11.47200175607112
				},
				{
					"lat": 43.593898192422245,
					"lng": 11.47200322199493
				},
				{
					"lat": 43.593899528269596,
					"lng": 11.472004725890795
				},
				{
					"lat": 43.593900864116925,
					"lng": 11.472006229786729
				},
				{
					"lat": 43.593902161122465,
					"lng": 11.472007695710731
				},
				{
					"lat": 43.59390338044443,
					"lng": 11.472009085690791
				},
				{
					"lat": 43.59390448324107,
					"lng": 11.472010361754895
				},
				{
					"lat": 43.593905443585115,
					"lng": 11.472011500102901
				},
				{
					"lat": 43.593906287207226,
					"lng": 11.47201253362221
				},
				{
					"lat": 43.593907052752634,
					"lng": 11.472013509372086
				},
				{
					"lat": 43.593907778866495,
					"lng": 11.472014474411834
				},
				{
					"lat": 43.59390850419401,
					"lng": 11.472015475800738
				},
				{
					"lat": 43.59390926738034,
					"lng": 11.472016560598076
				},
				{
					"lat": 43.59391010707068,
					"lng": 11.472017775863165
				},
				{
					"lat": 43.593911061910205,
					"lng": 11.472019168655311
				},
				{
					"lat": 43.59391216086639,
					"lng": 11.472020775026264
				},
				{
					"lat": 43.59391339419606,
					"lng": 11.472022586997607
				},
				{
					"lat": 43.59391474247829,
					"lng": 11.472024585583346
				},
				{
					"lat": 43.59391618629218,
					"lng": 11.472026751797495
				},
				{
					"lat": 43.59391770621687,
					"lng": 11.47202906665406
				},
				{
					"lat": 43.59391928283145,
					"lng": 11.472031511167053
				},
				{
					"lat": 43.59392089671503,
					"lng": 11.472034066350473
				},
				{
					"lat": 43.59392252844673,
					"lng": 11.47203671321832
				},
				{
					"lat": 43.593924158703956,
					"lng": 11.472039428240938
				},
				{
					"lat": 43.59392576855727,
					"lng": 11.472042169714111
				},
				{
					"lat": 43.593927339175586,
					"lng": 11.47204489138995
				},
				{
					"lat": 43.59392885172779,
					"lng": 11.472047547020578
				},
				{
					"lat": 43.59393028738277,
					"lng": 11.472050090358113
				},
				{
					"lat": 43.59393162730942,
					"lng": 11.472052475154646
				},
				{
					"lat": 43.59393285267666,
					"lng": 11.472054655162273
				},
				{
					"lat": 43.5939339446534,
					"lng": 11.472056584133098
				},
				{
					"lat": 43.593934892648896,
					"lng": 11.472058235733002
				},
				{
					"lat": 43.59393571903401,
					"lng": 11.472059663283092
				},
				{
					"lat": 43.593936454419904,
					"lng": 11.472060940018293
				},
				{
					"lat": 43.59393712941781,
					"lng": 11.472062139173534
				},
				{
					"lat": 43.59393777463892,
					"lng": 11.472063333983742
				},
				{
					"lat": 43.593938420694414,
					"lng": 11.472064597683868
				},
				{
					"lat": 43.59393909819549,
					"lng": 11.472066003508846
				},
				{
					"lat": 43.59393983775331,
					"lng": 11.472067624693631
				},
				{
					"lat": 43.593940661156,
					"lng": 11.47206951037855
				},
				{
					"lat": 43.59394155489909,
					"lng": 11.47207161332534
				},
				{
					"lat": 43.59394249665517,
					"lng": 11.472073862201128
				},
				{
					"lat": 43.59394346409671,
					"lng": 11.472076185672998
				},
				{
					"lat": 43.59394443489623,
					"lng": 11.472078512408059
				},
				{
					"lat": 43.59394538672632,
					"lng": 11.472080771073395
				},
				{
					"lat": 43.59394629725943,
					"lng": 11.47208289033608
				},
				{
					"lat": 43.59394714416816,
					"lng": 11.472084798863193
				},
				{
					"lat": 43.59394791253475,
					"lng": 11.47208645061398
				},
				{
					"lat": 43.593948617080365,
					"lng": 11.472087900716453
				},
				{
					"lat": 43.59394927993589,
					"lng": 11.472089229590804
				},
				{
					"lat": 43.59394992323221,
					"lng": 11.47209051765724
				},
				{
					"lat": 43.59395056910016,
					"lng": 11.472091845335964
				},
				{
					"lat": 43.59395123967068,
					"lng": 11.472093293047203
				},
				{
					"lat": 43.59395195707457,
					"lng": 11.472094941211166
				},
				{
					"lat": 43.59395274344272,
					"lng": 11.472096870248084
				},
				{
					"lat": 43.59395361218121,
					"lng": 11.472099131939894
				},
				{
					"lat": 43.59395454179675,
					"lng": 11.472101663515364
				},
				{
					"lat": 43.593955502071395,
					"lng": 11.472104373564946
				},
				{
					"lat": 43.593956462787204,
					"lng": 11.472107170679102
				},
				{
					"lat": 43.59395739372613,
					"lng": 11.47210996344826
				},
				{
					"lat": 43.59395826467019,
					"lng": 11.472112660462848
				},
				{
					"lat": 43.593959045401526,
					"lng": 11.472115170313296
				},
				{
					"lat": 43.59395970570211,
					"lng": 11.472117401590012
				},
				{
					"lat": 43.59396022773532,
					"lng": 11.472119295093924
				},
				{
					"lat": 43.593960643190165,
					"lng": 11.472120920468113
				},
				{
					"lat": 43.593960996136815,
					"lng": 11.472122379566192
				},
				{
					"lat": 43.59396133064556,
					"lng": 11.472123774241787
				},
				{
					"lat": 43.59396169078667,
					"lng": 11.472125206348528
				},
				{
					"lat": 43.593962120630344,
					"lng": 11.472126777740042
				},
				{
					"lat": 43.59396266424682,
					"lng": 11.472128590269978
				},
				{
					"lat": 43.593963365706415,
					"lng": 11.472130745791993
				},
				{
					"lat": 43.593964256394116,
					"lng": 11.472133321386005
				},
				{
					"lat": 43.593965316954616,
					"lng": 11.47213629503689
				},
				{
					"lat": 43.593966515347475,
					"lng": 11.472139619955767
				},
				{
					"lat": 43.593967819532146,
					"lng": 11.472143249353763
				},
				{
					"lat": 43.59396919746821,
					"lng": 11.472147136441981
				},
				{
					"lat": 43.593970617115176,
					"lng": 11.472151234431527
				},
				{
					"lat": 43.593972046432626,
					"lng": 11.472155496533476
				},
				{
					"lat": 43.593973453380066,
					"lng": 11.47215987595892
				},
				{
					"lat": 43.59397481045125,
					"lng": 11.47216432004105
				},
				{
					"lat": 43.59397610827667,
					"lng": 11.472168752601597
				},
				{
					"lat": 43.59397734202109,
					"lng": 11.472173091584443
				},
				{
					"lat": 43.5939785068492,
					"lng": 11.472177254933424
				},
				{
					"lat": 43.59397959792572,
					"lng": 11.472181160592413
				},
				{
					"lat": 43.59398061041539,
					"lng": 11.472184726505246
				},
				{
					"lat": 43.59398153948301,
					"lng": 11.472187870615773
				},
				{
					"lat": 43.59398238029329,
					"lng": 11.472190510867826
				},
				{
					"lat": 43.593983132695755,
					"lng": 11.472192603294385
				},
				{
					"lat": 43.59398381527881,
					"lng": 11.472194256284965
				},
				{
					"lat": 43.5939844513156,
					"lng": 11.472195616318226
				},
				{
					"lat": 43.59398506407924,
					"lng": 11.472196829872829
				},
				{
					"lat": 43.59398567684289,
					"lng": 11.47219804342746
				},
				{
					"lat": 43.59398631287963,
					"lng": 11.472199403460795
				},
				{
					"lat": 43.59398699546258,
					"lng": 11.472201056451535
				},
				{
					"lat": 43.59398774786484,
					"lng": 11.472203148878382
				},
				{
					"lat": 43.59398858757397,
					"lng": 11.472205789085827
				},
				{
					"lat": 43.59398950893551,
					"lng": 11.472208932881486
				},
				{
					"lat": 43.59399050050951,
					"lng": 11.472212497938754
				},
				{
					"lat": 43.593991550855876,
					"lng": 11.472216401931004
				},
				{
					"lat": 43.593992648534694,
					"lng": 11.472220562531627
				},
				{
					"lat": 43.59399378210604,
					"lng": 11.472224897414
				},
				{
					"lat": 43.5939949401299,
					"lng": 11.472229324251483
				},
				{
					"lat": 43.593996111166355,
					"lng": 11.472233760717437
				},
				{
					"lat": 43.593997286782894,
					"lng": 11.47223813825139
				},
				{
					"lat": 43.59399847057679,
					"lng": 11.472242443357663
				},
				{
					"lat": 43.593999669152744,
					"lng": 11.472246676306757
				},
				{
					"lat": 43.59400088911542,
					"lng": 11.472250837369181
				},
				{
					"lat": 43.59400213706953,
					"lng": 11.472254926815443
				},
				{
					"lat": 43.594003419619774,
					"lng": 11.472258944916046
				},
				{
					"lat": 43.59400474337082,
					"lng": 11.472262891941508
				},
				{
					"lat": 43.59400611492736,
					"lng": 11.472266768162338
				},
				{
					"lat": 43.594007536523776,
					"lng": 11.472270572154164
				},
				{
					"lat": 43.594008992912904,
					"lng": 11.47227429571305
				},
				{
					"lat": 43.59401046447738,
					"lng": 11.472277928940184
				},
				{
					"lat": 43.59401193159975,
					"lng": 11.472281461936717
				},
				{
					"lat": 43.594013374662545,
					"lng": 11.472284884803827
				},
				{
					"lat": 43.594014774048375,
					"lng": 11.472288187642672
				},
				{
					"lat": 43.59401611013977,
					"lng": 11.472291360554404
				},
				{
					"lat": 43.594017363319296,
					"lng": 11.472294393640166
				},
				{
					"lat": 43.594018532453454,
					"lng": 11.472297288369408
				},
				{
					"lat": 43.59401969034428,
					"lng": 11.472300091684772
				},
				{
					"lat": 43.594020928277665,
					"lng": 11.472302861897203
				},
				{
					"lat": 43.59402233753956,
					"lng": 11.472305657317683
				},
				{
					"lat": 43.594024009415875,
					"lng": 11.47230853625721
				},
				{
					"lat": 43.5940260351925,
					"lng": 11.472311557026801
				},
				{
					"lat": 43.59402850615537,
					"lng": 11.47231477793752
				},
				{
					"lat": 43.594031513590345,
					"lng": 11.472318257300456
				},
				{
					"lat": 43.59403511935715,
					"lng": 11.472322038578486
				},
				{
					"lat": 43.59403926761086,
					"lng": 11.472326105841443
				},
				{
					"lat": 43.59404387308042,
					"lng": 11.472330428310888
				},
				{
					"lat": 43.594048850494694,
					"lng": 11.472334975208375
				},
				{
					"lat": 43.59405411458257,
					"lng": 11.472339715755405
				},
				{
					"lat": 43.59405958007305,
					"lng": 11.47234461917347
				},
				{
					"lat": 43.59406516169499,
					"lng": 11.472349654684011
				},
				{
					"lat": 43.594070774177354,
					"lng": 11.472354791508437
				},
				{
					"lat": 43.59407634642815,
					"lng": 11.472360005512446
				},
				{
					"lat": 43.59408186407168,
					"lng": 11.47236529913902
				},
				{
					"lat": 43.59408732691131,
					"lng": 11.472370681475473
				},
				{
					"lat": 43.5940927347504,
					"lng": 11.472376161609121
				},
				{
					"lat": 43.594098087392304,
					"lng": 11.47238174862728
				},
				{
					"lat": 43.594103384640455,
					"lng": 11.472387451617271
				},
				{
					"lat": 43.59410862629817,
					"lng": 11.472393279666422
				},
				{
					"lat": 43.59411381216885,
					"lng": 11.472399241862055
				},
				{
					"lat": 43.594118941020554,
					"lng": 11.472405344217298
				},
				{
					"lat": 43.594124007480474,
					"lng": 11.472411580448535
				},
				{
					"lat": 43.594129005140545,
					"lng": 11.472417941197936
				},
				{
					"lat": 43.594133927592615,
					"lng": 11.472424417107668
				},
				{
					"lat": 43.594138768428664,
					"lng": 11.472430998819885
				},
				{
					"lat": 43.59414352124058,
					"lng": 11.47243767697675
				},
				{
					"lat": 43.59414817962031,
					"lng": 11.472444442220404
				},
				{
					"lat": 43.59415273715974,
					"lng": 11.472451285192989
				},
				{
					"lat": 43.59415718961963,
					"lng": 11.472458198141371
				},
				{
					"lat": 43.59416154143581,
					"lng": 11.472465179731323
				},
				{
					"lat": 43.59416579921301,
					"lng": 11.472472230233366
				},
				{
					"lat": 43.59416996955586,
					"lng": 11.472479349918002
				},
				{
					"lat": 43.594174059069026,
					"lng": 11.47248653905576
				},
				{
					"lat": 43.59417807435721,
					"lng": 11.472493797917158
				},
				{
					"lat": 43.594182022025066,
					"lng": 11.472501126772706
				},
				{
					"lat": 43.59418590867728,
					"lng": 11.472508525892932
				},
				{
					"lat": 43.59418973871693,
					"lng": 11.472515995458199
				},
				{
					"lat": 43.5941935077409,
					"lng": 11.472523535288117
				},
				{
					"lat": 43.594197209144475,
					"lng": 11.472531145112153
				},
				{
					"lat": 43.594200836322976,
					"lng": 11.472538824659747
				},
				{
					"lat": 43.59420438267172,
					"lng": 11.472546573660335
				},
				{
					"lat": 43.594207841586,
					"lng": 11.47255439184337
				},
				{
					"lat": 43.594211206461104,
					"lng": 11.472562278938268
				},
				{
					"lat": 43.594214470692314,
					"lng": 11.472570234674468
				},
				{
					"lat": 43.594217631010125,
					"lng": 11.472578257402116
				},
				{
					"lat": 43.59422069748534,
					"lng": 11.47258633995422
				},
				{
					"lat": 43.594223683523964,
					"lng": 11.47259447378452
				},
				{
					"lat": 43.594226602532025,
					"lng": 11.472602650346762
				},
				{
					"lat": 43.59422946791543,
					"lng": 11.47261086109469
				},
				{
					"lat": 43.59423229308025,
					"lng": 11.472619097482063
				},
				{
					"lat": 43.59423509143245,
					"lng": 11.47262735096264
				},
				{
					"lat": 43.594237876378045,
					"lng": 11.472635612990185
				},
				{
					"lat": 43.59424065685433,
					"lng": 11.472643877867213
				},
				{
					"lat": 43.59424342392402,
					"lng": 11.472652151291204
				},
				{
					"lat": 43.594246164181065,
					"lng": 11.472660441808374
				},
				{
					"lat": 43.59424886421949,
					"lng": 11.472668757964929
				},
				{
					"lat": 43.594251510633256,
					"lng": 11.472677108307074
				},
				{
					"lat": 43.594254090016385,
					"lng": 11.472685501381013
				},
				{
					"lat": 43.59425658896282,
					"lng": 11.472693945732933
				},
				{
					"lat": 43.594258994066585,
					"lng": 11.472702449909017
				},
				{
					"lat": 43.59426129642308,
					"lng": 11.472711018092149
				},
				{
					"lat": 43.59426350513351,
					"lng": 11.47271963701205
				},
				{
					"lat": 43.594265633800525,
					"lng": 11.472728289035134
				},
				{
					"lat": 43.59426769602674,
					"lng": 11.472736956527843
				},
				{
					"lat": 43.594269705414845,
					"lng": 11.472745621856603
				},
				{
					"lat": 43.59427167556747,
					"lng": 11.472754267387868
				},
				{
					"lat": 43.594273620087286,
					"lng": 11.472762875488089
				},
				{
					"lat": 43.59427555257698,
					"lng": 11.472771428523698
				},
				{
					"lat": 43.59427748654088,
					"lng": 11.472779913404842
				},
				{
					"lat": 43.59427943509004,
					"lng": 11.472788335216315
				},
				{
					"lat": 43.594281411237176,
					"lng": 11.472796703586582
				},
				{
					"lat": 43.59428342799506,
					"lng": 11.472805028144133
				},
				{
					"lat": 43.594285498376344,
					"lng": 11.472813318517447
				},
				{
					"lat": 43.594287635393805,
					"lng": 11.472821584335033
				},
				{
					"lat": 43.59428985206012,
					"lng": 11.472829835225383
				},
				{
					"lat": 43.59429216138803,
					"lng": 11.47283808081702
				},
				{
					"lat": 43.594294575355,
					"lng": 11.472846327664248
				},
				{
					"lat": 43.594297101797586,
					"lng": 11.472854570024575
				},
				{
					"lat": 43.594299747517155,
					"lng": 11.472862799081271
				},
				{
					"lat": 43.59430251931497,
					"lng": 11.47287100601764
				},
				{
					"lat": 43.594305423992445,
					"lng": 11.472879182016968
				},
				{
					"lat": 43.59430846835092,
					"lng": 11.472887318262552
				},
				{
					"lat": 43.594311659191725,
					"lng": 11.472895405937681
				},
				{
					"lat": 43.59431500331619,
					"lng": 11.472903436225659
				},
				{
					"lat": 43.594318508560924,
					"lng": 11.472911403383987
				},
				{
					"lat": 43.59432218690339,
					"lng": 11.472919313967017
				},
				{
					"lat": 43.5943260513563,
					"lng": 11.472927177603319
				},
				{
					"lat": 43.5943301149324,
					"lng": 11.47293500392146
				},
				{
					"lat": 43.59433439064433,
					"lng": 11.47294280255003
				},
				{
					"lat": 43.59433889150484,
					"lng": 11.472950583117624
				},
				{
					"lat": 43.594343630526645,
					"lng": 11.472958355252834
				},
				{
					"lat": 43.59434862072239,
					"lng": 11.472966128584275
				},
				{
					"lat": 43.5943538751048,
					"lng": 11.472973912740569
				},
				{
					"lat": 43.59435940668658,
					"lng": 11.472981717350352
				},
				{
					"lat": 43.59436522848036,
					"lng": 11.472989552042264
				},
				{
					"lat": 43.59437135349888,
					"lng": 11.472997426444953
				},
				{
					"lat": 43.594377794754806,
					"lng": 11.473005350187092
				},
				{
					"lat": 43.5943845652608,
					"lng": 11.473013332897361
				},
				{
					"lat": 43.59439167802955,
					"lng": 11.473021384204449
				},
				{
					"lat": 43.59439914607376,
					"lng": 11.473029513737067
				},
				{
					"lat": 43.594406981403594,
					"lng": 11.473037726535155
				},
				{
					"lat": 43.59441519201953,
					"lng": 11.473046009283584
				},
				{
					"lat": 43.59442378491956,
					"lng": 11.473054344078431
				},
				{
					"lat": 43.59443276710167,
					"lng": 11.473062713015763
				},
				{
					"lat": 43.594442145563924,
					"lng": 11.473071098191674
				},
				{
					"lat": 43.5944519273043,
					"lng": 11.473079481702225
				},
				{
					"lat": 43.594462119320845,
					"lng": 11.47308784564348
				},
				{
					"lat": 43.59447272861152,
					"lng": 11.47309617211149
				},
				{
					"lat": 43.594483783352835,
					"lng": 11.473104457334182
				},
				{
					"lat": 43.59449539643474,
					"lng": 11.473112754066957
				},
				{
					"lat": 43.59450770192556,
					"lng": 11.473121129197228
				},
				{
					"lat": 43.59452083389366,
					"lng": 11.473129649612533
				},
				{
					"lat": 43.594534926407334,
					"lng": 11.47313838220057
				},
				{
					"lat": 43.59455011353487,
					"lng": 11.473147393849182
				},
				{
					"lat": 43.59456652934453,
					"lng": 11.473156751446421
				},
				{
					"lat": 43.59458430790448,
					"lng": 11.473166521880513
				},
				{
					"lat": 43.594603592941475,
					"lng": 11.47317673302211
				},
				{
					"lat": 43.59462456681631,
					"lng": 11.473187256670725
				},
				{
					"lat": 43.59464742154833,
					"lng": 11.47319792560806
				},
				{
					"lat": 43.594672349157015,
					"lng": 11.473208572615745
				},
				{
					"lat": 43.59469954166182,
					"lng": 11.473219030475306
				},
				{
					"lat": 43.5947291910823,
					"lng": 11.473229131968102
				},
				{
					"lat": 43.59476148943805,
					"lng": 11.473238709875256
				},
				{
					"lat": 43.59479538033464,
					"lng": 11.473265277387044
				},
				{
					"lat": 43.594792511303595,
					"lng": 11.47329914723573
				},
				{
					"lat": 43.5947572600901,
					"lng": 11.473311542062785
				},
				{
					"lat": 43.59468720923406,
					"lng": 11.473298996024239
				},
				{
					"lat": 43.59454649137963,
					"lng": 11.473232690929668
				},
				{
					"lat": 43.594439740485335,
					"lng": 11.473160792598366
				},
				{
					"lat": 43.59436347425166,
					"lng": 11.473087815101751
				},
				{
					"lat": 43.59430411594789,
					"lng": 11.473015530510704
				},
				{
					"lat": 43.59426852946114,
					"lng": 11.472939563126562
				},
				{
					"lat": 43.59424308771192,
					"lng": 11.472864011435723
				},
				{
					"lat": 43.594224308420635,
					"lng": 11.472793389578287
				},
				{
					"lat": 43.59420880999998,
					"lng": 11.47272755899914
				},
				{
					"lat": 43.59418982926397,
					"lng": 11.47266624263663
				},
				{
					"lat": 43.59416736621972,
					"lng": 11.472609440497608
				},
				{
					"lat": 43.59414152154851,
					"lng": 11.472552499882866
				},
				{
					"lat": 43.59411219457747,
					"lng": 11.472500073504758
				},
				{
					"lat": 43.5940792846423,
					"lng": 11.472456814066348
				},
				{
					"lat": 43.5940396114933,
					"lng": 11.472413277657521
				},
				{
					"lat": 43.59399973699194,
					"lng": 11.472379046694776
				},
				{
					"lat": 43.59395289795045,
					"lng": 11.472353844150213
				},
				{
					"lat": 43.59390257663863,
					"lng": 11.47233315582962
				},
				{
					"lat": 43.59384539146059,
					"lng": 11.472316843223282
				},
				{
					"lat": 43.593788206278944,
					"lng": 11.472300530650225
				},
				{
					"lat": 43.593730920430716,
					"lng": 11.472288870784231
				},
				{
					"lat": 43.593677016178866,
					"lng": 11.472277349442226
				},
				{
					"lat": 43.593621622449106,
					"lng": 11.472256453542771
				},
				{
					"lat": 43.59357478337169,
					"lng": 11.472231251263393
				},
				{
					"lat": 43.59353500946256,
					"lng": 11.4721923680371
				},
				{
					"lat": 43.5935055816499,
					"lng": 11.472144595023888
				},
				{
					"lat": 43.59348639926835,
					"lng": 11.472092584866642
				},
				{
					"lat": 43.59347059846162,
					"lng": 11.472040713226866
				},
				{
					"lat": 43.59345131538069,
					"lng": 11.471993355784466
				},
				{
					"lat": 43.59342855003103,
					"lng": 11.471950512543707
				},
				{
					"lat": 43.59339882017061,
					"lng": 11.471916697679145
				},
				{
					"lat": 43.59335864356127,
					"lng": 11.471896425360141
				},
				{
					"lat": 43.593294594457014,
					"lng": 11.471884489026175
				},
				{
					"lat": 43.593227063104955,
					"lng": 11.471877066882383
				},
				{
					"lat": 43.59316659688551,
					"lng": 11.471855963811533
				},
				{
					"lat": 43.593123038660984,
					"lng": 11.47183555314545
				},
				{
					"lat": 43.59308286203198,
					"lng": 11.471815280980799
				},
				{
					"lat": 43.593039706363705,
					"lng": 11.471776259885692
				},
				{
					"lat": 43.59300361579844,
					"lng": 11.471723557920004
				},
				{
					"lat": 43.59297787128173,
					"lng": 11.47166196616766
				},
				{
					"lat": 43.59296247279986,
					"lng": 11.471591484607115
				},
				{
					"lat": 43.592950556504896,
					"lng": 11.471516488917983
				},
				{
					"lat": 43.59292849535636,
					"lng": 11.471441077909205
				},
				{
					"lat": 43.59289946970544,
					"lng": 11.471374695290288
				},
				{
					"lat": 43.592860097965925,
					"lng": 11.471317202630596
				},
				{
					"lat": 43.59283692986209,
					"lng": 11.471292970497222
				},
				{
					"lat": 43.59279971006385,
					"lng": 11.471232870827155
				}
			]
		]
	},
	"36": {
		"name": "IC02 - IC02",
		"center": {
			"lat": 43.583508,
			"lng": 11.471933
		},
		"coords": [
			[
				{
					"lat": 43.588717037390865,
					"lng": 11.474865879973672
				},
				{
					"lat": 43.58839368111683,
					"lng": 11.474544616775985
				},
				{
					"lat": 43.58806185042569,
					"lng": 11.474296686521907
				},
				{
					"lat": 43.5876330913511,
					"lng": 11.474041814340374
				},
				{
					"lat": 43.58746945559885,
					"lng": 11.47394880850956
				},
				{
					"lat": 43.58731662719585,
					"lng": 11.473856802276176
				},
				{
					"lat": 43.58705276505429,
					"lng": 11.473703061222716
				},
				{
					"lat": 43.58698193841306,
					"lng": 11.473649963651331
				},
				{
					"lat": 43.586548522607394,
					"lng": 11.473386097916212
				},
				{
					"lat": 43.58641547523428,
					"lng": 11.47331780369423
				},
				{
					"lat": 43.586251645626355,
					"lng": 11.473186645422208
				},
				{
					"lat": 43.58610804941017,
					"lng": 11.47305995413857
				},
				{
					"lat": 43.58598406053498,
					"lng": 11.472986505975767
				},
				{
					"lat": 43.58577478888074,
					"lng": 11.472876409001097
				},
				{
					"lat": 43.58572093172148,
					"lng": 11.472831617286365
				},
				{
					"lat": 43.58558180781652,
					"lng": 11.472724174392585
				},
				{
					"lat": 43.58546344974341,
					"lng": 11.472645844424894
				},
				{
					"lat": 43.585386727516045,
					"lng": 11.472595716314272
				},
				{
					"lat": 43.58530135510665,
					"lng": 11.472540260985632
				},
				{
					"lat": 43.58522891508358,
					"lng": 11.472504054975648
				},
				{
					"lat": 43.58505447012735,
					"lng": 11.472388775086259
				},
				{
					"lat": 43.58492891992837,
					"lng": 11.472307142292573
				},
				{
					"lat": 43.58480180253548,
					"lng": 11.472226448861948
				},
				{
					"lat": 43.584722599814526,
					"lng": 11.472173786182712
				},
				{
					"lat": 43.58461365089941,
					"lng": 11.472097106005888
				},
				{
					"lat": 43.58451626814817,
					"lng": 11.472002331611089
				},
				{
					"lat": 43.58443934671163,
					"lng": 11.471933017498634
				},
				{
					"lat": 43.58434918074078,
					"lng": 11.471838700167599
				},
				{
					"lat": 43.58420689421533,
					"lng": 11.471657785899515
				},
				{
					"lat": 43.584151016547466,
					"lng": 11.47157497073036
				},
				{
					"lat": 43.5840044870494,
					"lng": 11.471434766235772
				},
				{
					"lat": 43.58395440378302,
					"lng": 11.471369875222765
				},
				{
					"lat": 43.583844847095804,
					"lng": 11.471331788771902
				},
				{
					"lat": 43.583813859697855,
					"lng": 11.471262456971456
				},
				{
					"lat": 43.583813859697855,
					"lng": 11.471262456971456
				},
				{
					"lat": 43.583844847095804,
					"lng": 11.471331788771902
				},
				{
					"lat": 43.58395440378302,
					"lng": 11.471369875222765
				},
				{
					"lat": 43.5840044870494,
					"lng": 11.471434766235772
				},
				{
					"lat": 43.584151016547466,
					"lng": 11.47157497073036
				},
				{
					"lat": 43.58420689421533,
					"lng": 11.471657785899515
				},
				{
					"lat": 43.58434918074078,
					"lng": 11.471838700167599
				},
				{
					"lat": 43.58443934671163,
					"lng": 11.471933017498634
				},
				{
					"lat": 43.58451626814817,
					"lng": 11.472002331611089
				},
				{
					"lat": 43.58461365089941,
					"lng": 11.472097106005888
				},
				{
					"lat": 43.584722599814526,
					"lng": 11.472173786182712
				},
				{
					"lat": 43.58480180253548,
					"lng": 11.472226448861948
				},
				{
					"lat": 43.58492891992837,
					"lng": 11.472307142292573
				},
				{
					"lat": 43.58505447012735,
					"lng": 11.472388775086259
				},
				{
					"lat": 43.58522891508358,
					"lng": 11.472504054975648
				},
				{
					"lat": 43.58530135510665,
					"lng": 11.472540260985632
				},
				{
					"lat": 43.585386727516045,
					"lng": 11.472595716314272
				},
				{
					"lat": 43.58546344974341,
					"lng": 11.472645844424894
				},
				{
					"lat": 43.58558180781652,
					"lng": 11.472724174392585
				},
				{
					"lat": 43.58572093172148,
					"lng": 11.472831617286365
				},
				{
					"lat": 43.58577478888074,
					"lng": 11.472876409001097
				},
				{
					"lat": 43.58598406053498,
					"lng": 11.472986505975767
				},
				{
					"lat": 43.58610804941017,
					"lng": 11.47305995413857
				},
				{
					"lat": 43.586251645626355,
					"lng": 11.473186645422208
				},
				{
					"lat": 43.58641547523428,
					"lng": 11.47331780369423
				},
				{
					"lat": 43.586548522607394,
					"lng": 11.473386097916212
				},
				{
					"lat": 43.58698193841306,
					"lng": 11.473649963651331
				},
				{
					"lat": 43.58705276505429,
					"lng": 11.473703061222716
				},
				{
					"lat": 43.58731662719585,
					"lng": 11.473856802276176
				},
				{
					"lat": 43.58746945559885,
					"lng": 11.47394880850956
				},
				{
					"lat": 43.5876330913511,
					"lng": 11.474041814340374
				},
				{
					"lat": 43.58806185042569,
					"lng": 11.474296686521907
				},
				{
					"lat": 43.58839368111683,
					"lng": 11.474544616775985
				}
			],
			[
				{
					"lat": 43.5836694122797,
					"lng": 11.47510536150342
				},
				{
					"lat": 43.58394814126364,
					"lng": 11.47713320751934
				},
				{
					"lat": 43.584058278067324,
					"lng": 11.47755037864483
				},
				{
					"lat": 43.5841238495449,
					"lng": 11.477907220788113
				},
				{
					"lat": 43.58411538502159,
					"lng": 11.478280407601185
				},
				{
					"lat": 43.584100429519225,
					"lng": 11.478425517752234
				},
				{
					"lat": 43.58413455426099,
					"lng": 11.478617511604005
				},
				{
					"lat": 43.58419861176573,
					"lng": 11.478719492675014
				},
				{
					"lat": 43.584266534567796,
					"lng": 11.478779053415392
				},
				{
					"lat": 43.58443036468534,
					"lng": 11.478923998530105
				},
				{
					"lat": 43.58448710906388,
					"lng": 11.479023652876903
				},
				{
					"lat": 43.58460338737309,
					"lng": 11.479162248313429
				},
				{
					"lat": 43.584663909279186,
					"lng": 11.479223533722793
				},
				{
					"lat": 43.584731239553406,
					"lng": 11.479242518956607
				},
				{
					"lat": 43.58481525896961,
					"lng": 11.479306797033072
				},
				{
					"lat": 43.58486311010667,
					"lng": 11.479341203627579
				},
				{
					"lat": 43.584938740950605,
					"lng": 11.479384861500852
				},
				{
					"lat": 43.58496665253456,
					"lng": 11.479388035244863
				},
				{
					"lat": 43.58496665253456,
					"lng": 11.479388035244863
				},
				{
					"lat": 43.584938740950605,
					"lng": 11.479384861500852
				},
				{
					"lat": 43.58486311010667,
					"lng": 11.479341203627579
				},
				{
					"lat": 43.58481525896961,
					"lng": 11.479306797033072
				},
				{
					"lat": 43.584731239553406,
					"lng": 11.479242518956607
				},
				{
					"lat": 43.584663909279186,
					"lng": 11.479223533722793
				},
				{
					"lat": 43.58460338737309,
					"lng": 11.479162248313429
				},
				{
					"lat": 43.58448710906388,
					"lng": 11.479023652876903
				},
				{
					"lat": 43.58443036468534,
					"lng": 11.478923998530105
				},
				{
					"lat": 43.584266534567796,
					"lng": 11.478779053415392
				},
				{
					"lat": 43.58419861176573,
					"lng": 11.478719492675014
				},
				{
					"lat": 43.58413455426099,
					"lng": 11.478617511604005
				},
				{
					"lat": 43.584100429519225,
					"lng": 11.478425517752234
				},
				{
					"lat": 43.58411538502159,
					"lng": 11.478280407601185
				},
				{
					"lat": 43.5841238495449,
					"lng": 11.477907220788113
				},
				{
					"lat": 43.584058278067324,
					"lng": 11.47755037864483
				},
				{
					"lat": 43.58394814126364,
					"lng": 11.47713320751934
				}
			],
			[
				{
					"lat": 43.5836694122797,
					"lng": 11.47510536150342
				},
				{
					"lat": 43.583456117277784,
					"lng": 11.475207238976061
				},
				{
					"lat": 43.5833765008575,
					"lng": 11.475285514127481
				},
				{
					"lat": 43.58329720827219,
					"lng": 11.475339108993312
				},
				{
					"lat": 43.5831583333484,
					"lng": 11.475441824368758
				},
				{
					"lat": 43.583074253874486,
					"lng": 11.475510498353263
				},
				{
					"lat": 43.582986596744774,
					"lng": 11.475587100501846
				},
				{
					"lat": 43.58286914676649,
					"lng": 11.47568528051005
				},
				{
					"lat": 43.5827924297484,
					"lng": 11.475904780810266
				},
				{
					"lat": 43.58279976686315,
					"lng": 11.476292491550804
				},
				{
					"lat": 43.582802411479456,
					"lng": 11.476452490173095
				},
				{
					"lat": 43.58275932116487,
					"lng": 11.476635858900368
				},
				{
					"lat": 43.582744976923344,
					"lng": 11.476803218649787
				},
				{
					"lat": 43.58267293223391,
					"lng": 11.476910273577484
				},
				{
					"lat": 43.58253168345163,
					"lng": 11.477009455274555
				},
				{
					"lat": 43.582372880703375,
					"lng": 11.477043712046752
				},
				{
					"lat": 43.58230965593459,
					"lng": 11.477035662659755
				},
				{
					"lat": 43.5822245980678,
					"lng": 11.477029445886808
				},
				{
					"lat": 43.58214169676629,
					"lng": 11.477015133920347
				},
				{
					"lat": 43.582074513092365,
					"lng": 11.477006922626126
				},
				{
					"lat": 43.58202910355281,
					"lng": 11.476999604083353
				},
				{
					"lat": 43.581920351180386,
					"lng": 11.476989687758282
				},
				{
					"lat": 43.581855305941964,
					"lng": 11.477019232264263
				},
				{
					"lat": 43.581798276211,
					"lng": 11.477053018146304
				},
				{
					"lat": 43.581734869800705,
					"lng": 11.477058958819034
				},
				{
					"lat": 43.581648576155054,
					"lng": 11.477033211529324
				},
				{
					"lat": 43.581597325415686,
					"lng": 11.476993526736479
				},
				{
					"lat": 43.58155335708613,
					"lng": 11.476907929189512
				},
				{
					"lat": 43.58155335708613,
					"lng": 11.476907929189512
				},
				{
					"lat": 43.581597325415686,
					"lng": 11.476993526736479
				},
				{
					"lat": 43.581648576155054,
					"lng": 11.477033211529324
				},
				{
					"lat": 43.581734869800705,
					"lng": 11.477058958819034
				},
				{
					"lat": 43.581798276211,
					"lng": 11.477053018146304
				},
				{
					"lat": 43.581855305941964,
					"lng": 11.477019232264263
				},
				{
					"lat": 43.581920351180386,
					"lng": 11.476989687758282
				},
				{
					"lat": 43.58202910355281,
					"lng": 11.476999604083353
				},
				{
					"lat": 43.582074513092365,
					"lng": 11.477006922626126
				},
				{
					"lat": 43.58214169676629,
					"lng": 11.477015133920347
				},
				{
					"lat": 43.5822245980678,
					"lng": 11.477029445886808
				},
				{
					"lat": 43.58230965593459,
					"lng": 11.477035662659755
				},
				{
					"lat": 43.582372880703375,
					"lng": 11.477043712046752
				},
				{
					"lat": 43.58253168345163,
					"lng": 11.477009455274555
				},
				{
					"lat": 43.58267293223391,
					"lng": 11.476910273577484
				},
				{
					"lat": 43.582744976923344,
					"lng": 11.476803218649787
				},
				{
					"lat": 43.58275932116487,
					"lng": 11.476635858900368
				},
				{
					"lat": 43.582802411479456,
					"lng": 11.476452490173095
				},
				{
					"lat": 43.58279976686315,
					"lng": 11.476292491550804
				},
				{
					"lat": 43.5827924297484,
					"lng": 11.475904780810266
				},
				{
					"lat": 43.58286914676649,
					"lng": 11.47568528051005
				},
				{
					"lat": 43.582986596744774,
					"lng": 11.475587100501846
				},
				{
					"lat": 43.583074253874486,
					"lng": 11.475510498353263
				},
				{
					"lat": 43.5831583333484,
					"lng": 11.475441824368758
				},
				{
					"lat": 43.58329720827219,
					"lng": 11.475339108993312
				},
				{
					"lat": 43.5833765008575,
					"lng": 11.475285514127481
				},
				{
					"lat": 43.583456117277784,
					"lng": 11.475207238976061
				}
			],
			[
				{
					"lat": 43.583287003665,
					"lng": 11.47243089285305
				},
				{
					"lat": 43.58337999131296,
					"lng": 11.472591354362423
				},
				{
					"lat": 43.5836694122797,
					"lng": 11.47510536150342
				},
				{
					"lat": 43.5836694122797,
					"lng": 11.47510536150342
				},
				{
					"lat": 43.58337999131296,
					"lng": 11.472591354362423
				}
			],
			[
				{
					"lat": 43.58157007625261,
					"lng": 11.476918346323018
				},
				{
					"lat": 43.581288905832935,
					"lng": 11.476602011240692
				},
				{
					"lat": 43.58106485671775,
					"lng": 11.476475038180835
				},
				{
					"lat": 43.58075006256875,
					"lng": 11.476191226085351
				},
				{
					"lat": 43.580588164306675,
					"lng": 11.475960798798674
				},
				{
					"lat": 43.580396660909315,
					"lng": 11.475911723230997
				},
				{
					"lat": 43.5802421485302,
					"lng": 11.475890055303559
				},
				{
					"lat": 43.58014395185045,
					"lng": 11.475851995465854
				},
				{
					"lat": 43.57988642665526,
					"lng": 11.475680594284835
				},
				{
					"lat": 43.57988642665526,
					"lng": 11.475680594284835
				},
				{
					"lat": 43.58014395185045,
					"lng": 11.475851995465854
				},
				{
					"lat": 43.5802421485302,
					"lng": 11.475890055303559
				},
				{
					"lat": 43.580396660909315,
					"lng": 11.475911723230997
				},
				{
					"lat": 43.580588164306675,
					"lng": 11.475960798798674
				},
				{
					"lat": 43.58075006256875,
					"lng": 11.476191226085351
				},
				{
					"lat": 43.58106485671775,
					"lng": 11.476475038180835
				},
				{
					"lat": 43.581288905832935,
					"lng": 11.476602011240692
				}
			],
			[
				{
					"lat": 43.58377452820757,
					"lng": 11.471276952437226
				},
				{
					"lat": 43.58367429806432,
					"lng": 11.471433483819128
				},
				{
					"lat": 43.58360196043995,
					"lng": 11.471664388270979
				},
				{
					"lat": 43.58353731868,
					"lng": 11.471788432662143
				},
				{
					"lat": 43.58351079556234,
					"lng": 11.47190259024418
				},
				{
					"lat": 43.58339119382088,
					"lng": 11.472091468363505
				},
				{
					"lat": 43.583249419065254,
					"lng": 11.472237339077248
				},
				{
					"lat": 43.5831349915744,
					"lng": 11.472316014844651
				},
				{
					"lat": 43.58307068544608,
					"lng": 11.47236022902472
				},
				{
					"lat": 43.58296128947213,
					"lng": 11.472435444844177
				},
				{
					"lat": 43.58285340454518,
					"lng": 11.472501173689665
				},
				{
					"lat": 43.58280750938215,
					"lng": 11.472560548899567
				},
				{
					"lat": 43.58275985557675,
					"lng": 11.472644296460556
				},
				{
					"lat": 43.582703345459656,
					"lng": 11.472842494118012
				},
				{
					"lat": 43.582619490575155,
					"lng": 11.473158920819317
				},
				{
					"lat": 43.58252169342674,
					"lng": 11.473969013671057
				},
				{
					"lat": 43.582504283076226,
					"lng": 11.474688448154415
				},
				{
					"lat": 43.58244802911953,
					"lng": 11.475031799753868
				},
				{
					"lat": 43.58243316258879,
					"lng": 11.475731582049537
				},
				{
					"lat": 43.58231420471564,
					"lng": 11.476049889895295
				},
				{
					"lat": 43.58217639692171,
					"lng": 11.476249358593288
				},
				{
					"lat": 43.58200436065086,
					"lng": 11.47654973357526
				},
				{
					"lat": 43.58185050983977,
					"lng": 11.476757315283892
				},
				{
					"lat": 43.581734080735366,
					"lng": 11.476932889907108
				},
				{
					"lat": 43.58166088628383,
					"lng": 11.476947339731657
				},
				{
					"lat": 43.581581102443366,
					"lng": 11.476918798577504
				},
				{
					"lat": 43.58156243672811,
					"lng": 11.476898188994548
				},
				{
					"lat": 43.58156243672811,
					"lng": 11.476898188994548
				},
				{
					"lat": 43.581581102443366,
					"lng": 11.476918798577504
				},
				{
					"lat": 43.58166088628383,
					"lng": 11.476947339731657
				},
				{
					"lat": 43.581734080735366,
					"lng": 11.476932889907108
				},
				{
					"lat": 43.58185050983977,
					"lng": 11.476757315283892
				},
				{
					"lat": 43.58200436065086,
					"lng": 11.47654973357526
				},
				{
					"lat": 43.58217639692171,
					"lng": 11.476249358593288
				},
				{
					"lat": 43.58231420471564,
					"lng": 11.476049889895295
				},
				{
					"lat": 43.58243316258879,
					"lng": 11.475731582049537
				},
				{
					"lat": 43.58244802911953,
					"lng": 11.475031799753868
				},
				{
					"lat": 43.582504283076226,
					"lng": 11.474688448154415
				},
				{
					"lat": 43.58252169342674,
					"lng": 11.473969013671057
				},
				{
					"lat": 43.582619490575155,
					"lng": 11.473158920819317
				},
				{
					"lat": 43.582703345459656,
					"lng": 11.472842494118012
				},
				{
					"lat": 43.58275985557675,
					"lng": 11.472644296460556
				},
				{
					"lat": 43.58280750938215,
					"lng": 11.472560548899567
				},
				{
					"lat": 43.58285340454518,
					"lng": 11.472501173689665
				},
				{
					"lat": 43.58296128947213,
					"lng": 11.472435444844177
				},
				{
					"lat": 43.58307068544608,
					"lng": 11.47236022902472
				},
				{
					"lat": 43.5831349915744,
					"lng": 11.472316014844651
				},
				{
					"lat": 43.583249419065254,
					"lng": 11.472237339077248
				},
				{
					"lat": 43.58339119382088,
					"lng": 11.472091468363505
				},
				{
					"lat": 43.58351079556234,
					"lng": 11.47190259024418
				},
				{
					"lat": 43.58353731868,
					"lng": 11.471788432662143
				},
				{
					"lat": 43.58360196043995,
					"lng": 11.471664388270979
				},
				{
					"lat": 43.58367429806432,
					"lng": 11.471433483819128
				}
			],
			[
				{
					"lat": 43.58557207180463,
					"lng": 11.46993473421094
				},
				{
					"lat": 43.58516772432191,
					"lng": 11.470193159981187
				},
				{
					"lat": 43.58509991096804,
					"lng": 11.470218673944618
				},
				{
					"lat": 43.585007595709456,
					"lng": 11.470305798326464
				},
				{
					"lat": 43.58485303139714,
					"lng": 11.470431992588134
				},
				{
					"lat": 43.58462220264537,
					"lng": 11.470581695615248
				},
				{
					"lat": 43.58435192888285,
					"lng": 11.470793868117036
				},
				{
					"lat": 43.584106743075544,
					"lng": 11.470951515687707
				},
				{
					"lat": 43.5840035379943,
					"lng": 11.471031936354812
				},
				{
					"lat": 43.58391610033559,
					"lng": 11.47113912441015
				},
				{
					"lat": 43.58377452820757,
					"lng": 11.471276952437226
				},
				{
					"lat": 43.58377452820757,
					"lng": 11.471276952437226
				},
				{
					"lat": 43.58391610033559,
					"lng": 11.47113912441015
				},
				{
					"lat": 43.5840035379943,
					"lng": 11.471031936354812
				},
				{
					"lat": 43.584106743075544,
					"lng": 11.470951515687707
				},
				{
					"lat": 43.58435192888285,
					"lng": 11.470793868117036
				},
				{
					"lat": 43.58462220264537,
					"lng": 11.470581695615248
				},
				{
					"lat": 43.58485303139714,
					"lng": 11.470431992588134
				},
				{
					"lat": 43.585007595709456,
					"lng": 11.470305798326464
				},
				{
					"lat": 43.58509991096804,
					"lng": 11.470218673944618
				},
				{
					"lat": 43.58516772432191,
					"lng": 11.470193159981187
				}
			],
			[
				{
					"lat": 43.58811509938528,
					"lng": 11.462296965601153
				},
				{
					"lat": 43.58804612140358,
					"lng": 11.462449020652784
				},
				{
					"lat": 43.58798213140167,
					"lng": 11.462590079502531
				},
				{
					"lat": 43.58792312941882,
					"lng": 11.462720142221476
				},
				{
					"lat": 43.58786911549115,
					"lng": 11.462839208875147
				},
				{
					"lat": 43.58782008965184,
					"lng": 11.462947279523561
				},
				{
					"lat": 43.58777605193089,
					"lng": 11.463044354221168
				},
				{
					"lat": 43.587737002355304,
					"lng": 11.463130433016879
				},
				{
					"lat": 43.587702940949015,
					"lng": 11.463205515954078
				},
				{
					"lat": 43.58767011066476,
					"lng": 11.463277884898472
				},
				{
					"lat": 43.58763475443395,
					"lng": 11.463355821677064
				},
				{
					"lat": 43.58759687224558,
					"lng": 11.46343932626997
				},
				{
					"lat": 43.58755646408787,
					"lng": 11.463528398655885
				},
				{
					"lat": 43.587513529948275,
					"lng": 11.463623038812068
				},
				{
					"lat": 43.58746806981353,
					"lng": 11.463723246714391
				},
				{
					"lat": 43.58742008366945,
					"lng": 11.463829022337269
				},
				{
					"lat": 43.587369571501235,
					"lng": 11.463940365653706
				},
				{
					"lat": 43.587319431863136,
					"lng": 11.464050887391608
				},
				{
					"lat": 43.58727256333318,
					"lng": 11.46415419832152
				},
				{
					"lat": 43.58722896593012,
					"lng": 11.464250298477575
				},
				{
					"lat": 43.58718863967153,
					"lng": 11.464339187891541
				},
				{
					"lat": 43.58715158457358,
					"lng": 11.46442086659279
				},
				{
					"lat": 43.58711780065121,
					"lng": 11.4644953346083
				},
				{
					"lat": 43.58708728791797,
					"lng": 11.464562591962691
				},
				{
					"lat": 43.587060046386114,
					"lng": 11.464622638678186
				},
				{
					"lat": 43.58703267957878,
					"lng": 11.464684048281818
				},
				{
					"lat": 43.58700179100074,
					"lng": 11.464755394269869
				},
				{
					"lat": 43.58696738063399,
					"lng": 11.464836676613995
				},
				{
					"lat": 43.586929448458015,
					"lng": 11.464927895282283
				},
				{
					"lat": 43.58688799444978,
					"lng": 11.465029050239245
				},
				{
					"lat": 43.586843018583735,
					"lng": 11.46514014144584
				},
				{
					"lat": 43.586794520831745,
					"lng": 11.465261168859445
				},
				{
					"lat": 43.58674250116328,
					"lng": 11.465392132433871
				},
				{
					"lat": 43.58668968389318,
					"lng": 11.465522552057985
				},
				{
					"lat": 43.586638793381944,
					"lng": 11.465641947681457
				},
				{
					"lat": 43.58658982966329,
					"lng": 11.46575031934496
				},
				{
					"lat": 43.586542792767744,
					"lng": 11.465847667086898
				},
				{
					"lat": 43.586497682722694,
					"lng": 11.46593399094346
				},
				{
					"lat": 43.58645449955238,
					"lng": 11.46600929094856
				},
				{
					"lat": 43.58641324327796,
					"lng": 11.466073567133872
				},
				{
					"lat": 43.586373913917306,
					"lng": 11.466126819528826
				},
				{
					"lat": 43.58633671206957,
					"lng": 11.466175372731396
				},
				{
					"lat": 43.586301838321894,
					"lng": 11.466225551322653
				},
				{
					"lat": 43.58626929267216,
					"lng": 11.466277355305312
				},
				{
					"lat": 43.58623907511806,
					"lng": 11.466330784682462
				},
				{
					"lat": 43.586211185657284,
					"lng": 11.466385839457594
				},
				{
					"lat": 43.58618562428745,
					"lng": 11.466442519634573
				},
				{
					"lat": 43.586162391005985,
					"lng": 11.466500825217649
				},
				{
					"lat": 43.58614148581038,
					"lng": 11.466560756211456
				},
				{
					"lat": 43.58612292718257,
					"lng": 11.466619429737772
				},
				{
					"lat": 43.586106733610315,
					"lng": 11.466673962922208
				},
				{
					"lat": 43.58609290509935,
					"lng": 11.466724355774677
				},
				{
					"lat": 43.586081441654954,
					"lng": 11.466770608304142
				},
				{
					"lat": 43.58607234328198,
					"lng": 11.466812720518558
				},
				{
					"lat": 43.5860656099849,
					"lng": 11.46685069242491
				},
				{
					"lat": 43.586061241767624,
					"lng": 11.466884524029188
				},
				{
					"lat": 43.586059238633815,
					"lng": 11.466914215336422
				},
				{
					"lat": 43.58605838736771,
					"lng": 11.466940841036779
				},
				{
					"lat": 43.586057474752465,
					"lng": 11.466965475817613
				},
				{
					"lat": 43.58605650078932,
					"lng": 11.466988119678998
				},
				{
					"lat": 43.58605546547947,
					"lng": 11.467008772621012
				},
				{
					"lat": 43.58605436882403,
					"lng": 11.467027434643754
				},
				{
					"lat": 43.58605321082392,
					"lng": 11.467044105747307
				},
				{
					"lat": 43.586051991480055,
					"lng": 11.467058785931783
				},
				{
					"lat": 43.58605071079315,
					"lng": 11.46707147519729
				},
				{
					"lat": 43.586048497614875,
					"lng": 11.467083713959939
				},
				{
					"lat": 43.58604448079612,
					"lng": 11.467097042634908
				},
				{
					"lat": 43.58603866033656,
					"lng": 11.467111461220789
				},
				{
					"lat": 43.586031036235795,
					"lng": 11.467126969715975
				},
				{
					"lat": 43.58602160849344,
					"lng": 11.46714356811867
				},
				{
					"lat": 43.586010377109055,
					"lng": 11.467161256426907
				},
				{
					"lat": 43.58599734208215,
					"lng": 11.467180034638492
				},
				{
					"lat": 43.58598250341229,
					"lng": 11.467199902751089
				},
				{
					"lat": 43.585967249414026,
					"lng": 11.467220142130591
				},
				{
					"lat": 43.58595296840249,
					"lng": 11.467240034145407
				},
				{
					"lat": 43.58593966037784,
					"lng": 11.467259578796716
				},
				{
					"lat": 43.58592732534021,
					"lng": 11.467278776085683
				},
				{
					"lat": 43.58591596328978,
					"lng": 11.467297626013414
				},
				{
					"lat": 43.58590557422668,
					"lng": 11.467316128581011
				},
				{
					"lat": 43.58589615815105,
					"lng": 11.467334283789528
				},
				{
					"lat": 43.58588771506303,
					"lng": 11.467352091639999
				},
				{
					"lat": 43.58587978448431,
					"lng": 11.467370051889539
				},
				{
					"lat": 43.585871905936145,
					"lng": 11.467388664294447
				},
				{
					"lat": 43.585864079418236,
					"lng": 11.467407928854492
				},
				{
					"lat": 43.58585630493025,
					"lng": 11.467427845569473
				},
				{
					"lat": 43.58584858247191,
					"lng": 11.467448414439163
				},
				{
					"lat": 43.58584091204277,
					"lng": 11.467469635463347
				},
				{
					"lat": 43.58583329364256,
					"lng": 11.467491508641812
				},
				{
					"lat": 43.58582572727087,
					"lng": 11.467514033974362
				},
				{
					"lat": 43.58581810307629,
					"lng": 11.467540834423557
				},
				{
					"lat": 43.58581031120374,
					"lng": 11.467575532949779
				},
				{
					"lat": 43.58580235164607,
					"lng": 11.467618129549358
				},
				{
					"lat": 43.58579422439457,
					"lng": 11.467668624218406
				},
				{
					"lat": 43.585785929438835,
					"lng": 11.467727016952859
				},
				{
					"lat": 43.58577746676685,
					"lng": 11.467793307748416
				},
				{
					"lat": 43.58576883636492,
					"lng": 11.467867496600583
				},
				{
					"lat": 43.58576003821777,
					"lng": 11.467949583504664
				},
				{
					"lat": 43.5857515954935,
					"lng": 11.468034997203954
				},
				{
					"lat": 43.585744031373,
					"lng": 11.468119166447847
				},
				{
					"lat": 43.58573734585892,
					"lng": 11.468202091240608
				},
				{
					"lat": 43.58573153895387,
					"lng": 11.468283771586385
				},
				{
					"lat": 43.585726610660465,
					"lng": 11.468364207489202
				},
				{
					"lat": 43.585722560981196,
					"lng": 11.46844339895299
				},
				{
					"lat": 43.58571938991864,
					"lng": 11.468521345981575
				},
				{
					"lat": 43.58571709747514,
					"lng": 11.468598048578661
				},
				{
					"lat": 43.5857135511323,
					"lng": 11.469504438083623
				},
				{
					"lat": 43.5857135511323,
					"lng": 11.469504438083623
				},
				{
					"lat": 43.58571709747514,
					"lng": 11.468598048578661
				},
				{
					"lat": 43.58571938991864,
					"lng": 11.468521345981575
				},
				{
					"lat": 43.585722560981196,
					"lng": 11.46844339895299
				},
				{
					"lat": 43.585726610660465,
					"lng": 11.468364207489202
				},
				{
					"lat": 43.58573153895387,
					"lng": 11.468283771586385
				},
				{
					"lat": 43.58573734585892,
					"lng": 11.468202091240608
				},
				{
					"lat": 43.585744031373,
					"lng": 11.468119166447847
				},
				{
					"lat": 43.5857515954935,
					"lng": 11.468034997203954
				},
				{
					"lat": 43.58576003821777,
					"lng": 11.467949583504664
				},
				{
					"lat": 43.58576883636492,
					"lng": 11.467867496600583
				},
				{
					"lat": 43.58577746676685,
					"lng": 11.467793307748416
				},
				{
					"lat": 43.585785929438835,
					"lng": 11.467727016952859
				},
				{
					"lat": 43.58579422439457,
					"lng": 11.467668624218406
				},
				{
					"lat": 43.58580235164607,
					"lng": 11.467618129549358
				},
				{
					"lat": 43.58581031120374,
					"lng": 11.467575532949779
				},
				{
					"lat": 43.58581810307629,
					"lng": 11.467540834423557
				},
				{
					"lat": 43.58582572727087,
					"lng": 11.467514033974362
				},
				{
					"lat": 43.58583329364256,
					"lng": 11.467491508641812
				},
				{
					"lat": 43.58584091204277,
					"lng": 11.467469635463347
				},
				{
					"lat": 43.58584858247191,
					"lng": 11.467448414439163
				},
				{
					"lat": 43.58585630493025,
					"lng": 11.467427845569473
				},
				{
					"lat": 43.585864079418236,
					"lng": 11.467407928854492
				},
				{
					"lat": 43.585871905936145,
					"lng": 11.467388664294447
				},
				{
					"lat": 43.58587978448431,
					"lng": 11.467370051889539
				},
				{
					"lat": 43.58588771506303,
					"lng": 11.467352091639999
				},
				{
					"lat": 43.58589615815105,
					"lng": 11.467334283789528
				},
				{
					"lat": 43.58590557422668,
					"lng": 11.467316128581011
				},
				{
					"lat": 43.58591596328978,
					"lng": 11.467297626013414
				},
				{
					"lat": 43.58592732534021,
					"lng": 11.467278776085683
				},
				{
					"lat": 43.58593966037784,
					"lng": 11.467259578796716
				},
				{
					"lat": 43.58595296840249,
					"lng": 11.467240034145407
				},
				{
					"lat": 43.585967249414026,
					"lng": 11.467220142130591
				},
				{
					"lat": 43.58598250341229,
					"lng": 11.467199902751089
				},
				{
					"lat": 43.58599734208215,
					"lng": 11.467180034638492
				},
				{
					"lat": 43.586010377109055,
					"lng": 11.467161256426907
				},
				{
					"lat": 43.58602160849344,
					"lng": 11.46714356811867
				},
				{
					"lat": 43.586031036235795,
					"lng": 11.467126969715975
				},
				{
					"lat": 43.58603866033656,
					"lng": 11.467111461220789
				},
				{
					"lat": 43.58604448079612,
					"lng": 11.467097042634908
				},
				{
					"lat": 43.586048497614875,
					"lng": 11.467083713959939
				},
				{
					"lat": 43.58605071079315,
					"lng": 11.46707147519729
				},
				{
					"lat": 43.586051991480055,
					"lng": 11.467058785931783
				},
				{
					"lat": 43.58605321082392,
					"lng": 11.467044105747307
				},
				{
					"lat": 43.58605436882403,
					"lng": 11.467027434643754
				},
				{
					"lat": 43.58605546547947,
					"lng": 11.467008772621012
				},
				{
					"lat": 43.58605650078932,
					"lng": 11.466988119678998
				},
				{
					"lat": 43.586057474752465,
					"lng": 11.466965475817613
				},
				{
					"lat": 43.58605838736771,
					"lng": 11.466940841036779
				},
				{
					"lat": 43.586059238633815,
					"lng": 11.466914215336422
				},
				{
					"lat": 43.586061241767624,
					"lng": 11.466884524029188
				},
				{
					"lat": 43.5860656099849,
					"lng": 11.46685069242491
				},
				{
					"lat": 43.58607234328198,
					"lng": 11.466812720518558
				},
				{
					"lat": 43.586081441654954,
					"lng": 11.466770608304142
				},
				{
					"lat": 43.58609290509935,
					"lng": 11.466724355774677
				},
				{
					"lat": 43.586106733610315,
					"lng": 11.466673962922208
				},
				{
					"lat": 43.58612292718257,
					"lng": 11.466619429737772
				},
				{
					"lat": 43.58614148581038,
					"lng": 11.466560756211456
				},
				{
					"lat": 43.586162391005985,
					"lng": 11.466500825217649
				},
				{
					"lat": 43.58618562428745,
					"lng": 11.466442519634573
				},
				{
					"lat": 43.586211185657284,
					"lng": 11.466385839457594
				},
				{
					"lat": 43.58623907511806,
					"lng": 11.466330784682462
				},
				{
					"lat": 43.58626929267216,
					"lng": 11.466277355305312
				},
				{
					"lat": 43.586301838321894,
					"lng": 11.466225551322653
				},
				{
					"lat": 43.58633671206957,
					"lng": 11.466175372731396
				},
				{
					"lat": 43.586373913917306,
					"lng": 11.466126819528826
				},
				{
					"lat": 43.58641324327796,
					"lng": 11.466073567133872
				},
				{
					"lat": 43.58645449955238,
					"lng": 11.46600929094856
				},
				{
					"lat": 43.586497682722694,
					"lng": 11.46593399094346
				},
				{
					"lat": 43.586542792767744,
					"lng": 11.465847667086898
				},
				{
					"lat": 43.58658982966329,
					"lng": 11.46575031934496
				},
				{
					"lat": 43.586638793381944,
					"lng": 11.465641947681457
				},
				{
					"lat": 43.58668968389318,
					"lng": 11.465522552057985
				},
				{
					"lat": 43.58674250116328,
					"lng": 11.465392132433871
				},
				{
					"lat": 43.586794520831745,
					"lng": 11.465261168859445
				},
				{
					"lat": 43.586843018583735,
					"lng": 11.46514014144584
				},
				{
					"lat": 43.58688799444978,
					"lng": 11.465029050239245
				},
				{
					"lat": 43.586929448458015,
					"lng": 11.464927895282283
				},
				{
					"lat": 43.58696738063399,
					"lng": 11.464836676613995
				},
				{
					"lat": 43.58700179100074,
					"lng": 11.464755394269869
				},
				{
					"lat": 43.58703267957878,
					"lng": 11.464684048281818
				},
				{
					"lat": 43.587060046386114,
					"lng": 11.464622638678186
				},
				{
					"lat": 43.58708728791797,
					"lng": 11.464562591962691
				},
				{
					"lat": 43.58711780065121,
					"lng": 11.4644953346083
				},
				{
					"lat": 43.58715158457358,
					"lng": 11.46442086659279
				},
				{
					"lat": 43.58718863967153,
					"lng": 11.464339187891541
				},
				{
					"lat": 43.58722896593012,
					"lng": 11.464250298477575
				},
				{
					"lat": 43.58727256333318,
					"lng": 11.46415419832152
				},
				{
					"lat": 43.587319431863136,
					"lng": 11.464050887391608
				},
				{
					"lat": 43.587369571501235,
					"lng": 11.463940365653706
				},
				{
					"lat": 43.58742008366945,
					"lng": 11.463829022337269
				},
				{
					"lat": 43.58746806981353,
					"lng": 11.463723246714391
				},
				{
					"lat": 43.587513529948275,
					"lng": 11.463623038812068
				},
				{
					"lat": 43.58755646408787,
					"lng": 11.463528398655885
				},
				{
					"lat": 43.58759687224558,
					"lng": 11.46343932626997
				},
				{
					"lat": 43.58763475443395,
					"lng": 11.463355821677064
				},
				{
					"lat": 43.58767011066476,
					"lng": 11.463277884898472
				},
				{
					"lat": 43.587702940949015,
					"lng": 11.463205515954078
				},
				{
					"lat": 43.587737002355304,
					"lng": 11.463130433016879
				},
				{
					"lat": 43.58777605193089,
					"lng": 11.463044354221168
				},
				{
					"lat": 43.58782008965184,
					"lng": 11.462947279523561
				},
				{
					"lat": 43.58786911549115,
					"lng": 11.462839208875147
				},
				{
					"lat": 43.58792312941882,
					"lng": 11.462720142221476
				},
				{
					"lat": 43.58798213140167,
					"lng": 11.462590079502531
				},
				{
					"lat": 43.58804612140358,
					"lng": 11.462449020652784
				}
			]
		]
	},
	"37": {
		"name": "IC01 - IC01",
		"center": {
			"lat": 43.595408,
			"lng": 11.477869
		},
		"coords": [
			[
				{
					"lat": 43.59467133969996,
					"lng": 11.481521993230974
				},
				{
					"lat": 43.59470825931053,
					"lng": 11.4816966564838
				},
				{
					"lat": 43.59480262716844,
					"lng": 11.482123215608611
				},
				{
					"lat": 43.59488033336289,
					"lng": 11.48229446465452
				},
				{
					"lat": 43.59495053292539,
					"lng": 11.482470497900238
				},
				{
					"lat": 43.59497673002826,
					"lng": 11.482577744894694
				},
				{
					"lat": 43.594997457487,
					"lng": 11.482661310821884
				},
				{
					"lat": 43.59496840670305,
					"lng": 11.482681747441186
				},
				{
					"lat": 43.59496116191113,
					"lng": 11.482687299312564
				},
				{
					"lat": 43.59494489859698,
					"lng": 11.48269976230528
				},
				{
					"lat": 43.594858439851826,
					"lng": 11.482510702432826
				},
				{
					"lat": 43.59478469380104,
					"lng": 11.482323147385964
				},
				{
					"lat": 43.594767342472366,
					"lng": 11.482279727128795
				},
				{
					"lat": 43.59476312572166,
					"lng": 11.482268971460192
				},
				{
					"lat": 43.59474533022781,
					"lng": 11.482223580528764
				},
				{
					"lat": 43.594724339013155,
					"lng": 11.4821700383737
				},
				{
					"lat": 43.594721836080225,
					"lng": 11.482158152589696
				},
				{
					"lat": 43.59471849481821,
					"lng": 11.482142285807772
				},
				{
					"lat": 43.59470668788212,
					"lng": 11.482086217845962
				},
				{
					"lat": 43.59469345080217,
					"lng": 11.482023358699324
				},
				{
					"lat": 43.59467842433194,
					"lng": 11.48195200247919
				},
				{
					"lat": 43.59466291237639,
					"lng": 11.481880839817908
				},
				{
					"lat": 43.59464432717167,
					"lng": 11.481810902356731
				},
				{
					"lat": 43.59458766543152,
					"lng": 11.481549886931964
				},
				{
					"lat": 43.59458712199892,
					"lng": 11.481500476637846
				},
				{
					"lat": 43.59461932844878,
					"lng": 11.481155838224364
				},
				{
					"lat": 43.59461948781525,
					"lng": 11.481130895265752
				},
				{
					"lat": 43.59461456847458,
					"lng": 11.48103013028409
				},
				{
					"lat": 43.59461867395942,
					"lng": 11.480986644392496
				},
				{
					"lat": 43.59473261910036,
					"lng": 11.48053602311523
				},
				{
					"lat": 43.59474238687142,
					"lng": 11.480463017877726
				},
				{
					"lat": 43.59480066147439,
					"lng": 11.480228719096035
				},
				{
					"lat": 43.59480760183147,
					"lng": 11.480197604350142
				},
				{
					"lat": 43.59482495045664,
					"lng": 11.480083029385213
				},
				{
					"lat": 43.59482942770594,
					"lng": 11.480058953159233
				},
				{
					"lat": 43.595190166999586,
					"lng": 11.478632244244432
				},
				{
					"lat": 43.595245831543245,
					"lng": 11.478412085563843
				},
				{
					"lat": 43.59529315469857,
					"lng": 11.478209590248337
				},
				{
					"lat": 43.595321373512235,
					"lng": 11.477938916761579
				},
				{
					"lat": 43.5953709234275,
					"lng": 11.477523490032365
				},
				{
					"lat": 43.59540811351926,
					"lng": 11.477208732240753
				},
				{
					"lat": 43.595406906292524,
					"lng": 11.477130098568356
				},
				{
					"lat": 43.595402236196186,
					"lng": 11.477104213137316
				},
				{
					"lat": 43.59537052261796,
					"lng": 11.47664189606592
				},
				{
					"lat": 43.5953671400796,
					"lng": 11.476592587436452
				},
				{
					"lat": 43.595363757519856,
					"lng": 11.47654327881164
				},
				{
					"lat": 43.59536097446762,
					"lng": 11.476502709631486
				},
				{
					"lat": 43.59535754471136,
					"lng": 11.476452713595835
				},
				{
					"lat": 43.595354922019204,
					"lng": 11.476414482466712
				},
				{
					"lat": 43.59535132779035,
					"lng": 11.476362089502064
				},
				{
					"lat": 43.59534728706087,
					"lng": 11.47634334210739
				},
				{
					"lat": 43.59534223358947,
					"lng": 11.476319896012775
				},
				{
					"lat": 43.59533199916586,
					"lng": 11.47627241244468
				},
				{
					"lat": 43.59532176472212,
					"lng": 11.476224928891918
				},
				{
					"lat": 43.59531592623575,
					"lng": 11.476197840797479
				},
				{
					"lat": 43.59530465072201,
					"lng": 11.476145527308082
				},
				{
					"lat": 43.59529891786697,
					"lng": 11.476125339684119
				},
				{
					"lat": 43.59529016540561,
					"lng": 11.476086605373622
				},
				{
					"lat": 43.595288879235284,
					"lng": 11.476072354676836
				},
				{
					"lat": 43.595280826745814,
					"lng": 11.476034994833732
				},
				{
					"lat": 43.595272767074405,
					"lng": 11.476012453730013
				},
				{
					"lat": 43.59526505132691,
					"lng": 11.47598977229328
				},
				{
					"lat": 43.59525760134665,
					"lng": 11.475966982414745
				},
				{
					"lat": 43.59525015136171,
					"lng": 11.47594419254165
				},
				{
					"lat": 43.5952372288701,
					"lng": 11.475910352804394
				},
				{
					"lat": 43.59520731469341,
					"lng": 11.475924403229016
				},
				{
					"lat": 43.59518964759194,
					"lng": 11.475714883954772
				},
				{
					"lat": 43.595139249969264,
					"lng": 11.475478559539692
				},
				{
					"lat": 43.59510776455894,
					"lng": 11.475078092798299
				},
				{
					"lat": 43.59516838794527,
					"lng": 11.47474486962648
				},
				{
					"lat": 43.59519386491686,
					"lng": 11.474525304526013
				},
				{
					"lat": 43.595229371953224,
					"lng": 11.474545304370194
				},
				{
					"lat": 43.59523955284286,
					"lng": 11.474490089833436
				},
				{
					"lat": 43.59526360057932,
					"lng": 11.474416899825307
				},
				{
					"lat": 43.59529193618767,
					"lng": 11.474353157561476
				},
				{
					"lat": 43.59535879615465,
					"lng": 11.47437753346689
				},
				{
					"lat": 43.595353036979205,
					"lng": 11.474436020095053
				},
				{
					"lat": 43.59534721089609,
					"lng": 11.474497594639447
				},
				{
					"lat": 43.59534064909831,
					"lng": 11.474593136381259
				},
				{
					"lat": 43.595380310251116,
					"lng": 11.474628760014307
				},
				{
					"lat": 43.59529821110368,
					"lng": 11.474845980141767
				},
				{
					"lat": 43.59525150015125,
					"lng": 11.475080852047004
				},
				{
					"lat": 43.59525691197079,
					"lng": 11.475172739966075
				},
				{
					"lat": 43.595281094025594,
					"lng": 11.475423266987791
				},
				{
					"lat": 43.595334969178374,
					"lng": 11.475669919691255
				},
				{
					"lat": 43.59539397506758,
					"lng": 11.475850579972938
				},
				{
					"lat": 43.59537145674724,
					"lng": 11.4758649338702
				},
				{
					"lat": 43.59539251155486,
					"lng": 11.476035516567645
				},
				{
					"lat": 43.595434452340236,
					"lng": 11.47617322698821
				},
				{
					"lat": 43.59545868985858,
					"lng": 11.476316658804224
				},
				{
					"lat": 43.59548137717804,
					"lng": 11.476465274322008
				},
				{
					"lat": 43.59552066608017,
					"lng": 11.477006699588015
				},
				{
					"lat": 43.595523371217425,
					"lng": 11.477052643802692
				},
				{
					"lat": 43.595526186648456,
					"lng": 11.477093499971938
				},
				{
					"lat": 43.59551746704319,
					"lng": 11.477154252985452
				},
				{
					"lat": 43.59546095599943,
					"lng": 11.47771211624166
				},
				{
					"lat": 43.595446331258195,
					"lng": 11.477874478049277
				},
				{
					"lat": 43.59541503856295,
					"lng": 11.478122729021484
				},
				{
					"lat": 43.59540140651903,
					"lng": 11.478239298276886
				},
				{
					"lat": 43.59538159255681,
					"lng": 11.478299595410109
				},
				{
					"lat": 43.59535349977479,
					"lng": 11.478400293021638
				},
				{
					"lat": 43.59532943594602,
					"lng": 11.478485878321743
				},
				{
					"lat": 43.595312988644174,
					"lng": 11.478561591241457
				},
				{
					"lat": 43.59524714374898,
					"lng": 11.47886698649602
				},
				{
					"lat": 43.59503989088187,
					"lng": 11.479719112259506
				},
				{
					"lat": 43.59494578301383,
					"lng": 11.480132832791147
				},
				{
					"lat": 43.594929445091,
					"lng": 11.480203456749107
				},
				{
					"lat": 43.59487209633344,
					"lng": 11.480458272257753
				},
				{
					"lat": 43.59480967105399,
					"lng": 11.480605935795822
				},
				{
					"lat": 43.59478797785498,
					"lng": 11.48075272704824
				},
				{
					"lat": 43.59473101459294,
					"lng": 11.480989733504307
				},
				{
					"lat": 43.594718042599624,
					"lng": 11.48107577287299
				},
				{
					"lat": 43.59469276138971,
					"lng": 11.481217323715597
				},
				{
					"lat": 43.59467133969996,
					"lng": 11.481521993230974
				}
			]
		]
	}
};


export const DEMO_FILES = [
	{
		"name": "Profilo amministrativo",
		"subfolders": [
			{
				"name": "Conferenze dei Servizi",
				"subfolders": [],
				"files": [
					{
						"name": "Verbale Tavolo Tecnico",
						"date": 1402444800,
						"notes": "Validazione Studi Attuativi Concessione Mineraria Santa Barbara nei Comuni di Cavriglia (AR) e Figline - Incisa (FI)",
						"url": "https://cesi-repo.s3.eu-west-1.amazonaws.com/santa-barbara/doc/14_06_11_RT_Verbale CdS tavolo tecnico validazione studi generali.pdf"
					},
					{
						"name": "D.D.R.T. N° 416/2010",
						"date": 1271980800,
						"notes": "Validazione studi concessione mineraria S. Barbara nei comuni di Cavriglia (AR) e Figline-Incisa (FI).",
						"url": "https://cesi-repo.s3.eu-west-1.amazonaws.com/santa-barbara/doc/81579.PDF"
					}
				]
			},
			{
				"name": "Pareri tecnici",
				"subfolders": [],
				"files": [
					{
						"name": "Parere ARPAT - Macrolotto A - Piano Indagini - N° 20383",
						"date": 1552521600,
						"notes": "Recupero Ambientale Miniera S.Barbara – Revisione del Piano di indagini per la caratterizzazione delle terre delle aree del Macrolotto A - Rapporto CESI B8015517 – contributo istruttorio.",
						"url": "https://cesi-repo.s3.eu-west-1.amazonaws.com/santa-barbara/doc/Parere - Macrolotto A - Piano Indagini - Marzo 2019.pdf"
					},
					{
						"name": "Parere ARPAT - Piano Integrativo Buche di Calonica - N° 74884",
						"date": 1570492800,
						"notes": "Recupero Ambientale Miniera S. Barbara – Verifica di ottemperanza parziale delle prescrizioni c.22 e c.23 del Decreto MATTM n. 938 del 29/07/2009 - Indagini integrative Macrolotto A, Sub-area MA-07 Buche di Calonica: Rapporto CESI B9012890 – contributo istruttorio.",
						"url": "https://cesi-repo.s3.eu-west-1.amazonaws.com/santa-barbara/doc/Parere - Piano Integrativo Buche di Calonica.pdf"
					},
					{
						"name": "Parere ARPAT - Piano Macchine Miniera - N° 55682",
						"date": 1563494400,
						"notes": "Recupero Ambientale della Miniera Santa Barbara – Piano di indagine aree occupate dalle macchine operatrici di miniera – Rapporto CESI B8021866 – contributo istruttorio",
						"url": "https://cesi-repo.s3.eu-west-1.amazonaws.com/santa-barbara/doc/Parere - Piano Macchine Miniera - 55682_20190719.pdf"
					},
					{
						"name": "Parere ARPAT - Due Borri",
						"date": 1426723200,
						"notes": "Proposta di protocollo di campionamento ed analisi per la caratterizzazione delle aree dell'area mineraria Area Industriale Due Borri e aree non critiche",
						"url": "https://cesi-repo.s3.eu-west-1.amazonaws.com/santa-barbara/doc/Parere ARPAT del 19_03_15.pdf"
					}
				]
			},
			{
				"name": "Decreti e Delibere",
				"subfolders": [],
				"files": [
					{
						"name": "Decreto MATTM",
						"date": 1248825600,
						"notes": "Giudizio favorevole di compatibilità ambientale relativamente al progetto proposto da ENEL di recupero della miniera di Santa Barbara",
						"url": "https://cesi-repo.s3.eu-west-1.amazonaws.com/santa-barbara/doc/Decreto MATTM.pdf"
					}
				]
			},
			{
				"name": "Certificazioni",
				"subfolders": [],
				"files": []
			},
			{
				"name": "Verbali",
				"subfolders": [],
				"files": [
					{
						"name": "ARPAT - Verbale prelievo terze aliquote campioni terreno - N° 20160907_00434_1",
						"date": 1473206400,
						"notes": "Destinatario RdP: Carmela D'Aiutolo - Valentini S.",
						"url": "https://cesi-repo.s3.eu-west-1.amazonaws.com/santa-barbara/doc/3 - ARPAT - Verbale prelievo terze aliquote campioni terreno - 07 settembre 2016.pdf"
					},
					{
						"name": "ARPAT - Verbale prelievo terze aliquote Aree Non Critiche - N° 20170125_00434_1",
						"date": 1485302400,
						"notes": "Destinatario RdP: Carmela D'Aiutolo",
						"url": "https://cesi-repo.s3.eu-west-1.amazonaws.com/santa-barbara/doc/5 - ARPAT - Verbale prelievo terze aliquote Aree Non Critiche - 25 gennaio 2017.pdf"
					},
					{
						"name": "7 - ARPAT - Verbale verifica analisi presso CESI di Piacenza",
						"date": 1490832000,
						"notes": "Analisi eseguite ai fini della validazione della prova sul parametro SELENIO",
						"url": "https://cesi-repo.s3.eu-west-1.amazonaws.com/santa-barbara/doc/7 - ARPAT - Verbale verifica analisi presso CESI - 30 marzo 2017.pdf"
					},
					{
						"name": "7b - ARPAT - Verbale verifica analisi presso CESI di Piacenza",
						"date": 1490832000,
						"notes": "Analisi eseguite ai fini della validazione della prova sul parametro SELENIO",
						"url": "https://cesi-repo.s3.eu-west-1.amazonaws.com/santa-barbara/doc/7b - ARPAT - Verbale verifica analisi presso CESI - 30 marzo 2017.pdf"
					},
					{
						"name": "Verbale Incontro Tecnico ENEL-CESI-ARPAT",
						"date": 1557273600,
						"notes": "Nuovi accertamenti terre nel Macrolotto A e Sponda Ovest Lago Allori, validazione accertamenti 2017, georeferenziazione degli accertamenti (7.5.2019).",
						"url": "https://cesi-repo.s3.eu-west-1.amazonaws.com/santa-barbara/doc/INCONTRO_TECNICO_35270.pdf"
					},
					{
						"name": "Verbale Riunione",
						"date": 1398211200,
						"notes": "Validazione studi concessione mineraria Santa Barbara",
						"url": "https://cesi-repo.s3.eu-west-1.amazonaws.com/santa-barbara/doc/S BARBARA-PDF.PDF"
					},
					{
						"name": "Verbale di Acquisizione N° 997 - San Martino",
						"date": 1413244800,
						"notes": "Destinatario RdP: Panarese - Fascicolo FreeDocs: ar 01.03.01 /5.6",
						"url": "https://cesi-repo.s3.eu-west-1.amazonaws.com/santa-barbara/doc/SanMartino_14102014.pdf"
					},
					{
						"name": "Tavolo tecnico comune di Cavriglia",
						"date": 1443052800,
						"notes": "Protocollo di campionamento ed analisi per la caratterizzazione delle aree dell'Area mineraria Enel S. Barbara, nei comuni di Cavriglia e Figline e Incisa Valdarno – 4° seduta",
						"url": "https://cesi-repo.s3.eu-west-1.amazonaws.com/santa-barbara/doc/Tavolo tecnico comune di Cavriglia 24 Set 2015.pdf"
					},
					{
						"name": "Verbale riunione Comune Cavriglia/Arpat Arezzo/ENEL Produzione",
						"date": 1423094400,
						"notes": "Protocollo di campionamento ed analisi per la caratterizzazione delle aree dell'Area mineraria Enel S. Barbara, nei comuni di Cavriglia e Figline e Incisa Valdarno – 2° incontro",
						"url": "https://cesi-repo.s3.eu-west-1.amazonaws.com/santa-barbara/doc/Verbale Rionione Comune Cavriglia 15_02_15.pdf"
					},
					{
						"name": "Verbale di Acquisizione N° 996 - Vignale",
						"date": 1413244800,
						"notes": "Destinatario RdP: Panarese - Fascicolo FreeDocs: ar 01.03.01 /5.4",
						"url": "https://cesi-repo.s3.eu-west-1.amazonaws.com/santa-barbara/doc/Vignale_14102014.pdf"
					}
				]
			},
			{
				"name": "Validazioni",
				"subfolders": [],
				"files": [
					{
						"name": "ARPAT - Parere Santa Barbara Risultati analisi caratterizzazione",
						"date": 1471478400,
						"notes": "Riqualificazione ambientale aree minerarie ENEL (Cavriglia) - Indagini di caratterizzazione delle terre in corso di svolgimento presso il sito minerario Santa Barbara.",
						"url": "https://cesi-repo.s3.eu-west-1.amazonaws.com/santa-barbara/doc/1 - ARPAT - Parere Santa Barbara Risultati analisi caratterizzazione - 18 agosto 2016.pdf"
					},
					{
						"name": "ARPAT - Validazione terza aliquota - Parere",
						"date": 1480032000,
						"notes": "Riqualificazione ambientale aree minerarie ENEL (Cavriglia) - Indagini di caratterizzazione delle terre in corso di svolgimento presso il sito minerario Santa Barbara.",
						"url": "https://cesi-repo.s3.eu-west-1.amazonaws.com/santa-barbara/doc/4 - ARPAT - Validazione terza aliquota - Parere - 25 novembre 2016.pdf"
					}
				]
			}
		],
		"files": []
	},
	{
		"name": "Profilo ambientale",
		"subfolders": [
			{
				"name": "Acque superficiali",
				"subfolders": [],
				"files": []
			},
			{
				"name": "Aria",
				"subfolders": [],
				"files": []
			},
			{
				"name": "Biodiversità",
				"subfolders": [],
				"files": []
			},
			{
				"name": "Rumore",
				"subfolders": [],
				"files": []
			},
			{
				"name": "Vibrazioni",
				"subfolders": [],
				"files": []
			},
			{
				"name": "Campi elettromagnetici",
				"subfolders": [],
				"files": []
			},
			{
				"name": "Paesaggio",
				"subfolders": [],
				"files": []
			}
		],
		"files": []
	},
	{
		"name": "Indagini ambientali",
		"subfolders": [
			{
				"name": "Piani di indagine",
				"subfolders": [],
				"files": [
					{
						"name": "Piano delle indagini ambientali presso le aree non critiche",
						"date": 1435104000,
						"notes": "Progetto per il recupero ambientale della miniera di Santa Barbara",
						"url": "https://cesi-repo.s3.eu-west-1.amazonaws.com/santa-barbara/doc/AG11ESS128_B5013159_PdC_aree_non_critiche_finale.PDF"
					},
					{
						"name": "Risposta alle prescrizioni e raccomandazioni inerenti la caratterizzazione e gestione delle terre e rocce da scavo di provenienza interna all’area mineraria",
						"date": 1404086400,
						"notes": "Progetto per il recupero ambientale della miniera di Santa Barbara",
						"url": "https://cesi-repo.s3.eu-west-1.amazonaws.com/santa-barbara/doc/B4014668_PdC terre e rocce_Rev. 04_30_06_2014.pdf"
					},
					{
						"name": "Indagini ambientali presso le aree del Macrolotto A - SECONDA FASE",
						"date": 1543795200,
						"notes": "Progetto per il recupero ambientale della miniera di Santa Barbara",
						"url": "https://cesi-repo.s3.eu-west-1.amazonaws.com/santa-barbara/doc/B8015517 - P. Indagini Macrolotto A - Finale.pdf"
					}
				]
			},
			{
				"name": "Piani di caratterizzazione",
				"subfolders": [],
				"files": []
			},
			{
				"name": "Report dei piani d’indagine eseguiti",
				"subfolders": [],
				"files": [
					{
						"name": "Relazione tecnica delle indagini svolte - San Martino Vignale Bomba Lago Castelnuovo",
						"date": 1438560000,
						"notes": "Caratterizzazione delle terre da scavo presso le sub-aree in cui sono previste significative attività di scavo",
						"url": "https://cesi-repo.s3.eu-west-1.amazonaws.com/santa-barbara/doc/AG13ESS180_B4023914_SMartino-Bomba-Vignale-Castelnuovo.pdf"
					},
					{
						"name": "Indagini ambientali presso le aree non critiche - San Donato",
						"date": 1492646400,
						"notes": "Sub-area San Donato Rev. 1",
						"url": "https://cesi-repo.s3.eu-west-1.amazonaws.com/santa-barbara/doc/B7008087 - Indagini San Donato - rev1.PDF"
					}
				]
			}
		],
		"files": []
	},
	{
		"name": "Attività di bonifica",
		"subfolders": [
			{
				"name": "Progetti di bonifica",
				"subfolders": [],
				"files": []
			},
			{
				"name": "Progetti di riqualificazione",
				"subfolders": [],
				"files": []
			},
			{
				"name": "Messe in sicurezza di emergenza",
				"subfolders": [],
				"files": []
			},
			{
				"name": "Messe in sicurezza operativa",
				"subfolders": [],
				"files": []
			}
		],
		"files": []
	}
];